(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec789"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec789"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9HB6H", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fy1yK"));

});
parcelRegister("fy1yK", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $b51b3dabc534165f$export$ffb0004e005737fa; }, function (v) { return $b51b3dabc534165f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $b51b3dabc534165f$export$34b9dba7ce09269b; }, function (v) { return $b51b3dabc534165f$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $b51b3dabc534165f$export$25062201e9e25d76; }, function (v) { return $b51b3dabc534165f$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b51b3dabc534165f$export$ffb0004e005737fa;
var $b51b3dabc534165f$export$34b9dba7ce09269b;
var $b51b3dabc534165f$export$25062201e9e25d76;
'use strict';

var $iD6kw = parcelRequire("iD6kw");
var $b51b3dabc534165f$var$k = Symbol.for("react.element"), $b51b3dabc534165f$var$l = Symbol.for("react.fragment"), $b51b3dabc534165f$var$m = Object.prototype.hasOwnProperty, $b51b3dabc534165f$var$n = $iD6kw.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $b51b3dabc534165f$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b51b3dabc534165f$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$b51b3dabc534165f$var$m.call(a, b) && !$b51b3dabc534165f$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $b51b3dabc534165f$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $b51b3dabc534165f$var$n.current
    };
}
$b51b3dabc534165f$export$ffb0004e005737fa = $b51b3dabc534165f$var$l;
$b51b3dabc534165f$export$34b9dba7ce09269b = $b51b3dabc534165f$var$q;
$b51b3dabc534165f$export$25062201e9e25d76 = $b51b3dabc534165f$var$q;

});
parcelRegister("iD6kw", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jowWt"));

});
parcelRegister("jowWt", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $e1e9cfd39d0569dc$export$dca3b0875bd9a954; }, function (v) { return $e1e9cfd39d0569dc$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $e1e9cfd39d0569dc$export$16fa2f45be04daa8; }, function (v) { return $e1e9cfd39d0569dc$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $e1e9cfd39d0569dc$export$ffb0004e005737fa; }, function (v) { return $e1e9cfd39d0569dc$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $e1e9cfd39d0569dc$export$e2c29f18771995cb; }, function (v) { return $e1e9cfd39d0569dc$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $e1e9cfd39d0569dc$export$221d75b3f55bb0bd; }, function (v) { return $e1e9cfd39d0569dc$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $e1e9cfd39d0569dc$export$5f8d39834fd61797; }, function (v) { return $e1e9cfd39d0569dc$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $e1e9cfd39d0569dc$export$74bf444e3cd11ea5; }, function (v) { return $e1e9cfd39d0569dc$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $e1e9cfd39d0569dc$export$ae55be85d98224ed; }, function (v) { return $e1e9cfd39d0569dc$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $e1e9cfd39d0569dc$export$3ba232387fd5d6dd; }, function (v) { return $e1e9cfd39d0569dc$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $e1e9cfd39d0569dc$export$e530037191fcd5d7; }, function (v) { return $e1e9cfd39d0569dc$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $e1e9cfd39d0569dc$export$fd42f52fd3ae1109; }, function (v) { return $e1e9cfd39d0569dc$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $e1e9cfd39d0569dc$export$c8a8987d4410bf2d; }, function (v) { return $e1e9cfd39d0569dc$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $e1e9cfd39d0569dc$export$d38cd72104c1f0e9; }, function (v) { return $e1e9cfd39d0569dc$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $e1e9cfd39d0569dc$export$7d1e3a5e95ceca43; }, function (v) { return $e1e9cfd39d0569dc$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $e1e9cfd39d0569dc$export$257a8862b851cb5b; }, function (v) { return $e1e9cfd39d0569dc$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $e1e9cfd39d0569dc$export$a8257692ac88316c; }, function (v) { return $e1e9cfd39d0569dc$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $e1e9cfd39d0569dc$export$488013bae63b21da; }, function (v) { return $e1e9cfd39d0569dc$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $e1e9cfd39d0569dc$export$7c73462e0d25e514; }, function (v) { return $e1e9cfd39d0569dc$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $e1e9cfd39d0569dc$export$7568632d0d33d16d; }, function (v) { return $e1e9cfd39d0569dc$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $e1e9cfd39d0569dc$export$88948ce120ea2619; }, function (v) { return $e1e9cfd39d0569dc$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $e1e9cfd39d0569dc$export$35808ee640e87ca7; }, function (v) { return $e1e9cfd39d0569dc$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $e1e9cfd39d0569dc$export$fae74005e78b1a27; }, function (v) { return $e1e9cfd39d0569dc$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $e1e9cfd39d0569dc$export$dc8fbce3eb94dc1e; }, function (v) { return $e1e9cfd39d0569dc$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $e1e9cfd39d0569dc$export$6a7bc4e911dc01cf; }, function (v) { return $e1e9cfd39d0569dc$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $e1e9cfd39d0569dc$export$6d9c69b0de29b591; }, function (v) { return $e1e9cfd39d0569dc$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $e1e9cfd39d0569dc$export$f680877a34711e37; }, function (v) { return $e1e9cfd39d0569dc$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $e1e9cfd39d0569dc$export$d5a552a76deda3c2; }, function (v) { return $e1e9cfd39d0569dc$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $e1e9cfd39d0569dc$export$aaabe4eda9ed9969; }, function (v) { return $e1e9cfd39d0569dc$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $e1e9cfd39d0569dc$export$e5c5a5f917a5871c; }, function (v) { return $e1e9cfd39d0569dc$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $e1e9cfd39d0569dc$export$1538c33de8887b59; }, function (v) { return $e1e9cfd39d0569dc$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $e1e9cfd39d0569dc$export$13e3392192263954; }, function (v) { return $e1e9cfd39d0569dc$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $e1e9cfd39d0569dc$export$b8f5890fc79d6aca; }, function (v) { return $e1e9cfd39d0569dc$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $e1e9cfd39d0569dc$export$60241385465d0a34; }, function (v) { return $e1e9cfd39d0569dc$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $e1e9cfd39d0569dc$export$306c0aa65ff9ec16; }, function (v) { return $e1e9cfd39d0569dc$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $e1e9cfd39d0569dc$export$7b286972b8d8ccbf; }, function (v) { return $e1e9cfd39d0569dc$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $e1e9cfd39d0569dc$export$83d89fbfd8236492; }, function (v) { return $e1e9cfd39d0569dc$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $5djcY = parcelRequire("5djcY");
var $e1e9cfd39d0569dc$export$dca3b0875bd9a954;
var $e1e9cfd39d0569dc$export$16fa2f45be04daa8;
var $e1e9cfd39d0569dc$export$ffb0004e005737fa;
var $e1e9cfd39d0569dc$export$e2c29f18771995cb;
var $e1e9cfd39d0569dc$export$221d75b3f55bb0bd;
var $e1e9cfd39d0569dc$export$5f8d39834fd61797;
var $e1e9cfd39d0569dc$export$74bf444e3cd11ea5;
var $e1e9cfd39d0569dc$export$ae55be85d98224ed;
var $e1e9cfd39d0569dc$export$3ba232387fd5d6dd;
var $e1e9cfd39d0569dc$export$e530037191fcd5d7;
var $e1e9cfd39d0569dc$export$fd42f52fd3ae1109;
var $e1e9cfd39d0569dc$export$c8a8987d4410bf2d;
var $e1e9cfd39d0569dc$export$d38cd72104c1f0e9;
var $e1e9cfd39d0569dc$export$7d1e3a5e95ceca43;
var $e1e9cfd39d0569dc$export$257a8862b851cb5b;
var $e1e9cfd39d0569dc$export$a8257692ac88316c;
var $e1e9cfd39d0569dc$export$488013bae63b21da;
var $e1e9cfd39d0569dc$export$7c73462e0d25e514;
var $e1e9cfd39d0569dc$export$7568632d0d33d16d;
var $e1e9cfd39d0569dc$export$88948ce120ea2619;
var $e1e9cfd39d0569dc$export$35808ee640e87ca7;
var $e1e9cfd39d0569dc$export$fae74005e78b1a27;
var $e1e9cfd39d0569dc$export$dc8fbce3eb94dc1e;
var $e1e9cfd39d0569dc$export$6a7bc4e911dc01cf;
var $e1e9cfd39d0569dc$export$6d9c69b0de29b591;
var $e1e9cfd39d0569dc$export$f680877a34711e37;
var $e1e9cfd39d0569dc$export$d5a552a76deda3c2;
var $e1e9cfd39d0569dc$export$aaabe4eda9ed9969;
var $e1e9cfd39d0569dc$export$e5c5a5f917a5871c;
var $e1e9cfd39d0569dc$export$1538c33de8887b59;
var $e1e9cfd39d0569dc$export$13e3392192263954;
var $e1e9cfd39d0569dc$export$b8f5890fc79d6aca;
var $e1e9cfd39d0569dc$export$60241385465d0a34;
var $e1e9cfd39d0569dc$export$306c0aa65ff9ec16;
var $e1e9cfd39d0569dc$export$7b286972b8d8ccbf;
var $e1e9cfd39d0569dc$export$83d89fbfd8236492;
'use strict';
var $e1e9cfd39d0569dc$var$l = Symbol.for("react.element"), $e1e9cfd39d0569dc$var$n = Symbol.for("react.portal"), $e1e9cfd39d0569dc$var$p = Symbol.for("react.fragment"), $e1e9cfd39d0569dc$var$q = Symbol.for("react.strict_mode"), $e1e9cfd39d0569dc$var$r = Symbol.for("react.profiler"), $e1e9cfd39d0569dc$var$t = Symbol.for("react.provider"), $e1e9cfd39d0569dc$var$u = Symbol.for("react.context"), $e1e9cfd39d0569dc$var$v = Symbol.for("react.forward_ref"), $e1e9cfd39d0569dc$var$w = Symbol.for("react.suspense"), $e1e9cfd39d0569dc$var$x = Symbol.for("react.memo"), $e1e9cfd39d0569dc$var$y = Symbol.for("react.lazy"), $e1e9cfd39d0569dc$var$z = Symbol.iterator;
function $e1e9cfd39d0569dc$var$A(a) {
    if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a))) return null;
    a = $e1e9cfd39d0569dc$var$z && a[$e1e9cfd39d0569dc$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e1e9cfd39d0569dc$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $e1e9cfd39d0569dc$var$C = Object.assign, $e1e9cfd39d0569dc$var$D = {};
function $e1e9cfd39d0569dc$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $e1e9cfd39d0569dc$var$D;
    this.updater = e || $e1e9cfd39d0569dc$var$B;
}
$e1e9cfd39d0569dc$var$E.prototype.isReactComponent = {};
$e1e9cfd39d0569dc$var$E.prototype.setState = function(a, b) {
    if ("object" !== (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a)) && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$e1e9cfd39d0569dc$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $e1e9cfd39d0569dc$var$F() {}
$e1e9cfd39d0569dc$var$F.prototype = $e1e9cfd39d0569dc$var$E.prototype;
function $e1e9cfd39d0569dc$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $e1e9cfd39d0569dc$var$D;
    this.updater = e || $e1e9cfd39d0569dc$var$B;
}
var $e1e9cfd39d0569dc$var$H = $e1e9cfd39d0569dc$var$G.prototype = new $e1e9cfd39d0569dc$var$F;
$e1e9cfd39d0569dc$var$H.constructor = $e1e9cfd39d0569dc$var$G;
$e1e9cfd39d0569dc$var$C($e1e9cfd39d0569dc$var$H, $e1e9cfd39d0569dc$var$E.prototype);
$e1e9cfd39d0569dc$var$H.isPureReactComponent = !0;
var $e1e9cfd39d0569dc$var$I = Array.isArray, $e1e9cfd39d0569dc$var$J = Object.prototype.hasOwnProperty, $e1e9cfd39d0569dc$var$K = {
    current: null
}, $e1e9cfd39d0569dc$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $e1e9cfd39d0569dc$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$e1e9cfd39d0569dc$var$J.call(b, d) && !$e1e9cfd39d0569dc$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $e1e9cfd39d0569dc$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $e1e9cfd39d0569dc$var$K.current
    };
}
function $e1e9cfd39d0569dc$var$N(a, b) {
    return {
        $$typeof: $e1e9cfd39d0569dc$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $e1e9cfd39d0569dc$var$O(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a)) && null !== a && a.$$typeof === $e1e9cfd39d0569dc$var$l;
}
function $e1e9cfd39d0569dc$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $e1e9cfd39d0569dc$var$P = /\/+/g;
function $e1e9cfd39d0569dc$var$Q(a, b) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a)) && null !== a && null != a.key ? $e1e9cfd39d0569dc$var$escape("" + a.key) : b.toString(36);
}
function $e1e9cfd39d0569dc$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $e1e9cfd39d0569dc$var$l:
                case $e1e9cfd39d0569dc$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $e1e9cfd39d0569dc$var$Q(h, 0) : d, $e1e9cfd39d0569dc$var$I(c) ? (e = "", null != a && (e = a.replace($e1e9cfd39d0569dc$var$P, "$&/") + "/"), $e1e9cfd39d0569dc$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($e1e9cfd39d0569dc$var$O(c) && (c = $e1e9cfd39d0569dc$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($e1e9cfd39d0569dc$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($e1e9cfd39d0569dc$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $e1e9cfd39d0569dc$var$Q(k, g);
        h += $e1e9cfd39d0569dc$var$R(k, b, e, f, c);
    }
    else if (f = $e1e9cfd39d0569dc$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $e1e9cfd39d0569dc$var$Q(k, g++), h += $e1e9cfd39d0569dc$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $e1e9cfd39d0569dc$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $e1e9cfd39d0569dc$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $e1e9cfd39d0569dc$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $e1e9cfd39d0569dc$var$U = {
    current: null
}, $e1e9cfd39d0569dc$var$V = {
    transition: null
}, $e1e9cfd39d0569dc$var$W = {
    ReactCurrentDispatcher: $e1e9cfd39d0569dc$var$U,
    ReactCurrentBatchConfig: $e1e9cfd39d0569dc$var$V,
    ReactCurrentOwner: $e1e9cfd39d0569dc$var$K
};
function $e1e9cfd39d0569dc$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$e1e9cfd39d0569dc$export$dca3b0875bd9a954 = {
    map: $e1e9cfd39d0569dc$var$S,
    forEach: function forEach(a, b, e) {
        $e1e9cfd39d0569dc$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $e1e9cfd39d0569dc$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $e1e9cfd39d0569dc$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$e1e9cfd39d0569dc$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$e1e9cfd39d0569dc$export$16fa2f45be04daa8 = $e1e9cfd39d0569dc$var$E;
$e1e9cfd39d0569dc$export$ffb0004e005737fa = $e1e9cfd39d0569dc$var$p;
$e1e9cfd39d0569dc$export$e2c29f18771995cb = $e1e9cfd39d0569dc$var$r;
$e1e9cfd39d0569dc$export$221d75b3f55bb0bd = $e1e9cfd39d0569dc$var$G;
$e1e9cfd39d0569dc$export$5f8d39834fd61797 = $e1e9cfd39d0569dc$var$q;
$e1e9cfd39d0569dc$export$74bf444e3cd11ea5 = $e1e9cfd39d0569dc$var$w;
$e1e9cfd39d0569dc$export$ae55be85d98224ed = $e1e9cfd39d0569dc$var$W;
$e1e9cfd39d0569dc$export$3ba232387fd5d6dd = $e1e9cfd39d0569dc$var$X;
$e1e9cfd39d0569dc$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $e1e9cfd39d0569dc$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $e1e9cfd39d0569dc$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$e1e9cfd39d0569dc$var$J.call(b, f) && !$e1e9cfd39d0569dc$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $e1e9cfd39d0569dc$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$e1e9cfd39d0569dc$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $e1e9cfd39d0569dc$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $e1e9cfd39d0569dc$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$e1e9cfd39d0569dc$export$c8a8987d4410bf2d = $e1e9cfd39d0569dc$var$M;
$e1e9cfd39d0569dc$export$d38cd72104c1f0e9 = function(a) {
    var b = $e1e9cfd39d0569dc$var$M.bind(null, a);
    b.type = a;
    return b;
};
$e1e9cfd39d0569dc$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$e1e9cfd39d0569dc$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $e1e9cfd39d0569dc$var$v,
        render: a
    };
};
$e1e9cfd39d0569dc$export$a8257692ac88316c = $e1e9cfd39d0569dc$var$O;
$e1e9cfd39d0569dc$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $e1e9cfd39d0569dc$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $e1e9cfd39d0569dc$var$T
    };
};
$e1e9cfd39d0569dc$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $e1e9cfd39d0569dc$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$e1e9cfd39d0569dc$export$7568632d0d33d16d = function(a) {
    var b = $e1e9cfd39d0569dc$var$V.transition;
    $e1e9cfd39d0569dc$var$V.transition = {};
    try {
        a();
    } finally{
        $e1e9cfd39d0569dc$var$V.transition = b;
    }
};
$e1e9cfd39d0569dc$export$88948ce120ea2619 = $e1e9cfd39d0569dc$var$X;
$e1e9cfd39d0569dc$export$35808ee640e87ca7 = function(a, b) {
    return $e1e9cfd39d0569dc$var$U.current.useCallback(a, b);
};
$e1e9cfd39d0569dc$export$fae74005e78b1a27 = function(a) {
    return $e1e9cfd39d0569dc$var$U.current.useContext(a);
};
$e1e9cfd39d0569dc$export$dc8fbce3eb94dc1e = function() {};
$e1e9cfd39d0569dc$export$6a7bc4e911dc01cf = function(a) {
    return $e1e9cfd39d0569dc$var$U.current.useDeferredValue(a);
};
$e1e9cfd39d0569dc$export$6d9c69b0de29b591 = function(a, b) {
    return $e1e9cfd39d0569dc$var$U.current.useEffect(a, b);
};
$e1e9cfd39d0569dc$export$f680877a34711e37 = function() {
    return $e1e9cfd39d0569dc$var$U.current.useId();
};
$e1e9cfd39d0569dc$export$d5a552a76deda3c2 = function(a, b, e) {
    return $e1e9cfd39d0569dc$var$U.current.useImperativeHandle(a, b, e);
};
$e1e9cfd39d0569dc$export$aaabe4eda9ed9969 = function(a, b) {
    return $e1e9cfd39d0569dc$var$U.current.useInsertionEffect(a, b);
};
$e1e9cfd39d0569dc$export$e5c5a5f917a5871c = function(a, b) {
    return $e1e9cfd39d0569dc$var$U.current.useLayoutEffect(a, b);
};
$e1e9cfd39d0569dc$export$1538c33de8887b59 = function(a, b) {
    return $e1e9cfd39d0569dc$var$U.current.useMemo(a, b);
};
$e1e9cfd39d0569dc$export$13e3392192263954 = function(a, b, e) {
    return $e1e9cfd39d0569dc$var$U.current.useReducer(a, b, e);
};
$e1e9cfd39d0569dc$export$b8f5890fc79d6aca = function(a) {
    return $e1e9cfd39d0569dc$var$U.current.useRef(a);
};
$e1e9cfd39d0569dc$export$60241385465d0a34 = function(a) {
    return $e1e9cfd39d0569dc$var$U.current.useState(a);
};
$e1e9cfd39d0569dc$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $e1e9cfd39d0569dc$var$U.current.useSyncExternalStore(a, b, e);
};
$e1e9cfd39d0569dc$export$7b286972b8d8ccbf = function() {
    return $e1e9cfd39d0569dc$var$U.current.useTransition();
};
$e1e9cfd39d0569dc$export$83d89fbfd8236492 = "18.3.1";

});
parcelRegister("5djcY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3cbd10fe5fe1c504$export$71511d61b312f219; });
function $3cbd10fe5fe1c504$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});





parcelRegister("6VBea", function(module, exports) {
$parcel$export(module.exports, "b64_decode", function () { return (parcelRequire("hDdJN")).b64_decode; });
$parcel$export(module.exports, "getAllCookies", function () { return (parcelRequire("fnNvV")).getAllCookies; });
$parcel$export(module.exports, "elementReady", function () { return (parcelRequire("7YAJ4")).elementReady; });
$parcel$export(module.exports, "addWindowResizeEvent", function () { return (parcelRequire("2pyvk")).addWindowResizeEvent; });
$parcel$export(module.exports, "addWindowScrollEvent", function () { return (parcelRequire("2pyvk")).addWindowScrollEvent; });
$parcel$export(module.exports, "getReCAPTCHAResponse", function () { return (parcelRequire("9uiPq")).getReCAPTCHAResponse; });
$parcel$export(module.exports, "slideDown", function () { return (parcelRequire("cPDzI")).slideDown; });
$parcel$export(module.exports, "slideUp", function () { return (parcelRequire("cPDzI")).slideUp; });
$parcel$export(module.exports, "scrollToElement", function () { return (parcelRequire("9vUSI")).scrollToElement; });
$parcel$export(module.exports, "getThemeData", function () { return (parcelRequire("4XCT3")).getThemeData; });
$parcel$export(module.exports, "waitForElement", function () { return (parcelRequire("5BaYK")).waitForElement; });
parcelRequire("hDdJN");
parcelRequire("fnNvV");
parcelRequire("7YAJ4");
parcelRequire("2pyvk");
parcelRequire("9uiPq");
parcelRequire("cPDzI");
parcelRequire("9vUSI");
parcelRequire("4XCT3");
parcelRequire("5BaYK");

});
parcelRegister("hDdJN", function(module, exports) {

$parcel$export(module.exports, "b64_decode", function () { return $cd60bc3867d72b58$export$bf9d481ba07b53f9; });
var $cd60bc3867d72b58$export$3c2a198a9c1ae5f3 = function(string) {
    return window.btoa(unescape(encodeURIComponent(string)));
};
var $cd60bc3867d72b58$export$bf9d481ba07b53f9 = function(string) {
    return decodeURIComponent(escape(window.atob(string)));
};

});

parcelRegister("fnNvV", function(module, exports) {

$parcel$export(module.exports, "getAllCookies", function () { return $b32f6972fc6e67b5$export$1191989ae3ee4c15; });
var $b32f6972fc6e67b5$export$1191989ae3ee4c15 = function() {
    var cookies = document.cookie.split('; ');
    var allCookies = [];
    cookies.forEach(function(cookie) {
        var cookieParts = cookie.split('=');
        allCookies[cookieParts[0]] = cookieParts[1];
    });
    return allCookies;
};

});

parcelRegister("7YAJ4", function(module, exports) {

$parcel$export(module.exports, "elementReady", function () { return $5cea9fff8806cfad$export$5a68694636710d38; });
var $5cea9fff8806cfad$export$5a68694636710d38 = function(selector) {
    return new Promise(function(resolve) {
        var el = document.querySelectorAll(selector);
        if (el.length) {
            resolve(el);
            return;
        }
        new MutationObserver(function() {
            // Query for elements matching the specified selector
            Array.from(document.querySelectorAll(selector)).forEach(function(element) {
                resolve(element);
            });
        }).observe(document.documentElement, {
            childList: true,
            subtree: true
        });
    });
};

});

parcelRegister("2pyvk", function(module, exports) {

$parcel$export(module.exports, "addWindowResizeEvent", function () { return $1c18ae62fb4dbf93$export$5f2cd73bfe4df536; });
$parcel$export(module.exports, "addWindowScrollEvent", function () { return $1c18ae62fb4dbf93$export$b502183889628ce0; });
var $1c18ae62fb4dbf93$export$5f2cd73bfe4df536 = function(callback) {
    var timeout;
    window.addEventListener('resize', function() {
        clearTimeout(timeout);
        timeout = setTimeout(callback, 250);
    });
};
var $1c18ae62fb4dbf93$export$b502183889628ce0 = function(callback) {
    var timeout;
    window.addEventListener('scroll', function() {
        clearTimeout(timeout);
        timeout = setTimeout(callback, 250);
    });
};

});

parcelRegister("9uiPq", function(module, exports) {

$parcel$export(module.exports, "getReCAPTCHAResponse", function () { return $6e85854efd3089cd$export$26ae508a4c7ca84d; });

var $dxEC4 = parcelRequire("dxEC4");

var $gh3Df = parcelRequire("gh3Df");

var $4XCT3 = parcelRequire("4XCT3");
var $6e85854efd3089cd$export$26ae508a4c7ca84d = function(action) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var _themeData_ajax_actions, themeData, e;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, $4XCT3.getThemeData)()
                    ];
                case 1:
                    themeData = _state.sent();
                    if (!themeData.recaptcha_site_key) throw new Error('Missing Google reCAPTCHA Site Key in theme configuration');
                    if (!((_themeData_ajax_actions = themeData.ajax_actions) === null || _themeData_ajax_actions === void 0 ? void 0 : _themeData_ajax_actions.recaptcha_verify)) throw new Error('Missing AJAX route to verify reCAPTCHA token');
                    if (!themeData.ajax_route) throw new Error('Missing global AJAX route');
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            if (window.grecaptcha === undefined) {
                                console.warn('Google reCAPTCHA is not loaded');
                                resolve({
                                    success: true,
                                    score: 1
                                });
                            } else window.grecaptcha.ready(function() {
                                window.grecaptcha.execute(themeData.recaptcha_site_key, {
                                    action: action
                                }).then(function(token) {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                                        var formData, testParam, url, response, json, errorMessages, e;
                                        return (0, $gh3Df._)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    formData = new FormData();
                                                    formData.append('action', themeData.ajax_actions.recaptcha_verify);
                                                    // Determine if request is just a test
                                                    testParam = 'e2e-test';
                                                    url = new URL(window.location);
                                                    if (url.searchParams.has(testParam)) token = 'e2e-test-valid-user';
                                                    // Set reCAPTCHA token
                                                    formData.append('recaptcha_token', token);
                                                    _state.label = 1;
                                                case 1:
                                                    _state.trys.push([
                                                        1,
                                                        4,
                                                        ,
                                                        5
                                                    ]);
                                                    return [
                                                        4,
                                                        fetch(themeData.ajax_route, {
                                                            method: 'POST',
                                                            body: formData
                                                        })
                                                    ];
                                                case 2:
                                                    response = _state.sent();
                                                    return [
                                                        4,
                                                        response.json()
                                                    ];
                                                case 3:
                                                    json = _state.sent();
                                                    if (json.success) resolve(json);
                                                    else if (json['error-codes']) {
                                                        /**
								 * reCAPTCHA verification error codes
								 * @link https://developers.google.com/recaptcha/docs/verify#error_code_reference
								 *
								 * missing-input-secret	  The secret parameter is missing.
								 * invalid-input-secret	  The secret parameter is invalid or malformed.
								 * missing-input-response	The response parameter is missing.
								 * invalid-input-response	The response parameter is invalid or malformed.
								 * bad-request	          The request is invalid or malformed.
								 * timeout-or-duplicate	  The response is no longer valid: either is too old or has been used previously.
								 */ errorMessages = [];
                                                        json['error-codes'].forEach(function(errorCode) {
                                                            switch(errorCode){
                                                                case 'missing-input-secret':
                                                                    errorMessages.push('The secret parameter is missing.');
                                                                    break;
                                                                case 'invalid-input-secret':
                                                                    errorMessages.push('The secret parameter is invalid or malformed.');
                                                                    break;
                                                                case 'missing-input-response':
                                                                    errorMessages.push('The response parameter is missing.');
                                                                    break;
                                                                case 'invalid-input-response':
                                                                    errorMessages.push('The response parameter is invalid or malformed.');
                                                                    break;
                                                                case 'bad-request':
                                                                    errorMessages.push('The request is invalid or malformed.');
                                                                    break;
                                                                case 'timeout-or-duplicate':
                                                                    errorMessages.push('The response is no longer valid: either is too old or has been used previously.');
                                                                    break;
                                                                default:
                                                                    errorMessages.push('Unknown reCAPTCHA error code');
                                                            }
                                                        });
                                                        throw new Error("There was an error when trying to verify the user's response by reCAPTCHA:\n".concat(errorMessages.join('\n')));
                                                    } else if (json.data) throw new Error("The request to verify the reCAPTCHA user token failed: ".concat(response.data));
                                                    else throw new Error('Unknown error occurred when trying to verify the reCAPTCHA user token');
                                                    return [
                                                        3,
                                                        5
                                                    ];
                                                case 4:
                                                    e = _state.sent();
                                                    reject(e);
                                                    return [
                                                        3,
                                                        5
                                                    ];
                                                case 5:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    })();
                                });
                            });
                        })
                    ];
                case 2:
                    e = _state.sent();
                    console.error(e);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};

});
parcelRegister("dxEC4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9dbddc5847e39269$export$71511d61b312f219; });
function $9dbddc5847e39269$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $9dbddc5847e39269$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $9dbddc5847e39269$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $9dbddc5847e39269$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("gh3Df", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bd910d1ee9896911$export$71511d61b312f219; });
function $bd910d1ee9896911$export$71511d61b312f219(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}

});

parcelRegister("4XCT3", function(module, exports) {

$parcel$export(module.exports, "getThemeData", function () { return $39cad640efa60b84$export$3c72f11fd9e5031f; });
var $39cad640efa60b84$export$3c72f11fd9e5031f = function() {
    if (!window.themeDataRestUrl) throw new Error('Missing themeDataRestUrl in global context');
    else {
        var sessionStorageKey = 'themeData';
        return new Promise(function(resolve, reject) {
            if (sessionStorage.getItem('themeData')) resolve(JSON.parse(sessionStorage.getItem(sessionStorageKey)));
            else fetch(window.themeDataRestUrl).then(function(res) {
                return res.json();
            }).then(function(data) {
                try {
                    sessionStorage.setItem(sessionStorageKey, JSON.stringify(data));
                } catch (e) {
                    console.warn(e);
                }
                resolve(data);
            }).catch(function(e) {
                return reject(e);
            });
        });
    }
};

});


parcelRegister("cPDzI", function(module, exports) {

$parcel$export(module.exports, "slideUp", function () { return $9578f243206a91ae$export$deed561b1a0ff1ea; });
$parcel$export(module.exports, "slideDown", function () { return $9578f243206a91ae$export$abdd11a06a163232; });
var $9578f243206a91ae$export$deed561b1a0ff1ea = function(target) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500, isSearchable = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return new Promise(function(resolve) {
        target.style.transitionProperty = 'height, margin, padding';
        target.style.transitionDuration = duration + 'ms';
        target.style.boxSizing = 'border-box';
        target.style.height = target.offsetHeight + 'px';
        target.offsetHeight;
        target.style.overflow = 'hidden';
        [
            'height',
            'paddingTop',
            'paddingBottom',
            'marginTop',
            'marginBottom'
        ].forEach(function(prop) {
            target.style[prop] = 0;
        });
        window.setTimeout(function() {
            if (!isSearchable) target.style.display = 'none';
            [
                'height',
                'padding-top',
                'padding-bottom',
                'margin-top',
                'margin-bottom',
                'overflow',
                'transition-duration',
                'transition-property'
            ].forEach(function(prop) {
                return target.style.removeProperty(prop);
            });
            resolve();
        }, duration);
    });
};
var $9578f243206a91ae$export$abdd11a06a163232 = function(target) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500, isSearchable = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return new Promise(function(resolve) {
        if (!isSearchable) {
            target.style.removeProperty('display');
            var display = window.getComputedStyle(target).display;
            if (display === 'none') display = 'block';
            target.style.display = display;
        }
        var height = target.offsetHeight;
        target.style.overflow = 'hidden';
        [
            'height',
            'paddingTop',
            'paddingBottom',
            'marginTop',
            'marginBottom'
        ].forEach(function(prop) {
            target.style[prop] = 0;
        });
        target.offsetHeight;
        target.style.boxSizing = 'border-box';
        target.style.transitionProperty = 'height, margin, padding';
        target.style.transitionDuration = duration + 'ms';
        target.style.height = height + 'px';
        [
            'padding-top',
            'padding-bottom',
            'margin-top',
            'margin-bottom'
        ].forEach(function(prop) {
            return target.style.removeProperty(prop);
        });
        window.setTimeout(function() {
            [
                'height',
                'overflow',
                'transition-duration',
                'transition-property'
            ].forEach(function(prop) {
                return target.style.removeProperty(prop);
            });
            resolve();
        }, duration);
    });
};
var $9578f243206a91ae$export$715de50cedc228a8 = function(target) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500;
    return window.getComputedStyle(target).display === 'none' ? $9578f243206a91ae$export$abdd11a06a163232(target, duration) : $9578f243206a91ae$export$deed561b1a0ff1ea(target, duration);
};

});

parcelRegister("9vUSI", function(module, exports) {

$parcel$export(module.exports, "scrollToElement", function () { return $6ed321ce261ae421$export$2353115f31f4d15; });
var $6ed321ce261ae421$export$2353115f31f4d15 = function(selector) {
    var targetEl = document.querySelector(selector);
    if (!targetEl) return;
    window.scrollTo(0, window.scrollY + targetEl.getBoundingClientRect().top);
};

});

parcelRegister("5BaYK", function(module, exports) {

$parcel$export(module.exports, "waitForElement", function () { return $4138ec9fb36217c9$export$1a1c301579a08d1e; });
var $4138ec9fb36217c9$export$1a1c301579a08d1e = function(selector) {
    return new Promise(function(resolve) {
        if (document.querySelector(selector)) return resolve(document.querySelector(selector));
        var observer = new MutationObserver(function() {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
};

});


parcelRegister("kwI20", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $ef18f37ed0802d0c$export$882461b6382ed46c; }, function (v) { return $ef18f37ed0802d0c$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $ef18f37ed0802d0c$export$757ceba2d55c277e; }, function (v) { return $ef18f37ed0802d0c$export$757ceba2d55c277e = v; });
var $ef18f37ed0802d0c$export$882461b6382ed46c;
var $ef18f37ed0802d0c$export$757ceba2d55c277e;
'use strict';

var $kqzqZ = parcelRequire("kqzqZ");
var $ef18f37ed0802d0c$var$i;
$ef18f37ed0802d0c$export$882461b6382ed46c = $kqzqZ.createRoot;
$ef18f37ed0802d0c$export$757ceba2d55c277e = $kqzqZ.hydrateRoot;

});
parcelRegister("kqzqZ", function(module, exports) {
'use strict';
function $edf1b8dfeeff597d$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($edf1b8dfeeff597d$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$edf1b8dfeeff597d$var$checkDCE();

module.exports = (parcelRequire("gr7iX"));

});
parcelRegister("gr7iX", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $bf74d58b74973e6b$export$ae55be85d98224ed; }, function (v) { return $bf74d58b74973e6b$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $bf74d58b74973e6b$export$d39a5bbd09211389; }, function (v) { return $bf74d58b74973e6b$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $bf74d58b74973e6b$export$882461b6382ed46c; }, function (v) { return $bf74d58b74973e6b$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $bf74d58b74973e6b$export$466bfc07425424d5; }, function (v) { return $bf74d58b74973e6b$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $bf74d58b74973e6b$export$cd75ccfd720a3cd4; }, function (v) { return $bf74d58b74973e6b$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $bf74d58b74973e6b$export$fa8d919ba61d84db; }, function (v) { return $bf74d58b74973e6b$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $bf74d58b74973e6b$export$757ceba2d55c277e; }, function (v) { return $bf74d58b74973e6b$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $bf74d58b74973e6b$export$b3890eb0ae9dca99; }, function (v) { return $bf74d58b74973e6b$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $bf74d58b74973e6b$export$502457920280e6be; }, function (v) { return $bf74d58b74973e6b$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $bf74d58b74973e6b$export$c78a37762a8d58e1; }, function (v) { return $bf74d58b74973e6b$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $bf74d58b74973e6b$export$dc54d992c10e8a18; }, function (v) { return $bf74d58b74973e6b$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $bf74d58b74973e6b$export$83d89fbfd8236492; }, function (v) { return $bf74d58b74973e6b$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $5djcY = parcelRequire("5djcY");
var $bf74d58b74973e6b$export$ae55be85d98224ed;
var $bf74d58b74973e6b$export$d39a5bbd09211389;
var $bf74d58b74973e6b$export$882461b6382ed46c;
var $bf74d58b74973e6b$export$466bfc07425424d5;
var $bf74d58b74973e6b$export$cd75ccfd720a3cd4;
var $bf74d58b74973e6b$export$fa8d919ba61d84db;
var $bf74d58b74973e6b$export$757ceba2d55c277e;
var $bf74d58b74973e6b$export$b3890eb0ae9dca99;
var $bf74d58b74973e6b$export$502457920280e6be;
var $bf74d58b74973e6b$export$c78a37762a8d58e1;
var $bf74d58b74973e6b$export$dc54d992c10e8a18;
var $bf74d58b74973e6b$export$83d89fbfd8236492;
'use strict';

var $iD6kw = parcelRequire("iD6kw");

var $ojHeY = parcelRequire("ojHeY");
function $bf74d58b74973e6b$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $bf74d58b74973e6b$var$da = new Set, $bf74d58b74973e6b$var$ea = {};
function $bf74d58b74973e6b$var$fa(a, b) {
    $bf74d58b74973e6b$var$ha(a, b);
    $bf74d58b74973e6b$var$ha(a + "Capture", b);
}
function $bf74d58b74973e6b$var$ha(a, b) {
    $bf74d58b74973e6b$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$bf74d58b74973e6b$var$da.add(b[a]);
}
var $bf74d58b74973e6b$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $bf74d58b74973e6b$var$ja = Object.prototype.hasOwnProperty, $bf74d58b74973e6b$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $bf74d58b74973e6b$var$la = {}, $bf74d58b74973e6b$var$ma = {};
function $bf74d58b74973e6b$var$oa(a) {
    if ($bf74d58b74973e6b$var$ja.call($bf74d58b74973e6b$var$ma, a)) return !0;
    if ($bf74d58b74973e6b$var$ja.call($bf74d58b74973e6b$var$la, a)) return !1;
    if ($bf74d58b74973e6b$var$ka.test(a)) return $bf74d58b74973e6b$var$ma[a] = !0;
    $bf74d58b74973e6b$var$la[a] = !0;
    return !1;
}
function $bf74d58b74973e6b$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $5djcY._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $bf74d58b74973e6b$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $bf74d58b74973e6b$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $bf74d58b74973e6b$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $bf74d58b74973e6b$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $bf74d58b74973e6b$var$z[b] = new $bf74d58b74973e6b$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $bf74d58b74973e6b$var$ra = /[\-:]([a-z])/g;
function $bf74d58b74973e6b$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($bf74d58b74973e6b$var$ra, $bf74d58b74973e6b$var$sa);
    $bf74d58b74973e6b$var$z[b] = new $bf74d58b74973e6b$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($bf74d58b74973e6b$var$ra, $bf74d58b74973e6b$var$sa);
    $bf74d58b74973e6b$var$z[b] = new $bf74d58b74973e6b$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($bf74d58b74973e6b$var$ra, $bf74d58b74973e6b$var$sa);
    $bf74d58b74973e6b$var$z[b] = new $bf74d58b74973e6b$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$bf74d58b74973e6b$var$z.xlinkHref = new $bf74d58b74973e6b$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $bf74d58b74973e6b$var$ta(a, b, c, d) {
    var e = $bf74d58b74973e6b$var$z.hasOwnProperty(b) ? $bf74d58b74973e6b$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $bf74d58b74973e6b$var$qa(b, c, e, d) && (c = null), d || null === e ? $bf74d58b74973e6b$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $bf74d58b74973e6b$var$ua = $iD6kw.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $bf74d58b74973e6b$var$va = Symbol.for("react.element"), $bf74d58b74973e6b$var$wa = Symbol.for("react.portal"), $bf74d58b74973e6b$var$ya = Symbol.for("react.fragment"), $bf74d58b74973e6b$var$za = Symbol.for("react.strict_mode"), $bf74d58b74973e6b$var$Aa = Symbol.for("react.profiler"), $bf74d58b74973e6b$var$Ba = Symbol.for("react.provider"), $bf74d58b74973e6b$var$Ca = Symbol.for("react.context"), $bf74d58b74973e6b$var$Da = Symbol.for("react.forward_ref"), $bf74d58b74973e6b$var$Ea = Symbol.for("react.suspense"), $bf74d58b74973e6b$var$Fa = Symbol.for("react.suspense_list"), $bf74d58b74973e6b$var$Ga = Symbol.for("react.memo"), $bf74d58b74973e6b$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $bf74d58b74973e6b$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $bf74d58b74973e6b$var$Ja = Symbol.iterator;
function $bf74d58b74973e6b$var$Ka(a) {
    if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a))) return null;
    a = $bf74d58b74973e6b$var$Ja && a[$bf74d58b74973e6b$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $bf74d58b74973e6b$var$A = Object.assign, $bf74d58b74973e6b$var$La;
function $bf74d58b74973e6b$var$Ma(a) {
    if (void 0 === $bf74d58b74973e6b$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $bf74d58b74973e6b$var$La = b && b[1] || "";
    }
    return "\n" + $bf74d58b74973e6b$var$La + a;
}
var $bf74d58b74973e6b$var$Na = !1;
function $bf74d58b74973e6b$var$Oa(a, b) {
    if (!a || $bf74d58b74973e6b$var$Na) return "";
    $bf74d58b74973e6b$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === (typeof Reflect === "undefined" ? "undefined" : (0, $5djcY._)(Reflect)) && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $bf74d58b74973e6b$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $bf74d58b74973e6b$var$Ma(a) : "";
}
function $bf74d58b74973e6b$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $bf74d58b74973e6b$var$Ma(a.type);
        case 16:
            return $bf74d58b74973e6b$var$Ma("Lazy");
        case 13:
            return $bf74d58b74973e6b$var$Ma("Suspense");
        case 19:
            return $bf74d58b74973e6b$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $bf74d58b74973e6b$var$Oa(a.type, !1), a;
        case 11:
            return a = $bf74d58b74973e6b$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $bf74d58b74973e6b$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $bf74d58b74973e6b$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $bf74d58b74973e6b$var$ya:
            return "Fragment";
        case $bf74d58b74973e6b$var$wa:
            return "Portal";
        case $bf74d58b74973e6b$var$Aa:
            return "Profiler";
        case $bf74d58b74973e6b$var$za:
            return "StrictMode";
        case $bf74d58b74973e6b$var$Ea:
            return "Suspense";
        case $bf74d58b74973e6b$var$Fa:
            return "SuspenseList";
    }
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a))) switch(a.$$typeof){
        case $bf74d58b74973e6b$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $bf74d58b74973e6b$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $bf74d58b74973e6b$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $bf74d58b74973e6b$var$Ga:
            return b = a.displayName || null, null !== b ? b : $bf74d58b74973e6b$var$Qa(a.type) || "Memo";
        case $bf74d58b74973e6b$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $bf74d58b74973e6b$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $bf74d58b74973e6b$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $bf74d58b74973e6b$var$Qa(b);
        case 8:
            return b === $bf74d58b74973e6b$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $bf74d58b74973e6b$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $bf74d58b74973e6b$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $bf74d58b74973e6b$var$Ua(a) {
    var b = $bf74d58b74973e6b$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $bf74d58b74973e6b$var$Va(a) {
    a._valueTracker || (a._valueTracker = $bf74d58b74973e6b$var$Ua(a));
}
function $bf74d58b74973e6b$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $bf74d58b74973e6b$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $bf74d58b74973e6b$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $bf74d58b74973e6b$var$Ya(a, b) {
    var c = b.checked;
    return $bf74d58b74973e6b$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $bf74d58b74973e6b$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $bf74d58b74973e6b$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $bf74d58b74973e6b$var$ab(a, b) {
    b = b.checked;
    null != b && $bf74d58b74973e6b$var$ta(a, "checked", b, !1);
}
function $bf74d58b74973e6b$var$bb(a, b) {
    $bf74d58b74973e6b$var$ab(a, b);
    var c = $bf74d58b74973e6b$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $bf74d58b74973e6b$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $bf74d58b74973e6b$var$cb(a, b.type, $bf74d58b74973e6b$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $bf74d58b74973e6b$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $bf74d58b74973e6b$var$cb(a, b, c) {
    if ("number" !== b || $bf74d58b74973e6b$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $bf74d58b74973e6b$var$eb = Array.isArray;
function $bf74d58b74973e6b$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $bf74d58b74973e6b$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $bf74d58b74973e6b$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($bf74d58b74973e6b$var$p(91));
    return $bf74d58b74973e6b$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $bf74d58b74973e6b$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($bf74d58b74973e6b$var$p(92));
            if ($bf74d58b74973e6b$var$eb(c)) {
                if (1 < c.length) throw Error($bf74d58b74973e6b$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $bf74d58b74973e6b$var$Sa(c)
    };
}
function $bf74d58b74973e6b$var$ib(a, b) {
    var c = $bf74d58b74973e6b$var$Sa(b.value), d = $bf74d58b74973e6b$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $bf74d58b74973e6b$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $bf74d58b74973e6b$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $bf74d58b74973e6b$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $bf74d58b74973e6b$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $bf74d58b74973e6b$var$mb, $bf74d58b74973e6b$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $bf74d58b74973e6b$var$mb = $bf74d58b74973e6b$var$mb || document.createElement("div");
        $bf74d58b74973e6b$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $bf74d58b74973e6b$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $bf74d58b74973e6b$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $bf74d58b74973e6b$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $bf74d58b74973e6b$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($bf74d58b74973e6b$var$pb).forEach(function(a) {
    $bf74d58b74973e6b$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $bf74d58b74973e6b$var$pb[b] = $bf74d58b74973e6b$var$pb[a];
    });
});
function $bf74d58b74973e6b$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $bf74d58b74973e6b$var$pb.hasOwnProperty(a) && $bf74d58b74973e6b$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $bf74d58b74973e6b$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $bf74d58b74973e6b$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $bf74d58b74973e6b$var$tb = $bf74d58b74973e6b$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $bf74d58b74973e6b$var$ub(a, b) {
    if (b) {
        if ($bf74d58b74973e6b$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($bf74d58b74973e6b$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($bf74d58b74973e6b$var$p(60));
            if ("object" !== (0, $5djcY._)(b.dangerouslySetInnerHTML) || !("__html" in b.dangerouslySetInnerHTML)) throw Error($bf74d58b74973e6b$var$p(61));
        }
        if (null != b.style && "object" !== (0, $5djcY._)(b.style)) throw Error($bf74d58b74973e6b$var$p(62));
    }
}
function $bf74d58b74973e6b$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $bf74d58b74973e6b$var$wb = null;
function $bf74d58b74973e6b$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $bf74d58b74973e6b$var$yb = null, $bf74d58b74973e6b$var$zb = null, $bf74d58b74973e6b$var$Ab = null;
function $bf74d58b74973e6b$var$Bb(a) {
    if (a = $bf74d58b74973e6b$var$Cb(a)) {
        if ("function" !== typeof $bf74d58b74973e6b$var$yb) throw Error($bf74d58b74973e6b$var$p(280));
        var b = a.stateNode;
        b && (b = $bf74d58b74973e6b$var$Db(b), $bf74d58b74973e6b$var$yb(a.stateNode, a.type, b));
    }
}
function $bf74d58b74973e6b$var$Eb(a) {
    $bf74d58b74973e6b$var$zb ? $bf74d58b74973e6b$var$Ab ? $bf74d58b74973e6b$var$Ab.push(a) : $bf74d58b74973e6b$var$Ab = [
        a
    ] : $bf74d58b74973e6b$var$zb = a;
}
function $bf74d58b74973e6b$var$Fb() {
    if ($bf74d58b74973e6b$var$zb) {
        var a = $bf74d58b74973e6b$var$zb, b = $bf74d58b74973e6b$var$Ab;
        $bf74d58b74973e6b$var$Ab = $bf74d58b74973e6b$var$zb = null;
        $bf74d58b74973e6b$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$bf74d58b74973e6b$var$Bb(b[a]);
    }
}
function $bf74d58b74973e6b$var$Gb(a, b) {
    return a(b);
}
function $bf74d58b74973e6b$var$Hb() {}
var $bf74d58b74973e6b$var$Ib = !1;
function $bf74d58b74973e6b$var$Jb(a, b, c) {
    if ($bf74d58b74973e6b$var$Ib) return a(b, c);
    $bf74d58b74973e6b$var$Ib = !0;
    try {
        return $bf74d58b74973e6b$var$Gb(a, b, c);
    } finally{
        if ($bf74d58b74973e6b$var$Ib = !1, null !== $bf74d58b74973e6b$var$zb || null !== $bf74d58b74973e6b$var$Ab) $bf74d58b74973e6b$var$Hb(), $bf74d58b74973e6b$var$Fb();
    }
}
function $bf74d58b74973e6b$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $bf74d58b74973e6b$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($bf74d58b74973e6b$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $5djcY._)(c)));
    return c;
}
var $bf74d58b74973e6b$var$Lb = !1;
if ($bf74d58b74973e6b$var$ia) try {
    var $bf74d58b74973e6b$var$Mb = {};
    Object.defineProperty($bf74d58b74973e6b$var$Mb, "passive", {
        get: function get() {
            $bf74d58b74973e6b$var$Lb = !0;
        }
    });
    window.addEventListener("test", $bf74d58b74973e6b$var$Mb, $bf74d58b74973e6b$var$Mb);
    window.removeEventListener("test", $bf74d58b74973e6b$var$Mb, $bf74d58b74973e6b$var$Mb);
} catch (a) {
    $bf74d58b74973e6b$var$Lb = !1;
}
function $bf74d58b74973e6b$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $bf74d58b74973e6b$var$Ob = !1, $bf74d58b74973e6b$var$Pb = null, $bf74d58b74973e6b$var$Qb = !1, $bf74d58b74973e6b$var$Rb = null, $bf74d58b74973e6b$var$Sb = {
    onError: function onError(a) {
        $bf74d58b74973e6b$var$Ob = !0;
        $bf74d58b74973e6b$var$Pb = a;
    }
};
function $bf74d58b74973e6b$var$Tb(a, b, c, d, e, f, g, h, k) {
    $bf74d58b74973e6b$var$Ob = !1;
    $bf74d58b74973e6b$var$Pb = null;
    $bf74d58b74973e6b$var$Nb.apply($bf74d58b74973e6b$var$Sb, arguments);
}
function $bf74d58b74973e6b$var$Ub(a, b, c, d, e, f, g, h, k) {
    $bf74d58b74973e6b$var$Tb.apply(this, arguments);
    if ($bf74d58b74973e6b$var$Ob) {
        if ($bf74d58b74973e6b$var$Ob) {
            var l = $bf74d58b74973e6b$var$Pb;
            $bf74d58b74973e6b$var$Ob = !1;
            $bf74d58b74973e6b$var$Pb = null;
        } else throw Error($bf74d58b74973e6b$var$p(198));
        $bf74d58b74973e6b$var$Qb || ($bf74d58b74973e6b$var$Qb = !0, $bf74d58b74973e6b$var$Rb = l);
    }
}
function $bf74d58b74973e6b$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $bf74d58b74973e6b$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $bf74d58b74973e6b$var$Xb(a) {
    if ($bf74d58b74973e6b$var$Vb(a) !== a) throw Error($bf74d58b74973e6b$var$p(188));
}
function $bf74d58b74973e6b$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $bf74d58b74973e6b$var$Vb(a);
        if (null === b) throw Error($bf74d58b74973e6b$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $bf74d58b74973e6b$var$Xb(e), a;
                if (f === d) return $bf74d58b74973e6b$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($bf74d58b74973e6b$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($bf74d58b74973e6b$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($bf74d58b74973e6b$var$p(190));
    }
    if (3 !== c.tag) throw Error($bf74d58b74973e6b$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $bf74d58b74973e6b$var$Zb(a) {
    a = $bf74d58b74973e6b$var$Yb(a);
    return null !== a ? $bf74d58b74973e6b$var$$b(a) : null;
}
function $bf74d58b74973e6b$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $bf74d58b74973e6b$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $bf74d58b74973e6b$var$ac = $ojHeY.unstable_scheduleCallback, $bf74d58b74973e6b$var$bc = $ojHeY.unstable_cancelCallback, $bf74d58b74973e6b$var$cc = $ojHeY.unstable_shouldYield, $bf74d58b74973e6b$var$dc = $ojHeY.unstable_requestPaint, $bf74d58b74973e6b$var$B = $ojHeY.unstable_now, $bf74d58b74973e6b$var$ec = $ojHeY.unstable_getCurrentPriorityLevel, $bf74d58b74973e6b$var$fc = $ojHeY.unstable_ImmediatePriority, $bf74d58b74973e6b$var$gc = $ojHeY.unstable_UserBlockingPriority, $bf74d58b74973e6b$var$hc = $ojHeY.unstable_NormalPriority, $bf74d58b74973e6b$var$ic = $ojHeY.unstable_LowPriority, $bf74d58b74973e6b$var$jc = $ojHeY.unstable_IdlePriority, $bf74d58b74973e6b$var$kc = null, $bf74d58b74973e6b$var$lc = null;
function $bf74d58b74973e6b$var$mc(a) {
    if ($bf74d58b74973e6b$var$lc && "function" === typeof $bf74d58b74973e6b$var$lc.onCommitFiberRoot) try {
        $bf74d58b74973e6b$var$lc.onCommitFiberRoot($bf74d58b74973e6b$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $bf74d58b74973e6b$var$oc = Math.clz32 ? Math.clz32 : $bf74d58b74973e6b$var$nc, $bf74d58b74973e6b$var$pc = Math.log, $bf74d58b74973e6b$var$qc = Math.LN2;
function $bf74d58b74973e6b$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($bf74d58b74973e6b$var$pc(a) / $bf74d58b74973e6b$var$qc | 0) | 0;
}
var $bf74d58b74973e6b$var$rc = 64, $bf74d58b74973e6b$var$sc = 4194304;
function $bf74d58b74973e6b$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $bf74d58b74973e6b$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $bf74d58b74973e6b$var$tc(h) : (f &= g, 0 !== f && (d = $bf74d58b74973e6b$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $bf74d58b74973e6b$var$tc(g) : 0 !== f && (d = $bf74d58b74973e6b$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $bf74d58b74973e6b$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $bf74d58b74973e6b$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $bf74d58b74973e6b$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $bf74d58b74973e6b$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $bf74d58b74973e6b$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $bf74d58b74973e6b$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $bf74d58b74973e6b$var$yc() {
    var a = $bf74d58b74973e6b$var$rc;
    $bf74d58b74973e6b$var$rc <<= 1;
    0 === ($bf74d58b74973e6b$var$rc & 4194240) && ($bf74d58b74973e6b$var$rc = 64);
    return a;
}
function $bf74d58b74973e6b$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $bf74d58b74973e6b$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $bf74d58b74973e6b$var$oc(b);
    a[b] = c;
}
function $bf74d58b74973e6b$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $bf74d58b74973e6b$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $bf74d58b74973e6b$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $bf74d58b74973e6b$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $bf74d58b74973e6b$var$C = 0;
function $bf74d58b74973e6b$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $bf74d58b74973e6b$var$Ec, $bf74d58b74973e6b$var$Fc, $bf74d58b74973e6b$var$Gc, $bf74d58b74973e6b$var$Hc, $bf74d58b74973e6b$var$Ic, $bf74d58b74973e6b$var$Jc = !1, $bf74d58b74973e6b$var$Kc = [], $bf74d58b74973e6b$var$Lc = null, $bf74d58b74973e6b$var$Mc = null, $bf74d58b74973e6b$var$Nc = null, $bf74d58b74973e6b$var$Oc = new Map, $bf74d58b74973e6b$var$Pc = new Map, $bf74d58b74973e6b$var$Qc = [], $bf74d58b74973e6b$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $bf74d58b74973e6b$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $bf74d58b74973e6b$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $bf74d58b74973e6b$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $bf74d58b74973e6b$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $bf74d58b74973e6b$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $bf74d58b74973e6b$var$Pc.delete(b.pointerId);
    }
}
function $bf74d58b74973e6b$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $bf74d58b74973e6b$var$Cb(b), null !== b && $bf74d58b74973e6b$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $bf74d58b74973e6b$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $bf74d58b74973e6b$var$Lc = $bf74d58b74973e6b$var$Tc($bf74d58b74973e6b$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $bf74d58b74973e6b$var$Mc = $bf74d58b74973e6b$var$Tc($bf74d58b74973e6b$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $bf74d58b74973e6b$var$Nc = $bf74d58b74973e6b$var$Tc($bf74d58b74973e6b$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $bf74d58b74973e6b$var$Oc.set(f, $bf74d58b74973e6b$var$Tc($bf74d58b74973e6b$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $bf74d58b74973e6b$var$Pc.set(f, $bf74d58b74973e6b$var$Tc($bf74d58b74973e6b$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $bf74d58b74973e6b$var$Vc(a) {
    var b = $bf74d58b74973e6b$var$Wc(a.target);
    if (null !== b) {
        var c = $bf74d58b74973e6b$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $bf74d58b74973e6b$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $bf74d58b74973e6b$var$Ic(a.priority, function() {
                        $bf74d58b74973e6b$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $bf74d58b74973e6b$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $bf74d58b74973e6b$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $bf74d58b74973e6b$var$wb = d;
            c.target.dispatchEvent(d);
            $bf74d58b74973e6b$var$wb = null;
        } else return b = $bf74d58b74973e6b$var$Cb(c), null !== b && $bf74d58b74973e6b$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $bf74d58b74973e6b$var$Zc(a, b, c) {
    $bf74d58b74973e6b$var$Xc(a) && c.delete(b);
}
function $bf74d58b74973e6b$var$$c() {
    $bf74d58b74973e6b$var$Jc = !1;
    null !== $bf74d58b74973e6b$var$Lc && $bf74d58b74973e6b$var$Xc($bf74d58b74973e6b$var$Lc) && ($bf74d58b74973e6b$var$Lc = null);
    null !== $bf74d58b74973e6b$var$Mc && $bf74d58b74973e6b$var$Xc($bf74d58b74973e6b$var$Mc) && ($bf74d58b74973e6b$var$Mc = null);
    null !== $bf74d58b74973e6b$var$Nc && $bf74d58b74973e6b$var$Xc($bf74d58b74973e6b$var$Nc) && ($bf74d58b74973e6b$var$Nc = null);
    $bf74d58b74973e6b$var$Oc.forEach($bf74d58b74973e6b$var$Zc);
    $bf74d58b74973e6b$var$Pc.forEach($bf74d58b74973e6b$var$Zc);
}
function $bf74d58b74973e6b$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $bf74d58b74973e6b$var$Jc || ($bf74d58b74973e6b$var$Jc = !0, $ojHeY.unstable_scheduleCallback($ojHeY.unstable_NormalPriority, $bf74d58b74973e6b$var$$c)));
}
function $bf74d58b74973e6b$var$bd(a) {
    function b(b) {
        return $bf74d58b74973e6b$var$ad(b, a);
    }
    if (0 < $bf74d58b74973e6b$var$Kc.length) {
        $bf74d58b74973e6b$var$ad($bf74d58b74973e6b$var$Kc[0], a);
        for(var c = 1; c < $bf74d58b74973e6b$var$Kc.length; c++){
            var d = $bf74d58b74973e6b$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $bf74d58b74973e6b$var$Lc && $bf74d58b74973e6b$var$ad($bf74d58b74973e6b$var$Lc, a);
    null !== $bf74d58b74973e6b$var$Mc && $bf74d58b74973e6b$var$ad($bf74d58b74973e6b$var$Mc, a);
    null !== $bf74d58b74973e6b$var$Nc && $bf74d58b74973e6b$var$ad($bf74d58b74973e6b$var$Nc, a);
    $bf74d58b74973e6b$var$Oc.forEach(b);
    $bf74d58b74973e6b$var$Pc.forEach(b);
    for(c = 0; c < $bf74d58b74973e6b$var$Qc.length; c++)d = $bf74d58b74973e6b$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $bf74d58b74973e6b$var$Qc.length && (c = $bf74d58b74973e6b$var$Qc[0], null === c.blockedOn);)$bf74d58b74973e6b$var$Vc(c), null === c.blockedOn && $bf74d58b74973e6b$var$Qc.shift();
}
var $bf74d58b74973e6b$var$cd = $bf74d58b74973e6b$var$ua.ReactCurrentBatchConfig, $bf74d58b74973e6b$var$dd = !0;
function $bf74d58b74973e6b$var$ed(a, b, c, d) {
    var e = $bf74d58b74973e6b$var$C, f = $bf74d58b74973e6b$var$cd.transition;
    $bf74d58b74973e6b$var$cd.transition = null;
    try {
        $bf74d58b74973e6b$var$C = 1, $bf74d58b74973e6b$var$fd(a, b, c, d);
    } finally{
        $bf74d58b74973e6b$var$C = e, $bf74d58b74973e6b$var$cd.transition = f;
    }
}
function $bf74d58b74973e6b$var$gd(a, b, c, d) {
    var e = $bf74d58b74973e6b$var$C, f = $bf74d58b74973e6b$var$cd.transition;
    $bf74d58b74973e6b$var$cd.transition = null;
    try {
        $bf74d58b74973e6b$var$C = 4, $bf74d58b74973e6b$var$fd(a, b, c, d);
    } finally{
        $bf74d58b74973e6b$var$C = e, $bf74d58b74973e6b$var$cd.transition = f;
    }
}
function $bf74d58b74973e6b$var$fd(a, b, c, d) {
    if ($bf74d58b74973e6b$var$dd) {
        var e = $bf74d58b74973e6b$var$Yc(a, b, c, d);
        if (null === e) $bf74d58b74973e6b$var$hd(a, b, d, $bf74d58b74973e6b$var$id, c), $bf74d58b74973e6b$var$Sc(a, d);
        else if ($bf74d58b74973e6b$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($bf74d58b74973e6b$var$Sc(a, d), b & 4 && -1 < $bf74d58b74973e6b$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $bf74d58b74973e6b$var$Cb(e);
                null !== f && $bf74d58b74973e6b$var$Ec(f);
                f = $bf74d58b74973e6b$var$Yc(a, b, c, d);
                null === f && $bf74d58b74973e6b$var$hd(a, b, d, $bf74d58b74973e6b$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $bf74d58b74973e6b$var$hd(a, b, d, null, c);
    }
}
var $bf74d58b74973e6b$var$id = null;
function $bf74d58b74973e6b$var$Yc(a, b, c, d) {
    $bf74d58b74973e6b$var$id = null;
    a = $bf74d58b74973e6b$var$xb(d);
    a = $bf74d58b74973e6b$var$Wc(a);
    if (null !== a) {
        if (b = $bf74d58b74973e6b$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $bf74d58b74973e6b$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $bf74d58b74973e6b$var$id = a;
    return null;
}
function $bf74d58b74973e6b$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($bf74d58b74973e6b$var$ec()){
                case $bf74d58b74973e6b$var$fc:
                    return 1;
                case $bf74d58b74973e6b$var$gc:
                    return 4;
                case $bf74d58b74973e6b$var$hc:
                case $bf74d58b74973e6b$var$ic:
                    return 16;
                case $bf74d58b74973e6b$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $bf74d58b74973e6b$var$kd = null, $bf74d58b74973e6b$var$ld = null, $bf74d58b74973e6b$var$md = null;
function $bf74d58b74973e6b$var$nd() {
    if ($bf74d58b74973e6b$var$md) return $bf74d58b74973e6b$var$md;
    var a, b = $bf74d58b74973e6b$var$ld, c = b.length, d, e = "value" in $bf74d58b74973e6b$var$kd ? $bf74d58b74973e6b$var$kd.value : $bf74d58b74973e6b$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $bf74d58b74973e6b$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $bf74d58b74973e6b$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $bf74d58b74973e6b$var$pd() {
    return !0;
}
function $bf74d58b74973e6b$var$qd() {
    return !1;
}
function $bf74d58b74973e6b$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $bf74d58b74973e6b$var$pd : $bf74d58b74973e6b$var$qd;
        this.isPropagationStopped = $bf74d58b74973e6b$var$qd;
        return this;
    }
    $bf74d58b74973e6b$var$A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $5djcY._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $bf74d58b74973e6b$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $5djcY._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $bf74d58b74973e6b$var$pd);
        },
        persist: function persist() {},
        isPersistent: $bf74d58b74973e6b$var$pd
    });
    return b;
}
var $bf74d58b74973e6b$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $bf74d58b74973e6b$var$td = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$sd), $bf74d58b74973e6b$var$ud = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$sd, {
    view: 0,
    detail: 0
}), $bf74d58b74973e6b$var$vd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$ud), $bf74d58b74973e6b$var$wd, $bf74d58b74973e6b$var$xd, $bf74d58b74973e6b$var$yd, $bf74d58b74973e6b$var$Ad = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $bf74d58b74973e6b$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $bf74d58b74973e6b$var$yd && ($bf74d58b74973e6b$var$yd && "mousemove" === a.type ? ($bf74d58b74973e6b$var$wd = a.screenX - $bf74d58b74973e6b$var$yd.screenX, $bf74d58b74973e6b$var$xd = a.screenY - $bf74d58b74973e6b$var$yd.screenY) : $bf74d58b74973e6b$var$xd = $bf74d58b74973e6b$var$wd = 0, $bf74d58b74973e6b$var$yd = a);
        return $bf74d58b74973e6b$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $bf74d58b74973e6b$var$xd;
    }
}), $bf74d58b74973e6b$var$Bd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Ad), $bf74d58b74973e6b$var$Cd = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$Ad, {
    dataTransfer: 0
}), $bf74d58b74973e6b$var$Dd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Cd), $bf74d58b74973e6b$var$Ed = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$ud, {
    relatedTarget: 0
}), $bf74d58b74973e6b$var$Fd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Ed), $bf74d58b74973e6b$var$Gd = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $bf74d58b74973e6b$var$Hd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Gd), $bf74d58b74973e6b$var$Id = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $bf74d58b74973e6b$var$Jd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Id), $bf74d58b74973e6b$var$Kd = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$sd, {
    data: 0
}), $bf74d58b74973e6b$var$Ld = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Kd), $bf74d58b74973e6b$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $bf74d58b74973e6b$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $bf74d58b74973e6b$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $bf74d58b74973e6b$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $bf74d58b74973e6b$var$Od[a]) ? !!b[a] : !1;
}
function $bf74d58b74973e6b$var$zd() {
    return $bf74d58b74973e6b$var$Pd;
}
var $bf74d58b74973e6b$var$Qd = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $bf74d58b74973e6b$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $bf74d58b74973e6b$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $bf74d58b74973e6b$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $bf74d58b74973e6b$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $bf74d58b74973e6b$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $bf74d58b74973e6b$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $bf74d58b74973e6b$var$Rd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Qd), $bf74d58b74973e6b$var$Sd = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $bf74d58b74973e6b$var$Td = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Sd), $bf74d58b74973e6b$var$Ud = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $bf74d58b74973e6b$var$zd
}), $bf74d58b74973e6b$var$Vd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Ud), $bf74d58b74973e6b$var$Wd = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $bf74d58b74973e6b$var$Xd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Wd), $bf74d58b74973e6b$var$Yd = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $bf74d58b74973e6b$var$Zd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Yd), $bf74d58b74973e6b$var$$d = [
    9,
    13,
    27,
    32
], $bf74d58b74973e6b$var$ae = $bf74d58b74973e6b$var$ia && "CompositionEvent" in window, $bf74d58b74973e6b$var$be = null;
$bf74d58b74973e6b$var$ia && "documentMode" in document && ($bf74d58b74973e6b$var$be = document.documentMode);
var $bf74d58b74973e6b$var$ce = $bf74d58b74973e6b$var$ia && "TextEvent" in window && !$bf74d58b74973e6b$var$be, $bf74d58b74973e6b$var$de = $bf74d58b74973e6b$var$ia && (!$bf74d58b74973e6b$var$ae || $bf74d58b74973e6b$var$be && 8 < $bf74d58b74973e6b$var$be && 11 >= $bf74d58b74973e6b$var$be), $bf74d58b74973e6b$var$ee = String.fromCharCode(32), $bf74d58b74973e6b$var$fe = !1;
function $bf74d58b74973e6b$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $bf74d58b74973e6b$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $bf74d58b74973e6b$var$he(a) {
    a = a.detail;
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a)) && "data" in a ? a.data : null;
}
var $bf74d58b74973e6b$var$ie = !1;
function $bf74d58b74973e6b$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $bf74d58b74973e6b$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $bf74d58b74973e6b$var$fe = !0;
            return $bf74d58b74973e6b$var$ee;
        case "textInput":
            return a = b.data, a === $bf74d58b74973e6b$var$ee && $bf74d58b74973e6b$var$fe ? null : a;
        default:
            return null;
    }
}
function $bf74d58b74973e6b$var$ke(a, b) {
    if ($bf74d58b74973e6b$var$ie) return "compositionend" === a || !$bf74d58b74973e6b$var$ae && $bf74d58b74973e6b$var$ge(a, b) ? (a = $bf74d58b74973e6b$var$nd(), $bf74d58b74973e6b$var$md = $bf74d58b74973e6b$var$ld = $bf74d58b74973e6b$var$kd = null, $bf74d58b74973e6b$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $bf74d58b74973e6b$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $bf74d58b74973e6b$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $bf74d58b74973e6b$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$bf74d58b74973e6b$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $bf74d58b74973e6b$var$ne(a, b, c, d) {
    $bf74d58b74973e6b$var$Eb(d);
    b = $bf74d58b74973e6b$var$oe(b, "onChange");
    0 < b.length && (c = new $bf74d58b74973e6b$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $bf74d58b74973e6b$var$pe = null, $bf74d58b74973e6b$var$qe = null;
function $bf74d58b74973e6b$var$re(a) {
    $bf74d58b74973e6b$var$se(a, 0);
}
function $bf74d58b74973e6b$var$te(a) {
    var b = $bf74d58b74973e6b$var$ue(a);
    if ($bf74d58b74973e6b$var$Wa(b)) return a;
}
function $bf74d58b74973e6b$var$ve(a, b) {
    if ("change" === a) return b;
}
var $bf74d58b74973e6b$var$we = !1;
if ($bf74d58b74973e6b$var$ia) {
    var $bf74d58b74973e6b$var$xe;
    if ($bf74d58b74973e6b$var$ia) {
        var $bf74d58b74973e6b$var$ye = "oninput" in document;
        if (!$bf74d58b74973e6b$var$ye) {
            var $bf74d58b74973e6b$var$ze = document.createElement("div");
            $bf74d58b74973e6b$var$ze.setAttribute("oninput", "return;");
            $bf74d58b74973e6b$var$ye = "function" === typeof $bf74d58b74973e6b$var$ze.oninput;
        }
        $bf74d58b74973e6b$var$xe = $bf74d58b74973e6b$var$ye;
    } else $bf74d58b74973e6b$var$xe = !1;
    $bf74d58b74973e6b$var$we = $bf74d58b74973e6b$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $bf74d58b74973e6b$var$Ae() {
    $bf74d58b74973e6b$var$pe && ($bf74d58b74973e6b$var$pe.detachEvent("onpropertychange", $bf74d58b74973e6b$var$Be), $bf74d58b74973e6b$var$qe = $bf74d58b74973e6b$var$pe = null);
}
function $bf74d58b74973e6b$var$Be(a) {
    if ("value" === a.propertyName && $bf74d58b74973e6b$var$te($bf74d58b74973e6b$var$qe)) {
        var b = [];
        $bf74d58b74973e6b$var$ne(b, $bf74d58b74973e6b$var$qe, a, $bf74d58b74973e6b$var$xb(a));
        $bf74d58b74973e6b$var$Jb($bf74d58b74973e6b$var$re, b);
    }
}
function $bf74d58b74973e6b$var$Ce(a, b, c) {
    "focusin" === a ? ($bf74d58b74973e6b$var$Ae(), $bf74d58b74973e6b$var$pe = b, $bf74d58b74973e6b$var$qe = c, $bf74d58b74973e6b$var$pe.attachEvent("onpropertychange", $bf74d58b74973e6b$var$Be)) : "focusout" === a && $bf74d58b74973e6b$var$Ae();
}
function $bf74d58b74973e6b$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $bf74d58b74973e6b$var$te($bf74d58b74973e6b$var$qe);
}
function $bf74d58b74973e6b$var$Ee(a, b) {
    if ("click" === a) return $bf74d58b74973e6b$var$te(b);
}
function $bf74d58b74973e6b$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $bf74d58b74973e6b$var$te(b);
}
function $bf74d58b74973e6b$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $bf74d58b74973e6b$var$He = "function" === typeof Object.is ? Object.is : $bf74d58b74973e6b$var$Ge;
function $bf74d58b74973e6b$var$Ie(a, b) {
    if ($bf74d58b74973e6b$var$He(a, b)) return !0;
    if ("object" !== (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a)) || null === a || "object" !== (typeof b === "undefined" ? "undefined" : (0, $5djcY._)(b)) || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$bf74d58b74973e6b$var$ja.call(b, e) || !$bf74d58b74973e6b$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $bf74d58b74973e6b$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $bf74d58b74973e6b$var$Ke(a, b) {
    var c = $bf74d58b74973e6b$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $bf74d58b74973e6b$var$Je(c);
    }
}
function $bf74d58b74973e6b$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $bf74d58b74973e6b$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $bf74d58b74973e6b$var$Me() {
    for(var a = window, b = $bf74d58b74973e6b$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $bf74d58b74973e6b$var$Xa(a.document);
    }
    return b;
}
function $bf74d58b74973e6b$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $bf74d58b74973e6b$var$Oe(a) {
    var b = $bf74d58b74973e6b$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $bf74d58b74973e6b$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $bf74d58b74973e6b$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $bf74d58b74973e6b$var$Ke(c, f);
                var g = $bf74d58b74973e6b$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $bf74d58b74973e6b$var$Pe = $bf74d58b74973e6b$var$ia && "documentMode" in document && 11 >= document.documentMode, $bf74d58b74973e6b$var$Qe = null, $bf74d58b74973e6b$var$Re = null, $bf74d58b74973e6b$var$Se = null, $bf74d58b74973e6b$var$Te = !1;
function $bf74d58b74973e6b$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $bf74d58b74973e6b$var$Te || null == $bf74d58b74973e6b$var$Qe || $bf74d58b74973e6b$var$Qe !== $bf74d58b74973e6b$var$Xa(d) || (d = $bf74d58b74973e6b$var$Qe, "selectionStart" in d && $bf74d58b74973e6b$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $bf74d58b74973e6b$var$Se && $bf74d58b74973e6b$var$Ie($bf74d58b74973e6b$var$Se, d) || ($bf74d58b74973e6b$var$Se = d, d = $bf74d58b74973e6b$var$oe($bf74d58b74973e6b$var$Re, "onSelect"), 0 < d.length && (b = new $bf74d58b74973e6b$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $bf74d58b74973e6b$var$Qe)));
}
function $bf74d58b74973e6b$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $bf74d58b74973e6b$var$We = {
    animationend: $bf74d58b74973e6b$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $bf74d58b74973e6b$var$Ve("Animation", "AnimationIteration"),
    animationstart: $bf74d58b74973e6b$var$Ve("Animation", "AnimationStart"),
    transitionend: $bf74d58b74973e6b$var$Ve("Transition", "TransitionEnd")
}, $bf74d58b74973e6b$var$Xe = {}, $bf74d58b74973e6b$var$Ye = {};
$bf74d58b74973e6b$var$ia && ($bf74d58b74973e6b$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $bf74d58b74973e6b$var$We.animationend.animation, delete $bf74d58b74973e6b$var$We.animationiteration.animation, delete $bf74d58b74973e6b$var$We.animationstart.animation), "TransitionEvent" in window || delete $bf74d58b74973e6b$var$We.transitionend.transition);
function $bf74d58b74973e6b$var$Ze(a) {
    if ($bf74d58b74973e6b$var$Xe[a]) return $bf74d58b74973e6b$var$Xe[a];
    if (!$bf74d58b74973e6b$var$We[a]) return a;
    var b = $bf74d58b74973e6b$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $bf74d58b74973e6b$var$Ye) return $bf74d58b74973e6b$var$Xe[a] = b[c];
    return a;
}
var $bf74d58b74973e6b$var$$e = $bf74d58b74973e6b$var$Ze("animationend"), $bf74d58b74973e6b$var$af = $bf74d58b74973e6b$var$Ze("animationiteration"), $bf74d58b74973e6b$var$bf = $bf74d58b74973e6b$var$Ze("animationstart"), $bf74d58b74973e6b$var$cf = $bf74d58b74973e6b$var$Ze("transitionend"), $bf74d58b74973e6b$var$df = new Map, $bf74d58b74973e6b$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $bf74d58b74973e6b$var$ff(a, b) {
    $bf74d58b74973e6b$var$df.set(a, b);
    $bf74d58b74973e6b$var$fa(b, [
        a
    ]);
}
for(var $bf74d58b74973e6b$var$gf = 0; $bf74d58b74973e6b$var$gf < $bf74d58b74973e6b$var$ef.length; $bf74d58b74973e6b$var$gf++){
    var $bf74d58b74973e6b$var$hf = $bf74d58b74973e6b$var$ef[$bf74d58b74973e6b$var$gf], $bf74d58b74973e6b$var$jf = $bf74d58b74973e6b$var$hf.toLowerCase(), $bf74d58b74973e6b$var$kf = $bf74d58b74973e6b$var$hf[0].toUpperCase() + $bf74d58b74973e6b$var$hf.slice(1);
    $bf74d58b74973e6b$var$ff($bf74d58b74973e6b$var$jf, "on" + $bf74d58b74973e6b$var$kf);
}
$bf74d58b74973e6b$var$ff($bf74d58b74973e6b$var$$e, "onAnimationEnd");
$bf74d58b74973e6b$var$ff($bf74d58b74973e6b$var$af, "onAnimationIteration");
$bf74d58b74973e6b$var$ff($bf74d58b74973e6b$var$bf, "onAnimationStart");
$bf74d58b74973e6b$var$ff("dblclick", "onDoubleClick");
$bf74d58b74973e6b$var$ff("focusin", "onFocus");
$bf74d58b74973e6b$var$ff("focusout", "onBlur");
$bf74d58b74973e6b$var$ff($bf74d58b74973e6b$var$cf, "onTransitionEnd");
$bf74d58b74973e6b$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$bf74d58b74973e6b$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$bf74d58b74973e6b$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$bf74d58b74973e6b$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$bf74d58b74973e6b$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$bf74d58b74973e6b$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$bf74d58b74973e6b$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$bf74d58b74973e6b$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$bf74d58b74973e6b$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$bf74d58b74973e6b$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $bf74d58b74973e6b$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $bf74d58b74973e6b$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($bf74d58b74973e6b$var$lf));
function $bf74d58b74973e6b$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $bf74d58b74973e6b$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $bf74d58b74973e6b$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $bf74d58b74973e6b$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $bf74d58b74973e6b$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($bf74d58b74973e6b$var$Qb) throw a = $bf74d58b74973e6b$var$Rb, $bf74d58b74973e6b$var$Qb = !1, $bf74d58b74973e6b$var$Rb = null, a;
}
function $bf74d58b74973e6b$var$D(a, b) {
    var c = b[$bf74d58b74973e6b$var$of];
    void 0 === c && (c = b[$bf74d58b74973e6b$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($bf74d58b74973e6b$var$pf(b, a, 2, !1), c.add(d));
}
function $bf74d58b74973e6b$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $bf74d58b74973e6b$var$pf(c, a, d, b);
}
var $bf74d58b74973e6b$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $bf74d58b74973e6b$var$sf(a) {
    if (!a[$bf74d58b74973e6b$var$rf]) {
        a[$bf74d58b74973e6b$var$rf] = !0;
        $bf74d58b74973e6b$var$da.forEach(function(b) {
            "selectionchange" !== b && ($bf74d58b74973e6b$var$mf.has(b) || $bf74d58b74973e6b$var$qf(b, !1, a), $bf74d58b74973e6b$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$bf74d58b74973e6b$var$rf] || (b[$bf74d58b74973e6b$var$rf] = !0, $bf74d58b74973e6b$var$qf("selectionchange", !1, b));
    }
}
function $bf74d58b74973e6b$var$pf(a, b, c, d) {
    switch($bf74d58b74973e6b$var$jd(b)){
        case 1:
            var e = $bf74d58b74973e6b$var$ed;
            break;
        case 4:
            e = $bf74d58b74973e6b$var$gd;
            break;
        default:
            e = $bf74d58b74973e6b$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$bf74d58b74973e6b$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $bf74d58b74973e6b$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $bf74d58b74973e6b$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $bf74d58b74973e6b$var$Jb(function() {
        var _$d = f, _$e = $bf74d58b74973e6b$var$xb(c), g = [];
        a: {
            var h = $bf74d58b74973e6b$var$df.get(a);
            if (void 0 !== h) {
                var k = $bf74d58b74973e6b$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $bf74d58b74973e6b$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $bf74d58b74973e6b$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $bf74d58b74973e6b$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $bf74d58b74973e6b$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $bf74d58b74973e6b$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $bf74d58b74973e6b$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $bf74d58b74973e6b$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $bf74d58b74973e6b$var$Vd;
                        break;
                    case $bf74d58b74973e6b$var$$e:
                    case $bf74d58b74973e6b$var$af:
                    case $bf74d58b74973e6b$var$bf:
                        k = $bf74d58b74973e6b$var$Hd;
                        break;
                    case $bf74d58b74973e6b$var$cf:
                        k = $bf74d58b74973e6b$var$Xd;
                        break;
                    case "scroll":
                        k = $bf74d58b74973e6b$var$vd;
                        break;
                    case "wheel":
                        k = $bf74d58b74973e6b$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $bf74d58b74973e6b$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $bf74d58b74973e6b$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $bf74d58b74973e6b$var$Kb(w, x), null != F && t.push($bf74d58b74973e6b$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $bf74d58b74973e6b$var$wb && (n = c.relatedTarget || c.fromElement) && ($bf74d58b74973e6b$var$Wc(n) || n[$bf74d58b74973e6b$var$uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? $bf74d58b74973e6b$var$Wc(n) : null, null !== n && (J = $bf74d58b74973e6b$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = $bf74d58b74973e6b$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $bf74d58b74973e6b$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $bf74d58b74973e6b$var$ue(k);
                        u = null == n ? h : $bf74d58b74973e6b$var$ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $bf74d58b74973e6b$var$Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $bf74d58b74973e6b$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $bf74d58b74973e6b$var$vf(F))u++;
                            for(; 0 < w - u;)t = $bf74d58b74973e6b$var$vf(t), w--;
                            for(; 0 < u - w;)x = $bf74d58b74973e6b$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $bf74d58b74973e6b$var$vf(t);
                                x = $bf74d58b74973e6b$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $bf74d58b74973e6b$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $bf74d58b74973e6b$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? $bf74d58b74973e6b$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $bf74d58b74973e6b$var$ve;
                else if ($bf74d58b74973e6b$var$me(h)) {
                    if ($bf74d58b74973e6b$var$we) na = $bf74d58b74973e6b$var$Fe;
                    else {
                        na = $bf74d58b74973e6b$var$De;
                        var xa = $bf74d58b74973e6b$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $bf74d58b74973e6b$var$Ee);
                if (na && (na = na(a, _$d))) {
                    $bf74d58b74973e6b$var$ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $bf74d58b74973e6b$var$cb(h, "number", h.value);
            }
            xa = _$d ? $bf74d58b74973e6b$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($bf74d58b74973e6b$var$me(xa) || "true" === xa.contentEditable) $bf74d58b74973e6b$var$Qe = xa, $bf74d58b74973e6b$var$Re = _$d, $bf74d58b74973e6b$var$Se = null;
                    break;
                case "focusout":
                    $bf74d58b74973e6b$var$Se = $bf74d58b74973e6b$var$Re = $bf74d58b74973e6b$var$Qe = null;
                    break;
                case "mousedown":
                    $bf74d58b74973e6b$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $bf74d58b74973e6b$var$Te = !1;
                    $bf74d58b74973e6b$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($bf74d58b74973e6b$var$Pe) break;
                case "keydown":
                case "keyup":
                    $bf74d58b74973e6b$var$Ue(g, c, _$e);
            }
            var $a;
            if ($bf74d58b74973e6b$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $bf74d58b74973e6b$var$ie ? $bf74d58b74973e6b$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($bf74d58b74973e6b$var$de && "ko" !== c.locale && ($bf74d58b74973e6b$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $bf74d58b74973e6b$var$ie && ($a = $bf74d58b74973e6b$var$nd()) : ($bf74d58b74973e6b$var$kd = _$e, $bf74d58b74973e6b$var$ld = "value" in $bf74d58b74973e6b$var$kd ? $bf74d58b74973e6b$var$kd.value : $bf74d58b74973e6b$var$kd.textContent, $bf74d58b74973e6b$var$ie = !0)), xa = $bf74d58b74973e6b$var$oe(_$d, ba), 0 < xa.length && (ba = new $bf74d58b74973e6b$var$Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $bf74d58b74973e6b$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $bf74d58b74973e6b$var$ce ? $bf74d58b74973e6b$var$je(a, c) : $bf74d58b74973e6b$var$ke(a, c)) _$d = $bf74d58b74973e6b$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $bf74d58b74973e6b$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        $bf74d58b74973e6b$var$se(g, b);
    });
}
function $bf74d58b74973e6b$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $bf74d58b74973e6b$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $bf74d58b74973e6b$var$Kb(a, c), null != f && d.unshift($bf74d58b74973e6b$var$tf(a, f, e)), f = $bf74d58b74973e6b$var$Kb(a, b), null != f && d.push($bf74d58b74973e6b$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $bf74d58b74973e6b$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $bf74d58b74973e6b$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $bf74d58b74973e6b$var$Kb(c, f), null != k && g.unshift($bf74d58b74973e6b$var$tf(c, k, h))) : e || (k = $bf74d58b74973e6b$var$Kb(c, f), null != k && g.push($bf74d58b74973e6b$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $bf74d58b74973e6b$var$xf = /\r\n?/g, $bf74d58b74973e6b$var$yf = /\u0000|\uFFFD/g;
function $bf74d58b74973e6b$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($bf74d58b74973e6b$var$xf, "\n").replace($bf74d58b74973e6b$var$yf, "");
}
function $bf74d58b74973e6b$var$Af(a, b, c) {
    b = $bf74d58b74973e6b$var$zf(b);
    if ($bf74d58b74973e6b$var$zf(a) !== b && c) throw Error($bf74d58b74973e6b$var$p(425));
}
function $bf74d58b74973e6b$var$Bf() {}
var $bf74d58b74973e6b$var$Cf = null, $bf74d58b74973e6b$var$Df = null;
function $bf74d58b74973e6b$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === (0, $5djcY._)(b.dangerouslySetInnerHTML) && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $bf74d58b74973e6b$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $bf74d58b74973e6b$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $bf74d58b74973e6b$var$Hf = "function" === typeof Promise ? Promise : void 0, $bf74d58b74973e6b$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $bf74d58b74973e6b$var$Hf ? function Jf(a) {
    return $bf74d58b74973e6b$var$Hf.resolve(null).then(a).catch($bf74d58b74973e6b$var$If);
} : $bf74d58b74973e6b$var$Ff;
function $bf74d58b74973e6b$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $bf74d58b74973e6b$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $bf74d58b74973e6b$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $bf74d58b74973e6b$var$bd(b);
}
function $bf74d58b74973e6b$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $bf74d58b74973e6b$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $bf74d58b74973e6b$var$Nf = Math.random().toString(36).slice(2), $bf74d58b74973e6b$var$Of = "__reactFiber$" + $bf74d58b74973e6b$var$Nf, $bf74d58b74973e6b$var$Pf = "__reactProps$" + $bf74d58b74973e6b$var$Nf, $bf74d58b74973e6b$var$uf = "__reactContainer$" + $bf74d58b74973e6b$var$Nf, $bf74d58b74973e6b$var$of = "__reactEvents$" + $bf74d58b74973e6b$var$Nf, $bf74d58b74973e6b$var$Qf = "__reactListeners$" + $bf74d58b74973e6b$var$Nf, $bf74d58b74973e6b$var$Rf = "__reactHandles$" + $bf74d58b74973e6b$var$Nf;
function $bf74d58b74973e6b$var$Wc(a) {
    var b = a[$bf74d58b74973e6b$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$bf74d58b74973e6b$var$uf] || c[$bf74d58b74973e6b$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $bf74d58b74973e6b$var$Mf(a); null !== a;){
                if (c = a[$bf74d58b74973e6b$var$Of]) return c;
                a = $bf74d58b74973e6b$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $bf74d58b74973e6b$var$Cb(a) {
    a = a[$bf74d58b74973e6b$var$Of] || a[$bf74d58b74973e6b$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $bf74d58b74973e6b$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($bf74d58b74973e6b$var$p(33));
}
function $bf74d58b74973e6b$var$Db(a) {
    return a[$bf74d58b74973e6b$var$Pf] || null;
}
var $bf74d58b74973e6b$var$Sf = [], $bf74d58b74973e6b$var$Tf = -1;
function $bf74d58b74973e6b$var$Uf(a) {
    return {
        current: a
    };
}
function $bf74d58b74973e6b$var$E(a) {
    0 > $bf74d58b74973e6b$var$Tf || (a.current = $bf74d58b74973e6b$var$Sf[$bf74d58b74973e6b$var$Tf], $bf74d58b74973e6b$var$Sf[$bf74d58b74973e6b$var$Tf] = null, $bf74d58b74973e6b$var$Tf--);
}
function $bf74d58b74973e6b$var$G(a, b) {
    $bf74d58b74973e6b$var$Tf++;
    $bf74d58b74973e6b$var$Sf[$bf74d58b74973e6b$var$Tf] = a.current;
    a.current = b;
}
var $bf74d58b74973e6b$var$Vf = {}, $bf74d58b74973e6b$var$H = $bf74d58b74973e6b$var$Uf($bf74d58b74973e6b$var$Vf), $bf74d58b74973e6b$var$Wf = $bf74d58b74973e6b$var$Uf(!1), $bf74d58b74973e6b$var$Xf = $bf74d58b74973e6b$var$Vf;
function $bf74d58b74973e6b$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $bf74d58b74973e6b$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $bf74d58b74973e6b$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $bf74d58b74973e6b$var$$f() {
    $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$Wf);
    $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$H);
}
function $bf74d58b74973e6b$var$ag(a, b, c) {
    if ($bf74d58b74973e6b$var$H.current !== $bf74d58b74973e6b$var$Vf) throw Error($bf74d58b74973e6b$var$p(168));
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$H, b);
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$Wf, c);
}
function $bf74d58b74973e6b$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($bf74d58b74973e6b$var$p(108, $bf74d58b74973e6b$var$Ra(a) || "Unknown", e));
    return $bf74d58b74973e6b$var$A({}, c, d);
}
function $bf74d58b74973e6b$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $bf74d58b74973e6b$var$Vf;
    $bf74d58b74973e6b$var$Xf = $bf74d58b74973e6b$var$H.current;
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$H, a);
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$Wf, $bf74d58b74973e6b$var$Wf.current);
    return !0;
}
function $bf74d58b74973e6b$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($bf74d58b74973e6b$var$p(169));
    c ? (a = $bf74d58b74973e6b$var$bg(a, b, $bf74d58b74973e6b$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$Wf), $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$H), $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$H, a)) : $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$Wf);
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$Wf, c);
}
var $bf74d58b74973e6b$var$eg = null, $bf74d58b74973e6b$var$fg = !1, $bf74d58b74973e6b$var$gg = !1;
function $bf74d58b74973e6b$var$hg(a) {
    null === $bf74d58b74973e6b$var$eg ? $bf74d58b74973e6b$var$eg = [
        a
    ] : $bf74d58b74973e6b$var$eg.push(a);
}
function $bf74d58b74973e6b$var$ig(a) {
    $bf74d58b74973e6b$var$fg = !0;
    $bf74d58b74973e6b$var$hg(a);
}
function $bf74d58b74973e6b$var$jg() {
    if (!$bf74d58b74973e6b$var$gg && null !== $bf74d58b74973e6b$var$eg) {
        $bf74d58b74973e6b$var$gg = !0;
        var a = 0, b = $bf74d58b74973e6b$var$C;
        try {
            var c = $bf74d58b74973e6b$var$eg;
            for($bf74d58b74973e6b$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $bf74d58b74973e6b$var$eg = null;
            $bf74d58b74973e6b$var$fg = !1;
        } catch (e) {
            throw null !== $bf74d58b74973e6b$var$eg && ($bf74d58b74973e6b$var$eg = $bf74d58b74973e6b$var$eg.slice(a + 1)), $bf74d58b74973e6b$var$ac($bf74d58b74973e6b$var$fc, $bf74d58b74973e6b$var$jg), e;
        } finally{
            $bf74d58b74973e6b$var$C = b, $bf74d58b74973e6b$var$gg = !1;
        }
    }
    return null;
}
var $bf74d58b74973e6b$var$kg = [], $bf74d58b74973e6b$var$lg = 0, $bf74d58b74973e6b$var$mg = null, $bf74d58b74973e6b$var$ng = 0, $bf74d58b74973e6b$var$og = [], $bf74d58b74973e6b$var$pg = 0, $bf74d58b74973e6b$var$qg = null, $bf74d58b74973e6b$var$rg = 1, $bf74d58b74973e6b$var$sg = "";
function $bf74d58b74973e6b$var$tg(a, b) {
    $bf74d58b74973e6b$var$kg[$bf74d58b74973e6b$var$lg++] = $bf74d58b74973e6b$var$ng;
    $bf74d58b74973e6b$var$kg[$bf74d58b74973e6b$var$lg++] = $bf74d58b74973e6b$var$mg;
    $bf74d58b74973e6b$var$mg = a;
    $bf74d58b74973e6b$var$ng = b;
}
function $bf74d58b74973e6b$var$ug(a, b, c) {
    $bf74d58b74973e6b$var$og[$bf74d58b74973e6b$var$pg++] = $bf74d58b74973e6b$var$rg;
    $bf74d58b74973e6b$var$og[$bf74d58b74973e6b$var$pg++] = $bf74d58b74973e6b$var$sg;
    $bf74d58b74973e6b$var$og[$bf74d58b74973e6b$var$pg++] = $bf74d58b74973e6b$var$qg;
    $bf74d58b74973e6b$var$qg = a;
    var d = $bf74d58b74973e6b$var$rg;
    a = $bf74d58b74973e6b$var$sg;
    var e = 32 - $bf74d58b74973e6b$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $bf74d58b74973e6b$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $bf74d58b74973e6b$var$rg = 1 << 32 - $bf74d58b74973e6b$var$oc(b) + e | c << e | d;
        $bf74d58b74973e6b$var$sg = f + a;
    } else $bf74d58b74973e6b$var$rg = 1 << f | c << e | d, $bf74d58b74973e6b$var$sg = a;
}
function $bf74d58b74973e6b$var$vg(a) {
    null !== a.return && ($bf74d58b74973e6b$var$tg(a, 1), $bf74d58b74973e6b$var$ug(a, 1, 0));
}
function $bf74d58b74973e6b$var$wg(a) {
    for(; a === $bf74d58b74973e6b$var$mg;)$bf74d58b74973e6b$var$mg = $bf74d58b74973e6b$var$kg[--$bf74d58b74973e6b$var$lg], $bf74d58b74973e6b$var$kg[$bf74d58b74973e6b$var$lg] = null, $bf74d58b74973e6b$var$ng = $bf74d58b74973e6b$var$kg[--$bf74d58b74973e6b$var$lg], $bf74d58b74973e6b$var$kg[$bf74d58b74973e6b$var$lg] = null;
    for(; a === $bf74d58b74973e6b$var$qg;)$bf74d58b74973e6b$var$qg = $bf74d58b74973e6b$var$og[--$bf74d58b74973e6b$var$pg], $bf74d58b74973e6b$var$og[$bf74d58b74973e6b$var$pg] = null, $bf74d58b74973e6b$var$sg = $bf74d58b74973e6b$var$og[--$bf74d58b74973e6b$var$pg], $bf74d58b74973e6b$var$og[$bf74d58b74973e6b$var$pg] = null, $bf74d58b74973e6b$var$rg = $bf74d58b74973e6b$var$og[--$bf74d58b74973e6b$var$pg], $bf74d58b74973e6b$var$og[$bf74d58b74973e6b$var$pg] = null;
}
var $bf74d58b74973e6b$var$xg = null, $bf74d58b74973e6b$var$yg = null, $bf74d58b74973e6b$var$I = !1, $bf74d58b74973e6b$var$zg = null;
function $bf74d58b74973e6b$var$Ag(a, b) {
    var c = $bf74d58b74973e6b$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $bf74d58b74973e6b$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $bf74d58b74973e6b$var$xg = a, $bf74d58b74973e6b$var$yg = $bf74d58b74973e6b$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $bf74d58b74973e6b$var$xg = a, $bf74d58b74973e6b$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $bf74d58b74973e6b$var$qg ? {
                id: $bf74d58b74973e6b$var$rg,
                overflow: $bf74d58b74973e6b$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $bf74d58b74973e6b$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $bf74d58b74973e6b$var$xg = a, $bf74d58b74973e6b$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $bf74d58b74973e6b$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $bf74d58b74973e6b$var$Eg(a) {
    if ($bf74d58b74973e6b$var$I) {
        var b = $bf74d58b74973e6b$var$yg;
        if (b) {
            var c = b;
            if (!$bf74d58b74973e6b$var$Cg(a, b)) {
                if ($bf74d58b74973e6b$var$Dg(a)) throw Error($bf74d58b74973e6b$var$p(418));
                b = $bf74d58b74973e6b$var$Lf(c.nextSibling);
                var d = $bf74d58b74973e6b$var$xg;
                b && $bf74d58b74973e6b$var$Cg(a, b) ? $bf74d58b74973e6b$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $bf74d58b74973e6b$var$I = !1, $bf74d58b74973e6b$var$xg = a);
            }
        } else {
            if ($bf74d58b74973e6b$var$Dg(a)) throw Error($bf74d58b74973e6b$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $bf74d58b74973e6b$var$I = !1;
            $bf74d58b74973e6b$var$xg = a;
        }
    }
}
function $bf74d58b74973e6b$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $bf74d58b74973e6b$var$xg = a;
}
function $bf74d58b74973e6b$var$Gg(a) {
    if (a !== $bf74d58b74973e6b$var$xg) return !1;
    if (!$bf74d58b74973e6b$var$I) return $bf74d58b74973e6b$var$Fg(a), $bf74d58b74973e6b$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$bf74d58b74973e6b$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $bf74d58b74973e6b$var$yg)) {
        if ($bf74d58b74973e6b$var$Dg(a)) throw $bf74d58b74973e6b$var$Hg(), Error($bf74d58b74973e6b$var$p(418));
        for(; b;)$bf74d58b74973e6b$var$Ag(a, b), b = $bf74d58b74973e6b$var$Lf(b.nextSibling);
    }
    $bf74d58b74973e6b$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($bf74d58b74973e6b$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $bf74d58b74973e6b$var$yg = $bf74d58b74973e6b$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $bf74d58b74973e6b$var$yg = null;
        }
    } else $bf74d58b74973e6b$var$yg = $bf74d58b74973e6b$var$xg ? $bf74d58b74973e6b$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $bf74d58b74973e6b$var$Hg() {
    for(var a = $bf74d58b74973e6b$var$yg; a;)a = $bf74d58b74973e6b$var$Lf(a.nextSibling);
}
function $bf74d58b74973e6b$var$Ig() {
    $bf74d58b74973e6b$var$yg = $bf74d58b74973e6b$var$xg = null;
    $bf74d58b74973e6b$var$I = !1;
}
function $bf74d58b74973e6b$var$Jg(a) {
    null === $bf74d58b74973e6b$var$zg ? $bf74d58b74973e6b$var$zg = [
        a
    ] : $bf74d58b74973e6b$var$zg.push(a);
}
var $bf74d58b74973e6b$var$Kg = $bf74d58b74973e6b$var$ua.ReactCurrentBatchConfig;
function $bf74d58b74973e6b$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a))) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($bf74d58b74973e6b$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($bf74d58b74973e6b$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($bf74d58b74973e6b$var$p(284));
        if (!c._owner) throw Error($bf74d58b74973e6b$var$p(290, a));
    }
    return a;
}
function $bf74d58b74973e6b$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($bf74d58b74973e6b$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $bf74d58b74973e6b$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $bf74d58b74973e6b$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $bf74d58b74973e6b$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $bf74d58b74973e6b$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $bf74d58b74973e6b$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === (typeof f === "undefined" ? "undefined" : (0, $5djcY._)(f)) && null !== f && f.$$typeof === $bf74d58b74973e6b$var$Ha && $bf74d58b74973e6b$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $bf74d58b74973e6b$var$Lg(a, b, c), d.return = a, d;
        d = $bf74d58b74973e6b$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $bf74d58b74973e6b$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $bf74d58b74973e6b$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $bf74d58b74973e6b$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $bf74d58b74973e6b$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === (typeof b === "undefined" ? "undefined" : (0, $5djcY._)(b)) && null !== b) {
            switch(b.$$typeof){
                case $bf74d58b74973e6b$var$va:
                    return c = $bf74d58b74973e6b$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $bf74d58b74973e6b$var$Lg(a, null, b), c.return = a, c;
                case $bf74d58b74973e6b$var$wa:
                    return b = $bf74d58b74973e6b$var$Sg(b, a.mode, c), b.return = a, b;
                case $bf74d58b74973e6b$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($bf74d58b74973e6b$var$eb(b) || $bf74d58b74973e6b$var$Ka(b)) return b = $bf74d58b74973e6b$var$Tg(b, a.mode, c, null), b.return = a, b;
            $bf74d58b74973e6b$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === (typeof c === "undefined" ? "undefined" : (0, $5djcY._)(c)) && null !== c) {
            switch(c.$$typeof){
                case $bf74d58b74973e6b$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $bf74d58b74973e6b$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $bf74d58b74973e6b$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($bf74d58b74973e6b$var$eb(c) || $bf74d58b74973e6b$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $bf74d58b74973e6b$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === (typeof d === "undefined" ? "undefined" : (0, $5djcY._)(d)) && null !== d) {
            switch(d.$$typeof){
                case $bf74d58b74973e6b$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $bf74d58b74973e6b$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $bf74d58b74973e6b$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($bf74d58b74973e6b$var$eb(d) || $bf74d58b74973e6b$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $bf74d58b74973e6b$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $bf74d58b74973e6b$var$I && $bf74d58b74973e6b$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $bf74d58b74973e6b$var$I && $bf74d58b74973e6b$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $bf74d58b74973e6b$var$I && $bf74d58b74973e6b$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $bf74d58b74973e6b$var$Ka(h);
        if ("function" !== typeof l) throw Error($bf74d58b74973e6b$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($bf74d58b74973e6b$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $bf74d58b74973e6b$var$I && $bf74d58b74973e6b$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $bf74d58b74973e6b$var$I && $bf74d58b74973e6b$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $bf74d58b74973e6b$var$I && $bf74d58b74973e6b$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === (typeof f === "undefined" ? "undefined" : (0, $5djcY._)(f)) && null !== f && f.type === $bf74d58b74973e6b$var$ya && null === f.key && (f = f.props.children);
        if ("object" === (typeof f === "undefined" ? "undefined" : (0, $5djcY._)(f)) && null !== f) {
            switch(f.$$typeof){
                case $bf74d58b74973e6b$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $bf74d58b74973e6b$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === (typeof k === "undefined" ? "undefined" : (0, $5djcY._)(k)) && null !== k && k.$$typeof === $bf74d58b74973e6b$var$Ha && $bf74d58b74973e6b$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $bf74d58b74973e6b$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $bf74d58b74973e6b$var$ya ? (d = $bf74d58b74973e6b$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $bf74d58b74973e6b$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $bf74d58b74973e6b$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $bf74d58b74973e6b$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $bf74d58b74973e6b$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $bf74d58b74973e6b$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($bf74d58b74973e6b$var$eb(f)) return n(a, d, f, h);
            if ($bf74d58b74973e6b$var$Ka(f)) return t(a, d, f, h);
            $bf74d58b74973e6b$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $bf74d58b74973e6b$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $bf74d58b74973e6b$var$Ug = $bf74d58b74973e6b$var$Og(!0), $bf74d58b74973e6b$var$Vg = $bf74d58b74973e6b$var$Og(!1), $bf74d58b74973e6b$var$Wg = $bf74d58b74973e6b$var$Uf(null), $bf74d58b74973e6b$var$Xg = null, $bf74d58b74973e6b$var$Yg = null, $bf74d58b74973e6b$var$Zg = null;
function $bf74d58b74973e6b$var$$g() {
    $bf74d58b74973e6b$var$Zg = $bf74d58b74973e6b$var$Yg = $bf74d58b74973e6b$var$Xg = null;
}
function $bf74d58b74973e6b$var$ah(a) {
    var b = $bf74d58b74973e6b$var$Wg.current;
    $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$Wg);
    a._currentValue = b;
}
function $bf74d58b74973e6b$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $bf74d58b74973e6b$var$ch(a, b) {
    $bf74d58b74973e6b$var$Xg = a;
    $bf74d58b74973e6b$var$Zg = $bf74d58b74973e6b$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($bf74d58b74973e6b$var$dh = !0), a.firstContext = null);
}
function $bf74d58b74973e6b$var$eh(a) {
    var b = a._currentValue;
    if ($bf74d58b74973e6b$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $bf74d58b74973e6b$var$Yg) {
            if (null === $bf74d58b74973e6b$var$Xg) throw Error($bf74d58b74973e6b$var$p(308));
            $bf74d58b74973e6b$var$Yg = a;
            $bf74d58b74973e6b$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $bf74d58b74973e6b$var$Yg = $bf74d58b74973e6b$var$Yg.next = a;
    }
    return b;
}
var $bf74d58b74973e6b$var$fh = null;
function $bf74d58b74973e6b$var$gh(a) {
    null === $bf74d58b74973e6b$var$fh ? $bf74d58b74973e6b$var$fh = [
        a
    ] : $bf74d58b74973e6b$var$fh.push(a);
}
function $bf74d58b74973e6b$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $bf74d58b74973e6b$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $bf74d58b74973e6b$var$ih(a, d);
}
function $bf74d58b74973e6b$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $bf74d58b74973e6b$var$jh = !1;
function $bf74d58b74973e6b$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $bf74d58b74973e6b$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $bf74d58b74973e6b$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $bf74d58b74973e6b$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($bf74d58b74973e6b$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $bf74d58b74973e6b$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $bf74d58b74973e6b$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $bf74d58b74973e6b$var$ih(a, c);
}
function $bf74d58b74973e6b$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $bf74d58b74973e6b$var$Cc(a, c);
    }
}
function $bf74d58b74973e6b$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $bf74d58b74973e6b$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $bf74d58b74973e6b$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $bf74d58b74973e6b$var$A({}, q, r);
                            break a;
                        case 2:
                            $bf74d58b74973e6b$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $bf74d58b74973e6b$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $bf74d58b74973e6b$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($bf74d58b74973e6b$var$p(191, e));
            e.call(d);
        }
    }
}
var $bf74d58b74973e6b$var$th = {}, $bf74d58b74973e6b$var$uh = $bf74d58b74973e6b$var$Uf($bf74d58b74973e6b$var$th), $bf74d58b74973e6b$var$vh = $bf74d58b74973e6b$var$Uf($bf74d58b74973e6b$var$th), $bf74d58b74973e6b$var$wh = $bf74d58b74973e6b$var$Uf($bf74d58b74973e6b$var$th);
function $bf74d58b74973e6b$var$xh(a) {
    if (a === $bf74d58b74973e6b$var$th) throw Error($bf74d58b74973e6b$var$p(174));
    return a;
}
function $bf74d58b74973e6b$var$yh(a, b) {
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$wh, b);
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$vh, a);
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$uh, $bf74d58b74973e6b$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $bf74d58b74973e6b$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $bf74d58b74973e6b$var$lb(b, a);
    }
    $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$uh);
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$uh, b);
}
function $bf74d58b74973e6b$var$zh() {
    $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$uh);
    $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$vh);
    $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$wh);
}
function $bf74d58b74973e6b$var$Ah(a) {
    $bf74d58b74973e6b$var$xh($bf74d58b74973e6b$var$wh.current);
    var b = $bf74d58b74973e6b$var$xh($bf74d58b74973e6b$var$uh.current);
    var c = $bf74d58b74973e6b$var$lb(b, a.type);
    b !== c && ($bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$vh, a), $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$uh, c));
}
function $bf74d58b74973e6b$var$Bh(a) {
    $bf74d58b74973e6b$var$vh.current === a && ($bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$uh), $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$vh));
}
var $bf74d58b74973e6b$var$L = $bf74d58b74973e6b$var$Uf(0);
function $bf74d58b74973e6b$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $bf74d58b74973e6b$var$Dh = [];
function $bf74d58b74973e6b$var$Eh() {
    for(var a = 0; a < $bf74d58b74973e6b$var$Dh.length; a++)$bf74d58b74973e6b$var$Dh[a]._workInProgressVersionPrimary = null;
    $bf74d58b74973e6b$var$Dh.length = 0;
}
var $bf74d58b74973e6b$var$Fh = $bf74d58b74973e6b$var$ua.ReactCurrentDispatcher, $bf74d58b74973e6b$var$Gh = $bf74d58b74973e6b$var$ua.ReactCurrentBatchConfig, $bf74d58b74973e6b$var$Hh = 0, $bf74d58b74973e6b$var$M = null, $bf74d58b74973e6b$var$N = null, $bf74d58b74973e6b$var$O = null, $bf74d58b74973e6b$var$Ih = !1, $bf74d58b74973e6b$var$Jh = !1, $bf74d58b74973e6b$var$Kh = 0, $bf74d58b74973e6b$var$Lh = 0;
function $bf74d58b74973e6b$var$P() {
    throw Error($bf74d58b74973e6b$var$p(321));
}
function $bf74d58b74973e6b$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$bf74d58b74973e6b$var$He(a[c], b[c])) return !1;
    return !0;
}
function $bf74d58b74973e6b$var$Nh(a, b, c, d, e, f) {
    $bf74d58b74973e6b$var$Hh = f;
    $bf74d58b74973e6b$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $bf74d58b74973e6b$var$Fh.current = null === a || null === a.memoizedState ? $bf74d58b74973e6b$var$Oh : $bf74d58b74973e6b$var$Ph;
    a = c(d, e);
    if ($bf74d58b74973e6b$var$Jh) {
        f = 0;
        do {
            $bf74d58b74973e6b$var$Jh = !1;
            $bf74d58b74973e6b$var$Kh = 0;
            if (25 <= f) throw Error($bf74d58b74973e6b$var$p(301));
            f += 1;
            $bf74d58b74973e6b$var$O = $bf74d58b74973e6b$var$N = null;
            b.updateQueue = null;
            $bf74d58b74973e6b$var$Fh.current = $bf74d58b74973e6b$var$Qh;
            a = c(d, e);
        }while ($bf74d58b74973e6b$var$Jh);
    }
    $bf74d58b74973e6b$var$Fh.current = $bf74d58b74973e6b$var$Rh;
    b = null !== $bf74d58b74973e6b$var$N && null !== $bf74d58b74973e6b$var$N.next;
    $bf74d58b74973e6b$var$Hh = 0;
    $bf74d58b74973e6b$var$O = $bf74d58b74973e6b$var$N = $bf74d58b74973e6b$var$M = null;
    $bf74d58b74973e6b$var$Ih = !1;
    if (b) throw Error($bf74d58b74973e6b$var$p(300));
    return a;
}
function $bf74d58b74973e6b$var$Sh() {
    var a = 0 !== $bf74d58b74973e6b$var$Kh;
    $bf74d58b74973e6b$var$Kh = 0;
    return a;
}
function $bf74d58b74973e6b$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $bf74d58b74973e6b$var$O ? $bf74d58b74973e6b$var$M.memoizedState = $bf74d58b74973e6b$var$O = a : $bf74d58b74973e6b$var$O = $bf74d58b74973e6b$var$O.next = a;
    return $bf74d58b74973e6b$var$O;
}
function $bf74d58b74973e6b$var$Uh() {
    if (null === $bf74d58b74973e6b$var$N) {
        var a = $bf74d58b74973e6b$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $bf74d58b74973e6b$var$N.next;
    var b = null === $bf74d58b74973e6b$var$O ? $bf74d58b74973e6b$var$M.memoizedState : $bf74d58b74973e6b$var$O.next;
    if (null !== b) $bf74d58b74973e6b$var$O = b, $bf74d58b74973e6b$var$N = a;
    else {
        if (null === a) throw Error($bf74d58b74973e6b$var$p(310));
        $bf74d58b74973e6b$var$N = a;
        a = {
            memoizedState: $bf74d58b74973e6b$var$N.memoizedState,
            baseState: $bf74d58b74973e6b$var$N.baseState,
            baseQueue: $bf74d58b74973e6b$var$N.baseQueue,
            queue: $bf74d58b74973e6b$var$N.queue,
            next: null
        };
        null === $bf74d58b74973e6b$var$O ? $bf74d58b74973e6b$var$M.memoizedState = $bf74d58b74973e6b$var$O = a : $bf74d58b74973e6b$var$O = $bf74d58b74973e6b$var$O.next = a;
    }
    return $bf74d58b74973e6b$var$O;
}
function $bf74d58b74973e6b$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $bf74d58b74973e6b$var$Wh(a) {
    var b = $bf74d58b74973e6b$var$Uh(), c = b.queue;
    if (null === c) throw Error($bf74d58b74973e6b$var$p(311));
    c.lastRenderedReducer = a;
    var d = $bf74d58b74973e6b$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($bf74d58b74973e6b$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $bf74d58b74973e6b$var$M.lanes |= m;
                $bf74d58b74973e6b$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $bf74d58b74973e6b$var$He(d, b.memoizedState) || ($bf74d58b74973e6b$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $bf74d58b74973e6b$var$M.lanes |= f, $bf74d58b74973e6b$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $bf74d58b74973e6b$var$Xh(a) {
    var b = $bf74d58b74973e6b$var$Uh(), c = b.queue;
    if (null === c) throw Error($bf74d58b74973e6b$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $bf74d58b74973e6b$var$He(f, b.memoizedState) || ($bf74d58b74973e6b$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $bf74d58b74973e6b$var$Yh() {}
function $bf74d58b74973e6b$var$Zh(a, b) {
    var c = $bf74d58b74973e6b$var$M, d = $bf74d58b74973e6b$var$Uh(), e = b(), f = !$bf74d58b74973e6b$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $bf74d58b74973e6b$var$dh = !0);
    d = d.queue;
    $bf74d58b74973e6b$var$$h($bf74d58b74973e6b$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $bf74d58b74973e6b$var$O && $bf74d58b74973e6b$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $bf74d58b74973e6b$var$bi(9, $bf74d58b74973e6b$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $bf74d58b74973e6b$var$Q) throw Error($bf74d58b74973e6b$var$p(349));
        0 !== ($bf74d58b74973e6b$var$Hh & 30) || $bf74d58b74973e6b$var$di(c, b, e);
    }
    return e;
}
function $bf74d58b74973e6b$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $bf74d58b74973e6b$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $bf74d58b74973e6b$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $bf74d58b74973e6b$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $bf74d58b74973e6b$var$ei(b) && $bf74d58b74973e6b$var$fi(a);
}
function $bf74d58b74973e6b$var$ai(a, b, c) {
    return c(function() {
        $bf74d58b74973e6b$var$ei(b) && $bf74d58b74973e6b$var$fi(a);
    });
}
function $bf74d58b74973e6b$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$bf74d58b74973e6b$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $bf74d58b74973e6b$var$fi(a) {
    var b = $bf74d58b74973e6b$var$ih(a, 1);
    null !== b && $bf74d58b74973e6b$var$gi(b, a, 1, -1);
}
function $bf74d58b74973e6b$var$hi(a) {
    var b = $bf74d58b74973e6b$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $bf74d58b74973e6b$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $bf74d58b74973e6b$var$ii.bind(null, $bf74d58b74973e6b$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $bf74d58b74973e6b$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $bf74d58b74973e6b$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $bf74d58b74973e6b$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $bf74d58b74973e6b$var$ji() {
    return $bf74d58b74973e6b$var$Uh().memoizedState;
}
function $bf74d58b74973e6b$var$ki(a, b, c, d) {
    var e = $bf74d58b74973e6b$var$Th();
    $bf74d58b74973e6b$var$M.flags |= a;
    e.memoizedState = $bf74d58b74973e6b$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $bf74d58b74973e6b$var$li(a, b, c, d) {
    var e = $bf74d58b74973e6b$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $bf74d58b74973e6b$var$N) {
        var g = $bf74d58b74973e6b$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $bf74d58b74973e6b$var$Mh(d, g.deps)) {
            e.memoizedState = $bf74d58b74973e6b$var$bi(b, c, f, d);
            return;
        }
    }
    $bf74d58b74973e6b$var$M.flags |= a;
    e.memoizedState = $bf74d58b74973e6b$var$bi(1 | b, c, f, d);
}
function $bf74d58b74973e6b$var$mi(a, b) {
    return $bf74d58b74973e6b$var$ki(8390656, 8, a, b);
}
function $bf74d58b74973e6b$var$$h(a, b) {
    return $bf74d58b74973e6b$var$li(2048, 8, a, b);
}
function $bf74d58b74973e6b$var$ni(a, b) {
    return $bf74d58b74973e6b$var$li(4, 2, a, b);
}
function $bf74d58b74973e6b$var$oi(a, b) {
    return $bf74d58b74973e6b$var$li(4, 4, a, b);
}
function $bf74d58b74973e6b$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $bf74d58b74973e6b$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $bf74d58b74973e6b$var$li(4, 4, $bf74d58b74973e6b$var$pi.bind(null, b, a), c);
}
function $bf74d58b74973e6b$var$ri() {}
function $bf74d58b74973e6b$var$si(a, b) {
    var c = $bf74d58b74973e6b$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $bf74d58b74973e6b$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $bf74d58b74973e6b$var$ti(a, b) {
    var c = $bf74d58b74973e6b$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $bf74d58b74973e6b$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $bf74d58b74973e6b$var$ui(a, b, c) {
    if (0 === ($bf74d58b74973e6b$var$Hh & 21)) return a.baseState && (a.baseState = !1, $bf74d58b74973e6b$var$dh = !0), a.memoizedState = c;
    $bf74d58b74973e6b$var$He(c, b) || (c = $bf74d58b74973e6b$var$yc(), $bf74d58b74973e6b$var$M.lanes |= c, $bf74d58b74973e6b$var$rh |= c, a.baseState = !0);
    return b;
}
function $bf74d58b74973e6b$var$vi(a, b) {
    var c = $bf74d58b74973e6b$var$C;
    $bf74d58b74973e6b$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $bf74d58b74973e6b$var$Gh.transition;
    $bf74d58b74973e6b$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $bf74d58b74973e6b$var$C = c, $bf74d58b74973e6b$var$Gh.transition = d;
    }
}
function $bf74d58b74973e6b$var$wi() {
    return $bf74d58b74973e6b$var$Uh().memoizedState;
}
function $bf74d58b74973e6b$var$xi(a, b, c) {
    var d = $bf74d58b74973e6b$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($bf74d58b74973e6b$var$zi(a)) $bf74d58b74973e6b$var$Ai(b, c);
    else if (c = $bf74d58b74973e6b$var$hh(a, b, c, d), null !== c) {
        var e = $bf74d58b74973e6b$var$R();
        $bf74d58b74973e6b$var$gi(c, a, d, e);
        $bf74d58b74973e6b$var$Bi(c, b, d);
    }
}
function $bf74d58b74973e6b$var$ii(a, b, c) {
    var d = $bf74d58b74973e6b$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($bf74d58b74973e6b$var$zi(a)) $bf74d58b74973e6b$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($bf74d58b74973e6b$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $bf74d58b74973e6b$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $bf74d58b74973e6b$var$hh(a, b, e, d);
        null !== c && (e = $bf74d58b74973e6b$var$R(), $bf74d58b74973e6b$var$gi(c, a, d, e), $bf74d58b74973e6b$var$Bi(c, b, d));
    }
}
function $bf74d58b74973e6b$var$zi(a) {
    var b = a.alternate;
    return a === $bf74d58b74973e6b$var$M || null !== b && b === $bf74d58b74973e6b$var$M;
}
function $bf74d58b74973e6b$var$Ai(a, b) {
    $bf74d58b74973e6b$var$Jh = $bf74d58b74973e6b$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $bf74d58b74973e6b$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $bf74d58b74973e6b$var$Cc(a, c);
    }
}
var $bf74d58b74973e6b$var$Rh = {
    readContext: $bf74d58b74973e6b$var$eh,
    useCallback: $bf74d58b74973e6b$var$P,
    useContext: $bf74d58b74973e6b$var$P,
    useEffect: $bf74d58b74973e6b$var$P,
    useImperativeHandle: $bf74d58b74973e6b$var$P,
    useInsertionEffect: $bf74d58b74973e6b$var$P,
    useLayoutEffect: $bf74d58b74973e6b$var$P,
    useMemo: $bf74d58b74973e6b$var$P,
    useReducer: $bf74d58b74973e6b$var$P,
    useRef: $bf74d58b74973e6b$var$P,
    useState: $bf74d58b74973e6b$var$P,
    useDebugValue: $bf74d58b74973e6b$var$P,
    useDeferredValue: $bf74d58b74973e6b$var$P,
    useTransition: $bf74d58b74973e6b$var$P,
    useMutableSource: $bf74d58b74973e6b$var$P,
    useSyncExternalStore: $bf74d58b74973e6b$var$P,
    useId: $bf74d58b74973e6b$var$P,
    unstable_isNewReconciler: !1
}, $bf74d58b74973e6b$var$Oh = {
    readContext: $bf74d58b74973e6b$var$eh,
    useCallback: function useCallback(a, b) {
        $bf74d58b74973e6b$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $bf74d58b74973e6b$var$eh,
    useEffect: $bf74d58b74973e6b$var$mi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $bf74d58b74973e6b$var$ki(4194308, 4, $bf74d58b74973e6b$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $bf74d58b74973e6b$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $bf74d58b74973e6b$var$ki(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $bf74d58b74973e6b$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $bf74d58b74973e6b$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $bf74d58b74973e6b$var$xi.bind(null, $bf74d58b74973e6b$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $bf74d58b74973e6b$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $bf74d58b74973e6b$var$hi,
    useDebugValue: $bf74d58b74973e6b$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        return $bf74d58b74973e6b$var$Th().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $bf74d58b74973e6b$var$hi(!1), b = a[0];
        a = $bf74d58b74973e6b$var$vi.bind(null, a[1]);
        $bf74d58b74973e6b$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $bf74d58b74973e6b$var$M, e = $bf74d58b74973e6b$var$Th();
        if ($bf74d58b74973e6b$var$I) {
            if (void 0 === c) throw Error($bf74d58b74973e6b$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $bf74d58b74973e6b$var$Q) throw Error($bf74d58b74973e6b$var$p(349));
            0 !== ($bf74d58b74973e6b$var$Hh & 30) || $bf74d58b74973e6b$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $bf74d58b74973e6b$var$mi($bf74d58b74973e6b$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $bf74d58b74973e6b$var$bi(9, $bf74d58b74973e6b$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $bf74d58b74973e6b$var$Th(), b = $bf74d58b74973e6b$var$Q.identifierPrefix;
        if ($bf74d58b74973e6b$var$I) {
            var c = $bf74d58b74973e6b$var$sg;
            var d = $bf74d58b74973e6b$var$rg;
            c = (d & ~(1 << 32 - $bf74d58b74973e6b$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $bf74d58b74973e6b$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $bf74d58b74973e6b$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $bf74d58b74973e6b$var$Ph = {
    readContext: $bf74d58b74973e6b$var$eh,
    useCallback: $bf74d58b74973e6b$var$si,
    useContext: $bf74d58b74973e6b$var$eh,
    useEffect: $bf74d58b74973e6b$var$$h,
    useImperativeHandle: $bf74d58b74973e6b$var$qi,
    useInsertionEffect: $bf74d58b74973e6b$var$ni,
    useLayoutEffect: $bf74d58b74973e6b$var$oi,
    useMemo: $bf74d58b74973e6b$var$ti,
    useReducer: $bf74d58b74973e6b$var$Wh,
    useRef: $bf74d58b74973e6b$var$ji,
    useState: function useState() {
        return $bf74d58b74973e6b$var$Wh($bf74d58b74973e6b$var$Vh);
    },
    useDebugValue: $bf74d58b74973e6b$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = $bf74d58b74973e6b$var$Uh();
        return $bf74d58b74973e6b$var$ui(b, $bf74d58b74973e6b$var$N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $bf74d58b74973e6b$var$Wh($bf74d58b74973e6b$var$Vh)[0], b = $bf74d58b74973e6b$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $bf74d58b74973e6b$var$Yh,
    useSyncExternalStore: $bf74d58b74973e6b$var$Zh,
    useId: $bf74d58b74973e6b$var$wi,
    unstable_isNewReconciler: !1
}, $bf74d58b74973e6b$var$Qh = {
    readContext: $bf74d58b74973e6b$var$eh,
    useCallback: $bf74d58b74973e6b$var$si,
    useContext: $bf74d58b74973e6b$var$eh,
    useEffect: $bf74d58b74973e6b$var$$h,
    useImperativeHandle: $bf74d58b74973e6b$var$qi,
    useInsertionEffect: $bf74d58b74973e6b$var$ni,
    useLayoutEffect: $bf74d58b74973e6b$var$oi,
    useMemo: $bf74d58b74973e6b$var$ti,
    useReducer: $bf74d58b74973e6b$var$Xh,
    useRef: $bf74d58b74973e6b$var$ji,
    useState: function useState() {
        return $bf74d58b74973e6b$var$Xh($bf74d58b74973e6b$var$Vh);
    },
    useDebugValue: $bf74d58b74973e6b$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = $bf74d58b74973e6b$var$Uh();
        return null === $bf74d58b74973e6b$var$N ? b.memoizedState = a : $bf74d58b74973e6b$var$ui(b, $bf74d58b74973e6b$var$N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $bf74d58b74973e6b$var$Xh($bf74d58b74973e6b$var$Vh)[0], b = $bf74d58b74973e6b$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $bf74d58b74973e6b$var$Yh,
    useSyncExternalStore: $bf74d58b74973e6b$var$Zh,
    useId: $bf74d58b74973e6b$var$wi,
    unstable_isNewReconciler: !1
};
function $bf74d58b74973e6b$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $bf74d58b74973e6b$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $bf74d58b74973e6b$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $bf74d58b74973e6b$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $bf74d58b74973e6b$var$Ei = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $bf74d58b74973e6b$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $bf74d58b74973e6b$var$R(), e = $bf74d58b74973e6b$var$yi(a), f = $bf74d58b74973e6b$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $bf74d58b74973e6b$var$nh(a, f, e);
        null !== b && ($bf74d58b74973e6b$var$gi(b, a, e, d), $bf74d58b74973e6b$var$oh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $bf74d58b74973e6b$var$R(), e = $bf74d58b74973e6b$var$yi(a), f = $bf74d58b74973e6b$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $bf74d58b74973e6b$var$nh(a, f, e);
        null !== b && ($bf74d58b74973e6b$var$gi(b, a, e, d), $bf74d58b74973e6b$var$oh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $bf74d58b74973e6b$var$R(), d = $bf74d58b74973e6b$var$yi(a), e = $bf74d58b74973e6b$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $bf74d58b74973e6b$var$nh(a, e, d);
        null !== b && ($bf74d58b74973e6b$var$gi(b, a, d, c), $bf74d58b74973e6b$var$oh(b, a, d));
    }
};
function $bf74d58b74973e6b$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$bf74d58b74973e6b$var$Ie(c, d) || !$bf74d58b74973e6b$var$Ie(e, f) : !0;
}
function $bf74d58b74973e6b$var$Gi(a, b, c) {
    var d = !1, e = $bf74d58b74973e6b$var$Vf;
    var f = b.contextType;
    "object" === (typeof f === "undefined" ? "undefined" : (0, $5djcY._)(f)) && null !== f ? f = $bf74d58b74973e6b$var$eh(f) : (e = $bf74d58b74973e6b$var$Zf(b) ? $bf74d58b74973e6b$var$Xf : $bf74d58b74973e6b$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $bf74d58b74973e6b$var$Yf(a, e) : $bf74d58b74973e6b$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $bf74d58b74973e6b$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $bf74d58b74973e6b$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $bf74d58b74973e6b$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $bf74d58b74973e6b$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $bf74d58b74973e6b$var$kh(a);
    var f = b.contextType;
    "object" === (typeof f === "undefined" ? "undefined" : (0, $5djcY._)(f)) && null !== f ? e.context = $bf74d58b74973e6b$var$eh(f) : (f = $bf74d58b74973e6b$var$Zf(b) ? $bf74d58b74973e6b$var$Xf : $bf74d58b74973e6b$var$H.current, e.context = $bf74d58b74973e6b$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($bf74d58b74973e6b$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $bf74d58b74973e6b$var$Ei.enqueueReplaceState(e, e.state, null), $bf74d58b74973e6b$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $bf74d58b74973e6b$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $bf74d58b74973e6b$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $bf74d58b74973e6b$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $bf74d58b74973e6b$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $bf74d58b74973e6b$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $bf74d58b74973e6b$var$Ni(a, b, c) {
    c = $bf74d58b74973e6b$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $bf74d58b74973e6b$var$Oi || ($bf74d58b74973e6b$var$Oi = !0, $bf74d58b74973e6b$var$Pi = d);
        $bf74d58b74973e6b$var$Li(a, b);
    };
    return c;
}
function $bf74d58b74973e6b$var$Qi(a, b, c) {
    c = $bf74d58b74973e6b$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $bf74d58b74973e6b$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $bf74d58b74973e6b$var$Li(a, b);
        "function" !== typeof d && (null === $bf74d58b74973e6b$var$Ri ? $bf74d58b74973e6b$var$Ri = new Set([
            this
        ]) : $bf74d58b74973e6b$var$Ri.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $bf74d58b74973e6b$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $bf74d58b74973e6b$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $bf74d58b74973e6b$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $bf74d58b74973e6b$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $bf74d58b74973e6b$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $bf74d58b74973e6b$var$mh(-1, 1), b.tag = 2, $bf74d58b74973e6b$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $bf74d58b74973e6b$var$Wi = $bf74d58b74973e6b$var$ua.ReactCurrentOwner, $bf74d58b74973e6b$var$dh = !1;
function $bf74d58b74973e6b$var$Xi(a, b, c, d) {
    b.child = null === a ? $bf74d58b74973e6b$var$Vg(b, null, c, d) : $bf74d58b74973e6b$var$Ug(b, a.child, c, d);
}
function $bf74d58b74973e6b$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $bf74d58b74973e6b$var$ch(b, e);
    d = $bf74d58b74973e6b$var$Nh(a, b, c, d, f, e);
    c = $bf74d58b74973e6b$var$Sh();
    if (null !== a && !$bf74d58b74973e6b$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $bf74d58b74973e6b$var$Zi(a, b, e);
    $bf74d58b74973e6b$var$I && c && $bf74d58b74973e6b$var$vg(b);
    b.flags |= 1;
    $bf74d58b74973e6b$var$Xi(a, b, d, e);
    return b.child;
}
function $bf74d58b74973e6b$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$bf74d58b74973e6b$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $bf74d58b74973e6b$var$bj(a, b, f, d, e);
        a = $bf74d58b74973e6b$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $bf74d58b74973e6b$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $bf74d58b74973e6b$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $bf74d58b74973e6b$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $bf74d58b74973e6b$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($bf74d58b74973e6b$var$Ie(f, d) && a.ref === b.ref) {
            if ($bf74d58b74973e6b$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($bf74d58b74973e6b$var$dh = !0);
            else return b.lanes = a.lanes, $bf74d58b74973e6b$var$Zi(a, b, e);
        }
    }
    return $bf74d58b74973e6b$var$cj(a, b, c, d, e);
}
function $bf74d58b74973e6b$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$ej, $bf74d58b74973e6b$var$fj), $bf74d58b74973e6b$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$ej, $bf74d58b74973e6b$var$fj), $bf74d58b74973e6b$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$ej, $bf74d58b74973e6b$var$fj);
            $bf74d58b74973e6b$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$ej, $bf74d58b74973e6b$var$fj), $bf74d58b74973e6b$var$fj |= d;
    $bf74d58b74973e6b$var$Xi(a, b, e, c);
    return b.child;
}
function $bf74d58b74973e6b$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $bf74d58b74973e6b$var$cj(a, b, c, d, e) {
    var f = $bf74d58b74973e6b$var$Zf(c) ? $bf74d58b74973e6b$var$Xf : $bf74d58b74973e6b$var$H.current;
    f = $bf74d58b74973e6b$var$Yf(b, f);
    $bf74d58b74973e6b$var$ch(b, e);
    c = $bf74d58b74973e6b$var$Nh(a, b, c, d, f, e);
    d = $bf74d58b74973e6b$var$Sh();
    if (null !== a && !$bf74d58b74973e6b$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $bf74d58b74973e6b$var$Zi(a, b, e);
    $bf74d58b74973e6b$var$I && d && $bf74d58b74973e6b$var$vg(b);
    b.flags |= 1;
    $bf74d58b74973e6b$var$Xi(a, b, c, e);
    return b.child;
}
function $bf74d58b74973e6b$var$hj(a, b, c, d, e) {
    if ($bf74d58b74973e6b$var$Zf(c)) {
        var f = !0;
        $bf74d58b74973e6b$var$cg(b);
    } else f = !1;
    $bf74d58b74973e6b$var$ch(b, e);
    if (null === b.stateNode) $bf74d58b74973e6b$var$ij(a, b), $bf74d58b74973e6b$var$Gi(b, c, d), $bf74d58b74973e6b$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === (typeof l === "undefined" ? "undefined" : (0, $5djcY._)(l)) && null !== l ? l = $bf74d58b74973e6b$var$eh(l) : (l = $bf74d58b74973e6b$var$Zf(c) ? $bf74d58b74973e6b$var$Xf : $bf74d58b74973e6b$var$H.current, l = $bf74d58b74973e6b$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $bf74d58b74973e6b$var$Hi(b, g, d, l);
        $bf74d58b74973e6b$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $bf74d58b74973e6b$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $bf74d58b74973e6b$var$Wf.current || $bf74d58b74973e6b$var$jh ? ("function" === typeof m && ($bf74d58b74973e6b$var$Di(b, c, m, d), k = b.memoizedState), (h = $bf74d58b74973e6b$var$jh || $bf74d58b74973e6b$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $bf74d58b74973e6b$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $bf74d58b74973e6b$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === (typeof k === "undefined" ? "undefined" : (0, $5djcY._)(k)) && null !== k ? k = $bf74d58b74973e6b$var$eh(k) : (k = $bf74d58b74973e6b$var$Zf(c) ? $bf74d58b74973e6b$var$Xf : $bf74d58b74973e6b$var$H.current, k = $bf74d58b74973e6b$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $bf74d58b74973e6b$var$Hi(b, g, d, k);
        $bf74d58b74973e6b$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $bf74d58b74973e6b$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $bf74d58b74973e6b$var$Wf.current || $bf74d58b74973e6b$var$jh ? ("function" === typeof y && ($bf74d58b74973e6b$var$Di(b, c, y, d), n = b.memoizedState), (l = $bf74d58b74973e6b$var$jh || $bf74d58b74973e6b$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $bf74d58b74973e6b$var$jj(a, b, c, d, f, e);
}
function $bf74d58b74973e6b$var$jj(a, b, c, d, e, f) {
    $bf74d58b74973e6b$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $bf74d58b74973e6b$var$dg(b, c, !1), $bf74d58b74973e6b$var$Zi(a, b, f);
    d = b.stateNode;
    $bf74d58b74973e6b$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $bf74d58b74973e6b$var$Ug(b, a.child, null, f), b.child = $bf74d58b74973e6b$var$Ug(b, null, h, f)) : $bf74d58b74973e6b$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $bf74d58b74973e6b$var$dg(b, c, !0);
    return b.child;
}
function $bf74d58b74973e6b$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $bf74d58b74973e6b$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $bf74d58b74973e6b$var$ag(a, b.context, !1);
    $bf74d58b74973e6b$var$yh(a, b.containerInfo);
}
function $bf74d58b74973e6b$var$lj(a, b, c, d, e) {
    $bf74d58b74973e6b$var$Ig();
    $bf74d58b74973e6b$var$Jg(e);
    b.flags |= 256;
    $bf74d58b74973e6b$var$Xi(a, b, c, d);
    return b.child;
}
var $bf74d58b74973e6b$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $bf74d58b74973e6b$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $bf74d58b74973e6b$var$oj(a, b, c) {
    var d = b.pendingProps, e = $bf74d58b74973e6b$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$L, e & 1);
    if (null === a) {
        $bf74d58b74973e6b$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $bf74d58b74973e6b$var$pj(g, d, 0, null), a = $bf74d58b74973e6b$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $bf74d58b74973e6b$var$nj(c), b.memoizedState = $bf74d58b74973e6b$var$mj, a) : $bf74d58b74973e6b$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $bf74d58b74973e6b$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $bf74d58b74973e6b$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $bf74d58b74973e6b$var$Pg(h, f) : (f = $bf74d58b74973e6b$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $bf74d58b74973e6b$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $bf74d58b74973e6b$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $bf74d58b74973e6b$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $bf74d58b74973e6b$var$qj(a, b) {
    b = $bf74d58b74973e6b$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $bf74d58b74973e6b$var$sj(a, b, c, d) {
    null !== d && $bf74d58b74973e6b$var$Jg(d);
    $bf74d58b74973e6b$var$Ug(b, a.child, null, c);
    a = $bf74d58b74973e6b$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $bf74d58b74973e6b$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $bf74d58b74973e6b$var$Ki(Error($bf74d58b74973e6b$var$p(422))), $bf74d58b74973e6b$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $bf74d58b74973e6b$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $bf74d58b74973e6b$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $bf74d58b74973e6b$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $bf74d58b74973e6b$var$nj(g);
        b.memoizedState = $bf74d58b74973e6b$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $bf74d58b74973e6b$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($bf74d58b74973e6b$var$p(419));
        d = $bf74d58b74973e6b$var$Ki(f, d, void 0);
        return $bf74d58b74973e6b$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($bf74d58b74973e6b$var$dh || h) {
        d = $bf74d58b74973e6b$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $bf74d58b74973e6b$var$ih(a, e), $bf74d58b74973e6b$var$gi(d, a, e, -1));
        }
        $bf74d58b74973e6b$var$tj();
        d = $bf74d58b74973e6b$var$Ki(Error($bf74d58b74973e6b$var$p(421)));
        return $bf74d58b74973e6b$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $bf74d58b74973e6b$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $bf74d58b74973e6b$var$yg = $bf74d58b74973e6b$var$Lf(e.nextSibling);
    $bf74d58b74973e6b$var$xg = b;
    $bf74d58b74973e6b$var$I = !0;
    $bf74d58b74973e6b$var$zg = null;
    null !== a && ($bf74d58b74973e6b$var$og[$bf74d58b74973e6b$var$pg++] = $bf74d58b74973e6b$var$rg, $bf74d58b74973e6b$var$og[$bf74d58b74973e6b$var$pg++] = $bf74d58b74973e6b$var$sg, $bf74d58b74973e6b$var$og[$bf74d58b74973e6b$var$pg++] = $bf74d58b74973e6b$var$qg, $bf74d58b74973e6b$var$rg = a.id, $bf74d58b74973e6b$var$sg = a.overflow, $bf74d58b74973e6b$var$qg = b);
    b = $bf74d58b74973e6b$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $bf74d58b74973e6b$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $bf74d58b74973e6b$var$bh(a.return, b, c);
}
function $bf74d58b74973e6b$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $bf74d58b74973e6b$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $bf74d58b74973e6b$var$Xi(a, b, d.children, c);
    d = $bf74d58b74973e6b$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $bf74d58b74973e6b$var$vj(a, c, b);
            else if (19 === a.tag) $bf74d58b74973e6b$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $bf74d58b74973e6b$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $bf74d58b74973e6b$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $bf74d58b74973e6b$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $bf74d58b74973e6b$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $bf74d58b74973e6b$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $bf74d58b74973e6b$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $bf74d58b74973e6b$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $bf74d58b74973e6b$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($bf74d58b74973e6b$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $bf74d58b74973e6b$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $bf74d58b74973e6b$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $bf74d58b74973e6b$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $bf74d58b74973e6b$var$kj(b);
            $bf74d58b74973e6b$var$Ig();
            break;
        case 5:
            $bf74d58b74973e6b$var$Ah(b);
            break;
        case 1:
            $bf74d58b74973e6b$var$Zf(b.type) && $bf74d58b74973e6b$var$cg(b);
            break;
        case 4:
            $bf74d58b74973e6b$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$L, $bf74d58b74973e6b$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $bf74d58b74973e6b$var$oj(a, b, c);
                $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$L, $bf74d58b74973e6b$var$L.current & 1);
                a = $bf74d58b74973e6b$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$L, $bf74d58b74973e6b$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $bf74d58b74973e6b$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$L, $bf74d58b74973e6b$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $bf74d58b74973e6b$var$dj(a, b, c);
    }
    return $bf74d58b74973e6b$var$Zi(a, b, c);
}
var $bf74d58b74973e6b$var$zj, $bf74d58b74973e6b$var$Aj, $bf74d58b74973e6b$var$Bj, $bf74d58b74973e6b$var$Cj;
$bf74d58b74973e6b$var$zj = function zj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$bf74d58b74973e6b$var$Aj = function Aj() {};
$bf74d58b74973e6b$var$Bj = function Bj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $bf74d58b74973e6b$var$xh($bf74d58b74973e6b$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $bf74d58b74973e6b$var$Ya(a, e);
                d = $bf74d58b74973e6b$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $bf74d58b74973e6b$var$A({}, e, {
                    value: void 0
                });
                d = $bf74d58b74973e6b$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $bf74d58b74973e6b$var$gb(a, e);
                d = $bf74d58b74973e6b$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $bf74d58b74973e6b$var$Bf);
        }
        $bf74d58b74973e6b$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($bf74d58b74973e6b$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($bf74d58b74973e6b$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $bf74d58b74973e6b$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$bf74d58b74973e6b$var$Cj = function Cj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $bf74d58b74973e6b$var$Dj(a, b) {
    if (!$bf74d58b74973e6b$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $bf74d58b74973e6b$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $bf74d58b74973e6b$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $bf74d58b74973e6b$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $bf74d58b74973e6b$var$S(b), null;
        case 1:
            return $bf74d58b74973e6b$var$Zf(b.type) && $bf74d58b74973e6b$var$$f(), $bf74d58b74973e6b$var$S(b), null;
        case 3:
            d = b.stateNode;
            $bf74d58b74973e6b$var$zh();
            $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$Wf);
            $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$H);
            $bf74d58b74973e6b$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $bf74d58b74973e6b$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $bf74d58b74973e6b$var$zg && ($bf74d58b74973e6b$var$Fj($bf74d58b74973e6b$var$zg), $bf74d58b74973e6b$var$zg = null));
            $bf74d58b74973e6b$var$Aj(a, b);
            $bf74d58b74973e6b$var$S(b);
            return null;
        case 5:
            $bf74d58b74973e6b$var$Bh(b);
            var e = $bf74d58b74973e6b$var$xh($bf74d58b74973e6b$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $bf74d58b74973e6b$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($bf74d58b74973e6b$var$p(166));
                    $bf74d58b74973e6b$var$S(b);
                    return null;
                }
                a = $bf74d58b74973e6b$var$xh($bf74d58b74973e6b$var$uh.current);
                if ($bf74d58b74973e6b$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$bf74d58b74973e6b$var$Of] = b;
                    d[$bf74d58b74973e6b$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $bf74d58b74973e6b$var$D("cancel", d);
                            $bf74d58b74973e6b$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $bf74d58b74973e6b$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $bf74d58b74973e6b$var$lf.length; e++)$bf74d58b74973e6b$var$D($bf74d58b74973e6b$var$lf[e], d);
                            break;
                        case "source":
                            $bf74d58b74973e6b$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $bf74d58b74973e6b$var$D("error", d);
                            $bf74d58b74973e6b$var$D("load", d);
                            break;
                        case "details":
                            $bf74d58b74973e6b$var$D("toggle", d);
                            break;
                        case "input":
                            $bf74d58b74973e6b$var$Za(d, f);
                            $bf74d58b74973e6b$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $bf74d58b74973e6b$var$D("invalid", d);
                            break;
                        case "textarea":
                            $bf74d58b74973e6b$var$hb(d, f), $bf74d58b74973e6b$var$D("invalid", d);
                    }
                    $bf74d58b74973e6b$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $bf74d58b74973e6b$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $bf74d58b74973e6b$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $bf74d58b74973e6b$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $bf74d58b74973e6b$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $bf74d58b74973e6b$var$Va(d);
                            $bf74d58b74973e6b$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $bf74d58b74973e6b$var$Va(d);
                            $bf74d58b74973e6b$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $bf74d58b74973e6b$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $bf74d58b74973e6b$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$bf74d58b74973e6b$var$Of] = b;
                    a[$bf74d58b74973e6b$var$Pf] = d;
                    $bf74d58b74973e6b$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $bf74d58b74973e6b$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $bf74d58b74973e6b$var$D("cancel", a);
                                $bf74d58b74973e6b$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $bf74d58b74973e6b$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $bf74d58b74973e6b$var$lf.length; e++)$bf74d58b74973e6b$var$D($bf74d58b74973e6b$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $bf74d58b74973e6b$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $bf74d58b74973e6b$var$D("error", a);
                                $bf74d58b74973e6b$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $bf74d58b74973e6b$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $bf74d58b74973e6b$var$Za(a, d);
                                e = $bf74d58b74973e6b$var$Ya(a, d);
                                $bf74d58b74973e6b$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $bf74d58b74973e6b$var$A({}, d, {
                                    value: void 0
                                });
                                $bf74d58b74973e6b$var$D("invalid", a);
                                break;
                            case "textarea":
                                $bf74d58b74973e6b$var$hb(a, d);
                                e = $bf74d58b74973e6b$var$gb(a, d);
                                $bf74d58b74973e6b$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $bf74d58b74973e6b$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $bf74d58b74973e6b$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $bf74d58b74973e6b$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $bf74d58b74973e6b$var$ob(a, k) : "number" === typeof k && $bf74d58b74973e6b$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($bf74d58b74973e6b$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $bf74d58b74973e6b$var$D("scroll", a) : null != k && $bf74d58b74973e6b$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $bf74d58b74973e6b$var$Va(a);
                                $bf74d58b74973e6b$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $bf74d58b74973e6b$var$Va(a);
                                $bf74d58b74973e6b$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $bf74d58b74973e6b$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $bf74d58b74973e6b$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $bf74d58b74973e6b$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $bf74d58b74973e6b$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $bf74d58b74973e6b$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $bf74d58b74973e6b$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($bf74d58b74973e6b$var$p(166));
                c = $bf74d58b74973e6b$var$xh($bf74d58b74973e6b$var$wh.current);
                $bf74d58b74973e6b$var$xh($bf74d58b74973e6b$var$uh.current);
                if ($bf74d58b74973e6b$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$bf74d58b74973e6b$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $bf74d58b74973e6b$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $bf74d58b74973e6b$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $bf74d58b74973e6b$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$bf74d58b74973e6b$var$Of] = b, b.stateNode = d;
            }
            $bf74d58b74973e6b$var$S(b);
            return null;
        case 13:
            $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($bf74d58b74973e6b$var$I && null !== $bf74d58b74973e6b$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $bf74d58b74973e6b$var$Hg(), $bf74d58b74973e6b$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $bf74d58b74973e6b$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($bf74d58b74973e6b$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($bf74d58b74973e6b$var$p(317));
                        f[$bf74d58b74973e6b$var$Of] = b;
                    } else $bf74d58b74973e6b$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $bf74d58b74973e6b$var$S(b);
                    f = !1;
                } else null !== $bf74d58b74973e6b$var$zg && ($bf74d58b74973e6b$var$Fj($bf74d58b74973e6b$var$zg), $bf74d58b74973e6b$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($bf74d58b74973e6b$var$L.current & 1) ? 0 === $bf74d58b74973e6b$var$T && ($bf74d58b74973e6b$var$T = 3) : $bf74d58b74973e6b$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $bf74d58b74973e6b$var$S(b);
            return null;
        case 4:
            return $bf74d58b74973e6b$var$zh(), $bf74d58b74973e6b$var$Aj(a, b), null === a && $bf74d58b74973e6b$var$sf(b.stateNode.containerInfo), $bf74d58b74973e6b$var$S(b), null;
        case 10:
            return $bf74d58b74973e6b$var$ah(b.type._context), $bf74d58b74973e6b$var$S(b), null;
        case 17:
            return $bf74d58b74973e6b$var$Zf(b.type) && $bf74d58b74973e6b$var$$f(), $bf74d58b74973e6b$var$S(b), null;
        case 19:
            $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$L);
            f = b.memoizedState;
            if (null === f) return $bf74d58b74973e6b$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $bf74d58b74973e6b$var$Dj(f, !1);
                else {
                    if (0 !== $bf74d58b74973e6b$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $bf74d58b74973e6b$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $bf74d58b74973e6b$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$L, $bf74d58b74973e6b$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $bf74d58b74973e6b$var$B() > $bf74d58b74973e6b$var$Gj && (b.flags |= 128, d = !0, $bf74d58b74973e6b$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $bf74d58b74973e6b$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $bf74d58b74973e6b$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$bf74d58b74973e6b$var$I) return $bf74d58b74973e6b$var$S(b), null;
                    } else 2 * $bf74d58b74973e6b$var$B() - f.renderingStartTime > $bf74d58b74973e6b$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $bf74d58b74973e6b$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $bf74d58b74973e6b$var$B(), b.sibling = null, c = $bf74d58b74973e6b$var$L.current, $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$L, d ? c & 1 | 2 : c & 1), b;
            $bf74d58b74973e6b$var$S(b);
            return null;
        case 22:
        case 23:
            return $bf74d58b74973e6b$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($bf74d58b74973e6b$var$fj & 1073741824) && ($bf74d58b74973e6b$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $bf74d58b74973e6b$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($bf74d58b74973e6b$var$p(156, b.tag));
}
function $bf74d58b74973e6b$var$Ij(a, b) {
    $bf74d58b74973e6b$var$wg(b);
    switch(b.tag){
        case 1:
            return $bf74d58b74973e6b$var$Zf(b.type) && $bf74d58b74973e6b$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $bf74d58b74973e6b$var$zh(), $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$Wf), $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$H), $bf74d58b74973e6b$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $bf74d58b74973e6b$var$Bh(b), null;
        case 13:
            $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($bf74d58b74973e6b$var$p(340));
                $bf74d58b74973e6b$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$L), null;
        case 4:
            return $bf74d58b74973e6b$var$zh(), null;
        case 10:
            return $bf74d58b74973e6b$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $bf74d58b74973e6b$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $bf74d58b74973e6b$var$Jj = !1, $bf74d58b74973e6b$var$U = !1, $bf74d58b74973e6b$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $bf74d58b74973e6b$var$V = null;
function $bf74d58b74973e6b$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $bf74d58b74973e6b$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $bf74d58b74973e6b$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $bf74d58b74973e6b$var$W(a, b, d);
    }
}
var $bf74d58b74973e6b$var$Nj = !1;
function $bf74d58b74973e6b$var$Oj(a, b) {
    $bf74d58b74973e6b$var$Cf = $bf74d58b74973e6b$var$dd;
    a = $bf74d58b74973e6b$var$Me();
    if ($bf74d58b74973e6b$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $bf74d58b74973e6b$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $bf74d58b74973e6b$var$dd = !1;
    for($bf74d58b74973e6b$var$V = b; null !== $bf74d58b74973e6b$var$V;)if (b = $bf74d58b74973e6b$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $bf74d58b74973e6b$var$V = a;
    else for(; null !== $bf74d58b74973e6b$var$V;){
        b = $bf74d58b74973e6b$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $bf74d58b74973e6b$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($bf74d58b74973e6b$var$p(163));
            }
        } catch (F) {
            $bf74d58b74973e6b$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $bf74d58b74973e6b$var$V = a;
            break;
        }
        $bf74d58b74973e6b$var$V = b.return;
    }
    n = $bf74d58b74973e6b$var$Nj;
    $bf74d58b74973e6b$var$Nj = !1;
    return n;
}
function $bf74d58b74973e6b$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $bf74d58b74973e6b$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $bf74d58b74973e6b$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $bf74d58b74973e6b$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $bf74d58b74973e6b$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $bf74d58b74973e6b$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$bf74d58b74973e6b$var$Of], delete b[$bf74d58b74973e6b$var$Pf], delete b[$bf74d58b74973e6b$var$of], delete b[$bf74d58b74973e6b$var$Qf], delete b[$bf74d58b74973e6b$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $bf74d58b74973e6b$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $bf74d58b74973e6b$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $bf74d58b74973e6b$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $bf74d58b74973e6b$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $bf74d58b74973e6b$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($bf74d58b74973e6b$var$Vj(a, b, c), a = a.sibling; null !== a;)$bf74d58b74973e6b$var$Vj(a, b, c), a = a.sibling;
}
function $bf74d58b74973e6b$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($bf74d58b74973e6b$var$Wj(a, b, c), a = a.sibling; null !== a;)$bf74d58b74973e6b$var$Wj(a, b, c), a = a.sibling;
}
var $bf74d58b74973e6b$var$X = null, $bf74d58b74973e6b$var$Xj = !1;
function $bf74d58b74973e6b$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$bf74d58b74973e6b$var$Zj(a, b, c), c = c.sibling;
}
function $bf74d58b74973e6b$var$Zj(a, b, c) {
    if ($bf74d58b74973e6b$var$lc && "function" === typeof $bf74d58b74973e6b$var$lc.onCommitFiberUnmount) try {
        $bf74d58b74973e6b$var$lc.onCommitFiberUnmount($bf74d58b74973e6b$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $bf74d58b74973e6b$var$U || $bf74d58b74973e6b$var$Lj(c, b);
        case 6:
            var d = $bf74d58b74973e6b$var$X, e = $bf74d58b74973e6b$var$Xj;
            $bf74d58b74973e6b$var$X = null;
            $bf74d58b74973e6b$var$Yj(a, b, c);
            $bf74d58b74973e6b$var$X = d;
            $bf74d58b74973e6b$var$Xj = e;
            null !== $bf74d58b74973e6b$var$X && ($bf74d58b74973e6b$var$Xj ? (a = $bf74d58b74973e6b$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $bf74d58b74973e6b$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $bf74d58b74973e6b$var$X && ($bf74d58b74973e6b$var$Xj ? (a = $bf74d58b74973e6b$var$X, c = c.stateNode, 8 === a.nodeType ? $bf74d58b74973e6b$var$Kf(a.parentNode, c) : 1 === a.nodeType && $bf74d58b74973e6b$var$Kf(a, c), $bf74d58b74973e6b$var$bd(a)) : $bf74d58b74973e6b$var$Kf($bf74d58b74973e6b$var$X, c.stateNode));
            break;
        case 4:
            d = $bf74d58b74973e6b$var$X;
            e = $bf74d58b74973e6b$var$Xj;
            $bf74d58b74973e6b$var$X = c.stateNode.containerInfo;
            $bf74d58b74973e6b$var$Xj = !0;
            $bf74d58b74973e6b$var$Yj(a, b, c);
            $bf74d58b74973e6b$var$X = d;
            $bf74d58b74973e6b$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$bf74d58b74973e6b$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $bf74d58b74973e6b$var$Mj(c, b, g) : 0 !== (f & 4) && $bf74d58b74973e6b$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $bf74d58b74973e6b$var$Yj(a, b, c);
            break;
        case 1:
            if (!$bf74d58b74973e6b$var$U && ($bf74d58b74973e6b$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $bf74d58b74973e6b$var$W(c, b, h);
            }
            $bf74d58b74973e6b$var$Yj(a, b, c);
            break;
        case 21:
            $bf74d58b74973e6b$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($bf74d58b74973e6b$var$U = (d = $bf74d58b74973e6b$var$U) || null !== c.memoizedState, $bf74d58b74973e6b$var$Yj(a, b, c), $bf74d58b74973e6b$var$U = d) : $bf74d58b74973e6b$var$Yj(a, b, c);
            break;
        default:
            $bf74d58b74973e6b$var$Yj(a, b, c);
    }
}
function $bf74d58b74973e6b$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $bf74d58b74973e6b$var$Kj);
        b.forEach(function(b) {
            var d = $bf74d58b74973e6b$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $bf74d58b74973e6b$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $bf74d58b74973e6b$var$X = h.stateNode;
                        $bf74d58b74973e6b$var$Xj = !1;
                        break a;
                    case 3:
                        $bf74d58b74973e6b$var$X = h.stateNode.containerInfo;
                        $bf74d58b74973e6b$var$Xj = !0;
                        break a;
                    case 4:
                        $bf74d58b74973e6b$var$X = h.stateNode.containerInfo;
                        $bf74d58b74973e6b$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $bf74d58b74973e6b$var$X) throw Error($bf74d58b74973e6b$var$p(160));
            $bf74d58b74973e6b$var$Zj(f, g, e);
            $bf74d58b74973e6b$var$X = null;
            $bf74d58b74973e6b$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $bf74d58b74973e6b$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$bf74d58b74973e6b$var$dk(b, a), b = b.sibling;
}
function $bf74d58b74973e6b$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $bf74d58b74973e6b$var$ck(b, a);
            $bf74d58b74973e6b$var$ek(a);
            if (d & 4) {
                try {
                    $bf74d58b74973e6b$var$Pj(3, a, a.return), $bf74d58b74973e6b$var$Qj(3, a);
                } catch (t) {
                    $bf74d58b74973e6b$var$W(a, a.return, t);
                }
                try {
                    $bf74d58b74973e6b$var$Pj(5, a, a.return);
                } catch (t) {
                    $bf74d58b74973e6b$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $bf74d58b74973e6b$var$ck(b, a);
            $bf74d58b74973e6b$var$ek(a);
            d & 512 && null !== c && $bf74d58b74973e6b$var$Lj(c, c.return);
            break;
        case 5:
            $bf74d58b74973e6b$var$ck(b, a);
            $bf74d58b74973e6b$var$ek(a);
            d & 512 && null !== c && $bf74d58b74973e6b$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $bf74d58b74973e6b$var$ob(e, "");
                } catch (t) {
                    $bf74d58b74973e6b$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $bf74d58b74973e6b$var$ab(e, f);
                    $bf74d58b74973e6b$var$vb(h, g);
                    var l = $bf74d58b74973e6b$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $bf74d58b74973e6b$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $bf74d58b74973e6b$var$nb(e, q) : "children" === m ? $bf74d58b74973e6b$var$ob(e, q) : $bf74d58b74973e6b$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $bf74d58b74973e6b$var$bb(e, f);
                            break;
                        case "textarea":
                            $bf74d58b74973e6b$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $bf74d58b74973e6b$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $bf74d58b74973e6b$var$fb(e, !!f.multiple, f.defaultValue, !0) : $bf74d58b74973e6b$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$bf74d58b74973e6b$var$Pf] = f;
                } catch (t) {
                    $bf74d58b74973e6b$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $bf74d58b74973e6b$var$ck(b, a);
            $bf74d58b74973e6b$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($bf74d58b74973e6b$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $bf74d58b74973e6b$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $bf74d58b74973e6b$var$ck(b, a);
            $bf74d58b74973e6b$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $bf74d58b74973e6b$var$bd(b.containerInfo);
            } catch (t) {
                $bf74d58b74973e6b$var$W(a, a.return, t);
            }
            break;
        case 4:
            $bf74d58b74973e6b$var$ck(b, a);
            $bf74d58b74973e6b$var$ek(a);
            break;
        case 13:
            $bf74d58b74973e6b$var$ck(b, a);
            $bf74d58b74973e6b$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($bf74d58b74973e6b$var$fk = $bf74d58b74973e6b$var$B()));
            d & 4 && $bf74d58b74973e6b$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($bf74d58b74973e6b$var$U = (l = $bf74d58b74973e6b$var$U) || m, $bf74d58b74973e6b$var$ck(b, a), $bf74d58b74973e6b$var$U = l) : $bf74d58b74973e6b$var$ck(b, a);
            $bf74d58b74973e6b$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($bf74d58b74973e6b$var$V = a, m = a.child; null !== m;){
                    for(q = $bf74d58b74973e6b$var$V = m; null !== $bf74d58b74973e6b$var$V;){
                        r = $bf74d58b74973e6b$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $bf74d58b74973e6b$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $bf74d58b74973e6b$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $bf74d58b74973e6b$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $bf74d58b74973e6b$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $bf74d58b74973e6b$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $bf74d58b74973e6b$var$V = y) : $bf74d58b74973e6b$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $bf74d58b74973e6b$var$rb("display", g));
                            } catch (t) {
                                $bf74d58b74973e6b$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $bf74d58b74973e6b$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $bf74d58b74973e6b$var$ck(b, a);
            $bf74d58b74973e6b$var$ek(a);
            d & 4 && $bf74d58b74973e6b$var$ak(a);
            break;
        case 21:
            break;
        default:
            $bf74d58b74973e6b$var$ck(b, a), $bf74d58b74973e6b$var$ek(a);
    }
}
function $bf74d58b74973e6b$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($bf74d58b74973e6b$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($bf74d58b74973e6b$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($bf74d58b74973e6b$var$ob(e, ""), d.flags &= -33);
                    var f = $bf74d58b74973e6b$var$Uj(a);
                    $bf74d58b74973e6b$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $bf74d58b74973e6b$var$Uj(a);
                    $bf74d58b74973e6b$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($bf74d58b74973e6b$var$p(161));
            }
        } catch (k) {
            $bf74d58b74973e6b$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $bf74d58b74973e6b$var$hk(a, b, c) {
    $bf74d58b74973e6b$var$V = a;
    $bf74d58b74973e6b$var$ik(a, b, c);
}
function $bf74d58b74973e6b$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $bf74d58b74973e6b$var$V;){
        var e = $bf74d58b74973e6b$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $bf74d58b74973e6b$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $bf74d58b74973e6b$var$U;
                h = $bf74d58b74973e6b$var$Jj;
                var l = $bf74d58b74973e6b$var$U;
                $bf74d58b74973e6b$var$Jj = g;
                if (($bf74d58b74973e6b$var$U = k) && !l) for($bf74d58b74973e6b$var$V = e; null !== $bf74d58b74973e6b$var$V;)g = $bf74d58b74973e6b$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $bf74d58b74973e6b$var$jk(e) : null !== k ? (k.return = g, $bf74d58b74973e6b$var$V = k) : $bf74d58b74973e6b$var$jk(e);
                for(; null !== f;)$bf74d58b74973e6b$var$V = f, $bf74d58b74973e6b$var$ik(f, b, c), f = f.sibling;
                $bf74d58b74973e6b$var$V = e;
                $bf74d58b74973e6b$var$Jj = h;
                $bf74d58b74973e6b$var$U = l;
            }
            $bf74d58b74973e6b$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $bf74d58b74973e6b$var$V = f) : $bf74d58b74973e6b$var$kk(a, b, c);
    }
}
function $bf74d58b74973e6b$var$kk(a) {
    for(; null !== $bf74d58b74973e6b$var$V;){
        var b = $bf74d58b74973e6b$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $bf74d58b74973e6b$var$U || $bf74d58b74973e6b$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$bf74d58b74973e6b$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $bf74d58b74973e6b$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $bf74d58b74973e6b$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $bf74d58b74973e6b$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $bf74d58b74973e6b$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($bf74d58b74973e6b$var$p(163));
                }
                $bf74d58b74973e6b$var$U || b.flags & 512 && $bf74d58b74973e6b$var$Rj(b);
            } catch (r) {
                $bf74d58b74973e6b$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $bf74d58b74973e6b$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $bf74d58b74973e6b$var$V = c;
            break;
        }
        $bf74d58b74973e6b$var$V = b.return;
    }
}
function $bf74d58b74973e6b$var$gk(a) {
    for(; null !== $bf74d58b74973e6b$var$V;){
        var b = $bf74d58b74973e6b$var$V;
        if (b === a) {
            $bf74d58b74973e6b$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $bf74d58b74973e6b$var$V = c;
            break;
        }
        $bf74d58b74973e6b$var$V = b.return;
    }
}
function $bf74d58b74973e6b$var$jk(a) {
    for(; null !== $bf74d58b74973e6b$var$V;){
        var b = $bf74d58b74973e6b$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $bf74d58b74973e6b$var$Qj(4, b);
                    } catch (k) {
                        $bf74d58b74973e6b$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $bf74d58b74973e6b$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $bf74d58b74973e6b$var$Rj(b);
                    } catch (k) {
                        $bf74d58b74973e6b$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $bf74d58b74973e6b$var$Rj(b);
                    } catch (k) {
                        $bf74d58b74973e6b$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $bf74d58b74973e6b$var$W(b, b.return, k);
        }
        if (b === a) {
            $bf74d58b74973e6b$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $bf74d58b74973e6b$var$V = h;
            break;
        }
        $bf74d58b74973e6b$var$V = b.return;
    }
}
var $bf74d58b74973e6b$var$lk = Math.ceil, $bf74d58b74973e6b$var$mk = $bf74d58b74973e6b$var$ua.ReactCurrentDispatcher, $bf74d58b74973e6b$var$nk = $bf74d58b74973e6b$var$ua.ReactCurrentOwner, $bf74d58b74973e6b$var$ok = $bf74d58b74973e6b$var$ua.ReactCurrentBatchConfig, $bf74d58b74973e6b$var$K = 0, $bf74d58b74973e6b$var$Q = null, $bf74d58b74973e6b$var$Y = null, $bf74d58b74973e6b$var$Z = 0, $bf74d58b74973e6b$var$fj = 0, $bf74d58b74973e6b$var$ej = $bf74d58b74973e6b$var$Uf(0), $bf74d58b74973e6b$var$T = 0, $bf74d58b74973e6b$var$pk = null, $bf74d58b74973e6b$var$rh = 0, $bf74d58b74973e6b$var$qk = 0, $bf74d58b74973e6b$var$rk = 0, $bf74d58b74973e6b$var$sk = null, $bf74d58b74973e6b$var$tk = null, $bf74d58b74973e6b$var$fk = 0, $bf74d58b74973e6b$var$Gj = Infinity, $bf74d58b74973e6b$var$uk = null, $bf74d58b74973e6b$var$Oi = !1, $bf74d58b74973e6b$var$Pi = null, $bf74d58b74973e6b$var$Ri = null, $bf74d58b74973e6b$var$vk = !1, $bf74d58b74973e6b$var$wk = null, $bf74d58b74973e6b$var$xk = 0, $bf74d58b74973e6b$var$yk = 0, $bf74d58b74973e6b$var$zk = null, $bf74d58b74973e6b$var$Ak = -1, $bf74d58b74973e6b$var$Bk = 0;
function $bf74d58b74973e6b$var$R() {
    return 0 !== ($bf74d58b74973e6b$var$K & 6) ? $bf74d58b74973e6b$var$B() : -1 !== $bf74d58b74973e6b$var$Ak ? $bf74d58b74973e6b$var$Ak : $bf74d58b74973e6b$var$Ak = $bf74d58b74973e6b$var$B();
}
function $bf74d58b74973e6b$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($bf74d58b74973e6b$var$K & 2) && 0 !== $bf74d58b74973e6b$var$Z) return $bf74d58b74973e6b$var$Z & -$bf74d58b74973e6b$var$Z;
    if (null !== $bf74d58b74973e6b$var$Kg.transition) return 0 === $bf74d58b74973e6b$var$Bk && ($bf74d58b74973e6b$var$Bk = $bf74d58b74973e6b$var$yc()), $bf74d58b74973e6b$var$Bk;
    a = $bf74d58b74973e6b$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $bf74d58b74973e6b$var$jd(a.type);
    return a;
}
function $bf74d58b74973e6b$var$gi(a, b, c, d) {
    if (50 < $bf74d58b74973e6b$var$yk) throw $bf74d58b74973e6b$var$yk = 0, $bf74d58b74973e6b$var$zk = null, Error($bf74d58b74973e6b$var$p(185));
    $bf74d58b74973e6b$var$Ac(a, c, d);
    if (0 === ($bf74d58b74973e6b$var$K & 2) || a !== $bf74d58b74973e6b$var$Q) a === $bf74d58b74973e6b$var$Q && (0 === ($bf74d58b74973e6b$var$K & 2) && ($bf74d58b74973e6b$var$qk |= c), 4 === $bf74d58b74973e6b$var$T && $bf74d58b74973e6b$var$Ck(a, $bf74d58b74973e6b$var$Z)), $bf74d58b74973e6b$var$Dk(a, d), 1 === c && 0 === $bf74d58b74973e6b$var$K && 0 === (b.mode & 1) && ($bf74d58b74973e6b$var$Gj = $bf74d58b74973e6b$var$B() + 500, $bf74d58b74973e6b$var$fg && $bf74d58b74973e6b$var$jg());
}
function $bf74d58b74973e6b$var$Dk(a, b) {
    var c = a.callbackNode;
    $bf74d58b74973e6b$var$wc(a, b);
    var d = $bf74d58b74973e6b$var$uc(a, a === $bf74d58b74973e6b$var$Q ? $bf74d58b74973e6b$var$Z : 0);
    if (0 === d) null !== c && $bf74d58b74973e6b$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $bf74d58b74973e6b$var$bc(c);
        if (1 === b) 0 === a.tag ? $bf74d58b74973e6b$var$ig($bf74d58b74973e6b$var$Ek.bind(null, a)) : $bf74d58b74973e6b$var$hg($bf74d58b74973e6b$var$Ek.bind(null, a)), $bf74d58b74973e6b$var$Jf(function() {
            0 === ($bf74d58b74973e6b$var$K & 6) && $bf74d58b74973e6b$var$jg();
        }), c = null;
        else {
            switch($bf74d58b74973e6b$var$Dc(d)){
                case 1:
                    c = $bf74d58b74973e6b$var$fc;
                    break;
                case 4:
                    c = $bf74d58b74973e6b$var$gc;
                    break;
                case 16:
                    c = $bf74d58b74973e6b$var$hc;
                    break;
                case 536870912:
                    c = $bf74d58b74973e6b$var$jc;
                    break;
                default:
                    c = $bf74d58b74973e6b$var$hc;
            }
            c = $bf74d58b74973e6b$var$Fk(c, $bf74d58b74973e6b$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $bf74d58b74973e6b$var$Gk(a, b) {
    $bf74d58b74973e6b$var$Ak = -1;
    $bf74d58b74973e6b$var$Bk = 0;
    if (0 !== ($bf74d58b74973e6b$var$K & 6)) throw Error($bf74d58b74973e6b$var$p(327));
    var c = a.callbackNode;
    if ($bf74d58b74973e6b$var$Hk() && a.callbackNode !== c) return null;
    var d = $bf74d58b74973e6b$var$uc(a, a === $bf74d58b74973e6b$var$Q ? $bf74d58b74973e6b$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $bf74d58b74973e6b$var$Ik(a, d);
    else {
        b = d;
        var e = $bf74d58b74973e6b$var$K;
        $bf74d58b74973e6b$var$K |= 2;
        var f = $bf74d58b74973e6b$var$Jk();
        if ($bf74d58b74973e6b$var$Q !== a || $bf74d58b74973e6b$var$Z !== b) $bf74d58b74973e6b$var$uk = null, $bf74d58b74973e6b$var$Gj = $bf74d58b74973e6b$var$B() + 500, $bf74d58b74973e6b$var$Kk(a, b);
        for(;;)try {
            $bf74d58b74973e6b$var$Lk();
            break;
        } catch (h) {
            $bf74d58b74973e6b$var$Mk(a, h);
        }
        $bf74d58b74973e6b$var$$g();
        $bf74d58b74973e6b$var$mk.current = f;
        $bf74d58b74973e6b$var$K = e;
        null !== $bf74d58b74973e6b$var$Y ? b = 0 : ($bf74d58b74973e6b$var$Q = null, $bf74d58b74973e6b$var$Z = 0, b = $bf74d58b74973e6b$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $bf74d58b74973e6b$var$xc(a), 0 !== e && (d = e, b = $bf74d58b74973e6b$var$Nk(a, e)));
        if (1 === b) throw c = $bf74d58b74973e6b$var$pk, $bf74d58b74973e6b$var$Kk(a, 0), $bf74d58b74973e6b$var$Ck(a, d), $bf74d58b74973e6b$var$Dk(a, $bf74d58b74973e6b$var$B()), c;
        if (6 === b) $bf74d58b74973e6b$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$bf74d58b74973e6b$var$Ok(e) && (b = $bf74d58b74973e6b$var$Ik(a, d), 2 === b && (f = $bf74d58b74973e6b$var$xc(a), 0 !== f && (d = f, b = $bf74d58b74973e6b$var$Nk(a, f))), 1 === b)) throw c = $bf74d58b74973e6b$var$pk, $bf74d58b74973e6b$var$Kk(a, 0), $bf74d58b74973e6b$var$Ck(a, d), $bf74d58b74973e6b$var$Dk(a, $bf74d58b74973e6b$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($bf74d58b74973e6b$var$p(345));
                case 2:
                    $bf74d58b74973e6b$var$Pk(a, $bf74d58b74973e6b$var$tk, $bf74d58b74973e6b$var$uk);
                    break;
                case 3:
                    $bf74d58b74973e6b$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $bf74d58b74973e6b$var$fk + 500 - $bf74d58b74973e6b$var$B(), 10 < b)) {
                        if (0 !== $bf74d58b74973e6b$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $bf74d58b74973e6b$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $bf74d58b74973e6b$var$Ff($bf74d58b74973e6b$var$Pk.bind(null, a, $bf74d58b74973e6b$var$tk, $bf74d58b74973e6b$var$uk), b);
                        break;
                    }
                    $bf74d58b74973e6b$var$Pk(a, $bf74d58b74973e6b$var$tk, $bf74d58b74973e6b$var$uk);
                    break;
                case 4:
                    $bf74d58b74973e6b$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $bf74d58b74973e6b$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $bf74d58b74973e6b$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $bf74d58b74973e6b$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $bf74d58b74973e6b$var$Ff($bf74d58b74973e6b$var$Pk.bind(null, a, $bf74d58b74973e6b$var$tk, $bf74d58b74973e6b$var$uk), d);
                        break;
                    }
                    $bf74d58b74973e6b$var$Pk(a, $bf74d58b74973e6b$var$tk, $bf74d58b74973e6b$var$uk);
                    break;
                case 5:
                    $bf74d58b74973e6b$var$Pk(a, $bf74d58b74973e6b$var$tk, $bf74d58b74973e6b$var$uk);
                    break;
                default:
                    throw Error($bf74d58b74973e6b$var$p(329));
            }
        }
    }
    $bf74d58b74973e6b$var$Dk(a, $bf74d58b74973e6b$var$B());
    return a.callbackNode === c ? $bf74d58b74973e6b$var$Gk.bind(null, a) : null;
}
function $bf74d58b74973e6b$var$Nk(a, b) {
    var c = $bf74d58b74973e6b$var$sk;
    a.current.memoizedState.isDehydrated && ($bf74d58b74973e6b$var$Kk(a, b).flags |= 256);
    a = $bf74d58b74973e6b$var$Ik(a, b);
    2 !== a && (b = $bf74d58b74973e6b$var$tk, $bf74d58b74973e6b$var$tk = c, null !== b && $bf74d58b74973e6b$var$Fj(b));
    return a;
}
function $bf74d58b74973e6b$var$Fj(a) {
    null === $bf74d58b74973e6b$var$tk ? $bf74d58b74973e6b$var$tk = a : $bf74d58b74973e6b$var$tk.push.apply($bf74d58b74973e6b$var$tk, a);
}
function $bf74d58b74973e6b$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$bf74d58b74973e6b$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $bf74d58b74973e6b$var$Ck(a, b) {
    b &= ~$bf74d58b74973e6b$var$rk;
    b &= ~$bf74d58b74973e6b$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $bf74d58b74973e6b$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $bf74d58b74973e6b$var$Ek(a) {
    if (0 !== ($bf74d58b74973e6b$var$K & 6)) throw Error($bf74d58b74973e6b$var$p(327));
    $bf74d58b74973e6b$var$Hk();
    var b = $bf74d58b74973e6b$var$uc(a, 0);
    if (0 === (b & 1)) return $bf74d58b74973e6b$var$Dk(a, $bf74d58b74973e6b$var$B()), null;
    var c = $bf74d58b74973e6b$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $bf74d58b74973e6b$var$xc(a);
        0 !== d && (b = d, c = $bf74d58b74973e6b$var$Nk(a, d));
    }
    if (1 === c) throw c = $bf74d58b74973e6b$var$pk, $bf74d58b74973e6b$var$Kk(a, 0), $bf74d58b74973e6b$var$Ck(a, b), $bf74d58b74973e6b$var$Dk(a, $bf74d58b74973e6b$var$B()), c;
    if (6 === c) throw Error($bf74d58b74973e6b$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $bf74d58b74973e6b$var$Pk(a, $bf74d58b74973e6b$var$tk, $bf74d58b74973e6b$var$uk);
    $bf74d58b74973e6b$var$Dk(a, $bf74d58b74973e6b$var$B());
    return null;
}
function $bf74d58b74973e6b$var$Qk(a, b) {
    var c = $bf74d58b74973e6b$var$K;
    $bf74d58b74973e6b$var$K |= 1;
    try {
        return a(b);
    } finally{
        $bf74d58b74973e6b$var$K = c, 0 === $bf74d58b74973e6b$var$K && ($bf74d58b74973e6b$var$Gj = $bf74d58b74973e6b$var$B() + 500, $bf74d58b74973e6b$var$fg && $bf74d58b74973e6b$var$jg());
    }
}
function $bf74d58b74973e6b$var$Rk(a) {
    null !== $bf74d58b74973e6b$var$wk && 0 === $bf74d58b74973e6b$var$wk.tag && 0 === ($bf74d58b74973e6b$var$K & 6) && $bf74d58b74973e6b$var$Hk();
    var b = $bf74d58b74973e6b$var$K;
    $bf74d58b74973e6b$var$K |= 1;
    var c = $bf74d58b74973e6b$var$ok.transition, d = $bf74d58b74973e6b$var$C;
    try {
        if ($bf74d58b74973e6b$var$ok.transition = null, $bf74d58b74973e6b$var$C = 1, a) return a();
    } finally{
        $bf74d58b74973e6b$var$C = d, $bf74d58b74973e6b$var$ok.transition = c, $bf74d58b74973e6b$var$K = b, 0 === ($bf74d58b74973e6b$var$K & 6) && $bf74d58b74973e6b$var$jg();
    }
}
function $bf74d58b74973e6b$var$Hj() {
    $bf74d58b74973e6b$var$fj = $bf74d58b74973e6b$var$ej.current;
    $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$ej);
}
function $bf74d58b74973e6b$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $bf74d58b74973e6b$var$Gf(c));
    if (null !== $bf74d58b74973e6b$var$Y) for(c = $bf74d58b74973e6b$var$Y.return; null !== c;){
        var d = c;
        $bf74d58b74973e6b$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $bf74d58b74973e6b$var$$f();
                break;
            case 3:
                $bf74d58b74973e6b$var$zh();
                $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$Wf);
                $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$H);
                $bf74d58b74973e6b$var$Eh();
                break;
            case 5:
                $bf74d58b74973e6b$var$Bh(d);
                break;
            case 4:
                $bf74d58b74973e6b$var$zh();
                break;
            case 13:
                $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$L);
                break;
            case 19:
                $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$L);
                break;
            case 10:
                $bf74d58b74973e6b$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $bf74d58b74973e6b$var$Hj();
        }
        c = c.return;
    }
    $bf74d58b74973e6b$var$Q = a;
    $bf74d58b74973e6b$var$Y = a = $bf74d58b74973e6b$var$Pg(a.current, null);
    $bf74d58b74973e6b$var$Z = $bf74d58b74973e6b$var$fj = b;
    $bf74d58b74973e6b$var$T = 0;
    $bf74d58b74973e6b$var$pk = null;
    $bf74d58b74973e6b$var$rk = $bf74d58b74973e6b$var$qk = $bf74d58b74973e6b$var$rh = 0;
    $bf74d58b74973e6b$var$tk = $bf74d58b74973e6b$var$sk = null;
    if (null !== $bf74d58b74973e6b$var$fh) {
        for(b = 0; b < $bf74d58b74973e6b$var$fh.length; b++)if (c = $bf74d58b74973e6b$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $bf74d58b74973e6b$var$fh = null;
    }
    return a;
}
function $bf74d58b74973e6b$var$Mk(a, b) {
    do {
        var c = $bf74d58b74973e6b$var$Y;
        try {
            $bf74d58b74973e6b$var$$g();
            $bf74d58b74973e6b$var$Fh.current = $bf74d58b74973e6b$var$Rh;
            if ($bf74d58b74973e6b$var$Ih) {
                for(var d = $bf74d58b74973e6b$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $bf74d58b74973e6b$var$Ih = !1;
            }
            $bf74d58b74973e6b$var$Hh = 0;
            $bf74d58b74973e6b$var$O = $bf74d58b74973e6b$var$N = $bf74d58b74973e6b$var$M = null;
            $bf74d58b74973e6b$var$Jh = !1;
            $bf74d58b74973e6b$var$Kh = 0;
            $bf74d58b74973e6b$var$nk.current = null;
            if (null === c || null === c.return) {
                $bf74d58b74973e6b$var$T = 1;
                $bf74d58b74973e6b$var$pk = b;
                $bf74d58b74973e6b$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $bf74d58b74973e6b$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === (typeof k === "undefined" ? "undefined" : (0, $5djcY._)(k)) && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $bf74d58b74973e6b$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $bf74d58b74973e6b$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $bf74d58b74973e6b$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $bf74d58b74973e6b$var$Si(f, l, b);
                            $bf74d58b74973e6b$var$tj();
                            break a;
                        }
                        k = Error($bf74d58b74973e6b$var$p(426));
                    }
                } else if ($bf74d58b74973e6b$var$I && h.mode & 1) {
                    var J = $bf74d58b74973e6b$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $bf74d58b74973e6b$var$Vi(J, g, h, f, b);
                        $bf74d58b74973e6b$var$Jg($bf74d58b74973e6b$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $bf74d58b74973e6b$var$Ji(k, h);
                4 !== $bf74d58b74973e6b$var$T && ($bf74d58b74973e6b$var$T = 2);
                null === $bf74d58b74973e6b$var$sk ? $bf74d58b74973e6b$var$sk = [
                    f
                ] : $bf74d58b74973e6b$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $bf74d58b74973e6b$var$Ni(f, k, b);
                            $bf74d58b74973e6b$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $bf74d58b74973e6b$var$Ri || !$bf74d58b74973e6b$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $bf74d58b74973e6b$var$Qi(f, h, b);
                                $bf74d58b74973e6b$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $bf74d58b74973e6b$var$Sk(c);
        } catch (na) {
            b = na;
            $bf74d58b74973e6b$var$Y === c && null !== c && ($bf74d58b74973e6b$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $bf74d58b74973e6b$var$Jk() {
    var a = $bf74d58b74973e6b$var$mk.current;
    $bf74d58b74973e6b$var$mk.current = $bf74d58b74973e6b$var$Rh;
    return null === a ? $bf74d58b74973e6b$var$Rh : a;
}
function $bf74d58b74973e6b$var$tj() {
    if (0 === $bf74d58b74973e6b$var$T || 3 === $bf74d58b74973e6b$var$T || 2 === $bf74d58b74973e6b$var$T) $bf74d58b74973e6b$var$T = 4;
    null === $bf74d58b74973e6b$var$Q || 0 === ($bf74d58b74973e6b$var$rh & 268435455) && 0 === ($bf74d58b74973e6b$var$qk & 268435455) || $bf74d58b74973e6b$var$Ck($bf74d58b74973e6b$var$Q, $bf74d58b74973e6b$var$Z);
}
function $bf74d58b74973e6b$var$Ik(a, b) {
    var c = $bf74d58b74973e6b$var$K;
    $bf74d58b74973e6b$var$K |= 2;
    var d = $bf74d58b74973e6b$var$Jk();
    if ($bf74d58b74973e6b$var$Q !== a || $bf74d58b74973e6b$var$Z !== b) $bf74d58b74973e6b$var$uk = null, $bf74d58b74973e6b$var$Kk(a, b);
    for(;;)try {
        $bf74d58b74973e6b$var$Tk();
        break;
    } catch (e) {
        $bf74d58b74973e6b$var$Mk(a, e);
    }
    $bf74d58b74973e6b$var$$g();
    $bf74d58b74973e6b$var$K = c;
    $bf74d58b74973e6b$var$mk.current = d;
    if (null !== $bf74d58b74973e6b$var$Y) throw Error($bf74d58b74973e6b$var$p(261));
    $bf74d58b74973e6b$var$Q = null;
    $bf74d58b74973e6b$var$Z = 0;
    return $bf74d58b74973e6b$var$T;
}
function $bf74d58b74973e6b$var$Tk() {
    for(; null !== $bf74d58b74973e6b$var$Y;)$bf74d58b74973e6b$var$Uk($bf74d58b74973e6b$var$Y);
}
function $bf74d58b74973e6b$var$Lk() {
    for(; null !== $bf74d58b74973e6b$var$Y && !$bf74d58b74973e6b$var$cc();)$bf74d58b74973e6b$var$Uk($bf74d58b74973e6b$var$Y);
}
function $bf74d58b74973e6b$var$Uk(a) {
    var b = $bf74d58b74973e6b$var$Vk(a.alternate, a, $bf74d58b74973e6b$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $bf74d58b74973e6b$var$Sk(a) : $bf74d58b74973e6b$var$Y = b;
    $bf74d58b74973e6b$var$nk.current = null;
}
function $bf74d58b74973e6b$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $bf74d58b74973e6b$var$Ej(c, b, $bf74d58b74973e6b$var$fj), null !== c) {
                $bf74d58b74973e6b$var$Y = c;
                return;
            }
        } else {
            c = $bf74d58b74973e6b$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $bf74d58b74973e6b$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $bf74d58b74973e6b$var$T = 6;
                $bf74d58b74973e6b$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $bf74d58b74973e6b$var$Y = b;
            return;
        }
        $bf74d58b74973e6b$var$Y = b = a;
    }while (null !== b);
    0 === $bf74d58b74973e6b$var$T && ($bf74d58b74973e6b$var$T = 5);
}
function $bf74d58b74973e6b$var$Pk(a, b, c) {
    var d = $bf74d58b74973e6b$var$C, e = $bf74d58b74973e6b$var$ok.transition;
    try {
        $bf74d58b74973e6b$var$ok.transition = null, $bf74d58b74973e6b$var$C = 1, $bf74d58b74973e6b$var$Wk(a, b, c, d);
    } finally{
        $bf74d58b74973e6b$var$ok.transition = e, $bf74d58b74973e6b$var$C = d;
    }
    return null;
}
function $bf74d58b74973e6b$var$Wk(a, b, c, d) {
    do $bf74d58b74973e6b$var$Hk();
    while (null !== $bf74d58b74973e6b$var$wk);
    if (0 !== ($bf74d58b74973e6b$var$K & 6)) throw Error($bf74d58b74973e6b$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($bf74d58b74973e6b$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $bf74d58b74973e6b$var$Bc(a, f);
    a === $bf74d58b74973e6b$var$Q && ($bf74d58b74973e6b$var$Y = $bf74d58b74973e6b$var$Q = null, $bf74d58b74973e6b$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $bf74d58b74973e6b$var$vk || ($bf74d58b74973e6b$var$vk = !0, $bf74d58b74973e6b$var$Fk($bf74d58b74973e6b$var$hc, function() {
        $bf74d58b74973e6b$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $bf74d58b74973e6b$var$ok.transition;
        $bf74d58b74973e6b$var$ok.transition = null;
        var g = $bf74d58b74973e6b$var$C;
        $bf74d58b74973e6b$var$C = 1;
        var h = $bf74d58b74973e6b$var$K;
        $bf74d58b74973e6b$var$K |= 4;
        $bf74d58b74973e6b$var$nk.current = null;
        $bf74d58b74973e6b$var$Oj(a, c);
        $bf74d58b74973e6b$var$dk(c, a);
        $bf74d58b74973e6b$var$Oe($bf74d58b74973e6b$var$Df);
        $bf74d58b74973e6b$var$dd = !!$bf74d58b74973e6b$var$Cf;
        $bf74d58b74973e6b$var$Df = $bf74d58b74973e6b$var$Cf = null;
        a.current = c;
        $bf74d58b74973e6b$var$hk(c, a, e);
        $bf74d58b74973e6b$var$dc();
        $bf74d58b74973e6b$var$K = h;
        $bf74d58b74973e6b$var$C = g;
        $bf74d58b74973e6b$var$ok.transition = f;
    } else a.current = c;
    $bf74d58b74973e6b$var$vk && ($bf74d58b74973e6b$var$vk = !1, $bf74d58b74973e6b$var$wk = a, $bf74d58b74973e6b$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($bf74d58b74973e6b$var$Ri = null);
    $bf74d58b74973e6b$var$mc(c.stateNode, d);
    $bf74d58b74973e6b$var$Dk(a, $bf74d58b74973e6b$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($bf74d58b74973e6b$var$Oi) throw $bf74d58b74973e6b$var$Oi = !1, a = $bf74d58b74973e6b$var$Pi, $bf74d58b74973e6b$var$Pi = null, a;
    0 !== ($bf74d58b74973e6b$var$xk & 1) && 0 !== a.tag && $bf74d58b74973e6b$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $bf74d58b74973e6b$var$zk ? $bf74d58b74973e6b$var$yk++ : ($bf74d58b74973e6b$var$yk = 0, $bf74d58b74973e6b$var$zk = a) : $bf74d58b74973e6b$var$yk = 0;
    $bf74d58b74973e6b$var$jg();
    return null;
}
function $bf74d58b74973e6b$var$Hk() {
    if (null !== $bf74d58b74973e6b$var$wk) {
        var a = $bf74d58b74973e6b$var$Dc($bf74d58b74973e6b$var$xk), b = $bf74d58b74973e6b$var$ok.transition, c = $bf74d58b74973e6b$var$C;
        try {
            $bf74d58b74973e6b$var$ok.transition = null;
            $bf74d58b74973e6b$var$C = 16 > a ? 16 : a;
            if (null === $bf74d58b74973e6b$var$wk) var d = !1;
            else {
                a = $bf74d58b74973e6b$var$wk;
                $bf74d58b74973e6b$var$wk = null;
                $bf74d58b74973e6b$var$xk = 0;
                if (0 !== ($bf74d58b74973e6b$var$K & 6)) throw Error($bf74d58b74973e6b$var$p(331));
                var e = $bf74d58b74973e6b$var$K;
                $bf74d58b74973e6b$var$K |= 4;
                for($bf74d58b74973e6b$var$V = a.current; null !== $bf74d58b74973e6b$var$V;){
                    var f = $bf74d58b74973e6b$var$V, g = f.child;
                    if (0 !== ($bf74d58b74973e6b$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($bf74d58b74973e6b$var$V = l; null !== $bf74d58b74973e6b$var$V;){
                                    var m = $bf74d58b74973e6b$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $bf74d58b74973e6b$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $bf74d58b74973e6b$var$V = q;
                                    else for(; null !== $bf74d58b74973e6b$var$V;){
                                        m = $bf74d58b74973e6b$var$V;
                                        var r = m.sibling, y = m.return;
                                        $bf74d58b74973e6b$var$Sj(m);
                                        if (m === l) {
                                            $bf74d58b74973e6b$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $bf74d58b74973e6b$var$V = r;
                                            break;
                                        }
                                        $bf74d58b74973e6b$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $bf74d58b74973e6b$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $bf74d58b74973e6b$var$V = g;
                    else b: for(; null !== $bf74d58b74973e6b$var$V;){
                        f = $bf74d58b74973e6b$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $bf74d58b74973e6b$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $bf74d58b74973e6b$var$V = x;
                            break b;
                        }
                        $bf74d58b74973e6b$var$V = f.return;
                    }
                }
                var w = a.current;
                for($bf74d58b74973e6b$var$V = w; null !== $bf74d58b74973e6b$var$V;){
                    g = $bf74d58b74973e6b$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $bf74d58b74973e6b$var$V = u;
                    else b: for(g = w; null !== $bf74d58b74973e6b$var$V;){
                        h = $bf74d58b74973e6b$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $bf74d58b74973e6b$var$Qj(9, h);
                            }
                        } catch (na) {
                            $bf74d58b74973e6b$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $bf74d58b74973e6b$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $bf74d58b74973e6b$var$V = F;
                            break b;
                        }
                        $bf74d58b74973e6b$var$V = h.return;
                    }
                }
                $bf74d58b74973e6b$var$K = e;
                $bf74d58b74973e6b$var$jg();
                if ($bf74d58b74973e6b$var$lc && "function" === typeof $bf74d58b74973e6b$var$lc.onPostCommitFiberRoot) try {
                    $bf74d58b74973e6b$var$lc.onPostCommitFiberRoot($bf74d58b74973e6b$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $bf74d58b74973e6b$var$C = c, $bf74d58b74973e6b$var$ok.transition = b;
        }
    }
    return !1;
}
function $bf74d58b74973e6b$var$Xk(a, b, c) {
    b = $bf74d58b74973e6b$var$Ji(c, b);
    b = $bf74d58b74973e6b$var$Ni(a, b, 1);
    a = $bf74d58b74973e6b$var$nh(a, b, 1);
    b = $bf74d58b74973e6b$var$R();
    null !== a && ($bf74d58b74973e6b$var$Ac(a, 1, b), $bf74d58b74973e6b$var$Dk(a, b));
}
function $bf74d58b74973e6b$var$W(a, b, c) {
    if (3 === a.tag) $bf74d58b74973e6b$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $bf74d58b74973e6b$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $bf74d58b74973e6b$var$Ri || !$bf74d58b74973e6b$var$Ri.has(d))) {
                a = $bf74d58b74973e6b$var$Ji(c, a);
                a = $bf74d58b74973e6b$var$Qi(b, a, 1);
                b = $bf74d58b74973e6b$var$nh(b, a, 1);
                a = $bf74d58b74973e6b$var$R();
                null !== b && ($bf74d58b74973e6b$var$Ac(b, 1, a), $bf74d58b74973e6b$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $bf74d58b74973e6b$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $bf74d58b74973e6b$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $bf74d58b74973e6b$var$Q === a && ($bf74d58b74973e6b$var$Z & c) === c && (4 === $bf74d58b74973e6b$var$T || 3 === $bf74d58b74973e6b$var$T && ($bf74d58b74973e6b$var$Z & 130023424) === $bf74d58b74973e6b$var$Z && 500 > $bf74d58b74973e6b$var$B() - $bf74d58b74973e6b$var$fk ? $bf74d58b74973e6b$var$Kk(a, 0) : $bf74d58b74973e6b$var$rk |= c);
    $bf74d58b74973e6b$var$Dk(a, b);
}
function $bf74d58b74973e6b$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $bf74d58b74973e6b$var$sc, $bf74d58b74973e6b$var$sc <<= 1, 0 === ($bf74d58b74973e6b$var$sc & 130023424) && ($bf74d58b74973e6b$var$sc = 4194304)));
    var c = $bf74d58b74973e6b$var$R();
    a = $bf74d58b74973e6b$var$ih(a, b);
    null !== a && ($bf74d58b74973e6b$var$Ac(a, b, c), $bf74d58b74973e6b$var$Dk(a, c));
}
function $bf74d58b74973e6b$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $bf74d58b74973e6b$var$Yk(a, c);
}
function $bf74d58b74973e6b$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($bf74d58b74973e6b$var$p(314));
    }
    null !== d && d.delete(b);
    $bf74d58b74973e6b$var$Yk(a, c);
}
var $bf74d58b74973e6b$var$Vk;
$bf74d58b74973e6b$var$Vk = function Vk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $bf74d58b74973e6b$var$Wf.current) $bf74d58b74973e6b$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $bf74d58b74973e6b$var$dh = !1, $bf74d58b74973e6b$var$yj(a, b, c);
            $bf74d58b74973e6b$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $bf74d58b74973e6b$var$dh = !1, $bf74d58b74973e6b$var$I && 0 !== (b.flags & 1048576) && $bf74d58b74973e6b$var$ug(b, $bf74d58b74973e6b$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $bf74d58b74973e6b$var$ij(a, b);
            a = b.pendingProps;
            var e = $bf74d58b74973e6b$var$Yf(b, $bf74d58b74973e6b$var$H.current);
            $bf74d58b74973e6b$var$ch(b, c);
            e = $bf74d58b74973e6b$var$Nh(null, b, d, a, e, c);
            var f = $bf74d58b74973e6b$var$Sh();
            b.flags |= 1;
            "object" === (typeof e === "undefined" ? "undefined" : (0, $5djcY._)(e)) && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $bf74d58b74973e6b$var$Zf(d) ? (f = !0, $bf74d58b74973e6b$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $bf74d58b74973e6b$var$kh(b), e.updater = $bf74d58b74973e6b$var$Ei, b.stateNode = e, e._reactInternals = b, $bf74d58b74973e6b$var$Ii(b, d, a, c), b = $bf74d58b74973e6b$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $bf74d58b74973e6b$var$I && f && $bf74d58b74973e6b$var$vg(b), $bf74d58b74973e6b$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $bf74d58b74973e6b$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $bf74d58b74973e6b$var$Zk(d);
                a = $bf74d58b74973e6b$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $bf74d58b74973e6b$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $bf74d58b74973e6b$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $bf74d58b74973e6b$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $bf74d58b74973e6b$var$$i(null, b, d, $bf74d58b74973e6b$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($bf74d58b74973e6b$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bf74d58b74973e6b$var$Ci(d, e), $bf74d58b74973e6b$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bf74d58b74973e6b$var$Ci(d, e), $bf74d58b74973e6b$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $bf74d58b74973e6b$var$kj(b);
                if (null === a) throw Error($bf74d58b74973e6b$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $bf74d58b74973e6b$var$lh(a, b);
                $bf74d58b74973e6b$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $bf74d58b74973e6b$var$Ji(Error($bf74d58b74973e6b$var$p(423)), b);
                        b = $bf74d58b74973e6b$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $bf74d58b74973e6b$var$Ji(Error($bf74d58b74973e6b$var$p(424)), b);
                        b = $bf74d58b74973e6b$var$lj(a, b, d, c, e);
                        break a;
                    } else for($bf74d58b74973e6b$var$yg = $bf74d58b74973e6b$var$Lf(b.stateNode.containerInfo.firstChild), $bf74d58b74973e6b$var$xg = b, $bf74d58b74973e6b$var$I = !0, $bf74d58b74973e6b$var$zg = null, c = $bf74d58b74973e6b$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $bf74d58b74973e6b$var$Ig();
                    if (d === e) {
                        b = $bf74d58b74973e6b$var$Zi(a, b, c);
                        break a;
                    }
                    $bf74d58b74973e6b$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $bf74d58b74973e6b$var$Ah(b), null === a && $bf74d58b74973e6b$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $bf74d58b74973e6b$var$Ef(d, e) ? g = null : null !== f && $bf74d58b74973e6b$var$Ef(d, f) && (b.flags |= 32), $bf74d58b74973e6b$var$gj(a, b), $bf74d58b74973e6b$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $bf74d58b74973e6b$var$Eg(b), null;
        case 13:
            return $bf74d58b74973e6b$var$oj(a, b, c);
        case 4:
            return $bf74d58b74973e6b$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $bf74d58b74973e6b$var$Ug(b, null, d, c) : $bf74d58b74973e6b$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bf74d58b74973e6b$var$Ci(d, e), $bf74d58b74973e6b$var$Yi(a, b, d, e, c);
        case 7:
            return $bf74d58b74973e6b$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $bf74d58b74973e6b$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $bf74d58b74973e6b$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($bf74d58b74973e6b$var$He(f.value, g)) {
                        if (f.children === e.children && !$bf74d58b74973e6b$var$Wf.current) {
                            b = $bf74d58b74973e6b$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $bf74d58b74973e6b$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $bf74d58b74973e6b$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($bf74d58b74973e6b$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $bf74d58b74973e6b$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $bf74d58b74973e6b$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $bf74d58b74973e6b$var$ch(b, c), e = $bf74d58b74973e6b$var$eh(e), d = d(e), b.flags |= 1, $bf74d58b74973e6b$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $bf74d58b74973e6b$var$Ci(d, b.pendingProps), e = $bf74d58b74973e6b$var$Ci(d.type, e), $bf74d58b74973e6b$var$$i(a, b, d, e, c);
        case 15:
            return $bf74d58b74973e6b$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bf74d58b74973e6b$var$Ci(d, e), $bf74d58b74973e6b$var$ij(a, b), b.tag = 1, $bf74d58b74973e6b$var$Zf(d) ? (a = !0, $bf74d58b74973e6b$var$cg(b)) : a = !1, $bf74d58b74973e6b$var$ch(b, c), $bf74d58b74973e6b$var$Gi(b, d, e), $bf74d58b74973e6b$var$Ii(b, d, e, c), $bf74d58b74973e6b$var$jj(null, b, d, !0, a, c);
        case 19:
            return $bf74d58b74973e6b$var$xj(a, b, c);
        case 22:
            return $bf74d58b74973e6b$var$dj(a, b, c);
    }
    throw Error($bf74d58b74973e6b$var$p(156, b.tag));
};
function $bf74d58b74973e6b$var$Fk(a, b) {
    return $bf74d58b74973e6b$var$ac(a, b);
}
function $bf74d58b74973e6b$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $bf74d58b74973e6b$var$Bg(a, b, c, d) {
    return new $bf74d58b74973e6b$var$$k(a, b, c, d);
}
function $bf74d58b74973e6b$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $bf74d58b74973e6b$var$Zk(a) {
    if ("function" === typeof a) return $bf74d58b74973e6b$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $bf74d58b74973e6b$var$Da) return 11;
        if (a === $bf74d58b74973e6b$var$Ga) return 14;
    }
    return 2;
}
function $bf74d58b74973e6b$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $bf74d58b74973e6b$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $bf74d58b74973e6b$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $bf74d58b74973e6b$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $bf74d58b74973e6b$var$ya:
            return $bf74d58b74973e6b$var$Tg(c.children, e, f, b);
        case $bf74d58b74973e6b$var$za:
            g = 8;
            e |= 8;
            break;
        case $bf74d58b74973e6b$var$Aa:
            return a = $bf74d58b74973e6b$var$Bg(12, c, b, e | 2), a.elementType = $bf74d58b74973e6b$var$Aa, a.lanes = f, a;
        case $bf74d58b74973e6b$var$Ea:
            return a = $bf74d58b74973e6b$var$Bg(13, c, b, e), a.elementType = $bf74d58b74973e6b$var$Ea, a.lanes = f, a;
        case $bf74d58b74973e6b$var$Fa:
            return a = $bf74d58b74973e6b$var$Bg(19, c, b, e), a.elementType = $bf74d58b74973e6b$var$Fa, a.lanes = f, a;
        case $bf74d58b74973e6b$var$Ia:
            return $bf74d58b74973e6b$var$pj(c, e, f, b);
        default:
            if ("object" === (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a)) && null !== a) switch(a.$$typeof){
                case $bf74d58b74973e6b$var$Ba:
                    g = 10;
                    break a;
                case $bf74d58b74973e6b$var$Ca:
                    g = 9;
                    break a;
                case $bf74d58b74973e6b$var$Da:
                    g = 11;
                    break a;
                case $bf74d58b74973e6b$var$Ga:
                    g = 14;
                    break a;
                case $bf74d58b74973e6b$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($bf74d58b74973e6b$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a), ""));
    }
    b = $bf74d58b74973e6b$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $bf74d58b74973e6b$var$Tg(a, b, c, d) {
    a = $bf74d58b74973e6b$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $bf74d58b74973e6b$var$pj(a, b, c, d) {
    a = $bf74d58b74973e6b$var$Bg(22, a, d, b);
    a.elementType = $bf74d58b74973e6b$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $bf74d58b74973e6b$var$Qg(a, b, c) {
    a = $bf74d58b74973e6b$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $bf74d58b74973e6b$var$Sg(a, b, c) {
    b = $bf74d58b74973e6b$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $bf74d58b74973e6b$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $bf74d58b74973e6b$var$zc(0);
    this.expirationTimes = $bf74d58b74973e6b$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $bf74d58b74973e6b$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $bf74d58b74973e6b$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $bf74d58b74973e6b$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $bf74d58b74973e6b$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $bf74d58b74973e6b$var$kh(f);
    return a;
}
function $bf74d58b74973e6b$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $bf74d58b74973e6b$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $bf74d58b74973e6b$var$dl(a) {
    if (!a) return $bf74d58b74973e6b$var$Vf;
    a = a._reactInternals;
    a: {
        if ($bf74d58b74973e6b$var$Vb(a) !== a || 1 !== a.tag) throw Error($bf74d58b74973e6b$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($bf74d58b74973e6b$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($bf74d58b74973e6b$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($bf74d58b74973e6b$var$Zf(c)) return $bf74d58b74973e6b$var$bg(a, c, b);
    }
    return b;
}
function $bf74d58b74973e6b$var$el(a, b, c, d, e, f, g, h, k) {
    a = $bf74d58b74973e6b$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $bf74d58b74973e6b$var$dl(null);
    c = a.current;
    d = $bf74d58b74973e6b$var$R();
    e = $bf74d58b74973e6b$var$yi(c);
    f = $bf74d58b74973e6b$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $bf74d58b74973e6b$var$nh(c, f, e);
    a.current.lanes = e;
    $bf74d58b74973e6b$var$Ac(a, e, d);
    $bf74d58b74973e6b$var$Dk(a, d);
    return a;
}
function $bf74d58b74973e6b$var$fl(a, b, c, d) {
    var e = b.current, f = $bf74d58b74973e6b$var$R(), g = $bf74d58b74973e6b$var$yi(e);
    c = $bf74d58b74973e6b$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $bf74d58b74973e6b$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $bf74d58b74973e6b$var$nh(e, b, g);
    null !== a && ($bf74d58b74973e6b$var$gi(a, e, g, f), $bf74d58b74973e6b$var$oh(a, e, g));
    return g;
}
function $bf74d58b74973e6b$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $bf74d58b74973e6b$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $bf74d58b74973e6b$var$il(a, b) {
    $bf74d58b74973e6b$var$hl(a, b);
    (a = a.alternate) && $bf74d58b74973e6b$var$hl(a, b);
}
function $bf74d58b74973e6b$var$jl() {
    return null;
}
var $bf74d58b74973e6b$var$kl = "function" === typeof reportError ? reportError : function kl(a) {
    console.error(a);
};
function $bf74d58b74973e6b$var$ll(a) {
    this._internalRoot = a;
}
$bf74d58b74973e6b$var$ml.prototype.render = $bf74d58b74973e6b$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($bf74d58b74973e6b$var$p(409));
    $bf74d58b74973e6b$var$fl(a, b, null, null);
};
$bf74d58b74973e6b$var$ml.prototype.unmount = $bf74d58b74973e6b$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $bf74d58b74973e6b$var$Rk(function() {
            $bf74d58b74973e6b$var$fl(null, a, null, null);
        });
        b[$bf74d58b74973e6b$var$uf] = null;
    }
};
function $bf74d58b74973e6b$var$ml(a) {
    this._internalRoot = a;
}
$bf74d58b74973e6b$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $bf74d58b74973e6b$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $bf74d58b74973e6b$var$Qc.length && 0 !== b && b < $bf74d58b74973e6b$var$Qc[c].priority; c++);
        $bf74d58b74973e6b$var$Qc.splice(c, 0, a);
        0 === c && $bf74d58b74973e6b$var$Vc(a);
    }
};
function $bf74d58b74973e6b$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $bf74d58b74973e6b$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $bf74d58b74973e6b$var$pl() {}
function $bf74d58b74973e6b$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $bf74d58b74973e6b$var$gl(g);
                f.call(_$a);
            };
        }
        var g = $bf74d58b74973e6b$var$el(b, d, a, 0, null, !1, !1, "", $bf74d58b74973e6b$var$pl);
        a._reactRootContainer = g;
        a[$bf74d58b74973e6b$var$uf] = g.current;
        $bf74d58b74973e6b$var$sf(8 === a.nodeType ? a.parentNode : a);
        $bf74d58b74973e6b$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $bf74d58b74973e6b$var$gl(k);
            h.call(_$a);
        };
    }
    var k = $bf74d58b74973e6b$var$bl(a, 0, !1, null, null, !1, !1, "", $bf74d58b74973e6b$var$pl);
    a._reactRootContainer = k;
    a[$bf74d58b74973e6b$var$uf] = k.current;
    $bf74d58b74973e6b$var$sf(8 === a.nodeType ? a.parentNode : a);
    $bf74d58b74973e6b$var$Rk(function() {
        $bf74d58b74973e6b$var$fl(b, k, c, d);
    });
    return k;
}
function $bf74d58b74973e6b$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $bf74d58b74973e6b$var$gl(g);
                h.call(_$a);
            };
        }
        $bf74d58b74973e6b$var$fl(b, g, a, e);
    } else g = $bf74d58b74973e6b$var$ql(c, b, a, e, d);
    return $bf74d58b74973e6b$var$gl(g);
}
$bf74d58b74973e6b$var$Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $bf74d58b74973e6b$var$tc(b.pendingLanes);
                0 !== c && ($bf74d58b74973e6b$var$Cc(b, c | 1), $bf74d58b74973e6b$var$Dk(b, $bf74d58b74973e6b$var$B()), 0 === ($bf74d58b74973e6b$var$K & 6) && ($bf74d58b74973e6b$var$Gj = $bf74d58b74973e6b$var$B() + 500, $bf74d58b74973e6b$var$jg()));
            }
            break;
        case 13:
            $bf74d58b74973e6b$var$Rk(function() {
                var b = $bf74d58b74973e6b$var$ih(a, 1);
                if (null !== b) {
                    var c = $bf74d58b74973e6b$var$R();
                    $bf74d58b74973e6b$var$gi(b, a, 1, c);
                }
            }), $bf74d58b74973e6b$var$il(a, 1);
    }
};
$bf74d58b74973e6b$var$Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = $bf74d58b74973e6b$var$ih(a, 134217728);
        if (null !== b) {
            var c = $bf74d58b74973e6b$var$R();
            $bf74d58b74973e6b$var$gi(b, a, 134217728, c);
        }
        $bf74d58b74973e6b$var$il(a, 134217728);
    }
};
$bf74d58b74973e6b$var$Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = $bf74d58b74973e6b$var$yi(a), c = $bf74d58b74973e6b$var$ih(a, b);
        if (null !== c) {
            var d = $bf74d58b74973e6b$var$R();
            $bf74d58b74973e6b$var$gi(c, a, b, d);
        }
        $bf74d58b74973e6b$var$il(a, b);
    }
};
$bf74d58b74973e6b$var$Hc = function Hc() {
    return $bf74d58b74973e6b$var$C;
};
$bf74d58b74973e6b$var$Ic = function Ic(a, b) {
    var c = $bf74d58b74973e6b$var$C;
    try {
        return $bf74d58b74973e6b$var$C = a, b();
    } finally{
        $bf74d58b74973e6b$var$C = c;
    }
};
$bf74d58b74973e6b$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $bf74d58b74973e6b$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $bf74d58b74973e6b$var$Db(d);
                        if (!e) throw Error($bf74d58b74973e6b$var$p(90));
                        $bf74d58b74973e6b$var$Wa(d);
                        $bf74d58b74973e6b$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $bf74d58b74973e6b$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $bf74d58b74973e6b$var$fb(a, !!c.multiple, b, !1);
    }
};
$bf74d58b74973e6b$var$Gb = $bf74d58b74973e6b$var$Qk;
$bf74d58b74973e6b$var$Hb = $bf74d58b74973e6b$var$Rk;
var $bf74d58b74973e6b$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $bf74d58b74973e6b$var$Cb,
        $bf74d58b74973e6b$var$ue,
        $bf74d58b74973e6b$var$Db,
        $bf74d58b74973e6b$var$Eb,
        $bf74d58b74973e6b$var$Fb,
        $bf74d58b74973e6b$var$Qk
    ]
}, $bf74d58b74973e6b$var$tl = {
    findFiberByHostInstance: $bf74d58b74973e6b$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $bf74d58b74973e6b$var$ul = {
    bundleType: $bf74d58b74973e6b$var$tl.bundleType,
    version: $bf74d58b74973e6b$var$tl.version,
    rendererPackageName: $bf74d58b74973e6b$var$tl.rendererPackageName,
    rendererConfig: $bf74d58b74973e6b$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $bf74d58b74973e6b$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $bf74d58b74973e6b$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $bf74d58b74973e6b$var$tl.findFiberByHostInstance || $bf74d58b74973e6b$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $bf74d58b74973e6b$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$bf74d58b74973e6b$var$vl.isDisabled && $bf74d58b74973e6b$var$vl.supportsFiber) try {
        $bf74d58b74973e6b$var$kc = $bf74d58b74973e6b$var$vl.inject($bf74d58b74973e6b$var$ul), $bf74d58b74973e6b$var$lc = $bf74d58b74973e6b$var$vl;
    } catch (a) {}
}
$bf74d58b74973e6b$export$ae55be85d98224ed = $bf74d58b74973e6b$var$sl;
$bf74d58b74973e6b$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$bf74d58b74973e6b$var$nl(b)) throw Error($bf74d58b74973e6b$var$p(200));
    return $bf74d58b74973e6b$var$cl(a, b, null, c);
};
$bf74d58b74973e6b$export$882461b6382ed46c = function(a, b) {
    if (!$bf74d58b74973e6b$var$nl(a)) throw Error($bf74d58b74973e6b$var$p(299));
    var c = !1, d = "", e = $bf74d58b74973e6b$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $bf74d58b74973e6b$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$bf74d58b74973e6b$var$uf] = b.current;
    $bf74d58b74973e6b$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $bf74d58b74973e6b$var$ll(b);
};
$bf74d58b74973e6b$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($bf74d58b74973e6b$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($bf74d58b74973e6b$var$p(268, a));
    }
    a = $bf74d58b74973e6b$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$bf74d58b74973e6b$export$cd75ccfd720a3cd4 = function(a) {
    return $bf74d58b74973e6b$var$Rk(a);
};
$bf74d58b74973e6b$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$bf74d58b74973e6b$var$ol(b)) throw Error($bf74d58b74973e6b$var$p(200));
    return $bf74d58b74973e6b$var$rl(null, a, b, !0, c);
};
$bf74d58b74973e6b$export$757ceba2d55c277e = function(a, b, c) {
    if (!$bf74d58b74973e6b$var$nl(a)) throw Error($bf74d58b74973e6b$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $bf74d58b74973e6b$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $bf74d58b74973e6b$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$bf74d58b74973e6b$var$uf] = b.current;
    $bf74d58b74973e6b$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $bf74d58b74973e6b$var$ml(b);
};
$bf74d58b74973e6b$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$bf74d58b74973e6b$var$ol(b)) throw Error($bf74d58b74973e6b$var$p(200));
    return $bf74d58b74973e6b$var$rl(null, a, b, !1, c);
};
$bf74d58b74973e6b$export$502457920280e6be = function(a) {
    if (!$bf74d58b74973e6b$var$ol(a)) throw Error($bf74d58b74973e6b$var$p(40));
    return a._reactRootContainer ? ($bf74d58b74973e6b$var$Rk(function() {
        $bf74d58b74973e6b$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$bf74d58b74973e6b$var$uf] = null;
        });
    }), !0) : !1;
};
$bf74d58b74973e6b$export$c78a37762a8d58e1 = $bf74d58b74973e6b$var$Qk;
$bf74d58b74973e6b$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$bf74d58b74973e6b$var$ol(c)) throw Error($bf74d58b74973e6b$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($bf74d58b74973e6b$var$p(38));
    return $bf74d58b74973e6b$var$rl(a, b, c, !1, d);
};
$bf74d58b74973e6b$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("ojHeY", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5wZqJ"));

});
parcelRegister("5wZqJ", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $406f97a93edc2f95$export$c4744153514ff05d; }, function (v) { return $406f97a93edc2f95$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $406f97a93edc2f95$export$3e506c1ccc9cc1a7; }, function (v) { return $406f97a93edc2f95$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $406f97a93edc2f95$export$e26fe2ed2fa76875; }, function (v) { return $406f97a93edc2f95$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $406f97a93edc2f95$export$502329bbf4b505b1; }, function (v) { return $406f97a93edc2f95$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $406f97a93edc2f95$export$6e3807111c4874c4; }, function (v) { return $406f97a93edc2f95$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $406f97a93edc2f95$export$c27134553091fb3a; }, function (v) { return $406f97a93edc2f95$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $406f97a93edc2f95$export$33ee1acdc04fd2a2; }, function (v) { return $406f97a93edc2f95$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $406f97a93edc2f95$export$b00a404bbd5edef2; }, function (v) { return $406f97a93edc2f95$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $406f97a93edc2f95$export$8352ce38b91d0c62; }, function (v) { return $406f97a93edc2f95$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $406f97a93edc2f95$export$d66a1c1c77bd778b; }, function (v) { return $406f97a93edc2f95$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $406f97a93edc2f95$export$d3dfb8e4810cb555; }, function (v) { return $406f97a93edc2f95$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $406f97a93edc2f95$export$839f9183b0465a69; }, function (v) { return $406f97a93edc2f95$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $406f97a93edc2f95$export$72fdf0e06517287b; }, function (v) { return $406f97a93edc2f95$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $406f97a93edc2f95$export$4b844e58a3e414b4; }, function (v) { return $406f97a93edc2f95$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $406f97a93edc2f95$export$816d2913ae6b83b1; }, function (v) { return $406f97a93edc2f95$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $406f97a93edc2f95$export$61bcfe829111a1d0; }, function (v) { return $406f97a93edc2f95$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $406f97a93edc2f95$export$7ee8c9beb337bc3f; }, function (v) { return $406f97a93edc2f95$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $406f97a93edc2f95$export$b5836b71941fa3ed; }, function (v) { return $406f97a93edc2f95$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $406f97a93edc2f95$export$cf845f2c119da08a; }, function (v) { return $406f97a93edc2f95$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $5djcY = parcelRequire("5djcY");
var $406f97a93edc2f95$export$c4744153514ff05d;
var $406f97a93edc2f95$export$3e506c1ccc9cc1a7;
var $406f97a93edc2f95$export$e26fe2ed2fa76875;
var $406f97a93edc2f95$export$502329bbf4b505b1;
var $406f97a93edc2f95$export$6e3807111c4874c4;
var $406f97a93edc2f95$export$c27134553091fb3a;
var $406f97a93edc2f95$export$33ee1acdc04fd2a2;
var $406f97a93edc2f95$export$b00a404bbd5edef2;
var $406f97a93edc2f95$export$8352ce38b91d0c62;
var $406f97a93edc2f95$export$d66a1c1c77bd778b;
var $406f97a93edc2f95$export$d3dfb8e4810cb555;
var $406f97a93edc2f95$export$839f9183b0465a69;
var $406f97a93edc2f95$export$72fdf0e06517287b;
var $406f97a93edc2f95$export$4b844e58a3e414b4;
var $406f97a93edc2f95$export$816d2913ae6b83b1;
var $406f97a93edc2f95$export$61bcfe829111a1d0;
var $406f97a93edc2f95$export$7ee8c9beb337bc3f;
var $406f97a93edc2f95$export$b5836b71941fa3ed;
var $406f97a93edc2f95$export$cf845f2c119da08a;
'use strict';
function $406f97a93edc2f95$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $406f97a93edc2f95$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $406f97a93edc2f95$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $406f97a93edc2f95$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $406f97a93edc2f95$var$g(C, c)) n < e && 0 > $406f97a93edc2f95$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $406f97a93edc2f95$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $406f97a93edc2f95$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === (typeof performance === "undefined" ? "undefined" : (0, $5djcY._)(performance)) && "function" === typeof performance.now) {
    var $406f97a93edc2f95$var$l = performance;
    $406f97a93edc2f95$export$c4744153514ff05d = function() {
        return $406f97a93edc2f95$var$l.now();
    };
} else {
    var $406f97a93edc2f95$var$p = Date, $406f97a93edc2f95$var$q = $406f97a93edc2f95$var$p.now();
    $406f97a93edc2f95$export$c4744153514ff05d = function() {
        return $406f97a93edc2f95$var$p.now() - $406f97a93edc2f95$var$q;
    };
}
var $406f97a93edc2f95$var$r = [], $406f97a93edc2f95$var$t = [], $406f97a93edc2f95$var$u = 1, $406f97a93edc2f95$var$v = null, $406f97a93edc2f95$var$y = 3, $406f97a93edc2f95$var$z = !1, $406f97a93edc2f95$var$A = !1, $406f97a93edc2f95$var$B = !1, $406f97a93edc2f95$var$D = "function" === typeof setTimeout ? setTimeout : null, $406f97a93edc2f95$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $406f97a93edc2f95$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $406f97a93edc2f95$var$G(a) {
    for(var b = $406f97a93edc2f95$var$h($406f97a93edc2f95$var$t); null !== b;){
        if (null === b.callback) $406f97a93edc2f95$var$k($406f97a93edc2f95$var$t);
        else if (b.startTime <= a) $406f97a93edc2f95$var$k($406f97a93edc2f95$var$t), b.sortIndex = b.expirationTime, $406f97a93edc2f95$var$f($406f97a93edc2f95$var$r, b);
        else break;
        b = $406f97a93edc2f95$var$h($406f97a93edc2f95$var$t);
    }
}
function $406f97a93edc2f95$var$H(a) {
    $406f97a93edc2f95$var$B = !1;
    $406f97a93edc2f95$var$G(a);
    if (!$406f97a93edc2f95$var$A) {
        if (null !== $406f97a93edc2f95$var$h($406f97a93edc2f95$var$r)) $406f97a93edc2f95$var$A = !0, $406f97a93edc2f95$var$I($406f97a93edc2f95$var$J);
        else {
            var b = $406f97a93edc2f95$var$h($406f97a93edc2f95$var$t);
            null !== b && $406f97a93edc2f95$var$K($406f97a93edc2f95$var$H, b.startTime - a);
        }
    }
}
function $406f97a93edc2f95$var$J(a, b) {
    $406f97a93edc2f95$var$A = !1;
    $406f97a93edc2f95$var$B && ($406f97a93edc2f95$var$B = !1, $406f97a93edc2f95$var$E($406f97a93edc2f95$var$L), $406f97a93edc2f95$var$L = -1);
    $406f97a93edc2f95$var$z = !0;
    var c = $406f97a93edc2f95$var$y;
    try {
        $406f97a93edc2f95$var$G(b);
        for($406f97a93edc2f95$var$v = $406f97a93edc2f95$var$h($406f97a93edc2f95$var$r); null !== $406f97a93edc2f95$var$v && (!($406f97a93edc2f95$var$v.expirationTime > b) || a && !$406f97a93edc2f95$var$M());){
            var d = $406f97a93edc2f95$var$v.callback;
            if ("function" === typeof d) {
                $406f97a93edc2f95$var$v.callback = null;
                $406f97a93edc2f95$var$y = $406f97a93edc2f95$var$v.priorityLevel;
                var e = d($406f97a93edc2f95$var$v.expirationTime <= b);
                b = $406f97a93edc2f95$export$c4744153514ff05d();
                "function" === typeof e ? $406f97a93edc2f95$var$v.callback = e : $406f97a93edc2f95$var$v === $406f97a93edc2f95$var$h($406f97a93edc2f95$var$r) && $406f97a93edc2f95$var$k($406f97a93edc2f95$var$r);
                $406f97a93edc2f95$var$G(b);
            } else $406f97a93edc2f95$var$k($406f97a93edc2f95$var$r);
            $406f97a93edc2f95$var$v = $406f97a93edc2f95$var$h($406f97a93edc2f95$var$r);
        }
        if (null !== $406f97a93edc2f95$var$v) var w = !0;
        else {
            var m = $406f97a93edc2f95$var$h($406f97a93edc2f95$var$t);
            null !== m && $406f97a93edc2f95$var$K($406f97a93edc2f95$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $406f97a93edc2f95$var$v = null, $406f97a93edc2f95$var$y = c, $406f97a93edc2f95$var$z = !1;
    }
}
var $406f97a93edc2f95$var$N = !1, $406f97a93edc2f95$var$O = null, $406f97a93edc2f95$var$L = -1, $406f97a93edc2f95$var$P = 5, $406f97a93edc2f95$var$Q = -1;
function $406f97a93edc2f95$var$M() {
    return $406f97a93edc2f95$export$c4744153514ff05d() - $406f97a93edc2f95$var$Q < $406f97a93edc2f95$var$P ? !1 : !0;
}
function $406f97a93edc2f95$var$R() {
    if (null !== $406f97a93edc2f95$var$O) {
        var a = $406f97a93edc2f95$export$c4744153514ff05d();
        $406f97a93edc2f95$var$Q = a;
        var b = !0;
        try {
            b = $406f97a93edc2f95$var$O(!0, a);
        } finally{
            b ? $406f97a93edc2f95$var$S() : ($406f97a93edc2f95$var$N = !1, $406f97a93edc2f95$var$O = null);
        }
    } else $406f97a93edc2f95$var$N = !1;
}
var $406f97a93edc2f95$var$S;
if ("function" === typeof $406f97a93edc2f95$var$F) $406f97a93edc2f95$var$S = function S() {
    $406f97a93edc2f95$var$F($406f97a93edc2f95$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $406f97a93edc2f95$var$T = new MessageChannel, $406f97a93edc2f95$var$U = $406f97a93edc2f95$var$T.port2;
    $406f97a93edc2f95$var$T.port1.onmessage = $406f97a93edc2f95$var$R;
    $406f97a93edc2f95$var$S = function S() {
        $406f97a93edc2f95$var$U.postMessage(null);
    };
} else $406f97a93edc2f95$var$S = function S() {
    $406f97a93edc2f95$var$D($406f97a93edc2f95$var$R, 0);
};
function $406f97a93edc2f95$var$I(a) {
    $406f97a93edc2f95$var$O = a;
    $406f97a93edc2f95$var$N || ($406f97a93edc2f95$var$N = !0, $406f97a93edc2f95$var$S());
}
function $406f97a93edc2f95$var$K(a, b) {
    $406f97a93edc2f95$var$L = $406f97a93edc2f95$var$D(function() {
        a($406f97a93edc2f95$export$c4744153514ff05d());
    }, b);
}
$406f97a93edc2f95$export$3e506c1ccc9cc1a7 = 5;
$406f97a93edc2f95$export$e26fe2ed2fa76875 = 1;
$406f97a93edc2f95$export$502329bbf4b505b1 = 4;
$406f97a93edc2f95$export$6e3807111c4874c4 = 3;
$406f97a93edc2f95$export$c27134553091fb3a = null;
$406f97a93edc2f95$export$33ee1acdc04fd2a2 = 2;
$406f97a93edc2f95$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$406f97a93edc2f95$export$8352ce38b91d0c62 = function() {
    $406f97a93edc2f95$var$A || $406f97a93edc2f95$var$z || ($406f97a93edc2f95$var$A = !0, $406f97a93edc2f95$var$I($406f97a93edc2f95$var$J));
};
$406f97a93edc2f95$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $406f97a93edc2f95$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$406f97a93edc2f95$export$d3dfb8e4810cb555 = function() {
    return $406f97a93edc2f95$var$y;
};
$406f97a93edc2f95$export$839f9183b0465a69 = function() {
    return $406f97a93edc2f95$var$h($406f97a93edc2f95$var$r);
};
$406f97a93edc2f95$export$72fdf0e06517287b = function(a) {
    switch($406f97a93edc2f95$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $406f97a93edc2f95$var$y;
    }
    var c = $406f97a93edc2f95$var$y;
    $406f97a93edc2f95$var$y = b;
    try {
        return a();
    } finally{
        $406f97a93edc2f95$var$y = c;
    }
};
$406f97a93edc2f95$export$4b844e58a3e414b4 = function() {};
$406f97a93edc2f95$export$816d2913ae6b83b1 = function() {};
$406f97a93edc2f95$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $406f97a93edc2f95$var$y;
    $406f97a93edc2f95$var$y = a;
    try {
        return b();
    } finally{
        $406f97a93edc2f95$var$y = c;
    }
};
$406f97a93edc2f95$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $406f97a93edc2f95$export$c4744153514ff05d();
    "object" === (typeof c === "undefined" ? "undefined" : (0, $5djcY._)(c)) && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $406f97a93edc2f95$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $406f97a93edc2f95$var$f($406f97a93edc2f95$var$t, a), null === $406f97a93edc2f95$var$h($406f97a93edc2f95$var$r) && a === $406f97a93edc2f95$var$h($406f97a93edc2f95$var$t) && ($406f97a93edc2f95$var$B ? ($406f97a93edc2f95$var$E($406f97a93edc2f95$var$L), $406f97a93edc2f95$var$L = -1) : $406f97a93edc2f95$var$B = !0, $406f97a93edc2f95$var$K($406f97a93edc2f95$var$H, c - d))) : (a.sortIndex = e, $406f97a93edc2f95$var$f($406f97a93edc2f95$var$r, a), $406f97a93edc2f95$var$A || $406f97a93edc2f95$var$z || ($406f97a93edc2f95$var$A = !0, $406f97a93edc2f95$var$I($406f97a93edc2f95$var$J)));
    return a;
};
$406f97a93edc2f95$export$b5836b71941fa3ed = $406f97a93edc2f95$var$M;
$406f97a93edc2f95$export$cf845f2c119da08a = function(a) {
    var b = $406f97a93edc2f95$var$y;
    return function() {
        var c = $406f97a93edc2f95$var$y;
        $406f97a93edc2f95$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $406f97a93edc2f95$var$y = c;
        }
    };
};

});





parcelRegister("6tY97", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4b841b45c75a3225$export$71511d61b312f219; });
function $4b841b45c75a3225$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("kWfK0", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f3e56f3eac89eefa$export$71511d61b312f219; });

var $6tY97 = parcelRequire("6tY97");
function $f3e56f3eac89eefa$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $6tY97._)(target, key, source[key]);
        });
    }
    return target;
}

});

parcelRegister("hApvp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ccd99553ef7f1c61$export$71511d61b312f219; });
function $ccd99553ef7f1c61$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ccd99553ef7f1c61$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $ccd99553ef7f1c61$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("6ZpBv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $516c4cfaa4b34746$export$71511d61b312f219; });

var $ceUCx = parcelRequire("ceUCx");

var $e1lIn = parcelRequire("e1lIn");

var $OKxK3 = parcelRequire("OKxK3");

var $J66Jb = parcelRequire("J66Jb");
function $516c4cfaa4b34746$export$71511d61b312f219(arr, i) {
    return (0, $ceUCx._)(arr) || (0, $e1lIn._)(arr, i) || (0, $J66Jb._)(arr, i) || (0, $OKxK3._)();
}

});
parcelRegister("ceUCx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8e92b680619f4fa4$export$71511d61b312f219; });
function $8e92b680619f4fa4$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("e1lIn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a35200cd1f91429a$export$71511d61b312f219; });
function $a35200cd1f91429a$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("OKxK3", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0988c6241722d902$export$71511d61b312f219; });
function $0988c6241722d902$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("J66Jb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0878f0e8b254b036$export$71511d61b312f219; });

var $2PuG4 = parcelRequire("2PuG4");
function $0878f0e8b254b036$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $2PuG4._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $2PuG4._)(o, minLen);
}

});
parcelRegister("2PuG4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $20f8241f6119e7d1$export$71511d61b312f219; });
function $20f8241f6119e7d1$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("a8poV", function(module, exports) {
(function() {
    'use strict';
    var table = [], poly = 0xEDB88320; // reverse polynomial
    // build the table
    function makeTable() {
        var c, n, k;
        for(n = 0; n < 256; n += 1){
            c = n;
            for(k = 0; k < 8; k += 1)if (c & 1) c = poly ^ c >>> 1;
            else c = c >>> 1;
            table[n] = c >>> 0;
        }
    }
    function strToArr(str) {
        // sweet hack to turn string into a 'byte' array
        return Array.prototype.map.call(str, function(c) {
            return c.charCodeAt(0);
        });
    }
    /*
	 * Compute CRC of array directly.
	 *
	 * This is slower for repeated calls, so append mode is not supported.
	 */ function crcDirect(arr) {
        var crc = -1, i, j, l, temp;
        for(i = 0, l = arr.length; i < l; i += 1){
            temp = (crc ^ arr[i]) & 0xff;
            // read 8 bits one at a time
            for(j = 0; j < 8; j += 1)if ((temp & 1) === 1) temp = temp >>> 1 ^ poly;
            else temp = temp >>> 1;
            crc = crc >>> 8 ^ temp;
        }
        // flip bits
        return crc ^ -1;
    }
    /*
	 * Compute CRC with the help of a pre-calculated table.
	 *
	 * This supports append mode, if the second parameter is set.
	 */ function crcTable(arr, append) {
        var crc, i, l;
        // if we're in append mode, don't reset crc
        // if arr is null or undefined, reset table and return
        if (typeof crcTable.crc === 'undefined' || !append || !arr) {
            crcTable.crc = -1;
            if (!arr) return;
        }
        // store in temp variable for minor speed gain
        crc = crcTable.crc;
        for(i = 0, l = arr.length; i < l; i += 1)crc = crc >>> 8 ^ table[(crc ^ arr[i]) & 0xff];
        crcTable.crc = crc;
        return crc ^ -1;
    }
    // build the table
    // this isn't that costly, and most uses will be for table assisted mode
    makeTable();
    module.exports = function(val, direct) {
        var val = typeof val === 'string' ? strToArr(val) : val, ret = direct ? crcDirect(val) : crcTable(val);
        // convert to 2's complement hex
        return (ret >>> 0).toString(16);
    };
    module.exports.direct = crcDirect;
    module.exports.table = crcTable;
})();

});

parcelRegister("6tkaO", function(module, exports) {

$parcel$export(module.exports, "query", function () { return query; });
$parcel$export(module.exports, "where", function () { return where; });
$parcel$export(module.exports, "getDocs", function () { return getDocs; });
$parcel$export(module.exports, "setDoc", function () { return setDoc; });
$parcel$export(module.exports, "updateDoc", function () { return updateDoc; });
$parcel$export(module.exports, "collection", function () { return (parcelRequire("hh2l2")).aL; });
$parcel$export(module.exports, "getFirestore", function () { return (parcelRequire("hh2l2")).aV; });
$parcel$export(module.exports, "serverTimestamp", function () { return (parcelRequire("hh2l2")).b0; });
$parcel$export(module.exports, "doc", function () { return (parcelRequire("hh2l2")).v; });

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $hC9N3 = parcelRequire("hC9N3");

var $9atk1 = parcelRequire("9atk1");

var $c2MhV = parcelRequire("c2MhV");

var $kWfK0 = parcelRequire("kWfK0");

var $5djcY = parcelRequire("5djcY");

var $wQDEL = parcelRequire("wQDEL");

var $9xcZw = parcelRequire("9xcZw");

var $hh2l2 = parcelRequire("hh2l2");

var $hk14n = parcelRequire("hk14n");
parcelRequire("ak6Ro");
parcelRequire("5eJAc");
parcelRequire("2rSfQ");

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an aggregation that can be performed by Firestore.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
var AggregateField = function AggregateField() {
    "use strict";
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "count", t = arguments.length > 1 ? arguments[1] : void 0;
    (0, $4QweW._)(this, AggregateField);
    this._internalFieldPath = t, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateField", this.aggregateType = e;
};
/**
 * The results of executing an aggregation query.
 */ var AggregateQuerySnapshot = /*#__PURE__*/ function() {
    "use strict";
    function AggregateQuerySnapshot(e, t, n) {
        (0, $4QweW._)(this, AggregateQuerySnapshot);
        this._userDataWriter = t, this._data = n, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateQuerySnapshot", this.query = e;
    }
    (0, $6hK4i._)(AggregateQuerySnapshot, [
        {
            /**
     * Returns the results of the aggregations performed over the underlying
     * query.
     *
     * The keys of the returned object will be the same as those of the
     * `AggregateSpec` object specified to the aggregation method, and the values
     * will be the corresponding aggregation result.
     *
     * @returns The results of the aggregations performed over the underlying
     * query.
     */ key: "data",
            value: function data() {
                return this._userDataWriter.convertObjectMap(this._data);
            }
        },
        {
            /**
     * @internal
     * @private
     *
     * Retrieves all fields in the snapshot as a proto value.
     *
     * @returns An `Object` containing all fields in the snapshot.
     */ key: "_fieldsProto",
            value: function _fieldsProto() {
                // Return the cloned value to prevent manipulation of the Snapshot's data
                return new (0, $hh2l2.O)({
                    mapValue: {
                        fields: this._data
                    }
                }).clone().value.mapValue.fields;
            }
        }
    ]);
    return AggregateQuerySnapshot;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function __PRIVATE_validateHasExplicitOrderByForLimitToLast(e$1) {
    if ("L" /* LimitType.Last */  === e$1.limitType && 0 === e$1.explicitOrderBy.length) throw new (0, $hh2l2.f)((0, $hh2l2.t).UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
/**
 * An `AppliableConstraint` is an abstraction of a constraint that can be applied
 * to a Firestore query.
 */ var AppliableConstraint = function AppliableConstraint() {
    "use strict";
    (0, $4QweW._)(this, AppliableConstraint);
};
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Firestore query. `QueryConstraint`s are created by invoking {@link where},
 * {@link orderBy}, {@link (startAt:1)}, {@link (startAfter:1)}, {@link
 * (endBefore:1)}, {@link (endAt:1)}, {@link limit}, {@link limitToLast} and
 * can then be passed to {@link (query:1)} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ var QueryConstraint = /*#__PURE__*/ function(AppliableConstraint) {
    "use strict";
    (0, $c2MhV._)(QueryConstraint, AppliableConstraint);
    function QueryConstraint() {
        (0, $4QweW._)(this, QueryConstraint);
        return (0, $ehF45._)(this, QueryConstraint, arguments);
    }
    return QueryConstraint;
}(AppliableConstraint);
function query(e$1, t) {
    for(var _len = arguments.length, n = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        n[_key - 2] = arguments[_key];
    }
    var r = [];
    t instanceof AppliableConstraint && r.push(t), r = r.concat(n), function __PRIVATE_validateQueryConstraintArray(e$1) {
        var _$t = e$1.filter(function(e) {
            return e instanceof QueryCompositeFilterConstraint;
        }).length, n = e$1.filter(function(e) {
            return e instanceof QueryFieldFilterConstraint;
        }).length;
        if (_$t > 1 || _$t > 0 && n > 0) throw new (0, $hh2l2.f)((0, $hh2l2.t).INVALID_ARGUMENT, "InvalidQuery. When using composite filters, you cannot use more than one filter at the top level. Consider nesting the multiple filters within an `and(...)` statement. For example: change `query(query, where(...), or(...))` to `query(query, and(where(...), or(...)))`.");
    }(r);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _$t = _step.value;
            e$1 = _$t._apply(e$1);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return e$1;
}
/**
 * A `QueryFieldFilterConstraint` is used to narrow the set of documents returned by
 * a Firestore query by filtering on one or more document fields.
 * `QueryFieldFilterConstraint`s are created by invoking {@link where} and can then
 * be passed to {@link (query:1)} to create a new query instance that also contains
 * this `QueryFieldFilterConstraint`.
 */ var QueryFieldFilterConstraint = /*#__PURE__*/ function(QueryConstraint) {
    "use strict";
    (0, $c2MhV._)(QueryFieldFilterConstraint, QueryConstraint);
    function QueryFieldFilterConstraint(e, t, n) {
        (0, $4QweW._)(this, QueryFieldFilterConstraint);
        var _this;
        _this = (0, $ehF45._)(this, QueryFieldFilterConstraint), _this._field = e, _this._op = t, _this._value = n, /** The type of this query constraint */ _this.type = "where";
        return _this;
    }
    (0, $6hK4i._)(QueryFieldFilterConstraint, [
        {
            key: "_apply",
            value: function _apply(e) {
                var t = this._parse(e);
                return __PRIVATE_validateNewFieldFilter(e._query, t), new (0, $hh2l2.Q)(e.firestore, e.converter, (0, $hh2l2.c)(e._query, t));
            }
        },
        {
            key: "_parse",
            value: function _parse(e$1) {
                var t = (0, $hh2l2.l)(e$1.firestore), n = function __PRIVATE_newQueryFilter(e$1, t, n, r, s, a, o) {
                    var i;
                    if (s.isKeyField()) {
                        if ("array-contains" /* Operator.ARRAY_CONTAINS */  === a || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === a) throw new (0, $hh2l2.f)((0, $hh2l2.t).INVALID_ARGUMENT, "Invalid Query. You can't perform '".concat(a, "' queries on documentId()."));
                        if ("in" /* Operator.IN */  === a || "not-in" /* Operator.NOT_IN */  === a) {
                            __PRIVATE_validateDisjunctiveFilterElements(o, a);
                            var _$t = [];
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = o[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$n = _step.value;
                                    _$t.push(__PRIVATE_parseDocumentIdValue(r, e$1, _$n));
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            i = {
                                arrayValue: {
                                    values: _$t
                                }
                            };
                        } else i = __PRIVATE_parseDocumentIdValue(r, e$1, o);
                    } else "in" /* Operator.IN */  !== a && "not-in" /* Operator.NOT_IN */  !== a && "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  !== a || __PRIVATE_validateDisjunctiveFilterElements(o, a), i = (0, $hh2l2.g)(n, t, o, /* allowArrays= */ "in" /* Operator.IN */  === a || "not-in" /* Operator.NOT_IN */  === a);
                    var c = (0, $hh2l2.F).create(s, a, i);
                    return c;
                }(e$1._query, "where", t, e$1.firestore._databaseId, this._field, this._op, this._value);
                return n;
            }
        }
    ], [
        {
            key: "_create",
            value: function _create(e, t, n) {
                return new QueryFieldFilterConstraint(e, t, n);
            }
        }
    ]);
    return QueryFieldFilterConstraint;
}(QueryConstraint);
/**
 * Creates a {@link QueryFieldFilterConstraint} that enforces that documents
 * must contain the specified field and that the value should satisfy the
 * relation constraint provided.
 *
 * @param fieldPath - The path to compare
 * @param opStr - The operation string (e.g "&lt;", "&lt;=", "==", "&lt;",
 *   "&lt;=", "!=").
 * @param value - The value for comparison
 * @returns The created {@link QueryFieldFilterConstraint}.
 */ function where(e, t, n) {
    var r = t, s = (0, $hh2l2.K)("where", e);
    return QueryFieldFilterConstraint._create(s, r, n);
}
/**
 * A `QueryCompositeFilterConstraint` is used to narrow the set of documents
 * returned by a Firestore query by performing the logical OR or AND of multiple
 * {@link QueryFieldFilterConstraint}s or {@link QueryCompositeFilterConstraint}s.
 * `QueryCompositeFilterConstraint`s are created by invoking {@link or} or
 * {@link and} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains the `QueryCompositeFilterConstraint`.
 */ var QueryCompositeFilterConstraint = /*#__PURE__*/ function(AppliableConstraint) {
    "use strict";
    (0, $c2MhV._)(QueryCompositeFilterConstraint, AppliableConstraint);
    function QueryCompositeFilterConstraint(/** The type of this query constraint */ e, t) {
        (0, $4QweW._)(this, QueryCompositeFilterConstraint);
        var _this;
        _this = (0, $ehF45._)(this, QueryCompositeFilterConstraint), _this.type = e, _this._queryConstraints = t;
        return _this;
    }
    (0, $6hK4i._)(QueryCompositeFilterConstraint, [
        {
            key: "_parse",
            value: function _parse(e) {
                var t = this._queryConstraints.map(function(t) {
                    return t._parse(e);
                }).filter(function(e) {
                    return e.getFilters().length > 0;
                });
                return 1 === t.length ? t[0] : (0, $hh2l2.C).create(t, this._getOperator());
            }
        },
        {
            key: "_apply",
            value: function _apply(e) {
                var t = this._parse(e);
                return 0 === t.getFilters().length ? e : (function __PRIVATE_validateNewFilter(e, t) {
                    var n = e;
                    var r = t.getFlattenedFilters();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$e = _step.value;
                            __PRIVATE_validateNewFieldFilter(n, _$e), n = (0, $hh2l2.c)(n, _$e);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }(e._query, t), new (0, $hh2l2.Q)(e.firestore, e.converter, (0, $hh2l2.c)(e._query, t)));
            }
        },
        {
            key: "_getQueryConstraints",
            value: function _getQueryConstraints() {
                return this._queryConstraints;
            }
        },
        {
            key: "_getOperator",
            value: function _getOperator() {
                return "and" === this.type ? "and" /* CompositeOperator.AND */  : "or" /* CompositeOperator.OR */ ;
            }
        }
    ], [
        {
            key: "_create",
            value: function _create(e, t) {
                return new QueryCompositeFilterConstraint(e, t);
            }
        }
    ]);
    return QueryCompositeFilterConstraint;
}(AppliableConstraint);
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a disjunction of
 * the given filter constraints. A disjunction filter includes a document if it
 * satisfies any of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a disjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function or() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    // Only support QueryFilterConstraints
    return e.forEach(function(e) {
        return __PRIVATE_validateQueryFilterConstraint("or", e);
    }), QueryCompositeFilterConstraint._create("or" /* CompositeOperator.OR */ , e);
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a conjunction of
 * the given filter constraints. A conjunction filter includes a document if it
 * satisfies all of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a conjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function and() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    // Only support QueryFilterConstraints
    return e.forEach(function(e) {
        return __PRIVATE_validateQueryFilterConstraint("and", e);
    }), QueryCompositeFilterConstraint._create("and" /* CompositeOperator.AND */ , e);
}
/**
 * A `QueryOrderByConstraint` is used to sort the set of documents returned by a
 * Firestore query. `QueryOrderByConstraint`s are created by invoking
 * {@link orderBy} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains this `QueryOrderByConstraint`.
 *
 * Note: Documents that do not contain the orderBy field will not be present in
 * the query result.
 */ var QueryOrderByConstraint = /*#__PURE__*/ function(QueryConstraint) {
    "use strict";
    (0, $c2MhV._)(QueryOrderByConstraint, QueryConstraint);
    function QueryOrderByConstraint(e, t) {
        (0, $4QweW._)(this, QueryOrderByConstraint);
        var _this;
        _this = (0, $ehF45._)(this, QueryOrderByConstraint), _this._field = e, _this._direction = t, /** The type of this query constraint */ _this.type = "orderBy";
        return _this;
    }
    (0, $6hK4i._)(QueryOrderByConstraint, [
        {
            key: "_apply",
            value: function _apply(e$1) {
                var t = function __PRIVATE_newQueryOrderBy(e$1, t, n) {
                    if (null !== e$1.startAt) throw new (0, $hh2l2.f)((0, $hh2l2.t).INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
                    if (null !== e$1.endAt) throw new (0, $hh2l2.f)((0, $hh2l2.t).INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
                    var r = new (0, $hh2l2.i)(t, n);
                    return r;
                }(e$1._query, this._field, this._direction);
                return new (0, $hh2l2.Q)(e$1.firestore, e$1.converter, (0, $hh2l2.j)(e$1._query, t));
            }
        }
    ], [
        {
            key: "_create",
            value: function _create(e, t) {
                return new QueryOrderByConstraint(e, t);
            }
        }
    ]);
    return QueryOrderByConstraint;
}(QueryConstraint);
/**
 * Creates a {@link QueryOrderByConstraint} that sorts the query result by the
 * specified field, optionally in descending order instead of ascending.
 *
 * Note: Documents that do not contain the specified field will not be present
 * in the query result.
 *
 * @param fieldPath - The field to sort by.
 * @param directionStr - Optional direction to sort by ('asc' or 'desc'). If
 * not specified, order will be ascending.
 * @returns The created {@link QueryOrderByConstraint}.
 */ function orderBy(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "asc";
    var n = t, r = (0, $hh2l2.K)("orderBy", e);
    return QueryOrderByConstraint._create(r, n);
}
/**
 * A `QueryLimitConstraint` is used to limit the number of documents returned by
 * a Firestore query.
 * `QueryLimitConstraint`s are created by invoking {@link limit} or
 * {@link limitToLast} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryLimitConstraint`.
 */ var QueryLimitConstraint = /*#__PURE__*/ function(QueryConstraint) {
    "use strict";
    (0, $c2MhV._)(QueryLimitConstraint, QueryConstraint);
    function QueryLimitConstraint(/** The type of this query constraint */ e, t, n) {
        (0, $4QweW._)(this, QueryLimitConstraint);
        var _this;
        _this = (0, $ehF45._)(this, QueryLimitConstraint), _this.type = e, _this._limit = t, _this._limitType = n;
        return _this;
    }
    (0, $6hK4i._)(QueryLimitConstraint, [
        {
            key: "_apply",
            value: function _apply(e) {
                return new (0, $hh2l2.Q)(e.firestore, e.converter, (0, $hh2l2.h)(e._query, this._limit, this._limitType));
            }
        }
    ], [
        {
            key: "_create",
            value: function _create(e, t, n) {
                return new QueryLimitConstraint(e, t, n);
            }
        }
    ]);
    return QueryLimitConstraint;
}(QueryConstraint);
/**
 * Creates a {@link QueryLimitConstraint} that only returns the first matching
 * documents.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function limit(e) {
    return (0, $hh2l2.T)("limit", e), QueryLimitConstraint._create("limit", e, "F" /* LimitType.First */ );
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the last matching
 * documents.
 *
 * You must specify at least one `orderBy` clause for `limitToLast` queries,
 * otherwise an exception will be thrown during execution.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function limitToLast(e) {
    return (0, $hh2l2.T)("limitToLast", e), QueryLimitConstraint._create("limitToLast", e, "L" /* LimitType.Last */ );
}
/**
 * A `QueryStartAtConstraint` is used to exclude documents from the start of a
 * result set returned by a Firestore query.
 * `QueryStartAtConstraint`s are created by invoking {@link (startAt:1)} or
 * {@link (startAfter:1)} and can then be passed to {@link (query:1)} to create a
 * new query instance that also contains this `QueryStartAtConstraint`.
 */ var QueryStartAtConstraint = /*#__PURE__*/ function(QueryConstraint) {
    "use strict";
    (0, $c2MhV._)(QueryStartAtConstraint, QueryConstraint);
    function QueryStartAtConstraint(/** The type of this query constraint */ e, t, n) {
        (0, $4QweW._)(this, QueryStartAtConstraint);
        var _this;
        _this = (0, $ehF45._)(this, QueryStartAtConstraint), _this.type = e, _this._docOrFields = t, _this._inclusive = n;
        return _this;
    }
    (0, $6hK4i._)(QueryStartAtConstraint, [
        {
            key: "_apply",
            value: function _apply(e) {
                var t = __PRIVATE_newQueryBoundFromDocOrFields(e, this.type, this._docOrFields, this._inclusive);
                return new (0, $hh2l2.Q)(e.firestore, e.converter, (0, $hh2l2.k)(e._query, t));
            }
        }
    ], [
        {
            key: "_create",
            value: function _create(e, t, n) {
                return new QueryStartAtConstraint(e, t, n);
            }
        }
    ]);
    return QueryStartAtConstraint;
}(QueryConstraint);
function startAt() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    return QueryStartAtConstraint._create("startAt", e, /*inclusive=*/ true);
}
function startAfter() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    return QueryStartAtConstraint._create("startAfter", e, /*inclusive=*/ false);
}
/**
 * A `QueryEndAtConstraint` is used to exclude documents from the end of a
 * result set returned by a Firestore query.
 * `QueryEndAtConstraint`s are created by invoking {@link (endAt:1)} or
 * {@link (endBefore:1)} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryEndAtConstraint`.
 */ var QueryEndAtConstraint = /*#__PURE__*/ function(QueryConstraint) {
    "use strict";
    (0, $c2MhV._)(QueryEndAtConstraint, QueryConstraint);
    function QueryEndAtConstraint(/** The type of this query constraint */ e, t, n) {
        (0, $4QweW._)(this, QueryEndAtConstraint);
        var _this;
        _this = (0, $ehF45._)(this, QueryEndAtConstraint), _this.type = e, _this._docOrFields = t, _this._inclusive = n;
        return _this;
    }
    (0, $6hK4i._)(QueryEndAtConstraint, [
        {
            key: "_apply",
            value: function _apply(e) {
                var t = __PRIVATE_newQueryBoundFromDocOrFields(e, this.type, this._docOrFields, this._inclusive);
                return new (0, $hh2l2.Q)(e.firestore, e.converter, (0, $hh2l2.e)(e._query, t));
            }
        }
    ], [
        {
            key: "_create",
            value: function _create(e, t, n) {
                return new QueryEndAtConstraint(e, t, n);
            }
        }
    ]);
    return QueryEndAtConstraint;
}(QueryConstraint);
function endBefore() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    return QueryEndAtConstraint._create("endBefore", e, /*inclusive=*/ false);
}
function endAt() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    return QueryEndAtConstraint._create("endAt", e, /*inclusive=*/ true);
}
/** Helper function to create a bound from a document or fields */ function __PRIVATE_newQueryBoundFromDocOrFields(e$1, t, n, r) {
    if (n[0] = (0, $hk14n.getModularInstance)(n[0]), n[0] instanceof (0, $hh2l2.a5)) return function __PRIVATE_newQueryBoundFromDocument(e$1, t, n, r, s) {
        if (!r) throw new (0, $hh2l2.f)((0, $hh2l2.t).NOT_FOUND, "Can't use a DocumentSnapshot that doesn't exist for ".concat(n, "()."));
        var a = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // Because people expect to continue/end a query at the exact document
            // provided, we need to use the implicit sort order rather than the explicit
            // sort order, because it's guaranteed to contain the document key. That way
            // the position becomes unambiguous and the query continues/ends exactly at
            // the provided document. Without the key (by using the explicit sort
            // orders), multiple documents could match the position, yielding duplicate
            // results.
            for(var _iterator = (0, $hh2l2.a6)(e$1)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _$n = _step.value;
                if (_$n.field.isKeyField()) a.push((0, $hh2l2.a7)(t, r.key));
                else {
                    var _$e$1 = r.data.field(_$n.field);
                    if ((0, $hh2l2.a8)(_$e$1)) throw new (0, $hh2l2.f)((0, $hh2l2.t).INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + _$n.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
                    if (null === _$e$1) {
                        var _$e$11 = _$n.field.canonicalString();
                        throw new (0, $hh2l2.f)((0, $hh2l2.t).INVALID_ARGUMENT, "Invalid query. You are trying to start or end a query using a document for which the field '".concat(_$e$11, "' (used as the orderBy) does not exist."));
                    }
                    a.push(_$e$1);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return new (0, $hh2l2.a9)(a, s);
    }(e$1._query, e$1.firestore._databaseId, t, n[0]._document, r);
    {
        var s = (0, $hh2l2.l)(e$1.firestore);
        return function __PRIVATE_newQueryBoundFromFields(e$1, t, n, r, s, a) {
            // Use explicit order by's because it has to match the query the user made
            var o = e$1.explicitOrderBy;
            if (s.length > o.length) throw new (0, $hh2l2.f)((0, $hh2l2.t).INVALID_ARGUMENT, "Too many arguments provided to ".concat(r, "(). The number of arguments must be less than or equal to the number of orderBy() clauses"));
            var i = [];
            for(var _$a = 0; _$a < s.length; _$a++){
                var c = s[_$a];
                if (o[_$a].field.isKeyField()) {
                    if ("string" != typeof c) throw new (0, $hh2l2.f)((0, $hh2l2.t).INVALID_ARGUMENT, "Invalid query. Expected a string for document ID in ".concat(r, "(), but got a ").concat(typeof c === "undefined" ? "undefined" : (0, $5djcY._)(c)));
                    if (!(0, $hh2l2.aa)(e$1) && -1 !== c.indexOf("/")) throw new (0, $hh2l2.f)((0, $hh2l2.t).INVALID_ARGUMENT, "Invalid query. When querying a collection and ordering by documentId(), the value passed to ".concat(r, "() must be a plain document ID, but '").concat(c, "' contains a slash."));
                    var _$n = e$1.path.child((0, $hh2l2.ab).fromString(c));
                    if (!(0, $hh2l2.Y).isDocumentKey(_$n)) throw new (0, $hh2l2.f)((0, $hh2l2.t).INVALID_ARGUMENT, "Invalid query. When querying a collection group and ordering by documentId(), the value passed to ".concat(r, "() must result in a valid document path, but '").concat(_$n, "' is not because it contains an odd number of segments."));
                    var _$s = new (0, $hh2l2.Y)(_$n);
                    i.push((0, $hh2l2.a7)(t, _$s));
                } else {
                    var _$e = (0, $hh2l2.g)(n, r, c);
                    i.push(_$e);
                }
            }
            return new (0, $hh2l2.a9)(i, a);
        }(e$1._query, e$1.firestore._databaseId, s, t, n, r);
    }
}
function __PRIVATE_parseDocumentIdValue(e$1, t, n) {
    if ("string" == typeof (n = (0, $hk14n.getModularInstance)(n))) {
        if ("" === n) throw new (0, $hh2l2.f)((0, $hh2l2.t).INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
        if (!(0, $hh2l2.aa)(t) && -1 !== n.indexOf("/")) throw new (0, $hh2l2.f)((0, $hh2l2.t).INVALID_ARGUMENT, "Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '".concat(n, "' contains a '/' character."));
        var r = t.path.child((0, $hh2l2.ab).fromString(n));
        if (!(0, $hh2l2.Y).isDocumentKey(r)) throw new (0, $hh2l2.f)((0, $hh2l2.t).INVALID_ARGUMENT, "Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '".concat(r, "' is not because it has an odd number of segments (").concat(r.length, ")."));
        return (0, $hh2l2.a7)(e$1, new (0, $hh2l2.Y)(r));
    }
    if (n instanceof (0, $hh2l2.I)) return (0, $hh2l2.a7)(e$1, n._key);
    throw new (0, $hh2l2.f)((0, $hh2l2.t).INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ".concat((0, $hh2l2.ac)(n), "."));
}
/**
 * Validates that the value passed into a disjunctive filter satisfies all
 * array requirements.
 */ function __PRIVATE_validateDisjunctiveFilterElements(e$1, t) {
    if (!Array.isArray(e$1) || 0 === e$1.length) throw new (0, $hh2l2.f)((0, $hh2l2.t).INVALID_ARGUMENT, "Invalid Query. A non-empty array is required for '".concat(t.toString(), "' filters."));
}
/**
 * Given an operator, returns the set of operators that cannot be used with it.
 *
 * This is not a comprehensive check, and this function should be removed in the
 * long term. Validations should occur in the Firestore backend.
 *
 * Operators in a query must adhere to the following set of rules:
 * 1. Only one inequality per query.
 * 2. `NOT_IN` cannot be used with array, disjunctive, or `NOT_EQUAL` operators.
 */ function __PRIVATE_validateNewFieldFilter(e$1, t) {
    var n = function __PRIVATE_findOpInsideFilters(e, t) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                var n = _step.value;
                try {
                    for(var _iterator1 = n.getFlattenedFilters()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                        var _$e = _step1.value;
                        if (t.indexOf(_$e.op) >= 0) return _$e.op;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        return null;
    }(e$1.filters, function __PRIVATE_conflictingOps(e) {
        switch(e){
            case "!=" /* Operator.NOT_EQUAL */ :
                return [
                    "!=" /* Operator.NOT_EQUAL */ ,
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
            case "in" /* Operator.IN */ :
                return [
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "not-in" /* Operator.NOT_IN */ :
                return [
                    "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ,
                    "in" /* Operator.IN */ ,
                    "not-in" /* Operator.NOT_IN */ ,
                    "!=" /* Operator.NOT_EQUAL */ 
                ];
            default:
                return [];
        }
    }(t.op));
    if (null !== n) // Special case when it's a duplicate op to give a slightly clearer error message.
    throw n === t.op ? new (0, $hh2l2.f)((0, $hh2l2.t).INVALID_ARGUMENT, "Invalid query. You cannot use more than one '".concat(t.op.toString(), "' filter.")) : new (0, $hh2l2.f)((0, $hh2l2.t).INVALID_ARGUMENT, "Invalid query. You cannot use '".concat(t.op.toString(), "' filters with '").concat(n.toString(), "' filters."));
}
function __PRIVATE_validateQueryFilterConstraint(e$1, t) {
    if (!(t instanceof QueryFieldFilterConstraint || t instanceof QueryCompositeFilterConstraint)) throw new (0, $hh2l2.f)((0, $hh2l2.t).INVALID_ARGUMENT, "Function ".concat(e$1, "() requires AppliableConstraints created with a call to 'where(...)', 'or(...)', or 'and(...)'."));
}
function sum(e) {
    return new AggregateField("sum", (0, $hh2l2.K)("sum", e));
}
/**
 * Create an AggregateField object that can be used to compute the average of
 * a specified field over a range of documents in the result set of a query.
 * @param field - Specifies the field to average across the result set.
 */ function average(e) {
    return new AggregateField("avg", (0, $hh2l2.K)("average", e));
}
/**
 * Create an AggregateField object that can be used to compute the count of
 * documents in the result set of a query.
 */ function count() {
    return new AggregateField("count");
}
/**
 * Compares two 'AggregateField` instances for equality.
 *
 * @param left - Compare this AggregateField to the `right`.
 * @param right - Compare this AggregateField to the `left`.
 */ function aggregateFieldEqual(e, t) {
    var _e__internalFieldPath, _t__internalFieldPath;
    return e instanceof AggregateField && t instanceof AggregateField && e.aggregateType === t.aggregateType && ((_e__internalFieldPath = e._internalFieldPath) === null || _e__internalFieldPath === void 0 ? void 0 : _e__internalFieldPath.canonicalString()) === ((_t__internalFieldPath = t._internalFieldPath) === null || _t__internalFieldPath === void 0 ? void 0 : _t__internalFieldPath.canonicalString());
}
/**
 * Compares two `AggregateQuerySnapshot` instances for equality.
 *
 * Two `AggregateQuerySnapshot` instances are considered "equal" if they have
 * underlying queries that compare equal, and the same data.
 *
 * @param left - The first `AggregateQuerySnapshot` to compare.
 * @param right - The second `AggregateQuerySnapshot` to compare.
 *
 * @returns `true` if the objects are "equal", as defined above, or `false`
 * otherwise.
 */ function aggregateQuerySnapshotEqual(e, t) {
    return (0, $hh2l2.w)(e.query, t.query) && (0, $hk14n.deepEqual)(e.data(), t.data());
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function __PRIVATE_isPartialObserver(e) {
    /**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */ return function __PRIVATE_implementsAnyMethods(e, t) {
        if ("object" != (typeof e === "undefined" ? "undefined" : (0, $5djcY._)(e)) || null === e) return false;
        var n = e;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _$e = _step.value;
                if (_$e in n && "function" == typeof n[_$e]) return true;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return false;
    }(e, [
        "next",
        "error",
        "complete"
    ]);
}
function getCountFromServer(e) {
    return getAggregateFromServer(e, {
        count: count()
    });
}
/**
 * Calculates the specified aggregations over the documents in the result
 * set of the given query without actually downloading the documents.
 *
 * Using this function to perform aggregations is efficient because only the
 * final aggregation values, not the documents' data, are downloaded. This
 * function can perform aggregations of the documents in cases where the result
 * set is prohibitively large to download entirely (thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used. Every invocation of this function necessarily involves a round trip to
 * the server.
 *
 * @param query - The query whose result set is aggregated over.
 * @param aggregateSpec - An `AggregateSpec` object that specifies the aggregates
 * to perform over the result set. The AggregateSpec specifies aliases for each
 * aggregate, which can be used to retrieve the aggregate result.
 * @example
 * ```typescript
 * const aggregateSnapshot = await getAggregateFromServer(query, {
 *   countOfDocs: count(),
 *   totalHours: sum('hours'),
 *   averageScore: average('score')
 * });
 *
 * const countOfDocs: number = aggregateSnapshot.data().countOfDocs;
 * const totalHours: number = aggregateSnapshot.data().totalHours;
 * const averageScore: number | null = aggregateSnapshot.data().averageScore;
 * ```
 */ function getAggregateFromServer(e, t) {
    var n = (0, $hh2l2.s)(e.firestore, (0, $hh2l2.d)), r = (0, $hh2l2.x)(n), s = (0, $hh2l2.E)(t, function(e, t) {
        return new (0, $hh2l2.G)(t, e.aggregateType, e._internalFieldPath);
    });
    // Run the aggregation and convert the results
    return (0, $hh2l2.H)(r, e._query, s).then(function(t) {
        return(/**
 * Converts the core aggregation result to an `AggregateQuerySnapshot`
 * that can be returned to the consumer.
 * @param query
 * @param aggregateResult - Core aggregation result
 * @internal
 */ function __PRIVATE_convertToAggregateQuerySnapshot(e, t, n) {
            var r = new (0, $hh2l2.u)(e), s = new AggregateQuerySnapshot(t, r, n);
            return s;
        }(n, e, t));
    });
}
var __PRIVATE_MemoryLocalCacheImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryLocalCacheImpl(e) {
        (0, $4QweW._)(this, __PRIVATE_MemoryLocalCacheImpl);
        this.kind = "memory", this._onlineComponentProvider = (0, $hh2l2.ai).provider, this._offlineComponentProvider = (e === null || e === void 0 ? void 0 : e.garbageCollector) ? e.garbageCollector._offlineComponentProvider : {
            build: function() {
                return new (0, $hh2l2.aj)(void 0);
            }
        };
    }
    (0, $6hK4i._)(__PRIVATE_MemoryLocalCacheImpl, [
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    kind: this.kind
                };
            }
        }
    ]);
    return __PRIVATE_MemoryLocalCacheImpl;
}();
var __PRIVATE_PersistentLocalCacheImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_PersistentLocalCacheImpl(e) {
        (0, $4QweW._)(this, __PRIVATE_PersistentLocalCacheImpl);
        var t;
        this.kind = "persistent", (e === null || e === void 0 ? void 0 : e.tabManager) ? (e.tabManager._initialize(e), t = e.tabManager) : (t = persistentSingleTabManager(void 0), t._initialize(e)), this._onlineComponentProvider = t._onlineComponentProvider, this._offlineComponentProvider = t._offlineComponentProvider;
    }
    (0, $6hK4i._)(__PRIVATE_PersistentLocalCacheImpl, [
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    kind: this.kind
                };
            }
        }
    ]);
    return __PRIVATE_PersistentLocalCacheImpl;
}();
var __PRIVATE_MemoryEagerGarbageCollectorImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryEagerGarbageCollectorImpl() {
        (0, $4QweW._)(this, __PRIVATE_MemoryEagerGarbageCollectorImpl);
        this.kind = "memoryEager", this._offlineComponentProvider = (0, $hh2l2.ah).provider;
    }
    (0, $6hK4i._)(__PRIVATE_MemoryEagerGarbageCollectorImpl, [
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    kind: this.kind
                };
            }
        }
    ]);
    return __PRIVATE_MemoryEagerGarbageCollectorImpl;
}();
var __PRIVATE_MemoryLruGarbageCollectorImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryLruGarbageCollectorImpl(e) {
        (0, $4QweW._)(this, __PRIVATE_MemoryLruGarbageCollectorImpl);
        this.kind = "memoryLru", this._offlineComponentProvider = {
            build: function() {
                return new (0, $hh2l2.aj)(e);
            }
        };
    }
    (0, $6hK4i._)(__PRIVATE_MemoryLruGarbageCollectorImpl, [
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    kind: this.kind
                };
            }
        }
    ]);
    return __PRIVATE_MemoryLruGarbageCollectorImpl;
}();
/**
 * Creates an instance of `MemoryEagerGarbageCollector`. This is also the
 * default garbage collector unless it is explicitly specified otherwise.
 */ function memoryEagerGarbageCollector() {
    return new __PRIVATE_MemoryEagerGarbageCollectorImpl;
}
/**
 * Creates an instance of `MemoryLruGarbageCollector`.
 *
 * A target size can be specified as part of the setting parameter. The
 * collector will start deleting documents once the cache size exceeds
 * the given size. The default cache size is 40MB (40 * 1024 * 1024 bytes).
 */ function memoryLruGarbageCollector(e) {
    return new __PRIVATE_MemoryLruGarbageCollectorImpl(e === null || e === void 0 ? void 0 : e.cacheSizeBytes);
}
/**
 * Creates an instance of `MemoryLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 */ function memoryLocalCache(e) {
    return new __PRIVATE_MemoryLocalCacheImpl(e);
}
/**
 * Creates an instance of `PersistentLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 *
 * Persistent cache cannot be used in a Node.js environment.
 */ function persistentLocalCache(e) {
    return new __PRIVATE_PersistentLocalCacheImpl(e);
}
var __PRIVATE_SingleTabManagerImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_SingleTabManagerImpl(e) {
        (0, $4QweW._)(this, __PRIVATE_SingleTabManagerImpl);
        this.forceOwnership = e, this.kind = "persistentSingleTab";
    }
    (0, $6hK4i._)(__PRIVATE_SingleTabManagerImpl, [
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    kind: this.kind
                };
            }
        },
        {
            /**
     * @internal
     */ key: "_initialize",
            value: function _initialize(e) {
                var _this = this;
                this._onlineComponentProvider = (0, $hh2l2.ai).provider, this._offlineComponentProvider = {
                    build: function(t) {
                        return new (0, $hh2l2.al)(t, e === null || e === void 0 ? void 0 : e.cacheSizeBytes, _this.forceOwnership);
                    }
                };
            }
        }
    ]);
    return __PRIVATE_SingleTabManagerImpl;
}();
var __PRIVATE_MultiTabManagerImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MultiTabManagerImpl() {
        (0, $4QweW._)(this, __PRIVATE_MultiTabManagerImpl);
        this.kind = "PersistentMultipleTab";
    }
    (0, $6hK4i._)(__PRIVATE_MultiTabManagerImpl, [
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    kind: this.kind
                };
            }
        },
        {
            /**
     * @internal
     */ key: "_initialize",
            value: function _initialize(e) {
                this._onlineComponentProvider = (0, $hh2l2.ai).provider, this._offlineComponentProvider = {
                    build: function(t) {
                        return new (0, $hh2l2.ak)(t, e === null || e === void 0 ? void 0 : e.cacheSizeBytes);
                    }
                };
            }
        }
    ]);
    return __PRIVATE_MultiTabManagerImpl;
}();
/**
 * Creates an instance of `PersistentSingleTabManager`.
 *
 * @param settings - Configures the created tab manager.
 */ function persistentSingleTabManager(e) {
    return new __PRIVATE_SingleTabManagerImpl(e === null || e === void 0 ? void 0 : e.forceOwnership);
}
/**
 * Creates an instance of `PersistentMultipleTabManager`.
 */ function persistentMultipleTabManager() {
    return new __PRIVATE_MultiTabManagerImpl;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var Qe = {
    maxAttempts: 5
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A write batch, used to perform multiple writes as a single atomic unit.
 *
 * A `WriteBatch` object can be acquired by calling {@link writeBatch}. It
 * provides methods for adding writes to the write batch. None of the writes
 * will be committed (or visible locally) until {@link WriteBatch.commit} is
 * called.
 */ var WriteBatch = /*#__PURE__*/ function() {
    "use strict";
    function WriteBatch(e, t) {
        (0, $4QweW._)(this, WriteBatch);
        this._firestore = e, this._commitHandler = t, this._mutations = [], this._committed = false, this._dataReader = (0, $hh2l2.l)(e);
    }
    (0, $6hK4i._)(WriteBatch, [
        {
            key: "set",
            value: function set(e, t, n) {
                this._verifyNotCommitted();
                var r = __PRIVATE_validateReference(e, this._firestore), s = (0, $hh2l2.m)(r.converter, t, n), a = (0, $hh2l2.n)(this._dataReader, "WriteBatch.set", r._key, s, null !== r.converter, n);
                return this._mutations.push(a.toMutation(r._key, (0, $hh2l2.P).none())), this;
            }
        },
        {
            key: "update",
            value: function update(e, t, n) {
                for(var _len = arguments.length, r = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
                    r[_key - 3] = arguments[_key];
                }
                this._verifyNotCommitted();
                var s = __PRIVATE_validateReference(e, this._firestore);
                // For Compat types, we have to "extract" the underlying types before
                // performing validation.
                var a;
                return a = "string" == typeof (t = (0, $hk14n.getModularInstance)(t)) || t instanceof (0, $hh2l2.o) ? (0, $hh2l2.p)(this._dataReader, "WriteBatch.update", s._key, t, n, r) : (0, $hh2l2.q)(this._dataReader, "WriteBatch.update", s._key, t), this._mutations.push(a.toMutation(s._key, (0, $hh2l2.P).exists(true))), this;
            }
        },
        {
            /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `WriteBatch` instance. Used for chaining method calls.
     */ key: "delete",
            value: function _delete(e) {
                this._verifyNotCommitted();
                var t = __PRIVATE_validateReference(e, this._firestore);
                return this._mutations = this._mutations.concat(new (0, $hh2l2.r)(t._key, (0, $hh2l2.P).none())), this;
            }
        },
        {
            /**
     * Commits all of the writes in this write batch as a single atomic unit.
     *
     * The result of these writes will only be reflected in document reads that
     * occur after the returned promise resolves. If the client is offline, the
     * write fails. If you would like to see local modifications or buffer writes
     * until the client is online, use the full Firestore SDK.
     *
     * @returns A `Promise` resolved once all of the writes in the batch have been
     * successfully written to the backend as an atomic unit (note that it won't
     * resolve while you're offline).
     */ key: "commit",
            value: function commit() {
                return this._verifyNotCommitted(), this._committed = true, this._mutations.length > 0 ? this._commitHandler(this._mutations) : Promise.resolve();
            }
        },
        {
            key: "_verifyNotCommitted",
            value: function _verifyNotCommitted() {
                if (this._committed) throw new (0, $hh2l2.f)((0, $hh2l2.t).FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
            }
        }
    ]);
    return WriteBatch;
}();
function __PRIVATE_validateReference(e$1, t) {
    if ((e$1 = (0, $hk14n.getModularInstance)(e$1)).firestore !== t) throw new (0, $hh2l2.f)((0, $hh2l2.t).INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
    return e$1;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO(mrschmidt) Consider using `BaseTransaction` as the base class in the
// legacy SDK.
/**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ var xe = /*#__PURE__*/ function() {
    "use strict";
    function Transaction(e, t) {
        (0, $4QweW._)(this, Transaction);
        this._firestore = e, this._transaction = t, this._dataReader = (0, $hh2l2.l)(e);
    }
    (0, $6hK4i._)(Transaction, [
        {
            /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ key: "get",
            value: function get(e) {
                var _this = this;
                var t = __PRIVATE_validateReference(e, this._firestore), n = new (0, $hh2l2.ad)(this._firestore);
                return this._transaction.lookup([
                    t._key
                ]).then(function(e) {
                    if (!e || 1 !== e.length) return (0, $hh2l2.ae)(24041);
                    var r = e[0];
                    if (r.isFoundDocument()) return new (0, $hh2l2.a5)(_this._firestore, n, r.key, r, t.converter);
                    if (r.isNoDocument()) return new (0, $hh2l2.a5)(_this._firestore, n, t._key, null, t.converter);
                    throw (0, $hh2l2.ae)(18433, {
                        doc: r
                    });
                });
            }
        },
        {
            key: "set",
            value: function set(e, t, n) {
                var r = __PRIVATE_validateReference(e, this._firestore), s = (0, $hh2l2.m)(r.converter, t, n), a = (0, $hh2l2.n)(this._dataReader, "Transaction.set", r._key, s, null !== r.converter, n);
                return this._transaction.set(r._key, a), this;
            }
        },
        {
            key: "update",
            value: function update(e, t, n) {
                for(var _len = arguments.length, r = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
                    r[_key - 3] = arguments[_key];
                }
                var s = __PRIVATE_validateReference(e, this._firestore);
                // For Compat types, we have to "extract" the underlying types before
                // performing validation.
                var a;
                return a = "string" == typeof (t = (0, $hk14n.getModularInstance)(t)) || t instanceof (0, $hh2l2.o) ? (0, $hh2l2.p)(this._dataReader, "Transaction.update", s._key, t, n, r) : (0, $hh2l2.q)(this._dataReader, "Transaction.update", s._key, t), this._transaction.update(s._key, a), this;
            }
        },
        {
            /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `Transaction` instance. Used for chaining method calls.
     */ key: "delete",
            value: function _delete(e) {
                var t = __PRIVATE_validateReference(e, this._firestore);
                return this._transaction.delete(t._key), this;
            }
        }
    ]);
    return Transaction;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ var Transaction = /*#__PURE__*/ function(xe) {
    "use strict";
    (0, $c2MhV._)(Transaction, xe);
    function Transaction(e, t) {
        (0, $4QweW._)(this, Transaction);
        var _this;
        _this = (0, $ehF45._)(this, Transaction, [
            e,
            t
        ]), _this._firestore = e;
        return _this;
    }
    (0, $6hK4i._)(Transaction, [
        {
            /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ key: "get",
            value: function get(e) {
                var _this = this;
                var t = __PRIVATE_validateReference(e, this._firestore), n = new (0, $hh2l2.u)(this._firestore);
                return (0, $hC9N3._)((0, $9atk1._)(Transaction.prototype), "get", this).call(this, e).then(function(e) {
                    return new (0, $hh2l2.D)(_this._firestore, n, t._key, e._document, new (0, $hh2l2.S)(/* hasPendingWrites= */ false, /* fromCache= */ false), t.converter);
                });
            }
        }
    ]);
    return Transaction;
}(xe);
/**
 * Executes the given `updateFunction` and then attempts to commit the changes
 * applied within the transaction. If any document read within the transaction
 * has changed, Cloud Firestore retries the `updateFunction`. If it fails to
 * commit after 5 attempts, the transaction fails.
 *
 * The maximum number of writes allowed in a single transaction is 500.
 *
 * @param firestore - A reference to the Firestore database to run this
 * transaction against.
 * @param updateFunction - The function to execute within the transaction
 * context.
 * @param options - An options object to configure maximum number of attempts to
 * commit.
 * @returns If the transaction completed successfully or was explicitly aborted
 * (the `updateFunction` returned a failed promise), the promise returned by the
 * `updateFunction `is returned here. Otherwise, if the transaction failed, a
 * rejected promise with the corresponding failure error is returned.
 */ function runTransaction(e$1, t, n) {
    e$1 = (0, $hh2l2.s)(e$1, (0, $hh2l2.d));
    var r = (0, $kWfK0._)({}, Qe, n);
    !function __PRIVATE_validateTransactionOptions(e$1) {
        if (e$1.maxAttempts < 1) throw new (0, $hh2l2.f)((0, $hh2l2.t).INVALID_ARGUMENT, "Max attempts must be at least 1");
    }(r);
    var s = (0, $hh2l2.x)(e$1);
    return (0, $hh2l2.$)(s, function(n) {
        return t(new Transaction(e$1, n));
    }, r);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Reads the document referred to by this `DocumentReference`.
 *
 * Note: `getDoc()` attempts to provide up-to-date data when possible by waiting
 * for data from the server, but it may return cached data or fail if you are
 * offline and the server cannot be reached. To specify this behavior, invoke
 * {@link getDocFromCache} or {@link getDocFromServer}.
 *
 * @param reference - The reference of the document to fetch.
 * @returns A `Promise` that resolves with a `DocumentSnapshot` containing the
 * document contents.
 */ function getDoc(e) {
    e = (0, $hh2l2.s)(e, (0, $hh2l2.I));
    var t = (0, $hh2l2.s)(e.firestore, (0, $hh2l2.d)), n = (0, $hh2l2.x)(t);
    return (0, $hh2l2.J)(n, e._key).then(function(n) {
        return __PRIVATE_convertToDocSnapshot(t, e, n);
    });
}
/**
 * Reads the document referred to by this `DocumentReference` from cache.
 * Returns an error if the document is not currently cached.
 *
 * @returns A `Promise` that resolves with a `DocumentSnapshot` containing the
 * document contents.
 */ function getDocFromCache(e) {
    e = (0, $hh2l2.s)(e, (0, $hh2l2.I));
    var t = (0, $hh2l2.s)(e.firestore, (0, $hh2l2.d)), n = (0, $hh2l2.x)(t), r = new (0, $hh2l2.u)(t);
    return (0, $hh2l2.L)(n, e._key).then(function(n) {
        return new (0, $hh2l2.D)(t, r, e._key, n, new (0, $hh2l2.S)(null !== n && n.hasLocalMutations, /* fromCache= */ true), e.converter);
    });
}
/**
 * Reads the document referred to by this `DocumentReference` from the server.
 * Returns an error if the network is not available.
 *
 * @returns A `Promise` that resolves with a `DocumentSnapshot` containing the
 * document contents.
 */ function getDocFromServer(e) {
    e = (0, $hh2l2.s)(e, (0, $hh2l2.I));
    var t = (0, $hh2l2.s)(e.firestore, (0, $hh2l2.d)), n = (0, $hh2l2.x)(t);
    return (0, $hh2l2.J)(n, e._key, {
        source: "server"
    }).then(function(n) {
        return __PRIVATE_convertToDocSnapshot(t, e, n);
    });
}
function getDocs(e) {
    e = (0, $hh2l2.s)(e, (0, $hh2l2.Q));
    var t = (0, $hh2l2.s)(e.firestore, (0, $hh2l2.d)), n = (0, $hh2l2.x)(t), r = new (0, $hh2l2.u)(t);
    return __PRIVATE_validateHasExplicitOrderByForLimitToLast(e._query), (0, $hh2l2.M)(n, e._query).then(function(n) {
        return new (0, $hh2l2.N)(t, r, e, n);
    });
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from cache.
 * Returns an empty result set if no documents matching the query are currently
 * cached.
 *
 * @returns A `Promise` that resolves with the results of the query.
 */ function getDocsFromCache(e) {
    e = (0, $hh2l2.s)(e, (0, $hh2l2.Q));
    var t = (0, $hh2l2.s)(e.firestore, (0, $hh2l2.d)), n = (0, $hh2l2.x)(t), r = new (0, $hh2l2.u)(t);
    return (0, $hh2l2.R)(n, e._query).then(function(n) {
        return new (0, $hh2l2.N)(t, r, e, n);
    });
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from the
 * server. Returns an error if the network is not available.
 *
 * @returns A `Promise` that resolves with the results of the query.
 */ function getDocsFromServer(e) {
    e = (0, $hh2l2.s)(e, (0, $hh2l2.Q));
    var t = (0, $hh2l2.s)(e.firestore, (0, $hh2l2.d)), n = (0, $hh2l2.x)(t), r = new (0, $hh2l2.u)(t);
    return (0, $hh2l2.M)(n, e._query, {
        source: "server"
    }).then(function(n) {
        return new (0, $hh2l2.N)(t, r, e, n);
    });
}
function setDoc(e, t, n) {
    e = (0, $hh2l2.s)(e, (0, $hh2l2.I));
    var r = (0, $hh2l2.s)(e.firestore, (0, $hh2l2.d)), s = (0, $hh2l2.m)(e.converter, t, n), a = (0, $hh2l2.l)(r);
    return executeWrite(r, [
        (0, $hh2l2.n)(a, "setDoc", e._key, s, null !== e.converter, n).toMutation(e._key, (0, $hh2l2.P).none())
    ]);
}
function updateDoc(e, t, n) {
    for(var _len = arguments.length, r = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
        r[_key - 3] = arguments[_key];
    }
    e = (0, $hh2l2.s)(e, (0, $hh2l2.I));
    var s = (0, $hh2l2.s)(e.firestore, (0, $hh2l2.d)), a = (0, $hh2l2.l)(s);
    var o;
    o = "string" == typeof // For Compat types, we have to "extract" the underlying types before
    // performing validation.
    (t = (0, $hk14n.getModularInstance)(t)) || t instanceof (0, $hh2l2.o) ? (0, $hh2l2.p)(a, "updateDoc", e._key, t, n, r) : (0, $hh2l2.q)(a, "updateDoc", e._key, t);
    return executeWrite(s, [
        o.toMutation(e._key, (0, $hh2l2.P).exists(true))
    ]);
}
/**
 * Deletes the document referred to by the specified `DocumentReference`.
 *
 * Note that the returned `Promise` does _not_ resolve until the document is
 * successfully deleted from the remote Firestore backend and, similarly, is not
 * rejected until the remote Firestore backend reports an error deleting the given
 * document. So if the client cannot reach the backend (for example, due to being
 * offline) then the returned `Promise` will not resolve for a potentially-long
 * time (for example, until the client has gone back online). That being said,
 * the given data _will_ be immediately deleted from the local cache and will be
 * reflected in future "get" operations as if it had been successfully
 * deleted from the remote Firestore server, a feature of Firestore called
 * "latency compensation". The document will _eventually_ be deleted from the remote
 * Firestore backend once a connection can be established. Therefore, it is
 * usually undesirable to `await` the `Promise` returned from this function
 * because the indefinite amount of time before which the promise resolves or
 * rejects can block application logic unnecessarily.
 *
 * @param reference - A reference to the document to delete.
 * @returns A `Promise` that resolves once the document has been successfully
 * deleted from the backend or rejects once the backend reports an error
 * deleting the document.
 */ function deleteDoc(e) {
    return executeWrite((0, $hh2l2.s)(e.firestore, (0, $hh2l2.d)), [
        new (0, $hh2l2.r)(e._key, (0, $hh2l2.P).none())
    ]);
}
/**
 * Add a new document to specified `CollectionReference` with the given data,
 * assigning it a document ID automatically.
 *
 * Note that the returned `Promise` does _not_ resolve until the document is
 * successfully created to the remote Firestore backend and, similarly, is not
 * rejected until the remote Firestore backend reports an error creating the given
 * document. So if the client cannot reach the backend (for example, due to being
 * offline) then the returned `Promise` will not resolve for a potentially-long
 * time (for example, until the client has gone back online). That being said,
 * the given document _will_ be immediately created in the local cache and will be
 * incorporated into future "get" operations as if it had been successfully
 * created in the remote Firestore server, a feature of Firestore called
 * "latency compensation". The document will _eventually_ be created in the remote
 * Firestore backend once a connection can be established. Therefore, it is
 * usually undesirable to `await` the `Promise` returned from this function
 * because the indefinite amount of time before which the promise resolves or
 * rejects can block application logic unnecessarily.
 *
 * @param reference - A reference to the collection to add this document to.
 * @param data - An Object containing the data for the new document.
 * @returns A `Promise` that resolves once the docoument has been successfully
 * created in the backend or rejects once the backend reports an error creating
 * the document.
 */ function addDoc(e, t) {
    var n = (0, $hh2l2.s)(e.firestore, (0, $hh2l2.d)), r = (0, $hh2l2.v)(e), s = (0, $hh2l2.m)(e.converter, t), a = (0, $hh2l2.l)(e.firestore);
    return executeWrite(n, [
        (0, $hh2l2.n)(a, "addDoc", r._key, s, null !== e.converter, {}).toMutation(r._key, (0, $hh2l2.P).exists(false))
    ]).then(function() {
        return r;
    });
}
function onSnapshot(e) {
    for(var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        t[_key - 1] = arguments[_key];
    }
    // onSnapshot for Query or Document.
    e = (0, $hk14n.getModularInstance)(e);
    var n = {
        includeMetadataChanges: false,
        source: "default"
    }, r = 0;
    "object" != (0, $5djcY._)(t[r]) || __PRIVATE_isPartialObserver(t[r]) || (n = t[r++]);
    var s = {
        includeMetadataChanges: n.includeMetadataChanges,
        source: n.source
    };
    if (__PRIVATE_isPartialObserver(t[r])) {
        var _e_next, _e_error, _e_complete;
        var _$e = t[r];
        t[r] = (_e_next = _$e.next) === null || _e_next === void 0 ? void 0 : _e_next.bind(_$e), t[r + 1] = (_e_error = _$e.error) === null || _e_error === void 0 ? void 0 : _e_error.bind(_$e), t[r + 2] = (_e_complete = _$e.complete) === null || _e_complete === void 0 ? void 0 : _e_complete.bind(_$e);
    }
    var a, i, c;
    if (e instanceof (0, $hh2l2.I)) i = (0, $hh2l2.s)(e.firestore, (0, $hh2l2.d)), c = (0, $hh2l2.U)(e._key.path), a = {
        next: function(n) {
            t[r] && t[r](__PRIVATE_convertToDocSnapshot(i, e, n));
        },
        error: t[r + 1],
        complete: t[r + 2]
    };
    else {
        var n1 = (0, $hh2l2.s)(e, (0, $hh2l2.Q));
        i = (0, $hh2l2.s)(n1.firestore, (0, $hh2l2.d)), c = n1._query;
        var s1 = new (0, $hh2l2.u)(i);
        a = {
            next: function(e) {
                t[r] && t[r](new (0, $hh2l2.N)(i, s1, n1, e));
            },
            error: t[r + 1],
            complete: t[r + 2]
        }, __PRIVATE_validateHasExplicitOrderByForLimitToLast(e._query);
    }
    var u = (0, $hh2l2.x)(i);
    return (0, $hh2l2.V)(u, c, s, a);
}
function onSnapshotResume(e$1, t) {
    for(var _len = arguments.length, n = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        n[_key - 2] = arguments[_key];
    }
    var r = (0, $hk14n.getModularInstance)(e$1), s = /**
 * Ensures the data required to construct an {@link onSnapshot} listener exist in a `snapshotJson`
 * object that originates from {@link DocumentSnapshot.toJSON} or {@link Querysnapshot.toJSON}. The
 * data is normalized into a typed object.
 *
 * @param snapshotJson - The JSON object that the app provided to {@link onSnapshot}.
 * @returns A normalized object that contains all of the required bundle JSON fields. If
 * {@link snapshotJson} doesn't contain the required fields, or if the fields exist as empty
 * strings, then the {@link snapshotJson.error} field will be a non empty string.
 *
 * @internal
 */ function __PRIVATE_normalizeSnapshotJsonFields(e) {
        var _$t = {
            bundle: "",
            bundleName: "",
            bundleSource: ""
        }, n = [
            "bundle",
            "bundleName",
            "bundleSource"
        ];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var r = _step.value;
                if (!(r in e)) {
                    _$t.error = "snapshotJson missing required field: ".concat(r);
                    break;
                }
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var n1 = e[r];
                if ("string" != typeof n1) {
                    _$t.error = "snapshotJson field '".concat(r, "' must be a string.");
                    break;
                }
                if (0 === n1.length) {
                    _$t.error = "snapshotJson field '".concat(r, "' cannot be an empty string.");
                    break;
                }
                "bundle" === r ? _$t.bundle = n1 : "bundleName" === r ? _$t.bundleName = n1 : "bundleSource" === r && (_$t.bundleSource = n1);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _$t;
    }(t);
    if (s.error) throw new (0, $hh2l2.f)((0, $hh2l2.t).INVALID_ARGUMENT, s.error);
    var a, o = 0;
    if ("object" != (0, $5djcY._)(n[o]) || __PRIVATE_isPartialObserver(n[o]) || (a = n[o++]), "QuerySnapshot" === s.bundleSource) {
        var _$e = null;
        if ("object" == (0, $5djcY._)(n[o]) && __PRIVATE_isPartialObserver(n[o])) {
            var _$t = n[o++];
            _$e = {
                next: _$t.next,
                error: _$t.error,
                complete: _$t.complete
            };
        } else _$e = {
            next: n[o++],
            error: n[o++],
            complete: n[o++]
        };
        /**
 * Loads the bundle in a separate task and then invokes {@link onSnapshot} with a
 * {@link Query} that represents the Query in the bundle.
 *
 * @param firestore - The {@link Firestore} instance for the {@link onSnapshot} operation request.
 * @param json - The JSON bundle to load, produced by {@link QuerySnapshot.toJSON}.
 * @param options - Options controlling the listen behavior.
 * @param observer - A single object containing `next` and `error` callbacks.
 * @param converter - An optional object that converts objects from Firestore before the onNext
 * listener is invoked.
 * @returns An unsubscribe function that can be called to cancel the snapshot
 * listener.
 *
 * @internal
 */ return function __PRIVATE_onSnapshotQuerySnapshotBundle(e, t, n, r, s) {
            var a, o = false;
            var i = (0, $hh2l2.W)(e, t.bundle);
            return i.then(function() {
                return (0, $hh2l2.X)(e, t.bundleName);
            }).then(function(e) {
                if (e && !o) s && e.withConverter(s), a = onSnapshot(e, n || {}, r);
            }).catch(function(e) {
                return r.error && r.error(e), function() {};
            }), function() {
                o || (o = true, a && a());
            };
        }(r, s, a, _$e, n[o]);
    }
    if ("DocumentSnapshot" === s.bundleSource) {
        var _$e1 = null;
        if ("object" == (0, $5djcY._)(n[o]) && __PRIVATE_isPartialObserver(n[o])) {
            var _$t1 = n[o++];
            _$e1 = {
                next: _$t1.next,
                error: _$t1.error,
                complete: _$t1.complete
            };
        } else _$e1 = {
            next: n[o++],
            error: n[o++],
            complete: n[o++]
        };
        return function __PRIVATE_onSnapshotDocumentSnapshotBundle(e, t, n, r, s) {
            var a, o = false;
            var i = (0, $hh2l2.W)(e, t.bundle);
            return i.then(function() {
                if (!o) {
                    var o1 = new (0, $hh2l2.I)(e, s || null, (0, $hh2l2.Y).fromPath(t.bundleName));
                    a = onSnapshot(o1, n || {}, r);
                }
            }).catch(function(e) {
                return r.error && r.error(e), function() {};
            }), function() {
                o || (o = true, a && a());
            };
        }(r, s, a, _$e1, n[o]);
    }
    throw new (0, $hh2l2.f)((0, $hh2l2.t).INVALID_ARGUMENT, "unsupported bundle source: ".concat(s.bundleSource));
}
function onSnapshotsInSync(e, t) {
    e = (0, $hh2l2.s)(e, (0, $hh2l2.d));
    var n = (0, $hh2l2.x)(e), r = __PRIVATE_isPartialObserver(t) ? t : {
        next: t
    };
    return (0, $hh2l2.Z)(n, r);
}
/**
 * Locally writes `mutations` on the async queue.
 * @internal
 */ function executeWrite(e, t) {
    var n = (0, $hh2l2.x)(e);
    return (0, $hh2l2.B)(n, t);
}
/**
 * Converts a {@link ViewSnapshot} that contains the single document specified by `ref`
 * to a {@link DocumentSnapshot}.
 */ function __PRIVATE_convertToDocSnapshot(e, t, n) {
    var r = n.docs.get(t._key), s = new (0, $hh2l2.u)(e);
    return new (0, $hh2l2.D)(e, s, t._key, r, new (0, $hh2l2.S)(n.hasPendingWrites, n.fromCache), t.converter);
}
function writeBatch(e) {
    return e = (0, $hh2l2.s)(e, (0, $hh2l2.d)), (0, $hh2l2.x)(e), new WriteBatch(e, function(t) {
        return executeWrite(e, t);
    });
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function setIndexConfiguration(e$1, t) {
    e$1 = (0, $hh2l2.s)(e$1, (0, $hh2l2.d));
    var n = (0, $hh2l2.x)(e$1);
    if (!n._uninitializedComponentsProvider || "memory" === n._uninitializedComponentsProvider._offline.kind) // PORTING NOTE: We don't return an error if the user has not enabled
    // persistence since `enableIndexeddbPersistence()` can fail on the Web.
    return (0, $hh2l2.A)("Cannot enable indexes when persistence is disabled"), Promise.resolve();
    var r = function __PRIVATE_parseIndexes(e$1) {
        var _$t = "string" == typeof e$1 ? function __PRIVATE_tryParseJson(e$1) {
            try {
                return JSON.parse(e$1);
            } catch (e$1) {
                throw new (0, $hh2l2.f)((0, $hh2l2.t).INVALID_ARGUMENT, "Failed to parse JSON: " + (e$1 === null || e$1 === void 0 ? void 0 : e$1.message));
            }
        }(e$1) : e$1, n = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (Array.isArray(_$t.indexes)) try {
            for(var _iterator = _$t.indexes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var e1 = _step.value;
                var _$t1 = __PRIVATE_tryGetString(e1, "collectionGroup"), r = [];
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                if (Array.isArray(e1.fields)) try {
                    for(var _iterator1 = e1.fields[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _$t2 = _step1.value;
                        var e2 = __PRIVATE_tryGetString(_$t2, "fieldPath"), n1 = (0, $hh2l2.a0)("setIndexConfiguration", e2);
                        "CONTAINS" === _$t2.arrayConfig ? r.push(new (0, $hh2l2.a1)(n1, 2 /* IndexKind.CONTAINS */ )) : "ASCENDING" === _$t2.order ? r.push(new (0, $hh2l2.a1)(n1, 0 /* IndexKind.ASCENDING */ )) : "DESCENDING" === _$t2.order && r.push(new (0, $hh2l2.a1)(n1, 1 /* IndexKind.DESCENDING */ ));
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                n.push(new (0, $hh2l2.a2)((0, $hh2l2.a2).UNKNOWN_ID, _$t1, r, (0, $hh2l2.a3).empty()));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return n;
    }(t);
    return (0, $hh2l2.a4)(n, r);
}
function __PRIVATE_tryGetString(e$1, t) {
    if ("string" != typeof e$1[t]) throw new (0, $hh2l2.f)((0, $hh2l2.t).INVALID_ARGUMENT, "Missing string value for: " + t);
    return e$1[t];
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `PersistentCacheIndexManager` for configuring persistent cache indexes used
 * for local query execution.
 *
 * To use, call `getPersistentCacheIndexManager()` to get an instance.
 */ var PersistentCacheIndexManager = function PersistentCacheIndexManager(e) {
    "use strict";
    (0, $4QweW._)(this, PersistentCacheIndexManager);
    this._firestore = e, /** A type string to uniquely identify instances of this class. */ this.type = "PersistentCacheIndexManager";
};
/**
 * Returns the PersistentCache Index Manager used by the given `Firestore`
 * object.
 *
 * @returns The `PersistentCacheIndexManager` instance, or `null` if local
 * persistent storage is not in use.
 */ function getPersistentCacheIndexManager(e) {
    var _n__uninitializedComponentsProvider;
    e = (0, $hh2l2.s)(e, (0, $hh2l2.d));
    var t = De.get(e);
    if (t) return t;
    var n = (0, $hh2l2.x)(e);
    if ("persistent" !== ((_n__uninitializedComponentsProvider = n._uninitializedComponentsProvider) === null || _n__uninitializedComponentsProvider === void 0 ? void 0 : _n__uninitializedComponentsProvider._offline.kind)) return null;
    var r = new PersistentCacheIndexManager(e);
    return De.set(e, r), r;
}
/**
 * Enables the SDK to create persistent cache indexes automatically for local
 * query execution when the SDK believes cache indexes can help improve
 * performance.
 *
 * This feature is disabled by default.
 */ function enablePersistentCacheIndexAutoCreation(e) {
    __PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, true);
}
/**
 * Stops creating persistent cache indexes automatically for local query
 * execution. The indexes which have been created by calling
 * `enablePersistentCacheIndexAutoCreation()` still take effect.
 */ function disablePersistentCacheIndexAutoCreation(e) {
    __PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, false);
}
/**
 * Removes all persistent cache indexes.
 *
 * Please note this function will also deletes indexes generated by
 * `setIndexConfiguration()`, which is deprecated.
 */ function deleteAllPersistentCacheIndexes(e) {
    var t = (0, $hh2l2.x)(e._firestore);
    (0, $hh2l2.y)(t).then(function(e) {
        return (0, $hh2l2.z)("deleting all persistent cache indexes succeeded");
    }).catch(function(e) {
        return (0, $hh2l2.A)("deleting all persistent cache indexes failed", e);
    });
}
function __PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, t) {
    var n = (0, $hh2l2.x)(e._firestore);
    (0, $hh2l2.ag)(n, t).then(function(e) {
        return (0, $hh2l2.z)("setting persistent cache index auto creation isEnabled=".concat(t, " succeeded"));
    }).catch(function(e) {
        return (0, $hh2l2.A)("setting persistent cache index auto creation isEnabled=".concat(t, " failed"), e);
    });
}
/**
 * Maps `Firestore` instances to their corresponding
 * `PersistentCacheIndexManager` instances.
 *
 * Use a `WeakMap` so that the mapping will be automatically dropped when the
 * `Firestore` instance is garbage collected. This emulates a private member
 * as described in https://goo.gle/454yvug.
 */ var De = new WeakMap;
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Testing hooks for use by Firestore's integration test suite to reach into the
 * SDK internals to validate logic and behavior that is not visible from the
 * public API surface.
 *
 * @internal
 */ var TestingHooks = /*#__PURE__*/ function() {
    "use strict";
    function TestingHooks() {
        (0, $4QweW._)(this, TestingHooks);
        throw new Error("instances of this class should not be created");
    }
    (0, $6hK4i._)(TestingHooks, null, [
        {
            key: "onExistenceFilterMismatch",
            value: /**
     * Registers a callback to be notified when an existence filter mismatch
     * occurs in the Watch listen stream.
     *
     * The relative order in which callbacks are notified is unspecified; do not
     * rely on any particular ordering. If a given callback is registered multiple
     * times then it will be notified multiple times, once per registration.
     *
     * @param callback - the callback to invoke upon existence filter mismatch.
     *
     * @returns a function that, when called, unregisters the given callback; only
     * the first invocation of the returned function does anything; all subsequent
     * invocations do nothing.
     */ function onExistenceFilterMismatch(e) {
                return __PRIVATE_TestingHooksSpiImpl.instance.onExistenceFilterMismatch(e);
            }
        }
    ]);
    return TestingHooks;
}();
/**
 * The implementation of `TestingHooksSpi`.
 */ var __PRIVATE_TestingHooksSpiImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_TestingHooksSpiImpl() {
        (0, $4QweW._)(this, __PRIVATE_TestingHooksSpiImpl);
        this.t = new Map;
    }
    (0, $6hK4i._)(__PRIVATE_TestingHooksSpiImpl, [
        {
            key: "Ae",
            value: function Ae(e) {
                this.t.forEach(function(t) {
                    return t(e);
                });
            }
        },
        {
            key: "onExistenceFilterMismatch",
            value: function onExistenceFilterMismatch(e) {
                var t = Symbol(), n = this.t;
                return n.set(t, e), function() {
                    return n.delete(t);
                };
            }
        }
    ], [
        {
            key: "instance",
            get: function get() {
                return qe || (qe = new __PRIVATE_TestingHooksSpiImpl, (0, $hh2l2.af)(qe)), qe;
            }
        }
    ]);
    return __PRIVATE_TestingHooksSpiImpl;
}();
var qe = null;
var Be = "@firebase/firestore", Me = "4.17.2";
/**
 * Cloud Firestore
 *
 * @packageDocumentation
 */ !/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function __PRIVATE_registerFirestore(s) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    (0, $hh2l2.am)((0, $wQDEL.SDK_VERSION)), (0, $wQDEL._registerComponent)(new (0, $9xcZw.Component)("firestore", function(e, param) {
        var t = param.instanceIdentifier, n = param.options;
        var r = e.getProvider("app").getImmediate(), _$s = new (0, $hh2l2.d)(new (0, $hh2l2._)(e.getProvider("auth-internal")), new (0, $hh2l2.a)(r, e.getProvider("app-check-internal")), (0, $hh2l2.b)(r, t), r);
        return n = (0, $kWfK0._)({
            useFetchStreams: a
        }, n), _$s._setSettings(n), _$s;
    }, "PUBLIC").setMultipleInstances(true)), (0, $wQDEL.registerVersion)(Be, Me, s), // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, $wQDEL.registerVersion)(Be, Me, "esm2020");
}();

});
parcelRegister("ehF45", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a66281e0cb61a131$export$71511d61b312f219; });

var $9atk1 = parcelRequire("9atk1");

var $guZS9 = parcelRequire("guZS9");

var $hvep1 = parcelRequire("hvep1");
function $a66281e0cb61a131$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $9atk1._)(derived);
    return (0, $hvep1._)(_this, (0, $guZS9._)() ? Reflect.construct(derived, args || [], (0, $9atk1._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("9atk1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6acbcaee24263e7e$export$71511d61b312f219; });
function $6acbcaee24263e7e$export$71511d61b312f219(o) {
    $6acbcaee24263e7e$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6acbcaee24263e7e$export$71511d61b312f219(o);
}

});

parcelRegister("guZS9", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c02f7145f7333f96$export$71511d61b312f219; });
function $c02f7145f7333f96$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($c02f7145f7333f96$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("hvep1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cbe080f489d283a9$export$71511d61b312f219; });

var $kE8SG = parcelRequire("kE8SG");

var $5djcY = parcelRequire("5djcY");
function $cbe080f489d283a9$export$71511d61b312f219(self, call) {
    if (call && ((0, $5djcY._)(call) === "object" || typeof call === "function")) return call;
    return (0, $kE8SG._)(self);
}

});
parcelRegister("kE8SG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f07e6eacebc6356c$export$71511d61b312f219; });
function $f07e6eacebc6356c$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("4QweW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $387506f4e8043722$export$71511d61b312f219; });
function $387506f4e8043722$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("6hK4i", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $493810cfcf480a5a$export$71511d61b312f219; });
function $493810cfcf480a5a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $493810cfcf480a5a$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $493810cfcf480a5a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $493810cfcf480a5a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("hC9N3", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cd2d94639e35f6ff$export$71511d61b312f219; });

var $3wHsP = parcelRequire("3wHsP");
function $cd2d94639e35f6ff$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $cd2d94639e35f6ff$export$71511d61b312f219 = Reflect.get;
    else $cd2d94639e35f6ff$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $3wHsP._)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $cd2d94639e35f6ff$export$71511d61b312f219(target, property, receiver || target);
}

});
parcelRegister("3wHsP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2916134f4529eca2$export$71511d61b312f219; });

var $9atk1 = parcelRequire("9atk1");
function $2916134f4529eca2$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $9atk1._)(object);
        if (object === null) break;
    }
    return object;
}

});


parcelRegister("c2MhV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8c4b20f88f3acc70$export$71511d61b312f219; });

var $lwwt5 = parcelRequire("lwwt5");
function $8c4b20f88f3acc70$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $lwwt5._)(subClass, superClass);
}

});
parcelRegister("lwwt5", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fab5c5a3fca5294c$export$71511d61b312f219; });
function $fab5c5a3fca5294c$export$71511d61b312f219(o, p) {
    $fab5c5a3fca5294c$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $fab5c5a3fca5294c$export$71511d61b312f219(o, p);
}

});


parcelRegister("wQDEL", function(module, exports) {

$parcel$export(module.exports, "_registerComponent", function () { return $062bd234f7a7c2eb$export$c930050e7bb63965; });
$parcel$export(module.exports, "_getProvider", function () { return $062bd234f7a7c2eb$export$fa0d6da0f5838f50; });
$parcel$export(module.exports, "_removeServiceInstance", function () { return $062bd234f7a7c2eb$export$48d18de2ff1c45a5; });
$parcel$export(module.exports, "_isFirebaseServerApp", function () { return $062bd234f7a7c2eb$export$643c8bc6c389f34e; });
$parcel$export(module.exports, "registerVersion", function () { return $062bd234f7a7c2eb$export$d29d5299a7137abc; });
$parcel$export(module.exports, "SDK_VERSION", function () { return $062bd234f7a7c2eb$export$31499a9cd224b78c; });
$parcel$export(module.exports, "initializeApp", function () { return $062bd234f7a7c2eb$export$c55cfd413944906d; });
$parcel$export(module.exports, "getApp", function () { return $062bd234f7a7c2eb$export$f9962582c9e66d99; });

var $kE8SG = parcelRequire("kE8SG");

var $dxEC4 = parcelRequire("dxEC4");

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $6tY97 = parcelRequire("6tY97");

var $c2MhV = parcelRequire("c2MhV");

var $kWfK0 = parcelRequire("kWfK0");

var $jlUaU = parcelRequire("jlUaU");

var $5djcY = parcelRequire("5djcY");

var $gh3Df = parcelRequire("gh3Df");

var $9xcZw = parcelRequire("9xcZw");

var $5eJAc = parcelRequire("5eJAc");

var $hk14n = parcelRequire("hk14n");

var $bpmtn = parcelRequire("bpmtn");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $062bd234f7a7c2eb$var$PlatformLoggerServiceImpl = /*#__PURE__*/ function() {
    "use strict";
    function PlatformLoggerServiceImpl(container) {
        (0, $4QweW._)(this, PlatformLoggerServiceImpl);
        this.container = container;
    }
    (0, $6hK4i._)(PlatformLoggerServiceImpl, [
        {
            // In initial implementation, this will be called by installations on
            // auth token refresh, and installations will send this string.
            key: "getPlatformInfoString",
            value: function getPlatformInfoString() {
                var providers = this.container.getProviders();
                // Loop through providers and get library/version pairs from any that are
                // version components.
                return providers.map(function(provider) {
                    if ($062bd234f7a7c2eb$var$isVersionServiceProvider(provider)) {
                        var service = provider.getImmediate();
                        return "".concat(service.library, "/").concat(service.version);
                    } else return null;
                }).filter(function(logString) {
                    return logString;
                }).join(' ');
            }
        }
    ]);
    return PlatformLoggerServiceImpl;
}();
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $062bd234f7a7c2eb$var$isVersionServiceProvider(provider) {
    var component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
var $062bd234f7a7c2eb$var$name$q = "@firebase/app";
var $062bd234f7a7c2eb$var$version$1 = "0.16.2";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $062bd234f7a7c2eb$var$logger = new (0, $5eJAc.Logger)('@firebase/app');
var $062bd234f7a7c2eb$var$name$p = "@firebase/app-compat";
var $062bd234f7a7c2eb$var$name$o = "@firebase/analytics-compat";
var $062bd234f7a7c2eb$var$name$n = "@firebase/analytics";
var $062bd234f7a7c2eb$var$name$m = "@firebase/app-check-compat";
var $062bd234f7a7c2eb$var$name$l = "@firebase/app-check";
var $062bd234f7a7c2eb$var$name$k = "@firebase/auth";
var $062bd234f7a7c2eb$var$name$j = "@firebase/auth-compat";
var $062bd234f7a7c2eb$var$name$i = "@firebase/database";
var $062bd234f7a7c2eb$var$name$h = "@firebase/data-connect";
var $062bd234f7a7c2eb$var$name$g = "@firebase/database-compat";
var $062bd234f7a7c2eb$var$name$f = "@firebase/functions";
var $062bd234f7a7c2eb$var$name$e = "@firebase/functions-compat";
var $062bd234f7a7c2eb$var$name$d = "@firebase/installations";
var $062bd234f7a7c2eb$var$name$c = "@firebase/installations-compat";
var $062bd234f7a7c2eb$var$name$b = "@firebase/messaging";
var $062bd234f7a7c2eb$var$name$a = "@firebase/messaging-compat";
var $062bd234f7a7c2eb$var$name$9 = "@firebase/performance";
var $062bd234f7a7c2eb$var$name$8 = "@firebase/performance-compat";
var $062bd234f7a7c2eb$var$name$7 = "@firebase/remote-config";
var $062bd234f7a7c2eb$var$name$6 = "@firebase/remote-config-compat";
var $062bd234f7a7c2eb$var$name$5 = "@firebase/storage";
var $062bd234f7a7c2eb$var$name$4 = "@firebase/storage-compat";
var $062bd234f7a7c2eb$var$name$3 = "@firebase/firestore";
var $062bd234f7a7c2eb$var$name$2 = "@firebase/ai";
var $062bd234f7a7c2eb$var$name$1 = "@firebase/firestore-compat";
var $062bd234f7a7c2eb$var$name = "firebase";
var $062bd234f7a7c2eb$var$version = "12.19.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ var $062bd234f7a7c2eb$export$9f30fa0c10967f7f = '[DEFAULT]';
var $062bd234f7a7c2eb$var$_obj;
var $062bd234f7a7c2eb$var$PLATFORM_LOG_STRING = ($062bd234f7a7c2eb$var$_obj = {}, (0, $6tY97._)($062bd234f7a7c2eb$var$_obj, $062bd234f7a7c2eb$var$name$q, 'fire-core'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj, $062bd234f7a7c2eb$var$name$p, 'fire-core-compat'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj, $062bd234f7a7c2eb$var$name$n, 'fire-analytics'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj, $062bd234f7a7c2eb$var$name$o, 'fire-analytics-compat'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj, $062bd234f7a7c2eb$var$name$l, 'fire-app-check'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj, $062bd234f7a7c2eb$var$name$m, 'fire-app-check-compat'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj, $062bd234f7a7c2eb$var$name$k, 'fire-auth'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj, $062bd234f7a7c2eb$var$name$j, 'fire-auth-compat'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj, $062bd234f7a7c2eb$var$name$i, 'fire-rtdb'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj, $062bd234f7a7c2eb$var$name$h, 'fire-data-connect'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj, $062bd234f7a7c2eb$var$name$g, 'fire-rtdb-compat'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj, $062bd234f7a7c2eb$var$name$f, 'fire-fn'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj, $062bd234f7a7c2eb$var$name$e, 'fire-fn-compat'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj, $062bd234f7a7c2eb$var$name$d, 'fire-iid'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj, $062bd234f7a7c2eb$var$name$c, 'fire-iid-compat'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj, $062bd234f7a7c2eb$var$name$b, 'fire-fcm'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj, $062bd234f7a7c2eb$var$name$a, 'fire-fcm-compat'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj, $062bd234f7a7c2eb$var$name$9, 'fire-perf'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj, $062bd234f7a7c2eb$var$name$8, 'fire-perf-compat'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj, $062bd234f7a7c2eb$var$name$7, 'fire-rc'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj, $062bd234f7a7c2eb$var$name$6, 'fire-rc-compat'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj, $062bd234f7a7c2eb$var$name$5, 'fire-gcs'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj, $062bd234f7a7c2eb$var$name$4, 'fire-gcs-compat'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj, $062bd234f7a7c2eb$var$name$3, 'fire-fst'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj, $062bd234f7a7c2eb$var$name$1, 'fire-fst-compat'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj, $062bd234f7a7c2eb$var$name$2, 'fire-vertex'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj, 'fire-js', 'fire-js'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj, $062bd234f7a7c2eb$var$name, 'fire-js-all'), $062bd234f7a7c2eb$var$_obj);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ var $062bd234f7a7c2eb$export$b4e3c36c855b14b5 = new Map();
/**
 * @internal
 */ var $062bd234f7a7c2eb$export$fb03ad8d3d5c5f76 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var $062bd234f7a7c2eb$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $062bd234f7a7c2eb$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $062bd234f7a7c2eb$var$logger.debug("Component ".concat(component.name, " failed to register with FirebaseApp ").concat(app.name), e);
    }
}
/**
 *
 * @internal
 */ function $062bd234f7a7c2eb$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $062bd234f7a7c2eb$export$c930050e7bb63965(component) {
    var componentName = component.name;
    if ($062bd234f7a7c2eb$export$9566bce3835c0f28.has(componentName)) {
        $062bd234f7a7c2eb$var$logger.debug("There were multiple attempts to register component ".concat(componentName, "."));
        return false;
    }
    $062bd234f7a7c2eb$export$9566bce3835c0f28.set(componentName, component);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // add the component to existing app instances
        for(var _iterator = $062bd234f7a7c2eb$export$b4e3c36c855b14b5.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var app = _step.value;
            $062bd234f7a7c2eb$export$fa5244b94c62d36a(app, component);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = $062bd234f7a7c2eb$export$fb03ad8d3d5c5f76.values()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var serverApp = _step1.value;
            $062bd234f7a7c2eb$export$fa5244b94c62d36a(serverApp, component);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $062bd234f7a7c2eb$export$fa0d6da0f5838f50(app, name) {
    var heartbeatController = app.container.getProvider('heartbeat').getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $062bd234f7a7c2eb$export$48d18de2ff1c45a5(app, name) {
    var instanceIdentifier = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $062bd234f7a7c2eb$export$9f30fa0c10967f7f;
    $062bd234f7a7c2eb$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp, FirebaseOptions or FirebaseAppSettings.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function $062bd234f7a7c2eb$export$110778f8e98b8257(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp, FirebaseOptions or FirebaseAppSettings.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $062bd234f7a7c2eb$export$38e311c93c671bec(obj) {
    if ($062bd234f7a7c2eb$export$110778f8e98b8257(obj)) return false;
    return 'authIdToken' in obj || 'appCheckToken' in obj || 'releaseOnDeref' in obj || 'automaticDataCollectionEnabled' in obj;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $062bd234f7a7c2eb$export$643c8bc6c389f34e(obj) {
    if (obj === null || obj === undefined) return false;
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function $062bd234f7a7c2eb$export$3685d89b9c3cdfaf() {
    $062bd234f7a7c2eb$export$9566bce3835c0f28.clear();
}
var $062bd234f7a7c2eb$var$_obj1;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $062bd234f7a7c2eb$var$ERRORS = ($062bd234f7a7c2eb$var$_obj1 = {}, (0, $6tY97._)($062bd234f7a7c2eb$var$_obj1, "no-app" /* AppError.NO_APP */ , "No Firebase App '{$appName}' has been created - call initializeApp() first"), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj1, "bad-app-name" /* AppError.BAD_APP_NAME */ , "Illegal App name: '{$appName}'"), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj1, "duplicate-app" /* AppError.DUPLICATE_APP */ , "Firebase App named '{$appName}' already exists with different {$mismatchedParam}. Existing: '{$oldValue}'. New: '{$newValue}'."), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj1, "app-deleted" /* AppError.APP_DELETED */ , "Firebase App named '{$appName}' already deleted"), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj1, "server-app-deleted" /* AppError.SERVER_APP_DELETED */ , 'Firebase Server App has been deleted'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj1, "no-options" /* AppError.NO_OPTIONS */ , 'Need to provide options, when not being deployed to hosting via source.'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj1, "invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ , "firebase.{$appName}() takes either no argument or a Firebase App instance."), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj1, "invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ , 'First argument to `onLog` must be null or a function.'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj1, "idb-open" /* AppError.IDB_OPEN */ , 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj1, "idb-get" /* AppError.IDB_GET */ , 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj1, "idb-set" /* AppError.IDB_WRITE */ , 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj1, "idb-delete" /* AppError.IDB_DELETE */ , 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj1, "finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , 'FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.'), (0, $6tY97._)($062bd234f7a7c2eb$var$_obj1, "invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ , 'FirebaseServerApp is not for use in browser environments.'), $062bd234f7a7c2eb$var$_obj1);
var $062bd234f7a7c2eb$var$ERROR_FACTORY = new (0, $hk14n.ErrorFactory)('app', 'Firebase', $062bd234f7a7c2eb$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $062bd234f7a7c2eb$var$FirebaseAppImpl = /*#__PURE__*/ function() {
    "use strict";
    function FirebaseAppImpl(options, config, container) {
        var _this = this;
        (0, $4QweW._)(this, FirebaseAppImpl);
        this._isDeleted = false;
        this._options = (0, $kWfK0._)({}, options);
        this._config = (0, $kWfK0._)({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $9xcZw.Component)('app', function() {
            return _this;
        }, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    (0, $6hK4i._)(FirebaseAppImpl, [
        {
            key: "automaticDataCollectionEnabled",
            get: function get() {
                this.checkDestroyed();
                return this._automaticDataCollectionEnabled;
            },
            set: function set(val) {
                this.checkDestroyed();
                this._automaticDataCollectionEnabled = val;
            }
        },
        {
            key: "name",
            get: function get() {
                this.checkDestroyed();
                return this._name;
            }
        },
        {
            key: "options",
            get: function get() {
                this.checkDestroyed();
                return this._options;
            }
        },
        {
            key: "config",
            get: function get() {
                this.checkDestroyed();
                return this._config;
            }
        },
        {
            key: "container",
            get: function get() {
                return this._container;
            }
        },
        {
            key: "isDeleted",
            get: function get() {
                return this._isDeleted;
            },
            set: function set(val) {
                this._isDeleted = val;
            }
        },
        {
            /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ key: "checkDestroyed",
            value: function checkDestroyed() {
                if (this.isDeleted) throw $062bd234f7a7c2eb$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
                    appName: this._name
                });
            }
        }
    ]);
    return FirebaseAppImpl;
}();
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Parse the token and check to see if the `exp` claim is in the future.
// Reports an error to the console if the token or claim could not be parsed, or if `exp` is in
// the past.
function $062bd234f7a7c2eb$var$validateTokenTTL(base64Token, tokenName) {
    var secondPart = (0, $hk14n.base64Decode)(base64Token.split('.')[1]);
    if (secondPart === null) {
        console.error("FirebaseServerApp ".concat(tokenName, " is invalid: second part could not be parsed."));
        return;
    }
    var expClaim = JSON.parse(secondPart).exp;
    if (expClaim === undefined) {
        console.error("FirebaseServerApp ".concat(tokenName, " is invalid: expiration claim could not be parsed"));
        return;
    }
    var exp = JSON.parse(secondPart).exp * 1000;
    var now = new Date().getTime();
    var diff = exp - now;
    if (diff <= 0) console.error("FirebaseServerApp ".concat(tokenName, " is invalid: the token has expired."));
}
var $062bd234f7a7c2eb$var$FirebaseServerAppImpl = /*#__PURE__*/ function(FirebaseAppImpl) {
    "use strict";
    (0, $c2MhV._)(FirebaseServerAppImpl, FirebaseAppImpl);
    function FirebaseServerAppImpl(options, serverConfig, name, container) {
        (0, $4QweW._)(this, FirebaseServerAppImpl);
        var _this;
        // Build configuration parameters for the FirebaseAppImpl base class.
        var automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : true;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        var config = {
            name: name,
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        _this = (0, $ehF45._)(this, FirebaseServerAppImpl, [
            options,
            config,
            container
        ]);
        else {
            var appImpl = options;
            _this = (0, $ehF45._)(this, FirebaseServerAppImpl, [
                appImpl.options,
                config,
                container
            ]);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        (0, $kE8SG._)(_this)._serverConfig = (0, $kWfK0._)({
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        }, serverConfig);
        // Ensure that the current time is within the `authIdtoken` window of validity.
        if ((0, $kE8SG._)(_this)._serverConfig.authIdToken) $062bd234f7a7c2eb$var$validateTokenTTL((0, $kE8SG._)(_this)._serverConfig.authIdToken, 'authIdToken');
        // Ensure that the current time is within the `appCheckToken` window of validity.
        if ((0, $kE8SG._)(_this)._serverConfig.appCheckToken) $062bd234f7a7c2eb$var$validateTokenTTL((0, $kE8SG._)(_this)._serverConfig.appCheckToken, 'appCheckToken');
        (0, $kE8SG._)(_this)._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== 'undefined') (0, $kE8SG._)(_this)._finalizationRegistry = new FinalizationRegistry(function() {
            (0, $kE8SG._)(_this).automaticCleanup();
        });
        (0, $kE8SG._)(_this)._refCount = 0;
        (0, $kE8SG._)(_this).incRefCount((0, $kE8SG._)(_this)._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        (0, $kE8SG._)(_this)._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        $062bd234f7a7c2eb$export$d29d5299a7137abc($062bd234f7a7c2eb$var$name$q, $062bd234f7a7c2eb$var$version$1, 'serverapp');
        return (0, $kE8SG._)(_this);
    }
    (0, $6hK4i._)(FirebaseServerAppImpl, [
        {
            key: "toJSON",
            value: function toJSON() {
                return undefined;
            }
        },
        {
            key: "refCount",
            get: function get() {
                return this._refCount;
            }
        },
        {
            // Increment the reference count of this server app. If an object is provided, register it
            // with the finalization registry.
            key: "incRefCount",
            value: function incRefCount(obj) {
                if (this.isDeleted) return;
                this._refCount++;
                if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
            }
        },
        {
            // Decrement the reference count.
            key: "decRefCount",
            value: function decRefCount() {
                if (this.isDeleted) return 0;
                return --this._refCount;
            }
        },
        {
            // Invoked by the FinalizationRegistry callback to note that this app should go through its
            // reference counts and delete itself if no reference count remain. The coordinating logic that
            // handles this is in deleteApp(...).
            key: "automaticCleanup",
            value: function automaticCleanup() {
                $062bd234f7a7c2eb$export$6eec44aa53d5ea34(this);
            }
        },
        {
            key: "settings",
            get: function get() {
                this.checkDestroyed();
                return this._serverConfig;
            }
        },
        {
            /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ key: "checkDestroyed",
            value: function checkDestroyed() {
                if (this.isDeleted) throw $062bd234f7a7c2eb$var$ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
            }
        }
    ]);
    return FirebaseServerAppImpl;
}($062bd234f7a7c2eb$var$FirebaseAppImpl);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ var $062bd234f7a7c2eb$export$31499a9cd224b78c = $062bd234f7a7c2eb$var$version;
function $062bd234f7a7c2eb$export$c55cfd413944906d(_options) {
    var rawConfig = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var options = _options;
    if ((typeof rawConfig === "undefined" ? "undefined" : (0, $5djcY._)(rawConfig)) !== 'object') {
        var name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    var config = (0, $kWfK0._)({
        name: $062bd234f7a7c2eb$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: true
    }, rawConfig);
    var name1 = config.name;
    if (typeof name1 !== 'string' || !name1) throw $062bd234f7a7c2eb$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name1)
    });
    options || (options = (0, $hk14n.getDefaultAppConfig)());
    if (!options) throw $062bd234f7a7c2eb$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    var existingApp = $062bd234f7a7c2eb$export$b4e3c36c855b14b5.get(name1);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if (!(0, $hk14n.deepEqual)(options, existingApp.options)) throw $062bd234f7a7c2eb$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name1,
            mismatchedParam: 'options',
            oldValue: JSON.stringify(existingApp.options),
            newValue: JSON.stringify(options)
        });
        else if (!(0, $hk14n.deepEqual)(config, existingApp.config)) throw $062bd234f7a7c2eb$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name1,
            mismatchedParam: 'config',
            oldValue: JSON.stringify(existingApp.config),
            newValue: JSON.stringify(config)
        });
        else return existingApp;
    }
    var container = new (0, $9xcZw.ComponentContainer)(name1);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $062bd234f7a7c2eb$export$9566bce3835c0f28.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var component = _step.value;
            container.addComponent(component);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var newApp = new $062bd234f7a7c2eb$var$FirebaseAppImpl(options, config, container);
    $062bd234f7a7c2eb$export$b4e3c36c855b14b5.set(name1, newApp);
    return newApp;
}
function $062bd234f7a7c2eb$export$45a407ab953b136b(_options) {
    var _serverAppConfig = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if ((0, $hk14n.isBrowser)() && !(0, $hk14n.isWebWorker)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw $062bd234f7a7c2eb$var$ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    var firebaseOptions;
    var serverAppSettings = _serverAppConfig || {};
    if (_options) {
        if ($062bd234f7a7c2eb$export$110778f8e98b8257(_options)) firebaseOptions = _options.options;
        else if ($062bd234f7a7c2eb$export$38e311c93c671bec(_options)) serverAppSettings = _options;
        else firebaseOptions = _options;
    }
    if (serverAppSettings.automaticDataCollectionEnabled === undefined) serverAppSettings.automaticDataCollectionEnabled = true;
    firebaseOptions || (firebaseOptions = (0, $hk14n.getDefaultAppConfig)());
    if (!firebaseOptions) throw $062bd234f7a7c2eb$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    // Build an app name based on a hash of the configuration options.
    var nameObj = (0, $kWfK0._)({}, serverAppSettings, firebaseOptions);
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    var hashCode = function(s) {
        return (0, $jlUaU._)(s).reduce(function(hash, c) {
            return Math.imul(31, hash) + c.charCodeAt(0) | 0;
        }, 0);
    };
    if (serverAppSettings.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === 'undefined') throw $062bd234f7a7c2eb$var$ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    var nameString = '' + hashCode(JSON.stringify(nameObj));
    var existingApp = $062bd234f7a7c2eb$export$fb03ad8d3d5c5f76.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(serverAppSettings.releaseOnDeref);
        return existingApp;
    }
    var container = new (0, $9xcZw.ComponentContainer)(nameString);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $062bd234f7a7c2eb$export$9566bce3835c0f28.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var component = _step.value;
            container.addComponent(component);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var newApp = new $062bd234f7a7c2eb$var$FirebaseServerAppImpl(firebaseOptions, serverAppSettings, nameString, container);
    $062bd234f7a7c2eb$export$fb03ad8d3d5c5f76.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $062bd234f7a7c2eb$export$f9962582c9e66d99() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $062bd234f7a7c2eb$export$9f30fa0c10967f7f;
    var app = $062bd234f7a7c2eb$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $062bd234f7a7c2eb$export$9f30fa0c10967f7f && (0, $hk14n.getDefaultAppConfig)()) return $062bd234f7a7c2eb$export$c55cfd413944906d();
    if (!app) throw $062bd234f7a7c2eb$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $062bd234f7a7c2eb$export$68ddedf7d44b3bdf() {
    return Array.from($062bd234f7a7c2eb$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ function $062bd234f7a7c2eb$export$6eec44aa53d5ea34(app) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var cleanupProviders, name, firebaseServerApp;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    cleanupProviders = false;
                    name = app.name;
                    if ($062bd234f7a7c2eb$export$b4e3c36c855b14b5.has(name)) {
                        cleanupProviders = true;
                        $062bd234f7a7c2eb$export$b4e3c36c855b14b5.delete(name);
                    } else if ($062bd234f7a7c2eb$export$fb03ad8d3d5c5f76.has(name)) {
                        firebaseServerApp = app;
                        if (firebaseServerApp.decRefCount() <= 0) {
                            $062bd234f7a7c2eb$export$fb03ad8d3d5c5f76.delete(name);
                            cleanupProviders = true;
                        }
                    }
                    if (!cleanupProviders) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        Promise.all(app.container.getProviders().map(function(provider) {
                            return provider.delete();
                        }))
                    ];
                case 1:
                    _state.sent();
                    app.isDeleted = true;
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    })();
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $062bd234f7a7c2eb$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _PLATFORM_LOG_STRING_libraryKeyOrName;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    var library = (_PLATFORM_LOG_STRING_libraryKeyOrName = $062bd234f7a7c2eb$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _PLATFORM_LOG_STRING_libraryKeyOrName !== void 0 ? _PLATFORM_LOG_STRING_libraryKeyOrName : libraryKeyOrName;
    if (variant) library += "-".concat(variant);
    var libraryMismatch = library.match(/\s|\//);
    var versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        var warning = [
            'Unable to register library "'.concat(library, '" with version "').concat(version, '":')
        ];
        if (libraryMismatch) warning.push('library name "'.concat(library, '" contains illegal characters (whitespace or "/")'));
        if (libraryMismatch && versionMismatch) warning.push('and');
        if (versionMismatch) warning.push('version name "'.concat(version, '" contains illegal characters (whitespace or "/")'));
        $062bd234f7a7c2eb$var$logger.warn(warning.join(' '));
        return;
    }
    $062bd234f7a7c2eb$export$c930050e7bb63965(new (0, $9xcZw.Component)("".concat(library, "-version"), function() {
        return {
            library: library,
            version: version
        };
    }, "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $062bd234f7a7c2eb$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') throw $062bd234f7a7c2eb$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $5eJAc.setUserLogHandler)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $062bd234f7a7c2eb$export$c622e99c0ce7b1c9(logLevel) {
    (0, $5eJAc.setLogLevel)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $062bd234f7a7c2eb$var$DB_NAME = 'firebase-heartbeat-database';
var $062bd234f7a7c2eb$var$DB_VERSION = 1;
var $062bd234f7a7c2eb$var$STORE_NAME = 'firebase-heartbeat-store';
var $062bd234f7a7c2eb$var$dbPromise = null;
function $062bd234f7a7c2eb$var$getDbPromise() {
    if (!$062bd234f7a7c2eb$var$dbPromise) $062bd234f7a7c2eb$var$dbPromise = (0, $bpmtn.openDB)($062bd234f7a7c2eb$var$DB_NAME, $062bd234f7a7c2eb$var$DB_VERSION, {
        upgrade: function(db, oldVersion) {
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($062bd234f7a7c2eb$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch(function(e) {
        throw $062bd234f7a7c2eb$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $062bd234f7a7c2eb$var$dbPromise;
}
function $062bd234f7a7c2eb$var$readHeartbeatsFromIndexedDB(app) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var db, tx, result, e, idbGetError;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        $062bd234f7a7c2eb$var$getDbPromise()
                    ];
                case 1:
                    db = _state.sent();
                    tx = db.transaction($062bd234f7a7c2eb$var$STORE_NAME);
                    return [
                        4,
                        tx.objectStore($062bd234f7a7c2eb$var$STORE_NAME).get($062bd234f7a7c2eb$var$computeKey(app))
                    ];
                case 2:
                    result = _state.sent();
                    // We already have the value but tx.done can throw,
                    // so we need to await it here to catch errors
                    return [
                        4,
                        tx.done
                    ];
                case 3:
                    _state.sent();
                    return [
                        2,
                        result
                    ];
                case 4:
                    e = _state.sent();
                    if (e instanceof (0, $hk14n.FirebaseError)) $062bd234f7a7c2eb$var$logger.warn(e.message);
                    else {
                        idbGetError = $062bd234f7a7c2eb$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                            originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
                        });
                        $062bd234f7a7c2eb$var$logger.warn(idbGetError.message);
                    }
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $062bd234f7a7c2eb$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var db, tx, objectStore, e, idbGetError;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        $062bd234f7a7c2eb$var$getDbPromise()
                    ];
                case 1:
                    db = _state.sent();
                    tx = db.transaction($062bd234f7a7c2eb$var$STORE_NAME, 'readwrite');
                    objectStore = tx.objectStore($062bd234f7a7c2eb$var$STORE_NAME);
                    return [
                        4,
                        objectStore.put(heartbeatObject, $062bd234f7a7c2eb$var$computeKey(app))
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        tx.done
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    if (e instanceof (0, $hk14n.FirebaseError)) $062bd234f7a7c2eb$var$logger.warn(e.message);
                    else {
                        idbGetError = $062bd234f7a7c2eb$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                            originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
                        });
                        $062bd234f7a7c2eb$var$logger.warn(idbGetError.message);
                    }
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $062bd234f7a7c2eb$var$computeKey(app) {
    return "".concat(app.name, "!").concat(app.options.appId);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $062bd234f7a7c2eb$var$MAX_HEADER_BYTES = 1024;
var $062bd234f7a7c2eb$var$MAX_NUM_STORED_HEARTBEATS = 30;
var $062bd234f7a7c2eb$var$HeartbeatServiceImpl = /*#__PURE__*/ function() {
    "use strict";
    function HeartbeatServiceImpl(container) {
        var _this = this;
        (0, $4QweW._)(this, HeartbeatServiceImpl);
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        var app = this.container.getProvider('app').getImmediate();
        this._storage = new $062bd234f7a7c2eb$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then(function(result) {
            _this._heartbeatsCache = result;
            return result;
        });
    }
    (0, $6hK4i._)(HeartbeatServiceImpl, [
        {
            key: "triggerHeartbeat",
            value: /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ function triggerHeartbeat() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _this__heartbeatsCache, platformLogger, agent, date, _this__heartbeatsCache1, _, earliestHeartbeatIdx, e;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    3,
                                    ,
                                    4
                                ]);
                                platformLogger = this.container.getProvider('platform-logger').getImmediate();
                                // This is the "Firebase user agent" string from the platform logger
                                // service, not the browser user agent.
                                agent = platformLogger.getPlatformInfoString();
                                date = $062bd234f7a7c2eb$var$getUTCDateString();
                                if (!(((_this__heartbeatsCache = this._heartbeatsCache) === null || _this__heartbeatsCache === void 0 ? void 0 : _this__heartbeatsCache.heartbeats) == null)) return [
                                    3,
                                    2
                                ];
                                _ = this;
                                return [
                                    4,
                                    this._heartbeatsCachePromise
                                ];
                            case 1:
                                _._heartbeatsCache = _state.sent();
                                // If we failed to construct a heartbeats cache, then return immediately.
                                if (((_this__heartbeatsCache1 = this._heartbeatsCache) === null || _this__heartbeatsCache1 === void 0 ? void 0 : _this__heartbeatsCache1.heartbeats) == null) return [
                                    2
                                ];
                                _state.label = 2;
                            case 2:
                                // Do not store a heartbeat if one is already stored for this day
                                // or if a header has already been sent today.
                                if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some(function(singleDateHeartbeat) {
                                    return singleDateHeartbeat.date === date;
                                })) return [
                                    2
                                ];
                                else {
                                    // There is no entry for this date. Create one.
                                    this._heartbeatsCache.heartbeats.push({
                                        date: date,
                                        agent: agent
                                    });
                                    // If the number of stored heartbeats exceeds the maximum number of stored heartbeats, remove the heartbeat with the earliest date.
                                    // Since this is executed each time a heartbeat is pushed, the limit can only be exceeded by one, so only one needs to be removed.
                                    if (this._heartbeatsCache.heartbeats.length > $062bd234f7a7c2eb$var$MAX_NUM_STORED_HEARTBEATS) {
                                        earliestHeartbeatIdx = $062bd234f7a7c2eb$var$getEarliestHeartbeatIdx(this._heartbeatsCache.heartbeats);
                                        this._heartbeatsCache.heartbeats.splice(earliestHeartbeatIdx, 1);
                                    }
                                }
                                return [
                                    2,
                                    this._storage.overwrite(this._heartbeatsCache)
                                ];
                            case 3:
                                e = _state.sent();
                                $062bd234f7a7c2eb$var$logger.warn(e);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getHeartbeatsHeader",
            value: /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ function getHeartbeatsHeader() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _this__heartbeatsCache, date, _extractHeartbeatsForHeader, heartbeatsToSend, unsentEntries, headerString, e;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    6,
                                    ,
                                    7
                                ]);
                                if (!(this._heartbeatsCache === null)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this._heartbeatsCachePromise
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                // If it's still null or the array is empty, there is no data to send.
                                if (((_this__heartbeatsCache = this._heartbeatsCache) === null || _this__heartbeatsCache === void 0 ? void 0 : _this__heartbeatsCache.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0) return [
                                    2,
                                    ''
                                ];
                                date = $062bd234f7a7c2eb$var$getUTCDateString();
                                // Extract as many heartbeats from the cache as will fit under the size limit.
                                _extractHeartbeatsForHeader = $062bd234f7a7c2eb$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats), heartbeatsToSend = _extractHeartbeatsForHeader.heartbeatsToSend, unsentEntries = _extractHeartbeatsForHeader.unsentEntries;
                                headerString = (0, $hk14n.base64urlEncodeWithoutPadding)(JSON.stringify({
                                    version: 2,
                                    heartbeats: heartbeatsToSend
                                }));
                                // Store last sent date to prevent another being logged/sent for the same day.
                                this._heartbeatsCache.lastSentHeartbeatDate = date;
                                if (!(unsentEntries.length > 0)) return [
                                    3,
                                    4
                                ];
                                // Store any unsent entries if they exist.
                                this._heartbeatsCache.heartbeats = unsentEntries;
                                // This seems more likely than emptying the array (below) to lead to some odd state
                                // since the cache isn't empty and this will be called again on the next request,
                                // and is probably safest if we await it.
                                return [
                                    4,
                                    this._storage.overwrite(this._heartbeatsCache)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                this._heartbeatsCache.heartbeats = [];
                                // Do not wait for this, to reduce latency.
                                this._storage.overwrite(this._heartbeatsCache);
                                _state.label = 5;
                            case 5:
                                return [
                                    2,
                                    headerString
                                ];
                            case 6:
                                e = _state.sent();
                                $062bd234f7a7c2eb$var$logger.warn(e);
                                return [
                                    2,
                                    ''
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return HeartbeatServiceImpl;
}();
function $062bd234f7a7c2eb$var$getUTCDateString() {
    var today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $062bd234f7a7c2eb$var$extractHeartbeatsForHeader(heartbeatsCache) {
    var maxSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $062bd234f7a7c2eb$var$MAX_HEADER_BYTES;
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    var heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    var unsentEntries = heartbeatsCache.slice();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var singleDateHeartbeat = _step.value;
            // Look for an existing entry with the same user agent.
            var heartbeatEntry = heartbeatsToSend.find(function(hb) {
                return hb.agent === singleDateHeartbeat.agent;
            });
            if (!heartbeatEntry) {
                // If no entry for this user agent exists, create one.
                heartbeatsToSend.push({
                    agent: singleDateHeartbeat.agent,
                    dates: [
                        singleDateHeartbeat.date
                    ]
                });
                if ($062bd234f7a7c2eb$var$countBytes(heartbeatsToSend) > maxSize) {
                    // If the header would exceed max size, remove the added heartbeat
                    // entry and stop adding to the header.
                    heartbeatsToSend.pop();
                    return "break";
                }
            } else {
                heartbeatEntry.dates.push(singleDateHeartbeat.date);
                // If the header would exceed max size, remove the added date
                // and stop adding to the header.
                if ($062bd234f7a7c2eb$var$countBytes(heartbeatsToSend) > maxSize) {
                    heartbeatEntry.dates.pop();
                    return "break";
                }
            }
            // Pop unsent entry from queue. (Skipped if adding the entry exceeded
            // quota and the loop breaks early.)
            unsentEntries = unsentEntries.slice(1);
        };
        for(var _iterator = heartbeatsCache[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if (_ret === "break") break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
var $062bd234f7a7c2eb$var$HeartbeatStorageImpl = /*#__PURE__*/ function() {
    "use strict";
    function HeartbeatStorageImpl(app) {
        (0, $4QweW._)(this, HeartbeatStorageImpl);
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    (0, $6hK4i._)(HeartbeatStorageImpl, [
        {
            key: "runIndexedDBEnvironmentCheck",
            value: function runIndexedDBEnvironmentCheck() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        if (!(0, $hk14n.isIndexedDBAvailable)()) return [
                            2,
                            false
                        ];
                        else return [
                            2,
                            (0, $hk14n.validateIndexedDBOpenable)().then(function() {
                                return true;
                            }).catch(function() {
                                return false;
                            })
                        ];
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "read",
            value: /**
     * Read all heartbeats.
     */ function read() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var canUseIndexedDB, idbHeartbeatObject;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this._canUseIndexedDBPromise
                                ];
                            case 1:
                                canUseIndexedDB = _state.sent();
                                if (!!canUseIndexedDB) return [
                                    3,
                                    2
                                ];
                                return [
                                    2,
                                    {
                                        heartbeats: []
                                    }
                                ];
                            case 2:
                                return [
                                    4,
                                    $062bd234f7a7c2eb$var$readHeartbeatsFromIndexedDB(this.app)
                                ];
                            case 3:
                                idbHeartbeatObject = _state.sent();
                                if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) return [
                                    2,
                                    idbHeartbeatObject
                                ];
                                else return [
                                    2,
                                    {
                                        heartbeats: []
                                    }
                                ];
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "overwrite",
            value: // overwrite the storage with the provided heartbeats
            function overwrite(heartbeatsObject) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var canUseIndexedDB, existingHeartbeatsObject, _heartbeatsObject_lastSentHeartbeatDate;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this._canUseIndexedDBPromise
                                ];
                            case 1:
                                canUseIndexedDB = _state.sent();
                                if (!!canUseIndexedDB) return [
                                    3,
                                    2
                                ];
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    this.read()
                                ];
                            case 3:
                                existingHeartbeatsObject = _state.sent();
                                return [
                                    2,
                                    $062bd234f7a7c2eb$var$writeHeartbeatsToIndexedDB(this.app, {
                                        lastSentHeartbeatDate: (_heartbeatsObject_lastSentHeartbeatDate = heartbeatsObject.lastSentHeartbeatDate) !== null && _heartbeatsObject_lastSentHeartbeatDate !== void 0 ? _heartbeatsObject_lastSentHeartbeatDate : existingHeartbeatsObject.lastSentHeartbeatDate,
                                        heartbeats: heartbeatsObject.heartbeats
                                    })
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "add",
            value: // add heartbeats
            function add(heartbeatsObject) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var canUseIndexedDB, existingHeartbeatsObject, _heartbeatsObject_lastSentHeartbeatDate;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this._canUseIndexedDBPromise
                                ];
                            case 1:
                                canUseIndexedDB = _state.sent();
                                if (!!canUseIndexedDB) return [
                                    3,
                                    2
                                ];
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    this.read()
                                ];
                            case 3:
                                existingHeartbeatsObject = _state.sent();
                                return [
                                    2,
                                    $062bd234f7a7c2eb$var$writeHeartbeatsToIndexedDB(this.app, {
                                        lastSentHeartbeatDate: (_heartbeatsObject_lastSentHeartbeatDate = heartbeatsObject.lastSentHeartbeatDate) !== null && _heartbeatsObject_lastSentHeartbeatDate !== void 0 ? _heartbeatsObject_lastSentHeartbeatDate : existingHeartbeatsObject.lastSentHeartbeatDate,
                                        heartbeats: (0, $jlUaU._)(existingHeartbeatsObject.heartbeats).concat((0, $jlUaU._)(heartbeatsObject.heartbeats))
                                    })
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return HeartbeatStorageImpl;
}();
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $062bd234f7a7c2eb$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $hk14n.base64urlEncodeWithoutPadding)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * Returns the index of the heartbeat with the earliest date.
 * If the heartbeats array is empty, -1 is returned.
 */ function $062bd234f7a7c2eb$var$getEarliestHeartbeatIdx(heartbeats) {
    if (heartbeats.length === 0) return -1;
    var earliestHeartbeatIdx = 0;
    var earliestHeartbeatDate = heartbeats[0].date;
    for(var i = 1; i < heartbeats.length; i++)if (heartbeats[i].date < earliestHeartbeatDate) {
        earliestHeartbeatDate = heartbeats[i].date;
        earliestHeartbeatIdx = i;
    }
    return earliestHeartbeatIdx;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $062bd234f7a7c2eb$var$registerCoreComponents(variant) {
    $062bd234f7a7c2eb$export$c930050e7bb63965(new (0, $9xcZw.Component)('platform-logger', function(container) {
        return new $062bd234f7a7c2eb$var$PlatformLoggerServiceImpl(container);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ));
    $062bd234f7a7c2eb$export$c930050e7bb63965(new (0, $9xcZw.Component)('heartbeat', function(container) {
        return new $062bd234f7a7c2eb$var$HeartbeatServiceImpl(container);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $062bd234f7a7c2eb$export$d29d5299a7137abc($062bd234f7a7c2eb$var$name$q, $062bd234f7a7c2eb$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    $062bd234f7a7c2eb$export$d29d5299a7137abc($062bd234f7a7c2eb$var$name$q, $062bd234f7a7c2eb$var$version$1, 'esm2020');
    // Register platform SDK identifier (no version).
    $062bd234f7a7c2eb$export$d29d5299a7137abc('fire-js', '');
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $062bd234f7a7c2eb$var$registerCoreComponents('');

});
parcelRegister("jlUaU", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e16b8da7da809cdc$export$71511d61b312f219; });

var $dTQYG = parcelRequire("dTQYG");

var $d95Qy = parcelRequire("d95Qy");

var $eanwW = parcelRequire("eanwW");

var $J66Jb = parcelRequire("J66Jb");
function $e16b8da7da809cdc$export$71511d61b312f219(arr) {
    return (0, $dTQYG._)(arr) || (0, $d95Qy._)(arr) || (0, $J66Jb._)(arr) || (0, $eanwW._)();
}

});
parcelRegister("dTQYG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a1e981ac9d7864a0$export$71511d61b312f219; });

var $2PuG4 = parcelRequire("2PuG4");
function $a1e981ac9d7864a0$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $2PuG4._)(arr);
}

});

parcelRegister("d95Qy", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9920a6ac5bee97c9$export$71511d61b312f219; });
function $9920a6ac5bee97c9$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("eanwW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a504407b7f865a13$export$71511d61b312f219; });
function $a504407b7f865a13$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("9xcZw", function(module, exports) {

$parcel$export(module.exports, "Component", function () { return $6f1145ed9d2e7393$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "ComponentContainer", function () { return $6f1145ed9d2e7393$export$436a80eea5d5c0c5; });

var $dxEC4 = parcelRequire("dxEC4");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $6ZpBv = parcelRequire("6ZpBv");

var $jlUaU = parcelRequire("jlUaU");

var $gh3Df = parcelRequire("gh3Df");

var $hk14n = parcelRequire("hk14n");
/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ var $6f1145ed9d2e7393$export$16fa2f45be04daa8 = /*#__PURE__*/ function() {
    "use strict";
    function Component(name, instanceFactory, type) {
        (0, $4QweW._)(this, Component);
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    (0, $6hK4i._)(Component, [
        {
            key: "setInstantiationMode",
            value: function setInstantiationMode(mode) {
                this.instantiationMode = mode;
                return this;
            }
        },
        {
            key: "setMultipleInstances",
            value: function setMultipleInstances(multipleInstances) {
                this.multipleInstances = multipleInstances;
                return this;
            }
        },
        {
            key: "setServiceProps",
            value: function setServiceProps(props) {
                this.serviceProps = props;
                return this;
            }
        },
        {
            key: "setInstanceCreatedCallback",
            value: function setInstanceCreatedCallback(callback) {
                this.onInstanceCreated = callback;
                return this;
            }
        }
    ]);
    return Component;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6f1145ed9d2e7393$var$DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ var $6f1145ed9d2e7393$export$2881499e37b75b9a = /*#__PURE__*/ function() {
    "use strict";
    function Provider(name, container) {
        (0, $4QweW._)(this, Provider);
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    (0, $6hK4i._)(Provider, [
        {
            /**
     * @param identifier A provider can provide multiple instances of a service
     * if this.component.multipleInstances is true.
     */ key: "get",
            value: function get(identifier) {
                // if multipleInstances is not supported, use the default name
                var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
                if (!this.instancesDeferred.has(normalizedIdentifier)) {
                    var deferred = new (0, $hk14n.Deferred)();
                    this.instancesDeferred.set(normalizedIdentifier, deferred);
                    if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
                    try {
                        var instance = this.getOrInitializeService({
                            instanceIdentifier: normalizedIdentifier
                        });
                        if (instance) deferred.resolve(instance);
                    } catch (e) {
                    // when the instance factory throws an exception during get(), it should not cause
                    // a fatal error. We just return the unresolved promise in this case.
                    }
                }
                return this.instancesDeferred.get(normalizedIdentifier).promise;
            }
        },
        {
            key: "getImmediate",
            value: function getImmediate(options) {
                // if multipleInstances is not supported, use the default name
                var normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
                var _options_optional;
                var optional = (_options_optional = options === null || options === void 0 ? void 0 : options.optional) !== null && _options_optional !== void 0 ? _options_optional : false;
                if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
                    return this.getOrInitializeService({
                        instanceIdentifier: normalizedIdentifier
                    });
                } catch (e) {
                    if (optional) return null;
                    else throw e;
                }
                else {
                    // In case a component is not initialized and should/cannot be auto-initialized at the moment, return null if the optional flag is set, or throw
                    if (optional) return null;
                    else throw Error("Service ".concat(this.name, " is not available"));
                }
            }
        },
        {
            key: "getComponent",
            value: function getComponent() {
                return this.component;
            }
        },
        {
            key: "setComponent",
            value: function setComponent(component) {
                if (component.name !== this.name) throw Error("Mismatching Component ".concat(component.name, " for Provider ").concat(this.name, "."));
                if (this.component) throw Error("Component for ".concat(this.name, " has already been provided"));
                this.component = component;
                // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
                if (!this.shouldAutoInitialize()) return;
                // if the service is eager, initialize the default instance
                if ($6f1145ed9d2e7393$var$isComponentEager(component)) try {
                    this.getOrInitializeService({
                        instanceIdentifier: $6f1145ed9d2e7393$var$DEFAULT_ENTRY_NAME
                    });
                } catch (e) {
                // when the instance factory for an eager Component throws an exception during the eager
                // initialization, it should not cause a fatal error.
                // TODO: Investigate if we need to make it configurable, because some component may want to cause
                // a fatal error in this case?
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Create service instances for the pending promises and resolve them
                    // NOTE: if this.multipleInstances is false, only the default instance will be created
                    // and all promises with resolve with it regardless of the identifier.
                    for(var _iterator = this.instancesDeferred.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $6ZpBv._)(_step.value, 2), instanceIdentifier = _step_value[0], instanceDeferred = _step_value[1];
                        var normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
                        try {
                            // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                            var instance = this.getOrInitializeService({
                                instanceIdentifier: normalizedIdentifier
                            });
                            instanceDeferred.resolve(instance);
                        } catch (e) {
                        // when the instance factory throws an exception, it should not cause
                        // a fatal error. We just leave the promise unresolved.
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "clearInstance",
            value: function clearInstance() {
                var identifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $6f1145ed9d2e7393$var$DEFAULT_ENTRY_NAME;
                this.instancesDeferred.delete(identifier);
                this.instancesOptions.delete(identifier);
                this.instances.delete(identifier);
            }
        },
        {
            key: "delete",
            value: // app.delete() will call this method on every provider to delete the services
            // TODO: should we mark the provider as deleted?
            function _delete() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var services;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                services = Array.from(this.instances.values());
                                return [
                                    4,
                                    Promise.all((0, $jlUaU._)(services.filter(function(service) {
                                        return 'INTERNAL' in service;
                                    }) // legacy services
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                    .map(function(service) {
                                        return service.INTERNAL.delete();
                                    })).concat((0, $jlUaU._)(services.filter(function(service) {
                                        return '_delete' in service;
                                    }) // modularized services
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                    .map(function(service) {
                                        return service._delete();
                                    }))))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "isComponentSet",
            value: function isComponentSet() {
                return this.component != null;
            }
        },
        {
            key: "isInitialized",
            value: function isInitialized() {
                var identifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $6f1145ed9d2e7393$var$DEFAULT_ENTRY_NAME;
                return this.instances.has(identifier);
            }
        },
        {
            key: "getOptions",
            value: function getOptions() {
                var identifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $6f1145ed9d2e7393$var$DEFAULT_ENTRY_NAME;
                return this.instancesOptions.get(identifier) || {};
            }
        },
        {
            key: "initialize",
            value: function initialize() {
                var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _opts_options = opts.options, options = _opts_options === void 0 ? {} : _opts_options;
                var normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
                if (this.isInitialized(normalizedIdentifier)) throw Error("".concat(this.name, "(").concat(normalizedIdentifier, ") has already been initialized"));
                if (!this.isComponentSet()) throw Error("Component ".concat(this.name, " has not been registered yet"));
                var instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier,
                    options: options
                });
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // resolve any pending promise waiting for the service instance
                    for(var _iterator = this.instancesDeferred.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $6ZpBv._)(_step.value, 2), instanceIdentifier = _step_value[0], instanceDeferred = _step_value[1];
                        var normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
                        if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return instance;
            }
        },
        {
            /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ key: "onInit",
            value: function onInit(callback, identifier) {
                var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
                var _this_onInitCallbacks_get;
                var existingCallbacks = (_this_onInitCallbacks_get = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _this_onInitCallbacks_get !== void 0 ? _this_onInitCallbacks_get : new Set();
                existingCallbacks.add(callback);
                this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
                var existingInstance = this.instances.get(normalizedIdentifier);
                if (existingInstance) callback(existingInstance, normalizedIdentifier);
                return function() {
                    existingCallbacks.delete(callback);
                };
            }
        },
        {
            /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ key: "invokeOnInitCallbacks",
            value: function invokeOnInitCallbacks(instance, identifier) {
                var callbacks = this.onInitCallbacks.get(identifier);
                if (!callbacks) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = callbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var callback = _step.value;
                        try {
                            callback(instance, identifier);
                        } catch (e) {
                        // ignore errors in the onInit callback
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "getOrInitializeService",
            value: function getOrInitializeService(param) {
                var instanceIdentifier = param.instanceIdentifier, _param_options = param.options, options = _param_options === void 0 ? {} : _param_options;
                var instance = this.instances.get(instanceIdentifier);
                if (!instance && this.component) {
                    instance = this.component.instanceFactory(this.container, {
                        instanceIdentifier: $6f1145ed9d2e7393$var$normalizeIdentifierForFactory(instanceIdentifier),
                        options: options
                    });
                    this.instances.set(instanceIdentifier, instance);
                    this.instancesOptions.set(instanceIdentifier, options);
                    /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
                    /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                        this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
                    } catch (e) {
                    // ignore errors in the onInstanceCreatedCallback
                    }
                }
                return instance || null;
            }
        },
        {
            key: "normalizeInstanceIdentifier",
            value: function normalizeInstanceIdentifier() {
                var identifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $6f1145ed9d2e7393$var$DEFAULT_ENTRY_NAME;
                if (this.component) return this.component.multipleInstances ? identifier : $6f1145ed9d2e7393$var$DEFAULT_ENTRY_NAME;
                else return identifier; // assume multiple instances are supported before the component is provided.
            }
        },
        {
            key: "shouldAutoInitialize",
            value: function shouldAutoInitialize() {
                return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
            }
        }
    ]);
    return Provider;
}();
// undefined should be passed to the service factory for the default instance
function $6f1145ed9d2e7393$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $6f1145ed9d2e7393$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $6f1145ed9d2e7393$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ var $6f1145ed9d2e7393$export$436a80eea5d5c0c5 = /*#__PURE__*/ function() {
    "use strict";
    function ComponentContainer(name) {
        (0, $4QweW._)(this, ComponentContainer);
        this.name = name;
        this.providers = new Map();
    }
    (0, $6hK4i._)(ComponentContainer, [
        {
            /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ key: "addComponent",
            value: function addComponent(component) {
                var provider = this.getProvider(component.name);
                if (provider.isComponentSet()) throw new Error("Component ".concat(component.name, " has already been registered with ").concat(this.name));
                provider.setComponent(component);
            }
        },
        {
            key: "addOrOverwriteComponent",
            value: function addOrOverwriteComponent(component) {
                var provider = this.getProvider(component.name);
                if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
                this.providers.delete(component.name);
                this.addComponent(component);
            }
        },
        {
            /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ key: "getProvider",
            value: function getProvider(name) {
                if (this.providers.has(name)) return this.providers.get(name);
                // create a Provider for a service that hasn't registered with Firebase
                var provider = new $6f1145ed9d2e7393$export$2881499e37b75b9a(name, this);
                this.providers.set(name, provider);
                return provider;
            }
        },
        {
            key: "getProviders",
            value: function getProviders() {
                return Array.from(this.providers.values());
            }
        }
    ]);
    return ComponentContainer;
}();

});
parcelRegister("hk14n", function(module, exports) {

$parcel$export(module.exports, "base64urlEncodeWithoutPadding", function () { return $c9c522571f844a9d$export$4b5284a3025a455; });
$parcel$export(module.exports, "base64Decode", function () { return $c9c522571f844a9d$export$c62426fdd000a97e; });
$parcel$export(module.exports, "getGlobal", function () { return $c9c522571f844a9d$export$a4e55266d2135a7f; });
$parcel$export(module.exports, "getDefaultEmulatorHostnameAndPort", function () { return $c9c522571f844a9d$export$a3febcf1f14a3a0c; });
$parcel$export(module.exports, "getDefaultAppConfig", function () { return $c9c522571f844a9d$export$3dfb6827a9f89756; });
$parcel$export(module.exports, "Deferred", function () { return $c9c522571f844a9d$export$85f6557964517f1a; });
$parcel$export(module.exports, "createMockUserToken", function () { return $c9c522571f844a9d$export$367bf224123348f1; });
$parcel$export(module.exports, "getUA", function () { return $c9c522571f844a9d$export$c36915b22ce77c19; });
$parcel$export(module.exports, "isBrowser", function () { return $c9c522571f844a9d$export$4e09c449d6c407f7; });
$parcel$export(module.exports, "isWebWorker", function () { return $c9c522571f844a9d$export$97b87b8868ff7a3c; });
$parcel$export(module.exports, "isSafari", function () { return $c9c522571f844a9d$export$95df08bae54cb4df; });
$parcel$export(module.exports, "isSafariOrWebkit", function () { return $c9c522571f844a9d$export$ef10bcfb06572016; });
$parcel$export(module.exports, "isIndexedDBAvailable", function () { return $c9c522571f844a9d$export$3865db50535c2055; });
$parcel$export(module.exports, "validateIndexedDBOpenable", function () { return $c9c522571f844a9d$export$a8a3018f3d187a4d; });
$parcel$export(module.exports, "FirebaseError", function () { return $c9c522571f844a9d$export$dd24e9cd51226c56; });
$parcel$export(module.exports, "ErrorFactory", function () { return $c9c522571f844a9d$export$3fa6e1b18a3b2d40; });
$parcel$export(module.exports, "deepEqual", function () { return $c9c522571f844a9d$export$9cb4719e2e525b7a; });
$parcel$export(module.exports, "getModularInstance", function () { return $c9c522571f844a9d$export$4befe9b5fa509a1b; });
$parcel$export(module.exports, "isCloudWorkstation", function () { return $c9c522571f844a9d$export$5b4d24b45140ad90; });
$parcel$export(module.exports, "pingServer", function () { return $c9c522571f844a9d$export$c0f0d0ce4283a937; });

var $dxEC4 = parcelRequire("dxEC4");

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $c2MhV = parcelRequire("c2MhV");

var $kWfK0 = parcelRequire("kWfK0");

var $6ZpBv = parcelRequire("6ZpBv");

var $jlUaU = parcelRequire("jlUaU");

var $5djcY = parcelRequire("5djcY");

var $67kUy = parcelRequire("67kUy");

var $gh3Df = parcelRequire("gh3Df");

var $7gNbJ = parcelRequire("7gNbJ");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ var $c9c522571f844a9d$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: '${JSCORE_VERSION}'
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ var $c9c522571f844a9d$export$a7a9523472993e97 = function assert(assertion, message) {
    if (!assertion) throw $c9c522571f844a9d$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ var $c9c522571f844a9d$export$a39cad550e7ab28a = function assertionError(message) {
    return new Error('Firebase Database (' + $c9c522571f844a9d$export$588c7fdda06fbb0a.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $c9c522571f844a9d$var$stringToByteArray$1 = function stringToByteArray$1(str) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var p = 0;
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ var $c9c522571f844a9d$var$byteArrayToString = function byteArrayToString(bytes) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var pos = 0, c = 0;
    while(pos < bytes.length){
        var c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            var c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            var c21 = bytes[pos++];
            var c3 = bytes[pos++];
            var c4 = bytes[pos++];
            var u = ((c1 & 7) << 18 | (c21 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            var c22 = bytes[pos++];
            var c31 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c22 & 63) << 6 | c31 & 63);
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
// TODO(dlarocque): Define this as a class, since we no longer target ES5.
var $c9c522571f844a9d$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray: function(input, webSafe) {
        if (!Array.isArray(input)) throw Error('encodeByteArray takes an array as a parameter');
        this.init_();
        var byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        var output = [];
        for(var i = 0; i < input.length; i += 3){
            var byte1 = input[i];
            var haveByte2 = i + 1 < input.length;
            var byte2 = haveByte2 ? input[i + 1] : 0;
            var haveByte3 = i + 2 < input.length;
            var byte3 = haveByte3 ? input[i + 2] : 0;
            var outByte1 = byte1 >> 2;
            var outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            var outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            var outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString: function(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($c9c522571f844a9d$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString: function(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $c9c522571f844a9d$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray: function(input, webSafe) {
        this.init_();
        var charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        var output = [];
        for(var i = 0; i < input.length;){
            var byte1 = charToByteMap[input.charAt(i++)];
            var haveByte2 = i < input.length;
            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            var haveByte3 = i < input.length;
            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            var haveByte4 = i < input.length;
            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $c9c522571f844a9d$export$55ca9d4bee46aeb3();
            var outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                var outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    var outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_: function() {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(var i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ var $c9c522571f844a9d$export$55ca9d4bee46aeb3 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $c2MhV._)(DecodeBase64StringError, Error1);
    function DecodeBase64StringError() {
        (0, $4QweW._)(this, DecodeBase64StringError);
        var _this;
        _this = (0, $ehF45._)(this, DecodeBase64StringError, arguments);
        _this.name = 'DecodeBase64StringError';
        return _this;
    }
    return DecodeBase64StringError;
}((0, $67kUy._)(Error));
/**
 * URL-safe base64 encoding
 */ var $c9c522571f844a9d$export$e510a73ee562749 = function base64Encode(str) {
    var utf8Bytes = $c9c522571f844a9d$var$stringToByteArray$1(str);
    return $c9c522571f844a9d$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ var $c9c522571f844a9d$export$4b5284a3025a455 = function base64urlEncodeWithoutPadding(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $c9c522571f844a9d$export$e510a73ee562749(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ var $c9c522571f844a9d$export$c62426fdd000a97e = function base64Decode(str) {
    try {
        return $c9c522571f844a9d$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $c9c522571f844a9d$export$6c40052bed430212(value) {
    return $c9c522571f844a9d$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $c9c522571f844a9d$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            var dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(var prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$c9c522571f844a9d$var$isValidKey(prop)) continue;
        target[prop] = $c9c522571f844a9d$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $c9c522571f844a9d$var$isValidKey(key) {
    return key !== '__proto__';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $c9c522571f844a9d$export$a4e55266d2135a7f() {
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('Unable to locate global object.');
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $c9c522571f844a9d$var$getDefaultsFromGlobal = function() {
    return $c9c522571f844a9d$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
};
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ var $c9c522571f844a9d$var$getDefaultsFromEnvVariable = function() {
    return;
};
var $c9c522571f844a9d$var$getDefaultsFromCookie = function() {
    if (typeof document === 'undefined') return;
    var match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    var decoded = match && $c9c522571f844a9d$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ var $c9c522571f844a9d$export$212bb2fc580a90a8 = function() {
    try {
        return (0, $7gNbJ.getDefaultsFromPostinstall)() || $c9c522571f844a9d$var$getDefaultsFromGlobal() || $c9c522571f844a9d$var$getDefaultsFromEnvVariable() || $c9c522571f844a9d$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info("Unable to get __FIREBASE_DEFAULTS__ due to: ".concat(e));
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ var $c9c522571f844a9d$export$9c11895284c8adad = function(productName) {
    var _getDefaults_emulatorHosts, _getDefaults;
    return (_getDefaults = $c9c522571f844a9d$export$212bb2fc580a90a8()) === null || _getDefaults === void 0 ? void 0 : (_getDefaults_emulatorHosts = _getDefaults.emulatorHosts) === null || _getDefaults_emulatorHosts === void 0 ? void 0 : _getDefaults_emulatorHosts[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ var $c9c522571f844a9d$export$a3febcf1f14a3a0c = function(productName) {
    var host = $c9c522571f844a9d$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    var separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error("Invalid host ".concat(host, " with no separate hostname and port!"));
    // eslint-disable-next-line no-restricted-globals
    var port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ var $c9c522571f844a9d$export$3dfb6827a9f89756 = function() {
    var _getDefaults;
    return (_getDefaults = $c9c522571f844a9d$export$212bb2fc580a90a8()) === null || _getDefaults === void 0 ? void 0 : _getDefaults.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ var $c9c522571f844a9d$export$5539a1a3afe87d6 = function(name) {
    var _getDefaults;
    return (_getDefaults = $c9c522571f844a9d$export$212bb2fc580a90a8()) === null || _getDefaults === void 0 ? void 0 : _getDefaults["_".concat(name)];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $c9c522571f844a9d$export$85f6557964517f1a = /*#__PURE__*/ function() {
    "use strict";
    function Deferred() {
        var _this = this;
        (0, $4QweW._)(this, Deferred);
        this.reject = function() {};
        this.resolve = function() {};
        this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    (0, $6hK4i._)(Deferred, [
        {
            /**
     * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ key: "wrapCallback",
            value: function wrapCallback(callback) {
                var _this = this;
                return function(error, value) {
                    if (error) _this.reject(error);
                    else _this.resolve(value);
                    if (typeof callback === 'function') {
                        // Attaching noop handler just in case developer wasn't expecting
                        // promises
                        _this.promise.catch(function() {});
                        // Some of our callbacks don't expect a value and our own tests
                        // assert that the parameter length is 1
                        if (callback.length === 1) callback(error);
                        else callback(error, value);
                    }
                };
            }
        }
    ]);
    return Deferred;
}();
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c9c522571f844a9d$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    var header = {
        alg: 'none',
        type: 'JWT'
    };
    var project = projectId || 'demo-project';
    var iat = token.iat || 0;
    var sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    var payload = (0, $kWfK0._)({
        // Set all required fields to decent defaults
        iss: "https://securetoken.google.com/".concat(project),
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: 'custom',
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    var signature = '';
    return [
        $c9c522571f844a9d$export$4b5284a3025a455(JSON.stringify(header)),
        $c9c522571f844a9d$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join('.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $c9c522571f844a9d$export$c36915b22ce77c19() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') return navigator['userAgent'];
    else return '';
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $c9c522571f844a9d$export$872f8323f01d7ae0() {
    return typeof window !== 'undefined' && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($c9c522571f844a9d$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $c9c522571f844a9d$export$8ee0fc9ee280b4ee() {
    var _getDefaults;
    var forceEnvironment = (_getDefaults = $c9c522571f844a9d$export$212bb2fc580a90a8()) === null || _getDefaults === void 0 ? void 0 : _getDefaults.forceEnvironment;
    if (forceEnvironment === 'node') return true;
    else if (forceEnvironment === 'browser') return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment.
 * Note: This will return true for certain test frameworks that are incompletely
 * mimicking a browser, and should not lead to assuming all browser APIs are
 * available.
 */ function $c9c522571f844a9d$export$4e09c449d6c407f7() {
    return typeof window !== 'undefined' || $c9c522571f844a9d$export$97b87b8868ff7a3c();
}
/**
 * Detect Web Worker context.
 */ function $c9c522571f844a9d$export$97b87b8868ff7a3c() {
    return typeof WorkerGlobalScope !== 'undefined' && typeof self !== 'undefined' && self instanceof WorkerGlobalScope;
}
/**
 * Detect Cloudflare Worker context.
 */ function $c9c522571f844a9d$export$ad9e9b75cb9fb797() {
    return typeof navigator !== 'undefined' && navigator.userAgent === 'Cloudflare-Workers';
}
function $c9c522571f844a9d$export$caa8774a9107a58e() {
    var runtime = (typeof chrome === "undefined" ? "undefined" : (0, $5djcY._)(chrome)) === 'object' ? chrome.runtime : (typeof browser === "undefined" ? "undefined" : (0, $5djcY._)(browser)) === 'object' ? browser.runtime : undefined;
    return (typeof runtime === "undefined" ? "undefined" : (0, $5djcY._)(runtime)) === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $c9c522571f844a9d$export$f7a1e23e542d38e3() {
    return (typeof navigator === "undefined" ? "undefined" : (0, $5djcY._)(navigator)) === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */ function $c9c522571f844a9d$export$f2f6a8999f8ebd30() {
    return $c9c522571f844a9d$export$c36915b22ce77c19().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */ function $c9c522571f844a9d$export$7e7b1a9668aaed8() {
    var ua = $c9c522571f844a9d$export$c36915b22ce77c19();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */ function $c9c522571f844a9d$export$202944b2d2824246() {
    return $c9c522571f844a9d$export$c36915b22ce77c19().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $c9c522571f844a9d$export$5d1d834fbbf8bab7() {
    return $c9c522571f844a9d$export$588c7fdda06fbb0a.NODE_CLIENT === true || $c9c522571f844a9d$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $c9c522571f844a9d$export$95df08bae54cb4df() {
    return !$c9c522571f844a9d$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
/** Returns true if we are running in Safari or WebKit */ function $c9c522571f844a9d$export$ef10bcfb06572016() {
    return !$c9c522571f844a9d$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && (navigator.userAgent.includes('Safari') || navigator.userAgent.includes('WebKit')) && !navigator.userAgent.includes('Chrome');
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $c9c522571f844a9d$export$3865db50535c2055() {
    try {
        return (typeof indexedDB === "undefined" ? "undefined" : (0, $5djcY._)(indexedDB)) === 'object';
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $c9c522571f844a9d$export$a8a3018f3d187a4d() {
    return new Promise(function(resolve, reject) {
        try {
            var preExist = true;
            var DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            var request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = function() {
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = function() {
                preExist = false;
            };
            request.onerror = function() {
                var _request_error;
                reject(((_request_error = request.error) === null || _request_error === void 0 ? void 0 : _request_error.message) || '');
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $c9c522571f844a9d$export$f172b7eb6cf60599() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // TypeScript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ var $c9c522571f844a9d$var$ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
var $c9c522571f844a9d$export$dd24e9cd51226c56 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $c2MhV._)(FirebaseError, Error1);
    function FirebaseError(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData) {
        (0, $4QweW._)(this, FirebaseError);
        var _this;
        _this = (0, $ehF45._)(this, FirebaseError, [
            message
        ]);
        _this.code = code;
        _this.customData = customData;
        /** The custom name for all FirebaseErrors. */ _this.name = $c9c522571f844a9d$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // TODO(dlarocque): Replace this with `new.target`: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        //                   which we can now use since we no longer target ES5.
        Object.setPrototypeOf(_this, FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(_this, $c9c522571f844a9d$export$3fa6e1b18a3b2d40.prototype.create);
        return _this;
    }
    return FirebaseError;
}((0, $67kUy._)(Error));
var $c9c522571f844a9d$export$3fa6e1b18a3b2d40 = /*#__PURE__*/ function() {
    "use strict";
    function ErrorFactory(service, serviceName, errors) {
        (0, $4QweW._)(this, ErrorFactory);
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    (0, $6hK4i._)(ErrorFactory, [
        {
            key: "create",
            value: function create(code) {
                for(var _len = arguments.length, data = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    data[_key - 1] = arguments[_key];
                }
                var customData = data[0] || {};
                var fullCode = "".concat(this.service, "/").concat(code);
                var template = this.errors[code];
                var message = template ? $c9c522571f844a9d$var$replaceTemplate(template, customData) : 'Error';
                // Service Name: Error message (service/code).
                var fullMessage = "".concat(this.serviceName, ": ").concat(message, " (").concat(fullCode, ").");
                var error = new $c9c522571f844a9d$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
                return error;
            }
        }
    ]);
    return ErrorFactory;
}();
function $c9c522571f844a9d$var$replaceTemplate(template, data) {
    try {
        var ptr = 0;
        var result = '';
        while(ptr < template.length){
            var start = template.indexOf('{$', ptr);
            if (start === -1) {
                result += template.substring(ptr);
                break;
            }
            var end = template.indexOf('}', start + 2);
            if (end === -1) {
                result += template.substring(ptr);
                break;
            }
            var key = template.substring(start + 2, end);
            var value = data[key];
            result += template.substring(ptr, start) + (value != null ? String(value) : "<".concat(key, "?>"));
            ptr = end + 1;
        }
        return result;
    } catch (e) {
        // Should never happen, but fallback just in case
        return template;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $c9c522571f844a9d$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data JavaScript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $c9c522571f844a9d$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $c9c522571f844a9d$export$2f872c0f2117be69 = function decode(token) {
    var header = {}, claims = {}, data = {}, signature = '';
    try {
        var parts = token.split('.');
        header = $c9c522571f844a9d$export$c5a53ce6a17cf18d($c9c522571f844a9d$export$c62426fdd000a97e(parts[0]) || '');
        claims = $c9c522571f844a9d$export$c5a53ce6a17cf18d($c9c522571f844a9d$export$c62426fdd000a97e(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $c9c522571f844a9d$export$5f870fcca7ae6a88 = function isValidTimestamp(token) {
    var claims = $c9c522571f844a9d$export$2f872c0f2117be69(token).claims;
    var now = Math.floor(new Date().getTime() / 1000);
    var validSince = 0, validUntil = 0;
    if ((typeof claims === "undefined" ? "undefined" : (0, $5djcY._)(claims)) === 'object') {
        if (claims.hasOwnProperty('nbf')) validSince = claims['nbf'];
        else if (claims.hasOwnProperty('iat')) validSince = claims['iat'];
        if (claims.hasOwnProperty('exp')) validUntil = claims['exp'];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $c9c522571f844a9d$export$701c661ec91095f2 = function issuedAtTime(token) {
    var claims = $c9c522571f844a9d$export$2f872c0f2117be69(token).claims;
    if ((typeof claims === "undefined" ? "undefined" : (0, $5djcY._)(claims)) === 'object' && claims.hasOwnProperty('iat')) return claims['iat'];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $c9c522571f844a9d$export$9565ca3d387f8aa0 = function isValidFormat(token) {
    var decoded = $c9c522571f844a9d$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && (typeof claims === "undefined" ? "undefined" : (0, $5djcY._)(claims)) === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $c9c522571f844a9d$export$fc970ed23da99565 = function isAdmin(token) {
    var claims = $c9c522571f844a9d$export$2f872c0f2117be69(token).claims;
    return (typeof claims === "undefined" ? "undefined" : (0, $5djcY._)(claims)) === 'object' && claims['admin'] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c9c522571f844a9d$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $c9c522571f844a9d$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $c9c522571f844a9d$export$dd1bc94b04021eeb(obj) {
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $c9c522571f844a9d$export$871de8747c9eaa88(obj, fn, contextObj) {
    var res = {};
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $c9c522571f844a9d$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = aKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var k = _step.value;
            if (!bKeys.includes(k)) return false;
            var aProp = a[k];
            var bProp = b[k];
            if ($c9c522571f844a9d$var$isObject(aProp) && $c9c522571f844a9d$var$isObject(bProp)) {
                if (!$c9c522571f844a9d$export$9cb4719e2e525b7a(aProp, bProp)) return false;
            } else if (aProp !== bProp) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = bKeys[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var k1 = _step1.value;
            if (!aKeys.includes(k1)) return false;
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return true;
}
function $c9c522571f844a9d$var$isObject(thing) {
    return thing !== null && (typeof thing === "undefined" ? "undefined" : (0, $5djcY._)(thing)) === 'object';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $c9c522571f844a9d$export$a9cd205a244d9f54(promise) {
    var timeInMS = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2000;
    var deferredPromise = new $c9c522571f844a9d$export$85f6557964517f1a();
    setTimeout(function() {
        return deferredPromise.reject('timeout!');
    }, timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $c9c522571f844a9d$export$ac4103b836844853(querystringParams) {
    var params = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $6ZpBv._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            if (Array.isArray(value)) value.forEach(function(arrayVal) {
                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
            });
            else params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        };
        for(var _iterator = Object.entries(querystringParams)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $c9c522571f844a9d$export$c1271ca4c8a70741(querystring) {
    var obj = {};
    var tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach(function(token) {
        if (token) {
            var _token_split = (0, $6ZpBv._)(token.split('='), 2), key = _token_split[0], value = _token_split[1];
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $c9c522571f844a9d$export$1a8408415472d8ed(url) {
    var queryStart = url.indexOf('?');
    if (!queryStart) return '';
    var fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ var $c9c522571f844a9d$export$c85d589bf4e25fef = /*#__PURE__*/ function() {
    "use strict";
    function Sha1() {
        (0, $4QweW._)(this, Sha1);
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(var i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    (0, $6hK4i._)(Sha1, [
        {
            key: "reset",
            value: function reset() {
                this.chain_[0] = 0x67452301;
                this.chain_[1] = 0xefcdab89;
                this.chain_[2] = 0x98badcfe;
                this.chain_[3] = 0x10325476;
                this.chain_[4] = 0xc3d2e1f0;
                this.inbuf_ = 0;
                this.total_ = 0;
            }
        },
        {
            /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ key: "compress_",
            value: function compress_(buf, offset) {
                if (!offset) offset = 0;
                var W = this.W_;
                // get 16 big endian words
                if (typeof buf === 'string') for(var i = 0; i < 16; i++){
                    // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                    // have a bug that turns the post-increment ++ operator into pre-increment
                    // during JIT compilation.  We have code that depends heavily on SHA-1 for
                    // correctness and which is affected by this bug, so I've removed all uses
                    // of post-increment ++ in which the result value is used.  We can revert
                    // this change once the Safari bug
                    // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                    // most clients have been updated.
                    W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
                    offset += 4;
                }
                else for(var i1 = 0; i1 < 16; i1++){
                    W[i1] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
                    offset += 4;
                }
                // expand to 80 words
                for(var i2 = 16; i2 < 80; i2++){
                    var t = W[i2 - 3] ^ W[i2 - 8] ^ W[i2 - 14] ^ W[i2 - 16];
                    W[i2] = (t << 1 | t >>> 31) & 0xffffffff;
                }
                var a = this.chain_[0];
                var b = this.chain_[1];
                var c = this.chain_[2];
                var d = this.chain_[3];
                var e = this.chain_[4];
                var f, k;
                // TODO(user): Try to unroll this loop to speed up the computation.
                for(var i3 = 0; i3 < 80; i3++){
                    if (i3 < 40) {
                        if (i3 < 20) {
                            f = d ^ b & (c ^ d);
                            k = 0x5a827999;
                        } else {
                            f = b ^ c ^ d;
                            k = 0x6ed9eba1;
                        }
                    } else if (i3 < 60) {
                        f = b & c | d & (b | c);
                        k = 0x8f1bbcdc;
                    } else {
                        f = b ^ c ^ d;
                        k = 0xca62c1d6;
                    }
                    var t1 = (a << 5 | a >>> 27) + f + e + k + W[i3] & 0xffffffff;
                    e = d;
                    d = c;
                    c = (b << 30 | b >>> 2) & 0xffffffff;
                    b = a;
                    a = t1;
                }
                this.chain_[0] = this.chain_[0] + a & 0xffffffff;
                this.chain_[1] = this.chain_[1] + b & 0xffffffff;
                this.chain_[2] = this.chain_[2] + c & 0xffffffff;
                this.chain_[3] = this.chain_[3] + d & 0xffffffff;
                this.chain_[4] = this.chain_[4] + e & 0xffffffff;
            }
        },
        {
            key: "update",
            value: function update(bytes, length) {
                // TODO(johnlenz): tighten the function signature and remove this check
                if (bytes == null) return;
                if (length === undefined) length = bytes.length;
                var lengthMinusBlock = length - this.blockSize;
                var n = 0;
                // Using local instead of member variables gives ~5% speedup on Firefox 16.
                var buf = this.buf_;
                var inbuf = this.inbuf_;
                // The outer while loop should execute at most twice.
                while(n < length){
                    // When we have no data in the block to top up, we can directly process the
                    // input buffer (assuming it contains sufficient data). This gives ~25%
                    // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
                    // the data is provided in large chunks (or in multiples of 64 bytes).
                    if (inbuf === 0) while(n <= lengthMinusBlock){
                        this.compress_(bytes, n);
                        n += this.blockSize;
                    }
                    if (typeof bytes === 'string') while(n < length){
                        buf[inbuf] = bytes.charCodeAt(n);
                        ++inbuf;
                        ++n;
                        if (inbuf === this.blockSize) {
                            this.compress_(buf);
                            inbuf = 0;
                            break;
                        }
                    }
                    else while(n < length){
                        buf[inbuf] = bytes[n];
                        ++inbuf;
                        ++n;
                        if (inbuf === this.blockSize) {
                            this.compress_(buf);
                            inbuf = 0;
                            break;
                        }
                    }
                }
                this.inbuf_ = inbuf;
                this.total_ += length;
            }
        },
        {
            /** @override */ key: "digest",
            value: function digest() {
                var digest = [];
                var totalBits = this.total_ * 8;
                // Add pad 0x80 0x00*.
                if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
                else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
                // Add # bits.
                for(var i = this.blockSize - 1; i >= 56; i--){
                    this.buf_[i] = totalBits & 255;
                    totalBits /= 256; // Don't use bit-shifting here!
                }
                this.compress_(this.buf_);
                var n = 0;
                for(var i1 = 0; i1 < 5; i1++)for(var j = 24; j >= 0; j -= 8){
                    digest[n] = this.chain_[i1] >> j & 255;
                    ++n;
                }
                return digest;
            }
        }
    ]);
    return Sha1;
}();
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $c9c522571f844a9d$export$364097d812234b3f(executor, onNoObservers) {
    var proxy = new $c9c522571f844a9d$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ var $c9c522571f844a9d$var$ObserverProxy = /*#__PURE__*/ function() {
    "use strict";
    function ObserverProxy(executor, onNoObservers) {
        var _this = this;
        (0, $4QweW._)(this, ObserverProxy);
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(function() {
            executor(_this);
        }).catch(function(e) {
            _this.error(e);
        });
    }
    (0, $6hK4i._)(ObserverProxy, [
        {
            key: "next",
            value: function next(value) {
                this.forEachObserver(function(observer) {
                    observer.next(value);
                });
            }
        },
        {
            key: "error",
            value: function error(error) {
                this.forEachObserver(function(observer) {
                    observer.error(error);
                });
                this.close(error);
            }
        },
        {
            key: "complete",
            value: function complete() {
                this.forEachObserver(function(observer) {
                    observer.complete();
                });
                this.close();
            }
        },
        {
            /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber synchronously to their
     *   call to subscribe().
     */ key: "subscribe",
            value: function subscribe(nextOrObserver, error, complete) {
                var _this = this;
                var observer;
                if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error('Missing Observer.');
                // Assemble an Observer object when passed as callback functions.
                if ($c9c522571f844a9d$var$implementsAnyMethods(nextOrObserver, [
                    'next',
                    'error',
                    'complete'
                ])) observer = nextOrObserver;
                else observer = {
                    next: nextOrObserver,
                    error: error,
                    complete: complete
                };
                if (observer.next === undefined) observer.next = $c9c522571f844a9d$var$noop;
                if (observer.error === undefined) observer.error = $c9c522571f844a9d$var$noop;
                if (observer.complete === undefined) observer.complete = $c9c522571f844a9d$var$noop;
                var unsub = this.unsubscribeOne.bind(this, this.observers.length);
                // Attempt to subscribe to a terminated Observable - we
                // just respond to the Observer with the final error or complete
                // event.
                if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.task.then(function() {
                    try {
                        if (_this.finalError) observer.error(_this.finalError);
                        else observer.complete();
                    } catch (e) {
                    // nothing
                    }
                    return;
                });
                this.observers.push(observer);
                return unsub;
            }
        },
        {
            // Unsubscribe is synchronous - we guarantee that no events are sent to
            // any unsubscribed Observer.
            key: "unsubscribeOne",
            value: function unsubscribeOne(i) {
                if (this.observers === undefined || this.observers[i] === undefined) return;
                delete this.observers[i];
                this.observerCount -= 1;
                if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
            }
        },
        {
            key: "forEachObserver",
            value: function forEachObserver(fn) {
                if (this.finalized) // Already closed by previous event....just eat the additional values.
                return;
                // Since sendOne calls asynchronously - there is no chance that
                // this.observers will become undefined.
                for(var i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
            }
        },
        {
            // Call the Observer via one of it's callback function. We are careful to
            // confirm that the observe has not been unsubscribed since this asynchronous
            // function had been queued.
            key: "sendOne",
            value: function sendOne(i, fn) {
                var _this = this;
                // Execute the callback asynchronously
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.task.then(function() {
                    if (_this.observers !== undefined && _this.observers[i] !== undefined) try {
                        fn(_this.observers[i]);
                    } catch (e) {
                        // Ignore exceptions raised in Observers or missing methods of an
                        // Observer.
                        // Log error to console. b/31404806
                        if (typeof console !== 'undefined' && console.error) console.error(e);
                    }
                });
            }
        },
        {
            key: "close",
            value: function close(err) {
                var _this = this;
                if (this.finalized) return;
                this.finalized = true;
                if (err !== undefined) this.finalError = err;
                // Proxy is no longer needed - garbage collect references
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.task.then(function() {
                    _this.observers = undefined;
                    _this.onNoObservers = undefined;
                });
            }
        }
    ]);
    return ObserverProxy;
}();
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $c9c522571f844a9d$export$12af436354f1a4f7(fn, onError) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        Promise.resolve(true).then(function() {
            fn.apply(void 0, (0, $jlUaU._)(args));
        }).catch(function(error) {
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $c9c522571f844a9d$var$implementsAnyMethods(obj, methods) {
    if ((typeof obj === "undefined" ? "undefined" : (0, $5djcY._)(obj)) !== 'object' || obj === null) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = methods[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var method = _step.value;
            if (method in obj && typeof obj[method] === 'function') return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $c9c522571f844a9d$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ var $c9c522571f844a9d$export$20164226a0ed35c3 = function validateArgCount(fnName, minCount, maxCount, argCount) {
    var argError;
    if (argCount < minCount) argError = 'at least ' + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    if (argError) {
        var error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $c9c522571f844a9d$export$adea4917e02d93dc(fnName, argName) {
    return "".concat(fnName, " failed: ").concat(argName, " argument ");
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $c9c522571f844a9d$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($c9c522571f844a9d$export$adea4917e02d93dc(fnName, 'namespace') + 'must be a valid firebase namespace.');
}
function $c9c522571f844a9d$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error($c9c522571f844a9d$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid function.');
}
function $c9c522571f844a9d$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if ((typeof context === "undefined" ? "undefined" : (0, $5djcY._)(context)) !== 'object' || context === null) throw new Error($c9c522571f844a9d$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid context object.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in JavaScript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ var $c9c522571f844a9d$export$655666783217a925 = function stringToByteArray(str) {
    var out = [];
    var p = 0;
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            var high = c - 0xd800; // the high 10 bits.
            i++;
            $c9c522571f844a9d$export$a7a9523472993e97(i < str.length, 'Surrogate pair missing trail surrogate.');
            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ var $c9c522571f844a9d$export$9536dc0a75b20bf9 = function stringLength(str) {
    var p = 0;
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ var $c9c522571f844a9d$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ var $c9c522571f844a9d$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ var $c9c522571f844a9d$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ var $c9c522571f844a9d$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $c9c522571f844a9d$export$4d810c0ca64ed8e9(backoffCount) {
    var intervalMillis = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $c9c522571f844a9d$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $c9c522571f844a9d$var$DEFAULT_BACKOFF_FACTOR;
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    var currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    var randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $c9c522571f844a9d$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($c9c522571f844a9d$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $c9c522571f844a9d$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return "".concat(i);
    return i + $c9c522571f844a9d$var$indicator(i);
}
function $c9c522571f844a9d$var$indicator(i) {
    i = Math.abs(i);
    var cent = i % 100;
    if (cent >= 10 && cent <= 20) return 'th';
    var dec = i % 10;
    if (dec === 1) return 'st';
    if (dec === 2) return 'nd';
    if (dec === 3) return 'rd';
    return 'th';
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c9c522571f844a9d$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks whether host is a cloud workstation or not.
 * @public
 */ function $c9c522571f844a9d$export$5b4d24b45140ad90(url) {
    // `isCloudWorkstation` is called without protocol in certain connect*Emulator functions
    // In HTTP request builders, it's called with the protocol.
    // If called with protocol prefix, it's a valid URL, so we extract the hostname
    // If called without, we assume the string is the hostname.
    try {
        var host = url.startsWith('http://') || url.startsWith('https://') ? new URL(url).hostname : url;
        return host.endsWith('.cloudworkstations.dev');
    } catch (e) {
        return false;
    }
}
/**
 * Makes a fetch request to the given server.
 * Mostly used for forwarding cookies in Firebase Studio.
 * @public
 */ function $c9c522571f844a9d$export$c0f0d0ce4283a937(endpoint) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var result;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch(endpoint, {
                            credentials: 'include'
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result.ok
                    ];
            }
        });
    })();
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @public
 * Generates a SHA-256 hash for the given input string.
 *
 * @param input The string to hash.
 * @returns A promise that resolves to the SHA-256 hash as a hex string.
 */ function $c9c522571f844a9d$export$7220bf91e5c1b402(input) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var textEncoder, data, hashBuffer, hashArray, hexHash;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    textEncoder = new TextEncoder();
                    data = textEncoder.encode(input);
                    return [
                        4,
                        crypto.subtle.digest('SHA-256', data)
                    ];
                case 1:
                    hashBuffer = _state.sent();
                    // Convert ArrayBuffer to hex string
                    hashArray = Array.from(new Uint8Array(hashBuffer));
                    hexHash = hashArray.map(function(b) {
                        return b.toString(16).padStart(2, '0');
                    }).join('');
                    return [
                        2,
                        hexHash
                    ];
            }
        });
    })();
}

});
parcelRegister("67kUy", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $47439e10dae4d647$export$71511d61b312f219; });

var $2IRoN = parcelRequire("2IRoN");

var $9atk1 = parcelRequire("9atk1");

var $dcYQL = parcelRequire("dcYQL");

var $lwwt5 = parcelRequire("lwwt5");
function $47439e10dae4d647$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $47439e10dae4d647$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $dcYQL._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $2IRoN._)(Class, arguments, (0, $9atk1._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $lwwt5._)(Wrapper, Class);
    };
    return $47439e10dae4d647$export$71511d61b312f219(Class);
}

});
parcelRegister("2IRoN", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1fb91cc0e14bc157$export$71511d61b312f219; });

var $guZS9 = parcelRequire("guZS9");

var $lwwt5 = parcelRequire("lwwt5");
function $1fb91cc0e14bc157$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $guZS9._)()) $1fb91cc0e14bc157$export$71511d61b312f219 = Reflect.construct;
    else $1fb91cc0e14bc157$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $lwwt5._)(instance, Class.prototype);
        return instance;
    };
    return $1fb91cc0e14bc157$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("dcYQL", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $99db98e27fceb262$export$71511d61b312f219; });
function $99db98e27fceb262$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("7gNbJ", function(module, exports) {

$parcel$export(module.exports, "getDefaultsFromPostinstall", function () { return $c61b69bcff7a20bf$export$6d3c090e66a883b1; });
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // This value is retrieved and hardcoded by the NPM postinstall script
var $c61b69bcff7a20bf$export$6d3c090e66a883b1 = function() {
    return undefined;
};

});



parcelRegister("5eJAc", function(module, exports) {

$parcel$export(module.exports, "LogLevel", function () { return $3d019e5f270c970e$export$243e62d78d3b544d; });
$parcel$export(module.exports, "Logger", function () { return $3d019e5f270c970e$export$efa9a398d6368992; });
$parcel$export(module.exports, "setLogLevel", function () { return $3d019e5f270c970e$export$c622e99c0ce7b1c9; });
$parcel$export(module.exports, "setUserLogHandler", function () { return $3d019e5f270c970e$export$29577d29c84db5f6; });
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ 
var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $6tY97 = parcelRequire("6tY97");

var $jlUaU = parcelRequire("jlUaU");
var $3d019e5f270c970e$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $3d019e5f270c970e$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($3d019e5f270c970e$export$243e62d78d3b544d || ($3d019e5f270c970e$export$243e62d78d3b544d = {}));
var $3d019e5f270c970e$var$levelStringToEnum = {
    'debug': $3d019e5f270c970e$export$243e62d78d3b544d.DEBUG,
    'verbose': $3d019e5f270c970e$export$243e62d78d3b544d.VERBOSE,
    'info': $3d019e5f270c970e$export$243e62d78d3b544d.INFO,
    'warn': $3d019e5f270c970e$export$243e62d78d3b544d.WARN,
    'error': $3d019e5f270c970e$export$243e62d78d3b544d.ERROR,
    'silent': $3d019e5f270c970e$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ var $3d019e5f270c970e$var$defaultLogLevel = $3d019e5f270c970e$export$243e62d78d3b544d.INFO;
var $3d019e5f270c970e$var$_obj;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ var $3d019e5f270c970e$var$ConsoleMethod = ($3d019e5f270c970e$var$_obj = {}, (0, $6tY97._)($3d019e5f270c970e$var$_obj, $3d019e5f270c970e$export$243e62d78d3b544d.DEBUG, 'log'), (0, $6tY97._)($3d019e5f270c970e$var$_obj, $3d019e5f270c970e$export$243e62d78d3b544d.VERBOSE, 'log'), (0, $6tY97._)($3d019e5f270c970e$var$_obj, $3d019e5f270c970e$export$243e62d78d3b544d.INFO, 'info'), (0, $6tY97._)($3d019e5f270c970e$var$_obj, $3d019e5f270c970e$export$243e62d78d3b544d.WARN, 'warn'), (0, $6tY97._)($3d019e5f270c970e$var$_obj, $3d019e5f270c970e$export$243e62d78d3b544d.ERROR, 'error'), $3d019e5f270c970e$var$_obj);
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ var $3d019e5f270c970e$var$defaultLogHandler = function(instance, logType) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        args[_key - 2] = arguments[_key];
    }
    var _console;
    if (logType < instance.logLevel) return;
    var now = new Date().toISOString();
    var method = $3d019e5f270c970e$var$ConsoleMethod[logType];
    if (method) (_console = console)[method].apply(_console, [
        "[".concat(now, "]  ").concat(instance.name, ":")
    ].concat((0, $jlUaU._)(args)));
    else throw new Error("Attempted to log a message with an invalid logType (value: ".concat(logType, ")"));
};
var $3d019e5f270c970e$export$efa9a398d6368992 = /*#__PURE__*/ function() {
    "use strict";
    function Logger(name) {
        (0, $4QweW._)(this, Logger);
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $3d019e5f270c970e$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $3d019e5f270c970e$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $3d019e5f270c970e$var$instances.push(this);
    }
    (0, $6hK4i._)(Logger, [
        {
            key: "logLevel",
            get: function get() {
                return this._logLevel;
            },
            set: function set(val) {
                if (!(val in $3d019e5f270c970e$export$243e62d78d3b544d)) throw new TypeError('Invalid value "'.concat(val, '" assigned to `logLevel`'));
                this._logLevel = val;
            }
        },
        {
            // Workaround for setter/getter having to be the same type.
            key: "setLogLevel",
            value: function setLogLevel(val) {
                this._logLevel = typeof val === 'string' ? $3d019e5f270c970e$var$levelStringToEnum[val] : val;
            }
        },
        {
            key: "logHandler",
            get: function get() {
                return this._logHandler;
            },
            set: function set(val) {
                if (typeof val !== 'function') throw new TypeError('Value assigned to `logHandler` must be a function');
                this._logHandler = val;
            }
        },
        {
            key: "userLogHandler",
            get: function get() {
                return this._userLogHandler;
            },
            set: function set(val) {
                this._userLogHandler = val;
            }
        },
        {
            /**
     * The functions below are all based on the `console` interface
     */ key: "debug",
            value: function debug() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._userLogHandler && this._userLogHandler.apply(this, [
                    this,
                    $3d019e5f270c970e$export$243e62d78d3b544d.DEBUG
                ].concat((0, $jlUaU._)(args)));
                this._logHandler.apply(this, [
                    this,
                    $3d019e5f270c970e$export$243e62d78d3b544d.DEBUG
                ].concat((0, $jlUaU._)(args)));
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._userLogHandler && this._userLogHandler.apply(this, [
                    this,
                    $3d019e5f270c970e$export$243e62d78d3b544d.VERBOSE
                ].concat((0, $jlUaU._)(args)));
                this._logHandler.apply(this, [
                    this,
                    $3d019e5f270c970e$export$243e62d78d3b544d.VERBOSE
                ].concat((0, $jlUaU._)(args)));
            }
        },
        {
            key: "info",
            value: function info() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._userLogHandler && this._userLogHandler.apply(this, [
                    this,
                    $3d019e5f270c970e$export$243e62d78d3b544d.INFO
                ].concat((0, $jlUaU._)(args)));
                this._logHandler.apply(this, [
                    this,
                    $3d019e5f270c970e$export$243e62d78d3b544d.INFO
                ].concat((0, $jlUaU._)(args)));
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._userLogHandler && this._userLogHandler.apply(this, [
                    this,
                    $3d019e5f270c970e$export$243e62d78d3b544d.WARN
                ].concat((0, $jlUaU._)(args)));
                this._logHandler.apply(this, [
                    this,
                    $3d019e5f270c970e$export$243e62d78d3b544d.WARN
                ].concat((0, $jlUaU._)(args)));
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._userLogHandler && this._userLogHandler.apply(this, [
                    this,
                    $3d019e5f270c970e$export$243e62d78d3b544d.ERROR
                ].concat((0, $jlUaU._)(args)));
                this._logHandler.apply(this, [
                    this,
                    $3d019e5f270c970e$export$243e62d78d3b544d.ERROR
                ].concat((0, $jlUaU._)(args)));
            }
        }
    ]);
    return Logger;
}();
function $3d019e5f270c970e$export$c622e99c0ce7b1c9(level) {
    $3d019e5f270c970e$var$instances.forEach(function(inst) {
        inst.setLogLevel(level);
    });
}
function $3d019e5f270c970e$export$29577d29c84db5f6(logCallback, options) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var instance = _step.value;
            var customLogLevel = null;
            if (options && options.level) customLogLevel = $3d019e5f270c970e$var$levelStringToEnum[options.level];
            if (logCallback === null) instance.userLogHandler = null;
            else instance.userLogHandler = function(instance, level) {
                for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
                    args[_key - 2] = arguments[_key];
                }
                var message = args.map(function(arg) {
                    if (arg == null) return null;
                    else if (typeof arg === 'string') return arg;
                    else if (typeof arg === 'number' || typeof arg === 'boolean') return arg.toString();
                    else if (arg instanceof Error) return arg.message;
                    else try {
                        return JSON.stringify(arg);
                    } catch (ignored) {
                        return null;
                    }
                }).filter(function(arg) {
                    return arg;
                }).join(' ');
                if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                    level: $3d019e5f270c970e$export$243e62d78d3b544d[level].toLowerCase(),
                    message: message,
                    args: args,
                    type: instance.name
                });
            };
        };
        for(var _iterator = $3d019e5f270c970e$var$instances[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}

});

parcelRegister("bpmtn", function(module, exports) {

$parcel$export(module.exports, "openDB", function () { return $84e376244e91836e$export$ca0ed41b1a2af7e; });

var $dxEC4 = parcelRequire("dxEC4");

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $jlUaU = parcelRequire("jlUaU");

var $gh3Df = parcelRequire("gh3Df");

var $kHQGl = parcelRequire("kHQGl");
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $84e376244e91836e$export$ca0ed41b1a2af7e(name, version) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, blocked = _ref.blocked, upgrade = _ref.upgrade, blocking = _ref.blocking, terminated = _ref.terminated;
    var request = indexedDB.open(name, version);
    var openPromise = (0, $kHQGl.w)(request);
    if (upgrade) request.addEventListener('upgradeneeded', function(event) {
        upgrade((0, $kHQGl.w)(request.result), event.oldVersion, event.newVersion, (0, $kHQGl.w)(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', function(event) {
        return blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event);
    });
    openPromise.then(function(db) {
        if (terminated) db.addEventListener('close', function() {
            return terminated();
        });
        if (blocking) db.addEventListener('versionchange', function(event) {
            return blocking(event.oldVersion, event.newVersion, event);
        });
    }).catch(function() {});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $84e376244e91836e$export$9d6df0ac66a98bb2(name) {
    var blocked = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).blocked;
    var request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', function(event) {
        return blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event);
    });
    return (0, $kHQGl.w)(request).then(function() {
        return undefined;
    });
}
var $84e376244e91836e$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
var $84e376244e91836e$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
var $84e376244e91836e$var$cachedMethods = new Map();
function $84e376244e91836e$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($84e376244e91836e$var$cachedMethods.get(prop)) return $84e376244e91836e$var$cachedMethods.get(prop);
    var targetFuncName = prop.replace(/FromIndex$/, '');
    var useIndex = prop !== targetFuncName;
    var isWrite = $84e376244e91836e$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $84e376244e91836e$var$readMethods.includes(targetFuncName))) return;
    var method = function method(storeName) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var _target, tx, _$target;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
                        tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
                        _$target = tx.store;
                        if (useIndex) _$target = _$target.index(args.shift());
                        return [
                            4,
                            Promise.all([
                                (_target = _$target)[targetFuncName].apply(_target, (0, $jlUaU._)(args)),
                                isWrite && tx.done
                            ])
                        ];
                    case 1:
                        // Must reject if op rejects.
                        // If it's a write operation, must reject if tx.done rejects.
                        // Must reject with op rejection first.
                        // Must resolve with op value.
                        // Must handle both promises (no unhandled rejections)
                        return [
                            2,
                            _state.sent()[0]
                        ];
                }
            });
        }).call(this);
    };
    $84e376244e91836e$var$cachedMethods.set(prop, method);
    return method;
}
(0, $kHQGl.r)(function(oldTraps) {
    return (0, $hApvp._)((0, $kWfK0._)({}, oldTraps), {
        get: function(target, prop, receiver) {
            return $84e376244e91836e$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver);
        },
        has: function(target, prop) {
            return !!$84e376244e91836e$var$getMethod(target, prop) || oldTraps.has(target, prop);
        }
    });
});

});
parcelRegister("kHQGl", function(module, exports) {

$parcel$export(module.exports, "w", function () { return $f130b053fb212094$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "r", function () { return $f130b053fb212094$export$43caf9889c228507; });

var $jlUaU = parcelRequire("jlUaU");
var $f130b053fb212094$export$23f2a1d2818174ef = function(object, constructors) {
    return constructors.some(function(c) {
        return object instanceof c;
    });
};
var $f130b053fb212094$var$idbProxyableTypes;
var $f130b053fb212094$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $f130b053fb212094$var$getIdbProxyableTypes() {
    return $f130b053fb212094$var$idbProxyableTypes || ($f130b053fb212094$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $f130b053fb212094$var$getCursorAdvanceMethods() {
    return $f130b053fb212094$var$cursorAdvanceMethods || ($f130b053fb212094$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
var $f130b053fb212094$var$cursorRequestMap = new WeakMap();
var $f130b053fb212094$var$transactionDoneMap = new WeakMap();
var $f130b053fb212094$var$transactionStoreNamesMap = new WeakMap();
var $f130b053fb212094$var$transformCache = new WeakMap();
var $f130b053fb212094$export$407448d2b89b1813 = new WeakMap();
function $f130b053fb212094$var$promisifyRequest(request) {
    var promise = new Promise(function(resolve, reject) {
        var unlisten = function() {
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        var success = function() {
            resolve($f130b053fb212094$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        var error = function() {
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise.then(function(value) {
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $f130b053fb212094$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(function() {});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $f130b053fb212094$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $f130b053fb212094$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($f130b053fb212094$var$transactionDoneMap.has(tx)) return;
    var done = new Promise(function(resolve, reject) {
        var unlisten = function() {
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        var complete = function() {
            resolve();
            unlisten();
        };
        var error = function() {
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $f130b053fb212094$var$transactionDoneMap.set(tx, done);
}
var $f130b053fb212094$var$idbProxyTraps = {
    get: function(target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $f130b053fb212094$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') return target.objectStoreNames || $f130b053fb212094$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $f130b053fb212094$export$efccba1c4a2ef57b(target[prop]);
    },
    set: function(target, prop, value) {
        target[prop] = value;
        return true;
    },
    has: function(target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $f130b053fb212094$export$43caf9889c228507(callback) {
    $f130b053fb212094$var$idbProxyTraps = callback($f130b053fb212094$var$idbProxyTraps);
}
function $f130b053fb212094$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) return function(storeNames) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var _func;
        var tx = (_func = func).call.apply(_func, [
            $f130b053fb212094$export$3b14a55fb2447963(this),
            storeNames
        ].concat((0, $jlUaU._)(args)));
        $f130b053fb212094$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $f130b053fb212094$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($f130b053fb212094$var$getCursorAdvanceMethods().includes(func)) return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($f130b053fb212094$export$3b14a55fb2447963(this), args);
        return $f130b053fb212094$export$efccba1c4a2ef57b($f130b053fb212094$var$cursorRequestMap.get(this));
    };
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $f130b053fb212094$export$efccba1c4a2ef57b(func.apply($f130b053fb212094$export$3b14a55fb2447963(this), args));
    };
}
function $f130b053fb212094$var$transformCachableValue(value) {
    if (typeof value === 'function') return $f130b053fb212094$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $f130b053fb212094$var$cacheDonePromiseForTransaction(value);
    if ($f130b053fb212094$export$23f2a1d2818174ef(value, $f130b053fb212094$var$getIdbProxyableTypes())) return new Proxy(value, $f130b053fb212094$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $f130b053fb212094$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $f130b053fb212094$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($f130b053fb212094$var$transformCache.has(value)) return $f130b053fb212094$var$transformCache.get(value);
    var newValue = $f130b053fb212094$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $f130b053fb212094$var$transformCache.set(value, newValue);
        $f130b053fb212094$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
var $f130b053fb212094$export$3b14a55fb2447963 = function(value) {
    return $f130b053fb212094$export$407448d2b89b1813.get(value);
};

});



parcelRegister("hh2l2", function(module, exports) {

$parcel$export(module.exports, "G", function () { return __PRIVATE_AggregateImpl; });
$parcel$export(module.exports, "am", function () { return __PRIVATE_setSDKVersion; });
$parcel$export(module.exports, "z", function () { return __PRIVATE_logDebug; });
$parcel$export(module.exports, "A", function () { return __PRIVATE_logWarn; });
$parcel$export(module.exports, "ae", function () { return l; });
$parcel$export(module.exports, "t", function () { return ta; });
$parcel$export(module.exports, "f", function () { return e; });
$parcel$export(module.exports, "ab", function () { return ResourcePath; });
$parcel$export(module.exports, "E", function () { return __PRIVATE_mapToArray; });
$parcel$export(module.exports, "Y", function () { return DocumentKey; });
$parcel$export(module.exports, "ac", function () { return __PRIVATE_valueDescription; });
$parcel$export(module.exports, "s", function () { return ra; });
$parcel$export(module.exports, "T", function () { return __PRIVATE_validatePositiveNumber; });
$parcel$export(module.exports, "a8", function () { return __PRIVATE_isServerTimestamp; });
$parcel$export(module.exports, "b", function () { return __PRIVATE_databaseIdFromApp; });
$parcel$export(module.exports, "a7", function () { return __PRIVATE_refValue; });
$parcel$export(module.exports, "O", function () { return ObjectValue; });
$parcel$export(module.exports, "P", function () { return Precondition; });
$parcel$export(module.exports, "r", function () { return __PRIVATE_DeleteMutation; });
$parcel$export(module.exports, "a9", function () { return Bound; });
$parcel$export(module.exports, "F", function () { return FieldFilter; });
$parcel$export(module.exports, "C", function () { return CompositeFilter; });
$parcel$export(module.exports, "i", function () { return OrderBy; });
$parcel$export(module.exports, "a2", function () { return FieldIndex; });
$parcel$export(module.exports, "a1", function () { return IndexSegment; });
$parcel$export(module.exports, "a3", function () { return IndexState; });
$parcel$export(module.exports, "U", function () { return __PRIVATE_newQueryForPath; });
$parcel$export(module.exports, "aa", function () { return __PRIVATE_isCollectionGroupQuery; });
$parcel$export(module.exports, "a6", function () { return __PRIVATE_queryNormalizedOrderBy; });
$parcel$export(module.exports, "c", function () { return __PRIVATE_queryWithAddedFilter; });
$parcel$export(module.exports, "j", function () { return __PRIVATE_queryWithAddedOrderBy; });
$parcel$export(module.exports, "h", function () { return __PRIVATE_queryWithLimit; });
$parcel$export(module.exports, "k", function () { return __PRIVATE_queryWithStartAt; });
$parcel$export(module.exports, "e", function () { return __PRIVATE_queryWithEndAt; });
$parcel$export(module.exports, "af", function () { return __PRIVATE_setTestingHooksSpi; });
$parcel$export(module.exports, "o", function () { return FieldPath; });
$parcel$export(module.exports, "_", function () { return __PRIVATE_FirebaseAuthCredentialsProvider; });
$parcel$export(module.exports, "a", function () { return __PRIVATE_FirebaseAppCheckTokenProvider; });
$parcel$export(module.exports, "Q", function () { return Query; });
$parcel$export(module.exports, "I", function () { return aa; });
$parcel$export(module.exports, "aL", function () { return collection; });
$parcel$export(module.exports, "v", function () { return doc; });
$parcel$export(module.exports, "w", function () { return queryEqual; });
$parcel$export(module.exports, "l", function () { return la; });
$parcel$export(module.exports, "n", function () { return __PRIVATE_parseSetData; });
$parcel$export(module.exports, "K", function () { return K; });
$parcel$export(module.exports, "q", function () { return __PRIVATE_parseUpdateData; });
$parcel$export(module.exports, "a0", function () { return __PRIVATE_fieldPathFromDotSeparatedString; });
$parcel$export(module.exports, "p", function () { return __PRIVATE_parseUpdateVarargs; });
$parcel$export(module.exports, "g", function () { return __PRIVATE_parseQueryValue; });
$parcel$export(module.exports, "b0", function () { return serverTimestamp; });
$parcel$export(module.exports, "ah", function () { return __PRIVATE_MemoryOfflineComponentProvider; });
$parcel$export(module.exports, "aj", function () { return __PRIVATE_LruGcMemoryOfflineComponentProvider; });
$parcel$export(module.exports, "al", function () { return __PRIVATE_IndexedDbOfflineComponentProvider; });
$parcel$export(module.exports, "ak", function () { return __PRIVATE_MultiTabOfflineComponentProvider; });
$parcel$export(module.exports, "ai", function () { return OnlineComponentProvider; });
$parcel$export(module.exports, "V", function () { return __PRIVATE_firestoreClientListen; });
$parcel$export(module.exports, "L", function () { return __PRIVATE_firestoreClientGetDocumentFromLocalCache; });
$parcel$export(module.exports, "J", function () { return __PRIVATE_firestoreClientGetDocumentViaSnapshotListener; });
$parcel$export(module.exports, "R", function () { return __PRIVATE_firestoreClientGetDocumentsFromLocalCache; });
$parcel$export(module.exports, "M", function () { return __PRIVATE_firestoreClientGetDocumentsViaSnapshotListener; });
$parcel$export(module.exports, "H", function () { return __PRIVATE_firestoreClientRunAggregateQuery; });
$parcel$export(module.exports, "B", function () { return __PRIVATE_firestoreClientWrite; });
$parcel$export(module.exports, "Z", function () { return __PRIVATE_firestoreClientAddSnapshotsInSyncListener; });
$parcel$export(module.exports, "$", function () { return __PRIVATE_firestoreClientTransaction; });
$parcel$export(module.exports, "a4", function () { return __PRIVATE_firestoreClientSetIndexConfiguration; });
$parcel$export(module.exports, "ag", function () { return __PRIVATE_firestoreClientSetPersistentCacheIndexAutoCreationEnabled; });
$parcel$export(module.exports, "y", function () { return __PRIVATE_firestoreClientDeleteAllFieldIndexes; });
$parcel$export(module.exports, "a5", function () { return mr; });
$parcel$export(module.exports, "m", function () { return __PRIVATE_applyFirestoreDataConverter; });
$parcel$export(module.exports, "ad", function () { return __PRIVATE_LiteUserDataWriter; });
$parcel$export(module.exports, "d", function () { return da; });
$parcel$export(module.exports, "aV", function () { return getFirestore; });
$parcel$export(module.exports, "x", function () { return oa; });
$parcel$export(module.exports, "W", function () { return loadBundle; });
$parcel$export(module.exports, "X", function () { return namedQuery; });
$parcel$export(module.exports, "u", function () { return ua; });
$parcel$export(module.exports, "S", function () { return SnapshotMetadata; });
$parcel$export(module.exports, "D", function () { return DocumentSnapshot; });
$parcel$export(module.exports, "N", function () { return QuerySnapshot; });

var $dxEC4 = parcelRequire("dxEC4");

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $2IRoN = parcelRequire("2IRoN");

var $6hK4i = parcelRequire("6hK4i");

var $6tY97 = parcelRequire("6tY97");

var $hC9N3 = parcelRequire("hC9N3");

var $9atk1 = parcelRequire("9atk1");

var $c2MhV = parcelRequire("c2MhV");

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $1DiK7 = parcelRequire("1DiK7");

var $6ZpBv = parcelRequire("6ZpBv");

var $jlUaU = parcelRequire("jlUaU");

var $5djcY = parcelRequire("5djcY");

var $67kUy = parcelRequire("67kUy");

var $gh3Df = parcelRequire("gh3Df");

var $2TaHn = parcelRequire("2TaHn");

var $wQDEL = parcelRequire("wQDEL");

var $hk14n = parcelRequire("hk14n");

var $ak6Ro = parcelRequire("ak6Ro");

var $5eJAc = parcelRequire("5eJAc");

var $2rSfQ = parcelRequire("2rSfQ");

var $lmcdu = parcelRequire("lmcdu");

var $3QAQu = parcelRequire("3QAQu");
var $c935d68891f19798$require$Buffer = $3QAQu.Buffer;
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Concrete implementation of the Aggregate type.
 */ var __PRIVATE_AggregateImpl = function __PRIVATE_AggregateImpl(e, t, n) {
    "use strict";
    (0, $4QweW._)(this, __PRIVATE_AggregateImpl);
    this.alias = e, this.aggregateType = t, this.fieldPath = n;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The semver (www.semver.org) version of the SDK. */ var Se = "12.19.0";
function __PRIVATE_setSDKVersion(e) {
    Se = e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Formats an object as a JSON string, suitable for logging. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var ve = new (0, $5eJAc.Logger)("@firebase/firestore");
// Helper methods are needed because variables can't be exported as read/write
function __PRIVATE_getLogLevel() {
    return ve.logLevel;
}
/**
 * Sets the verbosity of Cloud Firestore logs (debug, error, or silent).
 *
 * @param logLevel - The verbosity you set for activity and error logging. Can
 *   be any of the following values:
 *
 *   <ul>
 *     <li>`debug` for the most verbose logging level, primarily for
 *     debugging.</li>
 *     <li>`error` to log errors only.</li>
 *     <li><code>`silent` to turn off logging.</li>
 *   </ul>
 */ function setLogLevel(e) {
    ve.setLogLevel(e);
}
function __PRIVATE_logDebug(e) {
    for(var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        t[_key - 1] = arguments[_key];
    }
    if (ve.logLevel <= (0, $5eJAc.LogLevel).DEBUG) {
        var _ve;
        var n = t.map(__PRIVATE_argToString);
        (_ve = ve).debug.apply(_ve, [
            "Firestore (".concat(Se, "): ").concat(e)
        ].concat((0, $jlUaU._)(n)));
    }
}
function __PRIVATE_logError(e) {
    for(var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        t[_key - 1] = arguments[_key];
    }
    if (ve.logLevel <= (0, $5eJAc.LogLevel).ERROR) {
        var _ve;
        var n = t.map(__PRIVATE_argToString);
        (_ve = ve).error.apply(_ve, [
            "Firestore (".concat(Se, "): ").concat(e)
        ].concat((0, $jlUaU._)(n)));
    }
}
/**
 * @internal
 */ function __PRIVATE_logWarn(e) {
    for(var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        t[_key - 1] = arguments[_key];
    }
    if (ve.logLevel <= (0, $5eJAc.LogLevel).WARN) {
        var _ve;
        var n = t.map(__PRIVATE_argToString);
        (_ve = ve).warn.apply(_ve, [
            "Firestore (".concat(Se, "): ").concat(e)
        ].concat((0, $jlUaU._)(n)));
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */ function __PRIVATE_argToString(e) {
    if ("string" == typeof e) return e;
    try {
        return function __PRIVATE_formatJSON(e) {
            return JSON.stringify(e);
        }(e);
    } catch (t) {
        // Converting to JSON failed, just log the object directly
        return e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function l(e, t, n) {
    var r = "Unexpected state";
    "string" == typeof t ? r = t : n = t, __PRIVATE__fail(e, r, n);
}
function __PRIVATE__fail(e, t, n) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    var r = "FIRESTORE (".concat(Se, ") INTERNAL ASSERTION FAILED: ").concat(t, " (ID: ").concat(e.toString(16), ")");
    if (void 0 !== n) try {
        r += " CONTEXT: " + JSON.stringify(n);
    } catch (e) {
        r += " CONTEXT: " + n;
    }
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw __PRIVATE_logError(r), new Error(r);
}
function __PRIVATE_hardAssert(e, t, n, r) {
    var i = "Unexpected state";
    "string" == typeof n ? i = n : r = n, e || __PRIVATE__fail(t, i, r);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * The code of callsites invoking this function are stripped out in production
 * builds. Any side-effects of code within the debugAssert() invocation will not
 * happen in this case.
 *
 * @internal
 */ function __PRIVATE_debugAssert(e, t) {
    e || l(57014, t);
}
/**
 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
 * instance of `T` before casting.
 */ function __PRIVATE_debugCast(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    return e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Generates `nBytes` of random bytes.
 *
 * If `nBytes < 0` , an error will be thrown.
 */ function __PRIVATE_randomBytes(e) {
    // Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
    var t = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    "undefined" != typeof self && (self.crypto || self.msCrypto), n = new Uint8Array(e);
    if (t && "function" == typeof t.getRandomValues) t.getRandomValues(n);
    else // Falls back to Math.random
    for(var t1 = 0; t1 < e; t1++)n[t1] = Math.floor(256 * Math.random());
    return n;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A utility class for generating unique alphanumeric IDs of a specified length.
 *
 * @internal
 * Exported internally for testing purposes.
 */ var __PRIVATE_AutoId = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_AutoId() {
        (0, $4QweW._)(this, __PRIVATE_AutoId);
    }
    (0, $6hK4i._)(__PRIVATE_AutoId, null, [
        {
            key: "newId",
            value: function newId() {
                // Alphanumeric characters
                var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", t = 62 * Math.floor(256 / 62);
                // The largest byte value that is a multiple of `char.length`.
                var n = "";
                for(; n.length < 20;){
                    var r = __PRIVATE_randomBytes(40);
                    for(var i = 0; i < r.length; ++i)// Only accept values that are [0, maxMultiple), this ensures they can
                    // be evenly mapped to indices of `chars` via a modulo operation.
                    n.length < 20 && r[i] < t && (n += e.charAt(r[i] % 62));
                }
                return n;
            }
        }
    ]);
    return __PRIVATE_AutoId;
}();
function __PRIVATE_primitiveComparator(e, t) {
    return e < t ? -1 : e > t ? 1 : 0;
}
/** Compare strings in UTF-8 encoded byte order */ function __PRIVATE_compareUtf8Strings(e, t) {
    // Find the first differing character (a.k.a. "UTF-16 code unit") in the two strings and,
    // if found, use that character to determine the relative ordering of the two strings as a
    // whole. Comparing UTF-16 strings in UTF-8 byte order can be done simply and efficiently by
    // comparing the UTF-16 code units (chars). This serendipitously works because of the way UTF-8
    // and UTF-16 happen to represent Unicode code points.
    // After finding the first pair of differing characters, there are two cases:
    // Case 1: Both characters are non-surrogates (code points less than or equal to 0xFFFF) or
    // both are surrogates from a surrogate pair (that collectively represent code points greater
    // than 0xFFFF). In this case their numeric order as UTF-16 code units is the same as the
    // lexicographical order of their corresponding UTF-8 byte sequences. A direct comparison is
    // sufficient.
    // Case 2: One character is a surrogate and the other is not. In this case the surrogate-
    // containing string is always ordered after the non-surrogate. This is because surrogates are
    // used to represent code points greater than 0xFFFF which have 4-byte UTF-8 representations
    // and are lexicographically greater than the 1, 2, or 3-byte representations of code points
    // less than or equal to 0xFFFF.
    // An example of why Case 2 is required is comparing the following two Unicode code points:
    // |-----------------------|------------|---------------------|-----------------|
    // | Name                  | Code Point | UTF-8 Encoding      | UTF-16 Encoding |
    // |-----------------------|------------|---------------------|-----------------|
    // | Replacement Character | U+FFFD     | 0xEF 0xBF 0xBD      | 0xFFFD          |
    // | Grinning Face         | U+1F600    | 0xF0 0x9F 0x98 0x80 | 0xD83D 0xDE00   |
    // |-----------------------|------------|---------------------|-----------------|
    // A lexicographical comparison of the UTF-8 encodings of these code points would order
    // "Replacement Character" _before_ "Grinning Face" because 0xEF is less than 0xF0. However, a
    // direct comparison of the UTF-16 code units, as would be done in case 1, would erroneously
    // produce the _opposite_ ordering, because 0xFFFD is _greater than_ 0xD83D. As it turns out,
    // this relative ordering holds for all comparisons of UTF-16 code points requiring a surrogate
    // pair with those that do not.
    var n = Math.min(e.length, t.length);
    for(var r = 0; r < n; r++){
        var n1 = e.charAt(r), i = t.charAt(r);
        if (n1 !== i) return __PRIVATE_isSurrogate(n1) === __PRIVATE_isSurrogate(i) ? __PRIVATE_primitiveComparator(n1, i) : __PRIVATE_isSurrogate(n1) ? 1 : -1;
    }
    // Use the lengths of the strings to determine the overall comparison result since either the
    // strings were equal or one is a prefix of the other.
    return __PRIVATE_primitiveComparator(e.length, t.length);
}
var De = 55296, xe = 57343;
function __PRIVATE_isSurrogate(e) {
    var t = e.charCodeAt(0);
    return t >= De && t <= xe;
}
/** Helper to compare arrays using isEqual(). */ function __PRIVATE_arrayEquals(e, t, n) {
    return e.length === t.length && e.every(function(e, r) {
        return n(e, t[r]);
    });
}
/**
 * Verifies equality for an optional value.
 */ function z(e, t, n) {
    return void 0 === e && void 0 === t || void 0 !== e && void 0 !== t && n(e, t);
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */ function __PRIVATE_immediateSuccessor(e) {
    // Return the input string, with an additional NUL byte appended.
    return e + "\0";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
var SortedMap = /*#__PURE__*/ function() {
    "use strict";
    function SortedMap(e, t) {
        (0, $4QweW._)(this, SortedMap);
        this.comparator = e, this.root = t || LLRBNode.EMPTY;
    }
    (0, $6hK4i._)(SortedMap, [
        {
            // Returns a copy of the map, with the specified key/value added or replaced.
            key: "insert",
            value: function insert(e, t) {
                return new SortedMap(this.comparator, this.root.insert(e, t, this.comparator).copy(null, null, LLRBNode.BLACK, null, null));
            }
        },
        {
            // Returns a copy of the map, with the specified key removed.
            key: "remove",
            value: function remove(e) {
                return new SortedMap(this.comparator, this.root.remove(e, this.comparator).copy(null, null, LLRBNode.BLACK, null, null));
            }
        },
        {
            // Returns the value of the node with the given key, or null.
            key: "get",
            value: function get(e) {
                var t = this.root;
                for(; !t.isEmpty();){
                    var n = this.comparator(e, t.key);
                    if (0 === n) return t.value;
                    n < 0 ? t = t.left : n > 0 && (t = t.right);
                }
                return null;
            }
        },
        {
            // Returns the index of the element in this sorted map, or -1 if it doesn't
            // exist.
            key: "indexOf",
            value: function indexOf(e) {
                // Number of nodes that were pruned when descending right
                var t = 0, n = this.root;
                for(; !n.isEmpty();){
                    var r = this.comparator(e, n.key);
                    if (0 === r) return t + n.left.size;
                    r < 0 ? n = n.left : // Count all nodes left of the node plus the node itself
                    (t += n.left.size + 1, n = n.right);
                }
                // Node not found
                return -1;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.root.isEmpty();
            }
        },
        {
            key: "size",
            get: // Returns the total number of nodes in the map.
            function get() {
                return this.root.size;
            }
        },
        {
            // Returns the minimum key in the map.
            key: "minKey",
            value: function minKey() {
                return this.root.minKey();
            }
        },
        {
            // Returns the maximum key in the map.
            key: "maxKey",
            value: function maxKey() {
                return this.root.maxKey();
            }
        },
        {
            // Traverses the map in key order and calls the specified action function
            // for each key/value pair. If action returns true, traversal is aborted.
            // Returns the first truthy value returned by action, or the last falsey
            // value returned by action.
            key: "inorderTraversal",
            value: function inorderTraversal(e) {
                return this.root.inorderTraversal(e);
            }
        },
        {
            key: "forEach",
            value: function forEach(e) {
                this.inorderTraversal(function(t, n) {
                    return e(t, n), false;
                });
            }
        },
        {
            key: "toString",
            value: function toString() {
                var e = [];
                return this.inorderTraversal(function(t, n) {
                    return e.push("".concat(t, ":").concat(n)), false;
                }), "{".concat(e.join(", "), "}");
            }
        },
        {
            // Traverses the map in reverse key order and calls the specified action
            // function for each key/value pair. If action returns true, traversal is
            // aborted.
            // Returns the first truthy value returned by action, or the last falsey
            // value returned by action.
            key: "reverseTraversal",
            value: function reverseTraversal(e) {
                return this.root.reverseTraversal(e);
            }
        },
        {
            // Returns an iterator over the SortedMap.
            key: "getIterator",
            value: function getIterator() {
                return new SortedMapIterator(this.root, null, this.comparator, false);
            }
        },
        {
            key: "getIteratorFrom",
            value: function getIteratorFrom(e) {
                return new SortedMapIterator(this.root, e, this.comparator, false);
            }
        },
        {
            key: "getReverseIterator",
            value: function getReverseIterator() {
                return new SortedMapIterator(this.root, null, this.comparator, true);
            }
        },
        {
            key: "getReverseIteratorFrom",
            value: function getReverseIteratorFrom(e) {
                return new SortedMapIterator(this.root, e, this.comparator, true);
            }
        }
    ]);
    return SortedMap;
}();
// end SortedMap
// An iterator over an LLRBNode.
var SortedMapIterator = /*#__PURE__*/ function() {
    "use strict";
    function SortedMapIterator(e, t, n, r) {
        (0, $4QweW._)(this, SortedMapIterator);
        this.isReverse = r, this.nodeStack = [];
        var i = 1;
        for(; !e.isEmpty();)if (i = t ? n(e.key, t) : 1, // flip the comparison if we're going in reverse
        t && r && (i *= -1), i < 0) // This node is less than our start key. ignore it
        e = this.isReverse ? e.left : e.right;
        else {
            if (0 === i) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(e);
                break;
            }
            // This node is greater than our start key, add it to the stack and move
            // to the next one
            this.nodeStack.push(e), e = this.isReverse ? e.right : e.left;
        }
    }
    (0, $6hK4i._)(SortedMapIterator, [
        {
            key: "getNext",
            value: function getNext() {
                var e = this.nodeStack.pop();
                var t = {
                    key: e.key,
                    value: e.value
                };
                if (this.isReverse) for(e = e.left; !e.isEmpty();)this.nodeStack.push(e), e = e.right;
                else for(e = e.right; !e.isEmpty();)this.nodeStack.push(e), e = e.left;
                return t;
            }
        },
        {
            key: "hasNext",
            value: function hasNext() {
                return this.nodeStack.length > 0;
            }
        },
        {
            key: "peek",
            value: function peek() {
                if (0 === this.nodeStack.length) return null;
                var e = this.nodeStack[this.nodeStack.length - 1];
                return {
                    key: e.key,
                    value: e.value
                };
            }
        }
    ]);
    return SortedMapIterator;
}();
// end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
var LLRBNode = /*#__PURE__*/ function() {
    "use strict";
    function LLRBNode(e, t, n, r, i) {
        (0, $4QweW._)(this, LLRBNode);
        this.key = e, this.value = t, this.color = null != n ? n : LLRBNode.RED, this.left = null != r ? r : LLRBNode.EMPTY, this.right = null != i ? i : LLRBNode.EMPTY, this.size = this.left.size + 1 + this.right.size;
    }
    (0, $6hK4i._)(LLRBNode, [
        {
            // Returns a copy of the current node, optionally replacing pieces of it.
            key: "copy",
            value: function copy(e, t, n, r, i) {
                return new LLRBNode(null != e ? e : this.key, null != t ? t : this.value, null != n ? n : this.color, null != r ? r : this.left, null != i ? i : this.right);
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return false;
            }
        },
        {
            // Traverses the tree in key order and calls the specified action function
            // for each node. If action returns true, traversal is aborted.
            // Returns the first truthy value returned by action, or the last falsey
            // value returned by action.
            key: "inorderTraversal",
            value: function inorderTraversal(e) {
                return this.left.inorderTraversal(e) || e(this.key, this.value) || this.right.inorderTraversal(e);
            }
        },
        {
            // Traverses the tree in reverse key order and calls the specified action
            // function for each node. If action returns true, traversal is aborted.
            // Returns the first truthy value returned by action, or the last falsey
            // value returned by action.
            key: "reverseTraversal",
            value: function reverseTraversal(e) {
                return this.right.reverseTraversal(e) || e(this.key, this.value) || this.left.reverseTraversal(e);
            }
        },
        {
            // Returns the minimum node in the tree.
            key: "min",
            value: function min() {
                return this.left.isEmpty() ? this : this.left.min();
            }
        },
        {
            // Returns the maximum key in the tree.
            key: "minKey",
            value: function minKey() {
                return this.min().key;
            }
        },
        {
            // Returns the maximum key in the tree.
            key: "maxKey",
            value: function maxKey() {
                return this.right.isEmpty() ? this.key : this.right.maxKey();
            }
        },
        {
            // Returns new tree, with the key/value added.
            key: "insert",
            value: function insert(e, t, n) {
                var r = this;
                var i = n(e, r.key);
                return r = i < 0 ? r.copy(null, null, null, r.left.insert(e, t, n), null) : 0 === i ? r.copy(null, t, null, null, null) : r.copy(null, null, null, null, r.right.insert(e, t, n)), r.fixUp();
            }
        },
        {
            key: "removeMin",
            value: function removeMin() {
                if (this.left.isEmpty()) return LLRBNode.EMPTY;
                var e = this;
                return e.left.isRed() || e.left.left.isRed() || (e = e.moveRedLeft()), e = e.copy(null, null, null, e.left.removeMin(), null), e.fixUp();
            }
        },
        {
            // Returns new tree, with the specified item removed.
            key: "remove",
            value: function remove(e, t) {
                var n, r = this;
                if (t(e, r.key) < 0) r.left.isEmpty() || r.left.isRed() || r.left.left.isRed() || (r = r.moveRedLeft()), r = r.copy(null, null, null, r.left.remove(e, t), null);
                else {
                    if (r.left.isRed() && (r = r.rotateRight()), r.right.isEmpty() || r.right.isRed() || r.right.left.isRed() || (r = r.moveRedRight()), 0 === t(e, r.key)) {
                        if (r.right.isEmpty()) return LLRBNode.EMPTY;
                        n = r.right.min(), r = r.copy(n.key, n.value, null, null, r.right.removeMin());
                    }
                    r = r.copy(null, null, null, null, r.right.remove(e, t));
                }
                return r.fixUp();
            }
        },
        {
            key: "isRed",
            value: function isRed() {
                return this.color;
            }
        },
        {
            // Returns new tree after performing any needed rotations.
            key: "fixUp",
            value: function fixUp() {
                var e = this;
                return e.right.isRed() && !e.left.isRed() && (e = e.rotateLeft()), e.left.isRed() && e.left.left.isRed() && (e = e.rotateRight()), e.left.isRed() && e.right.isRed() && (e = e.colorFlip()), e;
            }
        },
        {
            key: "moveRedLeft",
            value: function moveRedLeft() {
                var e = this.colorFlip();
                return e.right.left.isRed() && (e = e.copy(null, null, null, null, e.right.rotateRight()), e = e.rotateLeft(), e = e.colorFlip()), e;
            }
        },
        {
            key: "moveRedRight",
            value: function moveRedRight() {
                var e = this.colorFlip();
                return e.left.left.isRed() && (e = e.rotateRight(), e = e.colorFlip()), e;
            }
        },
        {
            key: "rotateLeft",
            value: function rotateLeft() {
                var e = this.copy(null, null, LLRBNode.RED, null, this.right.left);
                return this.right.copy(null, null, this.color, e, null);
            }
        },
        {
            key: "rotateRight",
            value: function rotateRight() {
                var e = this.copy(null, null, LLRBNode.RED, this.left.right, null);
                return this.left.copy(null, null, this.color, null, e);
            }
        },
        {
            key: "colorFlip",
            value: function colorFlip() {
                var e = this.left.copy(null, null, !this.left.color, null, null), t = this.right.copy(null, null, !this.right.color, null, null);
                return this.copy(null, null, !this.color, e, t);
            }
        },
        {
            // For testing.
            key: "checkMaxDepth",
            value: function checkMaxDepth() {
                var e = this.check();
                return Math.pow(2, e) <= this.size + 1;
            }
        },
        {
            // In a balanced RB tree, the black-depth (number of black nodes) from root to
            // leaves is equal on both sides.  This function verifies that or asserts.
            key: "check",
            value: function check() {
                if (this.isRed() && this.left.isRed()) throw l(43730, {
                    key: this.key,
                    value: this.value
                });
                if (this.right.isRed()) throw l(14113, {
                    key: this.key,
                    value: this.value
                });
                var e = this.left.check();
                if (e !== this.right.check()) throw l(27949);
                return e + (this.isRed() ? 0 : 1);
            }
        }
    ]);
    return LLRBNode;
}();
// end LLRBNode
// Empty node is shared between all LLRB trees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
LLRBNode.EMPTY = null, LLRBNode.RED = true, LLRBNode.BLACK = false;
// end LLRBEmptyNode
LLRBNode.EMPTY = new (/*#__PURE__*/ // Represents an empty node (a leaf node in the Red-Black Tree).
function() {
    "use strict";
    function LLRBEmptyNode() {
        (0, $4QweW._)(this, LLRBEmptyNode);
        this.size = 0;
    }
    (0, $6hK4i._)(LLRBEmptyNode, [
        {
            key: "key",
            get: function get() {
                throw l(57766);
            }
        },
        {
            key: "value",
            get: function get() {
                throw l(16141);
            }
        },
        {
            key: "color",
            get: function get() {
                throw l(16727);
            }
        },
        {
            key: "left",
            get: function get() {
                throw l(29726);
            }
        },
        {
            key: "right",
            get: function get() {
                throw l(36894);
            }
        },
        {
            // Returns a copy of the current node.
            key: "copy",
            value: function copy(e, t, n, r, i) {
                return this;
            }
        },
        {
            // Returns a copy of the tree, with the specified key/value added.
            key: "insert",
            value: function insert(e, t, n) {
                return new LLRBNode(e, t);
            }
        },
        {
            // Returns a copy of the tree, with the specified key removed.
            key: "remove",
            value: function remove(e, t) {
                return this;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return true;
            }
        },
        {
            key: "inorderTraversal",
            value: function inorderTraversal(e) {
                return false;
            }
        },
        {
            key: "reverseTraversal",
            value: function reverseTraversal(e) {
                return false;
            }
        },
        {
            key: "minKey",
            value: function minKey() {
                return null;
            }
        },
        {
            key: "maxKey",
            value: function maxKey() {
                return null;
            }
        },
        {
            key: "isRed",
            value: function isRed() {
                return false;
            }
        },
        {
            // For testing.
            key: "checkMaxDepth",
            value: function checkMaxDepth() {
                return true;
            }
        },
        {
            key: "check",
            value: function check() {
                return 0;
            }
        }
    ]);
    return LLRBEmptyNode;
}());
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */ var SortedSet = /*#__PURE__*/ function() {
    "use strict";
    function SortedSet(e) {
        (0, $4QweW._)(this, SortedSet);
        this.comparator = e, this.data = new SortedMap(this.comparator);
    }
    (0, $6hK4i._)(SortedSet, [
        {
            key: "has",
            value: function has(e) {
                return null !== this.data.get(e);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.data.minKey();
            }
        },
        {
            key: "last",
            value: function last() {
                return this.data.maxKey();
            }
        },
        {
            key: "size",
            get: function get() {
                return this.data.size;
            }
        },
        {
            key: "indexOf",
            value: function indexOf(e) {
                return this.data.indexOf(e);
            }
        },
        {
            /** Iterates elements in order defined by "comparator" */ key: "forEach",
            value: function forEach(e) {
                this.data.inorderTraversal(function(t, n) {
                    return e(t), false;
                });
            }
        },
        {
            /** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */ key: "forEachInRange",
            value: function forEachInRange(e, t) {
                var n = this.data.getIteratorFrom(e[0]);
                for(; n.hasNext();){
                    var r = n.getNext();
                    if (this.comparator(r.key, e[1]) >= 0) return;
                    t(r.key);
                }
            }
        },
        {
            /**
     * Iterates over `elem`s such that: start &lt;= elem until false is returned.
     */ key: "forEachWhile",
            value: function forEachWhile(e, t) {
                var n;
                for(n = void 0 !== t ? this.data.getIteratorFrom(t) : this.data.getIterator(); n.hasNext();){
                    if (!e(n.getNext().key)) return;
                }
            }
        },
        {
            /** Finds the least element greater than or equal to `elem`. */ key: "firstAfterOrEqual",
            value: function firstAfterOrEqual(e) {
                var t = this.data.getIteratorFrom(e);
                return t.hasNext() ? t.getNext().key : null;
            }
        },
        {
            key: "getIterator",
            value: function getIterator() {
                return new SortedSetIterator(this.data.getIterator());
            }
        },
        {
            key: "getIteratorFrom",
            value: function getIteratorFrom(e) {
                return new SortedSetIterator(this.data.getIteratorFrom(e));
            }
        },
        {
            /** Inserts or updates an element */ key: "add",
            value: function add(e) {
                return this.copy(this.data.remove(e).insert(e, true));
            }
        },
        {
            /** Deletes an element */ key: "delete",
            value: function _delete(e) {
                return this.has(e) ? this.copy(this.data.remove(e)) : this;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.data.isEmpty();
            }
        },
        {
            key: "unionWith",
            value: function unionWith(e) {
                var t = this;
                // Make sure `result` always refers to the larger one of the two sets.
                return t.size < e.size && (t = e, e = this), e.forEach(function(e) {
                    t = t.add(e);
                }), t;
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                if (!(e instanceof SortedSet)) return false;
                if (this.size !== e.size) return false;
                var t = this.data.getIterator(), n = e.data.getIterator();
                for(; t.hasNext();){
                    var _$e = t.getNext().key, r = n.getNext().key;
                    if (0 !== this.comparator(_$e, r)) return false;
                }
                return true;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                var e = [];
                return this.forEach(function(t) {
                    e.push(t);
                }), e;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var e = [];
                return this.forEach(function(t) {
                    return e.push(t);
                }), "SortedSet(" + e.toString() + ")";
            }
        },
        {
            key: "copy",
            value: function copy(e) {
                var t = new SortedSet(this.comparator);
                return t.data = e, t;
            }
        }
    ]);
    return SortedSet;
}();
var SortedSetIterator = /*#__PURE__*/ function() {
    "use strict";
    function SortedSetIterator(e) {
        (0, $4QweW._)(this, SortedSetIterator);
        this.iter = e;
    }
    (0, $6hK4i._)(SortedSetIterator, [
        {
            key: "getNext",
            value: function getNext() {
                return this.iter.getNext().key;
            }
        },
        {
            key: "hasNext",
            value: function hasNext() {
                return this.iter.hasNext();
            }
        }
    ]);
    return SortedSetIterator;
}();
/**
 * Compares two sorted sets for equality using their natural ordering. The
 * method computes the intersection and invokes `onAdd` for every element that
 * is in `after` but not `before`. `onRemove` is invoked for every element in
 * `before` but missing from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original set.
 * @param after - The elements to diff against the original set.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ /**
 * Returns the next element from the iterator or `undefined` if none available.
 */ function __PRIVATE_advanceIterator(e) {
    return e.hasNext() ? e.getNext() : void 0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var ta = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */ OK: "ok",
    /** The operation was cancelled (typically by the caller). */ CANCELLED: "cancelled",
    /** Unknown error or an error from a different error domain. */ UNKNOWN: "unknown",
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */ INVALID_ARGUMENT: "invalid-argument",
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */ DEADLINE_EXCEEDED: "deadline-exceeded",
    /** Some requested entity (e.g., file or directory) was not found. */ NOT_FOUND: "not-found",
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */ ALREADY_EXISTS: "already-exists",
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller cannot be identified
     * (use UNAUTHENTICATED instead for those errors).
     */ PERMISSION_DENIED: "permission-denied",
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */ UNAUTHENTICATED: "unauthenticated",
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */ RESOURCE_EXHAUSTED: "resource-exhausted",
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */ FAILED_PRECONDITION: "failed-precondition",
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ ABORTED: "aborted",
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */ OUT_OF_RANGE: "out-of-range",
    /** Operation is not implemented or not supported/enabled in this service. */ UNIMPLEMENTED: "unimplemented",
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */ INTERNAL: "internal",
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ UNAVAILABLE: "unavailable",
    /** Unrecoverable data loss or corruption. */ DATA_LOSS: "data-loss"
};
/** An error returned by a Firestore operation. */ var e = /*#__PURE__*/ function(FirebaseError) {
    "use strict";
    (0, $c2MhV._)(e, FirebaseError);
    function e(/**
     * The backend error code associated with this error.
     */ e1, /**
     * A custom error description.
     */ t) {
        (0, $4QweW._)(this, e);
        var _this;
        _this = (0, $ehF45._)(this, e, [
            e1,
            t
        ]), _this.code = e1, _this.message = t, // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        _this.toString = function() {
            return "".concat(_this.name, ": [code=").concat(_this.code, "]: ").concat(_this.message);
        };
        return _this;
    }
    return e;
}((0, $hk14n.FirebaseError));
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var Ce = "__name__";
/**
 * Path represents an ordered sequence of string segments.
 */ var BasePath = /*#__PURE__*/ function() {
    "use strict";
    function BasePath(e, t, n) {
        (0, $4QweW._)(this, BasePath);
        void 0 === t ? t = 0 : t > e.length && l(637, {
            offset: t,
            range: e.length
        }), void 0 === n ? n = e.length - t : n > e.length - t && l(1746, {
            length: n,
            range: e.length - t
        }), this.segments = e, this.offset = t, this.len = n;
    }
    (0, $6hK4i._)(BasePath, [
        {
            key: "length",
            get: function get() {
                return this.len;
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return 0 === BasePath.comparator(this, e);
            }
        },
        {
            key: "child",
            value: function child(e) {
                var t = this.segments.slice(this.offset, this.limit());
                return e instanceof BasePath ? e.forEach(function(e) {
                    t.push(e);
                }) : t.push(e), this.construct(t);
            }
        },
        {
            /** The index of one past the last segment of the path. */ key: "limit",
            value: function limit() {
                return this.offset + this.length;
            }
        },
        {
            key: "popFirst",
            value: function popFirst(e) {
                return e = void 0 === e ? 1 : e, this.construct(this.segments, this.offset + e, this.length - e);
            }
        },
        {
            key: "popLast",
            value: function popLast() {
                return this.construct(this.segments, this.offset, this.length - 1);
            }
        },
        {
            key: "firstSegment",
            value: function firstSegment() {
                return this.segments[this.offset];
            }
        },
        {
            key: "lastSegment",
            value: function lastSegment() {
                return this.get(this.length - 1);
            }
        },
        {
            key: "get",
            value: function get(e) {
                return this.segments[this.offset + e];
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return 0 === this.length;
            }
        },
        {
            key: "isPrefixOf",
            value: function isPrefixOf(e) {
                if (e.length < this.length) return false;
                for(var t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return false;
                return true;
            }
        },
        {
            key: "isImmediateParentOf",
            value: function isImmediateParentOf(e) {
                if (this.length + 1 !== e.length) return false;
                for(var t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return false;
                return true;
            }
        },
        {
            key: "forEach",
            value: function forEach(e) {
                for(var t = this.offset, n = this.limit(); t < n; t++)e(this.segments[t]);
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                return this.segments.slice(this.offset, this.limit());
            }
        }
    ], [
        {
            key: "comparator",
            value: /**
     * Compare 2 paths segment by segment, prioritizing numeric IDs
     * (e.g., "__id123__") in numeric ascending order, followed by string
     * segments in lexicographical order.
     */ function comparator(e, t) {
                var n = Math.min(e.length, t.length);
                for(var r = 0; r < n; r++){
                    var n1 = BasePath.compareSegments(e.get(r), t.get(r));
                    if (0 !== n1) return n1;
                }
                return __PRIVATE_primitiveComparator(e.length, t.length);
            }
        },
        {
            key: "compareSegments",
            value: function compareSegments(e, t) {
                var n = BasePath.isNumericId(e), r = BasePath.isNumericId(t);
                return n && !r ? -1 : !n && r ? 1 : n && r ? BasePath.extractNumericId(e).compare(BasePath.extractNumericId(t)) : __PRIVATE_compareUtf8Strings(e, t);
            }
        },
        {
            key: "isNumericId",
            value: // Checks if a segment is a numeric ID (starts with "__id" and ends with "__").
            function isNumericId(e) {
                return e.startsWith("__id") && e.endsWith("__");
            }
        },
        {
            key: "extractNumericId",
            value: function extractNumericId(e) {
                return (0, $ak6Ro.Integer).fromString(e.substring(4, e.length - 2));
            }
        }
    ]);
    return BasePath;
}();
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 *
 * @internal
 */ var ResourcePath = /*#__PURE__*/ function(BasePath) {
    "use strict";
    (0, $c2MhV._)(ResourcePath, BasePath);
    function ResourcePath() {
        (0, $4QweW._)(this, ResourcePath);
        return (0, $ehF45._)(this, ResourcePath, arguments);
    }
    (0, $6hK4i._)(ResourcePath, [
        {
            key: "construct",
            value: function construct(e, t, n) {
                return new ResourcePath(e, t, n);
            }
        },
        {
            key: "canonicalString",
            value: function canonicalString() {
                // NOTE: The client is ignorant of any path segments containing escape
                // sequences (e.g. __id123__) and just passes them through raw (they exist
                // for legacy reasons and should not be used frequently).
                return this.toArray().join("/");
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.canonicalString();
            }
        },
        {
            key: "toStringWithLeadingSlash",
            value: function toStringWithLeadingSlash() {
                return "/".concat(this.canonicalString());
            }
        },
        {
            /**
     * Returns a string representation of this path
     * where each path segment has been encoded with
     * `encodeURIComponent`.
     */ key: "toUriEncodedString",
            value: function toUriEncodedString() {
                return this.toArray().map(encodeURIComponent).join("/");
            }
        }
    ], [
        {
            key: "fromString",
            value: /**
     * Creates a resource path from the given slash-delimited string. If multiple
     * arguments are provided, all components are combined. Leading and trailing
     * slashes from all components are ignored.
     */ function fromString() {
                for(var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++){
                    t[_key] = arguments[_key];
                }
                // NOTE: The client is ignorant of any path segments containing escape
                // sequences (e.g. __id123__) and just passes them through raw (they exist
                // for legacy reasons and should not be used frequently).
                var n = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var r = _step.value;
                        var // Strip leading and trailing slashed.
                        _n;
                        if (r.indexOf("//") >= 0) throw new e(ta.INVALID_ARGUMENT, "Invalid segment (".concat(r, "). Paths must not contain // in them."));
                        (_n = n).push.apply(_n, (0, $jlUaU._)(r.split("/").filter(function(e) {
                            return e.length > 0;
                        })));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return new ResourcePath(n);
            }
        },
        {
            key: "emptyPath",
            value: function emptyPath() {
                return new ResourcePath([]);
            }
        }
    ]);
    return ResourcePath;
}(BasePath);
var Fe = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/**
 * A dot-separated path for navigating sub-objects within a document.
 * @internal
 */ var Oe = /*#__PURE__*/ function(BasePath) {
    "use strict";
    (0, $c2MhV._)(FieldPath, BasePath);
    function FieldPath() {
        (0, $4QweW._)(this, FieldPath);
        return (0, $ehF45._)(this, FieldPath, arguments);
    }
    (0, $6hK4i._)(FieldPath, [
        {
            key: "construct",
            value: function construct(e, t, n) {
                return new FieldPath(e, t, n);
            }
        },
        {
            key: "canonicalString",
            value: function canonicalString() {
                return this.toArray().map(function(e) {
                    return e = e.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), FieldPath.isValidIdentifier(e) || (e = "`" + e + "`"), e;
                }).join(".");
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.canonicalString();
            }
        },
        {
            /**
     * Returns true if this field references the key of a document.
     */ key: "isKeyField",
            value: function isKeyField() {
                return 1 === this.length && this.get(0) === Ce;
            }
        }
    ], [
        {
            key: "isValidIdentifier",
            value: /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */ function isValidIdentifier(e) {
                return Fe.test(e);
            }
        },
        {
            key: "keyField",
            value: /**
     * The field designating the key of a document.
     */ function keyField() {
                return new FieldPath([
                    Ce
                ]);
            }
        },
        {
            key: "fromServerFormat",
            value: /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */ function fromServerFormat(t) {
                var n = [];
                var r = "", i = 0;
                var __PRIVATE_addCurrentSegment = function() {
                    if (0 === r.length) throw new e(ta.INVALID_ARGUMENT, "Invalid field path (".concat(t, "). Paths must not be empty, begin with '.', end with '.', or contain '..'"));
                    n.push(r), r = "";
                };
                var s = false;
                for(; i < t.length;){
                    var n1 = t[i];
                    if ("\\" === n1) {
                        if (i + 1 === t.length) throw new e(ta.INVALID_ARGUMENT, "Path has trailing escape character: " + t);
                        var n2 = t[i + 1];
                        if ("\\" !== n2 && "." !== n2 && "`" !== n2) throw new e(ta.INVALID_ARGUMENT, "Path has invalid escape sequence: " + t);
                        r += n2, i += 2;
                    } else "`" === n1 ? (s = !s, i++) : "." !== n1 || s ? (r += n1, i++) : (__PRIVATE_addCurrentSegment(), i++);
                }
                if (__PRIVATE_addCurrentSegment(), s) throw new e(ta.INVALID_ARGUMENT, "Unterminated ` in path: " + t);
                return new FieldPath(n);
            }
        },
        {
            key: "emptyPath",
            value: function emptyPath() {
                return new FieldPath([]);
            }
        }
    ]);
    return FieldPath;
}(BasePath);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */ var FieldMask = /*#__PURE__*/ function() {
    "use strict";
    function FieldMask(e) {
        (0, $4QweW._)(this, FieldMask);
        this.fields = e, // TODO(dimond): validation of FieldMask
        // Sort the field mask to support `FieldMask.isEqual()` and assert below.
        e.sort(Oe.comparator);
    }
    (0, $6hK4i._)(FieldMask, [
        {
            /**
     * Returns a new FieldMask object that is the result of adding all the given
     * fields paths to this field mask.
     */ key: "unionWith",
            value: function unionWith(e) {
                var t = new SortedSet(Oe.comparator);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$e = _step.value;
                        t = t.add(_$e);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = e[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var n = _step1.value;
                        t = t.add(n);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return new FieldMask(t.toArray());
            }
        },
        {
            /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */ key: "covers",
            value: function covers(e) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var t = _step.value;
                        if (t.isPrefixOf(e)) return true;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return false;
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return __PRIVATE_arrayEquals(this.fields, e.fields, function(e, t) {
                    return e.isEqual(t);
                });
            }
        }
    ], [
        {
            key: "empty",
            value: function empty() {
                return new FieldMask([]);
            }
        }
    ]);
    return FieldMask;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function __PRIVATE_objectSize(e) {
    var t = 0;
    for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && t++;
    return t;
}
function forEach(e, t) {
    for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && t(n, e[n]);
}
function __PRIVATE_mapToArray(e, t) {
    var n = [];
    for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && n.push(t(e[r], r, e));
    return n;
}
function isEmpty(e) {
    for(var t in e)if (Object.prototype.hasOwnProperty.call(e, t)) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ var DocumentKey = /*#__PURE__*/ function() {
    "use strict";
    function DocumentKey(e) {
        (0, $4QweW._)(this, DocumentKey);
        this.path = e;
    }
    (0, $6hK4i._)(DocumentKey, [
        {
            key: "collectionGroup",
            get: function get() {
                return this.path.popLast().lastSegment();
            }
        },
        {
            /** Returns true if the document is in the specified collectionId. */ key: "hasCollectionId",
            value: function hasCollectionId(e) {
                return this.path.length >= 2 && this.path.get(this.path.length - 2) === e;
            }
        },
        {
            /** Returns the collection group (i.e. the name of the parent collection) for this key. */ key: "getCollectionGroup",
            value: function getCollectionGroup() {
                return this.path.get(this.path.length - 2);
            }
        },
        {
            /** Returns the fully qualified path to the parent collection. */ key: "getCollectionPath",
            value: function getCollectionPath() {
                return this.path.popLast();
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return null !== e && 0 === ResourcePath.comparator(this.path, e.path);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.path.toString();
            }
        }
    ], [
        {
            key: "fromPath",
            value: function fromPath(e) {
                return new DocumentKey(ResourcePath.fromString(e));
            }
        },
        {
            key: "fromName",
            value: function fromName(e) {
                return new DocumentKey(ResourcePath.fromString(e).popFirst(5));
            }
        },
        {
            key: "empty",
            value: function empty() {
                return new DocumentKey(ResourcePath.emptyPath());
            }
        },
        {
            key: "comparator",
            value: function comparator(e, t) {
                return ResourcePath.comparator(e.path, t.path);
            }
        },
        {
            key: "isDocumentKey",
            value: function isDocumentKey(e) {
                return e.length % 2 == 0;
            }
        },
        {
            key: "fromSegments",
            value: /**
     * Creates and returns a new document key with the given segments.
     *
     * @param segments - The segments of the path to the document
     * @returns A new instance of DocumentKey
     */ function fromSegments(e) {
                return new DocumentKey(new ResourcePath(e.slice()));
            }
        }
    ]);
    return DocumentKey;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function __PRIVATE_validateNonEmptyArgument(t, n, r) {
    if (!r) throw new e(ta.INVALID_ARGUMENT, "Function ".concat(t, "() cannot be called with an empty ").concat(n, "."));
}
/**
 * Validates that two boolean options are not set at the same time.
 * @internal
 */ function __PRIVATE_validateIsNotUsedTogether(t, n, r, i) {
    if (true === n && true === i) throw new e(ta.INVALID_ARGUMENT, "".concat(t, " and ").concat(r, " cannot be used together."));
}
/**
 * Validates that `path` refers to a document (indicated by the fact it contains
 * an even numbers of segments).
 */ function __PRIVATE_validateDocumentPath(t) {
    if (!DocumentKey.isDocumentKey(t)) throw new e(ta.INVALID_ARGUMENT, "Invalid document reference. Document references must have an even number of segments, but ".concat(t, " has ").concat(t.length, "."));
}
/**
 * Validates that `path` refers to a collection (indicated by the fact it
 * contains an odd numbers of segments).
 */ function __PRIVATE_validateCollectionPath(t) {
    if (DocumentKey.isDocumentKey(t)) throw new e(ta.INVALID_ARGUMENT, "Invalid collection reference. Collection references must have an odd number of segments, but ".concat(t, " has ").concat(t.length, "."));
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */ function p(e) {
    return "object" == (typeof e === "undefined" ? "undefined" : (0, $5djcY._)(e)) && null !== e && (Object.getPrototypeOf(e) === Object.prototype || null === Object.getPrototypeOf(e));
}
/** Returns a string describing the type / value of the provided input. */ function __PRIVATE_valueDescription(e) {
    if (void 0 === e) return "undefined";
    if (null === e) return "null";
    if ("string" == typeof e) return e.length > 20 && (e = "".concat(e.substring(0, 20), "...")), JSON.stringify(e);
    if ("number" == typeof e || "boolean" == typeof e) return "" + e;
    if ("object" == (typeof e === "undefined" ? "undefined" : (0, $5djcY._)(e))) {
        if (e instanceof Array) return "an array";
        {
            var t = /** try to get the constructor name for an object. */ function __PRIVATE_tryGetCustomObjectType(e) {
                if (e.constructor) return e.constructor.name;
                return null;
            }(e);
            return t ? "a custom ".concat(t, " object") : "an object";
        }
    }
    return "function" == typeof e ? "a function" : l(12329, {
        type: typeof e === "undefined" ? "undefined" : (0, $5djcY._)(e)
    });
}
function ra(t, // eslint-disable-next-line @typescript-eslint/no-explicit-any
n) {
    if ("_delegate" in t && // Unwrap Compat types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (t = t._delegate), !(t instanceof n)) {
        if (n.name === t.constructor.name) throw new e(ta.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
        {
            var r = __PRIVATE_valueDescription(t);
            throw new e(ta.INVALID_ARGUMENT, "Expected type '".concat(n.name, "', but it was: ").concat(r));
        }
    }
    return t;
}
function __PRIVATE_validatePositiveNumber(t, n) {
    if (n <= 0) throw new e(ta.INVALID_ARGUMENT, "Function ".concat(t, "() requires a positive number, but it was: ").concat(n, "."));
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper function to define a JSON schema {@link Property}.
 * @private
 * @internal
 */ function property(e, t) {
    var n = {
        typeString: e
    };
    return t && (n.value = t), n;
}
/**
 * Validates the JSON object based on the provided schema, and narrows the type to the provided
 * JSON schema.
 * @private
 * @internal
 *
 * @param json - A JSON object to validate.
 * @param scheme - a {@link JsonSchema} that defines the properties to validate.
 * @returns true if the JSON schema exists within the object. Throws a FirestoreError otherwise.
 */ function __PRIVATE_validateJSON(t, n) {
    if (!p(t)) throw new e(ta.INVALID_ARGUMENT, "JSON must be an object");
    var r;
    for(var e1 in n)if (n[e1]) {
        var i = n[e1].typeString, s = "value" in n[e1] ? {
            value: n[e1].value
        } : void 0;
        if (!(e1 in t)) {
            r = "JSON missing required field: '".concat(e1, "'");
            break;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var _ = t[e1];
        if (i && (typeof _ === "undefined" ? "undefined" : (0, $5djcY._)(_)) !== i) {
            r = "JSON field '".concat(e1, "' must be a ").concat(i, ".");
            break;
        }
        if (void 0 !== s && _ !== s.value) {
            r = "Expected '".concat(e1, "' field to equal '").concat(s.value, "'");
            break;
        }
    }
    if (r) throw new e(ta.INVALID_ARGUMENT, r);
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The earliest date supported by Firestore timestamps (0001-01-01T00:00:00Z).
var Me = -62135596800, Ne = 1e6;
// Number of nanoseconds in a millisecond.
/**
 * A `Timestamp` represents a point in time independent of any time zone or
 * calendar, represented as seconds and fractions of seconds at nanosecond
 * resolution in UTC Epoch time.
 *
 * It is encoded using the Proleptic Gregorian Calendar which extends the
 * Gregorian calendar backwards to year one. It is encoded assuming all minutes
 * are 60 seconds long, i.e. leap seconds are "smeared" so that no leap second
 * table is needed for interpretation. Range is from 0001-01-01T00:00:00Z to
 * 9999-12-31T23:59:59.999999999Z.
 *
 * For examples and further specifications, refer to the
 * {@link https://github.com/google/protobuf/blob/master/src/google/protobuf/timestamp.proto | Timestamp definition}.
 */ var Timestamp = /*#__PURE__*/ function() {
    "use strict";
    function Timestamp(/**
     * The number of seconds of UTC time since Unix epoch 1970-01-01T00:00:00Z.
     */ t, /**
     * The fractions of a second at nanosecond resolution.*
     */ n) {
        (0, $4QweW._)(this, Timestamp);
        if (this.seconds = t, this.nanoseconds = n, n < 0) throw new e(ta.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + n);
        if (n >= 1e9) throw new e(ta.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + n);
        if (t < Me) throw new e(ta.INVALID_ARGUMENT, "Timestamp seconds out of range: " + t);
        // This will break in the year 10,000.
        if (t >= 253402300800) throw new e(ta.INVALID_ARGUMENT, "Timestamp seconds out of range: " + t);
    }
    (0, $6hK4i._)(Timestamp, [
        {
            /**
     * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
     * causes a loss of precision since `Date` objects only support millisecond
     * precision.
     *
     * @returns JavaScript `Date` object representing the same point in time as
     *     this `Timestamp`, with millisecond precision.
     */ key: "toDate",
            value: function toDate() {
                return new Date(this.toMillis());
            }
        },
        {
            /**
     * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
     * epoch). This operation causes a loss of precision.
     *
     * @returns The point in time corresponding to this timestamp, represented as
     *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
     */ key: "toMillis",
            value: function toMillis() {
                return 1e3 * this.seconds + this.nanoseconds / Ne;
            }
        },
        {
            /**
     * Converts a `Timestamp` to a `Temporal.Instant` object.
     *
     * @returns `Temporal.Instant` object representing the same point in time as
     *     this `Timestamp`.
     */ key: "toInstant",
            value: function toInstant() {
                if ("undefined" == typeof Temporal || !Temporal.Instant) throw new e(ta.FAILED_PRECONDITION, "The Temporal object is not available in the current environment.");
                var t = 1000000000n * BigInt(this.seconds) + BigInt(this.nanoseconds);
                return Temporal.Instant.__PRIVATE_fromEpochNanoseconds(t);
            }
        },
        {
            key: "_compareTo",
            value: function _compareTo(e) {
                return this.seconds === e.seconds ? __PRIVATE_primitiveComparator(this.nanoseconds, e.nanoseconds) : __PRIVATE_primitiveComparator(this.seconds, e.seconds);
            }
        },
        {
            /**
     * Returns true if this `Timestamp` is equal to the provided one.
     *
     * @param other - The `Timestamp` to compare against.
     * @returns true if this `Timestamp` is equal to the provided one.
     */ key: "isEqual",
            value: function isEqual(e) {
                return e.seconds === this.seconds && e.nanoseconds === this.nanoseconds;
            }
        },
        {
            /** Returns a textual representation of this `Timestamp`. */ key: "toString",
            value: function toString() {
                return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
            }
        },
        {
            /**
     * Returns a JSON-serializable representation of this `Timestamp`.
     */ key: "toJSON",
            value: function toJSON() {
                return {
                    type: Timestamp._jsonSchemaVersion,
                    seconds: this.seconds,
                    nanoseconds: this.nanoseconds
                };
            }
        },
        {
            /**
     * Converts this object to a primitive string, which allows `Timestamp` objects
     * to be compared using the `>`, `<=`, `>=` and `>` operators.
     */ key: "valueOf",
            value: function valueOf() {
                // This method returns a string of the form <seconds>.<nanoseconds> where
                // <seconds> is translated to have a non-negative value and both <seconds>
                // and <nanoseconds> are left-padded with zeroes to be a consistent length.
                // Strings with this format then have a lexicographical ordering that matches
                // the expected ordering. The <seconds> translation is done to avoid having
                // a leading negative sign (i.e. a leading '-' character) in its string
                // representation, which would affect its lexicographical ordering.
                var e = this.seconds - Me;
                // Note: Up to 12 decimal digits are required to represent all valid
                // 'seconds' values.
                return String(e).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
            }
        }
    ], [
        {
            key: "now",
            value: /**
     * Creates a new timestamp with the current date, with millisecond precision.
     *
     * @returns a new timestamp representing the current date.
     */ function now() {
                return Timestamp.fromMillis(Date.now());
            }
        },
        {
            key: "fromDate",
            value: /**
     * Creates a new timestamp from the given date.
     *
     * @param date - The date to initialize the `Timestamp` from.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     date.
     */ function fromDate(e) {
                return Timestamp.fromMillis(e.getTime());
            }
        },
        {
            key: "fromMillis",
            value: /**
     * Creates a new timestamp from the given number of milliseconds.
     *
     * @param milliseconds - Number of milliseconds since Unix epoch
     *     1970-01-01T00:00:00Z.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     number of milliseconds.
     */ function fromMillis(e) {
                var t = Math.floor(e / 1e3), n = Math.floor((e - 1e3 * t) * Ne);
                return new Timestamp(t, n);
            }
        },
        {
            key: "fromInstant",
            value: /**
     * Creates a new timestamp from the given `Temporal.Instant`.
     *
     * @param instant - The `Temporal.Instant` to initialize the `Timestamp` from.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     instant.
     */ function fromInstant(t) {
                if (!t || "bigint" != (0, $5djcY._)(t.t)) throw new e(ta.INVALID_ARGUMENT, "Invalid Temporal.Instant object provided.");
                return Timestamp._fromEpochNanoseconds(t.t);
            }
        },
        {
            key: "_fromEpochNanoseconds",
            value: function _fromEpochNanoseconds(e) {
                var t, n;
                if (e >= 0n) t = Number(e / 1000000000n), n = Number(e % 1000000000n);
                else {
                    var r = e % 1000000000n;
                    0n === r ? (t = Number(e / 1000000000n), n = 0) : (t = Number(e / 1000000000n - 1n), n = Number(r + 1000000000n));
                }
                return new Timestamp(t, n);
            }
        },
        {
            key: "fromJSON",
            value: /**
     * Builds a `Timestamp` instance from a JSON object created by {@link Timestamp.toJSON}.
     */ function fromJSON(e) {
                if (__PRIVATE_validateJSON(e, Timestamp._jsonSchema)) return new Timestamp(e.seconds, e.nanoseconds);
            }
        }
    ]);
    return Timestamp;
}();
Timestamp._jsonSchemaVersion = "firestore/timestamp/1.0", Timestamp._jsonSchema = {
    type: property("string", Timestamp._jsonSchemaVersion),
    seconds: property("number"),
    nanoseconds: property("number")
};
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error encountered while decoding base64 string.
 */ var __PRIVATE_Base64DecodeError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_Base64DecodeError, Error1);
    function __PRIVATE_Base64DecodeError() {
        (0, $4QweW._)(this, __PRIVATE_Base64DecodeError);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_Base64DecodeError, arguments), _this.name = "Base64DecodeError";
        return _this;
    }
    return __PRIVATE_Base64DecodeError;
}((0, $67kUy._)(Error));
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ /** True if and only if the Base64 conversion functions are available. */ function __PRIVATE_isBase64Available() {
    return "undefined" != typeof atob;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Immutable class that represents a "proto" byte string.
 *
 * Proto byte strings can either be Base64-encoded strings or Uint8Arrays when
 * sent on the wire. This class abstracts away this differentiation by holding
 * the proto byte string in a common class that must be converted into a string
 * before being sent as a proto.
 * @internal
 */ var ByteString = /*#__PURE__*/ function() {
    "use strict";
    function ByteString(e) {
        (0, $4QweW._)(this, ByteString);
        this.binaryString = e;
    }
    (0, $6hK4i._)(ByteString, [
        {
            key: Symbol.iterator,
            value: function value() {
                var _this = this;
                var e = 0;
                return {
                    next: function() {
                        return e < _this.binaryString.length ? {
                            value: _this.binaryString.charCodeAt(e++),
                            done: false
                        } : {
                            value: void 0,
                            done: true
                        };
                    }
                };
            }
        },
        {
            key: "toBase64",
            value: function toBase64() {
                return function __PRIVATE_encodeBase64(e) {
                    return btoa(e);
                }(this.binaryString);
            }
        },
        {
            key: "toUint8Array",
            value: function toUint8Array() {
                return function __PRIVATE_uint8ArrayFromBinaryString(e) {
                    var t = new Uint8Array(e.length);
                    for(var n = 0; n < e.length; n++)t[n] = e.charCodeAt(n);
                    return t;
                }(this.binaryString);
            }
        },
        {
            key: "approximateByteSize",
            value: function approximateByteSize() {
                return 2 * this.binaryString.length;
            }
        },
        {
            key: "compareTo",
            value: function compareTo(e) {
                return __PRIVATE_primitiveComparator(this.binaryString, e.binaryString);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return this.binaryString === e.binaryString;
            }
        }
    ], [
        {
            key: "fromBase64String",
            value: function fromBase64String(e) {
                var t = function __PRIVATE_decodeBase64(e) {
                    try {
                        return atob(e);
                    } catch (e) {
                        // Check that `DOMException` is defined before using it to avoid
                        // "ReferenceError: Property 'DOMException' doesn't exist" in react-native.
                        // (https://github.com/firebase/firebase-js-sdk/issues/7115)
                        throw "undefined" != typeof DOMException && e instanceof DOMException ? new __PRIVATE_Base64DecodeError("Invalid base64 string: " + e) : e;
                    }
                }(e);
                return new ByteString(t);
            }
        },
        {
            key: "fromUint8Array",
            value: function fromUint8Array(e) {
                // TODO(indexing); Remove the copy of the byte string here as this method
                // is frequently called during indexing.
                var t = /**
 * Helper function to convert an Uint8array to a binary string.
 */ function __PRIVATE_binaryStringFromUint8Array(e) {
                    var t = "";
                    for(var n = 0; n < e.length; ++n)t += String.fromCharCode(e[n]);
                    return t;
                }(e);
                return new ByteString(t);
            }
        }
    ]);
    return ByteString;
}();
ByteString.EMPTY_BYTE_STRING = new ByteString("");
var Le = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
/**
 * Converts the possible Proto values for a timestamp value into a "seconds and
 * nanos" representation.
 */ function __PRIVATE_normalizeTimestamp(e) {
    // The json interface (for the browser) will return an iso timestamp string,
    // while the proto js library (for node) will return a
    // google.protobuf.Timestamp instance.
    if (__PRIVATE_hardAssert(!!e, 39018), "string" == typeof e) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        var t = 0;
        var n = Le.exec(e);
        if (__PRIVATE_hardAssert(!!n, 46558, {
            timestamp: e
        }), n[1]) {
            // Pad the fraction out to 9 digits (nanos).
            var _$e = n[1];
            _$e = (_$e + "000000000").substr(0, 9), t = Number(_$e);
        }
        // Parse the date to get the seconds.
        var r = new Date(e);
        return {
            seconds: Math.floor(r.getTime() / 1e3),
            nanos: t
        };
    }
    return {
        seconds: __PRIVATE_normalizeNumber(e.seconds),
        nanos: __PRIVATE_normalizeNumber(e.nanos)
    };
}
/**
 * Converts the possible Proto types for numbers into a JavaScript number.
 * Returns 0 if the value is not numeric.
 */ function __PRIVATE_normalizeNumber(e) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    return "number" == typeof e ? e : "string" == typeof e ? Number(e) : 0;
}
/** Converts the possible Proto types for Blobs into a ByteString. */ function __PRIVATE_normalizeByteString(e) {
    return "string" == typeof e ? ByteString.fromBase64String(e) : ByteString.fromUint8Array(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a locally-applied ServerTimestamp.
 *
 * Server Timestamps are backed by MapValues that contain an internal field
 * `__type__` with a value of `server_timestamp`. The previous value and local
 * write time are stored in its `__previous_value__` and `__local_write_time__`
 * fields respectively.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   transform. They can only exist in the local view of a document. Therefore
 *   they do not need to be parsed or serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */ var Be = "server_timestamp", Ue = "__type__", ke = "__previous_value__", qe = "__local_write_time__";
function __PRIVATE_isServerTimestamp(e) {
    var _Ue, _e_mapValue;
    var t = (_Ue = ((e === null || e === void 0 ? void 0 : (_e_mapValue = e.mapValue) === null || _e_mapValue === void 0 ? void 0 : _e_mapValue.fields) || {})[Ue]) === null || _Ue === void 0 ? void 0 : _Ue.stringValue;
    return t === Be;
}
/**
 * Creates a new ServerTimestamp proto value (using the internal format).
 */ /**
 * Returns the value of the field before this ServerTimestamp was set.
 *
 * Preserving the previous values allows the user to display the last resoled
 * value until the backend responds with the timestamp.
 */ function __PRIVATE_getPreviousValue(e) {
    var t = e.mapValue.fields[ke];
    return __PRIVATE_isServerTimestamp(t) ? __PRIVATE_getPreviousValue(t) : t;
}
/**
 * Returns the local time at which this timestamp was first set.
 */ function __PRIVATE_getLocalWriteTime(e) {
    var t = __PRIVATE_normalizeTimestamp(e.mapValue.fields[qe].timestampValue);
    return new Timestamp(t.seconds, t.nanos);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var DatabaseInfo = function DatabaseInfo(e, t, n, r, i, s, _, o, a, u, c, l, E) {
    "use strict";
    (0, $4QweW._)(this, DatabaseInfo);
    this.databaseId = e, this.appId = t, this.persistenceKey = n, this.host = r, this.ssl = i, this.forceLongPolling = s, this.autoDetectLongPolling = _, this.longPollingOptions = o, this.useFetchStreams = a, this.isUsingEmulator = u, this.apiKey = c, this._customHeaders = l, this.grpcFlowControlWindow = E;
};
/** The default database name for a project. */ var $e = "(default)";
/**
 * Represents the database ID a Firestore client is associated with.
 * @internal
 */ var DatabaseId = /*#__PURE__*/ function() {
    "use strict";
    function DatabaseId(e, t) {
        (0, $4QweW._)(this, DatabaseId);
        this.projectId = e, this.database = t || $e;
    }
    (0, $6hK4i._)(DatabaseId, [
        {
            key: "isDefaultDatabase",
            get: function get() {
                return this.database === $e;
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return e instanceof DatabaseId && e.projectId === this.projectId && e.database === this.database;
            }
        }
    ], [
        {
            key: "empty",
            value: function empty() {
                return new DatabaseId("", "");
            }
        }
    ]);
    return DatabaseId;
}();
function __PRIVATE_databaseIdFromApp(t, n) {
    if (!Object.prototype.hasOwnProperty.apply(t.options, [
        "projectId"
    ])) throw new e(ta.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
    return new DatabaseId(t.options.projectId, n);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Sentinel value that sorts before any Mutation Batch ID. */ var Ke = -1;
/**
 * Returns whether a variable is either undefined or null.
 */ function __PRIVATE_isNullOrUndefined(e) {
    return null == e;
}
/** Returns whether the value represents -0. */ function __PRIVATE_isNegativeZero(e) {
    // Detect if the value is -0.0. Based on polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    return 0 === e && 1 / e == -1 / 0;
}
function __PRIVATE_isNumber$1(e) {
    return "number" == typeof e;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value - The value to test for being an integer and in the safe range
 */ function isSafeInteger(e) {
    return "number" == typeof e && Number.isInteger(e) && !__PRIVATE_isNegativeZero(e) && e <= Number.MAX_SAFE_INTEGER && e >= Number.MIN_SAFE_INTEGER;
}
function __PRIVATE_isString$1(e) {
    return "string" == typeof e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var Qe = "__type__", We = "__max__", Ge = {
    mapValue: {
        fields: {
            __type__: {
                stringValue: We
            }
        }
    }
}, ze = "__vector__", je = "value", He = {
    nullValue: "NULL_VALUE"
}, Je = {
    booleanValue: true
}, Ye = {
    booleanValue: false
};
/** Extracts the backend's type order for the provided value. */ function __PRIVATE_typeOrder(e) {
    return "nullValue" in e ? 0 /* TypeOrder.NullValue */  : "booleanValue" in e ? 1 /* TypeOrder.BooleanValue */  : "integerValue" in e || "doubleValue" in e ? 2 /* TypeOrder.NumberValue */  : "timestampValue" in e ? 3 /* TypeOrder.TimestampValue */  : "stringValue" in e ? 5 /* TypeOrder.StringValue */  : "bytesValue" in e ? 6 /* TypeOrder.BlobValue */  : "referenceValue" in e ? 7 /* TypeOrder.RefValue */  : "geoPointValue" in e ? 8 /* TypeOrder.GeoPointValue */  : "arrayValue" in e ? 9 /* TypeOrder.ArrayValue */  : "mapValue" in e ? __PRIVATE_isServerTimestamp(e) ? 4 /* TypeOrder.ServerTimestampValue */  : __PRIVATE_isMaxValue(e) ? 9007199254740991 /* TypeOrder.MaxValue */  : __PRIVATE_isVectorValue(e) ? 10 /* TypeOrder.VectorValue */  : 11 /* TypeOrder.ObjectValue */  : l(28295, {
        value: e
    });
}
/** Tests `left` and `right` for equality based on the backend semantics. */ function __PRIVATE_valueEquals$1(e, t, n) {
    if (e === t) return true;
    var r = __PRIVATE_typeOrder(e);
    if (r !== __PRIVATE_typeOrder(t)) return false;
    switch(r){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return true;
        case 1 /* TypeOrder.BooleanValue */ :
            return e.booleanValue === t.booleanValue;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return __PRIVATE_getLocalWriteTime(e).isEqual(__PRIVATE_getLocalWriteTime(t));
        case 3 /* TypeOrder.TimestampValue */ :
            return function __PRIVATE_timestampEquals(e, t) {
                if ("string" == typeof e.timestampValue && "string" == typeof t.timestampValue && e.timestampValue.length === t.timestampValue.length) // Use string equality for ISO 8601 timestamps
                return e.timestampValue === t.timestampValue;
                var _$n = __PRIVATE_normalizeTimestamp(e.timestampValue), r = __PRIVATE_normalizeTimestamp(t.timestampValue);
                return _$n.seconds === r.seconds && _$n.nanos === r.nanos;
            }(e, t);
        case 5 /* TypeOrder.StringValue */ :
            return e.stringValue === t.stringValue;
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_blobEquals(e, t) {
                return __PRIVATE_normalizeByteString(e.bytesValue).isEqual(__PRIVATE_normalizeByteString(t.bytesValue));
            }(e, t);
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue === t.referenceValue;
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_geoPointEquals(e, t) {
                return __PRIVATE_normalizeNumber(e.geoPointValue.latitude) === __PRIVATE_normalizeNumber(t.geoPointValue.latitude) && __PRIVATE_normalizeNumber(e.geoPointValue.longitude) === __PRIVATE_normalizeNumber(t.geoPointValue.longitude);
            }(e, t);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_numberEquals(e, t, n) {
                if ("integerValue" in e && "integerValue" in t) return __PRIVATE_normalizeNumber(e.integerValue) === __PRIVATE_normalizeNumber(t.integerValue);
                var r, i;
                if ("doubleValue" in e && "doubleValue" in t) r = __PRIVATE_normalizeNumber(e.doubleValue), i = __PRIVATE_normalizeNumber(t.doubleValue);
                else {
                    if (!(n === null || n === void 0 ? void 0 : n.i)) return false;
                    var _e_integerValue, _t_integerValue;
                    r = __PRIVATE_normalizeNumber((_e_integerValue = e.integerValue) !== null && _e_integerValue !== void 0 ? _e_integerValue : e.doubleValue), i = __PRIVATE_normalizeNumber((_t_integerValue = t.integerValue) !== null && _t_integerValue !== void 0 ? _t_integerValue : t.doubleValue);
                }
                if (r === i) return !!(n === null || n === void 0 ? void 0 : n.o) || __PRIVATE_isNegativeZero(r) === __PRIVATE_isNegativeZero(i);
                return !!(void 0 === n || n.u) && isNaN(r) && isNaN(i);
            }(e, t, n);
        case 9 /* TypeOrder.ArrayValue */ :
            return __PRIVATE_arrayEquals(e.arrayValue.values || [], t.arrayValue.values || [], function(e, t) {
                return __PRIVATE_valueEquals$1(e, t, n);
            });
        case 10 /* TypeOrder.VectorValue */ :
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_objectEquals(e, t, n) {
                var r = e.mapValue.fields || {}, i = t.mapValue.fields || {};
                if (__PRIVATE_objectSize(r) !== __PRIVATE_objectSize(i)) return false;
                for(var _$e in r)if (r.hasOwnProperty(_$e) && (void 0 === i[_$e] || !__PRIVATE_valueEquals$1(r[_$e], i[_$e], n))) return false;
                return true;
            }(e, t, n);
        default:
            return l(52216, {
                left: e
            });
    }
}
function __PRIVATE_arrayValueContains(e, t) {
    return void 0 !== (e.values || []).find(function(e) {
        return __PRIVATE_valueEquals$1(e, t);
    });
}
function __PRIVATE_valueCompare(e, t) {
    if (e === t) return 0;
    var n = __PRIVATE_typeOrder(e), r = __PRIVATE_typeOrder(t);
    if (n !== r) return __PRIVATE_primitiveComparator(n, r);
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return 0;
        case 1 /* TypeOrder.BooleanValue */ :
            return __PRIVATE_primitiveComparator(e.booleanValue, t.booleanValue);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_compareNumbers(e, t) {
                var n = __PRIVATE_normalizeNumber(e.integerValue || e.doubleValue), r = __PRIVATE_normalizeNumber(t.integerValue || t.doubleValue);
                return n < r ? -1 : n > r ? 1 : n === r ? 0 : // one or both are NaN.
                isNaN(n) ? isNaN(r) ? 0 : -1 : 1;
            }(e, t);
        case 3 /* TypeOrder.TimestampValue */ :
            return __PRIVATE_compareTimestamps(e.timestampValue, t.timestampValue);
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return __PRIVATE_compareTimestamps(__PRIVATE_getLocalWriteTime(e), __PRIVATE_getLocalWriteTime(t));
        case 5 /* TypeOrder.StringValue */ :
            return __PRIVATE_compareUtf8Strings(e.stringValue, t.stringValue);
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_compareBlobs(e, t) {
                var n = __PRIVATE_normalizeByteString(e), r = __PRIVATE_normalizeByteString(t);
                return n.compareTo(r);
            }(e.bytesValue, t.bytesValue);
        case 7 /* TypeOrder.RefValue */ :
            return function __PRIVATE_compareReferences(e, t) {
                var n = e.split("/"), r = t.split("/");
                for(var _$e = 0; _$e < n.length && _$e < r.length; _$e++){
                    var _$t = __PRIVATE_primitiveComparator(n[_$e], r[_$e]);
                    if (0 !== _$t) return _$t;
                }
                return __PRIVATE_primitiveComparator(n.length, r.length);
            }(e.referenceValue, t.referenceValue);
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_compareGeoPoints(e, t) {
                var n = __PRIVATE_primitiveComparator(__PRIVATE_normalizeNumber(e.latitude), __PRIVATE_normalizeNumber(t.latitude));
                if (0 !== n) return n;
                return __PRIVATE_primitiveComparator(__PRIVATE_normalizeNumber(e.longitude), __PRIVATE_normalizeNumber(t.longitude));
            }(e.geoPointValue, t.geoPointValue);
        case 9 /* TypeOrder.ArrayValue */ :
            return __PRIVATE_compareArrays(e.arrayValue, t.arrayValue);
        case 10 /* TypeOrder.VectorValue */ :
            return function __PRIVATE_compareVectors(e, t) {
                var _n_je, _r_je, _i_values, _s_values;
                var n = e.fields || {}, r = t.fields || {}, i = (_n_je = n[je]) === null || _n_je === void 0 ? void 0 : _n_je.arrayValue, s = (_r_je = r[je]) === null || _r_je === void 0 ? void 0 : _r_je.arrayValue, _ = __PRIVATE_primitiveComparator((i === null || i === void 0 ? void 0 : (_i_values = i.values) === null || _i_values === void 0 ? void 0 : _i_values.length) || 0, (s === null || s === void 0 ? void 0 : (_s_values = s.values) === null || _s_values === void 0 ? void 0 : _s_values.length) || 0);
                if (0 !== _) return _;
                return __PRIVATE_compareArrays(i, s);
            }(e.mapValue, t.mapValue);
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_compareMaps(e, t) {
                if (e === Ge.mapValue && t === Ge.mapValue) return 0;
                if (e === Ge.mapValue) return 1;
                if (t === Ge.mapValue) return -1;
                var n = e.fields || {}, r = Object.keys(n), i = t.fields || {}, s = Object.keys(i);
                // Even though MapValues are likely sorted correctly based on their insertion
                // order (e.g. when received from the backend), local modifications can bring
                // elements out of order. We need to re-sort the elements to ensure that
                // canonical IDs are independent of insertion order.
                r.sort(), s.sort();
                for(var _$e = 0; _$e < r.length && _$e < s.length; ++_$e){
                    var _$t = __PRIVATE_compareUtf8Strings(r[_$e], s[_$e]);
                    if (0 !== _$t) return _$t;
                    var _ = __PRIVATE_valueCompare(n[r[_$e]], i[s[_$e]]);
                    if (0 !== _) return _;
                }
                return __PRIVATE_primitiveComparator(r.length, s.length);
            }(e.mapValue, t.mapValue);
        default:
            throw l(23264, {
                l: n
            });
    }
}
function __PRIVATE_compareTimestamps(e, t) {
    if ("string" == typeof e && "string" == typeof t && e.length === t.length) return __PRIVATE_primitiveComparator(e, t);
    var n = __PRIVATE_normalizeTimestamp(e), r = __PRIVATE_normalizeTimestamp(t), i = __PRIVATE_primitiveComparator(n.seconds, r.seconds);
    return 0 !== i ? i : __PRIVATE_primitiveComparator(n.nanos, r.nanos);
}
function __PRIVATE_compareArrays(e, t) {
    var n = e.values || [], r = t.values || [];
    for(var _$e = 0; _$e < n.length && _$e < r.length; ++_$e){
        var _$t = __PRIVATE_valueCompare(n[_$e], r[_$e]);
        if (void 0 !== _$t && 0 !== _$t) return _$t;
    }
    return __PRIVATE_primitiveComparator(n.length, r.length);
}
function canonicalId(e) {
    return __PRIVATE_canonifyValue(e);
}
function __PRIVATE_canonifyValue(e) {
    return "nullValue" in e ? "null" : "booleanValue" in e ? "" + e.booleanValue : "integerValue" in e ? "" + e.integerValue : "doubleValue" in e ? "" + e.doubleValue : "timestampValue" in e ? function __PRIVATE_canonifyTimestamp(e) {
        var t = __PRIVATE_normalizeTimestamp(e);
        return "time(".concat(t.seconds, ",").concat(t.nanos, ")");
    }(e.timestampValue) : "stringValue" in e ? e.stringValue : "bytesValue" in e ? function __PRIVATE_canonifyByteString(e) {
        return __PRIVATE_normalizeByteString(e).toBase64();
    }(e.bytesValue) : "referenceValue" in e ? function __PRIVATE_canonifyReference(e) {
        return DocumentKey.fromName(e).toString();
    }(e.referenceValue) : "geoPointValue" in e ? function __PRIVATE_canonifyGeoPoint(e) {
        return "geo(".concat(e.latitude, ",").concat(e.longitude, ")");
    }(e.geoPointValue) : "arrayValue" in e ? function __PRIVATE_canonifyArray(e) {
        var t = "[", n = true;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = (e.values || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var r = _step.value;
                n ? n = false : t += ",", t += __PRIVATE_canonifyValue(r);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return t + "]";
    }(e.arrayValue) : "mapValue" in e ? function __PRIVATE_canonifyMap(e) {
        // Iteration order in JavaScript is not guaranteed. To ensure that we generate
        // matching canonical IDs for identical maps, we need to sort the keys.
        var t = Object.keys(e.fields || {}).sort();
        var n = "{", r = true;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var i = _step.value;
                r ? r = false : n += ",", n += "".concat(i, ":").concat(__PRIVATE_canonifyValue(e.fields[i]));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return n + "}";
    }(e.mapValue) : l(61005, {
        value: e
    });
}
function __PRIVATE_estimateByteSize(e) {
    switch(__PRIVATE_typeOrder(e)){
        case 0 /* TypeOrder.NullValue */ :
        case 1 /* TypeOrder.BooleanValue */ :
            return 4;
        case 2 /* TypeOrder.NumberValue */ :
            return 8;
        case 3 /* TypeOrder.TimestampValue */ :
        case 8 /* TypeOrder.GeoPointValue */ :
            // GeoPoints are made up of two distinct numbers (latitude + longitude)
            return 16;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            var t = __PRIVATE_getPreviousValue(e);
            return t ? 16 + __PRIVATE_estimateByteSize(t) : 16;
        case 5 /* TypeOrder.StringValue */ :
            // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Data_structures:
            // "JavaScript's String type is [...] a set of elements of 16-bit unsigned
            // integer values"
            return 2 * e.stringValue.length;
        case 6 /* TypeOrder.BlobValue */ :
            return __PRIVATE_normalizeByteString(e.bytesValue).approximateByteSize();
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue.length;
        case 9 /* TypeOrder.ArrayValue */ :
            return function __PRIVATE_estimateArrayByteSize(e) {
                return (e.values || []).reduce(function(e, t) {
                    return e + __PRIVATE_estimateByteSize(t);
                }, 0);
            }(e.arrayValue);
        case 10 /* TypeOrder.VectorValue */ :
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_estimateMapByteSize(e) {
                var t = 0;
                return forEach(e.fields, function(e, n) {
                    t += e.length + __PRIVATE_estimateByteSize(n);
                }), t;
            }(e.mapValue);
        default:
            throw l(13486, {
                value: e
            });
    }
}
function __PRIVATE_refValue(e, t) {
    return {
        referenceValue: "projects/".concat(e.projectId, "/databases/").concat(e.database, "/documents/").concat(t.path.canonicalString())
    };
}
/** Returns true if `value` is an BooleanValue . */ /** Returns true if `value` is an IntegerValue . */ function isInteger(e) {
    return !!e && "integerValue" in e;
}
/** Returns true if `value` is a DoubleValue. */ function __PRIVATE_isDouble(e) {
    return !!e && "doubleValue" in e;
}
/** Returns true if `value` is either an IntegerValue or a DoubleValue. */ function R(e) {
    return isInteger(e) || __PRIVATE_isDouble(e);
}
/** Returns true if `value` is an ArrayValue. */ function isArray(e) {
    return !!e && "arrayValue" in e;
}
/** Returns true if `value` is an ArrayValue. */ /** Returns true if `value` is a NullValue. */ function __PRIVATE_isNullValue(e) {
    return !!e && "nullValue" in e;
}
/** Returns true if `value` is NaN. */ function __PRIVATE_isNanValue(e) {
    return !!e && "doubleValue" in e && isNaN(Number(e.doubleValue));
}
/** Returns true if `value` is Timestamp. */ /** Returns true if `value` is a MapValue. */ function __PRIVATE_isMapValue(e) {
    return !!e && "mapValue" in e;
}
/** Returns true if `value` is a VetorValue. */ function __PRIVATE_isVectorValue(e) {
    var _Qe, _e_mapValue;
    var t = (_Qe = ((e === null || e === void 0 ? void 0 : (_e_mapValue = e.mapValue) === null || _e_mapValue === void 0 ? void 0 : _e_mapValue.fields) || {})[Qe]) === null || _Qe === void 0 ? void 0 : _Qe.stringValue;
    return t === ze;
}
/** Returns true if `value` is a VetorValue. */ function __PRIVATE_getVectorValue(e) {
    var _je, _e_mapValue;
    return (_je = ((e === null || e === void 0 ? void 0 : (_e_mapValue = e.mapValue) === null || _e_mapValue === void 0 ? void 0 : _e_mapValue.fields) || {})[je]) === null || _je === void 0 ? void 0 : _je.arrayValue;
}
/** Creates a deep copy of `source`. */ function __PRIVATE_deepClone(e) {
    if (e.geoPointValue) return {
        geoPointValue: (0, $kWfK0._)({}, e.geoPointValue)
    };
    if (e.timestampValue && "object" == (0, $5djcY._)(e.timestampValue)) return {
        timestampValue: (0, $kWfK0._)({}, e.timestampValue)
    };
    if (e.mapValue) {
        var t = {
            mapValue: {
                fields: {}
            }
        };
        return forEach(e.mapValue.fields, function(e, n) {
            return t.mapValue.fields[e] = __PRIVATE_deepClone(n);
        }), t;
    }
    if (e.arrayValue) {
        var t1 = {
            arrayValue: {
                values: []
            }
        };
        for(var n = 0; n < (e.arrayValue.values || []).length; ++n)t1.arrayValue.values[n] = __PRIVATE_deepClone(e.arrayValue.values[n]);
        return t1;
    }
    return (0, $kWfK0._)({}, e);
}
/** Returns true if the Value represents the canonical {@link #MAX_VALUE} . */ function __PRIVATE_isMaxValue(e) {
    return (((e.mapValue || {}).fields || {}).__type__ || {}).stringValue === We;
}
var _obj;
var Ze = {
    mapValue: {
        fields: (_obj = {}, (0, $6tY97._)(_obj, Qe, {
            stringValue: ze
        }), (0, $6tY97._)(_obj, je, {
            arrayValue: {}
        }), _obj)
    }
};
/** Returns the lowest value for the given value type (inclusive). */ function __PRIVATE_valuesGetLowerBound(e) {
    return "nullValue" in e ? He : "booleanValue" in e ? {
        booleanValue: false
    } : "integerValue" in e || "doubleValue" in e ? {
        doubleValue: NaN
    } : "timestampValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "stringValue" in e ? {
        stringValue: ""
    } : "bytesValue" in e ? {
        bytesValue: ""
    } : "referenceValue" in e ? __PRIVATE_refValue(DatabaseId.empty(), DocumentKey.empty()) : "geoPointValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "arrayValue" in e ? {
        arrayValue: {}
    } : "mapValue" in e ? __PRIVATE_isVectorValue(e) ? Ze : {
        mapValue: {}
    } : l(35942, {
        value: e
    });
}
/** Returns the largest value for the given value type (exclusive). */ function __PRIVATE_valuesGetUpperBound(e) {
    return "nullValue" in e ? {
        booleanValue: false
    } : "booleanValue" in e ? {
        doubleValue: NaN
    } : "integerValue" in e || "doubleValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "timestampValue" in e ? {
        stringValue: ""
    } : "stringValue" in e ? {
        bytesValue: ""
    } : "bytesValue" in e ? __PRIVATE_refValue(DatabaseId.empty(), DocumentKey.empty()) : "referenceValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "geoPointValue" in e ? {
        arrayValue: {}
    } : "arrayValue" in e ? Ze : "mapValue" in e ? __PRIVATE_isVectorValue(e) ? {
        mapValue: {}
    } : Ge : l(61959, {
        value: e
    });
}
function __PRIVATE_lowerBoundCompare(e, t) {
    var n = __PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? -1 : !e.inclusive && t.inclusive ? 1 : 0;
}
function __PRIVATE_upperBoundCompare(e, t) {
    var n = __PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? 1 : !e.inclusive && t.inclusive ? -1 : 0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ObjectValue represents a MapValue in the Firestore Proto and offers the
 * ability to add and remove fields (via the ObjectValueBuilder).
 */ var ObjectValue = /*#__PURE__*/ function() {
    "use strict";
    function ObjectValue(e) {
        (0, $4QweW._)(this, ObjectValue);
        this.value = e;
    }
    (0, $6hK4i._)(ObjectValue, [
        {
            /**
     * Returns the value at the given path or null.
     *
     * @param path - the path to search
     * @returns The value at the path or null if the path is not set.
     */ key: "field",
            value: function field(e) {
                if (e.isEmpty()) return this.value;
                {
                    var t = this.value;
                    for(var n = 0; n < e.length - 1; ++n)if (t = (t.mapValue.fields || {})[e.get(n)], !__PRIVATE_isMapValue(t)) return null;
                    return t = (t.mapValue.fields || {})[e.lastSegment()], t || null;
                }
            }
        },
        {
            /**
     * Sets the field to the provided value.
     *
     * @param path - The field path to set.
     * @param value - The value to set.
     */ key: "set",
            value: function set(e, t) {
                this.getFieldsMap(e.popLast())[e.lastSegment()] = __PRIVATE_deepClone(t);
            }
        },
        {
            /**
     * Sets the provided fields to the provided values.
     *
     * @param data - A map of fields to values (or null for deletes).
     */ key: "setAll",
            value: function setAll(e) {
                var _this = this;
                var t = Oe.emptyPath(), n = {}, r = [];
                e.forEach(function(e, i) {
                    if (!t.isImmediateParentOf(i)) {
                        // Insert the accumulated changes at this parent location
                        var _$e = _this.getFieldsMap(t);
                        _this.applyChanges(_$e, n, r), n = {}, r = [], t = i.popLast();
                    }
                    e ? n[i.lastSegment()] = __PRIVATE_deepClone(e) : r.push(i.lastSegment());
                });
                var i = this.getFieldsMap(t);
                this.applyChanges(i, n, r);
            }
        },
        {
            /**
     * Removes the field at the specified path. If there is no field at the
     * specified path, nothing is changed.
     *
     * @param path - The field path to remove.
     */ key: "delete",
            value: function _delete(e) {
                var t = this.field(e.popLast());
                __PRIVATE_isMapValue(t) && t.mapValue.fields && delete t.mapValue.fields[e.lastSegment()];
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return __PRIVATE_valueEquals$1(this.value, e.value);
            }
        },
        {
            /**
     * Returns the map that contains the leaf element of `path`. If the parent
     * entry does not yet exist, or if it is not a map, a new map will be created.
     */ key: "getFieldsMap",
            value: function getFieldsMap(e) {
                var t = this.value;
                t.mapValue.fields || (t.mapValue = {
                    fields: {}
                });
                for(var n = 0; n < e.length; ++n){
                    var r = t.mapValue.fields[e.get(n)];
                    __PRIVATE_isMapValue(r) && r.mapValue.fields || (r = {
                        mapValue: {
                            fields: {}
                        }
                    }, t.mapValue.fields[e.get(n)] = r), t = r;
                }
                return t.mapValue.fields;
            }
        },
        {
            /**
     * Modifies `fieldsMap` by adding, replacing or deleting the specified
     * entries.
     */ key: "applyChanges",
            value: function applyChanges(e, t, n) {
                forEach(t, function(t, n) {
                    return e[t] = n;
                });
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$t = _step.value;
                        delete e[_$t];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new ObjectValue(__PRIVATE_deepClone(this.value));
            }
        }
    ], [
        {
            key: "empty",
            value: function empty() {
                return new ObjectValue({
                    mapValue: {}
                });
            }
        }
    ]);
    return ObjectValue;
}();
/**
 * Returns a FieldMask built from all fields in a MapValue.
 */ function __PRIVATE_extractFieldMask(e) {
    var t = [];
    return forEach(e.fields, function(e, n) {
        var r = new Oe([
            e
        ]);
        if (__PRIVATE_isMapValue(n)) {
            var _$e = __PRIVATE_extractFieldMask(n.mapValue).fields;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (0 === _$e.length) // Preserve the empty map by adding it to the FieldMask.
            t.push(r);
            else try {
                // For nested and non-empty ObjectValues, add the FieldPath of the
                // leaf nodes.
                for(var _iterator = _$e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$n = _step.value;
                    t.push(r.child(_$n));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        } else // For nested and non-empty ObjectValues, add the FieldPath of the leaf
        // nodes.
        t.push(r);
    }), new FieldMask(t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an DoubleValue for `value` that is encoded based the serializer's
 * `useProto3Json` setting.
 */ function __PRIVATE_toDouble(e, t) {
    if (e.useProto3Json) {
        if (isNaN(t)) return {
            doubleValue: "NaN"
        };
        if (t === 1 / 0) return {
            doubleValue: "Infinity"
        };
        if (t === -1 / 0) return {
            doubleValue: "-Infinity"
        };
    }
    return {
        doubleValue: __PRIVATE_isNegativeZero(t) ? "-0" : t
    };
}
/**
 * Returns an IntegerValue for `value`.
 */ function __PRIVATE_toInteger(e) {
    return {
        integerValue: "" + e
    };
}
/**
 * Returns a value for a number that's appropriate to put into a proto.
 * The return value is an IntegerValue if it can safely represent the value,
 * otherwise a DoubleValue is returned.
 */ function toNumber(e, t, n) {
    return isSafeInteger(t) ? __PRIVATE_toInteger(t) : __PRIVATE_toDouble(e, t);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Used to represent a field transform on a mutation. */ var TransformOperation = function TransformOperation() {
    "use strict";
    (0, $4QweW._)(this, TransformOperation);
    // Make sure that the structural type of `TransformOperation` is unique.
    // See https://github.com/microsoft/TypeScript/issues/5451
    this._ = void 0;
};
/**
 * Computes the local transform result against the provided `previousValue`,
 * optionally using the provided localWriteTime.
 */ function __PRIVATE_applyTransformOperationToLocalView(e, t, n) {
    return e instanceof __PRIVATE_ServerTimestampTransform ? function serverTimestamp$1(e, t) {
        var _obj;
        var _$n = {
            fields: (_obj = {}, (0, $6tY97._)(_obj, Ue, {
                stringValue: Be
            }), (0, $6tY97._)(_obj, qe, {
                timestampValue: {
                    seconds: e.seconds,
                    nanos: e.nanoseconds
                }
            }), _obj)
        };
        // We should avoid storing deeply nested server timestamp map values
        // because we never use the intermediate "previous values".
        // For example:
        // previous: 42L, add: t1, result: t1 -> 42L
        // previous: t1,  add: t2, result: t2 -> 42L (NOT t2 -> t1 -> 42L)
        // previous: t2,  add: t3, result: t3 -> 42L (NOT t3 -> t2 -> t1 -> 42L)
        // `getPreviousValue` recursively traverses server timestamps to find the
        // least recent Value.
        return t && __PRIVATE_isServerTimestamp(t) && (t = __PRIVATE_getPreviousValue(t)), t && (_$n.fields[ke] = t), {
            mapValue: _$n
        };
    }(n, t) : e instanceof __PRIVATE_ArrayUnionTransformOperation ? __PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof __PRIVATE_ArrayRemoveTransformOperation ? __PRIVATE_applyArrayRemoveTransformOperation(e, t) : e instanceof __PRIVATE_NumericIncrementTransformOperation ? function __PRIVATE_applyNumericIncrementTransformOperationToLocalView(e, t) {
        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
        // precision and resolves overflows by reducing precision, we do not
        // manually cap overflows at 2^63.
        var _$n = __PRIVATE_computeTransformOperationBaseValue(e, t), r = asNumber(_$n) + asNumber(e.h);
        return isInteger(_$n) && isInteger(e.h) ? __PRIVATE_toInteger(r) : __PRIVATE_toDouble(e.serializer, r);
    }(e, t) : e instanceof __PRIVATE_NumericMinimumTransformOperation ? function __PRIVATE_applyNumericMinimumTransformOperationToLocalView(e, t) {
        return __PRIVATE_applyNumericTransformOperationToLocalView(e, t, Math.min);
    }(e, t) : e instanceof __PRIVATE_NumericMaximumTransformOperation ? function __PRIVATE_applyNumericMaximumTransformOperationToLocalView(e, t) {
        return __PRIVATE_applyNumericTransformOperationToLocalView(e, t, Math.max);
    }(e, t) : void 0;
}
/**
 * Computes a final transform result after the transform has been acknowledged
 * by the server, potentially using the server-provided transformResult.
 */ function __PRIVATE_applyTransformOperationToRemoteDocument(e, t, n) {
    // The server just sends null as the transform result for array operations,
    // so we have to calculate a result the same as we do for local
    // applications.
    return e instanceof __PRIVATE_ArrayUnionTransformOperation ? __PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof __PRIVATE_ArrayRemoveTransformOperation ? __PRIVATE_applyArrayRemoveTransformOperation(e, t) : n;
}
/**
 * If this transform operation is not idempotent, returns the base value to
 * persist for this transform. If a base value is returned, the transform
 * operation is always applied to this base value, even if document has
 * already been updated.
 *
 * Base values provide consistent behavior for non-idempotent transforms and
 * allow us to return the same latency-compensated value even if the backend
 * has already applied the transform operation. The base value is null for
 * idempotent transforms, as they can be re-played even if the backend has
 * already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent transforms.
 */ function __PRIVATE_computeTransformOperationBaseValue(e, t) {
    return e instanceof __PRIVATE_NumericIncrementTransformOperation ? R(t) ? t : {
        integerValue: 0
    } : null;
}
/** Transforms a value into a server-generated timestamp. */ var __PRIVATE_ServerTimestampTransform = /*#__PURE__*/ function(TransformOperation) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_ServerTimestampTransform, TransformOperation);
    function __PRIVATE_ServerTimestampTransform() {
        (0, $4QweW._)(this, __PRIVATE_ServerTimestampTransform);
        return (0, $ehF45._)(this, __PRIVATE_ServerTimestampTransform, arguments);
    }
    return __PRIVATE_ServerTimestampTransform;
}(TransformOperation);
/** Transforms an array value via a union operation. */ var __PRIVATE_ArrayUnionTransformOperation = /*#__PURE__*/ function(TransformOperation) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_ArrayUnionTransformOperation, TransformOperation);
    function __PRIVATE_ArrayUnionTransformOperation(e) {
        (0, $4QweW._)(this, __PRIVATE_ArrayUnionTransformOperation);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_ArrayUnionTransformOperation), _this.elements = e;
        return _this;
    }
    return __PRIVATE_ArrayUnionTransformOperation;
}(TransformOperation);
function __PRIVATE_applyArrayUnionTransformOperation(e, t) {
    var n = __PRIVATE_coercedFieldValuesArray(t);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _$t = _step.value;
            n.some(function(e) {
                return __PRIVATE_valueEquals$1(e, _$t);
            }) || n.push(_$t);
        };
        for(var _iterator = e.elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        arrayValue: {
            values: n
        }
    };
}
/** Transforms an array value via a remove operation. */ var __PRIVATE_ArrayRemoveTransformOperation = /*#__PURE__*/ function(TransformOperation) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_ArrayRemoveTransformOperation, TransformOperation);
    function __PRIVATE_ArrayRemoveTransformOperation(e) {
        (0, $4QweW._)(this, __PRIVATE_ArrayRemoveTransformOperation);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_ArrayRemoveTransformOperation), _this.elements = e;
        return _this;
    }
    return __PRIVATE_ArrayRemoveTransformOperation;
}(TransformOperation);
function __PRIVATE_applyArrayRemoveTransformOperation(e, t) {
    var n = __PRIVATE_coercedFieldValuesArray(t);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _$t = _step.value;
            n = n.filter(function(e) {
                return !__PRIVATE_valueEquals$1(e, _$t);
            });
        };
        for(var _iterator = e.elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        arrayValue: {
            values: n
        }
    };
}
/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */ var __PRIVATE_NumericTransformOperation = /*#__PURE__*/ function(TransformOperation) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_NumericTransformOperation, TransformOperation);
    function __PRIVATE_NumericTransformOperation(e, t) {
        (0, $4QweW._)(this, __PRIVATE_NumericTransformOperation);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_NumericTransformOperation), _this.serializer = e, _this.h = t;
        return _this;
    }
    return __PRIVATE_NumericTransformOperation;
}(TransformOperation);
var __PRIVATE_NumericIncrementTransformOperation = /*#__PURE__*/ function(__PRIVATE_NumericTransformOperation) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_NumericIncrementTransformOperation, __PRIVATE_NumericTransformOperation);
    function __PRIVATE_NumericIncrementTransformOperation() {
        (0, $4QweW._)(this, __PRIVATE_NumericIncrementTransformOperation);
        return (0, $ehF45._)(this, __PRIVATE_NumericIncrementTransformOperation, arguments);
    }
    return __PRIVATE_NumericIncrementTransformOperation;
}(__PRIVATE_NumericTransformOperation);
var __PRIVATE_NumericMinimumTransformOperation = /*#__PURE__*/ function(__PRIVATE_NumericTransformOperation) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_NumericMinimumTransformOperation, __PRIVATE_NumericTransformOperation);
    function __PRIVATE_NumericMinimumTransformOperation() {
        (0, $4QweW._)(this, __PRIVATE_NumericMinimumTransformOperation);
        return (0, $ehF45._)(this, __PRIVATE_NumericMinimumTransformOperation, arguments);
    }
    return __PRIVATE_NumericMinimumTransformOperation;
}(__PRIVATE_NumericTransformOperation);
var __PRIVATE_NumericMaximumTransformOperation = /*#__PURE__*/ function(__PRIVATE_NumericTransformOperation) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_NumericMaximumTransformOperation, __PRIVATE_NumericTransformOperation);
    function __PRIVATE_NumericMaximumTransformOperation() {
        (0, $4QweW._)(this, __PRIVATE_NumericMaximumTransformOperation);
        return (0, $ehF45._)(this, __PRIVATE_NumericMaximumTransformOperation, arguments);
    }
    return __PRIVATE_NumericMaximumTransformOperation;
}(__PRIVATE_NumericTransformOperation);
function __PRIVATE_applyNumericTransformOperationToLocalView(e, t, n) {
    if (!R(t)) return e.h;
    var r = n(asNumber(t), asNumber(e.h));
    return isInteger(t) && isInteger(e.h) ? __PRIVATE_toInteger(r) : __PRIVATE_toDouble(e.serializer, r);
}
function asNumber(e) {
    return __PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
}
function __PRIVATE_coercedFieldValuesArray(e) {
    return isArray(e) && e.arrayValue.values ? e.arrayValue.values.slice() : [];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A field path and the TransformOperation to perform upon it. */ var FieldTransform = function FieldTransform(e, t) {
    "use strict";
    (0, $4QweW._)(this, FieldTransform);
    this.field = e, this.transform = t;
};
function __PRIVATE_fieldTransformEquals(e, t) {
    return e.field.isEqual(t.field) && function __PRIVATE_transformOperationEquals(e, t) {
        return e instanceof __PRIVATE_ArrayUnionTransformOperation && t instanceof __PRIVATE_ArrayUnionTransformOperation || e instanceof __PRIVATE_ArrayRemoveTransformOperation && t instanceof __PRIVATE_ArrayRemoveTransformOperation ? __PRIVATE_arrayEquals(e.elements, t.elements, __PRIVATE_valueEquals$1) : e instanceof __PRIVATE_NumericIncrementTransformOperation && t instanceof __PRIVATE_NumericIncrementTransformOperation || e instanceof __PRIVATE_NumericMinimumTransformOperation && t instanceof __PRIVATE_NumericMinimumTransformOperation || e instanceof __PRIVATE_NumericMaximumTransformOperation && t instanceof __PRIVATE_NumericMaximumTransformOperation ? __PRIVATE_valueEquals$1(e.h, t.h) : e instanceof __PRIVATE_ServerTimestampTransform && t instanceof __PRIVATE_ServerTimestampTransform;
    }(e.transform, t.transform);
}
/** The result of successfully applying a mutation to the backend. */ var MutationResult = function MutationResult(/**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */ e, /**
     * The resulting fields returned from the backend after a mutation
     * containing field transforms has been committed. Contains one FieldValue
     * for each FieldTransform that was in the mutation.
     *
     * Will be empty if the mutation did not contain any field transforms.
     */ t) {
    "use strict";
    (0, $4QweW._)(this, MutationResult);
    this.version = e, this.transformResults = t;
};
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */ var Precondition = /*#__PURE__*/ function() {
    "use strict";
    function Precondition(e, t) {
        (0, $4QweW._)(this, Precondition);
        this.updateTime = e, this.exists = t;
    }
    (0, $6hK4i._)(Precondition, [
        {
            key: "isNone",
            get: /** Returns whether this Precondition is empty. */ function get() {
                return void 0 === this.updateTime && void 0 === this.exists;
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return this.exists === e.exists && (this.updateTime ? !!e.updateTime && this.updateTime.isEqual(e.updateTime) : !e.updateTime);
            }
        }
    ], [
        {
            key: "none",
            value: /** Creates a new empty Precondition. */ function none() {
                return new Precondition;
            }
        },
        {
            key: "exists",
            value: /** Creates a new Precondition with an exists flag. */ function exists(e) {
                return new Precondition(void 0, e);
            }
        },
        {
            key: "updateTime",
            value: /** Creates a new Precondition based on a version a document exists at. */ function updateTime(e) {
                return new Precondition(e);
            }
        }
    ]);
    return Precondition;
}();
/** Returns true if the preconditions is valid for the given document. */ function __PRIVATE_preconditionIsValidForDocument(e, t) {
    return void 0 !== e.updateTime ? t.isFoundDocument() && t.version.isEqual(e.updateTime) : void 0 === e.exists || e.exists === t.isFoundDocument();
}
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also its version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set and Patch mutations. For Delete mutations, we
 * reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        InvalidDocument(v0)   Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      InvalidDocument(v0)   UnknownDocument(v3)
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     InvalidDocument(v0)   NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set and Patch mutations. As deletes have no
 * explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we transition to an `UnknownDocument` and rely on Watch to send us
 * the updated version.
 *
 * Field transforms are used only with Patch and Set Mutations. We use the
 * `updateTransforms` message to store transforms, rather than the `transforms`s
 * messages.
 *
 * ## Subclassing Notes
 *
 * Every type of mutation needs to implement its own applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document (see `setMutationApplyToRemoteDocument()` for an
 * example).
 */ var Mutation = function Mutation() {
    "use strict";
    (0, $4QweW._)(this, Mutation);
};
/**
 * A utility method to calculate a `Mutation` representing the overlay from the
 * final state of the document, and a `FieldMask` representing the fields that
 * are mutated by the local mutations.
 */ function __PRIVATE_calculateOverlayMutation(e, t) {
    if (!e.hasLocalMutations || t && 0 === t.fields.length) return null;
    // mask is null when sets or deletes are applied to the current document.
    if (null === t) return e.isNoDocument() ? new __PRIVATE_DeleteMutation(e.key, Precondition.none()) : new __PRIVATE_SetMutation(e.key, e.data, Precondition.none());
    {
        var n = e.data, r = ObjectValue.empty();
        var i = new SortedSet(Oe.comparator);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = t.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _$e = _step.value;
                if (!i.has(_$e)) {
                    var _$t = n.field(_$e);
                    // If we are deleting a nested field, we take the immediate parent as
                    // the mask used to construct the resulting mutation.
                    // Justification: Nested fields can create parent fields implicitly. If
                    // only a leaf entry is deleted in later mutations, the parent field
                    // should still remain, but we may have lost this information.
                    // Consider mutation (foo.bar 1), then mutation (foo.bar delete()).
                    // This leaves the final result (foo, {}). Despite the fact that `doc`
                    // has the correct result, `foo` is not in `mask`, and the resulting
                    // mutation would miss `foo`.
                    null === _$t && _$e.length > 1 && (_$e = _$e.popLast(), _$t = n.field(_$e)), null === _$t ? r.delete(_$e) : r.set(_$e, _$t), i = i.add(_$e);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return new __PRIVATE_PatchMutation(e.key, r, new FieldMask(i.toArray()), Precondition.none());
    }
}
/**
 * Applies this mutation to the given document for the purposes of computing a
 * new remote document. If the input document doesn't match the expected state
 * (e.g. it is invalid or outdated), the document type may transition to
 * unknown.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param mutationResult - The result of applying the mutation from the backend.
 */ function __PRIVATE_mutationApplyToRemoteDocument(e, t, n) {
    e instanceof __PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToRemoteDocument(e, t, n) {
        // Unlike setMutationApplyToLocalView, if we're applying a mutation to a
        // remote document the server has accepted the mutation so the precondition
        // must have held.
        var r = e.value.clone(), i = __PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults);
        r.setAll(i), t.convertToFoundDocument(n.version, r).setHasCommittedMutations();
    }(e, t, n) : e instanceof __PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToRemoteDocument(e, t, n) {
        if (!__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // Since the mutation was not rejected, we know that the precondition
        // matched on the backend. We therefore must not have the expected version
        // of the document in our cache and convert to an UnknownDocument with a
        // known updateTime.
        return void t.convertToUnknownDocument(n.version);
        var r = __PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults), i = t.data;
        i.setAll(__PRIVATE_getPatch(e)), i.setAll(r), t.convertToFoundDocument(n.version, i).setHasCommittedMutations();
    }(e, t, n) : function __PRIVATE_deleteMutationApplyToRemoteDocument(e, t, n) {
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        t.convertToNoDocument(n.version).setHasCommittedMutations();
    }(0, t, n);
}
/**
 * Applies this mutation to the given document for the purposes of computing
 * the new local view of a document. If the input document doesn't match the
 * expected state, the document is not modified.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param previousMask - The fields that have been updated before applying this mutation.
 * @param localWriteTime - A timestamp indicating the local write time of the
 *     batch this mutation is a part of.
 * @returns A `FieldMask` representing the fields that are changed by applying this mutation.
 */ function __PRIVATE_mutationApplyToLocalView(e, t, n, r) {
    return e instanceof __PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToLocalView(e, t, n, r) {
        if (!__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // The mutation failed to apply (e.g. a document ID created with add()
        // caused a name collision).
        return n;
        var i = e.value.clone(), s = __PRIVATE_localTransformResults(e.fieldTransforms, r, t);
        return i.setAll(s), t.convertToFoundDocument(t.version, i).setHasLocalMutations(), null;
    // SetMutation overwrites all fields.
    }(e, t, n, r) : e instanceof __PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToLocalView(e, t, n, r) {
        if (!__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return n;
        var i = __PRIVATE_localTransformResults(e.fieldTransforms, r, t), s = t.data;
        if (s.setAll(__PRIVATE_getPatch(e)), s.setAll(i), t.convertToFoundDocument(t.version, s).setHasLocalMutations(), null === n) return null;
        return n.unionWith(e.fieldMask.fields).unionWith(e.fieldTransforms.map(function(e) {
            return e.field;
        }));
    }(e, t, n, r) : function __PRIVATE_deleteMutationApplyToLocalView(e, t, n) {
        if (__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return t.convertToNoDocument(t.version).setHasLocalMutations(), null;
        return n;
    }(e, t, n);
}
/**
 * If this mutation is not idempotent, returns the base value to persist with
 * this mutation. If a base value is returned, the mutation is always applied
 * to this base value, even if document has already been updated.
 *
 * The base value is a sparse object that consists of only the document
 * fields for which this mutation contains a non-idempotent transformation
 * (e.g. a numeric increment). The provided value guarantees consistent
 * behavior for non-idempotent transforms and allow us to return the same
 * latency-compensated value even if the backend has already applied the
 * mutation. The base value is null for idempotent mutations, as they can be
 * re-played even if the backend has already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent mutations.
 */ function __PRIVATE_mutationExtractBaseValue(e, t) {
    var n = null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e.fieldTransforms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var r = _step.value;
            var _$e = t.data.field(r.field), i = __PRIVATE_computeTransformOperationBaseValue(r.transform, _$e || null);
            null != i && (null === n && (n = ObjectValue.empty()), n.set(r.field, i));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return n || null;
}
function __PRIVATE_mutationEquals(e, t) {
    return e.type === t.type && !!e.key.isEqual(t.key) && !!e.precondition.isEqual(t.precondition) && !!function __PRIVATE_fieldTransformsAreEqual(e, t) {
        return void 0 === e && void 0 === t || !(!e || !t) && __PRIVATE_arrayEquals(e, t, function(e, t) {
            return __PRIVATE_fieldTransformEquals(e, t);
        });
    }(e.fieldTransforms, t.fieldTransforms) && (0 /* MutationType.Set */  === e.type ? e.value.isEqual(t.value) : 1 /* MutationType.Patch */  !== e.type || e.data.isEqual(t.data) && e.fieldMask.isEqual(t.fieldMask));
}
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */ var __PRIVATE_SetMutation = /*#__PURE__*/ function(Mutation) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_SetMutation, Mutation);
    function __PRIVATE_SetMutation(e, t, n) {
        var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
        (0, $4QweW._)(this, __PRIVATE_SetMutation);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_SetMutation), _this.key = e, _this.value = t, _this.precondition = n, _this.fieldTransforms = r, _this.type = 0 /* MutationType.Set */ ;
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_SetMutation, [
        {
            key: "getFieldMask",
            value: function getFieldMask() {
                return null;
            }
        }
    ]);
    return __PRIVATE_SetMutation;
}(Mutation);
var __PRIVATE_PatchMutation = /*#__PURE__*/ function(Mutation) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_PatchMutation, Mutation);
    function __PRIVATE_PatchMutation(e, t, n, r) {
        var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [];
        (0, $4QweW._)(this, __PRIVATE_PatchMutation);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_PatchMutation), _this.key = e, _this.data = t, _this.fieldMask = n, _this.precondition = r, _this.fieldTransforms = i, _this.type = 1 /* MutationType.Patch */ ;
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_PatchMutation, [
        {
            key: "getFieldMask",
            value: function getFieldMask() {
                return this.fieldMask;
            }
        }
    ]);
    return __PRIVATE_PatchMutation;
}(Mutation);
function __PRIVATE_getPatch(e) {
    var t = new Map;
    return e.fieldMask.fields.forEach(function(n) {
        if (!n.isEmpty()) {
            var r = e.data.field(n);
            t.set(n, r);
        }
    }), t;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use after a mutation
 * containing transforms has been acknowledged by the server.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param mutableDocument - The current state of the document after applying all
 * previous mutations.
 * @param serverTransformResults - The transform results received by the server.
 * @returns The transform results list.
 */ function __PRIVATE_serverTransformResults(e, t, n) {
    var r = new Map;
    __PRIVATE_hardAssert(e.length === n.length, 32656, {
        T: n.length,
        P: e.length
    });
    for(var i = 0; i < n.length; i++){
        var s = e[i], _ = s.transform, o = t.data.field(s.field);
        r.set(s.field, __PRIVATE_applyTransformOperationToRemoteDocument(_, o, n[i]));
    }
    return r;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use when applying a
 * transform locally.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param localWriteTime - The local time of the mutation (used to
 *     generate ServerTimestampValues).
 * @param mutableDocument - The document to apply transforms on.
 * @returns The transform results list.
 */ function __PRIVATE_localTransformResults(e, t, n) {
    var r = new Map;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var i = _step.value;
            var _$e = i.transform, s = n.data.field(i.field);
            r.set(i.field, __PRIVATE_applyTransformOperationToLocalView(_$e, s, t));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return r;
}
/** A mutation that deletes the document at the given key. */ var __PRIVATE_DeleteMutation = /*#__PURE__*/ function(Mutation) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_DeleteMutation, Mutation);
    function __PRIVATE_DeleteMutation(e, t) {
        (0, $4QweW._)(this, __PRIVATE_DeleteMutation);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_DeleteMutation), _this.key = e, _this.precondition = t, _this.type = 2 /* MutationType.Delete */ , _this.fieldTransforms = [];
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_DeleteMutation, [
        {
            key: "getFieldMask",
            value: function getFieldMask() {
                return null;
            }
        }
    ]);
    return __PRIVATE_DeleteMutation;
}(Mutation);
var __PRIVATE_VerifyMutation = /*#__PURE__*/ function(Mutation) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_VerifyMutation, Mutation);
    function __PRIVATE_VerifyMutation(e, t) {
        (0, $4QweW._)(this, __PRIVATE_VerifyMutation);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_VerifyMutation), _this.key = e, _this.precondition = t, _this.type = 3 /* MutationType.Verify */ , _this.fieldTransforms = [];
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_VerifyMutation, [
        {
            key: "getFieldMask",
            value: function getFieldMask() {
                return null;
            }
        }
    ]);
    return __PRIVATE_VerifyMutation;
}(Mutation);
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */ var Bound = function Bound(e, t) {
    "use strict";
    (0, $4QweW._)(this, Bound);
    this.position = e, this.inclusive = t;
};
function __PRIVATE_boundCompareToDocument(e, t, n) {
    var r = 0;
    for(var i = 0; i < e.position.length; i++){
        var s = t[i], _ = e.position[i];
        if (s.field.isKeyField()) r = DocumentKey.comparator(DocumentKey.fromName(_.referenceValue), n.key);
        else r = __PRIVATE_valueCompare(_, n.data.field(s.field));
        if ("desc" /* Direction.DESCENDING */  === s.dir && (r *= -1), 0 !== r) break;
    }
    return r;
}
/**
 * Returns true if a document sorts after a bound using the provided sort
 * order.
 */ function __PRIVATE_boundEquals(e, t) {
    if (null === e) return null === t;
    if (null === t) return false;
    if (e.inclusive !== t.inclusive || e.position.length !== t.position.length) return false;
    for(var n = 0; n < e.position.length; n++){
        if (!__PRIVATE_valueEquals$1(e.position[n], t.position[n])) return false;
    }
    return true;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var Filter = function Filter() {
    "use strict";
    (0, $4QweW._)(this, Filter);
};
var FieldFilter = /*#__PURE__*/ function(Filter) {
    "use strict";
    (0, $c2MhV._)(FieldFilter, Filter);
    function FieldFilter(e, t, n) {
        (0, $4QweW._)(this, FieldFilter);
        var _this;
        _this = (0, $ehF45._)(this, FieldFilter), _this.field = e, _this.op = t, _this.value = n;
        return _this;
    }
    (0, $6hK4i._)(FieldFilter, [
        {
            key: "matches",
            value: function matches(e) {
                var t = e.data.field(this.field);
                // Types do not have to match in NOT_EQUAL filters.
                return "!=" /* Operator.NOT_EQUAL */  === this.op ? null !== t && void 0 === t.nullValue && this.matchesComparison(__PRIVATE_valueCompare(t, this.value)) : null !== t && __PRIVATE_typeOrder(this.value) === __PRIVATE_typeOrder(t) && this.matchesComparison(__PRIVATE_valueCompare(t, this.value));
            // Only compare types with matching backend order (such as double and int).
            }
        },
        {
            key: "matchesComparison",
            value: function matchesComparison(e) {
                switch(this.op){
                    case "<" /* Operator.LESS_THAN */ :
                        return e < 0;
                    case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                        return e <= 0;
                    case "==" /* Operator.EQUAL */ :
                        return 0 === e;
                    case "!=" /* Operator.NOT_EQUAL */ :
                        return 0 !== e;
                    case ">" /* Operator.GREATER_THAN */ :
                        return e > 0;
                    case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                        return e >= 0;
                    default:
                        return l(47266, {
                            operator: this.op
                        });
                }
            }
        },
        {
            key: "isInequality",
            value: function isInequality() {
                return [
                    "<" /* Operator.LESS_THAN */ ,
                    "<=" /* Operator.LESS_THAN_OR_EQUAL */ ,
                    ">" /* Operator.GREATER_THAN */ ,
                    ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ,
                    "!=" /* Operator.NOT_EQUAL */ ,
                    "not-in" /* Operator.NOT_IN */ 
                ].indexOf(this.op) >= 0;
            }
        },
        {
            key: "getFlattenedFilters",
            value: function getFlattenedFilters() {
                return [
                    this
                ];
            }
        },
        {
            key: "getFilters",
            value: function getFilters() {
                return [
                    this
                ];
            }
        }
    ], [
        {
            key: "create",
            value: /**
     * Creates a filter based on the provided arguments.
     */ function create(e, t, n) {
                return e.isKeyField() ? "in" /* Operator.IN */  === t || "not-in" /* Operator.NOT_IN */  === t ? this.createKeyFieldInFilter(e, t, n) : new __PRIVATE_KeyFieldFilter(e, t, n) : "array-contains" /* Operator.ARRAY_CONTAINS */  === t ? new __PRIVATE_ArrayContainsFilter(e, n) : "in" /* Operator.IN */  === t ? new __PRIVATE_InFilter(e, n) : "not-in" /* Operator.NOT_IN */  === t ? new __PRIVATE_NotInFilter(e, n) : "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === t ? new __PRIVATE_ArrayContainsAnyFilter(e, n) : new FieldFilter(e, t, n);
            }
        },
        {
            key: "createKeyFieldInFilter",
            value: function createKeyFieldInFilter(e, t, n) {
                return "in" /* Operator.IN */  === t ? new __PRIVATE_KeyFieldInFilter(e, n) : new __PRIVATE_KeyFieldNotInFilter(e, n);
            }
        }
    ]);
    return FieldFilter;
}(Filter);
var CompositeFilter = /*#__PURE__*/ function(Filter) {
    "use strict";
    (0, $c2MhV._)(CompositeFilter, Filter);
    function CompositeFilter(e, t) {
        (0, $4QweW._)(this, CompositeFilter);
        var _this;
        _this = (0, $ehF45._)(this, CompositeFilter), _this.filters = e, _this.op = t, _this.I = null;
        return _this;
    }
    (0, $6hK4i._)(CompositeFilter, [
        {
            key: "matches",
            value: function matches(e) {
                return __PRIVATE_compositeFilterIsConjunction(this) ? void 0 === this.filters.find(function(t) {
                    return !t.matches(e);
                }) : void 0 !== this.filters.find(function(t) {
                    return t.matches(e);
                });
            }
        },
        {
            key: "getFlattenedFilters",
            value: function getFlattenedFilters() {
                return null !== this.I || (this.I = this.filters.reduce(function(e, t) {
                    return e.concat(t.getFlattenedFilters());
                }, [])), this.I;
            }
        },
        {
            // Returns a mutable copy of `this.filters`
            key: "getFilters",
            value: function getFilters() {
                return Object.assign([], this.filters);
            }
        }
    ], [
        {
            key: "create",
            value: /**
     * Creates a filter based on the provided arguments.
     */ function create(e, t) {
                return new CompositeFilter(e, t);
            }
        }
    ]);
    return CompositeFilter;
}(Filter);
function __PRIVATE_compositeFilterIsConjunction(e) {
    return "and" /* CompositeOperator.AND */  === e.op;
}
function __PRIVATE_compositeFilterIsDisjunction(e) {
    return "or" /* CompositeOperator.OR */  === e.op;
}
/**
 * Returns true if this filter is a conjunction of field filters only. Returns false otherwise.
 */ function __PRIVATE_compositeFilterIsFlatConjunction(e) {
    return __PRIVATE_compositeFilterIsFlat(e) && __PRIVATE_compositeFilterIsConjunction(e);
}
/**
 * Returns true if this filter does not contain any composite filters. Returns false otherwise.
 */ function __PRIVATE_compositeFilterIsFlat(e) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e.filters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var t = _step.value;
            if (t instanceof CompositeFilter) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function __PRIVATE_canonifyFilter(e) {
    if (e instanceof FieldFilter) // TODO(b/29183165): Technically, this won't be unique if two values have
    // the same description, such as the int 3 and the string "3". So we should
    // add the types in here somehow, too.
    return e.field.canonicalString() + e.op.toString() + canonicalId(e.value);
    if (__PRIVATE_compositeFilterIsFlatConjunction(e)) // Older SDK versions use an implicit AND operation between their filters.
    // In the new SDK versions, the developer may use an explicit AND filter.
    // To stay consistent with the old usages, we add a special case to ensure
    // the canonical ID for these two are the same. For example:
    // `col.whereEquals("a", 1).whereEquals("b", 2)` should have the same
    // canonical ID as `col.where(and(equals("a",1), equals("b",2)))`.
    return e.filters.map(function(e) {
        return __PRIVATE_canonifyFilter(e);
    }).join(",");
    {
        // filter instanceof CompositeFilter
        var t = e.filters.map(function(e) {
            return __PRIVATE_canonifyFilter(e);
        }).join(",");
        return "".concat(e.op, "(").concat(t, ")");
    }
}
function __PRIVATE_filterEquals(e, t) {
    return e instanceof FieldFilter ? function __PRIVATE_fieldFilterEquals(e, t) {
        return t instanceof FieldFilter && e.op === t.op && e.field.isEqual(t.field) && __PRIVATE_valueEquals$1(e.value, t.value);
    }(e, t) : e instanceof CompositeFilter ? function __PRIVATE_compositeFilterEquals(e, t) {
        if (t instanceof CompositeFilter && e.op === t.op && e.filters.length === t.filters.length) return e.filters.reduce(function(e, n, r) {
            return e && __PRIVATE_filterEquals(n, t.filters[r]);
        }, true);
        return false;
    }(e, t) : void l(19439);
}
function __PRIVATE_compositeFilterWithAddedFilters(e, t) {
    var n = e.filters.concat(t);
    return CompositeFilter.create(n, e.op);
}
/** Returns a debug description for `filter`. */ function __PRIVATE_stringifyFilter(e) {
    return e instanceof FieldFilter ? function __PRIVATE_stringifyFieldFilter(e) {
        return "".concat(e.field.canonicalString(), " ").concat(e.op, " ").concat(canonicalId(e.value));
    }(e) : e instanceof CompositeFilter ? function __PRIVATE_stringifyCompositeFilter(e) {
        return e.op.toString() + " {" + e.getFilters().map(__PRIVATE_stringifyFilter).join(" ,") + "}";
    }(e) : "Filter";
}
var __PRIVATE_KeyFieldFilter = /*#__PURE__*/ function(FieldFilter) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_KeyFieldFilter, FieldFilter);
    function __PRIVATE_KeyFieldFilter(e, t, n) {
        (0, $4QweW._)(this, __PRIVATE_KeyFieldFilter);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_KeyFieldFilter, [
            e,
            t,
            n
        ]), _this.key = DocumentKey.fromName(n.referenceValue);
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_KeyFieldFilter, [
        {
            key: "matches",
            value: function matches(e) {
                var t = DocumentKey.comparator(e.key, this.key);
                return this.matchesComparison(t);
            }
        }
    ]);
    return __PRIVATE_KeyFieldFilter;
}(FieldFilter);
/** Filter that matches on key fields within an array. */ var __PRIVATE_KeyFieldInFilter = /*#__PURE__*/ function(FieldFilter) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_KeyFieldInFilter, FieldFilter);
    function __PRIVATE_KeyFieldInFilter(e, t) {
        (0, $4QweW._)(this, __PRIVATE_KeyFieldInFilter);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_KeyFieldInFilter, [
            e,
            "in" /* Operator.IN */ ,
            t
        ]), _this.keys = __PRIVATE_extractDocumentKeysFromArrayValue("in" /* Operator.IN */ , t);
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_KeyFieldInFilter, [
        {
            key: "matches",
            value: function matches(e) {
                return this.keys.some(function(t) {
                    return t.isEqual(e.key);
                });
            }
        }
    ]);
    return __PRIVATE_KeyFieldInFilter;
}(FieldFilter);
/** Filter that matches on key fields not present within an array. */ var __PRIVATE_KeyFieldNotInFilter = /*#__PURE__*/ function(FieldFilter) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_KeyFieldNotInFilter, FieldFilter);
    function __PRIVATE_KeyFieldNotInFilter(e, t) {
        (0, $4QweW._)(this, __PRIVATE_KeyFieldNotInFilter);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_KeyFieldNotInFilter, [
            e,
            "not-in" /* Operator.NOT_IN */ ,
            t
        ]), _this.keys = __PRIVATE_extractDocumentKeysFromArrayValue("not-in" /* Operator.NOT_IN */ , t);
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_KeyFieldNotInFilter, [
        {
            key: "matches",
            value: function matches(e) {
                return !this.keys.some(function(t) {
                    return t.isEqual(e.key);
                });
            }
        }
    ]);
    return __PRIVATE_KeyFieldNotInFilter;
}(FieldFilter);
function __PRIVATE_extractDocumentKeysFromArrayValue(e, t) {
    var _t_arrayValue;
    return (((_t_arrayValue = t.arrayValue) === null || _t_arrayValue === void 0 ? void 0 : _t_arrayValue.values) || []).map(function(e) {
        return DocumentKey.fromName(e.referenceValue);
    });
}
/** A Filter that implements the array-contains operator. */ var __PRIVATE_ArrayContainsFilter = /*#__PURE__*/ function(FieldFilter) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_ArrayContainsFilter, FieldFilter);
    function __PRIVATE_ArrayContainsFilter(e, t) {
        (0, $4QweW._)(this, __PRIVATE_ArrayContainsFilter);
        return (0, $ehF45._)(this, __PRIVATE_ArrayContainsFilter, [
            e,
            "array-contains" /* Operator.ARRAY_CONTAINS */ ,
            t
        ]);
    }
    (0, $6hK4i._)(__PRIVATE_ArrayContainsFilter, [
        {
            key: "matches",
            value: function matches(e) {
                var t = e.data.field(this.field);
                return isArray(t) && __PRIVATE_arrayValueContains(t.arrayValue, this.value);
            }
        }
    ]);
    return __PRIVATE_ArrayContainsFilter;
}(FieldFilter);
/** A Filter that implements the IN operator. */ var __PRIVATE_InFilter = /*#__PURE__*/ function(FieldFilter) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_InFilter, FieldFilter);
    function __PRIVATE_InFilter(e, t) {
        (0, $4QweW._)(this, __PRIVATE_InFilter);
        return (0, $ehF45._)(this, __PRIVATE_InFilter, [
            e,
            "in" /* Operator.IN */ ,
            t
        ]);
    }
    (0, $6hK4i._)(__PRIVATE_InFilter, [
        {
            key: "matches",
            value: function matches(e) {
                var t = e.data.field(this.field);
                return null !== t && __PRIVATE_arrayValueContains(this.value.arrayValue, t);
            }
        }
    ]);
    return __PRIVATE_InFilter;
}(FieldFilter);
/** A Filter that implements the not-in operator. */ var __PRIVATE_NotInFilter = /*#__PURE__*/ function(FieldFilter) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_NotInFilter, FieldFilter);
    function __PRIVATE_NotInFilter(e, t) {
        (0, $4QweW._)(this, __PRIVATE_NotInFilter);
        return (0, $ehF45._)(this, __PRIVATE_NotInFilter, [
            e,
            "not-in" /* Operator.NOT_IN */ ,
            t
        ]);
    }
    (0, $6hK4i._)(__PRIVATE_NotInFilter, [
        {
            key: "matches",
            value: function matches(e) {
                if (__PRIVATE_arrayValueContains(this.value.arrayValue, {
                    nullValue: "NULL_VALUE"
                })) return false;
                var t = e.data.field(this.field);
                return null !== t && void 0 === t.nullValue && !__PRIVATE_arrayValueContains(this.value.arrayValue, t);
            }
        }
    ]);
    return __PRIVATE_NotInFilter;
}(FieldFilter);
/** A Filter that implements the array-contains-any operator. */ var __PRIVATE_ArrayContainsAnyFilter = /*#__PURE__*/ function(FieldFilter) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_ArrayContainsAnyFilter, FieldFilter);
    function __PRIVATE_ArrayContainsAnyFilter(e, t) {
        (0, $4QweW._)(this, __PRIVATE_ArrayContainsAnyFilter);
        return (0, $ehF45._)(this, __PRIVATE_ArrayContainsAnyFilter, [
            e,
            "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ,
            t
        ]);
    }
    (0, $6hK4i._)(__PRIVATE_ArrayContainsAnyFilter, [
        {
            key: "matches",
            value: function matches(e) {
                var _this = this;
                var t = e.data.field(this.field);
                return !(!isArray(t) || !t.arrayValue.values) && t.arrayValue.values.some(function(e) {
                    return __PRIVATE_arrayValueContains(_this.value.arrayValue, e);
                });
            }
        }
    ]);
    return __PRIVATE_ArrayContainsAnyFilter;
}(FieldFilter);
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */ var OrderBy = function OrderBy(e) {
    "use strict";
    var t = arguments.length > 1 && arguments[1] !== void 0 /* Direction.ASCENDING */  ? arguments[1] : "asc";
    (0, $4QweW._)(this, OrderBy);
    this.field = e, this.dir = t;
};
function __PRIVATE_orderByEquals(e, t) {
    return e.dir === t.dir && e.field.isEqual(t.field);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */ var SnapshotVersion = /*#__PURE__*/ function() {
    "use strict";
    function SnapshotVersion(e) {
        (0, $4QweW._)(this, SnapshotVersion);
        this.timestamp = e;
    }
    (0, $6hK4i._)(SnapshotVersion, [
        {
            key: "compareTo",
            value: function compareTo(e) {
                return this.timestamp._compareTo(e.timestamp);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return this.timestamp.isEqual(e.timestamp);
            }
        },
        {
            /** Returns a number representation of the version for use in spec tests. */ key: "toMicroseconds",
            value: function toMicroseconds() {
                // Convert to microseconds.
                return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "SnapshotVersion(" + this.timestamp.toString() + ")";
            }
        },
        {
            key: "toTimestamp",
            value: function toTimestamp() {
                return this.timestamp;
            }
        }
    ], [
        {
            key: "fromTimestamp",
            value: function fromTimestamp(e) {
                return new SnapshotVersion(e);
            }
        },
        {
            key: "min",
            value: function min() {
                return new SnapshotVersion(new Timestamp(0, 0));
            }
        },
        {
            key: "max",
            value: function max() {
                return new SnapshotVersion(new Timestamp(253402300799, 999999999));
            }
        }
    ]);
    return SnapshotVersion;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a document in Firestore with a key, version, data and whether it
 * has local mutations applied to it.
 *
 * Documents can transition between states via `convertToFoundDocument()`,
 * `convertToNoDocument()` and `convertToUnknownDocument()`. If a document does
 * not transition to one of these states even after all mutations have been
 * applied, `isValidDocument()` returns false and the document should be removed
 * from all views.
 */ var MutableDocument = /*#__PURE__*/ function() {
    "use strict";
    function MutableDocument(e, t, n, r, i, s, _) {
        (0, $4QweW._)(this, MutableDocument);
        this.key = e, this.documentType = t, this.version = n, this.readTime = r, this.createTime = i, this.data = s, this.documentState = _;
    }
    (0, $6hK4i._)(MutableDocument, [
        {
            /**
     * Changes the document type to indicate that it exists and that its version
     * and data are known.
     */ key: "convertToFoundDocument",
            value: function convertToFoundDocument(e, t) {
                // If a document is switching state from being an invalid or deleted
                // document to a valid (FOUND_DOCUMENT) document, either due to receiving an
                // update from Watch or due to applying a local set mutation on top
                // of a deleted document, our best guess about its createTime would be the
                // version at which the document transitioned to a FOUND_DOCUMENT.
                return !this.createTime.isEqual(SnapshotVersion.min()) || 2 /* DocumentType.NO_DOCUMENT */  !== this.documentType && 0 /* DocumentType.INVALID */  !== this.documentType || (this.createTime = e), this.version = e, this.documentType = 1 /* DocumentType.FOUND_DOCUMENT */ , this.data = t, this.documentState = 0 /* DocumentState.SYNCED */ , this;
            }
        },
        {
            /**
     * Changes the document type to indicate that it doesn't exist at the given
     * version.
     */ key: "convertToNoDocument",
            value: function convertToNoDocument(e) {
                return this.version = e, this.documentType = 2 /* DocumentType.NO_DOCUMENT */ , this.data = ObjectValue.empty(), this.documentState = 0 /* DocumentState.SYNCED */ , this;
            }
        },
        {
            /**
     * Changes the document type to indicate that it exists at a given version but
     * that its data is not known (e.g. a document that was updated without a known
     * base document).
     */ key: "convertToUnknownDocument",
            value: function convertToUnknownDocument(e) {
                return this.version = e, this.documentType = 3 /* DocumentType.UNKNOWN_DOCUMENT */ , this.data = ObjectValue.empty(), this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
            }
        },
        {
            key: "setHasCommittedMutations",
            value: function setHasCommittedMutations() {
                return this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
            }
        },
        {
            key: "setHasLocalMutations",
            value: function setHasLocalMutations() {
                return this.documentState = 1 /* DocumentState.HAS_LOCAL_MUTATIONS */ , this.version = SnapshotVersion.min(), this;
            }
        },
        {
            key: "setReadTime",
            value: function setReadTime(e) {
                return this.readTime = e, this;
            }
        },
        {
            key: "hasLocalMutations",
            get: function get() {
                return 1 /* DocumentState.HAS_LOCAL_MUTATIONS */  === this.documentState;
            }
        },
        {
            key: "hasCommittedMutations",
            get: function get() {
                return 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */  === this.documentState;
            }
        },
        {
            key: "hasPendingWrites",
            get: function get() {
                return this.hasLocalMutations || this.hasCommittedMutations;
            }
        },
        {
            key: "isValidDocument",
            value: function isValidDocument() {
                return 0 /* DocumentType.INVALID */  !== this.documentType;
            }
        },
        {
            key: "isFoundDocument",
            value: function isFoundDocument() {
                return 1 /* DocumentType.FOUND_DOCUMENT */  === this.documentType;
            }
        },
        {
            key: "isNoDocument",
            value: function isNoDocument() {
                return 2 /* DocumentType.NO_DOCUMENT */  === this.documentType;
            }
        },
        {
            key: "isUnknownDocument",
            value: function isUnknownDocument() {
                return 3 /* DocumentType.UNKNOWN_DOCUMENT */  === this.documentType;
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return e instanceof MutableDocument && this.key.isEqual(e.key) && this.version.isEqual(e.version) && this.documentType === e.documentType && this.documentState === e.documentState && this.data.isEqual(e.data);
            }
        },
        {
            key: "mutableCopy",
            value: function mutableCopy() {
                return new MutableDocument(this.key, this.documentType, this.version, this.readTime, this.createTime, this.data.clone(), this.documentState);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "Document(".concat(this.key, ", ").concat(this.version, ", ").concat(JSON.stringify(this.data.value), ", {createTime: ").concat(this.createTime, "}), {documentType: ").concat(this.documentType, "}), {documentState: ").concat(this.documentState, "})");
            }
        }
    ], [
        {
            key: "newInvalidDocument",
            value: /**
     * Creates a document with no known version or data, but which can serve as
     * base document for mutations.
     */ function newInvalidDocument(e) {
                return new MutableDocument(e, 0 /* DocumentType.INVALID */ , /* version */ SnapshotVersion.min(), /* readTime */ SnapshotVersion.min(), /* createTime */ SnapshotVersion.min(), ObjectValue.empty(), 0 /* DocumentState.SYNCED */ );
            }
        },
        {
            key: "newFoundDocument",
            value: /**
     * Creates a new document that is known to exist with the given data at the
     * given version.
     */ function newFoundDocument(e, t, n, r) {
                return new MutableDocument(e, 1 /* DocumentType.FOUND_DOCUMENT */ , /* version */ t, /* readTime */ SnapshotVersion.min(), /* createTime */ n, r, 0 /* DocumentState.SYNCED */ );
            }
        },
        {
            key: "newNoDocument",
            value: /** Creates a new document that is known to not exist at the given version. */ function newNoDocument(e, t) {
                return new MutableDocument(e, 2 /* DocumentType.NO_DOCUMENT */ , /* version */ t, /* readTime */ SnapshotVersion.min(), /* createTime */ SnapshotVersion.min(), ObjectValue.empty(), 0 /* DocumentState.SYNCED */ );
            }
        },
        {
            key: "newUnknownDocument",
            value: /**
     * Creates a new document that is known to exist at the given version but
     * whose data is not known (e.g. a document that was updated without a known
     * base document).
     */ function newUnknownDocument(e, t) {
                return new MutableDocument(e, 3 /* DocumentType.UNKNOWN_DOCUMENT */ , /* version */ t, /* readTime */ SnapshotVersion.min(), /* createTime */ SnapshotVersion.min(), ObjectValue.empty(), 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ );
            }
        }
    ]);
    return MutableDocument;
}();
/**
 * Compares the value for field `field` in the provided documents. Throws if
 * the field does not exist in both documents.
 */ /**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The initial mutation batch id for each index. Gets updated during index
 * backfill.
 */ var Xe = -1;
/**
 * The initial sequence number for each index. Gets updated during index
 * backfill.
 */ /**
 * An index definition for field indexes in Firestore.
 *
 * Every index is associated with a collection. The definition contains a list
 * of fields and their index kind (which can be `ASCENDING`, `DESCENDING` or
 * `CONTAINS` for ArrayContains/ArrayContainsAny queries).
 *
 * Unlike the backend, the SDK does not differentiate between collection or
 * collection group-scoped indices. Every index can be used for both single
 * collection and collection group queries.
 */ var FieldIndex = function FieldIndex(/**
     * The index ID. Returns -1 if the index ID is not available (e.g. the index
     * has not yet been persisted).
     */ e, /** The collection ID this index applies to. */ t, /** The field segments for this index. */ n, /** Shows how up-to-date the index is for the current user. */ r) {
    "use strict";
    (0, $4QweW._)(this, FieldIndex);
    this.indexId = e, this.collectionGroup = t, this.fields = n, this.indexState = r;
};
/** An ID for an index that has not yet been added to persistence.  */ /** Returns the ArrayContains/ArrayContainsAny segment for this index. */ function __PRIVATE_fieldIndexGetArraySegment(e) {
    return e.fields.find(function(e) {
        return 2 /* IndexKind.CONTAINS */  === e.kind;
    });
}
/** Returns all directional (ascending/descending) segments for this index. */ function __PRIVATE_fieldIndexGetDirectionalSegments(e) {
    return e.fields.filter(function(e) {
        return 2 /* IndexKind.CONTAINS */  !== e.kind;
    });
}
/**
 * Returns the order of the document key component for the given index.
 *
 * PORTING NOTE: This is only used in the Web IndexedDb implementation.
 */ /**
 * Compares indexes by collection group and segments. Ignores update time and
 * index ID.
 */ function __PRIVATE_fieldIndexSemanticComparator(e, t) {
    var n = __PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
    if (0 !== n) return n;
    for(var r = 0; r < Math.min(e.fields.length, t.fields.length); ++r)if (n = __PRIVATE_indexSegmentComparator(e.fields[r], t.fields[r]), 0 !== n) return n;
    return __PRIVATE_primitiveComparator(e.fields.length, t.fields.length);
}
/** Returns a debug representation of the field index */ FieldIndex.UNKNOWN_ID = -1;
/** An index component consisting of field path and index type.  */ var IndexSegment = function IndexSegment(/** The field path of the component. */ e, /** The fields sorting order. */ t) {
    "use strict";
    (0, $4QweW._)(this, IndexSegment);
    this.fieldPath = e, this.kind = t;
};
function __PRIVATE_indexSegmentComparator(e, t) {
    var n = Oe.comparator(e.fieldPath, t.fieldPath);
    return 0 !== n ? n : __PRIVATE_primitiveComparator(e.kind, t.kind);
}
/**
 * Stores the "high water mark" that indicates how updated the Index is for the
 * current user.
 */ var IndexState = /*#__PURE__*/ function() {
    "use strict";
    function IndexState(/**
     * Indicates when the index was last updated (relative to other indexes).
     */ e, /** The the latest indexed read time, document and batch id. */ t) {
        (0, $4QweW._)(this, IndexState);
        this.sequenceNumber = e, this.offset = t;
    }
    (0, $6hK4i._)(IndexState, null, [
        {
            key: "empty",
            value: /** The state of an index that has not yet been backfilled. */ function empty() {
                return new IndexState(0, IndexOffset.min());
            }
        }
    ]);
    return IndexState;
}();
/**
 * Creates an offset that matches all documents with a read time higher than
 * `readTime`.
 */ function __PRIVATE_newIndexOffsetSuccessorFromReadTime(e, t) {
    // We want to create an offset that matches all documents with a read time
    // greater than the provided read time. To do so, we technically need to
    // create an offset for `(readTime, MAX_DOCUMENT_KEY)`. While we could use
    // Unicode codepoints to generate MAX_DOCUMENT_KEY, it is much easier to use
    // `(readTime + 1, DocumentKey.empty())` since `> DocumentKey.empty()` matches
    // all valid document IDs.
    var n = e.toTimestamp().seconds, r = e.toTimestamp().nanoseconds + 1, i = SnapshotVersion.fromTimestamp(1e9 === r ? new Timestamp(n + 1, 0) : new Timestamp(n, r));
    return new IndexOffset(i, DocumentKey.empty(), t);
}
/** Creates a new offset based on the provided document. */ function __PRIVATE_newIndexOffsetFromDocument(e) {
    return new IndexOffset(e.readTime, e.key, Xe);
}
/**
 * Stores the latest read time, document and batch ID that were processed for an
 * index.
 */ var IndexOffset = /*#__PURE__*/ function() {
    "use strict";
    function IndexOffset(/**
     * The latest read time version that has been indexed by Firestore for this
     * field index.
     */ e, /**
     * The key of the last document that was indexed for this query. Use
     * `DocumentKey.empty()` if no document has been indexed.
     */ t, /*
     * The largest mutation batch id that's been processed by Firestore.
     */ n) {
        (0, $4QweW._)(this, IndexOffset);
        this.readTime = e, this.documentKey = t, this.largestBatchId = n;
    }
    (0, $6hK4i._)(IndexOffset, null, [
        {
            key: "min",
            value: /** Returns an offset that sorts before all regular offsets. */ function min() {
                return new IndexOffset(SnapshotVersion.min(), DocumentKey.empty(), Xe);
            }
        },
        {
            key: "max",
            value: /** Returns an offset that sorts after all regular offsets. */ function max() {
                return new IndexOffset(SnapshotVersion.max(), DocumentKey.empty(), Xe);
            }
        }
    ]);
    return IndexOffset;
}();
function __PRIVATE_indexOffsetComparator(e, t) {
    var n = e.readTime.compareTo(t.readTime);
    return 0 !== n ? n : (n = DocumentKey.comparator(e.documentKey, t.documentKey), 0 !== n ? n : __PRIVATE_primitiveComparator(e.largestBatchId, t.largestBatchId));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Visible for testing
var __PRIVATE_TargetImpl = function __PRIVATE_TargetImpl(e) {
    "use strict";
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, _ = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null;
    (0, $4QweW._)(this, __PRIVATE_TargetImpl);
    this.path = e, this.collectionGroup = t, this.orderBy = n, this.filters = r, this.limit = i, this.startAt = s, this.endAt = _, this.R = null;
};
/**
 * Initializes a Target with a path and optional additional query constraints.
 * Path must currently be empty if this is a collection group query.
 *
 * NOTE: you should always construct `Target` from `Query.toTarget` instead of
 * using this factory method, because `Query` provides an implicit `orderBy`
 * property.
 */ function __PRIVATE_newTarget(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, _ = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null;
    return new __PRIVATE_TargetImpl(e, t, n, r, i, s, _);
}
function __PRIVATE_canonifyTarget(e) {
    var t = __PRIVATE_debugCast(e);
    if (null === t.R) {
        var _$e = t.path.canonicalString();
        null !== t.collectionGroup && (_$e += "|cg:" + t.collectionGroup), _$e += "|f:", _$e += t.filters.map(function(e) {
            return __PRIVATE_canonifyFilter(e);
        }).join(","), _$e += "|ob:", _$e += t.orderBy.map(function(e) {
            return function __PRIVATE_canonifyOrderBy(e) {
                // TODO(b/29183165): Make this collision robust.
                return e.field.canonicalString() + e.dir;
            }(e);
        }).join(","), __PRIVATE_isNullOrUndefined(t.limit) || (_$e += "|l:", _$e += t.limit), t.startAt && (_$e += "|lb:", _$e += t.startAt.inclusive ? "b:" : "a:", _$e += t.startAt.position.map(function(e) {
            return canonicalId(e);
        }).join(",")), t.endAt && (_$e += "|ub:", _$e += t.endAt.inclusive ? "a:" : "b:", _$e += t.endAt.position.map(function(e) {
            return canonicalId(e);
        }).join(",")), t.R = _$e;
    }
    return t.R;
}
function __PRIVATE_targetEquals(e, t) {
    if (e.limit !== t.limit) return false;
    if (e.orderBy.length !== t.orderBy.length) return false;
    for(var n = 0; n < e.orderBy.length; n++)if (!__PRIVATE_orderByEquals(e.orderBy[n], t.orderBy[n])) return false;
    if (e.filters.length !== t.filters.length) return false;
    for(var n1 = 0; n1 < e.filters.length; n1++)if (!__PRIVATE_filterEquals(e.filters[n1], t.filters[n1])) return false;
    return e.collectionGroup === t.collectionGroup && !!e.path.isEqual(t.path) && !!__PRIVATE_boundEquals(e.startAt, t.startAt) && __PRIVATE_boundEquals(e.endAt, t.endAt);
}
function __PRIVATE_targetIsPipelineTarget(e) {
    // Workaround for circular dependency
    return !!e.isCorePipeline;
}
function __PRIVATE_targetIsDocumentTarget(e) {
    return !!e.path && DocumentKey.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
}
/** Returns the field filters that target the given field path. */ function __PRIVATE_targetGetFieldFiltersForPath(e, t) {
    return e.filters.filter(function(e) {
        return e instanceof FieldFilter && e.field.isEqual(t);
    });
}
/**
 * Returns the values that are used in ARRAY_CONTAINS or ARRAY_CONTAINS_ANY
 * filters. Returns `null` if there are no such filters.
 */ /**
 * Returns the value to use as the lower bound for ascending index segment at
 * the provided `fieldPath` (or the upper bound for an descending segment).
 */ function __PRIVATE_targetGetAscendingBound(e, t, n) {
    var r = He, i = true;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Process all filters to find a value for the current field segment
        for(var _iterator = __PRIVATE_targetGetFieldFiltersForPath(e, t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _$n = _step.value;
            var _$e = He, _$t = true;
            switch(_$n.op){
                case "<" /* Operator.LESS_THAN */ :
                case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                    _$e = __PRIVATE_valuesGetLowerBound(_$n.value);
                    break;
                case "==" /* Operator.EQUAL */ :
                case "in" /* Operator.IN */ :
                case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                    _$e = _$n.value;
                    break;
                case ">" /* Operator.GREATER_THAN */ :
                    _$e = _$n.value, _$t = false;
                    break;
                case "!=" /* Operator.NOT_EQUAL */ :
                case "not-in" /* Operator.NOT_IN */ :
                    _$e = He;
            }
            __PRIVATE_lowerBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: _$e,
                inclusive: _$t
            }) < 0 && (r = _$e, i = _$t);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(var s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            var _$e1 = n.position[s];
            __PRIVATE_lowerBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: _$e1,
                inclusive: n.inclusive
            }) < 0 && (r = _$e1, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/**
 * Returns the value to use as the upper bound for ascending index segment at
 * the provided `fieldPath` (or the lower bound for a descending segment).
 */ function __PRIVATE_targetGetDescendingBound(e, t, n) {
    var r = Ge, i = true;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Process all filters to find a value for the current field segment
        for(var _iterator = __PRIVATE_targetGetFieldFiltersForPath(e, t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _$n = _step.value;
            var _$e = Ge, _$t = true;
            switch(_$n.op){
                case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                case ">" /* Operator.GREATER_THAN */ :
                    _$e = __PRIVATE_valuesGetUpperBound(_$n.value), _$t = false;
                    break;
                case "==" /* Operator.EQUAL */ :
                case "in" /* Operator.IN */ :
                case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                    _$e = _$n.value;
                    break;
                case "<" /* Operator.LESS_THAN */ :
                    _$e = _$n.value, _$t = false;
                    break;
                case "!=" /* Operator.NOT_EQUAL */ :
                case "not-in" /* Operator.NOT_IN */ :
                    _$e = Ge;
            }
            __PRIVATE_upperBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: _$e,
                inclusive: _$t
            }) > 0 && (r = _$e, i = _$t);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(var s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            var _$e1 = n.position[s];
            __PRIVATE_upperBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: _$e1,
                inclusive: n.inclusive
            }) > 0 && (r = _$e1, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/** Returns the number of segments of a perfect index for this target. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Query encapsulates all the query attributes we support in the SDK. It can
 * be run against the LocalStore, as well as be converted to a `Target` to
 * query the RemoteStore results.
 *
 * Visible for testing.
 */ var __PRIVATE_QueryImpl = function __PRIVATE_QueryImpl(e) {
    "use strict";
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, s = arguments.length > 5 && arguments[5] !== void 0 /* LimitType.First */  ? arguments[5] : "F", _ = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, o = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null;
    (0, $4QweW._)(this, __PRIVATE_QueryImpl);
    this.path = e, this.collectionGroup = t, this.explicitOrderBy = n, this.filters = r, this.limit = i, this.limitType = s, this.startAt = _, this.endAt = o, this.A = null, // The corresponding `Target` of this `Query` instance, for use with
    // non-aggregate queries.
    this.V = null, // The corresponding `Target` of this `Query` instance, for use with
    // aggregate queries. Unlike targets for non-aggregate queries,
    // aggregate query targets do not contain normalized order-bys, they only
    // contain explicit order-bys.
    this.m = null, this.startAt, this.endAt;
};
/** Creates a new Query instance with the options provided. */ function __PRIVATE_newQuery(e, t, n, r, i, s, _, o) {
    return new __PRIVATE_QueryImpl(e, t, n, r, i, s, _, o);
}
/** Creates a new Query for a query that matches all documents at `path` */ function __PRIVATE_newQueryForPath(e) {
    return new __PRIVATE_QueryImpl(e);
}
/**
 * Helper to convert a collection group query into a collection query at a
 * specific path. This is used when executing collection group queries, since
 * we have to split the query into a set of collection queries at multiple
 * paths.
 */ /**
 * Returns true if this query does not specify any query constraints that
 * could remove results.
 */ function __PRIVATE_queryMatchesAllDocuments(e) {
    return 0 === e.filters.length && null === e.limit && null == e.startAt && null == e.endAt && (0 === e.explicitOrderBy.length || 1 === e.explicitOrderBy.length && e.explicitOrderBy[0].field.isKeyField());
}
// Returns the sorted set of inequality filter fields used in this query.
/**
 * Returns whether the query matches a single document by path (rather than a
 * collection).
 */ function __PRIVATE_isDocumentQuery$1(e) {
    return DocumentKey.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
}
/**
 * Returns whether the query matches a collection group rather than a specific
 * collection.
 */ function __PRIVATE_isCollectionGroupQuery(e) {
    return null !== e.collectionGroup;
}
/**
 * Returns the normalized order-by constraint that is used to execute the Query,
 * which can be different from the order-by constraints the user provided (e.g.
 * the SDK and backend always orders by `__name__`). The normalized order-by
 * includes implicit order-bys in addition to the explicit user provided
 * order-bys.
 */ function __PRIVATE_queryNormalizedOrderBy(e) {
    var t = __PRIVATE_debugCast(e);
    if (null === t.A) {
        t.A = [];
        var _$e = new Set;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // Any explicit order by fields should be added as is.
            for(var _iterator = t.explicitOrderBy[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var n = _step.value;
                t.A.push(n), _$e.add(n.field.canonicalString());
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // The order of the implicit ordering always matches the last explicit order by.
        var n1 = t.explicitOrderBy.length > 0 ? t.explicitOrderBy[t.explicitOrderBy.length - 1].dir : "asc" /* Direction.ASCENDING */ , r = function __PRIVATE_getInequalityFilterFields(e) {
            var t = new SortedSet(Oe.comparator);
            return e.filters.forEach(function(e) {
                e.getFlattenedFilters().forEach(function(e) {
                    e.isInequality() && (t = t.add(e.field));
                });
            }), t;
        }(t);
        // Any inequality fields not explicitly ordered should be implicitly ordered in a lexicographical
        // order. When there are multiple inequality filters on the same field, the field should be added
        // only once.
        // Note: `SortedSet<FieldPath>` sorts the key field before other fields. However, we want the key
        // field to be sorted last.
        r.forEach(function(r) {
            _$e.has(r.canonicalString()) || r.isKeyField() || t.A.push(new OrderBy(r, n1));
        }), // Add the document key field to the last if it is not explicitly ordered.
        _$e.has(Oe.keyField().canonicalString()) || t.A.push(new OrderBy(Oe.keyField(), n1));
    }
    return t.A;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation.
 */ function __PRIVATE_queryToTarget(e) {
    var t = __PRIVATE_debugCast(e);
    return t.V || (t.V = __PRIVATE__queryToTarget(t, __PRIVATE_queryNormalizedOrderBy(e))), t.V;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation,
 * for use within an aggregate query. Unlike targets for non-aggregate queries,
 * aggregate query targets do not contain normalized order-bys, they only
 * contain explicit order-bys.
 */ function __PRIVATE_queryToAggregateTarget(e) {
    var t = __PRIVATE_debugCast(e);
    return t.m || // Do not include implicit order-bys for aggregate queries.
    (t.m = __PRIVATE__queryToTarget(t, e.explicitOrderBy)), t.m;
}
function __PRIVATE__queryToTarget(e, t) {
    if ("F" /* LimitType.First */  === e.limitType) return __PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, e.startAt, e.endAt);
    {
        // Flip the orderBy directions since we want the last results
        t = t.map(function(e) {
            var _$t = "desc" /* Direction.DESCENDING */  === e.dir ? "asc" /* Direction.ASCENDING */  : "desc" /* Direction.DESCENDING */ ;
            return new OrderBy(e.field, _$t);
        });
        // We need to swap the cursors to match the now-flipped query ordering.
        var n = e.endAt ? new Bound(e.endAt.position, e.endAt.inclusive) : null, r = e.startAt ? new Bound(e.startAt.position, e.startAt.inclusive) : null;
        // Now return as a LimitType.First query.
        return __PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, n, r);
    }
}
function __PRIVATE_queryWithAddedFilter(e, t) {
    var n = e.filters.concat([
        t
    ]);
    return new __PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), n, e.limit, e.limitType, e.startAt, e.endAt);
}
function __PRIVATE_queryWithAddedOrderBy(e, t) {
    // TODO(dimond): validate that orderBy does not list the same key twice.
    var n = e.explicitOrderBy.concat([
        t
    ]);
    return new __PRIVATE_QueryImpl(e.path, e.collectionGroup, n, e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
}
function __PRIVATE_queryWithLimit(e, t, n) {
    return new __PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), t, n, e.startAt, e.endAt);
}
function __PRIVATE_queryWithStartAt(e, t) {
    return new __PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, t, e.endAt);
}
function __PRIVATE_queryWithEndAt(e, t) {
    return new __PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, t);
}
function __PRIVATE_queryEquals(e, t) {
    return __PRIVATE_targetEquals(__PRIVATE_queryToTarget(e), __PRIVATE_queryToTarget(t)) && e.limitType === t.limitType;
}
// TODO(b/29183165): This is used to get a unique string from a query to, for
// example, use as a dictionary key, but the implementation is subject to
// collisions. Make it collision-free.
function __PRIVATE_stringifyQuery(e) {
    return "Query(target=".concat(function __PRIVATE_stringifyTarget(e) {
        var t = e.path.canonicalString();
        return null !== e.collectionGroup && (t += " collectionGroup=" + e.collectionGroup), e.filters.length > 0 && (t += ", filters: [".concat(e.filters.map(function(e) {
            return __PRIVATE_stringifyFilter(e);
        }).join(", "), "]")), __PRIVATE_isNullOrUndefined(e.limit) || (t += ", limit: " + e.limit), e.orderBy.length > 0 && (t += ", orderBy: [".concat(e.orderBy.map(function(e) {
            return function __PRIVATE_stringifyOrderBy(e) {
                return "".concat(e.field.canonicalString(), " (").concat(e.dir, ")");
            }(e);
        }).join(", "), "]")), e.startAt && (t += ", startAt: ", t += e.startAt.inclusive ? "b:" : "a:", t += e.startAt.position.map(function(e) {
            return canonicalId(e);
        }).join(",")), e.endAt && (t += ", endAt: ", t += e.endAt.inclusive ? "a:" : "b:", t += e.endAt.position.map(function(e) {
            return canonicalId(e);
        }).join(",")), "Target(".concat(t, ")");
    }(__PRIVATE_queryToTarget(e)), "; limitType=").concat(e.limitType, ")");
}
/** Returns whether `doc` matches the constraints of `query`. */ function __PRIVATE_queryMatches(e, t) {
    return t.isFoundDocument() && function __PRIVATE_queryMatchesPathAndCollectionGroup(e, t) {
        var n = t.key.path;
        return null !== e.collectionGroup ? t.key.hasCollectionId(e.collectionGroup) && e.path.isPrefixOf(n) : DocumentKey.isDocumentKey(e.path) ? e.path.isEqual(n) : e.path.isImmediateParentOf(n);
    }(e, t) && function __PRIVATE_queryMatchesOrderBy(e, t) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // We must use `queryNormalizedOrderBy()` to get the list of all orderBys (both implicit and explicit).
            // Note that for OR queries, orderBy applies to all disjunction terms and implicit orderBys must
            // be taken into account. For example, the query "a > 1 || b==1" has an implicit "orderBy a" due
            // to the inequality, and is evaluated as "a > 1 orderBy a || b==1 orderBy a".
            // A document with content of {b:1} matches the filters, but does not match the orderBy because
            // it's missing the field 'a'.
            for(var _iterator = __PRIVATE_queryNormalizedOrderBy(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var n = _step.value;
                // order-by key always matches
                if (!n.field.isKeyField() && null === t.data.field(n.field)) return false;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return true;
    }(e, t) && function __PRIVATE_queryMatchesFilters(e, t) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = e.filters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var n = _step.value;
                if (!n.matches(t)) return false;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return true;
    }(e, t) && function __PRIVATE_queryMatchesBounds(e, t) {
        if (e.startAt && !/**
 * Returns true if a document sorts before a bound using the provided sort
 * order.
 */ function __PRIVATE_boundSortsBeforeDocument(e, t, n) {
            var r = __PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r <= 0 : r < 0;
        }(e.startAt, __PRIVATE_queryNormalizedOrderBy(e), t)) return false;
        if (e.endAt && !function __PRIVATE_boundSortsAfterDocument(e, t, n) {
            var r = __PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r >= 0 : r > 0;
        }(e.endAt, __PRIVATE_queryNormalizedOrderBy(e), t)) return false;
        return true;
    }(e, t);
}
/**
 * Returns a new comparator function that can be used to compare two documents
 * based on the Query's ordering constraint.
 */ function __PRIVATE_newQueryComparator(e) {
    return function(t, n) {
        var r = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = __PRIVATE_queryNormalizedOrderBy(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var i = _step.value;
                var _$e = __PRIVATE_compareDocs(i, t, n);
                if (0 !== _$e) return _$e;
                r = r || i.field.isKeyField();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return 0;
    };
}
function __PRIVATE_compareDocs(e, t, n) {
    var r = e.field.isKeyField() ? DocumentKey.comparator(t.key, n.key) : function __PRIVATE_compareDocumentsByField(e, t, n) {
        var r = t.data.field(e), i = n.data.field(e);
        return null !== r && null !== i ? __PRIVATE_valueCompare(r, i) : l(42886);
    }(e.field, t, n);
    switch(e.dir){
        case "asc" /* Direction.ASCENDING */ :
            return r;
        case "desc" /* Direction.DESCENDING */ :
            return -1 * r;
        default:
            return l(19790, {
                direction: e.dir
            });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var ExistenceFilter = function ExistenceFilter(e, t) {
    "use strict";
    (0, $4QweW._)(this, ExistenceFilter);
    this.count = e, this.unchangedNames = t;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers or change this into a const enum.
 */ var et, tt;
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */ function __PRIVATE_isPermanentError(e) {
    switch(e){
        case ta.OK:
            return l(64938);
        case ta.CANCELLED:
        case ta.UNKNOWN:
        case ta.DEADLINE_EXCEEDED:
        case ta.RESOURCE_EXHAUSTED:
        case ta.INTERNAL:
        case ta.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        case ta.UNAUTHENTICATED:
            return false;
        case ta.INVALID_ARGUMENT:
        case ta.NOT_FOUND:
        case ta.ALREADY_EXISTS:
        case ta.PERMISSION_DENIED:
        case ta.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependent on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case ta.ABORTED:
        case ta.OUT_OF_RANGE:
        case ta.UNIMPLEMENTED:
        case ta.DATA_LOSS:
            return true;
        default:
            return l(15467, {
                code: e
            });
    }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */ /**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */ function __PRIVATE_mapCodeFromRpcCode(e) {
    if (void 0 === e) // This shouldn't normally happen, but in certain error cases (like trying
    // to send invalid proto messages) we may get an error with no GRPC code.
    return __PRIVATE_logError("GRPC error has no .code"), ta.UNKNOWN;
    switch(e){
        case et.OK:
            return ta.OK;
        case et.CANCELLED:
            return ta.CANCELLED;
        case et.UNKNOWN:
            return ta.UNKNOWN;
        case et.DEADLINE_EXCEEDED:
            return ta.DEADLINE_EXCEEDED;
        case et.RESOURCE_EXHAUSTED:
            return ta.RESOURCE_EXHAUSTED;
        case et.INTERNAL:
            return ta.INTERNAL;
        case et.UNAVAILABLE:
            return ta.UNAVAILABLE;
        case et.UNAUTHENTICATED:
            return ta.UNAUTHENTICATED;
        case et.INVALID_ARGUMENT:
            return ta.INVALID_ARGUMENT;
        case et.NOT_FOUND:
            return ta.NOT_FOUND;
        case et.ALREADY_EXISTS:
            return ta.ALREADY_EXISTS;
        case et.PERMISSION_DENIED:
            return ta.PERMISSION_DENIED;
        case et.FAILED_PRECONDITION:
            return ta.FAILED_PRECONDITION;
        case et.ABORTED:
            return ta.ABORTED;
        case et.OUT_OF_RANGE:
            return ta.OUT_OF_RANGE;
        case et.UNIMPLEMENTED:
            return ta.UNIMPLEMENTED;
        case et.DATA_LOSS:
            return ta.DATA_LOSS;
        default:
            return l(39323, {
                code: e
            });
    }
}
/**
 * Converts an HTTP response's error status to the equivalent error code.
 *
 * @param status - An HTTP error response status ("FAILED_PRECONDITION",
 * "UNKNOWN", etc.)
 * @returns The equivalent Code. Non-matching responses are mapped to
 *     Code.UNKNOWN.
 */ (tt = et || (et = {}))[tt.OK = 0] = "OK", tt[tt.CANCELLED = 1] = "CANCELLED", tt[tt.UNKNOWN = 2] = "UNKNOWN", tt[tt.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", tt[tt.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", tt[tt.NOT_FOUND = 5] = "NOT_FOUND", tt[tt.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", tt[tt.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", tt[tt.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", tt[tt.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", tt[tt.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", tt[tt.ABORTED = 10] = "ABORTED", tt[tt.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", tt[tt.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", tt[tt.INTERNAL = 13] = "INTERNAL", tt[tt.UNAVAILABLE = 14] = "UNAVAILABLE", tt[tt.DATA_LOSS = 15] = "DATA_LOSS";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A map implementation that uses objects as keys. Objects must have an
 * associated equals function and must be immutable. Entries in the map are
 * stored together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */ var ObjectMap = /*#__PURE__*/ function() {
    "use strict";
    function ObjectMap(e, t) {
        (0, $4QweW._)(this, ObjectMap);
        this.mapKeyFn = e, this.equalsFn = t, /**
         * The inner map for a key/value pair. Due to the possibility of collisions we
         * keep a list of entries that we do a linear search through to find an actual
         * match. Note that collisions should be rare, so we still expect near
         * constant time lookups in practice.
         */ this.inner = {}, /** The number of entries stored in the map */ this.innerSize = 0;
    }
    (0, $6hK4i._)(ObjectMap, [
        {
            /** Get a value for this key, or undefined if it does not exist. */ key: "get",
            value: function get(e) {
                var t = this.mapKeyFn(e), n = this.inner[t];
                if (void 0 !== n) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $6ZpBv._)(_step.value, 2), t1 = _step_value[0], r = _step_value[1];
                            if (this.equalsFn(t1, e)) return r;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
        },
        {
            key: "has",
            value: function has(e) {
                return void 0 !== this.get(e);
            }
        },
        {
            /** Put this key and value in the map. */ key: "set",
            value: function set(e, t) {
                var n = this.mapKeyFn(e), r = this.inner[n];
                if (void 0 === r) return this.inner[n] = [
                    [
                        e,
                        t
                    ]
                ], void this.innerSize++;
                for(var n1 = 0; n1 < r.length; n1++)if (this.equalsFn(r[n1][0], e)) // This is updating an existing entry and does not increase `innerSize`.
                return void (r[n1] = [
                    e,
                    t
                ]);
                r.push([
                    e,
                    t
                ]), this.innerSize++;
            }
        },
        {
            /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */ key: "delete",
            value: function _delete(e) {
                var t = this.mapKeyFn(e), n = this.inner[t];
                if (void 0 === n) return false;
                for(var r = 0; r < n.length; r++)if (this.equalsFn(n[r][0], e)) return 1 === n.length ? delete this.inner[t] : n.splice(r, 1), this.innerSize--, true;
                return false;
            }
        },
        {
            key: "forEach",
            value: function forEach1(e) {
                forEach(this.inner, function(t, n) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $6ZpBv._)(_step.value, 2), t1 = _step_value[0], r = _step_value[1];
                            e(t1, r);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                });
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty1() {
                return isEmpty(this.inner);
            }
        },
        {
            key: "size",
            value: function size() {
                return this.innerSize;
            }
        }
    ]);
    return ObjectMap;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var nt = new SortedMap(DocumentKey.comparator);
function __PRIVATE_mutableDocumentMap() {
    return nt;
}
var rt = new SortedMap(DocumentKey.comparator);
function documentMap() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    var t = rt;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var n = _step.value;
            t = t.insert(n.key, n);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return t;
}
function __PRIVATE_convertOverlayedDocumentMapToDocumentMap(e) {
    var t = rt;
    return e.forEach(function(e, n) {
        return t = t.insert(e, n.overlayedDocument);
    }), t;
}
function __PRIVATE_newOverlayMap() {
    return __PRIVATE_newDocumentKeyMap();
}
function __PRIVATE_newMutationMap() {
    return __PRIVATE_newDocumentKeyMap();
}
function __PRIVATE_newDocumentKeyMap() {
    return new ObjectMap(function(e) {
        return e.toString();
    }, function(e, t) {
        return e.isEqual(t);
    });
}
var it = new SortedMap(DocumentKey.comparator);
var st = new SortedSet(DocumentKey.comparator);
function __PRIVATE_documentKeySet() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    var t = st;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var n = _step.value;
            t = t.add(n);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return t;
}
var _t = new SortedSet(__PRIVATE_primitiveComparator);
function __PRIVATE_targetIdSet() {
    return _t;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The global, singleton instance of TestingHooksSpi.
 *
 * This variable will be `null` in all cases _except_ when running from
 * integration tests that have registered callbacks to be notified of events
 * that happen during the test execution.
 */ var ot = null;
/**
 * Sets the value of the `testingHooksSpi` object.
 * @param instance - the instance to set.
 */ function __PRIVATE_setTestingHooksSpi(e) {
    if (ot) throw new Error("a TestingHooksSpi instance is already set");
    ot = e;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An instance of the Platform's 'TextEncoder' implementation.
 */ function __PRIVATE_newTextEncoder() {
    return new TextEncoder;
}
/**
 * An instance of the Platform's 'TextDecoder' implementation.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var at = new (0, $ak6Ro.Integer)([
    4294967295,
    4294967295
], 0);
// Hash a string using md5 hashing algorithm.
function __PRIVATE_getMd5HashValue(e) {
    var t = __PRIVATE_newTextEncoder().encode(e), n = new (0, $ak6Ro.Md5);
    return n.update(t), new Uint8Array(n.digest());
}
// Interpret the 16 bytes array as two 64-bit unsigned integers, encoded using
// 2’s complement using little endian.
function __PRIVATE_get64BitUints(e) {
    var t = new DataView(e.buffer), n = t.getUint32(0, /* littleEndian= */ true), r = t.getUint32(4, /* littleEndian= */ true), i = t.getUint32(8, /* littleEndian= */ true), s = t.getUint32(12, /* littleEndian= */ true);
    return [
        new (0, $ak6Ro.Integer)([
            n,
            r
        ], 0),
        new (0, $ak6Ro.Integer)([
            i,
            s
        ], 0)
    ];
}
var BloomFilter = /*#__PURE__*/ function() {
    "use strict";
    function BloomFilter(e, t, n) {
        (0, $4QweW._)(this, BloomFilter);
        if (this.bitmap = e, this.padding = t, this.hashCount = n, t < 0 || t >= 8) throw new __PRIVATE_BloomFilterError("Invalid padding: ".concat(t));
        if (n < 0) throw new __PRIVATE_BloomFilterError("Invalid hash count: ".concat(n));
        if (e.length > 0 && 0 === this.hashCount) // Only empty bloom filter can have 0 hash count.
        throw new __PRIVATE_BloomFilterError("Invalid hash count: ".concat(n));
        if (0 === e.length && 0 !== t) // Empty bloom filter should have 0 padding.
        throw new __PRIVATE_BloomFilterError("Invalid padding when bitmap length is 0: ".concat(t));
        this.p = 8 * e.length - t, // Set the bit count in Integer to avoid repetition in mightContain().
        this.S = (0, $ak6Ro.Integer).fromNumber(this.p);
    }
    (0, $6hK4i._)(BloomFilter, [
        {
            // Calculate the ith hash value based on the hashed 64bit integers,
            // and calculate its corresponding bit index in the bitmap to be checked.
            key: "v",
            value: function v(e, t, n) {
                // Calculate hashed value h(i) = h1 + (i * h2).
                var r = e.add(t.multiply((0, $ak6Ro.Integer).fromNumber(n)));
                // Wrap if hash value overflow 64bit.
                return 1 === r.compare(at) && (r = new (0, $ak6Ro.Integer)([
                    r.getBits(0),
                    r.getBits(1)
                ], 0)), r.modulo(this.S).toNumber();
            }
        },
        {
            // Return whether the bit on the given index in the bitmap is set to 1.
            key: "D",
            value: function D(e) {
                return !!(this.bitmap[Math.floor(e / 8)] & 1 << e % 8);
            }
        },
        {
            key: "mightContain",
            value: function mightContain(e) {
                // Empty bitmap should always return false on membership check.
                if (0 === this.p) return false;
                var t = __PRIVATE_getMd5HashValue(e), _$__PRIVATE_get64BitUints = (0, $6ZpBv._)(__PRIVATE_get64BitUints(t), 2), n = _$__PRIVATE_get64BitUints[0], r = _$__PRIVATE_get64BitUints[1];
                for(var _$e = 0; _$e < this.hashCount; _$e++){
                    var t1 = this.v(n, r, _$e);
                    if (!this.D(t1)) return false;
                }
                return true;
            }
        },
        {
            key: "insert",
            value: function insert(e) {
                if (0 === this.p) return;
                var t = __PRIVATE_getMd5HashValue(e), _$__PRIVATE_get64BitUints = (0, $6ZpBv._)(__PRIVATE_get64BitUints(t), 2), n = _$__PRIVATE_get64BitUints[0], r = _$__PRIVATE_get64BitUints[1];
                for(var _$e = 0; _$e < this.hashCount; _$e++){
                    var t1 = this.v(n, r, _$e);
                    this.C(t1);
                }
            }
        },
        {
            key: "C",
            value: function C(e) {
                var t = Math.floor(e / 8), n = e % 8;
                this.bitmap[t] |= 1 << n;
            }
        }
    ], [
        {
            key: "create",
            value: /** Create bloom filter for testing purposes only. */ function create(e, t, n) {
                var r = e % 8 == 0 ? 0 : 8 - e % 8, i = new Uint8Array(Math.ceil(e / 8)), s = new BloomFilter(i, r, t);
                return n.forEach(function(e) {
                    return s.insert(e);
                }), s;
            }
        }
    ]);
    return BloomFilter;
}();
var __PRIVATE_BloomFilterError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_BloomFilterError, Error1);
    function __PRIVATE_BloomFilterError() {
        (0, $4QweW._)(this, __PRIVATE_BloomFilterError);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_BloomFilterError, arguments), _this.name = "BloomFilterError";
        return _this;
    }
    return __PRIVATE_BloomFilterError;
}((0, $67kUy._)(Error));
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */ var RemoteEvent = /*#__PURE__*/ function() {
    "use strict";
    function RemoteEvent(/**
     * The snapshot version this event brings us up to, or MIN if not set.
     */ e, /**
     * A map from target to changes to the target. See TargetChange.
     */ t, /**
     * A map of targets that is known to be inconsistent, and the purpose for
     * re-listening. Listens for these targets should be re-established without
     * resume tokens.
     */ n, /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */ r, /**
     * A set of which augmented documents (pipeline) have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */ i, /**
     * A set of which document updates are due only to limbo resolution targets.
     */ s) {
        (0, $4QweW._)(this, RemoteEvent);
        this.snapshotVersion = e, this.targetChanges = t, this.targetMismatches = n, this.documentUpdates = r, this.augmentedDocumentUpdates = i, this.resolvedLimboDocuments = s;
    }
    (0, $6hK4i._)(RemoteEvent, null, [
        {
            key: "createSynthesizedRemoteEventForCurrentChange",
            value: /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */ // PORTING NOTE: Multi-tab only
            function createSynthesizedRemoteEventForCurrentChange(e, t, n) {
                var r = new Map;
                return r.set(e, TargetChange.createSynthesizedTargetChangeForCurrentChange(e, t, n)), new RemoteEvent(SnapshotVersion.min(), r, new SortedMap(__PRIVATE_primitiveComparator), __PRIVATE_mutableDocumentMap(), __PRIVATE_mutableDocumentMap(), __PRIVATE_documentKeySet());
            }
        }
    ]);
    return RemoteEvent;
}();
/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */ var TargetChange = /*#__PURE__*/ function() {
    "use strict";
    function TargetChange(/**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */ e, /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */ t, /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */ n, /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */ r, /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */ i) {
        (0, $4QweW._)(this, TargetChange);
        this.resumeToken = e, this.current = t, this.addedDocuments = n, this.modifiedDocuments = r, this.removedDocuments = i;
    }
    (0, $6hK4i._)(TargetChange, null, [
        {
            key: "createSynthesizedTargetChangeForCurrentChange",
            value: /**
     * This method is used to create a synthesized TargetChanges that can be used to
     * apply a CURRENT status change to a View (for queries executed in a different
     * tab) or for new queries (to raise snapshots with correct CURRENT status).
     */ function createSynthesizedTargetChangeForCurrentChange(e, t, n) {
                return new TargetChange(n, t, __PRIVATE_documentKeySet(), __PRIVATE_documentKeySet(), __PRIVATE_documentKeySet());
            }
        }
    ]);
    return TargetChange;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */ var __PRIVATE_DocumentWatchChange = function __PRIVATE_DocumentWatchChange(/** The new document applies to all of these targets. */ e, /** The new document is removed from all of these targets. */ t, /** The key of the document for this change. */ n, /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */ r) {
    "use strict";
    (0, $4QweW._)(this, __PRIVATE_DocumentWatchChange);
    this.F = e, this.removedTargetIds = t, this.key = n, this.O = r;
};
var __PRIVATE_ExistenceFilterChange = function __PRIVATE_ExistenceFilterChange(e, t) {
    "use strict";
    (0, $4QweW._)(this, __PRIVATE_ExistenceFilterChange);
    this.targetId = e, this.M = t;
};
var __PRIVATE_WatchTargetChange = function __PRIVATE_WatchTargetChange(/** What kind of change occurred to the watch target. */ e, /** The target IDs that were added/removed/set. */ t) {
    "use strict";
    var /**
     * An opaque, server-assigned token that allows watching a target to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the target. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */ n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ByteString.EMPTY_BYTE_STRING, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    (0, $4QweW._)(this, __PRIVATE_WatchTargetChange);
    this.state = e, this.targetIds = t, this.resumeToken = n, this.cause = r;
};
/** Tracks the internal state of a Watch target. */ var __PRIVATE_TargetState = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_TargetState(e) {
        (0, $4QweW._)(this, __PRIVATE_TargetState);
        this.targetId = e, /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */ this.N = 0, /**
         * Keeps track of the document changes since the last raised snapshot.
         *
         * These changes are continuously updated as we receive document updates and
         * always reflect the current set of changes against the last issued snapshot.
         */ this.L = __PRIVATE_snapshotChangesMap(), /** See public getters for explanations of these fields. */ this.B = ByteString.EMPTY_BYTE_STRING, this.U = false, /**
         * Whether this target state should be included in the next snapshot. We
         * initialize to true so that newly-added targets are included in the next
         * RemoteEvent.
         */ this.k = true;
    }
    (0, $6hK4i._)(__PRIVATE_TargetState, [
        {
            key: "current",
            get: /**
     * Whether this target has been marked 'current'.
     *
     * 'Current' has special meaning in the RPC protocol: It implies that the
     * Watch backend has sent us all changes up to the point at which the target
     * was added and that the target is consistent with the rest of the watch
     * stream.
     */ function get() {
                return this.U;
            }
        },
        {
            key: "resumeToken",
            get: /** The last resume token sent to us for this target. */ function get() {
                return this.B;
            }
        },
        {
            key: "q",
            get: /** Whether this target has pending target adds or target removes. */ function get() {
                return 0 !== this.N;
            }
        },
        {
            key: "$",
            get: /** Whether we have modified any state that should trigger a snapshot. */ function get() {
                return this.k;
            }
        },
        {
            /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */ key: "K",
            value: function K(e) {
                e.approximateByteSize() > 0 && (this.k = true, this.B = e);
            }
        },
        {
            /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */ key: "W",
            value: function W() {
                var e = __PRIVATE_documentKeySet(), t = __PRIVATE_documentKeySet(), n = __PRIVATE_documentKeySet();
                return this.L.forEach(function(r, i) {
                    switch(i){
                        case 0 /* ChangeType.Added */ :
                            e = e.add(r);
                            break;
                        case 2 /* ChangeType.Modified */ :
                            t = t.add(r);
                            break;
                        case 1 /* ChangeType.Removed */ :
                            n = n.add(r);
                            break;
                        default:
                            l(38017, {
                                changeType: i
                            });
                    }
                }), new TargetChange(this.B, this.U, e, t, n);
            }
        },
        {
            /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */ key: "G",
            value: function G() {
                this.k = false, this.L = __PRIVATE_snapshotChangesMap();
            }
        },
        {
            key: "j",
            value: function j(e, t) {
                this.k = true, this.L = this.L.insert(e, t);
            }
        },
        {
            key: "H",
            value: function H(e) {
                this.k = true, this.L = this.L.remove(e);
            }
        },
        {
            key: "J",
            value: function J() {
                this.N += 1;
            }
        },
        {
            key: "Y",
            value: function Y() {
                this.N -= 1, __PRIVATE_hardAssert(this.N >= 0, 3241, {
                    N: this.N,
                    targetId: this.targetId
                });
            }
        },
        {
            key: "Z",
            value: function Z() {
                this.k = true, this.U = true;
            }
        }
    ]);
    return __PRIVATE_TargetState;
}();
var ut = "WatchChangeAggregator";
/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */ var __PRIVATE_WatchChangeAggregator = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_WatchChangeAggregator(e) {
        (0, $4QweW._)(this, __PRIVATE_WatchChangeAggregator);
        this.X = e, /**
         * The internal state of all tracked targets.
         *
         * Targets have the following lifecycle of [states] within the WatchChangeAggregator:
         * [unknown] -> recordPendingTargetRequest(t)
         *           -> [pending]
         *           -> handleTargetChange(t, Added)
         *           -> [added / !pending]
         *           -> recordPendingTargetRequest(t)
         *           -> [pending]
         *           -> handleTargetChange(t, Removed)
         *           -> [unknown]
         *
         * A reset on an [added] target leaves the target in an [added] state.
         * [added / !pending] -> handleTargetChange(t, Reset)
         *                    -> [added / !pending]
         *
         * [active]: is a substate of [added], where also `remoteStore.listenTargets.has(t) === true`.
         *           Generally it is expected that when a target is [active / !pending]
         *           then it is also [active], but the implementation does not guarantee
         *           this will always be true.
         *
         */ this.ee = new Map, /** Keeps track of the documents to update since the last raised snapshot. */ this.te = __PRIVATE_mutableDocumentMap(), this.ne = __PRIVATE_documentTargetMap(), /** Keeps track of the augmented documents to update since the last raised snapshot. */ this.re = __PRIVATE_mutableDocumentMap(), /** A mapping of document keys to their set of target IDs. */ this.ie = __PRIVATE_documentTargetMap(), /**
         * A map of targets with existence filter mismatches. These targets are
         * known to be inconsistent and their listens needs to be re-established by
         * RemoteStore.
         */ this.se = new SortedMap(__PRIVATE_primitiveComparator);
    }
    (0, $6hK4i._)(__PRIVATE_WatchChangeAggregator, [
        {
            /**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */ key: "_e",
            value: function _e(e) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = e.F[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var t = _step.value;
                        e.O && e.O.isFoundDocument() ? this.oe(t, e.O) : this.ae(t, e.key, e.O);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = e.removedTargetIds[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var t1 = _step1.value;
                        this.ae(t1, e.key, e.O);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            /** Processes and adds the WatchTargetChange to the current set of changes. */ key: "ue",
            value: function ue(e) {
                var _this = this;
                this.forEachTarget(e, function(t) {
                    var n = _this.ee.get(t);
                    // skip unknown target state, this indicates the target change is for
                    // an old target
                    if (n) switch(e.state){
                        case 0 /* WatchTargetChangeState.NoChange */ :
                            _this.ce(t) && n.K(e.resumeToken);
                            break;
                        case 1 /* WatchTargetChangeState.Added */ :
                            // We need to decrement the number of pending acks needed from watch
                            // for this targetId.
                            n.Y(), n.q || // We have a freshly added target, so we need to reset any state
                            // that we had previously. This can happen e.g. when remove and add
                            // back a target for existence filter mismatches.
                            n.G(), n.K(e.resumeToken);
                            break;
                        case 2 /* WatchTargetChangeState.Removed */ :
                            // We need to keep track of removed targets to we can post-filter and
                            // remove any target changes.
                            // We need to decrement the number of pending acks needed from watch
                            // for this targetId.
                            n.Y(), n.q || _this.removeTarget(t);
                            break;
                        case 3 /* WatchTargetChangeState.Current */ :
                            _this.ce(t) && (n.Z(), n.K(e.resumeToken));
                            break;
                        case 4 /* WatchTargetChangeState.Reset */ :
                            _this.ce(t) && // Reset the target and synthesizes removes for all existing
                            // documents. The backend will re-add any documents that still
                            // match the target before it sends the next global snapshot.
                            (_this.le(t), n.K(e.resumeToken));
                            break;
                        default:
                            l(56790, {
                                state: e.state
                            });
                    }
                    else __PRIVATE_logDebug(ut, "handleTargetChange received targetChange for untracked target ID (".concat(t, ") with state (").concat(e.state, ")"));
                });
            }
        },
        {
            /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */ key: "forEachTarget",
            value: function forEachTarget(e, t) {
                var _this = this;
                e.targetIds.length > 0 ? e.targetIds.forEach(t) : this.ee.forEach(function(e, n) {
                    _this.ce(n) && t(n);
                });
            }
        },
        {
            key: "Ee",
            value: function Ee(e) {
                var _e_getPipelineDocuments;
                return __PRIVATE_targetIsPipelineTarget(e) ? "documents" === e.getPipelineSourceType() && 1 === ((_e_getPipelineDocuments = e.getPipelineDocuments()) === null || _e_getPipelineDocuments === void 0 ? void 0 : _e_getPipelineDocuments.length) : __PRIVATE_targetIsDocumentTarget(e);
            }
        },
        {
            /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */ key: "he",
            value: function he(e) {
                var t = e.targetId, n = e.M.count, r = this.Te(t);
                if (r) {
                    var i = r.target;
                    if (this.Ee(i)) {
                        if (0 === n) {
                            // The existence filter told us the document does not exist. We deduce
                            // that this document does not exist and apply a deleted document to
                            // our updates. Without applying this deleted document there might be
                            // another query that will raise this document as part of a snapshot
                            // until it is resolved, essentially exposing inconsistency between
                            // queries.
                            var _$e = new DocumentKey(__PRIVATE_targetIsPipelineTarget(i) ? ResourcePath.fromString(i.getPipelineDocuments()[0]) : i.path);
                            this.ae(t, _$e, MutableDocument.newNoDocument(_$e, SnapshotVersion.min()));
                        } else __PRIVATE_hardAssert(1 === n, 20013, "Single document existence filter with count: " + n);
                    } else {
                        var r1 = this.Pe(t);
                        // Existence filter mismatch. Mark the documents as being in limbo, and
                        // raise a snapshot with `isFromCache:true`.
                        if (r1 !== n) {
                            // Apply bloom filter to identify and mark removed documents.
                            var n1 = this.Ie(e), i1 = n1 ? this.Re(n1, e, r1) : 1 /* BloomFilterApplicationStatus.Skipped */ ;
                            if (0 /* BloomFilterApplicationStatus.Success */  !== i1) {
                                // If bloom filter application fails, we reset the mapping and
                                // trigger re-run of the query.
                                this.le(t);
                                var _$e1 = 2 /* BloomFilterApplicationStatus.FalsePositive */  === i1 ? "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */  : "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ ;
                                this.se = this.se.insert(t, _$e1);
                            }
                            ot === null || ot === void 0 ? void 0 : ot.Ae(function __PRIVATE_createExistenceFilterMismatchInfoForTestingHooks(e, t, n, r, i) {
                                var __bits_bitmap, __bits, __bits1;
                                var s = {
                                    localCacheCount: e,
                                    existenceFilterCount: t.count,
                                    databaseId: n.database,
                                    projectId: n.projectId
                                }, _ = t.unchangedNames;
                                var __hashCount, __bits_bitmap_length, __bits_padding;
                                _ && (s.bloomFilter = {
                                    applied: 0 /* BloomFilterApplicationStatus.Success */  === i,
                                    hashCount: (__hashCount = _ === null || _ === void 0 ? void 0 : _.hashCount) !== null && __hashCount !== void 0 ? __hashCount : 0,
                                    bitmapLength: (__bits_bitmap_length = _ === null || _ === void 0 ? void 0 : (__bits = _.bits) === null || __bits === void 0 ? void 0 : (__bits_bitmap = __bits.bitmap) === null || __bits_bitmap === void 0 ? void 0 : __bits_bitmap.length) !== null && __bits_bitmap_length !== void 0 ? __bits_bitmap_length : 0,
                                    padding: (__bits_padding = _ === null || _ === void 0 ? void 0 : (__bits1 = _.bits) === null || __bits1 === void 0 ? void 0 : __bits1.padding) !== null && __bits_padding !== void 0 ? __bits_padding : 0,
                                    mightContain: function(e) {
                                        var _r_mightContain;
                                        return (_r_mightContain = r === null || r === void 0 ? void 0 : r.mightContain(e)) !== null && _r_mightContain !== void 0 ? _r_mightContain : false;
                                    }
                                });
                                return s;
                            }(r1, e.M, this.X.Ve(), n1, i1));
                        }
                    }
                }
            }
        },
        {
            /**
     * Parse the bloom filter from the "unchanged_names" field of an existence
     * filter.
     */ key: "Ie",
            value: function Ie(e) {
                var t = e.M.unchangedNames;
                if (!t || !t.bits) return null;
                var _t_bits = t.bits, tmp = _t_bits.bitmap, n = tmp === void 0 ? "" : tmp, tmp1 = _t_bits.padding, r = tmp1 === void 0 ? 0 : tmp1, tmp2 = t.hashCount, i = tmp2 === void 0 ? 0 : tmp2;
                var s, _;
                try {
                    s = __PRIVATE_normalizeByteString(n).toUint8Array();
                } catch (e) {
                    if (e instanceof __PRIVATE_Base64DecodeError) return __PRIVATE_logWarn("Decoding the base64 bloom filter in existence filter failed (" + e.message + "); ignoring the bloom filter and falling back to full re-query."), null;
                    throw e;
                }
                try {
                    // BloomFilter throws error if the inputs are invalid.
                    _ = new BloomFilter(s, r, i);
                } catch (e) {
                    return __PRIVATE_logWarn(e instanceof __PRIVATE_BloomFilterError ? "BloomFilter error: " : "Applying bloom filter failed: ", e), null;
                }
                return 0 === _.p ? null : _;
            }
        },
        {
            /**
     * Apply bloom filter to remove the deleted documents, and return the
     * application status.
     */ key: "Re",
            value: function Re(e, t, n) {
                return t.M.count === n - this.de(e, t.targetId) ? 0 /* BloomFilterApplicationStatus.Success */  : 2 /* BloomFilterApplicationStatus.FalsePositive */ ;
            }
        },
        {
            /**
     * Filter out removed documents based on bloom filter membership result and
     * return number of documents removed.
     */ key: "de",
            value: function de(e, t) {
                var _this = this;
                var n = this.X.getRemoteKeysForTarget(t);
                var r = 0;
                return n.forEach(function(n) {
                    var i = _this.X.Ve(), s = "projects/".concat(i.projectId, "/databases/").concat(i.database, "/documents/").concat(n.path.canonicalString());
                    e.mightContain(s) || (_this.ae(t, n, /*updatedDocument=*/ null), r++);
                }), r;
            }
        },
        {
            /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */ key: "fe",
            value: function fe(e) {
                var _this = this;
                var t = new Map;
                this.ee.forEach(function(n, r) {
                    var i = _this.Te(r);
                    if (i) {
                        if (n.current && _this.Ee(i.target)) {
                            // Document queries for document that don't exist can produce an empty
                            // result set. To update our local cache, we synthesize a document
                            // delete if we have not previously received the document for this
                            // target. This resolves the limbo state of the document, removing it
                            // from limboDocumentRefs.
                            // TODO(dimond): Ideally we would have an explicit lookup target
                            // instead resulting in an explicit delete message and we could
                            // remove this special logic.
                            var t1 = __PRIVATE_targetIsPipelineTarget(i.target) ? ResourcePath.fromString(i.target.getPipelineDocuments()[0]) : i.target.path, _$n = new DocumentKey(t1);
                            _this.me(_$n).has(r) || _this.pe(r, _$n) || _this.ae(r, _$n, MutableDocument.newNoDocument(_$n, e));
                        }
                        n.$ && (t.set(r, n.W()), n.G());
                    }
                });
                var n = __PRIVATE_documentKeySet();
                // We extract the set of limbo-only document updates as the GC logic
                // special-cases documents that do not appear in the target cache.
                // TODO(gsoltis): Expand on this comment once GC is available in the JS
                // client.
                this.ie.forEach(function(e, t) {
                    var r = true;
                    t.forEachWhile(function(e) {
                        var _$t = _this.Te(e);
                        return !_$t || "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */  === _$t.purpose || (r = false, false);
                    }), r && (n = n.add(e));
                }), this.te.forEach(function(t, n) {
                    return n.setReadTime(e);
                }), this.re.forEach(function(t, n) {
                    return n.setReadTime(e);
                });
                var r = new RemoteEvent(e, t, this.se, this.te, this.re, n);
                return this.te = __PRIVATE_mutableDocumentMap(), this.ne = __PRIVATE_documentTargetMap(), this.re = __PRIVATE_mutableDocumentMap(), this.ie = __PRIVATE_documentTargetMap(), this.se = new SortedMap(__PRIVATE_primitiveComparator), r;
            }
        },
        {
            /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */ // Visible for testing.
            key: "oe",
            value: function oe(e, t) {
                var n = this.ee.get(e);
                // skip unknown or inactive targets
                if (!n || !this.ce(e)) return void __PRIVATE_logDebug(ut, "addDocumentToTarget received document for unknown inactive target (".concat(e, ")"));
                var r = this.pe(e, t.key) ? 2 /* ChangeType.Modified */  : 0 /* ChangeType.Added */ ;
                n.j(t.key, r), __PRIVATE_targetIsPipelineTarget(this.Te(e).target) && "exact" !== this.Te(e).target.getPipelineFlavor() ? this.re = this.re.insert(t.key, t) : this.te = this.te.insert(t.key, t), this.ne = this.ne.insert(t.key, this.me(t.key).add(e)), this.ie = this.ie.insert(t.key, this.ge(t.key).add(e));
            }
        },
        {
            /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */ // Visible for testing.
            key: "ae",
            value: function ae(e, t, n) {
                var r = this.ee.get(e);
                // skip unknown target state, this indicates the target change is for
                // an old target
                r && this.ce(e) ? (this.pe(e, t) ? r.j(t, 1 /* ChangeType.Removed */ ) : // The document may have entered and left the target before we raised a
                // snapshot, so we can just ignore the change.
                r.H(t), this.ie = this.ie.insert(t, this.ge(t).delete(e)), this.ie = this.ie.insert(t, this.ge(t).add(e)), n && (__PRIVATE_targetIsPipelineTarget(this.Te(e).target) && "exact" !== this.Te(e).target.getPipelineFlavor() ? this.re = this.re.insert(t, n) : this.te = this.te.insert(t, n))) : __PRIVATE_logDebug(ut, "removeDocumentFromTarget received document for unknown or inactive target (".concat(e, ")"));
            }
        },
        {
            key: "removeTarget",
            value: function removeTarget(e) {
                this.ee.delete(e);
            }
        },
        {
            /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */ key: "Pe",
            value: function Pe(e) {
                var t = this.ee.get(e);
                // skip unknown target state
                if (!t) return 0;
                var n = t.W();
                return this.X.getRemoteKeysForTarget(e).size + n.addedDocuments.size - n.removedDocuments.size;
            }
        },
        {
            /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */ key: "J",
            value: function J(e) {
                // For each request we get we need to record we need a response for it.
                var t = this.ee.get(e);
                t || (__PRIVATE_logDebug(ut, "recordPendingTargetRequest set up tracking for target ID ".concat(e)), t = new __PRIVATE_TargetState(e), this.ee.set(e, t)), t.J();
            }
        },
        {
            key: "ge",
            value: function ge(e) {
                var t = this.ie.get(e);
                return t || (t = new SortedSet(__PRIVATE_primitiveComparator), this.ie = this.ie.insert(e, t)), t;
            }
        },
        {
            key: "me",
            value: function me(e) {
                var t = this.ne.get(e);
                return t || (t = new SortedSet(__PRIVATE_primitiveComparator), this.ne = this.ne.insert(e, t)), t;
            }
        },
        {
            /**
     * Verifies that the user is still interested in this target (by calling
     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */ key: "ce",
            value: function ce(e) {
                var t = null !== this.Te(e);
                return t || __PRIVATE_logDebug(ut, "Detected inactive target", e), t;
            }
        },
        {
            /**
     * Returns the TargetData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */ key: "Te",
            value: function Te(e) {
                var t = this.ee.get(e);
                return void 0 === t || t.q ? null : this.X.ye(e);
            }
        },
        {
            /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */ key: "le",
            value: function le(e) {
                var _this = this;
                this.ee.set(e, new __PRIVATE_TargetState(e));
                this.X.getRemoteKeysForTarget(e).forEach(function(t) {
                    _this.ae(e, t, /*updatedDocument=*/ null);
                });
            }
        },
        {
            /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */ key: "pe",
            value: function pe(e, t) {
                return this.X.getRemoteKeysForTarget(e).has(t);
            }
        }
    ]);
    return __PRIVATE_WatchChangeAggregator;
}();
function __PRIVATE_documentTargetMap() {
    return new SortedMap(DocumentKey.comparator);
}
function __PRIVATE_snapshotChangesMap() {
    return new SortedMap(DocumentKey.comparator);
}
var ct = function() {
    var e = {
        asc: "ASCENDING",
        desc: "DESCENDING"
    };
    return e;
}(), lt = function() {
    var e = {
        "<": "LESS_THAN",
        "<=": "LESS_THAN_OR_EQUAL",
        ">": "GREATER_THAN",
        ">=": "GREATER_THAN_OR_EQUAL",
        "==": "EQUAL",
        "!=": "NOT_EQUAL",
        "array-contains": "ARRAY_CONTAINS",
        in: "IN",
        "not-in": "NOT_IN",
        "array-contains-any": "ARRAY_CONTAINS_ANY"
    };
    return e;
}(), Et = function() {
    var e = {
        and: "AND",
        or: "OR"
    };
    return e;
}();
/**
 * This class generates JsonObject values for the Datastore API suitable for
 * sending to either GRPC stub methods or via the JSON/HTTP REST API.
 *
 * The serializer supports both Protobuf.js and Proto3 JSON formats. By
 * setting `useProto3Json` to true, the serializer will use the Proto3 JSON
 * format.
 *
 * For a description of the Proto3 JSON format check
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 *
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */ var JsonProtoSerializer = function JsonProtoSerializer(e, t) {
    "use strict";
    (0, $4QweW._)(this, JsonProtoSerializer);
    this.databaseId = e, this.useProto3Json = t;
};
/**
 * Returns a value for a number (or null) that's appropriate to put into
 * a google.protobuf.Int32Value proto.
 * DO NOT USE THIS FOR ANYTHING ELSE.
 * This method cheats. It's typed as returning "number" because that's what
 * our generated proto interfaces say Int32Value must be. But GRPC actually
 * expects a { value: <number> } struct.
 */ function __PRIVATE_toInt32Proto(e, t) {
    return e.useProto3Json || __PRIVATE_isNullOrUndefined(t) ? t : {
        value: t
    };
}
/**
 * Returns a number (or null) from a google.protobuf.Int32Value proto.
 */ /**
 * Returns a value for a Date that's appropriate to put into a proto.
 */ function toTimestamp(e, t) {
    if (e.useProto3Json) return "".concat(new Date(1e3 * t.seconds).toISOString().replace(/\.\d*/, "").replace("Z", ""), ".").concat(("000000000" + t.nanoseconds).slice(-9), "Z");
    return {
        seconds: "" + t.seconds,
        nanos: t.nanoseconds
    };
}
/**
 * Returns a Timestamp typed object given protobuf timestamp value.
 */ function fromTimestamp(e) {
    var t = __PRIVATE_normalizeTimestamp(e);
    return new Timestamp(t.seconds, t.nanos);
}
/**
 * Returns a value for bytes that's appropriate to put in a proto.
 *
 * Visible for testing.
 */ function __PRIVATE_toBytes(e, t) {
    return e.useProto3Json ? t.toBase64() : t.toUint8Array();
}
/**
 * Returns a ByteString based on the proto string value.
 */ function __PRIVATE_toVersion(e, t) {
    return toTimestamp(e, t.toTimestamp());
}
function __PRIVATE_fromVersion(e) {
    return __PRIVATE_hardAssert(!!e, 49232), SnapshotVersion.fromTimestamp(fromTimestamp(e));
}
function __PRIVATE_toResourceName(e, t) {
    return __PRIVATE_toResourcePath(e, t).canonicalString();
}
function __PRIVATE_toResourcePath(e, t) {
    var n = (function __PRIVATE_fullyQualifiedPrefixPath(e) {
        return new ResourcePath([
            "projects",
            e.projectId,
            "databases",
            e.database
        ]);
    })(e).child("documents");
    return void 0 === t ? n : n.child(t);
}
function __PRIVATE_fromResourceName(e) {
    var t = ResourcePath.fromString(e);
    return __PRIVATE_hardAssert(__PRIVATE_isValidResourceName(t), 10190, {
        key: t.toString()
    }), t;
}
function __PRIVATE_toName(e, t) {
    return __PRIVATE_toResourceName(e.databaseId, t.path);
}
function fromName(t, n) {
    var r = __PRIVATE_fromResourceName(n);
    if (r.get(1) !== t.databaseId.projectId) throw new e(ta.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + r.get(1) + " vs " + t.databaseId.projectId);
    if (r.get(3) !== t.databaseId.database) throw new e(ta.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + r.get(3) + " vs " + t.databaseId.database);
    return new DocumentKey(__PRIVATE_extractLocalPathFromResourceName(r));
}
function __PRIVATE_toQueryPath(e, t) {
    return __PRIVATE_toResourceName(e.databaseId, t);
}
function __PRIVATE_fromQueryPath(e) {
    var t = __PRIVATE_fromResourceName(e);
    // In v1beta1 queries for collections at the root did not have a trailing
    // "/documents". In v1 all resource paths contain "/documents". Preserve the
    // ability to read the v1beta1 form for compatibility with queries persisted
    // in the local target cache.
    return 4 === t.length ? ResourcePath.emptyPath() : __PRIVATE_extractLocalPathFromResourceName(t);
}
function __PRIVATE_getEncodedDatabaseId(e) {
    return new ResourcePath([
        "projects",
        e.databaseId.projectId,
        "databases",
        e.databaseId.database
    ]).canonicalString();
}
function __PRIVATE_extractLocalPathFromResourceName(e) {
    return __PRIVATE_hardAssert(e.length > 4 && "documents" === e.get(4), 29091, {
        key: e.toString()
    }), e.popFirst(5);
}
/** Creates a Document proto from key and fields (but no create/update time) */ function __PRIVATE_toMutationDocument(e, t, n) {
    return {
        name: __PRIVATE_toName(e, t),
        fields: n.value.mapValue.fields
    };
}
function __PRIVATE_fromPipelineResponse(e, t, n) {
    var _t_transaction;
    var r = {};
    ((_t_transaction = t.transaction) === null || _t_transaction === void 0 ? void 0 : _t_transaction.length) && (r.transaction = t.transaction);
    var i = t.executionTime ? __PRIVATE_fromVersion(t.executionTime) : void 0;
    return r.executionTime = i, n && (r.key = n.name ? fromName(e, n.name) : void 0, r.fields = new ObjectValue({
        mapValue: {
            fields: n.fields
        }
    }), r.createTime = n.createTime ? __PRIVATE_fromVersion(n.createTime) : void 0, r.updateTime = n.updateTime ? __PRIVATE_fromVersion(n.updateTime) : void 0), r;
}
function fromDocument(e, t, n) {
    var r = fromName(e, t.name), i = __PRIVATE_fromVersion(t.updateTime), s = t.createTime ? __PRIVATE_fromVersion(t.createTime) : SnapshotVersion.min(), _ = new ObjectValue({
        mapValue: {
            fields: t.fields
        }
    }), o = MutableDocument.newFoundDocument(r, i, s, _);
    return n && o.setHasCommittedMutations(), n ? o.setHasCommittedMutations() : o;
}
function __PRIVATE_fromBatchGetDocumentsResponse(e, t) {
    return "found" in t ? function __PRIVATE_fromFound(e, t) {
        __PRIVATE_hardAssert(!!t.found, 43571), t.found.name, t.found.updateTime;
        var n = fromName(e, t.found.name), r = __PRIVATE_fromVersion(t.found.updateTime), i = t.found.createTime ? __PRIVATE_fromVersion(t.found.createTime) : SnapshotVersion.min(), s = new ObjectValue({
            mapValue: {
                fields: t.found.fields
            }
        });
        return MutableDocument.newFoundDocument(n, r, i, s);
    }(e, t) : "missing" in t ? function __PRIVATE_fromMissing(e, t) {
        __PRIVATE_hardAssert(!!t.missing, 3894), __PRIVATE_hardAssert(!!t.readTime, 22933);
        var n = fromName(e, t.missing), r = __PRIVATE_fromVersion(t.readTime);
        return MutableDocument.newNoDocument(n, r);
    }(e, t) : l(7234, {
        result: t
    });
}
function __PRIVATE_fromWatchChange(t, n) {
    var r;
    if ("targetChange" in n) {
        n.targetChange;
        // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
        // if unset
        var i = function __PRIVATE_fromWatchTargetChangeState(e) {
            return "NO_CHANGE" === e ? 0 /* WatchTargetChangeState.NoChange */  : "ADD" === e ? 1 /* WatchTargetChangeState.Added */  : "REMOVE" === e ? 2 /* WatchTargetChangeState.Removed */  : "CURRENT" === e ? 3 /* WatchTargetChangeState.Current */  : "RESET" === e ? 4 /* WatchTargetChangeState.Reset */  : l(39313, {
                state: e
            });
        }(n.targetChange.targetChangeType || "NO_CHANGE"), s = n.targetChange.targetIds || [], _ = function __PRIVATE_fromBytes(e, t) {
            return e.useProto3Json ? (__PRIVATE_hardAssert(void 0 === t || "string" == typeof t, 58123), ByteString.fromBase64String(t || "")) : (__PRIVATE_hardAssert(void 0 === t || // Check if the value is an instance of both Buffer and Uint8Array,
            // despite the fact that Buffer extends Uint8Array. In some
            // environments, such as jsdom, the prototype chain of Buffer
            // does not indicate that it extends Uint8Array.
            t instanceof $c935d68891f19798$require$Buffer || t instanceof Uint8Array, 16193), ByteString.fromUint8Array(t || new Uint8Array));
        }(t, n.targetChange.resumeToken), o = n.targetChange.cause, a = o && function __PRIVATE_fromRpcStatus(t) {
            var _$n = void 0 === t.code ? ta.UNKNOWN : __PRIVATE_mapCodeFromRpcCode(t.code);
            return new e(_$n, t.message || "");
        }(o);
        r = new __PRIVATE_WatchTargetChange(i, s, _, a || null);
    } else if ("documentChange" in n) {
        n.documentChange;
        var e1 = n.documentChange;
        e1.document, e1.document.name, e1.document.updateTime;
        var i1 = fromName(t, e1.document.name), s1 = __PRIVATE_fromVersion(e1.document.updateTime), _1 = e1.document.createTime ? __PRIVATE_fromVersion(e1.document.createTime) : SnapshotVersion.min(), o1 = new ObjectValue({
            mapValue: {
                fields: e1.document.fields
            }
        }), a1 = MutableDocument.newFoundDocument(i1, s1, _1, o1), u = e1.targetIds || [], c = e1.removedTargetIds || [];
        r = new __PRIVATE_DocumentWatchChange(u, c, a1.key, a1);
    } else if ("documentDelete" in n) {
        n.documentDelete;
        var e2 = n.documentDelete;
        e2.document;
        var i2 = fromName(t, e2.document), s2 = e2.readTime ? __PRIVATE_fromVersion(e2.readTime) : SnapshotVersion.min(), _2 = MutableDocument.newNoDocument(i2, s2), o2 = e2.removedTargetIds || [];
        r = new __PRIVATE_DocumentWatchChange([], o2, _2.key, _2);
    } else if ("documentRemove" in n) {
        n.documentRemove;
        var e3 = n.documentRemove;
        e3.document;
        var i3 = fromName(t, e3.document), s3 = e3.removedTargetIds || [];
        r = new __PRIVATE_DocumentWatchChange([], s3, i3, null);
    } else {
        if (!("filter" in n)) return l(11601, {
            we: n
        });
        {
            n.filter;
            var e4 = n.filter;
            e4.targetId;
            var tmp = e4.count, _$t = tmp === void 0 ? 0 : tmp, i4 = e4.unchangedNames, s4 = new ExistenceFilter(_$t, i4), _3 = e4.targetId;
            r = new __PRIVATE_ExistenceFilterChange(_3, s4);
        }
    }
    return r;
}
function toMutation(e, t) {
    var n;
    if (t instanceof __PRIVATE_SetMutation) n = {
        update: __PRIVATE_toMutationDocument(e, t.key, t.value)
    };
    else if (t instanceof __PRIVATE_DeleteMutation) n = {
        delete: __PRIVATE_toName(e, t.key)
    };
    else if (t instanceof __PRIVATE_PatchMutation) n = {
        update: __PRIVATE_toMutationDocument(e, t.key, t.data),
        updateMask: __PRIVATE_toDocumentMask(t.fieldMask)
    };
    else {
        if (!(t instanceof __PRIVATE_VerifyMutation)) return l(16599, {
            be: t.type
        });
        n = {
            verify: __PRIVATE_toName(e, t.key)
        };
    }
    return t.fieldTransforms.length > 0 && (n.updateTransforms = t.fieldTransforms.map(function(e) {
        return function __PRIVATE_toFieldTransform(e, t) {
            var n = t.transform;
            if (n instanceof __PRIVATE_ServerTimestampTransform) return {
                fieldPath: t.field.canonicalString(),
                setToServerValue: "REQUEST_TIME"
            };
            if (n instanceof __PRIVATE_ArrayUnionTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                appendMissingElements: {
                    values: n.elements
                }
            };
            if (n instanceof __PRIVATE_ArrayRemoveTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                removeAllFromArray: {
                    values: n.elements
                }
            };
            if (n instanceof __PRIVATE_NumericIncrementTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                increment: n.h
            };
            if (n instanceof __PRIVATE_NumericMinimumTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                minimum: n.h
            };
            if (n instanceof __PRIVATE_NumericMaximumTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                maximum: n.h
            };
            throw l(20930, {
                transform: t.transform
            });
        }(0, e);
    })), t.precondition.isNone || (n.currentDocument = function __PRIVATE_toPrecondition(e, t) {
        return void 0 !== t.updateTime ? {
            updateTime: __PRIVATE_toVersion(e, t.updateTime)
        } : void 0 !== t.exists ? {
            exists: t.exists
        } : l(27497);
    }(e, t.precondition)), n;
}
function __PRIVATE_fromMutation(e, t) {
    var n = t.currentDocument ? function __PRIVATE_fromPrecondition(e) {
        return void 0 !== e.updateTime ? Precondition.updateTime(__PRIVATE_fromVersion(e.updateTime)) : void 0 !== e.exists ? Precondition.exists(e.exists) : Precondition.none();
    }(t.currentDocument) : Precondition.none(), r = t.updateTransforms ? t.updateTransforms.map(function(t) {
        return function __PRIVATE_fromFieldTransform(e, t) {
            var n = null;
            if ("setToServerValue" in t) __PRIVATE_hardAssert("REQUEST_TIME" === t.setToServerValue, 16630, {
                proto: t
            }), n = new __PRIVATE_ServerTimestampTransform;
            else if ("appendMissingElements" in t) {
                var _$e = t.appendMissingElements.values || [];
                n = new __PRIVATE_ArrayUnionTransformOperation(_$e);
            } else if ("removeAllFromArray" in t) {
                var _$e1 = t.removeAllFromArray.values || [];
                n = new __PRIVATE_ArrayRemoveTransformOperation(_$e1);
            } else "increment" in t ? n = new __PRIVATE_NumericIncrementTransformOperation(e, t.increment) : "minimum" in t ? n = new __PRIVATE_NumericMinimumTransformOperation(e, t.minimum) : "maximum" in t ? n = new __PRIVATE_NumericMaximumTransformOperation(e, t.maximum) : l(16584, {
                proto: t
            });
            var r = Oe.fromServerFormat(t.fieldPath);
            return new FieldTransform(r, n);
        }(e, t);
    }) : [];
    if (t.update) {
        t.update.name;
        var i = fromName(e, t.update.name), s = new ObjectValue({
            mapValue: {
                fields: t.update.fields
            }
        });
        if (t.updateMask) {
            var _$e = function __PRIVATE_fromDocumentMask(e) {
                var _$t = e.fieldPaths || [];
                return new FieldMask(_$t.map(function(e) {
                    return Oe.fromServerFormat(e);
                }));
            }(t.updateMask);
            return new __PRIVATE_PatchMutation(i, s, _$e, n, r);
        }
        return new __PRIVATE_SetMutation(i, s, n, r);
    }
    if (t.delete) {
        var r1 = fromName(e, t.delete);
        return new __PRIVATE_DeleteMutation(r1, n);
    }
    if (t.verify) {
        var r2 = fromName(e, t.verify);
        return new __PRIVATE_VerifyMutation(r2, n);
    }
    return l(1463, {
        proto: t
    });
}
function __PRIVATE_fromWriteResults(e, t) {
    return e && e.length > 0 ? (__PRIVATE_hardAssert(void 0 !== t, 14353), e.map(function(e) {
        return function __PRIVATE_fromWriteResult(e, t) {
            // NOTE: Deletes don't have an updateTime.
            var n = e.updateTime ? __PRIVATE_fromVersion(e.updateTime) : __PRIVATE_fromVersion(t);
            return n.isEqual(SnapshotVersion.min()) && // The Firestore Emulator currently returns an update time of 0 for
            // deletes of non-existing documents (rather than null). This breaks the
            // test "get deleted doc while offline with source=cache" as NoDocuments
            // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
            // TODO(#2149): Remove this when Emulator is fixed
            (n = __PRIVATE_fromVersion(t)), new MutationResult(n, e.transformResults || []);
        }(e, t);
    })) : [];
}
function __PRIVATE_toDocumentsTarget(e, t) {
    return {
        documents: [
            __PRIVATE_toQueryPath(e, t.path)
        ]
    };
}
function __PRIVATE_toQueryTarget(e, t) {
    // Dissect the path into parent, collectionId, and optional key filter.
    var n = {
        structuredQuery: {}
    }, r = t.path;
    var i;
    null !== t.collectionGroup ? (i = r, n.structuredQuery.from = [
        {
            collectionId: t.collectionGroup,
            allDescendants: true
        }
    ]) : (i = r.popLast(), n.structuredQuery.from = [
        {
            collectionId: r.lastSegment()
        }
    ]), n.parent = __PRIVATE_toQueryPath(e, i);
    var s = function __PRIVATE_toFilters(e) {
        if (0 === e.length) return;
        return __PRIVATE_toFilter(CompositeFilter.create(e, "and" /* CompositeOperator.AND */ ));
    }(t.filters);
    s && (n.structuredQuery.where = s);
    var _ = function __PRIVATE_toOrder(e) {
        if (0 === e.length) return;
        return e.map(function(e) {
            return(// visible for testing
            function __PRIVATE_toPropertyOrder(e) {
                return {
                    field: __PRIVATE_toFieldPathReference(e.field),
                    direction: __PRIVATE_toDirection(e.dir)
                };
            }(e));
        });
    }(t.orderBy);
    _ && (n.structuredQuery.orderBy = _);
    var o = __PRIVATE_toInt32Proto(e, t.limit);
    return null !== o && (n.structuredQuery.limit = o), t.startAt && (n.structuredQuery.startAt = function __PRIVATE_toStartAtCursor(e) {
        return {
            before: e.inclusive,
            values: e.position
        };
    }(t.startAt)), t.endAt && (n.structuredQuery.endAt = function __PRIVATE_toEndAtCursor(e) {
        return {
            before: !e.inclusive,
            values: e.position
        };
    }(t.endAt)), {
        Se: n,
        parent: i
    };
}
function __PRIVATE_toRunAggregationQueryRequest(e, t, n, r) {
    var _$__PRIVATE_toQueryTarget = __PRIVATE_toQueryTarget(e, t), i = _$__PRIVATE_toQueryTarget.Se, s = _$__PRIVATE_toQueryTarget.parent, _ = {}, o = [];
    var a = 0;
    return n.forEach(function(e) {
        // Map all client-side aliases to a unique short-form
        // alias. This avoids issues with client-side aliases that
        // exceed the 1500-byte string size limit.
        var _$t = r ? e.alias : "aggregate_" + a++;
        _[_$t] = e.alias, "count" === e.aggregateType ? o.push({
            alias: _$t,
            count: {}
        }) : "avg" === e.aggregateType ? o.push({
            alias: _$t,
            avg: {
                field: __PRIVATE_toFieldPathReference(e.fieldPath)
            }
        }) : "sum" === e.aggregateType && o.push({
            alias: _$t,
            sum: {
                field: __PRIVATE_toFieldPathReference(e.fieldPath)
            }
        });
    }), {
        request: {
            structuredAggregationQuery: {
                aggregations: o,
                structuredQuery: i.structuredQuery
            },
            parent: i.parent
        },
        ve: _,
        parent: s
    };
}
function __PRIVATE_convertQueryTargetToQuery(e) {
    var t = __PRIVATE_fromQueryPath(e.parent);
    var n = e.structuredQuery, r = n.from ? n.from.length : 0;
    var i = null;
    if (r > 0) {
        __PRIVATE_hardAssert(1 === r, 65062);
        var _$e = n.from[0];
        _$e.allDescendants ? i = _$e.collectionId : t = t.child(_$e.collectionId);
    }
    var s = [];
    n.where && (s = function __PRIVATE_fromFilters(e) {
        var t = __PRIVATE_fromFilter(e);
        if (t instanceof CompositeFilter && __PRIVATE_compositeFilterIsFlatConjunction(t)) return t.getFilters();
        return [
            t
        ];
    }(n.where));
    var _ = [];
    n.orderBy && (_ = function __PRIVATE_fromOrder(e) {
        return e.map(function(e) {
            return function __PRIVATE_fromPropertyOrder(e) {
                return new OrderBy(__PRIVATE_fromFieldPathReference(e.field), // visible for testing
                function __PRIVATE_fromDirection(e) {
                    switch(e){
                        case "ASCENDING":
                            return "asc" /* Direction.ASCENDING */ ;
                        case "DESCENDING":
                            return "desc" /* Direction.DESCENDING */ ;
                        default:
                            return;
                    }
                }(e.direction));
            }(e);
        });
    }(n.orderBy));
    var o = null;
    n.limit && (o = function __PRIVATE_fromInt32Proto(e) {
        var t;
        return t = "object" == (typeof e === "undefined" ? "undefined" : (0, $5djcY._)(e)) ? e.value : e, __PRIVATE_isNullOrUndefined(t) ? null : t;
    }(n.limit));
    var a = null;
    n.startAt && (a = function __PRIVATE_fromStartAtCursor(e) {
        var t = !!e.before, n = e.values || [];
        return new Bound(n, t);
    }(n.startAt));
    var u = null;
    return n.endAt && (u = function __PRIVATE_fromEndAtCursor(e) {
        var t = !e.before, n = e.values || [];
        return new Bound(n, t);
    }(n.endAt)), __PRIVATE_newQuery(t, i, _, s, o, "F" /* LimitType.First */ , a, u);
}
function __PRIVATE_toListenRequestLabels(e, t) {
    var n = function __PRIVATE_toLabel(e) {
        switch(e){
            case "TargetPurposeListen" /* TargetPurpose.Listen */ :
                return null;
            case "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ :
                return "existence-filter-mismatch";
            case "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */ :
                return "existence-filter-mismatch-bloom";
            case "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ :
                return "limbo-document";
            default:
                return l(28987, {
                    purpose: e
                });
        }
    }(t.purpose);
    return null == n ? null : {
        "goog-listen-tags": n
    };
}
function __PRIVATE_toPipelineTarget(e, t) {
    return {
        structuredPipeline: {
            pipeline: {
                stages: t.stages.map(function(t) {
                    return t._toProto(e);
                })
            }
        }
    };
}
function __PRIVATE_fromFilter(e) {
    return void 0 !== e.unaryFilter ? function __PRIVATE_fromUnaryFilter(e) {
        switch(e.unaryFilter.op){
            case "IS_NAN":
                var t = __PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return FieldFilter.create(t, "==" /* Operator.EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NULL":
                var n = __PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return FieldFilter.create(n, "==" /* Operator.EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "IS_NOT_NAN":
                var r = __PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return FieldFilter.create(r, "!=" /* Operator.NOT_EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NOT_NULL":
                var i = __PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return FieldFilter.create(i, "!=" /* Operator.NOT_EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "OPERATOR_UNSPECIFIED":
                return l(61313);
            default:
                return l(60726);
        }
    }(e) : void 0 !== e.fieldFilter ? function __PRIVATE_fromFieldFilter(e) {
        return FieldFilter.create(__PRIVATE_fromFieldPathReference(e.fieldFilter.field), function __PRIVATE_fromOperatorName(e) {
            switch(e){
                case "EQUAL":
                    return "==" /* Operator.EQUAL */ ;
                case "NOT_EQUAL":
                    return "!=" /* Operator.NOT_EQUAL */ ;
                case "GREATER_THAN":
                    return ">" /* Operator.GREATER_THAN */ ;
                case "GREATER_THAN_OR_EQUAL":
                    return ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ;
                case "LESS_THAN":
                    return "<" /* Operator.LESS_THAN */ ;
                case "LESS_THAN_OR_EQUAL":
                    return "<=" /* Operator.LESS_THAN_OR_EQUAL */ ;
                case "ARRAY_CONTAINS":
                    return "array-contains" /* Operator.ARRAY_CONTAINS */ ;
                case "IN":
                    return "in" /* Operator.IN */ ;
                case "NOT_IN":
                    return "not-in" /* Operator.NOT_IN */ ;
                case "ARRAY_CONTAINS_ANY":
                    return "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ;
                case "OPERATOR_UNSPECIFIED":
                    return l(58110);
                default:
                    return l(50506);
            }
        }(e.fieldFilter.op), e.fieldFilter.value);
    }(e) : void 0 !== e.compositeFilter ? function __PRIVATE_fromCompositeFilter(e) {
        return CompositeFilter.create(e.compositeFilter.filters.map(function(e) {
            return __PRIVATE_fromFilter(e);
        }), function __PRIVATE_fromCompositeOperatorName(e) {
            switch(e){
                case "AND":
                    return "and" /* CompositeOperator.AND */ ;
                case "OR":
                    return "or" /* CompositeOperator.OR */ ;
                default:
                    return l(1026);
            }
        }(e.compositeFilter.op));
    }(e) : l(30097, {
        filter: e
    });
}
function __PRIVATE_toDirection(e) {
    return ct[e];
}
function __PRIVATE_toOperatorName(e) {
    return lt[e];
}
function __PRIVATE_toCompositeOperatorName(e) {
    return Et[e];
}
function __PRIVATE_toFieldPathReference(e) {
    return {
        fieldPath: e.canonicalString()
    };
}
function __PRIVATE_fromFieldPathReference(e) {
    return Oe.fromServerFormat(e.fieldPath);
}
function __PRIVATE_toFilter(e) {
    return e instanceof FieldFilter ? function __PRIVATE_toUnaryOrFieldFilter(e) {
        if ("==" /* Operator.EQUAL */  === e.op) {
            if (__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: __PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NAN"
                }
            };
            if (__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: __PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NULL"
                }
            };
        } else if ("!=" /* Operator.NOT_EQUAL */  === e.op) {
            if (__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: __PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NAN"
                }
            };
            if (__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: __PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NULL"
                }
            };
        }
        return {
            fieldFilter: {
                field: __PRIVATE_toFieldPathReference(e.field),
                op: __PRIVATE_toOperatorName(e.op),
                value: e.value
            }
        };
    }(e) : e instanceof CompositeFilter ? function __PRIVATE_toCompositeFilter(e) {
        var t = e.getFilters().map(function(e) {
            return __PRIVATE_toFilter(e);
        });
        if (1 === t.length) return t[0];
        return {
            compositeFilter: {
                op: __PRIVATE_toCompositeOperatorName(e.op),
                filters: t
            }
        };
    }(e) : l(54877, {
        filter: e
    });
}
function __PRIVATE_toDocumentMask(e) {
    var t = [];
    return e.fields.forEach(function(e) {
        return t.push(e.canonicalString());
    }), {
        fieldPaths: t
    };
}
function __PRIVATE_isValidResourceName(e) {
    // Resource names have at least 4 components (project ID, database ID)
    return e.length >= 4 && "projects" === e.get(0) && "databases" === e.get(2);
}
function __PRIVATE_isProtoValueSerializable(// eslint-disable-next-line @typescript-eslint/no-explicit-any
e) {
    return !!e && "function" == typeof e._toProto && "ProtoValue" === e._protoValueType;
}
function toMapValue(e, t) {
    var n = {
        fields: {}
    };
    return t.forEach(function(t, r) {
        if ("string" != typeof r) throw new Error("Cannot encode map with non-string key: ".concat(r));
        n.fields[r] = t._toProto(e);
    }), {
        mapValue: n
    };
}
function __PRIVATE_toStringValue(e) {
    return {
        stringValue: e
    };
}
function __PRIVATE_toPipelineValue(e) {
    return {
        pipelineValue: e
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function __PRIVATE_newSerializer(e) {
    return new JsonProtoSerializer(e, /* useProto3Json= */ true);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing an array of bytes.
 */ var Bytes = /*#__PURE__*/ function() {
    "use strict";
    function Bytes(e) {
        (0, $4QweW._)(this, Bytes);
        this._byteString = e;
    }
    (0, $6hK4i._)(Bytes, [
        {
            /**
     * Returns the underlying bytes as a Base64-encoded string.
     *
     * @returns The Base64-encoded string created from the `Bytes` object.
     */ key: "toBase64",
            value: function toBase64() {
                return this._byteString.toBase64();
            }
        },
        {
            /**
     * Returns the underlying bytes in a new `Uint8Array`.
     *
     * @returns The Uint8Array created from the `Bytes` object.
     */ key: "toUint8Array",
            value: function toUint8Array() {
                return this._byteString.toUint8Array();
            }
        },
        {
            /**
     * Returns a string representation of the `Bytes` object.
     *
     * @returns A string representation of the `Bytes` object.
     */ key: "toString",
            value: function toString() {
                return "Bytes(base64: " + this.toBase64() + ")";
            }
        },
        {
            /**
     * Returns true if this `Bytes` object is equal to the provided one.
     *
     * @param other - The `Bytes` object to compare against.
     * @returns true if this `Bytes` object is equal to the provided one.
     */ key: "isEqual",
            value: function isEqual(e) {
                return this._byteString.isEqual(e._byteString);
            }
        },
        {
            /**
     * Returns a JSON-serializable representation of this `Bytes` instance.
     *
     * @returns a JSON representation of this object.
     */ key: "toJSON",
            value: function toJSON() {
                return {
                    type: Bytes._jsonSchemaVersion,
                    bytes: this.toBase64()
                };
            }
        }
    ], [
        {
            key: "fromBase64String",
            value: /**
     * Creates a new `Bytes` object from the given Base64 string, converting it to
     * bytes.
     *
     * @param base64 - The Base64 string used to create the `Bytes` object.
     */ function fromBase64String(t) {
                try {
                    return new Bytes(ByteString.fromBase64String(t));
                } catch (t) {
                    throw new e(ta.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + t);
                }
            }
        },
        {
            key: "fromUint8Array",
            value: /**
     * Creates a new `Bytes` object from the given Uint8Array.
     *
     * @param array - The Uint8Array used to create the `Bytes` object.
     */ function fromUint8Array(e) {
                return new Bytes(ByteString.fromUint8Array(e));
            }
        },
        {
            key: "fromJSON",
            value: /**
     * Builds a `Bytes` instance from a JSON object created by {@link Bytes.toJSON}.
     *
     * @param json - a JSON object represention of a `Bytes` instance
     * @returns an instance of {@link Bytes} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ function fromJSON(e) {
                if (__PRIVATE_validateJSON(e, Bytes._jsonSchema)) return Bytes.fromBase64String(e.bytes);
            }
        }
    ]);
    return Bytes;
}();
Bytes._jsonSchemaVersion = "firestore/bytes/1.0", Bytes._jsonSchema = {
    type: property("string", Bytes._jsonSchemaVersion),
    bytes: property("string")
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a
 * list of field names (referring to a nested field in the document).
 *
 * Create a `FieldPath` by providing field names. If more than one field
 * name is provided, the path will point to a nested field in a document.
 */ var FieldPath = /*#__PURE__*/ function() {
    "use strict";
    function FieldPath() {
        for(var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++){
            t[_key] = arguments[_key];
        }
        (0, $4QweW._)(this, FieldPath);
        for(var n = 0; n < t.length; ++n)if (0 === t[n].length) throw new e(ta.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
        this._internalPath = new Oe(t);
    }
    (0, $6hK4i._)(FieldPath, [
        {
            /**
     * Returns true if this `FieldPath` is equal to the provided one.
     *
     * @param other - The `FieldPath` to compare against.
     * @returns true if this `FieldPath` is equal to the provided one.
     */ key: "isEqual",
            value: function isEqual(e) {
                return this._internalPath.isEqual(e._internalPath);
            }
        }
    ]);
    return FieldPath;
}();
/**
 * Returns a special sentinel `FieldPath` to refer to the ID of a document.
 * It can be used in queries to sort or filter by the document ID.
 */ function documentId$1() {
    return new FieldPath(Ce);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sentinel values that can be used when writing document fields with `set()`
 * or `update()`.
 */ var FieldValue = function FieldValue(e) {
    "use strict";
    (0, $4QweW._)(this, FieldValue);
    this._methodName = e;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing a geographic location in Firestore. The
 * location is represented as latitude/longitude pair.
 *
 * Latitude values are in the range of [-90, 90].
 * Longitude values are in the range of [-180, 180].
 */ var GeoPoint = /*#__PURE__*/ function() {
    "use strict";
    function GeoPoint(t, n) {
        (0, $4QweW._)(this, GeoPoint);
        if (!isFinite(t) || t < -90 || t > 90) throw new e(ta.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + t);
        if (!isFinite(n) || n < -180 || n > 180) throw new e(ta.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + n);
        this._lat = t, this._long = n;
    }
    (0, $6hK4i._)(GeoPoint, [
        {
            key: "latitude",
            get: /**
     * The latitude of this `GeoPoint` instance.
     */ function get() {
                return this._lat;
            }
        },
        {
            key: "longitude",
            get: /**
     * The longitude of this `GeoPoint` instance.
     */ function get() {
                return this._long;
            }
        },
        {
            /**
     * Returns true if this `GeoPoint` is equal to the provided one.
     *
     * @param other - The `GeoPoint` to compare against.
     * @returns true if this `GeoPoint` is equal to the provided one.
     */ key: "isEqual",
            value: function isEqual(e) {
                return this._lat === e._lat && this._long === e._long;
            }
        },
        {
            /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */ key: "_compareTo",
            value: function _compareTo(e) {
                return __PRIVATE_primitiveComparator(this._lat, e._lat) || __PRIVATE_primitiveComparator(this._long, e._long);
            }
        },
        {
            /**
     * Returns a JSON-serializable representation of this `GeoPoint` instance.
     *
     * @returns a JSON representation of this object.
     */ key: "toJSON",
            value: function toJSON() {
                return {
                    latitude: this._lat,
                    longitude: this._long,
                    type: GeoPoint._jsonSchemaVersion
                };
            }
        }
    ], [
        {
            key: "fromJSON",
            value: /**
     * Builds a `GeoPoint` instance from a JSON object created by {@link GeoPoint.toJSON}.
     *
     * @param json - a JSON object represention of a `GeoPoint` instance
     * @returns an instance of {@link GeoPoint} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ function fromJSON(e) {
                if (__PRIVATE_validateJSON(e, GeoPoint._jsonSchema)) return new GeoPoint(e.latitude, e.longitude);
            }
        }
    ]);
    return GeoPoint;
}();
GeoPoint._jsonSchemaVersion = "firestore/geoPoint/1.0", GeoPoint._jsonSchema = {
    type: property("string", GeoPoint._jsonSchemaVersion),
    latitude: property("number"),
    longitude: property("number")
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */ var User = /*#__PURE__*/ function() {
    "use strict";
    function User(e) {
        (0, $4QweW._)(this, User);
        this.uid = e;
    }
    (0, $6hK4i._)(User, [
        {
            key: "isAuthenticated",
            value: function isAuthenticated() {
                return null != this.uid;
            }
        },
        {
            /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */ key: "toKey",
            value: function toKey() {
                return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return e.uid === this.uid;
            }
        }
    ]);
    return User;
}();
/** A user with a null UID. */ User.UNAUTHENTICATED = new User(null), // TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
User.GOOGLE_CREDENTIALS = new User("google-credentials-uid"), User.FIRST_PARTY = new User("first-party-uid"), User.MOCK_USER = new User("mock-user");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var __PRIVATE_Deferred = function __PRIVATE_Deferred() {
    "use strict";
    var _this = this;
    (0, $4QweW._)(this, __PRIVATE_Deferred);
    this.promise = new Promise(function(e, t) {
        _this.resolve = e, _this.reject = t;
    });
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var __PRIVATE_OAuthToken = function __PRIVATE_OAuthToken(e, t) {
    "use strict";
    (0, $4QweW._)(this, __PRIVATE_OAuthToken);
    this.user = t, this.type = "OAuth", this.headers = new Map, this.headers.set("Authorization", "Bearer ".concat(e));
};
/**
 * A CredentialsProvider that always yields an empty token.
 * @internal
 */ var __PRIVATE_EmptyAuthCredentialsProvider = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_EmptyAuthCredentialsProvider() {
        (0, $4QweW._)(this, __PRIVATE_EmptyAuthCredentialsProvider);
    }
    (0, $6hK4i._)(__PRIVATE_EmptyAuthCredentialsProvider, [
        {
            key: "getToken",
            value: function getToken() {
                return Promise.resolve(null);
            }
        },
        {
            key: "invalidateToken",
            value: function invalidateToken() {}
        },
        {
            key: "start",
            value: function start(e, t) {
                // Fire with initial user.
                e.enqueueRetryable(function() {
                    return t(User.UNAUTHENTICATED);
                });
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {}
        }
    ]);
    return __PRIVATE_EmptyAuthCredentialsProvider;
}();
/**
 * A CredentialsProvider that always returns a constant token. Used for
 * emulator token mocking.
 */ var __PRIVATE_EmulatorAuthCredentialsProvider = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_EmulatorAuthCredentialsProvider(e) {
        (0, $4QweW._)(this, __PRIVATE_EmulatorAuthCredentialsProvider);
        this.token = e, /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */ this.changeListener = null;
    }
    (0, $6hK4i._)(__PRIVATE_EmulatorAuthCredentialsProvider, [
        {
            key: "getToken",
            value: function getToken() {
                return Promise.resolve(this.token);
            }
        },
        {
            key: "invalidateToken",
            value: function invalidateToken() {}
        },
        {
            key: "start",
            value: function start(e, t) {
                var _this = this;
                this.changeListener = t, // Fire with initial user.
                e.enqueueRetryable(function() {
                    return t(_this.token.user);
                });
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {
                this.changeListener = null;
            }
        }
    ]);
    return __PRIVATE_EmulatorAuthCredentialsProvider;
}();
var __PRIVATE_FirebaseAuthCredentialsProvider = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_FirebaseAuthCredentialsProvider(e) {
        (0, $4QweW._)(this, __PRIVATE_FirebaseAuthCredentialsProvider);
        this.De = e, /** Tracks the current User. */ this.currentUser = User.UNAUTHENTICATED, /**
         * Counter used to detect if the token changed while a getToken request was
         * outstanding.
         */ this.xe = 0, this.forceRefresh = false, this.auth = null;
    }
    (0, $6hK4i._)(__PRIVATE_FirebaseAuthCredentialsProvider, [
        {
            key: "start",
            value: function start(e, t) {
                var _this = this;
                __PRIVATE_hardAssert(void 0 === this.Ce, 42304);
                var n = this.xe;
                // A change listener that prevents double-firing for the same token change.
                var __PRIVATE_guardedChangeListener = function(e) {
                    return _this.xe !== n ? (n = _this.xe, t(e)) : Promise.resolve();
                };
                // A promise that can be waited on to block on the next token change.
                // This promise is re-created after each change.
                var r = new __PRIVATE_Deferred;
                this.Ce = function() {
                    _this.xe++, _this.currentUser = _this.Fe(), r.resolve(), r = new __PRIVATE_Deferred, e.enqueueRetryable(function() {
                        return __PRIVATE_guardedChangeListener(_this.currentUser);
                    });
                };
                var __PRIVATE_awaitNextToken = function() {
                    var t = r;
                    e.enqueueRetryable(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                            return (0, $gh3Df._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            t.promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            4,
                                            __PRIVATE_guardedChangeListener(this.currentUser)
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        }).call(_this);
                    });
                }, __PRIVATE_registerAuth = function(e) {
                    __PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "Auth detected"), _this.auth = e, _this.Ce && (_this.auth.addAuthTokenListener(_this.Ce), __PRIVATE_awaitNextToken());
                };
                this.De.onInit(function(e) {
                    return __PRIVATE_registerAuth(e);
                }), // Our users can initialize Auth right after Firestore, so we give it
                // a chance to register itself with the component framework before we
                // determine whether to start up in unauthenticated mode.
                setTimeout(function() {
                    if (!_this.auth) {
                        var e = _this.De.getImmediate({
                            optional: true
                        });
                        e ? __PRIVATE_registerAuth(e) : // If auth is still not available, proceed with `null` user
                        (__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "Auth not yet detected"), r.resolve(), r = new __PRIVATE_Deferred);
                    }
                }, 0), __PRIVATE_awaitNextToken();
            }
        },
        {
            key: "getToken",
            value: function getToken() {
                var _this = this;
                // Take note of the current value of the tokenCounter so that this method
                // can fail (with an ABORTED error) if there is a token change while the
                // request is outstanding.
                var e = this.xe, t = this.forceRefresh;
                return this.forceRefresh = false, this.auth ? this.auth.getToken(t).then(function(t) {
                    return(// Cancel the request since the token changed while the request was
                    // outstanding so the response is potentially for a previous user (which
                    // user, we can't be sure).
                    _this.xe !== e ? (__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), _this.getToken()) : t ? (__PRIVATE_hardAssert("string" == typeof t.accessToken, 31837, {
                        Oe: t
                    }), new __PRIVATE_OAuthToken(t.accessToken, _this.currentUser)) : null);
                }) : Promise.resolve(null);
            }
        },
        {
            key: "invalidateToken",
            value: function invalidateToken() {
                this.forceRefresh = true;
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {
                this.auth && this.Ce && this.auth.removeAuthTokenListener(this.Ce), this.Ce = void 0;
            }
        },
        {
            // Auth.getUid() can return null even with a user logged in. It is because
            // getUid() is synchronous, but the auth code populating Uid is asynchronous.
            // This method should only be called in the AuthTokenListener callback
            // to guarantee to get the actual user.
            key: "Fe",
            value: function Fe() {
                var e = this.auth && this.auth.getUid();
                return __PRIVATE_hardAssert(null === e || "string" == typeof e, 2055, {
                    Me: e
                }), new User(e);
            }
        }
    ]);
    return __PRIVATE_FirebaseAuthCredentialsProvider;
}();
/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * Technically this may no longer be necessary since the SDK should gracefully
 * recover from unauthenticated errors (see b/33147818 for context), but it's
 * safer to keep the implementation as-is.
 */ var __PRIVATE_FirstPartyToken = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_FirstPartyToken(e, t, n) {
        (0, $4QweW._)(this, __PRIVATE_FirstPartyToken);
        this.Ne = e, this.Le = t, this.Be = n, this.type = "FirstParty", this.user = User.FIRST_PARTY, this.Ue = new Map;
    }
    (0, $6hK4i._)(__PRIVATE_FirstPartyToken, [
        {
            /**
     * Gets an authorization token, using a provided factory function, or return
     * null.
     */ key: "ke",
            value: function ke() {
                return this.Be ? this.Be() : null;
            }
        },
        {
            key: "headers",
            get: function get() {
                this.Ue.set("X-Goog-AuthUser", this.Ne);
                // Use array notation to prevent minification
                var e = this.ke();
                return e && this.Ue.set("Authorization", e), this.Le && this.Ue.set("X-Goog-Iam-Authorization-Token", this.Le), this.Ue;
            }
        }
    ]);
    return __PRIVATE_FirstPartyToken;
}();
/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */ var __PRIVATE_FirstPartyAuthCredentialsProvider = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_FirstPartyAuthCredentialsProvider(e, t, n) {
        (0, $4QweW._)(this, __PRIVATE_FirstPartyAuthCredentialsProvider);
        this.Ne = e, this.Le = t, this.Be = n;
    }
    (0, $6hK4i._)(__PRIVATE_FirstPartyAuthCredentialsProvider, [
        {
            key: "getToken",
            value: function getToken() {
                return Promise.resolve(new __PRIVATE_FirstPartyToken(this.Ne, this.Le, this.Be));
            }
        },
        {
            key: "start",
            value: function start(e, t) {
                // Fire with initial uid.
                e.enqueueRetryable(function() {
                    return t(User.FIRST_PARTY);
                });
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {}
        },
        {
            key: "invalidateToken",
            value: function invalidateToken() {}
        }
    ]);
    return __PRIVATE_FirstPartyAuthCredentialsProvider;
}();
var AppCheckToken = function AppCheckToken(e) {
    "use strict";
    (0, $4QweW._)(this, AppCheckToken);
    this.value = e, this.type = "AppCheck", this.headers = new Map, e && e.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
};
var __PRIVATE_FirebaseAppCheckTokenProvider = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_FirebaseAppCheckTokenProvider(e, t) {
        (0, $4QweW._)(this, __PRIVATE_FirebaseAppCheckTokenProvider);
        this.qe = t, this.forceRefresh = false, this.appCheck = null, this.$e = null, this.Ke = null, (0, $wQDEL._isFirebaseServerApp)(e) && e.settings.appCheckToken && (this.Ke = e.settings.appCheckToken);
    }
    (0, $6hK4i._)(__PRIVATE_FirebaseAppCheckTokenProvider, [
        {
            key: "start",
            value: function start(e, t) {
                var _this = this;
                __PRIVATE_hardAssert(void 0 === this.Ce, 3512);
                var onTokenChanged = function(e) {
                    null != e.error && __PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "Error getting App Check token; using placeholder token instead. Error: ".concat(e.error.message));
                    var n = e.token !== _this.$e;
                    return _this.$e = e.token, __PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "Received ".concat(n ? "new" : "existing", " token.")), n ? t(e.token) : Promise.resolve();
                };
                this.Ce = function(t) {
                    e.enqueueRetryable(function() {
                        return onTokenChanged(t);
                    });
                };
                var __PRIVATE_registerAppCheck = function(e) {
                    __PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "AppCheck detected"), _this.appCheck = e, _this.Ce && _this.appCheck.addTokenListener(_this.Ce);
                };
                this.qe.onInit(function(e) {
                    return __PRIVATE_registerAppCheck(e);
                }), // Our users can initialize AppCheck after Firestore, so we give it
                // a chance to register itself with the component framework.
                setTimeout(function() {
                    if (!_this.appCheck) {
                        var e = _this.qe.getImmediate({
                            optional: true
                        });
                        e ? __PRIVATE_registerAppCheck(e) : // If AppCheck is still not available, proceed without it.
                        __PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "AppCheck not yet detected");
                    }
                }, 0);
            }
        },
        {
            key: "getToken",
            value: function getToken() {
                var _this = this;
                if (this.Ke) return Promise.resolve(new AppCheckToken(this.Ke));
                var e = this.forceRefresh;
                return this.forceRefresh = false, this.appCheck ? this.appCheck.getToken(e).then(function(e) {
                    return e ? (__PRIVATE_hardAssert("string" == typeof e.token, 44558, {
                        tokenResult: e
                    }), _this.$e = e.token, new AppCheckToken(e.token)) : null;
                }) : Promise.resolve(null);
            }
        },
        {
            key: "invalidateToken",
            value: function invalidateToken() {
                this.forceRefresh = true;
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {
                this.appCheck && this.Ce && this.appCheck.removeTokenListener(this.Ce), this.Ce = void 0;
            }
        }
    ]);
    return __PRIVATE_FirebaseAppCheckTokenProvider;
}();
/**
 * An AppCheck token provider that always yields an empty token.
 * @internal
 */ var __PRIVATE_EmptyAppCheckTokenProvider = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_EmptyAppCheckTokenProvider() {
        (0, $4QweW._)(this, __PRIVATE_EmptyAppCheckTokenProvider);
    }
    (0, $6hK4i._)(__PRIVATE_EmptyAppCheckTokenProvider, [
        {
            key: "getToken",
            value: function getToken() {
                return Promise.resolve(new AppCheckToken(""));
            }
        },
        {
            key: "invalidateToken",
            value: function invalidateToken() {}
        },
        {
            key: "start",
            value: function start(e, t) {}
        },
        {
            key: "shutdown",
            value: function shutdown() {}
        }
    ]);
    return __PRIVATE_EmptyAppCheckTokenProvider;
}();
/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */ /**
 * Creates and returns a new `ExperimentalLongPollingOptions` with the same
 * option values as the given instance.
 */ function __PRIVATE_cloneLongPollingOptions(e) {
    var t = {};
    return void 0 !== e.timeoutSeconds && (t.timeoutSeconds = e.timeoutSeconds), t;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var __PRIVATE_NoopConnectivityMonitor = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_NoopConnectivityMonitor() {
        (0, $4QweW._)(this, __PRIVATE_NoopConnectivityMonitor);
    }
    (0, $6hK4i._)(__PRIVATE_NoopConnectivityMonitor, [
        {
            key: "Qe",
            value: function Qe(e) {
            // No-op.
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {
            // No-op.
            }
        }
    ]);
    return __PRIVATE_NoopConnectivityMonitor;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by BrowserConnectivityMonitor.isAvailable()
/* eslint-disable no-restricted-globals */ var ht = "ConnectivityMonitor";
/**
 * Browser implementation of ConnectivityMonitor.
 */ var __PRIVATE_BrowserConnectivityMonitor = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_BrowserConnectivityMonitor() {
        var _this = this;
        (0, $4QweW._)(this, __PRIVATE_BrowserConnectivityMonitor);
        this.We = function() {
            return _this.Ge();
        }, this.ze = function() {
            return _this.je();
        }, this.He = [], this.Je();
    }
    (0, $6hK4i._)(__PRIVATE_BrowserConnectivityMonitor, [
        {
            key: "Qe",
            value: function Qe(e) {
                this.He.push(e);
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {
                window.removeEventListener("online", this.We), window.removeEventListener("offline", this.ze);
            }
        },
        {
            key: "Je",
            value: function Je() {
                window.addEventListener("online", this.We), window.addEventListener("offline", this.ze);
            }
        },
        {
            key: "Ge",
            value: function Ge() {
                __PRIVATE_logDebug(ht, "Network connectivity changed: AVAILABLE");
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.He[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var e = _step.value;
                        e(0 /* NetworkStatus.AVAILABLE */ );
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "je",
            value: function je() {
                __PRIVATE_logDebug(ht, "Network connectivity changed: UNAVAILABLE");
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.He[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var e = _step.value;
                        e(1 /* NetworkStatus.UNAVAILABLE */ );
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ], [
        {
            key: "Ye",
            value: // TODO(chenbrian): Consider passing in window either into this component or
            // here for testing via FakeWindow.
            /** Checks that all used attributes of window are available. */ function Ye() {
                return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
            }
        }
    ]);
    return __PRIVATE_BrowserConnectivityMonitor;
}();
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The value returned from the most recent invocation of
 * `generateUniqueDebugId()`, or null if it has never been invoked.
 */ var Tt = null;
/**
 * Generates and returns an initial value for `lastUniqueDebugId`.
 *
 * The returned value is randomly selected from a range of integers that are
 * represented as 8 hexadecimal digits. This means that (within reason) any
 * numbers generated by incrementing the returned number by 1 will also be
 * represented by 8 hexadecimal digits. This leads to all "IDs" having the same
 * length when converted to a hexadecimal string, making reading logs containing
 * these IDs easier to follow. And since the return value is randomly selected
 * it will help to differentiate between logs from different executions.
 */ /**
 * Generates and returns a unique ID as a hexadecimal string.
 *
 * The returned ID is intended to be used in debug logging messages to help
 * correlate log messages that may be spatially separated in the logs, but
 * logically related. For example, a network connection could include the same
 * "debug ID" string in all of its log messages to help trace a specific
 * connection over time.
 *
 * @returns the 10-character generated ID (e.g. "0xa1b2c3d4").
 */ function __PRIVATE_generateUniqueDebugId() {
    return null === Tt ? Tt = function __PRIVATE_generateInitialUniqueDebugId() {
        return 268435456 + Math.round(2147483648 * Math.random());
    }() : Tt++, "0x" + Tt.toString(16);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var Pt = "RestConnection", It = {
    BatchGetDocuments: "batchGet",
    Commit: "commit",
    RunQuery: "runQuery",
    RunAggregationQuery: "runAggregationQuery",
    ExecutePipeline: "executePipeline"
};
/**
 * Maps RPC names to the corresponding REST endpoint name.
 *
 * We use array notation to avoid mangling.
 */ /**
 * Base class for all Rest-based connections to the backend (WebChannel and
 * HTTP).
 */ var __PRIVATE_RestConnection = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_RestConnection(e) {
        (0, $4QweW._)(this, __PRIVATE_RestConnection);
        this.databaseInfo = e, this.databaseId = e.databaseId;
        var t = e.ssl ? "https" : "http", n = encodeURIComponent(this.databaseId.projectId), r = encodeURIComponent(this.databaseId.database);
        this.Xe = t + "://" + e.host, this.et = "projects/".concat(n, "/databases/").concat(r), this.tt = this.databaseId.database === $e ? "project_id=".concat(n) : "project_id=".concat(n, "&database_id=").concat(r);
    }
    (0, $6hK4i._)(__PRIVATE_RestConnection, [
        {
            key: "Ze",
            get: function get() {
                // Both `invokeRPC()` and `invokeStreamingRPC()` use their `path` arguments to determine
                // where to run the query, and expect the `request` to NOT specify the "path".
                return false;
            }
        },
        {
            key: "nt",
            value: function nt(e, t, n, r, i) {
                var s = __PRIVATE_generateUniqueDebugId(), _ = this.rt(e, t.toUriEncodedString());
                __PRIVATE_logDebug(Pt, "Sending RPC '".concat(e, "' ").concat(s, ":"), _, n);
                var o = {
                    "google-cloud-resource-prefix": this.et,
                    "x-goog-request-params": this.tt
                };
                this.it(o, r, i);
                var _ref = new URL(_), a = _ref.host, u = (0, $hk14n.isCloudWorkstation)(a);
                return this.st(e, _, o, n, u).then(function(t) {
                    return __PRIVATE_logDebug(Pt, "Received RPC '".concat(e, "' ").concat(s, ": "), t), t;
                }, function(t) {
                    throw __PRIVATE_logWarn(Pt, "RPC '".concat(e, "' ").concat(s, " failed with error: "), t, "url: ", _, "request:", n), t;
                });
            }
        },
        {
            key: "_t",
            value: function _t(e, t, n, r, i, s) {
                // The REST API automatically aggregates all of the streamed results, so we
                // can just use the normal invoke() method.
                return this.nt(e, t, n, r, i);
            }
        },
        {
            /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */ key: "it",
            value: function it(e, t, n) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (e["X-Goog-Api-Client"] = // SDK_VERSION is updated to different value at runtime depending on the entry point,
                // so we need to get its value when we need it in a function.
                function __PRIVATE_getGoogApiClientValue() {
                    return "gl-js/ fire/" + Se;
                }(), // Content-Type: text/plain will avoid preflight requests which might
                // mess with CORS and redirects by proxies. If we add custom headers
                // we will need to change this code to potentially use the $httpOverwrite
                // parameter supported by ESF to avoid triggering preflight requests.
                e["Content-Type"] = "text/plain", this.databaseInfo.appId && (e["X-Firebase-GMPID"] = this.databaseInfo.appId), t && t.headers.forEach(function(t, n) {
                    return e[n] = t;
                }), n && n.headers.forEach(function(t, n) {
                    return e[n] = t;
                }), this.databaseInfo._customHeaders) try {
                    for(var _iterator = Object.keys(this.databaseInfo._customHeaders)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$t = _step.value;
                        e[_$t] = this.databaseInfo._customHeaders[_$t];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "rt",
            value: function rt(e, t) {
                var n = It[e];
                var r = "".concat(this.Xe, "/v1/").concat(t, ":").concat(n);
                return this.databaseInfo.apiKey && (r = "".concat(r, "?key=").concat(encodeURIComponent(this.databaseInfo.apiKey))), r;
            }
        },
        {
            /**
     * Closes and cleans up any resources associated with the connection. This
     * implementation is a no-op because there are no resources associated
     * with the RestConnection that need to be cleaned up.
     */ key: "terminate",
            value: function terminate() {
            // No-op
            }
        }
    ]);
    return __PRIVATE_RestConnection;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */ var __PRIVATE_StreamBridge = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_StreamBridge(e) {
        (0, $4QweW._)(this, __PRIVATE_StreamBridge);
        this.ot = e.ot, this.ut = e.ut;
    }
    (0, $6hK4i._)(__PRIVATE_StreamBridge, [
        {
            key: "ct",
            value: function ct(e) {
                this.lt = e;
            }
        },
        {
            key: "Et",
            value: function Et(e) {
                this.ht = e;
            }
        },
        {
            key: "Tt",
            value: function Tt(e) {
                this.Pt = e;
            }
        },
        {
            key: "onMessage",
            value: function onMessage(e) {
                this.It = e;
            }
        },
        {
            key: "close",
            value: function close() {
                this.ut();
            }
        },
        {
            key: "send",
            value: function send(e) {
                this.ot(e);
            }
        },
        {
            key: "Rt",
            value: function Rt() {
                this.lt();
            }
        },
        {
            key: "At",
            value: function At() {
                this.ht();
            }
        },
        {
            key: "Vt",
            value: function Vt(e) {
                this.Pt(e);
            }
        },
        {
            key: "dt",
            value: function dt(e) {
                this.It(e);
            }
        }
    ]);
    return __PRIVATE_StreamBridge;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var Rt = "WebChannelConnection", __PRIVATE_unguardedEventListen = function(e, t, n) {
    // TODO(dimond): closure typing seems broken because WebChannel does
    // not implement goog.events.Listenable
    e.listen(t, function(e) {
        try {
            n(e);
        } catch (e) {
            setTimeout(function() {
                throw e;
            }, 0);
        }
    });
};
var __PRIVATE_WebChannelConnection = /*#__PURE__*/ function(__PRIVATE_RestConnection) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_WebChannelConnection, __PRIVATE_RestConnection);
    function __PRIVATE_WebChannelConnection(e) {
        (0, $4QweW._)(this, __PRIVATE_WebChannelConnection);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_WebChannelConnection, [
            e
        ]), /** A collection of open WebChannel instances */ _this.ft = [], _this.forceLongPolling = e.forceLongPolling, _this.autoDetectLongPolling = e.autoDetectLongPolling, _this.useFetchStreams = e.useFetchStreams, _this.longPollingOptions = e.longPollingOptions;
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_WebChannelConnection, [
        {
            key: "st",
            value: function st(t, n, r, i, s) {
                var _ = __PRIVATE_generateUniqueDebugId();
                return new Promise(function(s, o) {
                    var a = new (0, $2rSfQ.XhrIo);
                    a.setWithCredentials(true), a.listenOnce((0, $2rSfQ.EventType).COMPLETE, function() {
                        try {
                            switch(a.getLastErrorCode()){
                                case (0, $2rSfQ.ErrorCode).NO_ERROR:
                                    var _$n = a.getResponseJson();
                                    __PRIVATE_logDebug(Rt, "XHR for RPC '".concat(t, "' ").concat(_, " received:"), JSON.stringify(_$n)), s(_$n);
                                    break;
                                case (0, $2rSfQ.ErrorCode).TIMEOUT:
                                    __PRIVATE_logDebug(Rt, "RPC '".concat(t, "' ").concat(_, " timed out")), o(new e(ta.DEADLINE_EXCEEDED, "Request time out"));
                                    break;
                                case (0, $2rSfQ.ErrorCode).HTTP_ERROR:
                                    var _$r = a.getStatus();
                                    if (__PRIVATE_logDebug(Rt, "RPC '".concat(t, "' ").concat(_, " failed with status:"), _$r, "response text:", a.getResponseText()), _$r > 0) {
                                        var _$t = a.getResponseJson();
                                        Array.isArray(_$t) && (_$t = _$t[0]);
                                        var _$n1 = _$t === null || _$t === void 0 ? void 0 : _$t.error;
                                        if (_$n1 && _$n1.status && _$n1.message) {
                                            var _$t1 = function __PRIVATE_mapCodeFromHttpResponseErrorStatus(e) {
                                                var _$t = e.toLowerCase().replace(/_/g, "-");
                                                return Object.values(ta).indexOf(_$t) >= 0 ? _$t : ta.UNKNOWN;
                                            }(_$n1.status);
                                            o(new e(_$t1, _$n1.message));
                                        } else o(new e(ta.UNKNOWN, "Server responded with status " + a.getStatus()));
                                    } else // If we received an HTTP_ERROR but there's no status code,
                                    // it's most probably a connection issue
                                    o(new e(ta.UNAVAILABLE, "Connection failed."));
                                    break;
                                default:
                                    l(9055, {
                                        wt: t,
                                        streamId: _,
                                        bt: a.getLastErrorCode(),
                                        St: a.getLastError()
                                    });
                            }
                        } finally{
                            __PRIVATE_logDebug(Rt, "RPC '".concat(t, "' ").concat(_, " completed."));
                        }
                    });
                    var u = JSON.stringify(i);
                    __PRIVATE_logDebug(Rt, "RPC '".concat(t, "' ").concat(_, " sending request:"), i), a.send(n, "POST", u, r, 15);
                });
            }
        },
        {
            key: "vt",
            value: function vt(t, n, r) {
                var _this = this;
                var i = __PRIVATE_generateUniqueDebugId(), s = [
                    this.Xe,
                    "/",
                    "google.firestore.v1.Firestore",
                    "/",
                    t,
                    "/channel"
                ], _ = this.createWebChannelTransport(), o = {
                    // Required for backend stickiness, routing behavior is based on this
                    // parameter.
                    httpSessionIdParam: "gsessionid",
                    initMessageHeaders: {},
                    messageUrlParams: {
                        // This param is used to improve routing and project isolation by the
                        // backend and must be included in every request.
                        database: "projects/".concat(this.databaseId.projectId, "/databases/").concat(this.databaseId.database)
                    },
                    sendRawJson: true,
                    supportsCrossDomainXhr: true,
                    internalChannelParams: {
                        // Override the default timeout (randomized between 10-20 seconds) since
                        // a large write batch on a slow internet connection may take a long
                        // time to send to the backend. Rather than have WebChannel impose a
                        // tight timeout which could lead to infinite timeouts and retries, we
                        // set it very large (5-10 minutes) and rely on the browser's builtin
                        // timeouts to kick in if the request isn't working.
                        forwardChannelRequestTimeoutMs: 6e5
                    },
                    forceLongPolling: this.forceLongPolling,
                    detectBufferingProxy: this.autoDetectLongPolling
                }, a = this.longPollingOptions.timeoutSeconds;
                void 0 !== a && (o.longPollingTimeout = Math.round(1e3 * a)), this.useFetchStreams && (o.useFetchStreams = true), this.it(o.initMessageHeaders, n, r), // Sending the custom headers we just added to request.initMessageHeaders
                // (Authorization, etc.) will trigger the browser to make a CORS preflight
                // request because the XHR will no longer meet the criteria for a "simple"
                // CORS request:
                // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
                // Therefore to avoid the CORS preflight request (an extra network
                // roundtrip), we use the encodeInitMessageHeaders option to specify that
                // the headers should instead be encoded in the request's POST payload,
                // which is recognized by the webchannel backend.
                o.encodeInitMessageHeaders = true;
                var u = s.join("");
                __PRIVATE_logDebug(Rt, "Creating RPC '".concat(t, "' stream ").concat(i, ": ").concat(u), o);
                var c = _.createWebChannel(u, o);
                this.Dt(c);
                // WebChannel supports sending the first message with the handshake - saving
                // a network round trip. However, it will have to call send in the same
                // JS event loop as open. In order to enforce this, we delay actually
                // opening the WebChannel until send is called. Whether we have called
                // open is tracked with this variable.
                var l = false, E = false;
                // A flag to determine whether the stream was closed (by us or through an
                // error/close event) to avoid delivering multiple close events or sending
                // on a closed stream
                var h = new __PRIVATE_StreamBridge({
                    ot: function(e) {
                        E ? __PRIVATE_logDebug(Rt, "Not sending because RPC '".concat(t, "' stream ").concat(i, " is closed:"), e) : (l || (__PRIVATE_logDebug(Rt, "Opening RPC '".concat(t, "' stream ").concat(i, " transport.")), c.open(), l = true), __PRIVATE_logDebug(Rt, "RPC '".concat(t, "' stream ").concat(i, " sending:"), e), c.send(e));
                    },
                    ut: function() {
                        return c.close();
                    }
                });
                return __PRIVATE_unguardedEventListen(c, (0, $2rSfQ.WebChannel).EventType.OPEN, function() {
                    E || (__PRIVATE_logDebug(Rt, "RPC '".concat(t, "' stream ").concat(i, " transport opened.")), h.Rt());
                }), __PRIVATE_unguardedEventListen(c, (0, $2rSfQ.WebChannel).EventType.CLOSE, function() {
                    E || (E = !0, __PRIVATE_logDebug(Rt, "RPC '".concat(t, "' stream ").concat(i, " transport closed")), h.Vt(), _this.xt(c));
                }), __PRIVATE_unguardedEventListen(c, (0, $2rSfQ.WebChannel).EventType.ERROR, function(n) {
                    E || (E = !0, __PRIVATE_logWarn(Rt, "RPC '".concat(t, "' stream ").concat(i, " transport errored. Name:"), n.name, "Message:", n.message), h.Vt(new e(ta.UNAVAILABLE, "The operation could not be completed")));
                }), __PRIVATE_unguardedEventListen(c, (0, $2rSfQ.WebChannel).EventType.MESSAGE, function(n) {
                    if (!E) {
                        var _s_;
                        var _$r = n.data[0];
                        __PRIVATE_hardAssert(!!_$r, 16349);
                        // TODO(b/35143891): There is a bug in One Platform that caused errors
                        // (and only errors) to be wrapped in an extra array. To be forward
                        // compatible with the bug we need to check either condition. The latter
                        // can be removed once the fix has been rolled out.
                        // Use any because msgData.error is not typed.
                        var s = _$r, _ = (s === null || s === void 0 ? void 0 : s.error) || ((_s_ = s[0]) === null || _s_ === void 0 ? void 0 : _s_.error);
                        if (_) {
                            __PRIVATE_logDebug(Rt, "RPC '".concat(t, "' stream ").concat(i, " received error:"), _);
                            // error.status will be a string like 'OK' or 'NOT_FOUND'.
                            var _$n = _.status;
                            var _$r1 = /**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */ function __PRIVATE_mapCodeFromRpcStatus(e) {
                                // lookup by string
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                var _$t = et[e];
                                if (void 0 !== _$t) return __PRIVATE_mapCodeFromRpcCode(_$t);
                            }(_$n), s1 = _.message;
                            "NOT_FOUND" === _$n && s1.includes("database") && s1.includes("does not exist") && s1.includes(_this.databaseId.database) && __PRIVATE_logWarn("Database '".concat(_this.databaseId.database, "' not found. Please check your project configuration.")), void 0 === _$r1 && (_$r1 = ta.INTERNAL, s1 = "Unknown error status: " + _$n + " with message " + _.message), // Mark closed so no further events are propagated
                            E = !0, h.Vt(new e(_$r1, s1)), c.close();
                        } else __PRIVATE_logDebug(Rt, "RPC '".concat(t, "' stream ").concat(i, " received:"), _$r), h.dt(_$r);
                    }
                }), // Ensure that event listeners are configured for STAT_EVENTs.
                __PRIVATE_WebChannelConnection.gt(), setTimeout(function() {
                    // Technically we could/should wait for the WebChannel opened event,
                    // but because we want to send the first message with the WebChannel
                    // handshake we pretend the channel opened here (asynchronously), and
                    // then delay the actual open until the first message is sent.
                    h.At();
                }, 0), h;
            }
        },
        {
            /**
     * Closes and cleans up any resources associated with the connection.
     */ key: "terminate",
            value: function terminate() {
                // If the Firestore instance is terminated, we will explicitly
                // close any remaining open WebChannel instances.
                this.ft.forEach(function(e) {
                    return e.close();
                }), this.ft = [];
            }
        },
        {
            /**
     * Add a WebChannel instance to the collection of open instances.
     * @param webChannel
     */ key: "Dt",
            value: function Dt(e) {
                this.ft.push(e);
            }
        },
        {
            /**
     * Remove a WebChannel instance from the collection of open instances.
     * @param webChannel
     */ key: "xt",
            value: function xt(e) {
                this.ft = this.ft.filter(function(t) {
                    return t === e;
                });
            }
        },
        {
            /**
     * Modifies the headers for a request, adding the api key if present,
     * and then calling super.modifyHeadersForRequest
     */ key: "it",
            value: function it(e, t, n) {
                (0, $hC9N3._)((0, $9atk1._)(__PRIVATE_WebChannelConnection.prototype), "it", this).call(this, e, t, n), // For web channel streams, we want to send the api key in the headers.
                this.databaseInfo.apiKey && (e["x-goog-api-key"] = this.databaseInfo.apiKey);
            }
        },
        {
            /**
     * Wrapped for mocking.
     * @protected
     */ key: "createWebChannelTransport",
            value: function createWebChannelTransport1() {
                return (0, $2rSfQ.createWebChannelTransport)();
            }
        }
    ], [
        {
            key: "gt",
            value: /**
     * Initialize STAT_EVENT listener once. Subsequent calls are a no-op.
     * getStatEventTarget() returns the same target every time.
     */ function gt() {
                if (!__PRIVATE_WebChannelConnection.yt) {
                    var e = (0, $2rSfQ.getStatEventTarget)();
                    __PRIVATE_unguardedEventListen(e, (0, $2rSfQ.Event).STAT_EVENT, function(e) {
                        e.stat === (0, $2rSfQ.Stat).PROXY ? __PRIVATE_logDebug(Rt, "STAT_EVENT: detected buffering proxy") : e.stat === (0, $2rSfQ.Stat).NOPROXY && __PRIVATE_logDebug(Rt, "STAT_EVENT: detected no buffering proxy");
                    }), __PRIVATE_WebChannelConnection.yt = true;
                }
            }
        }
    ]);
    return __PRIVATE_WebChannelConnection;
}(__PRIVATE_RestConnection);
/**
 * Track if the STAT_EVENT listener has been initialized.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Initializes the WebChannelConnection for the browser. */ function __PRIVATE_newConnection(e) {
    return new __PRIVATE_WebChannelConnection(e);
}
/** Return the Platform-specific connectivity monitor. */ __PRIVATE_WebChannelConnection.yt = false;
/**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */ var __PRIVATE_ExponentialBackoff = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_ExponentialBackoff(/**
     * The AsyncQueue to run backoff operations on.
     */ e, /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */ t) {
        var /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */ n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1e3, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1.5, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 6e4;
        (0, $4QweW._)(this, __PRIVATE_ExponentialBackoff);
        this.Ct = e, this.timerId = t, this.Ft = n, this.Ot = r, this.Mt = i, this.Nt = 0, this.Lt = null, /** The last backoff attempt, as epoch milliseconds. */ this.Bt = Date.now(), this.reset();
    }
    (0, $6hK4i._)(__PRIVATE_ExponentialBackoff, [
        {
            /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */ key: "reset",
            value: function reset() {
                this.Nt = 0;
            }
        },
        {
            /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */ key: "Ut",
            value: function Ut() {
                this.Nt = this.Mt;
            }
        },
        {
            /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */ key: "kt",
            value: function kt(e) {
                var _this = this;
                // Cancel any pending backoff operation.
                this.cancel();
                // First schedule using the current base (which may be 0 and should be
                // honored as such).
                var t = Math.floor(this.Nt + this.qt()), n = Math.max(0, Date.now() - this.Bt), r = Math.max(0, t - n);
                // Guard against lastAttemptTime being in the future due to a clock change.
                r > 0 && __PRIVATE_logDebug("ExponentialBackoff", "Backing off for ".concat(r, " ms (base delay: ").concat(this.Nt, " ms, delay with jitter: ").concat(t, " ms, last attempt: ").concat(n, " ms ago)")), this.Lt = this.Ct.enqueueAfterDelay(this.timerId, r, function() {
                    return _this.Bt = Date.now(), e();
                }), // Apply backoff factor to determine next delay and ensure it is within
                // bounds.
                this.Nt *= this.Ot, this.Nt < this.Ft && (this.Nt = this.Ft), this.Nt > this.Mt && (this.Nt = this.Mt);
            }
        },
        {
            key: "$t",
            value: function $t() {
                null !== this.Lt && (this.Lt.skipDelay(), this.Lt = null);
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                null !== this.Lt && (this.Lt.cancel(), this.Lt = null);
            }
        },
        {
            /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */ key: "qt",
            value: function qt() {
                return (Math.random() - .5) * this.Nt;
            }
        }
    ]);
    return __PRIVATE_ExponentialBackoff;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var At = "PersistentStream";
/** The time a stream stays open after it is marked idle. */ /**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */ var __PRIVATE_PersistentStream = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_PersistentStream(e, t, n, r, i, s, _, o) {
        (0, $4QweW._)(this, __PRIVATE_PersistentStream);
        this.Ct = e, this.Kt = n, this.Qt = r, this.connection = i, this.authCredentialsProvider = s, this.appCheckCredentialsProvider = _, this.listener = o, this.state = 0 /* PersistentStreamState.Initial */ , /**
         * A close count that's incremented every time the stream is closed; used by
         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
         * close.
         */ this.Wt = 0, this.Gt = null, this.zt = null, this.stream = null, /**
         * Count of response messages received.
         */ this.jt = 0, this.Ht = new __PRIVATE_ExponentialBackoff(e, t);
    }
    (0, $6hK4i._)(__PRIVATE_PersistentStream, [
        {
            /**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */ key: "Jt",
            value: function Jt() {
                return 1 /* PersistentStreamState.Starting */  === this.state || 5 /* PersistentStreamState.Backoff */  === this.state || this.Yt();
            }
        },
        {
            /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */ key: "Yt",
            value: function Yt() {
                return 2 /* PersistentStreamState.Open */  === this.state || 3 /* PersistentStreamState.Healthy */  === this.state;
            }
        },
        {
            /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */ key: "start",
            value: function start() {
                this.jt = 0, 4 /* PersistentStreamState.Error */  !== this.state ? this.auth() : this.Zt();
            }
        },
        {
            key: "stop",
            value: /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */ function stop() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _tmp;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this.Jt();
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.close(0 /* PersistentStreamState.Initial */ )
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */ key: "Xt",
            value: function Xt() {
                this.state = 0 /* PersistentStreamState.Initial */ , this.Ht.reset();
            }
        },
        {
            /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */ key: "en",
            value: function en() {
                var _this = this;
                // Starts the idle time if we are in state 'Open' and are not yet already
                // running a timer (in which case the previous idle timeout still applies).
                this.Yt() && null === this.Gt && (this.Gt = this.Ct.enqueueAfterDelay(this.Kt, 6e4, function() {
                    return _this.tn();
                }));
            }
        },
        {
            /** Sends a message to the underlying stream. */ key: "nn",
            value: function nn(e) {
                this.rn(), this.stream.send(e);
            }
        },
        {
            key: "tn",
            value: /** Called by the idle timer when the stream should close due to inactivity. */ function tn() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        if (this.Yt()) // When timing out an idle stream there's no reason to force the stream into backoff when
                        // it restarts so set the stream state to Initial instead of Error.
                        return [
                            2,
                            this.close(0 /* PersistentStreamState.Initial */ )
                        ];
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            /** Marks the stream as active again. */ key: "rn",
            value: function rn() {
                this.Gt && (this.Gt.cancel(), this.Gt = null);
            }
        },
        {
            /** Cancels the health check delayed operation. */ key: "sn",
            value: function sn() {
                this.zt && (this.zt.cancel(), this.zt = null);
            }
        },
        {
            key: "close",
            value: /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState - the intended state of the stream after closing.
     * @param error - the error the connection was closed with.
     */ function close(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Cancel any outstanding timers (they're guaranteed not to execute).
                                this.rn(), this.sn(), this.Ht.cancel(), // Invalidates any stream-related callbacks (e.g. from auth or the
                                // underlying stream), guaranteeing they won't execute.
                                this.Wt++, 4 /* PersistentStreamState.Error */  !== e ? // If this is an intentional close ensure we don't delay our next connection attempt.
                                this.Ht.reset() : t && t.code === ta.RESOURCE_EXHAUSTED ? // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
                                (__PRIVATE_logError(t.toString()), __PRIVATE_logError("Using maximum backoff delay to prevent overloading the backend."), this.Ht.Ut()) : t && t.code === ta.UNAUTHENTICATED && 3 /* PersistentStreamState.Healthy */  !== this.state && // "unauthenticated" error means the token was rejected. This should rarely
                                // happen since both Auth and AppCheck ensure a sufficient TTL when we
                                // request a token. If a user manually resets their system clock this can
                                // fail, however. In this case, we should get a Code.UNAUTHENTICATED error
                                // before we received the first message and we need to invalidate the token
                                // to ensure that we fetch a new token.
                                (this.authCredentialsProvider.invalidateToken(), this.appCheckCredentialsProvider.invalidateToken()), // Clean up the underlying stream because we are no longer interested in events.
                                null !== this.stream && (this._n(), this.stream.close(), this.stream = null), // This state must be assigned before calling onClose() to allow the callback to
                                // inhibit backoff or otherwise manipulate the state in its non-started state.
                                this.state = e;
                                // Notify the listener that the stream closed.
                                return [
                                    4,
                                    this.listener.Tt(t)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */ key: "_n",
            value: function _n() {}
        },
        {
            key: "auth",
            value: function auth() {
                var _this = this;
                this.state = 1 /* PersistentStreamState.Starting */ ;
                var t = this.an(this.Wt), n = this.Wt;
                // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
                Promise.all([
                    this.authCredentialsProvider.getToken(),
                    this.appCheckCredentialsProvider.getToken()
                ]).then(function(param) {
                    var _param = (0, $6ZpBv._)(param, 2), e = _param[0], t = _param[1];
                    // Stream can be stopped while waiting for authentication.
                    // TODO(mikelehen): We really should just use dispatchIfNotClosed
                    // and let this dispatch onto the queue, but that opened a spec test can
                    // of worms that I don't want to deal with in this PR.
                    _this.Wt === n && // Normally we'd have to schedule the callback on the AsyncQueue.
                    // However, the following calls are safe to be called outside the
                    // AsyncQueue since they don't chain asynchronous calls
                    _this.un(e, t);
                }, function(n) {
                    t(function() {
                        var t = new e(ta.UNKNOWN, "Fetching auth token failed: " + n.message);
                        return _this.cn(t);
                    });
                });
            }
        },
        {
            key: "un",
            value: function un(e, t) {
                var _this = this;
                var n = this.an(this.Wt);
                this.stream = this.En(e, t), this.stream.ct(function() {
                    n(function() {
                        return _this.listener.ct();
                    });
                }), this.stream.Et(function() {
                    n(function() {
                        return _this.state = 2 /* PersistentStreamState.Open */ , _this.zt = _this.Ct.enqueueAfterDelay(_this.Qt, 1e4, function() {
                            return _this.Yt() && (_this.state = 3 /* PersistentStreamState.Healthy */ ), Promise.resolve();
                        }), _this.listener.Et();
                    });
                }), this.stream.Tt(function(e) {
                    n(function() {
                        return _this.cn(e);
                    });
                }), this.stream.onMessage(function(e) {
                    n(function() {
                        return 1 == ++_this.jt ? _this.hn(e) : _this.onNext(e);
                    });
                });
            }
        },
        {
            key: "Zt",
            value: function Zt() {
                var _this = this;
                this.state = 5 /* PersistentStreamState.Backoff */ , this.Ht.kt(function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                        return (0, $gh3Df._)(this, function(_state) {
                            this.state = 0 /* PersistentStreamState.Initial */ , this.start();
                            return [
                                2
                            ];
                        });
                    }).call(_this);
                });
            }
        },
        {
            // Visible for tests
            key: "cn",
            value: function cn(e) {
                // In theory the stream could close cleanly, however, in our current model
                // we never expect this to happen because if we stop a stream ourselves,
                // this callback will never be called. To prevent cases where we retry
                // without a backoff accidentally, we set the stream to error in all cases.
                return __PRIVATE_logDebug(At, "close with error: ".concat(e)), this.stream = null, this.close(4 /* PersistentStreamState.Error */ , e);
            }
        },
        {
            /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */ key: "an",
            value: function an(e) {
                var _this = this;
                return function(t) {
                    _this.Ct.enqueueAndForget(function() {
                        return _this.Wt === e ? t() : (__PRIVATE_logDebug(At, "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve());
                    });
                };
            }
        }
    ]);
    return __PRIVATE_PersistentStream;
}();
/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */ var __PRIVATE_PersistentListenStream = /*#__PURE__*/ function(__PRIVATE_PersistentStream) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_PersistentListenStream, __PRIVATE_PersistentStream);
    function __PRIVATE_PersistentListenStream(e, t, n, r, i, s) {
        (0, $4QweW._)(this, __PRIVATE_PersistentListenStream);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_PersistentListenStream, [
            e,
            "listen_stream_connection_backoff" /* TimerId.ListenStreamConnectionBackoff */ ,
            "listen_stream_idle" /* TimerId.ListenStreamIdle */ ,
            "health_check_timeout" /* TimerId.HealthCheckTimeout */ ,
            t,
            n,
            r,
            s
        ]), _this.serializer = i;
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_PersistentListenStream, [
        {
            key: "En",
            value: function En(e, t) {
                return this.connection.vt("Listen", e, t);
            }
        },
        {
            key: "hn",
            value: function hn(e) {
                return this.onNext(e);
            }
        },
        {
            key: "onNext",
            value: function onNext(e) {
                // A successful response means the stream is healthy
                this.Ht.reset();
                var t = __PRIVATE_fromWatchChange(this.serializer, e), n = function __PRIVATE_versionFromListenResponse(e) {
                    // We have only reached a consistent snapshot for the entire stream if there
                    // is a read_time set and it applies to all targets (i.e. the list of
                    // targets is empty). The backend is guaranteed to send such responses.
                    if (!("targetChange" in e)) return SnapshotVersion.min();
                    var t = e.targetChange;
                    return t.targetIds && t.targetIds.length ? SnapshotVersion.min() : t.readTime ? __PRIVATE_fromVersion(t.readTime) : SnapshotVersion.min();
                }(e);
                return this.listener.Tn(t, n);
            }
        },
        {
            /**
     * Registers interest in the results of the given target. If the target
     * includes a resumeToken it will be included in the request. Results that
     * affect the target will be streamed back as WatchChange messages that
     * reference the targetId.
     */ key: "Pn",
            value: function Pn(e) {
                var t = {};
                t.database = __PRIVATE_getEncodedDatabaseId(this.serializer), t.addTarget = function __PRIVATE_toTarget(e, t) {
                    var n;
                    var r = t.target;
                    if (n = __PRIVATE_targetIsPipelineTarget(r) ? {
                        pipelineQuery: __PRIVATE_toPipelineTarget(e, r)
                    } : __PRIVATE_targetIsDocumentTarget(r) ? {
                        documents: __PRIVATE_toDocumentsTarget(e, r)
                    } : {
                        query: __PRIVATE_toQueryTarget(e, r).Se
                    }, n.targetId = t.targetId, t.resumeToken.approximateByteSize() > 0) {
                        n.resumeToken = __PRIVATE_toBytes(e, t.resumeToken);
                        var r1 = __PRIVATE_toInt32Proto(e, t.expectedCount);
                        null !== r1 && (n.expectedCount = r1);
                    } else if (t.snapshotVersion.compareTo(SnapshotVersion.min()) > 0) {
                        // TODO(wuandy): Consider removing above check because it is most likely true.
                        // Right now, many tests depend on this behaviour though (leaving min() out
                        // of serialization).
                        n.readTime = toTimestamp(e, t.snapshotVersion.toTimestamp());
                        var r2 = __PRIVATE_toInt32Proto(e, t.expectedCount);
                        null !== r2 && (n.expectedCount = r2);
                    }
                    return n;
                }(this.serializer, e);
                var n = __PRIVATE_toListenRequestLabels(this.serializer, e);
                n && (t.labels = n), this.nn(t);
            }
        },
        {
            /**
     * Unregisters interest in the results of the target associated with the
     * given targetId.
     */ key: "In",
            value: function In(e) {
                var t = {};
                t.database = __PRIVATE_getEncodedDatabaseId(this.serializer), t.removeTarget = e, this.nn(t);
            }
        }
    ]);
    return __PRIVATE_PersistentListenStream;
}(__PRIVATE_PersistentStream);
/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */ var __PRIVATE_PersistentWriteStream = /*#__PURE__*/ function(__PRIVATE_PersistentStream) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_PersistentWriteStream, __PRIVATE_PersistentStream);
    function __PRIVATE_PersistentWriteStream(e, t, n, r, i, s) {
        (0, $4QweW._)(this, __PRIVATE_PersistentWriteStream);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_PersistentWriteStream, [
            e,
            "write_stream_connection_backoff" /* TimerId.WriteStreamConnectionBackoff */ ,
            "write_stream_idle" /* TimerId.WriteStreamIdle */ ,
            "health_check_timeout" /* TimerId.HealthCheckTimeout */ ,
            t,
            n,
            r,
            s
        ]), _this.serializer = i;
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_PersistentWriteStream, [
        {
            key: "Rn",
            get: /**
     * Tracks whether or not a handshake has been successfully exchanged and
     * the stream is ready to accept mutations.
     */ function get() {
                return this.jt > 0;
            }
        },
        {
            // Override of PersistentStream.start
            key: "start",
            value: function start() {
                this.lastStreamToken = void 0, (0, $hC9N3._)((0, $9atk1._)(__PRIVATE_PersistentWriteStream.prototype), "start", this).call(this);
            }
        },
        {
            key: "_n",
            value: function _n() {
                this.Rn && this.An([]);
            }
        },
        {
            key: "En",
            value: function En(e, t) {
                return this.connection.vt("Write", e, t);
            }
        },
        {
            key: "hn",
            value: function hn(e) {
                // Always capture the last stream token.
                return __PRIVATE_hardAssert(!!e.streamToken, 31322), this.lastStreamToken = e.streamToken, // The first response is always the handshake response
                __PRIVATE_hardAssert(!e.writeResults || 0 === e.writeResults.length, 55816), this.listener.Vn();
            }
        },
        {
            key: "onNext",
            value: function onNext(e) {
                // Always capture the last stream token.
                __PRIVATE_hardAssert(!!e.streamToken, 12678), this.lastStreamToken = e.streamToken, // A successful first write response means the stream is healthy,
                // Note, that we could consider a successful handshake healthy, however,
                // the write itself might be causing an error we want to back off from.
                this.Ht.reset();
                var t = __PRIVATE_fromWriteResults(e.writeResults, e.commitTime), n = __PRIVATE_fromVersion(e.commitTime);
                return this.listener.dn(n, t);
            }
        },
        {
            /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */ key: "fn",
            value: function fn() {
                // TODO(dimond): Support stream resumption. We intentionally do not set the
                // stream token on the handshake, ignoring any stream token we might have.
                var e = {};
                e.database = __PRIVATE_getEncodedDatabaseId(this.serializer), this.nn(e);
            }
        },
        {
            /** Sends a group of mutations to the Firestore backend to apply. */ key: "An",
            value: function An(e) {
                var _this = this;
                var t = {
                    streamToken: this.lastStreamToken,
                    writes: e.map(function(e) {
                        return toMutation(_this.serializer, e);
                    })
                };
                this.nn(t);
            }
        }
    ]);
    return __PRIVATE_PersistentWriteStream;
}(__PRIVATE_PersistentStream);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Datastore and its related methods are a wrapper around the external Google
 * Cloud Datastore grpc API, which provides an interface that is more convenient
 * for the rest of the client SDK architecture to consume.
 */ var Datastore = function Datastore() {
    "use strict";
    (0, $4QweW._)(this, Datastore);
};
/**
 * An implementation of Datastore that exposes additional state for internal
 * consumption.
 */ var __PRIVATE_DatastoreImpl = /*#__PURE__*/ function(Datastore) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_DatastoreImpl, Datastore);
    function __PRIVATE_DatastoreImpl(e, t, n, r) {
        (0, $4QweW._)(this, __PRIVATE_DatastoreImpl);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_DatastoreImpl), _this.authCredentials = e, _this.appCheckCredentials = t, _this.connection = n, _this.serializer = r, _this.mn = false;
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_DatastoreImpl, [
        {
            key: "pn",
            value: function pn() {
                if (this.mn) throw new e(ta.FAILED_PRECONDITION, "The client has already been terminated.");
            }
        },
        {
            /** Invokes the provided RPC with auth and AppCheck tokens. */ key: "nt",
            value: function nt(t, n, r, i) {
                var _this = this;
                return this.pn(), Promise.all([
                    this.authCredentials.getToken(),
                    this.appCheckCredentials.getToken()
                ]).then(function(param) {
                    var _param = (0, $6ZpBv._)(param, 2), e = _param[0], s = _param[1];
                    return _this.connection.nt(t, __PRIVATE_toResourcePath(n, r), i, e, s);
                }).catch(function(t) {
                    throw "FirebaseError" === t.name ? (t.code === ta.UNAUTHENTICATED && (_this.authCredentials.invalidateToken(), _this.appCheckCredentials.invalidateToken()), t) : new e(ta.UNKNOWN, t.toString());
                });
            }
        },
        {
            /** Invokes the provided RPC with streamed results with auth and AppCheck tokens. */ key: "_t",
            value: function _t(t, n, r, i, s) {
                var _this = this;
                return this.pn(), Promise.all([
                    this.authCredentials.getToken(),
                    this.appCheckCredentials.getToken()
                ]).then(function(param) {
                    var _param = (0, $6ZpBv._)(param, 2), e = _param[0], _ = _param[1];
                    return _this.connection._t(t, __PRIVATE_toResourcePath(n, r), i, e, _, s);
                }).catch(function(t) {
                    throw "FirebaseError" === t.name ? (t.code === ta.UNAUTHENTICATED && (_this.authCredentials.invalidateToken(), _this.appCheckCredentials.invalidateToken()), t) : new e(ta.UNKNOWN, t.toString());
                });
            }
        },
        {
            key: "terminate",
            value: function terminate() {
                this.mn = true, this.connection.terminate();
            }
        }
    ]);
    return __PRIVATE_DatastoreImpl;
}(Datastore);
// TODO(firestorexp): Make sure there is only one Datastore instance per
// firestore-exp client.
function __PRIVATE_newDatastore(e, t, n, r) {
    return new __PRIVATE_DatastoreImpl(e, t, n, r);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var Vt = "ComponentProvider", dt = new Map;
/**
 * An instance map that ensures only one Datastore exists per Firestore
 * instance.
 */ function __PRIVATE_makeDatabaseInfo(e, t, n, r, i) {
    return new DatabaseInfo(e, t, n, i.host, i.ssl, i.experimentalForceLongPolling, i.experimentalAutoDetectLongPolling, __PRIVATE_cloneLongPollingOptions(i.experimentalLongPollingOptions), i.useFetchStreams, i.isUsingEmulator, r, i._customHeaders, i.grpcFlowControlWindow);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var ft = {
    didRun: false,
    sequenceNumbersCollected: 0,
    targetsRemoved: 0,
    documentsRemoved: 0
}, mt = 41943040;
var LruParams = /*#__PURE__*/ function() {
    "use strict";
    function LruParams(// When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    e, // The percentage of sequence numbers that we will attempt to collect
    t, // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    n) {
        (0, $4QweW._)(this, LruParams);
        this.cacheSizeCollectionThreshold = e, this.percentileToCollect = t, this.maximumSequenceNumbersToCollect = n;
    }
    (0, $6hK4i._)(LruParams, null, [
        {
            key: "withCacheSize",
            value: function withCacheSize(e) {
                return new LruParams(e, LruParams.DEFAULT_COLLECTION_PERCENTILE, LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
            }
        }
    ]);
    return LruParams;
}();
LruParams.DEFAULT_COLLECTION_PERCENTILE = 10, LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, LruParams.DEFAULT = new LruParams(mt, LruParams.DEFAULT_COLLECTION_PERCENTILE, LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), LruParams.DISABLED = new LruParams(-1, 0, 0);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */ var __PRIVATE_ListenSequence = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_ListenSequence(e, t) {
        var _this = this;
        (0, $4QweW._)(this, __PRIVATE_ListenSequence);
        this.previousValue = e, t && (t.sequenceNumberHandler = function(e) {
            return _this.gn(e);
        }, this.yn = function(e) {
            return t.writeSequenceNumber(e);
        });
    }
    (0, $6hK4i._)(__PRIVATE_ListenSequence, [
        {
            key: "gn",
            value: function gn(e) {
                return this.previousValue = Math.max(e, this.previousValue), this.previousValue;
            }
        },
        {
            key: "next",
            value: function next() {
                var e = ++this.previousValue;
                return this.yn && this.yn(e), e;
            }
        }
    ]);
    return __PRIVATE_ListenSequence;
}();
__PRIVATE_ListenSequence.wn = -1;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var pt = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";
/**
 * A base class representing a persistence transaction, encapsulating both the
 * transaction's sequence numbers as well as a list of onCommitted listeners.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */ var PersistenceTransaction = /*#__PURE__*/ function() {
    "use strict";
    function PersistenceTransaction() {
        (0, $4QweW._)(this, PersistenceTransaction);
        this.onCommittedListeners = [];
    }
    (0, $6hK4i._)(PersistenceTransaction, [
        {
            key: "addOnCommittedListener",
            value: function addOnCommittedListener(e) {
                this.onCommittedListeners.push(e);
            }
        },
        {
            key: "raiseOnCommittedEvent",
            value: function raiseOnCommittedEvent() {
                this.onCommittedListeners.forEach(function(e) {
                    return e();
                });
            }
        }
    ]);
    return PersistenceTransaction;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err - An error returned by a LocalStore operation.
 * @returns A Promise that resolves after we recovered, or the original error.
 */ function __PRIVATE_ignoreIfPrimaryLeaseLoss(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        return (0, $gh3Df._)(this, function(_state) {
            if (e.code !== ta.FAILED_PRECONDITION || e.message !== pt) throw e;
            __PRIVATE_logDebug("LocalStore", "Unexpectedly lost primary lease");
            return [
                2
            ];
        });
    })();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * PersistencePromise is essentially a re-implementation of Promise except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */ var PersistencePromise = /*#__PURE__*/ function() {
    "use strict";
    function PersistencePromise(e) {
        var _this = this;
        (0, $4QweW._)(this, PersistencePromise);
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        this.nextCallback = null, this.catchCallback = null, // When the operation resolves, we'll set result or error and mark isDone.
        this.result = void 0, this.error = void 0, this.isDone = false, // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.callbackAttached = false, e(function(e) {
            _this.isDone = true, _this.result = e, _this.nextCallback && // value should be defined unless T is Void, but we can't express
            // that in the type system.
            _this.nextCallback(e);
        }, function(e) {
            _this.isDone = true, _this.error = e, _this.catchCallback && _this.catchCallback(e);
        });
    }
    (0, $6hK4i._)(PersistencePromise, [
        {
            key: "catch",
            value: function _catch(e) {
                return this.next(void 0, e);
            }
        },
        {
            key: "next",
            value: function next(e, t) {
                var _this = this;
                return this.callbackAttached && l(59440), this.callbackAttached = true, this.isDone ? this.error ? this.wrapFailure(t, this.error) : this.wrapSuccess(e, this.result) : new PersistencePromise(function(n, r) {
                    _this.nextCallback = function(t) {
                        _this.wrapSuccess(e, t).next(n, r);
                    }, _this.catchCallback = function(e) {
                        _this.wrapFailure(t, e).next(n, r);
                    };
                });
            }
        },
        {
            key: "toPromise",
            value: function toPromise() {
                var _this = this;
                return new Promise(function(e, t) {
                    _this.next(e, t);
                });
            }
        },
        {
            key: "wrapUserFunction",
            value: function wrapUserFunction(e) {
                try {
                    var t = e();
                    return t instanceof PersistencePromise ? t : PersistencePromise.resolve(t);
                } catch (e) {
                    return PersistencePromise.reject(e);
                }
            }
        },
        {
            key: "wrapSuccess",
            value: function wrapSuccess(e, t) {
                return e ? this.wrapUserFunction(function() {
                    return e(t);
                }) : PersistencePromise.resolve(t);
            }
        },
        {
            key: "wrapFailure",
            value: function wrapFailure(e, t) {
                return e ? this.wrapUserFunction(function() {
                    return e(t);
                }) : PersistencePromise.reject(t);
            }
        }
    ], [
        {
            key: "resolve",
            value: function resolve(e) {
                return new PersistencePromise(function(t, n) {
                    t(e);
                });
            }
        },
        {
            key: "reject",
            value: function reject(e) {
                return new PersistencePromise(function(t, n) {
                    n(e);
                });
            }
        },
        {
            key: "waitFor",
            value: function waitFor(// Accept all Promise types in waitFor().
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            e) {
                return new PersistencePromise(function(t, n) {
                    var r = 0, i = 0, s = false;
                    e.forEach(function(e) {
                        ++r, e.next(function() {
                            ++i, s && i === r && t();
                        }, function(e) {
                            return n(e);
                        });
                    }), s = true, i === r && t();
                });
            }
        },
        {
            key: "or",
            value: /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */ function or(e) {
                var t = PersistencePromise.resolve(false);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _loop = function() {
                        var n = _step.value;
                        t = t.next(function(e) {
                            return e ? PersistencePromise.resolve(e) : n();
                        });
                    };
                    for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return t;
            }
        },
        {
            key: "forEach",
            value: function forEach(e, t) {
                var _this = this;
                var n = [];
                return e.forEach(function(e, r) {
                    n.push(t.call(_this, e, r));
                }), this.waitFor(n);
            }
        },
        {
            key: "mapArray",
            value: /**
     * Concurrently map all array elements through asynchronous function.
     */ function mapArray(e, t) {
                return new PersistencePromise(function(n, r) {
                    var _loop = function(o) {
                        var a = o;
                        t(e[a]).next(function(e) {
                            s[a] = e, ++_, _ === i && n(s);
                        }, function(e) {
                            return r(e);
                        });
                    };
                    var i = e.length, s = new Array(i);
                    var _ = 0;
                    for(var o = 0; o < i; o++)_loop(o);
                });
            }
        },
        {
            key: "doWhile",
            value: /**
     * An alternative to recursive PersistencePromise calls, that avoids
     * potential memory problems from unbounded chains of promises.
     *
     * The `action` will be called repeatedly while `condition` is true.
     */ function doWhile(e, t) {
                return new PersistencePromise(function(n, r) {
                    var process = function() {
                        true === e() ? t().next(function() {
                            process();
                        }, r) : n();
                    };
                    process();
                });
            }
        }
    ]);
    return PersistencePromise;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `indexedDB` are guarded by SimpleDb.isAvailable() and getGlobal()
/* eslint-disable no-restricted-globals */ var gt = "SimpleDb";
/**
 * The maximum number of retry attempts for an IndexedDb transaction that fails
 * with a DOMException.
 */ /**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */ var __PRIVATE_SimpleDbTransaction = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_SimpleDbTransaction(e, t) {
        var _this = this;
        (0, $4QweW._)(this, __PRIVATE_SimpleDbTransaction);
        this.action = e, this.transaction = t, this.aborted = false, /**
         * A `Promise` that resolves with the result of the IndexedDb transaction.
         */ this.bn = new __PRIVATE_Deferred, this.transaction.oncomplete = function() {
            _this.bn.resolve();
        }, this.transaction.onabort = function() {
            t.error ? _this.bn.reject(new __PRIVATE_IndexedDbTransactionError(e, t.error)) : _this.bn.resolve();
        }, this.transaction.onerror = function(t) {
            var n = __PRIVATE_checkForAndReportiOSError(t.target.error);
            _this.bn.reject(new __PRIVATE_IndexedDbTransactionError(e, n));
        };
    }
    (0, $6hK4i._)(__PRIVATE_SimpleDbTransaction, [
        {
            key: "Sn",
            get: function get() {
                return this.bn.promise;
            }
        },
        {
            key: "abort",
            value: function abort(e) {
                e && this.bn.reject(e), this.aborted || (__PRIVATE_logDebug(gt, "Aborting transaction:", e ? e.message : "Client-initiated abort"), this.aborted = true, this.transaction.abort());
            }
        },
        {
            key: "vn",
            value: function vn() {
                // If the browser supports V3 IndexedDB, we invoke commit() explicitly to
                // speed up index DB processing if the event loop remains blocks.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var e = this.transaction;
                this.aborted || "function" != typeof e.commit || e.commit();
            }
        },
        {
            /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */ key: "store",
            value: function store(e) {
                var t = this.transaction.objectStore(e);
                return new __PRIVATE_SimpleDbStore(t);
            }
        }
    ], [
        {
            key: "open",
            value: function open(e, t, n, r) {
                try {
                    return new __PRIVATE_SimpleDbTransaction(t, e.transaction(r, n));
                } catch (e) {
                    throw new __PRIVATE_IndexedDbTransactionError(t, e);
                }
            }
        }
    ]);
    return __PRIVATE_SimpleDbTransaction;
}();
/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */ var __PRIVATE_SimpleDb = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_SimpleDb(e, t, n) {
        (0, $4QweW._)(this, __PRIVATE_SimpleDb);
        this.name = e, this.version = t, this.Fn = n, this.On = null;
        // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
        // whatever reason it's much harder to hit after 12.2 so we only proactively
        // log on 12.2.
        12.2 === __PRIVATE_SimpleDb.xn((0, $hk14n.getUA)()) && __PRIVATE_logError("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
    }
    (0, $6hK4i._)(__PRIVATE_SimpleDb, [
        {
            key: "Mn",
            value: /**
     * Opens the specified database, creating or upgrading it if necessary.
     */ function Mn(t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _this, _tmp, _;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                _tmp = this.db;
                                if (_tmp) return [
                                    3,
                                    2
                                ];
                                __PRIVATE_logDebug(gt, "Opening database:", this.name);
                                _ = this;
                                return [
                                    4,
                                    new Promise(function(n, r) {
                                        // TODO(mikelehen): Investigate browser compatibility.
                                        // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
                                        // suggests IE9 and older WebKit browsers handle upgrade
                                        // differently. They expect setVersion, as described here:
                                        // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
                                        var i = indexedDB.open(_this.name, _this.version);
                                        i.onsuccess = function(e) {
                                            var t = e.target.result;
                                            n(t);
                                        }, i.onblocked = function() {
                                            r(new __PRIVATE_IndexedDbTransactionError(t, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
                                        }, i.onerror = function(n) {
                                            var i = n.target.error;
                                            "VersionError" === i.name ? r(new e(ta.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : "InvalidStateError" === i.name ? r(new e(ta.FAILED_PRECONDITION, "Unable to open an IndexedDB connection. This could be due to running in a private browsing session on a browser whose private browsing sessions do not support IndexedDB: " + i)) : r(new __PRIVATE_IndexedDbTransactionError(t, i));
                                        }, i.onupgradeneeded = function(e) {
                                            __PRIVATE_logDebug(gt, 'Database "' + _this.name + '" requires upgrade from version:', e.oldVersion);
                                            var t = e.target.result;
                                            _this.Fn.Nn(t, i.transaction, e.oldVersion, _this.version).next(function() {
                                                __PRIVATE_logDebug(gt, "Database upgrade to version " + _this.version + " complete");
                                            });
                                        };
                                    })
                                ];
                            case 1:
                                _tmp = _.db = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    (_tmp, this.Ln && (this.db.onversionchange = function(e) {
                                        return _this.Ln(e);
                                    }), this.db)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "Bn",
            value: function Bn(e) {
                this.Ln = e, this.db && (this.db.onversionchange = function(t) {
                    return e(t);
                });
            }
        },
        {
            key: "runTransaction",
            value: function runTransaction(e, t, n, r) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _this, _loop, i, s, _ret;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _loop = function() {
                                    var _$t, s1, _tmp, e1, _$t1, _$n;
                                    return (0, $gh3Df._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                ++s;
                                                _state.label = 1;
                                            case 1:
                                                _state.trys.push([
                                                    1,
                                                    4,
                                                    ,
                                                    5
                                                ]);
                                                return [
                                                    4,
                                                    _this.Mn(e)
                                                ];
                                            case 2:
                                                _this.db = _state.sent();
                                                _$t = __PRIVATE_SimpleDbTransaction.open(_this.db, e, i ? "readonly" : "readwrite", n), s1 = r(_$t).next(function(e) {
                                                    return _$t.vn(), e;
                                                }).catch(function(e) {
                                                    return(// Abort the transaction if there was an error.
                                                    _$t.abort(e), PersistencePromise.reject(e));
                                                }).toPromise();
                                                _tmp = {};
                                                s1.catch(function() {});
                                                // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                                                // fire), but still return the original transactionFnResult back to the
                                                // caller.
                                                return [
                                                    4,
                                                    _$t.Sn
                                                ];
                                            case 3:
                                                // As noted above, errors are propagated by aborting the transaction. So
                                                // we swallow any error here to avoid the browser logging it as unhandled.
                                                return [
                                                    2,
                                                    (_tmp.v = (_state.sent(), s1), _tmp)
                                                ];
                                            case 4:
                                                e1 = _state.sent();
                                                _$t1 = e1, _$n = "FirebaseError" !== _$t1.name && s < 3;
                                                // TODO(schmidt-sebastian): We could probably be smarter about this and
                                                // not retry exceptions that are likely unrecoverable (such as quota
                                                // exceeded errors).
                                                // Note: We cannot use an instanceof check for FirestoreException, since the
                                                // exception is wrapped in a generic error by our async/await handling.
                                                if (__PRIVATE_logDebug(gt, "Transaction failed with error:", _$t1.message, "Retrying:", _$n), _this.close(), !_$n) return [
                                                    2,
                                                    {
                                                        v: Promise.reject(_$t1)
                                                    }
                                                ];
                                                return [
                                                    3,
                                                    5
                                                ];
                                            case 5:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                };
                                i = "readonly" === t;
                                s = 0;
                                _state.label = 1;
                            case 1:
                                _this = this;
                                return [
                                    5,
                                    (0, $2TaHn.__values)(_loop())
                                ];
                            case 2:
                                _ret = _state.sent();
                                if ((0, $5djcY._)(_ret) === "object") return [
                                    2,
                                    _ret.v
                                ];
                                _state.label = 3;
                            case 3:
                                return [
                                    3,
                                    1
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "close",
            value: function close() {
                this.db && this.db.close(), this.db = void 0;
            }
        }
    ], [
        {
            key: "delete",
            value: /** Deletes the specified database. */ function _delete(e) {
                __PRIVATE_logDebug(gt, "Removing database:", e);
                return __PRIVATE_wrapRequest((0, $hk14n.getGlobal)().indexedDB.deleteDatabase(e)).toPromise();
            }
        },
        {
            key: "Ye",
            value: /** Returns true if IndexedDB is available in the current environment. */ function Ye() {
                if (!(0, $hk14n.isIndexedDBAvailable)()) return false;
                if (__PRIVATE_SimpleDb.Dn()) return true;
                // We extensively use indexed array values and compound keys,
                // which IE and Edge do not support. However, they still have indexedDB
                // defined on the window, so we need to check for them here and make sure
                // to return that persistence is not enabled for those browsers.
                // For tracking support of this feature, see here:
                // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
                // Check the UA string to find out the browser.
                var e = (0, $hk14n.getUA)(), t = __PRIVATE_SimpleDb.xn(e), n = 0 < t && t < 10, r = __PRIVATE_getAndroidVersion(e), i = 0 < r && r < 4.5;
                // IE 10
                // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
                // IE 11
                // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
                // Edge
                // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
                // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
                // iOS Safari: Disable for users running iOS version < 10.
                return !(e.indexOf("MSIE ") > 0 || e.indexOf("Trident/") > 0 || e.indexOf("Edge/") > 0 || n || i);
            }
        },
        {
            key: "Dn",
            value: /**
     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
     * (see https://github.com/axemclion/IndexedDBShim).
     */ function Dn() {
                return false;
            }
        },
        {
            key: "Cn",
            value: /** Helper to get a typed SimpleDbStore from a transaction. */ function Cn(e, t) {
                return e.store(t);
            }
        },
        {
            key: "xn",
            value: // visible for testing
            /** Parse User Agent to determine iOS version. Returns -1 if not found. */ function xn(e) {
                var t = e.match(/i(?:phone|pad|pod) os ([\d_]+)/i), n = t ? t[1].split("_").slice(0, 2).join(".") : "-1";
                return Number(n);
            }
        }
    ]);
    return __PRIVATE_SimpleDb;
}();
/** Parse User Agent to determine Android version. Returns -1 if not found. */ function __PRIVATE_getAndroidVersion(e) {
    var t = e.match(/Android ([\d.]+)/i), n = t ? t[1].split(".").slice(0, 2).join(".") : "-1";
    return Number(n);
}
/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */ var __PRIVATE_IterationController = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IterationController(e) {
        (0, $4QweW._)(this, __PRIVATE_IterationController);
        this.Un = e, this.kn = false, this.qn = null;
    }
    (0, $6hK4i._)(__PRIVATE_IterationController, [
        {
            key: "isDone",
            get: function get() {
                return this.kn;
            }
        },
        {
            key: "$n",
            get: function get() {
                return this.qn;
            }
        },
        {
            key: "cursor",
            set: function set(e) {
                this.Un = e;
            }
        },
        {
            /**
     * This function can be called to stop iteration at any point.
     */ key: "done",
            value: function done() {
                this.kn = true;
            }
        },
        {
            /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */ key: "Kn",
            value: function Kn(e) {
                this.qn = e;
            }
        },
        {
            /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */ key: "delete",
            value: function _delete() {
                return __PRIVATE_wrapRequest(this.Un.delete());
            }
        }
    ]);
    return __PRIVATE_IterationController;
}();
/** An error that wraps exceptions that thrown during IndexedDB execution. */ var __PRIVATE_IndexedDbTransactionError = /*#__PURE__*/ function(e) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_IndexedDbTransactionError, e);
    function __PRIVATE_IndexedDbTransactionError(e, t) {
        (0, $4QweW._)(this, __PRIVATE_IndexedDbTransactionError);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_IndexedDbTransactionError, [
            ta.UNAVAILABLE,
            "IndexedDB transaction '".concat(e, "' failed: ").concat(t)
        ]), _this.name = "IndexedDbTransactionError";
        return _this;
    }
    return __PRIVATE_IndexedDbTransactionError;
}(e);
/** Verifies whether `e` is an IndexedDbTransactionError. */ function __PRIVATE_isIndexedDbTransactionError(e) {
    // Use name equality, as instanceof checks on errors don't work with errors
    // that wrap other errors.
    return "IndexedDbTransactionError" === e.name;
}
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */ var __PRIVATE_SimpleDbStore = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_SimpleDbStore(e) {
        (0, $4QweW._)(this, __PRIVATE_SimpleDbStore);
        this.store = e;
    }
    (0, $6hK4i._)(__PRIVATE_SimpleDbStore, [
        {
            key: "put",
            value: function put(e, t) {
                var n;
                return void 0 !== t ? (__PRIVATE_logDebug(gt, "PUT", this.store.name, e, t), n = this.store.put(t, e)) : (__PRIVATE_logDebug(gt, "PUT", this.store.name, "<auto-key>", e), n = this.store.put(e)), __PRIVATE_wrapRequest(n);
            }
        },
        {
            /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value - The object to write.
     * @returns The key of the value to add.
     */ key: "add",
            value: function add(e) {
                __PRIVATE_logDebug(gt, "ADD", this.store.name, e, e);
                return __PRIVATE_wrapRequest(this.store.add(e));
            }
        },
        {
            /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @returns The object with the specified key or null if no object exists.
     */ key: "get",
            value: function get(e) {
                var _this = this;
                // We're doing an unsafe cast to ValueType.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return __PRIVATE_wrapRequest(this.store.get(e)).next(function(t) {
                    return(// Normalize nonexistence to null.
                    void 0 === t && (t = null), __PRIVATE_logDebug(gt, "GET", _this.store.name, e, t), t);
                });
            }
        },
        {
            key: "delete",
            value: function _delete(e) {
                __PRIVATE_logDebug(gt, "DELETE", this.store.name, e);
                return __PRIVATE_wrapRequest(this.store.delete(e));
            }
        },
        {
            /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */ key: "count",
            value: function count() {
                __PRIVATE_logDebug(gt, "COUNT", this.store.name);
                return __PRIVATE_wrapRequest(this.store.count());
            }
        },
        {
            key: "Qn",
            value: function Qn(e, t) {
                var n = this.options(e, t), r = n.index ? this.store.index(n.index) : this.store;
                // Use `getAll()` if the browser supports IndexedDB v3, as it is roughly
                // 20% faster.
                if ("function" == typeof r.getAll) {
                    var _$e = r.getAll(n.range);
                    return new PersistencePromise(function(t, n) {
                        _$e.onerror = function(e) {
                            n(e.target.error);
                        }, _$e.onsuccess = function(e) {
                            t(e.target.result);
                        };
                    });
                }
                {
                    var _$e1 = this.cursor(n), _$t = [];
                    return this.Wn(_$e1, function(e, n) {
                        _$t.push(n);
                    }).next(function() {
                        return _$t;
                    });
                }
            }
        },
        {
            /**
     * Loads the first `count` elements from the provided index range. Loads all
     * elements if no limit is provided.
     */ key: "Gn",
            value: function Gn(e, t) {
                var n = this.store.getAll(e, null === t ? void 0 : t);
                return new PersistencePromise(function(e, t) {
                    n.onerror = function(e) {
                        t(e.target.error);
                    }, n.onsuccess = function(t) {
                        e(t.target.result);
                    };
                });
            }
        },
        {
            key: "zn",
            value: function zn(e, t) {
                __PRIVATE_logDebug(gt, "DELETE ALL", this.store.name);
                var n = this.options(e, t);
                n.jn = false;
                var r = this.cursor(n);
                return this.Wn(r, function(e, t, n) {
                    return n.delete();
                });
            }
        },
        {
            key: "Hn",
            value: function Hn(e, t) {
                var n;
                t ? n = e : (n = {}, t = e);
                var r = this.cursor(n);
                return this.Wn(r, t);
            }
        },
        {
            /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */ key: "Jn",
            value: function Jn(e) {
                var t = this.cursor({});
                return new PersistencePromise(function(n, r) {
                    t.onerror = function(e) {
                        var t = __PRIVATE_checkForAndReportiOSError(e.target.error);
                        r(t);
                    }, t.onsuccess = function(t) {
                        var r = t.target.result;
                        r ? e(r.primaryKey, r.value).next(function(e) {
                            e ? r.continue() : n();
                        }) : n();
                    };
                });
            }
        },
        {
            key: "Wn",
            value: function Wn(e, t) {
                var n = [];
                return new PersistencePromise(function(r, i) {
                    e.onerror = function(e) {
                        i(e.target.error);
                    }, e.onsuccess = function(e) {
                        var i = e.target.result;
                        if (!i) return void r();
                        var s = new __PRIVATE_IterationController(i), _ = t(i.primaryKey, i.value, s);
                        if (_ instanceof PersistencePromise) {
                            var _$e = _.catch(function(e) {
                                return s.done(), PersistencePromise.reject(e);
                            });
                            n.push(_$e);
                        }
                        s.isDone ? r() : null === s.$n ? i.continue() : i.continue(s.$n);
                    };
                }).next(function() {
                    return PersistencePromise.waitFor(n);
                });
            }
        },
        {
            key: "options",
            value: function options(e, t) {
                var n;
                return void 0 !== e && ("string" == typeof e ? n = e : t = e), {
                    index: n,
                    range: t
                };
            }
        },
        {
            key: "cursor",
            value: function cursor(e) {
                var t = "next";
                if (e.reverse && (t = "prev"), e.index) {
                    var n = this.store.index(e.index);
                    return e.jn ? n.openKeyCursor(e.range, t) : n.openCursor(e.range, t);
                }
                return this.store.openCursor(e.range, t);
            }
        }
    ]);
    return __PRIVATE_SimpleDbStore;
}();
/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */ function __PRIVATE_wrapRequest(e) {
    return new PersistencePromise(function(t, n) {
        e.onsuccess = function(e) {
            var n = e.target.result;
            t(n);
        }, e.onerror = function(e) {
            var t = __PRIVATE_checkForAndReportiOSError(e.target.error);
            n(t);
        };
    });
}
// Guard so we only report the error once.
var yt = false;
function __PRIVATE_checkForAndReportiOSError(t) {
    var n = __PRIVATE_SimpleDb.xn((0, $hk14n.getUA)());
    if (n >= 12.2 && n < 13) {
        var n1 = "An internal error was encountered in the Indexed Database server";
        if (t.message.indexOf(n1) >= 0) {
            // Wrap error in a more descriptive one.
            var _$t = new e("internal", "IOS_INDEXEDDB_BUG1: IndexedDb has thrown '".concat(n1, "'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround."));
            return yt || (yt = true, // Throw a global exception outside of this promise chain, for the user to
            // potentially catch.
            setTimeout(function() {
                throw _$t;
            }, 0)), _$t;
        }
    }
    return t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var wt = "LruGarbageCollector", bt = 1048576;
function __PRIVATE_bufferEntryComparator(param, param1) {
    var _param = (0, $6ZpBv._)(param, 2), e = _param[0], t = _param[1], _param1 = (0, $6ZpBv._)(param1, 2), n = _param1[0], r = _param1[1];
    var i = __PRIVATE_primitiveComparator(e, n);
    return 0 === i ? __PRIVATE_primitiveComparator(t, r) : i;
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */ var __PRIVATE_RollingSequenceNumberBuffer = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_RollingSequenceNumberBuffer(e) {
        (0, $4QweW._)(this, __PRIVATE_RollingSequenceNumberBuffer);
        this.Yn = e, this.buffer = new SortedSet(__PRIVATE_bufferEntryComparator), this.Zn = 0;
    }
    (0, $6hK4i._)(__PRIVATE_RollingSequenceNumberBuffer, [
        {
            key: "Xn",
            value: function Xn() {
                return ++this.Zn;
            }
        },
        {
            key: "er",
            value: function er(e) {
                var t = [
                    e,
                    this.Xn()
                ];
                if (this.buffer.size < this.Yn) this.buffer = this.buffer.add(t);
                else {
                    var _$e = this.buffer.last();
                    __PRIVATE_bufferEntryComparator(t, _$e) < 0 && (this.buffer = this.buffer.delete(_$e).add(t));
                }
            }
        },
        {
            key: "maxValue",
            get: function get() {
                // Guaranteed to be non-empty. If we decide we are not collecting any
                // sequence numbers, nthSequenceNumber below short-circuits. If we have
                // decided that we are collecting n sequence numbers, it's because n is some
                // percentage of the existing sequence numbers. That means we should never
                // be in a situation where we are collecting sequence numbers but don't
                // actually have any.
                return this.buffer.last()[0];
            }
        }
    ]);
    return __PRIVATE_RollingSequenceNumberBuffer;
}();
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */ var __PRIVATE_LruScheduler = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_LruScheduler(e, t, n) {
        (0, $4QweW._)(this, __PRIVATE_LruScheduler);
        this.garbageCollector = e, this.asyncQueue = t, this.localStore = n, this.tr = null;
    }
    (0, $6hK4i._)(__PRIVATE_LruScheduler, [
        {
            key: "start",
            value: function start() {
                -1 !== this.garbageCollector.params.cacheSizeCollectionThreshold && this.nr(6e4);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.tr && (this.tr.cancel(), this.tr = null);
            }
        },
        {
            key: "started",
            get: function get() {
                return null !== this.tr;
            }
        },
        {
            key: "nr",
            value: function nr(e) {
                var _this = this;
                __PRIVATE_logDebug(wt, "Garbage collection scheduled in ".concat(e, "ms")), this.tr = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection" /* TimerId.LruGarbageCollection */ , e, function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                        var e, _tmp;
                        return (0, $gh3Df._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    this.tr = null;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        7
                                    ]);
                                    return [
                                        4,
                                        this.localStore.collectGarbage(this.garbageCollector)
                                    ];
                                case 2:
                                    _state.sent();
                                    return [
                                        3,
                                        7
                                    ];
                                case 3:
                                    e = _state.sent();
                                    if (!__PRIVATE_isIndexedDbTransactionError(e)) return [
                                        3,
                                        4
                                    ];
                                    _tmp = __PRIVATE_logDebug(wt, "Ignoring IndexedDB error during garbage collection: ", e);
                                    return [
                                        3,
                                        6
                                    ];
                                case 4:
                                    return [
                                        4,
                                        __PRIVATE_ignoreIfPrimaryLeaseLoss(e)
                                    ];
                                case 5:
                                    _tmp = _state.sent();
                                    _state.label = 6;
                                case 6:
                                    _tmp;
                                    return [
                                        3,
                                        7
                                    ];
                                case 7:
                                    return [
                                        4,
                                        this.nr(3e5)
                                    ];
                                case 8:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    }).call(_this);
                });
            }
        }
    ]);
    return __PRIVATE_LruScheduler;
}();
/**
 * Implements the steps for LRU garbage collection.
 */ var __PRIVATE_LruGarbageCollectorImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_LruGarbageCollectorImpl(e, t) {
        (0, $4QweW._)(this, __PRIVATE_LruGarbageCollectorImpl);
        this.rr = e, this.params = t;
    }
    (0, $6hK4i._)(__PRIVATE_LruGarbageCollectorImpl, [
        {
            key: "calculateTargetCount",
            value: function calculateTargetCount(e, t) {
                return this.rr.ir(e).next(function(e) {
                    return Math.floor(t / 100 * e);
                });
            }
        },
        {
            key: "nthSequenceNumber",
            value: function nthSequenceNumber(e, t) {
                var _this = this;
                if (0 === t) return PersistencePromise.resolve(__PRIVATE_ListenSequence.wn);
                var n = new __PRIVATE_RollingSequenceNumberBuffer(t);
                return this.rr.forEachTarget(e, function(e) {
                    return n.er(e.sequenceNumber);
                }).next(function() {
                    return _this.rr.sr(e, function(e) {
                        return n.er(e);
                    });
                }).next(function() {
                    return n.maxValue;
                });
            }
        },
        {
            key: "removeTargets",
            value: function removeTargets(e, t, n) {
                return this.rr.removeTargets(e, t, n);
            }
        },
        {
            key: "removeOrphanedDocuments",
            value: function removeOrphanedDocuments(e, t) {
                return this.rr.removeOrphanedDocuments(e, t);
            }
        },
        {
            key: "collect",
            value: function collect(e, t) {
                var _this = this;
                return -1 === this.params.cacheSizeCollectionThreshold ? (__PRIVATE_logDebug("LruGarbageCollector", "Garbage collection skipped; disabled"), PersistencePromise.resolve(ft)) : this.getCacheSize(e).next(function(n) {
                    return n < _this.params.cacheSizeCollectionThreshold ? (__PRIVATE_logDebug("LruGarbageCollector", "Garbage collection skipped; Cache size ".concat(n, " is lower than threshold ").concat(_this.params.cacheSizeCollectionThreshold)), ft) : _this._r(e, t);
                });
            }
        },
        {
            key: "getCacheSize",
            value: function getCacheSize(e) {
                return this.rr.getCacheSize(e);
            }
        },
        {
            key: "_r",
            value: function _r(e, t) {
                var _this = this;
                var n, r, i, s, _, o, a;
                var u = Date.now();
                return this.calculateTargetCount(e, this.params.percentileToCollect).next(function(t) {
                    return(// Cap at the configured max
                    t > _this.params.maximumSequenceNumbersToCollect ? (__PRIVATE_logDebug("LruGarbageCollector", "Capping sequence numbers to collect down to the maximum of ".concat(_this.params.maximumSequenceNumbersToCollect, " from ").concat(t)), r = _this.params.maximumSequenceNumbersToCollect) : r = t, s = Date.now(), _this.nthSequenceNumber(e, r));
                }).next(function(r) {
                    return n = r, _ = Date.now(), _this.removeTargets(e, n, t);
                }).next(function(t) {
                    return i = t, o = Date.now(), _this.removeOrphanedDocuments(e, n);
                }).next(function(e) {
                    if (a = Date.now(), __PRIVATE_getLogLevel() <= (0, $5eJAc.LogLevel).DEBUG) __PRIVATE_logDebug("LruGarbageCollector", "LRU Garbage Collection\n	Counted targets in ".concat(s - u, "ms\n	Determined least recently used ").concat(r, " in ") + (_ - s) + "ms\n" + "	Removed ".concat(i, " targets in ") + (o - _) + "ms\n" + "	Removed ".concat(e, " documents in ") + (a - o) + "ms\n" + "Total Duration: ".concat(a - u, "ms"));
                    return PersistencePromise.resolve({
                        didRun: true,
                        sequenceNumbersCollected: r,
                        targetsRemoved: i,
                        documentsRemoved: e
                    });
                });
            }
        }
    ]);
    return __PRIVATE_LruGarbageCollectorImpl;
}();
function __PRIVATE_newLruGarbageCollector(e, t) {
    return new __PRIVATE_LruGarbageCollectorImpl(e, t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // settings() defaults:
var St = "firestore.googleapis.com", vt = true;
/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied `FirestoreSettings` object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */ var FirestoreSettingsImpl = /*#__PURE__*/ function() {
    "use strict";
    function FirestoreSettingsImpl(t) {
        (0, $4QweW._)(this, FirestoreSettingsImpl);
        var _t_ssl;
        if (void 0 === t.host) {
            if (void 0 !== t.ssl) throw new e(ta.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            this.host = St, this.ssl = vt;
        } else this.host = t.host, this.ssl = (_t_ssl = t.ssl) !== null && _t_ssl !== void 0 ? _t_ssl : vt;
        if (this.isUsingEmulator = void 0 !== t.emulatorOptions, this.credentials = t.credentials, this.ignoreUndefinedProperties = !!t.ignoreUndefinedProperties, this.localCache = t.localCache, t._customHeaders && (this._customHeaders = (0, $kWfK0._)({}, t._customHeaders)), void 0 === t.cacheSizeBytes) this.cacheSizeBytes = mt;
        else {
            if (-1 !== t.cacheSizeBytes && t.cacheSizeBytes < bt) throw new e(ta.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
            this.cacheSizeBytes = t.cacheSizeBytes;
        }
        var _t_experimentalLongPollingOptions;
        if (__PRIVATE_validateIsNotUsedTogether("experimentalForceLongPolling", t.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", t.experimentalAutoDetectLongPolling), this.experimentalForceLongPolling = !!t.experimentalForceLongPolling, this.experimentalForceLongPolling ? this.experimentalAutoDetectLongPolling = false : void 0 === t.experimentalAutoDetectLongPolling ? this.experimentalAutoDetectLongPolling = true : // For backwards compatibility, coerce the value to boolean even though
        // the TypeScript compiler has narrowed the type to boolean already.
        // noinspection PointlessBooleanExpressionJS
        this.experimentalAutoDetectLongPolling = !!t.experimentalAutoDetectLongPolling, this.experimentalLongPollingOptions = __PRIVATE_cloneLongPollingOptions((_t_experimentalLongPollingOptions = t.experimentalLongPollingOptions) !== null && _t_experimentalLongPollingOptions !== void 0 ? _t_experimentalLongPollingOptions : {}), function __PRIVATE_validateLongPollingOptions(t) {
            if (void 0 !== t.timeoutSeconds) {
                if (isNaN(t.timeoutSeconds)) throw new e(ta.INVALID_ARGUMENT, "invalid long polling timeout: ".concat(t.timeoutSeconds, " (must not be NaN)"));
                if (t.timeoutSeconds < 5) throw new e(ta.INVALID_ARGUMENT, "invalid long polling timeout: ".concat(t.timeoutSeconds, " (minimum allowed value is 5)"));
                if (t.timeoutSeconds > 30) throw new e(ta.INVALID_ARGUMENT, "invalid long polling timeout: ".concat(t.timeoutSeconds, " (maximum allowed value is 30)"));
            }
        }(this.experimentalLongPollingOptions), this.useFetchStreams = !!t.useFetchStreams, void 0 !== t.grpcFlowControlWindow) {
            if ("number" != typeof t.grpcFlowControlWindow || t.grpcFlowControlWindow <= 0 || t.grpcFlowControlWindow > 2147483647 || !Number.isInteger(t.grpcFlowControlWindow)) throw new e(ta.INVALID_ARGUMENT, "grpcFlowControlWindow must be a positive integer and cannot exceed 2147483647");
            this.grpcFlowControlWindow = t.grpcFlowControlWindow;
        }
    }
    (0, $6hK4i._)(FirestoreSettingsImpl, [
        {
            key: "isEqual",
            value: function isEqual(e) {
                return this.host === e.host && this.ssl === e.ssl && this.credentials === e.credentials && this.cacheSizeBytes === e.cacheSizeBytes && this.experimentalForceLongPolling === e.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === e.experimentalAutoDetectLongPolling && /**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two `ExperimentalLongPollingOptions` objects for equality.
 */ function __PRIVATE_longPollingOptionsEqual(e, t) {
                    return e.timeoutSeconds === t.timeoutSeconds;
                }(this.experimentalLongPollingOptions, e.experimentalLongPollingOptions) && this.ignoreUndefinedProperties === e.ignoreUndefinedProperties && this.useFetchStreams === e.useFetchStreams && this.grpcFlowControlWindow === e.grpcFlowControlWindow && function __PRIVATE_customHeadersEqual(e, t) {
                    if (e === t) return true;
                    if (!e || !t) return false;
                    var n = Object.keys(e), r = Object.keys(t);
                    if (n.length !== r.length) return false;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var r1 = _step.value;
                            if (e[r1] !== t[r1]) return false;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return true;
                }(this._customHeaders, e._customHeaders);
            }
        }
    ]);
    return FirestoreSettingsImpl;
}();
var Dt = /*#__PURE__*/ function() {
    "use strict";
    function Firestore(e, t, n, r) {
        (0, $4QweW._)(this, Firestore);
        this._authCredentials = e, this._appCheckCredentials = t, this._databaseId = n, this._app = r, /**
         * Whether it's a Firestore or Firestore Lite instance.
         */ this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new FirestoreSettingsImpl({}), this._settingsFrozen = false, this._emulatorOptions = {}, // A task that is assigned when the terminate() is invoked and resolved when
        // all components have shut down. Otherwise, Firestore is not terminated,
        // which can mean either the FirestoreClient is in the process of starting,
        // or restarting.
        this._terminateTask = "notTerminated";
    }
    (0, $6hK4i._)(Firestore, [
        {
            key: "app",
            get: /**
     * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
     * instance.
     */ function get() {
                if (!this._app) throw new e(ta.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
                return this._app;
            }
        },
        {
            key: "_initialized",
            get: function get() {
                return this._settingsFrozen;
            }
        },
        {
            key: "_terminated",
            get: function get() {
                return "notTerminated" !== this._terminateTask;
            }
        },
        {
            key: "_setSettings",
            value: function _setSettings(t) {
                if (this._settingsFrozen) throw new e(ta.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
                this._settings = new FirestoreSettingsImpl(t), this._emulatorOptions = t.emulatorOptions || {}, void 0 !== t.credentials && (this._authCredentials = function __PRIVATE_makeAuthCredentialsProvider(t) {
                    if (!t) return new __PRIVATE_EmptyAuthCredentialsProvider;
                    switch(t.type){
                        case "firstParty":
                            return new __PRIVATE_FirstPartyAuthCredentialsProvider(t.sessionIndex || "0", t.iamToken || null, t.authTokenFactory || null);
                        case "provider":
                            return t.client;
                        default:
                            throw new e(ta.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
                    }
                }(t.credentials));
            }
        },
        {
            key: "_getSettings",
            value: function _getSettings() {
                return this._settings;
            }
        },
        {
            key: "_getEmulatorOptions",
            value: function _getEmulatorOptions() {
                return this._emulatorOptions;
            }
        },
        {
            key: "_freezeSettings",
            value: function _freezeSettings() {
                return this._settingsFrozen = true, this._settings;
            }
        },
        {
            key: "_delete",
            value: function _delete() {
                // The `_terminateTask` must be assigned future that completes when
                // terminate is complete. The existence of this future puts SDK in state
                // that will not accept further API interaction.
                return "notTerminated" === this._terminateTask && (this._terminateTask = this._terminate()), this._terminateTask;
            }
        },
        {
            key: "_restart",
            value: function _restart() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _tmp;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!// The `_terminateTask` must equal 'notTerminated' after restart to
                                // signal that client is in a state that accepts API calls.
                                ("notTerminated" === this._terminateTask)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this._terminate()
                                ];
                            case 1:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                _tmp = this._terminateTask = "notTerminated";
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /** Returns a JSON-serializable representation of this `Firestore` instance. */ key: "toJSON",
            value: function toJSON() {
                return {
                    app: this._app,
                    databaseId: this._databaseId,
                    settings: this._settings
                };
            }
        },
        {
            /**
     * Terminates all components used by this client. Subclasses can override
     * this method to clean up their own dependencies, but must also call this
     * method.
     *
     * Only ever called once.
     */ key: "_terminate",
            value: function _terminate() {
                /**
 * Removes all components associated with the provided instance. Must be called
 * when the `Firestore` instance is terminated.
 */ return function __PRIVATE_removeComponents(e) {
                    var t = dt.get(e);
                    t && (__PRIVATE_logDebug(Vt, "Removing Datastore"), dt.delete(e), t.terminate());
                }(this), Promise.resolve();
            }
        }
    ]);
    return Firestore;
}();
/**
 * Modify this instance to communicate with the Cloud Firestore emulator.
 *
 * Note: This must be called before this instance has been used to do any
 * operations.
 *
 * @param firestore - The `Firestore` instance to configure to connect to the
 * emulator.
 * @param host - the emulator host (ex: localhost).
 * @param port - the emulator port (ex: 9000).
 * @param options.mockUserToken - the mock auth token to use for unit testing
 * Security Rules.
 */ function connectFirestoreEmulator(t, n, r) {
    var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    t = ra(t, Dt);
    var s = (0, $hk14n.isCloudWorkstation)(n), _ = t._getSettings(), o = (0, $hApvp._)((0, $kWfK0._)({}, _), {
        emulatorOptions: t._getEmulatorOptions()
    }), a = "".concat(n, ":").concat(r);
    s && (0, $hk14n.pingServer)("https://".concat(a)), _.host !== St && _.host !== a && __PRIVATE_logWarn("Host has been set in both settings() and connectFirestoreEmulator(), emulator host will be used.");
    var u = (0, $hApvp._)((0, $kWfK0._)({}, _), {
        host: a,
        ssl: s,
        emulatorOptions: i
    });
    // No-op if the new configuration matches the current configuration. This supports SSR
    // enviornments which might call `connectFirestoreEmulator` multiple times as a standard practice.
    if (!(0, $hk14n.deepEqual)(u, o) && (t._setSettings(u), i.mockUserToken)) {
        var _$n, _$r;
        if ("string" == typeof i.mockUserToken) _$n = i.mockUserToken, _$r = User.MOCK_USER;
        else {
            var _t__app;
            // Let createMockUserToken validate first (catches common mistakes like
            // invalid field "uid" and missing field "sub" / "user_id".)
            _$n = (0, $hk14n.createMockUserToken)(i.mockUserToken, (_t__app = t._app) === null || _t__app === void 0 ? void 0 : _t__app.options.projectId);
            var s1 = i.mockUserToken.sub || i.mockUserToken.user_id;
            if (!s1) throw new e(ta.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
            _$r = new User(s1);
        }
        t._authCredentials = new __PRIVATE_EmulatorAuthCredentialsProvider(new __PRIVATE_OAuthToken(_$n, _$r));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `Query` refers to a query which you can read or listen to. You can also
 * construct refined `Query` objects by adding filters and ordering.
 */ var Query = /*#__PURE__*/ function() {
    "use strict";
    function Query(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n) {
        (0, $4QweW._)(this, Query);
        this.converter = t, this._query = n, /** The type of this Firestore reference. */ this.type = "query", this.firestore = e;
    }
    (0, $6hK4i._)(Query, [
        {
            key: "withConverter",
            value: function withConverter(e) {
                return new Query(this.firestore, e, this._query);
            }
        }
    ]);
    return Query;
}();
/**
 * A `DocumentReference` refers to a document location in a Firestore database
 * and can be used to write, read, or listen to the location. The document at
 * the referenced location may or may not exist.
 */ var aa = /*#__PURE__*/ function() {
    "use strict";
    function aa(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n) {
        (0, $4QweW._)(this, aa);
        this.converter = t, this._key = n, /** The type of this Firestore reference. */ this.type = "document", this.firestore = e;
    }
    (0, $6hK4i._)(aa, [
        {
            key: "_path",
            get: function get() {
                return this._key.path;
            }
        },
        {
            key: "id",
            get: /**
     * The document's identifier within its collection.
     */ function get() {
                return this._key.path.lastSegment();
            }
        },
        {
            key: "path",
            get: /**
     * A string representing the path of the referenced document (relative
     * to the root of the database).
     */ function get() {
                return this._key.path.canonicalString();
            }
        },
        {
            key: "parent",
            get: /**
     * The collection this `DocumentReference` belongs to.
     */ function get() {
                return new na(this.firestore, this.converter, this._key.path.popLast());
            }
        },
        {
            key: "withConverter",
            value: function withConverter(e) {
                return new aa(this.firestore, e, this._key);
            }
        },
        {
            /**
     * Returns a JSON-serializable representation of this `DocumentReference` instance.
     *
     * @returns a JSON representation of this object.
     */ key: "toJSON",
            value: function toJSON() {
                return {
                    type: aa._jsonSchemaVersion,
                    referencePath: this._key.toString()
                };
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function fromJSON(e, t, n) {
                if (__PRIVATE_validateJSON(t, aa._jsonSchema)) return new aa(e, n || null, new DocumentKey(ResourcePath.fromString(t.referencePath)));
            }
        }
    ]);
    return aa;
}();
aa._jsonSchemaVersion = "firestore/documentReference/1.0", aa._jsonSchema = {
    type: property("string", aa._jsonSchemaVersion),
    referencePath: property("string")
};
/**
 * A `CollectionReference` object can be used for adding documents, getting
 * document references, and querying for documents (using {@link (query:1)}).
 */ var na = /*#__PURE__*/ function(Query) {
    "use strict";
    (0, $c2MhV._)(na, Query);
    function na(e, t, n) {
        (0, $4QweW._)(this, na);
        var _this;
        _this = (0, $ehF45._)(this, na, [
            e,
            t,
            __PRIVATE_newQueryForPath(n)
        ]), _this._path = n, /** The type of this Firestore reference. */ _this.type = "collection";
        return _this;
    }
    (0, $6hK4i._)(na, [
        {
            key: "id",
            get: /** The collection's identifier. */ function get() {
                return this._query.path.lastSegment();
            }
        },
        {
            key: "path",
            get: /**
     * A string representing the path of the referenced collection (relative
     * to the root of the database).
     */ function get() {
                return this._query.path.canonicalString();
            }
        },
        {
            key: "parent",
            get: /**
     * A reference to the containing `DocumentReference` if this is a
     * subcollection. If this isn't a subcollection, the reference is null.
     */ function get() {
                var e = this._path.popLast();
                return e.isEmpty() ? null : new aa(this.firestore, /* converter= */ null, new DocumentKey(e));
            }
        },
        {
            key: "withConverter",
            value: function withConverter(e) {
                return new na(this.firestore, e, this._path);
            }
        }
    ]);
    return na;
}(Query);
function J(e) {
    return e instanceof na;
}
function collection(t, n) {
    for(var _len = arguments.length, r = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        r[_key - 2] = arguments[_key];
    }
    if (t = (0, $hk14n.getModularInstance)(t), __PRIVATE_validateNonEmptyArgument("collection", "path", n), t instanceof Dt) {
        var _ResourcePath;
        var e1 = (_ResourcePath = ResourcePath).fromString.apply(_ResourcePath, [
            n
        ].concat((0, $jlUaU._)(r)));
        return __PRIVATE_validateCollectionPath(e1), new na(t, /* converter= */ null, e1);
    }
    {
        var _ResourcePath1;
        if (!(t instanceof aa || t instanceof na)) throw new e(ta.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        var i = t._path.child((_ResourcePath1 = ResourcePath).fromString.apply(_ResourcePath1, [
            n
        ].concat((0, $jlUaU._)(r))));
        return __PRIVATE_validateCollectionPath(i), new na(t.firestore, /* converter= */ null, i);
    }
}
// TODO(firestorelite): Consider using ErrorFactory -
// https://github.com/firebase/firebase-js-sdk/blob/0131e1f/packages/util/src/errors.ts#L106
/**
 * Creates and returns a new `Query` instance that includes all documents in the
 * database that are contained in a collection or subcollection with the
 * given `collectionId`.
 *
 * @param firestore - A reference to the root `Firestore` instance.
 * @param collectionId - Identifies the collections to query over. Every
 * collection or subcollection with this ID as the last segment of its path
 * will be included. Cannot contain a slash.
 * @returns The created `Query`.
 */ function collectionGroup(t, n) {
    if (t = ra(t, Dt), __PRIVATE_validateNonEmptyArgument("collectionGroup", "collection id", n), n.indexOf("/") >= 0) throw new e(ta.INVALID_ARGUMENT, "Invalid collection ID '".concat(n, "' passed to function collectionGroup(). Collection IDs must not contain '/'."));
    return new Query(t, /* converter= */ null, function __PRIVATE_newQueryForCollectionGroup(e) {
        return new __PRIVATE_QueryImpl(ResourcePath.emptyPath(), e);
    }(n));
}
function doc(t, n) {
    for(var _len = arguments.length, r = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        r[_key - 2] = arguments[_key];
    }
    if (t = (0, $hk14n.getModularInstance)(t), // We allow omission of 'pathString' but explicitly prohibit passing in both
    // 'undefined' and 'null'.
    1 === arguments.length && (n = __PRIVATE_AutoId.newId()), __PRIVATE_validateNonEmptyArgument("doc", "path", n), t instanceof Dt) {
        var _ResourcePath;
        var e1 = (_ResourcePath = ResourcePath).fromString.apply(_ResourcePath, [
            n
        ].concat((0, $jlUaU._)(r)));
        return __PRIVATE_validateDocumentPath(e1), new aa(t, /* converter= */ null, new DocumentKey(e1));
    }
    {
        var _ResourcePath1;
        if (!(t instanceof aa || t instanceof na)) throw new e(ta.INVALID_ARGUMENT, "Expected first argument to doc() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        var i = t._path.child((_ResourcePath1 = ResourcePath).fromString.apply(_ResourcePath1, [
            n
        ].concat((0, $jlUaU._)(r))));
        return __PRIVATE_validateDocumentPath(i), new aa(t.firestore, t instanceof na ? t.converter : null, new DocumentKey(i));
    }
}
/**
 * Returns true if the provided references are equal.
 *
 * @param left - A reference to compare.
 * @param right - A reference to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function H(e, t) {
    return e = (0, $hk14n.getModularInstance)(e), t = (0, $hk14n.getModularInstance)(t), (e instanceof aa || e instanceof na) && (t instanceof aa || t instanceof na) && e.firestore === t.firestore && e.path === t.path && e.converter === t.converter;
}
/**
 * Returns true if the provided queries point to the same collection and apply
 * the same constraints.
 *
 * @param left - A `Query` to compare.
 * @param right - A `Query` to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function queryEqual(e, t) {
    return e = (0, $hk14n.getModularInstance)(e), t = (0, $hk14n.getModularInstance)(t), e instanceof Query && t instanceof Query && e.firestore === t.firestore && __PRIVATE_queryEquals(e._query, t._query) && e.converter === t.converter;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns true iff the array contains the value using strong equality.
 */ /**
 * Compares two array for equality using comparator. The method computes the
 * intersection and invokes `onAdd` for every element that is in `after` but not
 * `before`. `onRemove` is invoked for every element in `before` but missing
 * from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original array.
 * @param after - The elements to diff against the original array.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ /**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a vector type in Firestore documents.
 * Create an instance with <code>{@link vector}</code>.
 */ var n = /*#__PURE__*/ function() {
    "use strict";
    function n(e) {
        (0, $4QweW._)(this, n);
        // Making a copy of the parameter.
        this._values = (e || []).map(function(e) {
            return e;
        });
    }
    (0, $6hK4i._)(n, [
        {
            /**
     * Returns a copy of the raw number array form of the vector.
     */ key: "toArray",
            value: function toArray() {
                return this._values.map(function(e) {
                    return e;
                });
            }
        },
        {
            /**
     * Returns `true` if the two `VectorValue` values have the same raw number arrays, returns `false` otherwise.
     */ key: "isEqual",
            value: function isEqual(e) {
                /**
 * Verifies equality for an array of primitives.
 *
 * @private
 * @internal
 * @param left - Array of primitives.
 * @param right - Array of primitives.
 * @returns True if arrays are equal.
 */ return function __PRIVATE_isPrimitiveArrayEqual(e, t) {
                    if (e.length !== t.length) return false;
                    for(var _$n = 0; _$n < e.length; ++_$n)if (e[_$n] !== t[_$n]) return false;
                    return true;
                }(this._values, e._values);
            }
        },
        {
            /**
     * Returns a JSON-serializable representation of this `VectorValue` instance.
     *
     * @returns a JSON representation of this object.
     */ key: "toJSON",
            value: function toJSON() {
                return {
                    type: n._jsonSchemaVersion,
                    vectorValues: this._values
                };
            }
        }
    ], [
        {
            key: "fromJSON",
            value: /**
     * Builds a `VectorValue` instance from a JSON object created by {@link VectorValue.toJSON}.
     *
     * @param json - a JSON object represention of a `VectorValue` instance.
     * @returns an instance of {@link VectorValue} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ function fromJSON(t) {
                if (__PRIVATE_validateJSON(t, n._jsonSchema)) {
                    if (Array.isArray(t.vectorValues) && t.vectorValues.every(function(e) {
                        return "number" == typeof e;
                    })) return new n(t.vectorValues);
                    throw new e(ta.INVALID_ARGUMENT, "Expected 'vectorValues' field to be a number array");
                }
            }
        }
    ]);
    return n;
}();
n._jsonSchemaVersion = "firestore/vectorValue/1.0", n._jsonSchema = {
    type: property("string", n._jsonSchemaVersion),
    vectorValues: property("object")
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var xt = /^__.*__$/;
/** The result of parsing document data (e.g. for a setData call). */ var ParsedSetData = /*#__PURE__*/ function() {
    "use strict";
    function ParsedSetData(e, t, n) {
        (0, $4QweW._)(this, ParsedSetData);
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    (0, $6hK4i._)(ParsedSetData, [
        {
            key: "toMutation",
            value: function toMutation(e, t) {
                return null !== this.fieldMask ? new __PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms) : new __PRIVATE_SetMutation(e, this.data, t, this.fieldTransforms);
            }
        }
    ]);
    return ParsedSetData;
}();
/** The result of parsing "update" data (i.e. for an updateData call). */ var ParsedUpdateData = /*#__PURE__*/ function() {
    "use strict";
    function ParsedUpdateData(e, // The fieldMask does not include document transforms.
    t, n) {
        (0, $4QweW._)(this, ParsedUpdateData);
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    (0, $6hK4i._)(ParsedUpdateData, [
        {
            key: "toMutation",
            value: function toMutation(e, t) {
                return new __PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms);
            }
        }
    ]);
    return ParsedUpdateData;
}();
function __PRIVATE_isWrite(e) {
    switch(e){
        case 0 /* UserDataSource.Set */ :
        // fall through
        case 2 /* UserDataSource.MergeSet */ :
        // fall through
        case 1 /* UserDataSource.Update */ :
            return true;
        case 3 /* UserDataSource.Argument */ :
        case 4 /* UserDataSource.ArrayArgument */ :
            return false;
        default:
            throw l(40011, {
                dataSource: e
            });
    }
}
/** A "context" object passed around while parsing user data. */ var ParseContextImpl = /*#__PURE__*/ function() {
    "use strict";
    function ParseContextImpl(e, t, n, r, i, s) {
        (0, $4QweW._)(this, ParseContextImpl);
        this.settings = e, this.databaseId = t, this.serializer = n, this.ignoreUndefinedProperties = r, // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        void 0 === i && this.validatePath(), this.fieldTransforms = i || [], this.fieldMask = s || [];
    }
    (0, $6hK4i._)(ParseContextImpl, [
        {
            key: "path",
            get: function get() {
                return this.settings.path;
            }
        },
        {
            key: "dataSource",
            get: function get() {
                return this.settings.dataSource;
            }
        },
        {
            /** Returns a new context with the specified settings overwritten. */ key: "contextWith",
            value: function contextWith(e) {
                return new ParseContextImpl((0, $kWfK0._)({}, this.settings, e), this.databaseId, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
            }
        },
        {
            key: "childContextForField",
            value: function childContextForField(e) {
                var _this_path;
                var t = (_this_path = this.path) === null || _this_path === void 0 ? void 0 : _this_path.child(e), n = this.contextWith({
                    path: t,
                    arrayElement: false
                });
                return n.validatePathSegment(e), n;
            }
        },
        {
            key: "childContextForFieldPath",
            value: function childContextForFieldPath(e) {
                var _this_path;
                var t = (_this_path = this.path) === null || _this_path === void 0 ? void 0 : _this_path.child(e), n = this.contextWith({
                    path: t,
                    arrayElement: false
                });
                return n.validatePath(), n;
            }
        },
        {
            key: "childContextForArray",
            value: function childContextForArray(e) {
                // TODO(b/34871131): We don't support array paths right now; so make path
                // undefined.
                return this.contextWith({
                    path: void 0,
                    arrayElement: true
                });
            }
        },
        {
            key: "createError",
            value: function createError1(e) {
                return createError(e, this.settings.methodName, this.settings.hasConverter || false, this.path, this.settings.targetDoc);
            }
        },
        {
            /** Returns 'true' if 'fieldPath' was traversed when creating this context. */ key: "contains",
            value: function contains(e) {
                return void 0 !== this.fieldMask.find(function(t) {
                    return e.isPrefixOf(t);
                }) || void 0 !== this.fieldTransforms.find(function(t) {
                    return e.isPrefixOf(t.field);
                });
            }
        },
        {
            key: "validatePath",
            value: function validatePath() {
                // TODO(b/34871131): Remove null check once we have proper paths for fields
                // within arrays.
                if (this.path) for(var e = 0; e < this.path.length; e++)this.validatePathSegment(this.path.get(e));
            }
        },
        {
            key: "validatePathSegment",
            value: function validatePathSegment(e) {
                if (0 === e.length) throw this.createError("Document fields must not be empty");
                if (__PRIVATE_isWrite(this.dataSource) && xt.test(e)) throw this.createError('Document fields cannot begin and end with "__"');
            }
        }
    ]);
    return ParseContextImpl;
}();
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */ var UserDataReader = /*#__PURE__*/ function() {
    "use strict";
    function UserDataReader(e, t, n) {
        (0, $4QweW._)(this, UserDataReader);
        this.databaseId = e, this.ignoreUndefinedProperties = t, this.serializer = n || __PRIVATE_newSerializer(e);
    }
    (0, $6hK4i._)(UserDataReader, [
        {
            /** Creates a new top-level parse context. */ key: "createContext",
            value: function createContext(e, t, n) {
                var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
                return new ParseContextImpl({
                    dataSource: e,
                    methodName: t,
                    targetDoc: n,
                    path: Oe.emptyPath(),
                    arrayElement: false,
                    hasConverter: r
                }, this.databaseId, this.serializer, this.ignoreUndefinedProperties);
            }
        }
    ]);
    return UserDataReader;
}();
function la(e) {
    var t = e._freezeSettings(), n = __PRIVATE_newSerializer(e._databaseId);
    return new UserDataReader(e._databaseId, !!t.ignoreUndefinedProperties, n);
}
/** Parse document data from a set() call. */ function __PRIVATE_parseSetData(t, n, r, i, s) {
    var _ = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
    var o = t.createContext(_.merge || _.mergeFields ? 2 /* UserDataSource.MergeSet */  : 0 /* UserDataSource.Set */ , n, r, s);
    __PRIVATE_validatePlainObject("Data must be an object, but it was:", o, i);
    var a = __PRIVATE_parseObject(i, o);
    var u, c;
    if (_.merge) u = new FieldMask(o.fieldMask), c = o.fieldTransforms;
    else if (_.mergeFields) {
        var _$t = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _.mergeFields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _$i = _step.value;
                var _$s = K(n, _$i, r);
                if (!o.contains(_$s)) throw new e(ta.INVALID_ARGUMENT, "Field '".concat(_$s, "' is specified in your field mask but missing from your input data."));
                __PRIVATE_fieldMaskContains(_$t, _$s) || _$t.push(_$s);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        u = new FieldMask(_$t), c = o.fieldTransforms.filter(function(e) {
            return u.covers(e.field);
        });
    } else u = null, c = o.fieldTransforms;
    return new ParsedSetData(new ObjectValue(a), u, c);
}
var __PRIVATE_DeleteFieldValueImpl = /*#__PURE__*/ function(FieldValue) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_DeleteFieldValueImpl, FieldValue);
    function __PRIVATE_DeleteFieldValueImpl() {
        (0, $4QweW._)(this, __PRIVATE_DeleteFieldValueImpl);
        return (0, $ehF45._)(this, __PRIVATE_DeleteFieldValueImpl, arguments);
    }
    (0, $6hK4i._)(__PRIVATE_DeleteFieldValueImpl, [
        {
            key: "_toFieldTransform",
            value: function _toFieldTransform(e) {
                if (2 /* UserDataSource.MergeSet */  !== e.dataSource) throw 1 /* UserDataSource.Update */  === e.dataSource ? e.createError("".concat(this._methodName, "() can only appear at the top level of your update data")) : e.createError("".concat(this._methodName, "() cannot be used with set() unless you pass {merge:true}"));
                // No transform to add for a delete, but we need to add it to our
                // fieldMask so it gets deleted.
                return e.fieldMask.push(e.path), null;
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return e instanceof __PRIVATE_DeleteFieldValueImpl;
            }
        }
    ]);
    return __PRIVATE_DeleteFieldValueImpl;
}(FieldValue);
/**
 * Creates a child context for parsing SerializableFieldValues.
 *
 * This is different than calling `ParseContext.contextWith` because it keeps
 * the fieldTransforms and fieldMask separate.
 *
 * The created context has its `dataSource` set to `UserDataSource.Argument`.
 * Although these values are used with writes, any elements in these FieldValues
 * are not considered writes since they cannot contain any FieldValue sentinels,
 * etc.
 *
 * @param fieldValue - The sentinel FieldValue for which to create a child
 *     context.
 * @param context - The parent context.
 * @param arrayElement - Whether or not the FieldValue has an array.
 */ function __PRIVATE_createSentinelChildContext(e, t, n) {
    return new ParseContextImpl({
        dataSource: 3 /* UserDataSource.Argument */ ,
        targetDoc: t.settings.targetDoc,
        methodName: e._methodName,
        arrayElement: n
    }, t.databaseId, t.serializer, t.ignoreUndefinedProperties);
}
var __PRIVATE_ServerTimestampFieldValueImpl = /*#__PURE__*/ function(FieldValue) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_ServerTimestampFieldValueImpl, FieldValue);
    function __PRIVATE_ServerTimestampFieldValueImpl() {
        (0, $4QweW._)(this, __PRIVATE_ServerTimestampFieldValueImpl);
        return (0, $ehF45._)(this, __PRIVATE_ServerTimestampFieldValueImpl, arguments);
    }
    (0, $6hK4i._)(__PRIVATE_ServerTimestampFieldValueImpl, [
        {
            key: "_toFieldTransform",
            value: function _toFieldTransform(e) {
                return new FieldTransform(e.path, new __PRIVATE_ServerTimestampTransform);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return e instanceof __PRIVATE_ServerTimestampFieldValueImpl;
            }
        }
    ]);
    return __PRIVATE_ServerTimestampFieldValueImpl;
}(FieldValue);
var __PRIVATE_ArrayUnionFieldValueImpl = /*#__PURE__*/ function(FieldValue) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_ArrayUnionFieldValueImpl, FieldValue);
    function __PRIVATE_ArrayUnionFieldValueImpl(e, t) {
        (0, $4QweW._)(this, __PRIVATE_ArrayUnionFieldValueImpl);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_ArrayUnionFieldValueImpl, [
            e
        ]), _this.ar = t;
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_ArrayUnionFieldValueImpl, [
        {
            key: "_toFieldTransform",
            value: function _toFieldTransform(e) {
                var t = __PRIVATE_createSentinelChildContext(this, e, /*array=*/ true), n = this.ar.map(function(e) {
                    return __PRIVATE_parseData(e, t);
                }), r = new __PRIVATE_ArrayUnionTransformOperation(n);
                return new FieldTransform(e.path, r);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return e instanceof __PRIVATE_ArrayUnionFieldValueImpl && (0, $hk14n.deepEqual)(this.ar, e.ar);
            }
        }
    ]);
    return __PRIVATE_ArrayUnionFieldValueImpl;
}(FieldValue);
var __PRIVATE_ArrayRemoveFieldValueImpl = /*#__PURE__*/ function(FieldValue) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_ArrayRemoveFieldValueImpl, FieldValue);
    function __PRIVATE_ArrayRemoveFieldValueImpl(e, t) {
        (0, $4QweW._)(this, __PRIVATE_ArrayRemoveFieldValueImpl);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_ArrayRemoveFieldValueImpl, [
            e
        ]), _this.ar = t;
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_ArrayRemoveFieldValueImpl, [
        {
            key: "_toFieldTransform",
            value: function _toFieldTransform(e) {
                var t = __PRIVATE_createSentinelChildContext(this, e, /*array=*/ true), n = this.ar.map(function(e) {
                    return __PRIVATE_parseData(e, t);
                }), r = new __PRIVATE_ArrayRemoveTransformOperation(n);
                return new FieldTransform(e.path, r);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return e instanceof __PRIVATE_ArrayRemoveFieldValueImpl && (0, $hk14n.deepEqual)(this.ar, e.ar);
            }
        }
    ]);
    return __PRIVATE_ArrayRemoveFieldValueImpl;
}(FieldValue);
var __PRIVATE_NumericIncrementFieldValueImpl = /*#__PURE__*/ function(FieldValue) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_NumericIncrementFieldValueImpl, FieldValue);
    function __PRIVATE_NumericIncrementFieldValueImpl(e, t) {
        (0, $4QweW._)(this, __PRIVATE_NumericIncrementFieldValueImpl);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_NumericIncrementFieldValueImpl, [
            e
        ]), _this.ur = t;
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_NumericIncrementFieldValueImpl, [
        {
            key: "_toFieldTransform",
            value: function _toFieldTransform(e) {
                var t = new __PRIVATE_NumericIncrementTransformOperation(e.serializer, toNumber(e.serializer, this.ur));
                return new FieldTransform(e.path, t);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return e instanceof __PRIVATE_NumericIncrementFieldValueImpl && (this.ur === e.ur || Number.isNaN(this.ur) && Number.isNaN(e.ur));
            }
        }
    ]);
    return __PRIVATE_NumericIncrementFieldValueImpl;
}(FieldValue);
var __PRIVATE_NumericMinimumFieldValueImpl = /*#__PURE__*/ function(FieldValue) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_NumericMinimumFieldValueImpl, FieldValue);
    function __PRIVATE_NumericMinimumFieldValueImpl(e, t) {
        (0, $4QweW._)(this, __PRIVATE_NumericMinimumFieldValueImpl);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_NumericMinimumFieldValueImpl, [
            e
        ]), _this.ur = t;
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_NumericMinimumFieldValueImpl, [
        {
            key: "_toFieldTransform",
            value: function _toFieldTransform(e) {
                var t = new __PRIVATE_NumericMinimumTransformOperation(e.serializer, toNumber(e.serializer, this.ur));
                return new FieldTransform(e.path, t);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return e instanceof __PRIVATE_NumericMinimumFieldValueImpl && (this.ur === e.ur || Number.isNaN(this.ur) && Number.isNaN(e.ur));
            }
        }
    ]);
    return __PRIVATE_NumericMinimumFieldValueImpl;
}(FieldValue);
var __PRIVATE_NumericMaximumFieldValueImpl = /*#__PURE__*/ function(FieldValue) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_NumericMaximumFieldValueImpl, FieldValue);
    function __PRIVATE_NumericMaximumFieldValueImpl(e, t) {
        (0, $4QweW._)(this, __PRIVATE_NumericMaximumFieldValueImpl);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_NumericMaximumFieldValueImpl, [
            e
        ]), _this.ur = t;
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_NumericMaximumFieldValueImpl, [
        {
            key: "_toFieldTransform",
            value: function _toFieldTransform(e) {
                var t = new __PRIVATE_NumericMaximumTransformOperation(e.serializer, toNumber(e.serializer, this.ur));
                return new FieldTransform(e.path, t);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return e instanceof __PRIVATE_NumericMaximumFieldValueImpl && (this.ur === e.ur || Number.isNaN(this.ur) && Number.isNaN(e.ur));
            }
        }
    ]);
    return __PRIVATE_NumericMaximumFieldValueImpl;
}(FieldValue);
/** Parse update data from an update() call. */ function __PRIVATE_parseUpdateData(e, t, n, r) {
    var i = e.createContext(1 /* UserDataSource.Update */ , t, n);
    __PRIVATE_validatePlainObject("Data must be an object, but it was:", i, r);
    var s = [], _ = ObjectValue.empty();
    forEach(r, function(e, r) {
        var o = __PRIVATE_fieldPathFromDotSeparatedString(t, e, n);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        r = (0, $hk14n.getModularInstance)(r);
        var a = i.childContextForFieldPath(o);
        if (r instanceof __PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        s.push(o);
        else {
            var _$e = __PRIVATE_parseData(r, a);
            null != _$e && (s.push(o), _.set(o, _$e));
        }
    });
    var o = new FieldMask(s);
    return new ParsedUpdateData(_, o, i.fieldTransforms);
}
/** Parse update data from a list of field/value arguments. */ function __PRIVATE_parseUpdateVarargs(t, n, r, i, s, _) {
    var o = t.createContext(1 /* UserDataSource.Update */ , n, r), a = [
        K(n, i, r)
    ], u = [
        s
    ];
    if (_.length % 2 != 0) throw new e(ta.INVALID_ARGUMENT, "Function ".concat(n, "() needs to be called with an even number of arguments that alternate between field names and values."));
    for(var e1 = 0; e1 < _.length; e1 += 2)a.push(K(n, _[e1])), u.push(_[e1 + 1]);
    var c = [], l = ObjectValue.empty();
    // We iterate in reverse order to pick the last value for a field if the
    // user specified the field multiple times.
    for(var e2 = a.length - 1; e2 >= 0; --e2)if (!__PRIVATE_fieldMaskContains(c, a[e2])) {
        var _$t = a[e2];
        var _$n = u[e2];
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        _$n = (0, $hk14n.getModularInstance)(_$n);
        var _$r = o.childContextForFieldPath(_$t);
        if (_$n instanceof __PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        c.push(_$t);
        else {
            var e3 = __PRIVATE_parseData(_$n, _$r);
            null != e3 && (c.push(_$t), l.set(_$t, e3));
        }
    }
    var E = new FieldMask(c);
    return new ParsedUpdateData(l, E, o.fieldTransforms);
}
/**
 * Parse a "query value" (e.g. value in a where filter or a value in a cursor
 * bound).
 *
 * @param allowArrays - Whether the query value is an array that may directly
 * contain additional arrays (e.g. the operand of an `in` query).
 */ function __PRIVATE_parseQueryValue(e, t, n) {
    var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    return __PRIVATE_parseData(n, e.createContext(r ? 4 /* UserDataSource.ArrayArgument */  : 3 /* UserDataSource.Argument */ , t));
}
/**
 * Parses user data to Protobuf Values.
 *
 * @param input - Data to be parsed.
 * @param context - A context object representing the current path being parsed,
 * the source of the data being parsed, etc.
 * @returns The parsed value, or null if the value was a FieldValue sentinel
 * that should not be included in the resulting parsed data.
 */ function __PRIVATE_parseData(e, t, r) {
    if (__PRIVATE_looksLikeJsonObject(// Unwrap the API type from the Compat SDK. This will return the API type
    // from firestore-exp.
    e = (0, $hk14n.getModularInstance)(e))) return __PRIVATE_validatePlainObject("Unsupported field value:", t, e), __PRIVATE_parseObject(e, t);
    if (e instanceof FieldValue) // FieldValues usually parse into transforms (except deleteField())
    // in which case we do not want to include this field in our parsed data
    // (as doing so will overwrite the field directly prior to the transform
    // trying to transform it). So we don't add this location to
    // context.fieldMask and we return null as our parsing result.
    /**
 * "Parses" the provided FieldValueImpl, adding any necessary transforms to
 * context.fieldTransforms.
 */ return function __PRIVATE_parseSentinelFieldValue(e, t) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!__PRIVATE_isWrite(t.dataSource)) throw t.createError("".concat(e._methodName, "() can only be used with update() and set()"));
        if (!t.path) throw t.createError("".concat(e._methodName, "() is not currently supported inside arrays"));
        var n = e._toFieldTransform(t);
        n && t.fieldTransforms.push(n);
    }(e, t), null;
    if (void 0 === e && t.ignoreUndefinedProperties) // If the input is undefined it can never participate in the fieldMask, so
    // don't handle this below. If `ignoreUndefinedProperties` is false,
    // `parseScalarValue` will reject an undefined value.
    return null;
    if (// If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    t.path && t.fieldMask.push(t.path), e instanceof Array) {
        // TODO(b/34871131): Include the path containing the array in the error
        // message.
        // In the case of IN queries, the parsed data is an array (representing
        // the set of values to be included for the IN query) that may directly
        // contain additional arrays (each representing an individual field
        // value), so we disable this validation.
        if (t.settings.arrayElement && 4 /* UserDataSource.ArrayArgument */  !== t.dataSource) throw t.createError("Nested arrays are not supported");
        return function __PRIVATE_parseArray(e, t) {
            var n = [];
            var r = 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var i = _step.value;
                    var _$e = __PRIVATE_parseData(i, t.childContextForArray(r));
                    null == _$e && // Just include nulls in the array for fields being replaced with a
                    // sentinel.
                    (_$e = {
                        nullValue: "NULL_VALUE"
                    }), n.push(_$e), r++;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return {
                arrayValue: {
                    values: n
                }
            };
        }(e, t);
    }
    return function __PRIVATE_parseScalarValue(e, t, r) {
        if (null === (e = (0, $hk14n.getModularInstance)(e))) return {
            nullValue: "NULL_VALUE"
        };
        if ("number" == typeof e) return toNumber(t.serializer, e);
        if ("boolean" == typeof e) return {
            booleanValue: e
        };
        if ("string" == typeof e) return {
            stringValue: e
        };
        if (e instanceof Date) {
            var n1 = Timestamp.fromDate(e);
            return {
                timestampValue: toTimestamp(t.serializer, n1)
            };
        }
        if (e instanceof Timestamp) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            var n2 = new Timestamp(e.seconds, 1e3 * Math.floor(e.nanoseconds / 1e3));
            return {
                timestampValue: toTimestamp(t.serializer, n2)
            };
        }
        if (__PRIVATE_isTemporalInstant(e)) {
            var n3 = Timestamp.fromInstant(e), r1 = new Timestamp(n3.seconds, 1e3 * Math.floor(n3.nanoseconds / 1e3));
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            return {
                timestampValue: toTimestamp(t.serializer, r1)
            };
        }
        if (e instanceof GeoPoint) return {
            geoPointValue: {
                latitude: e.latitude,
                longitude: e.longitude
            }
        };
        if (e instanceof Bytes) return {
            bytesValue: __PRIVATE_toBytes(t.serializer, e._byteString)
        };
        if (e instanceof aa) {
            var n4 = t.databaseId, r2 = e.firestore._databaseId;
            if (!r2.isEqual(n4)) throw t.createError("Document reference is for database ".concat(r2.projectId, "/").concat(r2.database, " but should be for database ").concat(n4.projectId, "/").concat(n4.database));
            return {
                referenceValue: __PRIVATE_toResourceName(e.firestore._databaseId || t.databaseId, e._key.path)
            };
        }
        if (e instanceof n) /**
 * Creates a new VectorValue proto value (using the internal format).
 */ return function __PRIVATE_parseVectorValue(e, t) {
            var _obj;
            var r = e instanceof n ? e.toArray() : e, i = {
                fields: (_obj = {}, (0, $6tY97._)(_obj, Qe, {
                    stringValue: ze
                }), (0, $6tY97._)(_obj, je, {
                    arrayValue: {
                        values: r.map(function(e) {
                            if ("number" != typeof e) throw t.createError("VectorValues must only contain numeric values.");
                            return __PRIVATE_toDouble(t.serializer, e);
                        })
                    }
                }), _obj)
            };
            return {
                mapValue: i
            };
        }(e, t);
        if (__PRIVATE_isProtoValueSerializable(e)) return e._toProto(t.serializer);
        throw t.createError("Unsupported field value: ".concat(__PRIVATE_valueDescription(e)));
    }(e, t);
}
function __PRIVATE_parseObject(e, t) {
    var n = {};
    return isEmpty(e) ? // If we encounter an empty object, we explicitly add it to the update
    // mask to ensure that the server creates a map entry.
    t.path && t.path.length > 0 && t.fieldMask.push(t.path) : forEach(e, function(e, r) {
        var i = __PRIVATE_parseData(r, t.childContextForField(e));
        null != i && (n[e] = i);
    }), {
        mapValue: {
            fields: n
        }
    };
}
function __PRIVATE_isTemporalInstant(e) {
    if ("object" != (typeof e === "undefined" ? "undefined" : (0, $5djcY._)(e)) || null === e) return false;
    if ("undefined" != typeof Temporal && "function" == typeof Temporal.Instant) {
        if (e instanceof Temporal.Instant) return true;
    }
    var t = e;
    return "Temporal.Instant" === t[Symbol.toStringTag] && "bigint" == (0, $5djcY._)(t.t);
}
function __PRIVATE_looksLikeJsonObject(e) {
    return !("object" != (typeof e === "undefined" ? "undefined" : (0, $5djcY._)(e)) || null === e || e instanceof Array || e instanceof Date || e instanceof Timestamp || e instanceof GeoPoint || e instanceof Bytes || e instanceof aa || e instanceof FieldValue || e instanceof n || __PRIVATE_isTemporalInstant(e) || __PRIVATE_isProtoValueSerializable(e));
}
function __PRIVATE_validatePlainObject(e, t, n) {
    if (!__PRIVATE_looksLikeJsonObject(n) || !p(n)) {
        var r = __PRIVATE_valueDescription(n);
        throw "an object" === r ? t.createError(e + " a custom object") : t.createError(e + " " + r);
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */ function K(e, t, n) {
    if (// If required, replace the FieldPath Compat class with the firestore-exp
    // FieldPath.
    (t = (0, $hk14n.getModularInstance)(t)) instanceof FieldPath) return t._internalPath;
    if ("string" == typeof t) return __PRIVATE_fieldPathFromDotSeparatedString(e, t);
    throw createError("Field path arguments must be of type string or ", e, /* hasConverter= */ false, /* path= */ void 0, n);
}
/**
 * Matches any characters in a field path string that are reserved.
 */ var Ct = new RegExp("[~\\*/\\[\\]]");
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName - The publicly visible method name
 * @param path - The dot-separated string form of a field path which will be
 * split on dots.
 * @param targetDoc - The document against which the field path will be
 * evaluated.
 */ function __PRIVATE_fieldPathFromDotSeparatedString(e, t, n) {
    if (t.search(Ct) >= 0) throw createError("Invalid field path (".concat(t, "). Paths must not contain '~', '*', '/', '[', or ']'"), e, /* hasConverter= */ false, /* path= */ void 0, n);
    try {
        return (0, $2IRoN._)(FieldPath, (0, $jlUaU._)(t.split(".")))._internalPath;
    } catch (r) {
        throw createError("Invalid field path (".concat(t, "). Paths must not be empty, begin with '.', end with '.', or contain '..'"), e, /* hasConverter= */ false, /* path= */ void 0, n);
    }
}
function createError(t, n, r, i, s) {
    var _ = i && !i.isEmpty(), o = void 0 !== s;
    var a = "Function ".concat(n, "() called with invalid data");
    r && (a += " (via `toFirestore()`)"), a += ". ";
    var u = "";
    return (_ || o) && (u += " (found", _ && (u += " in field ".concat(i)), o && (u += " in document ".concat(s)), u += ")"), new e(ta.INVALID_ARGUMENT, a + t + u);
}
/** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */ function __PRIVATE_fieldMaskContains(e, t) {
    return e.some(function(e) {
        return e.isEqual(t);
    });
}
function __PRIVATE_isUserData(e) {
    return "function" == typeof e._readUserData;
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var OptionsUtil = /*#__PURE__*/ function() {
    "use strict";
    function OptionsUtil(e) {
        (0, $4QweW._)(this, OptionsUtil);
        this.optionDefinitions = e;
    }
    (0, $6hK4i._)(OptionsUtil, [
        {
            key: "_getKnownOptions",
            value: function _getKnownOptions(e, t) {
                var n = ObjectValue.empty();
                // SERIALIZE KNOWN OPTIONS
                for(var r in this.optionDefinitions)if (this.optionDefinitions.hasOwnProperty(r)) {
                    var i = this.optionDefinitions[r];
                    if (r in e) {
                        var s = e[r];
                        var _ = void 0;
                        var _$__PRIVATE_parseData;
                        if (i.nestedOptions && p(s)) _ = {
                            mapValue: {
                                fields: new OptionsUtil(i.nestedOptions).getOptionsProto(t, s)
                            }
                        };
                        else s && (_ = (_$__PRIVATE_parseData = __PRIVATE_parseData(s, t)) !== null && _$__PRIVATE_parseData !== void 0 ? _$__PRIVATE_parseData : void 0);
                        _ && n.set(Oe.fromServerFormat(i.serverName), _);
                    }
                }
                return n;
            }
        },
        {
            key: "getOptionsProto",
            value: function getOptionsProto(e, t, n) {
                var r = this._getKnownOptions(t, e);
                // APPLY OPTIONS OVERRIDES
                if (n) {
                    var _$t = new Map(__PRIVATE_mapToArray(n, function(t, n) {
                        return [
                            Oe.fromServerFormat(n),
                            void 0 !== t ? __PRIVATE_parseData(t, e) : null
                        ];
                    }));
                    r.setAll(_$t);
                }
                var _r_value_mapValue_fields;
                // Return MapValue from `result` or empty map value
                return (_r_value_mapValue_fields = r.value.mapValue.fields) !== null && _r_value_mapValue_fields !== void 0 ? _r_value_mapValue_fields : {};
            }
        }
    ]);
    return OptionsUtil;
}();
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint @typescript-eslint/no-explicit-any: 0 */ function u(e) {
    return "object" == (typeof e === "undefined" ? "undefined" : (0, $5djcY._)(e)) && null !== e && !!("nullValue" in e && (null === e.nullValue || "NULL_VALUE" === e.nullValue) || "booleanValue" in e && (null === e.booleanValue || "boolean" == typeof e.booleanValue) || "integerValue" in e && (null === e.integerValue || "number" == typeof e.integerValue || "string" == typeof e.integerValue) || "doubleValue" in e && (null === e.doubleValue || "number" == typeof e.doubleValue) || "timestampValue" in e && (null === e.timestampValue || function __PRIVATE_isITimestamp(e) {
        return "object" == (typeof e === "undefined" ? "undefined" : (0, $5djcY._)(e)) && null !== e && "seconds" in e && (null === e.seconds || "number" == typeof e.seconds || "string" == typeof e.seconds) && "nanos" in e && (null === e.nanos || "number" == typeof e.nanos);
    }(e.timestampValue)) || "stringValue" in e && (null === e.stringValue || "string" == typeof e.stringValue) || "bytesValue" in e && (null === e.bytesValue || e.bytesValue instanceof Uint8Array) || "referenceValue" in e && (null === e.referenceValue || "string" == typeof e.referenceValue) || "geoPointValue" in e && (null === e.geoPointValue || function __PRIVATE_isILatLng(e) {
        return "object" == (typeof e === "undefined" ? "undefined" : (0, $5djcY._)(e)) && null !== e && "latitude" in e && (null === e.latitude || "number" == typeof e.latitude) && "longitude" in e && (null === e.longitude || "number" == typeof e.longitude);
    }(e.geoPointValue)) || "arrayValue" in e && (null === e.arrayValue || function __PRIVATE_isIArrayValue(e) {
        return "object" == (typeof e === "undefined" ? "undefined" : (0, $5djcY._)(e)) && null !== e && !(!("values" in e) || null !== e.values && !Array.isArray(e.values));
    }(e.arrayValue)) || "mapValue" in e && (null === e.mapValue || function __PRIVATE_isIMapValue(e) {
        return "object" == (typeof e === "undefined" ? "undefined" : (0, $5djcY._)(e)) && null !== e && !(!("fields" in e) || null !== e.fields && !p(e.fields));
    }(e.mapValue)) || "fieldReferenceValue" in e && (null === e.fieldReferenceValue || "string" == typeof e.fieldReferenceValue) || "functionValue" in e && (null === e.functionValue || function __PRIVATE_isIFunction(e) {
        return "object" == (typeof e === "undefined" ? "undefined" : (0, $5djcY._)(e)) && null !== e && !(!("name" in e) || null !== e.name && "string" != typeof e.name || !("args" in e) || null !== e.args && !Array.isArray(e.args));
    }(e.functionValue)) || "pipelineValue" in e && (null === e.pipelineValue || function __PRIVATE_isIPipeline(e) {
        return "object" == (typeof e === "undefined" ? "undefined" : (0, $5djcY._)(e)) && null !== e && !(!("stages" in e) || null !== e.stages && !Array.isArray(e.stages));
    }(e.pipelineValue)));
// Check optional properties and their types
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a sentinel for use with {@link @firebase/firestore/lite#(updateDoc:1)} or
 * {@link @firebase/firestore/lite#(setDoc:1)} with `{merge: true}` to mark a field for deletion.
 */ function deleteField() {
    return new __PRIVATE_DeleteFieldValueImpl("deleteField");
}
/**
 * Returns a sentinel used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link @firebase/firestore/lite#(updateDoc:1)} to
 * include a server-generated timestamp in the written data.
 */ function serverTimestamp() {
    return new __PRIVATE_ServerTimestampFieldValueImpl("serverTimestamp");
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to union the given elements with any array
 * value that already exists on the server. Each specified element that doesn't
 * already exist in the array will be added to the end. If the field being
 * modified is not already an array it will be overwritten with an array
 * containing exactly the specified elements.
 *
 * @param elements - The elements to union into the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`.
 */ function arrayUnion() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new __PRIVATE_ArrayUnionFieldValueImpl("arrayUnion", e);
}
/**
 * Returns a special value that can be used with {@link (setDoc:1)} or {@link
 * updateDoc:1} that tells the server to remove the given elements from any
 * array value that already exists on the server. All instances of each element
 * specified will be removed from the array. If the field being modified is not
 * already an array it will be overwritten with an empty array.
 *
 * @param elements - The elements to remove from the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function arrayRemove() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new __PRIVATE_ArrayRemoveFieldValueImpl("arrayRemove", e);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to increment the field's current value by
 * the given value.
 *
 * If either the operand or the current field value uses floating point
 * precision, all arithmetic follows IEEE 754 semantics. If both values are
 * integers, values outside of JavaScript's safe number range
 * (`Number.MIN_SAFE_INTEGER` to `Number.MAX_SAFE_INTEGER`) are also subject to
 * precision loss. Furthermore, once processed by the Firestore backend, all
 * integer operations are capped between -2^63 and 2^63-1.
 *
 * If the current field value is not of type `number`, or if the field does not
 * yet exist, the transformation sets the field to the given value.
 *
 * @param n - The value to increment by.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function increment(e) {
    return new __PRIVATE_NumericIncrementFieldValueImpl("increment", e);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to set the field to the numeric minimum of the
 * field's current and the given value.
 *
 * @param n - The value to compare to the existing field value.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function minimum$1(e) {
    return new __PRIVATE_NumericMinimumFieldValueImpl("minimum", e);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to set the field to the numeric maximum of the
 * field's current and the given value.
 *
 * @param n - The value to compare to the existing field value.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function maximum$1(e) {
    return new __PRIVATE_NumericMaximumFieldValueImpl("maximum", e);
}
/**
 * Creates a new `VectorValue` constructed with a copy of the given array of numbers.
 *
 * @param values - Create a `VectorValue` instance with a copy of this array of numbers.
 *
 * @returns A new `VectorValue` constructed with a copy of the given array of numbers.
 */ function r(e) {
    return new n(e);
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts a value to an Expression, Returning either a Constant, MapFunction,
 * ArrayFunction, or the input itself (if it's already an expression).
 *
 * @private
 * @internal
 * @param value
 */ function __PRIVATE_valueToDefaultExpr(e) {
    var n;
    return e instanceof t ? e : (n = p(e) ? __PRIVATE__map(e) : e instanceof Array ? b(e) : m(e, void 0), n);
}
/**
 * Converts a value to an Expression, Returning either a Constant, MapFunction,
 * ArrayFunction, or the input itself (if it's already an expression).
 *
 * @private
 * @internal
 * @param value
 */ function __PRIVATE_vectorToExpr(e) {
    if (e instanceof t) return e;
    if (e instanceof n) return i(e);
    if (Array.isArray(e)) return i(r(e));
    throw new Error("Unsupported value: " + (typeof e === "undefined" ? "undefined" : (0, $5djcY._)(e)));
}
/**
 * Converts a value to an Expression, Returning either a Constant, MapFunction,
 * ArrayFunction, or the input itself (if it's already an expression).
 * If the input is a string, it is assumed to be a field name, and a
 * field(value) is returned.
 *
 * @private
 * @internal
 * @param value
 */ function __PRIVATE_fieldOrExpression(e) {
    if (__PRIVATE_isString$1(e)) return s(e);
    return __PRIVATE_valueToDefaultExpr(e);
}
/**
 *
 * Represents an expression that can be evaluated to a value within the execution of a {@link
 * @firebase/firestore/pipelines#Pipeline}.
 *
 * Expressions are the building blocks for creating complex queries and transformations in
 * Firestore pipelines. They can represent:
 *
 * - **Field references:** Access values from document fields.
 * - **Literals:** Represent constant values (strings, numbers, booleans).
 * - **Function calls:** Apply functions to one or more expressions.
 *
 * The `Expression` class provides a fluent API for building expressions. You can chain together
 * method calls to create complex expressions.
 */ var t = /*#__PURE__*/ function() {
    "use strict";
    function t() {
        (0, $4QweW._)(this, t);
        this._protoValueType = "ProtoValue";
    }
    (0, $6hK4i._)(t, [
        {
            /**
     * Creates an expression that adds this expression to another expression.
     *
     * @example
     * ```typescript
     * // Add the value of the 'quantity' field and the 'reserve' field.
     * field("quantity").add(field("reserve"));
     * ```
     *
     * @param second - The expression or literal to add to this expression.
     * @param others - Optional additional expressions or literals to add to this expression.
     * @returns A new `Expression` representing the addition operation.
     */ key: "add",
            value: function add(e) {
                return new y("add", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "add");
            }
        },
        {
            /**
     * Wraps the expression in a [BooleanExpression].
     *
     * @returns A [BooleanExpression] representing the same expression.
     */ key: "asBoolean",
            value: function asBoolean() {
                if (this instanceof BooleanExpression) return this;
                if (this instanceof Constant) return new __PRIVATE_BooleanConstant(this);
                if (this instanceof o) return new __PRIVATE_BooleanField(this);
                if (this instanceof y) return new __PRIVATE_BooleanFunctionExpression(this);
                throw new e("invalid-argument", "Conversion of type ".concat((0, $5djcY._)(this), " to BooleanExpression not supported."));
            }
        },
        {
            key: "subtract",
            value: function subtract(e) {
                return new y("subtract", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "subtract");
            }
        },
        {
            /**
     * Creates an expression that multiplies this expression by another expression.
     *
     * @example
     * ```typescript
     * // Multiply the 'quantity' field by the 'price' field
     * field("quantity").multiply(field("price"));
     * ```
     *
     * @param second - The second expression or literal to multiply by.
     * @param others - Optional additional expressions or literals to multiply by.
     * @returns A new `Expression` representing the multiplication operation.
     */ key: "multiply",
            value: function multiply(e) {
                return new y("multiply", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "multiply");
            }
        },
        {
            key: "divide",
            value: function divide(e) {
                return new y("divide", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "divide");
            }
        },
        {
            key: "mod",
            value: function mod(e) {
                return new y("mod", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "mod");
            }
        },
        {
            key: "equal",
            value: function equal(e) {
                return new y("equal", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "equal").asBoolean();
            }
        },
        {
            key: "notEqual",
            value: function notEqual(e) {
                return new y("not_equal", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "notEqual").asBoolean();
            }
        },
        {
            key: "lessThan",
            value: function lessThan(e) {
                return new y("less_than", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "lessThan").asBoolean();
            }
        },
        {
            key: "lessThanOrEqual",
            value: function lessThanOrEqual(e) {
                return new y("less_than_or_equal", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "lessThanOrEqual").asBoolean();
            }
        },
        {
            key: "greaterThan",
            value: function greaterThan(e) {
                return new y("greater_than", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "greaterThan").asBoolean();
            }
        },
        {
            key: "greaterThanOrEqual",
            value: function greaterThanOrEqual(e) {
                return new y("greater_than_or_equal", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "greaterThanOrEqual").asBoolean();
            }
        },
        {
            /**
     * Creates an expression that concatenates an array expression with one or more other arrays.
     *
     * @example
     * ```typescript
     * // Combine the 'items' array with another array field.
     * field("items").arrayConcat(field("otherItems"));
     * ```
     * @param secondArray - Second array expression or array literal to concatenate.
     * @param otherArrays - Optional additional array expressions or array literals to concatenate.
     * @returns A new `Expression` representing the concatenated array.
     */ key: "arrayConcat",
            value: function arrayConcat(e) {
                for(var _len = arguments.length, _$t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    _$t[_key - 1] = arguments[_key];
                }
                var n = [
                    e
                ].concat((0, $jlUaU._)(_$t)).map(function(e) {
                    return __PRIVATE_valueToDefaultExpr(e);
                });
                return new y("array_concat", [
                    this
                ].concat((0, $jlUaU._)(n)), "arrayConcat");
            }
        },
        {
            key: "arrayContains",
            value: function arrayContains(e) {
                return new y("array_contains", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "arrayContains").asBoolean();
            }
        },
        {
            key: "arrayContainsAll",
            value: function arrayContainsAll(e) {
                var _$t = Array.isArray(e) ? new __PRIVATE_ListOfExprs(e.map(__PRIVATE_valueToDefaultExpr), "arrayContainsAll") : e;
                return new y("array_contains_all", [
                    this,
                    _$t
                ], "arrayContainsAll").asBoolean();
            }
        },
        {
            key: "arrayContainsAny",
            value: function arrayContainsAny(e) {
                var _$t = Array.isArray(e) ? new __PRIVATE_ListOfExprs(e.map(__PRIVATE_valueToDefaultExpr), "arrayContainsAny") : e;
                return new y("array_contains_any", [
                    this,
                    _$t
                ], "arrayContainsAny").asBoolean();
            }
        },
        {
            /**
     * Creates an expression that reverses an array.
     *
     * @example
     * ```typescript
     * // Reverse the value of the 'myArray' field.
     * field("myArray").arrayReverse();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the reversed array.
     */ key: "arrayReverse",
            value: function arrayReverse() {
                return new y("array_reverse", [
                    this
                ]);
            }
        },
        {
            /**
     * Creates an expression that calculates the length of an array.
     *
     * @example
     * ```typescript
     * // Get the number of items in the 'cart' array
     * field("cart").arrayLength();
     * ```
     *
     * @returns A new `Expression` representing the length of the array.
     */ key: "arrayLength",
            value: function arrayLength() {
                return new y("array_length", [
                    this
                ], "arrayLength");
            }
        },
        {
            key: "equalAny",
            value: function equalAny(e) {
                var _$t = Array.isArray(e) ? new __PRIVATE_ListOfExprs(e.map(__PRIVATE_valueToDefaultExpr), "equalAny") : e;
                return new y("equal_any", [
                    this,
                    _$t
                ], "equalAny").asBoolean();
            }
        },
        {
            key: "notEqualAny",
            value: function notEqualAny(e) {
                var _$t = Array.isArray(e) ? new __PRIVATE_ListOfExprs(e.map(__PRIVATE_valueToDefaultExpr), "notEqualAny") : e;
                return new y("not_equal_any", [
                    this,
                    _$t
                ], "notEqualAny").asBoolean();
            }
        },
        {
            /**
     * Creates an expression that checks if a field exists in the document.
     *
     * @example
     * ```typescript
     * // Check if the document has a field named "phoneNumber"
     * field("phoneNumber").exists();
     * ```
     *
     * @returns A new `Expression` representing the 'exists' check.
     */ key: "exists",
            value: function exists() {
                return new y("exists", [
                    this
                ], "exists").asBoolean();
            }
        },
        {
            /**
     * Creates an expression that calculates the character length of a string in UTF-8.
     *
     * @example
     * ```typescript
     * // Get the character length of the 'name' field in its UTF-8 form.
     * field("name").charLength();
     * ```
     *
     * @returns A new `Expression` representing the length of the string.
     */ key: "charLength",
            value: function charLength() {
                return new y("char_length", [
                    this
                ], "charLength");
            }
        },
        {
            key: "like",
            value: function like(e) {
                return new y("like", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "like").asBoolean();
            }
        },
        {
            key: "regexContains",
            value: function regexContains(e) {
                return new y("regex_contains", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "regexContains").asBoolean();
            }
        },
        {
            key: "regexFind",
            value: function regexFind(e) {
                return new y("regex_find", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "regexFind");
            }
        },
        {
            key: "regexFindAll",
            value: function regexFindAll(e) {
                return new y("regex_find_all", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "regexFindAll");
            }
        },
        {
            key: "regexMatch",
            value: function regexMatch(e) {
                return new y("regex_match", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "regexMatch").asBoolean();
            }
        },
        {
            key: "stringContains",
            value: function stringContains(e) {
                return new y("string_contains", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "stringContains").asBoolean();
            }
        },
        {
            key: "startsWith",
            value: function startsWith(e) {
                return new y("starts_with", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "startsWith").asBoolean();
            }
        },
        {
            key: "endsWith",
            value: function endsWith(e) {
                return new y("ends_with", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "endsWith").asBoolean();
            }
        },
        {
            /**
     * Creates an expression that converts a string to lowercase.
     *
     * @example
     * ```typescript
     * // Convert the 'name' field to lowercase
     * field("name").toLower();
     * ```
     *
     * @returns A new `Expression` representing the lowercase string.
     */ key: "toLower",
            value: function toLower() {
                return new y("to_lower", [
                    this
                ], "toLower");
            }
        },
        {
            /**
     * Creates an expression that converts a string to uppercase.
     *
     * @example
     * ```typescript
     * // Convert the 'title' field to uppercase
     * field("title").toUpper();
     * ```
     *
     * @returns A new `Expression` representing the uppercase string.
     */ key: "toUpper",
            value: function toUpper() {
                return new y("to_upper", [
                    this
                ], "toUpper");
            }
        },
        {
            /**
     * Creates an expression that removes leading and trailing characters from a string or byte array.
     *
     * @example
     * ```typescript
     * // Trim whitespace from the 'userInput' field
     * field("userInput").trim();
     *
     * // Trim quotes from the 'userInput' field
     * field("userInput").trim('"');
     * ```
     * @param valueToTrim - Optional This parameter is treated as a set of characters or bytes that will be
     * trimmed from the input. If not specified, then whitespace will be trimmed.
     * @returns A new `Expression` representing the trimmed string or byte array.
     */ key: "trim",
            value: function trim(e) {
                var _$t = [
                    this
                ];
                return e && _$t.push(__PRIVATE_valueToDefaultExpr(e)), new y("trim", _$t, "trim");
            }
        },
        {
            /**
     * Trims whitespace or a specified set of characters/bytes from the beginning of a string or byte array.
     *
     * @example
     * ```typescript
     * // Trim whitespace from the beginning of the 'userInput' field
     * field("userInput").ltrim();
     *
     * // Trim quotes from the beginning of the 'userInput' field
     * field("userInput").ltrim('"');
     * ```
     *
     * @param valueToTrim - Optional. A string or byte array containing the characters/bytes to trim.
     * If not specified, whitespace will be trimmed.
     * @returns A new `Expression` representing the trimmed string.
     */ key: "ltrim",
            value: function ltrim(e) {
                var _$t = [
                    this
                ];
                return e && _$t.push(__PRIVATE_valueToDefaultExpr(e)), new y("ltrim", _$t, "ltrim");
            }
        },
        {
            /**
     * Trims whitespace or a specified set of characters/bytes from the end of a string or byte array.
     *
     * @example
     * ```typescript
     * // Trim whitespace from the end of the 'userInput' field
     * field("userInput").rtrim();
     *
     * // Trim quotes from the end of the 'userInput' field
     * field("userInput").rtrim('"');
     * ```
     *
     * @param valueToTrim - Optional. A string or byte array containing the characters/bytes to trim.
     * If not specified, whitespace will be trimmed.
     * @returns A new `Expression` representing the trimmed string or byte array.
     */ key: "rtrim",
            value: function rtrim(e) {
                var _$t = [
                    this
                ];
                return e && _$t.push(__PRIVATE_valueToDefaultExpr(e)), new y("rtrim", _$t, "rtrim");
            }
        },
        {
            /**
     * Creates an expression that returns the data type of this expression's result, as a string.
     *
     * @remarks
     * This is evaluated on the backend. This means:
     * 1. Generic typed elements (like `array<string>`) evaluate strictly to the primitive `'array'`.
     * 2. Any custom `FirestoreDataConverter` mappings are ignored.
     * 3. For numeric values, the backend does not yield the JavaScript `"number"` type; it evaluates
     *    precisely as `"int64"` or `"float64"`.
     * 4. For date or timestamp objects, the backend evaluates to `"timestamp"`.
     *
     * @example
     * ```typescript
     * // Get the data type of the value in field 'title'
     * field('title').type()
     * ```
     *
     * @returns A new `Expression` representing the data type.
     */ key: "type",
            value: function type() {
                return new y("type", [
                    this
                ]);
            }
        },
        {
            /**
     * Creates an expression that checks if the result of this expression is of the given type.
     *
     * @remarks Null or undefined fields evaluate to skip/error. Use `ifAbsent()` / `isAbsent()` to evaluate missing data.
     * Supported values for `type` are:
     * `'null'`, `'array'`, `'boolean'`, `'bytes'`, `'timestamp'`, `'geo_point'`, `'number'`,
     * `'int32'`, `'int64'`, `'float64'`, `'decimal128'`, `'map'`, `'reference'`, `'string'`,
     * `'vector'`, `'max_key'`, `'min_key'`, `'object_id'`, `'regex'`, `'request_timestamp'`.
     *
     * @example
     * ```typescript
     * // Check if the 'price' field is specifically an integer (not just 'number')
     * field('price').isType('int64');
     * ```
     *
     * @param type - The type to check for.
     * @returns A new `BooleanExpression` that evaluates to true if the expression's result is of the given type, false otherwise.
     */ key: "isType",
            value: function isType(e) {
                return new y("is_type", [
                    this,
                    i(e)
                ], "isType").asBoolean();
            }
        },
        {
            /**
     * Creates an expression that concatenates string expressions together.
     *
     * @example
     * ```typescript
     * // Combine the 'firstName', " ", and 'lastName' fields into a single string
     * field("firstName").stringConcat(constant(" "), field("lastName"));
     * ```
     *
     * @param secondString - The additional expression or string literal to concatenate.
     * @param otherStrings - Optional additional expressions or string literals to concatenate.
     * @returns A new `Expression` representing the concatenated string.
     */ key: "stringConcat",
            value: function stringConcat(e) {
                for(var _len = arguments.length, _$t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    _$t[_key - 1] = arguments[_key];
                }
                var n = [
                    e
                ].concat((0, $jlUaU._)(_$t)).map(__PRIVATE_valueToDefaultExpr);
                return new y("string_concat", [
                    this
                ].concat((0, $jlUaU._)(n)), "stringConcat");
            }
        },
        {
            /**
     * Creates an expression that finds the index of the first occurrence of a substring or byte sequence.
     *
     * @example
     * ```typescript
     * // Find the index of "foo" in the 'text' field
     * field("text").stringIndexOf("foo");
     * ```
     *
     * @param search - The substring or byte sequence to search for.
     * @returns A new `Expression` representing the index of the first occurrence.
     */ key: "stringIndexOf",
            value: function stringIndexOf(e) {
                return new y("string_index_of", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "stringIndexOf");
            }
        },
        {
            /**
     * Creates an expression that repeats a string or byte array a specified number of times.
     *
     * @example
     * ```typescript
     * // Repeat the 'label' field 3 times
     * field("label").stringRepeat(3);
     * ```
     *
     * @param repetitions - The number of times to repeat the string or byte array.
     * @returns A new `Expression` representing the repeated string or byte array.
     */ key: "stringRepeat",
            value: function stringRepeat(e) {
                return new y("string_repeat", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "stringRepeat");
            }
        },
        {
            /**
     * Creates an expression that replaces all occurrences of a substring or byte sequence with a replacement.
     *
     * @example
     * ```typescript
     * // Replace all occurrences of "foo" with "bar" in the 'text' field
     * field("text").stringReplaceAll("foo", "bar");
     * ```
     *
     * @param find - The substring or byte sequence to search for.
     * @param replacement - The replacement string or byte sequence.
     * @returns A new `Expression` representing the string or byte array with replacements.
     */ key: "stringReplaceAll",
            value: function stringReplaceAll(e, t) {
                return new y("string_replace_all", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e),
                    __PRIVATE_valueToDefaultExpr(t)
                ], "stringReplaceAll");
            }
        },
        {
            /**
     * Creates an expression that replaces the first occurrence of a substring or byte sequence with a replacement.
     *
     * @example
     * ```typescript
     * // Replace the first occurrence of "foo" with "bar" in the 'text' field
     * field("text").stringReplaceOne("foo", "bar");
     * ```
     *
     * @param find - The substring or byte sequence to search for.
     * @param replacement - The replacement string or byte sequence.
     * @returns A new `Expression` representing the string or byte array with the replacement.
     */ key: "stringReplaceOne",
            value: function stringReplaceOne(e, t) {
                return new y("string_replace_one", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e),
                    __PRIVATE_valueToDefaultExpr(t)
                ], "stringReplaceOne");
            }
        },
        {
            /**
     * Creates an expression that concatenates expression results together.
     *
     * @example
     * ```typescript
     * // Combine the 'firstName', ' ', and 'lastName' fields into a single value.
     * field("firstName").concat(constant(" "), field("lastName"));
     * ```
     *
     * @param second - The additional expression or literal to concatenate.
     * @param others - Optional additional expressions or literals to concatenate.
     * @returns A new `Expression` representing the concatenated value.
     */ key: "concat",
            value: function concat(e) {
                for(var _len = arguments.length, _$t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    _$t[_key - 1] = arguments[_key];
                }
                var n = [
                    e
                ].concat((0, $jlUaU._)(_$t)).map(__PRIVATE_valueToDefaultExpr);
                return new y("concat", [
                    this
                ].concat((0, $jlUaU._)(n)), "concat");
            }
        },
        {
            /**
     * Creates an expression that reverses this string expression.
     *
     * @example
     * ```typescript
     * // Reverse the value of the 'myString' field.
     * field("myString").reverse();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the reversed string.
     */ key: "reverse",
            value: function reverse() {
                return new y("reverse", [
                    this
                ], "reverse");
            }
        },
        {
            /**
     * Filters the array using a provided alias and predicate expression.
     *
     * @example
     * ```typescript
     * // Filter the 'items' array to only include those where the 'price' is greater than 10
     * field("items").arrayFilter('item', greaterThan(variable('item.price'), 10));
     * ```
     *
     * @param alias - The variable name to use for each element.
     * @param filter - The predicate boolean expression to filter by.
     * @returns A new `Expression` representing the filtered array.
     */ key: "arrayFilter",
            value: function arrayFilter(e, t) {
                return new y("array_filter", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e),
                    t
                ], "arrayFilter");
            }
        },
        {
            /**
     * Creates an expression that applies a provided transformation to each element in an array.
     *
     * @example
     * ```typescript
     * // Transform the 'scores' array by multiplying each score by 10
     * field("scores").arrayTransform("score", multiply(variable("score"), 10));
     * ```
     *
     * @param elementAlias - The variable name to use for each element.
     * @param transform - The lambda expression used to transform the elements.
     * @returns A new `Expression` representing the arrayTransform operation.
     */ key: "arrayTransform",
            value: function arrayTransform(e, t) {
                return new y("array_transform", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e),
                    t
                ], "arrayTransform");
            }
        },
        {
            /**
     * Creates an expression that applies a provided transformation to each element in an array, providing the element's index to the transformation expression.
     *
     * @example
     * ```typescript
     * // Transform the 'scores' array by adding the index to each score
     * field("scores").arrayTransformWithIndex("score", "i", add(variable("score"), variable("i")));
     * ```
     *
     * @param elementAlias - The variable name to use for each element.
     * @param indexAlias - The variable name to use for the current index.
     * @param transform - The lambda expression used to transform the elements.
     * @returns A new `Expression` representing the arrayTransformWithIndex operation.
     */ key: "arrayTransformWithIndex",
            value: function arrayTransformWithIndex(e, t, n) {
                return new y("array_transform", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e),
                    __PRIVATE_valueToDefaultExpr(t),
                    n
                ], "arrayTransformWithIndex");
            }
        },
        {
            /**
     * Returns a subset of the array.
     *
     * @example
     * ```typescript
     * // Get 5 elements from the 'items' array starting from index 2
     * field("items").arraySlice(2, 5);
     *
     * // Get n number of elements from the 'items' array starting from index 2
     * field("items").arraySlice(2, field("count"));
     * ```
     *
     * @param offset - The starting offset.
     * @param length - The optional length of the slice.
     * @returns A new `Expression` representing the sliced array.
     */ key: "arraySlice",
            value: function arraySlice(e, t) {
                var n = [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ];
                return void 0 !== t && n.push(__PRIVATE_valueToDefaultExpr(t)), new y("array_slice", n, "arraySlice");
            }
        },
        {
            /**
     * Returns the first element of the array.
     *
     * @example
     * ```typescript
     * // Get the first element of the 'myArray' field.
     * field("myArray").arrayFirst();
     * ```
     *
     * @returns A new `Expression` representing the first element.
     */ key: "arrayFirst",
            value: function arrayFirst() {
                return new y("array_first", [
                    this
                ], "arrayFirst");
            }
        },
        {
            key: "arrayFirstN",
            value: function arrayFirstN(e) {
                return new y("array_first_n", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "arrayFirstN");
            }
        },
        {
            /**
     * Returns the last element of the array.
     *
     * @example
     * ```typescript
     * // Get the last element of the 'myArray' field.
     * field("myArray").arrayLast();
     * ```
     *
     * @returns A new `Expression` representing the last element.
     */ key: "arrayLast",
            value: function arrayLast() {
                return new y("array_last", [
                    this
                ], "arrayLast");
            }
        },
        {
            key: "arrayLastN",
            value: function arrayLastN(e) {
                return new y("array_last_n", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "arrayLastN");
            }
        },
        {
            /**
     * Returns the maximum value in the array.
     *
     * @example
     * ```typescript
     * // Get the maximum value of the 'myArray' field.
     * field("myArray").arrayMaximum();
     * ```
     *
     * @returns A new `Expression` representing the maximum value.
     */ key: "arrayMaximum",
            value: function arrayMaximum() {
                return new y("maximum", [
                    this
                ], "arrayMaximum");
            }
        },
        {
            key: "arrayMaximumN",
            value: function arrayMaximumN(e) {
                return new y("maximum_n", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "arrayMaximumN");
            }
        },
        {
            /**
     * Returns the minimum value in the array.
     *
     * @example
     * ```typescript
     * // Get the minimum value of the 'myArray' field.
     * field("myArray").arrayMinimum();
     * ```
     *
     * @returns A new `Expression` representing the minimum value.
     */ key: "arrayMinimum",
            value: function arrayMinimum() {
                return new y("minimum", [
                    this
                ], "arrayMinimum");
            }
        },
        {
            key: "arrayMinimumN",
            value: function arrayMinimumN(e) {
                return new y("minimum_n", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "arrayMinimumN");
            }
        },
        {
            key: "arrayIndexOf",
            value: function arrayIndexOf(e) {
                return new y("array_index_of", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e),
                    __PRIVATE_valueToDefaultExpr("first")
                ], "arrayIndexOf");
            }
        },
        {
            key: "arrayLastIndexOf",
            value: function arrayLastIndexOf(e) {
                return new y("array_index_of", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e),
                    __PRIVATE_valueToDefaultExpr("last")
                ], "arrayLastIndexOf");
            }
        },
        {
            key: "arrayIndexOfAll",
            value: function arrayIndexOfAll(e) {
                return new y("array_index_of_all", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "arrayIndexOfAll");
            }
        },
        {
            /**
     * Creates an expression that calculates the length of this string expression in bytes.
     *
     * @example
     * ```typescript
     * // Calculate the length of the 'myString' field in bytes.
     * field("myString").byteLength();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the length of the string in bytes.
     */ key: "byteLength",
            value: function byteLength() {
                return new y("byte_length", [
                    this
                ], "byteLength");
            }
        },
        {
            /**
     * Creates an expression that computes the ceiling of a numeric value.
     *
     * @example
     * ```typescript
     * // Compute the ceiling of the 'price' field.
     * field("price").ceil();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the ceiling of the numeric value.
     */ key: "ceil",
            value: function ceil() {
                return new y("ceil", [
                    this
                ]);
            }
        },
        {
            /**
     * Creates an expression that computes the floor of a numeric value.
     *
     * @example
     * ```typescript
     * // Compute the floor of the 'price' field.
     * field("price").floor();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the floor of the numeric value.
     */ key: "floor",
            value: function floor() {
                return new y("floor", [
                    this
                ]);
            }
        },
        {
            /**
     * Creates an expression that computes the absolute value of a numeric value.
     *
     * @example
     * ```typescript
     * // Compute the absolute value of the 'price' field.
     * field("price").abs();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the absolute value of the numeric value.
     */ key: "abs",
            value: function abs() {
                return new y("abs", [
                    this
                ]);
            }
        },
        {
            /**
     * Creates an expression that computes e to the power of this expression.
     *
     * @example
     * ```typescript
     * // Compute e to the power of the 'value' field.
     * field("value").exp();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the exp of the numeric value.
     */ key: "exp",
            value: function exp() {
                return new y("exp", [
                    this
                ]);
            }
        },
        {
            /**
     * Accesses a value from a map (object) field using the provided key.
     *
     * @example
     * ```typescript
     * // Get the 'city' value from the 'address' map field
     * field("address").mapGet("city");
     * ```
     *
     * @param subfield - The key to access in the map.
     * @returns A new `Expression` representing the value associated with the given key in the map.
     */ key: "mapGet",
            value: function mapGet(e) {
                return new y("map_get", [
                    this,
                    i(e)
                ], "mapGet");
            }
        },
        {
            /**
     * Creates an expression that returns a new map with the specified entries added or updated.
     *
     * @remarks
     * Note that `mapSet` only performs shallow updates to the map. Setting a value to `null`
     * will retain the key with a `null` value. To remove a key entirely, use `mapRemove`.
     *
     * @example
     * ```typescript
     * // Set the 'city' to "San Francisco" in the 'address' map
     * field("address").mapSet("city", "San Francisco");
     * ```
     *
     * @param key - The key to set. Must be a string or a constant string expression.
     * @param value - The value to set.
     * @param moreKeyValues - Additional key-value pairs to set.
     * @returns A new `Expression` representing the map with the entries set.
     */ key: "mapSet",
            value: function mapSet(e, t) {
                for(var _len = arguments.length, n = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
                    n[_key - 2] = arguments[_key];
                }
                var r = [
                    this,
                    __PRIVATE_valueToDefaultExpr(e),
                    __PRIVATE_valueToDefaultExpr(t)
                ].concat((0, $jlUaU._)(n.map(__PRIVATE_valueToDefaultExpr)));
                return new y("map_set", r, "mapSet");
            }
        },
        {
            /**
     * Creates an expression that returns the keys of a map.
     *
     * @remarks
     * While the backend generally preserves insertion order, relying on the
     * order of the output array is not guaranteed and should be avoided.
     *
     * @example
     * ```typescript
     * // Get the keys of the 'address' map
     * field("address").mapKeys();
     * ```
     *
     * @returns A new `Expression` representing the keys of the map.
     */ key: "mapKeys",
            value: function mapKeys() {
                return new y("map_keys", [
                    this
                ], "mapKeys");
            }
        },
        {
            /**
     * Creates an expression that returns the values of a map.
     *
     * @remarks
     * While the backend generally preserves insertion order, relying on the
     * order of the output array is not guaranteed and should be avoided.
     *
     * @example
     * ```typescript
     * // Get the values of the 'address' map
     * field("address").mapValues();
     * ```
     *
     * @returns A new `Expression` representing the values of the map.
     */ key: "mapValues",
            value: function mapValues() {
                return new y("map_values", [
                    this
                ], "mapValues");
            }
        },
        {
            /**
     * Creates an expression that returns the entries of a map as an array of maps,
     * where each map contains a `"k"` property for the key and a `"v"` property for the value.
     * For example: `[{ k: "key1", v: "value1" }, ...]`.
     *
     * @example
     * ```typescript
     * // Get the entries of the 'address' map
     * field("address").mapEntries();
     * ```
     *
     * @returns A new `Expression` representing the entries of the map.
     */ key: "mapEntries",
            value: function mapEntries() {
                return new y("map_entries", [
                    this
                ], "mapEntries");
            }
        },
        {
            /**
     * @public
     * Creates an expression that returns the value of a field from the document that results from the evaluation of this expression.
     *
     * @example
     * ```typescript
     * // Get the value of the "city" field in the "address" document.
     * field("address").getField("city")
     * ```
     *
     * @param key The field to access in the document.
     * @returns A new `Expression` representing the value of the field in the document.
     */ key: "getField",
            value: function getField(e) {
                return new y("get_field", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "get_field");
            }
        },
        {
            /**
     * Creates an aggregation that counts the number of stage inputs with valid evaluations of the
     * expression or field.
     *
     * @example
     * ```typescript
     * // Count the total number of products
     * field("productId").count().as("totalProducts");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'count' aggregation.
     */ key: "count",
            value: function count() {
                return k._create("count", [
                    this
                ], "count");
            }
        },
        {
            /**
     * Creates an aggregation that calculates the sum of a numeric field across multiple stage inputs.
     *
     * @example
     * ```typescript
     * // Calculate the total revenue from a set of orders
     * field("orderAmount").sum().as("totalRevenue");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'sum' aggregation.
     */ key: "sum",
            value: function sum() {
                return k._create("sum", [
                    this
                ], "sum");
            }
        },
        {
            /**
     * Creates an aggregation that calculates the average (mean) of a numeric field across multiple
     * stage inputs.
     *
     * @example
     * ```typescript
     * // Calculate the average age of users
     * field("age").average().as("averageAge");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'average' aggregation.
     */ key: "average",
            value: function average() {
                return k._create("average", [
                    this
                ], "average");
            }
        },
        {
            /**
     * Creates an aggregation that finds the minimum value of a field across multiple stage inputs.
     *
     * @example
     * ```typescript
     * // Find the lowest price of all products
     * field("price").minimum().as("lowestPrice");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'minimum' aggregation.
     */ key: "minimum",
            value: function minimum() {
                return k._create("minimum", [
                    this
                ], "minimum");
            }
        },
        {
            /**
     * Creates an aggregation that finds the maximum value of a field across multiple stage inputs.
     *
     * @example
     * ```typescript
     * // Find the highest score in a leaderboard
     * field("score").maximum().as("highestScore");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'maximum' aggregation.
     */ key: "maximum",
            value: function maximum() {
                return k._create("maximum", [
                    this
                ], "maximum");
            }
        },
        {
            /**
     * Creates an aggregation that finds the first value of an expression across multiple stage inputs.
     *
     * @example
     * ```typescript
     * // Find the first value of the 'rating' field
     * field("rating").first().as("firstRating");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'first' aggregation.
     */ key: "first",
            value: function first() {
                return k._create("first", [
                    this
                ], "first");
            }
        },
        {
            /**
     * Creates an aggregation that finds the last value of an expression across multiple stage inputs.
     *
     * @example
     * ```typescript
     * // Find the last value of the 'rating' field
     * field("rating").last().as("lastRating");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'last' aggregation.
     */ key: "last",
            value: function last() {
                return k._create("last", [
                    this
                ], "last");
            }
        },
        {
            /**
     * Creates an aggregation that collects all values of an expression across multiple stage inputs
     * into an array.
     *
     * @remarks
     * If the expression resolves to an absent value, it is converted to `null`.
     * The order of elements in the output array is not stable and shouldn't be relied upon.
     *
     * @example
     * ```typescript
     * // Collect all tags from books into an array
     * field("tags").arrayAgg().as("allTags");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'array_agg' aggregation.
     */ key: "arrayAgg",
            value: function arrayAgg() {
                return k._create("array_agg", [
                    this
                ], "arrayAgg");
            }
        },
        {
            /**
     * Creates an aggregation that collects all distinct values of an expression across multiple stage
     * inputs into an array.
     *
     * @remarks
     * If the expression resolves to an absent value, it is converted to `null`.
     * The order of elements in the output array is not stable and shouldn't be relied upon.
     *
     * @example
     * ```typescript
     * // Collect all distinct tags from books into an array
     * field("tags").arrayAggDistinct().as("allDistinctTags");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'array_agg_distinct' aggregation.
     */ key: "arrayAggDistinct",
            value: function arrayAggDistinct() {
                return k._create("array_agg_distinct", [
                    this
                ], "arrayAggDistinct");
            }
        },
        {
            /**
     * Creates an aggregation that counts the number of distinct values of the expression or field.
     *
     * @example
     * ```typescript
     * // Count the distinct number of products
     * field("productId").countDistinct().as("distinctProducts");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'count_distinct' aggregation.
     */ key: "countDistinct",
            value: function countDistinct() {
                return k._create("count_distinct", [
                    this
                ], "countDistinct");
            }
        },
        {
            /**
     * Creates an expression that returns the larger value between this expression and another expression, based on Firestore's value type ordering.
     *
     * @example
     * ```typescript
     * // Returns the larger value between the 'timestamp' field and the current timestamp.
     * field("timestamp").logicalMaximum(currentTimestamp());
     * ```
     *
     * @param second - The second expression or literal to compare with.
     * @param others - Optional additional expressions or literals to compare with.
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the logical maximum operation.
     */ key: "logicalMaximum",
            value: function logicalMaximum(e) {
                for(var _len = arguments.length, _$t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    _$t[_key - 1] = arguments[_key];
                }
                var n = [
                    e
                ].concat((0, $jlUaU._)(_$t));
                return new y("maximum", [
                    this
                ].concat((0, $jlUaU._)(n.map(__PRIVATE_valueToDefaultExpr))), "logicalMaximum");
            }
        },
        {
            /**
     * Creates an expression that returns the smaller value between this expression and another expression, based on Firestore's value type ordering.
     *
     * @example
     * ```typescript
     * // Returns the smaller value between the 'timestamp' field and the current timestamp.
     * field("timestamp").logicalMinimum(currentTimestamp());
     * ```
     *
     * @param second - The second expression or literal to compare with.
     * @param others - Optional additional expressions or literals to compare with.
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the logical minimum operation.
     */ key: "logicalMinimum",
            value: function logicalMinimum(e) {
                for(var _len = arguments.length, _$t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    _$t[_key - 1] = arguments[_key];
                }
                var n = [
                    e
                ].concat((0, $jlUaU._)(_$t));
                return new y("minimum", [
                    this
                ].concat((0, $jlUaU._)(n.map(__PRIVATE_valueToDefaultExpr))), "minimum");
            }
        },
        {
            /**
     * Creates an expression that calculates the length (number of dimensions) of this Firestore Vector expression.
     *
     * @example
     * ```typescript
     * // Get the vector length (dimension) of the field 'embedding'.
     * field("embedding").vectorLength();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the length of the vector.
     */ key: "vectorLength",
            value: function vectorLength() {
                return new y("vector_length", [
                    this
                ], "vectorLength");
            }
        },
        {
            key: "cosineDistance",
            value: function cosineDistance(e) {
                return new y("cosine_distance", [
                    this,
                    __PRIVATE_vectorToExpr(e)
                ], "cosineDistance");
            }
        },
        {
            key: "dotProduct",
            value: function dotProduct(e) {
                return new y("dot_product", [
                    this,
                    __PRIVATE_vectorToExpr(e)
                ], "dotProduct");
            }
        },
        {
            key: "euclideanDistance",
            value: function euclideanDistance(e) {
                return new y("euclidean_distance", [
                    this,
                    __PRIVATE_vectorToExpr(e)
                ], "euclideanDistance");
            }
        },
        {
            /**
     * Creates an expression that interprets this expression as the number of microseconds since the Unix epoch (1970-01-01 00:00:00 UTC)
     * and returns a timestamp.
     *
     * @example
     * ```typescript
     * // Interpret the 'microseconds' field as microseconds since epoch.
     * field("microseconds").unixMicrosToTimestamp();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the timestamp.
     */ key: "unixMicrosToTimestamp",
            value: function unixMicrosToTimestamp() {
                return new y("unix_micros_to_timestamp", [
                    this
                ], "unixMicrosToTimestamp");
            }
        },
        {
            /**
     * Creates an expression that converts this timestamp expression to the number of microseconds since the Unix epoch (1970-01-01 00:00:00 UTC).
     *
     * @example
     * ```typescript
     * // Convert the 'timestamp' field to microseconds since epoch.
     * field("timestamp").timestampToUnixMicros();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the number of microseconds since epoch.
     */ key: "timestampToUnixMicros",
            value: function timestampToUnixMicros() {
                return new y("timestamp_to_unix_micros", [
                    this
                ], "timestampToUnixMicros");
            }
        },
        {
            /**
     * Creates an expression that interprets this expression as the number of milliseconds since the Unix epoch (1970-01-01 00:00:00 UTC)
     * and returns a timestamp.
     *
     * @example
     * ```typescript
     * // Interpret the 'milliseconds' field as milliseconds since epoch.
     * field("milliseconds").unixMillisToTimestamp();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the timestamp.
     */ key: "unixMillisToTimestamp",
            value: function unixMillisToTimestamp() {
                return new y("unix_millis_to_timestamp", [
                    this
                ], "unixMillisToTimestamp");
            }
        },
        {
            /**
     * Creates an expression that converts this timestamp expression to the number of milliseconds since the Unix epoch (1970-01-01 00:00:00 UTC).
     *
     * @example
     * ```typescript
     * // Convert the 'timestamp' field to milliseconds since epoch.
     * field("timestamp").timestampToUnixMillis();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the number of milliseconds since epoch.
     */ key: "timestampToUnixMillis",
            value: function timestampToUnixMillis() {
                return new y("timestamp_to_unix_millis", [
                    this
                ], "timestampToUnixMillis");
            }
        },
        {
            /**
     * Creates an expression that interprets this expression as the number of seconds since the Unix epoch (1970-01-01 00:00:00 UTC)
     * and returns a timestamp.
     *
     * @example
     * ```typescript
     * // Interpret the 'seconds' field as seconds since epoch.
     * field("seconds").unixSecondsToTimestamp();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the timestamp.
     */ key: "unixSecondsToTimestamp",
            value: function unixSecondsToTimestamp() {
                return new y("unix_seconds_to_timestamp", [
                    this
                ], "unixSecondsToTimestamp");
            }
        },
        {
            /**
     * Creates an expression that converts this timestamp expression to the number of seconds since the Unix epoch (1970-01-01 00:00:00 UTC).
     *
     * @example
     * ```typescript
     * // Convert the 'timestamp' field to seconds since epoch.
     * field("timestamp").timestampToUnixSeconds();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the number of seconds since epoch.
     */ key: "timestampToUnixSeconds",
            value: function timestampToUnixSeconds() {
                return new y("timestamp_to_unix_seconds", [
                    this
                ], "timestampToUnixSeconds");
            }
        },
        {
            key: "timestampAdd",
            value: function timestampAdd(e, t) {
                return new y("timestamp_add", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e),
                    __PRIVATE_valueToDefaultExpr(t)
                ], "timestampAdd");
            }
        },
        {
            key: "timestampSubtract",
            value: function timestampSubtract(e, t) {
                return new y("timestamp_subtract", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e),
                    __PRIVATE_valueToDefaultExpr(t)
                ], "timestampSubtract");
            }
        },
        {
            key: "timestampDiff",
            value: function timestampDiff(e, t) {
                return new y("timestamp_diff", [
                    this,
                    __PRIVATE_fieldOrExpression(e),
                    __PRIVATE_valueToDefaultExpr(t)
                ], "timestampDiff");
            }
        },
        {
            key: "timestampExtract",
            value: function timestampExtract(e, t) {
                var n = [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ];
                return t && n.push(__PRIVATE_valueToDefaultExpr(t)), new y("timestamp_extract", n, "timestampExtract");
            }
        },
        {
            /**
     *
     * Creates an expression that returns the document ID from a path.
     *
     * @example
     * ```typescript
     * // Get the document ID from a path.
     * field("__path__").documentId();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the documentId operation.
     */ key: "documentId",
            value: function documentId() {
                return new y("document_id", [
                    this
                ], "documentId");
            }
        },
        {
            /**
     *
     * Creates an expression that returns the parent document reference of a document reference.
     *
     * @example
     * ```typescript
     * // Get the parent document reference of a document reference.
     * field("__path__").parent();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the parent operation.
     */ key: "parent",
            value: function parent() {
                return new y("parent", [
                    this
                ], "parent");
            }
        },
        {
            key: "substring",
            value: function substring(e, t) {
                var n = __PRIVATE_valueToDefaultExpr(e);
                return new y("substring", void 0 === t ? [
                    this,
                    n
                ] : [
                    this,
                    n,
                    __PRIVATE_valueToDefaultExpr(t)
                ], "substring");
            }
        },
        {
            key: "arrayGet",
            value: function arrayGet(e) {
                return new y("array_get", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "arrayGet");
            }
        },
        {
            /**
     *
     * Creates an expression that checks if a given expression produces an error.
     *
     * @example
     * ```typescript
     * // Check if the result of a calculation is an error
     * field("title").arrayContains(1).isError();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#BooleanExpression} representing the 'isError' check.
     */ key: "isError",
            value: function isError() {
                return new y("is_error", [
                    this
                ], "isError").asBoolean();
            }
        },
        {
            key: "ifError",
            value: function ifError(e) {
                var _$t = new y("if_error", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "ifError");
                return e instanceof BooleanExpression ? _$t.asBoolean() : _$t;
            }
        },
        {
            /**
     *
     * Creates an expression that returns `true` if the result of this expression
     * is absent. Otherwise, returns `false` even if the value is `null`.
     *
     * @example
     * ```typescript
     * // Check if the field `value` is absent.
     * field("value").isAbsent();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#BooleanExpression} representing the 'isAbsent' check.
     */ key: "isAbsent",
            value: function isAbsent() {
                return new y("is_absent", [
                    this
                ], "isAbsent").asBoolean();
            }
        },
        {
            key: "mapRemove",
            value: function mapRemove(e) {
                return new y("map_remove", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "mapRemove");
            }
        },
        {
            /**
     *
     * Creates an expression that merges multiple map values.
     *
     * @example
     * ```
     * // Merges the map in the settings field with, a map literal, and a map in
     * // that is conditionally returned by another expression
     * field('settings').mapMerge({ enabled: true }, conditional(field('isAdmin'), { admin: true}, {})
     * ```
     *
     * @param secondMap - A required second map to merge. Represented as a literal or
     * an expression that returns a map.
     * @param otherMaps - Optional additional maps to merge. Each map is represented
     * as a literal or an expression that returns a map.
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the 'mapMerge' operation.
     */ key: "mapMerge",
            value: function mapMerge(e) {
                for(var _len = arguments.length, _$t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    _$t[_key - 1] = arguments[_key];
                }
                var n = __PRIVATE_valueToDefaultExpr(e), r = _$t.map(__PRIVATE_valueToDefaultExpr);
                return new y("map_merge", [
                    this,
                    n
                ].concat((0, $jlUaU._)(r)), "mapMerge");
            }
        },
        {
            key: "pow",
            value: function pow(e) {
                return new y("pow", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ]);
            }
        },
        {
            key: "trunc",
            value: function trunc(e) {
                return void 0 === e ? new y("trunc", [
                    this
                ]) : new y("trunc", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "trunc");
            }
        },
        {
            key: "round",
            value: function round(e) {
                return void 0 === e ? new y("round", [
                    this
                ]) : new y("round", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "round");
            }
        },
        {
            /**
     * Creates an expression that returns the collection ID from a path.
     *
     * @example
     * ```typescript
     * // Get the collection ID from a path.
     * field("__path__").collectionId();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the collectionId operation.
     */ key: "collectionId",
            value: function collectionId() {
                return new y("collection_id", [
                    this
                ]);
            }
        },
        {
            /**
     * Creates an expression that calculates the length of a string, array, map, vector, or bytes.
     *
     * @example
     * ```typescript
     * // Get the length of the 'name' field.
     * field("name").length();
     *
     * // Get the number of items in the 'cart' array.
     * field("cart").length();
     * ```
     *
     * @returns A new `Expression` representing the length of the string, array, map, vector, or bytes.
     */ key: "length",
            value: function length() {
                return new y("length", [
                    this
                ]);
            }
        },
        {
            /**
     * Creates an expression that computes the natural logarithm of a numeric value.
     *
     * @example
     * ```typescript
     * // Compute the natural logarithm of the 'value' field.
     * field("value").ln();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the natural logarithm of the numeric value.
     */ key: "ln",
            value: function ln() {
                return new y("ln", [
                    this
                ]);
            }
        },
        {
            /**
     * Creates an expression that computes the square root of a numeric value.
     *
     * @example
     * ```typescript
     * // Compute the square root of the 'value' field.
     * field("value").sqrt();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the square root of the numeric value.
     */ key: "sqrt",
            value: function sqrt() {
                return new y("sqrt", [
                    this
                ]);
            }
        },
        {
            /**
     * Creates an expression that reverses a string.
     *
     * @example
     * ```typescript
     * // Reverse the value of the 'myString' field.
     * field("myString").stringReverse();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the reversed string.
     */ key: "stringReverse",
            value: function stringReverse() {
                return new y("string_reverse", [
                    this
                ]);
            }
        },
        {
            key: "ifAbsent",
            value: function ifAbsent(e) {
                return new y("if_absent", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "ifAbsent");
            }
        },
        {
            key: "ifNull",
            value: function ifNull(e) {
                return new y("if_null", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "ifNull");
            }
        },
        {
            /**
     * Creates an expression that returns the first non-null, non-absent argument, without evaluating
     * the rest of the arguments. When all arguments are null or absent, returns the last argument.
     *
     * @example
     * ```typescript
     * // Returns the value of the first non-null, non-absent field among 'preferredName', 'fullName',
     * // or the last argument if all previous fields are null.
     * field("preferredName").coalesce(field("fullName"), "Anonymous");
     * ```
     *
     * @param replacement - The value to use if this expression evaluates to null.
     * @param others - Optional additional values to check if previous values are null.
     * @returns A new `Expression` representing the coalesce operation.
     */ key: "coalesce",
            value: function coalesce(e) {
                for(var _len = arguments.length, _$t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    _$t[_key - 1] = arguments[_key];
                }
                return new y("coalesce", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ].concat((0, $jlUaU._)(_$t.map(__PRIVATE_valueToDefaultExpr))), "coalesce");
            }
        },
        {
            key: "join",
            value: function join(e) {
                return new y("join", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "join");
            }
        },
        {
            /**
     * Creates an expression that computes the base-10 logarithm of a numeric value.
     *
     * @example
     * ```typescript
     * // Compute the base-10 logarithm of the 'value' field.
     * field("value").log10();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the base-10 logarithm of the numeric value.
     */ key: "log10",
            value: function log10() {
                return new y("log10", [
                    this
                ]);
            }
        },
        {
            /**
     * Creates an expression that computes the sum of the elements in an array.
     *
     * @example
     * ```typescript
     * // Compute the sum of the elements in the 'scores' field.
     * field("scores").arraySum();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the sum of the elements in the array.
     */ key: "arraySum",
            value: function arraySum() {
                return new y("sum", [
                    this
                ]);
            }
        },
        {
            key: "split",
            value: function split(e) {
                return new y("split", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ]);
            }
        },
        {
            key: "timestampTruncate",
            value: function timestampTruncate(e, t) {
                var n = [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ];
                return t && n.push(__PRIVATE_valueToDefaultExpr(t)), new y("timestamp_trunc", n);
            }
        },
        {
            // TODO(search) enable with backend support
            // /**
            //  * Evaluates if the result of this `expression` is between
            //  * the `lowerBound` (inclusive) and `upperBound` (inclusive).
            //  *
            //  * @example
            //  * ```
            //  * // Evaluate if the 'tireWidth' is between 2.2 and 2.4
            //  * field('tireWidth').between(constant(2.2), constant(2.4))
            //  *
            //  * // This is functionally equivalent to
            //  * and(field('tireWidth').greaterThanOrEqual(contant(2.2)), field('tireWidth').lessThanOrEqual(constant(2.4)))
            //  * ```
            //  *
            //  * @param lowerBound - Lower bound (inclusive) of the range.
            //  * @param upperBound - Upper bound (inclusive) of the range.
            //  */
            // between(lowerBound: Expression, upperBound: Expression): BooleanExpression;
            // /**
            //  * Evaluates if the result of this `expression` is between
            //  * the `lowerBound` (inclusive) and `upperBound` (inclusive).
            //  *
            //  * @example
            //  * ```
            //  * // Evaluate if the 'tireWidth' is between 2.2 and 2.4
            //  * field('tireWidth').between(2.2, 2.4)
            //  *
            //  * // This is functionally equivalent to
            //  * and(field('tireWidth').greaterThanOrEqual(2.2), field('tireWidth').lessThanOrEqual(2.4))
            //  * ```
            //  *
            //  * @param lowerBound - Lower bound (inclusive) of the range.
            //  * @param upperBound - Upper bound (inclusive) of the range.
            //  */
            // between(lowerBound: unknown, upperBound: unknown): BooleanExpression;
            // between(lowerBound: unknown, upperBound: unknown): BooleanExpression {
            //   return new FunctionExpression('between', [
            //     this,
            //     valueToDefaultExpr(lowerBound),
            //     valueToDefaultExpr(upperBound)
            //   ]).asBoolean();
            // }
            // TODO(search) enable with backend support
            // /**
            //  * Evaluates to an HTML-formatted text snippet that renders terms matching
            //  * the search query in `<b>bold</b>`.
            //  *
            //  * @remarks This Expression can only be used within a `search` stage.
            //  *
            //  * @param rquery Define the search query using the search domain-specific language (DSL).
            //  */
            // snippet(rquery: string): Expression;
            // /**
            //  * Evaluates to an HTML-formatted text snippet that renders terms matching
            //  * the search query in `<b>bold</b>`.
            //  *
            //  * @remarks This Expression can only be used within a `search` stage.
            //  *
            //  * @param options Define how snippeting behaves.
            //  */
            // snippet(options: SnippetOptions): Expression;
            // snippet(queryOrOptions: string | SnippetOptions): Expression {
            //   const options: SnippetOptions = isString(queryOrOptions)
            //     ? { rquery: queryOrOptions }
            //     : queryOrOptions;
            //   const rquery = options.rquery;
            //   const internalOptions = {
            //     maxSnippetWidth: options.maxSnippetWidth,
            //     maxSnippets: options.maxSnippets,
            //     separator: options.separator
            //   };
            //   return new SnippetExpression([this, constant(rquery)], internalOptions);
            // }
            // TODO(new-expression): Add new expression method definitions above this line
            /**
     * Creates an {@link @firebase/firestore/pipelines#Ordering} that sorts documents in ascending order based on this expression.
     *
     * @example
     * ```typescript
     * // Sort documents by the 'name' field in ascending order
     * firestore.pipeline().collection("users")
     *   .sort(field("name").ascending());
     * ```
     *
     * @returns A new `Ordering` for ascending sorting.
     */ key: "ascending",
            value: function ascending1() {
                return ascending(this);
            }
        },
        {
            /**
     * Creates an {@link @firebase/firestore/pipelines#Ordering} that sorts documents in descending order based on this expression.
     *
     * @example
     * ```typescript
     * // Sort documents by the 'createdAt' field in descending order
     * firestore.pipeline().collection("users")
     *   .sort(field("createdAt").descending());
     * ```
     *
     * @returns A new `Ordering` for descending sorting.
     */ key: "descending",
            value: function descending1() {
                return descending(this);
            }
        },
        {
            /**
     * Assigns an alias to this expression.
     *
     * Aliases are useful for renaming fields in the output of a stage or for giving meaningful
     * names to calculated values.
     *
     * @example
     * ```typescript
     * // Calculate the total price and assign it the alias "totalPrice" and add it to the output.
     * firestore.pipeline().collection("items")
     *   .addFields(field("price").multiply(field("quantity")).as("totalPrice"));
     * ```
     *
     * @param name - The alias to assign to this expression.
     * @returns A new {@link @firebase/firestore/pipelines#AliasedExpression} that wraps this
     *     expression and associates it with the provided alias.
     */ key: "as",
            value: function as(e) {
                return new c(this, e, "as");
            }
        }
    ]);
    return t;
}();
/**
 *
 * A class that represents an aggregate function.
 */ var k = /*#__PURE__*/ function() {
    "use strict";
    function k(e, t) {
        (0, $4QweW._)(this, k);
        this.name = e, this.params = t, this.exprType = "AggregateFunction", this._protoValueType = "ProtoValue";
    }
    (0, $6hK4i._)(k, [
        {
            /**
     * Assigns an alias to this AggregateFunction. The alias specifies the name that
     * the aggregated value will have in the output document.
     *
     * @example
     * ```typescript
     * // Calculate the average price of all items and assign it the alias "averagePrice".
     * firestore.pipeline().collection("items")
     *   .aggregate(field("price").average().as("averagePrice"));
     * ```
     *
     * @param name - The alias to assign to this AggregateFunction.
     * @returns A new {@link @firebase/firestore/pipelines#AliasedAggregate} that wraps this
     *     AggregateFunction and associates it with the provided alias.
     */ key: "as",
            value: function as(e) {
                return new AliasedAggregate(this, e, "as");
            }
        },
        {
            /**
     * @private
     * @internal
     */ key: "_toProto",
            value: function _toProto(e) {
                return {
                    functionValue: {
                        name: this.name,
                        args: this.params.map(function(t) {
                            return t._toProto(e);
                        })
                    }
                };
            }
        },
        {
            /**
     * @private
     * @internal
     */ key: "_readUserData",
            value: function _readUserData(e) {
                e = this._methodName ? e.contextWith({
                    methodName: this._methodName
                }) : e, this.params.forEach(function(t) {
                    return t._readUserData(e);
                });
            }
        }
    ], [
        {
            key: "_create",
            value: /**
     * @internal
     * @private
     */ function _create(e, t, n) {
                var r = new k(e, t);
                return r._methodName = n, r;
            }
        }
    ]);
    return k;
}();
/**
 *
 * An AggregateFunction with alias.
 */ var AliasedAggregate = /*#__PURE__*/ function() {
    "use strict";
    function AliasedAggregate(e, t, n) {
        (0, $4QweW._)(this, AliasedAggregate);
        this.aggregate = e, this.alias = t, this._methodName = n;
    }
    (0, $6hK4i._)(AliasedAggregate, [
        {
            /**
     * @private
     * @internal
     */ key: "_readUserData",
            value: function _readUserData(e) {
                this.aggregate._readUserData(e);
            }
        }
    ]);
    return AliasedAggregate;
}();
var c = /*#__PURE__*/ function() {
    "use strict";
    function c(e, t, n) {
        (0, $4QweW._)(this, c);
        this.expr = e, this.alias = t, this._methodName = n, this.exprType = "AliasedExpression", this.selectable = true;
    }
    (0, $6hK4i._)(c, [
        {
            /**
     * @private
     * @internal
     */ key: "_readUserData",
            value: function _readUserData(e) {
                this.expr._readUserData(e);
            }
        }
    ]);
    return c;
}();
/**
 * @internal
 */ var __PRIVATE_ListOfExprs = /*#__PURE__*/ function(t) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_ListOfExprs, t);
    function __PRIVATE_ListOfExprs(e, t) {
        (0, $4QweW._)(this, __PRIVATE_ListOfExprs);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_ListOfExprs), _this.cr = e, _this._methodName = t, _this.expressionType = "ListOfExpressions";
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_ListOfExprs, [
        {
            /**
     * @private
     * @internal
     */ key: "_toProto",
            value: function _toProto(e) {
                return {
                    arrayValue: {
                        values: this.cr.map(function(t) {
                            return t._toProto(e);
                        })
                    }
                };
            }
        },
        {
            /**
     * @private
     * @internal
     */ key: "_readUserData",
            value: function _readUserData(e) {
                this.cr.forEach(function(t) {
                    return t._readUserData(e);
                });
            }
        }
    ]);
    return __PRIVATE_ListOfExprs;
}(t);
/**
 *
 * Represents a reference to a field in a Firestore document, or outputs of a {@link @firebase/firestore/pipelines#Pipeline} stage.
 *
 * <p>Field references are used to access document field values in expressions and to specify fields
 * for sorting, filtering, and projecting data in Firestore pipelines.
 *
 * <p>You can create a `Field` instance using the static {@link @firebase/firestore/pipelines#(field:1) | field} method:
 *
 * @example
 * ```typescript
 * // Create a Field instance for the 'name' field
 * const nameField = field("name");
 *
 * // Create a Field instance for a nested field 'address.city'
 * const cityField = field("address.city");
 * ```
 */ var o = /*#__PURE__*/ function(t) {
    "use strict";
    (0, $c2MhV._)(o, t);
    function o(e, t) {
        (0, $4QweW._)(this, o);
        var _this;
        _this = (0, $ehF45._)(this, o), _this.fieldPath = e, _this._methodName = t, _this.expressionType = "Field", _this.selectable = true;
        return _this;
    }
    (0, $6hK4i._)(o, [
        {
            key: "_fieldPath",
            get: function get() {
                return this.fieldPath;
            }
        },
        {
            key: "fieldName",
            get: function get() {
                return this.fieldPath.canonicalString();
            }
        },
        {
            key: "alias",
            get: function get() {
                return this.fieldName;
            }
        },
        {
            key: "expr",
            get: function get() {
                return this;
            }
        },
        {
            // TODO(search) enable with backend support
            // /**
            //  * Perform a full-text search on this field.
            //  *
            //  * @remarks This Expression can only be used within a `search` stage.
            //  *
            //  * @param rquery Define the search query using the search domain-specific language (DSL).
            //  */
            // matches(rquery: string | Expression): BooleanExpression {
            //   return new FunctionExpression(
            //     'matches',
            //     [this, valueToDefaultExpr(rquery)],
            //     'matches'
            //   ).asBoolean();
            // }
            /**
     * @beta
     * Evaluates to the distance in meters between the location specified
     * by this field and the query location.
     *
     * @remarks This Expression can only be used within a `search` stage.
     *
     * @param location - Compute distance to this GeoPoint.
     */ key: "geoDistance",
            value: function geoDistance(e) {
                return new y("geo_distance", [
                    this,
                    __PRIVATE_valueToDefaultExpr(e)
                ], "geoDistance");
            }
        },
        {
            /**
     * @private
     * @internal
     */ key: "_toProto",
            value: function _toProto(e) {
                return {
                    fieldReferenceValue: this.fieldPath.canonicalString()
                };
            }
        },
        {
            /**
     * @private
     * @internal
     */ key: "_readUserData",
            value: function _readUserData(e) {}
        }
    ]);
    return o;
}(t);
function s(e) {
    return G(e, "field");
}
function G(e, t) {
    return new o("string" == typeof e ? Ce === e ? documentId$1()._internalPath : K("field", e) : e._internalPath, t);
}
/**
 * @internal
 *
 * Represents a constant value that can be used in a Firestore pipeline expression.
 *
 * You can create a `Constant` instance using the static {@link @firebase/firestore/pipelines#(constant:1) | constant} method:
 *
 * @example
 * ```typescript
 * // Create a Constant instance for the number 10
 * const ten = constant(10);
 *
 * // Create a Constant instance for the string "hello"
 * const hello = constant("hello");
 * ```
 */ var Constant = /*#__PURE__*/ function(t) {
    "use strict";
    (0, $c2MhV._)(Constant, t);
    function Constant(e, t) {
        (0, $4QweW._)(this, Constant);
        var _this;
        _this = (0, $ehF45._)(this, Constant), _this.value = e, _this._methodName = t, _this.expressionType = "Constant";
        return _this;
    }
    (0, $6hK4i._)(Constant, [
        {
            /**
     * @private
     * @internal
     */ key: "_toProto",
            value: function _toProto(e) {
                return __PRIVATE_hardAssert(void 0 !== this._protoValue, 237), this._protoValue;
            }
        },
        {
            key: "_getValue",
            value: function _getValue() {
                return this._protoValue;
            }
        },
        {
            /**
     * @private
     * @internal
     */ key: "_readUserData",
            value: function _readUserData(e) {
                e = this._methodName ? e.contextWith({
                    methodName: this._methodName
                }) : e, u(this._protoValue) || (this._protoValue = __PRIVATE_parseData(this.value, e));
            }
        }
    ], [
        {
            key: "_fromProto",
            value: /**
     * @private
     * @internal
     */ function _fromProto(e) {
                var _$t = new Constant(e, void 0);
                return _$t._protoValue = e, _$t;
            }
        }
    ]);
    return Constant;
}(t);
function i(e, t) {
    return m(e, "constant");
}
/**
 * @internal
 * @private
 * @param value
 * @param methodName
 */ function m(e, t) {
    var n = new Constant(e, t);
    return "boolean" == typeof e ? new __PRIVATE_BooleanConstant(n) : n;
}
/**
 * Internal only
 * @internal
 * @private
 */ var MapValue = /*#__PURE__*/ function(t) {
    "use strict";
    (0, $c2MhV._)(MapValue, t);
    function MapValue(e, t) {
        (0, $4QweW._)(this, MapValue);
        var _this;
        _this = (0, $ehF45._)(this, MapValue), _this.lr = e, _this._methodName = t, _this.expressionType = "Constant";
        return _this;
    }
    (0, $6hK4i._)(MapValue, [
        {
            key: "_readUserData",
            value: function _readUserData(e) {
                e = this._methodName ? e.contextWith({
                    methodName: this._methodName
                }) : e, this.lr.forEach(function(t) {
                    t._readUserData(e);
                });
            }
        },
        {
            key: "_toProto",
            value: function _toProto(e) {
                return toMapValue(e, this.lr);
            }
        }
    ]);
    return MapValue;
}(t);
/**
 *
 * This class defines the base class for Firestore {@link @firebase/firestore/pipelines#Pipeline} functions, which can be evaluated within pipeline
 * execution.
 *
 * Typically, you would not use this class or its children directly. Use either the functions like {@link @firebase/firestore/pipelines#and}, {@link @firebase/firestore/pipelines#(equal:1)},
 * or the methods on {@link @firebase/firestore/pipelines#Expression} ({@link @firebase/firestore/pipelines#Expression.(equal:1)}, {@link @firebase/firestore/pipelines#Expression.(lessThan:1)}, etc.) to construct new Function instances.
 */ var y = /*#__PURE__*/ function(t) {
    "use strict";
    (0, $c2MhV._)(y, t);
    function y(e, t, n, r) {
        (0, $4QweW._)(this, y);
        var _this;
        _this = (0, $ehF45._)(this, y), _this.name = e, _this.params = t, _this.expressionType = "Function", /**
         * @private
         * @internal
         */ _this._optionsProto = void 0, void 0 !== n && (_this._methodName = n), void 0 !== r && (_this._options = r);
        return _this;
    }
    (0, $6hK4i._)(y, [
        {
            key: "_optionsUtil",
            get: /**
     * @private
     * @internal
     */ function get() {
                return new OptionsUtil({});
            }
        },
        {
            /**
     * @private
     * @internal
     */ key: "_toProto",
            value: function _toProto(e) {
                var _$t = {
                    functionValue: {
                        name: this.name,
                        args: this.params.map(function(t) {
                            return t._toProto(e);
                        })
                    }
                };
                return this._optionsProto && (_$t.functionValue.options = this._optionsProto), _$t;
            }
        },
        {
            /**
     * @private
     * @internal
     */ key: "_readUserData",
            value: function _readUserData(e) {
                e = this._methodName ? e.contextWith({
                    methodName: this._methodName
                }) : e, this.params.forEach(function(t) {
                    return t._readUserData(e);
                }), this._options && (this._optionsProto = this._optionsUtil.getOptionsProto(e, this._options));
            }
        }
    ]);
    return y;
}(t);
/**
 *
 * An interface that represents a filter condition.
 */ var BooleanExpression = /*#__PURE__*/ function(t) {
    "use strict";
    (0, $c2MhV._)(BooleanExpression, t);
    function BooleanExpression() {
        (0, $4QweW._)(this, BooleanExpression);
        return (0, $ehF45._)(this, BooleanExpression, arguments);
    }
    (0, $6hK4i._)(BooleanExpression, [
        {
            key: "_methodName",
            get: function get() {
                return this._expr._methodName;
            }
        },
        {
            /**
     * Creates an aggregation that finds the count of input documents satisfying
     * this boolean expression.
     *
     * @example
     * ```typescript
     * // Find the count of documents with a score greater than 90
     * field("score").greaterThan(90).countIf().as("highestScore");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'countIf' aggregation.
     */ key: "countIf",
            value: function countIf() {
                return k._create("count_if", [
                    this
                ], "countIf");
            }
        },
        {
            /**
     * Creates an expression that negates this boolean expression.
     *
     * @example
     * ```typescript
     * // Find documents where the 'tags' field does not contain 'completed'
     * field("tags").arrayContains("completed").not();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the negated filter condition.
     */ key: "not",
            value: function not() {
                return new y("not", [
                    this
                ], "not").asBoolean();
            }
        },
        {
            /**
     * Creates a conditional expression that evaluates to the 'then' expression
     * if `this` expression evaluates to `true`,
     * or evaluates to the 'else' expression if `this` expressions evaluates `false`.
     *
     * @example
     * ```typescript
     * // If 'age' is greater than 18, return "Adult"; otherwise, return "Minor".
     * field("age").greaterThanOrEqual(18).conditional(constant("Adult"), constant("Minor"));
     * ```
     *
     * @param thenExpr - The expression to evaluate if the condition is true.
     * @param elseExpr - The expression to evaluate if the condition is false.
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the conditional expression.
     */ key: "conditional",
            value: function conditional(e, t) {
                return new y("conditional", [
                    this,
                    e,
                    t
                ], "conditional");
            }
        },
        {
            key: "ifError",
            value: function ifError(e) {
                var _$t = __PRIVATE_valueToDefaultExpr(e), n = new y("if_error", [
                    this,
                    _$t
                ], "ifError");
                return _$t instanceof BooleanExpression ? n.asBoolean() : n;
            }
        },
        {
            /**
     * @private
     * @internal
     */ key: "_toProto",
            value: function _toProto(e) {
                return this._expr._toProto(e);
            }
        },
        {
            /**
     * @private
     * @internal
     */ key: "_readUserData",
            value: function _readUserData(e) {
                this._expr._readUserData(e);
            }
        }
    ]);
    return BooleanExpression;
}(t);
var __PRIVATE_BooleanFunctionExpression = /*#__PURE__*/ function(BooleanExpression) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_BooleanFunctionExpression, BooleanExpression);
    function __PRIVATE_BooleanFunctionExpression(e) {
        (0, $4QweW._)(this, __PRIVATE_BooleanFunctionExpression);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_BooleanFunctionExpression), _this._expr = e, _this.expressionType = "Function";
        return _this;
    }
    return __PRIVATE_BooleanFunctionExpression;
}(BooleanExpression);
var __PRIVATE_BooleanConstant = /*#__PURE__*/ function(BooleanExpression) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_BooleanConstant, BooleanExpression);
    function __PRIVATE_BooleanConstant(e) {
        (0, $4QweW._)(this, __PRIVATE_BooleanConstant);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_BooleanConstant), _this._expr = e, _this.expressionType = "Constant";
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_BooleanConstant, [
        {
            key: "_getValue",
            value: function _getValue() {
                return this._expr._getValue();
            }
        }
    ]);
    return __PRIVATE_BooleanConstant;
}(BooleanExpression);
var __PRIVATE_BooleanField = /*#__PURE__*/ function(BooleanExpression) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_BooleanField, BooleanExpression);
    function __PRIVATE_BooleanField(e) {
        (0, $4QweW._)(this, __PRIVATE_BooleanField);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_BooleanField), _this._expr = e, _this.expressionType = "Field";
        return _this;
    }
    return __PRIVATE_BooleanField;
}(BooleanExpression);
/**
 * Creates an aggregation that counts the number of stage inputs where the provided
 * boolean expression evaluates to true.
 *
 * @example
 * ```typescript
 * // Count the number of documents where 'is_active' field equals true
 * countIf(field("is_active").equal(true)).as("numActiveDocuments");
 * ```
 *
 * @param booleanExpr - The boolean expression to evaluate on each input.
 * @returns A new `AggregateFunction` representing the 'countIf' aggregation.
 */ function countIf(e) {
    return e.countIf();
}
function arrayGet(e, t) {
    return __PRIVATE_fieldOrExpression(e).arrayGet(__PRIVATE_valueToDefaultExpr(t));
}
/**
 *
 * Creates an expression that checks if a given expression produces an error.
 *
 * @example
 * ```typescript
 * // Check if the result of a calculation is an error
 * isError(field("title").arrayContains(1));
 * ```
 *
 * @param value - The expression to check.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the 'isError' check.
 */ function isError(e) {
    return e.isError().asBoolean();
}
function ifError(e, t) {
    return e instanceof BooleanExpression && t instanceof BooleanExpression ? e.ifError(t).asBoolean() : e.ifError(__PRIVATE_valueToDefaultExpr(t));
}
function isAbsent(e) {
    return __PRIVATE_fieldOrExpression(e).isAbsent();
}
function mapRemove(e, t) {
    return __PRIVATE_fieldOrExpression(e).mapRemove(__PRIVATE_valueToDefaultExpr(t));
}
function mapMerge(e, t) {
    for(var _len = arguments.length, n = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        n[_key - 2] = arguments[_key];
    }
    var _$__PRIVATE_fieldOrExpression;
    var r = __PRIVATE_valueToDefaultExpr(t), i = n.map(__PRIVATE_valueToDefaultExpr);
    return (_$__PRIVATE_fieldOrExpression = __PRIVATE_fieldOrExpression(e)).mapMerge.apply(_$__PRIVATE_fieldOrExpression, [
        r
    ].concat((0, $jlUaU._)(i)));
}
function documentId(e) {
    return __PRIVATE_valueToDefaultExpr(e).documentId();
}
function parent(e) {
    return __PRIVATE_valueToDefaultExpr(e).parent();
}
function substring(e, t, n) {
    var r = __PRIVATE_fieldOrExpression(e), i = __PRIVATE_valueToDefaultExpr(t), s = void 0 === n ? void 0 : __PRIVATE_valueToDefaultExpr(n);
    return r.substring(i, s);
}
function add(e, t) {
    return __PRIVATE_fieldOrExpression(e).add(__PRIVATE_valueToDefaultExpr(t));
}
function subtract(e, t) {
    var n = "string" == typeof e ? s(e) : e, r = __PRIVATE_valueToDefaultExpr(t);
    return n.subtract(r);
}
function multiply(e, t) {
    return __PRIVATE_fieldOrExpression(e).multiply(__PRIVATE_valueToDefaultExpr(t));
}
function divide(e, t) {
    var n = "string" == typeof e ? s(e) : e, r = __PRIVATE_valueToDefaultExpr(t);
    return n.divide(r);
}
function mod(e, t) {
    var n = "string" == typeof e ? s(e) : e, r = __PRIVATE_valueToDefaultExpr(t);
    return n.mod(r);
}
/**
 *
 * Creates an expression that creates a Firestore map value from an input object.
 *
 * @example
 * ```typescript
 * // Create a map from the input object and reference the 'baz' field value from the input document.
 * map({foo: 'bar', baz: field('baz')}).as('data');
 * ```
 *
 * @param elements - The input map to evaluate in the expression.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the map function.
 */ function h(e) {
    return __PRIVATE__map(e);
}
function __PRIVATE__map(e, t) {
    var n = [];
    for(var t1 in e)if (Object.prototype.hasOwnProperty.call(e, t1)) {
        var r = e[t1];
        n.push(i(t1)), n.push(__PRIVATE_valueToDefaultExpr(r));
    }
    return new y("map", n, "map");
}
/**
 * Internal use only
 * Converts a plainObject to a mapValue in the proto representation,
 * rather than a functionValue+map that is the result of the map(...) function.
 * This behaves different from constant(plainObject) because it
 * traverses the input object, converts values in the object to expressions,
 * and calls _readUserData on each of these expressions.
 * @private
 * @internal
 * @param plainObject
 */ function B(e) {
    var t = new Map;
    for(var n in e)if (Object.prototype.hasOwnProperty.call(e, n)) {
        var r = e[n];
        t.set(n, __PRIVATE_valueToDefaultExpr(r));
    }
    return new MapValue(t, void 0);
}
/**
 *
 * Creates an expression that creates a Firestore array value from an input array.
 *
 * @example
 * ```typescript
 * // Create an array value from the input array and reference the 'baz' field value from the input document.
 * array(['bar', field('baz')]).as('foo');
 * ```
 *
 * @param elements - The input array to evaluate in the expression.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the array function.
 */ function b(e) {
    return function __PRIVATE__array(e, t) {
        return new y("array", e.map(function(e) {
            return __PRIVATE_valueToDefaultExpr(e);
        }), t);
    }(e, "array");
}
function equal(e, n) {
    var r = e instanceof t ? e : s(e), i = __PRIVATE_valueToDefaultExpr(n);
    return r.equal(i);
}
function notEqual(e, n) {
    var r = e instanceof t ? e : s(e), i = __PRIVATE_valueToDefaultExpr(n);
    return r.notEqual(i);
}
function lessThan(e, n) {
    var r = e instanceof t ? e : s(e), i = __PRIVATE_valueToDefaultExpr(n);
    return r.lessThan(i);
}
function lessThanOrEqual(e, n) {
    var r = e instanceof t ? e : s(e), i = __PRIVATE_valueToDefaultExpr(n);
    return r.lessThanOrEqual(i);
}
function greaterThan(e, n) {
    var r = e instanceof t ? e : s(e), i = __PRIVATE_valueToDefaultExpr(n);
    return r.greaterThan(i);
}
function greaterThanOrEqual(e, n) {
    var r = e instanceof t ? e : s(e), i = __PRIVATE_valueToDefaultExpr(n);
    return r.greaterThanOrEqual(i);
}
function arrayConcat(e, t) {
    for(var _len = arguments.length, n = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        n[_key - 2] = arguments[_key];
    }
    var _$__PRIVATE_fieldOrExpression;
    var r = n.map(function(e) {
        return __PRIVATE_valueToDefaultExpr(e);
    });
    return (_$__PRIVATE_fieldOrExpression = __PRIVATE_fieldOrExpression(e)).arrayConcat.apply(_$__PRIVATE_fieldOrExpression, [
        __PRIVATE_fieldOrExpression(t)
    ].concat((0, $jlUaU._)(r)));
}
function arrayContains(e, t) {
    var n = __PRIVATE_fieldOrExpression(e), r = __PRIVATE_valueToDefaultExpr(t);
    return n.arrayContains(r);
}
function arrayContainsAny(e, t) {
    // @ts-ignore implementation accepts both types
    return __PRIVATE_fieldOrExpression(e).arrayContainsAny(t);
}
function arrayContainsAll(e, t) {
    // @ts-ignore implementation accepts both types
    return __PRIVATE_fieldOrExpression(e).arrayContainsAll(t);
}
function arrayLength(e) {
    return __PRIVATE_fieldOrExpression(e).arrayLength();
}
function equalAny(e, t) {
    // @ts-ignore implementation accepts both types
    return __PRIVATE_fieldOrExpression(e).equalAny(t);
}
function notEqualAny(e, t) {
    // @ts-ignore implementation accepts both types
    return __PRIVATE_fieldOrExpression(e).notEqualAny(t);
}
/**
 *
 * Creates an expression that performs a logical 'XOR' (exclusive OR) operation on multiple BooleanExpressions.
 *
 * @example
 * ```typescript
 * // Check if only one of the conditions is true: 'age' greater than 18, 'city' is "London",
 * // or 'status' is "active".
 * const condition = xor(
 *     greaterThan("age", 18),
 *     equal("city", "London"),
 *     equal("status", "active"));
 * ```
 *
 * @param first - The first condition.
 * @param second - The second condition.
 * @param additionalConditions - Additional conditions to 'XOR' together.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the logical 'XOR' operation.
 */ function xor(e, t) {
    for(var _len = arguments.length, n = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        n[_key - 2] = arguments[_key];
    }
    return new y("xor", [
        e,
        t
    ].concat((0, $jlUaU._)(n)), "xor").asBoolean();
}
/**
 *
 * Creates a conditional expression that evaluates to a 'then' expression if a condition is true
 * and an 'else' expression if the condition is false.
 *
 * @example
 * ```typescript
 * // If 'age' is greater than 18, return "Adult"; otherwise, return "Minor".
 * conditional(
 *     greaterThan("age", 18), constant("Adult"), constant("Minor"));
 * ```
 *
 * @param condition - The condition to evaluate.
 * @param thenExpr - The expression to evaluate if the condition is true.
 * @param elseExpr - The expression to evaluate if the condition is false.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the conditional expression.
 */ function conditional(e, t, n) {
    return new y("conditional", [
        e,
        t,
        n
    ], "conditional");
}
/**
 *
 * Creates an expression that negates a filter condition.
 *
 * @example
 * ```typescript
 * // Find documents where the 'completed' field is NOT true
 * not(equal("completed", true));
 * ```
 *
 * @param booleanExpr - The filter condition to negate.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the negated filter condition.
 */ function not(e) {
    return e.not();
}
function logicalMaximum(e, t) {
    for(var _len = arguments.length, n = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        n[_key - 2] = arguments[_key];
    }
    var _$__PRIVATE_fieldOrExpression;
    return (_$__PRIVATE_fieldOrExpression = __PRIVATE_fieldOrExpression(e)).logicalMaximum.apply(_$__PRIVATE_fieldOrExpression, [
        __PRIVATE_valueToDefaultExpr(t)
    ].concat((0, $jlUaU._)(n.map(function(e) {
        return __PRIVATE_valueToDefaultExpr(e);
    }))));
}
function logicalMinimum(e, t) {
    for(var _len = arguments.length, n = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        n[_key - 2] = arguments[_key];
    }
    var _$__PRIVATE_fieldOrExpression;
    return (_$__PRIVATE_fieldOrExpression = __PRIVATE_fieldOrExpression(e)).logicalMinimum.apply(_$__PRIVATE_fieldOrExpression, [
        __PRIVATE_valueToDefaultExpr(t)
    ].concat((0, $jlUaU._)(n.map(function(e) {
        return __PRIVATE_valueToDefaultExpr(e);
    }))));
}
function exists(e) {
    return __PRIVATE_fieldOrExpression(e).exists();
}
function reverse(e) {
    return __PRIVATE_fieldOrExpression(e).reverse();
}
function byteLength(e) {
    return __PRIVATE_fieldOrExpression(e).byteLength();
}
function exp(e) {
    return __PRIVATE_fieldOrExpression(e).exp();
}
function ceil(e) {
    return __PRIVATE_fieldOrExpression(e).ceil();
}
function floor(e) {
    return __PRIVATE_fieldOrExpression(e).floor();
}
/**
 * Creates an aggregation that counts the number of distinct values of a field.
 *
 * @param expr - The expression or field to count distinct values of.
 * @returns A new `AggregateFunction` representing the 'count_distinct' aggregation.
 */ function countDistinct(e) {
    return __PRIVATE_fieldOrExpression(e).countDistinct();
}
function charLength(e) {
    return __PRIVATE_fieldOrExpression(e).charLength();
}
function like(e, t) {
    var n = __PRIVATE_fieldOrExpression(e), r = __PRIVATE_valueToDefaultExpr(t);
    return n.like(r);
}
function regexContains(e, t) {
    var n = __PRIVATE_fieldOrExpression(e), r = __PRIVATE_valueToDefaultExpr(t);
    return n.regexContains(r);
}
function arrayFilter(e, t, n) {
    return __PRIVATE_fieldOrExpression(e).arrayFilter(t, n);
}
function arrayTransform(e, t, n) {
    return __PRIVATE_fieldOrExpression(e).arrayTransform(t, n);
}
function arrayTransformWithIndex(e, t, n, r) {
    return __PRIVATE_fieldOrExpression(e).arrayTransformWithIndex(t, n, r);
}
function arraySlice(e, t, n) {
    return __PRIVATE_fieldOrExpression(e).arraySlice(t, n);
}
function arrayFirst(e) {
    return __PRIVATE_fieldOrExpression(e).arrayFirst();
}
function arrayFirstN(e, t) {
    return __PRIVATE_fieldOrExpression(e).arrayFirstN(__PRIVATE_valueToDefaultExpr(t));
}
function arrayLast(e) {
    return __PRIVATE_fieldOrExpression(e).arrayLast();
}
function arrayLastN(e, t) {
    return __PRIVATE_fieldOrExpression(e).arrayLastN(__PRIVATE_valueToDefaultExpr(t));
}
function arrayMaximum(e) {
    return __PRIVATE_fieldOrExpression(e).arrayMaximum();
}
function arrayMaximumN(e, t) {
    return __PRIVATE_fieldOrExpression(e).arrayMaximumN(__PRIVATE_valueToDefaultExpr(t));
}
function arrayMinimum(e) {
    return __PRIVATE_fieldOrExpression(e).arrayMinimum();
}
function arrayMinimumN(e, t) {
    return __PRIVATE_fieldOrExpression(e).arrayMinimumN(__PRIVATE_valueToDefaultExpr(t));
}
function arrayIndexOf(e, t) {
    return __PRIVATE_fieldOrExpression(e).arrayIndexOf(__PRIVATE_valueToDefaultExpr(t));
}
function arrayLastIndexOf(e, t) {
    return __PRIVATE_fieldOrExpression(e).arrayLastIndexOf(__PRIVATE_valueToDefaultExpr(t));
}
function arrayIndexOfAll(e, t) {
    return __PRIVATE_fieldOrExpression(e).arrayIndexOfAll(__PRIVATE_valueToDefaultExpr(t));
}
function regexFind(e, t) {
    var n = __PRIVATE_fieldOrExpression(e), r = __PRIVATE_valueToDefaultExpr(t);
    return n.regexFind(r);
}
function regexFindAll(e, t) {
    var n = __PRIVATE_fieldOrExpression(e), r = __PRIVATE_valueToDefaultExpr(t);
    return n.regexFindAll(r);
}
function regexMatch(e, t) {
    var n = __PRIVATE_fieldOrExpression(e), r = __PRIVATE_valueToDefaultExpr(t);
    return n.regexMatch(r);
}
function stringContains(e, t) {
    var n = __PRIVATE_fieldOrExpression(e), r = __PRIVATE_valueToDefaultExpr(t);
    return n.stringContains(r);
}
function startsWith(e, t) {
    return __PRIVATE_fieldOrExpression(e).startsWith(__PRIVATE_valueToDefaultExpr(t));
}
function endsWith(e, t) {
    return __PRIVATE_fieldOrExpression(e).endsWith(__PRIVATE_valueToDefaultExpr(t));
}
function toLower(e) {
    return __PRIVATE_fieldOrExpression(e).toLower();
}
function toUpper(e) {
    return __PRIVATE_fieldOrExpression(e).toUpper();
}
function trim(e, t) {
    return __PRIVATE_fieldOrExpression(e).trim(t);
}
function ltrim(e, t) {
    return __PRIVATE_fieldOrExpression(e).ltrim(t);
}
function rtrim(e, t) {
    return __PRIVATE_fieldOrExpression(e).rtrim(t);
}
function type(e) {
    return __PRIVATE_fieldOrExpression(e).type();
}
function isType(e, t) {
    return __PRIVATE_fieldOrExpression(e).isType(t);
}
function stringConcat(e, t) {
    for(var _len = arguments.length, n = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        n[_key - 2] = arguments[_key];
    }
    var _$__PRIVATE_fieldOrExpression;
    return (_$__PRIVATE_fieldOrExpression = __PRIVATE_fieldOrExpression(e)).stringConcat.apply(_$__PRIVATE_fieldOrExpression, [
        __PRIVATE_valueToDefaultExpr(t)
    ].concat((0, $jlUaU._)(n.map(__PRIVATE_valueToDefaultExpr))));
}
function stringIndexOf(e, t) {
    return __PRIVATE_fieldOrExpression(e).stringIndexOf(t);
}
function stringRepeat(e, t) {
    return __PRIVATE_fieldOrExpression(e).stringRepeat(t);
}
function stringReplaceAll(e, t, n) {
    return __PRIVATE_fieldOrExpression(e).stringReplaceAll(t, n);
}
function stringReplaceOne(e, t, n) {
    return __PRIVATE_fieldOrExpression(e).stringReplaceOne(t, n);
}
function mapGet(e, t) {
    return __PRIVATE_fieldOrExpression(e).mapGet(t);
}
function mapSet(e, t, n) {
    for(var _len = arguments.length, r = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
        r[_key - 3] = arguments[_key];
    }
    var _$__PRIVATE_fieldOrExpression;
    return (_$__PRIVATE_fieldOrExpression = __PRIVATE_fieldOrExpression(e)).mapSet.apply(_$__PRIVATE_fieldOrExpression, [
        t,
        n
    ].concat((0, $jlUaU._)(r)));
}
function mapKeys(e) {
    return __PRIVATE_fieldOrExpression(e).mapKeys();
}
function mapValues(e) {
    return __PRIVATE_fieldOrExpression(e).mapValues();
}
function mapEntries(e) {
    return __PRIVATE_fieldOrExpression(e).mapEntries();
}
/**
 * Creates an aggregation that counts the total number of stage inputs.
 *
 * @example
 * ```typescript
 * // Count the total number of input documents
 * countAll().as("totalDocument");
 * ```
 *
 * @returns A new {@link @firebase/firestore/pipelines#AggregateFunction} representing the 'countAll' aggregation.
 */ function countAll() {
    return k._create("count", [], "count");
}
function count(e) {
    return __PRIVATE_fieldOrExpression(e).count();
}
function sum(e) {
    return __PRIVATE_fieldOrExpression(e).sum();
}
function average(e) {
    return __PRIVATE_fieldOrExpression(e).average();
}
function minimum(e) {
    return __PRIVATE_fieldOrExpression(e).minimum();
}
function maximum(e) {
    return __PRIVATE_fieldOrExpression(e).maximum();
}
function first(e) {
    return __PRIVATE_fieldOrExpression(e).first();
}
function last(e) {
    return __PRIVATE_fieldOrExpression(e).last();
}
function arrayAgg(e) {
    return __PRIVATE_fieldOrExpression(e).arrayAgg();
}
function arrayAggDistinct(e) {
    return __PRIVATE_fieldOrExpression(e).arrayAggDistinct();
}
function cosineDistance(e, t) {
    var n = __PRIVATE_fieldOrExpression(e), r = __PRIVATE_vectorToExpr(t);
    return n.cosineDistance(r);
}
function dotProduct(e, t) {
    var n = __PRIVATE_fieldOrExpression(e), r = __PRIVATE_vectorToExpr(t);
    return n.dotProduct(r);
}
function euclideanDistance(e, t) {
    var n = __PRIVATE_fieldOrExpression(e), r = __PRIVATE_vectorToExpr(t);
    return n.euclideanDistance(r);
}
function vectorLength(e) {
    return __PRIVATE_fieldOrExpression(e).vectorLength();
}
function unixMicrosToTimestamp(e) {
    return __PRIVATE_fieldOrExpression(e).unixMicrosToTimestamp();
}
function timestampToUnixMicros(e) {
    return __PRIVATE_fieldOrExpression(e).timestampToUnixMicros();
}
function unixMillisToTimestamp(e) {
    return __PRIVATE_fieldOrExpression(e).unixMillisToTimestamp();
}
function timestampToUnixMillis(e) {
    return __PRIVATE_fieldOrExpression(e).timestampToUnixMillis();
}
function unixSecondsToTimestamp(e) {
    return __PRIVATE_fieldOrExpression(e).unixSecondsToTimestamp();
}
function timestampToUnixSeconds(e) {
    return __PRIVATE_fieldOrExpression(e).timestampToUnixSeconds();
}
function timestampAdd(e, t, n) {
    var r = __PRIVATE_fieldOrExpression(e), i = __PRIVATE_valueToDefaultExpr(t), s = __PRIVATE_valueToDefaultExpr(n);
    return r.timestampAdd(i, s);
}
function timestampSubtract(e, t, n) {
    var r = __PRIVATE_fieldOrExpression(e), i = __PRIVATE_valueToDefaultExpr(t), s = __PRIVATE_valueToDefaultExpr(n);
    return r.timestampSubtract(i, s);
}
/**
 *
 * Creates an expression that evaluates to the current server timestamp.
 *
 * @example
 * ```typescript
 * // Get the current server timestamp
 * currentTimestamp()
 * ```
 *
 * @returns A new Expression representing the current server timestamp.
 */ function currentTimestamp() {
    return new y("current_timestamp", [], "currentTimestamp");
}
/**
 *
 * Creates an expression that performs a logical 'AND' operation on multiple filter conditions.
 *
 * @example
 * ```typescript
 * // Check if the 'age' field is greater than 18 AND the 'city' field is "London" AND
 * // the 'status' field is "active"
 * const condition = and(greaterThan("age", 18), equal("city", "London"), equal("status", "active"));
 * ```
 *
 * @param first - The first filter condition.
 * @param second - The second filter condition.
 * @param more - Additional filter conditions to 'AND' together.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the logical 'AND' operation.
 */ function and(e, t) {
    for(var _len = arguments.length, n = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        n[_key - 2] = arguments[_key];
    }
    return new y("and", [
        e,
        t
    ].concat((0, $jlUaU._)(n)), "and").asBoolean();
}
/**
 *
 * Creates an expression that performs a logical 'OR' operation on multiple filter conditions.
 *
 * @example
 * ```typescript
 * // Check if the 'age' field is greater than 18 OR the 'city' field is "London" OR
 * // the 'status' field is "active"
 * const condition = or(greaterThan("age", 18), equal("city", "London"), equal("status", "active"));
 * ```
 *
 * @param first - The first filter condition.
 * @param second - The second filter condition.
 * @param more - Additional filter conditions to 'OR' together.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the logical 'OR' operation.
 */ function or(e, t) {
    for(var _len = arguments.length, n = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        n[_key - 2] = arguments[_key];
    }
    return new y("or", [
        e,
        t
    ].concat((0, $jlUaU._)(n)), "xor").asBoolean();
}
/**
 *
 * Creates an expression that performs a logical 'NOR' operation on multiple filter conditions.
 *
 * @example
 * ```typescript
 * // Check if neither the 'age' field is greater than 18 nor the 'city' field is "London"
 * const condition = nor(
 *   greaterThan("age", 18),
 *   equal("city", "London")
 * );
 * ```
 *
 * @param first - The first filter condition.
 * @param second - The second filter condition.
 * @param more - Additional filter conditions to 'NOR' together.
 * @returns A new {@link @firebase/firestore/pipelines#BooleanExpression} representing the logical 'NOR' operation.
 */ function nor(e, t) {
    for(var _len = arguments.length, n = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        n[_key - 2] = arguments[_key];
    }
    return new y("nor", [
        e,
        t
    ].concat((0, $jlUaU._)(n)), "nor").asBoolean();
}
function pow(e, t) {
    return __PRIVATE_fieldOrExpression(e).pow(t);
}
/**
 *
 * Creates an expression that generates a random number between 0.0 and 1.0 but not including 1.0.
 *
 * @example
 * ```typescript
 * // Generate a random number between 0.0 and 1.0.
 * rand();
 * ```
 *
 * @returns A new `Expression` representing the rand operation.
 */ function rand() {
    return new y("rand", [], "rand");
}
function round(e, t) {
    return void 0 === t ? __PRIVATE_fieldOrExpression(e).round() : __PRIVATE_fieldOrExpression(e).round(__PRIVATE_valueToDefaultExpr(t));
}
function trunc(e, t) {
    return void 0 === t ? __PRIVATE_fieldOrExpression(e).trunc() : __PRIVATE_fieldOrExpression(e).trunc(__PRIVATE_valueToDefaultExpr(t));
}
function collectionId(e) {
    return __PRIVATE_fieldOrExpression(e).collectionId();
}
function length(e) {
    return __PRIVATE_fieldOrExpression(e).length();
}
function ln(e) {
    return __PRIVATE_fieldOrExpression(e).ln();
}
function log(e, t) {
    return new y("log", [
        __PRIVATE_fieldOrExpression(e),
        __PRIVATE_valueToDefaultExpr(t)
    ]);
}
function sqrt(e) {
    return __PRIVATE_fieldOrExpression(e).sqrt();
}
function stringReverse(e) {
    return __PRIVATE_fieldOrExpression(e).stringReverse();
}
function concat(e, t) {
    for(var _len = arguments.length, n = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        n[_key - 2] = arguments[_key];
    }
    return new y("concat", [
        __PRIVATE_fieldOrExpression(e),
        __PRIVATE_valueToDefaultExpr(t)
    ].concat((0, $jlUaU._)(n.map(__PRIVATE_valueToDefaultExpr))));
}
function abs(e) {
    return __PRIVATE_fieldOrExpression(e).abs();
}
function ifAbsent(e, t) {
    return __PRIVATE_fieldOrExpression(e).ifAbsent(__PRIVATE_valueToDefaultExpr(t));
}
function ifNull(e, t) {
    return __PRIVATE_fieldOrExpression(e).ifNull(t);
}
function coalesce(e, t) {
    for(var _len = arguments.length, n = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        n[_key - 2] = arguments[_key];
    }
    var _$__PRIVATE_fieldOrExpression;
    return (_$__PRIVATE_fieldOrExpression = __PRIVATE_fieldOrExpression(e)).coalesce.apply(_$__PRIVATE_fieldOrExpression, [
        t
    ].concat((0, $jlUaU._)(n)));
}
/**
 * Creates an expression that evaluates to the result corresponding to the first true condition.
 *
 * @remarks
 * This function behaves like a `switch` statement. It accepts an alternating sequence of conditions
 * and their corresponding results.
 * If an odd number of arguments is provided, the final argument serves as a default fallback result.
 * If no default is provided and no condition evaluates to true, it throws an error.
 *
 * @example
 * ```typescript
 * // Return "Active" if field "status" is 1, "Pending" if field "status" is 2,
 * // and default to "Unknown" if none of the conditions are true.
 * switchOn(
 *   equal(field("status"), 1), constant("Active"),
 *   equal(field("status"), 2), constant("Pending"),
 *   constant("Unknown")
 * )
 * ```
 *
 * @param condition - The first condition to check.
 * @param result - The result if the first condition is true.
 * @param others - Additional conditions and results, and optionally a default value.
 * @returns A new Expression representing the switch operation.
 */ function switchOn(e, t) {
    for(var _len = arguments.length, n = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        n[_key - 2] = arguments[_key];
    }
    return new y("switch_on", [
        __PRIVATE_valueToDefaultExpr(e),
        __PRIVATE_valueToDefaultExpr(t)
    ].concat((0, $jlUaU._)(n.map(__PRIVATE_valueToDefaultExpr))), "switchOn");
}
function join(e, t) {
    return __PRIVATE_fieldOrExpression(e).join(__PRIVATE_valueToDefaultExpr(t));
}
function log10(e) {
    return __PRIVATE_fieldOrExpression(e).log10();
}
function arraySum(e) {
    return __PRIVATE_fieldOrExpression(e).arraySum();
}
function split(e, t) {
    return __PRIVATE_fieldOrExpression(e).split(__PRIVATE_valueToDefaultExpr(t));
}
function timestampTruncate(e, t, n) {
    var r = __PRIVATE_isString$1(t) ? __PRIVATE_valueToDefaultExpr(t) : t;
    return __PRIVATE_fieldOrExpression(e).timestampTruncate(r, n);
}
/**
 * @public
 * Creates an expression that retrieves the value of a variable bound via `define()`.
 *
 * @example
 * ```typescript
 * db.pipeline().collection("products")
 *   .define(
 *     field("price").multiply(0.9).as("discountedPrice"),
 *     field("stock").add(10).as("newStock")
 *   )
 *   .where(variable("discountedPrice").lessThan(100))
 *   .select(field("name"), variable("newStock"));
 * ```
 *
 * @param name - The name of the variable to retrieve.
 * @returns An {@link @firebase/firestore/pipelines#Expression} representing the variable's value.
 */ function variable(e) {
    return new __PRIVATE_VariableExpression(e);
}
/**
 * @internal
 *
 * Expression representing a variable reference. This evaluates to the value of a variable
 * defined in a pipeline.
 */ var __PRIVATE_VariableExpression = /*#__PURE__*/ function(t) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_VariableExpression, t);
    function __PRIVATE_VariableExpression(e) {
        (0, $4QweW._)(this, __PRIVATE_VariableExpression);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_VariableExpression), _this.name = e, _this.expressionType = "Variable";
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_VariableExpression, [
        {
            /**
     * @internal
     */ key: "_toProto",
            value: function _toProto(e) {
                return {
                    variableReferenceValue: this.name
                };
            }
        },
        {
            /**
     * @internal
     */ key: "_readUserData",
            value: function _readUserData(e) {}
        }
    ]);
    return __PRIVATE_VariableExpression;
}(t);
/**
 * @public
 * Creates an expression that represents the current document being processed.
 *
 * @example
 * ```typescript
 * // Define the current document as a variable "doc"
 * firestore.pipeline().collection("books")
 *     .define(currentDocument().as("doc"))
 *     // Access a field from the defined document variable
 *     .select(variable("doc").mapGet("title"));
 * ```
 *
 * @returns An {@link @firebase/firestore/pipelines#Expression} representing the current document.
 */ function currentDocument() {
    return new y("current_document", []);
}
/**
 * @internal
 */ function d(e) {
    return new __PRIVATE_PipelineValueExpression(e);
}
/**
 * @internal
 */ var __PRIVATE_PipelineValueExpression = /*#__PURE__*/ function(t) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_PipelineValueExpression, t);
    function __PRIVATE_PipelineValueExpression(e) {
        (0, $4QweW._)(this, __PRIVATE_PipelineValueExpression);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_PipelineValueExpression), _this.pipeline = e, _this.expressionType = "PipelineValue";
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_PipelineValueExpression, [
        {
            /**
     * @internal
     */ key: "_toProto",
            value: function _toProto(e) {
                return __PRIVATE_toPipelineValue(this.pipeline._toProto(e));
            }
        },
        {
            /**
     * @internal
     */ key: "_readUserData",
            value: function _readUserData(e) {
                this.pipeline._readUserData(e);
            }
        }
    ]);
    return __PRIVATE_PipelineValueExpression;
}(t);
function timestampDiff(e, t, n) {
    var r = __PRIVATE_fieldOrExpression(e), i = __PRIVATE_fieldOrExpression(t), s = __PRIVATE_valueToDefaultExpr(n);
    return r.timestampDiff(i, s);
}
function timestampExtract(e, t, n) {
    return __PRIVATE_fieldOrExpression(e).timestampExtract(__PRIVATE_valueToDefaultExpr(t), n);
}
// TODO(search) enable with backend support
// /**
//  * Perform a full-text search on the specified field.
//  *
//  * @remarks This Expression can only be used within a `search` stage.
//  *
//  * @example
//  * ```typescript
//  * db.pipeline().collection('restaurants').search({
//  *   query: matches('menu', 'waffles')
//  * })
//  * ```
//  *
//  * @param searchField Search the specified field.
//  * @param rquery Define the search query using the search domain-specific language (DSL).
//  */
// export function matches(
//   searchField: string | Field,
//   rquery: string | Expression
// ): BooleanExpression {
//   return toField(searchField).matches(rquery);
// }
/**
 * @beta
 * Perform a full-text search on all indexed search fields in the document.
 *
 * @remarks This Expression can only be used within a `search` stage.
 *
 * @example
 * ```typescript
 * db.pipeline().collection('restaurants').search({
 *   query: documentMatches('waffles OR pancakes')
 * })
 * ```
 *
 * @param rquery Define the search query using the search domain-specific language (DSL).
 */ function j(e) {
    return new y("document_matches", [
        __PRIVATE_valueToDefaultExpr(e)
    ], "documentMatches").asBoolean();
}
/**
 * @beta
 *
 * Evaluates to the search score that reflects the topicality of the document
 * to all of the text predicates (for example: `documentMatches`)
 * in the search query. If `SearchOptions.query` is not set or does not contain
 * any text predicates, then this topicality score will always be `0`.
 *
 * @example
 * ```typescript
 * db.pipeline().collection('restaurants').search({
 *   query: 'waffles',
 *   sort: score().descending()
 * })
 * ```
 *
 * @remarks This Expression can only be used within a `search` stage.
 */ function score() {
    return new y("score", [], "score");
}
// TODO(search) enable with backend support
// /**
//  * Options defining how a snippet expression is evaluated.
//  */
// export interface SnippetOptions {
//   /**
//    * Define the search query using the search domain-specific language (DSL).
//    */
//   rquery: string;
//   /**
//    * The maximum width of the string estimated for a variable width font. The
//    * unit is tenths of ems. The default is `160`.
//    */
//   maxSnippetWidth?: number;
//   /**
//    * The maximum number of non-contiguous pieces of text in the returned snippet.
//    * The default is `1`.
//    */
//   maxSnippets?: number;
//   /**
//    * The string to join the pieces. The default value is '\n'
//    */
//   separator?: string;
// }
// /**
//  * Evaluates to an HTML-formatted text snippet that highlights terms matching
//  * the search query in `<b>bold</b>`.
//  *
//  * @remarks This Expression can only be used within a `search` stage.
//  *
//  * @example
//  * ```typescript
//  * db.pipeline().collection('restaurants').search({
//  *   query: 'waffles',
//  *   addFields: { snippet: snippet('menu', 'waffles') }
//  * })
//  * ```
//  *
//  * @param searchField Search the specified field for matching terms.
//  * @param rquery Define the search query using the search domain-specific language (DSL).
//  */
// export function snippet(
//   searchField: string | Field,
//   rquery: string
// ): Expression;
// /**
//  * Evaluates to an HTML-formatted text snippet that highlights terms matching
//  * the search query in `<b>bold</b>`.
//  *
//  * @remarks This Expression can only be used within a `search` stage.
//  *
//  * @param searchField Search the specified field for matching terms.
//  * @param options Define the search query using the search domain-specific language (DSL).
//  */
// export function snippet(
//   searchField: string | Field,
//   options: SnippetOptions
// ): Expression;
// export function snippet(
//   field: string | Field,
//   queryOrOptions: string | SnippetOptions
// ): Expression {
//   return toField(field).snippet(
//     isString(queryOrOptions) ? { rquery: queryOrOptions } : queryOrOptions
//   );
// }
/**
 * @beta
 * Evaluates to the distance in meters between the location in the specified
 * field and the query location.
 *
 * @remarks This Expression can only be used within a `search` stage.
 *
 * @example
 * ```typescript
 * db.pipeline().collection('restaurants').search({
 *   query: 'waffles',
 *   sort: geoDistance('location', new GeoPoint(37.0, -122.0)).ascending()
 * })
 * ```
 *
 * @param fieldName - Specifies the field in the document which contains
 * the first GeoPoint for distance computation.
 * @param location - Compute distance to this GeoPoint.
 */ function geoDistance(e, t) {
    return S(e).geoDistance(t);
}
function ascending(e) {
    return new Ordering(__PRIVATE_fieldOrExpression(e), "ascending", "ascending");
}
function descending(e) {
    return new Ordering(__PRIVATE_fieldOrExpression(e), "descending", "descending");
}
/**
 *
 * Represents an ordering criterion for sorting documents in a Firestore pipeline.
 *
 * You create `Ordering` instances using the `ascending` and `descending` helper functions.
 */ var Ordering = /*#__PURE__*/ function() {
    "use strict";
    function Ordering(e, t, n) {
        (0, $4QweW._)(this, Ordering);
        this.expr = e, this.direction = t, this._methodName = n, this._protoValueType = "ProtoValue";
    }
    (0, $6hK4i._)(Ordering, [
        {
            /**
     * @private
     * @internal
     */ key: "_toProto",
            value: function _toProto(e) {
                return {
                    mapValue: {
                        fields: {
                            direction: __PRIVATE_toStringValue(this.direction),
                            expression: this.expr._toProto(e)
                        }
                    }
                };
            }
        },
        {
            /**
     * @private
     * @internal
     */ key: "_readUserData",
            value: function _readUserData(e) {
                this.expr._readUserData(e);
            }
        }
    ]);
    return Ordering;
}();
function f(e) {
    var t = e;
    return t.selectable && __PRIVATE_isString$1(t.alias) && F(t.expr);
}
function q(e) {
    var t = e;
    return null != t && F(t.expr) && ("ascending" === t.direction || "descending" === t.direction);
}
function V(e) {
    var t = e;
    return __PRIVATE_isString$1(t.alias) && t.aggregate instanceof k;
}
function F(e) {
    return e instanceof t;
}
function E(e) {
    return e instanceof BooleanExpression;
}
function T(e) {
    return e instanceof c;
}
function g(e) {
    return e instanceof o;
}
function S(e) {
    if (__PRIVATE_isString$1(e)) return s(e);
    return e;
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var Stage = /*#__PURE__*/ function() {
    "use strict";
    function Stage(e) {
        (0, $4QweW._)(this, Stage);
        var _e;
        var ref;
        /**
         * Store _optionsProto parsed by _readUserData.
         * @private
         * @internal
         * @protected
         */ this.optionsProto = void 0, _e = e, this.knownOptions = (0, $1DiK7._)(_e, [
            "rawOptions"
        ]), ref = _e, this.rawOptions = ref.rawOptions, ref, _e;
    }
    (0, $6hK4i._)(Stage, [
        {
            key: "_readUserData",
            value: function _readUserData(e) {
                this.optionsProto = this._optionsUtil.getOptionsProto(e, this.knownOptions, this.rawOptions);
            }
        },
        {
            key: "_toProto",
            value: function _toProto(e) {
                return {
                    name: this._name,
                    options: this.optionsProto
                };
            }
        }
    ]);
    return Stage;
}();
var w = /*#__PURE__*/ function(Stage) {
    "use strict";
    (0, $c2MhV._)(w, Stage);
    function w(e, t) {
        (0, $4QweW._)(this, w);
        var _this;
        _this = (0, $ehF45._)(this, w, [
            t
        ]), _this.fields = e;
        return _this;
    }
    (0, $6hK4i._)(w, [
        {
            key: "_name",
            get: function get() {
                return "add_fields";
            }
        },
        {
            key: "_optionsUtil",
            get: function get() {
                return new OptionsUtil({});
            }
        },
        {
            key: "_toProto",
            value: function _toProto(e) {
                return (0, $hApvp._)((0, $kWfK0._)({}, (0, $hC9N3._)((0, $9atk1._)(w.prototype), "_toProto", this).call(this, e)), {
                    args: [
                        toMapValue(e, this.fields)
                    ]
                });
            }
        },
        {
            key: "_readUserData",
            value: function _readUserData(e) {
                (0, $hC9N3._)((0, $9atk1._)(w.prototype), "_readUserData", this).call(this, e), __PRIVATE_readUserDataHelper(this.fields, e);
            }
        }
    ]);
    return w;
}(Stage);
var _ = /*#__PURE__*/ function(Stage) {
    "use strict";
    (0, $c2MhV._)(_, Stage);
    function _(e, t) {
        (0, $4QweW._)(this, _);
        var _this;
        _this = (0, $ehF45._)(this, _, [
            t
        ]), _this.fields = e;
        return _this;
    }
    (0, $6hK4i._)(_, [
        {
            key: "_name",
            get: function get() {
                return "remove_fields";
            }
        },
        {
            key: "_optionsUtil",
            get: function get() {
                return new OptionsUtil({});
            }
        },
        {
            /**
     * @internal
     * @private
     */ key: "_toProto",
            value: function _toProto(e) {
                return (0, $hApvp._)((0, $kWfK0._)({}, (0, $hC9N3._)((0, $9atk1._)(_.prototype), "_toProto", this).call(this, e)), {
                    args: this.fields.map(function(t) {
                        return t._toProto(e);
                    })
                });
            }
        },
        {
            key: "_readUserData",
            value: function _readUserData(e) {
                (0, $hC9N3._)((0, $9atk1._)(_.prototype), "_readUserData", this).call(this, e), __PRIVATE_readUserDataHelper(this.fields, e);
            }
        }
    ]);
    return _;
}(Stage);
/**
 * @public
 */ var P = /*#__PURE__*/ function(Stage) {
    "use strict";
    (0, $c2MhV._)(P, Stage);
    function P(e, t) {
        (0, $4QweW._)(this, P);
        var _this;
        _this = (0, $ehF45._)(this, P, [
            t
        ]), _this.Er = e;
        return _this;
    }
    (0, $6hK4i._)(P, [
        {
            key: "_name",
            get: function get() {
                return "let";
            }
        },
        {
            key: "_optionsUtil",
            get: function get() {
                return new OptionsUtil({});
            }
        },
        {
            /**
     * @internal
     * @private
     */ key: "_toProto",
            value: function _toProto(e) {
                return (0, $hApvp._)((0, $kWfK0._)({}, (0, $hC9N3._)((0, $9atk1._)(P.prototype), "_toProto", this).call(this, e)), {
                    args: [
                        toMapValue(e, this.Er)
                    ]
                });
            }
        },
        {
            key: "_readUserData",
            value: function _readUserData(e) {
                (0, $hC9N3._)((0, $9atk1._)(P.prototype), "_readUserData", this).call(this, e), __PRIVATE_readUserDataHelper(this.Er, e);
            }
        }
    ]);
    return P;
}(Stage);
var O = /*#__PURE__*/ function(Stage) {
    "use strict";
    (0, $c2MhV._)(O, Stage);
    function O(e, t, n) {
        (0, $4QweW._)(this, O);
        var _this;
        _this = (0, $ehF45._)(this, O, [
            n
        ]), _this.groups = e, _this.accumulators = t;
        return _this;
    }
    (0, $6hK4i._)(O, [
        {
            key: "_name",
            get: function get() {
                return "aggregate";
            }
        },
        {
            key: "_optionsUtil",
            get: function get() {
                return new OptionsUtil({});
            }
        },
        {
            /**
     * @internal
     * @private
     */ key: "_toProto",
            value: function _toProto(e) {
                return (0, $hApvp._)((0, $kWfK0._)({}, (0, $hC9N3._)((0, $9atk1._)(O.prototype), "_toProto", this).call(this, e)), {
                    args: [
                        toMapValue(e, this.accumulators),
                        toMapValue(e, this.groups)
                    ]
                });
            }
        },
        {
            key: "_readUserData",
            value: function _readUserData(e) {
                (0, $hC9N3._)((0, $9atk1._)(O.prototype), "_readUserData", this).call(this, e), __PRIVATE_readUserDataHelper(this.groups, e), __PRIVATE_readUserDataHelper(this.accumulators, e);
            }
        }
    ]);
    return O;
}(Stage);
var M = /*#__PURE__*/ function(Stage) {
    "use strict";
    (0, $c2MhV._)(M, Stage);
    function M(e, t) {
        (0, $4QweW._)(this, M);
        var _this;
        _this = (0, $ehF45._)(this, M, [
            t
        ]), _this.groups = e;
        return _this;
    }
    (0, $6hK4i._)(M, [
        {
            key: "_name",
            get: function get() {
                return "distinct";
            }
        },
        {
            key: "_optionsUtil",
            get: function get() {
                return new OptionsUtil({});
            }
        },
        {
            /**
     * @internal
     * @private
     */ key: "_toProto",
            value: function _toProto(e) {
                return (0, $hApvp._)((0, $kWfK0._)({}, (0, $hC9N3._)((0, $9atk1._)(M.prototype), "_toProto", this).call(this, e)), {
                    args: [
                        toMapValue(e, this.groups)
                    ]
                });
            }
        },
        {
            key: "_readUserData",
            value: function _readUserData(e) {
                (0, $hC9N3._)((0, $9atk1._)(M.prototype), "_readUserData", this).call(this, e), __PRIVATE_readUserDataHelper(this.groups, e);
            }
        }
    ]);
    return M;
}(Stage);
var X = /*#__PURE__*/ function(Stage) {
    "use strict";
    (0, $c2MhV._)(X, Stage);
    function X(e, t) {
        (0, $4QweW._)(this, X);
        var _this;
        _this = (0, $ehF45._)(this, X, [
            t
        ]), // prepend slash to collection string
        _this.hr = e.startsWith("/") ? e : "/" + e;
        return _this;
    }
    (0, $6hK4i._)(X, [
        {
            key: "_name",
            get: function get() {
                return "collection";
            }
        },
        {
            key: "_optionsUtil",
            get: function get() {
                return new OptionsUtil({
                    forceIndex: {
                        serverName: "force_index"
                    }
                });
            }
        },
        {
            /**
     * @internal
     * @private
     */ key: "_toProto",
            value: function _toProto(e) {
                return (0, $hApvp._)((0, $kWfK0._)({}, (0, $hC9N3._)((0, $9atk1._)(X.prototype), "_toProto", this).call(this, e)), {
                    args: [
                        {
                            referenceValue: this.hr
                        }
                    ]
                });
            }
        },
        {
            key: "_readUserData",
            value: function _readUserData(e) {
                (0, $hC9N3._)((0, $9atk1._)(X.prototype), "_readUserData", this).call(this, e);
            }
        }
    ]);
    return X;
}(Stage);
var Y = /*#__PURE__*/ function(Stage) {
    "use strict";
    (0, $c2MhV._)(Y, Stage);
    function Y(e, t) {
        (0, $4QweW._)(this, Y);
        var _this;
        _this = (0, $ehF45._)(this, Y, [
            t
        ]), _this.collectionId = e;
        return _this;
    }
    (0, $6hK4i._)(Y, [
        {
            key: "_name",
            get: function get() {
                return "collection_group";
            }
        },
        {
            key: "_optionsUtil",
            get: function get() {
                return new OptionsUtil({
                    forceIndex: {
                        serverName: "force_index"
                    }
                });
            }
        },
        {
            /**
     * @internal
     * @private
     */ key: "_toProto",
            value: function _toProto(e) {
                return (0, $hApvp._)((0, $kWfK0._)({}, (0, $hC9N3._)((0, $9atk1._)(Y.prototype), "_toProto", this).call(this, e)), {
                    args: [
                        {
                            referenceValue: ""
                        },
                        {
                            stringValue: this.collectionId
                        }
                    ]
                });
            }
        },
        {
            key: "_readUserData",
            value: function _readUserData(e) {
                (0, $hC9N3._)((0, $9atk1._)(Y.prototype), "_readUserData", this).call(this, e);
            }
        }
    ]);
    return Y;
}(Stage);
var ia = /*#__PURE__*/ function(Stage) {
    "use strict";
    (0, $c2MhV._)(ia, Stage);
    function ia(e, t) {
        (0, $4QweW._)(this, ia);
        var _this;
        _this = (0, $ehF45._)(this, ia, [
            t
        ]), _this.path = e;
        return _this;
    }
    (0, $6hK4i._)(ia, [
        {
            key: "_name",
            get: function get() {
                return "subcollection";
            }
        },
        {
            key: "_optionsUtil",
            get: function get() {
                return new OptionsUtil({});
            }
        },
        {
            /**
     * @internal
     * @private
     */ key: "_toProto",
            value: function _toProto(e) {
                return (0, $hApvp._)((0, $kWfK0._)({}, (0, $hC9N3._)((0, $9atk1._)(ia.prototype), "_toProto", this).call(this, e)), {
                    args: [
                        {
                            stringValue: this.path
                        }
                    ]
                });
            }
        },
        {
            key: "_readUserData",
            value: function _readUserData(e) {
                (0, $hC9N3._)((0, $9atk1._)(ia.prototype), "_readUserData", this).call(this, e);
            }
        }
    ]);
    return ia;
}(Stage);
var Z = /*#__PURE__*/ function(Stage) {
    "use strict";
    (0, $c2MhV._)(Z, Stage);
    function Z() {
        (0, $4QweW._)(this, Z);
        return (0, $ehF45._)(this, Z, arguments);
    }
    (0, $6hK4i._)(Z, [
        {
            key: "_name",
            get: function get() {
                return "database";
            }
        },
        {
            key: "_optionsUtil",
            get: function get() {
                return new OptionsUtil({});
            }
        },
        {
            /**
     * @internal
     * @private
     */ key: "_toProto",
            value: function _toProto(e) {
                return (0, $kWfK0._)({}, (0, $hC9N3._)((0, $9atk1._)(Z.prototype), "_toProto", this).call(this, e));
            }
        },
        {
            key: "_readUserData",
            value: function _readUserData(e) {
                (0, $hC9N3._)((0, $9atk1._)(Z.prototype), "_readUserData", this).call(this, e);
            }
        }
    ]);
    return Z;
}(Stage);
var sa = /*#__PURE__*/ function(Stage) {
    "use strict";
    (0, $c2MhV._)(sa, Stage);
    function sa(t, n) {
        (0, $4QweW._)(this, sa);
        var _this;
        if (_this = (0, $ehF45._)(this, sa, [
            n
        ]), !t || 0 === t.length) throw new e(ta.INVALID_ARGUMENT, "Empty document paths are not allowed in DocumentsSource");
        var r = t.map(function(e) {
            return e.startsWith("/") ? e : "/" + e;
        }), i = new Set(r);
        if (i.size !== r.length) throw new e(ta.INVALID_ARGUMENT, "Duplicate document paths are not allowed in DocumentsSource");
        _this.Tr = r, _this.Pr = i;
        return _this;
    }
    (0, $6hK4i._)(sa, [
        {
            key: "_name",
            get: function get() {
                return "documents";
            }
        },
        {
            key: "_optionsUtil",
            get: function get() {
                return new OptionsUtil({});
            }
        },
        {
            /**
     * @internal
     * @private
     */ key: "_toProto",
            value: function _toProto(e) {
                return (0, $hApvp._)((0, $kWfK0._)({}, (0, $hC9N3._)((0, $9atk1._)(sa.prototype), "_toProto", this).call(this, e)), {
                    args: this.Tr.map(function(e) {
                        return {
                            referenceValue: e
                        };
                    })
                });
            }
        },
        {
            key: "_readUserData",
            value: function _readUserData(e) {
                (0, $hC9N3._)((0, $9atk1._)(sa.prototype), "_readUserData", this).call(this, e);
            }
        }
    ]);
    return sa;
}(Stage);
var A = /*#__PURE__*/ function(Stage) {
    "use strict";
    (0, $c2MhV._)(A, Stage);
    function A(e, t) {
        (0, $4QweW._)(this, A);
        var _this;
        _this = (0, $ehF45._)(this, A, [
            t
        ]), _this.condition = e;
        return _this;
    }
    (0, $6hK4i._)(A, [
        {
            key: "_name",
            get: function get() {
                return "where";
            }
        },
        {
            key: "_optionsUtil",
            get: function get() {
                return new OptionsUtil({});
            }
        },
        {
            /**
     * @internal
     * @private
     */ key: "_toProto",
            value: function _toProto(e) {
                return (0, $hApvp._)((0, $kWfK0._)({}, (0, $hC9N3._)((0, $9atk1._)(A.prototype), "_toProto", this).call(this, e)), {
                    args: [
                        this.condition._toProto(e)
                    ]
                });
            }
        },
        {
            key: "_readUserData",
            value: function _readUserData(e) {
                (0, $hC9N3._)((0, $9atk1._)(A.prototype), "_readUserData", this).call(this, e), __PRIVATE_readUserDataHelper(this.condition, e);
            }
        }
    ]);
    return A;
}(Stage);
var D = /*#__PURE__*/ function(Stage) {
    "use strict";
    (0, $c2MhV._)(D, Stage);
    function D(e, t, n, r) {
        (0, $4QweW._)(this, D);
        var _this;
        _this = (0, $ehF45._)(this, D, [
            r
        ]), _this.vectorValue = e, _this.field = t, _this.distanceMeasure = n;
        return _this;
    }
    (0, $6hK4i._)(D, [
        {
            key: "_name",
            get: function get() {
                return "find_nearest";
            }
        },
        {
            key: "_optionsUtil",
            get: function get() {
                return new OptionsUtil({
                    limit: {
                        serverName: "limit"
                    },
                    distanceField: {
                        serverName: "distance_field"
                    }
                });
            }
        },
        {
            /**
     * @private
     * @internal
     */ key: "_toProto",
            value: function _toProto(e) {
                return (0, $hApvp._)((0, $kWfK0._)({}, (0, $hC9N3._)((0, $9atk1._)(D.prototype), "_toProto", this).call(this, e)), {
                    args: [
                        this.field._toProto(e),
                        this.vectorValue._toProto(e),
                        __PRIVATE_toStringValue(this.distanceMeasure)
                    ]
                });
            }
        },
        {
            key: "_readUserData",
            value: function _readUserData(e) {
                (0, $hC9N3._)((0, $9atk1._)(D.prototype), "_readUserData", this).call(this, e), __PRIVATE_readUserDataHelper(this.vectorValue, e), __PRIVATE_readUserDataHelper(this.field, e);
            }
        }
    ]);
    return D;
}(Stage);
var v = /*#__PURE__*/ function(Stage) {
    "use strict";
    (0, $c2MhV._)(v, Stage);
    function v(e, t) {
        (0, $4QweW._)(this, v);
        var _this;
        __PRIVATE_hardAssert(!isNaN(e) && e !== 1 / 0 && e !== -1 / 0, 34860), _this = (0, $ehF45._)(this, v, [
            t
        ]), _this.limit = e;
        return _this;
    }
    (0, $6hK4i._)(v, [
        {
            key: "_name",
            get: function get() {
                return "limit";
            }
        },
        {
            key: "_optionsUtil",
            get: function get() {
                return new OptionsUtil({});
            }
        },
        {
            /**
     * @internal
     * @private
     */ key: "_toProto",
            value: function _toProto(e) {
                return (0, $hApvp._)((0, $kWfK0._)({}, (0, $hC9N3._)((0, $9atk1._)(v.prototype), "_toProto", this).call(this, e)), {
                    args: [
                        toNumber(e, this.limit)
                    ]
                });
            }
        }
    ]);
    return v;
}(Stage);
var I = /*#__PURE__*/ function(Stage) {
    "use strict";
    (0, $c2MhV._)(I, Stage);
    function I(e, t) {
        (0, $4QweW._)(this, I);
        var _this;
        _this = (0, $ehF45._)(this, I, [
            t
        ]), _this.offset = e;
        return _this;
    }
    (0, $6hK4i._)(I, [
        {
            key: "_name",
            get: function get() {
                return "offset";
            }
        },
        {
            key: "_optionsUtil",
            get: function get() {
                return new OptionsUtil({});
            }
        },
        {
            /**
     * @internal
     * @private
     */ key: "_toProto",
            value: function _toProto(e) {
                return (0, $hApvp._)((0, $kWfK0._)({}, (0, $hC9N3._)((0, $9atk1._)(I.prototype), "_toProto", this).call(this, e)), {
                    args: [
                        toNumber(e, this.offset)
                    ]
                });
            }
        }
    ]);
    return I;
}(Stage);
var x = /*#__PURE__*/ function(Stage) {
    "use strict";
    (0, $c2MhV._)(x, Stage);
    function x(e, t) {
        (0, $4QweW._)(this, x);
        var _this;
        _this = (0, $ehF45._)(this, x, [
            t
        ]), _this.selections = e;
        return _this;
    }
    (0, $6hK4i._)(x, [
        {
            key: "_name",
            get: function get() {
                return "select";
            }
        },
        {
            key: "_optionsUtil",
            get: function get() {
                return new OptionsUtil({});
            }
        },
        {
            /**
     * @internal
     * @private
     */ key: "_toProto",
            value: function _toProto(e) {
                return (0, $hApvp._)((0, $kWfK0._)({}, (0, $hC9N3._)((0, $9atk1._)(x.prototype), "_toProto", this).call(this, e)), {
                    args: [
                        toMapValue(e, this.selections)
                    ]
                });
            }
        },
        {
            key: "_readUserData",
            value: function _readUserData(e) {
                (0, $hC9N3._)((0, $9atk1._)(x.prototype), "_readUserData", this).call(this, e), __PRIVATE_readUserDataHelper(this.selections, e);
            }
        }
    ]);
    return x;
}(Stage);
var L = /*#__PURE__*/ function(Stage) {
    "use strict";
    (0, $c2MhV._)(L, Stage);
    function L(e, t) {
        (0, $4QweW._)(this, L);
        var _this;
        _this = (0, $ehF45._)(this, L, [
            t
        ]), _this.orderings = e;
        return _this;
    }
    (0, $6hK4i._)(L, [
        {
            key: "_name",
            get: function get() {
                return "sort";
            }
        },
        {
            key: "_optionsUtil",
            get: function get() {
                return new OptionsUtil({});
            }
        },
        {
            /**
     * @internal
     * @private
     */ key: "_toProto",
            value: function _toProto(e) {
                return (0, $hApvp._)((0, $kWfK0._)({}, (0, $hC9N3._)((0, $9atk1._)(L.prototype), "_toProto", this).call(this, e)), {
                    args: this.orderings.map(function(t) {
                        return t._toProto(e);
                    })
                });
            }
        },
        {
            key: "_readUserData",
            value: function _readUserData(e) {
                (0, $hC9N3._)((0, $9atk1._)(L.prototype), "_readUserData", this).call(this, e), __PRIVATE_readUserDataHelper(this.orderings, e);
            }
        }
    ]);
    return L;
}(Stage);
var N = /*#__PURE__*/ function(Stage) {
    "use strict";
    (0, $c2MhV._)(N, Stage);
    function N(e, t, n) {
        (0, $4QweW._)(this, N);
        var _this;
        _this = (0, $ehF45._)(this, N, [
            n
        ]), _this.rate = e, _this.mode = t;
        return _this;
    }
    (0, $6hK4i._)(N, [
        {
            key: "_name",
            get: function get() {
                return "sample";
            }
        },
        {
            key: "_optionsUtil",
            get: function get() {
                return new OptionsUtil({});
            }
        },
        {
            key: "_toProto",
            value: function _toProto(e) {
                return (0, $hApvp._)((0, $kWfK0._)({}, (0, $hC9N3._)((0, $9atk1._)(N.prototype), "_toProto", this).call(this, e)), {
                    args: [
                        toNumber(e, this.rate),
                        __PRIVATE_toStringValue(this.mode)
                    ]
                });
            }
        },
        {
            key: "_readUserData",
            value: function _readUserData(e) {
                (0, $hC9N3._)((0, $9atk1._)(N.prototype), "_readUserData", this).call(this, e);
            }
        }
    ]);
    return N;
}(Stage);
var U = /*#__PURE__*/ function(Stage) {
    "use strict";
    (0, $c2MhV._)(U, Stage);
    function U(e, t) {
        (0, $4QweW._)(this, U);
        var _this;
        _this = (0, $ehF45._)(this, U, [
            t
        ]), _this.other = e;
        return _this;
    }
    (0, $6hK4i._)(U, [
        {
            key: "_name",
            get: function get() {
                return "union";
            }
        },
        {
            key: "_optionsUtil",
            get: function get() {
                return new OptionsUtil({});
            }
        },
        {
            key: "_toProto",
            value: function _toProto(e) {
                return (0, $hApvp._)((0, $kWfK0._)({}, (0, $hC9N3._)((0, $9atk1._)(U.prototype), "_toProto", this).call(this, e)), {
                    args: [
                        __PRIVATE_toPipelineValue(this.other._toProto(e))
                    ]
                });
            }
        },
        {
            key: "_readUserData",
            value: function _readUserData(e) {
                this.other._readUserData(e), (0, $hC9N3._)((0, $9atk1._)(U.prototype), "_readUserData", this).call(this, e);
            }
        }
    ]);
    return U;
}(Stage);
var W = /*#__PURE__*/ function(Stage) {
    "use strict";
    (0, $c2MhV._)(W, Stage);
    function W(e, t, n) {
        (0, $4QweW._)(this, W);
        var _this;
        _this = (0, $ehF45._)(this, W, [
            n
        ]), _this.alias = e, _this.expr = t;
        return _this;
    }
    (0, $6hK4i._)(W, [
        {
            key: "_name",
            get: function get() {
                return "unnest";
            }
        },
        {
            key: "_optionsUtil",
            get: function get() {
                return new OptionsUtil({
                    indexField: {
                        serverName: "index_field"
                    }
                });
            }
        },
        {
            key: "_toProto",
            value: function _toProto(e) {
                return (0, $hApvp._)((0, $kWfK0._)({}, (0, $hC9N3._)((0, $9atk1._)(W.prototype), "_toProto", this).call(this, e)), {
                    args: [
                        this.expr._toProto(e),
                        s(this.alias)._toProto(e)
                    ]
                });
            }
        },
        {
            key: "_readUserData",
            value: function _readUserData(e) {
                (0, $hC9N3._)((0, $9atk1._)(W.prototype), "_readUserData", this).call(this, e), __PRIVATE_readUserDataHelper(this.expr, e);
            }
        }
    ]);
    return W;
}(Stage);
var $ = /*#__PURE__*/ function(Stage) {
    "use strict";
    (0, $c2MhV._)($, Stage);
    function $(e, t) {
        (0, $4QweW._)(this, $);
        var _this;
        _this = (0, $ehF45._)(this, $, [
            t
        ]), _this.map = e;
        return _this;
    }
    (0, $6hK4i._)($, [
        {
            key: "_name",
            get: function get() {
                return "replace_with";
            }
        },
        {
            key: "_optionsUtil",
            get: function get() {
                return new OptionsUtil({});
            }
        },
        {
            key: "_toProto",
            value: function _toProto(e) {
                return (0, $hApvp._)((0, $kWfK0._)({}, (0, $hC9N3._)((0, $9atk1._)($.prototype), "_toProto", this).call(this, e)), {
                    args: [
                        this.map._toProto(e),
                        __PRIVATE_toStringValue($.Ir)
                    ]
                });
            }
        },
        {
            key: "_readUserData",
            value: function _readUserData(e) {
                (0, $hC9N3._)((0, $9atk1._)($.prototype), "_readUserData", this).call(this, e), __PRIVATE_readUserDataHelper(this.map, e);
            }
        }
    ]);
    return $;
}(Stage);
$.Ir = "full_replace";
/**
 * @beta
 */ var C = /*#__PURE__*/ function(Stage) {
    "use strict";
    (0, $c2MhV._)(C, Stage);
    function C(e) {
        (0, $4QweW._)(this, C);
        var _this;
        _this = (0, $ehF45._)(this, C, [
            e
        ]), _this.Rr = e;
        return _this;
    }
    (0, $6hK4i._)(C, [
        {
            key: "_name",
            get: function get() {
                return "search";
            }
        },
        {
            key: "_optionsUtil",
            get: function get() {
                return new OptionsUtil({
                    query: {
                        serverName: "query"
                    },
                    limit: {
                        serverName: "limit"
                    },
                    retrievalDepth: {
                        serverName: "retrieval_depth"
                    },
                    sort: {
                        serverName: "sort"
                    },
                    addFields: {
                        serverName: "add_fields"
                    },
                    select: {
                        serverName: "select"
                    },
                    offset: {
                        serverName: "offset"
                    },
                    Ar: {
                        serverName: "query_enhancement"
                    },
                    languageCode: {
                        serverName: "language_code"
                    }
                });
            }
        },
        {
            /**
     * @private
     * @internal
     */ key: "_toProto",
            value: function _toProto(e) {
                return (0, $hApvp._)((0, $kWfK0._)({}, (0, $hC9N3._)((0, $9atk1._)(C.prototype), "_toProto", this).call(this, e)), {
                    args: []
                });
            }
        },
        {
            key: "_readUserData",
            value: function _readUserData(e) {
                __PRIVATE_readUserDataHelper(this.Rr.query, e), this.Rr.addFields && __PRIVATE_readUserDataHelper(this.Rr.addFields, e), this.Rr.select && __PRIVATE_readUserDataHelper(this.Rr.select, e), this.Rr.sort && __PRIVATE_readUserDataHelper(this.Rr.sort, e), (0, $hC9N3._)((0, $9atk1._)(C.prototype), "_readUserData", this).call(this, e);
            }
        }
    ]);
    return C;
}(Stage);
/**
 * @beta
 */ var Q = /*#__PURE__*/ function(Stage) {
    "use strict";
    (0, $c2MhV._)(Q, Stage);
    function Q(e, t, n) {
        (0, $4QweW._)(this, Q);
        var _this;
        _this = (0, $ehF45._)(this, Q, [
            {
                rawOptions: n
            }
        ]), _this.name = e, _this.params = t;
        return _this;
    }
    (0, $6hK4i._)(Q, [
        {
            /**
     * @internal
     * @private
     */ key: "_toProto",
            value: function _toProto(e) {
                return {
                    name: this.name,
                    args: this.params.map(function(t) {
                        return t._toProto(e);
                    }),
                    options: this.optionsProto
                };
            }
        },
        {
            key: "_readUserData",
            value: function _readUserData(e) {
                (0, $hC9N3._)((0, $9atk1._)(Q.prototype), "_readUserData", this).call(this, e), __PRIVATE_readUserDataHelper(this.params, e);
            }
        },
        {
            key: "_name",
            get: function get() {
                return this.name;
            }
        },
        {
            key: "_optionsUtil",
            get: function get() {
                return new OptionsUtil({});
            }
        }
    ]);
    return Q;
}(Stage);
/**
 * Helper to read user data across a number of different formats.
 * @param name - Name of the calling function. Used for error messages when invalid user data is encountered.
 * @param expressionMap
 * @returns the expressionMap argument.
 * @private
 */ function __PRIVATE_readUserDataHelper(e, t) {
    return __PRIVATE_isUserData(e) ? e._readUserData(t) : Array.isArray(e) ? e.forEach(function(e) {
        return e._readUserData(t);
    }) : e instanceof Map ? e.forEach(function(e) {
        return e._readUserData(t);
    }) : Object.values(e).forEach(function(e) {
        return e._readUserData(t);
    }), e;
}
/**
 * @license
 * Copyright 2026 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @beta
 * @internal
 *
 * The RealtimePipeline class provides a flexible and expressive framework for building complex data
 * transformation and query pipelines that can be used with Firestore's real-time and offline capabilities.
 *
 * A RealtimePipeline takes data sources, such as Firestore collections or collection groups, and applies
 * a series of stages that are chained together. Each stage takes the output from the previous stage
 * (or the data source) and produces an output for the next stage (or as the final output of the
 * pipeline).
 *
 * Expressions can be used within each stage to filter and transform data through the stage.
 *
 * NOTE: Both the initial and subsequent snapshots for RealtimePipeline take the consideration of the SDK's cache.
 * They might include results that have not been synchronized with the server yet, and wait for subsequent snapshots
 * to reflect the latest server state, this is the same as classic Firestore {@link Query}.
 * This behavior is different from the {@link Pipeline} class, which does not take the consideration of the SDK's cache.
 *
 * Usage Examples:
 *
 * ```typescript
 * const db: Firestore; // Assumes a valid firestore instance.
 *
 * // Example 1: Listen to books published after 1980
 * const unsubscribe = onRealtimePipelineSnapshot(db.realtimePipeline()
 *     .collection("books")
 *     .where(field("published").gt(1980)),
 *     (snapshot) => {
 *       // Handle the snapshot
 *     }
 * );
 * ```
 */ // TODO(pipeline): Add more examples to showcase functions
var __PRIVATE_RealtimePipeline = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_RealtimePipeline(/**
     * @internal
     * @private
     */ e, /**
     * @internal
     * @private
     */ t, /**
     * @internal
     * @private
     */ n, r) {
        (0, $4QweW._)(this, __PRIVATE_RealtimePipeline);
        this._db = e, this.userDataReader = t, this._userDataWriter = n, this.stages = r;
    }
    (0, $6hK4i._)(__PRIVATE_RealtimePipeline, [
        {
            /**
     * Reads user data for each expression in the expressionMap.
     * @param name Name of the calling function. Used for error messages when invalid user data is encountered.
     * @param expressionMap
     * @return the expressionMap argument.
     * @private
     * @internal
     */ key: "Vr",
            value: function Vr(e, t) {
                var n = this.userDataReader.createContext(3 /* UserDataSource.Argument */ , e);
                return __PRIVATE_isUserData(t) ? t._readUserData(n) : Array.isArray(t) ? t.forEach(function(e) {
                    return e._readUserData(n);
                }) : t.forEach(function(e) {
                    return e._readUserData(n);
                }), t;
            }
        },
        {
            key: "where",
            value: function where(e) {
                var t = this.stages.map(function(e) {
                    return e;
                });
                return this.Vr("where", e), t.push(new A(e, {})), new __PRIVATE_RealtimePipeline(this._db, this.userDataReader, this._userDataWriter, t);
            }
        },
        {
            key: "limit",
            value: function limit(e) {
                var t = this.stages.map(function(e) {
                    return e;
                });
                return t.push(new v(e, {})), new __PRIVATE_RealtimePipeline(this._db, this.userDataReader, this._userDataWriter, t);
            }
        },
        {
            key: "sort",
            value: function sort(e) {
                for(var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    t[_key - 1] = arguments[_key];
                }
                var n = this.stages.map(function(e) {
                    return e;
                });
                // Option object
                return "orderings" in e ? n.push(new L(this.Vr("sort", e.orderings), {})) : // Ordering object
                n.push(new L(this.Vr("sort", [
                    e
                ].concat((0, $jlUaU._)(t))), {})), new __PRIVATE_RealtimePipeline(this._db, this.userDataReader, this._userDataWriter, n);
            }
        },
        {
            /**
     * @internal
     * @private
     */ key: "dr",
            value: function dr(e) {
                return {
                    pipeline: {
                        stages: this.stages.map(function(t) {
                            return t._toProto(e);
                        })
                    }
                };
            }
        }
    ]);
    return __PRIVATE_RealtimePipeline;
}();
// Copyright 2024 Google LLC* @license
// Copyright 2024 Google LLC
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//      http://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var CorePipeline = /*#__PURE__*/ function() {
    "use strict";
    function CorePipeline(e, t, n) {
        (0, $4QweW._)(this, CorePipeline);
        this.serializer = e, this.stages = t, this.listenOptions = n, this.isCorePipeline = true;
    }
    (0, $6hK4i._)(CorePipeline, [
        {
            key: "getPipelineCollection",
            value: function getPipelineCollection1() {
                return getPipelineCollection(this);
            }
        },
        {
            key: "getPipelineCollectionGroup",
            value: function getPipelineCollectionGroup1() {
                return getPipelineCollectionGroup(this);
            }
        },
        {
            key: "getPipelineCollectionId",
            value: function getPipelineCollectionId1() {
                return getPipelineCollectionId(this);
            }
        },
        {
            key: "getPipelineDocuments",
            value: function getPipelineDocuments1() {
                return getPipelineDocuments(this);
            }
        },
        {
            key: "getPipelineFlavor",
            value: function getPipelineFlavor() {
                return function getPipelineFlavor(e) {
                    var t = "exact";
                    return e.stages.forEach(function(n, r) {
                        n._name !== M.name && n._name !== O.name || (t = "keyless"), n._name === x.name && "exact" === t && (t = "augmented"), // TODO(pipeline): verify the last stage is addFields, and it is added by the SDK.
                        n._name === w.name && r < e.stages.length - 1 && "exact" === t && (t = "augmented");
                    }), t;
                }(this);
            }
        },
        {
            key: "getPipelineSourceType",
            value: function getPipelineSourceType1() {
                return getPipelineSourceType(this);
            }
        }
    ]);
    return CorePipeline;
}();
function getPipelineSourceType(e) {
    var t = e.stages[0];
    return t instanceof X || t instanceof Y || t instanceof Z || t instanceof sa ? t._name : "unknown";
}
function getPipelineCollection(e) {
    if ("collection" === getPipelineSourceType(e)) return e.stages[0].hr;
}
function getPipelineCollectionGroup(e) {
    if ("collection_group" === getPipelineSourceType(e)) return e.stages[0].collectionId;
}
function getPipelineCollectionId(e) {
    switch(getPipelineSourceType(e)){
        case "collection":
            return ResourcePath.fromString(getPipelineCollection(e)).lastSegment();
        case "collection_group":
            return getPipelineCollectionGroup(e);
        default:
            return;
    }
}
function getPipelineDocuments(e) {
    if ("documents" === getPipelineSourceType(e)) return e.stages[0].Tr;
}
var __PRIVATE_EvaluateResult = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_EvaluateResult(e, t) {
        (0, $4QweW._)(this, __PRIVATE_EvaluateResult);
        this.type = e, this.value = t;
    }
    (0, $6hK4i._)(__PRIVATE_EvaluateResult, [
        {
            key: "yr",
            value: function yr() {
                return "ERROR" === this.type || "UNSET" === this.type;
            }
        },
        {
            key: "wr",
            value: function wr() {
                return "NULL" === this.type;
            }
        }
    ], [
        {
            key: "mr",
            value: function mr() {
                return new __PRIVATE_EvaluateResult("ERROR", void 0);
            }
        },
        {
            key: "pr",
            value: function pr() {
                return new __PRIVATE_EvaluateResult("UNSET", void 0);
            }
        },
        {
            key: "gr",
            value: function gr() {
                return new __PRIVATE_EvaluateResult("NULL", He);
            }
        },
        {
            key: "newValue",
            value: function newValue(e) {
                return __PRIVATE_isNullValue(e) ? new __PRIVATE_EvaluateResult("NULL", He) : function __PRIVATE_isBoolean(e) {
                    return !!e && "booleanValue" in e;
                }(e) ? new __PRIVATE_EvaluateResult("BOOLEAN", e) : isInteger(e) ? new __PRIVATE_EvaluateResult("INT", e) : __PRIVATE_isDouble(e) ? new __PRIVATE_EvaluateResult("DOUBLE", e) : function __PRIVATE_isTimestampValue(e) {
                    return !!e && "timestampValue" in e && !!e.timestampValue;
                }(e) ? new __PRIVATE_EvaluateResult("TIMESTAMP", e) : function __PRIVATE_isString(e) {
                    return !!e && "stringValue" in e;
                }(e) ? new __PRIVATE_EvaluateResult("STRING", e) : function __PRIVATE_isBytes(e) {
                    return !!e && "bytesValue" in e;
                }(e) ? new __PRIVATE_EvaluateResult("BYTES", e) : e.referenceValue ? new __PRIVATE_EvaluateResult("REFERENCE", e) : e.geoPointValue ? new __PRIVATE_EvaluateResult("GEO_POINT", e) : isArray(e) ? new __PRIVATE_EvaluateResult("ARRAY", e) : __PRIVATE_isVectorValue(e) ? new __PRIVATE_EvaluateResult("VECTOR", e) : __PRIVATE_isMapValue(e) ? new __PRIVATE_EvaluateResult("MAP", e) : new __PRIVATE_EvaluateResult("ERROR", void 0);
            }
        }
    ]);
    return __PRIVATE_EvaluateResult;
}();
function __PRIVATE_valueOrUndefined(e) {
    if (!e.yr()) return e.value;
}
function __PRIVATE_unwrapExpression(e) {
    return e instanceof BooleanExpression ? e._expr : e;
}
function __PRIVATE_toEvaluable(e) {
    if ((e = __PRIVATE_unwrapExpression(e)) instanceof o) return new __PRIVATE_CoreField(e);
    if (e instanceof Constant) return new __PRIVATE_CoreConstant(e);
    if (e instanceof __PRIVATE_ListOfExprs) return new __PRIVATE_CoreListOfExprs(e);
    if (e instanceof y) {
        // TODO(pipeline): We should define all supported function names as constants somewhere instead of magic strings.
        if ("add" === e.name) return new __PRIVATE_CoreAdd(e);
        if ("subtract" === e.name) return new __PRIVATE_CoreSubtract(e);
        if ("multiply" === e.name) return new __PRIVATE_CoreMultiply(e);
        if ("divide" === e.name) return new __PRIVATE_CoreDivide(e);
        if ("mod" === e.name) return new __PRIVATE_CoreMod(e);
        if ("and" === e.name) return new __PRIVATE_CoreAnd(e);
        if ("equal" === e.name) return new __PRIVATE_CoreEq(e);
        if ("not_equal" === e.name) return new __PRIVATE_CoreNeq(e);
        if ("less_than" === e.name) return new __PRIVATE_CoreLt(e);
        if ("less_than_or_equal" === e.name) return new __PRIVATE_CoreLte(e);
        if ("greater_than" === e.name) return new __PRIVATE_CoreGt(e);
        if ("greater_than_or_equal" === e.name) return new __PRIVATE_CoreGte(e);
        if ("array_concat" === e.name) return new __PRIVATE_CoreArrayConcat(e);
        if ("array_reverse" === e.name) return new __PRIVATE_CoreArrayReverse(e);
        if ("array_contains" === e.name) return new __PRIVATE_CoreArrayContains(e);
        if ("array_contains_all" === e.name) return new __PRIVATE_CoreArrayContainsAll(e);
        if ("array_contains_any" === e.name) return new __PRIVATE_CoreArrayContainsAny(e);
        if ("array_length" === e.name) return new __PRIVATE_CoreArrayLength(e);
        if ("array_element" === e.name) return new __PRIVATE_CoreArrayElement(e);
        if ("equal_any" === e.name) return new __PRIVATE_CoreEqAny(e);
        if ("not_equal_any" === e.name) return new __PRIVATE_CoreNotEqAny(e);
        if ("is_nan" === e.name) return new __PRIVATE_CoreIsNan(e);
        if ("is_not_nan" === e.name) return new __PRIVATE_CoreIsNotNan(e);
        if ("is_null" === e.name) return new __PRIVATE_CoreIsNull(e);
        if ("is_not_null" === e.name) return new __PRIVATE_CoreIsNotNull(e);
        if ("is_error" === e.name) return new __PRIVATE_CoreIsError(e);
        if ("exists" === e.name) return new __PRIVATE_CoreExists(e);
        if ("not" === e.name) return new __PRIVATE_CoreNot(e);
        if ("or" === e.name) return new __PRIVATE_CoreOr(e);
        if ("xor" === e.name) return new __PRIVATE_CoreXor(e);
        if ("conditional" === e.name) return new __PRIVATE_CoreCond(e);
        if ("maximum" === e.name) return new __PRIVATE_CoreLogicalMaximum(e);
        if ("minimum" === e.name) return new __PRIVATE_CoreLogicalMinimum(e);
        if ("reverse" === e.name) return new __PRIVATE_CoreReverse(e);
        if ("replace_first" === e.name) return new __PRIVATE_CoreReplaceFirst(e);
        if ("replace_all" === e.name) return new __PRIVATE_CoreReplaceAll(e);
        if ("char_length" === e.name) return new __PRIVATE_CoreCharLength(e);
        if ("byte_length" === e.name) return new __PRIVATE_CoreByteLength(e);
        if ("like" === e.name) return new __PRIVATE_CoreLike(e);
        if ("regex_contains" === e.name) return new __PRIVATE_CoreRegexContains(e);
        if ("regex_match" === e.name) return new __PRIVATE_CoreRegexMatch(e);
        if ("string_contains" === e.name) return new __PRIVATE_CoreStrContains(e);
        if ("starts_with" === e.name) return new __PRIVATE_CoreStartsWith(e);
        if ("ends_with" === e.name) return new __PRIVATE_CoreEndsWith(e);
        if ("to_lower" === e.name) return new __PRIVATE_CoreToLower(e);
        if ("to_upper" === e.name) return new __PRIVATE_CoreToUpper(e);
        if ("trim" === e.name) return new __PRIVATE_CoreTrim(e);
        if ("string_concat" === e.name) return new __PRIVATE_CoreStrConcat(e);
        if ("map_get" === e.name) return new __PRIVATE_CoreMapGet(e);
        if ("cosine_distance" === e.name) return new __PRIVATE_CoreCosineDistance(e);
        if ("dot_product" === e.name) return new __PRIVATE_CoreDotProduct(e);
        if ("euclidean_distance" === e.name) return new __PRIVATE_CoreEuclideanDistance(e);
        if ("vector_length" === e.name) return new __PRIVATE_CoreVectorLength(e);
        if ("unix_micros_to_timestamp" === e.name) return new __PRIVATE_CoreUnixMicrosToTimestamp(e);
        if ("timestamp_to_unix_micros" === e.name) return new __PRIVATE_CoreTimestampToUnixMicros(e);
        if ("unix_millis_to_timestamp" === e.name) return new __PRIVATE_CoreUnixMillisToTimestamp(e);
        if ("timestamp_to_unix_millis" === e.name) return new __PRIVATE_CoreTimestampToUnixMillis(e);
        if ("unix_seconds_to_timestamp" === e.name) return new __PRIVATE_CoreUnixSecondsToTimestamp(e);
        if ("timestamp_to_unix_seconds" === e.name) return new __PRIVATE_CoreTimestampToUnixSeconds(e);
        if ("timestamp_add" === e.name) return new __PRIVATE_CoreTimestampAdd(e);
        if ("timestamp_subtract" === e.name) return new __PRIVATE_CoreTimestampSub(e);
    }
    throw new Error("Unknown Expr : ".concat(e));
}
var __PRIVATE_CoreField = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreField(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreField);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreField, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                if (this.expr.fieldName === Ce) return __PRIVATE_EvaluateResult.newValue({
                    referenceValue: __PRIVATE_toName(e.serializer, t.key)
                });
                if ("__update_time__" === this.expr.fieldName) return __PRIVATE_EvaluateResult.newValue({
                    timestampValue: __PRIVATE_toVersion(e.serializer, t.version)
                });
                if ("__create_time__" === this.expr.fieldName) return __PRIVATE_EvaluateResult.newValue({
                    timestampValue: __PRIVATE_toVersion(e.serializer, t.createTime)
                });
                // Return 'UNSET' if the field doesn't exist, otherwise the Value.
                var n = t.data.field(this.expr._fieldPath);
                return n ? __PRIVATE_isServerTimestamp(n) ? __PRIVATE_EvaluateResult.newValue(function __PRIVATE_getServerTimestampValue(e, t) {
                    if ("estimate" === e.serverTimestampBehavior) return {
                        timestampValue: __PRIVATE_toVersion(e.serializer, SnapshotVersion.fromTimestamp(__PRIVATE_getLocalWriteTime(t)))
                    };
                    if ("previous" === e.serverTimestampBehavior) {
                        var _$e = __PRIVATE_getPreviousValue(t);
                        if (_$e) return _$e;
                    }
                    return {
                        nullValue: "NULL_VALUE"
                    };
                }(e, n)) : __PRIVATE_EvaluateResult.newValue(n) : __PRIVATE_EvaluateResult.pr();
            }
        }
    ]);
    return __PRIVATE_CoreField;
}();
var __PRIVATE_CoreConstant = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreConstant(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreConstant);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreConstant, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                return __PRIVATE_EvaluateResult.newValue(this.expr._getValue());
            }
        }
    ]);
    return __PRIVATE_CoreConstant;
}();
var __PRIVATE_CoreListOfExprs = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreListOfExprs(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreListOfExprs);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreListOfExprs, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                var n = this.expr.cr.map(function(n) {
                    return __PRIVATE_toEvaluable(n).evaluate(e, t);
                });
                // If any sub-expression resulted in error or was unset, the list evaluation fails.
                return n.some(function(e) {
                    return e.yr();
                }) ? __PRIVATE_EvaluateResult.mr() : __PRIVATE_EvaluateResult.newValue({
                    arrayValue: {
                        values: n.map(function(e) {
                            return e.value;
                        })
                    }
                });
            }
        }
    ]);
    return __PRIVATE_CoreListOfExprs;
}();
function __PRIVATE_asDouble(e) {
    return __PRIVATE_isDouble(e) ? Number(e.doubleValue) : Number(e.integerValue);
}
function __PRIVATE_asBigInt(e) {
    return BigInt(e.integerValue);
}
var Ft = BigInt("0x7fffffffffffffff"), Ot = -BigInt("0x8000000000000000");
var __PRIVATE_BigIntOrDoubleArithmetics = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_BigIntOrDoubleArithmetics(e) {
        (0, $4QweW._)(this, __PRIVATE_BigIntOrDoubleArithmetics);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_BigIntOrDoubleArithmetics, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                __PRIVATE_hardAssert(this.expr.params.length >= 2, 24778);
                var n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t), r = __PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
                var i = this.br(n, r);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.expr.params.slice(2)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var n1 = _step.value;
                        var r1 = __PRIVATE_toEvaluable(n1).evaluate(e, t);
                        i = this.br(i, r1);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return i;
            }
        },
        {
            key: "br",
            value: function br(e, t) {
                // If any operand is error or unset, the result is error.
                if (e.yr() || t.yr()) return __PRIVATE_EvaluateResult.mr();
                if (e.wr() || t.wr()) return __PRIVATE_EvaluateResult.gr();
                // Type check: Both must be numbers (integer or double).
                // We know left and right are Value here due to the check above.
                var n = e.value, r = t.value;
                if (!__PRIVATE_isDouble(n) && !isInteger(n) || !__PRIVATE_isDouble(r) && !isInteger(r)) return __PRIVATE_EvaluateResult.mr(); // Type error
                // Perform arithmetic based on types.
                if (__PRIVATE_isDouble(n) || __PRIVATE_isDouble(r)) {
                    var _$e = this.Sr(n, r);
                    return _$e ? __PRIVATE_EvaluateResult.newValue(_$e) : __PRIVATE_EvaluateResult.mr();
                }
                if (isInteger(n) && isInteger(r)) {
                    // Pass the narrowed Value types
                    var _$e1 = this.vr(n, r);
                    return void 0 === _$e1 ? __PRIVATE_EvaluateResult.mr() : "number" == typeof _$e1 ? __PRIVATE_EvaluateResult.newValue({
                        doubleValue: _$e1
                    }) : _$e1 < Ot || _$e1 > Ft ? __PRIVATE_EvaluateResult.mr() : __PRIVATE_EvaluateResult.newValue({
                        integerValue: "".concat(_$e1)
                    });
                }
                // Should not be reached due to initial type checks
                return __PRIVATE_EvaluateResult.mr();
            }
        }
    ]);
    return __PRIVATE_BigIntOrDoubleArithmetics;
}();
function __PRIVATE_strictValueEquals(e, t) {
    return __PRIVATE_typeOrder(e) !== __PRIVATE_typeOrder(t) ? "TYPE_MISMATCH" : __PRIVATE_isNanValue(e) || __PRIVATE_isNanValue(t) ? "NOT_EQ" : __PRIVATE_isNullValue(e) && __PRIVATE_isNullValue(t) ? "EQ" : __PRIVATE_isNullValue(e) || __PRIVATE_isNullValue(t) ? "NULL" : isArray(e) && isArray(t) ? function __PRIVATE_strictArrayValueEquals(e, t) {
        var _e_values, _t_values, _e_values1;
        if (((_e_values = e.values) === null || _e_values === void 0 ? void 0 : _e_values.length) !== ((_t_values = t.values) === null || _t_values === void 0 ? void 0 : _t_values.length)) return "NOT_EQ";
        var n = false;
        var _e_values_length;
        for(var r = 0; r < ((_e_values_length = (_e_values1 = e.values) === null || _e_values1 === void 0 ? void 0 : _e_values1.length) !== null && _e_values_length !== void 0 ? _e_values_length : 0); r++){
            var i = e.values[r], s = t.values[r];
            switch(__PRIVATE_strictValueEquals(i, s)){
                case "EQ":
                    break;
                case "NOT_EQ":
                case "TYPE_MISMATCH":
                    return "NOT_EQ";
                case "NULL":
                    n = true;
                    break;
                default:
                    l(44609, {
                        Dr: i,
                        Cr: s
                    });
            }
        }
        if (n) return "NULL";
        return "EQ";
    }(e.arrayValue, t.arrayValue) : __PRIVATE_isVectorValue(e) && __PRIVATE_isVectorValue(t) || __PRIVATE_isMapValue(e) && __PRIVATE_isMapValue(t) ? function __PRIVATE_strictObjectValueEquals(e, t) {
        var n = e.fields || {}, r = t.fields || {};
        if (__PRIVATE_objectSize(n) !== __PRIVATE_objectSize(r)) return "NOT_EQ";
        var i = false;
        for(var _$e in n)if (n.hasOwnProperty(_$e)) {
            if (void 0 === r[_$e]) return "NOT_EQ";
            switch(__PRIVATE_strictValueEquals(n[_$e], r[_$e])){
                case "NOT_EQ":
                case "TYPE_MISMATCH":
                    return "NOT_EQ";
                case "NULL":
                    i = true;
            }
        }
        if (i) return "NULL";
        return "EQ";
    }(e.mapValue, t.mapValue) : function __PRIVATE_valueEquals(e, t) {
        return __PRIVATE_valueEquals$1(e, t, {
            u: false,
            i: true,
            o: true
        });
    }(e, t) ? "EQ" : "NOT_EQ";
}
var __PRIVATE_CoreAdd = /*#__PURE__*/ function(__PRIVATE_BigIntOrDoubleArithmetics) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_CoreAdd, __PRIVATE_BigIntOrDoubleArithmetics);
    function __PRIVATE_CoreAdd() {
        (0, $4QweW._)(this, __PRIVATE_CoreAdd);
        return (0, $ehF45._)(this, __PRIVATE_CoreAdd, arguments);
    }
    (0, $6hK4i._)(__PRIVATE_CoreAdd, [
        {
            key: "vr",
            value: function vr(e, t) {
                return __PRIVATE_asBigInt(e) + __PRIVATE_asBigInt(t);
            }
        },
        {
            key: "Sr",
            value: function Sr(e, t) {
                return {
                    doubleValue: __PRIVATE_asDouble(e) + __PRIVATE_asDouble(t)
                };
            }
        }
    ]);
    return __PRIVATE_CoreAdd;
}(__PRIVATE_BigIntOrDoubleArithmetics);
var __PRIVATE_CoreSubtract = /*#__PURE__*/ function(__PRIVATE_BigIntOrDoubleArithmetics) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_CoreSubtract, __PRIVATE_BigIntOrDoubleArithmetics);
    function __PRIVATE_CoreSubtract(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreSubtract);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_CoreSubtract, [
            e
        ]), _this.expr = e;
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_CoreSubtract, [
        {
            key: "vr",
            value: function vr(e, t) {
                return __PRIVATE_asBigInt(e) - __PRIVATE_asBigInt(t);
            }
        },
        {
            key: "Sr",
            value: function Sr(e, t) {
                return {
                    doubleValue: __PRIVATE_asDouble(e) - __PRIVATE_asDouble(t)
                };
            }
        }
    ]);
    return __PRIVATE_CoreSubtract;
}(__PRIVATE_BigIntOrDoubleArithmetics);
var __PRIVATE_CoreMultiply = /*#__PURE__*/ function(__PRIVATE_BigIntOrDoubleArithmetics) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_CoreMultiply, __PRIVATE_BigIntOrDoubleArithmetics);
    function __PRIVATE_CoreMultiply(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreMultiply);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_CoreMultiply, [
            e
        ]), _this.expr = e;
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_CoreMultiply, [
        {
            key: "vr",
            value: function vr(e, t) {
                return __PRIVATE_asBigInt(e) * __PRIVATE_asBigInt(t);
            }
        },
        {
            key: "Sr",
            value: function Sr(e, t) {
                return {
                    doubleValue: __PRIVATE_asDouble(e) * __PRIVATE_asDouble(t)
                };
            }
        }
    ]);
    return __PRIVATE_CoreMultiply;
}(__PRIVATE_BigIntOrDoubleArithmetics);
var __PRIVATE_CoreDivide = /*#__PURE__*/ function(__PRIVATE_BigIntOrDoubleArithmetics) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_CoreDivide, __PRIVATE_BigIntOrDoubleArithmetics);
    function __PRIVATE_CoreDivide(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreDivide);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_CoreDivide, [
            e
        ]), _this.expr = e;
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_CoreDivide, [
        {
            key: "vr",
            value: function vr(e, t) {
                var n = __PRIVATE_asBigInt(t);
                if (n !== BigInt(0)) return __PRIVATE_asBigInt(e) / n;
            }
        },
        {
            key: "Sr",
            value: function Sr(e, t) {
                var n = __PRIVATE_asDouble(t);
                return 0 === n ? {
                    doubleValue: __PRIVATE_isNegativeZero(n) ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY
                } : {
                    doubleValue: __PRIVATE_asDouble(e) / n
                };
            }
        }
    ]);
    return __PRIVATE_CoreDivide;
}(__PRIVATE_BigIntOrDoubleArithmetics);
var __PRIVATE_CoreMod = /*#__PURE__*/ function(__PRIVATE_BigIntOrDoubleArithmetics) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_CoreMod, __PRIVATE_BigIntOrDoubleArithmetics);
    function __PRIVATE_CoreMod(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreMod);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_CoreMod, [
            e
        ]), _this.expr = e;
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_CoreMod, [
        {
            key: "vr",
            value: function vr(e, t) {
                var n = __PRIVATE_asBigInt(t);
                if (n !== BigInt(0)) return __PRIVATE_asBigInt(e) % n;
            }
        },
        {
            key: "Sr",
            value: function Sr(e, t) {
                var n = __PRIVATE_asDouble(t);
                if (0 !== n) return {
                    doubleValue: __PRIVATE_asDouble(e) % n
                };
            }
        }
    ]);
    return __PRIVATE_CoreMod;
}(__PRIVATE_BigIntOrDoubleArithmetics);
var __PRIVATE_CoreAnd = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreAnd(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreAnd);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreAnd, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                var n = false, r = false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.expr.params[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var s = __PRIVATE_toEvaluable(i).evaluate(e, t);
                        switch(s.type){
                            case "BOOLEAN":
                                var _s_value;
                                if (!((_s_value = s.value) === null || _s_value === void 0 ? void 0 : _s_value.booleanValue)) return __PRIVATE_EvaluateResult.newValue(Ye);
                                break;
                            case "NULL":
                                r = true;
                                break;
                            default:
                                n = true;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return n ? __PRIVATE_EvaluateResult.mr() : r ? __PRIVATE_EvaluateResult.gr() : __PRIVATE_EvaluateResult.newValue(Je);
            }
        }
    ]);
    return __PRIVATE_CoreAnd;
}();
var __PRIVATE_CoreNot = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreNot(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreNot);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreNot, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                __PRIVATE_hardAssert(1 === this.expr.params.length, 9634);
                var n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
                switch(n.type){
                    case "BOOLEAN":
                        var _n_value;
                        return __PRIVATE_EvaluateResult.newValue({
                            booleanValue: !((_n_value = n.value) === null || _n_value === void 0 ? void 0 : _n_value.booleanValue)
                        });
                    case "NULL":
                        return __PRIVATE_EvaluateResult.gr();
                    default:
                        return __PRIVATE_EvaluateResult.mr();
                }
            }
        }
    ]);
    return __PRIVATE_CoreNot;
}();
var __PRIVATE_CoreOr = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreOr(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreOr);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreOr, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                var n = false, r = false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.expr.params[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var s = __PRIVATE_toEvaluable(i).evaluate(e, t);
                        switch(s.type){
                            case "BOOLEAN":
                                var _s_value;
                                if ((_s_value = s.value) === null || _s_value === void 0 ? void 0 : _s_value.booleanValue) return __PRIVATE_EvaluateResult.newValue(Je);
                                break;
                            case "NULL":
                                r = true;
                                break;
                            default:
                                n = true;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return n ? __PRIVATE_EvaluateResult.mr() : r ? __PRIVATE_EvaluateResult.gr() : __PRIVATE_EvaluateResult.newValue(Ye);
            }
        }
    ]);
    return __PRIVATE_CoreOr;
}();
var __PRIVATE_CoreXor = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreXor(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreXor);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreXor, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                var n = false, r = false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.expr.params[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var s = __PRIVATE_toEvaluable(i).evaluate(e, t);
                        switch(s.type){
                            case "BOOLEAN":
                                var _s_value;
                                n = __PRIVATE_CoreXor.xor(n, !!((_s_value = s.value) === null || _s_value === void 0 ? void 0 : _s_value.booleanValue));
                                break;
                            case "NULL":
                                r = true;
                                break;
                            default:
                                return __PRIVATE_EvaluateResult.mr();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return r ? __PRIVATE_EvaluateResult.gr() : __PRIVATE_EvaluateResult.newValue({
                    booleanValue: n
                });
            }
        }
    ], [
        {
            key: "xor",
            value: // XOR(a, b) is equivalent to (a OR b) AND NOT(a AND b)
            // It is required to evaluate all arguments to ensure that the correct error semantics are
            // applied.
            function xor(e, t) {
                return (e || t) && !(e && t);
            }
        }
    ]);
    return __PRIVATE_CoreXor;
}();
var __PRIVATE_CoreEqAny = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreEqAny(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreEqAny);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreEqAny, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                var _i_value_arrayValue, _i_value;
                __PRIVATE_hardAssert(2 === this.expr.params.length, 55094);
                var n = false;
                var r = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
                switch(r.type){
                    case "NULL":
                        n = true;
                        break;
                    case "ERROR":
                    case "UNSET":
                        return __PRIVATE_EvaluateResult.mr();
                }
                var i = __PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
                switch(i.type){
                    case "ARRAY":
                        break;
                    case "NULL":
                        n = true;
                        break;
                    default:
                        return __PRIVATE_EvaluateResult.mr();
                }
                if (n) return __PRIVATE_EvaluateResult.gr();
                var _i_value_arrayValue_values;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = ((_i_value_arrayValue_values = (_i_value = i.value) === null || _i_value === void 0 ? void 0 : (_i_value_arrayValue = _i_value.arrayValue) === null || _i_value_arrayValue === void 0 ? void 0 : _i_value_arrayValue.values) !== null && _i_value_arrayValue_values !== void 0 ? _i_value_arrayValue_values : [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$e = _step.value;
                        switch(__PRIVATE_isNullValue(r.value) && __PRIVATE_isNullValue(_$e) ? "EQ" : __PRIVATE_strictValueEquals(r.value, _$e)){
                            case "EQ":
                                return __PRIVATE_EvaluateResult.newValue(Je);
                            case "NOT_EQ":
                            case "TYPE_MISMATCH":
                                break;
                            case "NULL":
                                n = true;
                                break;
                            default:
                                l(44608, {
                                    value: r.value,
                                    candidate: _$e
                                });
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return n ? __PRIVATE_EvaluateResult.gr() : __PRIVATE_EvaluateResult.newValue(Ye);
            }
        }
    ]);
    return __PRIVATE_CoreEqAny;
}();
var __PRIVATE_CoreNotEqAny = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreNotEqAny(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreNotEqAny);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreNotEqAny, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                return new __PRIVATE_CoreNot(new y("not", [
                    new y("equal_any", this.expr.params)
                ])).evaluate(e, t);
            }
        }
    ]);
    return __PRIVATE_CoreNotEqAny;
}();
var __PRIVATE_CoreIsNan = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreIsNan(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreIsNan);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreIsNan, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                __PRIVATE_hardAssert(1 === this.expr.params.length, 23322);
                var n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
                switch(n.type){
                    case "INT":
                        return __PRIVATE_EvaluateResult.newValue(Ye);
                    case "DOUBLE":
                        return __PRIVATE_EvaluateResult.newValue({
                            booleanValue: isNaN(__PRIVATE_asDouble(n.value))
                        });
                    case "NULL":
                        return __PRIVATE_EvaluateResult.gr();
                    default:
                        return __PRIVATE_EvaluateResult.mr();
                }
            }
        }
    ]);
    return __PRIVATE_CoreIsNan;
}();
var __PRIVATE_CoreIsNotNan = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreIsNotNan(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreIsNotNan);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreIsNotNan, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                __PRIVATE_hardAssert(1 === this.expr.params.length, 50406);
                return new __PRIVATE_CoreNot(new y("not", [
                    new y("is_nan", this.expr.params)
                ])).evaluate(e, t);
            }
        }
    ]);
    return __PRIVATE_CoreIsNotNan;
}();
var __PRIVATE_CoreIsNull = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreIsNull(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreIsNull);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreIsNull, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                __PRIVATE_hardAssert(1 === this.expr.params.length, 23123);
                switch(__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t).type){
                    case "NULL":
                        return __PRIVATE_EvaluateResult.newValue(Je);
                    case "UNSET":
                    case "ERROR":
                        return __PRIVATE_EvaluateResult.mr();
                    default:
                        return __PRIVATE_EvaluateResult.newValue(Ye);
                }
            }
        }
    ]);
    return __PRIVATE_CoreIsNull;
}();
var __PRIVATE_CoreIsNotNull = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreIsNotNull(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreIsNotNull);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreIsNotNull, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                __PRIVATE_hardAssert(1 === this.expr.params.length, 23167);
                return new __PRIVATE_CoreNot(new y("not", [
                    new y("is_null", this.expr.params)
                ])).evaluate(e, t);
            }
        }
    ]);
    return __PRIVATE_CoreIsNotNull;
}();
var __PRIVATE_CoreIsError = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreIsError(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreIsError);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreIsError, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                __PRIVATE_hardAssert(1 === this.expr.params.length, 5228);
                return "ERROR" === __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t).type ? __PRIVATE_EvaluateResult.newValue(Je) : __PRIVATE_EvaluateResult.newValue(Ye);
            }
        }
    ]);
    return __PRIVATE_CoreIsError;
}();
var __PRIVATE_CoreExists = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreExists(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreExists);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreExists, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                __PRIVATE_hardAssert(1 === this.expr.params.length, 6877);
                switch(__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t).type){
                    case "ERROR":
                        return __PRIVATE_EvaluateResult.mr();
                    case "UNSET":
                        return __PRIVATE_EvaluateResult.newValue(Ye);
                    default:
                        return __PRIVATE_EvaluateResult.newValue(Je);
                }
            }
        }
    ]);
    return __PRIVATE_CoreExists;
}();
var __PRIVATE_CoreCond = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreCond(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreCond);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreCond, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                __PRIVATE_hardAssert(3 === this.expr.params.length, 11706);
                var n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
                switch(n.type){
                    case "BOOLEAN":
                        var _n_value;
                        return ((_n_value = n.value) === null || _n_value === void 0 ? void 0 : _n_value.booleanValue) ? __PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t) : __PRIVATE_toEvaluable(this.expr.params[2]).evaluate(e, t);
                    case "NULL":
                        return __PRIVATE_toEvaluable(this.expr.params[2]).evaluate(e, t);
                    default:
                        return __PRIVATE_EvaluateResult.mr();
                }
            }
        }
    ]);
    return __PRIVATE_CoreCond;
}();
var __PRIVATE_CoreLogicalMaximum = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreLogicalMaximum(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreLogicalMaximum);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreLogicalMaximum, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                var n = this.expr.params.map(function(n) {
                    return __PRIVATE_toEvaluable(n).evaluate(e, t);
                });
                var r;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var e1 = _step.value;
                        switch(e1.type){
                            case "ERROR":
                            case "UNSET":
                            case "NULL":
                                continue;
                            default:
                                r = void 0 === r || __PRIVATE_valueCompare(e1.value, r.value) > 0 ? e1 : r;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return void 0 === r ? __PRIVATE_EvaluateResult.gr() : r;
            }
        }
    ]);
    return __PRIVATE_CoreLogicalMaximum;
}();
var __PRIVATE_CoreLogicalMinimum = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreLogicalMinimum(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreLogicalMinimum);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreLogicalMinimum, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                var n = this.expr.params.map(function(n) {
                    return __PRIVATE_toEvaluable(n).evaluate(e, t);
                });
                var r;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var e1 = _step.value;
                        switch(e1.type){
                            case "ERROR":
                            case "UNSET":
                            case "NULL":
                                continue;
                            default:
                                r = void 0 === r || __PRIVATE_valueCompare(e1.value, r.value) < 0 ? e1 : r;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return void 0 === r ? __PRIVATE_EvaluateResult.gr() : r;
            }
        }
    ]);
    return __PRIVATE_CoreLogicalMinimum;
}();
var __PRIVATE_ComparisonBase = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_ComparisonBase(e) {
        (0, $4QweW._)(this, __PRIVATE_ComparisonBase);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_ComparisonBase, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                __PRIVATE_hardAssert(2 === this.expr.params.length, 31033, "".concat(this.expr.name, "() function should have exactly 2 params"));
                var n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
                switch(n.type){
                    case "ERROR":
                    case "UNSET":
                        return __PRIVATE_EvaluateResult.mr();
                }
                var r = __PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
                switch(r.type){
                    case "ERROR":
                    case "UNSET":
                        return __PRIVATE_EvaluateResult.mr();
                }
                return this.Fr(n, r);
            }
        }
    ]);
    return __PRIVATE_ComparisonBase;
}();
var __PRIVATE_CoreEq = /*#__PURE__*/ function(__PRIVATE_ComparisonBase) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_CoreEq, __PRIVATE_ComparisonBase);
    function __PRIVATE_CoreEq(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreEq);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_CoreEq, [
            e
        ]), _this.expr = e;
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_CoreEq, [
        {
            key: "Fr",
            value: function Fr(e, t) {
                if (e.wr() && t.wr()) return __PRIVATE_EvaluateResult.newValue(Je);
                if (e.wr() || t.wr()) return __PRIVATE_EvaluateResult.newValue(Ye);
                if (__PRIVATE_isNanValue(e.value) || __PRIVATE_isNanValue(t.value)) return __PRIVATE_EvaluateResult.newValue(Ye);
                if (__PRIVATE_typeOrder(e.value) !== __PRIVATE_typeOrder(t.value)) return __PRIVATE_EvaluateResult.newValue(Ye);
                switch(__PRIVATE_strictValueEquals(e.value, t.value)){
                    case "EQ":
                        return __PRIVATE_EvaluateResult.newValue(Je);
                    case "NOT_EQ":
                        return __PRIVATE_EvaluateResult.newValue(Ye);
                    case "NULL":
                        return __PRIVATE_EvaluateResult.gr();
                    default:
                        l(44615, {
                            left: e,
                            right: t
                        });
                }
            }
        }
    ]);
    return __PRIVATE_CoreEq;
}(__PRIVATE_ComparisonBase);
var __PRIVATE_CoreNeq = /*#__PURE__*/ function(__PRIVATE_ComparisonBase) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_CoreNeq, __PRIVATE_ComparisonBase);
    function __PRIVATE_CoreNeq(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreNeq);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_CoreNeq, [
            e
        ]), _this.expr = e;
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_CoreNeq, [
        {
            key: "Fr",
            value: function Fr(e, t) {
                switch(__PRIVATE_strictValueEquals(e.value, t.value)){
                    case "EQ":
                        return __PRIVATE_EvaluateResult.newValue(Ye);
                    case "NOT_EQ":
                    case "TYPE_MISMATCH":
                        return __PRIVATE_EvaluateResult.newValue(Je);
                    case "NULL":
                        return __PRIVATE_EvaluateResult.gr();
                    default:
                        l(44614, {
                            left: e,
                            right: t
                        });
                }
            }
        }
    ]);
    return __PRIVATE_CoreNeq;
}(__PRIVATE_ComparisonBase);
var __PRIVATE_CoreLt = /*#__PURE__*/ function(__PRIVATE_ComparisonBase) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_CoreLt, __PRIVATE_ComparisonBase);
    function __PRIVATE_CoreLt(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreLt);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_CoreLt, [
            e
        ]), _this.expr = e;
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_CoreLt, [
        {
            key: "Fr",
            value: function Fr(e, t) {
                return __PRIVATE_typeOrder(e.value) !== __PRIVATE_typeOrder(t.value) || __PRIVATE_isNanValue(e.value) || __PRIVATE_isNanValue(t.value) ? __PRIVATE_EvaluateResult.newValue(Ye) : __PRIVATE_EvaluateResult.newValue({
                    booleanValue: __PRIVATE_valueCompare(e.value, t.value) < 0
                });
            }
        }
    ]);
    return __PRIVATE_CoreLt;
}(__PRIVATE_ComparisonBase);
var __PRIVATE_CoreLte = /*#__PURE__*/ function(__PRIVATE_ComparisonBase) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_CoreLte, __PRIVATE_ComparisonBase);
    function __PRIVATE_CoreLte(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreLte);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_CoreLte, [
            e
        ]), _this.expr = e;
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_CoreLte, [
        {
            key: "Fr",
            value: function Fr(e, t) {
                return __PRIVATE_typeOrder(e.value) !== __PRIVATE_typeOrder(t.value) || __PRIVATE_isNanValue(e.value) || __PRIVATE_isNanValue(t.value) ? __PRIVATE_EvaluateResult.newValue(Ye) : "EQ" === __PRIVATE_strictValueEquals(e.value, t.value) ? __PRIVATE_EvaluateResult.newValue(Je) : __PRIVATE_EvaluateResult.newValue({
                    booleanValue: __PRIVATE_valueCompare(e.value, t.value) < 0
                });
            }
        }
    ]);
    return __PRIVATE_CoreLte;
}(__PRIVATE_ComparisonBase);
var __PRIVATE_CoreGt = /*#__PURE__*/ function(__PRIVATE_ComparisonBase) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_CoreGt, __PRIVATE_ComparisonBase);
    function __PRIVATE_CoreGt(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreGt);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_CoreGt, [
            e
        ]), _this.expr = e;
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_CoreGt, [
        {
            key: "Fr",
            value: function Fr(e, t) {
                return __PRIVATE_typeOrder(e.value) !== __PRIVATE_typeOrder(t.value) || __PRIVATE_isNanValue(e.value) || __PRIVATE_isNanValue(t.value) ? __PRIVATE_EvaluateResult.newValue(Ye) : __PRIVATE_EvaluateResult.newValue({
                    booleanValue: __PRIVATE_valueCompare(e.value, t.value) > 0
                });
            }
        }
    ]);
    return __PRIVATE_CoreGt;
}(__PRIVATE_ComparisonBase);
var __PRIVATE_CoreGte = /*#__PURE__*/ function(__PRIVATE_ComparisonBase) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_CoreGte, __PRIVATE_ComparisonBase);
    function __PRIVATE_CoreGte(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreGte);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_CoreGte, [
            e
        ]), _this.expr = e;
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_CoreGte, [
        {
            key: "Fr",
            value: function Fr(e, t) {
                return __PRIVATE_typeOrder(e.value) !== __PRIVATE_typeOrder(t.value) || __PRIVATE_isNanValue(e.value) || __PRIVATE_isNanValue(t.value) ? __PRIVATE_EvaluateResult.newValue(Ye) : "EQ" === __PRIVATE_strictValueEquals(e.value, t.value) ? __PRIVATE_EvaluateResult.newValue(Je) : __PRIVATE_EvaluateResult.newValue({
                    booleanValue: __PRIVATE_valueCompare(e.value, t.value) > 0
                });
            }
        }
    ]);
    return __PRIVATE_CoreGte;
}(__PRIVATE_ComparisonBase);
var __PRIVATE_CoreArrayConcat = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreArrayConcat(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreArrayConcat);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreArrayConcat, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                throw new Error("Unimplemented");
            }
        }
    ]);
    return __PRIVATE_CoreArrayConcat;
}();
var __PRIVATE_CoreArrayReverse = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreArrayReverse(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreArrayReverse);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreArrayReverse, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                __PRIVATE_hardAssert(1 === this.expr.params.length, 216);
                var n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
                switch(n.type){
                    case "NULL":
                        return __PRIVATE_EvaluateResult.gr();
                    case "ARRAY":
                        {
                            var _n_value_arrayValue;
                            var _n_value_arrayValue_values;
                            var _$e = (_n_value_arrayValue_values = (_n_value_arrayValue = n.value.arrayValue) === null || _n_value_arrayValue === void 0 ? void 0 : _n_value_arrayValue.values) !== null && _n_value_arrayValue_values !== void 0 ? _n_value_arrayValue_values : [];
                            return __PRIVATE_EvaluateResult.newValue({
                                arrayValue: {
                                    values: (0, $jlUaU._)(_$e).reverse()
                                }
                            });
                        }
                    default:
                        return __PRIVATE_EvaluateResult.mr();
                }
            }
        }
    ]);
    return __PRIVATE_CoreArrayReverse;
}();
var __PRIVATE_CoreArrayContains = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreArrayContains(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreArrayContains);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreArrayContains, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                return __PRIVATE_hardAssert(2 === this.expr.params.length, 52884), new __PRIVATE_CoreEqAny(new y("eq_any", [
                    this.expr.params[1],
                    this.expr.params[0]
                ])).evaluate(e, t);
            }
        }
    ]);
    return __PRIVATE_CoreArrayContains;
}();
var __PRIVATE_CoreArrayContainsAll = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreArrayContainsAll(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreArrayContainsAll);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreArrayContainsAll, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                var _i_value_arrayValue, _i_value, _r_value_arrayValue, _r_value;
                __PRIVATE_hardAssert(2 === this.expr.params.length, 1392);
                var n = false;
                var r = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
                switch(r.type){
                    case "ARRAY":
                        break;
                    case "NULL":
                        n = true;
                        break;
                    default:
                        return __PRIVATE_EvaluateResult.mr();
                }
                var i = __PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
                switch(i.type){
                    case "ARRAY":
                        break;
                    case "NULL":
                        n = true;
                        break;
                    default:
                        return __PRIVATE_EvaluateResult.mr();
                }
                if (n) return __PRIVATE_EvaluateResult.gr();
                var _i_value_arrayValue_values, _r_value_arrayValue_values;
                var s = (_i_value_arrayValue_values = (_i_value = i.value) === null || _i_value === void 0 ? void 0 : (_i_value_arrayValue = _i_value.arrayValue) === null || _i_value_arrayValue === void 0 ? void 0 : _i_value_arrayValue.values) !== null && _i_value_arrayValue_values !== void 0 ? _i_value_arrayValue_values : [], _ = (_r_value_arrayValue_values = (_r_value = r.value) === null || _r_value === void 0 ? void 0 : (_r_value_arrayValue = _r_value.arrayValue) === null || _r_value_arrayValue === void 0 ? void 0 : _r_value_arrayValue.values) !== null && _r_value_arrayValue_values !== void 0 ? _r_value_arrayValue_values : [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = s[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$e = _step.value;
                        var _$t = false;
                        n = false;
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = _[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var r1 = _step1.value;
                                switch(__PRIVATE_isNullValue(_$e) && __PRIVATE_isNullValue(r1) ? "EQ" : __PRIVATE_strictValueEquals(_$e, r1)){
                                    case "EQ":
                                        _$t = true;
                                        break;
                                    case "NOT_EQ":
                                    case "TYPE_MISMATCH":
                                        break;
                                    case "NULL":
                                        n = true;
                                        break;
                                    default:
                                        l(44613, {
                                            value: r1,
                                            search: _$e
                                        });
                                }
                                if (_$t) break;
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        if (!_$t) // false case - we didn't find a match, short circuit
                        return __PRIVATE_EvaluateResult.newValue(Ye);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return __PRIVATE_EvaluateResult.newValue(Je);
            }
        }
    ]);
    return __PRIVATE_CoreArrayContainsAll;
}();
var __PRIVATE_CoreArrayContainsAny = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreArrayContainsAny(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreArrayContainsAny);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreArrayContainsAny, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                var _i_value_arrayValue, _i_value, _r_value_arrayValue, _r_value;
                __PRIVATE_hardAssert(2 === this.expr.params.length, 2680);
                var n = false;
                var r = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
                switch(r.type){
                    case "ARRAY":
                        break;
                    case "NULL":
                        n = true;
                        break;
                    default:
                        return __PRIVATE_EvaluateResult.mr();
                }
                var i = __PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
                switch(i.type){
                    case "ARRAY":
                        break;
                    case "NULL":
                        n = true;
                        break;
                    default:
                        return __PRIVATE_EvaluateResult.mr();
                }
                if (n) return __PRIVATE_EvaluateResult.gr();
                var _i_value_arrayValue_values, _r_value_arrayValue_values;
                var s = (_i_value_arrayValue_values = (_i_value = i.value) === null || _i_value === void 0 ? void 0 : (_i_value_arrayValue = _i_value.arrayValue) === null || _i_value_arrayValue === void 0 ? void 0 : _i_value_arrayValue.values) !== null && _i_value_arrayValue_values !== void 0 ? _i_value_arrayValue_values : [], _ = (_r_value_arrayValue_values = (_r_value = r.value) === null || _r_value === void 0 ? void 0 : (_r_value_arrayValue = _r_value.arrayValue) === null || _r_value_arrayValue === void 0 ? void 0 : _r_value_arrayValue.values) !== null && _r_value_arrayValue_values !== void 0 ? _r_value_arrayValue_values : [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator = _[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                        var _$e = _step.value;
                        try {
                            for(var _iterator1 = s[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                var _$t = _step1.value;
                                switch(__PRIVATE_isNullValue(_$e) && __PRIVATE_isNullValue(_$t) ? "EQ" : __PRIVATE_strictValueEquals(_$e, _$t)){
                                    case "EQ":
                                        return __PRIVATE_EvaluateResult.newValue(Je);
                                    case "NOT_EQ":
                                    case "TYPE_MISMATCH":
                                        break;
                                    case "NULL":
                                        n = true;
                                        break;
                                    default:
                                        l(60403, {
                                            value: _$e,
                                            search: _$t
                                        });
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return n ? __PRIVATE_EvaluateResult.gr() : __PRIVATE_EvaluateResult.newValue(Ye);
            }
        }
    ]);
    return __PRIVATE_CoreArrayContainsAny;
}();
var __PRIVATE_CoreArrayLength = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreArrayLength(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreArrayLength);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreArrayLength, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                __PRIVATE_hardAssert(1 === this.expr.params.length, 38605);
                var n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
                switch(n.type){
                    case "NULL":
                        return __PRIVATE_EvaluateResult.gr();
                    case "ARRAY":
                        var _n_value_arrayValue_values, _n_value_arrayValue, _n_value;
                        var _n_value_arrayValue_values_length;
                        return __PRIVATE_EvaluateResult.newValue({
                            integerValue: "".concat((_n_value_arrayValue_values_length = (_n_value = n.value) === null || _n_value === void 0 ? void 0 : (_n_value_arrayValue = _n_value.arrayValue) === null || _n_value_arrayValue === void 0 ? void 0 : (_n_value_arrayValue_values = _n_value_arrayValue.values) === null || _n_value_arrayValue_values === void 0 ? void 0 : _n_value_arrayValue_values.length) !== null && _n_value_arrayValue_values_length !== void 0 ? _n_value_arrayValue_values_length : 0)
                        });
                    default:
                        return __PRIVATE_EvaluateResult.mr();
                }
            }
        }
    ]);
    return __PRIVATE_CoreArrayLength;
}();
var __PRIVATE_CoreArrayElement = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreArrayElement(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreArrayElement);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreArrayElement, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                throw new Error("Unimplemented");
            }
        }
    ]);
    return __PRIVATE_CoreArrayElement;
}();
var __PRIVATE_CoreReverse = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreReverse(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreReverse);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreReverse, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                __PRIVATE_hardAssert(1 === this.expr.params.length, 1508);
                var n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
                switch(n.type){
                    case "NULL":
                        return __PRIVATE_EvaluateResult.gr();
                    case "BYTES":
                        {
                            var _n_value;
                            var _$e = (_n_value = n.value) === null || _n_value === void 0 ? void 0 : _n_value.bytesValue;
                            if ("string" == typeof _$e) {
                                var _$t = ByteString.fromBase64String(_$e).toUint8Array();
                                return _$t.reverse(), __PRIVATE_EvaluateResult.newValue({
                                    bytesValue: ByteString.fromUint8Array(_$t).toBase64()
                                });
                            }
                            return __PRIVATE_EvaluateResult.newValue({
                                bytesValue: new Uint8Array(_$e).reverse()
                            });
                        }
                    case "STRING":
                        {
                            var _n_value1;
                            var _$e1 = (_n_value1 = n.value) === null || _n_value1 === void 0 ? void 0 : _n_value1.stringValue, _$t1 = new Intl.__PRIVATE_Segmenter(void 0, {
                                granularity: "grapheme"
                            }).segment(_$e1), r = Array.from(_$t1, function(e) {
                                return e.segment;
                            }).reverse();
                            return __PRIVATE_EvaluateResult.newValue({
                                stringValue: r.join("")
                            });
                        }
                    default:
                        return __PRIVATE_EvaluateResult.mr();
                }
            }
        }
    ]);
    return __PRIVATE_CoreReverse;
}();
var __PRIVATE_CoreReplaceFirst = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreReplaceFirst(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreReplaceFirst);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreReplaceFirst, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                throw new Error("Unimplemented");
            }
        }
    ]);
    return __PRIVATE_CoreReplaceFirst;
}();
var __PRIVATE_CoreReplaceAll = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreReplaceAll(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreReplaceAll);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreReplaceAll, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                throw new Error("Unimplemented");
            }
        }
    ]);
    return __PRIVATE_CoreReplaceAll;
}();
var __PRIVATE_CoreCharLength = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreCharLength(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreCharLength);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreCharLength, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                __PRIVATE_hardAssert(1 === this.expr.params.length, 19400);
                var n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
                switch(n.type){
                    case "NULL":
                        return __PRIVATE_EvaluateResult.gr();
                    case "STRING":
                        {
                            var _$e = function __PRIVATE_getUnicodePointCount(e) {
                                var _$t = 0;
                                for(var n = 0; n < e.length; n++){
                                    var r = e.codePointAt(n);
                                    if (void 0 === r) return; // Should not happen with valid JS strings
                                    // BMP character (including lone surrogates, which count as 1)
                                    if (r <= 65535) {
                                        // Check specifically for lone surrogates which are invalid UTF-16 sequences
                                        if (r >= 55296 && r <= 57343) {
                                            // High surrogate: check if followed by low surrogate
                                            if (r <= 56319) {
                                                var r1 = e.codePointAt(n + 1);
                                                void 0 !== r1 && r1 >= 56320 && r1 <= 57343 ? // Valid surrogate pair (counts as one character)
                                                (_$t += 1, n++) : // Lone high surrogate - treat as one character for length, but invalid for byte length
                                                _$t += 1;
                                            } else // Lone low surrogate - treat as one character
                                            _$t += 1;
                                        } else // Regular BMP character
                                        _$t += 1;
                                    } else {
                                        if (!(r <= 1114111)) return;
                                        // Invalid code point
                                        _$t += 1, n++;
                                    }
                                }
                                return _$t;
                            }(n.value.stringValue);
                            // If counting failed (e.g., invalid sequence), return error
                            return void 0 === _$e ? __PRIVATE_EvaluateResult.mr() : __PRIVATE_EvaluateResult.newValue({
                                integerValue: _$e
                            });
                        }
                    default:
                        return __PRIVATE_EvaluateResult.mr();
                }
            }
        }
    ]);
    return __PRIVATE_CoreCharLength;
}();
var __PRIVATE_CoreByteLength = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreByteLength(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreByteLength);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreByteLength, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                __PRIVATE_hardAssert(1 === this.expr.params.length, 8486);
                var n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
                switch(n.type){
                    case "BYTES":
                        {
                            var _n_value;
                            var _$e = (_n_value = n.value) === null || _n_value === void 0 ? void 0 : _n_value.bytesValue;
                            return "string" == typeof _$e ? __PRIVATE_EvaluateResult.newValue({
                                integerValue: ByteString.fromBase64String(_$e).toUint8Array().length
                            }) : __PRIVATE_EvaluateResult.newValue({
                                integerValue: new Uint8Array(_$e).length
                            });
                        }
                    case "STRING":
                        {
                            var _n_value1;
                            // return the number of bytes in the string
                            var _$e1 = function __PRIVATE_getUtf8ByteLength(e) {
                                var _$t = 0;
                                for(var n = 0; n < e.length; n++){
                                    var r = e.codePointAt(n);
                                    // Check for out of range of lone surrogate
                                    if (void 0 === r) return;
                                    if (r >= 55296 && r <= 57343) {
                                        // If it is a high surrogate, check if a low surrogate follows
                                        if (!(r <= 56319)) return;
                                        // Lone low surrogate
                                        {
                                            var r1 = e.codePointAt(n + 1);
                                            if (void 0 === r1 || !(r1 >= 56320 && r1 <= 57343)) return; // Lone high surrogate
                                            // Valid surrogate pair
                                            _$t += 4, n++;
                                        }
                                    } else if (r <= 127) _$t += 1;
                                    else if (r <= 2047) _$t += 2;
                                    else if (r <= 65535) _$t += 3;
                                    else {
                                        if (!(r <= 1114111)) return;
                                        // Invalid code point (should not normally happen)
                                        _$t += 4, n++;
                                    }
                                }
                                return _$t;
                            }((_n_value1 = n.value) === null || _n_value1 === void 0 ? void 0 : _n_value1.stringValue);
                            return void 0 === _$e1 ? __PRIVATE_EvaluateResult.mr() : __PRIVATE_EvaluateResult.newValue({
                                integerValue: _$e1
                            });
                        }
                    case "NULL":
                        return __PRIVATE_EvaluateResult.gr();
                    default:
                        return __PRIVATE_EvaluateResult.mr();
                }
            }
        }
    ]);
    return __PRIVATE_CoreByteLength;
}();
var __PRIVATE_StringSearchFunctionBase = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_StringSearchFunctionBase(e) {
        (0, $4QweW._)(this, __PRIVATE_StringSearchFunctionBase);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_StringSearchFunctionBase, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                var _r_value, _i_value;
                __PRIVATE_hardAssert(2 === this.expr.params.length, 39773, "".concat(this.expr.name, "() function should have exactly two parameters"));
                var n = false;
                var r = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
                switch(r.type){
                    case "STRING":
                        break;
                    case "NULL":
                        n = true;
                        break;
                    default:
                        return __PRIVATE_EvaluateResult.mr();
                }
                var i = __PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
                switch(i.type){
                    case "STRING":
                        break;
                    case "NULL":
                        n = true;
                        break;
                    default:
                        return __PRIVATE_EvaluateResult.mr();
                }
                return n ? __PRIVATE_EvaluateResult.gr() : this.Or((_r_value = r.value) === null || _r_value === void 0 ? void 0 : _r_value.stringValue, (_i_value = i.value) === null || _i_value === void 0 ? void 0 : _i_value.stringValue);
            }
        }
    ]);
    return __PRIVATE_StringSearchFunctionBase;
}();
var __PRIVATE_CoreLike = /*#__PURE__*/ function(__PRIVATE_StringSearchFunctionBase) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_CoreLike, __PRIVATE_StringSearchFunctionBase);
    function __PRIVATE_CoreLike() {
        (0, $4QweW._)(this, __PRIVATE_CoreLike);
        return (0, $ehF45._)(this, __PRIVATE_CoreLike, arguments);
    }
    (0, $6hK4i._)(__PRIVATE_CoreLike, [
        {
            key: "Or",
            value: function Or(e, t) {
                try {
                    var n = function __PRIVATE_likeToRegex(e) {
                        var _$t = "";
                        for(var n = 0; n < e.length; n++){
                            var r = e.charAt(n);
                            switch(r){
                                case "_":
                                    _$t += ".";
                                    break;
                                case "%":
                                    _$t += ".*";
                                    break;
                                // Escape regex special characters
                                case "\\":
                                // Need to escape backslash itself
                                case ".":
                                case "*":
                                case "?":
                                case "+":
                                case "^":
                                case "$":
                                case "|":
                                case "(":
                                case ")":
                                case "[":
                                case "]":
                                case "{":
                                case "}":
                                    _$t += "\\" + r;
                                    break;
                                default:
                                    _$t += r;
                            }
                        }
                        // Anchor the regex to match the entire string
                        return "^" + _$t + "$";
                    }(t), r = (0, $lmcdu.RE2JS).compile(n);
                    return __PRIVATE_EvaluateResult.newValue({
                        booleanValue: r.matches(e)
                    });
                } catch (e) {
                    return __PRIVATE_logWarn("Invalid LIKE pattern converted to regex: ".concat(t, ", returning error. Error: ").concat(e)), __PRIVATE_EvaluateResult.mr();
                }
            }
        }
    ]);
    return __PRIVATE_CoreLike;
}(__PRIVATE_StringSearchFunctionBase);
var __PRIVATE_CoreRegexContains = /*#__PURE__*/ function(__PRIVATE_StringSearchFunctionBase) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_CoreRegexContains, __PRIVATE_StringSearchFunctionBase);
    function __PRIVATE_CoreRegexContains() {
        (0, $4QweW._)(this, __PRIVATE_CoreRegexContains);
        return (0, $ehF45._)(this, __PRIVATE_CoreRegexContains, arguments);
    }
    (0, $6hK4i._)(__PRIVATE_CoreRegexContains, [
        {
            key: "Or",
            value: function Or(e, t) {
                try {
                    var n = (0, $lmcdu.RE2JS).compile(t);
                    return __PRIVATE_EvaluateResult.newValue({
                        booleanValue: n.test(e)
                    });
                } catch (e) {
                    return __PRIVATE_logWarn("Invalid regex pattern found in regex_contains: ".concat(t, ", returning error")), __PRIVATE_EvaluateResult.mr();
                }
            }
        }
    ]);
    return __PRIVATE_CoreRegexContains;
}(__PRIVATE_StringSearchFunctionBase);
var __PRIVATE_CoreRegexMatch = /*#__PURE__*/ function(__PRIVATE_StringSearchFunctionBase) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_CoreRegexMatch, __PRIVATE_StringSearchFunctionBase);
    function __PRIVATE_CoreRegexMatch() {
        (0, $4QweW._)(this, __PRIVATE_CoreRegexMatch);
        return (0, $ehF45._)(this, __PRIVATE_CoreRegexMatch, arguments);
    }
    (0, $6hK4i._)(__PRIVATE_CoreRegexMatch, [
        {
            key: "Or",
            value: function Or(e, t) {
                try {
                    // Use matches() for full string match semantics
                    return __PRIVATE_EvaluateResult.newValue({
                        booleanValue: (0, $lmcdu.RE2JS).compile(t).matches(e)
                    });
                } catch (e) {
                    return __PRIVATE_logWarn("Invalid regex pattern found in regex_match: ".concat(t, ", returning error")), __PRIVATE_EvaluateResult.mr();
                }
            }
        }
    ]);
    return __PRIVATE_CoreRegexMatch;
}(__PRIVATE_StringSearchFunctionBase);
var __PRIVATE_CoreStrContains = /*#__PURE__*/ function(__PRIVATE_StringSearchFunctionBase) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_CoreStrContains, __PRIVATE_StringSearchFunctionBase);
    function __PRIVATE_CoreStrContains() {
        (0, $4QweW._)(this, __PRIVATE_CoreStrContains);
        return (0, $ehF45._)(this, __PRIVATE_CoreStrContains, arguments);
    }
    (0, $6hK4i._)(__PRIVATE_CoreStrContains, [
        {
            key: "Or",
            value: function Or(e, t) {
                return __PRIVATE_EvaluateResult.newValue({
                    booleanValue: e.includes(t)
                });
            }
        }
    ]);
    return __PRIVATE_CoreStrContains;
}(__PRIVATE_StringSearchFunctionBase);
var __PRIVATE_CoreStartsWith = /*#__PURE__*/ function(__PRIVATE_StringSearchFunctionBase) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_CoreStartsWith, __PRIVATE_StringSearchFunctionBase);
    function __PRIVATE_CoreStartsWith() {
        (0, $4QweW._)(this, __PRIVATE_CoreStartsWith);
        return (0, $ehF45._)(this, __PRIVATE_CoreStartsWith, arguments);
    }
    (0, $6hK4i._)(__PRIVATE_CoreStartsWith, [
        {
            key: "Or",
            value: function Or(e, t) {
                return __PRIVATE_EvaluateResult.newValue({
                    booleanValue: e.startsWith(t)
                });
            }
        }
    ]);
    return __PRIVATE_CoreStartsWith;
}(__PRIVATE_StringSearchFunctionBase);
var __PRIVATE_CoreEndsWith = /*#__PURE__*/ function(__PRIVATE_StringSearchFunctionBase) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_CoreEndsWith, __PRIVATE_StringSearchFunctionBase);
    function __PRIVATE_CoreEndsWith() {
        (0, $4QweW._)(this, __PRIVATE_CoreEndsWith);
        return (0, $ehF45._)(this, __PRIVATE_CoreEndsWith, arguments);
    }
    (0, $6hK4i._)(__PRIVATE_CoreEndsWith, [
        {
            key: "Or",
            value: function Or(e, t) {
                return __PRIVATE_EvaluateResult.newValue({
                    booleanValue: e.endsWith(t)
                });
            }
        }
    ]);
    return __PRIVATE_CoreEndsWith;
}(__PRIVATE_StringSearchFunctionBase);
var __PRIVATE_CoreToLower = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreToLower(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreToLower);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreToLower, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                __PRIVATE_hardAssert(1 === this.expr.params.length, 29079);
                var n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
                switch(n.type){
                    case "STRING":
                        var _n_value_stringValue, _n_value;
                        return __PRIVATE_EvaluateResult.newValue({
                            stringValue: (_n_value = n.value) === null || _n_value === void 0 ? void 0 : (_n_value_stringValue = _n_value.stringValue) === null || _n_value_stringValue === void 0 ? void 0 : _n_value_stringValue.toLowerCase()
                        });
                    case "NULL":
                        return __PRIVATE_EvaluateResult.gr();
                    default:
                        return __PRIVATE_EvaluateResult.mr();
                }
            }
        }
    ]);
    return __PRIVATE_CoreToLower;
}();
var __PRIVATE_CoreToUpper = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreToUpper(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreToUpper);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreToUpper, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                __PRIVATE_hardAssert(1 === this.expr.params.length, 60487);
                var n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
                switch(n.type){
                    case "STRING":
                        var _n_value_stringValue, _n_value;
                        return __PRIVATE_EvaluateResult.newValue({
                            stringValue: (_n_value = n.value) === null || _n_value === void 0 ? void 0 : (_n_value_stringValue = _n_value.stringValue) === null || _n_value_stringValue === void 0 ? void 0 : _n_value_stringValue.toUpperCase()
                        });
                    case "NULL":
                        return __PRIVATE_EvaluateResult.gr();
                    default:
                        return __PRIVATE_EvaluateResult.mr();
                }
            }
        }
    ]);
    return __PRIVATE_CoreToUpper;
}();
var __PRIVATE_CoreTrim = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreTrim(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreTrim);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreTrim, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                __PRIVATE_hardAssert(1 === this.expr.params.length, 28544);
                var n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
                switch(n.type){
                    case "STRING":
                        var _n_value_stringValue, _n_value;
                        return __PRIVATE_EvaluateResult.newValue({
                            stringValue: (_n_value = n.value) === null || _n_value === void 0 ? void 0 : (_n_value_stringValue = _n_value.stringValue) === null || _n_value_stringValue === void 0 ? void 0 : _n_value_stringValue.trim()
                        });
                    case "NULL":
                        return __PRIVATE_EvaluateResult.gr();
                    default:
                        return __PRIVATE_EvaluateResult.mr();
                }
            }
        }
    ]);
    return __PRIVATE_CoreTrim;
}();
var __PRIVATE_CoreStrConcat = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreStrConcat(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreStrConcat);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreStrConcat, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                var n = this.expr.params.map(function(n) {
                    return __PRIVATE_toEvaluable(n).evaluate(e, t);
                });
                // If any part is error or unset, or not a string (and not null), result is error
                // If any part is null, result is null
                var r = "", i = false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var e1 = _step.value;
                        switch(e1.type){
                            case "STRING":
                                r += e1.value.stringValue;
                                break;
                            case "NULL":
                                i = true;
                                break;
                            default:
                                return __PRIVATE_EvaluateResult.mr();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return i ? __PRIVATE_EvaluateResult.gr() : __PRIVATE_EvaluateResult.newValue({
                    stringValue: r
                });
            }
        }
    ]);
    return __PRIVATE_CoreStrConcat;
}();
var __PRIVATE_CoreMapGet = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreMapGet(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreMapGet);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreMapGet, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                var _r_value, _n_value_mapValue_fields, _n_value_mapValue, _n_value;
                __PRIVATE_hardAssert(2 === this.expr.params.length, 4483);
                var n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
                switch(n.type){
                    case "UNSET":
                        return __PRIVATE_EvaluateResult.pr();
                    case "MAP":
                        break;
                    default:
                        return __PRIVATE_EvaluateResult.mr();
                }
                var r = __PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
                if ("STRING" !== r.type) return __PRIVATE_EvaluateResult.mr();
                var i = (_n_value = n.value) === null || _n_value === void 0 ? void 0 : (_n_value_mapValue = _n_value.mapValue) === null || _n_value_mapValue === void 0 ? void 0 : (_n_value_mapValue_fields = _n_value_mapValue.fields) === null || _n_value_mapValue_fields === void 0 ? void 0 : _n_value_mapValue_fields[(_r_value = r.value) === null || _r_value === void 0 ? void 0 : _r_value.stringValue];
                return void 0 === i ? __PRIVATE_EvaluateResult.pr() : __PRIVATE_EvaluateResult.newValue(i);
            }
        }
    ]);
    return __PRIVATE_CoreMapGet;
}();
var __PRIVATE_DistanceBase = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_DistanceBase(e) {
        (0, $4QweW._)(this, __PRIVATE_DistanceBase);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_DistanceBase, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                var _s_values, __values;
                __PRIVATE_hardAssert(2 === this.expr.params.length, 25231, "".concat(this.expr.name, "() function should have exactly 2 params"));
                var n = false;
                var r = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
                switch(r.type){
                    case "VECTOR":
                        break;
                    case "NULL":
                        n = true;
                        break;
                    default:
                        return __PRIVATE_EvaluateResult.mr();
                }
                var i = __PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
                switch(i.type){
                    case "VECTOR":
                        break;
                    case "NULL":
                        n = true;
                        break;
                    default:
                        return __PRIVATE_EvaluateResult.mr();
                }
                if (n) return __PRIVATE_EvaluateResult.gr();
                var s = __PRIVATE_getVectorValue(r.value), _ = __PRIVATE_getVectorValue(i.value);
                // Mismatched lengths or undefined vectors result in error
                if (void 0 === s || void 0 === _ || ((_s_values = s.values) === null || _s_values === void 0 ? void 0 : _s_values.length) !== ((__values = _.values) === null || __values === void 0 ? void 0 : __values.length)) return __PRIVATE_EvaluateResult.mr();
                var o = this.Mr(s, _);
                // NaN or undefined distance calculation results in error
                return void 0 === o || isNaN(o) ? __PRIVATE_EvaluateResult.mr() : __PRIVATE_EvaluateResult.newValue({
                    doubleValue: o
                });
            }
        }
    ]);
    return __PRIVATE_DistanceBase;
}();
var __PRIVATE_CoreCosineDistance = /*#__PURE__*/ function(__PRIVATE_DistanceBase) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_CoreCosineDistance, __PRIVATE_DistanceBase);
    function __PRIVATE_CoreCosineDistance() {
        (0, $4QweW._)(this, __PRIVATE_CoreCosineDistance);
        return (0, $ehF45._)(this, __PRIVATE_CoreCosineDistance, arguments);
    }
    (0, $6hK4i._)(__PRIVATE_CoreCosineDistance, [
        {
            key: "Mr",
            value: function Mr(e, t) {
                var _e_values, _t_values;
                var n = (_e_values = e === null || e === void 0 ? void 0 : e.values) !== null && _e_values !== void 0 ? _e_values : [], r = (_t_values = t === null || t === void 0 ? void 0 : t.values) !== null && _t_values !== void 0 ? _t_values : [];
                if (0 === n.length) return;
                // Distance undefined for empty vectors
                var i = 0, s = 0, _ = 0;
                for(var _$e = 0; _$e < n.length; _$e++){
                    // Error if any element is not a number
                    if (!R(n[_$e]) || !R(r[_$e])) return;
                    var _$t = __PRIVATE_asDouble(n[_$e]), o = __PRIVATE_asDouble(r[_$e]);
                    i += _$t * o, s += _$t * _$t, _ += o * o;
                }
                var o1 = Math.sqrt(s) * Math.sqrt(_);
                // Distance undefined if either vector has zero magnitude
                if (0 === o1) return;
                // Clamp cosine similarity to [-1, 1] due to potential floating point inaccuracies
                return 1 - Math.max(-1, Math.min(1, i / o1));
            }
        }
    ]);
    return __PRIVATE_CoreCosineDistance;
}(__PRIVATE_DistanceBase);
var __PRIVATE_CoreDotProduct = /*#__PURE__*/ function(__PRIVATE_DistanceBase) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_CoreDotProduct, __PRIVATE_DistanceBase);
    function __PRIVATE_CoreDotProduct() {
        (0, $4QweW._)(this, __PRIVATE_CoreDotProduct);
        return (0, $ehF45._)(this, __PRIVATE_CoreDotProduct, arguments);
    }
    (0, $6hK4i._)(__PRIVATE_CoreDotProduct, [
        {
            key: "Mr",
            value: function Mr(e, t) {
                var _e_values, _t_values;
                var n = (_e_values = e === null || e === void 0 ? void 0 : e.values) !== null && _e_values !== void 0 ? _e_values : [], r = (_t_values = t === null || t === void 0 ? void 0 : t.values) !== null && _t_values !== void 0 ? _t_values : [];
                if (0 === n.length) return 0;
                // Dot product of empty vectors is 0
                var i = 0;
                for(var _$e = 0; _$e < n.length; _$e++){
                    // Error if any element is not a number
                    if (!R(n[_$e]) || !R(r[_$e])) return;
                    i += __PRIVATE_asDouble(n[_$e]) * __PRIVATE_asDouble(r[_$e]);
                }
                return i;
            }
        }
    ]);
    return __PRIVATE_CoreDotProduct;
}(__PRIVATE_DistanceBase);
var __PRIVATE_CoreEuclideanDistance = /*#__PURE__*/ function(__PRIVATE_DistanceBase) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_CoreEuclideanDistance, __PRIVATE_DistanceBase);
    function __PRIVATE_CoreEuclideanDistance() {
        (0, $4QweW._)(this, __PRIVATE_CoreEuclideanDistance);
        return (0, $ehF45._)(this, __PRIVATE_CoreEuclideanDistance, arguments);
    }
    (0, $6hK4i._)(__PRIVATE_CoreEuclideanDistance, [
        {
            key: "Mr",
            value: function Mr(e, t) {
                var _e_values, _t_values;
                var n = (_e_values = e === null || e === void 0 ? void 0 : e.values) !== null && _e_values !== void 0 ? _e_values : [], r = (_t_values = t === null || t === void 0 ? void 0 : t.values) !== null && _t_values !== void 0 ? _t_values : [];
                if (0 === n.length) return 0;
                // Distance between empty vectors is 0
                var i = 0;
                for(var _$e = 0; _$e < n.length; _$e++){
                    // Error if any element is not a number
                    if (!R(n[_$e]) || !R(r[_$e])) return;
                    var _$t = __PRIVATE_asDouble(n[_$e]), s = __PRIVATE_asDouble(r[_$e]);
                    i += Math.pow(_$t - s, 2);
                }
                return Math.sqrt(i);
            }
        }
    ]);
    return __PRIVATE_CoreEuclideanDistance;
}(__PRIVATE_DistanceBase);
var __PRIVATE_CoreVectorLength = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_CoreVectorLength(e) {
        (0, $4QweW._)(this, __PRIVATE_CoreVectorLength);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_CoreVectorLength, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                __PRIVATE_hardAssert(1 === this.expr.params.length, 39044);
                var n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
                switch(n.type){
                    case "VECTOR":
                        {
                            var _e_values;
                            var _$e = __PRIVATE_getVectorValue(n.value);
                            var _e_values_length;
                            return __PRIVATE_EvaluateResult.newValue({
                                integerValue: (_e_values_length = _$e === null || _$e === void 0 ? void 0 : (_e_values = _$e.values) === null || _e_values === void 0 ? void 0 : _e_values.length) !== null && _e_values_length !== void 0 ? _e_values_length : 0
                            });
                        }
                    case "NULL":
                        return __PRIVATE_EvaluateResult.gr();
                    default:
                        return __PRIVATE_EvaluateResult.mr();
                }
            }
        }
    ]);
    return __PRIVATE_CoreVectorLength;
}();
// 0001-01-01T00:00:00Z
var Mt = BigInt(-62135596800), Nt = BigInt(253402300799), Lt = BigInt(1e3), Bt = BigInt(1e6), Ut = Mt * Lt, kt = Nt * Lt + BigInt(999), qt = Mt * Bt, $t = Nt * Bt + BigInt(999999);
// 9999-12-31T23:59:59Z - but the max timestamp has 999,999,999 nanoseconds
// Max sub-second micros
function __PRIVATE_isMicrosInBounds(e) {
    return e >= qt && e <= $t;
}
function __PRIVATE_isSecondsInBounds(e) {
    return e >= Mt && e <= Nt;
}
function __PRIVATE_isTimestampInBounds(e, t) {
    var n = BigInt(e);
    return !(n < Mt || n > Nt) && // Nanos must be non-negative and less than 1 second
    !(t < 0 || t >= 1e9) && // Additional check for min/max boundaries
    (n !== Mt || 0 === t) && !(n === Nt && t > 999999999);
}
// Helper function to adjust timestamp for negative nanoseconds
function __PRIVATE_adjustTimestamp(e, t) {
    return t < 0 ? {
        seconds: e - 1,
        nanos: t + 1e9
    } : {
        seconds: e,
        nanos: t
    };
}
function __PRIVATE_timestampToMicros(e) {
    return BigInt(e.seconds) * Bt + // Integer division truncates towards zero
    BigInt(Math.trunc(e.nanoseconds / 1e3));
}
var __PRIVATE_UnixToTimestamp = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_UnixToTimestamp(e) {
        (0, $4QweW._)(this, __PRIVATE_UnixToTimestamp);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_UnixToTimestamp, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                __PRIVATE_hardAssert(1 === this.expr.params.length, 49262, "".concat(this.expr.name, "() function should have exactly one parameter"));
                var n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
                switch(n.type){
                    case "INT":
                        return this.toTimestamp(BigInt(n.value.integerValue));
                    case "NULL":
                        return __PRIVATE_EvaluateResult.gr();
                    default:
                        return __PRIVATE_EvaluateResult.mr();
                }
            }
        }
    ]);
    return __PRIVATE_UnixToTimestamp;
}();
var __PRIVATE_CoreUnixMicrosToTimestamp = /*#__PURE__*/ function(__PRIVATE_UnixToTimestamp) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_CoreUnixMicrosToTimestamp, __PRIVATE_UnixToTimestamp);
    function __PRIVATE_CoreUnixMicrosToTimestamp() {
        (0, $4QweW._)(this, __PRIVATE_CoreUnixMicrosToTimestamp);
        return (0, $ehF45._)(this, __PRIVATE_CoreUnixMicrosToTimestamp, arguments);
    }
    (0, $6hK4i._)(__PRIVATE_CoreUnixMicrosToTimestamp, [
        {
            key: "toTimestamp",
            value: function toTimestamp(e) {
                if (!__PRIVATE_isMicrosInBounds(e)) return __PRIVATE_EvaluateResult.mr();
                var t = Number(e / Bt), n = Number(e % Bt * BigInt(1e3));
                // Note: BigInt modulo can result in negative values if the dividend is negative.
                // Adjust for negative nanoseconds
                var r = __PRIVATE_adjustTimestamp(t, n);
                // Final bounds check after adjustment
                return t = r.seconds, n = r.nanos, __PRIVATE_isTimestampInBounds(t, n) ? __PRIVATE_EvaluateResult.newValue({
                    timestampValue: {
                        seconds: t,
                        nanos: n
                    }
                }) : __PRIVATE_EvaluateResult.mr();
            }
        }
    ]);
    return __PRIVATE_CoreUnixMicrosToTimestamp;
}(__PRIVATE_UnixToTimestamp);
var __PRIVATE_CoreUnixMillisToTimestamp = /*#__PURE__*/ function(__PRIVATE_UnixToTimestamp) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_CoreUnixMillisToTimestamp, __PRIVATE_UnixToTimestamp);
    function __PRIVATE_CoreUnixMillisToTimestamp() {
        (0, $4QweW._)(this, __PRIVATE_CoreUnixMillisToTimestamp);
        return (0, $ehF45._)(this, __PRIVATE_CoreUnixMillisToTimestamp, arguments);
    }
    (0, $6hK4i._)(__PRIVATE_CoreUnixMillisToTimestamp, [
        {
            key: "toTimestamp",
            value: function toTimestamp(e) {
                if (!function __PRIVATE_isMillisInBounds(e) {
                    return e >= Ut && e <= kt;
                }(e)) return __PRIVATE_EvaluateResult.mr();
                var t = Number(e / Lt), n = Number(e % Lt * BigInt(1e6));
                // Adjust for negative nanoseconds
                var r = __PRIVATE_adjustTimestamp(t, n);
                // Final bounds check after adjustment
                return t = r.seconds, n = r.nanos, __PRIVATE_isTimestampInBounds(t, n) ? __PRIVATE_EvaluateResult.newValue({
                    timestampValue: {
                        seconds: t,
                        nanos: n
                    }
                }) : __PRIVATE_EvaluateResult.mr();
            }
        }
    ]);
    return __PRIVATE_CoreUnixMillisToTimestamp;
}(__PRIVATE_UnixToTimestamp);
var __PRIVATE_CoreUnixSecondsToTimestamp = /*#__PURE__*/ function(__PRIVATE_UnixToTimestamp) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_CoreUnixSecondsToTimestamp, __PRIVATE_UnixToTimestamp);
    function __PRIVATE_CoreUnixSecondsToTimestamp() {
        (0, $4QweW._)(this, __PRIVATE_CoreUnixSecondsToTimestamp);
        return (0, $ehF45._)(this, __PRIVATE_CoreUnixSecondsToTimestamp, arguments);
    }
    (0, $6hK4i._)(__PRIVATE_CoreUnixSecondsToTimestamp, [
        {
            key: "toTimestamp",
            value: function toTimestamp(e) {
                if (!__PRIVATE_isSecondsInBounds(e)) return __PRIVATE_EvaluateResult.mr();
                var t = Number(e);
                return __PRIVATE_EvaluateResult.newValue({
                    timestampValue: {
                        seconds: t,
                        nanos: 0
                    }
                });
            }
        }
    ]);
    return __PRIVATE_CoreUnixSecondsToTimestamp;
}(__PRIVATE_UnixToTimestamp);
var __PRIVATE_TimestampToUnix = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_TimestampToUnix(e) {
        (0, $4QweW._)(this, __PRIVATE_TimestampToUnix);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_TimestampToUnix, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                __PRIVATE_hardAssert(1 === this.expr.params.length, 1265, "".concat(this.expr.name, "() function should have exactly one parameter"));
                var n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
                switch(n.type){
                    case "TIMESTAMP":
                        break;
                    case "NULL":
                        return __PRIVATE_EvaluateResult.gr();
                    default:
                        return __PRIVATE_EvaluateResult.mr();
                }
                var r = fromTimestamp(n.value.timestampValue);
                // Check if the input timestamp is within valid bounds
                return __PRIVATE_isTimestampInBounds(r.seconds, r.nanoseconds) ? this.Nr(r) : __PRIVATE_EvaluateResult.mr();
            }
        }
    ]);
    return __PRIVATE_TimestampToUnix;
}();
var __PRIVATE_CoreTimestampToUnixMicros = /*#__PURE__*/ function(__PRIVATE_TimestampToUnix) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_CoreTimestampToUnixMicros, __PRIVATE_TimestampToUnix);
    function __PRIVATE_CoreTimestampToUnixMicros() {
        (0, $4QweW._)(this, __PRIVATE_CoreTimestampToUnixMicros);
        return (0, $ehF45._)(this, __PRIVATE_CoreTimestampToUnixMicros, arguments);
    }
    (0, $6hK4i._)(__PRIVATE_CoreTimestampToUnixMicros, [
        {
            key: "Nr",
            value: function Nr(e) {
                var t = __PRIVATE_timestampToMicros(e);
                // Check if the resulting micros are within representable bounds
                return __PRIVATE_isMicrosInBounds(t) ? __PRIVATE_EvaluateResult.newValue({
                    integerValue: "".concat(t.toString())
                }) : __PRIVATE_EvaluateResult.mr();
            }
        }
    ]);
    return __PRIVATE_CoreTimestampToUnixMicros;
}(__PRIVATE_TimestampToUnix);
var __PRIVATE_CoreTimestampToUnixMillis = /*#__PURE__*/ function(__PRIVATE_TimestampToUnix) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_CoreTimestampToUnixMillis, __PRIVATE_TimestampToUnix);
    function __PRIVATE_CoreTimestampToUnixMillis() {
        (0, $4QweW._)(this, __PRIVATE_CoreTimestampToUnixMillis);
        return (0, $ehF45._)(this, __PRIVATE_CoreTimestampToUnixMillis, arguments);
    }
    (0, $6hK4i._)(__PRIVATE_CoreTimestampToUnixMillis, [
        {
            key: "Nr",
            value: function Nr(e) {
                var t = __PRIVATE_timestampToMicros(e), n = t / BigInt(1e3), r = t % BigInt(1e3);
                // Perform division, truncating towards zero (default JS BigInt division)
                return n > BigInt(0) || r === BigInt(0) ? __PRIVATE_EvaluateResult.newValue({
                    integerValue: n.toString()
                }) : __PRIVATE_EvaluateResult.newValue({
                    integerValue: (n - BigInt(1)).toString()
                });
            }
        }
    ]);
    return __PRIVATE_CoreTimestampToUnixMillis;
}(__PRIVATE_TimestampToUnix);
var __PRIVATE_CoreTimestampToUnixSeconds = /*#__PURE__*/ function(__PRIVATE_TimestampToUnix) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_CoreTimestampToUnixSeconds, __PRIVATE_TimestampToUnix);
    function __PRIVATE_CoreTimestampToUnixSeconds() {
        (0, $4QweW._)(this, __PRIVATE_CoreTimestampToUnixSeconds);
        return (0, $ehF45._)(this, __PRIVATE_CoreTimestampToUnixSeconds, arguments);
    }
    (0, $6hK4i._)(__PRIVATE_CoreTimestampToUnixSeconds, [
        {
            key: "Nr",
            value: function Nr(e) {
                // Seconds are directly available
                var t = BigInt(e.seconds);
                // Check if the resulting seconds are within representable bounds
                return __PRIVATE_isSecondsInBounds(t) ? __PRIVATE_EvaluateResult.newValue({
                    integerValue: t.toString()
                }) : __PRIVATE_EvaluateResult.mr();
            }
        }
    ]);
    return __PRIVATE_CoreTimestampToUnixSeconds;
}(__PRIVATE_TimestampToUnix);
var __PRIVATE_TimestampArithmetic = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_TimestampArithmetic(e) {
        (0, $4QweW._)(this, __PRIVATE_TimestampArithmetic);
        this.expr = e;
    }
    (0, $6hK4i._)(__PRIVATE_TimestampArithmetic, [
        {
            key: "evaluate",
            value: function evaluate(e, t) {
                __PRIVATE_hardAssert(3 === this.expr.params.length, 2775, "".concat(this.expr.name, "() function should have exactly 3 parameters"));
                var n = false;
                var r = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
                switch(r.type){
                    case "TIMESTAMP":
                        break;
                    case "NULL":
                        n = true;
                        break;
                    default:
                        return __PRIVATE_EvaluateResult.mr();
                }
                var i = __PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
                var s;
                switch(i.type){
                    case "STRING":
                        if (s = function __PRIVATE_asTimeUnit(e) {
                            switch(e){
                                case "microsecond":
                                    return "microsecond";
                                case "millisecond":
                                    return "millisecond";
                                case "second":
                                    return "second";
                                case "minute":
                                    return "minute";
                                case "hour":
                                    return "hour";
                                case "day":
                                    return "day";
                                default:
                                    return;
                            }
                        }(i.value.stringValue), void 0 === s) return __PRIVATE_EvaluateResult.mr();
                        break;
                    case "NULL":
                        n = true;
                        break;
                    default:
                        return __PRIVATE_EvaluateResult.mr();
                }
                var _ = __PRIVATE_toEvaluable(this.expr.params[2]).evaluate(e, t);
                switch(_.type){
                    case "INT":
                        break;
                    case "NULL":
                        n = true;
                        break;
                    default:
                        return __PRIVATE_EvaluateResult.mr();
                }
                if (n) return __PRIVATE_EvaluateResult.gr();
                var o = BigInt(_.value.integerValue);
                var a;
                try {
                    switch(s){
                        case "microsecond":
                            a = o;
                            break;
                        case "millisecond":
                            a = o * BigInt(1e3);
                            break;
                        case "second":
                            a = o * BigInt(1e6);
                            break;
                        case "minute":
                            a = o * BigInt(6e7);
                            break;
                        case "hour":
                            a = o * BigInt(36e8);
                            break;
                        case "day":
                            a = o * BigInt(864e8);
                            break;
                        default:
                            return __PRIVATE_EvaluateResult.mr();
                    }
                    // Check for potential overflow during multiplication
                    if ("microsecond" !== s && o !== BigInt(0) && a / o !== BigInt(this.Lr(s))) return __PRIVATE_EvaluateResult.mr();
                } catch (e) {
                    // Catch potential BigInt errors (though unlikely with isInteger check)
                    return __PRIVATE_logWarn("Error during timestamp arithmetic: ".concat(e)), __PRIVATE_EvaluateResult.mr();
                }
                var u = fromTimestamp(r.value.timestampValue);
                // Check initial timestamp bounds
                if (!__PRIVATE_isTimestampInBounds(u.seconds, u.nanoseconds)) return __PRIVATE_EvaluateResult.mr();
                var c = __PRIVATE_timestampToMicros(u), l = this.Br(c, a);
                // Check final microsecond bounds
                if (!__PRIVATE_isMicrosInBounds(l)) return __PRIVATE_EvaluateResult.mr();
                // Convert back to seconds and nanos
                var E = Number(l / Bt), h = l % Bt, T = Number((h < 0 ? h + Bt : h) * BigInt(1e3)), P = h < 0 ? E - 1 : E;
                // Final check on calculated timestamp bounds
                return __PRIVATE_isTimestampInBounds(P, T) ? __PRIVATE_EvaluateResult.newValue({
                    timestampValue: {
                        seconds: P,
                        nanos: T
                    }
                }) : __PRIVATE_EvaluateResult.mr();
            }
        },
        {
            key: "Lr",
            value: function Lr(e) {
                switch(e){
                    case "millisecond":
                        return 1e3;
                    case "second":
                        return 1e6;
                    case "minute":
                        return 6e7;
                    case "hour":
                        return 36e8;
                    case "day":
                        return 864e8;
                    default:
                        return 1;
                }
            }
        }
    ]);
    return __PRIVATE_TimestampArithmetic;
}();
var __PRIVATE_CoreTimestampAdd = /*#__PURE__*/ function(__PRIVATE_TimestampArithmetic) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_CoreTimestampAdd, __PRIVATE_TimestampArithmetic);
    function __PRIVATE_CoreTimestampAdd() {
        (0, $4QweW._)(this, __PRIVATE_CoreTimestampAdd);
        return (0, $ehF45._)(this, __PRIVATE_CoreTimestampAdd, arguments);
    }
    (0, $6hK4i._)(__PRIVATE_CoreTimestampAdd, [
        {
            key: "Br",
            value: function Br(e, t) {
                return e + t;
            }
        }
    ]);
    return __PRIVATE_CoreTimestampAdd;
}(__PRIVATE_TimestampArithmetic);
var __PRIVATE_CoreTimestampSub = /*#__PURE__*/ function(__PRIVATE_TimestampArithmetic) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_CoreTimestampSub, __PRIVATE_TimestampArithmetic);
    function __PRIVATE_CoreTimestampSub() {
        (0, $4QweW._)(this, __PRIVATE_CoreTimestampSub);
        return (0, $ehF45._)(this, __PRIVATE_CoreTimestampSub, arguments);
    }
    (0, $6hK4i._)(__PRIVATE_CoreTimestampSub, [
        {
            key: "Br",
            value: function Br(e, t) {
                return e - t;
            }
        }
    ]);
    return __PRIVATE_CoreTimestampSub;
}(__PRIVATE_TimestampArithmetic);
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint @typescript-eslint/no-explicit-any: 0 */ function __PRIVATE_toPipelineBooleanExpr(e) {
    if (e instanceof FieldFilter) {
        var t = s(e.field.toString()), n = e.value;
        // Comparison filters
        switch(e.op){
            case "<" /* Operator.LESS_THAN */ :
                return and(t.exists(), t.lessThan(Constant._fromProto(n)));
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                return and(t.exists(), t.lessThanOrEqual(Constant._fromProto(n)));
            case ">" /* Operator.GREATER_THAN */ :
                return and(t.exists(), t.greaterThan(Constant._fromProto(n)));
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                return and(t.exists(), t.greaterThanOrEqual(Constant._fromProto(n)));
            case "==" /* Operator.EQUAL */ :
                return and(t.exists(), t.equal(Constant._fromProto(n)));
            case "!=" /* Operator.NOT_EQUAL */ :
                return t.notEqual(Constant._fromProto(n));
            case "array-contains" /* Operator.ARRAY_CONTAINS */ :
                return and(t.exists(), t.arrayContains(Constant._fromProto(n)));
            case "in" /* Operator.IN */ :
                {
                    var _n_arrayValue_values, _n_arrayValue;
                    var _$e = n === null || n === void 0 ? void 0 : (_n_arrayValue = n.arrayValue) === null || _n_arrayValue === void 0 ? void 0 : (_n_arrayValue_values = _n_arrayValue.values) === null || _n_arrayValue_values === void 0 ? void 0 : _n_arrayValue_values.map(function(e) {
                        return Constant._fromProto(e);
                    });
                    return _$e ? 1 === _$e.length ? and(t.exists(), t.equal(_$e[0])) : and(t.exists(), t.equalAny(_$e)) : and(t.exists(), t.equalAny([]));
                }
            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
                {
                    var _n_arrayValue_values1, _n_arrayValue1;
                    var _$e1 = n === null || n === void 0 ? void 0 : (_n_arrayValue1 = n.arrayValue) === null || _n_arrayValue1 === void 0 ? void 0 : (_n_arrayValue_values1 = _n_arrayValue1.values) === null || _n_arrayValue_values1 === void 0 ? void 0 : _n_arrayValue_values1.map(function(e) {
                        return Constant._fromProto(e);
                    });
                    return and(t.exists(), t.arrayContainsAny(_$e1));
                }
            case "not-in" /* Operator.NOT_IN */ :
                {
                    var _n_arrayValue_values2, _n_arrayValue2;
                    var _$e2 = n === null || n === void 0 ? void 0 : (_n_arrayValue2 = n.arrayValue) === null || _n_arrayValue2 === void 0 ? void 0 : (_n_arrayValue_values2 = _n_arrayValue2.values) === null || _n_arrayValue_values2 === void 0 ? void 0 : _n_arrayValue_values2.map(function(e) {
                        return Constant._fromProto(e);
                    });
                    return _$e2 ? 1 === _$e2.length ? t.notEqual(_$e2[0]) : t.notEqualAny(_$e2) : t.notEqualAny([]);
                }
            default:
                l(36935);
        }
    } else if (e instanceof CompositeFilter) switch(e.op){
        case "and" /* CompositeOperator.AND */ :
            {
                var t1 = e.getFilters().map(function(e) {
                    return __PRIVATE_toPipelineBooleanExpr(e);
                });
                return and.apply(void 0, [
                    t1[0],
                    t1[1]
                ].concat((0, $jlUaU._)(t1.slice(2))));
            }
        case "or" /* CompositeOperator.OR */ :
            {
                var t2 = e.getFilters().map(function(e) {
                    return __PRIVATE_toPipelineBooleanExpr(e);
                });
                return or.apply(void 0, [
                    t2[0],
                    t2[1]
                ].concat((0, $jlUaU._)(t2.slice(2))));
            }
        default:
            l(35306);
    }
    throw new Error("Failed to convert filter to pipeline conditions: ".concat(e));
}
function ea(e, t) {
    var n;
    n = __PRIVATE_isCollectionGroupQuery(e) ? t.pipeline().collectionGroup(e.collectionGroup) : __PRIVATE_isDocumentQuery$1(e) ? t.pipeline().documents([
        doc(t, e.path.canonicalString())
    ]) : t.pipeline().collection(e.path.canonicalString());
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // filters
        for(var _iterator = e.filters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _$t = _step.value;
            n = n.where(__PRIVATE_toPipelineBooleanExpr(_$t));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // orders
    var r = __PRIVATE_queryNormalizedOrderBy(e), i = r.map(function(e) {
        return s(e.field.canonicalString()).exists();
    });
    n = i.length > 1 ? n.where(and.apply(void 0, [
        i[0],
        i[1]
    ].concat((0, $jlUaU._)(i.slice(2))))) : n.where(i[0]);
    var _ = r.map(function(e) {
        return "asc" /* Direction.ASCENDING */  === e.dir ? s(e.field.canonicalString()).ascending() : s(e.field.canonicalString()).descending();
    });
    if (_.length > 0) {
        var _n;
        if ("L" /* LimitType.Last */  === e.limitType) {
            var _n1, _n2;
            var _$t1 = function __PRIVATE_reverseOrderings(e) {
                return e.map(function(e) {
                    return new Ordering(e.expr, "ascending" === e.direction ? "descending" : "ascending", void 0);
                });
            }(_);
            n = (_n1 = n).sort.apply(_n1, [
                _$t1[0]
            ].concat((0, $jlUaU._)(_$t1.slice(1)))), // cursors
            null !== e.startAt && (n = n.where(__PRIVATE_whereConditionsFromCursor(e.startAt, _, "after"))), null !== e.endAt && (n = n.where(__PRIVATE_whereConditionsFromCursor(e.endAt, _, "before"))), n = n.limit(e.limit), n = (_n2 = n).sort.apply(_n2, [
                _[0]
            ].concat((0, $jlUaU._)(_.slice(1))));
        } else n = (_n = n).sort.apply(_n, [
            _[0]
        ].concat((0, $jlUaU._)(_.slice(1)))), null !== e.startAt && (n = n.where(__PRIVATE_whereConditionsFromCursor(e.startAt, _, "after"))), null !== e.endAt && (n = n.where(__PRIVATE_whereConditionsFromCursor(e.endAt, _, "before"))), null !== e.limit && (n = n.limit(e.limit));
    }
    return n.stages;
}
function __PRIVATE_whereConditionsFromCursor(e, t, n) {
    // The filterFunc is either greater than or less than
    var r = "before" === n ? lessThan : greaterThan, i = e.position.map(function(e) {
        return Constant._fromProto(e);
    }), s = i.length;
    var _ = t[s - 1].expr, o = i[s - 1], a = r(_, o);
    e.inclusive && // When the cursor bound is inclusive, then the last bound
    // can be equal to the value, otherwise it's not equal
    (a = or(a, _.equal(o)));
    // Iterate backwards over the remaining bounds, adding
    // a condition for each one
    for(var _$e = s - 2; _$e >= 0; _$e--)_ = t[_$e].expr, o = i[_$e], // For each field in the orderings, the condition is either
    // a) lt|gt the cursor value,
    // b) or equal the cursor value and lt|gt the cursor values for other fields
    a = or(r(_, o), and(_.equal(o), a));
    return a;
}
function __PRIVATE_canonifyExpr(e) {
    if ((e = __PRIVATE_unwrapExpression(e)) instanceof o) return "fld(".concat(e.fieldName, ")");
    if (e instanceof Constant) return "cst(".concat(function __PRIVATE_canonifyConstantValue(e) {
        return null === e ? "null" : "number" == typeof e ? e.toString() : "string" == typeof e ? '"'.concat(e, '"') : e instanceof aa ? "ref(".concat(e.path, ")") : e instanceof n ? "vec(".concat(JSON.stringify(e), ")") : JSON.stringify(e);
    }(e.value), ")");
    if (e instanceof y) return "fn(".concat(e.name, ",[").concat(e.params.map(__PRIVATE_canonifyExpr).join(","), "])");
    if ("ListOfExpressions" === e.expressionType) return "list([".concat(e.cr.map(__PRIVATE_canonifyExpr).join(","), "])");
    throw new Error("Unrecognized expr ".concat(JSON.stringify(e, null, 2)));
}
function __PRIVATE_canonifyStage(e) {
    if (e instanceof w) return "".concat(e._name, "(").concat(__PRIVATE_canonifyExprMap(e.fields), ")");
    if (e instanceof O) {
        var t = "".concat(e._name, "(").concat(__PRIVATE_canonifyExprMap(e.accumulators), ")");
        return e.groups.size > 0 && (t += "grouping(".concat(__PRIVATE_canonifyExprMap(e.groups), ")")), t;
    }
    if (e instanceof M) return "".concat(e._name, "(").concat(__PRIVATE_canonifyExprMap(e.groups), ")");
    if (e instanceof X) return "".concat(e._name, "(").concat(e.hr, ")");
    if (e instanceof Y) return "".concat(e._name, "(").concat(e.collectionId, ")");
    if (e instanceof Z) return "".concat(e._name, "()");
    if (e instanceof sa) return "".concat(e._name, "(").concat(e.Tr.sort(), ")");
    if (e instanceof A) return "".concat(e._name, "(").concat(__PRIVATE_canonifyExpr(e.condition), ")");
    if (e instanceof v) return "".concat(e._name, "(").concat(e.limit, ")");
    if (e instanceof L) return "".concat(e._name, "(").concat(function __PRIVATE_canonifySortOrderings(e) {
        return e.map(function(e) {
            return "".concat(__PRIVATE_canonifyExpr(e.expr)).concat(e.direction);
        }).join(",");
    }(e.orderings), ")");
    throw new Error("Unrecognized stage ".concat(e._name));
}
function __PRIVATE_canonifyExprMap(e) {
    return "".concat(Array.from(e.entries()).sort().map(function(param) {
        var _param = (0, $6ZpBv._)(param, 2), _$e = _param[0], t = _param[1];
        return "".concat(_$e, "=").concat(__PRIVATE_canonifyExpr(t));
    }).join(","));
}
function __PRIVATE_canonifyPipeline(e) {
    return e.stages.map(function(e) {
        return __PRIVATE_canonifyStage(e);
    }).join("|");
}
// TODO(pipeline): do a proper implementation for eq.
function __PRIVATE_pipelineEq(e, t) {
    return __PRIVATE_canonifyPipeline(e) === __PRIVATE_canonifyPipeline(t);
}
function __PRIVATE_isPipeline(e) {
    return e instanceof CorePipeline;
}
function __PRIVATE_stringifyQueryOrPipeline(e) {
    return __PRIVATE_isPipeline(e) ? __PRIVATE_canonifyPipeline(e) : __PRIVATE_stringifyQuery(e);
}
function __PRIVATE_canonifyQueryOrPipeline(e) {
    return __PRIVATE_isPipeline(e) ? __PRIVATE_canonifyPipeline(e) : function __PRIVATE_canonifyQuery(e) {
        return "".concat(__PRIVATE_canonifyTarget(__PRIVATE_queryToTarget(e)), "|lt:").concat(e.limitType);
    }(e);
}
function __PRIVATE_queryOrPipelineEqual(e, t) {
    return e instanceof CorePipeline && t instanceof CorePipeline ? __PRIVATE_pipelineEq(e, t) : !(e instanceof CorePipeline && !(t instanceof CorePipeline) || !(e instanceof CorePipeline) && t instanceof CorePipeline) && __PRIVATE_queryEquals(e, t);
}
function __PRIVATE_canonifyTargetOrPipeline(e) {
    return __PRIVATE_targetIsPipelineTarget(e) ? __PRIVATE_canonifyPipeline(e) : __PRIVATE_canonifyTarget(e);
}
function __PRIVATE_targetOrPipelineEqual(e, t) {
    return e instanceof CorePipeline && t instanceof CorePipeline ? __PRIVATE_pipelineEq(e, t) : !(e instanceof CorePipeline && !(t instanceof CorePipeline) || !(e instanceof CorePipeline) && t instanceof CorePipeline) && __PRIVATE_targetEquals(e, t);
}
// function addSystemFields(
//   fields: Map<string, Expression>
// ): Map<string, Expression> {
//   const newFields = new Map<string, Expression>(fields);
//   newFields.set(DOCUMENT_KEY_NAME, field(DOCUMENT_KEY_NAME));
//   newFields.set(CREATE_TIME_NAME, field(CREATE_TIME_NAME));
//   newFields.set(UPDATE_TIME_NAME, field(UPDATE_TIME_NAME));
//   return newFields;
// }
function __PRIVATE_toCorePipeline(e, t) {
    var n = function __PRIVATE_rewriteStages(e) {
        var _$t = false;
        var n = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var r = _step.value;
                // For stages that provide ordering semantics
                if (r instanceof L) {
                    // Ensure we have a stable ordering
                    if (_$t = true, r.orderings.some(function(e) {
                        return e.expr instanceof o && e.expr.fieldName === Ce;
                    })) n.push(r);
                    else {
                        var _$e = r.orderings.map(function(e) {
                            return e;
                        });
                        _$e.push(s(Ce).ascending()), n.push(new L(_$e, {}));
                    }
                } else r instanceof v ? (_$t || (n.push(new L([
                    s(Ce).ascending()
                ], {})), _$t = true), n.push(r)) : n.push(r);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _$t || n.push(new L([
            s(Ce).ascending()
        ], {})), n;
    }(e.stages);
    if (e.userDataReader) {
        var _$t = e.userDataReader.createContext(3 /* UserDataSource.Argument */ , "toCorePipeline");
        n.forEach(function(e) {
            return e._readUserData(_$t);
        });
    }
    return new CorePipeline(e.userDataReader.serializer, n, t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A batch of mutations that will be sent as one unit to the backend.
 */ var MutationBatch = /*#__PURE__*/ function() {
    "use strict";
    function MutationBatch(e, t, n, r) {
        (0, $4QweW._)(this, MutationBatch);
        this.batchId = e, this.localWriteTime = t, this.baseMutations = n, this.mutations = r;
    }
    (0, $6hK4i._)(MutationBatch, [
        {
            /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to compute the state of the remote document
     *
     * @param document - The document to apply mutations to.
     * @param batchResult - The result of applying the MutationBatch to the
     * backend.
     */ key: "applyToRemoteDocument",
            value: function applyToRemoteDocument(e, t) {
                var n = t.mutationResults;
                for(var _$t = 0; _$t < this.mutations.length; _$t++){
                    var r = this.mutations[_$t];
                    if (r.key.isEqual(e.key)) __PRIVATE_mutationApplyToRemoteDocument(r, e, n[_$t]);
                }
            }
        },
        {
            /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param document - The document to apply mutations to.
     * @param mutatedFields - Fields that have been updated before applying this mutation batch.
     * @returns A `FieldMask` representing all the fields that are mutated.
     */ key: "applyToLocalView",
            value: function applyToLocalView(e, t) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // First, apply the base state. This allows us to apply non-idempotent
                    // transform against a consistent set of values.
                    for(var _iterator = this.baseMutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var n = _step.value;
                        n.key.isEqual(e.key) && (t = __PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    // Second, apply all user-provided mutations.
                    for(var _iterator1 = this.mutations[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var n1 = _step1.value;
                        n1.key.isEqual(e.key) && (t = __PRIVATE_mutationApplyToLocalView(n1, e, t, this.localWriteTime));
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return t;
            }
        },
        {
            /**
     * Computes the local view for all provided documents given the mutations in
     * this batch. Returns a `DocumentKey` to `Mutation` map which can be used to
     * replace all the mutation applications.
     */ key: "applyToLocalDocumentSet",
            value: function applyToLocalDocumentSet(e, t) {
                var _this = this;
                // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
                // directly (as done in `applyToLocalView()`), we can reduce the complexity
                // to O(n).
                var n = __PRIVATE_newMutationMap();
                return this.mutations.forEach(function(r) {
                    var i = e.get(r.key), s = i.overlayedDocument;
                    // TODO(mutabledocuments): This method should take a MutableDocumentMap
                    // and we should remove this cast.
                    var _ = _this.applyToLocalView(s, i.mutatedFields);
                    // Set mutatedFields to null if the document is only from local mutations.
                    // This creates a Set or Delete mutation, instead of trying to create a
                    // patch mutation as the overlay.
                    _ = t.has(r.key) ? null : _;
                    var o = __PRIVATE_calculateOverlayMutation(s, _);
                    null !== o && n.set(r.key, o), s.isValidDocument() || s.convertToNoDocument(SnapshotVersion.min());
                }), n;
            }
        },
        {
            key: "keys",
            value: function keys() {
                return this.mutations.reduce(function(e, t) {
                    return e.add(t.key);
                }, __PRIVATE_documentKeySet());
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return this.batchId === e.batchId && __PRIVATE_arrayEquals(this.mutations, e.mutations, function(e, t) {
                    return __PRIVATE_mutationEquals(e, t);
                }) && __PRIVATE_arrayEquals(this.baseMutations, e.baseMutations, function(e, t) {
                    return __PRIVATE_mutationEquals(e, t);
                });
            }
        }
    ]);
    return MutationBatch;
}();
/** The result of applying a mutation batch to the backend. */ var MutationBatchResult = /*#__PURE__*/ function() {
    "use strict";
    function MutationBatchResult(e, t, n, /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */ r) {
        (0, $4QweW._)(this, MutationBatchResult);
        this.batch = e, this.commitVersion = t, this.mutationResults = n, this.docVersions = r;
    }
    (0, $6hK4i._)(MutationBatchResult, null, [
        {
            key: "from",
            value: /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=&gt;version mapping (docVersions).
     */ function from(e, t, n) {
                __PRIVATE_hardAssert(e.mutations.length === n.length, 58842, {
                    Ur: e.mutations.length,
                    kr: n.length
                });
                var r = function __PRIVATE_documentVersionMap() {
                    return it;
                }();
                var i = e.mutations;
                for(var _$e = 0; _$e < i.length; _$e++)r = r.insert(i[_$e].key, n[_$e].version);
                return new MutationBatchResult(e, t, n, r);
            }
        }
    ]);
    return MutationBatchResult;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var Kt = "";
/**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */ function __PRIVATE_encodeResourcePath(e) {
    var t = "";
    for(var n = 0; n < e.length; n++)t.length > 0 && (t = __PRIVATE_encodeSeparator(t)), t = __PRIVATE_encodeSegment(e.get(n), t);
    return __PRIVATE_encodeSeparator(t);
}
/** Encodes a single segment of a resource path into the given result */ function __PRIVATE_encodeSegment(e, t) {
    var n = t;
    var r = e.length;
    for(var _$t = 0; _$t < r; _$t++){
        var r1 = e.charAt(_$t);
        switch(r1){
            case "\0":
                n += "";
                break;
            case Kt:
                n += "";
                break;
            default:
                n += r1;
        }
    }
    return n;
}
/** Encodes a path separator into the given result */ function __PRIVATE_encodeSeparator(e) {
    return e + Kt + "";
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */ function __PRIVATE_decodeResourcePath(e) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    var t = e.length;
    if (__PRIVATE_hardAssert(t >= 2, 64408, {
        path: e
    }), 2 === t) return __PRIVATE_hardAssert(e.charAt(0) === Kt && "" === e.charAt(1), 56145, {
        path: e
    }), ResourcePath.emptyPath();
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    var __PRIVATE_lastReasonableEscapeIndex = t - 2, n = [];
    var r = "";
    for(var i = 0; i < t;){
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        var t1 = e.indexOf(Kt, i);
        (t1 < 0 || t1 > __PRIVATE_lastReasonableEscapeIndex) && l(50515, {
            path: e
        });
        switch(e.charAt(t1 + 1)){
            case "":
                var s = e.substring(i, t1);
                var _ = void 0;
                0 === r.length ? // Avoid copying for the common case of a segment that excludes \0
                // and \001
                _ = s : (r += s, _ = r, r = ""), n.push(_);
                break;
            case "":
                r += e.substring(i, t1), r += "\0";
                break;
            case "":
                // The escape character can be used in the output to encode itself.
                r += e.substring(i, t1 + 1);
                break;
            default:
                l(61167, {
                    path: e
                });
        }
        i = t1 + 2;
    }
    return new ResourcePath(n);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var Qt = "remoteDocuments", Wt = "owner", Gt = "owner", zt = "mutationQueues", jt = "userId", Ht = "mutations", Jt = "batchId", Yt = "userMutationsIndex", Zt = [
    "userId",
    "batchId"
];
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Name of the IndexedDb object store.
 *
 * Note that the name 'owner' is chosen to ensure backwards compatibility with
 * older clients that only supported single locked access to the persistence
 * layer.
 */ /**
 * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
 * index to iterate over all at document mutations for a given path or lower.
 */ function __PRIVATE_newDbDocumentMutationPrefixForPath(e, t) {
    return [
        e,
        __PRIVATE_encodeResourcePath(t)
    ];
}
/**
 * Creates a full index key of [userId, encodedPath, batchId] for inserting
 * and deleting into the DbDocumentMutations index.
 */ function __PRIVATE_newDbDocumentMutationKey(e, t, n) {
    return [
        e,
        __PRIVATE_encodeResourcePath(t),
        n
    ];
}
/**
 * Because we store all the useful information for this store in the key,
 * there is no useful information to store as the value. The raw (unencoded)
 * path cannot be stored because IndexedDb doesn't store prototype
 * information.
 */ var Xt = {}, en = "documentMutations", tn = "remoteDocumentsV14", nn = [
    "prefixPath",
    "collectionGroup",
    "readTime",
    "documentId"
], rn = "documentKeyIndex", sn = [
    "prefixPath",
    "collectionGroup",
    "documentId"
], _n = "collectionGroupIndex", on = [
    "collectionGroup",
    "readTime",
    "prefixPath",
    "documentId"
], an = "remoteDocumentGlobal", un = "remoteDocumentGlobalKey", cn = "targets", En = "queryTargetsIndex", hn = [
    "canonicalId",
    "targetId"
], Tn = "targetDocuments", Pn = [
    "targetId",
    "path"
], In = "documentTargetsIndex", Rn = [
    "path",
    "targetId"
], An = "targetGlobalKey", Vn = "targetGlobal", dn = "collectionParents", fn = [
    "collectionId",
    "parent"
], mn = "clientMetadata", pn = "clientId", gn = "bundles", yn = "bundleId", wn = "namedQueries", bn = "name", Sn = "indexConfiguration", vn = "indexId", Dn = "collectionGroupIndex", xn = "collectionGroup", Cn = "indexState", Fn = [
    "indexId",
    "uid"
], On = "sequenceNumberIndex", Mn = [
    "uid",
    "sequenceNumber"
], Nn = "indexEntries", Ln = [
    "indexId",
    "uid",
    "arrayValue",
    "directionalValue",
    "orderedDocumentKey",
    "documentKey"
], Bn = "documentKeyIndex", Un = [
    "indexId",
    "uid",
    "orderedDocumentKey"
], kn = "documentOverlays", qn = [
    "userId",
    "collectionPath",
    "documentId"
], $n = "collectionPathOverlayIndex", Kn = [
    "userId",
    "collectionPath",
    "largestBatchId"
], Qn = "collectionGroupOverlayIndex", Wn = [
    "userId",
    "collectionGroup",
    "largestBatchId"
], Gn = "globals", zn = "name", jn = [
    zt,
    Ht,
    en,
    Qt,
    cn,
    Wt,
    Vn,
    Tn,
    mn,
    an,
    dn,
    gn,
    wn
], Hn = (0, $jlUaU._)(jn).concat([
    kn
]), Jn = [
    zt,
    Ht,
    en,
    tn,
    cn,
    Wt,
    Vn,
    Tn,
    mn,
    an,
    dn,
    gn,
    wn,
    kn
], Yn = Jn, Zn = (0, $jlUaU._)(Yn).concat([
    Sn,
    Cn,
    Nn
]), Xn = Zn, er = (0, $jlUaU._)(Zn).concat([
    Gn
]), tr = er;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Delete a mutation batch and the associated document mutations.
 * @returns A PersistencePromise of the document mutations that were removed.
 */ function removeMutationBatch(e, t, n) {
    var r = e.store(Ht), i = e.store(en), s = [], _ = IDBKeyRange.only(n.batchId);
    var o = 0;
    var a = r.Hn({
        range: _
    }, function(e, t, n) {
        return o++, n.delete();
    });
    s.push(a.next(function() {
        __PRIVATE_hardAssert(1 === o, 47070, {
            batchId: n.batchId
        });
    }));
    var u = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = n.mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _$e = _step.value;
            var r1 = __PRIVATE_newDbDocumentMutationKey(t, _$e.key.path, n.batchId);
            s.push(i.delete(r1)), u.push(_$e.key);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return PersistencePromise.waitFor(s).next(function() {
        return u;
    });
}
/**
 * Returns an approximate size for the given document.
 */ function __PRIVATE_dbDocumentSize(e) {
    if (!e) return 0;
    var t;
    if (e.document) t = e.document;
    else if (e.unknownDocument) t = e.unknownDocument;
    else {
        if (!e.noDocument) throw l(14731);
        t = e.noDocument;
    }
    return JSON.stringify(t).length;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var __PRIVATE_IndexedDbTransaction = /*#__PURE__*/ function(PersistenceTransaction) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_IndexedDbTransaction, PersistenceTransaction);
    function __PRIVATE_IndexedDbTransaction(e, t) {
        (0, $4QweW._)(this, __PRIVATE_IndexedDbTransaction);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_IndexedDbTransaction), _this.qr = e, _this.currentSequenceNumber = t;
        return _this;
    }
    return __PRIVATE_IndexedDbTransaction;
}(PersistenceTransaction);
function __PRIVATE_getStore(e, t) {
    var n = __PRIVATE_debugCast(e);
    return __PRIVATE_SimpleDb.Cn(n.qr, t);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Representation of an overlay computed by Firestore.
 *
 * Holds information about a mutation and the largest batch id in Firestore when
 * the mutation was created.
 */ var Overlay = /*#__PURE__*/ function() {
    "use strict";
    function Overlay(e, t) {
        (0, $4QweW._)(this, Overlay);
        this.largestBatchId = e, this.mutation = t;
    }
    (0, $6hK4i._)(Overlay, [
        {
            key: "getKey",
            value: function getKey() {
                return this.mutation.key;
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return null !== e && this.mutation === e.mutation;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "Overlay{\n      largestBatchId: ".concat(this.largestBatchId, ",\n      mutation: ").concat(this.mutation.toString(), "\n    }");
            }
        }
    ]);
    return Overlay;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable set of metadata that the local store tracks for each target.
 */ var TargetData = /*#__PURE__*/ function() {
    "use strict";
    function TargetData(/** The target being listened to. */ e, /**
     * The target ID to which the target corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */ t, /** The purpose of the target. */ n, /**
     * The sequence number of the last transaction during which this target data
     * was modified.
     */ r) {
        var /** The latest snapshot version seen for this target. */ i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : SnapshotVersion.min(), s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : SnapshotVersion.min(), _ = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : ByteString.EMPTY_BYTE_STRING, o = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null;
        (0, $4QweW._)(this, TargetData);
        this.target = e, this.targetId = t, this.purpose = n, this.sequenceNumber = r, this.snapshotVersion = i, this.lastLimboFreeSnapshotVersion = s, this.resumeToken = _, this.expectedCount = o;
    }
    (0, $6hK4i._)(TargetData, [
        {
            /** Creates a new target data instance with an updated sequence number. */ key: "withSequenceNumber",
            value: function withSequenceNumber(e) {
                return new TargetData(this.target, this.targetId, this.purpose, e, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, this.expectedCount);
            }
        },
        {
            /**
     * Creates a new target data instance with an updated resume token and
     * snapshot version.
     */ key: "withResumeToken",
            value: function withResumeToken(e, t) {
                return new TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, t, this.lastLimboFreeSnapshotVersion, e, /* expectedCount= */ null);
            }
        },
        {
            /**
     * Creates a new target data instance with an updated expected count.
     */ key: "withExpectedCount",
            value: function withExpectedCount(e) {
                return new TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, e);
            }
        },
        {
            /**
     * Creates a new target data instance with an updated last limbo free
     * snapshot version number.
     */ key: "withLastLimboFreeSnapshotVersion",
            value: function withLastLimboFreeSnapshotVersion(e) {
                return new TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, e, this.resumeToken, this.expectedCount);
            }
        }
    ]);
    return TargetData;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Serializer for values stored in the LocalStore. */ var __PRIVATE_LocalSerializer = function __PRIVATE_LocalSerializer(e) {
    "use strict";
    (0, $4QweW._)(this, __PRIVATE_LocalSerializer);
    this.$r = e;
};
/** Decodes a remote document from storage locally to a Document. */ function __PRIVATE_fromDbRemoteDocument(e, t) {
    var n;
    if (t.document) n = fromDocument(e.$r, t.document, !!t.hasCommittedMutations);
    else if (t.noDocument) {
        var _$e = DocumentKey.fromSegments(t.noDocument.path), r = __PRIVATE_fromDbTimestamp(t.noDocument.readTime);
        n = MutableDocument.newNoDocument(_$e, r), t.hasCommittedMutations && n.setHasCommittedMutations();
    } else {
        if (!t.unknownDocument) return l(56709);
        {
            var _$e1 = DocumentKey.fromSegments(t.unknownDocument.path), r1 = __PRIVATE_fromDbTimestamp(t.unknownDocument.version);
            n = MutableDocument.newUnknownDocument(_$e1, r1);
        }
    }
    return t.readTime && n.setReadTime(function __PRIVATE_fromDbTimestampKey(e) {
        var _$t = new Timestamp(e[0], e[1]);
        return SnapshotVersion.fromTimestamp(_$t);
    }(t.readTime)), n;
}
/** Encodes a document for storage locally. */ function __PRIVATE_toDbRemoteDocument(e, t) {
    var n = t.key, r = {
        prefixPath: n.getCollectionPath().popLast().toArray(),
        collectionGroup: n.collectionGroup,
        documentId: n.path.lastSegment(),
        readTime: __PRIVATE_toDbTimestampKey(t.readTime),
        hasCommittedMutations: t.hasCommittedMutations
    };
    if (t.isFoundDocument()) r.document = function __PRIVATE_toDocument(e, t) {
        return {
            name: __PRIVATE_toName(e, t.key),
            fields: t.data.value.mapValue.fields,
            updateTime: toTimestamp(e, t.version.toTimestamp()),
            createTime: toTimestamp(e, t.createTime.toTimestamp())
        };
    }(e.$r, t);
    else if (t.isNoDocument()) r.noDocument = {
        path: n.path.toArray(),
        readTime: __PRIVATE_toDbTimestamp(t.version)
    };
    else {
        if (!t.isUnknownDocument()) return l(57904, {
            document: t
        });
        r.unknownDocument = {
            path: n.path.toArray(),
            version: __PRIVATE_toDbTimestamp(t.version)
        };
    }
    return r;
}
function __PRIVATE_toDbTimestampKey(e) {
    var t = e.toTimestamp();
    return [
        t.seconds,
        t.nanoseconds
    ];
}
function __PRIVATE_toDbTimestamp(e) {
    var t = e.toTimestamp();
    return {
        seconds: t.seconds,
        nanoseconds: t.nanoseconds
    };
}
function __PRIVATE_fromDbTimestamp(e) {
    var t = new Timestamp(e.seconds, e.nanoseconds);
    return SnapshotVersion.fromTimestamp(t);
}
/** Encodes a batch of mutations into a DbMutationBatch for local storage. */ /** Decodes a DbMutationBatch into a MutationBatch */ function __PRIVATE_fromDbMutationBatch(e, t) {
    var n = (t.baseMutations || []).map(function(t) {
        return __PRIVATE_fromMutation(e.$r, t);
    });
    // Squash old transform mutations into existing patch or set mutations.
    // The replacement of representing `transforms` with `update_transforms`
    // on the SDK means that old `transform` mutations stored in IndexedDB need
    // to be updated to `update_transforms`.
    // TODO(b/174608374): Remove this code once we perform a schema migration.
    for(var e1 = 0; e1 < t.mutations.length - 1; ++e1){
        var n1 = t.mutations[e1];
        if (e1 + 1 < t.mutations.length && void 0 !== t.mutations[e1 + 1].transform) {
            var r = t.mutations[e1 + 1];
            n1.updateTransforms = r.transform.fieldTransforms, t.mutations.splice(e1 + 1, 1), ++e1;
        }
    }
    var r1 = t.mutations.map(function(t) {
        return __PRIVATE_fromMutation(e.$r, t);
    }), i = Timestamp.fromMillis(t.localWriteTimeMs);
    return new MutationBatch(t.batchId, i, n, r1);
}
/** Decodes a DbTarget into TargetData */ function __PRIVATE_fromDbTarget(e, t) {
    var n = __PRIVATE_fromDbTimestamp(t.readTime), r = void 0 !== t.lastLimboFreeSnapshotVersion ? __PRIVATE_fromDbTimestamp(t.lastLimboFreeSnapshotVersion) : SnapshotVersion.min();
    var i;
    return i = function __PRIVATE_isPipelineQueryTarget(e) {
        return void 0 !== e.structuredPipeline;
    }(t.query) ? function __PRIVATE_fromPipelineTarget(e, t) {
        var _n_pipeline, _n_pipeline1;
        var n = e.structuredPipeline;
        var _n_pipeline_stages;
        __PRIVATE_hardAssert(((_n_pipeline_stages = n === null || n === void 0 ? void 0 : (_n_pipeline = n.pipeline) === null || _n_pipeline === void 0 ? void 0 : _n_pipeline.stages) !== null && _n_pipeline_stages !== void 0 ? _n_pipeline_stages : []).length > 0, 1845);
        var r = n === null || n === void 0 ? void 0 : (_n_pipeline1 = n.pipeline) === null || _n_pipeline1 === void 0 ? void 0 : _n_pipeline1.stages.map(__PRIVATE_stageFromProto);
        return new CorePipeline(t, r);
    }(t.query, e.$r) : function __PRIVATE_isDocumentQuery(e) {
        return void 0 !== e.documents;
    }(t.query) ? function __PRIVATE_fromDocumentsTarget(e) {
        var _$t = e.documents.length;
        return __PRIVATE_hardAssert(1 === _$t, 1966, {
            count: _$t
        }), __PRIVATE_queryToTarget(__PRIVATE_newQueryForPath(__PRIVATE_fromQueryPath(e.documents[0])));
    }(t.query) : function __PRIVATE_fromQueryTarget(e) {
        return __PRIVATE_queryToTarget(__PRIVATE_convertQueryTargetToQuery(e));
    }(t.query), new TargetData(i, t.targetId, "TargetPurposeListen" /* TargetPurpose.Listen */ , t.lastListenSequenceNumber, n, r, ByteString.fromBase64String(t.resumeToken));
}
/** Encodes TargetData into a DbTarget for storage locally. */ function __PRIVATE_toDbTarget(e, t) {
    var n = __PRIVATE_toDbTimestamp(t.snapshotVersion), r = __PRIVATE_toDbTimestamp(t.lastLimboFreeSnapshotVersion);
    var i;
    i = __PRIVATE_targetIsPipelineTarget(t.target) ? __PRIVATE_toPipelineTarget(e.$r, t.target) : __PRIVATE_targetIsDocumentTarget(t.target) ? __PRIVATE_toDocumentsTarget(e.$r, t.target) : __PRIVATE_toQueryTarget(e.$r, t.target).Se;
    // We can't store the resumeToken as a ByteString in IndexedDb, so we
    // convert it to a base64 string for storage.
    var s = t.resumeToken.toBase64();
    // lastListenSequenceNumber is always 0 until we do real GC.
    return {
        targetId: t.targetId,
        canonicalId: __PRIVATE_canonifyTargetOrPipeline(t.target),
        readTime: n,
        resumeToken: s,
        lastListenSequenceNumber: t.sequenceNumber,
        lastLimboFreeSnapshotVersion: r,
        query: i
    };
}
/**
 * Encodes a `BundledQuery` from bundle proto to a Query object.
 *
 * This reconstructs the original query used to build the bundle being loaded,
 * including features exists only in SDKs (for example: limit-to-last).
 */ function __PRIVATE_fromBundledQuery(e) {
    var t = __PRIVATE_convertQueryTargetToQuery({
        parent: e.parent,
        structuredQuery: e.structuredQuery
    });
    return "LAST" === e.limitType ? __PRIVATE_queryWithLimit(t, t.limit, "L" /* LimitType.Last */ ) : t;
}
/** Encodes a NamedQuery proto object to a NamedQuery model object. */ /** Encodes a DbDocumentOverlay object to an Overlay model object. */ function __PRIVATE_fromDbDocumentOverlay(e, t) {
    return new Overlay(t.largestBatchId, __PRIVATE_fromMutation(e.$r, t.overlayMutation));
}
/** Decodes an Overlay model object into a DbDocumentOverlay object. */ /**
 * Returns the DbDocumentOverlayKey corresponding to the given user and
 * document key.
 */ function __PRIVATE_toDbDocumentOverlayKey(e, t) {
    var n = t.path.lastSegment();
    return [
        e,
        __PRIVATE_encodeResourcePath(t.path.popLast()),
        n
    ];
}
function __PRIVATE_toDbIndexState(e, t, n, r) {
    return {
        indexId: e,
        uid: t,
        sequenceNumber: n,
        readTime: __PRIVATE_toDbTimestamp(r.readTime),
        documentKey: __PRIVATE_encodeResourcePath(r.documentKey.path),
        largestBatchId: r.largestBatchId
    };
}
function __PRIVATE_stageFromProto(e) {
    switch(e.name){
        case "collection":
            return new X(e.args[0].referenceValue, {});
        case "collection_group":
            return new Y(e.args[1].stringValue, {});
        case "database":
            return new Z({});
        case "documents":
            return new sa(e.args.map(function(e) {
                return e.referenceValue;
            }), {});
        case "where":
            return new A(__PRIVATE_exprFromProto(e.args[0]), {});
        case "limit":
            {
                var _e_args__integerValue;
                var t = (_e_args__integerValue = e.args[0].integerValue) !== null && _e_args__integerValue !== void 0 ? _e_args__integerValue : e.args[0].doubleValue;
                return new v("number" == typeof t ? t : Number(t), {});
            }
        case "sort":
            return new L(e.args.map(function(e) {
                return function __PRIVATE_orderingFromProto(e) {
                    var _e_mapValue, _t_direction;
                    var t = (_e_mapValue = e.mapValue) === null || _e_mapValue === void 0 ? void 0 : _e_mapValue.fields;
                    return new Ordering(__PRIVATE_exprFromProto(t.expression), (_t_direction = t.direction) === null || _t_direction === void 0 ? void 0 : _t_direction.stringValue, "orderingFromProto");
                }(e);
            }), {});
        default:
            throw new Error("Stage type: ".concat(e.name, " not supported."));
    }
}
function __PRIVATE_exprFromProto(e) {
    return e.fieldReferenceValue ? new o(K("_exprFromProto", e.fieldReferenceValue), "_exprFromProto") : e.functionValue ? function __PRIVATE_functionFromProto(e) {
        var _e_functionValue_args;
        // TODO(pipeline): When aggregation is supported, we need to return AggregateFunction for the functions
        // with aggregate names (sum, count, etc).
        return new y(e.functionValue.name, ((_e_functionValue_args = e.functionValue.args) === null || _e_functionValue_args === void 0 ? void 0 : _e_functionValue_args.map(__PRIVATE_exprFromProto)) || []);
    }(e) : Constant._fromProto(e);
}
var __PRIVATE_IndexedDbMutationQueue = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexedDbMutationQueue(/**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */ e, t, n, r) {
        (0, $4QweW._)(this, __PRIVATE_IndexedDbMutationQueue);
        this.userId = e, this.serializer = t, this.indexManager = n, this.referenceDelegate = r, /**
         * Caches the document keys for pending mutation batches. If the mutation
         * has been removed from IndexedDb, the cached value may continue to
         * be used to retrieve the batch's document keys. To remove a cached value
         * locally, `removeCachedMutationKeys()` should be invoked either directly
         * or through `removeMutationBatches()`.
         *
         * With multi-tab, when the primary client acknowledges or rejects a mutation,
         * this cache is used by secondary clients to invalidate the local
         * view of the documents that were previously affected by the mutation.
         */ // PORTING NOTE: Multi-tab only.
        this.Kr = {};
    }
    (0, $6hK4i._)(__PRIVATE_IndexedDbMutationQueue, [
        {
            key: "checkEmpty",
            value: function checkEmpty(e) {
                var t = true;
                var n = IDBKeyRange.bound([
                    this.userId,
                    Number.NEGATIVE_INFINITY
                ], [
                    this.userId,
                    Number.POSITIVE_INFINITY
                ]);
                return __PRIVATE_mutationsStore(e).Hn({
                    index: Yt,
                    range: n
                }, function(e, n, r) {
                    t = false, r.done();
                }).next(function() {
                    return t;
                });
            }
        },
        {
            key: "addMutationBatch",
            value: function addMutationBatch(e, t, n, r) {
                var _this = this;
                var i = __PRIVATE_documentMutationsStore(e), s = __PRIVATE_mutationsStore(e);
                // The IndexedDb implementation in Chrome (and Firefox) does not handle
                // compound indices that include auto-generated keys correctly. To ensure
                // that the index entry is added correctly in all browsers, we perform two
                // writes: The first write is used to retrieve the next auto-generated Batch
                // ID, and the second write populates the index and stores the actual
                // mutation batch.
                // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
                // We write an empty object to obtain key
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return s.add({}).next(function(_) {
                    __PRIVATE_hardAssert("number" == typeof _, 49019);
                    var o = new MutationBatch(_, t, n, r), a = function __PRIVATE_toDbMutationBatch(e, t, n) {
                        var _$r = n.baseMutations.map(function(t) {
                            return toMutation(e.$r, t);
                        }), i = n.mutations.map(function(t) {
                            return toMutation(e.$r, t);
                        });
                        return {
                            userId: t,
                            batchId: n.batchId,
                            localWriteTimeMs: n.localWriteTime.toMillis(),
                            baseMutations: _$r,
                            mutations: i
                        };
                    }(_this.serializer, _this.userId, o), u = [];
                    var c = new SortedSet(function(e, t) {
                        return __PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString());
                    });
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$e = _step.value;
                            var _$t = __PRIVATE_newDbDocumentMutationKey(_this.userId, _$e.key.path, _);
                            c = c.add(_$e.key.path.popLast()), u.push(s.put(a)), u.push(i.put(_$t, Xt));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return c.forEach(function(t) {
                        u.push(_this.indexManager.addToCollectionParentIndex(e, t));
                    }), e.addOnCommittedListener(function() {
                        _this.Kr[_] = o.keys();
                    }), PersistencePromise.waitFor(u).next(function() {
                        return o;
                    });
                });
            }
        },
        {
            key: "lookupMutationBatch",
            value: function lookupMutationBatch(e, t) {
                var _this = this;
                return __PRIVATE_mutationsStore(e).get(t).next(function(e) {
                    return e ? (__PRIVATE_hardAssert(e.userId === _this.userId, 48, "Unexpected user for mutation batch", {
                        userId: e.userId,
                        batchId: t
                    }), __PRIVATE_fromDbMutationBatch(_this.serializer, e)) : null;
                });
            }
        },
        {
            /**
     * Returns the document keys for the mutation batch with the given batchId.
     * For primary clients, this method returns `null` after
     * `removeMutationBatches()` has been called. Secondary clients return a
     * cached result until `removeCachedMutationKeys()` is invoked.
     */ // PORTING NOTE: Multi-tab only.
            key: "Wr",
            value: function Wr(e, t) {
                var _this = this;
                return this.Kr[t] ? PersistencePromise.resolve(this.Kr[t]) : this.lookupMutationBatch(e, t).next(function(e) {
                    if (e) {
                        var n = e.keys();
                        return _this.Kr[t] = n, n;
                    }
                    return null;
                });
            }
        },
        {
            key: "getNextMutationBatchAfterBatchId",
            value: function getNextMutationBatchAfterBatchId(e, t) {
                var _this = this;
                var n = t + 1, r = IDBKeyRange.lowerBound([
                    this.userId,
                    n
                ]);
                var i = null;
                return __PRIVATE_mutationsStore(e).Hn({
                    index: Yt,
                    range: r
                }, function(e, t, r) {
                    t.userId === _this.userId && (__PRIVATE_hardAssert(t.batchId >= n, 47524, {
                        Gr: n
                    }), i = __PRIVATE_fromDbMutationBatch(_this.serializer, t)), r.done();
                }).next(function() {
                    return i;
                });
            }
        },
        {
            key: "getHighestUnacknowledgedBatchId",
            value: function getHighestUnacknowledgedBatchId(e) {
                var t = IDBKeyRange.upperBound([
                    this.userId,
                    Number.POSITIVE_INFINITY
                ]);
                var n = Ke;
                return __PRIVATE_mutationsStore(e).Hn({
                    index: Yt,
                    range: t,
                    reverse: true
                }, function(e, t, r) {
                    n = t.batchId, r.done();
                }).next(function() {
                    return n;
                });
            }
        },
        {
            key: "getAllMutationBatches",
            value: function getAllMutationBatches(e) {
                var _this = this;
                var t = IDBKeyRange.bound([
                    this.userId,
                    Ke
                ], [
                    this.userId,
                    Number.POSITIVE_INFINITY
                ]);
                return __PRIVATE_mutationsStore(e).Qn(Yt, t).next(function(e) {
                    return e.map(function(e) {
                        return __PRIVATE_fromDbMutationBatch(_this.serializer, e);
                    });
                });
            }
        },
        {
            key: "getAllMutationBatchesAffectingDocumentKey",
            value: function getAllMutationBatchesAffectingDocumentKey(e, t) {
                var _this = this;
                // Scan the document-mutation index starting with a prefix starting with
                // the given documentKey.
                var n = __PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), r = IDBKeyRange.lowerBound(n), i = [];
                return __PRIVATE_documentMutationsStore(e).Hn({
                    range: r
                }, function(n, r, s) {
                    var _n = (0, $6ZpBv._)(n, 3), _ = _n[0], o = _n[1], a = _n[2], u = __PRIVATE_decodeResourcePath(o);
                    // Only consider rows matching exactly the specific key of
                    // interest. Note that because we order by path first, and we
                    // order terminators before path separators, we'll encounter all
                    // the index rows for documentKey contiguously. In particular, all
                    // the rows for documentKey will occur before any rows for
                    // documents nested in a subcollection beneath documentKey so we
                    // can stop as soon as we hit any such row.
                    if (_ === _this.userId && t.path.isEqual(u)) // Look up the mutation batch in the store.
                    return __PRIVATE_mutationsStore(e).get(a).next(function(e) {
                        if (!e) throw l(61480, {
                            zr: n,
                            batchId: a
                        });
                        __PRIVATE_hardAssert(e.userId === _this.userId, 10503, "Unexpected user for mutation batch", {
                            userId: e.userId,
                            batchId: a
                        }), i.push(__PRIVATE_fromDbMutationBatch(_this.serializer, e));
                    });
                    s.done();
                }).next(function() {
                    return i;
                });
            }
        },
        {
            key: "getAllMutationBatchesAffectingDocumentKeys",
            value: function getAllMutationBatchesAffectingDocumentKeys(e, t) {
                var _this = this;
                var n = new SortedSet(__PRIVATE_primitiveComparator);
                var r = [];
                return t.forEach(function(t) {
                    var i = __PRIVATE_newDbDocumentMutationPrefixForPath(_this.userId, t.path), s = IDBKeyRange.lowerBound(i), _ = __PRIVATE_documentMutationsStore(e).Hn({
                        range: s
                    }, function(e, r, i) {
                        var _e = (0, $6ZpBv._)(e, 3), s = _e[0], _ = _e[1], o = _e[2], a = __PRIVATE_decodeResourcePath(_);
                        // Only consider rows matching exactly the specific key of
                        // interest. Note that because we order by path first, and we
                        // order terminators before path separators, we'll encounter all
                        // the index rows for documentKey contiguously. In particular, all
                        // the rows for documentKey will occur before any rows for
                        // documents nested in a subcollection beneath documentKey so we
                        // can stop as soon as we hit any such row.
                        s === _this.userId && t.path.isEqual(a) ? n = n.add(o) : i.done();
                    });
                    r.push(_);
                }), PersistencePromise.waitFor(r).next(function() {
                    return _this.jr(e, n);
                });
            }
        },
        {
            key: "getAllMutationBatchesAffectingQuery",
            value: function getAllMutationBatchesAffectingQuery(e, t) {
                var _this = this;
                var n = t.path, r = n.length + 1, i = __PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, n), s = IDBKeyRange.lowerBound(i);
                // Collect up unique batchIDs encountered during a scan of the index. Use a
                // SortedSet to accumulate batch IDs so they can be traversed in order in a
                // scan of the main table.
                var _ = new SortedSet(__PRIVATE_primitiveComparator);
                return __PRIVATE_documentMutationsStore(e).Hn({
                    range: s
                }, function(e, t, i) {
                    var _e = (0, $6ZpBv._)(e, 3), s = _e[0], o = _e[1], a = _e[2], u = __PRIVATE_decodeResourcePath(o);
                    s === _this.userId && n.isPrefixOf(u) ? // Rows with document keys more than one segment longer than the
                    // query path can't be matches. For example, a query on 'rooms'
                    // can't match the document /rooms/abc/messages/xyx.
                    // TODO(mcg): we'll need a different scanner when we implement
                    // ancestor queries.
                    u.length === r && (_ = _.add(a)) : i.done();
                }).next(function() {
                    return _this.jr(e, _);
                });
            }
        },
        {
            key: "jr",
            value: function jr(e, t) {
                var _this = this;
                var n = [], r = [];
                // TODO(rockwood): Implement this using iterate.
                return t.forEach(function(t) {
                    r.push(__PRIVATE_mutationsStore(e).get(t).next(function(e) {
                        if (null === e) throw l(35274, {
                            batchId: t
                        });
                        __PRIVATE_hardAssert(e.userId === _this.userId, 9748, "Unexpected user for mutation batch", {
                            userId: e.userId,
                            batchId: t
                        }), n.push(__PRIVATE_fromDbMutationBatch(_this.serializer, e));
                    }));
                }), PersistencePromise.waitFor(r).next(function() {
                    return n;
                });
            }
        },
        {
            key: "removeMutationBatch",
            value: function removeMutationBatch1(e, t) {
                var _this = this;
                return removeMutationBatch(e.qr, this.userId, t).next(function(n) {
                    return e.addOnCommittedListener(function() {
                        _this.Hr(t.batchId);
                    }), PersistencePromise.forEach(n, function(t) {
                        return _this.referenceDelegate.markPotentiallyOrphaned(e, t);
                    });
                });
            }
        },
        {
            /**
     * Clears the cached keys for a mutation batch. This method should be
     * called by secondary clients after they process mutation updates.
     *
     * Note that this method does not have to be called from primary clients as
     * the corresponding cache entries are cleared when an acknowledged or
     * rejected batch is removed from the mutation queue.
     */ // PORTING NOTE: Multi-tab only
            key: "Hr",
            value: function Hr(e) {
                delete this.Kr[e];
            }
        },
        {
            key: "performConsistencyCheck",
            value: function performConsistencyCheck(e) {
                var _this = this;
                return this.checkEmpty(e).next(function(t) {
                    if (!t) return PersistencePromise.resolve();
                    // Verify that there are no entries in the documentMutations index if
                    // the queue is empty.
                    var n = IDBKeyRange.lowerBound(/**
 * Creates a [userId] key for use in the DbDocumentMutations index to iterate
 * over all of a user's document mutations.
 */ function __PRIVATE_newDbDocumentMutationPrefixForUser(e) {
                        return [
                            e
                        ];
                    }(_this.userId)), r = [];
                    return __PRIVATE_documentMutationsStore(e).Hn({
                        range: n
                    }, function(e, t, n) {
                        if (e[0] === _this.userId) {
                            var _$t = __PRIVATE_decodeResourcePath(e[1]);
                            r.push(_$t);
                        } else n.done();
                    }).next(function() {
                        __PRIVATE_hardAssert(0 === r.length, 56720, {
                            Jr: r.map(function(e) {
                                return e.canonicalString();
                            })
                        });
                    });
                });
            }
        },
        {
            key: "containsKey",
            value: function containsKey(e, t) {
                return __PRIVATE_mutationQueueContainsKey(e, this.userId, t);
            }
        },
        {
            // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
            /** Returns the mutation queue's metadata from IndexedDb. */ key: "Yr",
            value: function Yr(e) {
                var _this = this;
                return __PRIVATE_mutationQueuesStore(e).get(this.userId).next(function(e) {
                    return e || {
                        userId: _this.userId,
                        lastAcknowledgedBatchId: Ke,
                        lastStreamToken: ""
                    };
                });
            }
        }
    ], [
        {
            key: "Qr",
            value: /**
     * Creates a new mutation queue for the given user.
     * @param user - The user for which to create a mutation queue.
     * @param serializer - The serializer to use when persisting to IndexedDb.
     */ function Qr(e, t, n, r) {
                // TODO(mcg): Figure out what constraints there are on userIDs
                // In particular, are there any reserved characters? are empty ids allowed?
                // For the moment store these together in the same mutations table assuming
                // that empty userIDs aren't allowed.
                __PRIVATE_hardAssert("" !== e.uid, 64387);
                var i = e.isAuthenticated() ? e.uid : "";
                return new __PRIVATE_IndexedDbMutationQueue(i, t, n, r);
            }
        }
    ]);
    return __PRIVATE_IndexedDbMutationQueue;
}();
/**
 * @returns true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */ function __PRIVATE_mutationQueueContainsKey(e, t, n) {
    var r = __PRIVATE_newDbDocumentMutationPrefixForPath(t, n.path), i = r[1], s = IDBKeyRange.lowerBound(r);
    var _ = false;
    return __PRIVATE_documentMutationsStore(e).Hn({
        range: s,
        jn: true
    }, function(e, n, r) {
        var _e = (0, $6ZpBv._)(e, 3), s = _e[0], o = _e[1], /*batchID*/ a = _e[2];
        s === t && o === i && (_ = true), r.done();
    }).next(function() {
        return _;
    });
}
/** Returns true if any mutation queue contains the given document. */ /**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */ function __PRIVATE_mutationsStore(e) {
    return __PRIVATE_getStore(e, Ht);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function __PRIVATE_documentMutationsStore(e) {
    return __PRIVATE_getStore(e, en);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function __PRIVATE_mutationQueuesStore(e) {
    return __PRIVATE_getStore(e, zt);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var __PRIVATE_IndexedDbBundleCache = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexedDbBundleCache() {
        (0, $4QweW._)(this, __PRIVATE_IndexedDbBundleCache);
    }
    (0, $6hK4i._)(__PRIVATE_IndexedDbBundleCache, [
        {
            key: "getBundleMetadata",
            value: function getBundleMetadata(e, t) {
                return __PRIVATE_bundlesStore(e).get(t).next(function(e) {
                    if (e) return function __PRIVATE_fromDbBundle(e) {
                        return {
                            id: e.bundleId,
                            createTime: __PRIVATE_fromDbTimestamp(e.createTime),
                            version: e.version
                        };
                    }(e);
                });
            }
        },
        {
            key: "saveBundleMetadata",
            value: function saveBundleMetadata(e, t) {
                return __PRIVATE_bundlesStore(e).put(function __PRIVATE_toDbBundle(e) {
                    return {
                        bundleId: e.id,
                        createTime: __PRIVATE_toDbTimestamp(__PRIVATE_fromVersion(e.createTime)),
                        version: e.version
                    };
                }(t));
            }
        },
        {
            key: "getNamedQuery",
            value: function getNamedQuery(e, t) {
                return __PRIVATE_namedQueriesStore(e).get(t).next(function(e) {
                    if (e) return function __PRIVATE_fromDbNamedQuery(e) {
                        return {
                            name: e.name,
                            query: __PRIVATE_fromBundledQuery(e.bundledQuery),
                            readTime: __PRIVATE_fromDbTimestamp(e.readTime)
                        };
                    }(e);
                });
            }
        },
        {
            key: "saveNamedQuery",
            value: function saveNamedQuery(e, t) {
                return __PRIVATE_namedQueriesStore(e).put(function __PRIVATE_toDbNamedQuery(e) {
                    return {
                        name: e.name,
                        readTime: __PRIVATE_toDbTimestamp(__PRIVATE_fromVersion(e.readTime)),
                        bundledQuery: e.bundledQuery
                    };
                }(t));
            }
        }
    ]);
    return __PRIVATE_IndexedDbBundleCache;
}();
/**
 * Helper to get a typed SimpleDbStore for the bundles object store.
 */ function __PRIVATE_bundlesStore(e) {
    return __PRIVATE_getStore(e, gn);
}
/**
 * Helper to get a typed SimpleDbStore for the namedQueries object store.
 */ function __PRIVATE_namedQueriesStore(e) {
    return __PRIVATE_getStore(e, wn);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implementation of DocumentOverlayCache using IndexedDb.
 */ var __PRIVATE_IndexedDbDocumentOverlayCache = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexedDbDocumentOverlayCache(e, t) {
        (0, $4QweW._)(this, __PRIVATE_IndexedDbDocumentOverlayCache);
        this.serializer = e, this.userId = t;
    }
    (0, $6hK4i._)(__PRIVATE_IndexedDbDocumentOverlayCache, [
        {
            key: "getOverlay",
            value: function getOverlay(e, t) {
                var _this = this;
                return __PRIVATE_documentOverlayStore(e).get(__PRIVATE_toDbDocumentOverlayKey(this.userId, t)).next(function(e) {
                    return e ? __PRIVATE_fromDbDocumentOverlay(_this.serializer, e) : null;
                });
            }
        },
        {
            key: "getOverlays",
            value: function getOverlays(e, t) {
                var _this = this;
                var n = __PRIVATE_newOverlayMap();
                return PersistencePromise.forEach(t, function(t) {
                    return _this.getOverlay(e, t).next(function(e) {
                        null !== e && n.set(t, e);
                    });
                }).next(function() {
                    return n;
                });
            }
        },
        {
            key: "getAllOverlays",
            value: function getAllOverlays(e, t) {
                var _this = this;
                var n = __PRIVATE_newOverlayMap();
                // TODO(pipeline): should we create an index for this? But how often people really expect
                // querying entire database to be fast?
                return __PRIVATE_documentOverlayStore(e).Hn(function(e, r) {
                    var i = __PRIVATE_fromDbDocumentOverlay(_this.serializer, r);
                    i.largestBatchId > t && n.set(i.getKey(), i);
                }).next(function() {
                    return n;
                });
            }
        },
        {
            key: "saveOverlays",
            value: function saveOverlays(e, t, n) {
                var _this = this;
                var r = [];
                return n.forEach(function(n, i) {
                    var s = new Overlay(t, i);
                    r.push(_this.Zr(e, s));
                }), PersistencePromise.waitFor(r);
            }
        },
        {
            key: "removeOverlaysForBatchId",
            value: function removeOverlaysForBatchId(e, t, n) {
                var _this = this;
                var r = new Set;
                // Get the set of unique collection paths.
                t.forEach(function(e) {
                    return r.add(__PRIVATE_encodeResourcePath(e.getCollectionPath()));
                });
                var i = [];
                return r.forEach(function(t) {
                    var r = IDBKeyRange.bound([
                        _this.userId,
                        t,
                        n
                    ], [
                        _this.userId,
                        t,
                        n + 1
                    ], /*lowerOpen=*/ false, /*upperOpen=*/ true);
                    i.push(__PRIVATE_documentOverlayStore(e).zn($n, r));
                }), PersistencePromise.waitFor(i);
            }
        },
        {
            key: "getOverlaysForCollection",
            value: function getOverlaysForCollection(e, t, n) {
                var _this = this;
                var r = __PRIVATE_newOverlayMap(), i = __PRIVATE_encodeResourcePath(t), s = IDBKeyRange.bound([
                    this.userId,
                    i,
                    n
                ], [
                    this.userId,
                    i,
                    Number.POSITIVE_INFINITY
                ], /*lowerOpen=*/ true);
                return __PRIVATE_documentOverlayStore(e).Qn($n, s).next(function(e) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$t = _step.value;
                            var _$e = __PRIVATE_fromDbDocumentOverlay(_this.serializer, _$t);
                            r.set(_$e.getKey(), _$e);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return r;
                });
            }
        },
        {
            key: "getOverlaysForCollectionGroup",
            value: function getOverlaysForCollectionGroup(e, t, n, r) {
                var _this = this;
                var i = __PRIVATE_newOverlayMap();
                var s;
                // We want batch IDs larger than `sinceBatchId`, and so the lower bound
                // is not inclusive.
                var _ = IDBKeyRange.bound([
                    this.userId,
                    t,
                    n
                ], [
                    this.userId,
                    t,
                    Number.POSITIVE_INFINITY
                ], /*lowerOpen=*/ true);
                return __PRIVATE_documentOverlayStore(e).Hn({
                    index: Qn,
                    range: _
                }, function(e, t, n) {
                    // We do not want to return partial batch overlays, even if the size
                    // of the result set exceeds the given `count` argument. Therefore, we
                    // continue to aggregate results even after the result size exceeds
                    // `count` if there are more overlays from the `currentBatchId`.
                    var _ = __PRIVATE_fromDbDocumentOverlay(_this.serializer, t);
                    i.size() < r || _.largestBatchId === s ? (i.set(_.getKey(), _), s = _.largestBatchId) : n.done();
                }).next(function() {
                    return i;
                });
            }
        },
        {
            key: "Zr",
            value: function Zr(e, t) {
                return __PRIVATE_documentOverlayStore(e).put(function __PRIVATE_toDbDocumentOverlay(e, t, n) {
                    var _$__PRIVATE_toDbDocumentOverlayKey = (0, $6ZpBv._)(__PRIVATE_toDbDocumentOverlayKey(t, n.mutation.key), 3), r = _$__PRIVATE_toDbDocumentOverlayKey[0], i = _$__PRIVATE_toDbDocumentOverlayKey[1], s = _$__PRIVATE_toDbDocumentOverlayKey[2];
                    return {
                        userId: t,
                        collectionPath: i,
                        documentId: s,
                        collectionGroup: n.mutation.key.getCollectionGroup(),
                        largestBatchId: n.largestBatchId,
                        overlayMutation: toMutation(e.$r, n.mutation)
                    };
                }(this.serializer, this.userId, t));
            }
        }
    ], [
        {
            key: "Qr",
            value: function Qr(e, t) {
                var n = t.uid || "";
                return new __PRIVATE_IndexedDbDocumentOverlayCache(e, n);
            }
        }
    ]);
    return __PRIVATE_IndexedDbDocumentOverlayCache;
}();
/**
 * Helper to get a typed SimpleDbStore for the document overlay object store.
 */ function __PRIVATE_documentOverlayStore(e) {
    return __PRIVATE_getStore(e, kn);
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var __PRIVATE_IndexedDbGlobalsCache = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexedDbGlobalsCache() {
        (0, $4QweW._)(this, __PRIVATE_IndexedDbGlobalsCache);
    }
    (0, $6hK4i._)(__PRIVATE_IndexedDbGlobalsCache, [
        {
            key: "Xr",
            value: function Xr(e) {
                return __PRIVATE_getStore(e, Gn);
            }
        },
        {
            key: "getSessionToken",
            value: function getSessionToken(e) {
                return this.Xr(e).get("sessionToken").next(function(e) {
                    var t = e === null || e === void 0 ? void 0 : e.value;
                    return t ? ByteString.fromUint8Array(t) : ByteString.EMPTY_BYTE_STRING;
                });
            }
        },
        {
            key: "setSessionToken",
            value: function setSessionToken(e, t) {
                return this.Xr(e).put({
                    name: "sessionToken",
                    value: t.toUint8Array()
                });
            }
        }
    ]);
    return __PRIVATE_IndexedDbGlobalsCache;
}();
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Note: This code is copied from the backend. Code that is not used by
// Firestore was removed.
/** Firestore index value writer.  */ var __PRIVATE_FirestoreIndexValueWriter = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_FirestoreIndexValueWriter() {
        (0, $4QweW._)(this, __PRIVATE_FirestoreIndexValueWriter);
    }
    (0, $6hK4i._)(__PRIVATE_FirestoreIndexValueWriter, [
        {
            // The write methods below short-circuit writing terminators for values
            // containing a (terminating) truncated value.
            // As an example, consider the resulting encoding for:
            // ["bar", [2, "foo"]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TERM, TERM, TERM)
            // ["bar", [2, truncated("foo")]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TRUNC)
            // ["bar", truncated(["foo"])] -> (STRING, "bar", TERM, ARRAY. STRING, "foo", TERM, TRUNC)
            /** Writes an index value.  */ key: "ei",
            value: function ei(e, t) {
                this.ti(e, t), // Write separator to split index values
                // (see go/firestore-storage-format#encodings).
                t.ni();
            }
        },
        {
            key: "ti",
            value: function ti(e, t) {
                if ("nullValue" in e) this.ri(t, 5);
                else if ("booleanValue" in e) this.ri(t, 10), t.ii(e.booleanValue ? 1 : 0);
                else if ("integerValue" in e) this.ri(t, 15), t.ii(__PRIVATE_normalizeNumber(e.integerValue));
                else if ("doubleValue" in e) {
                    var n = __PRIVATE_normalizeNumber(e.doubleValue);
                    isNaN(n) ? this.ri(t, 13) : (this.ri(t, 15), __PRIVATE_isNegativeZero(n) ? // -0.0, 0 and 0.0 are all considered the same
                    t.ii(0) : t.ii(n));
                } else if ("timestampValue" in e) {
                    var n1 = e.timestampValue;
                    this.ri(t, 20), "string" == typeof n1 && (n1 = __PRIVATE_normalizeTimestamp(n1)), t.si("".concat(n1.seconds || "")), t.ii(n1.nanos || 0);
                } else if ("stringValue" in e) this._i(e.stringValue, t), this.oi(t);
                else if ("bytesValue" in e) this.ri(t, 30), t.ai(__PRIVATE_normalizeByteString(e.bytesValue)), this.oi(t);
                else if ("referenceValue" in e) this.ui(e.referenceValue, t);
                else if ("geoPointValue" in e) {
                    var n2 = e.geoPointValue;
                    this.ri(t, 45), t.ii(n2.latitude || 0), t.ii(n2.longitude || 0);
                } else "mapValue" in e ? __PRIVATE_isMaxValue(e) ? this.ri(t, Number.MAX_SAFE_INTEGER) : __PRIVATE_isVectorValue(e) ? this.ci(e.mapValue, t) : (this.li(e.mapValue, t), this.oi(t)) : "arrayValue" in e ? (this.Ei(e.arrayValue, t), this.oi(t)) : l(19022, {
                    hi: e
                });
            }
        },
        {
            key: "_i",
            value: function _i(e, t) {
                this.ri(t, 25), this.Ti(e, t);
            }
        },
        {
            key: "Ti",
            value: function Ti(e, t) {
                t.si(e);
            }
        },
        {
            key: "li",
            value: function li(e, t) {
                var n = e.fields || {};
                this.ri(t, 55);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(n)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$e = _step.value;
                        this._i(_$e, t), this.ti(n[_$e], t);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "ci",
            value: function ci(e, t) {
                var _n_r_arrayValue_values, _n_r_arrayValue;
                var n = e.fields || {};
                this.ri(t, 53);
                // Vectors sort first by length
                var r = je, i = ((_n_r_arrayValue = n[r].arrayValue) === null || _n_r_arrayValue === void 0 ? void 0 : (_n_r_arrayValue_values = _n_r_arrayValue.values) === null || _n_r_arrayValue_values === void 0 ? void 0 : _n_r_arrayValue_values.length) || 0;
                this.ri(t, 15), t.ii(__PRIVATE_normalizeNumber(i)), // Vectors then sort by position value
                this._i(r, t), this.ti(n[r], t);
            }
        },
        {
            key: "Ei",
            value: function Ei(e, t) {
                var n = e.values || [];
                this.ri(t, 50);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$e = _step.value;
                        this.ti(_$e, t);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "ui",
            value: function ui(e, t) {
                var _this = this;
                this.ri(t, 37);
                DocumentKey.fromName(e).path.forEach(function(e) {
                    _this.ri(t, 60), _this.Ti(e, t);
                });
            }
        },
        {
            key: "ri",
            value: function ri(e, t) {
                e.ii(t);
            }
        },
        {
            key: "oi",
            value: function oi(e) {
                // While the SDK does not implement truncation, the truncation marker is
                // used to terminate all variable length values (which are strings, bytes,
                // references, arrays and maps).
                e.ii(2);
            }
        }
    ]);
    return __PRIVATE_FirestoreIndexValueWriter;
}();
__PRIVATE_FirestoreIndexValueWriter.Pi = new __PRIVATE_FirestoreIndexValueWriter;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law | agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES | CONDITIONS OF ANY KIND, either express | implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** These constants are taken from the backend. */ var nr = 255;
/**
 * Counts the number of zeros in a byte.
 *
 * Visible for testing.
 */ function __PRIVATE_numberOfLeadingZerosInByte(e) {
    if (0 === e) return 8;
    var t = 0;
    return e >> 4 || // Test if the first four bits are zero.
    (t += 4, e <<= 4), e >> 6 || // Test if the first two (or next two) bits are zero.
    (t += 2, e <<= 2), e >> 7 || // Test if the remaining bit is zero.
    (t += 1), t;
}
/** Counts the number of leading zeros in the given byte array. */ /**
 * Returns the number of bytes required to store "value". Leading zero bytes
 * are skipped.
 */ function __PRIVATE_unsignedNumLength(e) {
    // This is just the number of bytes for the unsigned representation of the number.
    var t = 64 - function __PRIVATE_numberOfLeadingZeros(e) {
        var t = 0;
        for(var n = 0; n < 8; ++n){
            var r = __PRIVATE_numberOfLeadingZerosInByte(255 & e[n]);
            if (t += r, 8 !== r) break;
        }
        return t;
    }(e);
    return Math.ceil(t / 8);
}
/**
 * OrderedCodeWriter is a minimal-allocation implementation of the writing
 * behavior defined by the backend.
 *
 * The code is ported from its Java counterpart.
 */ var __PRIVATE_OrderedCodeWriter = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_OrderedCodeWriter() {
        (0, $4QweW._)(this, __PRIVATE_OrderedCodeWriter);
        this.buffer = new Uint8Array(1024), this.position = 0;
    }
    (0, $6hK4i._)(__PRIVATE_OrderedCodeWriter, [
        {
            key: "Ii",
            value: function Ii(e) {
                var t = e[Symbol.iterator]();
                var n = t.next();
                for(; !n.done;)this.Ri(n.value), n = t.next();
                this.Ai();
            }
        },
        {
            key: "Vi",
            value: function Vi(e) {
                var t = e[Symbol.iterator]();
                var n = t.next();
                for(; !n.done;)this.di(n.value), n = t.next();
                this.fi();
            }
        },
        {
            /** Writes utf8 bytes into this byte sequence, ascending. */ key: "mi",
            value: function mi(e) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var t = _step.value;
                        var _$e = t.charCodeAt(0);
                        if (_$e < 128) this.Ri(_$e);
                        else if (_$e < 2048) this.Ri(960 | _$e >>> 6), this.Ri(128 | 63 & _$e);
                        else if (t < "\ud800" || "\udbff" < t) this.Ri(480 | _$e >>> 12), this.Ri(128 | 63 & _$e >>> 6), this.Ri(128 | 63 & _$e);
                        else {
                            var _$e1 = t.codePointAt(0);
                            this.Ri(240 | _$e1 >>> 18), this.Ri(128 | 63 & _$e1 >>> 12), this.Ri(128 | 63 & _$e1 >>> 6), this.Ri(128 | 63 & _$e1);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.Ai();
            }
        },
        {
            /** Writes utf8 bytes into this byte sequence, descending */ key: "pi",
            value: function pi(e) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var t = _step.value;
                        var _$e = t.charCodeAt(0);
                        if (_$e < 128) this.di(_$e);
                        else if (_$e < 2048) this.di(960 | _$e >>> 6), this.di(128 | 63 & _$e);
                        else if (t < "\ud800" || "\udbff" < t) this.di(480 | _$e >>> 12), this.di(128 | 63 & _$e >>> 6), this.di(128 | 63 & _$e);
                        else {
                            var _$e1 = t.codePointAt(0);
                            this.di(240 | _$e1 >>> 18), this.di(128 | 63 & _$e1 >>> 12), this.di(128 | 63 & _$e1 >>> 6), this.di(128 | 63 & _$e1);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.fi();
            }
        },
        {
            key: "gi",
            value: function gi(e) {
                // Values are encoded with a single byte length prefix, followed by the
                // actual value in big-endian format with leading 0 bytes dropped.
                var t = this.yi(e), n = __PRIVATE_unsignedNumLength(t);
                this.wi(1 + n), this.buffer[this.position++] = 255 & n;
                // Write the length
                for(var _$e = t.length - n; _$e < t.length; ++_$e)this.buffer[this.position++] = 255 & t[_$e];
            }
        },
        {
            key: "bi",
            value: function bi(e) {
                // Values are encoded with a single byte length prefix, followed by the
                // inverted value in big-endian format with leading 0 bytes dropped.
                var t = this.yi(e), n = __PRIVATE_unsignedNumLength(t);
                this.wi(1 + n), this.buffer[this.position++] = ~(255 & n);
                // Write the length
                for(var _$e = t.length - n; _$e < t.length; ++_$e)this.buffer[this.position++] = ~(255 & t[_$e]);
            }
        },
        {
            /**
     * Writes the "infinity" byte sequence that sorts after all other byte
     * sequences written in ascending order.
     */ key: "Si",
            value: function Si() {
                this.Di(nr), this.Di(255);
            }
        },
        {
            /**
     * Writes the "infinity" byte sequence that sorts before all other byte
     * sequences written in descending order.
     */ key: "xi",
            value: function xi() {
                this.Ci(nr), this.Ci(255);
            }
        },
        {
            /**
     * Resets the buffer such that it is the same as when it was newly
     * constructed.
     */ key: "reset",
            value: function reset() {
                this.position = 0;
            }
        },
        {
            key: "seed",
            value: function seed(e) {
                this.wi(e.length), this.buffer.set(e, this.position), this.position += e.length;
            }
        },
        {
            /** Makes a copy of the encoded bytes in this buffer.  */ key: "Fi",
            value: function Fi() {
                return this.buffer.slice(0, this.position);
            }
        },
        {
            /**
     * Encodes `val` into an encoding so that the order matches the IEEE 754
     * floating-point comparison results with the following exceptions:
     *   -0.0 < 0.0
     *   all non-NaN < NaN
     *   NaN = NaN
     */ key: "yi",
            value: function yi(e) {
                var t = /** Converts a JavaScript number to a byte array (using big endian encoding). */ function __PRIVATE_doubleToLongBits(e) {
                    var t = new DataView(new ArrayBuffer(8));
                    return t.setFloat64(0, e, /* littleEndian= */ false), new Uint8Array(t.buffer);
                }(e), n = !!(128 & t[0]);
                // Check if the first bit is set. We use a bit mask since value[0] is
                // encoded as a number from 0 to 255.
                // Revert the two complement to get natural ordering
                t[0] ^= n ? 255 : 128;
                for(var _$e = 1; _$e < t.length; ++_$e)t[_$e] ^= n ? 255 : 0;
                return t;
            }
        },
        {
            /** Writes a single byte ascending to the buffer. */ key: "Ri",
            value: function Ri(e) {
                var t = 255 & e;
                0 === t ? (this.Di(0), this.Di(255)) : t === nr ? (this.Di(nr), this.Di(0)) : this.Di(t);
            }
        },
        {
            /** Writes a single byte descending to the buffer.  */ key: "di",
            value: function di(e) {
                var t = 255 & e;
                0 === t ? (this.Ci(0), this.Ci(255)) : t === nr ? (this.Ci(nr), this.Ci(0)) : this.Ci(e);
            }
        },
        {
            key: "Ai",
            value: function Ai() {
                this.Di(0), this.Di(1);
            }
        },
        {
            key: "fi",
            value: function fi() {
                this.Ci(0), this.Ci(1);
            }
        },
        {
            key: "Di",
            value: function Di(e) {
                this.wi(1), this.buffer[this.position++] = e;
            }
        },
        {
            key: "Ci",
            value: function Ci(e) {
                this.wi(1), this.buffer[this.position++] = ~e;
            }
        },
        {
            key: "wi",
            value: function wi(e) {
                var t = e + this.position;
                if (t <= this.buffer.length) return;
                // Try doubling.
                var n = 2 * this.buffer.length;
                // Still not big enough? Just allocate the right size.
                n < t && (n = t);
                // Create the new buffer.
                var r = new Uint8Array(n);
                r.set(this.buffer), this.buffer = r;
            }
        }
    ]);
    return __PRIVATE_OrderedCodeWriter;
}();
var __PRIVATE_AscendingIndexByteEncoder = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_AscendingIndexByteEncoder(e) {
        (0, $4QweW._)(this, __PRIVATE_AscendingIndexByteEncoder);
        this.Oi = e;
    }
    (0, $6hK4i._)(__PRIVATE_AscendingIndexByteEncoder, [
        {
            key: "ai",
            value: function ai(e) {
                this.Oi.Ii(e);
            }
        },
        {
            key: "si",
            value: function si(e) {
                this.Oi.mi(e);
            }
        },
        {
            key: "ii",
            value: function ii(e) {
                this.Oi.gi(e);
            }
        },
        {
            key: "ni",
            value: function ni() {
                this.Oi.Si();
            }
        }
    ]);
    return __PRIVATE_AscendingIndexByteEncoder;
}();
var __PRIVATE_DescendingIndexByteEncoder = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_DescendingIndexByteEncoder(e) {
        (0, $4QweW._)(this, __PRIVATE_DescendingIndexByteEncoder);
        this.Oi = e;
    }
    (0, $6hK4i._)(__PRIVATE_DescendingIndexByteEncoder, [
        {
            key: "ai",
            value: function ai(e) {
                this.Oi.Vi(e);
            }
        },
        {
            key: "si",
            value: function si(e) {
                this.Oi.pi(e);
            }
        },
        {
            key: "ii",
            value: function ii(e) {
                this.Oi.bi(e);
            }
        },
        {
            key: "ni",
            value: function ni() {
                this.Oi.xi();
            }
        }
    ]);
    return __PRIVATE_DescendingIndexByteEncoder;
}();
/**
 * Implements `DirectionalIndexByteEncoder` using `OrderedCodeWriter` for the
 * actual encoding.
 */ var __PRIVATE_IndexByteEncoder = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexByteEncoder() {
        (0, $4QweW._)(this, __PRIVATE_IndexByteEncoder);
        this.Oi = new __PRIVATE_OrderedCodeWriter, this.ascending = new __PRIVATE_AscendingIndexByteEncoder(this.Oi), this.descending = new __PRIVATE_DescendingIndexByteEncoder(this.Oi);
    }
    (0, $6hK4i._)(__PRIVATE_IndexByteEncoder, [
        {
            key: "seed",
            value: function seed(e) {
                this.Oi.seed(e);
            }
        },
        {
            key: "Mi",
            value: function Mi(e) {
                return 0 /* IndexKind.ASCENDING */  === e ? this.ascending : this.descending;
            }
        },
        {
            key: "Fi",
            value: function Fi() {
                return this.Oi.Fi();
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.Oi.reset();
            }
        }
    ]);
    return __PRIVATE_IndexByteEncoder;
}();
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Represents an index entry saved by the SDK in persisted storage. */ var __PRIVATE_IndexEntry = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexEntry(e, t, n, r) {
        (0, $4QweW._)(this, __PRIVATE_IndexEntry);
        this.Ni = e, this.Li = t, this.Bi = n, this.Ui = r;
    }
    (0, $6hK4i._)(__PRIVATE_IndexEntry, [
        {
            /**
     * Returns an IndexEntry entry that sorts immediately after the current
     * directional value.
     */ key: "ki",
            value: function ki() {
                var e = this.Ui.length, t = 0 === e || 255 === this.Ui[e - 1] ? e + 1 : e, n = new Uint8Array(t);
                return n.set(this.Ui, 0), t !== e ? n.set([
                    0
                ], this.Ui.length) : ++n[n.length - 1], new __PRIVATE_IndexEntry(this.Ni, this.Li, this.Bi, n);
            }
        },
        {
            // Create a representation of the Index Entry as a DbIndexEntry
            key: "qi",
            value: function qi(e, t, n) {
                return {
                    indexId: this.Ni,
                    uid: e,
                    arrayValue: __PRIVATE_encodeKeySafeBytes(this.Bi),
                    directionalValue: __PRIVATE_encodeKeySafeBytes(this.Ui),
                    orderedDocumentKey: __PRIVATE_encodeKeySafeBytes(t),
                    documentKey: n.path.toArray()
                };
            }
        },
        {
            // Create a representation of the Index Entry as a DbIndexEntryKey
            key: "$i",
            value: function $i(e, t, n) {
                var r = this.qi(e, t, n);
                return [
                    r.indexId,
                    r.uid,
                    r.arrayValue,
                    r.directionalValue,
                    r.orderedDocumentKey,
                    r.documentKey
                ];
            }
        }
    ]);
    return __PRIVATE_IndexEntry;
}();
function __PRIVATE_indexEntryComparator(e, t) {
    var n = e.Ni - t.Ni;
    return 0 !== n ? n : (n = __PRIVATE_compareByteArrays(e.Bi, t.Bi), 0 !== n ? n : (n = __PRIVATE_compareByteArrays(e.Ui, t.Ui), 0 !== n ? n : DocumentKey.comparator(e.Li, t.Li)));
}
function __PRIVATE_compareByteArrays(e, t) {
    for(var n = 0; n < e.length && n < t.length; ++n){
        var r = e[n] - t[n];
        if (0 !== r) return r;
    }
    return e.length - t.length;
}
/**
 * Workaround for WebKit bug: https://bugs.webkit.org/show_bug.cgi?id=292721
 * Create a key safe representation of Uint8Array values.
 * If the browser is detected as Safari or WebKit, then
 * the input array will be converted to "sortable byte string".
 * Otherwise, the input array will be returned in its original type.
 */ function __PRIVATE_encodeKeySafeBytes(e) {
    return (0, $hk14n.isSafariOrWebkit)() ? /**
 * Encodes a Uint8Array into a "sortable byte string".
 * A "sortable byte string" sorts in the same order as the Uint8Array.
 * This works because JS string comparison sorts strings based on code points.
 */ function __PRIVATE_encodeUint8ArrayToSortableString(e) {
        var t = "";
        for(var n = 0; n < e.length; n++)t += String.fromCharCode(e[n]);
        return t;
    }(e) : e;
}
/**
 * Reverts the key safe representation of Uint8Array (created by
 * encodeKeySafeBytes) to a normal Uint8Array.
 */ function __PRIVATE_decodeKeySafeBytes(e) {
    return "string" != typeof e ? e : function __PRIVATE_decodeSortableStringToUint8Array(e) {
        var t = new Uint8Array(e.length);
        for(var n = 0; n < e.length; n++)t[n] = e.charCodeAt(n);
        return t;
    }(e);
}
var __PRIVATE_TargetIndexMatcher = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_TargetIndexMatcher(e) {
        (0, $4QweW._)(this, __PRIVATE_TargetIndexMatcher);
        // The inequality filters of the target (if it exists).
        // Note: The sort on FieldFilters is not required. Using SortedSet here just to utilize the custom
        // comparator.
        this.Ki = new SortedSet(function(e, t) {
            return Oe.comparator(e.field, t.field);
        }), this.collectionId = null != e.collectionGroup ? e.collectionGroup : e.path.lastSegment(), this.Qi = e.orderBy, this.Wi = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = e.filters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var t = _step.value;
                var _$e = t;
                _$e.isInequality() ? this.Ki = this.Ki.add(_$e) : this.Wi.push(_$e);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    (0, $6hK4i._)(__PRIVATE_TargetIndexMatcher, [
        {
            key: "Gi",
            get: function get() {
                return this.Ki.size > 1;
            }
        },
        {
            /**
     * Returns whether the index can be used to serve the TargetIndexMatcher's
     * target.
     *
     * An index is considered capable of serving the target when:
     * - The target uses all index segments for its filters and orderBy clauses.
     *   The target can have additional filter and orderBy clauses, but not
     *   fewer.
     * - If an ArrayContains/ArrayContainsAnyfilter is used, the index must also
     *   have a corresponding `CONTAINS` segment.
     * - All directional index segments can be mapped to the target as a series of
     *   equality filters, a single inequality filter and a series of orderBy
     *   clauses.
     * - The segments that represent the equality filters may appear out of order.
     * - The optional segment for the inequality filter must appear after all
     *   equality segments.
     * - The segments that represent that orderBy clause of the target must appear
     *   in order after all equality and inequality segments. Single orderBy
     *   clauses cannot be skipped, but a continuous orderBy suffix may be
     *   omitted.
     */ key: "zi",
            value: function zi(e) {
                if (__PRIVATE_hardAssert(e.collectionGroup === this.collectionId, 49279), this.Gi) // Only single inequality is supported for now.
                // TODO(Add support for multiple inequality query): b/298441043
                return false;
                // If there is an array element, find a matching filter.
                var t = __PRIVATE_fieldIndexGetArraySegment(e);
                if (void 0 !== t && !this.ji(t)) return false;
                var n = __PRIVATE_fieldIndexGetDirectionalSegments(e);
                var r = new Set, i = 0, s = 0;
                // Process all equalities first. Equalities can appear out of order.
                for(; i < n.length && this.ji(n[i]); ++i)r = r.add(n[i].fieldPath.canonicalString());
                // If we already have processed all segments, all segments are used to serve
                // the equality filters and we do not need to map any segments to the
                // target's inequality and orderBy clauses.
                if (i === n.length) return true;
                if (this.Ki.size > 0) {
                    // Only a single inequality is currently supported. Get the only entry in the set.
                    var _$e = this.Ki.getIterator().getNext();
                    // If there is an inequality filter and the field was not in one of the
                    // equality filters above, the next segment must match both the filter
                    // and the first orderBy clause.
                    if (!r.has(_$e.field.canonicalString())) {
                        var t1 = n[i];
                        if (!this.Hi(_$e, t1) || !this.Ji(this.Qi[s++], t1)) return false;
                    }
                    ++i;
                }
                // All remaining segments need to represent the prefix of the target's
                // orderBy.
                for(; i < n.length; ++i){
                    var _$e1 = n[i];
                    if (s >= this.Qi.length || !this.Ji(this.Qi[s++], _$e1)) return false;
                }
                return true;
            }
        },
        {
            /**
     * Returns a full matched field index for this target. Currently multiple
     * inequality query is not supported so function returns null.
     */ key: "Yi",
            value: function Yi() {
                if (this.Gi) return null;
                // We want to make sure only one segment created for one field. For example,
                // in case like a == 3 and a > 2, Index {a ASCENDING} will only be created
                // once.
                var e = new SortedSet(Oe.comparator);
                var t = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.Wi[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var n = _step.value;
                        if (n.field.isKeyField()) continue;
                        if ("array-contains" /* Operator.ARRAY_CONTAINS */  === n.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === n.op) t.push(new IndexSegment(n.field, 2 /* IndexKind.CONTAINS */ ));
                        else {
                            if (e.has(n.field)) continue;
                            e = e.add(n.field), t.push(new IndexSegment(n.field, 0 /* IndexKind.ASCENDING */ ));
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    // Note: We do not explicitly check `this.inequalityFilter` but rather rely
                    // on the target defining an appropriate "order by" to ensure that the
                    // required index segment is added. The query engine would reject a query
                    // with an inequality filter that lacks the required order-by clause.
                    for(var _iterator1 = this.Qi[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var n1 = _step1.value;
                        // Stop adding more segments if we see a order-by on key. Typically this
                        // is the default implicit order-by which is covered in the index_entry
                        // table as a separate column. If it is not the default order-by, the
                        // generated index will be missing some segments optimized for order-bys,
                        // which is probably fine.
                        n1.field.isKeyField() || e.has(n1.field) || (e = e.add(n1.field), t.push(new IndexSegment(n1.field, "asc" /* Direction.ASCENDING */  === n1.dir ? 0 /* IndexKind.ASCENDING */  : 1 /* IndexKind.DESCENDING */ )));
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return new FieldIndex(FieldIndex.UNKNOWN_ID, this.collectionId, t, IndexState.empty());
            }
        },
        {
            key: "ji",
            value: function ji(e) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.Wi[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var t = _step.value;
                        if (this.Hi(t, e)) return true;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return false;
            }
        },
        {
            key: "Hi",
            value: function Hi(e, t) {
                if (void 0 === e || !e.field.isEqual(t.fieldPath)) return false;
                var n = "array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op;
                return 2 /* IndexKind.CONTAINS */  === t.kind === n;
            }
        },
        {
            key: "Ji",
            value: function Ji(e, t) {
                return !!e.field.isEqual(t.fieldPath) && (0 /* IndexKind.ASCENDING */  === t.kind && "asc" /* Direction.ASCENDING */  === e.dir || 1 /* IndexKind.DESCENDING */  === t.kind && "desc" /* Direction.DESCENDING */  === e.dir);
            }
        }
    ]);
    return __PRIVATE_TargetIndexMatcher;
}();
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides utility functions that help with boolean logic transformations needed for handling
 * complex filters used in queries.
 */ /**
 * The `in` filter is only a syntactic sugar over a disjunction of equalities. For instance: `a in
 * [1,2,3]` is in fact `a==1 || a==2 || a==3`. This method expands any `in` filter in the given
 * input into a disjunction of equality filters and returns the expanded filter.
 */ function __PRIVATE_computeInExpansion(e) {
    if (__PRIVATE_hardAssert(e instanceof FieldFilter || e instanceof CompositeFilter, 20012), e instanceof FieldFilter) {
        if (e instanceof __PRIVATE_InFilter) {
            var _e_value_arrayValue_values, _e_value_arrayValue;
            var t = ((_e_value_arrayValue = e.value.arrayValue) === null || _e_value_arrayValue === void 0 ? void 0 : (_e_value_arrayValue_values = _e_value_arrayValue.values) === null || _e_value_arrayValue_values === void 0 ? void 0 : _e_value_arrayValue_values.map(function(t) {
                return FieldFilter.create(e.field, "==" /* Operator.EQUAL */ , t);
            })) || [];
            return CompositeFilter.create(t, "or" /* CompositeOperator.OR */ );
        }
        // We have reached other kinds of field filters.
        return e;
    }
    // We have a composite filter.
    var t1 = e.filters.map(function(e) {
        return __PRIVATE_computeInExpansion(e);
    });
    return CompositeFilter.create(t1, e.op);
}
/**
 * Given a composite filter, returns the list of terms in its disjunctive normal form.
 *
 * <p>Each element in the return value is one term of the resulting DNF. For instance: For the
 * input: (A || B) && C, the DNF form is: (A && C) || (B && C), and the return value is a list
 * with two elements: a composite filter that performs (A && C), and a composite filter that
 * performs (B && C).
 *
 * @param filter - the composite filter to calculate DNF transform for.
 * @returns the terms in the DNF transform.
 */ function __PRIVATE_getDnfTerms(e) {
    if (0 === e.getFilters().length) return [];
    var t = __PRIVATE_computeDistributedNormalForm(__PRIVATE_computeInExpansion(e));
    return __PRIVATE_hardAssert(__PRIVATE_isDisjunctiveNormalForm(t), 7391), __PRIVATE_isSingleFieldFilter(t) || __PRIVATE_isFlatConjunction(t) ? [
        t
    ] : t.getFilters();
}
/** Returns true if the given filter is a single field filter. e.g. (a == 10). */ function __PRIVATE_isSingleFieldFilter(e) {
    return e instanceof FieldFilter;
}
/**
 * Returns true if the given filter is the conjunction of one or more field filters. e.g. (a == 10
 * && b == 20)
 */ function __PRIVATE_isFlatConjunction(e) {
    return e instanceof CompositeFilter && __PRIVATE_compositeFilterIsFlatConjunction(e);
}
/**
 * Returns whether or not the given filter is in disjunctive normal form (DNF).
 *
 * <p>In boolean logic, a disjunctive normal form (DNF) is a canonical normal form of a logical
 * formula consisting of a disjunction of conjunctions; it can also be described as an OR of ANDs.
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Disjunctive_normal_form
 */ function __PRIVATE_isDisjunctiveNormalForm(e) {
    return __PRIVATE_isSingleFieldFilter(e) || __PRIVATE_isFlatConjunction(e) || /**
 * Returns true if the given filter is the disjunction of one or more "flat conjunctions" and
 * field filters. e.g. (a == 10) || (b==20 && c==30)
 */ function __PRIVATE_isDisjunctionOfFieldFiltersAndFlatConjunctions(e) {
        if (e instanceof CompositeFilter && __PRIVATE_compositeFilterIsDisjunction(e)) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = e.getFilters()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var t = _step.value;
                    if (!__PRIVATE_isSingleFieldFilter(t) && !__PRIVATE_isFlatConjunction(t)) return false;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return true;
        }
        return false;
    }(e);
}
function __PRIVATE_computeDistributedNormalForm(e) {
    if (__PRIVATE_hardAssert(e instanceof FieldFilter || e instanceof CompositeFilter, 34018), e instanceof FieldFilter) return e;
    if (1 === e.filters.length) return __PRIVATE_computeDistributedNormalForm(e.filters[0]);
    // Compute DNF for each of the subfilters first
    var t = e.filters.map(function(e) {
        return __PRIVATE_computeDistributedNormalForm(e);
    });
    var n = CompositeFilter.create(t, e.op);
    return n = __PRIVATE_applyAssociation(n), __PRIVATE_isDisjunctiveNormalForm(n) ? n : (__PRIVATE_hardAssert(n instanceof CompositeFilter, 64498), __PRIVATE_hardAssert(__PRIVATE_compositeFilterIsConjunction(n), 40251), __PRIVATE_hardAssert(n.filters.length > 1, 57927), n.filters.reduce(function(e, t) {
        return __PRIVATE_applyDistribution(e, t);
    }));
}
function __PRIVATE_applyDistribution(e, t) {
    var n;
    return __PRIVATE_hardAssert(e instanceof FieldFilter || e instanceof CompositeFilter, 38388), __PRIVATE_hardAssert(t instanceof FieldFilter || t instanceof CompositeFilter, 25473), // FieldFilter FieldFilter
    n = e instanceof FieldFilter ? t instanceof FieldFilter ? function __PRIVATE_applyDistributionFieldFilters(e, t) {
        // Conjunction distribution for two field filters is the conjunction of them.
        return CompositeFilter.create([
            e,
            t
        ], "and" /* CompositeOperator.AND */ );
    }(e, t) : __PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) : t instanceof FieldFilter ? __PRIVATE_applyDistributionFieldAndCompositeFilters(t, e) : function __PRIVATE_applyDistributionCompositeFilters(e, t) {
        // There are four cases:
        // (A & B) & (C & D) --> (A & B & C & D)
        // (A & B) & (C | D) --> (A & B & C) | (A & B & D)
        // (A | B) & (C & D) --> (C & D & A) | (C & D & B)
        // (A | B) & (C | D) --> (A & C) | (A & D) | (B & C) | (B & D)
        // Case 1 is a merge.
        if (__PRIVATE_hardAssert(e.filters.length > 0 && t.filters.length > 0, 48005), __PRIVATE_compositeFilterIsConjunction(e) && __PRIVATE_compositeFilterIsConjunction(t)) return __PRIVATE_compositeFilterWithAddedFilters(e, t.getFilters());
        // Case 2,3,4 all have at least one side (lhs or rhs) that is a disjunction. In all three cases
        // we should take each element of the disjunction and distribute it over the other side, and
        // return the disjunction of the distribution results.
        var n = __PRIVATE_compositeFilterIsDisjunction(e) ? e : t, r = __PRIVATE_compositeFilterIsDisjunction(e) ? t : e, i = n.filters.map(function(e) {
            return __PRIVATE_applyDistribution(e, r);
        });
        return CompositeFilter.create(i, "or" /* CompositeOperator.OR */ );
    }(e, t), __PRIVATE_applyAssociation(n);
}
function __PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) {
    // There are two cases:
    // A & (B & C) --> (A & B & C)
    // A & (B | C) --> (A & B) | (A & C)
    if (__PRIVATE_compositeFilterIsConjunction(t)) // Case 1
    return __PRIVATE_compositeFilterWithAddedFilters(t, e.getFilters());
    {
        // Case 2
        var n = t.filters.map(function(t) {
            return __PRIVATE_applyDistribution(e, t);
        });
        return CompositeFilter.create(n, "or" /* CompositeOperator.OR */ );
    }
}
/**
 * Applies the associativity property to the given filter and returns the resulting filter.
 *
 * <ul>
 *   <li>A | (B | C) == (A | B) | C == (A | B | C)
 *   <li>A & (B & C) == (A & B) & C == (A & B & C)
 * </ul>
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Associative_property#Propositional_logic
 */ function __PRIVATE_applyAssociation(e) {
    if (__PRIVATE_hardAssert(e instanceof FieldFilter || e instanceof CompositeFilter, 11850), e instanceof FieldFilter) return e;
    var t = e.getFilters();
    // If the composite filter only contains 1 filter, apply associativity to it.
    if (1 === t.length) return __PRIVATE_applyAssociation(t[0]);
    // Associativity applied to a flat composite filter results is itself.
    if (__PRIVATE_compositeFilterIsFlat(e)) return e;
    // First apply associativity to all subfilters. This will in turn recursively apply
    // associativity to all nested composite filters and field filters.
    var n = t.map(function(e) {
        return __PRIVATE_applyAssociation(e);
    }), r = [];
    // For composite subfilters that perform the same kind of logical operation as `compositeFilter`
    // take out their filters and add them to `compositeFilter`. For example:
    // compositeFilter = (A | (B | C | D))
    // compositeSubfilter = (B | C | D)
    // Result: (A | B | C | D)
    // Note that the `compositeSubfilter` has been eliminated, and its filters (B, C, D) have been
    // added to the top-level "compositeFilter".
    return n.forEach(function(t) {
        var // compositeFilter: (A | (B | C))
        // compositeSubfilter: (B | C)
        // Result: (A | B | C)
        _r;
        t instanceof FieldFilter ? r.push(t) : t instanceof CompositeFilter && (t.op === e.op ? (_r = r).push.apply(_r, (0, $jlUaU._)(t.filters)) : // compositeFilter: (A | (B & C))
        // compositeSubfilter: (B & C)
        // Result: (A | (B & C))
        r.push(t));
    }), 1 === r.length ? r[0] : CompositeFilter.create(r, e.op);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of IndexManager.
 */ var __PRIVATE_MemoryIndexManager = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryIndexManager() {
        (0, $4QweW._)(this, __PRIVATE_MemoryIndexManager);
        this.Zi = new __PRIVATE_MemoryCollectionParentIndex;
    }
    (0, $6hK4i._)(__PRIVATE_MemoryIndexManager, [
        {
            key: "addToCollectionParentIndex",
            value: function addToCollectionParentIndex(e, t) {
                return this.Zi.add(t), PersistencePromise.resolve();
            }
        },
        {
            key: "getCollectionParents",
            value: function getCollectionParents(e, t) {
                return PersistencePromise.resolve(this.Zi.getEntries(t));
            }
        },
        {
            key: "addFieldIndex",
            value: function addFieldIndex(e, t) {
                // Field indices are not supported with memory persistence.
                return PersistencePromise.resolve();
            }
        },
        {
            key: "deleteFieldIndex",
            value: function deleteFieldIndex(e, t) {
                // Field indices are not supported with memory persistence.
                return PersistencePromise.resolve();
            }
        },
        {
            key: "deleteAllFieldIndexes",
            value: function deleteAllFieldIndexes(e) {
                // Field indices are not supported with memory persistence.
                return PersistencePromise.resolve();
            }
        },
        {
            key: "createTargetIndexes",
            value: function createTargetIndexes(e, t) {
                // Field indices are not supported with memory persistence.
                return PersistencePromise.resolve();
            }
        },
        {
            key: "getDocumentsMatchingTarget",
            value: function getDocumentsMatchingTarget(e, t) {
                // Field indices are not supported with memory persistence.
                return PersistencePromise.resolve(null);
            }
        },
        {
            key: "getIndexType",
            value: function getIndexType(e, t) {
                // Field indices are not supported with memory persistence.
                return PersistencePromise.resolve(0 /* IndexType.NONE */ );
            }
        },
        {
            key: "getFieldIndexes",
            value: function getFieldIndexes(e, t) {
                // Field indices are not supported with memory persistence.
                return PersistencePromise.resolve([]);
            }
        },
        {
            key: "getNextCollectionGroupToUpdate",
            value: function getNextCollectionGroupToUpdate(e) {
                // Field indices are not supported with memory persistence.
                return PersistencePromise.resolve(null);
            }
        },
        {
            key: "getMinOffset",
            value: function getMinOffset(e, t) {
                return PersistencePromise.resolve(IndexOffset.min());
            }
        },
        {
            key: "getMinOffsetFromCollectionGroup",
            value: function getMinOffsetFromCollectionGroup(e, t) {
                return PersistencePromise.resolve(IndexOffset.min());
            }
        },
        {
            key: "updateCollectionGroup",
            value: function updateCollectionGroup(e, t, n) {
                // Field indices are not supported with memory persistence.
                return PersistencePromise.resolve();
            }
        },
        {
            key: "updateIndexEntries",
            value: function updateIndexEntries(e, t) {
                // Field indices are not supported with memory persistence.
                return PersistencePromise.resolve();
            }
        }
    ]);
    return __PRIVATE_MemoryIndexManager;
}();
/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */ var __PRIVATE_MemoryCollectionParentIndex = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryCollectionParentIndex() {
        (0, $4QweW._)(this, __PRIVATE_MemoryCollectionParentIndex);
        this.index = {};
    }
    (0, $6hK4i._)(__PRIVATE_MemoryCollectionParentIndex, [
        {
            // Returns false if the entry already existed.
            key: "add",
            value: function add(e) {
                var t = e.lastSegment(), n = e.popLast(), r = this.index[t] || new SortedSet(ResourcePath.comparator), i = !r.has(n);
                return this.index[t] = r.add(n), i;
            }
        },
        {
            key: "has",
            value: function has(e) {
                var t = e.lastSegment(), n = e.popLast(), r = this.index[t];
                return r && r.has(n);
            }
        },
        {
            key: "getEntries",
            value: function getEntries(e) {
                return (this.index[e] || new SortedSet(ResourcePath.comparator)).toArray();
            }
        }
    ]);
    return __PRIVATE_MemoryCollectionParentIndex;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var rr = "IndexedDbIndexManager", ir = new Uint8Array(0);
/**
 * A persisted implementation of IndexManager.
 *
 * PORTING NOTE: Unlike iOS and Android, the Web SDK does not memoize index
 * data as it supports multi-tab access.
 */ var __PRIVATE_IndexedDbIndexManager = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexedDbIndexManager(e, t) {
        (0, $4QweW._)(this, __PRIVATE_IndexedDbIndexManager);
        this.databaseId = t, /**
         * An in-memory copy of the index entries we've already written since the SDK
         * launched. Used to avoid re-writing the same entry repeatedly.
         *
         * This is *NOT* a complete cache of what's in persistence and so can never be
         * used to satisfy reads.
         */ this.Xi = new __PRIVATE_MemoryCollectionParentIndex, /**
         * Maps from a target to its equivalent list of sub-targets. Each sub-target
         * contains only one term from the target's disjunctive normal form (DNF).
         */ this.es = new ObjectMap(function(e) {
            return __PRIVATE_canonifyTarget(e);
        }, function(e, t) {
            return __PRIVATE_targetEquals(e, t);
        }), this.uid = e.uid || "";
    }
    (0, $6hK4i._)(__PRIVATE_IndexedDbIndexManager, [
        {
            /**
     * Adds a new entry to the collection parent index.
     *
     * Repeated calls for the same collectionPath should be avoided within a
     * transaction as IndexedDbIndexManager only caches writes once a transaction
     * has been committed.
     */ key: "addToCollectionParentIndex",
            value: function addToCollectionParentIndex(e, t) {
                var _this = this;
                if (!this.Xi.has(t)) {
                    var n = t.lastSegment(), r = t.popLast();
                    e.addOnCommittedListener(function() {
                        // Add the collection to the in memory cache only if the transaction was
                        // successfully committed.
                        _this.Xi.add(t);
                    });
                    var i = {
                        collectionId: n,
                        parent: __PRIVATE_encodeResourcePath(r)
                    };
                    return __PRIVATE_collectionParentsStore(e).put(i);
                }
                return PersistencePromise.resolve();
            }
        },
        {
            key: "getCollectionParents",
            value: function getCollectionParents(e, t) {
                var n = [], r = IDBKeyRange.bound([
                    t,
                    ""
                ], [
                    __PRIVATE_immediateSuccessor(t),
                    ""
                ], /*lowerOpen=*/ false, /*upperOpen=*/ true);
                return __PRIVATE_collectionParentsStore(e).Qn(r).next(function(e) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var r = _step.value;
                            // This collectionId guard shouldn't be necessary (and isn't as long
                            // as we're running in a real browser), but there's a bug in
                            // indexeddbshim that breaks our range in our tests running in node:
                            // https://github.com/axemclion/IndexedDBShim/issues/334
                            if (r.collectionId !== t) break;
                            n.push(__PRIVATE_decodeResourcePath(r.parent));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return n;
                });
            }
        },
        {
            key: "addFieldIndex",
            value: function addFieldIndex(e, t) {
                var _this = this;
                // TODO(indexing): Verify that the auto-incrementing index ID works in
                // Safari & Firefox.
                var n = __PRIVATE_indexConfigurationStore(e), r = function __PRIVATE_toDbIndexConfiguration(e) {
                    return {
                        indexId: e.indexId,
                        collectionGroup: e.collectionGroup,
                        fields: e.fields.map(function(e) {
                            return [
                                e.fieldPath.canonicalString(),
                                e.kind
                            ];
                        })
                    };
                }(t);
                delete r.indexId;
                // `indexId` is auto-populated by IndexedDb
                var i = n.add(r);
                if (t.indexState) {
                    var n1 = __PRIVATE_indexStateStore(e);
                    return i.next(function(e) {
                        n1.put(__PRIVATE_toDbIndexState(e, _this.uid, t.indexState.sequenceNumber, t.indexState.offset));
                    });
                }
                return i.next();
            }
        },
        {
            key: "deleteFieldIndex",
            value: function deleteFieldIndex(e, t) {
                var n = __PRIVATE_indexConfigurationStore(e), r = __PRIVATE_indexStateStore(e), i = __PRIVATE_indexEntriesStore(e);
                return n.delete(t.indexId).next(function() {
                    return r.delete(IDBKeyRange.bound([
                        t.indexId
                    ], [
                        t.indexId + 1
                    ], /*lowerOpen=*/ false, /*upperOpen=*/ true));
                }).next(function() {
                    return i.delete(IDBKeyRange.bound([
                        t.indexId
                    ], [
                        t.indexId + 1
                    ], /*lowerOpen=*/ false, /*upperOpen=*/ true));
                });
            }
        },
        {
            key: "deleteAllFieldIndexes",
            value: function deleteAllFieldIndexes(e) {
                var t = __PRIVATE_indexConfigurationStore(e), n = __PRIVATE_indexEntriesStore(e), r = __PRIVATE_indexStateStore(e);
                return t.zn().next(function() {
                    return n.zn();
                }).next(function() {
                    return r.zn();
                });
            }
        },
        {
            key: "createTargetIndexes",
            value: function createTargetIndexes(e, t) {
                var _this = this;
                return PersistencePromise.forEach(this.ts(t), function(t) {
                    return _this.getIndexType(e, t).next(function(n) {
                        if (0 /* IndexType.NONE */  === n || 1 /* IndexType.PARTIAL */  === n) {
                            var _$n = new __PRIVATE_TargetIndexMatcher(t).Yi();
                            if (null != _$n) return _this.addFieldIndex(e, _$n);
                        }
                    });
                });
            }
        },
        {
            key: "getDocumentsMatchingTarget",
            value: function getDocumentsMatchingTarget(e, t) {
                var _this = this;
                var n = __PRIVATE_indexEntriesStore(e);
                var r = true;
                var i = new Map;
                return PersistencePromise.forEach(this.ts(t), function(t) {
                    return _this.ns(e, t).next(function(e) {
                        r && (r = !!e), i.set(t, e);
                    });
                }).next(function() {
                    if (r) {
                        var _$e = __PRIVATE_documentKeySet();
                        var r1 = [];
                        return PersistencePromise.forEach(i, function(i, s) {
                            __PRIVATE_logDebug(rr, "Using index ".concat(function __PRIVATE_fieldIndexToString(e) {
                                return "id=".concat(e.indexId, "|cg=").concat(e.collectionGroup, "|f=").concat(e.fields.map(function(e) {
                                    return "".concat(e.fieldPath, ":").concat(e.kind);
                                }).join(","));
                            }(i), " to execute ").concat(__PRIVATE_canonifyTarget(t)));
                            var _ = function __PRIVATE_targetGetArrayValues(e, t) {
                                var n = __PRIVATE_fieldIndexGetArraySegment(t);
                                if (void 0 === n) return null;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = __PRIVATE_targetGetFieldFiltersForPath(e, n.fieldPath)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _$t = _step.value;
                                        switch(_$t.op){
                                            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
                                                return _$t.value.arrayValue.values || [];
                                            case "array-contains" /* Operator.ARRAY_CONTAINS */ :
                                                return [
                                                    _$t.value
                                                ];
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return null;
                            }(s, i), o = function __PRIVATE_targetGetNotInValues(e, t) {
                                var n = new Map;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(var _iterator = __PRIVATE_fieldIndexGetDirectionalSegments(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                                        var r = _step.value;
                                        try {
                                            for(var _iterator1 = __PRIVATE_targetGetFieldFiltersForPath(e, r.fieldPath)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                                var _$t = _step1.value;
                                                switch(_$t.op){
                                                    case "==" /* Operator.EQUAL */ :
                                                    case "in" /* Operator.IN */ :
                                                        // Encode equality prefix, which is encoded in the index value before
                                                        // the inequality (e.g. `a == 'a' && b != 'b'` is encoded to
                                                        // `value != 'ab'`).
                                                        n.set(r.fieldPath.canonicalString(), _$t.value);
                                                        break;
                                                    case "not-in" /* Operator.NOT_IN */ :
                                                    case "!=" /* Operator.NOT_EQUAL */ :
                                                        // NotIn/NotEqual is always a suffix. There cannot be any remaining
                                                        // segments and hence we can return early here.
                                                        return n.set(r.fieldPath.canonicalString(), _$t.value), Array.from(n.values());
                                                }
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                                    _iterator1.return();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                return null;
                            }(s, i), a = function __PRIVATE_targetGetLowerBound(e, t) {
                                var n = [];
                                var r = true;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    // For each segment, retrieve a lower bound if there is a suitable filter or
                                    // startAt.
                                    for(var _iterator = __PRIVATE_fieldIndexGetDirectionalSegments(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _$i = _step.value;
                                        var _$t = 0 /* IndexKind.ASCENDING */  === _$i.kind ? __PRIVATE_targetGetAscendingBound(e, _$i.fieldPath, e.startAt) : __PRIVATE_targetGetDescendingBound(e, _$i.fieldPath, e.startAt);
                                        n.push(_$t.value), r && (r = _$t.inclusive);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return new Bound(n, r);
                            }(s, i), u = function __PRIVATE_targetGetUpperBound(e, t) {
                                var n = [];
                                var r = true;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    // For each segment, retrieve an upper bound if there is a suitable filter or
                                    // endAt.
                                    for(var _iterator = __PRIVATE_fieldIndexGetDirectionalSegments(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _$i = _step.value;
                                        var _$t = 0 /* IndexKind.ASCENDING */  === _$i.kind ? __PRIVATE_targetGetDescendingBound(e, _$i.fieldPath, e.endAt) : __PRIVATE_targetGetAscendingBound(e, _$i.fieldPath, e.endAt);
                                        n.push(_$t.value), r && (r = _$t.inclusive);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return new Bound(n, r);
                            }(s, i), c = _this.rs(i, s, a), l = _this.rs(i, s, u), E = _this.ss(i, s, o), h = _this._s(i.indexId, _, c, a.inclusive, l, u.inclusive, E);
                            return PersistencePromise.forEach(h, function(i) {
                                return n.Gn(i, t.limit).next(function(t) {
                                    t.forEach(function(t) {
                                        var n = DocumentKey.fromSegments(t.documentKey);
                                        _$e.has(n) || (_$e = _$e.add(n), r1.push(n));
                                    });
                                });
                            });
                        }).next(function() {
                            return r1;
                        });
                    }
                    return PersistencePromise.resolve(null);
                });
            }
        },
        {
            key: "ts",
            value: function ts(e) {
                var t = this.es.get(e);
                if (t) return t;
                if (0 === e.filters.length) t = [
                    e
                ];
                else t = __PRIVATE_getDnfTerms(CompositeFilter.create(e.filters, "and" /* CompositeOperator.AND */ )).map(function(t) {
                    return __PRIVATE_newTarget(e.path, e.collectionGroup, e.orderBy, t.getFilters(), e.limit, e.startAt, e.endAt);
                });
                return this.es.set(e, t), t;
            }
        },
        {
            /**
     * Constructs a key range query on `DbIndexEntryStore` that unions all
     * bounds.
     */ key: "_s",
            value: function _s(e, t, n, r, i, s, _) {
                var _this, _loop = function(c) {
                    var _u;
                    var o = t ? _this.us(t[c / a]) : ir, l = _this.cs(e, o, n[c % a], r), E = _this.ls(e, o, i[c % a], s), h = _.map(function(t) {
                        return _this1.cs(e, o, t, /* inclusive= */ true);
                    });
                    (_u = u).push.apply(_u, (0, $jlUaU._)(_this.createRange(l, E, h)));
                };
                var _this1 = this;
                // The number of total index scans we union together. This is similar to a
                // distributed normal form, but adapted for array values. We create a single
                // index range per value in an ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filter
                // combined with the values from the query bounds.
                var o = (null != t ? t.length : 1) * Math.max(n.length, i.length), a = o / (null != t ? t.length : 1), u = [];
                for(var c = 0; c < o; ++c)_this = this, _loop(c);
                return u;
            }
        },
        {
            /** Generates the lower bound for `arrayValue` and `directionalValue`. */ key: "cs",
            value: function cs(e, t, n, r) {
                var i = new __PRIVATE_IndexEntry(e, DocumentKey.empty(), t, n);
                return r ? i : i.ki();
            }
        },
        {
            /** Generates the upper bound for `arrayValue` and `directionalValue`. */ key: "ls",
            value: function ls(e, t, n, r) {
                var i = new __PRIVATE_IndexEntry(e, DocumentKey.empty(), t, n);
                return r ? i.ki() : i;
            }
        },
        {
            key: "ns",
            value: function ns(e, t) {
                var n = new __PRIVATE_TargetIndexMatcher(t), r = null != t.collectionGroup ? t.collectionGroup : t.path.lastSegment();
                return this.getFieldIndexes(e, r).next(function(e) {
                    // Return the index with the most number of segments.
                    var _$t = null;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var r = _step.value;
                            n.zi(r) && (!_$t || r.fields.length > _$t.fields.length) && (_$t = r);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return _$t;
                });
            }
        },
        {
            key: "getIndexType",
            value: function getIndexType(e, t) {
                var _this = this;
                var n = 2 /* IndexType.FULL */ ;
                var r = this.ts(t);
                return PersistencePromise.forEach(r, function(t) {
                    return _this.ns(e, t).next(function(e) {
                        e ? 0 /* IndexType.NONE */  !== n && e.fields.length < function __PRIVATE_targetGetSegmentCount(e) {
                            var _$t = new SortedSet(Oe.comparator), n = false;
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(var _iterator = e.filters[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                                    var r = _step.value;
                                    try {
                                        for(var _iterator1 = r.getFlattenedFilters()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                            var _$e = _step1.value;
                                            // __name__ is not an explicit segment of any index, so we don't need to
                                            // count it.
                                            _$e.field.isKeyField() || // ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filters must be counted separately.
                                            // For instance, it is possible to have an index for "a ARRAY a ASC". Even
                                            // though these are on the same field, they should be counted as two
                                            // separate segments in an index.
                                            ("array-contains" /* Operator.ARRAY_CONTAINS */  === _$e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === _$e.op ? n = true : _$t = _$t.add(_$e.field));
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                                _iterator1.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            try {
                                for(var _iterator2 = e.orderBy[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                    var n1 = _step2.value;
                                    // __name__ is not an explicit segment of any index, so we don't need to
                                    // count it.
                                    n1.field.isKeyField() || (_$t = _$t.add(n1.field));
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                        _iterator2.return();
                                    }
                                } finally{
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                            return _$t.size + (n ? 1 : 0);
                        }(t) && (n = 1 /* IndexType.PARTIAL */ ) : n = 0 /* IndexType.NONE */ ;
                    });
                }).next(function() {
                    return(// OR queries have more than one sub-target (one sub-target per DNF term). We currently consider
                    // OR queries that have a `limit` to have a partial index. For such queries we perform sorting
                    // and apply the limit in memory as a post-processing step.
                    function __PRIVATE_targetHasLimit(e) {
                        return null !== e.limit;
                    }(t) && r.length > 1 && 2 /* IndexType.FULL */  === n ? 1 /* IndexType.PARTIAL */  : n);
                });
            }
        },
        {
            /**
     * Returns the byte encoded form of the directional values in the field index.
     * Returns `null` if the document does not have all fields specified in the
     * index.
     */ key: "Es",
            value: function Es(e, t) {
                var n = new __PRIVATE_IndexByteEncoder;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = __PRIVATE_fieldIndexGetDirectionalSegments(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var r = _step.value;
                        var _$e = t.data.field(r.fieldPath);
                        if (null == _$e) return null;
                        var i = n.Mi(r.kind);
                        __PRIVATE_FirestoreIndexValueWriter.Pi.ei(_$e, i);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return n.Fi();
            }
        },
        {
            /** Encodes a single value to the ascending index format. */ key: "us",
            value: function us(e) {
                var t = new __PRIVATE_IndexByteEncoder;
                return __PRIVATE_FirestoreIndexValueWriter.Pi.ei(e, t.Mi(0 /* IndexKind.ASCENDING */ )), t.Fi();
            }
        },
        {
            /**
     * Returns an encoded form of the document key that sorts based on the key
     * ordering of the field index.
     */ key: "hs",
            value: function hs(e, t) {
                var n = new __PRIVATE_IndexByteEncoder;
                return __PRIVATE_FirestoreIndexValueWriter.Pi.ei(__PRIVATE_refValue(this.databaseId, t), n.Mi(function __PRIVATE_fieldIndexGetKeyOrder(e) {
                    var _$t = __PRIVATE_fieldIndexGetDirectionalSegments(e);
                    return 0 === _$t.length ? 0 /* IndexKind.ASCENDING */  : _$t[_$t.length - 1].kind;
                }(e))), n.Fi();
            }
        },
        {
            /**
     * Encodes the given field values according to the specification in `target`.
     * For IN queries, a list of possible values is returned.
     */ key: "ss",
            value: function ss(e, t, n) {
                if (null === n) return [];
                var r = [];
                r.push(new __PRIVATE_IndexByteEncoder);
                var i = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = __PRIVATE_fieldIndexGetDirectionalSegments(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var s = _step.value;
                        var _$e = n[i++];
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = r[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var _$n = _step1.value;
                                if (this.Ts(t, s.fieldPath) && isArray(_$e)) r = this.Ps(r, s, _$e);
                                else {
                                    var _$t = _$n.Mi(s.kind);
                                    __PRIVATE_FirestoreIndexValueWriter.Pi.ei(_$e, _$t);
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return this.Is(r);
            }
        },
        {
            /**
     * Encodes the given bounds according to the specification in `target`. For IN
     * queries, a list of possible values is returned.
     */ key: "rs",
            value: function rs(e, t, n) {
                return this.ss(e, t, n.position);
            }
        },
        {
            /** Returns the byte representation for the provided encoders. */ key: "Is",
            value: function Is(e) {
                var t = [];
                for(var n = 0; n < e.length; ++n)t[n] = e[n].Fi();
                return t;
            }
        },
        {
            /**
     * Creates a separate encoder for each element of an array.
     *
     * The method appends each value to all existing encoders (e.g. filter("a",
     * "==", "a1").filter("b", "in", ["b1", "b2"]) becomes ["a1,b1", "a1,b2"]). A
     * list of new encoders is returned.
     */ key: "Ps",
            value: function Ps(e, t, n) {
                var r = (0, $jlUaU._)(e), i = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator = (n.arrayValue.values || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                        var _$e = _step.value;
                        try {
                            for(var _iterator1 = r[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                var _$n = _step1.value;
                                var r1 = new __PRIVATE_IndexByteEncoder;
                                r1.seed(_$n.Fi()), __PRIVATE_FirestoreIndexValueWriter.Pi.ei(_$e, r1.Mi(t.kind)), i.push(r1);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return i;
            }
        },
        {
            key: "Ts",
            value: function Ts(e, t) {
                return !!e.filters.find(function(e) {
                    return e instanceof FieldFilter && e.field.isEqual(t) && ("in" /* Operator.IN */  === e.op || "not-in" /* Operator.NOT_IN */  === e.op);
                });
            }
        },
        {
            key: "getFieldIndexes",
            value: function getFieldIndexes(e, t) {
                var _this = this;
                var n = __PRIVATE_indexConfigurationStore(e), r = __PRIVATE_indexStateStore(e);
                return (t ? n.Qn(Dn, IDBKeyRange.bound(t, t)) : n.Qn()).next(function(e) {
                    var _$t = [];
                    return PersistencePromise.forEach(e, function(e) {
                        return r.get([
                            e.indexId,
                            _this.uid
                        ]).next(function(n) {
                            _$t.push(function __PRIVATE_fromDbIndexConfiguration(e, t) {
                                var _$n = t ? new IndexState(t.sequenceNumber, new IndexOffset(__PRIVATE_fromDbTimestamp(t.readTime), new DocumentKey(__PRIVATE_decodeResourcePath(t.documentKey)), t.largestBatchId)) : IndexState.empty(), r = e.fields.map(function(param) {
                                    var _param = (0, $6ZpBv._)(param, 2), _$e = _param[0], _$t = _param[1];
                                    return new IndexSegment(Oe.fromServerFormat(_$e), _$t);
                                });
                                return new FieldIndex(e.indexId, e.collectionGroup, r, _$n);
                            }(e, n));
                        });
                    }).next(function() {
                        return _$t;
                    });
                });
            }
        },
        {
            key: "getNextCollectionGroupToUpdate",
            value: function getNextCollectionGroupToUpdate(e) {
                return this.getFieldIndexes(e).next(function(e) {
                    return 0 === e.length ? null : (e.sort(function(e, t) {
                        var n = e.indexState.sequenceNumber - t.indexState.sequenceNumber;
                        return 0 !== n ? n : __PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
                    }), e[0].collectionGroup);
                });
            }
        },
        {
            key: "updateCollectionGroup",
            value: function updateCollectionGroup(e, t, n) {
                var _this = this;
                var r = __PRIVATE_indexConfigurationStore(e), i = __PRIVATE_indexStateStore(e);
                return this.Rs(e).next(function(e) {
                    return r.Qn(Dn, IDBKeyRange.bound(t, t)).next(function(t) {
                        return PersistencePromise.forEach(t, function(t) {
                            return i.put(__PRIVATE_toDbIndexState(t.indexId, _this.uid, e, n));
                        });
                    });
                });
            }
        },
        {
            key: "updateIndexEntries",
            value: function updateIndexEntries(e, t) {
                var _this = this;
                // Porting Note: `getFieldIndexes()` on Web does not cache index lookups as
                // it could be used across different IndexedDB transactions. As any cached
                // data might be invalidated by other multi-tab clients, we can only trust
                // data within a single IndexedDB transaction. We therefore add a cache
                // here.
                var n = new Map;
                return PersistencePromise.forEach(t, function(t, r) {
                    var i = n.get(t.collectionGroup);
                    return (i ? PersistencePromise.resolve(i) : _this.getFieldIndexes(e, t.collectionGroup)).next(function(i) {
                        return n.set(t.collectionGroup, i), PersistencePromise.forEach(i, function(n) {
                            return _this.As(e, t, n).next(function(t) {
                                var _$i = _this.Vs(r, n);
                                return t.isEqual(_$i) ? PersistencePromise.resolve() : _this.ds(e, r, n, t, _$i);
                            });
                        });
                    });
                });
            }
        },
        {
            key: "fs",
            value: function fs(e, t, n, r) {
                return __PRIVATE_indexEntriesStore(e).put(r.qi(this.uid, this.hs(n, t.key), t.key));
            }
        },
        {
            key: "ps",
            value: function ps(e, t, n, r) {
                return __PRIVATE_indexEntriesStore(e).delete(r.$i(this.uid, this.hs(n, t.key), t.key));
            }
        },
        {
            key: "As",
            value: function As(e, t, n) {
                var r = __PRIVATE_indexEntriesStore(e);
                var i = new SortedSet(__PRIVATE_indexEntryComparator);
                return r.Hn({
                    index: Bn,
                    range: IDBKeyRange.only([
                        n.indexId,
                        this.uid,
                        __PRIVATE_encodeKeySafeBytes(this.hs(n, t))
                    ])
                }, function(e, r) {
                    i = i.add(new __PRIVATE_IndexEntry(n.indexId, t, __PRIVATE_decodeKeySafeBytes(r.arrayValue), __PRIVATE_decodeKeySafeBytes(r.directionalValue)));
                }).next(function() {
                    return i;
                });
            }
        },
        {
            /** Creates the index entries for the given document. */ key: "Vs",
            value: function Vs(e, t) {
                var n = new SortedSet(__PRIVATE_indexEntryComparator);
                var r = this.Es(t, e);
                if (null == r) return n;
                var i = __PRIVATE_fieldIndexGetArraySegment(t);
                if (null != i) {
                    var s = e.data.field(i.fieldPath);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (isArray(s)) try {
                        for(var _iterator = (s.arrayValue.values || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var i1 = _step.value;
                            n = n.add(new __PRIVATE_IndexEntry(t.indexId, e.key, this.us(i1), r));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } else n = n.add(new __PRIVATE_IndexEntry(t.indexId, e.key, ir, r));
                return n;
            }
        },
        {
            /**
     * Updates the index entries for the provided document by deleting entries
     * that are no longer referenced in `newEntries` and adding all newly added
     * entries.
     */ key: "ds",
            value: function ds(e, t, n, r, i) {
                var _this = this;
                __PRIVATE_logDebug(rr, "Updating index entries for document '%s'", t.key);
                var s = [];
                return function __PRIVATE_diffSortedSets(e, t, n, r, i) {
                    var s = e.getIterator(), _ = t.getIterator();
                    var o = __PRIVATE_advanceIterator(s), a = __PRIVATE_advanceIterator(_);
                    // Walk through the two sets at the same time, using the ordering defined by
                    // `comparator`.
                    for(; o || a;){
                        var _$e = false, _$t = false;
                        if (o && a) {
                            var _$r = n(o, a);
                            _$r < 0 ? // The element was removed if the next element in our ordered
                            // walkthrough is only in `before`.
                            _$t = true : _$r > 0 && // The element was added if the next element in our ordered walkthrough
                            // is only in `after`.
                            (_$e = true);
                        } else null != o ? _$t = true : _$e = true;
                        _$e ? (r(a), a = __PRIVATE_advanceIterator(_)) : _$t ? (i(o), o = __PRIVATE_advanceIterator(s)) : (o = __PRIVATE_advanceIterator(s), a = __PRIVATE_advanceIterator(_));
                    }
                }(r, i, __PRIVATE_indexEntryComparator, /* onAdd= */ function(r) {
                    s.push(_this.fs(e, t, n, r));
                }, /* onRemove= */ function(r) {
                    s.push(_this.ps(e, t, n, r));
                }), PersistencePromise.waitFor(s);
            }
        },
        {
            key: "Rs",
            value: function Rs(e) {
                var t = 1;
                return __PRIVATE_indexStateStore(e).Hn({
                    index: On,
                    reverse: true,
                    range: IDBKeyRange.upperBound([
                        this.uid,
                        Number.MAX_SAFE_INTEGER
                    ])
                }, function(e, n, r) {
                    r.done(), t = n.sequenceNumber + 1;
                }).next(function() {
                    return t;
                });
            }
        },
        {
            /**
     * Returns a new set of IDB ranges that splits the existing range and excludes
     * any values that match the `notInValue` from these ranges. As an example,
     * '[foo > 2 && foo != 3]` becomes  `[foo > 2 && < 3, foo > 3]`.
     */ key: "createRange",
            value: function createRange(e, t, n) {
                // The notIn values need to be sorted and unique so that we can return a
                // sorted set of non-overlapping ranges.
                n = n.sort(function(e, t) {
                    return __PRIVATE_indexEntryComparator(e, t);
                }).filter(function(e, t, n) {
                    return !t || 0 !== __PRIVATE_indexEntryComparator(e, n[t - 1]);
                });
                var r = [];
                r.push(e);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var _$n = __PRIVATE_indexEntryComparator(i, e), s = __PRIVATE_indexEntryComparator(i, t);
                        if (0 === _$n) // `notInValue` is the lower bound. We therefore need to raise the bound
                        // to the next value.
                        r[0] = e.ki();
                        else if (_$n > 0 && s < 0) // `notInValue` is in the middle of the range
                        r.push(i), r.push(i.ki());
                        else if (s > 0) break;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                r.push(t);
                var i1 = [];
                for(var _$e = 0; _$e < r.length; _$e += 2){
                    // If we encounter two bounds that will create an unmatchable key range,
                    // then we return an empty set of key ranges.
                    if (this.gs(r[_$e], r[_$e + 1])) return [];
                    var _$t = r[_$e].$i(this.uid, ir, DocumentKey.empty()), _$n1 = r[_$e + 1].$i(this.uid, ir, DocumentKey.empty());
                    i1.push(IDBKeyRange.bound(_$t, _$n1));
                }
                return i1;
            }
        },
        {
            key: "gs",
            value: function gs(e, t) {
                // If lower bound is greater than the upper bound, then the key
                // range can never be matched.
                return __PRIVATE_indexEntryComparator(e, t) > 0;
            }
        },
        {
            key: "getMinOffsetFromCollectionGroup",
            value: function getMinOffsetFromCollectionGroup(e, t) {
                return this.getFieldIndexes(e, t).next(__PRIVATE_getMinOffsetFromFieldIndexes);
            }
        },
        {
            key: "getMinOffset",
            value: function getMinOffset(e, t) {
                var _this = this;
                return PersistencePromise.mapArray(this.ts(t), function(t) {
                    return _this.ns(e, t).next(function(e) {
                        return e || l(44426);
                    });
                }).next(__PRIVATE_getMinOffsetFromFieldIndexes);
            }
        }
    ]);
    return __PRIVATE_IndexedDbIndexManager;
}();
/**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */ function __PRIVATE_collectionParentsStore(e) {
    return __PRIVATE_getStore(e, dn);
}
/**
 * Helper to get a typed SimpleDbStore for the index entry object store.
 */ function __PRIVATE_indexEntriesStore(e) {
    return __PRIVATE_getStore(e, Nn);
}
/**
 * Helper to get a typed SimpleDbStore for the index configuration object store.
 */ function __PRIVATE_indexConfigurationStore(e) {
    return __PRIVATE_getStore(e, Sn);
}
/**
 * Helper to get a typed SimpleDbStore for the index state object store.
 */ function __PRIVATE_indexStateStore(e) {
    return __PRIVATE_getStore(e, Cn);
}
function __PRIVATE_getMinOffsetFromFieldIndexes(e) {
    __PRIVATE_hardAssert(0 !== e.length, 28825);
    var t = e[0].indexState.offset, n = t.largestBatchId;
    for(var r = 1; r < e.length; r++){
        var i = e[r].indexState.offset;
        __PRIVATE_indexOffsetComparator(i, t) < 0 && (t = i), n < i.largestBatchId && (n = i.largestBatchId);
    }
    return new IndexOffset(t.readTime, t.documentKey, n);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Offset to ensure non-overlapping target ids. */ /**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the target cache, and one for
 * for the sync engine (to generate limbo documents targets). These
 * generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */ var __PRIVATE_TargetIdGenerator = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_TargetIdGenerator(e) {
        (0, $4QweW._)(this, __PRIVATE_TargetIdGenerator);
        this.ys = e;
    }
    (0, $6hK4i._)(__PRIVATE_TargetIdGenerator, [
        {
            key: "next",
            value: function next() {
                return this.ys += 2, this.ys;
            }
        }
    ], [
        {
            key: "ws",
            value: function ws() {
                // The target cache generator must return '2' in its first call to `next()`
                // as there is no differentiation in the protocol layer between an unset
                // number and the number '0'. If we were to sent a target with target ID
                // '0', the backend would consider it unset and replace it with its own ID.
                return new __PRIVATE_TargetIdGenerator(0);
            }
        },
        {
            key: "bs",
            value: function bs() {
                // Sync engine assigns target IDs for limbo document detection.
                return new __PRIVATE_TargetIdGenerator(-1);
            }
        }
    ]);
    return __PRIVATE_TargetIdGenerator;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var __PRIVATE_IndexedDbTargetCache = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexedDbTargetCache(e, t) {
        (0, $4QweW._)(this, __PRIVATE_IndexedDbTargetCache);
        this.referenceDelegate = e, this.serializer = t;
    }
    (0, $6hK4i._)(__PRIVATE_IndexedDbTargetCache, [
        {
            // PORTING NOTE: We don't cache global metadata for the target cache, since
            // some of it (in particular `highestTargetId`) can be modified by secondary
            // tabs. We could perhaps be more granular (and e.g. still cache
            // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
            // to IndexedDb whenever we need to read metadata. We can revisit if it turns
            // out to have a meaningful performance impact.
            key: "allocateTargetId",
            value: function allocateTargetId(e) {
                var _this = this;
                return this.Ss(e).next(function(t) {
                    var n = new __PRIVATE_TargetIdGenerator(t.highestTargetId);
                    return t.highestTargetId = n.next(), _this.vs(e, t).next(function() {
                        return t.highestTargetId;
                    });
                });
            }
        },
        {
            key: "getLastRemoteSnapshotVersion",
            value: function getLastRemoteSnapshotVersion(e) {
                return this.Ss(e).next(function(e) {
                    return SnapshotVersion.fromTimestamp(new Timestamp(e.lastRemoteSnapshotVersion.seconds, e.lastRemoteSnapshotVersion.nanoseconds));
                });
            }
        },
        {
            key: "getHighestSequenceNumber",
            value: function getHighestSequenceNumber(e) {
                return this.Ss(e).next(function(e) {
                    return e.highestListenSequenceNumber;
                });
            }
        },
        {
            key: "setTargetsMetadata",
            value: function setTargetsMetadata(e, t, n) {
                var _this = this;
                return this.Ss(e).next(function(r) {
                    return r.highestListenSequenceNumber = t, n && (r.lastRemoteSnapshotVersion = n.toTimestamp()), t > r.highestListenSequenceNumber && (r.highestListenSequenceNumber = t), _this.vs(e, r);
                });
            }
        },
        {
            key: "addTargetData",
            value: function addTargetData(e, t) {
                var _this = this;
                return this.Ds(e, t).next(function() {
                    return _this.Ss(e).next(function(n) {
                        return n.targetCount += 1, _this.xs(t, n), _this.vs(e, n);
                    });
                });
            }
        },
        {
            key: "updateTargetData",
            value: function updateTargetData(e, t) {
                return this.Ds(e, t);
            }
        },
        {
            key: "removeTargetData",
            value: function removeTargetData(e, t) {
                var _this = this;
                return this.removeMatchingKeysForTargetId(e, t.targetId).next(function() {
                    return __PRIVATE_targetsStore(e).delete(t.targetId);
                }).next(function() {
                    return _this.Ss(e);
                }).next(function(t) {
                    return __PRIVATE_hardAssert(t.targetCount > 0, 8065), t.targetCount -= 1, _this.vs(e, t);
                });
            }
        },
        {
            /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */ key: "removeTargets",
            value: function removeTargets(e, t, n) {
                var _this = this;
                var r = 0;
                var i = [];
                return __PRIVATE_targetsStore(e).Hn(function(s, _) {
                    var o = __PRIVATE_fromDbTarget(_this.serializer, _);
                    o.sequenceNumber <= t && null === n.get(o.targetId) && (r++, i.push(_this.removeTargetData(e, o)));
                }).next(function() {
                    return PersistencePromise.waitFor(i);
                }).next(function() {
                    return r;
                });
            }
        },
        {
            /**
     * Call provided function with each `TargetData` that we have cached.
     */ key: "forEachTarget",
            value: function forEachTarget(e, t) {
                var _this = this;
                return __PRIVATE_targetsStore(e).Hn(function(e, n) {
                    var r = __PRIVATE_fromDbTarget(_this.serializer, n);
                    t(r);
                });
            }
        },
        {
            key: "Ss",
            value: function Ss(e) {
                return __PRIVATE_globalTargetStore(e).get(An).next(function(e) {
                    return __PRIVATE_hardAssert(null !== e, 2888), e;
                });
            }
        },
        {
            key: "vs",
            value: function vs(e, t) {
                return __PRIVATE_globalTargetStore(e).put(An, t);
            }
        },
        {
            key: "Ds",
            value: function Ds(e, t) {
                return __PRIVATE_targetsStore(e).put(__PRIVATE_toDbTarget(this.serializer, t));
            }
        },
        {
            /**
     * In-place updates the provided metadata to account for values in the given
     * TargetData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */ key: "xs",
            value: function xs(e, t) {
                var n = false;
                return e.targetId > t.highestTargetId && (t.highestTargetId = e.targetId, n = true), e.sequenceNumber > t.highestListenSequenceNumber && (t.highestListenSequenceNumber = e.sequenceNumber, n = true), n;
            }
        },
        {
            key: "getTargetCount",
            value: function getTargetCount(e) {
                return this.Ss(e).next(function(e) {
                    return e.targetCount;
                });
            }
        },
        {
            key: "getTargetData",
            value: function getTargetData(e, t) {
                var _this = this;
                // Iterating by the canonicalId may yield more than one result because
                // canonicalId values are not required to be unique per target. This query
                // depends on the queryTargets index to be efficient.
                var n = __PRIVATE_canonifyTargetOrPipeline(t), r = IDBKeyRange.bound([
                    n,
                    Number.NEGATIVE_INFINITY
                ], [
                    n,
                    Number.POSITIVE_INFINITY
                ]);
                var i = null;
                return __PRIVATE_targetsStore(e).Hn({
                    range: r,
                    index: En
                }, function(e, n, r) {
                    var s = __PRIVATE_fromDbTarget(_this.serializer, n);
                    // After finding a potential match, check that the target is
                    // actually equal to the requested target.
                    __PRIVATE_targetOrPipelineEqual(t, s.target) && (i = s, r.done());
                }).next(function() {
                    return i;
                });
            }
        },
        {
            key: "addMatchingKeys",
            value: function addMatchingKeys(e, t, n) {
                var _this = this;
                // PORTING NOTE: The reverse index (documentsTargets) is maintained by
                // IndexedDb.
                var r = [], i = __PRIVATE_documentTargetStore(e);
                return t.forEach(function(t) {
                    var s = __PRIVATE_encodeResourcePath(t.path);
                    r.push(i.put({
                        targetId: n,
                        path: s
                    })), r.push(_this.referenceDelegate.addReference(e, n, t));
                }), PersistencePromise.waitFor(r);
            }
        },
        {
            key: "removeMatchingKeys",
            value: function removeMatchingKeys(e, t, n) {
                var _this = this;
                // PORTING NOTE: The reverse index (documentsTargets) is maintained by
                // IndexedDb.
                var r = __PRIVATE_documentTargetStore(e);
                return PersistencePromise.forEach(t, function(t) {
                    var i = __PRIVATE_encodeResourcePath(t.path);
                    return PersistencePromise.waitFor([
                        r.delete([
                            n,
                            i
                        ]),
                        _this.referenceDelegate.removeReference(e, n, t)
                    ]);
                });
            }
        },
        {
            key: "removeMatchingKeysForTargetId",
            value: function removeMatchingKeysForTargetId(e, t) {
                var n = __PRIVATE_documentTargetStore(e), r = IDBKeyRange.bound([
                    t
                ], [
                    t + 1
                ], /*lowerOpen=*/ false, /*upperOpen=*/ true);
                return n.delete(r);
            }
        },
        {
            key: "getMatchingKeysForTargetId",
            value: function getMatchingKeysForTargetId(e, t) {
                var n = IDBKeyRange.bound([
                    t
                ], [
                    t + 1
                ], /*lowerOpen=*/ false, /*upperOpen=*/ true), r = __PRIVATE_documentTargetStore(e);
                var i = __PRIVATE_documentKeySet();
                return r.Hn({
                    range: n,
                    jn: true
                }, function(e, t, n) {
                    var r = __PRIVATE_decodeResourcePath(e[1]), s = new DocumentKey(r);
                    i = i.add(s);
                }).next(function() {
                    return i;
                });
            }
        },
        {
            key: "containsKey",
            value: function containsKey(e, t) {
                var n = __PRIVATE_encodeResourcePath(t.path), r = IDBKeyRange.bound([
                    n
                ], [
                    __PRIVATE_immediateSuccessor(n)
                ], /*lowerOpen=*/ false, /*upperOpen=*/ true);
                var i = 0;
                return __PRIVATE_documentTargetStore(e).Hn({
                    index: In,
                    jn: true,
                    range: r
                }, function(param, n, r) {
                    var _param = (0, $6ZpBv._)(param, 2), _$e = _param[0], _$t = _param[1];
                    // Having a sentinel row for a document does not count as containing that document;
                    // For the target cache, containing the document means the document is part of some
                    // target.
                    0 !== _$e && (i++, r.done());
                }).next(function() {
                    return i > 0;
                });
            }
        },
        {
            /**
     * Looks up a TargetData entry by target ID.
     *
     * @param targetId - The target ID of the TargetData entry to look up.
     * @returns The cached TargetData entry, or null if the cache has no entry for
     * the target.
     */ // PORTING NOTE: Multi-tab only.
            key: "ye",
            value: function ye(e, t) {
                var _this = this;
                return __PRIVATE_targetsStore(e).get(t).next(function(e) {
                    return e ? __PRIVATE_fromDbTarget(_this.serializer, e) : null;
                });
            }
        }
    ]);
    return __PRIVATE_IndexedDbTargetCache;
}();
/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */ function __PRIVATE_targetsStore(e) {
    return __PRIVATE_getStore(e, cn);
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */ function __PRIVATE_globalTargetStore(e) {
    return __PRIVATE_getStore(e, Vn);
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */ function __PRIVATE_documentTargetStore(e) {
    return __PRIVATE_getStore(e, Tn);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Provides LRU functionality for IndexedDB persistence. */ var __PRIVATE_IndexedDbLruDelegateImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexedDbLruDelegateImpl(e, t) {
        (0, $4QweW._)(this, __PRIVATE_IndexedDbLruDelegateImpl);
        this.db = e, this.garbageCollector = __PRIVATE_newLruGarbageCollector(this, t);
    }
    (0, $6hK4i._)(__PRIVATE_IndexedDbLruDelegateImpl, [
        {
            key: "ir",
            value: function ir(e) {
                var t = this.Cs(e);
                return this.db.getTargetCache().getTargetCount(e).next(function(e) {
                    return t.next(function(t) {
                        return e + t;
                    });
                });
            }
        },
        {
            key: "Cs",
            value: function Cs(e) {
                var t = 0;
                return this.sr(e, function(e) {
                    t++;
                }).next(function() {
                    return t;
                });
            }
        },
        {
            key: "forEachTarget",
            value: function forEachTarget(e, t) {
                return this.db.getTargetCache().forEachTarget(e, t);
            }
        },
        {
            key: "sr",
            value: function sr(e, t) {
                return this.Fs(e, function(e, n) {
                    return t(n);
                });
            }
        },
        {
            key: "addReference",
            value: function addReference(e, t, n) {
                return __PRIVATE_writeSentinelKey(e, n);
            }
        },
        {
            key: "removeReference",
            value: function removeReference(e, t, n) {
                return __PRIVATE_writeSentinelKey(e, n);
            }
        },
        {
            key: "removeTargets",
            value: function removeTargets(e, t, n) {
                return this.db.getTargetCache().removeTargets(e, t, n);
            }
        },
        {
            key: "markPotentiallyOrphaned",
            value: function markPotentiallyOrphaned(e, t) {
                return __PRIVATE_writeSentinelKey(e, t);
            }
        },
        {
            /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */ key: "Os",
            value: function Os(e, t) {
                return function __PRIVATE_mutationQueuesContainKey(e, t) {
                    var n = false;
                    return __PRIVATE_mutationQueuesStore(e).Jn(function(r) {
                        return __PRIVATE_mutationQueueContainsKey(e, r, t).next(function(e) {
                            return e && (n = true), PersistencePromise.resolve(!e);
                        });
                    }).next(function() {
                        return n;
                    });
                }(e, t);
            }
        },
        {
            key: "removeOrphanedDocuments",
            value: function removeOrphanedDocuments(e, t) {
                var _this = this;
                var n = this.db.getRemoteDocumentCache().newChangeBuffer(), r = [];
                var i = 0;
                return this.Fs(e, function(s, _) {
                    if (_ <= t) {
                        var _$t = _this.Os(e, s).next(function(t) {
                            if (!t) // Our size accounting requires us to read all documents before
                            // removing them.
                            return i++, n.getEntry(e, s).next(function() {
                                return n.removeEntry(s, SnapshotVersion.min()), __PRIVATE_documentTargetStore(e).delete(function __PRIVATE_sentinelKey$1(e) {
                                    return [
                                        0,
                                        __PRIVATE_encodeResourcePath(e.path)
                                    ];
                                }(s));
                            });
                        });
                        r.push(_$t);
                    }
                }).next(function() {
                    return PersistencePromise.waitFor(r);
                }).next(function() {
                    return n.apply(e);
                }).next(function() {
                    return i;
                });
            }
        },
        {
            key: "removeTarget",
            value: function removeTarget(e, t) {
                var n = t.withSequenceNumber(e.currentSequenceNumber);
                return this.db.getTargetCache().updateTargetData(e, n);
            }
        },
        {
            key: "updateLimboDocument",
            value: function updateLimboDocument(e, t) {
                return __PRIVATE_writeSentinelKey(e, t);
            }
        },
        {
            /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */ key: "Fs",
            value: function Fs(e, t) {
                var n = __PRIVATE_documentTargetStore(e);
                var r, i = __PRIVATE_ListenSequence.wn;
                return n.Hn({
                    index: In
                }, function(param, param1) {
                    var _param = (0, $6ZpBv._)(param, 2), _$e = _param[0], n = _param[1], s = param1.path, _ = param1.sequenceNumber;
                    0 === _$e ? // if nextToReport is valid, report it, this is a new key so the
                    // last one must not be a member of any targets.
                    (i !== __PRIVATE_ListenSequence.wn && t(new DocumentKey(__PRIVATE_decodeResourcePath(r)), i), // set nextToReport to be this sequence number. It's the next one we
                    // might report, if we don't find any targets for this document.
                    // Note that the sequence number must be defined when the targetId
                    // is 0.
                    i = _, r = s) : // set nextToReport to be invalid, we know we don't need to report
                    // this one since we found a target for it.
                    i = __PRIVATE_ListenSequence.wn;
                }).next(function() {
                    // Since we report sequence numbers after getting to the next key, we
                    // need to check if the last key we iterated over was an orphaned
                    // document and report it.
                    i !== __PRIVATE_ListenSequence.wn && t(new DocumentKey(__PRIVATE_decodeResourcePath(r)), i);
                });
            }
        },
        {
            key: "getCacheSize",
            value: function getCacheSize(e) {
                return this.db.getRemoteDocumentCache().getSize(e);
            }
        }
    ]);
    return __PRIVATE_IndexedDbLruDelegateImpl;
}();
function __PRIVATE_writeSentinelKey(e, t) {
    return __PRIVATE_documentTargetStore(e).put(function __PRIVATE_sentinelRow(e, t) {
        return {
            targetId: 0,
            path: __PRIVATE_encodeResourcePath(e.path),
            sequenceNumber: t
        };
    }(t, e.currentSequenceNumber));
}
// Copyright 2024 Google LLC* @license
// Copyright 2024 Google LLC
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//      http://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
function __PRIVATE_runPipeline(e, t) {
    var _e_listenOptions;
    var n = t;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e.stages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _$t = _step.value;
            n = evaluate({
                serializer: e.serializer,
                serverTimestampBehavior: (_e_listenOptions = e.listenOptions) === null || _e_listenOptions === void 0 ? void 0 : _e_listenOptions.serverTimestampBehavior
            }, _$t, n);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return n;
}
function __PRIVATE_pipelineMatches(e, t) {
    // TODO(pipeline): this is not true for aggregations, and we need to examine if there are other
    // stages that will not work this way.
    return __PRIVATE_runPipeline(e, [
        t
    ]).length > 0;
}
function __PRIVATE_queryOrPipelineMatches(e, t) {
    return __PRIVATE_isPipeline(e) ? __PRIVATE_pipelineMatches(e, t) : __PRIVATE_queryMatches(e, t);
}
function evaluate(e, t, n) {
    if (t instanceof X) return function __PRIVATE_evaluateCollection(e, t, n) {
        return n.filter(function(e) {
            return e.isFoundDocument() && "/".concat(e.key.getCollectionPath().canonicalString()) === t.hr;
        });
    }(0, t, n);
    if (t instanceof A) return function __PRIVATE_evaluateWhere(e, t, n) {
        return n.filter(function(n) {
            var r = __PRIVATE_valueOrUndefined(__PRIVATE_toEvaluable(t.condition).evaluate(e, n));
            return void 0 !== r && __PRIVATE_valueEquals$1(r, Je);
        });
    }(e, t, n);
    if (t instanceof Y) return function __PRIVATE_evaluateCollectionGroup(e, t, n) {
        // return those records in input whose collection id is stage.collectionId
        return n.filter(function(e) {
            return e.isFoundDocument() && e.key.getCollectionPath().lastSegment() === t.collectionId;
        });
    }(0, t, n);
    if (t instanceof Z) return function __PRIVATE_evaluateDatabase(e, t, n) {
        return n.filter(function(e) {
            return e.isFoundDocument();
        });
    }(0, 0, n);
    if (t instanceof sa) return function __PRIVATE_evaluateDocuments(e, t, n) {
        return n.filter(function(e) {
            return e.isFoundDocument() && t.Pr.has(e.key.path.toStringWithLeadingSlash());
        });
    }(0, t, n);
    if (t instanceof v) return function __PRIVATE_evaluateLimit(e, t, n) {
        return n.slice(0, t.limit);
    }(0, t, n);
    if (t instanceof L) return function __PRIVATE_evaluateSort(e, t, n) {
        var r = t.orderings.map(function(e) {
            return {
                Ms: __PRIVATE_toEvaluable(e.expr),
                direction: e.direction
            };
        });
        return (0, $jlUaU._)(n).sort(function(t, n) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                // Evaluate expressions in stage.orderings against left and right, and use them to compare
                // the documents
                for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = _step.value, i = _step_value.Ms, s = _step_value.direction;
                    var r1 = __PRIVATE_valueOrUndefined(i.evaluate(e, t)), _ = __PRIVATE_valueOrUndefined(i.evaluate(e, n)), o = __PRIVATE_valueCompare(r1 !== null && r1 !== void 0 ? r1 : He, _ !== null && _ !== void 0 ? _ : He);
                    if (0 !== o) // Return the comparison result if documents are not equal
                    return "ascending" === s ? o : -o;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return 0;
        });
    }(e, t, n);
    throw new Error("Unknown stage: ".concat(t._name));
}
function __PRIVATE_newPipelineComparator(e) {
    var t = function __PRIVATE_lastEffectiveSort(e) {
        // return the last sort stage, throws exception if it doesn't exist
        // TODO(pipeline): this implementation is wrong, there are stages that can invalidate
        // the orderings later. The proper way to manipulate the pipeline so that last Sort
        // always has effects.
        for(var t = e.stages.length - 1; t >= 0; t--){
            var n = e.stages[t];
            if (n instanceof L) return n.orderings;
        }
        throw new Error("Pipeline must contain at least one Sort stage");
    }(e);
    return function(n, r) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var i = _step.value;
                // TODO(pipeline): consider the possibility of memoizing the evaluation
                var t1 = __PRIVATE_valueOrUndefined(__PRIVATE_toEvaluable(i.expr).evaluate({
                    serializer: e.serializer
                }, n)), s = __PRIVATE_valueOrUndefined(__PRIVATE_toEvaluable(i.expr).evaluate({
                    serializer: e.serializer
                }, r)), _ = __PRIVATE_valueCompare(t1 || He, s || He);
                if (0 !== _) return "ascending" === i.direction ? _ : -_;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return 0;
    };
}
function __PRIVATE_getLastEffectiveLimit(e) {
    // TODO(pipeline): Consider other stages that might imply a limit,
    // e.g., FindNearestStage, once they are implemented.
    for(var t = e.stages.length - 1; t >= 0; t--){
        var n = e.stages[t];
        if (n instanceof v) return {
            limit: n.limit
        };
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */ var RemoteDocumentChangeBuffer = /*#__PURE__*/ function() {
    "use strict";
    function RemoteDocumentChangeBuffer() {
        (0, $4QweW._)(this, RemoteDocumentChangeBuffer);
        // A mapping of document key to the new cache entry that should be written.
        this.changes = new ObjectMap(function(e) {
            return e.toString();
        }, function(e, t) {
            return e.isEqual(t);
        }), this.changesApplied = false;
    }
    (0, $6hK4i._)(RemoteDocumentChangeBuffer, [
        {
            /**
     * Buffers a `RemoteDocumentCache.addEntry()` call.
     *
     * You can only modify documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ key: "addEntry",
            value: function addEntry(e) {
                this.assertNotApplied(), this.changes.set(e.key, e);
            }
        },
        {
            /**
     * Buffers a `RemoteDocumentCache.removeEntry()` call.
     *
     * You can only remove documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ key: "removeEntry",
            value: function removeEntry(e, t) {
                this.assertNotApplied(), this.changes.set(e, MutableDocument.newInvalidDocument(e).setReadTime(t));
            }
        },
        {
            /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document or an invalid document if we have nothing
     * cached.
     */ key: "getEntry",
            value: function getEntry(e, t) {
                this.assertNotApplied();
                var n = this.changes.get(t);
                return void 0 !== n ? PersistencePromise.resolve(n) : this.getFromCache(e, t);
            }
        },
        {
            /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys - The keys of the entries to look up.
     * @returns A map of cached documents, indexed by key. If an entry cannot be
     *     found, the corresponding key will be mapped to an invalid document.
     */ key: "getEntries",
            value: function getEntries(e, t) {
                return this.getAllFromCache(e, t);
            }
        },
        {
            /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */ key: "apply",
            value: function apply(e) {
                return this.assertNotApplied(), this.changesApplied = true, this.applyChanges(e);
            }
        },
        {
            /** Helper to assert this.changes is not null  */ key: "assertNotApplied",
            value: function assertNotApplied() {}
        }
    ]);
    return RemoteDocumentChangeBuffer;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newIndexedDbRemoteDocumentCache()`.
 */ var __PRIVATE_IndexedDbRemoteDocumentCacheImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexedDbRemoteDocumentCacheImpl(e) {
        (0, $4QweW._)(this, __PRIVATE_IndexedDbRemoteDocumentCacheImpl);
        this.serializer = e;
    }
    (0, $6hK4i._)(__PRIVATE_IndexedDbRemoteDocumentCacheImpl, [
        {
            key: "setIndexManager",
            value: function setIndexManager(e) {
                this.indexManager = e;
            }
        },
        {
            /**
     * Adds the supplied entries to the cache.
     *
     * All calls of `addEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ key: "addEntry",
            value: function addEntry(e, t, n) {
                return __PRIVATE_remoteDocumentsStore(e).put(n);
            }
        },
        {
            /**
     * Removes a document from the cache.
     *
     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ key: "removeEntry",
            value: function removeEntry(e, t, n) {
                return __PRIVATE_remoteDocumentsStore(e).delete(/**
 * Returns a key that can be used for document lookups via the primary key of
 * the DbRemoteDocument object store.
 */ function __PRIVATE_dbReadTimeKey(e, t) {
                    var _$n = e.path.toArray();
                    return [
                        /* prefix path */ _$n.slice(0, _$n.length - 2),
                        /* collection id */ _$n[_$n.length - 2],
                        __PRIVATE_toDbTimestampKey(t),
                        /* document id */ _$n[_$n.length - 1]
                    ];
                }(t, n));
            }
        },
        {
            /**
     * Updates the current cache size.
     *
     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
     * cache's metadata.
     */ key: "updateMetadata",
            value: function updateMetadata(e, t) {
                var _this = this;
                return this.getMetadata(e).next(function(n) {
                    return n.byteSize += t, _this.Ns(e, n);
                });
            }
        },
        {
            key: "getEntry",
            value: function getEntry(e, t) {
                var _this = this;
                var n = MutableDocument.newInvalidDocument(t);
                return __PRIVATE_remoteDocumentsStore(e).Hn({
                    index: rn,
                    range: IDBKeyRange.only(__PRIVATE_dbKey(t))
                }, function(e, r) {
                    n = _this.Ls(t, r);
                }).next(function() {
                    return n;
                });
            }
        },
        {
            /**
     * Looks up an entry in the cache.
     *
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document entry and its size.
     */ key: "Bs",
            value: function Bs(e, t) {
                var _this = this;
                var n = {
                    size: 0,
                    document: MutableDocument.newInvalidDocument(t)
                };
                return __PRIVATE_remoteDocumentsStore(e).Hn({
                    index: rn,
                    range: IDBKeyRange.only(__PRIVATE_dbKey(t))
                }, function(e, r) {
                    n = {
                        document: _this.Ls(t, r),
                        size: __PRIVATE_dbDocumentSize(r)
                    };
                }).next(function() {
                    return n;
                });
            }
        },
        {
            key: "getEntries",
            value: function getEntries(e, t) {
                var _this = this;
                var n = __PRIVATE_mutableDocumentMap();
                return this.Us(e, t, function(e, t) {
                    var r = _this.Ls(e, t);
                    n = n.insert(e, r);
                }).next(function() {
                    return n;
                });
            }
        },
        {
            key: "getAllEntries",
            value: function getAllEntries(e) {
                var _this = this;
                var t = __PRIVATE_mutableDocumentMap();
                return __PRIVATE_remoteDocumentsStore(e).Hn(function(e, n) {
                    var r = _this.Ls(DocumentKey.fromSegments(n.prefixPath.concat(n.collectionGroup, n.documentId)), n);
                    t = t.insert(r.key, r);
                }).next(function() {
                    return t;
                });
            }
        },
        {
            /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys - The set of keys entries to look up.
     * @returns A map of documents indexed by key and a map of sizes indexed by
     *     key (zero if the document does not exist).
     */ key: "ks",
            value: function ks(e, t) {
                var _this = this;
                var n = __PRIVATE_mutableDocumentMap(), r = new SortedMap(DocumentKey.comparator);
                return this.Us(e, t, function(e, t) {
                    var i = _this.Ls(e, t);
                    n = n.insert(e, i), r = r.insert(e, __PRIVATE_dbDocumentSize(t));
                }).next(function() {
                    return {
                        documents: n,
                        qs: r
                    };
                });
            }
        },
        {
            key: "Us",
            value: function Us(e, t, n) {
                if (t.isEmpty()) return PersistencePromise.resolve();
                var r = new SortedSet(__PRIVATE_dbKeyComparator);
                t.forEach(function(e) {
                    return r = r.add(e);
                });
                var i = IDBKeyRange.bound(__PRIVATE_dbKey(r.first()), __PRIVATE_dbKey(r.last())), s = r.getIterator();
                var _ = s.getNext();
                return __PRIVATE_remoteDocumentsStore(e).Hn({
                    index: rn,
                    range: i
                }, function(e, t, r) {
                    var i = DocumentKey.fromSegments((0, $jlUaU._)(t.prefixPath).concat([
                        t.collectionGroup,
                        t.documentId
                    ]));
                    // Go through keys not found in cache.
                    for(; _ && __PRIVATE_dbKeyComparator(_, i) < 0;)n(_, null), _ = s.getNext();
                    _ && _.isEqual(i) && // Key found in cache.
                    (n(_, t), _ = s.hasNext() ? s.getNext() : null), // Skip to the next key (if there is one).
                    _ ? r.Kn(__PRIVATE_dbKey(_)) : r.done();
                }).next(function() {
                    // The rest of the keys are not in the cache. One case where `iterate`
                    // above won't go through them is when the cache is empty.
                    for(; _;)n(_, null), _ = s.hasNext() ? s.getNext() : null;
                });
            }
        },
        {
            key: "getDocumentsMatchingQuery",
            value: function getDocumentsMatchingQuery(e, t, n, r, i) {
                var _this = this;
                var s = __PRIVATE_isPipeline(t) ? ResourcePath.fromString(getPipelineCollection(t)) : t.path, _ = [
                    s.popLast().toArray(),
                    s.lastSegment(),
                    __PRIVATE_toDbTimestampKey(n.readTime),
                    n.documentKey.path.isEmpty() ? "" : n.documentKey.path.lastSegment()
                ], o = [
                    s.popLast().toArray(),
                    s.lastSegment(),
                    [
                        Number.MAX_SAFE_INTEGER,
                        Number.MAX_SAFE_INTEGER
                    ],
                    ""
                ];
                return __PRIVATE_remoteDocumentsStore(e).Qn(IDBKeyRange.bound(_, o, true)).next(function(e) {
                    i === null || i === void 0 ? void 0 : i.incrementDocumentReadCount(e.length);
                    var _$n = __PRIVATE_mutableDocumentMap();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$i = _step.value;
                            var _$e = _this.Ls(DocumentKey.fromSegments(_$i.prefixPath.concat(_$i.collectionGroup, _$i.documentId)), _$i);
                            _$e.isFoundDocument() && (__PRIVATE_queryOrPipelineMatches(t, _$e) || r.has(_$e.key)) && // Either the document matches the given query, or it is mutated.
                            (_$n = _$n.insert(_$e.key, _$e));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return _$n;
                });
            }
        },
        {
            key: "getAllFromCollectionGroup",
            value: function getAllFromCollectionGroup(e, t, n, r) {
                var _this = this;
                var i = __PRIVATE_mutableDocumentMap();
                var s = __PRIVATE_dbCollectionGroupKey(t, n), _ = __PRIVATE_dbCollectionGroupKey(t, IndexOffset.max());
                return __PRIVATE_remoteDocumentsStore(e).Hn({
                    index: _n,
                    range: IDBKeyRange.bound(s, _, true)
                }, function(e, t, n) {
                    var s = _this.Ls(DocumentKey.fromSegments(t.prefixPath.concat(t.collectionGroup, t.documentId)), t);
                    i = i.insert(s.key, s), i.size === r && n.done();
                }).next(function() {
                    return i;
                });
            }
        },
        {
            key: "newChangeBuffer",
            value: function newChangeBuffer(e) {
                return new __PRIVATE_IndexedDbRemoteDocumentChangeBuffer(this, !!e && e.trackRemovals);
            }
        },
        {
            key: "getSize",
            value: function getSize(e) {
                return this.getMetadata(e).next(function(e) {
                    return e.byteSize;
                });
            }
        },
        {
            key: "getMetadata",
            value: function getMetadata(e) {
                return __PRIVATE_documentGlobalStore(e).get(un).next(function(e) {
                    return __PRIVATE_hardAssert(!!e, 20021), e;
                });
            }
        },
        {
            key: "Ns",
            value: function Ns(e, t) {
                return __PRIVATE_documentGlobalStore(e).put(un, t);
            }
        },
        {
            /**
     * Decodes `dbRemoteDoc` and returns the document (or an invalid document if
     * the document corresponds to the format used for sentinel deletes).
     */ key: "Ls",
            value: function Ls(e, t) {
                if (t) {
                    var _$e = __PRIVATE_fromDbRemoteDocument(this.serializer, t);
                    // Whether the document is a sentinel removal and should only be used in the
                    // `getNewDocumentChanges()`
                    if (!(_$e.isNoDocument() && _$e.version.isEqual(SnapshotVersion.min()))) return _$e;
                }
                return MutableDocument.newInvalidDocument(e);
            }
        }
    ]);
    return __PRIVATE_IndexedDbRemoteDocumentCacheImpl;
}();
/** Creates a new IndexedDbRemoteDocumentCache. */ function __PRIVATE_newIndexedDbRemoteDocumentCache(e) {
    return new __PRIVATE_IndexedDbRemoteDocumentCacheImpl(e);
}
/**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache.
 *
 * Unlike the MemoryRemoteDocumentChangeBuffer, the IndexedDb implementation computes the size
 * delta for all submitted changes. This avoids having to re-read all documents from IndexedDb
 * when we apply the changes.
 */ var __PRIVATE_IndexedDbRemoteDocumentChangeBuffer = /*#__PURE__*/ function(RemoteDocumentChangeBuffer) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_IndexedDbRemoteDocumentChangeBuffer, RemoteDocumentChangeBuffer);
    function __PRIVATE_IndexedDbRemoteDocumentChangeBuffer(e, t) {
        (0, $4QweW._)(this, __PRIVATE_IndexedDbRemoteDocumentChangeBuffer);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_IndexedDbRemoteDocumentChangeBuffer), _this.$s = e, _this.trackRemovals = t, // A map of document sizes and read times prior to applying the changes in
        // this buffer.
        _this.Ks = new ObjectMap(function(e) {
            return e.toString();
        }, function(e, t) {
            return e.isEqual(t);
        });
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_IndexedDbRemoteDocumentChangeBuffer, [
        {
            key: "applyChanges",
            value: function applyChanges(e) {
                var _this = this;
                var t = [];
                var n = 0, r = new SortedSet(function(e, t) {
                    return __PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString());
                });
                return this.changes.forEach(function(i, s) {
                    var _ = _this.Ks.get(i);
                    if (t.push(_this.$s.removeEntry(e, i, _.readTime)), s.isValidDocument()) {
                        var o = __PRIVATE_toDbRemoteDocument(_this.$s.serializer, s);
                        r = r.add(i.path.popLast());
                        var a = __PRIVATE_dbDocumentSize(o);
                        n += a - _.size, t.push(_this.$s.addEntry(e, i, o));
                    } else if (n -= _.size, _this.trackRemovals) {
                        // In order to track removals, we store a "sentinel delete" in the
                        // RemoteDocumentCache. This entry is represented by a NoDocument
                        // with a version of 0 and ignored by `maybeDecodeDocument()` but
                        // preserved in `getNewDocumentChanges()`.
                        var n1 = __PRIVATE_toDbRemoteDocument(_this.$s.serializer, s.convertToNoDocument(SnapshotVersion.min()));
                        t.push(_this.$s.addEntry(e, i, n1));
                    }
                }), r.forEach(function(n) {
                    t.push(_this.$s.indexManager.addToCollectionParentIndex(e, n));
                }), t.push(this.$s.updateMetadata(e, n)), PersistencePromise.waitFor(t);
            }
        },
        {
            key: "getFromCache",
            value: function getFromCache(e, t) {
                var _this = this;
                // Record the size of everything we load from the cache so we can compute a delta later.
                return this.$s.Bs(e, t).next(function(e) {
                    return _this.Ks.set(t, {
                        size: e.size,
                        readTime: e.document.readTime
                    }), e.document;
                });
            }
        },
        {
            key: "getAllFromCache",
            value: function getAllFromCache(e, t) {
                var _this = this;
                // Record the size of everything we load from the cache so we can compute
                // a delta later.
                return this.$s.ks(e, t).next(function(param) {
                    var _$e = param.documents, _$t = param.qs;
                    return(// Note: `getAllFromCache` returns two maps instead of a single map from
                    // keys to `DocumentSizeEntry`s. This is to allow returning the
                    // `MutableDocumentMap` directly, without a conversion.
                    _$t.forEach(function(t, n) {
                        _this.Ks.set(t, {
                            size: n,
                            readTime: _$e.get(t).readTime
                        });
                    }), _$e);
                });
            }
        }
    ]);
    return __PRIVATE_IndexedDbRemoteDocumentChangeBuffer;
}(RemoteDocumentChangeBuffer);
function __PRIVATE_documentGlobalStore(e) {
    return __PRIVATE_getStore(e, an);
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */ function __PRIVATE_remoteDocumentsStore(e) {
    return __PRIVATE_getStore(e, tn);
}
/**
 * Returns a key that can be used for document lookups on the
 * `DbRemoteDocumentDocumentKeyIndex` index.
 */ function __PRIVATE_dbKey(e) {
    var t = e.path.toArray();
    return [
        /* prefix path */ t.slice(0, t.length - 2),
        /* collection id */ t[t.length - 2],
        /* document id */ t[t.length - 1]
    ];
}
function __PRIVATE_dbCollectionGroupKey(e, t) {
    var n = t.documentKey.path.toArray();
    return [
        /* collection id */ e,
        __PRIVATE_toDbTimestampKey(t.readTime),
        /* prefix path */ n.slice(0, n.length - 2),
        /* document id */ n.length > 0 ? n[n.length - 1] : ""
    ];
}
/**
 * Comparator that compares document keys according to the primary key sorting
 * used by the `DbRemoteDocumentDocument` store (by prefix path, collection id
 * and then document ID).
 *
 * Visible for testing.
 */ function __PRIVATE_dbKeyComparator(e, t) {
    var n = e.path.toArray(), r = t.path.toArray();
    // The ordering is based on https://chromium.googlesource.com/chromium/blink/+/fe5c21fef94dae71c1c3344775b8d8a7f7e6d9ec/Source/modules/indexeddb/IDBKey.cpp#74
    var i = 0;
    for(var _$e = 0; _$e < n.length - 2 && _$e < r.length - 2; ++_$e)if (i = __PRIVATE_primitiveComparator(n[_$e], r[_$e]), i) return i;
    return i = __PRIVATE_primitiveComparator(n.length, r.length), i || (i = __PRIVATE_primitiveComparator(n[n.length - 2], r[r.length - 2]), i || __PRIVATE_primitiveComparator(n[n.length - 1], r[r.length - 1]));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Schema Version for the Web client:
 * 1.  Initial version including Mutation Queue, Query Cache, and Remote
 *     Document Cache
 * 2.  Used to ensure a targetGlobal object exists and add targetCount to it. No
 *     longer required because migration 3 unconditionally clears it.
 * 3.  Dropped and re-created Query Cache to deal with cache corruption related
 *     to limbo resolution. Addresses
 *     https://github.com/firebase/firebase-ios-sdk/issues/1548
 * 4.  Multi-Tab Support.
 * 5.  Removal of held write acks.
 * 6.  Create document global for tracking document cache size.
 * 7.  Ensure every cached document has a sentinel row with a sequence number.
 * 8.  Add collection-parent index for Collection Group queries.
 * 9.  Change RemoteDocumentChanges store to be keyed by readTime rather than
 *     an auto-incrementing ID. This is required for Index-Free queries.
 * 10. Rewrite the canonical IDs to the explicit Protobuf-based format.
 * 11. Add bundles and named_queries for bundle support.
 * 12. Add document overlays.
 * 13. Rewrite the keys of the remote document cache to allow for efficient
 *     document lookup via `getAll()`.
 * 14. Add overlays.
 * 15. Add indexing support.
 * 16. Parse timestamp strings before creating index entries.
 * 17. TODO(tomandersen)
 * 18. Encode key safe representations of IndexEntry in DbIndexEntryStore.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a local view (overlay) of a document, and the fields that are
 * locally mutated.
 */ var OverlayedDocument = function OverlayedDocument(e, /**
     * The fields that are locally mutated by patch mutations.
     *
     * If the overlayed	document is from set or delete mutations, this is `null`.
     * If there is no overlay (mutation) for the document, this is an empty `FieldMask`.
     */ t) {
    "use strict";
    (0, $4QweW._)(this, OverlayedDocument);
    this.overlayedDocument = e, this.mutatedFields = t;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */ var LocalDocumentsView = /*#__PURE__*/ function() {
    "use strict";
    function LocalDocumentsView(e, t, n, r) {
        (0, $4QweW._)(this, LocalDocumentsView);
        this.remoteDocumentCache = e, this.mutationQueue = t, this.documentOverlayCache = n, this.indexManager = r;
    }
    (0, $6hK4i._)(LocalDocumentsView, [
        {
            /**
     * Get the local view of the document identified by `key`.
     *
     * @returns Local view of the document or null if we don't have any cached
     * state for it.
     */ key: "getDocument",
            value: function getDocument(e, t) {
                var _this = this;
                var n = null;
                return this.documentOverlayCache.getOverlay(e, t).next(function(r) {
                    return n = r, _this.remoteDocumentCache.getEntry(e, t);
                }).next(function(e) {
                    return null !== n && __PRIVATE_mutationApplyToLocalView(n.mutation, e, FieldMask.empty(), Timestamp.now()), e;
                });
            }
        },
        {
            /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */ key: "getDocuments",
            value: function getDocuments(e, t) {
                var _this = this;
                return this.remoteDocumentCache.getEntries(e, t).next(function(t) {
                    return _this.getLocalViewOfDocuments(e, t, __PRIVATE_documentKeySet()).next(function() {
                        return t;
                    });
                });
            }
        },
        {
            /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     *
     * @param transaction - The transaction this operation is scoped to.
     * @param docs - The documents to apply local mutations to get the local views.
     * @param existenceStateChanged - The set of document keys whose existence state
     *   is changed. This is useful to determine if some documents overlay needs
     *   to be recalculated.
     */ key: "getLocalViewOfDocuments",
            value: function getLocalViewOfDocuments(e, t) {
                var _this = this;
                var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : __PRIVATE_documentKeySet();
                var r = __PRIVATE_newOverlayMap();
                return this.populateOverlays(e, r, t).next(function() {
                    return _this.computeViews(e, t, r, n).next(function(e) {
                        var _$t = documentMap();
                        return e.forEach(function(e, n) {
                            _$t = _$t.insert(e, n.overlayedDocument);
                        }), _$t;
                    });
                });
            }
        },
        {
            /**
     * Gets the overlayed documents for the given document map, which will include
     * the local view of those documents and a `FieldMask` indicating which fields
     * are mutated locally, `null` if overlay is a Set or Delete mutation.
     */ key: "getOverlayedDocuments",
            value: function getOverlayedDocuments(e, t) {
                var _this = this;
                var n = __PRIVATE_newOverlayMap();
                return this.populateOverlays(e, n, t).next(function() {
                    return _this.computeViews(e, t, n, __PRIVATE_documentKeySet());
                });
            }
        },
        {
            /**
     * Fetches the overlays for {@code docs} and adds them to provided overlay map
     * if the map does not already contain an entry for the given document key.
     */ key: "populateOverlays",
            value: function populateOverlays(e, t, n) {
                var r = [];
                return n.forEach(function(e) {
                    t.has(e) || r.push(e);
                }), this.documentOverlayCache.getOverlays(e, r).next(function(e) {
                    e.forEach(function(e, n) {
                        t.set(e, n);
                    });
                });
            }
        },
        {
            /**
     * Computes the local view for the given documents.
     *
     * @param docs - The documents to compute views for. It also has the base
     *   version of the documents.
     * @param overlays - The overlays that need to be applied to the given base
     *   version of the documents.
     * @param existenceStateChanged - A set of documents whose existence states
     *   might have changed. This is used to determine if we need to re-calculate
     *   overlays from mutation queues.
     * @returns A map represents the local documents view.
     */ key: "computeViews",
            value: function computeViews(e, t, n, r) {
                var i = __PRIVATE_mutableDocumentMap();
                var s = __PRIVATE_newDocumentKeyMap(), _ = function __PRIVATE_newOverlayedDocumentMap() {
                    return __PRIVATE_newDocumentKeyMap();
                }();
                return t.forEach(function(e, t) {
                    var _ = n.get(t.key);
                    // Recalculate an overlay if the document's existence state changed due to
                    // a remote event *and* the overlay is a PatchMutation. This is because
                    // document existence state can change if some patch mutation's
                    // preconditions are met.
                    // NOTE: we recalculate when `overlay` is undefined as well, because there
                    // might be a patch mutation whose precondition does not match before the
                    // change (hence overlay is undefined), but would now match.
                    r.has(t.key) && (void 0 === _ || _.mutation instanceof __PRIVATE_PatchMutation) ? i = i.insert(t.key, t) : void 0 !== _ ? (s.set(t.key, _.mutation.getFieldMask()), __PRIVATE_mutationApplyToLocalView(_.mutation, t, _.mutation.getFieldMask(), Timestamp.now())) : // no overlay exists
                    // Using EMPTY to indicate there is no overlay for the document.
                    s.set(t.key, FieldMask.empty());
                }), this.recalculateAndSaveOverlays(e, i).next(function(e) {
                    return e.forEach(function(e, t) {
                        return s.set(e, t);
                    }), t.forEach(function(e, t) {
                        var _s_get;
                        return _.set(e, new OverlayedDocument(t, (_s_get = s.get(e)) !== null && _s_get !== void 0 ? _s_get : null));
                    }), _;
                });
            }
        },
        {
            key: "recalculateAndSaveOverlays",
            value: function recalculateAndSaveOverlays(e, t) {
                var _this = this;
                var n = __PRIVATE_newDocumentKeyMap();
                // A reverse lookup map from batch id to the documents within that batch.
                var r = new SortedMap(function(e, t) {
                    return e - t;
                }), i = __PRIVATE_documentKeySet();
                return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(e, t).next(function(e) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        var _loop = function() {
                            var i = _step.value;
                            i.keys().forEach(function(e) {
                                var s = t.get(e);
                                if (null === s) return;
                                var _ = n.get(e) || FieldMask.empty();
                                _ = i.applyToLocalView(s, _), n.set(e, _);
                                var o = (r.get(i.batchId) || __PRIVATE_documentKeySet()).add(e);
                                r = r.insert(i.batchId, o);
                            });
                        };
                        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }).next(function() {
                    var _loop = function() {
                        var r = _.getNext(), o = r.key, a = r.value, u = __PRIVATE_newMutationMap();
                        a.forEach(function(e) {
                            if (!i.has(e)) {
                                var r = __PRIVATE_calculateOverlayMutation(t.get(e), n.get(e));
                                null !== r && u.set(e, r), i = i.add(e);
                            }
                        }), s.push(_this.documentOverlayCache.saveOverlays(e, o, u));
                    };
                    var s = [], _ = r.getReverseIterator();
                    // Iterate in descending order of batch IDs, and skip documents that are
                    // already saved.
                    for(; _.hasNext();)_loop();
                    return PersistencePromise.waitFor(s);
                }).next(function() {
                    return n;
                });
            }
        },
        {
            /**
     * Recalculates overlays by reading the documents from remote document cache
     * first, and saves them after they are calculated.
     */ key: "recalculateAndSaveOverlaysForDocumentKeys",
            value: function recalculateAndSaveOverlaysForDocumentKeys(e, t) {
                var _this = this;
                return this.remoteDocumentCache.getEntries(e, t).next(function(t) {
                    return _this.recalculateAndSaveOverlays(e, t);
                });
            }
        },
        {
            /**
     * Performs a query against the local view of all documents.
     *
     * @param transaction - The persistence transaction.
     * @param query - The query to match documents against.
     * @param offset - Read time and key to start scanning by (exclusive).
     * @param context - A optional tracker to keep a record of important details
     *   during database local query execution.
     */ key: "getDocumentsMatchingQuery",
            value: function getDocumentsMatchingQuery(e, t, n, r) {
                return __PRIVATE_isPipeline(t) ? this.getDocumentsMatchingPipeline(e, t, n, r) : __PRIVATE_isDocumentQuery$1(t) ? this.getDocumentsMatchingDocumentQuery(e, t.path) : __PRIVATE_isCollectionGroupQuery(t) ? this.getDocumentsMatchingCollectionGroupQuery(e, t, n, r) : this.getDocumentsMatchingCollectionQuery(e, t, n, r);
            }
        },
        {
            /**
     * Given a collection group, returns the next documents that follow the provided offset, along
     * with an updated batch ID.
     *
     * <p>The documents returned by this method are ordered by remote version from the provided
     * offset. If there are no more remote documents after the provided offset, documents with
     * mutations in order of batch id from the offset are returned. Since all documents in a batch are
     * returned together, the total number of documents returned can exceed {@code count}.
     *
     * @param transaction
     * @param collectionGroup - The collection group for the documents.
     * @param offset - The offset to index into.
     * @param count - The number of documents to return
     * @returns A LocalWriteResult with the documents that follow the provided offset and the last processed batch id.
     */ key: "getNextDocuments",
            value: function getNextDocuments(e, t, n, r) {
                var _this = this;
                return this.remoteDocumentCache.getAllFromCollectionGroup(e, t, n, r).next(function(i) {
                    var s = r - i.size > 0 ? _this.documentOverlayCache.getOverlaysForCollectionGroup(e, t, n.largestBatchId, r - i.size) : PersistencePromise.resolve(__PRIVATE_newOverlayMap());
                    // The callsite will use the largest batch ID together with the latest read time to create
                    // a new index offset. Since we only process batch IDs if all remote documents have been read,
                    // no overlay will increase the overall read time. This is why we only need to special case
                    // the batch id.
                    var _ = Xe, o = i;
                    return s.next(function(t) {
                        return PersistencePromise.forEach(t, function(t, n) {
                            return _ < n.largestBatchId && (_ = n.largestBatchId), i.get(t) ? PersistencePromise.resolve() : _this.remoteDocumentCache.getEntry(e, t).next(function(e) {
                                o = o.insert(t, e);
                            });
                        }).next(function() {
                            return _this.populateOverlays(e, t, i);
                        }).next(function() {
                            return _this.computeViews(e, o, t, __PRIVATE_documentKeySet());
                        }).next(function(e) {
                            return {
                                batchId: _,
                                changes: __PRIVATE_convertOverlayedDocumentMapToDocumentMap(e)
                            };
                        });
                    });
                });
            }
        },
        {
            key: "getDocumentsMatchingDocumentQuery",
            value: function getDocumentsMatchingDocumentQuery(e, t) {
                // Just do a simple document lookup.
                return this.getDocument(e, new DocumentKey(t)).next(function(e) {
                    var _$t = documentMap();
                    return e.isFoundDocument() && (_$t = _$t.insert(e.key, e)), _$t;
                });
            }
        },
        {
            key: "getDocumentsMatchingCollectionGroupQuery",
            value: function getDocumentsMatchingCollectionGroupQuery(e, t, n, r) {
                var _this = this;
                var i = t.collectionGroup;
                var s = documentMap();
                return this.indexManager.getCollectionParents(e, i).next(function(_) {
                    return PersistencePromise.forEach(_, function(_) {
                        var o = function __PRIVATE_asCollectionQueryAtPath(e, t) {
                            return new __PRIVATE_QueryImpl(t, /*collectionGroup=*/ null, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
                        }(t, _.child(i));
                        return _this.getDocumentsMatchingCollectionQuery(e, o, n, r).next(function(e) {
                            e.forEach(function(e, t) {
                                s = s.insert(e, t);
                            });
                        });
                    }).next(function() {
                        return s;
                    });
                });
            }
        },
        {
            key: "getDocumentsMatchingCollectionQuery",
            value: function getDocumentsMatchingCollectionQuery(e, t, n, r) {
                var _this = this;
                // Query the remote documents and overlay mutations.
                var i;
                return this.documentOverlayCache.getOverlaysForCollection(e, t.path, n.largestBatchId).next(function(s) {
                    return i = s, _this.remoteDocumentCache.getDocumentsMatchingQuery(e, t, n, i, r);
                }).next(function(e) {
                    return _this.retrieveMatchingLocalDocuments(i, e, function(e) {
                        return __PRIVATE_queryMatches(t, e);
                    });
                });
            }
        },
        {
            key: "getDocumentsMatchingPipeline",
            value: function getDocumentsMatchingPipeline(t, n, r, i) {
                var _this = this;
                if ("collection_group" === getPipelineSourceType(n)) {
                    var e1 = getPipelineCollectionGroup(n);
                    var s = documentMap();
                    return this.indexManager.getCollectionParents(t, e1).next(function(_) {
                        return PersistencePromise.forEach(_, function(_) {
                            var o = function __PRIVATE_asCollectionPipelineAtPath(e, t) {
                                var _$n = e.stages.map(function(e) {
                                    return e instanceof Y ? new X(t.canonicalString(), {}) : e;
                                });
                                return new CorePipeline(e.serializer, _$n);
                            }(n, _.child(e1));
                            return _this.getDocumentsMatchingPipeline(t, o, r, i).next(function(e) {
                                e.forEach(function(e, t) {
                                    s = s.insert(e, t);
                                });
                            });
                        }).next(function() {
                            return s;
                        });
                    });
                }
                {
                    // Query the remote documents and overlay mutations.
                    var s1;
                    return this.getOverlaysForPipeline(t, n, r.largestBatchId).next(function(_) {
                        switch(s1 = _, getPipelineSourceType(n)){
                            case "collection":
                                return _this.remoteDocumentCache.getDocumentsMatchingQuery(t, n, r, s1, i);
                            case "documents":
                                var _$_ = __PRIVATE_documentKeySet();
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = getPipelineDocuments(n)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var e1 = _step.value;
                                        _$_ = _$_.add(DocumentKey.fromPath(e1));
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return _this.remoteDocumentCache.getEntries(t, _$_);
                            case "database":
                                return _this.remoteDocumentCache.getAllEntries(t);
                            default:
                                throw new e("invalid-argument", "Invalid pipeline source to execute offline: ".concat(__PRIVATE_canonifyPipeline(n)));
                        }
                    }).next(function(e) {
                        return _this.retrieveMatchingLocalDocuments(s1, e, function(e) {
                            return __PRIVATE_pipelineMatches(n, e);
                        });
                    });
                }
            }
        },
        {
            key: "retrieveMatchingLocalDocuments",
            value: function retrieveMatchingLocalDocuments(e, t, n) {
                // As documents might match the query because of their overlay we need to
                // include documents for all overlays in the initial document set.
                e.forEach(function(e, n) {
                    var r = n.getKey();
                    null === t.get(r) && (t = t.insert(r, MutableDocument.newInvalidDocument(r)));
                });
                // Apply the overlays and match against the query.
                var r = documentMap();
                return t.forEach(function(t, i) {
                    var s = e.get(t);
                    void 0 !== s && __PRIVATE_mutationApplyToLocalView(s.mutation, i, FieldMask.empty(), Timestamp.now()), // Finally, insert the documents that still match the query
                    n(i) && (r = r.insert(t, i));
                }), r;
            }
        },
        {
            key: "getOverlaysForPipeline",
            value: function getOverlaysForPipeline(t, n, r) {
                switch(getPipelineSourceType(n)){
                    case "collection":
                        return this.documentOverlayCache.getOverlaysForCollection(t, ResourcePath.fromString(getPipelineCollection(n)), r);
                    case "collection_group":
                        throw new e("invalid-argument", "Unexpected collection group pipeline: ".concat(__PRIVATE_canonifyPipeline(n)));
                    case "documents":
                        return this.documentOverlayCache.getOverlays(t, getPipelineDocuments(n).map(function(e) {
                            return DocumentKey.fromPath(e);
                        }));
                    case "database":
                        return this.documentOverlayCache.getAllOverlays(t, r);
                    default:
                        throw new e("invalid-argument", "Failed to get overlays for pipeline: ".concat(__PRIVATE_canonifyPipeline(n)));
                }
            }
        }
    ]);
    return LocalDocumentsView;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var __PRIVATE_MemoryBundleCache = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryBundleCache(e) {
        (0, $4QweW._)(this, __PRIVATE_MemoryBundleCache);
        this.serializer = e, this.Qs = new Map, this.Ws = new Map;
    }
    (0, $6hK4i._)(__PRIVATE_MemoryBundleCache, [
        {
            key: "getBundleMetadata",
            value: function getBundleMetadata(e, t) {
                return PersistencePromise.resolve(this.Qs.get(t));
            }
        },
        {
            key: "saveBundleMetadata",
            value: function saveBundleMetadata(e, t) {
                return this.Qs.set(t.id, /** Decodes a BundleMetadata proto into a BundleMetadata object. */ function __PRIVATE_fromBundleMetadata(e) {
                    return {
                        id: e.id,
                        version: e.version,
                        createTime: __PRIVATE_fromVersion(e.createTime)
                    };
                }(t)), PersistencePromise.resolve();
            }
        },
        {
            key: "getNamedQuery",
            value: function getNamedQuery(e, t) {
                return PersistencePromise.resolve(this.Ws.get(t));
            }
        },
        {
            key: "saveNamedQuery",
            value: function saveNamedQuery(e, t) {
                return this.Ws.set(t.name, function __PRIVATE_fromProtoNamedQuery(e) {
                    return {
                        name: e.name,
                        query: __PRIVATE_fromBundledQuery(e.bundledQuery),
                        readTime: __PRIVATE_fromVersion(e.readTime)
                    };
                }(t)), PersistencePromise.resolve();
            }
        }
    ]);
    return __PRIVATE_MemoryBundleCache;
}();
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of DocumentOverlayCache.
 */ var __PRIVATE_MemoryDocumentOverlayCache = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryDocumentOverlayCache() {
        (0, $4QweW._)(this, __PRIVATE_MemoryDocumentOverlayCache);
        // A map sorted by DocumentKey, whose value is a pair of the largest batch id
        // for the overlay and the overlay itself.
        this.overlays = new SortedMap(DocumentKey.comparator), this.Gs = new Map;
    }
    (0, $6hK4i._)(__PRIVATE_MemoryDocumentOverlayCache, [
        {
            key: "getOverlay",
            value: function getOverlay(e, t) {
                return PersistencePromise.resolve(this.overlays.get(t));
            }
        },
        {
            key: "getOverlays",
            value: function getOverlays(e, t) {
                var _this = this;
                var n = __PRIVATE_newOverlayMap();
                return PersistencePromise.forEach(t, function(t) {
                    return _this.getOverlay(e, t).next(function(e) {
                        null !== e && n.set(t, e);
                    });
                }).next(function() {
                    return n;
                });
            }
        },
        {
            key: "getAllOverlays",
            value: function getAllOverlays(e, t) {
                var n = __PRIVATE_newOverlayMap();
                return this.overlays.forEach(function(e, r) {
                    r.largestBatchId > t && n.set(e, r);
                }), PersistencePromise.resolve(n);
            }
        },
        {
            key: "saveOverlays",
            value: function saveOverlays(e, t, n) {
                var _this = this;
                return n.forEach(function(n, r) {
                    _this.Zr(e, t, r);
                }), PersistencePromise.resolve();
            }
        },
        {
            key: "removeOverlaysForBatchId",
            value: function removeOverlaysForBatchId(e, t, n) {
                var _this = this;
                var r = this.Gs.get(n);
                return void 0 !== r && (r.forEach(function(e) {
                    return _this.overlays = _this.overlays.remove(e);
                }), this.Gs.delete(n)), PersistencePromise.resolve();
            }
        },
        {
            key: "getOverlaysForCollection",
            value: function getOverlaysForCollection(e, t, n) {
                var r = __PRIVATE_newOverlayMap(), i = t.length + 1, s = new DocumentKey(t.child("")), _ = this.overlays.getIteratorFrom(s);
                for(; _.hasNext();){
                    var e1 = _.getNext().value, s1 = e1.getKey();
                    if (!t.isPrefixOf(s1.path)) break;
                    // Documents from sub-collections
                    s1.path.length === i && e1.largestBatchId > n && r.set(e1.getKey(), e1);
                }
                return PersistencePromise.resolve(r);
            }
        },
        {
            key: "getOverlaysForCollectionGroup",
            value: function getOverlaysForCollectionGroup(e, t, n, r) {
                var i = new SortedMap(function(e, t) {
                    return e - t;
                });
                var s = this.overlays.getIterator();
                for(; s.hasNext();){
                    var e1 = s.getNext().value;
                    if (e1.getKey().getCollectionGroup() === t && e1.largestBatchId > n) {
                        var _$t = i.get(e1.largestBatchId);
                        null === _$t && (_$t = __PRIVATE_newOverlayMap(), i = i.insert(e1.largestBatchId, _$t)), _$t.set(e1.getKey(), e1);
                    }
                }
                var _ = __PRIVATE_newOverlayMap(), o = i.getIterator();
                for(; o.hasNext();){
                    if (o.getNext().value.forEach(function(e, t) {
                        return _.set(e, t);
                    }), _.size() >= r) break;
                }
                return PersistencePromise.resolve(_);
            }
        },
        {
            key: "Zr",
            value: function Zr(e, t, n) {
                // Remove the association of the overlay to its batch id.
                var r = this.overlays.get(n.key);
                if (null !== r) {
                    var e1 = this.Gs.get(r.largestBatchId).delete(n.key);
                    this.Gs.set(r.largestBatchId, e1);
                }
                this.overlays = this.overlays.insert(n.key, new Overlay(t, n));
                // Create the association of this overlay to the given largestBatchId.
                var i = this.Gs.get(t);
                void 0 === i && (i = __PRIVATE_documentKeySet(), this.Gs.set(t, i)), this.Gs.set(t, i.add(n.key));
            }
        }
    ]);
    return __PRIVATE_MemoryDocumentOverlayCache;
}();
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var __PRIVATE_MemoryGlobalsCache = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryGlobalsCache() {
        (0, $4QweW._)(this, __PRIVATE_MemoryGlobalsCache);
        this.sessionToken = ByteString.EMPTY_BYTE_STRING;
    }
    (0, $6hK4i._)(__PRIVATE_MemoryGlobalsCache, [
        {
            key: "getSessionToken",
            value: function getSessionToken(e) {
                return PersistencePromise.resolve(this.sessionToken);
            }
        },
        {
            key: "setSessionToken",
            value: function setSessionToken(e, t) {
                return this.sessionToken = t, PersistencePromise.resolve();
            }
        }
    ]);
    return __PRIVATE_MemoryGlobalsCache;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */ var __PRIVATE_ReferenceSet = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_ReferenceSet() {
        (0, $4QweW._)(this, __PRIVATE_ReferenceSet);
        // A set of outstanding references to a document sorted by key.
        this.zs = new SortedSet(__PRIVATE_DocReference.js), // A set of outstanding references to a document sorted by target id.
        this.Hs = new SortedSet(__PRIVATE_DocReference.Js);
    }
    (0, $6hK4i._)(__PRIVATE_ReferenceSet, [
        {
            /** Returns true if the reference set contains no references. */ key: "isEmpty",
            value: function isEmpty() {
                return this.zs.isEmpty();
            }
        },
        {
            /** Adds a reference to the given document key for the given ID. */ key: "addReference",
            value: function addReference(e, t) {
                var n = new __PRIVATE_DocReference(e, t);
                this.zs = this.zs.add(n), this.Hs = this.Hs.add(n);
            }
        },
        {
            /** Add references to the given document keys for the given ID. */ key: "Ys",
            value: function Ys(e, t) {
                var _this = this;
                e.forEach(function(e) {
                    return _this.addReference(e, t);
                });
            }
        },
        {
            /**
     * Removes a reference to the given document key for the given
     * ID.
     */ key: "removeReference",
            value: function removeReference(e, t) {
                this.Zs(new __PRIVATE_DocReference(e, t));
            }
        },
        {
            key: "Xs",
            value: function Xs(e, t) {
                var _this = this;
                e.forEach(function(e) {
                    return _this.removeReference(e, t);
                });
            }
        },
        {
            /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */ key: "e_",
            value: function e_(e) {
                var _this = this;
                var t = new DocumentKey(new ResourcePath([])), n = new __PRIVATE_DocReference(t, e), r = new __PRIVATE_DocReference(t, e + 1), i = [];
                return this.Hs.forEachInRange([
                    n,
                    r
                ], function(e) {
                    _this.Zs(e), i.push(e.key);
                }), i;
            }
        },
        {
            key: "t_",
            value: function t_() {
                var _this = this;
                this.zs.forEach(function(e) {
                    return _this.Zs(e);
                });
            }
        },
        {
            key: "Zs",
            value: function Zs(e) {
                this.zs = this.zs.delete(e), this.Hs = this.Hs.delete(e);
            }
        },
        {
            key: "n_",
            value: function n_(e) {
                var t = new DocumentKey(new ResourcePath([])), n = new __PRIVATE_DocReference(t, e), r = new __PRIVATE_DocReference(t, e + 1);
                var i = __PRIVATE_documentKeySet();
                return this.Hs.forEachInRange([
                    n,
                    r
                ], function(e) {
                    i = i.add(e.key);
                }), i;
            }
        },
        {
            key: "containsKey",
            value: function containsKey(e) {
                var t = new __PRIVATE_DocReference(e, 0), n = this.zs.firstAfterOrEqual(t);
                return null !== n && e.isEqual(n.key);
            }
        }
    ]);
    return __PRIVATE_ReferenceSet;
}();
var __PRIVATE_DocReference = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_DocReference(e, t) {
        (0, $4QweW._)(this, __PRIVATE_DocReference);
        this.key = e, this.r_ = t;
    }
    (0, $6hK4i._)(__PRIVATE_DocReference, null, [
        {
            key: "js",
            value: /** Compare by key then by ID */ function js(e, t) {
                return DocumentKey.comparator(e.key, t.key) || __PRIVATE_primitiveComparator(e.r_, t.r_);
            }
        },
        {
            key: "Js",
            value: /** Compare by ID then by key */ function Js(e, t) {
                return __PRIVATE_primitiveComparator(e.r_, t.r_) || DocumentKey.comparator(e.key, t.key);
            }
        }
    ]);
    return __PRIVATE_DocReference;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var __PRIVATE_MemoryMutationQueue = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryMutationQueue(e, t) {
        (0, $4QweW._)(this, __PRIVATE_MemoryMutationQueue);
        this.indexManager = e, this.referenceDelegate = t, /**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */ this.mutationQueue = [], /** Next value to use when assigning sequential IDs to each mutation batch. */ this.Gr = 1, /** An ordered mapping between documents and the mutations batch IDs. */ this.i_ = new SortedSet(__PRIVATE_DocReference.js);
    }
    (0, $6hK4i._)(__PRIVATE_MemoryMutationQueue, [
        {
            key: "checkEmpty",
            value: function checkEmpty(e) {
                return PersistencePromise.resolve(0 === this.mutationQueue.length);
            }
        },
        {
            key: "addMutationBatch",
            value: function addMutationBatch(e, t, n, r) {
                var i = this.Gr;
                this.Gr++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
                var s = new MutationBatch(i, t, n, r);
                this.mutationQueue.push(s);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Track references by document key and index collection parents.
                    for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$t = _step.value;
                        this.i_ = this.i_.add(new __PRIVATE_DocReference(_$t.key, i)), this.indexManager.addToCollectionParentIndex(e, _$t.key.path.popLast());
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return PersistencePromise.resolve(s);
            }
        },
        {
            key: "lookupMutationBatch",
            value: function lookupMutationBatch(e, t) {
                return PersistencePromise.resolve(this.s_(t));
            }
        },
        {
            key: "getNextMutationBatchAfterBatchId",
            value: function getNextMutationBatchAfterBatchId(e, t) {
                var n = t + 1, r = this.__(n), i = r < 0 ? 0 : r;
                // The requested batchId may still be out of range so normalize it to the
                // start of the queue.
                return PersistencePromise.resolve(this.mutationQueue.length > i ? this.mutationQueue[i] : null);
            }
        },
        {
            key: "getHighestUnacknowledgedBatchId",
            value: function getHighestUnacknowledgedBatchId() {
                return PersistencePromise.resolve(0 === this.mutationQueue.length ? Ke : this.Gr - 1);
            }
        },
        {
            key: "getAllMutationBatches",
            value: function getAllMutationBatches(e) {
                return PersistencePromise.resolve(this.mutationQueue.slice());
            }
        },
        {
            key: "getAllMutationBatchesAffectingDocumentKey",
            value: function getAllMutationBatchesAffectingDocumentKey(e, t) {
                var _this = this;
                var n = new __PRIVATE_DocReference(t, 0), r = new __PRIVATE_DocReference(t, Number.POSITIVE_INFINITY), i = [];
                return this.i_.forEachInRange([
                    n,
                    r
                ], function(e) {
                    var _$t = _this.s_(e.r_);
                    i.push(_$t);
                }), PersistencePromise.resolve(i);
            }
        },
        {
            key: "getAllMutationBatchesAffectingDocumentKeys",
            value: function getAllMutationBatchesAffectingDocumentKeys(e, t) {
                var _this = this;
                var n = new SortedSet(__PRIVATE_primitiveComparator);
                return t.forEach(function(e) {
                    var _$t = new __PRIVATE_DocReference(e, 0), r = new __PRIVATE_DocReference(e, Number.POSITIVE_INFINITY);
                    _this.i_.forEachInRange([
                        _$t,
                        r
                    ], function(e) {
                        n = n.add(e.r_);
                    });
                }), PersistencePromise.resolve(this.o_(n));
            }
        },
        {
            key: "getAllMutationBatchesAffectingQuery",
            value: function getAllMutationBatchesAffectingQuery(e, t) {
                // Use the query path as a prefix for testing if a document matches the
                // query.
                var n = t.path, r = n.length + 1;
                // Construct a document reference for actually scanning the index. Unlike
                // the prefix the document key in this reference must have an even number of
                // segments. The empty segment can be used a suffix of the query path
                // because it precedes all other segments in an ordered traversal.
                var i = n;
                DocumentKey.isDocumentKey(i) || (i = i.child(""));
                var s = new __PRIVATE_DocReference(new DocumentKey(i), 0);
                // Find unique batchIDs referenced by all documents potentially matching the
                // query.
                var _ = new SortedSet(__PRIVATE_primitiveComparator);
                return this.i_.forEachWhile(function(e) {
                    var _$t = e.key.path;
                    return !!n.isPrefixOf(_$t) && // Rows with document keys more than one segment longer than the query
                    // path can't be matches. For example, a query on 'rooms' can't match
                    // the document /rooms/abc/messages/xyx.
                    // TODO(mcg): we'll need a different scanner when we implement
                    // ancestor queries.
                    (_$t.length === r && (_ = _.add(e.r_)), true);
                }, s), PersistencePromise.resolve(this.o_(_));
            }
        },
        {
            key: "o_",
            value: function o_(e) {
                var _this = this;
                // Construct an array of matching batches, sorted by batchID to ensure that
                // multiple mutations affecting the same document key are applied in order.
                var t = [];
                return e.forEach(function(e) {
                    var n = _this.s_(e);
                    null !== n && t.push(n);
                }), t;
            }
        },
        {
            key: "removeMutationBatch",
            value: function removeMutationBatch(e, t) {
                var _this = this;
                __PRIVATE_hardAssert(0 === this.a_(t.batchId, "removed"), 55003), this.mutationQueue.shift();
                var n = this.i_;
                return PersistencePromise.forEach(t.mutations, function(r) {
                    var i = new __PRIVATE_DocReference(r.key, t.batchId);
                    return n = n.delete(i), _this.referenceDelegate.markPotentiallyOrphaned(e, r.key);
                }).next(function() {
                    _this.i_ = n;
                });
            }
        },
        {
            key: "Hr",
            value: function Hr(e) {
            // No-op since the memory mutation queue does not maintain a separate cache.
            }
        },
        {
            key: "containsKey",
            value: function containsKey(e, t) {
                var n = new __PRIVATE_DocReference(t, 0), r = this.i_.firstAfterOrEqual(n);
                return PersistencePromise.resolve(t.isEqual(r && r.key));
            }
        },
        {
            key: "performConsistencyCheck",
            value: function performConsistencyCheck(e) {
                return this.mutationQueue.length, PersistencePromise.resolve();
            }
        },
        {
            /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId - The batchId to search for
     * @param action - A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */ key: "a_",
            value: function a_(e, t) {
                return this.__(e);
            }
        },
        {
            /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @returns The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been removed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */ key: "__",
            value: function __(e) {
                if (0 === this.mutationQueue.length) // As an index this is past the end of the queue
                return 0;
                // Examine the front of the queue to figure out the difference between the
                // batchId and indexes in the array. Note that since the queue is ordered
                // by batchId, if the first batch has a larger batchId then the requested
                // batchId doesn't exist in the queue.
                return e - this.mutationQueue[0].batchId;
            }
        },
        {
            /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficient.
     */ key: "s_",
            value: function s_(e) {
                var t = this.__(e);
                if (t < 0 || t >= this.mutationQueue.length) return null;
                return this.mutationQueue[t];
            }
        }
    ]);
    return __PRIVATE_MemoryMutationQueue;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The smallest value representable by a 64-bit signed integer (long).
 */ /**
 * The memory-only RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newMemoryRemoteDocumentCache()`.
 */ var __PRIVATE_MemoryRemoteDocumentCacheImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryRemoteDocumentCacheImpl(e) {
        (0, $4QweW._)(this, __PRIVATE_MemoryRemoteDocumentCacheImpl);
        this.u_ = e, /** Underlying cache of documents and their read times. */ this.docs = function __PRIVATE_documentEntryMap() {
            return new SortedMap(DocumentKey.comparator);
        }(), /** Size of all cached documents. */ this.size = 0;
    }
    (0, $6hK4i._)(__PRIVATE_MemoryRemoteDocumentCacheImpl, [
        {
            key: "setIndexManager",
            value: function setIndexManager(e) {
                this.indexManager = e;
            }
        },
        {
            /**
     * Adds the supplied entry to the cache and updates the cache size as appropriate.
     *
     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ key: "addEntry",
            value: function addEntry(e, t) {
                var n = t.key, r = this.docs.get(n), i = r ? r.size : 0, s = this.u_(t);
                return this.docs = this.docs.insert(n, {
                    document: t.mutableCopy(),
                    size: s
                }), this.size += s - i, this.indexManager.addToCollectionParentIndex(e, n.path.popLast());
            }
        },
        {
            /**
     * Removes the specified entry from the cache and updates the cache size as appropriate.
     *
     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ key: "removeEntry",
            value: function removeEntry(e) {
                var t = this.docs.get(e);
                t && (this.docs = this.docs.remove(e), this.size -= t.size);
            }
        },
        {
            key: "getEntry",
            value: function getEntry(e, t) {
                var n = this.docs.get(t);
                return PersistencePromise.resolve(n ? n.document.mutableCopy() : MutableDocument.newInvalidDocument(t));
            }
        },
        {
            key: "getEntries",
            value: function getEntries(e, t) {
                var _this = this;
                var n = __PRIVATE_mutableDocumentMap();
                return t.forEach(function(e) {
                    var _$t = _this.docs.get(e);
                    n = n.insert(e, _$t ? _$t.document.mutableCopy() : MutableDocument.newInvalidDocument(e));
                }), PersistencePromise.resolve(n);
            }
        },
        {
            key: "getAllEntries",
            value: function getAllEntries(e) {
                var t = __PRIVATE_mutableDocumentMap();
                return this.docs.forEach(function(e, n) {
                    t = t.insert(e, n.document);
                }), PersistencePromise.resolve(t);
            }
        },
        {
            key: "getDocumentsMatchingQuery",
            value: function getDocumentsMatchingQuery(e, t, n, r) {
                // Documents are ordered by key, so we can use a prefix scan to narrow down
                // the documents we need to match the query against.
                var i, s;
                __PRIVATE_isPipeline(t) ? // Documents are ordered by key, so we can use a prefix scan to narrow down
                // the documents we need to match the query against.
                (i = ResourcePath.fromString(getPipelineCollection(t)), s = function(e) {
                    return __PRIVATE_pipelineMatches(t, e);
                }) : // Documents are ordered by key, so we can use a prefix scan to narrow down
                // the documents we need to match the query against.
                (i = t.path, s = function(e) {
                    return __PRIVATE_queryMatches(t, e);
                });
                var _ = __PRIVATE_mutableDocumentMap();
                // Document keys are ordered first by numeric value ("__id<Long>__"),
                // then lexicographically by string value. Start the iterator at the minimum
                // possible Document key value.
                var o = new DocumentKey(i.child("__id-9223372036854775808__")), a = this.docs.getIteratorFrom(o);
                for(; a.hasNext();){
                    var _a_getNext = a.getNext(), e1 = _a_getNext.key, _a_getNext_value = _a_getNext.value, _$t = _a_getNext_value.document;
                    if (!i.isPrefixOf(e1.path)) break;
                    e1.path.length > i.length + 1 || __PRIVATE_indexOffsetComparator(__PRIVATE_newIndexOffsetFromDocument(_$t), n) <= 0 || (r.has(_$t.key) || s(_$t)) && (_ = _.insert(_$t.key, _$t.mutableCopy()));
                }
                return PersistencePromise.resolve(_);
            }
        },
        {
            key: "getAllFromCollectionGroup",
            value: function getAllFromCollectionGroup(e, t, n, r) {
                // This method should only be called from the IndexBackfiller if persistence
                // is enabled.
                l(9500);
            }
        },
        {
            key: "c_",
            value: function c_(e, t) {
                return PersistencePromise.forEach(this.docs, function(e) {
                    return t(e);
                });
            }
        },
        {
            key: "newChangeBuffer",
            value: function newChangeBuffer(e) {
                // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
                // a separate changelog and does not need special handling for removals.
                return new __PRIVATE_MemoryRemoteDocumentChangeBuffer(this);
            }
        },
        {
            key: "getSize",
            value: function getSize(e) {
                return PersistencePromise.resolve(this.size);
            }
        }
    ]);
    return __PRIVATE_MemoryRemoteDocumentCacheImpl;
}();
/**
 * Creates a new memory-only RemoteDocumentCache.
 *
 * @param sizer - Used to assess the size of a document. For eager GC, this is
 * expected to just return 0 to avoid unnecessarily doing the work of
 * calculating the size.
 */ /**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */ var __PRIVATE_MemoryRemoteDocumentChangeBuffer = /*#__PURE__*/ function(RemoteDocumentChangeBuffer) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_MemoryRemoteDocumentChangeBuffer, RemoteDocumentChangeBuffer);
    function __PRIVATE_MemoryRemoteDocumentChangeBuffer(e) {
        (0, $4QweW._)(this, __PRIVATE_MemoryRemoteDocumentChangeBuffer);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_MemoryRemoteDocumentChangeBuffer), _this.$s = e;
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_MemoryRemoteDocumentChangeBuffer, [
        {
            key: "applyChanges",
            value: function applyChanges(e) {
                var _this = this;
                var t = [];
                return this.changes.forEach(function(n, r) {
                    r.isValidDocument() ? t.push(_this.$s.addEntry(e, r)) : _this.$s.removeEntry(n);
                }), PersistencePromise.waitFor(t);
            }
        },
        {
            key: "getFromCache",
            value: function getFromCache(e, t) {
                return this.$s.getEntry(e, t);
            }
        },
        {
            key: "getAllFromCache",
            value: function getAllFromCache(e, t) {
                return this.$s.getEntries(e, t);
            }
        }
    ]);
    return __PRIVATE_MemoryRemoteDocumentChangeBuffer;
}(RemoteDocumentChangeBuffer);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var __PRIVATE_MemoryTargetCache = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryTargetCache(e) {
        (0, $4QweW._)(this, __PRIVATE_MemoryTargetCache);
        this.persistence = e, /**
         * Maps a target to the data about that target
         */ this.l_ = new ObjectMap(function(e) {
            return __PRIVATE_canonifyTargetOrPipeline(e);
        }, __PRIVATE_targetOrPipelineEqual), /** The last received snapshot version. */ this.lastRemoteSnapshotVersion = SnapshotVersion.min(), /** The highest numbered target ID encountered. */ this.highestTargetId = 0, /** The highest sequence number encountered. */ this.E_ = 0, /**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */ this.h_ = new __PRIVATE_ReferenceSet, this.targetCount = 0, this.T_ = __PRIVATE_TargetIdGenerator.ws();
    }
    (0, $6hK4i._)(__PRIVATE_MemoryTargetCache, [
        {
            key: "forEachTarget",
            value: function forEachTarget(e, t) {
                return this.l_.forEach(function(e, n) {
                    return t(n);
                }), PersistencePromise.resolve();
            }
        },
        {
            key: "getLastRemoteSnapshotVersion",
            value: function getLastRemoteSnapshotVersion(e) {
                return PersistencePromise.resolve(this.lastRemoteSnapshotVersion);
            }
        },
        {
            key: "getHighestSequenceNumber",
            value: function getHighestSequenceNumber(e) {
                return PersistencePromise.resolve(this.E_);
            }
        },
        {
            key: "allocateTargetId",
            value: function allocateTargetId(e) {
                return this.highestTargetId = this.T_.next(), PersistencePromise.resolve(this.highestTargetId);
            }
        },
        {
            key: "setTargetsMetadata",
            value: function setTargetsMetadata(e, t, n) {
                return n && (this.lastRemoteSnapshotVersion = n), t > this.E_ && (this.E_ = t), PersistencePromise.resolve();
            }
        },
        {
            key: "Ds",
            value: function Ds(e) {
                this.l_.set(e.target, e);
                var t = e.targetId;
                t > this.highestTargetId && (this.T_ = new __PRIVATE_TargetIdGenerator(t), this.highestTargetId = t), e.sequenceNumber > this.E_ && (this.E_ = e.sequenceNumber);
            }
        },
        {
            key: "addTargetData",
            value: function addTargetData(e, t) {
                return this.Ds(t), this.targetCount += 1, PersistencePromise.resolve();
            }
        },
        {
            key: "updateTargetData",
            value: function updateTargetData(e, t) {
                return this.Ds(t), PersistencePromise.resolve();
            }
        },
        {
            key: "removeTargetData",
            value: function removeTargetData(e, t) {
                return this.l_.delete(t.target), this.h_.e_(t.targetId), this.targetCount -= 1, PersistencePromise.resolve();
            }
        },
        {
            key: "removeTargets",
            value: function removeTargets(e, t, n) {
                var _this = this;
                var r = 0;
                var i = [];
                return this.l_.forEach(function(s, _) {
                    _.sequenceNumber <= t && null === n.get(_.targetId) && (_this.l_.delete(s), i.push(_this.removeMatchingKeysForTargetId(e, _.targetId)), r++);
                }), PersistencePromise.waitFor(i).next(function() {
                    return r;
                });
            }
        },
        {
            key: "getTargetCount",
            value: function getTargetCount(e) {
                return PersistencePromise.resolve(this.targetCount);
            }
        },
        {
            key: "getTargetData",
            value: function getTargetData(e, t) {
                var n = this.l_.get(t) || null;
                return PersistencePromise.resolve(n);
            }
        },
        {
            key: "addMatchingKeys",
            value: function addMatchingKeys(e, t, n) {
                return this.h_.Ys(t, n), PersistencePromise.resolve();
            }
        },
        {
            key: "removeMatchingKeys",
            value: function removeMatchingKeys(e, t, n) {
                this.h_.Xs(t, n);
                var r = this.persistence.referenceDelegate, i = [];
                return r && t.forEach(function(t) {
                    i.push(r.markPotentiallyOrphaned(e, t));
                }), PersistencePromise.waitFor(i);
            }
        },
        {
            key: "removeMatchingKeysForTargetId",
            value: function removeMatchingKeysForTargetId(e, t) {
                return this.h_.e_(t), PersistencePromise.resolve();
            }
        },
        {
            key: "getMatchingKeysForTargetId",
            value: function getMatchingKeysForTargetId(e, t) {
                var n = this.h_.n_(t);
                return PersistencePromise.resolve(n);
            }
        },
        {
            key: "containsKey",
            value: function containsKey(e, t) {
                return PersistencePromise.resolve(this.h_.containsKey(t));
            }
        }
    ]);
    return __PRIVATE_MemoryTargetCache;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */ var __PRIVATE_MemoryPersistence = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryPersistence(e, t) {
        var _this = this;
        (0, $4QweW._)(this, __PRIVATE_MemoryPersistence);
        this.P_ = {}, this.overlays = {}, this.I_ = new __PRIVATE_ListenSequence(0), this.R_ = false, this.R_ = true, this.A_ = new __PRIVATE_MemoryGlobalsCache, this.referenceDelegate = e(this), this.V_ = new __PRIVATE_MemoryTargetCache(this);
        this.indexManager = new __PRIVATE_MemoryIndexManager, this.remoteDocumentCache = function __PRIVATE_newMemoryRemoteDocumentCache(e) {
            return new __PRIVATE_MemoryRemoteDocumentCacheImpl(e);
        }(function(e) {
            return _this.referenceDelegate.d_(e);
        }), this.serializer = new __PRIVATE_LocalSerializer(t), this.f_ = new __PRIVATE_MemoryBundleCache(this.serializer);
    }
    (0, $6hK4i._)(__PRIVATE_MemoryPersistence, [
        {
            key: "start",
            value: function start() {
                return Promise.resolve();
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {
                // No durable state to ensure is closed on shutdown.
                return this.R_ = false, Promise.resolve();
            }
        },
        {
            key: "started",
            get: function get() {
                return this.R_;
            }
        },
        {
            key: "setDatabaseDeletedListener",
            value: function setDatabaseDeletedListener() {
            // No op.
            }
        },
        {
            key: "setNetworkEnabled",
            value: function setNetworkEnabled() {
            // No op.
            }
        },
        {
            key: "getIndexManager",
            value: function getIndexManager(e) {
                // We do not currently support indices for memory persistence, so we can
                // return the same shared instance of the memory index manager.
                return this.indexManager;
            }
        },
        {
            key: "getDocumentOverlayCache",
            value: function getDocumentOverlayCache(e) {
                var t = this.overlays[e.toKey()];
                return t || (t = new __PRIVATE_MemoryDocumentOverlayCache, this.overlays[e.toKey()] = t), t;
            }
        },
        {
            key: "getMutationQueue",
            value: function getMutationQueue(e, t) {
                var n = this.P_[e.toKey()];
                return n || (n = new __PRIVATE_MemoryMutationQueue(t, this.referenceDelegate), this.P_[e.toKey()] = n), n;
            }
        },
        {
            key: "getGlobalsCache",
            value: function getGlobalsCache() {
                return this.A_;
            }
        },
        {
            key: "getTargetCache",
            value: function getTargetCache() {
                return this.V_;
            }
        },
        {
            key: "getRemoteDocumentCache",
            value: function getRemoteDocumentCache() {
                return this.remoteDocumentCache;
            }
        },
        {
            key: "getBundleCache",
            value: function getBundleCache() {
                return this.f_;
            }
        },
        {
            key: "runTransaction",
            value: function runTransaction(e, t, n) {
                var _this = this;
                __PRIVATE_logDebug("MemoryPersistence", "Starting transaction:", e);
                var r = new __PRIVATE_MemoryTransaction(this.I_.next());
                return this.referenceDelegate.m_(), n(r).next(function(e) {
                    return _this.referenceDelegate.p_(r).next(function() {
                        return e;
                    });
                }).toPromise().then(function(e) {
                    return r.raiseOnCommittedEvent(), e;
                });
            }
        },
        {
            key: "g_",
            value: function g_(e, t) {
                return PersistencePromise.or(Object.values(this.P_).map(function(n) {
                    return function() {
                        return n.containsKey(e, t);
                    };
                }));
            }
        }
    ]);
    return __PRIVATE_MemoryPersistence;
}();
/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */ var __PRIVATE_MemoryTransaction = /*#__PURE__*/ function(PersistenceTransaction) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_MemoryTransaction, PersistenceTransaction);
    function __PRIVATE_MemoryTransaction(e) {
        (0, $4QweW._)(this, __PRIVATE_MemoryTransaction);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_MemoryTransaction), _this.currentSequenceNumber = e;
        return _this;
    }
    return __PRIVATE_MemoryTransaction;
}(PersistenceTransaction);
var __PRIVATE_MemoryEagerDelegate = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryEagerDelegate(e) {
        (0, $4QweW._)(this, __PRIVATE_MemoryEagerDelegate);
        this.persistence = e, /** Tracks all documents that are active in Query views. */ this.y_ = new __PRIVATE_ReferenceSet, /** The list of documents that are potentially GCed after each transaction. */ this.w_ = null;
    }
    (0, $6hK4i._)(__PRIVATE_MemoryEagerDelegate, [
        {
            key: "S_",
            get: function get() {
                if (this.w_) return this.w_;
                throw l(60996);
            }
        },
        {
            key: "addReference",
            value: function addReference(e, t, n) {
                return this.y_.addReference(n, t), this.S_.delete(n.toString()), PersistencePromise.resolve();
            }
        },
        {
            key: "removeReference",
            value: function removeReference(e, t, n) {
                return this.y_.removeReference(n, t), this.S_.add(n.toString()), PersistencePromise.resolve();
            }
        },
        {
            key: "markPotentiallyOrphaned",
            value: function markPotentiallyOrphaned(e, t) {
                return this.S_.add(t.toString()), PersistencePromise.resolve();
            }
        },
        {
            key: "removeTarget",
            value: function removeTarget(e, t) {
                var _this = this;
                this.y_.e_(t.targetId).forEach(function(e) {
                    return _this.S_.add(e.toString());
                });
                var n = this.persistence.getTargetCache();
                return n.getMatchingKeysForTargetId(e, t.targetId).next(function(e) {
                    e.forEach(function(e) {
                        return _this.S_.add(e.toString());
                    });
                }).next(function() {
                    return n.removeTargetData(e, t);
                });
            }
        },
        {
            key: "m_",
            value: function m_() {
                this.w_ = new Set;
            }
        },
        {
            key: "p_",
            value: function p_(e) {
                var _this = this;
                // Remove newly orphaned documents.
                var t = this.persistence.getRemoteDocumentCache().newChangeBuffer();
                return PersistencePromise.forEach(this.S_, function(n) {
                    var r = DocumentKey.fromPath(n);
                    return _this.v_(e, r).next(function(e) {
                        e || t.removeEntry(r, SnapshotVersion.min());
                    });
                }).next(function() {
                    return _this.w_ = null, t.apply(e);
                });
            }
        },
        {
            key: "updateLimboDocument",
            value: function updateLimboDocument(e, t) {
                var _this = this;
                return this.v_(e, t).next(function(e) {
                    e ? _this.S_.delete(t.toString()) : _this.S_.add(t.toString());
                });
            }
        },
        {
            key: "d_",
            value: function d_(e) {
                // For eager GC, we don't care about the document size, there are no size thresholds.
                return 0;
            }
        },
        {
            key: "v_",
            value: function v_(e, t) {
                var _this = this;
                return PersistencePromise.or([
                    function() {
                        return PersistencePromise.resolve(_this.y_.containsKey(t));
                    },
                    function() {
                        return _this.persistence.getTargetCache().containsKey(e, t);
                    },
                    function() {
                        return _this.persistence.g_(e, t);
                    }
                ]);
            }
        }
    ], [
        {
            key: "b_",
            value: function b_(e) {
                return new __PRIVATE_MemoryEagerDelegate(e);
            }
        }
    ]);
    return __PRIVATE_MemoryEagerDelegate;
}();
var __PRIVATE_MemoryLruDelegate = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryLruDelegate(e, t) {
        (0, $4QweW._)(this, __PRIVATE_MemoryLruDelegate);
        this.persistence = e, this.D_ = new ObjectMap(function(e) {
            return __PRIVATE_encodeResourcePath(e.path);
        }, function(e, t) {
            return e.isEqual(t);
        }), this.garbageCollector = __PRIVATE_newLruGarbageCollector(this, t);
    }
    (0, $6hK4i._)(__PRIVATE_MemoryLruDelegate, [
        {
            // No-ops, present so memory persistence doesn't have to care which delegate
            // it has.
            key: "m_",
            value: function m_() {}
        },
        {
            key: "p_",
            value: function p_(e) {
                return PersistencePromise.resolve();
            }
        },
        {
            key: "forEachTarget",
            value: function forEachTarget(e, t) {
                return this.persistence.getTargetCache().forEachTarget(e, t);
            }
        },
        {
            key: "ir",
            value: function ir(e) {
                var t = this.Cs(e);
                return this.persistence.getTargetCache().getTargetCount(e).next(function(e) {
                    return t.next(function(t) {
                        return e + t;
                    });
                });
            }
        },
        {
            key: "Cs",
            value: function Cs(e) {
                var t = 0;
                return this.sr(e, function(e) {
                    t++;
                }).next(function() {
                    return t;
                });
            }
        },
        {
            key: "sr",
            value: function sr(e, t) {
                var _this = this;
                return PersistencePromise.forEach(this.D_, function(n, r) {
                    return _this.Os(e, n, r).next(function(e) {
                        return e ? PersistencePromise.resolve() : t(r);
                    });
                });
            }
        },
        {
            key: "removeTargets",
            value: function removeTargets(e, t, n) {
                return this.persistence.getTargetCache().removeTargets(e, t, n);
            }
        },
        {
            key: "removeOrphanedDocuments",
            value: function removeOrphanedDocuments(e, t) {
                var _this = this;
                var n = 0;
                var r = this.persistence.getRemoteDocumentCache(), i = r.newChangeBuffer();
                return r.c_(e, function(r) {
                    return _this.Os(e, r, t).next(function(e) {
                        e || (n++, i.removeEntry(r, SnapshotVersion.min()));
                    });
                }).next(function() {
                    return i.apply(e);
                }).next(function() {
                    return n;
                });
            }
        },
        {
            key: "markPotentiallyOrphaned",
            value: function markPotentiallyOrphaned(e, t) {
                return this.D_.set(t, e.currentSequenceNumber), PersistencePromise.resolve();
            }
        },
        {
            key: "removeTarget",
            value: function removeTarget(e, t) {
                var n = t.withSequenceNumber(e.currentSequenceNumber);
                return this.persistence.getTargetCache().updateTargetData(e, n);
            }
        },
        {
            key: "addReference",
            value: function addReference(e, t, n) {
                return this.D_.set(n, e.currentSequenceNumber), PersistencePromise.resolve();
            }
        },
        {
            key: "removeReference",
            value: function removeReference(e, t, n) {
                return this.D_.set(n, e.currentSequenceNumber), PersistencePromise.resolve();
            }
        },
        {
            key: "updateLimboDocument",
            value: function updateLimboDocument(e, t) {
                return this.D_.set(t, e.currentSequenceNumber), PersistencePromise.resolve();
            }
        },
        {
            key: "d_",
            value: function d_(e) {
                var t = e.key.toString().length;
                return e.isFoundDocument() && (t += __PRIVATE_estimateByteSize(e.data.value)), t;
            }
        },
        {
            key: "Os",
            value: function Os(e, t, n) {
                var _this = this;
                return PersistencePromise.or([
                    function() {
                        return _this.persistence.g_(e, t);
                    },
                    function() {
                        return _this.persistence.getTargetCache().containsKey(e, t);
                    },
                    function() {
                        var e = _this.D_.get(t);
                        return PersistencePromise.resolve(void 0 !== e && e > n);
                    }
                ]);
            }
        },
        {
            key: "getCacheSize",
            value: function getCacheSize(e) {
                return this.persistence.getRemoteDocumentCache().getSize(e);
            }
        }
    ], [
        {
            key: "b_",
            value: function b_(e, t) {
                return new __PRIVATE_MemoryLruDelegate(e, t);
            }
        }
    ]);
    return __PRIVATE_MemoryLruDelegate;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Performs database creation and schema upgrades. */ var __PRIVATE_SchemaConverter = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_SchemaConverter(e) {
        (0, $4QweW._)(this, __PRIVATE_SchemaConverter);
        this.serializer = e;
    }
    (0, $6hK4i._)(__PRIVATE_SchemaConverter, [
        {
            /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */ key: "Nn",
            value: function Nn1(e, t, n, r) {
                var _this = this;
                var i = new __PRIVATE_SimpleDbTransaction("createOrUpgrade", t);
                n < 1 && r >= 1 && (!function __PRIVATE_createPrimaryClientStore(e) {
                    e.createObjectStore(Wt);
                }(e), function __PRIVATE_createMutationQueue(e) {
                    e.createObjectStore(zt, {
                        keyPath: jt
                    });
                    var _$t = e.createObjectStore(Ht, {
                        keyPath: Jt,
                        autoIncrement: true
                    });
                    _$t.createIndex(Yt, Zt, {
                        unique: true
                    }), e.createObjectStore(en);
                }(e), __PRIVATE_createQueryCache(e), function __PRIVATE_createLegacyRemoteDocumentCache(e) {
                    e.createObjectStore(Qt);
                }(e));
                // Migration 2 to populate the targetGlobal object no longer needed since
                // migration 3 unconditionally clears it.
                var s = PersistencePromise.resolve();
                return n < 3 && r >= 3 && // Brand new clients don't need to drop and recreate--only clients that
                // potentially have corrupt data.
                (0 !== n && (!function __PRIVATE_dropQueryCache(e) {
                    e.deleteObjectStore(Tn), e.deleteObjectStore(cn), e.deleteObjectStore(Vn);
                }(e), __PRIVATE_createQueryCache(e)), s = s.next(function() {
                    return(/**
 * Creates the target global singleton row.
 *
 * @param txn - The version upgrade transaction for indexeddb
 */ function __PRIVATE_writeEmptyTargetGlobalEntry(e) {
                        var _$t = e.store(Vn), _$n = {
                            highestTargetId: 0,
                            highestListenSequenceNumber: 0,
                            lastRemoteSnapshotVersion: SnapshotVersion.min().toTimestamp(),
                            targetCount: 0
                        };
                        return _$t.put(An, _$n);
                    }(i));
                })), n < 4 && r >= 4 && (0 !== n && // Schema version 3 uses auto-generated keys to generate globally unique
                // mutation batch IDs (this was previously ensured internally by the
                // client). To migrate to the new schema, we have to read all mutations
                // and write them back out. We preserve the existing batch IDs to guarantee
                // consistency with other object stores. Any further mutation batch IDs will
                // be auto-generated.
                (s = s.next(function() {
                    return function __PRIVATE_upgradeMutationBatchSchemaAndMigrateData(e, t) {
                        var _$n = t.store(Ht);
                        return _$n.Qn().next(function(n) {
                            e.deleteObjectStore(Ht);
                            e.createObjectStore(Ht, {
                                keyPath: Jt,
                                autoIncrement: true
                            }).createIndex(Yt, Zt, {
                                unique: true
                            });
                            var _$r = t.store(Ht), i = n.map(function(e) {
                                return _$r.put(e);
                            });
                            return PersistencePromise.waitFor(i);
                        });
                    }(e, i);
                })), s = s.next(function() {
                    !function __PRIVATE_createClientMetadataStore(e) {
                        e.createObjectStore(mn, {
                            keyPath: pn
                        });
                    }(e);
                })), n < 5 && r >= 5 && (s = s.next(function() {
                    return _this.x_(i);
                })), n < 6 && r >= 6 && (s = s.next(function() {
                    return function __PRIVATE_createDocumentGlobalStore(e) {
                        e.createObjectStore(an);
                    }(e), _this.C_(i);
                })), n < 7 && r >= 7 && (s = s.next(function() {
                    return _this.F_(i);
                })), n < 8 && r >= 8 && (s = s.next(function() {
                    return _this.O_(e, i);
                })), n < 9 && r >= 9 && (s = s.next(function() {
                    // Multi-Tab used to manage its own changelog, but this has been moved
                    // to the DbRemoteDocument object store itself. Since the previous change
                    // log only contained transient data, we can drop its object store.
                    !function __PRIVATE_dropRemoteDocumentChangesStore(e) {
                        e.objectStoreNames.contains("remoteDocumentChanges") && e.deleteObjectStore("remoteDocumentChanges");
                    }(e);
                // Note: Schema version 9 used to create a read time index for the
                // RemoteDocumentCache. This is now done with schema version 13.
                })), n < 10 && r >= 10 && (s = s.next(function() {
                    return _this.M_(i);
                })), n < 11 && r >= 11 && (s = s.next(function() {
                    !function __PRIVATE_createBundlesStore(e) {
                        e.createObjectStore(gn, {
                            keyPath: yn
                        });
                    }(e), function __PRIVATE_createNamedQueriesStore(e) {
                        e.createObjectStore(wn, {
                            keyPath: bn
                        });
                    }(e);
                })), n < 12 && r >= 12 && (s = s.next(function() {
                    !function __PRIVATE_createDocumentOverlayStore(e) {
                        var _$t = e.createObjectStore(kn, {
                            keyPath: qn
                        });
                        _$t.createIndex($n, Kn, {
                            unique: false
                        }), _$t.createIndex(Qn, Wn, {
                            unique: false
                        });
                    }(e);
                })), n < 13 && r >= 13 && (s = s.next(function() {
                    return function __PRIVATE_createRemoteDocumentCache(e) {
                        var _$t = e.createObjectStore(tn, {
                            keyPath: nn
                        });
                        _$t.createIndex(rn, sn), _$t.createIndex(_n, on);
                    }(e);
                }).next(function() {
                    return _this.N_(e, i);
                }).next(function() {
                    return e.deleteObjectStore(Qt);
                })), n < 14 && r >= 14 && (s = s.next(function() {
                    return _this.L_(e, i);
                })), n < 15 && r >= 15 && (s = s.next(function() {
                    return function __PRIVATE_createFieldIndex(e) {
                        var _$t = e.createObjectStore(Sn, {
                            keyPath: vn,
                            autoIncrement: true
                        });
                        _$t.createIndex(Dn, xn, {
                            unique: false
                        });
                        var _$n = e.createObjectStore(Cn, {
                            keyPath: Fn
                        });
                        _$n.createIndex(On, Mn, {
                            unique: false
                        });
                        var _$r = e.createObjectStore(Nn, {
                            keyPath: Ln
                        });
                        _$r.createIndex(Bn, Un, {
                            unique: false
                        });
                    }(e);
                })), n < 16 && r >= 16 && // Clear the object stores to remove possibly corrupted index entries
                (s = s.next(function() {
                    t.objectStore(Cn).clear();
                }).next(function() {
                    t.objectStore(Nn).clear();
                })), n < 17 && r >= 17 && (s = s.next(function() {
                    !function __PRIVATE_createGlobalsStore(e) {
                        e.createObjectStore(Gn, {
                            keyPath: zn
                        });
                    }(e);
                })), n < 18 && r >= 18 && (0, $hk14n.isSafariOrWebkit)() && (s = s.next(function() {
                    t.objectStore(Cn).clear();
                }).next(function() {
                    t.objectStore(Nn).clear();
                })), s;
            }
        },
        {
            key: "C_",
            value: function C_(e) {
                var t = 0;
                return e.store(Qt).Hn(function(e, n) {
                    t += __PRIVATE_dbDocumentSize(n);
                }).next(function() {
                    var n = {
                        byteSize: t
                    };
                    return e.store(an).put(un, n);
                });
            }
        },
        {
            key: "x_",
            value: function x_(e) {
                var _this = this;
                var t = e.store(zt), n = e.store(Ht);
                return t.Qn().next(function(t) {
                    return PersistencePromise.forEach(t, function(t) {
                        var r = IDBKeyRange.bound([
                            t.userId,
                            Ke
                        ], [
                            t.userId,
                            t.lastAcknowledgedBatchId
                        ]);
                        return n.Qn(Yt, r).next(function(n) {
                            return PersistencePromise.forEach(n, function(n) {
                                __PRIVATE_hardAssert(n.userId === t.userId, 18650, "Cannot process batch from unexpected user", {
                                    batchId: n.batchId
                                });
                                var r = __PRIVATE_fromDbMutationBatch(_this.serializer, n);
                                return removeMutationBatch(e, t.userId, r).next(function() {});
                            });
                        });
                    });
                });
            }
        },
        {
            /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */ key: "F_",
            value: function F_(e) {
                var t = e.store(Tn), n = e.store(Qt);
                return e.store(Vn).get(An).next(function(e) {
                    var r = [];
                    return n.Hn(function(n, i) {
                        var s = new ResourcePath(n), _ = function __PRIVATE_sentinelKey(e) {
                            return [
                                0,
                                __PRIVATE_encodeResourcePath(e)
                            ];
                        }(s);
                        r.push(t.get(_).next(function(n) {
                            return n ? PersistencePromise.resolve() : function(n) {
                                return t.put({
                                    targetId: 0,
                                    path: __PRIVATE_encodeResourcePath(n),
                                    sequenceNumber: e.highestListenSequenceNumber
                                });
                            }(s);
                        }));
                    }).next(function() {
                        return PersistencePromise.waitFor(r);
                    });
                });
            }
        },
        {
            key: "O_",
            value: function O_(e, t) {
                // Create the index.
                e.createObjectStore(dn, {
                    keyPath: fn
                });
                var n = t.store(dn), r = new __PRIVATE_MemoryCollectionParentIndex, addEntry = function(e) {
                    if (r.add(e)) {
                        var _$t = e.lastSegment(), r1 = e.popLast();
                        return n.put({
                            collectionId: _$t,
                            parent: __PRIVATE_encodeResourcePath(r1)
                        });
                    }
                };
                // Helper to add an index entry iff we haven't already written it.
                // Index existing remote documents.
                return t.store(Qt).Hn({
                    jn: true
                }, function(e, t) {
                    var n = new ResourcePath(e);
                    return addEntry(n.popLast());
                }).next(function() {
                    return t.store(en).Hn({
                        jn: true
                    }, function(param, r) {
                        var _param = (0, $6ZpBv._)(param, 3), _$e = _param[0], _$t = _param[1], n = _param[2];
                        var i = __PRIVATE_decodeResourcePath(_$t);
                        return addEntry(i.popLast());
                    });
                });
            }
        },
        {
            key: "M_",
            value: function M_(e) {
                var _this = this;
                var t = e.store(cn);
                return t.Hn(function(e, n) {
                    var r = __PRIVATE_fromDbTarget(_this.serializer, n), i = __PRIVATE_toDbTarget(_this.serializer, r);
                    return t.put(i);
                });
            }
        },
        {
            key: "N_",
            value: function N_(e, t) {
                var n = t.store(Qt), r = [];
                return n.Hn(function(e, n) {
                    var i = t.store(tn), s = (function __PRIVATE_extractKey(e) {
                        return e.document ? new DocumentKey(ResourcePath.fromString(e.document.name).popFirst(5)) : e.noDocument ? DocumentKey.fromSegments(e.noDocument.path) : e.unknownDocument ? DocumentKey.fromSegments(e.unknownDocument.path) : l(36783);
                    })(n).path.toArray(), _ = {
                        prefixPath: s.slice(0, s.length - 2),
                        collectionGroup: s[s.length - 2],
                        documentId: s[s.length - 1],
                        readTime: n.readTime || [
                            0,
                            0
                        ],
                        unknownDocument: n.unknownDocument,
                        noDocument: n.noDocument,
                        document: n.document,
                        hasCommittedMutations: !!n.hasCommittedMutations
                    };
                    r.push(i.put(_));
                }).next(function() {
                    return PersistencePromise.waitFor(r);
                });
            }
        },
        {
            key: "L_",
            value: function L_(e, t) {
                var _this = this;
                var n = t.store(Ht), r = __PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), i = new __PRIVATE_MemoryPersistence(__PRIVATE_MemoryEagerDelegate.b_, this.serializer.$r);
                return n.Qn().next(function(e) {
                    var n = new Map;
                    return e.forEach(function(e) {
                        var _n_get;
                        var _$t = (_n_get = n.get(e.userId)) !== null && _n_get !== void 0 ? _n_get : __PRIVATE_documentKeySet();
                        __PRIVATE_fromDbMutationBatch(_this.serializer, e).keys().forEach(function(e) {
                            return _$t = _$t.add(e);
                        }), n.set(e.userId, _$t);
                    }), PersistencePromise.forEach(n, function(e, n) {
                        var s = new User(n), _ = __PRIVATE_IndexedDbDocumentOverlayCache.Qr(_this.serializer, s), o = i.getIndexManager(s), a = __PRIVATE_IndexedDbMutationQueue.Qr(s, _this.serializer, o, i.referenceDelegate);
                        return new LocalDocumentsView(r, a, _, o).recalculateAndSaveOverlaysForDocumentKeys(new __PRIVATE_IndexedDbTransaction(t, __PRIVATE_ListenSequence.wn), e).next();
                    });
                });
            }
        }
    ]);
    return __PRIVATE_SchemaConverter;
}();
function __PRIVATE_createQueryCache(e) {
    e.createObjectStore(Tn, {
        keyPath: Pn
    }).createIndex(In, Rn, {
        unique: true
    });
    // NOTE: This is unique only because the TargetId is the suffix.
    e.createObjectStore(cn, {
        keyPath: "targetId"
    }).createIndex(En, hn, {
        unique: true
    }), e.createObjectStore(Vn);
}
var sr = "IndexedDbPersistence", _r = 18e5, ar = 5e3, ur = "Failed to obtain exclusive access to the persistence layer. To allow shared access, multi-tab synchronization has to be enabled in all tabs. If you are using `experimentalForceOwningTab:true`, make sure that only one tab has persistence enabled at any given time.", cr = "main";
/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data is garbage collected.
 */ /**
 * An IndexedDB-backed instance of Persistence. Data is stored persistently
 * across sessions.
 *
 * On Web only, the Firestore SDKs support shared access to its persistence
 * layer. This allows multiple browser tabs to read and write to IndexedDb and
 * to synchronize state even without network connectivity. Shared access is
 * currently optional and not enabled unless all clients invoke
 * `enablePersistence()` with `{synchronizeTabs:true}`.
 *
 * In multi-tab mode, if multiple clients are active at the same time, the SDK
 * will designate one client as the "primary client". An effort is made to pick
 * a visible, network-connected and active client, and this client is
 * responsible for letting other clients know about its presence. The primary
 * client writes a unique client-generated identifier (the client ID) to
 * IndexedDb’s "owner" store every 4 seconds. If the primary client fails to
 * update this entry, another client can acquire the lease and take over as
 * primary.
 *
 * Some persistence operations in the SDK are designated as primary-client only
 * operations. This includes the acknowledgment of mutations and all updates of
 * remote documents. The effects of these operations are written to persistence
 * and then broadcast to other tabs via LocalStorage (see
 * `WebStorageSharedClientState`), which then refresh their state from
 * persistence.
 *
 * Similarly, the primary client listens to notifications sent by secondary
 * clients to discover persistence changes written by secondary clients, such as
 * the addition of new mutations and query targets.
 *
 * If multi-tab is not enabled and another tab already obtained the primary
 * lease, IndexedDbPersistence enters a failed state and all subsequent
 * operations will automatically fail.
 *
 * Additionally, there is an optimization so that when a tab is closed, the
 * primary lease is released immediately (this is especially important to make
 * sure that a refreshed tab is able to immediately re-acquire the primary
 * lease). Unfortunately, IndexedDB cannot be reliably used in window.unload
 * since it is an asynchronous API. So in addition to attempting to give up the
 * lease, the leaseholder writes its client ID to a "zombiedClient" entry in
 * LocalStorage which acts as an indicator that another tab should go ahead and
 * take the primary lease immediately regardless of the current lease timestamp.
 *
 * TODO(b/114226234): Remove `synchronizeTabs` section when multi-tab is no
 * longer optional.
 */ var __PRIVATE_IndexedDbPersistence = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexedDbPersistence(/**
     * Whether to synchronize the in-memory state of multiple tabs and share
     * access to local persistence.
     */ t, n, r, i, s, _, o, a, u, /**
     * If set to true, forcefully obtains database access. Existing tabs will
     * no longer be able to access IndexedDB.
     */ c) {
        var l = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : 18;
        (0, $4QweW._)(this, __PRIVATE_IndexedDbPersistence);
        if (this.allowTabSynchronization = t, this.persistenceKey = n, this.clientId = r, this.Ct = s, this.window = _, this.document = o, this.B_ = u, this.U_ = c, this.k_ = l, this.I_ = null, this.R_ = false, this.isPrimary = false, this.networkEnabled = true, /** Our window.unload handler, if registered. */ this.q_ = null, this.inForeground = false, /** Our 'visibilitychange' listener if registered. */ this.K_ = null, /** The client metadata refresh task. */ this.Q_ = null, /** The last time we garbage collected the client metadata object store. */ this.W_ = Number.NEGATIVE_INFINITY, /** A listener to notify on primary state changes. */ this.G_ = function(e) {
            return Promise.resolve();
        }, !__PRIVATE_IndexedDbPersistence.Ye()) throw new e(ta.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
        this.referenceDelegate = new __PRIVATE_IndexedDbLruDelegateImpl(this, i), this.z_ = n + cr, this.serializer = new __PRIVATE_LocalSerializer(a), this.j_ = new __PRIVATE_SimpleDb(this.z_, this.k_, new __PRIVATE_SchemaConverter(this.serializer)), this.A_ = new __PRIVATE_IndexedDbGlobalsCache, this.V_ = new __PRIVATE_IndexedDbTargetCache(this.referenceDelegate, this.serializer), this.remoteDocumentCache = __PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), this.f_ = new __PRIVATE_IndexedDbBundleCache, this.window && this.window.localStorage ? this.H_ = this.window.localStorage : (this.H_ = null, false === c && __PRIVATE_logError(sr, "LocalStorage is unavailable. As a result, persistence may not work reliably. In particular enablePersistence() could fail immediately after refreshing the page."));
    }
    (0, $6hK4i._)(__PRIVATE_IndexedDbPersistence, [
        {
            /**
     * Attempt to start IndexedDb persistence.
     *
     * @returns Whether persistence was enabled.
     */ key: "start",
            value: function start() {
                var _this = this;
                // NOTE: This is expected to fail sometimes (in the case of another tab
                // already having the persistence lock), so it's the first thing we should
                // do.
                return this.J_().then(function() {
                    if (!_this.isPrimary && !_this.allowTabSynchronization) // Fail `start()` if `synchronizeTabs` is disabled and we cannot
                    // obtain the primary lease.
                    throw new e(ta.FAILED_PRECONDITION, ur);
                    return _this.Y_(), _this.Z_(), _this.X_(), _this.runTransaction("getHighestListenSequenceNumber", "readonly", function(e) {
                        return _this.V_.getHighestSequenceNumber(e);
                    });
                }).then(function(e) {
                    _this.I_ = new __PRIVATE_ListenSequence(e, _this.B_);
                }).then(function() {
                    _this.R_ = true;
                }).catch(function(e) {
                    return _this.j_ && _this.j_.close(), Promise.reject(e);
                });
            }
        },
        {
            /**
     * Registers a listener that gets called when the primary state of the
     * instance changes. Upon registering, this listener is invoked immediately
     * with the current primary state.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ key: "eo",
            value: function eo(e) {
                var _this = this;
                return this.G_ = function(t) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                        return (0, $gh3Df._)(this, function(_state) {
                            if (this.started) return [
                                2,
                                e(t)
                            ];
                            return [
                                2
                            ];
                        });
                    }).call(_this);
                }, e(this.isPrimary);
            }
        },
        {
            /**
     * Registers a listener that gets called when the database receives a
     * version change event indicating that it has deleted.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ key: "setDatabaseDeletedListener",
            value: function setDatabaseDeletedListener(e) {
                this.j_.Bn(function(t) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                        var _tmp;
                        return (0, $gh3Df._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    // Check if an attempt is made to delete IndexedDB.
                                    _tmp = null === t.newVersion;
                                    if (!_tmp) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        e()
                                    ];
                                case 1:
                                    _tmp = _state.sent();
                                    _state.label = 2;
                                case 2:
                                    _tmp;
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                });
            }
        },
        {
            /**
     * Adjusts the current network state in the client's metadata, potentially
     * affecting the primary lease.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ key: "setNetworkEnabled",
            value: function setNetworkEnabled(e) {
                var _this = this;
                this.networkEnabled !== e && (this.networkEnabled = e, // Schedule a primary lease refresh for immediate execution. The eventual
                // lease update will be propagated via `primaryStateListener`.
                this.Ct.enqueueAndForget(function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                        var _tmp;
                        return (0, $gh3Df._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _tmp = this.started;
                                    if (!_tmp) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        this.J_()
                                    ];
                                case 1:
                                    _tmp = _state.sent();
                                    _state.label = 2;
                                case 2:
                                    _tmp;
                                    return [
                                        2
                                    ];
                            }
                        });
                    }).call(_this);
                }));
            }
        },
        {
            /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */ key: "J_",
            value: function J_() {
                var _this = this;
                return this.runTransaction("updateClientMetadataAndTryBecomePrimary", "readwrite", function(e) {
                    return __PRIVATE_clientMetadataStore(e).put({
                        clientId: _this.clientId,
                        updateTimeMs: Date.now(),
                        networkEnabled: _this.networkEnabled,
                        inForeground: _this.inForeground
                    }).next(function() {
                        if (_this.isPrimary) return _this.no(e).next(function(e) {
                            e || (_this.isPrimary = false, _this.Ct.enqueueRetryable(function() {
                                return _this.G_(false);
                            }));
                        });
                    }).next(function() {
                        return _this.ro(e);
                    }).next(function(t) {
                        return _this.isPrimary && !t ? _this.io(e).next(function() {
                            return false;
                        }) : !!t && _this.so(e).next(function() {
                            return true;
                        });
                    });
                }).catch(function(e) {
                    if (__PRIVATE_isIndexedDbTransactionError(e)) // Proceed with the existing state. Any subsequent access to
                    // IndexedDB will verify the lease.
                    return __PRIVATE_logDebug(sr, "Failed to extend owner lease: ", e), _this.isPrimary;
                    if (!_this.allowTabSynchronization) throw e;
                    return __PRIVATE_logDebug(sr, "Releasing owner lease after error during lease refresh", e), /* isPrimary= */ false;
                }).then(function(e) {
                    _this.isPrimary !== e && _this.Ct.enqueueRetryable(function() {
                        return _this.G_(e);
                    }), _this.isPrimary = e;
                });
            }
        },
        {
            key: "no",
            value: function no(e) {
                var _this = this;
                return __PRIVATE_primaryClientStore(e).get(Gt).next(function(e) {
                    return PersistencePromise.resolve(_this._o(e));
                });
            }
        },
        {
            key: "oo",
            value: function oo(e) {
                return __PRIVATE_clientMetadataStore(e).delete(this.clientId);
            }
        },
        {
            key: "ao",
            value: /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */ function ao() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _this, e, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, t;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                if (!(this.isPrimary && !this.uo(this.W_, _r))) return [
                                    3,
                                    2
                                ];
                                this.W_ = Date.now();
                                return [
                                    4,
                                    this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", function(e) {
                                        var t = __PRIVATE_getStore(e, mn);
                                        return t.Qn().next(function(e) {
                                            var n = _this.co(e, _r), r = e.filter(function(e) {
                                                return -1 === n.indexOf(e);
                                            });
                                            // Delete metadata for clients that are no longer considered active.
                                            return PersistencePromise.forEach(r, function(e) {
                                                return t.delete(e.clientId);
                                            }).next(function() {
                                                return r;
                                            });
                                        });
                                    }).catch(function() {
                                        return [];
                                    })
                                ];
                            case 1:
                                e = _state.sent();
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                // Delete potential leftover entries that may continue to mark the
                                // inactive clients as zombied in LocalStorage.
                                // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
                                // the client atomically, but we can't. So we opt to delete the IndexedDb
                                // entries first to avoid potentially reviving a zombied client.
                                if (this.H_) try {
                                    for(_iterator = e[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        t = _step.value;
                                        this.H_.removeItem(this.lo(t.clientId));
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */ key: "X_",
            value: function X_() {
                var _this = this;
                this.Q_ = this.Ct.enqueueAfterDelay("client_metadata_refresh" /* TimerId.ClientMetadataRefresh */ , 4e3, function() {
                    return _this.J_().then(function() {
                        return _this.ao();
                    }).then(function() {
                        return _this.X_();
                    });
                });
            }
        },
        {
            /** Checks whether `client` is the local client. */ key: "_o",
            value: function _o(e) {
                return !!e && e.ownerId === this.clientId;
            }
        },
        {
            /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */ key: "ro",
            value: function ro(t) {
                var _this = this;
                if (this.U_) return PersistencePromise.resolve(true);
                return __PRIVATE_primaryClientStore(t).get(Gt).next(function(n) {
                    // A client is eligible for the primary lease if:
                    // - its network is enabled and the client's tab is in the foreground.
                    // - its network is enabled and no other client's tab is in the
                    //   foreground.
                    // - every clients network is disabled and the client's tab is in the
                    //   foreground.
                    // - every clients network is disabled and no other client's tab is in
                    //   the foreground.
                    // - the `forceOwningTab` setting was passed in.
                    if (null !== n && _this.uo(n.leaseTimestampMs, ar) && !_this.Eo(n.ownerId)) {
                        if (_this._o(n) && _this.networkEnabled) return true;
                        if (!_this._o(n)) {
                            if (!n.allowTabSynchronization) // Fail the `canActAsPrimary` check if the current leaseholder has
                            // not opted into multi-tab synchronization. If this happens at
                            // client startup, we reject the Promise returned by
                            // `enablePersistence()` and the user can continue to use Firestore
                            // with in-memory persistence.
                            // If this fails during a lease refresh, we will instead block the
                            // AsyncQueue from executing further operations. Note that this is
                            // acceptable since mixing & matching different `synchronizeTabs`
                            // settings is not supported.
                            // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                            // no longer be turned off.
                            throw new e(ta.FAILED_PRECONDITION, ur);
                            return false;
                        }
                    }
                    return !(!_this.networkEnabled || !_this.inForeground) || __PRIVATE_clientMetadataStore(t).Qn().next(function(e) {
                        return void 0 === _this.co(e, ar).find(function(e) {
                            if (_this.clientId !== e.clientId) {
                                var _$t = !_this.networkEnabled && e.networkEnabled, _$n = !_this.inForeground && e.inForeground, r = _this.networkEnabled === e.networkEnabled;
                                if (_$t || _$n && r) return true;
                            }
                            return false;
                        });
                    });
                }).next(function(e) {
                    return _this.isPrimary !== e && __PRIVATE_logDebug(sr, "Client ".concat(e ? "is" : "is not", " eligible for a primary lease.")), e;
                });
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _this;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                // The shutdown() operations are idempotent and can be called even when
                                // start() aborted (e.g. because it couldn't acquire the persistence lease).
                                this.R_ = false, this.ho(), this.Q_ && (this.Q_.cancel(), this.Q_ = null), this.To(), this.Po();
                                // Use `SimpleDb.runTransaction` directly to avoid failing if another tab
                                // has obtained the primary lease.
                                return [
                                    4,
                                    this.j_.runTransaction("shutdown", "readwrite", [
                                        Wt,
                                        mn
                                    ], function(e) {
                                        var t = new __PRIVATE_IndexedDbTransaction(e, __PRIVATE_ListenSequence.wn);
                                        return _this.io(t).next(function() {
                                            return _this.oo(t);
                                        });
                                    })
                                ];
                            case 1:
                                _state.sent(), this.j_.close(), // Remove the entry marking the client as zombied from LocalStorage since
                                // we successfully deleted its metadata from IndexedDb.
                                this.Io();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */ key: "co",
            value: function co(e, t) {
                var _this = this;
                return e.filter(function(e) {
                    return _this.uo(e.updateTimeMs, t) && !_this.Eo(e.clientId);
                });
            }
        },
        {
            /**
     * Returns the IDs of the clients that are currently active. If multi-tab
     * is not supported, returns an array that only contains the local client's
     * ID.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ key: "Ro",
            value: function Ro() {
                var _this = this;
                return this.runTransaction("getActiveClients", "readonly", function(e) {
                    return __PRIVATE_clientMetadataStore(e).Qn().next(function(e) {
                        return _this.co(e, _r).map(function(e) {
                            return e.clientId;
                        });
                    });
                });
            }
        },
        {
            key: "started",
            get: function get() {
                return this.R_;
            }
        },
        {
            key: "getGlobalsCache",
            value: function getGlobalsCache() {
                return this.A_;
            }
        },
        {
            key: "getMutationQueue",
            value: function getMutationQueue(e, t) {
                return __PRIVATE_IndexedDbMutationQueue.Qr(e, this.serializer, t, this.referenceDelegate);
            }
        },
        {
            key: "getTargetCache",
            value: function getTargetCache() {
                return this.V_;
            }
        },
        {
            key: "getRemoteDocumentCache",
            value: function getRemoteDocumentCache() {
                return this.remoteDocumentCache;
            }
        },
        {
            key: "getIndexManager",
            value: function getIndexManager(e) {
                return new __PRIVATE_IndexedDbIndexManager(e, this.serializer.$r.databaseId);
            }
        },
        {
            key: "getDocumentOverlayCache",
            value: function getDocumentOverlayCache(e) {
                return __PRIVATE_IndexedDbDocumentOverlayCache.Qr(this.serializer, e);
            }
        },
        {
            key: "getBundleCache",
            value: function getBundleCache() {
                return this.f_;
            }
        },
        {
            key: "runTransaction",
            value: function runTransaction(t, n, r) {
                var _this = this;
                __PRIVATE_logDebug(sr, "Starting transaction:", t);
                var i = "readonly" === n ? "readonly" : "readwrite", s = /** Returns the object stores for the provided schema. */ function __PRIVATE_getObjectStores(e) {
                    return 18 === e ? tr : 17 === e ? er : 16 === e ? Xn : 15 === e ? Zn : 14 === e ? Yn : 13 === e ? Jn : 12 === e ? Hn : 11 === e ? jn : void l(60245);
                }(this.k_);
                var _;
                // Do all transactions as readwrite against all object stores, since we
                // are the only reader/writer.
                return this.j_.runTransaction(t, i, s, function(i) {
                    return _ = new __PRIVATE_IndexedDbTransaction(i, _this.I_ ? _this.I_.next() : __PRIVATE_ListenSequence.wn), "readwrite-primary" === n ? _this.no(_).next(function(e) {
                        return !!e || _this.ro(_);
                    }).next(function(n) {
                        if (!n) throw __PRIVATE_logError("Failed to obtain primary lease for action '".concat(t, "'.")), _this.isPrimary = false, _this.Ct.enqueueRetryable(function() {
                            return _this.G_(false);
                        }), new e(ta.FAILED_PRECONDITION, pt);
                        return r(_);
                    }).next(function(e) {
                        return _this.so(_).next(function() {
                            return e;
                        });
                    }) : _this.Ao(_).next(function() {
                        return r(_);
                    });
                }).then(function(e) {
                    return _.raiseOnCommittedEvent(), e;
                });
            }
        },
        {
            /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */ // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
            // be turned off.
            key: "Ao",
            value: function Ao(t) {
                var _this = this;
                return __PRIVATE_primaryClientStore(t).get(Gt).next(function(t) {
                    if (null !== t && _this.uo(t.leaseTimestampMs, ar) && !_this.Eo(t.ownerId) && !_this._o(t) && !(_this.U_ || _this.allowTabSynchronization && t.allowTabSynchronization)) throw new e(ta.FAILED_PRECONDITION, ur);
                });
            }
        },
        {
            /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */ key: "so",
            value: function so(e) {
                var t = {
                    ownerId: this.clientId,
                    allowTabSynchronization: this.allowTabSynchronization,
                    leaseTimestampMs: Date.now()
                };
                return __PRIVATE_primaryClientStore(e).put(Gt, t);
            }
        },
        {
            /** Checks the primary lease and removes it if we are the current primary. */ key: "io",
            value: function io(e) {
                var _this = this;
                var t = __PRIVATE_primaryClientStore(e);
                return t.get(Gt).next(function(e) {
                    return _this._o(e) ? (__PRIVATE_logDebug(sr, "Releasing primary lease."), t.delete(Gt)) : PersistencePromise.resolve();
                });
            }
        },
        {
            /** Verifies that `updateTimeMs` is within `maxAgeMs`. */ key: "uo",
            value: function uo(e, t) {
                var n = Date.now();
                return !(e < n - t) && (!(e > n) || (__PRIVATE_logError("Detected an update time that is in the future: ".concat(e, " > ").concat(n)), false));
            }
        },
        {
            key: "Y_",
            value: function Y_() {
                var _this = this;
                null !== this.document && "function" == typeof this.document.addEventListener && (this.K_ = function() {
                    _this.Ct.enqueueAndForget(function() {
                        return _this.inForeground = "visible" === _this.document.visibilityState, _this.J_();
                    });
                }, this.document.addEventListener("visibilitychange", this.K_), this.inForeground = "visible" === this.document.visibilityState);
            }
        },
        {
            key: "To",
            value: function To() {
                this.K_ && (this.document.removeEventListener("visibilitychange", this.K_), this.K_ = null);
            }
        },
        {
            /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */ key: "Z_",
            value: function Z_() {
                var _this = this;
                var _this_window;
                "function" == typeof ((_this_window = this.window) === null || _this_window === void 0 ? void 0 : _this_window.addEventListener) && (this.q_ = function() {
                    // Note: In theory, this should be scheduled on the AsyncQueue since it
                    // accesses internal state. We execute this code directly during shutdown
                    // to make sure it gets a chance to run.
                    _this.ho();
                    var e = /(?:Version|Mobile)\/1[456]/;
                    (0, $hk14n.isSafari)() && (navigator.appVersion.match(e) || navigator.userAgent.match(e)) && // On Safari 14, 15, and 16, we do not run any cleanup actions as it might
                    // trigger a bug that prevents Safari from re-opening IndexedDB during
                    // the next page load.
                    // See https://bugs.webkit.org/show_bug.cgi?id=226547
                    _this.Ct.enterRestrictedMode(/* purgeExistingTasks= */ true), _this.Ct.enqueueAndForget(function() {
                        return _this.shutdown();
                    });
                }, this.window.addEventListener("pagehide", this.q_));
            }
        },
        {
            key: "Po",
            value: function Po() {
                this.q_ && (this.window.removeEventListener("pagehide", this.q_), this.q_ = null);
            }
        },
        {
            /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */ key: "Eo",
            value: function Eo(e) {
                try {
                    var _this_H_;
                    var t = null !== ((_this_H_ = this.H_) === null || _this_H_ === void 0 ? void 0 : _this_H_.getItem(this.lo(e)));
                    return __PRIVATE_logDebug(sr, "Client '".concat(e, "' ").concat(t ? "is" : "is not", " zombied in LocalStorage")), t;
                } catch (e) {
                    // Gracefully handle if LocalStorage isn't working.
                    return __PRIVATE_logError(sr, "Failed to get zombied client id.", e), false;
                }
            }
        },
        {
            /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */ key: "ho",
            value: function ho() {
                if (this.H_) try {
                    this.H_.setItem(this.lo(this.clientId), String(Date.now()));
                } catch (e) {
                    // Gracefully handle if LocalStorage isn't available / working.
                    __PRIVATE_logError("Failed to set zombie client id.", e);
                }
            }
        },
        {
            /** Removes the zombied client entry if it exists. */ key: "Io",
            value: function Io() {
                if (this.H_) try {
                    this.H_.removeItem(this.lo(this.clientId));
                } catch (e) {
                // Ignore
                }
            }
        },
        {
            key: "lo",
            value: function lo(e) {
                return "firestore_zombie_".concat(this.persistenceKey, "_").concat(e);
            }
        }
    ], [
        {
            key: "Ye",
            value: function Ye() {
                return __PRIVATE_SimpleDb.Ye();
            }
        }
    ]);
    return __PRIVATE_IndexedDbPersistence;
}();
/**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */ function __PRIVATE_primaryClientStore(e) {
    return __PRIVATE_getStore(e, Wt);
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */ function __PRIVATE_clientMetadataStore(e) {
    return __PRIVATE_getStore(e, mn);
}
/**
 * Generates a string used as a prefix when storing data in IndexedDB and
 * LocalStorage.
 */ function __PRIVATE_indexedDbStoragePrefix(e, t) {
    // Use two different prefix formats:
    //   * firestore / persistenceKey / projectID . databaseID / ...
    //   * firestore / persistenceKey / projectID / ...
    // projectIDs are DNS-compatible names and cannot contain dots
    // so there's no danger of collisions.
    var n = e.projectId;
    return e.isDefaultDatabase || (n += "." + e.database), "firestore/" + t + "/" + n + "/";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */ var __PRIVATE_LocalViewChanges = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_LocalViewChanges(e, t, n, r) {
        (0, $4QweW._)(this, __PRIVATE_LocalViewChanges);
        this.targetId = e, this.fromCache = t, this.Vo = n, this.fo = r;
    }
    (0, $6hK4i._)(__PRIVATE_LocalViewChanges, null, [
        {
            key: "mo",
            value: function mo(e, t) {
                var n = __PRIVATE_documentKeySet(), r = __PRIVATE_documentKeySet();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = t.docChanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$e = _step.value;
                        switch(_$e.type){
                            case 0 /* ChangeType.Added */ :
                                n = n.add(_$e.doc.key);
                                break;
                            case 1 /* ChangeType.Removed */ :
                                r = r.add(_$e.doc.key);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return new __PRIVATE_LocalViewChanges(e, t.fromCache, n, r);
            }
        }
    ]);
    return __PRIVATE_LocalViewChanges;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function __PRIVATE_compareByKey(e, t) {
    return DocumentKey.comparator(e.key, t.key);
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A tracker to keep a record of important details during database local query
 * execution.
 */ var QueryContext = /*#__PURE__*/ function() {
    "use strict";
    function QueryContext() {
        (0, $4QweW._)(this, QueryContext);
        /**
         * Counts the number of documents passed through during local query execution.
         */ this._documentReadCount = 0;
    }
    (0, $6hK4i._)(QueryContext, [
        {
            key: "documentReadCount",
            get: function get() {
                return this._documentReadCount;
            }
        },
        {
            key: "incrementDocumentReadCount",
            value: function incrementDocumentReadCount(e) {
                this._documentReadCount += e;
            }
        }
    ]);
    return QueryContext;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The Firestore query engine.
 *
 * Firestore queries can be executed in three modes. The Query Engine determines
 * what mode to use based on what data is persisted. The mode only determines
 * the runtime complexity of the query - the result set is equivalent across all
 * implementations.
 *
 * The Query engine will use indexed-based execution if a user has configured
 * any index that can be used to execute query (via `setIndexConfiguration()`).
 * Otherwise, the engine will try to optimize the query by re-using a previously
 * persisted query result. If that is not possible, the query will be executed
 * via a full collection scan.
 *
 * Index-based execution is the default when available. The query engine
 * supports partial indexed execution and merges the result from the index
 * lookup with documents that have not yet been indexed. The index evaluation
 * matches the backend's format and as such, the SDK can use indexing for all
 * queries that the backend supports.
 *
 * If no index exists, the query engine tries to take advantage of the target
 * document mapping in the TargetCache. These mappings exists for all queries
 * that have been synced with the backend at least once and allow the query
 * engine to only read documents that previously matched a query plus any
 * documents that were edited after the query was last listened to.
 *
 * There are some cases when this optimization is not guaranteed to produce
 * the same results as full collection scans. In these cases, query
 * processing falls back to full scans. These cases are:
 *
 * - Limit queries where a document that matched the query previously no longer
 *   matches the query.
 *
 * - Limit queries where a document edit may cause the document to sort below
 *   another document that is in the local cache.
 *
 * - Queries that have never been CURRENT or free of limbo documents.
 */ var __PRIVATE_QueryEngine = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_QueryEngine() {
        (0, $4QweW._)(this, __PRIVATE_QueryEngine);
        this.po = false, this.yo = false, /**
         * SDK only decides whether it should create index when collection size is
         * larger than this.
         */ this.wo = 100, this.bo = /**
 * This cost represents the evaluation result of
 * (([index, docKey] + [docKey, docContent]) per document in the result set)
 * / ([docKey, docContent] per documents in full collection scan) coming from
 * experiment [enter PR experiment URL here].
 */ function __PRIVATE_getDefaultRelativeIndexReadCostPerDocument() {
            // These values were derived from an experiment where several members of the
            // Firestore SDK team ran a performance test in various environments.
            // Googlers can see b/299284287 for details.
            return (0, $hk14n.isSafari)() ? 8 : __PRIVATE_getAndroidVersion((0, $hk14n.getUA)()) > 0 ? 6 : 4;
        }();
    }
    (0, $6hK4i._)(__PRIVATE_QueryEngine, [
        {
            /** Sets the document view to query against. */ key: "initialize",
            value: function initialize(e, t) {
                this.So = e, this.indexManager = t, this.po = true;
            }
        },
        {
            /** Returns all local documents matching the specified query. */ key: "getDocumentsMatchingQuery",
            value: function getDocumentsMatchingQuery(e, t, n, r) {
                var _this = this;
                // Stores the result from executing the query; using this object is more
                // convenient than passing the result between steps of the persistence
                // transaction and improves readability comparatively.
                var i = {
                    result: null
                };
                return this.vo(e, t).next(function(e) {
                    i.result = e;
                }).next(function() {
                    if (!i.result) return _this.Do(e, t, r, n).next(function(e) {
                        i.result = e;
                    });
                }).next(function() {
                    if (i.result) return;
                    var n = new QueryContext;
                    return _this.xo(e, t, n).next(function(r) {
                        if (i.result = r, _this.yo) return _this.Co(e, t, n, r.size);
                    });
                }).next(function() {
                    return i.result;
                });
            }
        },
        {
            key: "Co",
            value: function Co(e, t, n, r) {
                return __PRIVATE_isPipeline(t) ? PersistencePromise.resolve() : n.documentReadCount < this.wo ? (__PRIVATE_getLogLevel() <= (0, $5eJAc.LogLevel).DEBUG && __PRIVATE_logDebug("QueryEngine", "SDK will not create cache indexes for query:", __PRIVATE_stringifyQuery(t), "since it only creates cache indexes for collection contains", "more than or equal to", this.wo, "documents"), PersistencePromise.resolve()) : (__PRIVATE_getLogLevel() <= (0, $5eJAc.LogLevel).DEBUG && __PRIVATE_logDebug("QueryEngine", "Query:", __PRIVATE_stringifyQuery(t), "scans", n.documentReadCount, "local documents and returns", r, "documents as results."), n.documentReadCount > this.bo * r ? (__PRIVATE_getLogLevel() <= (0, $5eJAc.LogLevel).DEBUG && __PRIVATE_logDebug("QueryEngine", "The SDK decides to create cache indexes for query:", __PRIVATE_stringifyQuery(t), "as using cache indexes may help improve performance."), this.indexManager.createTargetIndexes(e, __PRIVATE_queryToTarget(t))) : PersistencePromise.resolve());
            }
        },
        {
            /**
     * Performs an indexed query that evaluates the query based on a collection's
     * persisted index values. Returns `null` if an index is not available.
     */ key: "vo",
            value: function vo(e, t) {
                var _this = this;
                if (__PRIVATE_isPipeline(t)) return PersistencePromise.resolve(null);
                var n = t;
                if (__PRIVATE_queryMatchesAllDocuments(n)) // Queries that match all documents don't benefit from using
                // key-based lookups. It is more efficient to scan all documents in a
                // collection, rather than to perform individual lookups.
                return PersistencePromise.resolve(null);
                var r = __PRIVATE_queryToTarget(n);
                return this.indexManager.getIndexType(e, r).next(function(t) {
                    return 0 /* IndexType.NONE */  === t ? null : (null !== n.limit && 1 /* IndexType.PARTIAL */  === t && // We cannot apply a limit for targets that are served using a partial
                    // index. If a partial index will be used to serve the target, the
                    // query may return a superset of documents that match the target
                    // (e.g. if the index doesn't include all the target's filters), or
                    // may return the correct set of documents in the wrong order (e.g. if
                    // the index doesn't include a segment for one of the orderBys).
                    // Therefore, a limit should not be applied in such cases.
                    (n = __PRIVATE_queryWithLimit(n, null, "F" /* LimitType.First */ ), r = __PRIVATE_queryToTarget(n)), _this.indexManager.getDocumentsMatchingTarget(e, r).next(function(t) {
                        var i = __PRIVATE_documentKeySet.apply(void 0, (0, $jlUaU._)(t));
                        return _this.So.getDocuments(e, i).next(function(t) {
                            return _this.indexManager.getMinOffset(e, r).next(function(r) {
                                var s = _this.Fo(n, t);
                                return _this.Oo(n, s, i, r.readTime) ? _this.vo(e, __PRIVATE_queryWithLimit(n, null, "F" /* LimitType.First */ )) : _this.Mo(e, s, n, r);
                            });
                        });
                    }));
                });
            }
        },
        {
            /**
     * Performs a query based on the target's persisted query mapping. Returns
     * `null` if the mapping is not available or cannot be used.
     */ key: "Do",
            value: function Do(e, t, n, r) {
                var _this = this;
                return (__PRIVATE_isPipeline(t) ? function __PRIVATE_pipelineMatchesAllDocuments(e) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = e.stages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$t = _step.value;
                            if (_$t instanceof v || _$t instanceof I) return false;
                            // Check if it's the special 'exists(__name__)' case
                            if (_$t instanceof A) {
                                if (_$t.condition instanceof __PRIVATE_BooleanFunctionExpression && "exists" === _$t.condition._expr.name && _$t.condition._expr.params[0] instanceof o && _$t.condition._expr.params[0].fieldName === Ce) continue;
                                return false;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return true;
                }(t) : __PRIVATE_queryMatchesAllDocuments(t)) || r.isEqual(SnapshotVersion.min()) ? PersistencePromise.resolve(null) : this.So.getDocuments(e, n).next(function(i) {
                    var s = _this.Fo(t, i);
                    return _this.Oo(t, s, n, r) ? PersistencePromise.resolve(null) : (__PRIVATE_getLogLevel() <= (0, $5eJAc.LogLevel).DEBUG && __PRIVATE_logDebug("QueryEngine", "Re-using previous result from %s to execute query: %s", r.toString(), __PRIVATE_stringifyQueryOrPipeline(t)), _this.Mo(e, s, t, __PRIVATE_newIndexOffsetSuccessorFromReadTime(r, Xe)).next(function(e) {
                        return e;
                    }));
                });
            // Queries that have never seen a snapshot without limbo free documents
            // should also be run as a full collection scan.
            }
        },
        {
            /** Applies the query filter and sorting to the provided documents.  */ key: "Fo",
            value: function Fo(e, t) {
                var n, r;
                return __PRIVATE_isPipeline(e) ? // TODO(pipeline): the order here does not actually matter, not until we implement
                // refill logic for pipelines as well.
                (n = new SortedSet(__PRIVATE_compareByKey), r = function(t) {
                    return __PRIVATE_pipelineMatches(e, t);
                }) : // Sort the documents and re-apply the query filter since previously
                // matching documents do not necessarily still match the query.
                (n = new SortedSet(__PRIVATE_newQueryComparator(e)), r = function(t) {
                    return __PRIVATE_queryMatches(e, t);
                }), t.forEach(function(e, t) {
                    r(t) && (n = n.add(t));
                }), n;
            }
        },
        {
            /**
     * Determines if a limit query needs to be refilled from cache, making it
     * ineligible for index-free execution.
     *
     * @param query - The query.
     * @param sortedPreviousResults - The documents that matched the query when it
     * was last synchronized, sorted by the query's comparator.
     * @param remoteKeys - The document keys that matched the query at the last
     * snapshot.
     * @param limboFreeSnapshotVersion - The version of the snapshot when the
     * query was last synchronized.
     */ key: "Oo",
            value: function Oo(e, t, n, r) {
                // TODO(pipeline): For pipelines it is simple for now, we refill for all limit/offset.
                // we should implement a similar approach for query at some point.
                if (__PRIVATE_isPipeline(e)) return function __PRIVATE_pipelineHasRanges(e) {
                    return e.stages.some(function(e) {
                        return e instanceof v || e instanceof I;
                    });
                }(e);
                if (null === e.limit) // Queries without limits do not need to be refilled.
                return false;
                if (n.size !== t.size) // The query needs to be refilled if a previously matching document no
                // longer matches.
                return true;
                // Limit queries are not eligible for index-free query execution if there is
                // a potential that an older document from cache now sorts before a document
                // that was previously part of the limit. This, however, can only happen if
                // the document at the edge of the limit goes out of limit.
                // If a document that is not the limit boundary sorts differently,
                // the boundary of the limit itself did not change and documents from cache
                // will continue to be "rejected" by this boundary. Therefore, we can ignore
                // any modifications that don't affect the last document.
                var i = "F" /* LimitType.First */  === e.limitType ? t.last() : t.first();
                return !!i && (i.hasPendingWrites || i.version.compareTo(r) > 0);
            }
        },
        {
            key: "xo",
            value: function xo(e, t, n) {
                return __PRIVATE_getLogLevel() <= (0, $5eJAc.LogLevel).DEBUG && __PRIVATE_logDebug("QueryEngine", "Using full collection scan to execute query:", __PRIVATE_stringifyQueryOrPipeline(t)), this.So.getDocumentsMatchingQuery(e, t, IndexOffset.min(), n);
            }
        },
        {
            /**
     * Combines the results from an indexed execution with the remaining documents
     * that have not yet been indexed.
     */ key: "Mo",
            value: function Mo(e, t, n, r) {
                // Retrieve all results for documents that were updated since the offset.
                return this.So.getDocumentsMatchingQuery(e, n, r).next(function(e) {
                    return(// Merge with existing results
                    t.forEach(function(t) {
                        e = e.insert(t.key, t);
                    }), e);
                });
            }
        }
    ]);
    return __PRIVATE_QueryEngine;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var lr = "LocalStore", Er = 3e8;
/**
 * The maximum time to leave a resume token buffered without writing it out.
 * This value is arbitrary: it's long enough to avoid several writes
 * (possibly indefinitely if updates come more frequently than this) but
 * short enough that restarting after crashing will still have a pretty
 * recent resume token.
 */ /**
 * Implements `LocalStore` interface.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ var __PRIVATE_LocalStoreImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_LocalStoreImpl(/** Manages our in-memory or durable persistence. */ e, t, n, r) {
        (0, $4QweW._)(this, __PRIVATE_LocalStoreImpl);
        this.persistence = e, this.No = t, this.serializer = r, /**
         * Maps a targetID to data about its target.
         *
         * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
         * of `applyRemoteEvent()` idempotent.
         */ this.Lo = new SortedMap(__PRIVATE_primitiveComparator), /** Maps a target to its targetID. */ // TODO(wuandy): Evaluate if TargetId can be part of Target.
        this.Bo = new ObjectMap(function(e) {
            return __PRIVATE_canonifyTargetOrPipeline(e);
        }, __PRIVATE_targetOrPipelineEqual), /**
         * A per collection group index of the last read time processed by
         * `getNewDocumentChanges()`.
         *
         * PORTING NOTE: This is only used for multi-tab synchronization.
         */ this.Uo = new Map, this.ko = e.getRemoteDocumentCache(), this.V_ = e.getTargetCache(), this.f_ = e.getBundleCache(), this.qo(n);
    }
    (0, $6hK4i._)(__PRIVATE_LocalStoreImpl, [
        {
            key: "qo",
            value: function qo(e) {
                // TODO(indexing): Add spec tests that test these components change after a
                // user change
                this.documentOverlayCache = this.persistence.getDocumentOverlayCache(e), this.indexManager = this.persistence.getIndexManager(e), this.mutationQueue = this.persistence.getMutationQueue(e, this.indexManager), this.localDocuments = new LocalDocumentsView(this.ko, this.mutationQueue, this.documentOverlayCache, this.indexManager), this.ko.setIndexManager(this.indexManager), this.No.initialize(this.localDocuments, this.indexManager);
            }
        },
        {
            key: "collectGarbage",
            value: function collectGarbage(e) {
                var _this = this;
                return this.persistence.runTransaction("Collect garbage", "readwrite-primary", function(t) {
                    return e.collect(t, _this.Lo);
                });
            }
        }
    ]);
    return __PRIVATE_LocalStoreImpl;
}();
function __PRIVATE_newLocalStore(/** Manages our in-memory or durable persistence. */ e, t, n, r) {
    return new __PRIVATE_LocalStoreImpl(e, t, n, r);
}
/**
 * Tells the LocalStore that the currently authenticated user has changed.
 *
 * In response the local store switches the mutation queue to the new user and
 * returns any resulting document changes.
 */ // PORTING NOTE: Android and iOS only return the documents affected by the
// change.
function __PRIVATE_localStoreHandleUserChange(e, t) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var n;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = __PRIVATE_debugCast(e);
                    return [
                        4,
                        n.persistence.runTransaction("Handle user change", "readonly", function(e) {
                            // Swap out the mutation queue, grabbing the pending mutation batches
                            // before and after.
                            var r;
                            return n.mutationQueue.getAllMutationBatches(e).next(function(i) {
                                return r = i, n.qo(t), n.mutationQueue.getAllMutationBatches(e);
                            }).next(function(t) {
                                var i = [], s = [];
                                // Union the old/new changed keys.
                                var _ = __PRIVATE_documentKeySet();
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _$e = _step.value;
                                        i.push(_$e.batchId);
                                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                        try {
                                            for(var _iterator1 = _$e.mutations[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                                var _$t = _step1.value;
                                                _ = _.add(_$t.key);
                                            }
                                        } catch (err) {
                                            _didIteratorError1 = true;
                                            _iteratorError1 = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                    _iterator1.return();
                                                }
                                            } finally{
                                                if (_didIteratorError1) {
                                                    throw _iteratorError1;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                try {
                                    for(var _iterator2 = t[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                        var _$e1 = _step2.value;
                                        s.push(_$e1.batchId);
                                        var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                                        try {
                                            for(var _iterator3 = _$e1.mutations[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                                var _$t1 = _step3.value;
                                                _ = _.add(_$t1.key);
                                            }
                                        } catch (err) {
                                            _didIteratorError3 = true;
                                            _iteratorError3 = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                                    _iterator3.return();
                                                }
                                            } finally{
                                                if (_didIteratorError3) {
                                                    throw _iteratorError3;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                            _iterator2.return();
                                        }
                                    } finally{
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }
                                // Return the set of all (potentially) changed documents and the list
                                // of mutation batch IDs that were affected by change.
                                return n.localDocuments.getDocuments(e, _).next(function(e) {
                                    return {
                                        $o: e,
                                        removedBatchIds: i,
                                        addedBatchIds: s
                                    };
                                });
                            });
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    })();
}
/* Accepts locally generated Mutations and commit them to storage. */ /**
 * Acknowledges the given batch.
 *
 * On the happy path when a batch is acknowledged, the local store will
 *
 *  + remove the batch from the mutation queue;
 *  + apply the changes to the remote document cache;
 *  + recalculate the latency compensated view implied by those changes (there
 *    may be mutations in the queue that affect the documents but haven't been
 *    acknowledged yet); and
 *  + give the changed documents back the sync engine
 *
 * @returns The resulting (modified) documents.
 */ function __PRIVATE_localStoreAcknowledgeBatch(e, t) {
    var n = __PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", function(e) {
        var r = t.batch.keys(), i = n.ko.newChangeBuffer({
            trackRemovals: true
        });
        return (function __PRIVATE_applyWriteToRemoteDocuments(e, t, n, r) {
            var i = n.batch, s = i.keys();
            var _ = PersistencePromise.resolve();
            return s.forEach(function(e) {
                _ = _.next(function() {
                    return r.getEntry(t, e);
                }).next(function(t) {
                    var s = n.docVersions.get(e);
                    __PRIVATE_hardAssert(null !== s, 48541), t.version.compareTo(s) < 0 && (i.applyToRemoteDocument(t, n), t.isValidDocument() && // We use the commitVersion as the readTime rather than the
                    // document's updateTime since the updateTime is not advanced
                    // for updates that do not modify the underlying document.
                    (t.setReadTime(n.commitVersion), r.addEntry(t)));
                });
            }), _.next(function() {
                return e.mutationQueue.removeMutationBatch(t, i);
            });
        })(n, e, t, i).next(function() {
            return i.apply(e);
        }).next(function() {
            return n.mutationQueue.performConsistencyCheck(e);
        }).next(function() {
            return n.documentOverlayCache.removeOverlaysForBatchId(e, r, t.batch.batchId);
        }).next(function() {
            return n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, function __PRIVATE_getKeysWithTransformResults(e) {
                var _$t = __PRIVATE_documentKeySet();
                for(var n = 0; n < e.mutationResults.length; ++n)e.mutationResults[n].transformResults.length > 0 && (_$t = _$t.add(e.batch.mutations[n].key));
                return _$t;
            }(t));
        }).next(function() {
            return n.localDocuments.getDocuments(e, r);
        });
    });
}
/**
 * Returns the last consistent snapshot processed (used by the RemoteStore to
 * determine whether to buffer incoming snapshots from the backend).
 */ function __PRIVATE_localStoreGetLastRemoteSnapshotVersion(e) {
    var t = __PRIVATE_debugCast(e);
    return t.persistence.runTransaction("Get last remote snapshot version", "readonly", function(e) {
        return t.V_.getLastRemoteSnapshotVersion(e);
    });
}
/**
 * Updates the "ground-state" (remote) documents. We assume that the remote
 * event reflects any write batches that have been acknowledged or rejected
 * (i.e. we do not re-apply local mutations to updates from this event).
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ function __PRIVATE_localStoreApplyRemoteEventToLocalCache(e, t) {
    var n = __PRIVATE_debugCast(e), r = t.snapshotVersion;
    var i = n.Lo;
    return n.persistence.runTransaction("Apply remote event", "readwrite-primary", function(e) {
        var s = n.ko.newChangeBuffer({
            trackRemovals: true
        });
        // Reset newTargetDataByTargetMap in case this transaction gets re-run.
        i = n.Lo;
        var _ = [];
        t.targetChanges.forEach(function(s, o) {
            var a = i.get(o);
            if (!a) return;
            // Only update the remote keys if the target is still active. This
            // ensures that we can persist the updated target data along with
            // the updated assignment.
            _.push(n.V_.removeMatchingKeys(e, s.removedDocuments, o).next(function() {
                return n.V_.addMatchingKeys(e, s.addedDocuments, o);
            }));
            var u = a.withSequenceNumber(e.currentSequenceNumber);
            null !== t.targetMismatches.get(o) ? u = u.withResumeToken(ByteString.EMPTY_BYTE_STRING, SnapshotVersion.min()).withLastLimboFreeSnapshotVersion(SnapshotVersion.min()) : s.resumeToken.approximateByteSize() > 0 && (u = u.withResumeToken(s.resumeToken, r)), i = i.insert(o, u), // Update the target data if there are target changes (or if
            // sufficient time has passed since the last update).
            /**
 * Returns true if the newTargetData should be persisted during an update of
 * an active target. TargetData should always be persisted when a target is
 * being released and should not call this function.
 *
 * While the target is active, TargetData updates can be omitted when nothing
 * about the target has changed except metadata like the resume token or
 * snapshot version. Occasionally it's worth the extra write to prevent these
 * values from getting too stale after a crash, but this doesn't have to be
 * too frequent.
 */ function __PRIVATE_shouldPersistTargetData(e, t, n) {
                // Always persist target data if we don't already have a resume token.
                if (0 === e.resumeToken.approximateByteSize()) return true;
                // Don't allow resume token changes to be buffered indefinitely. This
                // allows us to be reasonably up-to-date after a crash and avoids needing
                // to loop over all active queries on shutdown. Especially in the browser
                // we may not get time to do anything interesting while the current tab is
                // closing.
                var r = t.snapshotVersion.toMicroseconds() - e.snapshotVersion.toMicroseconds();
                if (r >= Er) return true;
                // Otherwise if the only thing that has changed about a target is its resume
                // token it's not worth persisting. Note that the RemoteStore keeps an
                // in-memory view of the currently active targets which includes the current
                // resume token, so stream failure or user changes will still use an
                // up-to-date resume token regardless of what we do here.
                var i = n.addedDocuments.size + n.modifiedDocuments.size + n.removedDocuments.size;
                return i > 0;
            }(a, u, s) && _.push(n.V_.updateTargetData(e, u));
        });
        var o = __PRIVATE_mutableDocumentMap(), a = __PRIVATE_documentKeySet();
        // HACK: The only reason we allow a null snapshot version is so that we
        // can synthesize remote events when we get permission denied errors while
        // trying to resolve the state of a locally cached document that is in
        // limbo.
        if (t.documentUpdates.forEach(function(r) {
            t.resolvedLimboDocuments.has(r) && _.push(n.persistence.referenceDelegate.updateLimboDocument(e, r));
        }), // Each loop iteration only affects its "own" doc, so it's safe to get all
        // the remote documents in advance in a single call.
        _.push(__PRIVATE_populateDocumentChangeBuffer(e, s, t.documentUpdates).next(function(e) {
            o = e.Ko, a = e.Qo;
        })), !r.isEqual(SnapshotVersion.min())) {
            var _$t = n.V_.getLastRemoteSnapshotVersion(e).next(function(t) {
                return n.V_.setTargetsMetadata(e, e.currentSequenceNumber, r);
            });
            _.push(_$t);
        }
        return PersistencePromise.waitFor(_).next(function() {
            return s.apply(e);
        }).next(function() {
            return n.localDocuments.getLocalViewOfDocuments(e, o, a);
        }).next(function() {
            return o;
        });
    }).then(function(e) {
        return n.Lo = i, e;
    });
}
/**
 * Populates document change buffer with documents from backend or a bundle.
 * Returns the document changes resulting from applying those documents, and
 * also a set of documents whose existence state are changed as a result.
 *
 * @param txn - Transaction to use to read existing documents from storage.
 * @param documentBuffer - Document buffer to collect the resulted changes to be
 *        applied to storage.
 * @param documents - Documents to be applied.
 */ function __PRIVATE_populateDocumentChangeBuffer(e, t, n) {
    var r = __PRIVATE_documentKeySet(), i = __PRIVATE_documentKeySet();
    return n.forEach(function(e) {
        return r = r.add(e);
    }), t.getEntries(e, r).next(function(e) {
        var r = __PRIVATE_mutableDocumentMap();
        return n.forEach(function(n, s) {
            var _ = e.get(n);
            // Check if see if there is a existence state change for this document.
            s.isFoundDocument() !== _.isFoundDocument() && (i = i.add(n)), // Note: The order of the steps below is important, since we want
            // to ensure that rejected limbo resolutions (which fabricate
            // NoDocuments with SnapshotVersion.min()) never add documents to
            // cache.
            s.isNoDocument() && s.version.isEqual(SnapshotVersion.min()) ? // NoDocuments with SnapshotVersion.min() are used in manufactured
            // events. We remove these documents from cache since we lost
            // access.
            (t.removeEntry(n, s.readTime), r = r.insert(n, s)) : !_.isValidDocument() || s.version.compareTo(_.version) > 0 || 0 === s.version.compareTo(_.version) && _.hasPendingWrites ? (t.addEntry(s), r = r.insert(n, s)) : __PRIVATE_logDebug(lr, "Ignoring outdated watch update for ", n, ". Current version:", _.version, " Watch version:", s.version);
        }), {
            Ko: r,
            Qo: i
        };
    });
}
/**
 * Gets the mutation batch after the passed in batchId in the mutation queue
 * or null if empty.
 * @param afterBatchId - If provided, the batch to search after.
 * @returns The next mutation or null if there wasn't one.
 */ function __PRIVATE_localStoreGetNextMutationBatch(e, t) {
    var n = __PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Get next mutation batch", "readonly", function(e) {
        return void 0 === t && (t = Ke), n.mutationQueue.getNextMutationBatchAfterBatchId(e, t);
    });
}
/**
 * Reads the current value of a Document with a given key or null if not
 * found - used for testing.
 */ /**
 * Assigns the given target an internal ID so that its results can be pinned so
 * they don't get GC'd. A target must be allocated in the local store before
 * the store can be used to manage its view.
 *
 * Allocating an already allocated `Target` will return the existing `TargetData`
 * for that `Target`.
 */ function __PRIVATE_localStoreAllocateTarget(e, t) {
    var n = __PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Allocate target", "readwrite", function(e) {
        var r;
        return n.V_.getTargetData(e, t).next(function(i) {
            return i ? // This target has been listened to previously, so reuse the
            // previous targetID.
            // TODO(mcg): freshen last accessed date?
            (r = i, PersistencePromise.resolve(r)) : n.V_.allocateTargetId(e).next(function(i) {
                return r = new TargetData(t, i, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.currentSequenceNumber), n.V_.addTargetData(e, r).next(function() {
                    return r;
                });
            });
        });
    }).then(function(e) {
        // If Multi-Tab is enabled, the existing target data may be newer than
        // the in-memory data
        var r = n.Lo.get(e.targetId);
        return (null === r || e.snapshotVersion.compareTo(r.snapshotVersion) > 0) && (n.Lo = n.Lo.insert(e.targetId, e), n.Bo.set(t, e.targetId)), e;
    });
}
/**
 * Returns the TargetData as seen by the LocalStore, including updates that may
 * have not yet been persisted to the TargetCache.
 */ // Visible for testing.
/**
 * Unpins all the documents associated with the given target. If
 * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
 * directly removes the associated target data from the target cache.
 *
 * Releasing a non-existing `Target` is a no-op.
 */ // PORTING NOTE: `keepPersistedTargetData` is multi-tab only.
function __PRIVATE_localStoreReleaseTarget(e, t, n) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var r, i, s, _tmp, e1;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = __PRIVATE_debugCast(e), i = r.Lo.get(t), s = n ? "readwrite" : "readwrite-primary";
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    _tmp = n;
                    if (_tmp) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        r.persistence.runTransaction("Release target", s, function(e) {
                            return r.persistence.referenceDelegate.removeTarget(e, i);
                        })
                    ];
                case 2:
                    _tmp = _state.sent();
                    _state.label = 3;
                case 3:
                    _tmp;
                    return [
                        3,
                        5
                    ];
                case 4:
                    e1 = _state.sent();
                    if (!__PRIVATE_isIndexedDbTransactionError(e1)) throw e1;
                    // All `releaseTarget` does is record the final metadata state for the
                    // target, but we've been recording this periodically during target
                    // activity. If we lose this write this could cause a very slight
                    // difference in the order of target deletion during GC, but we
                    // don't define exact LRU semantics so this is acceptable.
                    __PRIVATE_logDebug(lr, "Failed to update sequence numbers for target ".concat(t, ": ").concat(e1));
                    return [
                        3,
                        5
                    ];
                case 5:
                    r.Lo = r.Lo.remove(t), // TODO(pipeline): This needs to handle pipeline properly.
                    r.Bo.delete(i.target);
                    return [
                        2
                    ];
            }
        });
    })();
}
/**
 * Runs the specified query against the local store and returns the results,
 * potentially taking advantage of query data from previous executions (such
 * as the set of remote keys).
 *
 * @param usePreviousResults - Whether results from previous executions can
 * be used to optimize this query execution.
 */ function __PRIVATE_localStoreExecuteQuery(e, t, n) {
    var r = __PRIVATE_debugCast(e);
    var i = SnapshotVersion.min(), s = __PRIVATE_documentKeySet();
    return r.persistence.runTransaction("Execute query", "readwrite", // Use readwrite instead of readonly so indexes can be created
    function(e) {
        return (function __PRIVATE_localStoreGetTargetData(e, t, n) {
            var r = __PRIVATE_debugCast(e), i = r.Bo.get(n);
            return void 0 !== i ? PersistencePromise.resolve(r.Lo.get(i)) : r.V_.getTargetData(t, n);
        })(r, e, __PRIVATE_isPipeline(t) ? t : __PRIVATE_queryToTarget(t)).next(function(t) {
            if (t) return i = t.lastLimboFreeSnapshotVersion, r.V_.getMatchingKeysForTargetId(e, t.targetId).next(function(e) {
                s = e;
            });
        }).next(function() {
            return r.No.getDocumentsMatchingQuery(e, t, n ? i : SnapshotVersion.min(), n ? s : __PRIVATE_documentKeySet());
        }).next(function(e) {
            return(// TODO(pipeline): this needs to be adapted to support other pipeline flavors.
            // For now, only 'exact' flavor is supported and it is enough.
            __PRIVATE_setMaxReadTime(r, e), {
                documents: e,
                Wo: s
            });
        });
    });
}
// PORTING NOTE: Multi-Tab only.
function __PRIVATE_localStoreGetCachedTarget(e, t) {
    var n = __PRIVATE_debugCast(e), r = __PRIVATE_debugCast(n.V_), i = n.Lo.get(t);
    var _i_target;
    return i ? Promise.resolve((_i_target = i.target) !== null && _i_target !== void 0 ? _i_target : null) : n.persistence.runTransaction("Get target data", "readonly", function(e) {
        return r.ye(e, t).next(function(e) {
            var _e_target;
            return (_e_target = e === null || e === void 0 ? void 0 : e.target) !== null && _e_target !== void 0 ? _e_target : null;
        });
    });
}
// PORTING NOTE: Multi-Tab only.
/**
 * Returns the set of documents that have been updated since the last call.
 * If this is the first call, returns the set of changes since client
 * initialization. Further invocations will return document that have changed
 * since the prior call.
 */ // PORTING NOTE: Multi-Tab only.
function __PRIVATE_localStoreGetNewDocumentChanges(e, t) {
    var n = __PRIVATE_debugCast(e), r = n.Uo.get(t) || SnapshotVersion.min();
    // Get the current maximum read time for the collection. This should always
    // exist, but to reduce the chance for regressions we default to
    // SnapshotVersion.Min()
    // TODO(indexing): Consider removing the default value.
    return n.persistence.runTransaction("Get new document changes", "readonly", function(e) {
        return n.ko.getAllFromCollectionGroup(e, t, __PRIVATE_newIndexOffsetSuccessorFromReadTime(r, Xe), /* limit= */ Number.MAX_SAFE_INTEGER);
    }).then(function(e) {
        return __PRIVATE_setMaxReadTime(n, e), e;
    });
}
/** Sets the collection group's maximum read time from the given documents. */ // PORTING NOTE: Multi-Tab only.
function __PRIVATE_setMaxReadTime(e, t) {
    t.forEach(function(t, n) {
        var r = n.key.getCollectionGroup(), i = e.Uo.get(r) || SnapshotVersion.min();
        n.readTime.compareTo(i) > 0 && e.Uo.set(r, n.readTime);
    });
}
/**
 * Creates a new target using the given bundle name, which will be used to
 * hold the keys of all documents from the bundle in query-document mappings.
 * This ensures that the loaded documents do not get garbage collected
 * right away.
 */ /**
 * Applies the documents from a bundle to the "ground-state" (remote)
 * documents.
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ function __PRIVATE_localStoreApplyBundledDocuments(e, t, n, r) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var i, s, _, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _$e, _$n, _$r, o, a;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    i = __PRIVATE_debugCast(e);
                    s = __PRIVATE_documentKeySet(), _ = __PRIVATE_mutableDocumentMap();
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = n[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            _$e = _step.value;
                            _$n = t.Go(_$e.metadata.name);
                            _$e.document && (s = s.add(_$n));
                            _$r = t.zo(_$e);
                            _$r.setReadTime(t.jo(_$e.metadata.readTime)), _ = _.insert(_$n, _$r);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    o = i.ko.newChangeBuffer({
                        trackRemovals: true
                    });
                    return [
                        4,
                        __PRIVATE_localStoreAllocateTarget(i, function __PRIVATE_umbrellaTarget(e) {
                            // It is OK that the path used for the query is not valid, because this will
                            // not be read and queried.
                            return __PRIVATE_queryToTarget(__PRIVATE_newQueryForPath(ResourcePath.fromString("__bundle__/docs/".concat(e))));
                        }(r))
                    ];
                case 1:
                    a = _state.sent();
                    // Allocates a target to hold all document keys from the bundle, such that
                    // they will not get garbage collected right away.
                    return [
                        2,
                        i.persistence.runTransaction("Apply bundle documents", "readwrite", function(e) {
                            return __PRIVATE_populateDocumentChangeBuffer(e, o, _).next(function(t) {
                                return o.apply(e), t;
                            }).next(function(t) {
                                return i.V_.removeMatchingKeysForTargetId(e, a.targetId).next(function() {
                                    return i.V_.addMatchingKeys(e, s, a.targetId);
                                }).next(function() {
                                    return i.localDocuments.getLocalViewOfDocuments(e, t.Ko, t.Qo);
                                }).next(function() {
                                    return t.Ko;
                                });
                            });
                        })
                    ];
            }
        });
    })();
}
/**
 * Returns a promise of a boolean to indicate if the given bundle has already
 * been loaded and the create time is newer than the current loading bundle.
 */ /**
 * Saves the given `NamedQuery` to local persistence.
 */ function __PRIVATE_localStoreSaveNamedQuery(_0, _1) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function(e, t) {
        var n, r, i;
        var _arguments = arguments;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : __PRIVATE_documentKeySet();
                    return [
                        4,
                        __PRIVATE_localStoreAllocateTarget(e, __PRIVATE_queryToTarget(__PRIVATE_fromBundledQuery(t.bundledQuery)))
                    ];
                case 1:
                    r = _state.sent(), i = __PRIVATE_debugCast(e);
                    return [
                        2,
                        i.persistence.runTransaction("Save named query", "readwrite", function(e) {
                            var s = __PRIVATE_fromVersion(t.readTime);
                            // Simply save the query itself if it is older than what the SDK already
                            // has.
                            if (r.snapshotVersion.compareTo(s) >= 0) return i.f_.saveNamedQuery(e, t);
                            // Update existing target data because the query from the bundle is newer.
                            var _ = r.withResumeToken(ByteString.EMPTY_BYTE_STRING, s);
                            return i.Lo = i.Lo.insert(_.targetId, _), i.V_.updateTargetData(e, _).next(function() {
                                return i.V_.removeMatchingKeysForTargetId(e, r.targetId);
                            }).next(function() {
                                return i.V_.addMatchingKeys(e, n, r.targetId);
                            }).next(function() {
                                return i.f_.saveNamedQuery(e, t);
                            });
                        })
                    ];
            }
        });
    }).apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A complete element in the bundle stream, together with the byte length it
 * occupies in the stream.
 */ var __PRIVATE_SizedBundleElement = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_SizedBundleElement(e, // How many bytes this element takes to store in the bundle.
    t) {
        (0, $4QweW._)(this, __PRIVATE_SizedBundleElement);
        this.Ho = e, this.byteLength = t;
    }
    (0, $6hK4i._)(__PRIVATE_SizedBundleElement, [
        {
            key: "Jo",
            value: function Jo() {
                return "metadata" in this.Ho;
            }
        }
    ]);
    return __PRIVATE_SizedBundleElement;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * How many bytes to read each time when `ReadableStreamReader.read()` is
 * called. Only applicable for byte streams that we control (e.g. those backed
 * by an UInt8Array).
 */ /**
 * Builds a `ByteStreamReader` from a UInt8Array.
 * @param source - The data source to use.
 * @param bytesPerRead - How many bytes each `read()` from the returned reader
 *        will read.
 */ function __PRIVATE_toByteStreamReaderHelper(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10240;
    var n = 0;
    // The TypeScript definition for ReadableStreamReader changed. We use
    // `any` here to allow this code to compile with different versions.
    // See https://github.com/microsoft/TypeScript/issues/42970
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return {
        read: // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                var r;
                return (0, $gh3Df._)(this, function(_state) {
                    if (n < e.byteLength) {
                        r = {
                            value: e.slice(n, n + t),
                            done: false
                        };
                        return [
                            2,
                            (n += t, r)
                        ];
                    }
                    return [
                        2,
                        {
                            done: true
                        }
                    ];
                });
            })();
        },
        cancel: function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                return (0, $gh3Df._)(this, function(_state) {
                    return [
                        2
                    ];
                });
            })();
        },
        releaseLock: function() {},
        closed: Promise.resolve()
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * On web, a `ReadableStream` is wrapped around by a `ByteStreamReader`.
 */ /**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */ var __PRIVATE_OnlineStateTracker = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_OnlineStateTracker(e, t) {
        (0, $4QweW._)(this, __PRIVATE_OnlineStateTracker);
        this.asyncQueue = e, this.onlineStateHandler = t, /** The current OnlineState. */ this.state = "Unknown" /* OnlineState.Unknown */ , /**
         * A count of consecutive failures to open the stream. If it reaches the
         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
         * Offline.
         */ this.Yo = 0, /**
         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
         */ this.Zo = null, /**
         * Whether the client should log a warning message if it fails to connect to
         * the backend (initially true, cleared after a successful stream, or if we've
         * logged the message already).
         */ this.Xo = true;
    }
    (0, $6hK4i._)(__PRIVATE_OnlineStateTracker, [
        {
            /**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */ key: "ea",
            value: function ea() {
                var _this = this;
                0 === this.Yo && (this.ta("Unknown" /* OnlineState.Unknown */ ), this.Zo = this.asyncQueue.enqueueAfterDelay("online_state_timeout" /* TimerId.OnlineStateTimeout */ , 1e4, function() {
                    return _this.Zo = null, _this.na("Backend didn't respond within 10 seconds."), _this.ta("Offline" /* OnlineState.Offline */ ), Promise.resolve();
                }));
            }
        },
        {
            /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */ key: "ra",
            value: function ra(e) {
                "Online" /* OnlineState.Online */  === this.state ? this.ta("Unknown" /* OnlineState.Unknown */ ) : (this.Yo++, this.Yo >= 1 && (this.ia(), this.na("Connection failed 1 times. Most recent error: ".concat(e.toString())), this.ta("Offline" /* OnlineState.Offline */ )));
            }
        },
        {
            /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */ key: "set",
            value: function set(e) {
                this.ia(), this.Yo = 0, "Online" /* OnlineState.Online */  === e && // We've connected to watch at least once. Don't warn the developer
                // about being offline going forward.
                (this.Xo = false), this.ta(e);
            }
        },
        {
            key: "ta",
            value: function ta(e) {
                e !== this.state && (this.state = e, this.onlineStateHandler(e));
            }
        },
        {
            key: "na",
            value: function na(e) {
                var t = "Could not reach Cloud Firestore backend. ".concat(e, "\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.");
                this.Xo ? (__PRIVATE_logError(t), this.Xo = false) : __PRIVATE_logDebug("OnlineStateTracker", t);
            }
        },
        {
            key: "ia",
            value: function ia() {
                null !== this.Zo && (this.Zo.cancel(), this.Zo = null);
            }
        }
    ]);
    return __PRIVATE_OnlineStateTracker;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var hr = "RemoteStore";
// TODO(b/35853402): Negotiate this with the stream.
var __PRIVATE_RemoteStoreImpl = function __PRIVATE_RemoteStoreImpl(/**
     * The local store, used to fill the write pipeline with outbound mutations.
     */ e, /** The client-side proxy for interacting with the backend. */ t, n, r, i) {
    "use strict";
    var _this = this;
    (0, $4QweW._)(this, __PRIVATE_RemoteStoreImpl);
    this.localStore = e, this.datastore = t, this.asyncQueue = n, this.remoteSyncer = {}, /**
         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
         * LocalStore via fillWritePipeline() and have or will send to the write
         * stream.
         *
         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
         * restart the write stream. When the stream is established the writes in the
         * pipeline will be sent in order.
         *
         * Writes remain in writePipeline until they are acknowledged by the backend
         * and thus will automatically be re-sent if the stream is interrupted /
         * restarted before they're acknowledged.
         *
         * Write responses from the backend are linked to their originating request
         * purely based on order, and so we can just shift() writes from the front of
         * the writePipeline as we receive responses.
         */ this.sa = [], /**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */ this._a = new Map, this.oa = new Map, this.aa = new Map, this.ua = new __PRIVATE_TargetIdGenerator(1e3), this.ca = new __PRIVATE_TargetIdGenerator(1001), /**
         * A set of reasons for why the RemoteStore may be offline. If empty, the
         * RemoteStore may start its network connections.
         */ this.la = new Set, /**
         * Event handlers that get called when the network is disabled or enabled.
         *
         * PORTING NOTE: These functions are used on the Web client to create the
         * underlying streams (to support tree-shakeable streams). On Android and iOS,
         * the streams are created during construction of RemoteStore.
         */ this.Ea = [], this.ha = i, this.ha.Qe(function(e) {
        n.enqueueAndForget(function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                var _tmp;
                return (0, $gh3Df._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            // Porting Note: Unlike iOS, `restartNetwork()` is called even when the
                            // network becomes unreachable as we don't have any other way to tear
                            // down our streams.
                            _tmp = __PRIVATE_canUseNetwork(this);
                            if (!_tmp) return [
                                3,
                                2
                            ];
                            __PRIVATE_logDebug(hr, "Restarting streams for network reachability change.");
                            return [
                                4,
                                function __PRIVATE_restartNetwork(e) {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                                        var _$t;
                                        return (0, $gh3Df._)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    _$t = __PRIVATE_debugCast(e);
                                                    _$t.la.add(4 /* OfflineCause.ConnectivityChange */ );
                                                    return [
                                                        4,
                                                        __PRIVATE_disableNetworkInternal(_$t)
                                                    ];
                                                case 1:
                                                    _state.sent(), _$t.Ta.set("Unknown" /* OnlineState.Unknown */ ), _$t.la.delete(4 /* OfflineCause.ConnectivityChange */ );
                                                    return [
                                                        4,
                                                        __PRIVATE_enableNetworkInternal(_$t)
                                                    ];
                                                case 2:
                                                    _state.sent();
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    })();
                                }(this)
                            ];
                        case 1:
                            _tmp = _state.sent();
                            _state.label = 2;
                        case 2:
                            _tmp;
                            return [
                                2
                            ];
                    }
                });
            }).call(_this);
        });
    }), this.Ta = new __PRIVATE_OnlineStateTracker(n, r);
};
function __PRIVATE_enableNetworkInternal(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, t, err;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (!__PRIVATE_canUseNetwork(e)) return [
                        3,
                        8
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _iterator = e.Ea[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    t = _step.value;
                    return [
                        4,
                        t(/* enabled= */ true)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    })();
}
/**
 * Temporarily disables the network. The network can be re-enabled using
 * enableNetwork().
 */ function __PRIVATE_disableNetworkInternal(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, t, err;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _iterator = e.Ea[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    t = _step.value;
                    return [
                        4,
                        t(/* enabled= */ false)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    })();
}
/**
 * Returns the remote target ID currently mapped to this
 * sdkTargetId. Or returns `0` if the SDK target ID
 * is not currently mapped.
 * @param remoteStoreImpl
 * @param sdkTargetId
 */ function __PRIVATE_getRemoteTargetId(e, t) {
    return e.oa.get(t) || void 0;
}
/**
 * Generates a new remote target ID that is acceptable
 * to map to the given SDK target ID.
 * @param remoteStoreImpl
 * @param sdkTargetId
 */ /**
 * Starts new listen for the given target. Uses resume token if provided. It
 * is a no-op if the target of given `TargetData` is already being listened to.
 */ function __PRIVATE_remoteStoreListen(e, t) {
    var n = __PRIVATE_debugCast(e), r = __PRIVATE_getRemoteTargetId(n, t.targetId);
    // Get any remote target ID currently mapped to the targetData
    // If remote store is still listening for this remote target ID, this is a no-op.
    if (void 0 !== r && n._a.has(r)) return;
    // Generate and map a new remote ID to the SDK target ID
    var i = /**
 * Generate a new remote target ID for the given SDK target ID.
 * Re-map the given SDK to the new remote ID.
 * Delete any mapping of the old remote ID, if given.
 * @param remoteStoreImpl
 * @param sdkTargetId
 * @return The new remote ID.
 */ function __PRIVATE_allocateRemoteTargetId(e, t) {
        var n = __PRIVATE_getRemoteTargetId(e, t);
        void 0 !== n && // If there was an existing remote target ID mapped to that SDK target ID, forget about the old remote ID.
        e.aa.delete(n);
        // Generate a new unique remote target ID
        var r = function __PRIVATE_generateRemoteTargetId(e, t) {
            // If the given sdkTargetId is odd, map it to an odd (sync engine) target ID
            return t % 2 != 0 ? e.ca.next() : e.ua.next();
        }(e, t);
        return e.oa.set(t, r), e.aa.set(r, t), r;
    }(n, t.targetId);
    __PRIVATE_logDebug(hr, "remoteStoreListen mapping SDK target ID to remote", t.targetId, i);
    // Create a new TargetData for remote use, which uses
    // the remote TargetID.
    var s = new TargetData(t.target, i, t.purpose, t.sequenceNumber, t.snapshotVersion, t.lastLimboFreeSnapshotVersion, t.resumeToken);
    // Mark this as something the client is currently listening for.
    n._a.set(i, s), __PRIVATE_shouldStartWatchStream(n) ? // The listen will be sent in onWatchStreamOpen
    __PRIVATE_startWatchStream(n) : __PRIVATE_ensureWatchStream(n).Yt() && __PRIVATE_sendWatchRequest(n, s);
}
/**
 * Removes the listen from server. It is a no-op if the given target id is
 * not being listened to.
 */ function __PRIVATE_remoteStoreUnlisten(e, t) {
    var n = __PRIVATE_debugCast(e), r = __PRIVATE_ensureWatchStream(n), i = __PRIVATE_getRemoteTargetId(n, t);
    __PRIVATE_logDebug(hr, "remoteStoreUnlisten removing mapping of SDK target ID to remote", t, i), n._a.delete(i), n.oa.delete(t), n.aa.delete(i), r.Yt() && __PRIVATE_sendUnwatchRequest(n, i), 0 === n._a.size && (r.Yt() ? r.en() : __PRIVATE_canUseNetwork(n) && // Revert to OnlineState.Unknown if the watch stream is not open and we
    // have no listeners, since without any listens to send we cannot
    // confirm if the stream is healthy and upgrade to OnlineState.Online.
    n.Ta.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the ack to process any messages from this target.
 */ function __PRIVATE_sendWatchRequest(e, t) {
    if (e.Pa.J(t.targetId), t.resumeToken.approximateByteSize() > 0 || t.snapshotVersion.compareTo(SnapshotVersion.min()) > 0) {
        var n = e.aa.get(t.targetId);
        if (void 0 === n) // There's already a new remoteStoreListen request for the original
        // target, so ignore this.
        return void __PRIVATE_logDebug(hr, "SDK target ID not found for remote ID: " + t.targetId);
        var r = e.remoteSyncer.getRemoteKeysForTarget(n).size;
        t = t.withExpectedCount(r);
    }
    __PRIVATE_ensureWatchStream(e).Pn(t);
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the removal on the server before we process any
 * messages from this target.
 */ function __PRIVATE_sendUnwatchRequest(e, t) {
    e.Pa.J(t), __PRIVATE_ensureWatchStream(e).In(t);
}
function __PRIVATE_startWatchStream(e) {
    e.Pa = new __PRIVATE_WatchChangeAggregator({
        getRemoteKeysForTarget: function(t) {
            // Remote syncer uses SDK target IDs, so we need to map the remote
            // id to external id
            var n = e.aa.get(t);
            // If no sdkTargetId is mapped, return an empty key set
            return void 0 !== n ? e.remoteSyncer.getRemoteKeysForTarget(n) : __PRIVATE_documentKeySet();
        },
        ye: function(t) {
            return e._a.get(t) || null;
        },
        Ve: function() {
            return e.datastore.serializer.databaseId;
        }
    }), __PRIVATE_ensureWatchStream(e).start(), e.Ta.ea();
}
/**
 * Returns whether the watch stream should be started because it's necessary
 * and has not yet been started.
 */ function __PRIVATE_shouldStartWatchStream(e) {
    return __PRIVATE_canUseNetwork(e) && !__PRIVATE_ensureWatchStream(e).Jt() && e._a.size > 0;
}
function __PRIVATE_canUseNetwork(e) {
    return 0 === __PRIVATE_debugCast(e).la.size;
}
function __PRIVATE_cleanUpWatchStreamState(e) {
    e.Pa = void 0;
}
function __PRIVATE_onWatchStreamConnected(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        return (0, $gh3Df._)(this, function(_state) {
            // Mark the client as online since we got a "connected" notification.
            e.Ta.set("Online" /* OnlineState.Online */ );
            return [
                2
            ];
        });
    })();
}
function __PRIVATE_onWatchStreamOpen(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        return (0, $gh3Df._)(this, function(_state) {
            e._a.forEach(function(t, n) {
                __PRIVATE_sendWatchRequest(e, t);
            });
            return [
                2
            ];
        });
    })();
}
function __PRIVATE_onWatchStreamClose(e, t) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        return (0, $gh3Df._)(this, function(_state) {
            __PRIVATE_cleanUpWatchStreamState(e), // If we still need the watch stream, retry the connection.
            __PRIVATE_shouldStartWatchStream(e) ? (e.Ta.ra(t), __PRIVATE_startWatchStream(e)) : // No need to restart watch stream because there are no active targets.
            // The online state is set to unknown because there is no active attempt
            // at establishing a connection
            e.Ta.set("Unknown" /* OnlineState.Unknown */ );
            return [
                2
            ];
        });
    })();
}
function __PRIVATE_onWatchStreamChange(e, t, n) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var n1, _$t, _tmp, t1;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!// Mark the client as online since we got a message from the server
                    (e.Ta.set("Online" /* OnlineState.Online */ ), t instanceof __PRIVATE_WatchTargetChange && 2 /* WatchTargetChangeState.Removed */  === t.state && t.cause)) return [
                        3,
                        6
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        5
                    ]);
                    /** Handles an error on a target */ return [
                        4,
                        function __PRIVATE_handleTargetError(e, t) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                                var _$n, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, r, _$t, _tmp, err;
                                return (0, $gh3Df._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _$n = t.cause;
                                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            _state.label = 1;
                                        case 1:
                                            _state.trys.push([
                                                1,
                                                8,
                                                9,
                                                10
                                            ]);
                                            _iterator = t.targetIds[Symbol.iterator]();
                                            _state.label = 2;
                                        case 2:
                                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                                3,
                                                7
                                            ];
                                            r = _step.value;
                                            if (!e._a.has(r)) return [
                                                3,
                                                5
                                            ];
                                            _$t = e.aa.get(r);
                                            // If we still track the remote target ID, then notify the remoteSyncer
                                            // of the error and then free up the remote ID.
                                            _tmp = void 0 !== _$t;
                                            if (!_tmp) return [
                                                3,
                                                4
                                            ];
                                            return [
                                                4,
                                                e.remoteSyncer.rejectListen(_$t, _$n)
                                            ];
                                        case 3:
                                            _tmp = (_state.sent(), e.oa.delete(_$t), e.aa.delete(r));
                                            _state.label = 4;
                                        case 4:
                                            _tmp, e._a.delete(r);
                                            _state.label = 5;
                                        case 5:
                                            e.Pa.removeTarget(r);
                                            _state.label = 6;
                                        case 6:
                                            _iteratorNormalCompletion = true;
                                            return [
                                                3,
                                                2
                                            ];
                                        case 7:
                                            return [
                                                3,
                                                10
                                            ];
                                        case 8:
                                            err = _state.sent();
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                            return [
                                                3,
                                                10
                                            ];
                                        case 9:
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                    _iterator.return();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                            return [
                                                7
                                            ];
                                        case 10:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })();
                        }(e, t)
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    n1 = _state.sent();
                    __PRIVATE_logDebug(hr, "Failed to remove targets %s: %s ", t.targetIds.join(","), n1);
                    return [
                        4,
                        __PRIVATE_disableNetworkUntilRecovery(e, n1)
                    ];
                case 4:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        3,
                        13
                    ];
                case 6:
                    if (!(t instanceof __PRIVATE_DocumentWatchChange ? e.Pa._e(t) : t instanceof __PRIVATE_ExistenceFilterChange ? e.Pa.he(t) : e.Pa.ue(t), !n.isEqual(SnapshotVersion.min()))) return [
                        3,
                        13
                    ];
                    _state.label = 7;
                case 7:
                    _state.trys.push([
                        7,
                        11,
                        ,
                        13
                    ]);
                    return [
                        4,
                        __PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore)
                    ];
                case 8:
                    _$t = _state.sent();
                    _tmp = n.compareTo(_$t) >= 0;
                    if (!_tmp) return [
                        3,
                        10
                    ];
                    // We have received a target change with a global snapshot if the snapshot
                    // version is not equal to SnapshotVersion.min().
                    /**
 * Takes a batch of changes from the Datastore, repackages them as a
 * RemoteEvent, and passes that on to the listener, which is typically the
 * SyncEngine.
 */ return [
                        4,
                        function __PRIVATE_raiseWatchSnapshot(e, t) {
                            var _$n = e.Pa.fe(t);
                            // Update in-memory resume tokens. LocalStore will update the
                            // persistent view of these when applying the completed RemoteEvent.
                            _$n.targetChanges.forEach(function(n, r) {
                                if (n.resumeToken.approximateByteSize() > 0) {
                                    var i = e._a.get(r);
                                    // A watched target might have been removed already.
                                    i && e._a.set(r, i.withResumeToken(n.resumeToken, t));
                                }
                            }), // Re-establish listens for the targets that have been invalidated by
                            // existence filter mismatches.
                            // TODO ideally this would use a new remote target ID
                            _$n.targetMismatches.forEach(function(t, n) {
                                var r = e._a.get(t);
                                if (!r) // A watched target might have been removed already.
                                return;
                                // Clear the resume token for the target, since we're in a known mismatch
                                // state.
                                e._a.set(t, r.withResumeToken(ByteString.EMPTY_BYTE_STRING, r.snapshotVersion)), // Cause a hard reset by unwatching and rewatching immediately, but
                                // deliberately don't send a resume token so that we get a full update.
                                __PRIVATE_sendUnwatchRequest(e, t);
                                // Mark the target we send as being on behalf of an existence filter
                                // mismatch, but don't actually retain that in listenTargets. This ensures
                                // that we flag the first re-listen this way without impacting future
                                // listens of this target (that might happen e.g. on reconnect).
                                var i = new TargetData(r.target, t, n, r.sequenceNumber);
                                __PRIVATE_sendWatchRequest(e, i);
                            });
                            var r = /**
 * Convert a RemoteEvent with remote IDs to a RemoteEvent with
 * SDK IDs and dropped updates
 * for any targets we no longer track.
 *
 * @param remoteStoreImpl
 * @param remoteEvent
 * @return a new RemoteEvent with SDK IDs and dropped updates
 * for any targets we no longer track.
 */ function __PRIVATE_toSdkRemoteEvent(e, t) {
                                // Map TargetChanges to TargetChanges with SDK ID
                                var _$n = new Map;
                                t.targetChanges.forEach(function(t, r) {
                                    // If we no longer track the remote ID, then drop the TargetChange
                                    // otherwise propagate the TargetChange
                                    var i = e.aa.get(r);
                                    void 0 !== i && _$n.set(i, t);
                                });
                                // Map target mismatches to target mismatches with SDK ID
                                var r = new SortedMap(__PRIVATE_primitiveComparator);
                                return t.targetMismatches.forEach(function(t, n) {
                                    // If we no longer track the remote ID, then drop the target mismatch
                                    // otherwise propagate the target mismatch
                                    var i = e.aa.get(t);
                                    void 0 !== i && (r = r.insert(i, n));
                                }), new RemoteEvent(t.snapshotVersion, _$n, r, t.documentUpdates, t.augmentedDocumentUpdates, t.resolvedLimboDocuments);
                            }(e, _$n);
                            return e.remoteSyncer.applyRemoteEvent(r);
                        }(e, n)
                    ];
                case 9:
                    _tmp = _state.sent();
                    _state.label = 10;
                case 10:
                    _tmp;
                    return [
                        3,
                        13
                    ];
                case 11:
                    t1 = _state.sent();
                    __PRIVATE_logDebug(hr, "Failed to raise snapshot:", t1);
                    return [
                        4,
                        __PRIVATE_disableNetworkUntilRecovery(e, t1)
                    ];
                case 12:
                    _state.sent();
                    return [
                        3,
                        13
                    ];
                case 13:
                    return [
                        2
                    ];
            }
        });
    })();
}
/**
 * Recovery logic for IndexedDB errors that takes the network offline until
 * `op` succeeds. Retries are scheduled with backoff using
 * `enqueueRetryable()`. If `op()` is not provided, IndexedDB access is
 * validated via a generic operation.
 *
 * The returned Promise is resolved once the network is disabled and before
 * any retry attempt.
 */ function __PRIVATE_disableNetworkUntilRecovery(e, t, n) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!__PRIVATE_isIndexedDbTransactionError(t)) throw t;
                    e.la.add(1 /* OfflineCause.IndexedDbFailed */ );
                    // Disable network and raise offline snapshots
                    return [
                        4,
                        __PRIVATE_disableNetworkInternal(e)
                    ];
                case 1:
                    _state.sent(), e.Ta.set("Offline" /* OnlineState.Offline */ ), n || // Use a simple read operation to determine if IndexedDB recovered.
                    // Ideally, we would expose a health check directly on SimpleDb, but
                    // RemoteStore only has access to persistence through LocalStore.
                    (n = function() {
                        return __PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore);
                    }), // Probe IndexedDB periodically and re-enable network
                    e.asyncQueue.enqueueRetryable(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                            return (0, $gh3Df._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        __PRIVATE_logDebug(hr, "Retrying IndexedDB access");
                                        return [
                                            4,
                                            n()
                                        ];
                                    case 1:
                                        _state.sent(), e.la.delete(1 /* OfflineCause.IndexedDbFailed */ );
                                        return [
                                            4,
                                            __PRIVATE_enableNetworkInternal(e)
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                    return [
                        2
                    ];
            }
        });
    })();
}
/**
 * Executes `op`. If `op` fails, takes the network offline until `op`
 * succeeds. Returns after the first attempt.
 */ function __PRIVATE_executeWithRecovery(e, t) {
    return t().catch(function(n) {
        return __PRIVATE_disableNetworkUntilRecovery(e, n, t);
    });
}
function __PRIVATE_fillWritePipeline(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var t, n, r, _$e, e1;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    t = __PRIVATE_debugCast(e), n = __PRIVATE_ensureWriteStream(t);
                    r = t.sa.length > 0 ? t.sa[t.sa.length - 1].batchId : Ke;
                    _state.label = 1;
                case 1:
                    if (!__PRIVATE_canAddToWritePipeline(t)) return [
                        3,
                        7
                    ];
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        6
                    ]);
                    return [
                        4,
                        __PRIVATE_localStoreGetNextMutationBatch(t.localStore, r)
                    ];
                case 3:
                    _$e = _state.sent();
                    if (null === _$e) {
                        0 === t.sa.length && n.en();
                        return [
                            3,
                            7
                        ];
                    }
                    r = _$e.batchId, __PRIVATE_addToWritePipeline(t, _$e);
                    return [
                        3,
                        6
                    ];
                case 4:
                    e1 = _state.sent();
                    return [
                        4,
                        __PRIVATE_disableNetworkUntilRecovery(t, e1)
                    ];
                case 5:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        3,
                        1
                    ];
                case 7:
                    __PRIVATE_shouldStartWriteStream(t) && __PRIVATE_startWriteStream(t);
                    return [
                        2
                    ];
            }
        });
    })();
}
/**
 * Returns true if we can add to the write pipeline (i.e. the network is
 * enabled and the write pipeline is not full).
 */ function __PRIVATE_canAddToWritePipeline(e) {
    return __PRIVATE_canUseNetwork(e) && e.sa.length < 10;
}
/**
 * Queues additional writes to be sent to the write stream, sending them
 * immediately if the write stream is established.
 */ function __PRIVATE_addToWritePipeline(e, t) {
    e.sa.push(t);
    var n = __PRIVATE_ensureWriteStream(e);
    n.Yt() && n.Rn && n.An(t.mutations);
}
function __PRIVATE_shouldStartWriteStream(e) {
    return __PRIVATE_canUseNetwork(e) && !__PRIVATE_ensureWriteStream(e).Jt() && e.sa.length > 0;
}
function __PRIVATE_startWriteStream(e) {
    __PRIVATE_ensureWriteStream(e).start();
}
function __PRIVATE_onWriteStreamOpen(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        return (0, $gh3Df._)(this, function(_state) {
            __PRIVATE_ensureWriteStream(e).fn();
            return [
                2
            ];
        });
    })();
}
function __PRIVATE_onWriteHandshakeComplete(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var t, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, n;
        return (0, $gh3Df._)(this, function(_state) {
            t = __PRIVATE_ensureWriteStream(e);
            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                // Send the write pipeline now that the stream is established.
                for(_iterator = e.sa[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    n = _step.value;
                    t.An(n.mutations);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return [
                2
            ];
        });
    })();
}
function __PRIVATE_onMutationResult(e, t, n) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var r, i;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = e.sa.shift(), i = MutationBatchResult.from(r, t, n);
                    return [
                        4,
                        __PRIVATE_executeWithRecovery(e, function() {
                            return e.remoteSyncer.applySuccessfulWrite(i);
                        })
                    ];
                case 1:
                    _state.sent();
                    // It's possible that with the completion of this mutation another
                    // slot has freed up.
                    return [
                        4,
                        __PRIVATE_fillWritePipeline(e)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function __PRIVATE_onWriteStreamClose(e, t) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var _tmp;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // If the write stream closed after the write handshake completes, a write
                    // operation failed and we fail the pending operation.
                    _tmp = t && __PRIVATE_ensureWriteStream(e).Rn;
                    if (!_tmp) return [
                        3,
                        2
                    ];
                    // This error affects the actual write.
                    return [
                        4,
                        function __PRIVATE_handleWriteError(e, t) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                                var n;
                                return (0, $gh3Df._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!function __PRIVATE_isPermanentWriteError(e) {
                                                return __PRIVATE_isPermanentError(e) && e !== ta.ABORTED;
                                            }(t.code)) return [
                                                3,
                                                3
                                            ];
                                            // This was a permanent error, the request itself was the problem
                                            // so it's not going to succeed if we resend it.
                                            n = e.sa.shift();
                                            // In this case it's also unlikely that the server itself is melting
                                            // down -- this was just a bad request so inhibit backoff on the next
                                            // restart.
                                            __PRIVATE_ensureWriteStream(e).Xt();
                                            return [
                                                4,
                                                __PRIVATE_executeWithRecovery(e, function() {
                                                    return e.remoteSyncer.rejectFailedWrite(n.batchId, t);
                                                })
                                            ];
                                        case 1:
                                            _state.sent();
                                            // It's possible that with the completion of this mutation
                                            // another slot has freed up.
                                            return [
                                                4,
                                                __PRIVATE_fillWritePipeline(e)
                                            ];
                                        case 2:
                                            _state.sent();
                                            _state.label = 3;
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })();
                        }(e, t)
                    ];
                case 1:
                    _tmp = _state.sent();
                    _state.label = 2;
                case 2:
                    _tmp, // The write stream might have been started by refilling the write
                    // pipeline for failed writes
                    __PRIVATE_shouldStartWriteStream(e) && __PRIVATE_startWriteStream(e);
                    return [
                        2
                    ];
            }
        });
    })();
}
function __PRIVATE_remoteStoreHandleCredentialChange(e, t) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var n, r;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = __PRIVATE_debugCast(e);
                    n.asyncQueue.verifyOperationInProgress(), __PRIVATE_logDebug(hr, "RemoteStore received new credentials");
                    r = __PRIVATE_canUseNetwork(n);
                    // Tear down and re-create our network streams. This will ensure we get a
                    // fresh auth token for the new user and re-fill the write pipeline with
                    // new mutations from the LocalStore (since mutations are per-user).
                    n.la.add(3 /* OfflineCause.CredentialChange */ );
                    return [
                        4,
                        __PRIVATE_disableNetworkInternal(n)
                    ];
                case 1:
                    _state.sent(), r && // Don't set the network status to Unknown if we are offline.
                    n.Ta.set("Unknown" /* OnlineState.Unknown */ );
                    return [
                        4,
                        n.remoteSyncer.handleCredentialChange(t)
                    ];
                case 2:
                    _state.sent(), n.la.delete(3 /* OfflineCause.CredentialChange */ );
                    return [
                        4,
                        __PRIVATE_enableNetworkInternal(n)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
/**
 * Toggles the network state when the client gains or loses its primary lease.
 */ function __PRIVATE_remoteStoreApplyPrimaryState(e, t) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var n, _tmp, _tmp1;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = __PRIVATE_debugCast(e);
                    if (!t) return [
                        3,
                        2
                    ];
                    n.la.delete(2 /* OfflineCause.IsSecondary */ );
                    return [
                        4,
                        __PRIVATE_enableNetworkInternal(n)
                    ];
                case 1:
                    _tmp = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 2:
                    _tmp1 = t;
                    if (_tmp1) return [
                        3,
                        4
                    ];
                    n.la.add(2 /* OfflineCause.IsSecondary */ );
                    return [
                        4,
                        __PRIVATE_disableNetworkInternal(n)
                    ];
                case 3:
                    _tmp1 = (_state.sent(), n.Ta.set("Unknown" /* OnlineState.Unknown */ ));
                    _state.label = 4;
                case 4:
                    _tmp = _tmp1;
                    _state.label = 5;
                case 5:
                    _tmp;
                    return [
                        2
                    ];
            }
        });
    })();
}
/**
 * If not yet initialized, registers the WatchStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WatchStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function __PRIVATE_ensureWatchStream(e) {
    return e.Ia || // Create stream (but note that it is not started yet).
    (e.Ia = function __PRIVATE_newPersistentWatchStream(e, t, n) {
        var r = __PRIVATE_debugCast(e);
        return r.pn(), new __PRIVATE_PersistentListenStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        ct: __PRIVATE_onWatchStreamConnected.bind(null, e),
        Et: __PRIVATE_onWatchStreamOpen.bind(null, e),
        Tt: __PRIVATE_onWatchStreamClose.bind(null, e),
        Tn: __PRIVATE_onWatchStreamChange.bind(null, e)
    }), e.Ea.push(function(t) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var _tmp;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!t) return [
                            3,
                            1
                        ];
                        _tmp = (e.Ia.Xt(), __PRIVATE_shouldStartWatchStream(e) ? __PRIVATE_startWatchStream(e) : e.Ta.set("Unknown" /* OnlineState.Unknown */ ));
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            e.Ia.stop()
                        ];
                    case 2:
                        _tmp = (_state.sent(), __PRIVATE_cleanUpWatchStreamState(e));
                        _state.label = 3;
                    case 3:
                        _tmp;
                        return [
                            2
                        ];
                }
            });
        })();
    })), e.Ia;
}
/**
 * If not yet initialized, registers the WriteStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WriteStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function __PRIVATE_ensureWriteStream(e) {
    return e.Ra || // Create stream (but note that it is not started yet).
    (e.Ra = function __PRIVATE_newPersistentWriteStream(e, t, n) {
        var r = __PRIVATE_debugCast(e);
        return r.pn(), new __PRIVATE_PersistentWriteStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        ct: function() {
            return Promise.resolve();
        },
        Et: __PRIVATE_onWriteStreamOpen.bind(null, e),
        Tt: __PRIVATE_onWriteStreamClose.bind(null, e),
        Vn: __PRIVATE_onWriteHandshakeComplete.bind(null, e),
        dn: __PRIVATE_onMutationResult.bind(null, e)
    }), e.Ea.push(function(t) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var _tmp;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!t) return [
                            3,
                            2
                        ];
                        e.Ra.Xt();
                        // This will start the write stream if necessary.
                        return [
                            4,
                            __PRIVATE_fillWritePipeline(e)
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            e.Ra.stop()
                        ];
                    case 3:
                        _tmp = (_state.sent(), e.sa.length > 0 && (__PRIVATE_logDebug(hr, "Stopping write stream with ".concat(e.sa.length, " pending writes")), e.sa = []));
                        _state.label = 4;
                    case 4:
                        _tmp;
                        return [
                            2
                        ];
                }
            });
        })();
    })), e.Ra;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */ var __PRIVATE_AsyncObserver = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_AsyncObserver(e) {
        (0, $4QweW._)(this, __PRIVATE_AsyncObserver);
        this.observer = e, /**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */ this.muted = false;
    }
    (0, $6hK4i._)(__PRIVATE_AsyncObserver, [
        {
            key: "next",
            value: function next(e) {
                this.muted || this.observer.next && this.Aa(this.observer.next, e);
            }
        },
        {
            key: "error",
            value: function error(e) {
                this.muted || (this.observer.error ? this.Aa(this.observer.error, e) : __PRIVATE_logError("Uncaught Error in snapshot listener:", e.toString()));
            }
        },
        {
            key: "Va",
            value: function Va() {
                this.muted = true;
            }
        },
        {
            key: "Aa",
            value: function Aa(e, t) {
                var _this = this;
                setTimeout(function() {
                    _this.muted || e(t);
                }, 0);
            }
        }
    ]);
    return __PRIVATE_AsyncObserver;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 *
 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
 * in newer versions of TypeScript defines `finally`, which is not available in
 * IE.
 */ var DelayedOperation = /*#__PURE__*/ function() {
    "use strict";
    function DelayedOperation(e, t, n, r, i) {
        (0, $4QweW._)(this, DelayedOperation);
        this.asyncQueue = e, this.timerId = t, this.targetTimeMs = n, this.op = r, this.removalCallback = i, this.deferred = new __PRIVATE_Deferred, this.then = this.deferred.promise.then.bind(this.deferred.promise), // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.deferred.promise.catch(function(e) {});
    }
    (0, $6hK4i._)(DelayedOperation, [
        {
            key: "promise",
            get: function get() {
                return this.deferred.promise;
            }
        },
        {
            /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */ key: "start",
            value: function start(e) {
                var _this = this;
                this.timerHandle = setTimeout(function() {
                    return _this.handleDelayElapsed();
                }, e);
            }
        },
        {
            /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */ key: "skipDelay",
            value: function skipDelay() {
                return this.handleDelayElapsed();
            }
        },
        {
            /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */ key: "cancel",
            value: function cancel(t) {
                null !== this.timerHandle && (this.clearTimeout(), this.deferred.reject(new e(ta.CANCELLED, "Operation cancelled" + (t ? ": " + t : ""))));
            }
        },
        {
            key: "handleDelayElapsed",
            value: function handleDelayElapsed() {
                var _this = this;
                this.asyncQueue.enqueueAndForget(function() {
                    return null !== _this.timerHandle ? (_this.clearTimeout(), _this.op().then(function(e) {
                        return _this.deferred.resolve(e);
                    })) : Promise.resolve();
                });
            }
        },
        {
            key: "clearTimeout",
            value: function clearTimeout1() {
                null !== this.timerHandle && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
            }
        }
    ], [
        {
            key: "createAndSchedule",
            value: /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue - The queue to schedule the operation on.
     * @param id - A Timer ID identifying the type of operation this is.
     * @param delayMs - The delay (ms) before the operation should be scheduled.
     * @param op - The operation to run.
     * @param removalCallback - A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */ function createAndSchedule(e, t, n, r, i) {
                var s = Date.now() + n, _ = new DelayedOperation(e, t, s, r, i);
                return _.start(n), _;
            }
        }
    ]);
    return DelayedOperation;
}();
/**
 * Returns a FirestoreError that can be surfaced to the user if the provided
 * error is an IndexedDbTransactionError. Re-throws the error otherwise.
 */ function __PRIVATE_wrapInUserErrorIfRecoverable(t, n) {
    if (__PRIVATE_logError("AsyncQueue", "".concat(n, ": ").concat(t)), __PRIVATE_isIndexedDbTransactionError(t)) return new e(ta.UNAVAILABLE, "".concat(n, ": ").concat(t));
    throw t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class representing a bundle.
 *
 * Takes a bundle stream or buffer, and presents abstractions to read bundled
 * elements out of the underlying content.
 */ var __PRIVATE_BundleReaderImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_BundleReaderImpl(/** The reader to read from underlying binary bundle data source. */ e, t) {
        var _this = this;
        (0, $4QweW._)(this, __PRIVATE_BundleReaderImpl);
        this.da = e, this.serializer = t, /** Cached bundle metadata. */ this.metadata = new __PRIVATE_Deferred, /**
         * Internal buffer to hold bundle content, accumulating incomplete element
         * content.
         */ this.buffer = new Uint8Array, this.fa = function __PRIVATE_newTextDecoder() {
            return new TextDecoder("utf-8");
        }(), // Read the metadata (which is the first element).
        this.ma().then(function(e) {
            e && e.Jo() ? _this.metadata.resolve(e.Ho.metadata) : _this.metadata.reject(new Error("The first element of the bundle is not a metadata, it is\n             ".concat(JSON.stringify(e === null || e === void 0 ? void 0 : e.Ho))));
        }, function(e) {
            return _this.metadata.reject(e);
        });
    }
    (0, $6hK4i._)(__PRIVATE_BundleReaderImpl, [
        {
            key: "close",
            value: function close() {
                return this.da.cancel();
            }
        },
        {
            key: "getMetadata",
            value: function getMetadata() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        return [
                            2,
                            this.metadata.promise
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "pa",
            value: function pa() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getMetadata()
                                ];
                            case 1:
                                // Makes sure metadata is read before proceeding.
                                return [
                                    2,
                                    (_state.sent(), this.ma())
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "ma",
            value: /**
     * Reads from the head of internal buffer, and pulling more data from
     * underlying stream if a complete element cannot be found, until an
     * element(including the prefixed length and the JSON string) is found.
     *
     * Once a complete element is read, it is dropped from internal buffer.
     *
     * Returns either the bundled element, or null if we have reached the end of
     * the stream.
     */ function ma() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var e, t, n, r;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.ga()
                                ];
                            case 1:
                                e = _state.sent();
                                if (null === e) return [
                                    2,
                                    null
                                ];
                                t = this.fa.decode(e), n = Number(t);
                                isNaN(n) && this.ya("length string (".concat(t, ") is not valid number"));
                                return [
                                    4,
                                    this.wa(n)
                                ];
                            case 2:
                                r = _state.sent();
                                return [
                                    2,
                                    new __PRIVATE_SizedBundleElement(JSON.parse(r), e.length + n)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /** First index of '{' from the underlying buffer. */ key: "ba",
            value: function ba() {
                return this.buffer.findIndex(function(e) {
                    return e === "{".charCodeAt(0);
                });
            }
        },
        {
            key: "ga",
            value: /**
     * Reads from the beginning of the internal buffer, until the first '{', and
     * return the content.
     *
     * If reached end of the stream, returns a null.
     */ function ga() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var e, t;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(this.ba() < 0)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this.Sa()
                                ];
                            case 1:
                                if (_state.sent()) return [
                                    3,
                                    3
                                ];
                                _state.label = 2;
                            case 2:
                                return [
                                    3,
                                    0
                                ];
                            case 3:
                                // Broke out of the loop because underlying stream is closed, and there
                                // happens to be no more data to process.
                                if (0 === this.buffer.length) return [
                                    2,
                                    null
                                ];
                                e = this.ba();
                                // Broke out of the loop because underlying stream is closed, but still
                                // cannot find an open bracket.
                                e < 0 && this.ya("Reached the end of bundle when a length string is expected.");
                                t = this.buffer.slice(0, e);
                                // Update the internal buffer to drop the read length.
                                return [
                                    2,
                                    (this.buffer = this.buffer.slice(e), t)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "wa",
            value: /**
     * Reads from a specified position from the internal buffer, for a specified
     * number of bytes, pulling more data from the underlying stream if needed.
     *
     * Returns a string decoded from the read bytes.
     */ function wa(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var t;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(this.buffer.length < e)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this.Sa()
                                ];
                            case 1:
                                _state.sent() && this.ya("Reached the end of bundle when more is expected.");
                                _state.label = 2;
                            case 2:
                                return [
                                    3,
                                    0
                                ];
                            case 3:
                                t = this.fa.decode(this.buffer.slice(0, e));
                                // Update the internal buffer to drop the read json string.
                                return [
                                    2,
                                    (this.buffer = this.buffer.slice(e), t)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "ya",
            value: function ya(e) {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                throw this.da.cancel(), new Error("Invalid bundle format: ".concat(e));
            }
        },
        {
            key: "Sa",
            value: /**
     * Pulls more data from underlying stream to internal buffer.
     * Returns a boolean indicating whether the stream is finished.
     */ function Sa() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var e, t;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.da.read()
                                ];
                            case 1:
                                e = _state.sent();
                                if (!e.done) {
                                    t = new Uint8Array(this.buffer.length + e.value.length);
                                    t.set(this.buffer), t.set(e.value, this.buffer.length), this.buffer = t;
                                }
                                return [
                                    2,
                                    e.done
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return __PRIVATE_BundleReaderImpl;
}();
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class that can parse a bundle form the string serialization of a bundle.
 */ var __PRIVATE_BundleReaderSyncImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_BundleReaderSyncImpl(e, t) {
        (0, $4QweW._)(this, __PRIVATE_BundleReaderSyncImpl);
        this.bundleData = e, this.serializer = t, this.cursor = 0, this.elements = [];
        var n = this.pa();
        if (!n || !n.Jo()) throw new Error("The first element of the bundle is not a metadata object, it is\n         ".concat(JSON.stringify(n === null || n === void 0 ? void 0 : n.Ho)));
        this.metadata = n;
        do n = this.pa(), null !== n && this.elements.push(n);
        while (null !== n);
    }
    (0, $6hK4i._)(__PRIVATE_BundleReaderSyncImpl, [
        {
            /* Returns the parsed metadata of the bundle. */ key: "getMetadata",
            value: function getMetadata() {
                return this.metadata;
            }
        },
        {
            /* Returns the DocumentSnapshot or NamedQuery elements of the bundle. */ key: "va",
            value: function va() {
                return this.elements;
            }
        },
        {
            /**
     * Parses the next element of the bundle.
     *
     * @returns a SizedBundleElement representation of the next element in the bundle, or null if
     * no more elements exist.
     */ key: "pa",
            value: function pa() {
                if (this.cursor === this.bundleData.length) return null;
                var e = this.ga(), t = this.wa(e);
                return new __PRIVATE_SizedBundleElement(JSON.parse(t), e);
            }
        },
        {
            /**
     * Reads from a specified position from the bundleData string, for a specified
     * number of bytes.
     *
     * @param length - how many characters to read.
     * @returns a string parsed from the bundle.
     */ key: "wa",
            value: function wa(t) {
                if (this.cursor + t > this.bundleData.length) throw new e(ta.INTERNAL, "Reached the end of bundle when more is expected.");
                return this.bundleData.slice(this.cursor, this.cursor += t);
            }
        },
        {
            /**
     * Reads from the current cursor until the first '{'.
     *
     * @returns  A string to integer represention of the parsed value.
     * @throws An {@link Error} if the cursor has reached the end of the stream, since lengths
     * prefix bundle objects.
     */ key: "ga",
            value: function ga() {
                var e = this.cursor;
                var t = this.cursor;
                for(; t < this.bundleData.length;){
                    if ("{" === this.bundleData[t]) {
                        if (t === e) throw new Error("First character is a bracket and not a number");
                        return this.cursor = t, Number(this.bundleData.slice(e, t));
                    }
                    t++;
                }
                throw new Error("Reached the end of bundle when more is expected.");
            }
        }
    ]);
    return __PRIVATE_BundleReaderSyncImpl;
}();
/**
 *  Creates an instance of BundleReader without exposing the BundleReaderSyncImpl class type.
 */ var Tr = "IndexBackfiller";
/** How long we wait to try running index backfill after SDK initialization. */ /** This class is responsible for the scheduling of Index Backfiller. */ var __PRIVATE_IndexBackfillerScheduler = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexBackfillerScheduler(e, t) {
        (0, $4QweW._)(this, __PRIVATE_IndexBackfillerScheduler);
        this.asyncQueue = e, this.Da = t, this.task = null;
    }
    (0, $6hK4i._)(__PRIVATE_IndexBackfillerScheduler, [
        {
            key: "start",
            value: function start() {
                this.xa(15e3);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.task && (this.task.cancel(), this.task = null);
            }
        },
        {
            key: "started",
            get: function get() {
                return null !== this.task;
            }
        },
        {
            key: "xa",
            value: function xa(e) {
                var _this = this;
                __PRIVATE_logDebug(Tr, "Scheduled in ".concat(e, "ms")), this.task = this.asyncQueue.enqueueAfterDelay("index_backfill" /* TimerId.IndexBackfill */ , e, function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                        var _$e, e, _tmp;
                        return (0, $gh3Df._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    this.task = null;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        7
                                    ]);
                                    return [
                                        4,
                                        this.Da.Ca()
                                    ];
                                case 2:
                                    _$e = _state.sent();
                                    __PRIVATE_logDebug(Tr, "Documents written: ".concat(_$e));
                                    return [
                                        3,
                                        7
                                    ];
                                case 3:
                                    e = _state.sent();
                                    if (!__PRIVATE_isIndexedDbTransactionError(e)) return [
                                        3,
                                        4
                                    ];
                                    _tmp = __PRIVATE_logDebug(Tr, "Ignoring IndexedDB error during index backfill: ", e);
                                    return [
                                        3,
                                        6
                                    ];
                                case 4:
                                    return [
                                        4,
                                        __PRIVATE_ignoreIfPrimaryLeaseLoss(e)
                                    ];
                                case 5:
                                    _tmp = _state.sent();
                                    _state.label = 6;
                                case 6:
                                    _tmp;
                                    return [
                                        3,
                                        7
                                    ];
                                case 7:
                                    return [
                                        4,
                                        this.xa(6e4)
                                    ];
                                case 8:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    }).call(_this);
                });
            }
        }
    ]);
    return __PRIVATE_IndexBackfillerScheduler;
}();
/** Implements the steps for backfilling indexes. */ var __PRIVATE_IndexBackfiller = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexBackfiller(/**
     * LocalStore provides access to IndexManager and LocalDocumentView.
     * These properties will update when the user changes. Consequently,
     * making a local copy of IndexManager and LocalDocumentView will require
     * updates over time. The simpler solution is to rely on LocalStore to have
     * an up-to-date references to IndexManager and LocalDocumentStore.
     */ e, t) {
        (0, $4QweW._)(this, __PRIVATE_IndexBackfiller);
        this.localStore = e, this.persistence = t;
    }
    (0, $6hK4i._)(__PRIVATE_IndexBackfiller, [
        {
            key: "Ca",
            value: function Ca() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 50;
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _this;
                    return (0, $gh3Df._)(this, function(_state) {
                        _this = this;
                        return [
                            2,
                            this.persistence.runTransaction("Backfill Indexes", "readwrite-primary", function(t) {
                                return _this.Fa(t, e);
                            })
                        ];
                    });
                }).call(this);
            }
        },
        {
            /** Writes index entries until the cap is reached. Returns the number of documents processed. */ key: "Fa",
            value: function Fa(e, t) {
                var _this = this;
                var n = new Set;
                var r = t, i = true;
                return PersistencePromise.doWhile(function() {
                    return true === i && r > 0;
                }, function() {
                    return _this.localStore.indexManager.getNextCollectionGroupToUpdate(e).next(function(t) {
                        if (null !== t && !n.has(t)) return __PRIVATE_logDebug(Tr, "Processing collection: ".concat(t)), _this.Oa(e, t, r).next(function(e) {
                            r -= e, n.add(t);
                        });
                        i = false;
                    });
                }).next(function() {
                    return t - r;
                });
            }
        },
        {
            /**
     * Writes entries for the provided collection group. Returns the number of documents processed.
     */ key: "Oa",
            value: function Oa(e, t, n) {
                var _this = this;
                // Use the earliest offset of all field indexes to query the local cache.
                return this.localStore.indexManager.getMinOffsetFromCollectionGroup(e, t).next(function(r) {
                    return _this.localStore.localDocuments.getNextDocuments(e, t, r, n).next(function(n) {
                        var i = n.changes;
                        return _this.localStore.indexManager.updateIndexEntries(e, i).next(function() {
                            return _this.Ma(r, n);
                        }).next(function(n) {
                            return __PRIVATE_logDebug(Tr, "Updating offset: ".concat(n)), _this.localStore.indexManager.updateCollectionGroup(e, t, n);
                        }).next(function() {
                            return i.size;
                        });
                    });
                });
            }
        },
        {
            /** Returns the next offset based on the provided documents. */ key: "Ma",
            value: function Ma(e, t) {
                var n = e;
                return t.changes.forEach(function(e, t) {
                    var r = __PRIVATE_newIndexOffsetFromDocument(t);
                    __PRIVATE_indexOffsetComparator(r, n) > 0 && (n = r);
                }), new IndexOffset(n.readTime, n.documentKey, Math.max(t.batchId, e.largestBatchId));
            }
        }
    ]);
    return __PRIVATE_IndexBackfiller;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The format of the LocalStorage key that stores the client state is:
//     firestore_clients_<persistence_prefix>_<instance_key>
var Pr = "firestore_clients";
/** Assembles the key for a client state in WebStorage */ function createWebStorageClientStateKey(e, t) {
    return "".concat(Pr, "_").concat(e, "_").concat(t);
}
// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
var Ir = "firestore_mutations";
/** Assembles the key for a mutation batch in WebStorage */ function createWebStorageMutationBatchKey(e, t, n) {
    var r = "".concat(Ir, "_").concat(e, "_").concat(n);
    return t.isAuthenticated() && (r += "_".concat(t.uid)), r;
}
// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
var Rr = "firestore_targets";
/** Assembles the key for a query state in WebStorage */ function createWebStorageQueryTargetMetadataKey(e, t) {
    return "".concat(Rr, "_").concat(e, "_").concat(t);
}
// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var Ar = "SharedClientState";
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */ // Visible for testing
var __PRIVATE_MutationMetadata = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MutationMetadata(e, t, n, r) {
        (0, $4QweW._)(this, __PRIVATE_MutationMetadata);
        this.user = e, this.batchId = t, this.state = n, this.error = r;
    }
    (0, $6hK4i._)(__PRIVATE_MutationMetadata, [
        {
            key: "La",
            value: function La() {
                var e = {
                    state: this.state,
                    updateTimeMs: Date.now()
                };
                return this.error && (e.error = {
                    code: this.error.code,
                    message: this.error.message
                }), JSON.stringify(e);
            }
        }
    ], [
        {
            key: "Na",
            value: /**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ function Na(t, n, r) {
                var i = JSON.parse(r);
                var s, _ = "object" == (typeof i === "undefined" ? "undefined" : (0, $5djcY._)(i)) && -1 !== [
                    "pending",
                    "acknowledged",
                    "rejected"
                ].indexOf(i.state) && (void 0 === i.error || "object" == (0, $5djcY._)(i.error));
                return _ && i.error && (_ = "string" == typeof i.error.message && "string" == typeof i.error.code, _ && (s = new e(i.error.code, i.error.message))), _ ? new __PRIVATE_MutationMetadata(t, n, i.state, s) : (__PRIVATE_logError(Ar, "Failed to parse mutation state for ID '".concat(n, "': ").concat(r)), null);
            }
        }
    ]);
    return __PRIVATE_MutationMetadata;
}();
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */ // Visible for testing
var __PRIVATE_QueryTargetMetadata = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_QueryTargetMetadata(e, t, n) {
        (0, $4QweW._)(this, __PRIVATE_QueryTargetMetadata);
        this.targetId = e, this.state = t, this.error = n;
    }
    (0, $6hK4i._)(__PRIVATE_QueryTargetMetadata, [
        {
            key: "La",
            value: function La() {
                var e = {
                    state: this.state,
                    updateTimeMs: Date.now()
                };
                return this.error && (e.error = {
                    code: this.error.code,
                    message: this.error.message
                }), JSON.stringify(e);
            }
        }
    ], [
        {
            key: "Na",
            value: /**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ function Na(t, n) {
                var r = JSON.parse(n);
                var i, s = "object" == (typeof r === "undefined" ? "undefined" : (0, $5djcY._)(r)) && -1 !== [
                    "not-current",
                    "current",
                    "rejected"
                ].indexOf(r.state) && (void 0 === r.error || "object" == (0, $5djcY._)(r.error));
                return s && r.error && (s = "string" == typeof r.error.message && "string" == typeof r.error.code, s && (i = new e(r.error.code, r.error.message))), s ? new __PRIVATE_QueryTargetMetadata(t, r.state, i) : (__PRIVATE_logError(Ar, "Failed to parse target state for ID '".concat(t, "': ").concat(n)), null);
            }
        }
    ]);
    return __PRIVATE_QueryTargetMetadata;
}();
/**
 * This class represents the immutable ClientState for a client read from
 * WebStorage, containing the list of active query targets.
 */ var __PRIVATE_RemoteClientState = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_RemoteClientState(e, t) {
        (0, $4QweW._)(this, __PRIVATE_RemoteClientState);
        this.clientId = e, this.activeTargetIds = t;
    }
    (0, $6hK4i._)(__PRIVATE_RemoteClientState, null, [
        {
            key: "Na",
            value: /**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ function Na(e, t) {
                var n = JSON.parse(t);
                var r = "object" == (typeof n === "undefined" ? "undefined" : (0, $5djcY._)(n)) && n.activeTargetIds instanceof Array, i = __PRIVATE_targetIdSet();
                for(var _$e = 0; r && _$e < n.activeTargetIds.length; ++_$e)r = isSafeInteger(n.activeTargetIds[_$e]), i = i.add(n.activeTargetIds[_$e]);
                return r ? new __PRIVATE_RemoteClientState(e, i) : (__PRIVATE_logError(Ar, "Failed to parse client data for instance '".concat(e, "': ").concat(t)), null);
            }
        }
    ]);
    return __PRIVATE_RemoteClientState;
}();
/**
 * This class represents the online state for all clients participating in
 * multi-tab. The online state is only written to by the primary client, and
 * used in secondary clients to update their query views.
 */ var __PRIVATE_SharedOnlineState = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_SharedOnlineState(e, t) {
        (0, $4QweW._)(this, __PRIVATE_SharedOnlineState);
        this.clientId = e, this.onlineState = t;
    }
    (0, $6hK4i._)(__PRIVATE_SharedOnlineState, null, [
        {
            key: "Na",
            value: /**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ function Na(e) {
                var t = JSON.parse(e);
                return "object" == (typeof t === "undefined" ? "undefined" : (0, $5djcY._)(t)) && -1 !== [
                    "Unknown",
                    "Online",
                    "Offline"
                ].indexOf(t.onlineState) && "string" == typeof t.clientId ? new __PRIVATE_SharedOnlineState(t.clientId, t.onlineState) : (__PRIVATE_logError(Ar, "Failed to parse online state: ".concat(e)), null);
            }
        }
    ]);
    return __PRIVATE_SharedOnlineState;
}();
/**
 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
 * mutable and keeps track of all pending mutations, which allows us to
 * update the range of pending mutation batch IDs as new mutations are added or
 * removed.
 *
 * The data in `LocalClientState` is not read from WebStorage and instead
 * updated via its instance methods. The updated state can be serialized via
 * `toWebStorageJSON()`.
 */ // Visible for testing.
var __PRIVATE_LocalClientState = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_LocalClientState() {
        (0, $4QweW._)(this, __PRIVATE_LocalClientState);
        this.activeTargetIds = __PRIVATE_targetIdSet();
    }
    (0, $6hK4i._)(__PRIVATE_LocalClientState, [
        {
            key: "Ba",
            value: function Ba(e) {
                this.activeTargetIds = this.activeTargetIds.add(e);
            }
        },
        {
            key: "Ua",
            value: function Ua(e) {
                this.activeTargetIds = this.activeTargetIds.delete(e);
            }
        },
        {
            /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */ key: "La",
            value: function La() {
                var e = {
                    activeTargetIds: this.activeTargetIds.toArray(),
                    updateTimeMs: Date.now()
                };
                return JSON.stringify(e);
            }
        }
    ]);
    return __PRIVATE_LocalClientState;
}();
/**
 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
 * backing store for the SharedClientState. It keeps track of all active
 * clients and supports modifications of the local client's data.
 */ var __PRIVATE_WebStorageSharedClientState = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_WebStorageSharedClientState(e, t, n, r, i) {
        (0, $4QweW._)(this, __PRIVATE_WebStorageSharedClientState);
        this.window = e, this.Ct = t, this.persistenceKey = n, this.ka = r, this.syncEngine = null, this.onlineStateHandler = null, this.sequenceNumberHandler = null, this.qa = this.$a.bind(this), this.Ka = new SortedMap(__PRIVATE_primitiveComparator), this.started = false, /**
         * Captures WebStorage events that occur before `start()` is called. These
         * events are replayed once `WebStorageSharedClientState` is started.
         */ this.Qa = [];
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        var s = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        this.storage = this.window.localStorage, this.currentUser = i, this.Wa = createWebStorageClientStateKey(this.persistenceKey, this.ka), this.Ga = /** Assembles the key for the current sequence number. */ function createWebStorageSequenceNumberKey(e) {
            return "firestore_sequence_number_".concat(e);
        }(this.persistenceKey), this.Ka = this.Ka.insert(this.ka, new __PRIVATE_LocalClientState), this.za = new RegExp("^".concat(Pr, "_").concat(s, "_([^_]*)$")), this.ja = new RegExp("^".concat(Ir, "_").concat(s, "_(\\d+)(?:_(.*))?$")), this.Ha = new RegExp("^".concat(Rr, "_").concat(s, "_(\\d+)$")), this.Ja = /** Assembles the key for the online state of the primary tab. */ function createWebStorageOnlineStateKey(e) {
            return "firestore_online_state_".concat(e);
        }(this.persistenceKey), this.Ya = function createBundleLoadedKey(e) {
            return "firestore_bundle_loaded_v2_".concat(e);
        }(this.persistenceKey), // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.window.addEventListener("storage", this.qa);
    }
    (0, $6hK4i._)(__PRIVATE_WebStorageSharedClientState, [
        {
            key: "start",
            value: function start() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _this, e, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, t, e1, n, t1, e2, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, e3;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.syncEngine.Ro()
                                ];
                            case 1:
                                e = _state.sent();
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = e[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        t = _step.value;
                                        if (t === this.ka) continue;
                                        e1 = this.getItem(createWebStorageClientStateKey(this.persistenceKey, t));
                                        if (e1) {
                                            n = __PRIVATE_RemoteClientState.Na(t, e1);
                                            n && (this.Ka = this.Ka.insert(n.clientId, n));
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                this.Za();
                                // Check if there is an existing online state and call the callback handler
                                // if applicable.
                                t1 = this.storage.getItem(this.Ja);
                                if (t1) {
                                    e2 = this.Xa(t1);
                                    e2 && this.eu(e2);
                                }
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(_iterator1 = this.Qa[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        e3 = _step1.value;
                                        this.$a(e3);
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                this.Qa = [], // Register a window unload hook to remove the client metadata entry from
                                // WebStorage even if `shutdown()` was not called.
                                this.window.addEventListener("pagehide", function() {
                                    return _this.shutdown();
                                }), this.started = true;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "writeSequenceNumber",
            value: function writeSequenceNumber(e) {
                this.setItem(this.Ga, JSON.stringify(e));
            }
        },
        {
            key: "getAllActiveQueryTargets",
            value: function getAllActiveQueryTargets() {
                return this.tu(this.Ka);
            }
        },
        {
            key: "isActiveQueryTarget",
            value: function isActiveQueryTarget(e) {
                var t = false;
                return this.Ka.forEach(function(n, r) {
                    r.activeTargetIds.has(e) && (t = true);
                }), t;
            }
        },
        {
            key: "addPendingMutation",
            value: function addPendingMutation(e) {
                this.nu(e, "pending");
            }
        },
        {
            key: "updateMutationState",
            value: function updateMutationState(e, t, n) {
                this.nu(e, t, n), // Once a final mutation result is observed by other clients, they no longer
                // access the mutation's metadata entry. Since WebStorage replays events
                // in order, it is safe to delete the entry right after updating it.
                this.ru(e);
            }
        },
        {
            key: "addLocalQueryTarget",
            value: function addLocalQueryTarget(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var n = "not-current";
                // Lookup an existing query state if the target ID was already registered
                // by another tab
                if (this.isActiveQueryTarget(e)) {
                    var t1 = this.storage.getItem(createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
                    if (t1) {
                        var r = __PRIVATE_QueryTargetMetadata.Na(e, t1);
                        r && (n = r.state);
                    }
                }
                // If the query is listening to cache only, the target ID should not be registered with the
                // local Firestore client as an active watch target.
                return t && this.iu.Ba(e), this.Za(), n;
            }
        },
        {
            key: "removeLocalQueryTarget",
            value: function removeLocalQueryTarget(e) {
                this.iu.Ua(e), this.Za();
            }
        },
        {
            key: "isLocalQueryTarget",
            value: function isLocalQueryTarget(e) {
                return this.iu.activeTargetIds.has(e);
            }
        },
        {
            key: "clearQueryState",
            value: function clearQueryState(e) {
                this.removeItem(createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
            }
        },
        {
            key: "updateQueryState",
            value: function updateQueryState(e, t, n) {
                this.su(e, t, n);
            }
        },
        {
            key: "handleUserChange",
            value: function handleUserChange(e, t, n) {
                var _this = this;
                t.forEach(function(e) {
                    _this.ru(e);
                }), this.currentUser = e, n.forEach(function(e) {
                    _this.addPendingMutation(e);
                });
            }
        },
        {
            key: "setOnlineState",
            value: function setOnlineState(e) {
                this._u(e);
            }
        },
        {
            key: "notifyBundleLoaded",
            value: function notifyBundleLoaded(e) {
                this.ou(e);
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {
                this.started && (this.window.removeEventListener("storage", this.qa), this.removeItem(this.Wa), this.started = false);
            }
        },
        {
            key: "getItem",
            value: function getItem(e) {
                var t = this.storage.getItem(e);
                return __PRIVATE_logDebug(Ar, "READ", e, t), t;
            }
        },
        {
            key: "setItem",
            value: function setItem(e, t) {
                __PRIVATE_logDebug(Ar, "SET", e, t), this.storage.setItem(e, t);
            }
        },
        {
            key: "removeItem",
            value: function removeItem(e) {
                __PRIVATE_logDebug(Ar, "REMOVE", e), this.storage.removeItem(e);
            }
        },
        {
            key: "$a",
            value: function $a(e) {
                var _this = this;
                // Note: The function is typed to take Event to be interface-compatible with
                // `Window.addEventListener`.
                var t = e;
                if (t.storageArea === this.storage) {
                    if (__PRIVATE_logDebug(Ar, "EVENT", t.key, t.newValue), t.key === this.Wa) return void __PRIVATE_logError("Received WebStorage notification for local change. Another client might have garbage-collected our state");
                    this.Ct.enqueueRetryable(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                            var _this, _$e, _$e1, _$e2, _$e3, _$e4, _$e5, _$e6;
                            return (0, $gh3Df._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _this = this;
                                        if (!this.started) return [
                                            3,
                                            8
                                        ];
                                        if (!(null !== t.key)) return [
                                            3,
                                            7
                                        ];
                                        if (!this.za.test(t.key)) return [
                                            3,
                                            1
                                        ];
                                        if (null == t.newValue) {
                                            _$e = this.au(t.key);
                                            return [
                                                2,
                                                this.uu(_$e, null)
                                            ];
                                        }
                                        {
                                            _$e1 = this.cu(t.key, t.newValue);
                                            if (_$e1) return [
                                                2,
                                                this.uu(_$e1.clientId, _$e1)
                                            ];
                                        }
                                        return [
                                            3,
                                            7
                                        ];
                                    case 1:
                                        if (!this.ja.test(t.key)) return [
                                            3,
                                            2
                                        ];
                                        if (null !== t.newValue) {
                                            _$e2 = this.lu(t.key, t.newValue);
                                            if (_$e2) return [
                                                2,
                                                this.Eu(_$e2)
                                            ];
                                        }
                                        return [
                                            3,
                                            7
                                        ];
                                    case 2:
                                        if (!this.Ha.test(t.key)) return [
                                            3,
                                            3
                                        ];
                                        if (null !== t.newValue) {
                                            _$e3 = this.hu(t.key, t.newValue);
                                            if (_$e3) return [
                                                2,
                                                this.Tu(_$e3)
                                            ];
                                        }
                                        return [
                                            3,
                                            7
                                        ];
                                    case 3:
                                        if (!(t.key === this.Ja)) return [
                                            3,
                                            4
                                        ];
                                        if (null !== t.newValue) {
                                            _$e4 = this.Xa(t.newValue);
                                            if (_$e4) return [
                                                2,
                                                this.eu(_$e4)
                                            ];
                                        }
                                        return [
                                            3,
                                            7
                                        ];
                                    case 4:
                                        if (!(t.key === this.Ga)) return [
                                            3,
                                            5
                                        ];
                                        _$e5 = function __PRIVATE_fromWebStorageSequenceNumber(e) {
                                            var t = __PRIVATE_ListenSequence.wn;
                                            if (null != e) try {
                                                var n = JSON.parse(e);
                                                __PRIVATE_hardAssert("number" == typeof n, 30636, {
                                                    Pu: e
                                                }), t = n;
                                            } catch (e) {
                                                __PRIVATE_logError(Ar, "Failed to read sequence number from WebStorage", e);
                                            }
                                            return t;
                                        }(t.newValue);
                                        _$e5 !== __PRIVATE_ListenSequence.wn && this.sequenceNumberHandler(_$e5);
                                        return [
                                            3,
                                            7
                                        ];
                                    case 5:
                                        if (!(t.key === this.Ya)) return [
                                            3,
                                            7
                                        ];
                                        _$e6 = this.Iu(t.newValue);
                                        return [
                                            4,
                                            Promise.all(_$e6.map(function(e) {
                                                return _this.syncEngine.Ru(e);
                                            }))
                                        ];
                                    case 6:
                                        _state.sent();
                                        _state.label = 7;
                                    case 7:
                                        return [
                                            3,
                                            9
                                        ];
                                    case 8:
                                        this.Qa.push(t);
                                        _state.label = 9;
                                    case 9:
                                        return [
                                            2
                                        ];
                                }
                            });
                        }).call(_this);
                    });
                }
            }
        },
        {
            key: "iu",
            get: function get() {
                return this.Ka.get(this.ka);
            }
        },
        {
            key: "Za",
            value: function Za() {
                this.setItem(this.Wa, this.iu.La());
            }
        },
        {
            key: "nu",
            value: function nu(e, t, n) {
                var r = new __PRIVATE_MutationMetadata(this.currentUser, e, t, n), i = createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
                this.setItem(i, r.La());
            }
        },
        {
            key: "ru",
            value: function ru(e) {
                var t = createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
                this.removeItem(t);
            }
        },
        {
            key: "_u",
            value: function _u(e) {
                var t = {
                    clientId: this.ka,
                    onlineState: e
                };
                this.storage.setItem(this.Ja, JSON.stringify(t));
            }
        },
        {
            key: "su",
            value: function su(e, t, n) {
                var r = createWebStorageQueryTargetMetadataKey(this.persistenceKey, e), i = new __PRIVATE_QueryTargetMetadata(e, t, n);
                this.setItem(r, i.La());
            }
        },
        {
            key: "ou",
            value: function ou(e) {
                var t = JSON.stringify(Array.from(e));
                this.setItem(this.Ya, t);
            }
        },
        {
            /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */ key: "au",
            value: function au(e) {
                var t = this.za.exec(e);
                return t ? t[1] : null;
            }
        },
        {
            /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */ key: "cu",
            value: function cu(e, t) {
                var n = this.au(e);
                return __PRIVATE_RemoteClientState.Na(n, t);
            }
        },
        {
            /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ key: "lu",
            value: function lu(e, t) {
                var n = this.ja.exec(e), r = Number(n[1]), i = void 0 !== n[2] ? n[2] : null;
                return __PRIVATE_MutationMetadata.Na(new User(i), r, t);
            }
        },
        {
            /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ key: "hu",
            value: function hu(e, t) {
                var n = this.Ha.exec(e), r = Number(n[1]);
                return __PRIVATE_QueryTargetMetadata.Na(r, t);
            }
        },
        {
            /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ key: "Xa",
            value: function Xa(e) {
                return __PRIVATE_SharedOnlineState.Na(e);
            }
        },
        {
            key: "Iu",
            value: function Iu(e) {
                return JSON.parse(e);
            }
        },
        {
            key: "Eu",
            value: function Eu(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        if (e.user.uid === this.currentUser.uid) return [
                            2,
                            this.syncEngine.Au(e.batchId, e.state, e.error)
                        ];
                        __PRIVATE_logDebug(Ar, "Ignoring mutation for non-active user ".concat(e.user.uid));
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "Tu",
            value: function Tu(e) {
                return this.syncEngine.Vu(e.targetId, e.state, e.error);
            }
        },
        {
            key: "uu",
            value: function uu(e, t) {
                var _this = this;
                var n = t ? this.Ka.insert(e, t) : this.Ka.remove(e), r = this.tu(this.Ka), i = this.tu(n), s = [], _ = [];
                return i.forEach(function(e) {
                    r.has(e) || s.push(e);
                }), r.forEach(function(e) {
                    i.has(e) || _.push(e);
                }), this.syncEngine.du(s, _).then(function() {
                    _this.Ka = n;
                });
            }
        },
        {
            key: "eu",
            value: function eu(e) {
                // We check whether the client that wrote this online state is still active
                // by comparing its client ID to the list of clients kept active in
                // IndexedDb. If a client does not update their IndexedDb client state
                // within 5 seconds, it is considered inactive and we don't emit an online
                // state event.
                this.Ka.get(e.clientId) && this.onlineStateHandler(e.onlineState);
            }
        },
        {
            key: "tu",
            value: function tu(e) {
                var t = __PRIVATE_targetIdSet();
                return e.forEach(function(e, n) {
                    t = t.unionWith(n.activeTargetIds);
                }), t;
            }
        }
    ], [
        {
            key: "Ye",
            value: /** Returns 'true' if WebStorage is available in the current environment. */ function Ye(e) {
                return !(!e || !e.localStorage);
            }
        }
    ]);
    return __PRIVATE_WebStorageSharedClientState;
}();
var __PRIVATE_MemorySharedClientState = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemorySharedClientState() {
        (0, $4QweW._)(this, __PRIVATE_MemorySharedClientState);
        this.fu = new __PRIVATE_LocalClientState, this.mu = {}, this.onlineStateHandler = null, this.sequenceNumberHandler = null;
    }
    (0, $6hK4i._)(__PRIVATE_MemorySharedClientState, [
        {
            key: "addPendingMutation",
            value: function addPendingMutation(e) {
            // No op.
            }
        },
        {
            key: "updateMutationState",
            value: function updateMutationState(e, t, n) {
            // No op.
            }
        },
        {
            key: "addLocalQueryTarget",
            value: function addLocalQueryTarget(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                return t && this.fu.Ba(e), this.mu[e] || "not-current";
            }
        },
        {
            key: "updateQueryState",
            value: function updateQueryState(e, t, n) {
                this.mu[e] = t;
            }
        },
        {
            key: "removeLocalQueryTarget",
            value: function removeLocalQueryTarget(e) {
                this.fu.Ua(e);
            }
        },
        {
            key: "isLocalQueryTarget",
            value: function isLocalQueryTarget(e) {
                return this.fu.activeTargetIds.has(e);
            }
        },
        {
            key: "clearQueryState",
            value: function clearQueryState(e) {
                delete this.mu[e];
            }
        },
        {
            key: "getAllActiveQueryTargets",
            value: function getAllActiveQueryTargets() {
                return this.fu.activeTargetIds;
            }
        },
        {
            key: "isActiveQueryTarget",
            value: function isActiveQueryTarget(e) {
                return this.fu.activeTargetIds.has(e);
            }
        },
        {
            key: "start",
            value: function start() {
                return this.fu = new __PRIVATE_LocalClientState, Promise.resolve();
            }
        },
        {
            key: "handleUserChange",
            value: function handleUserChange(e, t, n) {
            // No op.
            }
        },
        {
            key: "setOnlineState",
            value: function setOnlineState(e) {
            // No op.
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {}
        },
        {
            key: "writeSequenceNumber",
            value: function writeSequenceNumber(e) {}
        },
        {
            key: "notifyBundleLoaded",
            value: function notifyBundleLoaded(e) {
            // No op.
            }
        }
    ]);
    return __PRIVATE_MemorySharedClientState;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The Platform's 'window' implementation or null if not available. */ function __PRIVATE_getWindow() {
    // `window` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof window ? window : null;
}
/** The Platform's 'document' implementation or null if not available. */ function getDocument() {
    // `document` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof document ? document : null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */ var DocumentSet = /*#__PURE__*/ function() {
    "use strict";
    function DocumentSet(e) {
        (0, $4QweW._)(this, DocumentSet);
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        this.comparator = e ? function(t, n) {
            return e(t, n) || DocumentKey.comparator(t.key, n.key);
        } : function(e, t) {
            return DocumentKey.comparator(e.key, t.key);
        }, this.keyedMap = documentMap(), this.sortedSet = new SortedMap(this.comparator);
    }
    (0, $6hK4i._)(DocumentSet, [
        {
            key: "has",
            value: function has(e) {
                return null != this.keyedMap.get(e);
            }
        },
        {
            key: "get",
            value: function get(e) {
                return this.keyedMap.get(e);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.sortedSet.minKey();
            }
        },
        {
            key: "last",
            value: function last() {
                return this.sortedSet.maxKey();
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.sortedSet.isEmpty();
            }
        },
        {
            /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */ key: "indexOf",
            value: function indexOf(e) {
                var t = this.keyedMap.get(e);
                return t ? this.sortedSet.indexOf(t) : -1;
            }
        },
        {
            key: "size",
            get: function get() {
                return this.sortedSet.size;
            }
        },
        {
            /** Iterates documents in order defined by "comparator" */ key: "forEach",
            value: function forEach(e) {
                this.sortedSet.inorderTraversal(function(t, n) {
                    return e(t), false;
                });
            }
        },
        {
            /** Inserts or updates a document with the same key */ key: "add",
            value: function add(e) {
                // First remove the element if we have it.
                var t = this.delete(e.key);
                return t.copy(t.keyedMap.insert(e.key, e), t.sortedSet.insert(e, null));
            }
        },
        {
            /** Deletes a document with a given key */ key: "delete",
            value: function _delete(e) {
                var t = this.get(e);
                return t ? this.copy(this.keyedMap.remove(e), this.sortedSet.remove(t)) : this;
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                if (!(e instanceof DocumentSet)) return false;
                if (this.size !== e.size) return false;
                var t = this.sortedSet.getIterator(), n = e.sortedSet.getIterator();
                for(; t.hasNext();){
                    var _$e = t.getNext().key, r = n.getNext().key;
                    if (!_$e.isEqual(r)) return false;
                }
                return true;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var e = [];
                return this.forEach(function(t) {
                    e.push(t.toString());
                }), 0 === e.length ? "DocumentSet ()" : "DocumentSet (\n  " + e.join("  \n") + "\n)";
            }
        },
        {
            key: "copy",
            value: function copy(e, t) {
                var n = new DocumentSet;
                return n.comparator = this.comparator, n.keyedMap = e, n.sortedSet = t, n;
            }
        }
    ], [
        {
            key: "emptySet",
            value: /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */ function emptySet(e) {
                return new DocumentSet(e.comparator);
            }
        }
    ]);
    return DocumentSet;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */ var __PRIVATE_DocumentChangeSet = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_DocumentChangeSet() {
        (0, $4QweW._)(this, __PRIVATE_DocumentChangeSet);
        this.pu = new SortedMap(DocumentKey.comparator);
    }
    (0, $6hK4i._)(__PRIVATE_DocumentChangeSet, [
        {
            key: "track",
            value: function track(e) {
                var t = e.doc.key, n = this.pu.get(t);
                n ? // Merge the new change with the existing change.
                0 /* ChangeType.Added */  !== e.type && 3 /* ChangeType.Metadata */  === n.type ? this.pu = this.pu.insert(t, e) : 3 /* ChangeType.Metadata */  === e.type && 1 /* ChangeType.Removed */  !== n.type ? this.pu = this.pu.insert(t, {
                    type: n.type,
                    doc: e.doc
                }) : 2 /* ChangeType.Modified */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.pu = this.pu.insert(t, {
                    type: 2 /* ChangeType.Modified */ ,
                    doc: e.doc
                }) : 2 /* ChangeType.Modified */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.pu = this.pu.insert(t, {
                    type: 0 /* ChangeType.Added */ ,
                    doc: e.doc
                }) : 1 /* ChangeType.Removed */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.pu = this.pu.remove(t) : 1 /* ChangeType.Removed */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.pu = this.pu.insert(t, {
                    type: 1 /* ChangeType.Removed */ ,
                    doc: n.doc
                }) : 0 /* ChangeType.Added */  === e.type && 1 /* ChangeType.Removed */  === n.type ? this.pu = this.pu.insert(t, {
                    type: 2 /* ChangeType.Modified */ ,
                    doc: e.doc
                }) : // This includes these cases, which don't make sense:
                // Added->Added
                // Removed->Removed
                // Modified->Added
                // Removed->Modified
                // Metadata->Added
                // Removed->Metadata
                l(63341, {
                    we: e,
                    gu: n
                }) : this.pu = this.pu.insert(t, e);
            }
        },
        {
            key: "yu",
            value: function yu() {
                var e = [];
                return this.pu.inorderTraversal(function(t, n) {
                    e.push(n);
                }), e;
            }
        }
    ]);
    return __PRIVATE_DocumentChangeSet;
}();
var ViewSnapshot = /*#__PURE__*/ function() {
    "use strict";
    function ViewSnapshot(e, t, n, r, i, s, _, o, a) {
        (0, $4QweW._)(this, ViewSnapshot);
        this.query = e, this.docs = t, this.oldDocs = n, this.docChanges = r, this.mutatedKeys = i, this.fromCache = s, this.syncStateChanged = _, this.excludesMetadataChanges = o, this.hasCachedResults = a;
    }
    (0, $6hK4i._)(ViewSnapshot, [
        {
            key: "hasPendingWrites",
            get: function get() {
                return !this.mutatedKeys.isEmpty();
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                if (!(this.fromCache === e.fromCache && this.hasCachedResults === e.hasCachedResults && this.syncStateChanged === e.syncStateChanged && this.mutatedKeys.isEqual(e.mutatedKeys) && __PRIVATE_queryOrPipelineEqual(this.query, e.query) && this.docs.isEqual(e.docs) && this.oldDocs.isEqual(e.oldDocs))) return false;
                var t = this.docChanges, n = e.docChanges;
                if (t.length !== n.length) return false;
                for(var _$e = 0; _$e < t.length; _$e++)if (t[_$e].type !== n[_$e].type || !t[_$e].doc.isEqual(n[_$e].doc)) return false;
                return true;
            }
        }
    ], [
        {
            key: "fromInitialDocuments",
            value: /** Returns a view snapshot as if all documents in the snapshot were added. */ function fromInitialDocuments(e, t, n, r, i) {
                var s = [];
                return t.forEach(function(e) {
                    s.push({
                        type: 0 /* ChangeType.Added */ ,
                        doc: e
                    });
                }), new ViewSnapshot(e, t, DocumentSet.emptySet(t), s, n, r, /* syncStateChanged= */ true, /* excludesMetadataChanges= */ false, i);
            }
        }
    ]);
    return ViewSnapshot;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */ var __PRIVATE_QueryListenersInfo = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_QueryListenersInfo() {
        (0, $4QweW._)(this, __PRIVATE_QueryListenersInfo);
        this.wu = void 0, this.bu = [];
    }
    (0, $6hK4i._)(__PRIVATE_QueryListenersInfo, [
        {
            // Helper methods that checks if the query has listeners that listening to remote store
            key: "Su",
            value: function Su() {
                return this.bu.some(function(e) {
                    return e.vu();
                });
            }
        }
    ]);
    return __PRIVATE_QueryListenersInfo;
}();
var __PRIVATE_EventManagerImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_EventManagerImpl() {
        (0, $4QweW._)(this, __PRIVATE_EventManagerImpl);
        this.queries = __PRIVATE_newQueriesObjectMap(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.Du = new Set;
    }
    (0, $6hK4i._)(__PRIVATE_EventManagerImpl, [
        {
            key: "terminate",
            value: function terminate() {
                !function __PRIVATE_errorAllTargets(e, t) {
                    var n = __PRIVATE_debugCast(e), r = n.queries;
                    // Prevent further access by clearing ObjectMap.
                    n.queries = __PRIVATE_newQueriesObjectMap(), r.forEach(function(e, n) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = n.bu[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                _$e.onError(t);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    });
                }(this, new e(ta.ABORTED, "Firestore shutting down"));
            }
        }
    ]);
    return __PRIVATE_EventManagerImpl;
}();
function __PRIVATE_newQueriesObjectMap() {
    return new ObjectMap(function(e) {
        return __PRIVATE_canonifyQueryOrPipeline(e);
    }, __PRIVATE_queryOrPipelineEqual);
}
function __PRIVATE_eventManagerListen(e, t) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var n, r, i, s, e1, n1;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = __PRIVATE_debugCast(e);
                    r = 3 /* ListenerSetupAction.NoActionRequired */ ;
                    i = t.query;
                    s = n.queries.get(i);
                    s ? !s.Su() && t.vu() && // Query has been listening to local cache, and tries to add a new listener sourced from watch.
                    (r = 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ ) : (s = new __PRIVATE_QueryListenersInfo, r = t.vu() ? 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */  : 1 /* ListenerSetupAction.InitializeLocalListenOnly */ );
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        9,
                        ,
                        10
                    ]);
                    switch(r){
                        case 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */ :
                            return [
                                3,
                                2
                            ];
                        case 1 /* ListenerSetupAction.InitializeLocalListenOnly */ :
                            return [
                                3,
                                4
                            ];
                        case 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ :
                            return [
                                3,
                                6
                            ];
                    }
                    return [
                        3,
                        8
                    ];
                case 2:
                    return [
                        4,
                        n.onListen(i, /** enableRemoteListen= */ !0)
                    ];
                case 3:
                    s.wu = _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    return [
                        4,
                        n.onListen(i, /** enableRemoteListen= */ !1)
                    ];
                case 5:
                    s.wu = _state.sent();
                    return [
                        3,
                        8
                    ];
                case 6:
                    return [
                        4,
                        n.onFirstRemoteStoreListen(i)
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    e1 = _state.sent();
                    n1 = __PRIVATE_wrapInUserErrorIfRecoverable(e1, "Initialization of query '".concat(__PRIVATE_isPipeline(t.query) ? __PRIVATE_canonifyPipeline(t.query) : __PRIVATE_stringifyQuery(t.query), "' failed"));
                    return [
                        2,
                        void t.onError(n1)
                    ];
                case 10:
                    if (n.queries.set(i, s), s.bu.push(t), // Run global snapshot listeners if a consistent snapshot has been emitted.
                    t.xu(n.onlineState), s.wu) t.Cu(s.wu) && __PRIVATE_raiseSnapshotsInSyncEvent(n);
                    return [
                        2
                    ];
            }
        });
    })();
}
function __PRIVATE_eventManagerUnlisten(e, t) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var n, r, i, s, _$e;
        return (0, $gh3Df._)(this, function(_state) {
            n = __PRIVATE_debugCast(e), r = t.query;
            i = 3 /* ListenerRemovalAction.NoActionRequired */ ;
            s = n.queries.get(r);
            if (s) {
                _$e = s.bu.indexOf(t);
                _$e >= 0 && (s.bu.splice(_$e, 1), 0 === s.bu.length ? i = t.vu() ? 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */  : 1 /* ListenerRemovalAction.TerminateLocalListenOnly */  : !s.Su() && t.vu() && // The removed listener is the last one that sourced from watch.
                (i = 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ ));
            }
            switch(i){
                case 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */ :
                    return [
                        2,
                        (n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ true))
                    ];
                case 1 /* ListenerRemovalAction.TerminateLocalListenOnly */ :
                    return [
                        2,
                        (n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ false))
                    ];
                case 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ :
                    return [
                        2,
                        n.onLastRemoteStoreUnlisten(r)
                    ];
                default:
                    return [
                        2
                    ];
            }
            return [
                2
            ];
        });
    })();
}
function __PRIVATE_eventManagerOnWatchChange(e, t) {
    var n = __PRIVATE_debugCast(e);
    var r = false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _$e = _step.value;
            var _$t = _$e.query, i = n.queries.get(_$t);
            if (i) {
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = i.bu[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _$t1 = _step1.value;
                        _$t1.Cu(_$e) && (r = true);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                i.wu = _$e;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    r && __PRIVATE_raiseSnapshotsInSyncEvent(n);
}
function __PRIVATE_eventManagerOnWatchError(e, t, n) {
    var r = __PRIVATE_debugCast(e), i = r.queries.get(t);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (i) try {
        for(var _iterator = i.bu[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _$e = _step.value;
            _$e.onError(n);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
    // after an error.
    r.queries.delete(t);
}
function __PRIVATE_raiseSnapshotsInSyncEvent(e) {
    e.Du.forEach(function(e) {
        e.next();
    });
}
var Vr;
!function(e) {
    /** Listen to both cache and server changes */ e.Default = "default", /** Listen to changes in cache only */ e.Cache = "cache";
}(Vr || (Vr = {}));
/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */ var __PRIVATE_QueryListener = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_QueryListener(e, t, n) {
        (0, $4QweW._)(this, __PRIVATE_QueryListener);
        this.query = e, this.Fu = t, /**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */ this.Ou = false, this.Mu = null, this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.options = n || {};
    }
    (0, $6hK4i._)(__PRIVATE_QueryListener, [
        {
            /**
     * Applies the new ViewSnapshot to this listener, raising a user-facing event
     * if applicable (depending on what changed, whether the user has opted into
     * metadata-only changes, etc.). Returns true if a user-facing event was
     * indeed raised.
     */ key: "Cu",
            value: function Cu(e) {
                if (!this.options.includeMetadataChanges) {
                    // Remove the metadata only changes.
                    var t = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = e.docChanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var n = _step.value;
                            3 /* ChangeType.Metadata */  !== n.type && t.push(n);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    e = new ViewSnapshot(e.query, e.docs, e.oldDocs, t, e.mutatedKeys, e.fromCache, e.syncStateChanged, /* excludesMetadataChanges= */ true, e.hasCachedResults);
                }
                var t1 = false;
                return this.Ou ? this.Nu(e) && (this.Fu.next(e), t1 = true) : this.Lu(e, this.onlineState) && (this.Bu(e), t1 = true), this.Mu = e, t1;
            }
        },
        {
            key: "onError",
            value: function onError(e) {
                this.Fu.error(e);
            }
        },
        {
            /** Returns whether a snapshot was raised. */ key: "xu",
            value: function xu(e) {
                this.onlineState = e;
                var t = false;
                return this.Mu && !this.Ou && this.Lu(this.Mu, e) && (this.Bu(this.Mu), t = true), t;
            }
        },
        {
            key: "Lu",
            value: function Lu(e, t) {
                // Always raise the first event when we're synced
                if (!e.fromCache) return true;
                // Always raise event if listening to cache
                if (!this.vu()) return true;
                // NOTE: We consider OnlineState.Unknown as online (it should become Offline
                // or Online if we wait long enough).
                var n = "Offline" /* OnlineState.Offline */  !== t;
                // Don't raise the event if we're online, aren't synced yet (checked
                // above) and are waiting for a sync.
                return (!this.options.waitForSyncWhenOnline || !n) && (!e.docs.isEmpty() || e.hasCachedResults || "Offline" /* OnlineState.Offline */  === t);
            // Raise data from cache if we have any documents, have cached results before,
            // or we are offline.
            }
        },
        {
            key: "Nu",
            value: function Nu(e) {
                // We don't need to handle includeDocumentMetadataChanges here because
                // the Metadata only changes have already been stripped out if needed.
                // At this point the only changes we will see are the ones we should
                // propagate.
                if (e.docChanges.length > 0) return true;
                var t = this.Mu && this.Mu.hasPendingWrites !== e.hasPendingWrites;
                return !(!e.syncStateChanged && !t) && true === this.options.includeMetadataChanges;
            // Generally we should have hit one of the cases above, but it's possible
            // to get here if there were only metadata docChanges and they got
            // stripped out.
            }
        },
        {
            key: "Bu",
            value: function Bu(e) {
                e = ViewSnapshot.fromInitialDocuments(e.query, e.docs, e.mutatedKeys, e.fromCache, e.hasCachedResults), this.Ou = true, this.Fu.next(e);
            }
        },
        {
            key: "vu",
            value: function vu() {
                return this.options.source !== Vr.Cache;
            }
        }
    ]);
    return __PRIVATE_QueryListener;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to convert objects from bundles to model objects in the SDK.
 */ var __PRIVATE_BundleConverterImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_BundleConverterImpl(e) {
        (0, $4QweW._)(this, __PRIVATE_BundleConverterImpl);
        this.serializer = e;
    }
    (0, $6hK4i._)(__PRIVATE_BundleConverterImpl, [
        {
            key: "Go",
            value: function Go(e) {
                return fromName(this.serializer, e);
            }
        },
        {
            /**
     * Converts a BundleDocument to a MutableDocument.
     */ key: "zo",
            value: function zo(e) {
                return e.metadata.exists ? fromDocument(this.serializer, e.document, false) : MutableDocument.newNoDocument(this.Go(e.metadata.name), this.jo(e.metadata.readTime));
            }
        },
        {
            key: "jo",
            value: function jo(e) {
                return __PRIVATE_fromVersion(e);
            }
        }
    ]);
    return __PRIVATE_BundleConverterImpl;
}();
/**
 * A class to process the elements from a bundle, and optionally load them into local
 * storage and provide progress update while loading.
 */ var __PRIVATE_BundleLoader = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_BundleLoader(e, t) {
        (0, $4QweW._)(this, __PRIVATE_BundleLoader);
        this.Uu = e, this.serializer = t, /** Batched queries to be saved into storage */ this.ku = [], /** Batched documents to be saved into storage */ this.qu = [], /** The collection groups affected by this bundle. */ this.collectionGroups = new Set, this.progress = __PRIVATE_bundleInitialProgress(e);
    }
    (0, $6hK4i._)(__PRIVATE_BundleLoader, [
        {
            key: "queries",
            get: /**
     * Returns the named queries that have been parsed from the SizeBundleElements added by
     * calling {@link adSizedElement}.
     */ function get() {
                return this.ku;
            }
        },
        {
            key: "documents",
            get: /**
     * Returns the BundledDocuments that have been parsed from the SizeBundleElements added by
     * calling {@link addSizedElement}.
     */ function get() {
                return this.qu;
            }
        },
        {
            /**
     * Adds an element from the bundle to the loader.
     *
     * Returns a new progress if adding the element leads to a new progress,
     * otherwise returns null.
     */ key: "$u",
            value: function $u(e) {
                this.progress.bytesLoaded += e.byteLength;
                var t = this.progress.documentsLoaded;
                if (e.Ho.namedQuery) this.ku.push(e.Ho.namedQuery);
                else if (e.Ho.documentMetadata) {
                    this.qu.push({
                        metadata: e.Ho.documentMetadata
                    }), e.Ho.documentMetadata.exists || ++t;
                    var n = ResourcePath.fromString(e.Ho.documentMetadata.name);
                    this.collectionGroups.add(n.get(n.length - 2));
                } else e.Ho.document && (this.qu[this.qu.length - 1].document = e.Ho.document, ++t);
                return t !== this.progress.documentsLoaded ? (this.progress.documentsLoaded = t, (0, $kWfK0._)({}, this.progress)) : null;
            }
        },
        {
            key: "Ku",
            value: function Ku(e) {
                var t = new Map, n = new __PRIVATE_BundleConverterImpl(this.serializer);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var r = _step.value;
                        if (r.metadata.queries) {
                            var _$e = n.Go(r.metadata.name);
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(var _iterator1 = r.metadata.queries[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    var n1 = _step1.value;
                                    var r1 = (t.get(n1) || __PRIVATE_documentKeySet()).add(_$e);
                                    t.set(n1, r1);
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return t;
            }
        },
        {
            key: "Qu",
            value: /**
     * Update the progress to 'Success' and return the updated progress.
     */ function Qu(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var t, n, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, t1, err;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    __PRIVATE_localStoreApplyBundledDocuments(e, new __PRIVATE_BundleConverterImpl(this.serializer), this.qu, this.Uu.id)
                                ];
                            case 1:
                                t = _state.sent(), n = this.Ku(this.documents);
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    7,
                                    8,
                                    9
                                ]);
                                _iterator = this.ku[Symbol.iterator]();
                                _state.label = 3;
                            case 3:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    6
                                ];
                                t1 = _step.value;
                                return [
                                    4,
                                    __PRIVATE_localStoreSaveNamedQuery(e, t1, n.get(t1.name))
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    3
                                ];
                            case 6:
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 9:
                                return [
                                    2,
                                    (this.progress.taskState = "Success", {
                                        progress: this.progress,
                                        Wu: this.collectionGroups,
                                        Gu: t
                                    })
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return __PRIVATE_BundleLoader;
}();
/**
 * Returns a `LoadBundleTaskProgress` representing the initial progress of
 * loading a bundle.
 */ function __PRIVATE_bundleInitialProgress(e) {
    return {
        taskState: "Running",
        documentsLoaded: 0,
        bytesLoaded: 0,
        totalDocuments: e.totalDocuments,
        totalBytes: e.totalBytes
    };
}
/**
 * Returns a `LoadBundleTaskProgress` representing the progress that the loading
 * has succeeded.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var __PRIVATE_AddedLimboDocument = function __PRIVATE_AddedLimboDocument(e) {
    "use strict";
    (0, $4QweW._)(this, __PRIVATE_AddedLimboDocument);
    this.key = e;
};
var __PRIVATE_RemovedLimboDocument = function __PRIVATE_RemovedLimboDocument(e) {
    "use strict";
    (0, $4QweW._)(this, __PRIVATE_RemovedLimboDocument);
    this.key = e;
};
/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */ var __PRIVATE_View = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_View(e, /** Documents included in the remote target */ t) {
        (0, $4QweW._)(this, __PRIVATE_View);
        this.query = e, this.zu = t, this.ju = null, this.hasCachedResults = false, /**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */ this.current = false, /** Documents in the view but not in the remote target */ this.Hu = __PRIVATE_documentKeySet(), /** Document Keys that have local changes */ this.mutatedKeys = __PRIVATE_documentKeySet(), this.Ju = __PRIVATE_isPipeline(e) ? __PRIVATE_newPipelineComparator(e) : __PRIVATE_newQueryComparator(e), this.Yu = new DocumentSet(this.Ju);
    }
    (0, $6hK4i._)(__PRIVATE_View, [
        {
            key: "Zu",
            get: /**
     * The set of remote documents that the server has told us belongs to the target associated with
     * this view.
     */ function get() {
                return this.zu;
            }
        },
        {
            /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges - The doc changes to apply to this view.
     * @param previousChanges - If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @returns a new set of docs, changes, and refill flag.
     */ key: "Xu",
            value: function Xu(e, t) {
                var _this = this;
                var n = t ? t.ec : new __PRIVATE_DocumentChangeSet, r = t ? t.Yu : this.Yu;
                var i = t ? t.mutatedKeys : this.mutatedKeys, s = r, _ = false;
                var _this_tc = (0, $6ZpBv._)(this.tc(this.query, r), 2), o = _this_tc[0], a = _this_tc[1];
                e.inorderTraversal(function(e, t) {
                    var u = r.get(e), c = __PRIVATE_queryOrPipelineMatches(_this.query, t) ? t : null, l = !!u && _this.mutatedKeys.has(u.key), E = !!c && (c.hasLocalMutations || // We only consider committed mutations for documents that were
                    // mutated during the lifetime of the view.
                    _this.mutatedKeys.has(c.key) && c.hasCommittedMutations);
                    var h = false;
                    // Calculate change
                    if (u && c) u.data.isEqual(c.data) ? l !== E && (n.track({
                        type: 3 /* ChangeType.Metadata */ ,
                        doc: c
                    }), h = true) : _this.nc(u, c) || (n.track({
                        type: 2 /* ChangeType.Modified */ ,
                        doc: c
                    }), h = true, (o && _this.Ju(c, o) > 0 || a && _this.Ju(c, a) < 0) && // This doc moved from inside the limit to outside the limit.
                    // That means there may be some other doc in the local cache
                    // that should be included instead.
                    (_ = true));
                    else !u && c ? (n.track({
                        type: 0 /* ChangeType.Added */ ,
                        doc: c
                    }), h = true) : u && !c && (n.track({
                        type: 1 /* ChangeType.Removed */ ,
                        doc: u
                    }), h = true, (o || a) && // A doc was removed from a full limit query. We'll need to
                    // requery from the local cache to see if we know about some other
                    // doc that should be in the results.
                    (_ = true));
                    h && (c ? (s = s.add(c), i = E ? i.add(e) : i.delete(e)) : (s = s.delete(e), i = i.delete(e)));
                });
                // Drop documents out to meet limit/limitToLast requirement.
                var u = this.rc(this.query);
                if (u) {
                    if (__PRIVATE_isPipeline(this.query)) {
                        // TODO(pipeline): Not very efficient obviously, but should be fine for now.
                        // Longer term, limit queries should be evaluated from query engine as well.
                        var _$e = [];
                        s.forEach(function(t) {
                            return _$e.push(t);
                        });
                        var _$t = __PRIVATE_runPipeline(this.query, _$e);
                        var r1 = new DocumentSet(__PRIVATE_newPipelineComparator(this.query));
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = _$t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e1 = _step.value;
                                r1 = r1.add(_$e1);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        s.forEach(function(e) {
                            r1.has(e.key) || (i = i.delete(e.key), n.track({
                                type: 1 /* ChangeType.Removed */ ,
                                doc: e
                            }));
                        }), s = r1;
                    } else {
                        var _$e2 = this.sc(this.query);
                        for(; s.size > u;){
                            var _$t1 = "F" /* LimitType.First */  === _$e2 ? s.last() : s.first();
                            s = s.delete(_$t1.key), i = i.delete(_$t1.key), n.track({
                                type: 1 /* ChangeType.Removed */ ,
                                doc: _$t1
                            });
                        }
                    }
                }
                return {
                    Yu: s,
                    ec: n,
                    Oo: _,
                    mutatedKeys: i
                };
            }
        },
        {
            key: "rc",
            value: function rc(e) {
                var _$__PRIVATE_getLastEffectiveLimit;
                return __PRIVATE_isPipeline(e) ? (_$__PRIVATE_getLastEffectiveLimit = __PRIVATE_getLastEffectiveLimit(e)) === null || _$__PRIVATE_getLastEffectiveLimit === void 0 ? void 0 : _$__PRIVATE_getLastEffectiveLimit.limit : e.limit || void 0;
            }
        },
        {
            key: "sc",
            value: function sc(e) {
                if (__PRIVATE_isPipeline(e)) {
                    var t = __PRIVATE_getLastEffectiveLimit(e);
                    return t && t.limit < 0 ? "L" /* LimitType.Last */  : "F" /* LimitType.First */ ;
                }
                return e.limitType;
            }
        },
        {
            key: "tc",
            value: function tc(e, t) {
                if (__PRIVATE_isPipeline(e)) {
                    var _$__PRIVATE_getLastEffectiveLimit;
                    var n = (_$__PRIVATE_getLastEffectiveLimit = __PRIVATE_getLastEffectiveLimit(e)) === null || _$__PRIVATE_getLastEffectiveLimit === void 0 ? void 0 : _$__PRIVATE_getLastEffectiveLimit.limit;
                    return [
                        t.size === n ? t.last() : null,
                        null
                    ];
                }
                return [
                    "F" /* LimitType.First */  === e.limitType && t.size === this.rc(this.query) ? t.last() : null,
                    "L" /* LimitType.Last */  === e.limitType && t.size === this.rc(this.query) ? t.first() : null
                ];
            }
        },
        {
            key: "nc",
            value: function nc(e, t) {
                // We suppress the initial change event for documents that were modified as
                // part of a write acknowledgment (e.g. when the value of a server transform
                // is applied) as Watch will send us the same document again.
                // By suppressing the event, we only raise two user visible events (one with
                // `hasPendingWrites` and the final state of the document) instead of three
                // (one with `hasPendingWrites`, the modified document with
                // `hasPendingWrites` and the final state of the document).
                return e.hasLocalMutations && t.hasCommittedMutations && !t.hasLocalMutations;
            }
        },
        {
            /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges - The set of changes to make to the view's docs.
     * @param limboResolutionEnabled - Whether to update limbo documents based on
     *        this change.
     * @param targetChange - A target change to apply for computing limbo docs and
     *        sync state.
     * @param targetIsPendingReset - Whether the target is pending to reset due to
     *        existence filter mismatch. If not explicitly specified, it is treated
     *        equivalently to `false`.
     * @returns A new ViewChange with the given docs, changes, and sync state.
     */ // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
            key: "applyChanges",
            value: function applyChanges(e, t, n, r) {
                var _this = this;
                var i = this.Yu;
                this.Yu = e.Yu, this.mutatedKeys = e.mutatedKeys;
                // Sort changes based on type and query comparator
                var s = e.ec.yu();
                s.sort(function(e, t) {
                    return function __PRIVATE_compareChangeType(e, t) {
                        var order = function(e) {
                            switch(e){
                                case 0 /* ChangeType.Added */ :
                                    return 1;
                                case 2 /* ChangeType.Modified */ :
                                case 3 /* ChangeType.Metadata */ :
                                    // A metadata change is converted to a modified change at the public
                                    // api layer.  Since we sort by document key and then change type,
                                    // metadata and modified changes must be sorted equivalently.
                                    return 2;
                                case 1 /* ChangeType.Removed */ :
                                    return 0;
                                default:
                                    return l(20277, {
                                        we: e
                                    });
                            }
                        };
                        return order(e) - order(t);
                    }(e.type, t.type) || _this.Ju(e.doc, t.doc);
                }), this._c(n), r = r !== null && r !== void 0 ? r : false;
                var _ = t && !r ? this.oc() : [], o = 0 === this.Hu.size && this.current && !r ? 1 /* SyncState.Synced */  : 0 /* SyncState.Local */ , a = o !== this.ju;
                // We are at synced state if there is no limbo docs are waiting to be resolved, view is current
                // with the backend, and the query is not pending to reset due to existence filter mismatch.
                if (this.ju = o, 0 !== s.length || a) return {
                    snapshot: new ViewSnapshot(this.query, e.Yu, i, s, e.mutatedKeys, 0 /* SyncState.Local */  === o, a, /* excludesMetadataChanges= */ false, !!n && n.resumeToken.approximateByteSize() > 0),
                    ac: _
                };
                // no changes
                return {
                    ac: _
                };
            }
        },
        {
            /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */ key: "xu",
            value: function xu(e) {
                return this.current && "Offline" /* OnlineState.Offline */  === e ? // If we're offline, set `current` to false and then call applyChanges()
                // to refresh our syncState and generate a ViewChange as appropriate. We
                // are guaranteed to get a new TargetChange that sets `current` back to
                // true once the client is back online.
                (this.current = false, this.applyChanges({
                    Yu: this.Yu,
                    ec: new __PRIVATE_DocumentChangeSet,
                    mutatedKeys: this.mutatedKeys,
                    Oo: false
                }, /* limboResolutionEnabled= */ false)) : {
                    ac: []
                };
            }
        },
        {
            /**
     * Returns whether the doc for the given key should be in limbo.
     */ key: "uc",
            value: function uc(e) {
                // If the remote end says it's part of this query, it's not in limbo.
                return !this.zu.has(e) && // The local store doesn't think it's a result, so it shouldn't be in limbo.
                !!this.Yu.has(e) && !this.Yu.get(e).hasLocalMutations;
            }
        },
        {
            /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */ key: "_c",
            value: function _c(e) {
                var _this = this;
                e && (e.addedDocuments.forEach(function(e) {
                    return _this.zu = _this.zu.add(e);
                }), e.modifiedDocuments.forEach(function(e) {}), e.removedDocuments.forEach(function(e) {
                    return _this.zu = _this.zu.delete(e);
                }), this.current = e.current);
            }
        },
        {
            key: "oc",
            value: function oc() {
                var _this = this;
                // We can only determine limbo documents when we're in-sync with the server.
                if (!this.current) return [];
                // TODO(klimt): Do this incrementally so that it's not quadratic when
                // updating many documents.
                var e = this.Hu;
                this.Hu = __PRIVATE_documentKeySet(), this.Yu.forEach(function(e) {
                    _this.uc(e.key) && (_this.Hu = _this.Hu.add(e.key));
                });
                // Diff the new limbo docs with the old limbo docs.
                var t = [];
                return e.forEach(function(e) {
                    _this.Hu.has(e) || t.push(new __PRIVATE_RemovedLimboDocument(e));
                }), this.Hu.forEach(function(n) {
                    e.has(n) || t.push(new __PRIVATE_AddedLimboDocument(n));
                }), t;
            }
        },
        {
            /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param queryResult.documents - The documents that match the query according
     * to the LocalStore.
     * @param queryResult.remoteKeys - The keys of the documents that match the
     * query according to the backend.
     *
     * @returns The ViewChange that resulted from this synchronization.
     */ // PORTING NOTE: Multi-tab only.
            key: "cc",
            value: function cc(e) {
                this.zu = e.Wo, this.Hu = __PRIVATE_documentKeySet();
                var t = this.Xu(e.documents);
                return this.applyChanges(t, /* limboResolutionEnabled= */ true);
            }
        },
        {
            /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */ // PORTING NOTE: Multi-tab only.
            key: "lc",
            value: function lc() {
                return ViewSnapshot.fromInitialDocuments(this.query, this.Yu, this.mutatedKeys, 0 /* SyncState.Local */  === this.ju, this.hasCachedResults);
            }
        }
    ]);
    return __PRIVATE_View;
}();
var dr = "SyncEngine";
/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */ var __PRIVATE_QueryView = function __PRIVATE_QueryView(/**
     * The query itself.
     */ e, /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */ t, /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */ n) {
    "use strict";
    (0, $4QweW._)(this, __PRIVATE_QueryView);
    this.query = e, this.targetId = t, this.view = n;
};
/** Tracks a limbo resolution. */ var LimboResolution = function LimboResolution(e) {
    "use strict";
    (0, $4QweW._)(this, LimboResolution);
    this.key = e, /**
         * Set to true once we've received a document. This is used in
         * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
         * decide whether it needs to manufacture a delete event for the target once
         * the target is CURRENT.
         */ this.Ec = false;
};
/**
 * An implementation of `SyncEngine` coordinating with other parts of SDK.
 *
 * The parts of SyncEngine that act as a callback to RemoteStore need to be
 * registered individually. This is done in `syncEngineWrite()` and
 * `syncEngineListen()` (as well as `applyPrimaryState()`) as these methods
 * serve as entry points to RemoteStore's functionality.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ var __PRIVATE_SyncEngineImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_SyncEngineImpl(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
    r, i, s) {
        (0, $4QweW._)(this, __PRIVATE_SyncEngineImpl);
        this.localStore = e, this.remoteStore = t, this.eventManager = n, this.sharedClientState = r, this.currentUser = i, this.maxConcurrentLimboResolutions = s, this.hc = {}, this.Tc = new ObjectMap(function(e) {
            return __PRIVATE_canonifyQueryOrPipeline(e);
        }, __PRIVATE_queryOrPipelineEqual), this.Pc = new Map, /**
         * The keys of documents that are in limbo for which we haven't yet started a
         * limbo resolution query. The strings in this set are the result of calling
         * `key.path.canonicalString()` where `key` is a `DocumentKey` object.
         *
         * The `Set` type was chosen because it provides efficient lookup and removal
         * of arbitrary elements and it also maintains insertion order, providing the
         * desired queue-like FIFO semantics.
         */ this.Ic = new Set, /**
         * Keeps track of the target ID for each document that is in limbo with an
         * active target.
         */ this.Rc = new SortedMap(DocumentKey.comparator), /**
         * Keeps track of the information about an active limbo resolution for each
         * active target ID that was started for the purpose of limbo resolution.
         */ this.Ac = new Map, this.Vc = new __PRIVATE_ReferenceSet, /** Stores user completion handlers, indexed by User and BatchId. */ this.dc = {}, /** Stores user callbacks waiting for all pending writes to be acknowledged. */ this.fc = new Map, this.mc = __PRIVATE_TargetIdGenerator.bs(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        this.gc = void 0;
    }
    (0, $6hK4i._)(__PRIVATE_SyncEngineImpl, [
        {
            key: "isPrimaryClient",
            get: function get() {
                return true === this.gc;
            }
        }
    ]);
    return __PRIVATE_SyncEngineImpl;
}();
/**
 * Initiates the new listen, resolves promise when listen enqueued to the
 * server. All the subsequent view snapshots or errors are sent to the
 * subscribed handlers. Returns the initial snapshot.
 */ function __PRIVATE_syncEngineListen(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var r, i, s, _tmp;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = __PRIVATE_ensureWatchCallbacks(e);
                    s = r.Tc.get(t);
                    if (!s) return [
                        3,
                        1
                    ];
                    // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
                    // already exists when EventManager calls us for the first time. This
                    // happens when the primary tab is already listening to this query on
                    // behalf of another tab and the user of the primary also starts listening
                    // to the query. EventManager will not have an assigned target ID in this
                    // case and calls `listen` to obtain this ID.
                    _tmp = (r.sharedClientState.addLocalQueryTarget(s.targetId), i = s.view.lc());
                    return [
                        3,
                        3
                    ];
                case 1:
                    return [
                        4,
                        __PRIVATE_allocateTargetAndMaybeListen(r, t, n, /** shouldInitializeView= */ true)
                    ];
                case 2:
                    _tmp = i = _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        (_tmp, i)
                    ];
            }
        });
    })();
}
/** Query has been listening to the cache, and tries to initiate the remote store listen */ function __PRIVATE_triggerRemoteStoreListen(e, t) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var n;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = __PRIVATE_ensureWatchCallbacks(e);
                    return [
                        4,
                        __PRIVATE_allocateTargetAndMaybeListen(n, t, /** shouldListenToRemote= */ true, /** shouldInitializeView= */ false)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function __PRIVATE_allocateTargetAndMaybeListen(e, t, n, r) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var i, s, _, o, _tmp;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        __PRIVATE_localStoreAllocateTarget(e.localStore, __PRIVATE_isPipeline(t) ? t : __PRIVATE_queryToTarget(t))
                    ];
                case 1:
                    i = _state.sent(), s = i.targetId, _ = e.sharedClientState.addLocalQueryTarget(s, n);
                    _tmp = r;
                    if (!_tmp) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        __PRIVATE_initializeViewAndComputeSnapshot(e, t, s, "current" === _, i.resumeToken)
                    ];
                case 2:
                    _tmp = o = _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        (_tmp, e.isPrimaryClient && n && __PRIVATE_remoteStoreListen(e.remoteStore, i), o)
                    ];
            }
        });
    })();
}
/**
 * Registers a view for a previously unknown query and computes its initial
 * snapshot.
 */ function __PRIVATE_initializeViewAndComputeSnapshot(e, t, n, r, i) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var s, _, o, a, u, c;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // PORTING NOTE: On Web only, we inject the code that registers new Limbo
                    // targets based on view changes. This allows us to only depend on Limbo
                    // changes when user code includes queries.
                    e.yc = function(t, n, r) {
                        return function __PRIVATE_applyDocChanges(e, t, n, r) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                                var _$i, _tmp, s, _, o;
                                return (0, $gh3Df._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _$i = t.view.Xu(n);
                                            _tmp = _$i.Oo;
                                            if (!_tmp) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                __PRIVATE_localStoreExecuteQuery(e.localStore, t.query, /* usePreviousResults= */ false).then(function(param) {
                                                    var _$e = param.documents;
                                                    return t.view.Xu(_$e, _$i);
                                                })
                                            ];
                                        case 1:
                                            // The query has a limit and some docs were removed, so we need
                                            // to re-run the query against the local store to make sure we
                                            // didn't lose any good docs that had been past the limit.
                                            _tmp = _$i = _state.sent();
                                            _state.label = 2;
                                        case 2:
                                            _tmp;
                                            s = r && r.targetChanges.get(t.targetId), _ = r && null != r.targetMismatches.get(t.targetId), o = t.view.applyChanges(_$i, /* limboResolutionEnabled= */ e.isPrimaryClient, s, _);
                                            return [
                                                2,
                                                (__PRIVATE_updateTrackedLimbos(e, t.targetId, o.ac), o.snapshot)
                                            ];
                                    }
                                });
                            })();
                        }(e, t, n, r);
                    };
                    return [
                        4,
                        __PRIVATE_localStoreExecuteQuery(e.localStore, t, /* usePreviousResults= */ true)
                    ];
                case 1:
                    s = _state.sent(), _ = new __PRIVATE_View(t, s.Wo), o = _.Xu(s.documents), a = TargetChange.createSynthesizedTargetChangeForCurrentChange(n, r && "Offline" /* OnlineState.Offline */  !== e.onlineState, i), u = _.applyChanges(o, /* limboResolutionEnabled= */ e.isPrimaryClient, a);
                    __PRIVATE_updateTrackedLimbos(e, n, u.ac);
                    c = new __PRIVATE_QueryView(t, n, _);
                    return [
                        2,
                        (e.Tc.set(t, c), e.Pc.has(n) ? e.Pc.get(n).push(t) : e.Pc.set(n, [
                            t
                        ]), u.snapshot)
                    ];
            }
        });
    })();
}
/** Stops listening to the query. */ function __PRIVATE_syncEngineUnlisten(e, t, n) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var r, i, s, _tmp;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = __PRIVATE_debugCast(e), i = r.Tc.get(t), s = r.Pc.get(i.targetId);
                    if (s.length > 1) return [
                        2,
                        (r.Pc.set(i.targetId, s.filter(function(e) {
                            return !__PRIVATE_queryOrPipelineEqual(e, t);
                        })), void r.Tc.delete(t))
                    ];
                    if (!r.isPrimaryClient) return [
                        3,
                        3
                    ];
                    // We need to remove the local query target first to allow us to verify
                    // whether any other client is still interested in this target.
                    r.sharedClientState.removeLocalQueryTarget(i.targetId);
                    _tmp = r.sharedClientState.isActiveQueryTarget(i.targetId);
                    if (_tmp) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        __PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ false).then(function() {
                            r.sharedClientState.clearQueryState(i.targetId), n && __PRIVATE_remoteStoreUnlisten(r.remoteStore, i.targetId), __PRIVATE_removeAndCleanupTarget(r, i.targetId);
                        }).catch(__PRIVATE_ignoreIfPrimaryLeaseLoss)
                    ];
                case 1:
                    _tmp = _state.sent();
                    _state.label = 2;
                case 2:
                    _tmp;
                    return [
                        3,
                        5
                    ];
                case 3:
                    __PRIVATE_removeAndCleanupTarget(r, i.targetId);
                    return [
                        4,
                        __PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ true)
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    return [
                        2
                    ];
            }
        });
    })();
}
/** Unlistens to the remote store while still listening to the cache. */ function __PRIVATE_triggerRemoteStoreUnlisten(e, t) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var n, r, i;
        return (0, $gh3Df._)(this, function(_state) {
            n = __PRIVATE_debugCast(e), r = n.Tc.get(t), i = n.Pc.get(r.targetId);
            n.isPrimaryClient && 1 === i.length && // PORTING NOTE: Unregister the target ID with local Firestore client as
            // watch target.
            (n.sharedClientState.removeLocalQueryTarget(r.targetId), __PRIVATE_remoteStoreUnlisten(n.remoteStore, r.targetId));
            return [
                2
            ];
        });
    })();
}
/**
 * Initiates the write of local mutation batch which involves adding the
 * writes to the mutation queue, notifying the remote store about new
 * mutations and raising events for any changes this write caused.
 *
 * The promise returned by this call is resolved when the above steps
 * have completed, *not* when the write was acked by the backend. The
 * userCallback is resolved once the write was acked/rejected by the
 * backend (or failed locally for any other reason).
 */ function __PRIVATE_syncEngineWrite(e, t, n) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var r, _$e, e1, _$t;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = __PRIVATE_syncEngineEnsureWriteCallbacks(e);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        function __PRIVATE_localStoreWriteLocally(e, t) {
                            var _$n = __PRIVATE_debugCast(e), r = Timestamp.now(), i = t.reduce(function(e, t) {
                                return e.add(t.key);
                            }, __PRIVATE_documentKeySet());
                            var s, _;
                            return _$n.persistence.runTransaction("Locally write mutations", "readwrite", function(e) {
                                // Figure out which keys do not have a remote version in the cache, this
                                // is needed to create the right overlay mutation: if no remote version
                                // presents, we do not need to create overlays as patch mutations.
                                // TODO(Overlay): Is there a better way to determine this? Using the
                                //  document version does not work because local mutations set them back
                                //  to 0.
                                var o = __PRIVATE_mutableDocumentMap(), a = __PRIVATE_documentKeySet();
                                return _$n.ko.getEntries(e, i).next(function(e) {
                                    o = e, o.forEach(function(e, t) {
                                        t.isValidDocument() || (a = a.add(e));
                                    });
                                }).next(function() {
                                    return _$n.localDocuments.getOverlayedDocuments(e, o);
                                }).next(function(i) {
                                    s = i;
                                    // For non-idempotent mutations (such as `FieldValue.increment()`),
                                    // we record the base state in a separate patch mutation. This is
                                    // later used to guarantee consistent values and prevents flicker
                                    // even if the backend sends us an update that already includes our
                                    // transform.
                                    var _ = [];
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var _$e = _step.value;
                                            var _$t = __PRIVATE_mutationExtractBaseValue(_$e, s.get(_$e.key).overlayedDocument);
                                            null != _$t && // NOTE: The base state should only be applied if there's some
                                            // existing document to override, so use a Precondition of
                                            // exists=true
                                            _.push(new __PRIVATE_PatchMutation(_$e.key, _$t, __PRIVATE_extractFieldMask(_$t.value.mapValue), Precondition.exists(!0)));
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    return _$n.mutationQueue.addMutationBatch(e, r, _, t);
                                }).next(function(t) {
                                    _ = t;
                                    var r = t.applyToLocalDocumentSet(s, a);
                                    return _$n.documentOverlayCache.saveOverlays(e, t.batchId, r);
                                });
                            }).then(function() {
                                return {
                                    batchId: _.batchId,
                                    changes: __PRIVATE_convertOverlayedDocumentMapToDocumentMap(s)
                                };
                            });
                        }(r.localStore, t)
                    ];
                case 2:
                    _$e = _state.sent();
                    r.sharedClientState.addPendingMutation(_$e.batchId), function __PRIVATE_addMutationCallback(e, t, n) {
                        var r = e.dc[e.currentUser.toKey()];
                        r || (r = new SortedMap(__PRIVATE_primitiveComparator));
                        r = r.insert(t, n), e.dc[e.currentUser.toKey()] = r;
                    }(r, _$e.batchId, n);
                    return [
                        4,
                        __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, _$e.changes)
                    ];
                case 3:
                    _state.sent();
                    return [
                        4,
                        __PRIVATE_fillWritePipeline(r.remoteStore)
                    ];
                case 4:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 5:
                    e1 = _state.sent();
                    // If we can't persist the mutation, we reject the user callback and
                    // don't send the mutation. The user can then retry the write.
                    _$t = __PRIVATE_wrapInUserErrorIfRecoverable(e1, "Failed to persist write");
                    n.reject(_$t);
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    })();
}
/**
 * Applies one remote event to the sync engine, notifying any views of the
 * changes, and releasing any pending mutation batches that would become
 * visible because of the snapshot version the remote event contains.
 */ function __PRIVATE_syncEngineApplyRemoteEvent(e, t) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var n, _$e, e1;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = __PRIVATE_debugCast(e);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        6
                    ]);
                    return [
                        4,
                        __PRIVATE_localStoreApplyRemoteEventToLocalCache(n.localStore, t)
                    ];
                case 2:
                    _$e = _state.sent();
                    // Update `receivedDocument` as appropriate for any limbo targets.
                    t.targetChanges.forEach(function(e, t) {
                        var r = n.Ac.get(t);
                        r && // Since this is a limbo resolution lookup, it's for a single document
                        // and it could be added, modified, or removed, but not a combination.
                        (__PRIVATE_hardAssert(e.addedDocuments.size + e.modifiedDocuments.size + e.removedDocuments.size <= 1, 22616), e.addedDocuments.size > 0 ? r.Ec = !0 : e.modifiedDocuments.size > 0 ? __PRIVATE_hardAssert(r.Ec, 14607) : e.removedDocuments.size > 0 && (__PRIVATE_hardAssert(r.Ec, 42227), r.Ec = !1));
                    });
                    return [
                        4,
                        __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, _$e, t)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 4:
                    e1 = _state.sent();
                    return [
                        4,
                        __PRIVATE_ignoreIfPrimaryLeaseLoss(e1)
                    ];
                case 5:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    })();
}
/**
 * Applies an OnlineState change to the sync engine and notifies any views of
 * the change.
 */ function __PRIVATE_syncEngineApplyOnlineStateChange(e, t, n) {
    var r = __PRIVATE_debugCast(e);
    // If we are the secondary client, we explicitly ignore the remote store's
    // online state (the local client may go offline, even though the primary
    // tab remains online) and only apply the primary tab's online state from
    // SharedClientState.
    if (r.isPrimaryClient && 0 /* OnlineStateSource.RemoteStore */  === n || !r.isPrimaryClient && 1 /* OnlineStateSource.SharedClientState */  === n) {
        var _$e = [];
        r.Tc.forEach(function(n, r) {
            var i = r.view.xu(t);
            i.snapshot && _$e.push(i.snapshot);
        }), function __PRIVATE_eventManagerOnOnlineStateChange(e, t) {
            var _$n = __PRIVATE_debugCast(e);
            _$n.onlineState = t;
            var r = false;
            _$n.queries.forEach(function(e, n) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = n.bu[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$e = _step.value;
                        // Run global snapshot listeners if a consistent snapshot has been emitted.
                        _$e.xu(t) && (r = true);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }), r && __PRIVATE_raiseSnapshotsInSyncEvent(_$n);
        }(r.eventManager, t), _$e.length && r.hc.Tn(_$e), r.onlineState = t, r.isPrimaryClient && r.sharedClientState.setOnlineState(t);
    }
}
/**
 * Rejects the listen for the given targetID. This can be triggered by the
 * backend for any active target.
 *
 * @param syncEngine - The sync engine implementation.
 * @param targetId - The targetID corresponds to one previously initiated by the
 * user as part of TargetData passed to listen() on RemoteStore.
 * @param err - A description of the condition that has forced the rejection.
 * Nearly always this will be an indication that the user is no longer
 * authorized to see the data matching the target.
 */ function __PRIVATE_syncEngineRejectListen(e, t, n) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var r, i, s, _$e, _$n, i1;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = __PRIVATE_debugCast(e);
                    // PORTING NOTE: Multi-tab only.
                    r.sharedClientState.updateQueryState(t, "rejected", n);
                    i = r.Ac.get(t), s = i && i.key;
                    if (!s) return [
                        3,
                        2
                    ];
                    // TODO(klimt): We really only should do the following on permission
                    // denied errors, but we don't have the cause code here.
                    // It's a limbo doc. Create a synthetic event saying it was deleted.
                    // This is kind of a hack. Ideally, we would have a method in the local
                    // store to purge a document. However, it would be tricky to keep all of
                    // the local store's invariants with another method.
                    _$e = new SortedMap(DocumentKey.comparator);
                    // TODO(b/217189216): This limbo document should ideally have a read time,
                    // so that it is picked up by any read-time based scans. The backend,
                    // however, does not send a read time for target removals.
                    _$e = _$e.insert(s, MutableDocument.newNoDocument(s, SnapshotVersion.min()));
                    _$n = __PRIVATE_documentKeySet().add(s), i1 = new RemoteEvent(SnapshotVersion.min(), /* targetChanges= */ new Map, /* targetMismatches= */ new SortedMap(__PRIVATE_primitiveComparator), _$e, __PRIVATE_mutableDocumentMap(), _$n);
                    return [
                        4,
                        __PRIVATE_syncEngineApplyRemoteEvent(r, i1)
                    ];
                case 1:
                    _state.sent(), // Since this query failed, we won't want to manually unlisten to it.
                    // We only remove it from bookkeeping after we successfully applied the
                    // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
                    // this query when the RemoteStore restarts the Watch stream, which should
                    // re-trigger the target failure.
                    r.Rc = r.Rc.remove(s), r.Ac.delete(t), __PRIVATE_pumpEnqueuedLimboResolutions(r);
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        __PRIVATE_localStoreReleaseTarget(r.localStore, t, /* keepPersistedTargetData */ false).then(function() {
                            return __PRIVATE_removeAndCleanupTarget(r, t, n);
                        }).catch(__PRIVATE_ignoreIfPrimaryLeaseLoss)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}
function __PRIVATE_syncEngineApplySuccessfulWrite(e, t) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var n, r, _$e, e1;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = __PRIVATE_debugCast(e), r = t.batch.batchId;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        6
                    ]);
                    return [
                        4,
                        __PRIVATE_localStoreAcknowledgeBatch(n.localStore, t)
                    ];
                case 2:
                    _$e = _state.sent();
                    // The local store may or may not be able to apply the write result and
                    // raise events immediately (depending on whether the watcher is caught
                    // up), so we raise user callbacks first so that they consistently happen
                    // before listen events.
                    __PRIVATE_processUserCallback(n, r, /*error=*/ null), __PRIVATE_triggerPendingWritesCallbacks(n, r), n.sharedClientState.updateMutationState(r, "acknowledged");
                    return [
                        4,
                        __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, _$e)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 4:
                    e1 = _state.sent();
                    return [
                        4,
                        __PRIVATE_ignoreIfPrimaryLeaseLoss(e1)
                    ];
                case 5:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    })();
}
function __PRIVATE_syncEngineRejectFailedWrite(e, t, n) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var r, _$e, n1;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = __PRIVATE_debugCast(e);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        6
                    ]);
                    return [
                        4,
                        function __PRIVATE_localStoreRejectBatch(e, t) {
                            var _$n = __PRIVATE_debugCast(e);
                            return _$n.persistence.runTransaction("Reject batch", "readwrite-primary", function(e) {
                                var r;
                                return _$n.mutationQueue.lookupMutationBatch(e, t).next(function(t) {
                                    return __PRIVATE_hardAssert(null !== t, 37113), r = t.keys(), _$n.mutationQueue.removeMutationBatch(e, t);
                                }).next(function() {
                                    return _$n.mutationQueue.performConsistencyCheck(e);
                                }).next(function() {
                                    return _$n.documentOverlayCache.removeOverlaysForBatchId(e, r, t);
                                }).next(function() {
                                    return _$n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, r);
                                }).next(function() {
                                    return _$n.localDocuments.getDocuments(e, r);
                                });
                            });
                        }(r.localStore, t)
                    ];
                case 2:
                    _$e = _state.sent();
                    // The local store may or may not be able to apply the write result and
                    // raise events immediately (depending on whether the watcher is caught up),
                    // so we raise user callbacks first so that they consistently happen before
                    // listen events.
                    __PRIVATE_processUserCallback(r, t, n), __PRIVATE_triggerPendingWritesCallbacks(r, t), r.sharedClientState.updateMutationState(t, "rejected", n);
                    return [
                        4,
                        __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, _$e)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 4:
                    n1 = _state.sent();
                    return [
                        4,
                        __PRIVATE_ignoreIfPrimaryLeaseLoss(n1)
                    ];
                case 5:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    })();
}
/**
 * Registers a user callback that resolves when all pending mutations at the moment of calling
 * are acknowledged .
 */ function __PRIVATE_syncEngineRegisterPendingWritesCallback(e, t) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var n, _$e, r, e1, n1;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = __PRIVATE_debugCast(e);
                    __PRIVATE_canUseNetwork(n.remoteStore) || __PRIVATE_logDebug(dr, "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled.");
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        function __PRIVATE_localStoreGetHighestUnacknowledgedBatchId(e) {
                            var _$t = __PRIVATE_debugCast(e);
                            return _$t.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", function(e) {
                                return _$t.mutationQueue.getHighestUnacknowledgedBatchId(e);
                            });
                        }(n.localStore)
                    ];
                case 2:
                    _$e = _state.sent();
                    if (_$e === Ke) // Trigger the callback right away if there is no pending writes at the moment.
                    return [
                        2,
                        void t.resolve()
                    ];
                    r = n.fc.get(_$e) || [];
                    r.push(t), n.fc.set(_$e, r);
                    return [
                        3,
                        4
                    ];
                case 3:
                    e1 = _state.sent();
                    n1 = __PRIVATE_wrapInUserErrorIfRecoverable(e1, "Initialization of waitForPendingWrites() operation failed");
                    t.reject(n1);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}
/**
 * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
 * if there are any.
 */ function __PRIVATE_triggerPendingWritesCallbacks(e, t) {
    (e.fc.get(t) || []).forEach(function(e) {
        e.resolve();
    }), e.fc.delete(t);
}
/** Reject all outstanding callbacks waiting for pending writes to complete. */ function __PRIVATE_processUserCallback(e, t, n) {
    var r = __PRIVATE_debugCast(e);
    var i = r.dc[r.currentUser.toKey()];
    // NOTE: Mutations restored from persistence won't have callbacks, so it's
    // okay for there to be no callback for this ID.
    if (i) {
        var _$e = i.get(t);
        _$e && (n ? _$e.reject(n) : _$e.resolve(), i = i.remove(t)), r.dc[r.currentUser.toKey()] = i;
    }
}
function __PRIVATE_removeAndCleanupTarget(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    e.sharedClientState.removeLocalQueryTarget(t);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e.Pc.get(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var r = _step.value;
            e.Tc.delete(r), n && e.hc.wc(r, n);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (e.Pc.delete(t), e.isPrimaryClient) e.Vc.e_(t).forEach(function(t) {
        e.Vc.containsKey(t) || // We removed the last reference for this key
        __PRIVATE_removeLimboTarget(e, t);
    });
}
function __PRIVATE_removeLimboTarget(e, t) {
    e.Ic.delete(t.path.canonicalString());
    // It's possible that the target already got removed because the query failed. In that case,
    // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
    var n = e.Rc.get(t);
    null !== n && (__PRIVATE_remoteStoreUnlisten(e.remoteStore, n), e.Rc = e.Rc.remove(t), e.Ac.delete(n), __PRIVATE_pumpEnqueuedLimboResolutions(e));
}
function __PRIVATE_updateTrackedLimbos(e, t, n) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var r = _step.value;
            if (r instanceof __PRIVATE_AddedLimboDocument) e.Vc.addReference(r.key, t), __PRIVATE_trackLimboChange(e, r);
            else if (r instanceof __PRIVATE_RemovedLimboDocument) {
                __PRIVATE_logDebug(dr, "Document no longer in limbo: " + r.key), e.Vc.removeReference(r.key, t);
                e.Vc.containsKey(r.key) || // We removed the last reference for this key
                __PRIVATE_removeLimboTarget(e, r.key);
            } else l(19791, {
                bc: r
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function __PRIVATE_trackLimboChange(e, t) {
    var n = t.key, r = n.path.canonicalString();
    e.Rc.get(n) || e.Ic.has(r) || (__PRIVATE_logDebug(dr, "New document in limbo: " + n), e.Ic.add(r), __PRIVATE_pumpEnqueuedLimboResolutions(e));
}
/**
 * Starts listens for documents in limbo that are enqueued for resolution,
 * subject to a maximum number of concurrent resolutions.
 *
 * Without bounding the number of concurrent resolutions, the server can fail
 * with "resource exhausted" errors which can lead to pathological client
 * behavior as seen in https://github.com/firebase/firebase-js-sdk/issues/2683.
 */ function __PRIVATE_pumpEnqueuedLimboResolutions(e) {
    for(; e.Ic.size > 0 && e.Rc.size < e.maxConcurrentLimboResolutions;){
        var t = e.Ic.values().next().value;
        e.Ic.delete(t);
        var n = new DocumentKey(ResourcePath.fromString(t)), r = e.mc.next();
        e.Ac.set(r, new LimboResolution(n)), e.Rc = e.Rc.insert(n, r), __PRIVATE_remoteStoreListen(e.remoteStore, new TargetData(__PRIVATE_queryToTarget(__PRIVATE_newQueryForPath(n.path)), r, "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ , __PRIVATE_ListenSequence.wn));
    }
}
function __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, t, n) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var r, i, s, _, _tmp;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = __PRIVATE_debugCast(e), i = [], s = [], _ = [];
                    _tmp = r.Tc.isEmpty();
                    if (_tmp) return [
                        3,
                        3
                    ];
                    r.Tc.forEach(function(e, o) {
                        _.push(r.yc(o, t, n).then(function(e) {
                            // If there are changes, or we are handling a global snapshot, notify
                            // secondary clients to update query state.
                            if ((e || n) && r.isPrimaryClient) {
                                var _n_targetChanges_get;
                                // Query state is set to `current` if:
                                // - There is a view change and it is up-to-date, or,
                                // - There is a global snapshot, the Target is current, and no changes to be resolved
                                var _$t = e ? !e.fromCache : n === null || n === void 0 ? void 0 : (_n_targetChanges_get = n.targetChanges.get(o.targetId)) === null || _n_targetChanges_get === void 0 ? void 0 : _n_targetChanges_get.current;
                                r.sharedClientState.updateQueryState(o.targetId, _$t ? "current" : "not-current");
                            }
                            // Update views if there are actual changes.
                            if (e) {
                                i.push(e);
                                var _$t1 = __PRIVATE_LocalViewChanges.mo(o.targetId, e);
                                s.push(_$t1);
                            }
                        }));
                    });
                    return [
                        4,
                        Promise.all(_)
                    ];
                case 1:
                    _state.sent(), r.hc.Tn(i);
                    return [
                        4,
                        function __PRIVATE_localStoreNotifyLocalViewChanges(e, t) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                                var n, e1, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _$e, _$t, _$e1, r, i;
                                return (0, $gh3Df._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            n = __PRIVATE_debugCast(e);
                                            _state.label = 1;
                                        case 1:
                                            _state.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4,
                                                n.persistence.runTransaction("notifyLocalViewChanges", "readwrite", function(e) {
                                                    return PersistencePromise.forEach(t, function(t) {
                                                        return PersistencePromise.forEach(t.Vo, function(r) {
                                                            return n.persistence.referenceDelegate.addReference(e, t.targetId, r);
                                                        }).next(function() {
                                                            return PersistencePromise.forEach(t.fo, function(r) {
                                                                return n.persistence.referenceDelegate.removeReference(e, t.targetId, r);
                                                            });
                                                        });
                                                    });
                                                })
                                            ];
                                        case 2:
                                            _state.sent();
                                            return [
                                                3,
                                                4
                                            ];
                                        case 3:
                                            e1 = _state.sent();
                                            if (!__PRIVATE_isIndexedDbTransactionError(e1)) throw e1;
                                            // If `notifyLocalViewChanges` fails, we did not advance the sequence
                                            // number for the documents that were included in this transaction.
                                            // This might trigger them to be deleted earlier than they otherwise
                                            // would have, but it should not invalidate the integrity of the data.
                                            __PRIVATE_logDebug(lr, "Failed to update sequence numbers: " + e1);
                                            return [
                                                3,
                                                4
                                            ];
                                        case 4:
                                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(_iterator = t[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    _$e = _step.value;
                                                    _$t = _$e.targetId;
                                                    if (!_$e.fromCache) {
                                                        _$e1 = n.Lo.get(_$t), r = _$e1.snapshotVersion, i = _$e1.withLastLimboFreeSnapshotVersion(r);
                                                        // Advance the last limbo free snapshot version
                                                        n.Lo = n.Lo.insert(_$t, i);
                                                    }
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                        _iterator.return();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })();
                        }(r.localStore, s)
                    ];
                case 2:
                    _tmp = _state.sent();
                    _state.label = 3;
                case 3:
                    _tmp;
                    return [
                        2
                    ];
            }
        });
    })();
}
function __PRIVATE_syncEngineHandleCredentialChange(t, n) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var r, _$t;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = __PRIVATE_debugCast(t);
                    if (!!r.currentUser.isEqual(n)) return [
                        3,
                        3
                    ];
                    __PRIVATE_logDebug(dr, "User change. New user:", n.toKey());
                    return [
                        4,
                        __PRIVATE_localStoreHandleUserChange(r.localStore, n)
                    ];
                case 1:
                    _$t = _state.sent();
                    r.currentUser = n, // Fails tasks waiting for pending writes requested by previous user.
                    function __PRIVATE_rejectOutstandingPendingWritesCallbacks(t, n) {
                        t.fc.forEach(function(t) {
                            t.forEach(function(t) {
                                t.reject(new e(ta.CANCELLED, n));
                            });
                        }), t.fc.clear();
                    }(r, "'waitForPendingWrites' promise is rejected due to a user change."), // TODO(b/114226417): Consider calling this only in the primary tab.
                    r.sharedClientState.handleUserChange(n, _$t.removedBatchIds, _$t.addedBatchIds);
                    return [
                        4,
                        __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, _$t.$o)
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
}
function __PRIVATE_syncEngineGetRemoteKeysForTarget(e, t) {
    var n = __PRIVATE_debugCast(e), r = n.Ac.get(t);
    if (r && r.Ec) return __PRIVATE_documentKeySet().add(r.key);
    {
        var _$e = __PRIVATE_documentKeySet();
        var r1 = n.Pc.get(t);
        if (!r1) return _$e;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = (r1 !== null && r1 !== void 0 ? r1 : [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _$t = _step.value;
                var r2 = n.Tc.get(_$t);
                _$e = _$e.unionWith(r2.view.Zu);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _$e;
    }
}
/**
 * Reconcile the list of synced documents in an existing view with those
 * from persistence.
 */ function __PRIVATE_synchronizeViewAndComputeSnapshot(e, t) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var n, r, i;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = __PRIVATE_debugCast(e);
                    return [
                        4,
                        __PRIVATE_localStoreExecuteQuery(n.localStore, t.query, /* usePreviousResults= */ true)
                    ];
                case 1:
                    r = _state.sent(), i = t.view.cc(r);
                    return [
                        2,
                        (n.isPrimaryClient && __PRIVATE_updateTrackedLimbos(n, t.targetId, i.ac), i)
                    ];
            }
        });
    })();
}
/**
 * Retrieves newly changed documents from remote document cache and raises
 * snapshots if needed.
 */ // PORTING NOTE: Multi-Tab only.
function __PRIVATE_syncEngineSynchronizeWithChangedDocuments(e, t) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var n;
        return (0, $gh3Df._)(this, function(_state) {
            n = __PRIVATE_debugCast(e);
            return [
                2,
                __PRIVATE_localStoreGetNewDocumentChanges(n.localStore, t).then(function(e) {
                    return __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e);
                })
            ];
        });
    })();
}
/** Applies a mutation state to an existing batch.  */ // PORTING NOTE: Multi-Tab only.
function __PRIVATE_syncEngineApplyBatchState(e, t, n, r) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var i, s, _tmp, _tmp1;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    i = __PRIVATE_debugCast(e);
                    return [
                        4,
                        function __PRIVATE_localStoreLookupMutationDocuments(e, t) {
                            var _$n = __PRIVATE_debugCast(e), _$r = __PRIVATE_debugCast(_$n.mutationQueue);
                            return _$n.persistence.runTransaction("Lookup mutation documents", "readonly", function(e) {
                                return _$r.Wr(e, t).next(function(t) {
                                    return t ? _$n.localDocuments.getDocuments(e, t) : PersistencePromise.resolve(null);
                                });
                            });
                        }(i.localStore, t)
                    ];
                case 1:
                    s = _state.sent();
                    if (!(null !== s)) return [
                        3,
                        6
                    ];
                    if (!("pending" === n)) return [
                        3,
                        3
                    ];
                    // If we are the primary client, we need to send this write to the
                    // backend. Secondary clients will ignore these writes since their remote
                    // connection is disabled.
                    return [
                        4,
                        __PRIVATE_fillWritePipeline(i.remoteStore)
                    ];
                case 2:
                    _tmp1 = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    _tmp1 = "acknowledged" === n || "rejected" === n ? // NOTE: Both these methods are no-ops for batches that originated from
                    // other clients.
                    (__PRIVATE_processUserCallback(i, t, r || null), __PRIVATE_triggerPendingWritesCallbacks(i, t), function __PRIVATE_localStoreRemoveCachedMutationBatchMetadata(e, t) {
                        __PRIVATE_debugCast(__PRIVATE_debugCast(e).mutationQueue).Hr(t);
                    }(i.localStore, t)) : l(6720, "Unknown batchState", {
                        Sc: n
                    });
                    _state.label = 4;
                case 4:
                    _tmp1;
                    return [
                        4,
                        __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, s)
                    ];
                case 5:
                    _tmp = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    _tmp = // A throttled tab may not have seen the mutation before it was completed
                    // and removed from the mutation queue, in which case we won't have cached
                    // the affected documents. In this case we can safely ignore the update
                    // since that means we didn't apply the mutation locally at all (if we
                    // had, we would have cached the affected documents), and so we will just
                    // see any resulting document changes via normal remote document updates
                    // as applicable.
                    __PRIVATE_logDebug(dr, "Cannot apply mutation batch with id: " + t);
                    _state.label = 7;
                case 7:
                    _tmp;
                    return [
                        2
                    ];
            }
        });
    })();
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
function __PRIVATE_syncEngineApplyPrimaryState(e, t) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var n, _$e, _$t, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _$e1, _$e2, _$t1;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = __PRIVATE_debugCast(e);
                    if (!(__PRIVATE_ensureWatchCallbacks(n), __PRIVATE_syncEngineEnsureWriteCallbacks(n), true === t && true !== n.gc)) return [
                        3,
                        3
                    ];
                    _$e = n.sharedClientState.getAllActiveQueryTargets();
                    return [
                        4,
                        __PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, _$e.toArray())
                    ];
                case 1:
                    _$t = _state.sent();
                    n.gc = true;
                    return [
                        4,
                        __PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, true)
                    ];
                case 2:
                    _state.sent();
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = _$t[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            _$e1 = _step.value;
                            __PRIVATE_remoteStoreListen(n.remoteStore, _$e1);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return [
                        3,
                        7
                    ];
                case 3:
                    if (!(false === t && false !== n.gc)) return [
                        3,
                        7
                    ];
                    _$e2 = [];
                    _$t1 = Promise.resolve();
                    n.Pc.forEach(function(r, i) {
                        n.sharedClientState.isLocalQueryTarget(i) ? _$e2.push(i) : _$t1 = _$t1.then(function() {
                            return __PRIVATE_removeAndCleanupTarget(n, i), __PRIVATE_localStoreReleaseTarget(n.localStore, i, /*keepPersistedTargetData=*/ true);
                        }), __PRIVATE_remoteStoreUnlisten(n.remoteStore, i);
                    });
                    return [
                        4,
                        _$t1
                    ];
                case 4:
                    _state.sent();
                    return [
                        4,
                        __PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, _$e2)
                    ];
                case 5:
                    _state.sent(), // PORTING NOTE: Multi-Tab only.
                    function __PRIVATE_resetLimboDocuments(e) {
                        var _$t = __PRIVATE_debugCast(e);
                        _$t.Ac.forEach(function(e, n) {
                            __PRIVATE_remoteStoreUnlisten(_$t.remoteStore, n);
                        }), _$t.Vc.t_(), _$t.Ac = new Map, _$t.Rc = new SortedMap(DocumentKey.comparator);
                    }(n), n.gc = false;
                    return [
                        4,
                        __PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, false)
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        2
                    ];
            }
        });
    })();
}
function __PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(e, t, n) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var r, i, s, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _$e, _$t, n, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, _$e1, _$t1, n1, err, n2, err;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = __PRIVATE_debugCast(e), i = [], s = [];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    _iterator = t[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        18
                    ];
                    _$e = _step.value;
                    _$t = void 0;
                    n = r.Pc.get(_$e);
                    if (!(n && 0 !== n.length)) return [
                        3,
                        12
                    ];
                    return [
                        4,
                        __PRIVATE_localStoreAllocateTarget(r.localStore, __PRIVATE_isPipeline(n[0]) ? n[0] : __PRIVATE_queryToTarget(n[0]))
                    ];
                case 3:
                    // For queries that have a local View, we fetch their current state
                    // from LocalStore (as the resume token and the snapshot version
                    // might have changed) and reconcile their views with the persisted
                    // state (the list of syncedDocuments may have gotten out of sync).
                    _$t = _state.sent();
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        9,
                        10,
                        11
                    ]);
                    _iterator1 = n[Symbol.iterator]();
                    _state.label = 5;
                case 5:
                    if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                        3,
                        8
                    ];
                    _$e1 = _step1.value;
                    _$t1 = r.Tc.get(_$e1);
                    return [
                        4,
                        __PRIVATE_synchronizeViewAndComputeSnapshot(r, _$t1)
                    ];
                case 6:
                    n1 = _state.sent();
                    n1.snapshot && s.push(n1.snapshot);
                    _state.label = 7;
                case 7:
                    _iteratorNormalCompletion1 = true;
                    return [
                        3,
                        5
                    ];
                case 8:
                    return [
                        3,
                        11
                    ];
                case 9:
                    err = _state.sent();
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                    return [
                        3,
                        11
                    ];
                case 10:
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        3,
                        16
                    ];
                case 12:
                    return [
                        4,
                        __PRIVATE_localStoreGetCachedTarget(r.localStore, _$e)
                    ];
                case 13:
                    n2 = _state.sent();
                    return [
                        4,
                        __PRIVATE_localStoreAllocateTarget(r.localStore, n2)
                    ];
                case 14:
                    _$t = _state.sent();
                    return [
                        4,
                        __PRIVATE_initializeViewAndComputeSnapshot(r, __PRIVATE_synthesizeTargetToQuery(n2), _$e, /*current=*/ false, _$t.resumeToken)
                    ];
                case 15:
                    _state.sent();
                    _state.label = 16;
                case 16:
                    i.push(_$t);
                    _state.label = 17;
                case 17:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 18:
                    return [
                        3,
                        21
                    ];
                case 19:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        21
                    ];
                case 20:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 21:
                    return [
                        2,
                        (r.hc.Tn(s), i)
                    ];
            }
        });
    })();
}
/**
 * Creates a `Query` object from the specified `Target`. There is no way to
 * obtain the original `Query`, so we synthesize a `Query` from the `Target`
 * object.
 *
 * The synthesized result might be different from the original `Query`, but
 * since the synthesized `Query` should return the same results as the
 * original one (only the presentation of results might differ), the potential
 * difference will not cause issues.
 */ // PORTING NOTE: Multi-Tab only.
function __PRIVATE_synthesizeTargetToQuery(e) {
    return __PRIVATE_targetIsPipelineTarget(e) ? e : __PRIVATE_newQuery(e.path, e.collectionGroup, e.orderBy, e.filters, e.limit, "F" /* LimitType.First */ , e.startAt, e.endAt);
}
/** Returns the IDs of the clients that are currently active. */ // PORTING NOTE: Multi-Tab only.
function __PRIVATE_syncEngineGetActiveClients(e) {
    return function __PRIVATE_localStoreGetActiveClients(e) {
        return __PRIVATE_debugCast(__PRIVATE_debugCast(e).persistence).Ro();
    }(__PRIVATE_debugCast(e).localStore);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
function __PRIVATE_syncEngineApplyTargetState(e, t, n, r) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var i, s, _$e, _, _$r;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    i = __PRIVATE_debugCast(e);
                    if (i.gc) // If we receive a target state notification via WebStorage, we are
                    // either already secondary or another tab has taken the primary lease.
                    return [
                        2,
                        void __PRIVATE_logDebug(dr, "Ignoring unexpected query state notification.")
                    ];
                    s = i.Pc.get(t);
                    if (!(s && s.length > 0)) return [
                        3,
                        15
                    ];
                    switch(n){
                        case "current":
                            return [
                                3,
                                1
                            ];
                        case "not-current":
                            return [
                                3,
                                1
                            ];
                        case "rejected":
                            return [
                                3,
                                12
                            ];
                    }
                    return [
                        3,
                        14
                    ];
                case 1:
                    if (!__PRIVATE_isPipeline(s[0])) return [
                        3,
                        8
                    ];
                    _ = getPipelineSourceType(s[0]);
                    switch(_){
                        case "collection_group":
                            return [
                                3,
                                2
                            ];
                        case "collection":
                            return [
                                3,
                                2
                            ];
                        case "documents":
                            return [
                                3,
                                4
                            ];
                    }
                    return [
                        3,
                        6
                    ];
                case 2:
                    return [
                        4,
                        __PRIVATE_localStoreGetNewDocumentChanges(i.localStore, getPipelineCollectionId(s[0]))
                    ];
                case 3:
                    _$e = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 4:
                    return [
                        4,
                        function __PRIVATE_localStoreGetDocuments(e, t) {
                            var _$n = __PRIVATE_debugCast(e), _$r = __PRIVATE_documentKeySet.apply(void 0, (0, $jlUaU._)(getPipelineDocuments(t).map(function(e) {
                                return DocumentKey.fromPath(e);
                            })));
                            return _$n.persistence.runTransaction("Get documents for pipeline", "readonly", function(e) {
                                return _$n.ko.getEntries(e, _$r);
                            }).then(function(e) {
                                return e;
                            });
                        }(i.localStore, s[0])
                    ];
                case 5:
                    _$e = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    __PRIVATE_logWarn(""), _$e = documentMap();
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        10
                    ];
                case 8:
                    return [
                        4,
                        __PRIVATE_localStoreGetNewDocumentChanges(i.localStore, function __PRIVATE_queryCollectionGroup(e) {
                            return e.collectionGroup || (e.path.length % 2 == 1 ? e.path.lastSegment() : e.path.get(e.path.length - 2));
                        }(s[0]))
                    ];
                case 9:
                    _$e = _state.sent();
                    _state.label = 10;
                case 10:
                    _$r = RemoteEvent.createSynthesizedRemoteEventForCurrentChange(t, "current" === n, ByteString.EMPTY_BYTE_STRING);
                    return [
                        4,
                        __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, _$e, _$r)
                    ];
                case 11:
                    _state.sent();
                    return [
                        3,
                        15
                    ];
                case 12:
                    return [
                        4,
                        __PRIVATE_localStoreReleaseTarget(i.localStore, t, /* keepPersistedTargetData */ true)
                    ];
                case 13:
                    _state.sent(), __PRIVATE_removeAndCleanupTarget(i, t, r);
                    return [
                        3,
                        15
                    ];
                case 14:
                    l(64155, n);
                    _state.label = 15;
                case 15:
                    return [
                        2
                    ];
            }
        });
    })();
}
/** Adds or removes Watch targets for queries from different tabs. */ function __PRIVATE_syncEngineApplyActiveTargetsChange(e, t, n) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var r, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _$e, _$t, _$n, err, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _loop, _iterator1, _step1, err;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = __PRIVATE_ensureWatchCallbacks(e);
                    if (!r.gc) return [
                        3,
                        18
                    ];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        9,
                        10
                    ]);
                    _iterator = t[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        7
                    ];
                    _$e = _step.value;
                    if (r.Pc.has(_$e) && r.sharedClientState.isActiveQueryTarget(_$e)) {
                        __PRIVATE_logDebug(dr, "Adding an already active target " + _$e);
                        return [
                            3,
                            6
                        ];
                    }
                    return [
                        4,
                        __PRIVATE_localStoreGetCachedTarget(r.localStore, _$e)
                    ];
                case 3:
                    _$t = _state.sent();
                    return [
                        4,
                        __PRIVATE_localStoreAllocateTarget(r.localStore, _$t)
                    ];
                case 4:
                    _$n = _state.sent();
                    return [
                        4,
                        __PRIVATE_initializeViewAndComputeSnapshot(r, __PRIVATE_synthesizeTargetToQuery(_$t), _$n.targetId, /*current=*/ false, _$n.resumeToken)
                    ];
                case 5:
                    _state.sent(), __PRIVATE_remoteStoreListen(r.remoteStore, _$n);
                    _state.label = 6;
                case 6:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 7:
                    return [
                        3,
                        10
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        10
                    ];
                case 9:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 10:
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    _state.label = 11;
                case 11:
                    _state.trys.push([
                        11,
                        16,
                        17,
                        18
                    ]);
                    _loop = function() {
                        var _$e, _tmp;
                        return (0, $gh3Df._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _$e = _step1.value;
                                    // Check that the target is still active since the target might have been
                                    // removed if it has been rejected by the backend.
                                    _tmp = r.Pc.has(_$e);
                                    if (!_tmp) return [
                                        3,
                                        2
                                    ];
                                    // Release queries that are still active.
                                    return [
                                        4,
                                        __PRIVATE_localStoreReleaseTarget(r.localStore, _$e, /* keepPersistedTargetData */ false).then(function() {
                                            __PRIVATE_remoteStoreUnlisten(r.remoteStore, _$e), __PRIVATE_removeAndCleanupTarget(r, _$e);
                                        }).catch(__PRIVATE_ignoreIfPrimaryLeaseLoss)
                                    ];
                                case 1:
                                    _tmp = _state.sent();
                                    _state.label = 2;
                                case 2:
                                    _tmp;
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    _iterator1 = n[Symbol.iterator]();
                    _state.label = 12;
                case 12:
                    if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                        3,
                        15
                    ];
                    return [
                        5,
                        (0, $2TaHn.__values)(_loop())
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    _iteratorNormalCompletion1 = true;
                    return [
                        3,
                        12
                    ];
                case 15:
                    return [
                        3,
                        18
                    ];
                case 16:
                    err = _state.sent();
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                    return [
                        3,
                        18
                    ];
                case 17:
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                    return [
                        7
                    ];
                case 18:
                    return [
                        2
                    ];
            }
        });
    })();
}
function __PRIVATE_ensureWatchCallbacks(e) {
    var t = __PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applyRemoteEvent = __PRIVATE_syncEngineApplyRemoteEvent.bind(null, t), t.remoteStore.remoteSyncer.getRemoteKeysForTarget = __PRIVATE_syncEngineGetRemoteKeysForTarget.bind(null, t), t.remoteStore.remoteSyncer.rejectListen = __PRIVATE_syncEngineRejectListen.bind(null, t), t.hc.Tn = __PRIVATE_eventManagerOnWatchChange.bind(null, t.eventManager), t.hc.wc = __PRIVATE_eventManagerOnWatchError.bind(null, t.eventManager), t;
}
function __PRIVATE_syncEngineEnsureWriteCallbacks(e) {
    var t = __PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applySuccessfulWrite = __PRIVATE_syncEngineApplySuccessfulWrite.bind(null, t), t.remoteStore.remoteSyncer.rejectFailedWrite = __PRIVATE_syncEngineRejectFailedWrite.bind(null, t), t;
}
/**
 * Loads a Firestore bundle into the SDK. The returned promise resolves when
 * the bundle finished loading.
 *
 * @param syncEngine - SyncEngine to use.
 * @param bundleReader - Bundle to load into the SDK.
 * @param task - LoadBundleTask used to update the loading progress to public API.
 */ function __PRIVATE_syncEngineLoadBundle(e, t, n) {
    var r = __PRIVATE_debugCast(e);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    /** Loads a bundle and returns the list of affected collection groups. */ (function __PRIVATE_loadBundleImpl(e, t, n) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var r, i, s, _$e, _, e1;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            14,
                            ,
                            15
                        ]);
                        return [
                            4,
                            t.getMetadata()
                        ];
                    case 1:
                        r = _state.sent();
                        return [
                            4,
                            function __PRIVATE_localStoreHasNewerBundle(e, t) {
                                var _$n = __PRIVATE_debugCast(e), r = __PRIVATE_fromVersion(t.createTime);
                                return _$n.persistence.runTransaction("hasNewerBundle", "readonly", function(e) {
                                    return _$n.f_.getBundleMetadata(e, t.id);
                                }).then(function(e) {
                                    return !!e && e.createTime.compareTo(r) >= 0;
                                });
                            }(e.localStore, r)
                        ];
                    case 2:
                        if (!_state.sent()) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            t.close()
                        ];
                    case 3:
                        return [
                            2,
                            (_state.sent(), n._completeWith(function __PRIVATE_bundleSuccessProgress(e) {
                                return {
                                    taskState: "Success",
                                    documentsLoaded: e.totalDocuments,
                                    bytesLoaded: e.totalBytes,
                                    totalDocuments: e.totalDocuments,
                                    totalBytes: e.totalBytes
                                };
                            }(r)), Promise.resolve(new Set))
                        ];
                    case 4:
                        n._updateProgress(__PRIVATE_bundleInitialProgress(r));
                        i = new __PRIVATE_BundleLoader(r, t.serializer);
                        return [
                            4,
                            t.pa()
                        ];
                    case 5:
                        s = _state.sent();
                        _state.label = 6;
                    case 6:
                        if (!s) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            i.$u(s)
                        ];
                    case 7:
                        _$e = _state.sent();
                        _$e && n._updateProgress(_$e);
                        return [
                            4,
                            t.pa()
                        ];
                    case 8:
                        s = _state.sent();
                        _state.label = 9;
                    case 9:
                        return [
                            3,
                            6
                        ];
                    case 10:
                        return [
                            4,
                            i.Qu(e.localStore)
                        ];
                    case 11:
                        _ = _state.sent();
                        return [
                            4,
                            __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, _.Gu, /* remoteEvent */ void 0)
                        ];
                    case 12:
                        _state.sent();
                        // Save metadata, so loading the same bundle will skip.
                        return [
                            4,
                            function __PRIVATE_localStoreSaveBundle(e, t) {
                                var _$n = __PRIVATE_debugCast(e);
                                return _$n.persistence.runTransaction("Save bundle", "readwrite", function(e) {
                                    return _$n.f_.saveBundleMetadata(e, t);
                                });
                            }(e.localStore, r)
                        ];
                    case 13:
                        return [
                            2,
                            (_state.sent(), n._completeWith(_.progress), Promise.resolve(_.Wu))
                        ];
                    case 14:
                        e1 = _state.sent();
                        return [
                            2,
                            (__PRIVATE_logWarn(dr, "Loading bundle failed with ".concat(e1)), n._failWith(e1), Promise.resolve(new Set))
                        ];
                    case 15:
                        return [
                            2
                        ];
                }
            });
        })();
    })(r, t, n).then(function(e) {
        r.sharedClientState.notifyBundleLoaded(e);
    });
}
var __PRIVATE_MemoryOfflineComponentProvider = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryOfflineComponentProvider() {
        (0, $4QweW._)(this, __PRIVATE_MemoryOfflineComponentProvider);
        this.kind = "memory", this.synchronizeTabs = false;
    }
    (0, $6hK4i._)(__PRIVATE_MemoryOfflineComponentProvider, [
        {
            key: "initialize",
            value: function initialize(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this.serializer = __PRIVATE_newSerializer(e.databaseInfo.databaseId), this.sharedClientState = this.vc(e), this.persistence = this.Dc(e);
                                return [
                                    4,
                                    this.persistence.start()
                                ];
                            case 1:
                                _state.sent(), this.localStore = this.xc(e), this.gcScheduler = this.Cc(e, this.localStore), this.indexBackfillerScheduler = this.Fc(e, this.localStore);
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "Cc",
            value: function Cc(e, t) {
                return null;
            }
        },
        {
            key: "Fc",
            value: function Fc(e, t) {
                return null;
            }
        },
        {
            key: "xc",
            value: function xc(e) {
                return __PRIVATE_newLocalStore(this.persistence, new __PRIVATE_QueryEngine, e.initialUser, this.serializer);
            }
        },
        {
            key: "Dc",
            value: function Dc(e) {
                return new __PRIVATE_MemoryPersistence(__PRIVATE_MemoryEagerDelegate.b_, this.serializer);
            }
        },
        {
            key: "vc",
            value: function vc(e) {
                return new __PRIVATE_MemorySharedClientState;
            }
        },
        {
            key: "terminate",
            value: function terminate() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _this_gcScheduler, _this_indexBackfillerScheduler;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (_this_gcScheduler = this.gcScheduler) === null || _this_gcScheduler === void 0 ? void 0 : _this_gcScheduler.stop(), (_this_indexBackfillerScheduler = this.indexBackfillerScheduler) === null || _this_indexBackfillerScheduler === void 0 ? void 0 : _this_indexBackfillerScheduler.stop(), this.sharedClientState.shutdown();
                                return [
                                    4,
                                    this.persistence.shutdown()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return __PRIVATE_MemoryOfflineComponentProvider;
}();
__PRIVATE_MemoryOfflineComponentProvider.provider = {
    build: function() {
        return new __PRIVATE_MemoryOfflineComponentProvider;
    }
};
var __PRIVATE_LruGcMemoryOfflineComponentProvider = /*#__PURE__*/ function(__PRIVATE_MemoryOfflineComponentProvider) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_LruGcMemoryOfflineComponentProvider, __PRIVATE_MemoryOfflineComponentProvider);
    function __PRIVATE_LruGcMemoryOfflineComponentProvider(e) {
        (0, $4QweW._)(this, __PRIVATE_LruGcMemoryOfflineComponentProvider);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_LruGcMemoryOfflineComponentProvider), _this.cacheSizeBytes = e;
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_LruGcMemoryOfflineComponentProvider, [
        {
            key: "Cc",
            value: function Cc(e, t) {
                __PRIVATE_hardAssert(this.persistence.referenceDelegate instanceof __PRIVATE_MemoryLruDelegate, 46915);
                var n = this.persistence.referenceDelegate.garbageCollector;
                return new __PRIVATE_LruScheduler(n, e.asyncQueue, t);
            }
        },
        {
            key: "Dc",
            value: function Dc(e) {
                var t = void 0 !== this.cacheSizeBytes ? LruParams.withCacheSize(this.cacheSizeBytes) : LruParams.DEFAULT;
                return new __PRIVATE_MemoryPersistence(function(e) {
                    return __PRIVATE_MemoryLruDelegate.b_(e, t);
                }, this.serializer);
            }
        }
    ]);
    return __PRIVATE_LruGcMemoryOfflineComponentProvider;
}(__PRIVATE_MemoryOfflineComponentProvider);
/**
 * Provides all components needed for Firestore with IndexedDB persistence.
 */ var __PRIVATE_IndexedDbOfflineComponentProvider = /*#__PURE__*/ function(__PRIVATE_MemoryOfflineComponentProvider) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_IndexedDbOfflineComponentProvider, __PRIVATE_MemoryOfflineComponentProvider);
    function __PRIVATE_IndexedDbOfflineComponentProvider(e, t, n) {
        (0, $4QweW._)(this, __PRIVATE_IndexedDbOfflineComponentProvider);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_IndexedDbOfflineComponentProvider), _this.Oc = e, _this.cacheSizeBytes = t, _this.forceOwnership = n, _this.kind = "persistent", _this.synchronizeTabs = false;
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_IndexedDbOfflineComponentProvider, [
        {
            key: "initialize",
            value: function initialize(e) {
                var _this = this;
                var _this1 = this, _superprop_get_initialize = function() {
                    return (0, $hC9N3._)((0, $9atk1._)(__PRIVATE_IndexedDbOfflineComponentProvider.prototype), "initialize", _this);
                };
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _this;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    _superprop_get_initialize().call(_this1, e)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this.Oc.initialize(this, e)
                                ];
                            case 2:
                                _state.sent();
                                // Enqueue writes from a previous session
                                return [
                                    4,
                                    __PRIVATE_syncEngineEnsureWriteCallbacks(this.Oc.syncEngine)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    4,
                                    __PRIVATE_fillWritePipeline(this.Oc.remoteStore)
                                ];
                            case 4:
                                _state.sent();
                                // NOTE: This will immediately call the listener, so we make sure to
                                // set it after localStore / remoteStore are started.
                                return [
                                    4,
                                    this.persistence.eo(function() {
                                        return _this.gcScheduler && !_this.gcScheduler.started && _this.gcScheduler.start(), _this.indexBackfillerScheduler && !_this.indexBackfillerScheduler.started && _this.indexBackfillerScheduler.start(), Promise.resolve();
                                    })
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "xc",
            value: function xc(e) {
                return __PRIVATE_newLocalStore(this.persistence, new __PRIVATE_QueryEngine, e.initialUser, this.serializer);
            }
        },
        {
            key: "Cc",
            value: function Cc(e, t) {
                var n = this.persistence.referenceDelegate.garbageCollector;
                return new __PRIVATE_LruScheduler(n, e.asyncQueue, t);
            }
        },
        {
            key: "Fc",
            value: function Fc(e, t) {
                var n = new __PRIVATE_IndexBackfiller(t, this.persistence);
                return new __PRIVATE_IndexBackfillerScheduler(e.asyncQueue, n);
            }
        },
        {
            key: "Dc",
            value: function Dc(e) {
                var t = __PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey), n = void 0 !== this.cacheSizeBytes ? LruParams.withCacheSize(this.cacheSizeBytes) : LruParams.DEFAULT;
                return new __PRIVATE_IndexedDbPersistence(this.synchronizeTabs, t, e.clientId, n, e.asyncQueue, __PRIVATE_getWindow(), getDocument(), this.serializer, this.sharedClientState, !!this.forceOwnership);
            }
        },
        {
            key: "vc",
            value: function vc(e) {
                return new __PRIVATE_MemorySharedClientState;
            }
        }
    ]);
    return __PRIVATE_IndexedDbOfflineComponentProvider;
}(__PRIVATE_MemoryOfflineComponentProvider);
/**
 * Provides all components needed for Firestore with multi-tab IndexedDB
 * persistence.
 *
 * In the legacy client, this provider is used to provide both multi-tab and
 * non-multi-tab persistence since we cannot tell at build time whether
 * `synchronizeTabs` will be enabled.
 */ var __PRIVATE_MultiTabOfflineComponentProvider = /*#__PURE__*/ function(__PRIVATE_IndexedDbOfflineComponentProvider) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_MultiTabOfflineComponentProvider, __PRIVATE_IndexedDbOfflineComponentProvider);
    function __PRIVATE_MultiTabOfflineComponentProvider(e, t) {
        (0, $4QweW._)(this, __PRIVATE_MultiTabOfflineComponentProvider);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_MultiTabOfflineComponentProvider, [
            e,
            t,
            /* forceOwnership= */ false
        ]), _this.Oc = e, _this.cacheSizeBytes = t, _this.synchronizeTabs = true;
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_MultiTabOfflineComponentProvider, [
        {
            key: "initialize",
            value: function initialize(e) {
                var _this = this;
                var _this1 = this, _superprop_get_initialize = function() {
                    return (0, $hC9N3._)((0, $9atk1._)(__PRIVATE_MultiTabOfflineComponentProvider.prototype), "initialize", _this);
                };
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _this, t, _tmp;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    _superprop_get_initialize().call(_this1, e)
                                ];
                            case 1:
                                _state.sent();
                                t = this.Oc.syncEngine;
                                _tmp = this.sharedClientState instanceof __PRIVATE_WebStorageSharedClientState;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                this.sharedClientState.syncEngine = {
                                    Au: __PRIVATE_syncEngineApplyBatchState.bind(null, t),
                                    Vu: __PRIVATE_syncEngineApplyTargetState.bind(null, t),
                                    du: __PRIVATE_syncEngineApplyActiveTargetsChange.bind(null, t),
                                    Ro: __PRIVATE_syncEngineGetActiveClients.bind(null, t),
                                    Ru: __PRIVATE_syncEngineSynchronizeWithChangedDocuments.bind(null, t)
                                };
                                return [
                                    4,
                                    this.sharedClientState.start()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                // NOTE: This will immediately call the listener, so we make sure to
                                // set it after localStore / remoteStore are started.
                                return [
                                    4,
                                    this.persistence.eo(function(e) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                                            return (0, $gh3Df._)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            __PRIVATE_syncEngineApplyPrimaryState(this.Oc.syncEngine, e)
                                                        ];
                                                    case 1:
                                                        _state.sent(), this.gcScheduler && (e && !this.gcScheduler.started ? this.gcScheduler.start() : e || this.gcScheduler.stop()), this.indexBackfillerScheduler && (e && !this.indexBackfillerScheduler.started ? this.indexBackfillerScheduler.start() : e || this.indexBackfillerScheduler.stop());
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        }).call(_this);
                                    })
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "vc",
            value: function vc(t) {
                var n = __PRIVATE_getWindow();
                if (!__PRIVATE_WebStorageSharedClientState.Ye(n)) throw new e(ta.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
                var r = __PRIVATE_indexedDbStoragePrefix(t.databaseInfo.databaseId, t.databaseInfo.persistenceKey);
                return new __PRIVATE_WebStorageSharedClientState(n, t.asyncQueue, r, t.clientId, t.initialUser);
            }
        }
    ]);
    return __PRIVATE_MultiTabOfflineComponentProvider;
}(__PRIVATE_IndexedDbOfflineComponentProvider);
/**
 * Initializes and wires the components that are needed to interface with the
 * network.
 */ var OnlineComponentProvider = /*#__PURE__*/ function() {
    "use strict";
    function OnlineComponentProvider() {
        (0, $4QweW._)(this, OnlineComponentProvider);
    }
    (0, $6hK4i._)(OnlineComponentProvider, [
        {
            key: "initialize",
            value: function initialize(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _this, _tmp;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                _tmp = this.localStore;
                                if (_tmp) return [
                                    3,
                                    2
                                ];
                                this.localStore = e.localStore, this.sharedClientState = e.sharedClientState, this.datastore = this.createDatastore(t), this.remoteStore = this.createRemoteStore(t), this.eventManager = this.createEventManager(t), this.syncEngine = this.createSyncEngine(t, /* startAsPrimary=*/ !e.synchronizeTabs), this.sharedClientState.onlineStateHandler = function(e) {
                                    return __PRIVATE_syncEngineApplyOnlineStateChange(_this.syncEngine, e, 1 /* OnlineStateSource.SharedClientState */ );
                                }, this.remoteStore.remoteSyncer.handleCredentialChange = __PRIVATE_syncEngineHandleCredentialChange.bind(null, this.syncEngine);
                                return [
                                    4,
                                    __PRIVATE_remoteStoreApplyPrimaryState(this.remoteStore, this.syncEngine.isPrimaryClient)
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "createEventManager",
            value: function createEventManager(e) {
                return function __PRIVATE_newEventManager() {
                    return new __PRIVATE_EventManagerImpl;
                }();
            }
        },
        {
            key: "createDatastore",
            value: function createDatastore(e) {
                var t = __PRIVATE_newSerializer(e.databaseInfo.databaseId), n = __PRIVATE_newConnection(e.databaseInfo);
                return __PRIVATE_newDatastore(e.authCredentials, e.appCheckCredentials, n, t);
            }
        },
        {
            key: "createRemoteStore",
            value: function createRemoteStore(e) {
                var _this = this;
                return function __PRIVATE_newRemoteStore(e, t, n, r, i) {
                    return new __PRIVATE_RemoteStoreImpl(e, t, n, r, i);
                }(this.localStore, this.datastore, e.asyncQueue, function(e) {
                    return __PRIVATE_syncEngineApplyOnlineStateChange(_this.syncEngine, e, 0 /* OnlineStateSource.RemoteStore */ );
                }, function __PRIVATE_newConnectivityMonitor() {
                    return __PRIVATE_BrowserConnectivityMonitor.Ye() ? new __PRIVATE_BrowserConnectivityMonitor : new __PRIVATE_NoopConnectivityMonitor;
                }());
            }
        },
        {
            key: "createSyncEngine",
            value: function createSyncEngine(e, t) {
                return function __PRIVATE_newSyncEngine(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
                r, i, s, _) {
                    var o = new __PRIVATE_SyncEngineImpl(e, t, n, r, i, s);
                    return _ && (o.gc = true), o;
                }(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, e.initialUser, e.maxConcurrentLimboResolutions, t);
            }
        },
        {
            key: "terminate",
            value: function terminate() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _this_datastore, _this_eventManager;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    function __PRIVATE_remoteStoreShutdown(e) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                                            var t;
                                            return (0, $gh3Df._)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        t = __PRIVATE_debugCast(e);
                                                        __PRIVATE_logDebug(hr, "RemoteStore shutting down."), t.la.add(5 /* OfflineCause.Shutdown */ );
                                                        return [
                                                            4,
                                                            __PRIVATE_disableNetworkInternal(t)
                                                        ];
                                                    case 1:
                                                        _state.sent(), t.ha.shutdown(), // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
                                                        // triggering spurious listener events with cached data, etc.
                                                        t.Ta.set("Unknown" /* OnlineState.Unknown */ );
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        })();
                                    }(this.remoteStore)
                                ];
                            case 1:
                                _state.sent(), (_this_datastore = this.datastore) === null || _this_datastore === void 0 ? void 0 : _this_datastore.terminate(), (_this_eventManager = this.eventManager) === null || _this_eventManager === void 0 ? void 0 : _this_eventManager.terminate();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return OnlineComponentProvider;
}();
OnlineComponentProvider.provider = {
    build: function() {
        return new OnlineComponentProvider;
    }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */ var Transaction = /*#__PURE__*/ function() {
    "use strict";
    function Transaction(e) {
        (0, $4QweW._)(this, Transaction);
        this.datastore = e, // The version of each document that was read during this transaction.
        this.readVersions = new Map, this.mutations = [], this.committed = false, /**
         * A deferred usage error that occurred previously in this transaction that
         * will cause the transaction to fail once it actually commits.
         */ this.lastTransactionError = null, /**
         * Set of documents that have been written in the transaction.
         *
         * When there's more than one write to the same key in a transaction, any
         * writes after the first are handled differently.
         */ this.writtenDocs = new Set;
    }
    (0, $6hK4i._)(Transaction, [
        {
            key: "lookup",
            value: function lookup(t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _this, n;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                if (this.ensureCommitNotCalled(), this.mutations.length > 0) throw this.lastTransactionError = new e(ta.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes."), this.lastTransactionError;
                                return [
                                    4,
                                    function __PRIVATE_invokeBatchGetDocumentsRpc(e, t) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                                            var n, r, i, s, _;
                                            return (0, $gh3Df._)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        n = __PRIVATE_debugCast(e), r = {
                                                            documents: t.map(function(e) {
                                                                return __PRIVATE_toName(n.serializer, e);
                                                            })
                                                        };
                                                        return [
                                                            4,
                                                            n._t("BatchGetDocuments", n.serializer.databaseId, ResourcePath.emptyPath(), r, t.length)
                                                        ];
                                                    case 1:
                                                        i = _state.sent(), s = new Map;
                                                        i.forEach(function(e) {
                                                            var _$t = __PRIVATE_fromBatchGetDocumentsResponse(n.serializer, e);
                                                            s.set(_$t.key.toString(), _$t);
                                                        });
                                                        _ = [];
                                                        return [
                                                            2,
                                                            (t.forEach(function(e) {
                                                                var _$t = s.get(e.toString());
                                                                __PRIVATE_hardAssert(!!_$t, 55234, {
                                                                    key: e
                                                                }), _.push(_$t);
                                                            }), _)
                                                        ];
                                                }
                                            });
                                        })();
                                    }(this.datastore, t)
                                ];
                            case 1:
                                n = _state.sent();
                                return [
                                    2,
                                    (n.forEach(function(e) {
                                        return _this.recordVersion(e);
                                    }), n)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "set",
            value: function set(e, t) {
                this.write(t.toMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
            }
        },
        {
            key: "update",
            value: function update(e, t) {
                try {
                    this.write(t.toMutation(e, this.preconditionForUpdate(e)));
                } catch (e) {
                    this.lastTransactionError = e;
                }
                this.writtenDocs.add(e.toString());
            }
        },
        {
            key: "delete",
            value: function _delete(e) {
                this.write(new __PRIVATE_DeleteMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
            }
        },
        {
            key: "commit",
            value: function commit() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _this, e;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                if (this.ensureCommitNotCalled(), this.lastTransactionError) throw this.lastTransactionError;
                                e = this.readVersions;
                                // For each mutation, note that the doc was written.
                                this.mutations.forEach(function(t) {
                                    e.delete(t.key.toString());
                                }), // For each document that was read but not written to, we want to perform
                                // a `verify` operation.
                                e.forEach(function(e, t) {
                                    var n = DocumentKey.fromPath(t);
                                    _this.mutations.push(new __PRIVATE_VerifyMutation(n, _this.precondition(n)));
                                });
                                return [
                                    4,
                                    function __PRIVATE_invokeCommitRpc(e, t) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                                            var n, r;
                                            return (0, $gh3Df._)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        n = __PRIVATE_debugCast(e), r = {
                                                            writes: t.map(function(e) {
                                                                return toMutation(n.serializer, e);
                                                            })
                                                        };
                                                        return [
                                                            4,
                                                            n.nt("Commit", n.serializer.databaseId, ResourcePath.emptyPath(), r)
                                                        ];
                                                    case 1:
                                                        _state.sent();
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        })();
                                    }(this.datastore, this.mutations)
                                ];
                            case 1:
                                _state.sent(), this.committed = true;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "recordVersion",
            value: function recordVersion(t) {
                var n;
                if (t.isFoundDocument()) n = t.version;
                else {
                    if (!t.isNoDocument()) throw l(50498, {
                        Mc: t.constructor.name
                    });
                    // Represent a deleted doc using SnapshotVersion.min().
                    n = SnapshotVersion.min();
                }
                var r = this.readVersions.get(t.key.toString());
                if (r) {
                    if (!n.isEqual(r)) // This transaction will fail no matter what.
                    throw new e(ta.ABORTED, "Document version changed between two reads.");
                } else this.readVersions.set(t.key.toString(), n);
            }
        },
        {
            /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */ key: "precondition",
            value: function precondition(e) {
                var t = this.readVersions.get(e.toString());
                return !this.writtenDocs.has(e.toString()) && t ? t.isEqual(SnapshotVersion.min()) ? Precondition.exists(false) : Precondition.updateTime(t) : Precondition.none();
            }
        },
        {
            /**
     * Returns the precondition for a document if the operation is an update.
     */ key: "preconditionForUpdate",
            value: function preconditionForUpdate(t) {
                var n = this.readVersions.get(t.toString());
                // The first time a document is written, we want to take into account the
                // read time and existence
                if (!this.writtenDocs.has(t.toString()) && n) {
                    if (n.isEqual(SnapshotVersion.min())) // The document doesn't exist, so fail the transaction.
                    // This has to be validated locally because you can't send a
                    // precondition that a document does not exist without changing the
                    // semantics of the backend write to be an insert. This is the reverse
                    // of what we want, since we want to assert that the document doesn't
                    // exist but then send the update and have it fail. Since we can't
                    // express that to the backend, we have to validate locally.
                    // Note: this can change once we can send separate verify writes in the
                    // transaction.
                    throw new e(ta.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
                    // Document exists, base precondition on document update time.
                    return Precondition.updateTime(n);
                }
                // Document was not read, so we just use the preconditions for a blind
                // update.
                return Precondition.exists(true);
            }
        },
        {
            key: "write",
            value: function write(e) {
                this.ensureCommitNotCalled(), this.mutations.push(e);
            }
        },
        {
            key: "ensureCommitNotCalled",
            value: function ensureCommitNotCalled() {}
        }
    ]);
    return Transaction;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * TransactionRunner encapsulates the logic needed to run and retry transactions
 * with backoff.
 */ var __PRIVATE_TransactionRunner = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_TransactionRunner(e, t, n, r, i) {
        (0, $4QweW._)(this, __PRIVATE_TransactionRunner);
        this.asyncQueue = e, this.datastore = t, this.options = n, this.updateFunction = r, this.deferred = i, this.Nc = n.maxAttempts, this.Ht = new __PRIVATE_ExponentialBackoff(this.asyncQueue, "transaction_retry" /* TimerId.TransactionRetry */ );
    }
    (0, $6hK4i._)(__PRIVATE_TransactionRunner, [
        {
            /** Runs the transaction and sets the result on deferred. */ key: "Lc",
            value: function Lc() {
                this.Nc -= 1, this.Bc();
            }
        },
        {
            key: "Bc",
            value: function Bc() {
                var _this = this;
                this.Ht.kt(function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                        var _this, e, t;
                        return (0, $gh3Df._)(this, function(_state) {
                            _this = this;
                            e = new Transaction(this.datastore), t = this.Uc(e);
                            t && t.then(function(t) {
                                _this.asyncQueue.enqueueAndForget(function() {
                                    return e.commit().then(function() {
                                        _this.deferred.resolve(t);
                                    }).catch(function(e) {
                                        _this.kc(e);
                                    });
                                });
                            }).catch(function(e) {
                                _this.kc(e);
                            });
                            return [
                                2
                            ];
                        });
                    }).call(_this);
                });
            }
        },
        {
            key: "Uc",
            value: function Uc(e) {
                try {
                    var t = this.updateFunction(e);
                    return !__PRIVATE_isNullOrUndefined(t) && t.catch && t.then ? t : (this.deferred.reject(Error("Transaction callback must return a Promise")), null);
                } catch (e) {
                    // Do not retry errors thrown by user provided updateFunction.
                    return this.deferred.reject(e), null;
                }
            }
        },
        {
            key: "kc",
            value: function kc(e) {
                var _this = this;
                this.Nc > 0 && this.qc(e) ? (this.Nc -= 1, this.asyncQueue.enqueueAndForget(function() {
                    return _this.Bc(), Promise.resolve();
                })) : this.deferred.reject(e);
            }
        },
        {
            key: "qc",
            value: function qc(e) {
                if ("FirebaseError" === (e === null || e === void 0 ? void 0 : e.name)) {
                    // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
                    // non-matching document versions with ABORTED. These errors should be retried.
                    var t = e.code;
                    return "aborted" === t || "failed-precondition" === t || "already-exists" === t || !__PRIVATE_isPermanentError(t);
                }
                return false;
            }
        }
    ]);
    return __PRIVATE_TransactionRunner;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var fr = "FirestoreClient";
/**
 * FirestoreClient is a top-level class that constructs and owns all of the //
 * pieces of the client SDK architecture. It is responsible for creating the //
 * async queue that is shared by all of the other components in the system. //
 */ var FirestoreClient = /*#__PURE__*/ function() {
    "use strict";
    function FirestoreClient(e, t, /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */ n, /**
     * Exposed for testing
     */ r, i) {
        var _this = this;
        (0, $4QweW._)(this, FirestoreClient);
        this.authCredentials = e, this.appCheckCredentials = t, this.asyncQueue = n, this._databaseInfo = r, this.user = User.UNAUTHENTICATED, this.clientId = __PRIVATE_AutoId.newId(), this.authCredentialListener = function() {
            return Promise.resolve();
        }, this.appCheckCredentialListener = function() {
            return Promise.resolve();
        }, this._uninitializedComponentsProvider = i, this.authCredentials.start(n, function(e) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                return (0, $gh3Df._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            __PRIVATE_logDebug(fr, "Received user=", e.uid);
                            return [
                                4,
                                this.authCredentialListener(e)
                            ];
                        case 1:
                            _state.sent(), this.user = e;
                            return [
                                2
                            ];
                    }
                });
            }).call(_this);
        }), this.appCheckCredentials.start(n, function(e) {
            return __PRIVATE_logDebug(fr, "Received new app check token=", e), _this.appCheckCredentialListener(e, _this.user);
        });
    }
    (0, $6hK4i._)(FirestoreClient, [
        {
            key: "configuration",
            get: function get() {
                return {
                    asyncQueue: this.asyncQueue,
                    databaseInfo: this._databaseInfo,
                    clientId: this.clientId,
                    authCredentials: this.authCredentials,
                    appCheckCredentials: this.appCheckCredentials,
                    initialUser: this.user,
                    maxConcurrentLimboResolutions: 100
                };
            }
        },
        {
            key: "setCredentialChangeListener",
            value: function setCredentialChangeListener(e) {
                this.authCredentialListener = e;
            }
        },
        {
            key: "setAppCheckTokenChangeListener",
            value: function setAppCheckTokenChangeListener(e) {
                this.appCheckCredentialListener = e;
            }
        },
        {
            key: "terminate",
            value: function terminate() {
                var _this = this;
                this.asyncQueue.enterRestrictedMode();
                var e = new __PRIVATE_Deferred;
                return this.asyncQueue.enqueueAndForgetEvenWhileRestricted(function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                        var _tmp, _tmp1, t, n;
                        return (0, $gh3Df._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _state.trys.push([
                                        0,
                                        5,
                                        ,
                                        6
                                    ]);
                                    _tmp = this._onlineComponents;
                                    if (!_tmp) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        this._onlineComponents.terminate()
                                    ];
                                case 1:
                                    _tmp = _state.sent();
                                    _state.label = 2;
                                case 2:
                                    _tmp;
                                    _tmp1 = this._offlineComponents;
                                    if (!_tmp1) return [
                                        3,
                                        4
                                    ];
                                    return [
                                        4,
                                        this._offlineComponents.terminate()
                                    ];
                                case 3:
                                    _tmp1 = _state.sent();
                                    _state.label = 4;
                                case 4:
                                    _tmp1, // The credentials provider must be terminated after shutting down the
                                    // RemoteStore as it will prevent the RemoteStore from retrieving auth
                                    // tokens.
                                    this.authCredentials.shutdown(), this.appCheckCredentials.shutdown(), e.resolve();
                                    return [
                                        3,
                                        6
                                    ];
                                case 5:
                                    t = _state.sent();
                                    n = __PRIVATE_wrapInUserErrorIfRecoverable(t, "Failed to shutdown persistence");
                                    e.reject(n);
                                    return [
                                        3,
                                        6
                                    ];
                                case 6:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }).call(_this);
                }), e.promise;
            }
        }
    ]);
    return FirestoreClient;
}();
function __PRIVATE_setOfflineComponentProvider(e, t) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var n, r;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e.asyncQueue.verifyOperationInProgress(), __PRIVATE_logDebug(fr, "Initializing OfflineComponentProvider");
                    n = e.configuration;
                    return [
                        4,
                        t.initialize(n)
                    ];
                case 1:
                    _state.sent();
                    r = n.initialUser;
                    e.setCredentialChangeListener(function(e) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                            var _tmp;
                            return (0, $gh3Df._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _tmp = r.isEqual(e);
                                        if (_tmp) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            __PRIVATE_localStoreHandleUserChange(t.localStore, e)
                                        ];
                                    case 1:
                                        _tmp = (_state.sent(), r = e);
                                        _state.label = 2;
                                    case 2:
                                        _tmp;
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    }), // When a user calls clearPersistence() in one client, all other clients
                    // need to be terminated to allow the delete to succeed.
                    t.persistence.setDatabaseDeletedListener(function() {
                        return e.terminate();
                    }), e._offlineComponents = t;
                    return [
                        2
                    ];
            }
        });
    })();
}
function __PRIVATE_setOnlineComponentProvider(e, t) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var n;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e.asyncQueue.verifyOperationInProgress();
                    return [
                        4,
                        __PRIVATE_ensureOfflineComponents(e)
                    ];
                case 1:
                    n = _state.sent();
                    __PRIVATE_logDebug(fr, "Initializing OnlineComponentProvider");
                    return [
                        4,
                        t.initialize(n, e.configuration)
                    ];
                case 2:
                    _state.sent(), // The CredentialChangeListener of the online component provider takes
                    // precedence over the offline component provider.
                    e.setCredentialChangeListener(function(e) {
                        return __PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, e);
                    }), e.setAppCheckTokenChangeListener(function(e, n) {
                        return __PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, n);
                    }), e._onlineComponents = t;
                    return [
                        2
                    ];
            }
        });
    })();
}
/**
 * Decides whether the provided error allows us to gracefully disable
 * persistence (as opposed to crashing the client).
 */ function __PRIVATE_ensureOfflineComponents(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var t, n;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!!e._offlineComponents) return [
                        3,
                        8
                    ];
                    if (!e._uninitializedComponentsProvider) return [
                        3,
                        6
                    ];
                    __PRIVATE_logDebug(fr, "Using user provided OfflineComponentProvider");
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        5
                    ]);
                    return [
                        4,
                        __PRIVATE_setOfflineComponentProvider(e, e._uninitializedComponentsProvider._offline)
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    t = _state.sent();
                    n = t;
                    if (!function __PRIVATE_canFallbackFromIndexedDbError(e) {
                        return "FirebaseError" === e.name ? e.code === ta.FAILED_PRECONDITION || e.code === ta.UNIMPLEMENTED : !("undefined" != typeof DOMException && e instanceof DOMException) || // When the browser is out of quota we could get either quota exceeded
                        // or an aborted error depending on whether the error happened during
                        // schema migration.
                        22 === e.code || 20 === e.code || // Firefox Private Browsing mode disables IndexedDb and returns
                        // INVALID_STATE for any usage.
                        11 === e.code;
                    }(n)) throw n;
                    __PRIVATE_logWarn("Error using user provided cache. Falling back to memory cache: " + n);
                    return [
                        4,
                        __PRIVATE_setOfflineComponentProvider(e, new __PRIVATE_MemoryOfflineComponentProvider)
                    ];
                case 4:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    __PRIVATE_logDebug(fr, "Using default OfflineComponentProvider");
                    return [
                        4,
                        __PRIVATE_setOfflineComponentProvider(e, new __PRIVATE_LruGcMemoryOfflineComponentProvider(void 0))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        2,
                        e._offlineComponents
                    ];
            }
        });
    })();
}
function __PRIVATE_ensureOnlineComponents(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var _tmp, _tmp1;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = e._onlineComponents;
                    if (_tmp) return [
                        3,
                        5
                    ];
                    if (!e._uninitializedComponentsProvider) return [
                        3,
                        2
                    ];
                    __PRIVATE_logDebug(fr, "Using user provided OnlineComponentProvider");
                    return [
                        4,
                        __PRIVATE_setOnlineComponentProvider(e, e._uninitializedComponentsProvider._online)
                    ];
                case 1:
                    _tmp1 = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    __PRIVATE_logDebug(fr, "Using default OnlineComponentProvider");
                    return [
                        4,
                        __PRIVATE_setOnlineComponentProvider(e, new OnlineComponentProvider)
                    ];
                case 3:
                    _tmp1 = _state.sent();
                    _state.label = 4;
                case 4:
                    _tmp = _tmp1;
                    _state.label = 5;
                case 5:
                    return [
                        2,
                        (_tmp, e._onlineComponents)
                    ];
            }
        });
    })();
}
function __PRIVATE_getPersistence(e) {
    return __PRIVATE_ensureOfflineComponents(e).then(function(e) {
        return e.persistence;
    });
}
function __PRIVATE_getLocalStore(e) {
    return __PRIVATE_ensureOfflineComponents(e).then(function(e) {
        return e.localStore;
    });
}
function __PRIVATE_getRemoteStore(e) {
    return __PRIVATE_ensureOnlineComponents(e).then(function(e) {
        return e.remoteStore;
    });
}
function __PRIVATE_getSyncEngine(e) {
    return __PRIVATE_ensureOnlineComponents(e).then(function(e) {
        return e.syncEngine;
    });
}
function __PRIVATE_getDatastore(e) {
    return __PRIVATE_ensureOnlineComponents(e).then(function(e) {
        return e.datastore;
    });
}
function __PRIVATE_getEventManager(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var t, n;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        __PRIVATE_ensureOnlineComponents(e)
                    ];
                case 1:
                    t = _state.sent(), n = t.eventManager;
                    return [
                        2,
                        (n.onListen = __PRIVATE_syncEngineListen.bind(null, t.syncEngine), n.onUnlisten = __PRIVATE_syncEngineUnlisten.bind(null, t.syncEngine), n.onFirstRemoteStoreListen = __PRIVATE_triggerRemoteStoreListen.bind(null, t.syncEngine), n.onLastRemoteStoreUnlisten = __PRIVATE_triggerRemoteStoreUnlisten.bind(null, t.syncEngine), n)
                    ];
            }
        });
    })();
}
/** Enables the network connection and re-enqueues all pending operations. */ function __PRIVATE_firestoreClientEnableNetwork(e) {
    return e.asyncQueue.enqueue(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var t, n;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            __PRIVATE_getPersistence(e)
                        ];
                    case 1:
                        t = _state.sent();
                        return [
                            4,
                            __PRIVATE_getRemoteStore(e)
                        ];
                    case 2:
                        n = _state.sent();
                        return [
                            2,
                            (t.setNetworkEnabled(true), function __PRIVATE_remoteStoreEnableNetwork(e) {
                                var t = __PRIVATE_debugCast(e);
                                return t.la.delete(0 /* OfflineCause.UserDisabled */ ), __PRIVATE_enableNetworkInternal(t);
                            }(n))
                        ];
                }
            });
        })();
    });
}
/** Disables the network connection. Pending operations will not complete. */ function __PRIVATE_firestoreClientDisableNetwork(e) {
    return e.asyncQueue.enqueue(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var t, n;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            __PRIVATE_getPersistence(e)
                        ];
                    case 1:
                        t = _state.sent();
                        return [
                            4,
                            __PRIVATE_getRemoteStore(e)
                        ];
                    case 2:
                        n = _state.sent();
                        return [
                            2,
                            (t.setNetworkEnabled(false), function __PRIVATE_remoteStoreDisableNetwork(e) {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                                    var t;
                                    return (0, $gh3Df._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                t = __PRIVATE_debugCast(e);
                                                t.la.add(0 /* OfflineCause.UserDisabled */ );
                                                return [
                                                    4,
                                                    __PRIVATE_disableNetworkInternal(t)
                                                ];
                                            case 1:
                                                _state.sent(), // Set the OnlineState to Offline so get()s return from cache, etc.
                                                t.Ta.set("Offline" /* OnlineState.Offline */ );
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            }(n))
                        ];
                }
            });
        })();
    });
}
/**
 * Returns a Promise that resolves when all writes that were pending at the time
 * this method was called received server acknowledgement. An acknowledgement
 * can be either acceptance or rejection.
 */ function __PRIVATE_firestoreClientListen(e, t, n, r) {
    var i = new __PRIVATE_AsyncObserver(r), s = new __PRIVATE_QueryListener(t, i, n);
    return e.asyncQueue.enqueueAndForget(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            __PRIVATE_getEventManager(e)
                        ];
                    case 1:
                        return [
                            2,
                            __PRIVATE_eventManagerListen.apply(void 0, [
                                _state.sent(),
                                s
                            ])
                        ];
                }
            });
        })();
    }), function() {
        i.Va(), e.asyncQueue.enqueueAndForget(function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                return (0, $gh3Df._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                __PRIVATE_getEventManager(e)
                            ];
                        case 1:
                            return [
                                2,
                                __PRIVATE_eventManagerUnlisten.apply(void 0, [
                                    _state.sent(),
                                    s
                                ])
                            ];
                    }
                });
            })();
        });
    };
}
function __PRIVATE_firestoreClientGetDocumentFromLocalCache(t, n) {
    var r = new __PRIVATE_Deferred;
    return t.asyncQueue.enqueueAndForget(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var _;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ = function __PRIVATE_readDocumentFromCache(t, n, r) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                                var i, e1, _$t;
                                return (0, $gh3Df._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _state.trys.push([
                                                0,
                                                2,
                                                ,
                                                3
                                            ]);
                                            return [
                                                4,
                                                function __PRIVATE_localStoreReadDocument(e, t) {
                                                    var _$n = __PRIVATE_debugCast(e);
                                                    return _$n.persistence.runTransaction("read document", "readonly", function(e) {
                                                        return _$n.localDocuments.getDocument(e, t);
                                                    });
                                                }(t, n)
                                            ];
                                        case 1:
                                            i = _state.sent();
                                            i.isFoundDocument() ? r.resolve(i) : i.isNoDocument() ? r.resolve(null) : r.reject(new e(ta.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)"));
                                            return [
                                                3,
                                                3
                                            ];
                                        case 2:
                                            e1 = _state.sent();
                                            _$t = __PRIVATE_wrapInUserErrorIfRecoverable(e1, "Failed to get document '".concat(n, " from cache"));
                                            r.reject(_$t);
                                            return [
                                                3,
                                                3
                                            ];
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })();
                        };
                        return [
                            4,
                            __PRIVATE_getLocalStore(t)
                        ];
                    case 1:
                        return [
                            2,
                            _.apply(void 0, [
                                _state.sent(),
                                n,
                                r
                            ])
                        ];
                }
            });
        })();
    }), r.promise;
}
function __PRIVATE_firestoreClientGetDocumentViaSnapshotListener(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var i = new __PRIVATE_Deferred;
    return t.asyncQueue.enqueueAndForget(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var _;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ = function __PRIVATE_readDocumentViaSnapshotListener(t, n, r, i, s) {
                            var _ = new __PRIVATE_AsyncObserver({
                                next: function(a) {
                                    // Mute and remove query first before passing event to user to avoid
                                    // user actions affecting the now stale query.
                                    _.Va(), n.enqueueAndForget(function() {
                                        return __PRIVATE_eventManagerUnlisten(t, o);
                                    });
                                    var u = a.docs.has(r);
                                    !u && a.fromCache ? // TODO(dimond): If we're online and the document doesn't
                                    // exist then we resolve with a doc.exists set to false. If
                                    // we're offline however, we reject the Promise in this
                                    // case. Two options: 1) Cache the negative response from
                                    // the server so we can deliver that even when you're
                                    // offline 2) Actually reject the Promise in the online case
                                    // if the document doesn't exist.
                                    s.reject(new e(ta.UNAVAILABLE, "Failed to get document because the client is offline.")) : u && a.fromCache && i && "server" === i.source ? s.reject(new e(ta.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : s.resolve(a);
                                },
                                error: function(e) {
                                    return s.reject(e);
                                }
                            }), o = new __PRIVATE_QueryListener(__PRIVATE_newQueryForPath(r.path), _, {
                                includeMetadataChanges: true,
                                waitForSyncWhenOnline: true
                            });
                            return __PRIVATE_eventManagerListen(t, o);
                        };
                        return [
                            4,
                            __PRIVATE_getEventManager(t)
                        ];
                    case 1:
                        return [
                            2,
                            _.apply(void 0, [
                                _state.sent(),
                                t.asyncQueue,
                                n,
                                r,
                                i
                            ])
                        ];
                }
            });
        })();
    }), i.promise;
}
function __PRIVATE_firestoreClientGetDocumentsFromLocalCache(e, t) {
    var n = new __PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var _;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ = function __PRIVATE_executeQueryFromCache(e, t, n) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                                var r, i, s, _, e1, r1;
                                return (0, $gh3Df._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _state.trys.push([
                                                0,
                                                2,
                                                ,
                                                3
                                            ]);
                                            return [
                                                4,
                                                __PRIVATE_localStoreExecuteQuery(e, t, /* usePreviousResults= */ !0)
                                            ];
                                        case 1:
                                            r = _state.sent(), i = new __PRIVATE_View(t, r.Wo), s = i.Xu(r.documents), _ = i.applyChanges(s, /* limboResolutionEnabled= */ !1);
                                            n.resolve(_.snapshot);
                                            return [
                                                3,
                                                3
                                            ];
                                        case 2:
                                            e1 = _state.sent();
                                            r1 = __PRIVATE_wrapInUserErrorIfRecoverable(e1, "Failed to execute query '".concat(t, " against cache"));
                                            n.reject(r1);
                                            return [
                                                3,
                                                3
                                            ];
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })();
                        };
                        return [
                            4,
                            __PRIVATE_getLocalStore(e)
                        ];
                    case 1:
                        return [
                            2,
                            _.apply(void 0, [
                                _state.sent(),
                                t,
                                n
                            ])
                        ];
                }
            });
        })();
    }), n.promise;
}
function __PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var i = new __PRIVATE_Deferred;
    return t.asyncQueue.enqueueAndForget(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var _;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ = function __PRIVATE_executeQueryViaSnapshotListener(t, n, r, i, s) {
                            var _ = new __PRIVATE_AsyncObserver({
                                next: function(r) {
                                    // Mute and remove query first before passing event to user to avoid
                                    // user actions affecting the now stale query.
                                    _.Va(), n.enqueueAndForget(function() {
                                        return __PRIVATE_eventManagerUnlisten(t, o);
                                    }), r.fromCache && "server" === i.source ? s.reject(new e(ta.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : s.resolve(r);
                                },
                                error: function(e) {
                                    return s.reject(e);
                                }
                            }), o = new __PRIVATE_QueryListener(r instanceof __PRIVATE_RealtimePipeline ? __PRIVATE_toCorePipeline(r) : r, _, {
                                includeMetadataChanges: true,
                                waitForSyncWhenOnline: true
                            });
                            return __PRIVATE_eventManagerListen(t, o);
                        };
                        return [
                            4,
                            __PRIVATE_getEventManager(t)
                        ];
                    case 1:
                        return [
                            2,
                            _.apply(void 0, [
                                _state.sent(),
                                t.asyncQueue,
                                n,
                                r,
                                i
                            ])
                        ];
                }
            });
        })();
    }), i.promise;
}
function __PRIVATE_firestoreClientRunAggregateQuery(e, t, n) {
    var r = new __PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var i, e1;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            __PRIVATE_getDatastore(e)
                        ];
                    case 1:
                        i = _state.sent();
                        r.resolve(function __PRIVATE_invokeRunAggregationQueryRpc(e, t, n) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                                var _o__result, r, _$__PRIVATE_toRunAggregationQueryRequest, i, s, _, o, a;
                                return (0, $gh3Df._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            r = __PRIVATE_debugCast(e), _$__PRIVATE_toRunAggregationQueryRequest = __PRIVATE_toRunAggregationQueryRequest(r.serializer, __PRIVATE_queryToAggregateTarget(t), n), i = _$__PRIVATE_toRunAggregationQueryRequest.request, s = _$__PRIVATE_toRunAggregationQueryRequest.ve, _ = _$__PRIVATE_toRunAggregationQueryRequest.parent;
                                            r.connection.Ze || delete i.parent;
                                            return [
                                                4,
                                                r._t("RunAggregationQuery", r.serializer.databaseId, _, i, /*expectedResponseCount=*/ 1)
                                            ];
                                        case 1:
                                            o = _state.sent().filter(function(e) {
                                                return !!e.result;
                                            });
                                            // Omit RunAggregationQueryResponse that only contain readTimes.
                                            __PRIVATE_hardAssert(1 === o.length, 64727);
                                            // Remap the short-form aliases that were sent to the server
                                            // to the client-side aliases. Users will access the results
                                            // using the client-side alias.
                                            a = (_o__result = o[0].result) === null || _o__result === void 0 ? void 0 : _o__result.aggregateFields;
                                            return [
                                                2,
                                                Object.keys(a).reduce(function(e, t) {
                                                    return e[s[t]] = a[t], e;
                                                }, {})
                                            ];
                                    }
                                });
                            })();
                        }(i, t, n));
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e1 = _state.sent();
                        r.reject(e1);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }), r.promise;
}
function ha(e, t) {
    var n = new __PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var r, e1;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            __PRIVATE_getDatastore(e)
                        ];
                    case 1:
                        r = _state.sent();
                        n.resolve(function __PRIVATE_invokeExecutePipeline(e, t) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                                var n, r, i, s;
                                return (0, $gh3Df._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            n = __PRIVATE_debugCast(e), r = {
                                                database: __PRIVATE_getEncodedDatabaseId(n.serializer),
                                                structuredPipeline: t._toProto(n.serializer)
                                            };
                                            return [
                                                4,
                                                n._t("ExecutePipeline", n.serializer.databaseId, ResourcePath.emptyPath(), r)
                                            ];
                                        case 1:
                                            i = _state.sent(), s = [];
                                            return [
                                                2,
                                                (i.forEach(function(e) {
                                                    if (e.results && 0 !== e.results.length) return e.results.forEach(function(t) {
                                                        return s.push(__PRIVATE_fromPipelineResponse(n.serializer, e, t));
                                                    });
                                                    s.push(__PRIVATE_fromPipelineResponse(n.serializer, e));
                                                }), s)
                                            ];
                                    }
                                });
                            })();
                        }(r, t));
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e1 = _state.sent();
                        n.reject(e1);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }), n.promise;
}
function __PRIVATE_firestoreClientWrite(e, t) {
    var n = new __PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            __PRIVATE_getSyncEngine(e)
                        ];
                    case 1:
                        return [
                            2,
                            __PRIVATE_syncEngineWrite.apply(void 0, [
                                _state.sent(),
                                t,
                                n
                            ])
                        ];
                }
            });
        })();
    }), n.promise;
}
function __PRIVATE_firestoreClientAddSnapshotsInSyncListener(e, t) {
    var n = new __PRIVATE_AsyncObserver(t);
    return e.asyncQueue.enqueueAndForget(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var _;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ = function __PRIVATE_addSnapshotsInSyncListener(e, t) {
                            __PRIVATE_debugCast(e).Du.add(t), // Immediately fire an initial event, indicating all existing listeners
                            // are in-sync.
                            t.next();
                        };
                        return [
                            4,
                            __PRIVATE_getEventManager(e)
                        ];
                    case 1:
                        return [
                            2,
                            _.apply(void 0, [
                                _state.sent(),
                                n
                            ])
                        ];
                }
            });
        })();
    }), function() {
        n.Va(), e.asyncQueue.enqueueAndForget(function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                var _;
                return (0, $gh3Df._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _ = function __PRIVATE_removeSnapshotsInSyncListener(e, t) {
                                __PRIVATE_debugCast(e).Du.delete(t);
                            };
                            return [
                                4,
                                __PRIVATE_getEventManager(e)
                            ];
                        case 1:
                            return [
                                2,
                                _.apply(void 0, [
                                    _state.sent(),
                                    n
                                ])
                            ];
                    }
                });
            })();
        });
    };
}
/**
 * Takes an updateFunction in which a set of reads and writes can be performed
 * atomically. In the updateFunction, the client can read and write values
 * using the supplied transaction object. After the updateFunction, all
 * changes will be committed. If a retryable error occurs (ex: some other
 * client has changed any of the data referenced), then the updateFunction
 * will be called again after a backoff. If the updateFunction still fails
 * after all retries, then the transaction will be rejected.
 *
 * The transaction object passed to the updateFunction contains methods for
 * accessing documents and collections. Unlike other datastore access, data
 * accessed with the transaction will not reflect local changes that have not
 * been committed. For this reason, it is required that all reads are
 * performed before any writes. Transactions must be performed while online.
 */ function __PRIVATE_firestoreClientTransaction(e, t, n) {
    var r = new __PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var i;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            __PRIVATE_getDatastore(e)
                        ];
                    case 1:
                        i = _state.sent();
                        new __PRIVATE_TransactionRunner(e.asyncQueue, i, n, t, r).Lc();
                        return [
                            2
                        ];
                }
            });
        })();
    }), r.promise;
}
function __PRIVATE_firestoreClientLoadBundle(e, t, n, r) {
    var i = function __PRIVATE_createBundleReader(e, t) {
        var _$n;
        _$n = "string" == typeof e ? __PRIVATE_newTextEncoder().encode(e) : e;
        return function __PRIVATE_newBundleReader(e, t) {
            return new __PRIVATE_BundleReaderImpl(e, t);
        }(function __PRIVATE_toByteStreamReader(e, t) {
            if (e instanceof Uint8Array) return __PRIVATE_toByteStreamReaderHelper(e, t);
            if (e instanceof ArrayBuffer) return __PRIVATE_toByteStreamReaderHelper(new Uint8Array(e), t);
            if (e instanceof ReadableStream) return e.getReader();
            throw new Error("Source of `toByteStreamReader` has to be a ArrayBuffer or ReadableStream");
        }(_$n), t);
    }(n, __PRIVATE_newSerializer(t));
    e.asyncQueue.enqueueAndForget(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            __PRIVATE_getSyncEngine(e)
                        ];
                    case 1:
                        __PRIVATE_syncEngineLoadBundle.apply(void 0, [
                            _state.sent(),
                            i,
                            r
                        ]);
                        return [
                            2
                        ];
                }
            });
        })();
    });
}
function __PRIVATE_firestoreClientGetNamedQuery(e, t) {
    return e.asyncQueue.enqueue(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var _;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ = function __PRIVATE_localStoreGetNamedQuery(e, t) {
                            var n = __PRIVATE_debugCast(e);
                            return n.persistence.runTransaction("Get named query", "readonly", function(e) {
                                return n.f_.getNamedQuery(e, t);
                            });
                        };
                        return [
                            4,
                            __PRIVATE_getLocalStore(e)
                        ];
                    case 1:
                        return [
                            2,
                            _.apply(void 0, [
                                _state.sent(),
                                t
                            ])
                        ];
                }
            });
        })();
    });
}
function __PRIVATE_createBundleReaderSync(e, t) {
    return function __PRIVATE_newBundleReaderSync(e, t) {
        return new __PRIVATE_BundleReaderSyncImpl(e, t);
    }(e, t);
}
function __PRIVATE_firestoreClientSetIndexConfiguration(e, t) {
    return e.asyncQueue.enqueue(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var _;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ = function __PRIVATE_localStoreConfigureFieldIndexes(e, t) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                                var n, r, i;
                                return (0, $gh3Df._)(this, function(_state) {
                                    n = __PRIVATE_debugCast(e), r = n.indexManager, i = [];
                                    return [
                                        2,
                                        n.persistence.runTransaction("Configure indexes", "readwrite", function(e) {
                                            return r.getFieldIndexes(e).next(function(n) {
                                                return function __PRIVATE_diffArrays(e, t, n, r, i) {
                                                    e = (0, $jlUaU._)(e), t = (0, $jlUaU._)(t), e.sort(n), t.sort(n);
                                                    var s = e.length, _ = t.length;
                                                    var o = 0, a = 0;
                                                    for(; o < _ && a < s;){
                                                        var s1 = n(e[a], t[o]);
                                                        s1 < 0 ? // The element was removed if the next element in our ordered
                                                        // walkthrough is only in `before`.
                                                        i(e[a++]) : s1 > 0 ? // The element was added if the next element in our ordered walkthrough
                                                        // is only in `after`.
                                                        r(t[o++]) : (o++, a++);
                                                    }
                                                    for(; o < _;)r(t[o++]);
                                                    for(; a < s;)i(e[a++]);
                                                }(n, t, __PRIVATE_fieldIndexSemanticComparator, function(t) {
                                                    i.push(r.addFieldIndex(e, t));
                                                }, function(t) {
                                                    i.push(r.deleteFieldIndex(e, t));
                                                });
                                            }).next(function() {
                                                return PersistencePromise.waitFor(i);
                                            });
                                        })
                                    ];
                                });
                            })();
                        };
                        return [
                            4,
                            __PRIVATE_getLocalStore(e)
                        ];
                    case 1:
                        return [
                            2,
                            _.apply(void 0, [
                                _state.sent(),
                                t
                            ])
                        ];
                }
            });
        })();
    });
}
function __PRIVATE_firestoreClientSetPersistentCacheIndexAutoCreationEnabled(e, t) {
    return e.asyncQueue.enqueue(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var _;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ = function __PRIVATE_localStoreSetIndexAutoCreationEnabled(e, t) {
                            __PRIVATE_debugCast(e).No.yo = t;
                        };
                        return [
                            4,
                            __PRIVATE_getLocalStore(e)
                        ];
                    case 1:
                        return [
                            2,
                            _.apply(void 0, [
                                _state.sent(),
                                t
                            ])
                        ];
                }
            });
        })();
    });
}
function __PRIVATE_firestoreClientDeleteAllFieldIndexes(e) {
    return e.asyncQueue.enqueue(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var _;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ = function __PRIVATE_localStoreDeleteAllFieldIndexes(e) {
                            var t = __PRIVATE_debugCast(e), n = t.indexManager;
                            return t.persistence.runTransaction("Delete All Indexes", "readwrite", function(e) {
                                return n.deleteAllFieldIndexes(e);
                            });
                        };
                        return [
                            4,
                            __PRIVATE_getLocalStore(e)
                        ];
                    case 1:
                        return [
                            2,
                            _.apply(void 0, [
                                _state.sent()
                            ])
                        ];
                }
            });
        })();
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ var mr = /*#__PURE__*/ function() {
    "use strict";
    function DocumentSnapshot(e, t, n, r, i) {
        (0, $4QweW._)(this, DocumentSnapshot);
        this._firestore = e, this._userDataWriter = t, this._key = n, this._document = r, this._converter = i;
    }
    (0, $6hK4i._)(DocumentSnapshot, [
        {
            key: "id",
            get: /** Property of the `DocumentSnapshot` that provides the document's ID. */ function get() {
                return this._key.path.lastSegment();
            }
        },
        {
            key: "ref",
            get: /**
     * The `DocumentReference` for the document included in the `DocumentSnapshot`.
     */ function get() {
                return new aa(this._firestore, this._converter, this._key);
            }
        },
        {
            /**
     * Signals whether or not the document at the snapshot's location exists.
     *
     * @returns true if the document exists.
     */ key: "exists",
            value: function exists() {
                return null !== this._document;
            }
        },
        {
            /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ key: "data",
            value: function data() {
                if (this._document) {
                    if (this._converter) {
                        // We only want to use the converter and create a new DocumentSnapshot
                        // if a converter has been provided.
                        var e = new pr(this._firestore, this._userDataWriter, this._key, this._document, /* converter= */ null);
                        return this._converter.fromFirestore(e);
                    }
                    return this._userDataWriter.convertValue(this._document.data.value);
                }
            }
        },
        {
            /**
     * @internal
     * @private
     *
     * Retrieves all fields in the document as a proto Value. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ key: "_fieldsProto",
            value: function _fieldsProto() {
                var _this__document;
                var _this__document_data_clone_value_mapValue_fields;
                // Return a cloned value to prevent manipulation of the Snapshot's data
                return (_this__document_data_clone_value_mapValue_fields = (_this__document = this._document) === null || _this__document === void 0 ? void 0 : _this__document.data.clone().value.mapValue.fields) !== null && _this__document_data_clone_value_mapValue_fields !== void 0 ? _this__document_data_clone_value_mapValue_fields : void 0;
            }
        },
        {
            /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "get",
            value: function get(e) {
                if (this._document) {
                    var t = this._document.data.field(K("DocumentSnapshot.get", e));
                    if (null !== t) return this._userDataWriter.convertValue(t);
                }
            }
        }
    ]);
    return DocumentSnapshot;
}(), pr = /*#__PURE__*/ function(mr) {
    "use strict";
    (0, $c2MhV._)(QueryDocumentSnapshot, mr);
    function QueryDocumentSnapshot() {
        (0, $4QweW._)(this, QueryDocumentSnapshot);
        return (0, $ehF45._)(this, QueryDocumentSnapshot, arguments);
    }
    (0, $6hK4i._)(QueryDocumentSnapshot, [
        {
            /**
     * Retrieves all fields in the document as an `Object`.
     *
     * @override
     * @returns An `Object` containing all fields in the document.
     */ key: "data",
            value: function data() {
                return (0, $hC9N3._)((0, $9atk1._)(QueryDocumentSnapshot.prototype), "data", this).call(this);
            }
        }
    ]);
    return QueryDocumentSnapshot;
}(mr);
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts Firestore's internal types to the JavaScript types that we expose
 * to the user.
 *
 * @internal
 */ var AbstractUserDataWriter = /*#__PURE__*/ function() {
    "use strict";
    function AbstractUserDataWriter() {
        (0, $4QweW._)(this, AbstractUserDataWriter);
    }
    (0, $6hK4i._)(AbstractUserDataWriter, [
        {
            key: "convertValue",
            value: function convertValue(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "none";
                switch(__PRIVATE_typeOrder(e)){
                    case 0 /* TypeOrder.NullValue */ :
                        return null;
                    case 1 /* TypeOrder.BooleanValue */ :
                        return e.booleanValue;
                    case 2 /* TypeOrder.NumberValue */ :
                        return __PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
                    case 3 /* TypeOrder.TimestampValue */ :
                        return this.convertTimestamp(e.timestampValue);
                    case 4 /* TypeOrder.ServerTimestampValue */ :
                        return this.convertServerTimestamp(e, t);
                    case 5 /* TypeOrder.StringValue */ :
                        return e.stringValue;
                    case 6 /* TypeOrder.BlobValue */ :
                        return this.convertBytes(__PRIVATE_normalizeByteString(e.bytesValue));
                    case 7 /* TypeOrder.RefValue */ :
                        return this.convertReference(e.referenceValue);
                    case 8 /* TypeOrder.GeoPointValue */ :
                        return this.convertGeoPoint(e.geoPointValue);
                    case 9 /* TypeOrder.ArrayValue */ :
                        return this.convertArray(e.arrayValue, t);
                    case 11 /* TypeOrder.ObjectValue */ :
                        return this.convertObject(e.mapValue, t);
                    case 10 /* TypeOrder.VectorValue */ :
                        return this.convertVectorValue(e.mapValue);
                    default:
                        throw l(62114, {
                            value: e
                        });
                }
            }
        },
        {
            key: "convertObject",
            value: function convertObject(e, t) {
                return this.convertObjectMap(e.fields, t);
            }
        },
        {
            /**
     * @internal
     */ key: "convertObjectMap",
            value: function convertObjectMap(e) {
                var _this = this;
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "none";
                var n = {};
                return forEach(e, function(e, r) {
                    n[e] = _this.convertValue(r, t);
                }), n;
            }
        },
        {
            /**
     * @internal
     */ key: "convertVectorValue",
            value: function convertVectorValue(e) {
                var _e_fields_je_arrayValue_values, _e_fields_je_arrayValue, _e_fields;
                var t = (_e_fields = e.fields) === null || _e_fields === void 0 ? void 0 : (_e_fields_je_arrayValue = _e_fields[je].arrayValue) === null || _e_fields_je_arrayValue === void 0 ? void 0 : (_e_fields_je_arrayValue_values = _e_fields_je_arrayValue.values) === null || _e_fields_je_arrayValue_values === void 0 ? void 0 : _e_fields_je_arrayValue_values.map(function(e) {
                    return __PRIVATE_normalizeNumber(e.doubleValue);
                });
                return new n(t);
            }
        },
        {
            key: "convertGeoPoint",
            value: function convertGeoPoint(e) {
                return new GeoPoint(__PRIVATE_normalizeNumber(e.latitude), __PRIVATE_normalizeNumber(e.longitude));
            }
        },
        {
            key: "convertArray",
            value: function convertArray(e, t) {
                var _this = this;
                return (e.values || []).map(function(e) {
                    return _this.convertValue(e, t);
                });
            }
        },
        {
            key: "convertServerTimestamp",
            value: function convertServerTimestamp(e, t) {
                switch(t){
                    case "previous":
                        var n = __PRIVATE_getPreviousValue(e);
                        return null == n ? null : this.convertValue(n, t);
                    case "estimate":
                        return this.convertTimestamp(__PRIVATE_getLocalWriteTime(e));
                    default:
                        return null;
                }
            }
        },
        {
            key: "convertTimestamp",
            value: function convertTimestamp(e) {
                var t = __PRIVATE_normalizeTimestamp(e);
                return new Timestamp(t.seconds, t.nanos);
            }
        },
        {
            key: "convertDocumentKey",
            value: function convertDocumentKey(e, t) {
                var n = ResourcePath.fromString(e);
                __PRIVATE_hardAssert(__PRIVATE_isValidResourceName(n), 9688, {
                    name: e
                });
                var r = new DatabaseId(n.get(1), n.get(3)), i = new DocumentKey(n.popFirst(5));
                return r.isEqual(t) || // TODO(b/64130202): Somehow support foreign references.
                __PRIVATE_logError("A document reference to ".concat(i, " refers to a different database (").concat(r.projectId, "/").concat(r.database, "), which is not supported. It will be treated as a reference in the current database (").concat(t.projectId, "/").concat(t.database, ") instead.")), i;
            }
        }
    ]);
    return AbstractUserDataWriter;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts custom model object of type T into `DocumentData` by applying the
 * converter if it exists.
 *
 * This function is used when converting user objects to `DocumentData`
 * because we want to provide the user with a more specific error message if
 * their `set()` or fails due to invalid data originating from a `toFirestore()`
 * call.
 */ function __PRIVATE_applyFirestoreDataConverter(e, t, n) {
    var r;
    // Cast to `any` in order to satisfy the union type constraint on
    // toFirestore().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return r = e ? n && (n.merge || n.mergeFields) ? e.toFirestore(t, n) : e.toFirestore(t) : t, r;
}
var __PRIVATE_LiteUserDataWriter = /*#__PURE__*/ function(AbstractUserDataWriter) {
    "use strict";
    (0, $c2MhV._)(__PRIVATE_LiteUserDataWriter, AbstractUserDataWriter);
    function __PRIVATE_LiteUserDataWriter(e) {
        (0, $4QweW._)(this, __PRIVATE_LiteUserDataWriter);
        var _this;
        _this = (0, $ehF45._)(this, __PRIVATE_LiteUserDataWriter), _this.firestore = e;
        return _this;
    }
    (0, $6hK4i._)(__PRIVATE_LiteUserDataWriter, [
        {
            key: "convertBytes",
            value: function convertBytes(e) {
                return new Bytes(e);
            }
        },
        {
            key: "convertReference",
            value: function convertReference(e) {
                var t = this.convertDocumentKey(e, this.firestore._databaseId);
                return new aa(this.firestore, /* converter= */ null, t);
            }
        }
    ]);
    return __PRIVATE_LiteUserDataWriter;
}(AbstractUserDataWriter);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var gr = "AsyncQueue";
var __PRIVATE_AsyncQueueImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_AsyncQueueImpl() {
        var _this = this;
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Promise.resolve();
        (0, $4QweW._)(this, __PRIVATE_AsyncQueueImpl);
        // A list of retryable operations. Retryable operations are run in order and
        // retried with backoff.
        this.$c = [], // Is this AsyncQueue being shut down? Once it is set to true, it will not
        // be changed again.
        this.Kc = false, // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this.Qc = [], // visible for testing
        this.Wc = null, // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.Gc = false, // Enabled during shutdown on Safari to prevent future access to IndexedDB.
        this.zc = false, // List of TimerIds to fast-forward delays for.
        this.jc = [], // Backoff timer used to schedule retries for retryable operations
        this.Ht = new __PRIVATE_ExponentialBackoff(this, "async_queue_retry" /* TimerId.AsyncQueueRetry */ ), // Visibility handler that triggers an immediate retry of all retryable
        // operations. Meant to speed up recovery when we regain file system access
        // after page comes into foreground.
        this.Hc = function() {
            var e = getDocument();
            e && __PRIVATE_logDebug(gr, "Visibility state changed to " + e.visibilityState), _this.Ht.$t();
        }, this.Jc = e;
        var t = getDocument();
        t && "function" == typeof t.addEventListener && t.addEventListener("visibilitychange", this.Hc);
    }
    (0, $6hK4i._)(__PRIVATE_AsyncQueueImpl, [
        {
            key: "isShuttingDown",
            get: function get() {
                return this.Kc;
            }
        },
        {
            /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */ key: "enqueueAndForget",
            value: function enqueueAndForget(e) {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.enqueue(e);
            }
        },
        {
            key: "enqueueAndForgetEvenWhileRestricted",
            value: function enqueueAndForgetEvenWhileRestricted(e) {
                this.Yc(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.Zc(e);
            }
        },
        {
            key: "enterRestrictedMode",
            value: function enterRestrictedMode(e) {
                if (!this.Kc) {
                    this.Kc = true, this.zc = e || false;
                    var t = getDocument();
                    t && "function" == typeof t.removeEventListener && t.removeEventListener("visibilitychange", this.Hc);
                }
            }
        },
        {
            key: "enqueue",
            value: function enqueue(e) {
                var _this = this;
                if (this.Yc(), this.Kc) // Return a Promise which never resolves.
                return new Promise(function() {});
                // Create a deferred Promise that we can return to the callee. This
                // allows us to return a "hanging Promise" only to the callee and still
                // advance the queue even when the operation is not run.
                var t = new __PRIVATE_Deferred;
                return this.Zc(function() {
                    return _this.Kc && _this.zc ? Promise.resolve() : (e().then(t.resolve, t.reject), t.promise);
                }).then(function() {
                    return t.promise;
                });
            }
        },
        {
            key: "enqueueRetryable",
            value: function enqueueRetryable(e) {
                var _this = this;
                this.enqueueAndForget(function() {
                    return _this.$c.push(e), _this.Xc();
                });
            }
        },
        {
            key: "Xc",
            value: /**
     * Runs the next operation from the retryable queue. If the operation fails,
     * reschedules with backoff.
     */ function Xc() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var _this, e;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                if (!(0 !== this.$c.length)) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this.$c[0]()
                                ];
                            case 2:
                                _state.sent(), this.$c.shift(), this.Ht.reset();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                if (!__PRIVATE_isIndexedDbTransactionError(e)) throw e;
                                // Failure will be handled by AsyncQueue
                                __PRIVATE_logDebug(gr, "Operation failed with retryable error: " + e);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                this.$c.length > 0 && // If there are additional operations, we re-schedule `retryNextOp()`.
                                // This is necessary to run retryable operations that failed during
                                // their initial attempt since we don't know whether they are already
                                // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
                                // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
                                // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
                                // call scheduled here.
                                // Since `backoffAndRun()` cancels an existing backoff and schedules a
                                // new backoff on every call, there is only ever a single additional
                                // operation in the queue.
                                this.Ht.kt(function() {
                                    return _this.Xc();
                                });
                                _state.label = 5;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "Zc",
            value: function Zc(e) {
                var _this = this;
                var t = this.Jc.then(function() {
                    return _this.Gc = true, e().catch(function(e) {
                        _this.Wc = e, _this.Gc = false;
                        // Re-throw the error so that this.tail becomes a rejected Promise and
                        // all further attempts to chain (via .then) will just short-circuit
                        // and return the rejected Promise.
                        throw __PRIVATE_logError("INTERNAL UNHANDLED ERROR: ", __PRIVATE_getMessageOrStack(e)), e;
                    }).then(function(e) {
                        return _this.Gc = false, e;
                    });
                });
                return this.Jc = t, t;
            }
        },
        {
            key: "enqueueAfterDelay",
            value: function enqueueAfterDelay(e, t, n) {
                var _this = this;
                this.Yc(), // Fast-forward delays for timerIds that have been overridden.
                this.jc.indexOf(e) > -1 && (t = 0);
                var r = DelayedOperation.createAndSchedule(this, e, t, n, function(e) {
                    return _this.el(e);
                });
                return this.Qc.push(r), r;
            }
        },
        {
            key: "Yc",
            value: function Yc() {
                this.Wc && l(47125, {
                    tl: __PRIVATE_getMessageOrStack(this.Wc)
                });
            }
        },
        {
            key: "verifyOperationInProgress",
            value: function verifyOperationInProgress() {}
        },
        {
            key: "nl",
            value: /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */ function nl() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var e;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                e = this.Jc;
                                return [
                                    4,
                                    e
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                if (e !== this.Jc) return [
                                    3,
                                    0
                                ];
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */ key: "rl",
            value: function rl(e) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.Qc[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var t = _step.value;
                        if (t.timerId === e) return true;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return false;
            }
        },
        {
            /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId - Delayed operations up to and including this TimerId
     * will be drained. Pass TimerId.All to run all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */ key: "il",
            value: function il(e) {
                var _this = this;
                // Note that draining may generate more delayed ops, so we do that first.
                return this.nl().then(function() {
                    // Run ops in the same order they'd run if they ran naturally.
                    /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ _this.Qc.sort(function(e, t) {
                        return e.targetTimeMs - t.targetTimeMs;
                    });
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = _this.Qc[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var t = _step.value;
                            if (t.skipDelay(), "all" /* TimerId.All */  !== e && t.timerId === e) break;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return _this.nl();
                });
            }
        },
        {
            /**
     * For Tests: Skip all subsequent delays for a timer id.
     */ key: "sl",
            value: function sl(e) {
                this.jc.push(e);
            }
        },
        {
            /** Called once a DelayedOperation is run or canceled. */ key: "el",
            value: function el(e) {
                // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
                var t = this.Qc.indexOf(e);
                /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ this.Qc.splice(t, 1);
            }
        }
    ]);
    return __PRIVATE_AsyncQueueImpl;
}();
/**
 * Chrome includes Error.message in Error.stack. Other browsers do not.
 * This returns expected output of message + stack when available.
 * @param error - Error or FirestoreError
 */ function __PRIVATE_getMessageOrStack(e) {
    var t = e.message || "";
    return e.stack && (t = e.stack.includes(e.message) ? e.stack : e.message + "\n" + e.stack), t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the task of loading a Firestore bundle. It provides progress of bundle
 * loading, as well as task completion and error events.
 *
 * The API is compatible with `Promise<LoadBundleTaskProgress>`.
 */ var LoadBundleTask = /*#__PURE__*/ function() {
    "use strict";
    function LoadBundleTask() {
        (0, $4QweW._)(this, LoadBundleTask);
        this._progressObserver = {}, this._taskCompletionResolver = new __PRIVATE_Deferred, this._lastProgress = {
            taskState: "Running",
            totalBytes: 0,
            totalDocuments: 0,
            bytesLoaded: 0,
            documentsLoaded: 0
        };
    }
    (0, $6hK4i._)(LoadBundleTask, [
        {
            /**
     * Registers functions to listen to bundle loading progress events.
     * @param next - Called when there is a progress update from bundle loading. Typically `next` calls occur
     *   each time a Firestore document is loaded from the bundle.
     * @param error - Called when an error occurs during bundle loading. The task aborts after reporting the
     *   error, and there should be no more updates after this.
     * @param complete - Called when the loading task is complete.
     */ key: "onProgress",
            value: function onProgress(e, t, n) {
                this._progressObserver = {
                    next: e,
                    error: t,
                    complete: n
                };
            }
        },
        {
            /**
     * Implements the `Promise<LoadBundleTaskProgress>.catch` interface.
     *
     * @param onRejected - Called when an error occurs during bundle loading.
     */ key: "catch",
            value: function _catch(e) {
                return this._taskCompletionResolver.promise.catch(e);
            }
        },
        {
            /**
     * Implements the `Promise<LoadBundleTaskProgress>.then` interface.
     *
     * @param onFulfilled - Called on the completion of the loading task with a final `LoadBundleTaskProgress` update.
     *   The update will always have its `taskState` set to `"Success"`.
     * @param onRejected - Called when an error occurs during bundle loading.
     */ key: "then",
            value: function then(e, t) {
                return this._taskCompletionResolver.promise.then(e, t);
            }
        },
        {
            /**
     * Notifies all observers that bundle loading has completed, with a provided
     * `LoadBundleTaskProgress` object.
     *
     * @private
     */ key: "_completeWith",
            value: function _completeWith(e) {
                this._updateProgress(e), this._progressObserver.complete && this._progressObserver.complete(), this._taskCompletionResolver.resolve(e);
            }
        },
        {
            /**
     * Notifies all observers that bundle loading has failed, with a provided
     * `Error` as the reason.
     *
     * @private
     */ key: "_failWith",
            value: function _failWith(e) {
                this._lastProgress.taskState = "Error", this._progressObserver.next && this._progressObserver.next(this._lastProgress), this._progressObserver.error && this._progressObserver.error(e), this._taskCompletionResolver.reject(e);
            }
        },
        {
            /**
     * Notifies a progress update of loading a bundle.
     * @param progress - The new progress.
     *
     * @private
     */ key: "_updateProgress",
            value: function _updateProgress(e) {
                this._lastProgress = e, this._progressObserver.next && this._progressObserver.next(e);
            }
        }
    ]);
    return LoadBundleTask;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Constant used to indicate the LRU garbage collection should be disabled.
 * Set this value as the `cacheSizeBytes` on the settings passed to the
 * {@link Firestore} instance.
 */ var yr = -1;
/**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link (getFirestore:1)}.
 */ var da = /*#__PURE__*/ function(Dt) {
    "use strict";
    (0, $c2MhV._)(da, Dt);
    function da(e, t, n, r) {
        (0, $4QweW._)(this, da);
        var _this;
        _this = (0, $ehF45._)(this, da, [
            e,
            t,
            n,
            r
        ]), /**
         * Whether it's a {@link Firestore} or Firestore Lite instance.
         */ _this.type = "firestore", _this._queue = new __PRIVATE_AsyncQueueImpl, _this._persistenceKey = (r === null || r === void 0 ? void 0 : r.name) || "[DEFAULT]";
        return _this;
    }
    (0, $6hK4i._)(da, [
        {
            key: "_terminate",
            value: function _terminate() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var e;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this._firestoreClient) return [
                                    3,
                                    2
                                ];
                                e = this._firestoreClient.terminate();
                                this._queue = new __PRIVATE_AsyncQueueImpl(e), this._firestoreClient = void 0;
                                return [
                                    4,
                                    e
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return da;
}(Dt);
/**
 * Initializes a new instance of {@link Firestore} with the provided settings.
 * Can only be called before any other function, including
 * {@link (getFirestore:1)}. If the custom settings are empty, this function is
 * equivalent to calling {@link (getFirestore:1)}.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} with which the {@link Firestore} instance will
 * be associated.
 * @param settings - A settings object to configure the {@link Firestore} instance.
 * @param databaseId - The name of the database.
 * @returns A newly initialized {@link Firestore} instance.
 */ function initializeFirestore(t, n, r) {
    r || (r = $e);
    var i = (0, $wQDEL._getProvider)(t, "firestore");
    if (i.isInitialized(r)) {
        var _$t = i.getImmediate({
            identifier: r
        }), s = i.getOptions(r);
        if ((0, $hk14n.deepEqual)(s, n)) return _$t;
        throw new e(ta.FAILED_PRECONDITION, "initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance.");
    }
    if (void 0 !== n.cacheSizeBytes && void 0 !== n.localCache) throw new e(ta.INVALID_ARGUMENT, "cache and cacheSizeBytes cannot be specified at the same time as cacheSizeBytes willbe deprecated. Instead, specify the cache size in the cache object");
    if (void 0 !== n.cacheSizeBytes && -1 !== n.cacheSizeBytes && n.cacheSizeBytes < bt) throw new e(ta.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
    // Workaround to get cookies in Firebase Studio
    return n.host && (0, $hk14n.isCloudWorkstation)(n.host) && (0, $hk14n.pingServer)(n.host), i.initialize({
        options: n,
        instanceIdentifier: r
    });
}
function getFirestore(e, t) {
    var n = "object" == (typeof e === "undefined" ? "undefined" : (0, $5djcY._)(e)) ? e : (0, $wQDEL.getApp)(), r = "string" == typeof e ? e : t || $e, i = (0, $wQDEL._getProvider)(n, "firestore").getImmediate({
        identifier: r
    });
    if (!i._initialized) {
        var _$e = (0, $hk14n.getDefaultEmulatorHostnameAndPort)("firestore");
        _$e && connectFirestoreEmulator.apply(void 0, [
            i
        ].concat((0, $jlUaU._)(_$e)));
    }
    return i;
}
/**
 * @internal
 */ function oa(t) {
    if (t._terminated) throw new e(ta.FAILED_PRECONDITION, "The client has already been terminated.");
    return t._firestoreClient || __PRIVATE_configureFirestore(t), t._firestoreClient;
}
function __PRIVATE_configureFirestore(e) {
    var _e__app, _e__app1, _t_localCache, _t_localCache1;
    var t = e._freezeSettings(), n = __PRIVATE_makeDatabaseInfo(e._databaseId, ((_e__app = e._app) === null || _e__app === void 0 ? void 0 : _e__app.options.appId) || "", e._persistenceKey, (_e__app1 = e._app) === null || _e__app1 === void 0 ? void 0 : _e__app1.options.apiKey, t);
    e._componentsProvider || ((_t_localCache = t.localCache) === null || _t_localCache === void 0 ? void 0 : _t_localCache._offlineComponentProvider) && ((_t_localCache1 = t.localCache) === null || _t_localCache1 === void 0 ? void 0 : _t_localCache1._onlineComponentProvider) && (e._componentsProvider = {
        _offline: t.localCache._offlineComponentProvider,
        _online: t.localCache._onlineComponentProvider
    }), e._firestoreClient = new FirestoreClient(e._authCredentials, e._appCheckCredentials, e._queue, n, e._componentsProvider && function __PRIVATE_buildComponentProvider(e) {
        var t = e === null || e === void 0 ? void 0 : e._online.build();
        return {
            _offline: e === null || e === void 0 ? void 0 : e._offline.build(t),
            _online: t
        };
    }(e._componentsProvider));
}
function enableIndexedDbPersistence(e, t) {
    __PRIVATE_logWarn("enableIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    var n = e._freezeSettings();
    return __PRIVATE_setPersistenceProviders(e, OnlineComponentProvider.provider, {
        build: function(e) {
            return new __PRIVATE_IndexedDbOfflineComponentProvider(e, n.cacheSizeBytes, t === null || t === void 0 ? void 0 : t.forceOwnership);
        }
    }), Promise.resolve();
}
/**
 * Attempts to enable multi-tab persistent storage, if possible. If enabled
 * across all tabs, all operations share access to local persistence, including
 * shared execution of queries and latency-compensated local document updates
 * across all connected instances.
 *
 * On failure, `enableMultiTabIndexedDbPersistence()` will reject the promise or
 * throw an exception. There are several reasons why this can fail, which can be
 * identified by the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab and
 *     multi-tab is not enabled.
 *   * unimplemented: The browser is incompatible with the offline persistence
 *     implementation.
 *
 * Note that even after a failure, the {@link Firestore} instance will remain
 * usable, however offline persistence will be disabled.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @returns A `Promise` that represents successfully enabling persistent
 * storage.
 * @deprecated This function will be removed in a future major release. Instead, set
 * `FirestoreSettings.localCache` to an instance of `PersistentLocalCache` to
 * turn on indexeddb cache. Calling this function when `FirestoreSettings.localCache`
 * is already specified will throw an exception.
 */ function enableMultiTabIndexedDbPersistence(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var t;
        return (0, $gh3Df._)(this, function(_state) {
            __PRIVATE_logWarn("enableMultiTabIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
            t = e._freezeSettings();
            __PRIVATE_setPersistenceProviders(e, OnlineComponentProvider.provider, {
                build: function(e) {
                    return new __PRIVATE_MultiTabOfflineComponentProvider(e, t.cacheSizeBytes);
                }
            });
            return [
                2
            ];
        });
    })();
}
/**
 * Registers both the `OfflineComponentProvider` and `OnlineComponentProvider`.
 * If the operation fails with a recoverable error (see
 * `canRecoverFromIndexedDbError()` below), the returned Promise is rejected
 * but the client remains usable.
 */ function __PRIVATE_setPersistenceProviders(t, n, r) {
    if ((t = ra(t, da))._firestoreClient || t._terminated) throw new e(ta.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only enable persistence before calling any other methods on a Firestore object.");
    if (t._componentsProvider || t._getSettings().localCache) throw new e(ta.FAILED_PRECONDITION, "SDK cache is already specified.");
    t._componentsProvider = {
        _online: n,
        _offline: r
    }, __PRIVATE_configureFirestore(t);
}
/**
 * Clears the persistent storage. This includes pending writes and cached
 * documents.
 *
 * Must be called while the {@link Firestore} instance is not started (after the app is
 * terminated or when the app is first initialized). On startup, this function
 * must be called before other functions (other than {@link
 * initializeFirestore} or {@link (getFirestore:1)})). If the {@link Firestore}
 * instance is still running, the promise will be rejected with the error code
 * of `failed-precondition`.
 *
 * Note: `clearIndexedDbPersistence()` is primarily intended to help write
 * reliable tests that use Cloud Firestore. It uses an efficient mechanism for
 * dropping existing data but does not attempt to securely overwrite or
 * otherwise make cached data unrecoverable. For applications that are sensitive
 * to the disclosure of cached data in between user sessions, we strongly
 * recommend not enabling persistence at all.
 *
 * @param firestore - The {@link Firestore} instance to clear persistence for.
 * @returns A `Promise` that is resolved when the persistent storage is
 * cleared. Otherwise, the promise is rejected with an error.
 */ function clearIndexedDbPersistence(t) {
    if (t._initialized && !t._terminated) throw new e(ta.FAILED_PRECONDITION, "Persistence can only be cleared before a Firestore instance is initialized or after it is terminated.");
    var n = new __PRIVATE_Deferred;
    return t._queue.enqueueAndForgetEvenWhileRestricted(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var e;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            function __PRIVATE_indexedDbClearPersistence(e) {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                                    var _$t;
                                    return (0, $gh3Df._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!__PRIVATE_SimpleDb.Ye()) return [
                                                    2,
                                                    Promise.resolve()
                                                ];
                                                _$t = e + cr;
                                                return [
                                                    4,
                                                    __PRIVATE_SimpleDb.delete(_$t)
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            }(__PRIVATE_indexedDbStoragePrefix(t._databaseId, t._persistenceKey))
                        ];
                    case 1:
                        _state.sent(), n.resolve();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        n.reject(e);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }), n.promise;
}
/**
 * Waits until all currently pending writes for the active user have been
 * acknowledged by the backend.
 *
 * The returned promise resolves immediately if there are no outstanding writes.
 * Otherwise, the promise waits for all previously issued writes (including
 * those written in a previous app session), but it does not wait for writes
 * that were added after the function is called. If you want to wait for
 * additional writes, call `waitForPendingWrites()` again.
 *
 * Any outstanding `waitForPendingWrites()` promises are rejected during user
 * changes.
 *
 * @returns A `Promise` which resolves when all currently pending writes have been
 * acknowledged by the backend.
 */ function waitForPendingWrites(e) {
    return function __PRIVATE_firestoreClientWaitForPendingWrites(e) {
        var t = new __PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                return (0, $gh3Df._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                __PRIVATE_getSyncEngine(e)
                            ];
                        case 1:
                            return [
                                2,
                                __PRIVATE_syncEngineRegisterPendingWritesCallback.apply(void 0, [
                                    _state.sent(),
                                    t
                                ])
                            ];
                    }
                });
            })();
        }), t.promise;
    }(oa(e = ra(e, da)));
}
/**
 * Re-enables use of the network for this {@link Firestore} instance after a prior
 * call to {@link disableNetwork}.
 *
 * @returns A `Promise` that is resolved once the network has been enabled.
 */ function enableNetwork(e) {
    return __PRIVATE_firestoreClientEnableNetwork(oa(e = ra(e, da)));
}
/**
 * Disables network usage for this instance. It can be re-enabled via {@link
 * enableNetwork}. While the network is disabled, any snapshot listeners,
 * `getDoc()` or `getDocs()` calls will return results from cache, and any write
 * operations will be queued until the network is restored.
 *
 * @returns A `Promise` that is resolved once the network has been disabled.
 */ function disableNetwork(e) {
    return __PRIVATE_firestoreClientDisableNetwork(oa(e = ra(e, da)));
}
/**
 * Terminates the provided {@link Firestore} instance.
 *
 * After calling `terminate()` only the `clearIndexedDbPersistence()` function
 * may be used. Any other function will throw a `FirestoreError`.
 *
 * To restart after termination, create a new instance of FirebaseFirestore with
 * {@link (getFirestore:1)}.
 *
 * Termination does not cancel any pending writes, and any promises that are
 * awaiting a response from the server will not be resolved. If you have
 * persistence enabled, the next time you start this instance, it will resume
 * sending these writes to the server.
 *
 * Note: Under normal circumstances, calling `terminate()` is not required. This
 * function is useful only when you want to force this instance to release all
 * of its resources or in combination with `clearIndexedDbPersistence()` to
 * ensure that all local state is destroyed between test runs.
 *
 * @returns A `Promise` that is resolved when the instance has been successfully
 * terminated.
 */ function terminate(e) {
    return (0, $wQDEL._removeServiceInstance)(e.app, "firestore", e._databaseId.database), e._delete();
}
/**
 * Loads a Firestore bundle into the local cache.
 *
 * @param firestore - The {@link Firestore} instance to load bundles for.
 * @param bundleData - An object representing the bundle to be loaded. Valid
 * objects are `ArrayBuffer`, `ReadableStream<Uint8Array>` or `string`.
 *
 * @returns A `LoadBundleTask` object, which notifies callers with progress
 * updates, and completion or error events. It can be used as a
 * `Promise<LoadBundleTaskProgress>`.
 */ function loadBundle(e, t) {
    var n = oa(e = ra(e, da)), r = new LoadBundleTask;
    return __PRIVATE_firestoreClientLoadBundle(n, e._databaseId, t, r), r;
}
/**
 * Reads a Firestore {@link Query} from local cache, identified by the given
 * name.
 *
 * The named queries are packaged  into bundles on the server side (along
 * with resulting documents), and loaded to local cache using `loadBundle`. Once
 * in local cache, use this method to extract a {@link Query} by name.
 *
 * @param firestore - The {@link Firestore} instance to read the query from.
 * @param name - The name of the query.
 * @returns A `Promise` that is resolved with the Query or `null`.
 */ function namedQuery(e, t) {
    return __PRIVATE_firestoreClientGetNamedQuery(oa(e = ra(e, da)), t).then(function(t) {
        return t ? new Query(e, null, t.query) : null;
    });
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var ua = /*#__PURE__*/ function(AbstractUserDataWriter) {
    "use strict";
    (0, $c2MhV._)(ua, AbstractUserDataWriter);
    function ua(e) {
        (0, $4QweW._)(this, ua);
        var _this;
        _this = (0, $ehF45._)(this, ua), _this.firestore = e;
        return _this;
    }
    (0, $6hK4i._)(ua, [
        {
            key: "convertBytes",
            value: function convertBytes(e) {
                return new Bytes(e);
            }
        },
        {
            key: "convertReference",
            value: function convertReference(e) {
                var t = this.convertDocumentKey(e, this.firestore._databaseId);
                return new aa(this.firestore, /* converter= */ null, t);
            }
        }
    ]);
    return ua;
}(AbstractUserDataWriter);
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var wr = "NOT SUPPORTED";
/**
 * Metadata about a snapshot, describing the state of the snapshot.
 */ var SnapshotMetadata = /*#__PURE__*/ function() {
    "use strict";
    function SnapshotMetadata(e, t) {
        (0, $4QweW._)(this, SnapshotMetadata);
        this.hasPendingWrites = e, this.fromCache = t;
    }
    (0, $6hK4i._)(SnapshotMetadata, [
        {
            /**
     * Returns true if this `SnapshotMetadata` is equal to the provided one.
     *
     * @param other - The `SnapshotMetadata` to compare against.
     * @returns true if this `SnapshotMetadata` is equal to the provided one.
     */ key: "isEqual",
            value: function isEqual(e) {
                return this.hasPendingWrites === e.hasPendingWrites && this.fromCache === e.fromCache;
            }
        }
    ]);
    return SnapshotMetadata;
}();
/**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ var DocumentSnapshot = /*#__PURE__*/ function(mr) {
    "use strict";
    (0, $c2MhV._)(DocumentSnapshot, mr);
    function DocumentSnapshot(e, t, n, r, i, s) {
        (0, $4QweW._)(this, DocumentSnapshot);
        var _this;
        _this = (0, $ehF45._)(this, DocumentSnapshot, [
            e,
            t,
            n,
            r,
            s
        ]), _this._firestore = e, _this._firestoreImpl = e, _this.metadata = i;
        return _this;
    }
    (0, $6hK4i._)(DocumentSnapshot, [
        {
            /**
     * Returns whether or not the data exists. True if the document exists.
     */ key: "exists",
            value: function exists() {
                return (0, $hC9N3._)((0, $9atk1._)(DocumentSnapshot.prototype), "exists", this).call(this);
            }
        },
        {
            /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document or `undefined` if
     * the document doesn't exist.
     */ key: "data",
            value: function data() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                if (this._document) {
                    if (this._converter) {
                        // We only want to use the converter and create a new DocumentSnapshot
                        // if a converter has been provided.
                        var t = new QueryDocumentSnapshot(this._firestore, this._userDataWriter, this._key, this._document, this.metadata, /* converter= */ null);
                        return this._converter.fromFirestore(t, e);
                    }
                    return this._userDataWriter.convertValue(this._document.data.value, e.serverTimestamps);
                }
            }
        },
        {
            /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * By default, a `serverTimestamp()` that has not yet been set to
     * its final value will be returned as `null`. You can override this by
     * passing an options object.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @param options - An options object to configure how the field is retrieved
     * from the snapshot (for example the desired behavior for server timestamps
     * that have not yet been set to their final value).
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "get",
            value: function get(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (this._document) {
                    var n = this._document.data.field(K("DocumentSnapshot.get", e));
                    if (null !== n) return this._userDataWriter.convertValue(n, t.serverTimestamps);
                }
            }
        },
        {
            /**
     * Returns a JSON-serializable representation of this `DocumentSnapshot` instance.
     *
     * @returns a JSON representation of this object.  Throws a {@link FirestoreError} if this
     * `DocumentSnapshot` has pending writes.
     */ key: "toJSON",
            value: function toJSON() {
                if (this.metadata.hasPendingWrites) throw new e(ta.FAILED_PRECONDITION, "DocumentSnapshot.toJSON() attempted to serialize a document with pending writes. Await waitForPendingWrites() before invoking toJSON().");
                var t = this._document, n = {};
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (n.type = DocumentSnapshot._jsonSchemaVersion, n.bundle = "", n.bundleSource = "DocumentSnapshot", n.bundleName = this._key.toString(), !t || !t.isValidDocument() || !t.isFoundDocument()) return n;
                this._userDataWriter.convertObjectMap(t.data.value.mapValue.fields, "previous");
                return n.bundle = (this._firestore, this.ref.path, "NOT SUPPORTED"), n;
            }
        }
    ]);
    return DocumentSnapshot;
}(mr);
function documentSnapshotFromJSON(t, n, r) {
    if (__PRIVATE_validateJSON(n, DocumentSnapshot._jsonSchema)) {
        if (n.bundle === wr) throw new e(ta.INVALID_ARGUMENT, "The provided JSON object was created in a client environment, which is not supported.");
        // Parse the bundle data.
        var i = __PRIVATE_newSerializer(t._databaseId), s = __PRIVATE_createBundleReaderSync(n.bundle, i), _ = s.va(), o = new __PRIVATE_BundleLoader(s.getMetadata(), i);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var e1 = _step.value;
                o.$u(e1);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // Ensure that we have the correct number of documents in the bundle.
        var a = o.documents;
        if (1 !== a.length) throw new e(ta.INVALID_ARGUMENT, "Expected bundle data to contain 1 document, but it contains ".concat(a.length, " documents."));
        // Build out the internal document data.
        var u = fromDocument(i, a[0].document), c = new DocumentKey(ResourcePath.fromString(n.bundleName));
        // Return the external facing DocumentSnapshot.
        return new DocumentSnapshot(t, new __PRIVATE_LiteUserDataWriter(t), c, u, new SnapshotMetadata(/* hasPendingWrites= */ false, /* fromCache= */ false), r || null);
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ DocumentSnapshot._jsonSchemaVersion = "firestore/documentSnapshot/1.0", DocumentSnapshot._jsonSchema = {
    type: property("string", DocumentSnapshot._jsonSchemaVersion),
    bundleSource: property("string", "DocumentSnapshot"),
    bundleName: property("string"),
    bundle: property("string")
};
var QueryDocumentSnapshot = /*#__PURE__*/ function(DocumentSnapshot) {
    "use strict";
    (0, $c2MhV._)(QueryDocumentSnapshot, DocumentSnapshot);
    function QueryDocumentSnapshot() {
        (0, $4QweW._)(this, QueryDocumentSnapshot);
        return (0, $ehF45._)(this, QueryDocumentSnapshot, arguments);
    }
    (0, $6hK4i._)(QueryDocumentSnapshot, [
        {
            /**
     * Retrieves all fields in the document as an `Object`.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @override
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document.
     */ key: "data",
            value: function data() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                return (0, $hC9N3._)((0, $9atk1._)(QueryDocumentSnapshot.prototype), "data", this).call(this, e);
            }
        }
    ]);
    return QueryDocumentSnapshot;
}(DocumentSnapshot);
/**
 * A `QuerySnapshot` contains zero or more `DocumentSnapshot` objects
 * representing the results of a query. The documents can be accessed as an
 * array via the `docs` property or enumerated using the `forEach` method. The
 * number of documents can be determined via the `empty` and `size`
 * properties.
 */ var QuerySnapshot = /*#__PURE__*/ function() {
    "use strict";
    function QuerySnapshot(e, t, n, r) {
        (0, $4QweW._)(this, QuerySnapshot);
        this._firestore = e, this._userDataWriter = t, this._snapshot = r, this.metadata = new SnapshotMetadata(r.hasPendingWrites, r.fromCache), this.query = n;
    }
    (0, $6hK4i._)(QuerySnapshot, [
        {
            key: "docs",
            get: /** An array of all the documents in the `QuerySnapshot`. */ function get() {
                var e = [];
                return this.forEach(function(t) {
                    return e.push(t);
                }), e;
            }
        },
        {
            key: "size",
            get: /** The number of documents in the `QuerySnapshot`. */ function get() {
                return this._snapshot.docs.size;
            }
        },
        {
            key: "empty",
            get: /** True if there are no documents in the `QuerySnapshot`. */ function get() {
                return 0 === this.size;
            }
        },
        {
            /**
     * Enumerates all of the documents in the `QuerySnapshot`.
     *
     * @param callback - A callback to be called with a `QueryDocumentSnapshot` for
     * each document in the snapshot.
     * @param thisArg - The `this` binding for the callback.
     */ key: "forEach",
            value: function forEach(e, t) {
                var _this = this;
                this._snapshot.docs.forEach(function(n) {
                    e.call(t, new QueryDocumentSnapshot(_this._firestore, _this._userDataWriter, n.key, n, new SnapshotMetadata(_this._snapshot.mutatedKeys.has(n.key), _this._snapshot.fromCache), _this.query.converter));
                });
            }
        },
        {
            /**
     * Returns an array of the documents changes since the last snapshot. If this
     * is the first snapshot, all documents will be in the list as 'added'
     * changes.
     *
     * @param options - `SnapshotListenOptions` that control whether metadata-only
     * changes (i.e. only `DocumentSnapshot.metadata` changed) should trigger
     * snapshot events.
     */ key: "docChanges",
            value: function docChanges() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var n = !!t.includeMetadataChanges;
                if (n && this._snapshot.excludesMetadataChanges) throw new e(ta.INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
                return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === n || (this._cachedChanges = /** Calculates the array of `DocumentChange`s for a given `ViewSnapshot`. */ function __PRIVATE_changesFromSnapshot(e, t) {
                    if (e._snapshot.oldDocs.isEmpty()) {
                        var t1 = 0;
                        return e._snapshot.docChanges.map(function(n) {
                            __PRIVATE_isPipeline(e._snapshot.query) ? __PRIVATE_newPipelineComparator(e._snapshot.query) : __PRIVATE_newQueryComparator(e.query._query);
                            var r = new QueryDocumentSnapshot(e._firestore, e._userDataWriter, n.doc.key, n.doc, new SnapshotMetadata(e._snapshot.mutatedKeys.has(n.doc.key), e._snapshot.fromCache), e.query.converter);
                            return n.doc, {
                                type: "added",
                                doc: r,
                                oldIndex: -1,
                                newIndex: t1++
                            };
                        });
                    }
                    {
                        // A `DocumentSet` that is updated incrementally as changes are applied to use
                        // to lookup the index of a document.
                        var n = e._snapshot.oldDocs;
                        return e._snapshot.docChanges.filter(function(e) {
                            return t || 3 /* ChangeType.Metadata */  !== e.type;
                        }).map(function(t) {
                            var r = new QueryDocumentSnapshot(e._firestore, e._userDataWriter, t.doc.key, t.doc, new SnapshotMetadata(e._snapshot.mutatedKeys.has(t.doc.key), e._snapshot.fromCache), e.query.converter);
                            var i = -1, s = -1;
                            return 0 /* ChangeType.Added */  !== t.type && (i = n.indexOf(t.doc.key), n = n.delete(t.doc.key)), 1 /* ChangeType.Removed */  !== t.type && (n = n.add(t.doc), s = n.indexOf(t.doc.key)), {
                                type: __PRIVATE_resultChangeType(t.type),
                                doc: r,
                                oldIndex: i,
                                newIndex: s
                            };
                        });
                    }
                }(this, n), this._cachedChangesIncludeMetadataChanges = n), this._cachedChanges;
            }
        },
        {
            /**
     * Returns a JSON-serializable representation of this `QuerySnapshot` instance.
     *
     * @returns a JSON representation of this object. Throws a {@link FirestoreError} if this
     * `QuerySnapshot` has pending writes.
     */ key: "toJSON",
            value: function toJSON() {
                var _this = this;
                if (this.metadata.hasPendingWrites) throw new e(ta.FAILED_PRECONDITION, "QuerySnapshot.toJSON() attempted to serialize a document with pending writes. Await waitForPendingWrites() before invoking toJSON().");
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var t = {};
                t.type = QuerySnapshot._jsonSchemaVersion, t.bundleSource = "QuerySnapshot", t.bundleName = __PRIVATE_AutoId.newId(), this._firestore._databaseId.database, this._firestore._databaseId.projectId;
                var n = [], r = [], i = [];
                return this.docs.forEach(function(e) {
                    null !== e._document && (n.push(e._document), r.push(_this._userDataWriter.convertObjectMap(e._document.data.value.mapValue.fields, "previous")), i.push(e.ref.path));
                }), t.bundle = (this._firestore, this.query._query, t.bundleName, "NOT SUPPORTED"), t;
            }
        }
    ]);
    return QuerySnapshot;
}();
function querySnapshotFromJSON(t, n, r) {
    if (__PRIVATE_validateJSON(n, QuerySnapshot._jsonSchema)) {
        if (n.bundle === wr) throw new e(ta.INVALID_ARGUMENT, "The provided JSON object was created in a client environment, which is not supported.");
        // Parse the bundle data.
        var i = __PRIVATE_newSerializer(t._databaseId), s = __PRIVATE_createBundleReaderSync(n.bundle, i), _ = s.va(), o = new __PRIVATE_BundleLoader(s.getMetadata(), i);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var e1 = _step.value;
                o.$u(e1);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (1 !== o.queries.length) throw new e(ta.INVALID_ARGUMENT, "Snapshot data expected 1 query but found ".concat(o.queries.length, " queries."));
        // Create an internal Query object from the named query in the bundle.
        var a = __PRIVATE_fromBundledQuery(o.queries[0].bundledQuery), u = __PRIVATE_isPipeline(a) ? __PRIVATE_newPipelineComparator(a) : __PRIVATE_newQueryComparator(a), c = o.documents;
        var l = new DocumentSet(u);
        c.map(function(e) {
            var _$t = fromDocument(i, e.document);
            l = l.add(_$t);
        });
        // Create a view snapshot of the query and documents.
        var E = ViewSnapshot.fromInitialDocuments(a, l, __PRIVATE_documentKeySet(), /* fromCache= */ false, /* hasCachedResults= */ false), h = new Query(t, r || null, a);
        // Create an external Query object, required to construct the QuerySnapshot.
        // Return a new QuerySnapshot with all of the collected data.
        return new QuerySnapshot(t, new __PRIVATE_LiteUserDataWriter(t), h, E);
    }
}
function __PRIVATE_resultChangeType(e) {
    switch(e){
        case 0 /* ChangeType.Added */ :
            return "added";
        case 2 /* ChangeType.Modified */ :
        case 3 /* ChangeType.Metadata */ :
            return "modified";
        case 1 /* ChangeType.Removed */ :
            return "removed";
        default:
            return l(61501, {
                type: e
            });
    }
}
// TODO(firestoreexp): Add tests for snapshotEqual with different snapshot
// metadata
/**
 * Returns true if the provided snapshots are equal.
 *
 * @param left - A snapshot to compare.
 * @param right - A snapshot to compare.
 * @returns true if the snapshots are equal.
 */ function snapshotEqual(e, t) {
    return e instanceof DocumentSnapshot && t instanceof DocumentSnapshot ? e._firestore === t._firestore && e._key.isEqual(t._key) && (null === e._document ? null === t._document : e._document.isEqual(t._document)) && e._converter === t._converter : e instanceof QuerySnapshot && t instanceof QuerySnapshot && e._firestore === t._firestore && queryEqual(e.query, t.query) && e.metadata.isEqual(t.metadata) && e._snapshot.isEqual(t._snapshot);
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ QuerySnapshot._jsonSchemaVersion = "firestore/querySnapshot/1.0", QuerySnapshot._jsonSchema = {
    type: property("string", QuerySnapshot._jsonSchemaVersion),
    bundleSource: property("string", "QuerySnapshot"),
    bundleName: property("string"),
    bundle: property("string")
};
var pa = /*#__PURE__*/ function() {
    "use strict";
    function pa() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $4QweW._)(this, pa);
        this._l = e, this.ol = t, this.al = new OptionsUtil({
            indexMode: {
                serverName: "index_mode"
            }
        });
    }
    (0, $6hK4i._)(pa, [
        {
            key: "_readUserData",
            value: function _readUserData(e) {
                this.proto = this.al.getOptionsProto(e, this._l, this.ol);
            }
        }
    ]);
    return pa;
}();
var ma = /*#__PURE__*/ function() {
    "use strict";
    function ma(e, t) {
        (0, $4QweW._)(this, ma);
        this.pipeline = e, this.options = t;
    }
    (0, $6hK4i._)(ma, [
        {
            key: "_toProto",
            value: function _toProto(e) {
                return {
                    pipeline: this.pipeline._toProto(e),
                    options: this.options.proto
                };
            }
        }
    ]);
    return ma;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns the `QueryTarget` representation of the given query. Returns `null`
 * if the Firestore client associated with the given query has not been
 * initialized or has been terminated.
 *
 * @param query - The Query to convert to proto representation.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function _internalQueryToProtoQueryTarget(e) {
    var _t__onlineComponents;
    var t = oa(ra(e.firestore, da)), n = (_t__onlineComponents = t._onlineComponents) === null || _t__onlineComponents === void 0 ? void 0 : _t__onlineComponents.datastore.serializer;
    return void 0 === n ? null : __PRIVATE_toQueryTarget(n, __PRIVATE_queryToTarget(e._query)).Se;
}
/**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns `RunAggregationQueryRequest` which contains the proto representation
 * of the given aggregation query request. Returns null if the Firestore client
 * associated with the given query has not been initialized or has been
 * terminated.
 *
 * @param query - The Query to convert to proto representation.
 * @param aggregateSpec - The set of aggregations and their aliases.
 */ function _internalAggregationQueryToProtoRunAggregationQueryRequest(e, t) {
    var _r__onlineComponents;
    var n = __PRIVATE_mapToArray(t, function(e, t) {
        return new __PRIVATE_AggregateImpl(t, e.aggregateType, e._internalFieldPath);
    }), r = oa(ra(e.firestore, da)), i = (_r__onlineComponents = r._onlineComponents) === null || _r__onlineComponents === void 0 ? void 0 : _r__onlineComponents.datastore.serializer;
    return void 0 === i ? null : __PRIVATE_toRunAggregationQueryRequest(i, __PRIVATE_queryToAggregateTarget(e._query), n, /* skipAliasing= */ true).request;
}
/**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns the `ExecutePipelineRequest` representation of the given query.
 * Returns `null` if the Firestore client associated with the given query has
 * not been initialized or has been terminated.
 *
 * @param pipeline - The Pipeline to convert to proto representation.
 */ function _internalPipelineToExecutePipelineRequestProto(t) {
    if (!t._db) throw new e(ta.FAILED_PRECONDITION, "This pipeline was created without a database and cannot be serialized for execution.");
    var n = ra(t._db, da), r = la(n).createContext(3 /* UserDataSource.Argument */ , "_internalPipelineToExecutePipelineRequestProto");
    t._readUserData(r);
    var i = /**
 * Returns an initialized and started Datastore for the given Firestore
 * instance. Callers must invoke removeComponents() when the Firestore
 * instance is terminated.
 */ function __PRIVATE_getDatastore$1(t) {
        if (t._terminated) throw new e(ta.FAILED_PRECONDITION, "The client has already been terminated.");
        if (!dt.has(t)) {
            __PRIVATE_logDebug(Vt, "Initializing Datastore");
            var e1 = __PRIVATE_newConnection(__PRIVATE_makeDatabaseInfo(t._databaseId, t.app.options.appId || "", t._persistenceKey, t.app.options.apiKey, t._freezeSettings())), n = __PRIVATE_newSerializer(t._databaseId), r = __PRIVATE_newDatastore(t._authCredentials, t._appCheckCredentials, e1, n);
            dt.set(t, r);
        }
        return dt.get(t);
    }(n), s = i.serializer;
    if (void 0 === s) return null;
    var _ = new ma(t, new pa);
    return {
        database: __PRIVATE_getEncodedDatabaseId(s),
        structuredPipeline: _._toProto(s)
    };
}

});
parcelRegister("1DiK7", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1307f8e9916ec00c$export$71511d61b312f219; });

var $fD3AT = parcelRequire("fD3AT");
function $1307f8e9916ec00c$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = (0, $fD3AT._)(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("fD3AT", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b60d49377240381a$export$71511d61b312f219; });
function $b60d49377240381a$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("2TaHn", function(module, exports) {

$parcel$export(module.exports, "__values", function () { return $e8d611dd65e01992$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $5djcY = parcelRequire("5djcY");
var $e8d611dd65e01992$var$extendStatics = function extendStatics1(d, b) {
    $e8d611dd65e01992$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $e8d611dd65e01992$var$extendStatics(d, b);
};
function $e8d611dd65e01992$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $e8d611dd65e01992$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e8d611dd65e01992$export$18ce0697a983be9b = function __assign1() {
    $e8d611dd65e01992$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e8d611dd65e01992$export$18ce0697a983be9b.apply(this, arguments);
};
function $e8d611dd65e01992$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e8d611dd65e01992$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $5djcY._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e8d611dd65e01992$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e8d611dd65e01992$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5djcY._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $e8d611dd65e01992$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $e8d611dd65e01992$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $5djcY._)(x)) === "symbol" ? x : "".concat(x);
}
function $e8d611dd65e01992$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5djcY._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $e8d611dd65e01992$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $5djcY._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e8d611dd65e01992$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e8d611dd65e01992$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $e8d611dd65e01992$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $e8d611dd65e01992$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $e8d611dd65e01992$export$45d3717a4c69092e(o, m, p);
}
function $e8d611dd65e01992$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e8d611dd65e01992$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e8d611dd65e01992$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e8d611dd65e01992$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e8d611dd65e01992$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e8d611dd65e01992$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $e8d611dd65e01992$export$10c90e4f7922046c(v) {
    return this instanceof $e8d611dd65e01992$export$10c90e4f7922046c ? (this.v = v, this) : new $e8d611dd65e01992$export$10c90e4f7922046c(v);
}
function $e8d611dd65e01992$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e8d611dd65e01992$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e8d611dd65e01992$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e8d611dd65e01992$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $e8d611dd65e01992$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e8d611dd65e01992$export$19a8beecd37a4c45 === "function" ? $e8d611dd65e01992$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e8d611dd65e01992$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $e8d611dd65e01992$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $e8d611dd65e01992$var$ownKeys = function ownKeys1(o) {
    $e8d611dd65e01992$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $e8d611dd65e01992$var$ownKeys(o);
};
function $e8d611dd65e01992$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $e8d611dd65e01992$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $e8d611dd65e01992$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $e8d611dd65e01992$var$__setModuleDefault(result, mod);
    return result;
}
function $e8d611dd65e01992$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e8d611dd65e01992$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $e8d611dd65e01992$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $e8d611dd65e01992$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $5djcY._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $e8d611dd65e01992$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $5djcY._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $e8d611dd65e01992$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $e8d611dd65e01992$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $e8d611dd65e01992$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $e8d611dd65e01992$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $e8d611dd65e01992$export$2e2bcd8739ae039 = {
    __extends: $e8d611dd65e01992$export$a8ba968b8961cb8a,
    __assign: $e8d611dd65e01992$export$18ce0697a983be9b,
    __rest: $e8d611dd65e01992$export$3c9a16f847548506,
    __decorate: $e8d611dd65e01992$export$29e00dfd3077644b,
    __param: $e8d611dd65e01992$export$d5ad3fd78186038f,
    __esDecorate: $e8d611dd65e01992$export$3a84e1ae4e97e9b0,
    __runInitializers: $e8d611dd65e01992$export$d831c04e792af3d,
    __propKey: $e8d611dd65e01992$export$6a2a36740a146cb8,
    __setFunctionName: $e8d611dd65e01992$export$d1a06452d3489bc7,
    __metadata: $e8d611dd65e01992$export$f1db080c865becb9,
    __awaiter: $e8d611dd65e01992$export$1050f835b63b671e,
    __generator: $e8d611dd65e01992$export$67ebef60e6f28a6,
    __createBinding: $e8d611dd65e01992$export$45d3717a4c69092e,
    __exportStar: $e8d611dd65e01992$export$f33643c0debef087,
    __values: $e8d611dd65e01992$export$19a8beecd37a4c45,
    __read: $e8d611dd65e01992$export$8d051b38c9118094,
    __spread: $e8d611dd65e01992$export$afc72e2116322959,
    __spreadArrays: $e8d611dd65e01992$export$6388937ca91ccae8,
    __spreadArray: $e8d611dd65e01992$export$1216008129fb82ed,
    __await: $e8d611dd65e01992$export$10c90e4f7922046c,
    __asyncGenerator: $e8d611dd65e01992$export$e427f37a30a4de9b,
    __asyncDelegator: $e8d611dd65e01992$export$bbd80228419bb833,
    __asyncValues: $e8d611dd65e01992$export$e3b29a3d6162315f,
    __makeTemplateObject: $e8d611dd65e01992$export$4fb47efe1390b86f,
    __importStar: $e8d611dd65e01992$export$c21735bcef00d192,
    __importDefault: $e8d611dd65e01992$export$da59b14a69baef04,
    __classPrivateFieldGet: $e8d611dd65e01992$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $e8d611dd65e01992$export$d40a35129aaff81f,
    __classPrivateFieldIn: $e8d611dd65e01992$export$81fdc39f203e4e04,
    __addDisposableResource: $e8d611dd65e01992$export$88ac25d8e944e405,
    __disposeResources: $e8d611dd65e01992$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $e8d611dd65e01992$export$889dfb5d17574b0b
};

});

parcelRegister("ak6Ro", function(module, exports) {

$parcel$export(module.exports, "Integer", function () { return $784117ec5b8d3931$export$70ffa26850098d01; });
$parcel$export(module.exports, "Md5", function () { return $784117ec5b8d3931$export$9f5a3dfc7a9f5dd; });
var $784117ec5b8d3931$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
var $784117ec5b8d3931$export$2e2bcd8739ae039 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var $784117ec5b8d3931$export$70ffa26850098d01;
var $784117ec5b8d3931$export$9f5a3dfc7a9f5dd;
(function() {
    var h; /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    function k(d, a) {
        function c() {}
        c.prototype = a.prototype;
        d.F = a.prototype;
        d.prototype = new c;
        d.prototype.constructor = d;
        d.D = function(f, e, g) {
            for(var b = Array(arguments.length - 2), r = 2; r < arguments.length; r++)b[r - 2] = arguments[r];
            return a.prototype[e].apply(f, b);
        };
    }
    function l() {
        this.blockSize = -1;
    }
    function m() {
        this.blockSize = -1;
        this.blockSize = 64;
        this.g = Array(4);
        this.C = Array(this.blockSize);
        this.o = this.h = 0;
        this.u();
    }
    k(m, l);
    m.prototype.u = function() {
        this.g[0] = 1732584193;
        this.g[1] = 4023233417;
        this.g[2] = 2562383102;
        this.g[3] = 271733878;
        this.o = this.h = 0;
    };
    function n(d, a, c) {
        c || (c = 0);
        var f = Array(16);
        if (typeof a === "string") for(var e = 0; e < 16; ++e)f[e] = a.charCodeAt(c++) | a.charCodeAt(c++) << 8 | a.charCodeAt(c++) << 16 | a.charCodeAt(c++) << 24;
        else for(e = 0; e < 16; ++e)f[e] = a[c++] | a[c++] << 8 | a[c++] << 16 | a[c++] << 24;
        a = d.g[0];
        c = d.g[1];
        e = d.g[2];
        var g = d.g[3], b;
        b = a + (g ^ c & (e ^ g)) + f[0] + 3614090360 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + f[1] + 3905402710 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + f[2] + 606105819 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + f[3] + 3250441966 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + f[4] + 4118548399 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + f[5] + 1200080426 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + f[6] + 2821735955 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + f[7] + 4249261313 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + f[8] + 1770035416 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + f[9] + 2336552879 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + f[10] + 4294925233 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + f[11] + 2304563134 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + f[12] + 1804603682 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + f[13] + 4254626195 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + f[14] + 2792965006 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + f[15] + 1236535329 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (e ^ g & (c ^ e)) + f[1] + 4129170786 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + f[6] + 3225465664 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + f[11] + 643717713 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + f[0] + 3921069994 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + f[5] + 3593408605 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + f[10] + 38016083 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + f[15] + 3634488961 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + f[4] + 3889429448 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + f[9] + 568446438 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + f[14] + 3275163606 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + f[3] + 4107603335 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + f[8] + 1163531501 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + f[13] + 2850285829 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + f[2] + 4243563512 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + f[7] + 1735328473 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + f[12] + 2368359562 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (c ^ e ^ g) + f[5] + 4294588738 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + f[8] + 2272392833 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + f[11] + 1839030562 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + f[14] + 4259657740 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + f[1] + 2763975236 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + f[4] + 1272893353 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + f[7] + 4139469664 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + f[10] + 3200236656 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + f[13] + 681279174 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + f[0] + 3936430074 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + f[3] + 3572445317 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + f[6] + 76029189 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + f[9] + 3654602809 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + f[12] + 3873151461 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + f[15] + 530742520 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + f[2] + 3299628645 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (e ^ (c | ~g)) + f[0] + 4096336452 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + f[7] + 1126891415 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + f[14] + 2878612391 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + f[5] + 4237533241 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + f[12] + 1700485571 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + f[3] + 2399980690 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + f[10] + 4293915773 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + f[1] + 2240044497 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + f[8] + 1873313359 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + f[15] + 4264355552 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + f[6] + 2734768916 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + f[13] + 1309151649 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + f[4] + 4149444226 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + f[11] + 3174756917 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + f[2] + 718787259 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + f[9] + 3951481745 & 4294967295;
        d.g[0] = d.g[0] + a & 4294967295;
        d.g[1] = d.g[1] + (e + (b << 21 & 4294967295 | b >>> 11)) & 4294967295;
        d.g[2] = d.g[2] + e & 4294967295;
        d.g[3] = d.g[3] + g & 4294967295;
    }
    m.prototype.v = function(d, a) {
        a === void 0 && (a = d.length);
        var c = a - this.blockSize, f = this.C;
        var e = this.h, g = 0;
        for(; g < a;){
            if (e == 0) for(; g <= c;)n(this, d, g), g += this.blockSize;
            if (typeof d === "string") {
                for(; g < a;)if (f[e++] = d.charCodeAt(g++), e == this.blockSize) {
                    n(this, f);
                    e = 0;
                    break;
                }
            } else for(; g < a;)if (f[e++] = d[g++], e == this.blockSize) {
                n(this, f);
                e = 0;
                break;
            }
        }
        this.h = e;
        this.o += a;
    };
    m.prototype.A = function() {
        var d = Array((this.h < 56 ? this.blockSize : this.blockSize * 2) - this.h);
        d[0] = 128;
        for(var a = 1; a < d.length - 8; ++a)d[a] = 0;
        a = this.o * 8;
        for(var c = d.length - 8; c < d.length; ++c)d[c] = a & 255, a /= 256;
        this.v(d);
        d = Array(16);
        a = 0;
        for(c = 0; c < 4; ++c)for(var f = 0; f < 32; f += 8)d[a++] = this.g[c] >>> f & 255;
        return d;
    };
    function p(d, a) {
        var c = q;
        return Object.prototype.hasOwnProperty.call(c, d) ? c[d] : c[d] = a(d);
    }
    function t(d, a) {
        this.h = a;
        var c = [];
        var f = true;
        for(var e = d.length - 1; e >= 0; e--){
            var g = d[e] | 0;
            f && g == a || (c[e] = g, f = false);
        }
        this.g = c;
    }
    var q = {};
    function u(d) {
        return -128 <= d && d < 128 ? p(d, function(a) {
            return new t([
                a | 0
            ], a < 0 ? -1 : 0);
        }) : new t([
            d | 0
        ], d < 0 ? -1 : 0);
    }
    function v(d) {
        if (isNaN(d) || !isFinite(d)) return w;
        if (d < 0) return x(v(-d));
        var a = [];
        var c = 1;
        for(var f = 0; d >= c; f++)a[f] = d / c | 0, c *= 4294967296;
        return new t(a, 0);
    }
    function y(d, a) {
        if (d.length == 0) throw Error("number format error: empty string");
        a = a || 10;
        if (a < 2 || 36 < a) throw Error("radix out of range: " + a);
        if (d.charAt(0) == "-") return x(y(d.substring(1), a));
        if (d.indexOf("-") >= 0) throw Error('number format error: interior "-" character');
        var c = v(Math.pow(a, 8));
        var f = w;
        for(var g = 0; g < d.length; g += 8){
            var e = Math.min(8, d.length - g);
            var b = parseInt(d.substring(g, g + e), a);
            e < 8 ? (e = v(Math.pow(a, e)), f = f.j(e).add(v(b))) : (f = f.j(c), f = f.add(v(b)));
        }
        return f;
    }
    var w = u(0), z = u(1), A = u(16777216);
    h = t.prototype;
    h.m = function() {
        if (B(this)) return -x(this).m();
        var d = 0, a = 1;
        for(var c = 0; c < this.g.length; c++){
            var f = this.i(c);
            d += (f >= 0 ? f : 4294967296 + f) * a;
            a *= 4294967296;
        }
        return d;
    };
    h.toString = function(d) {
        d = d || 10;
        if (d < 2 || 36 < d) throw Error("radix out of range: " + d);
        if (C(this)) return "0";
        if (B(this)) return "-" + x(this).toString(d);
        var a = v(Math.pow(d, 6));
        var c = this;
        var f = "";
        for(;;){
            var e = D(c, a).g;
            c = F(c, e.j(a));
            var g = ((c.g.length > 0 ? c.g[0] : c.h) >>> 0).toString(d);
            c = e;
            if (C(c)) return g + f;
            for(; g.length < 6;)g = "0" + g;
            f = g + f;
        }
    };
    h.i = function(d) {
        return d < 0 ? 0 : d < this.g.length ? this.g[d] : this.h;
    };
    function C(d) {
        if (d.h != 0) return false;
        for(var a = 0; a < d.g.length; a++)if (d.g[a] != 0) return false;
        return true;
    }
    function B(d) {
        return d.h == -1;
    }
    h.l = function(d) {
        d = F(this, d);
        return B(d) ? -1 : C(d) ? 0 : 1;
    };
    function x(d) {
        var a = d.g.length, c = [];
        for(var f = 0; f < a; f++)c[f] = ~d.g[f];
        return new t(c, ~d.h).add(z);
    }
    h.abs = function() {
        return B(this) ? x(this) : this;
    };
    h.add = function(d) {
        var a = Math.max(this.g.length, d.g.length), c = [];
        var f = 0;
        for(var e = 0; e <= a; e++){
            var g = f + (this.i(e) & 65535) + (d.i(e) & 65535), b = (g >>> 16) + (this.i(e) >>> 16) + (d.i(e) >>> 16);
            f = b >>> 16;
            g &= 65535;
            b &= 65535;
            c[e] = b << 16 | g;
        }
        return new t(c, c[c.length - 1] & -2147483648 ? -1 : 0);
    };
    function F(d, a) {
        return d.add(x(a));
    }
    h.j = function(d) {
        if (C(this) || C(d)) return w;
        if (B(this)) return B(d) ? x(this).j(x(d)) : x(x(this).j(d));
        if (B(d)) return x(this.j(x(d)));
        if (this.l(A) < 0 && d.l(A) < 0) return v(this.m() * d.m());
        var a = this.g.length + d.g.length, c = [];
        for(var f = 0; f < 2 * a; f++)c[f] = 0;
        for(f = 0; f < this.g.length; f++)for(var e = 0; e < d.g.length; e++){
            var g = this.i(f) >>> 16, b = this.i(f) & 65535, r = d.i(e) >>> 16, E = d.i(e) & 65535;
            c[2 * f + 2 * e] += b * E;
            G(c, 2 * f + 2 * e);
            c[2 * f + 2 * e + 1] += g * E;
            G(c, 2 * f + 2 * e + 1);
            c[2 * f + 2 * e + 1] += b * r;
            G(c, 2 * f + 2 * e + 1);
            c[2 * f + 2 * e + 2] += g * r;
            G(c, 2 * f + 2 * e + 2);
        }
        for(d = 0; d < a; d++)c[d] = c[2 * d + 1] << 16 | c[2 * d];
        for(d = a; d < 2 * a; d++)c[d] = 0;
        return new t(c, 0);
    };
    function G(d, a) {
        for(; (d[a] & 65535) != d[a];)d[a + 1] += d[a] >>> 16, d[a] &= 65535, a++;
    }
    function H(d, a) {
        this.g = d;
        this.h = a;
    }
    function D(d, a) {
        if (C(a)) throw Error("division by zero");
        if (C(d)) return new H(w, w);
        if (B(d)) return a = D(x(d), a), new H(x(a.g), x(a.h));
        if (B(a)) return a = D(d, x(a)), new H(x(a.g), a.h);
        if (d.g.length > 30) {
            if (B(d) || B(a)) throw Error("slowDivide_ only works with positive integers.");
            for(var c = z, f = a; f.l(d) <= 0;)c = I(c), f = I(f);
            var e = J(c, 1), g = J(f, 1);
            f = J(f, 2);
            for(c = J(c, 2); !C(f);){
                var b = g.add(f);
                b.l(d) <= 0 && (e = e.add(c), g = b);
                f = J(f, 1);
                c = J(c, 1);
            }
            a = F(d, e.j(a));
            return new H(e, a);
        }
        for(e = w; d.l(a) >= 0;){
            c = Math.max(1, Math.floor(d.m() / a.m()));
            f = Math.ceil(Math.log(c) / Math.LN2);
            f = f <= 48 ? 1 : Math.pow(2, f - 48);
            g = v(c);
            for(b = g.j(a); B(b) || b.l(d) > 0;)c -= f, g = v(c), b = g.j(a);
            C(g) && (g = z);
            e = e.add(g);
            d = F(d, b);
        }
        return new H(e, d);
    }
    h.B = function(d) {
        return D(this, d).h;
    };
    h.and = function(d) {
        var a = Math.max(this.g.length, d.g.length), c = [];
        for(var f = 0; f < a; f++)c[f] = this.i(f) & d.i(f);
        return new t(c, this.h & d.h);
    };
    h.or = function(d) {
        var a = Math.max(this.g.length, d.g.length), c = [];
        for(var f = 0; f < a; f++)c[f] = this.i(f) | d.i(f);
        return new t(c, this.h | d.h);
    };
    h.xor = function(d) {
        var a = Math.max(this.g.length, d.g.length), c = [];
        for(var f = 0; f < a; f++)c[f] = this.i(f) ^ d.i(f);
        return new t(c, this.h ^ d.h);
    };
    function I(d) {
        var a = d.g.length + 1, c = [];
        for(var f = 0; f < a; f++)c[f] = d.i(f) << 1 | d.i(f - 1) >>> 31;
        return new t(c, d.h);
    }
    function J(d, a) {
        var c = a >> 5;
        a %= 32;
        var f = d.g.length - c, e = [];
        for(var g = 0; g < f; g++)e[g] = a > 0 ? d.i(g + c) >>> a | d.i(g + c + 1) << 32 - a : d.i(g + c);
        return new t(e, d.h);
    }
    m.prototype.digest = m.prototype.A;
    m.prototype.reset = m.prototype.u;
    m.prototype.update = m.prototype.v;
    $784117ec5b8d3931$export$9f5a3dfc7a9f5dd = $784117ec5b8d3931$export$2e2bcd8739ae039.Md5 = m;
    t.prototype.add = t.prototype.add;
    t.prototype.multiply = t.prototype.j;
    t.prototype.modulo = t.prototype.B;
    t.prototype.compare = t.prototype.l;
    t.prototype.toNumber = t.prototype.m;
    t.prototype.toString = t.prototype.toString;
    t.prototype.getBits = t.prototype.i;
    t.fromNumber = v;
    t.fromString = y;
    $784117ec5b8d3931$export$70ffa26850098d01 = $784117ec5b8d3931$export$2e2bcd8739ae039.Integer = t;
}).apply(typeof $784117ec5b8d3931$var$commonjsGlobal !== 'undefined' ? $784117ec5b8d3931$var$commonjsGlobal : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});

});

parcelRegister("2rSfQ", function(module, exports) {

$parcel$export(module.exports, "XhrIo", function () { return $1c8830389a9e4a77$export$26404658cda3ee02; });
$parcel$export(module.exports, "WebChannel", function () { return $1c8830389a9e4a77$export$aa726fb96ad3e039; });
$parcel$export(module.exports, "EventType", function () { return $1c8830389a9e4a77$export$3d7865934588d77e; });
$parcel$export(module.exports, "ErrorCode", function () { return $1c8830389a9e4a77$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "Stat", function () { return $1c8830389a9e4a77$export$cbbc350c1dfc80cb; });
$parcel$export(module.exports, "Event", function () { return $1c8830389a9e4a77$export$d61e24a684f9e51; });
$parcel$export(module.exports, "getStatEventTarget", function () { return $1c8830389a9e4a77$export$888d0d9ab79d08fc; });
$parcel$export(module.exports, "createWebChannelTransport", function () { return $1c8830389a9e4a77$export$66869136fc133c3a; });

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $hC9N3 = parcelRequire("hC9N3");

var $9atk1 = parcelRequire("9atk1");

var $c2MhV = parcelRequire("c2MhV");

var $6ZpBv = parcelRequire("6ZpBv");

var $5djcY = parcelRequire("5djcY");
var $1c8830389a9e4a77$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
var $1c8830389a9e4a77$export$2e2bcd8739ae039 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var $1c8830389a9e4a77$export$26404658cda3ee02;
var $1c8830389a9e4a77$export$ddb1030448106742;
var $1c8830389a9e4a77$export$aa726fb96ad3e039;
var $1c8830389a9e4a77$export$3d7865934588d77e;
var $1c8830389a9e4a77$export$d4e71bc0b80dc0fb;
var $1c8830389a9e4a77$export$cbbc350c1dfc80cb;
var $1c8830389a9e4a77$export$d61e24a684f9e51;
var $1c8830389a9e4a77$export$888d0d9ab79d08fc;
var $1c8830389a9e4a77$export$66869136fc133c3a;
(function() {
    var h, aa = Object.defineProperty;
    function ba(a) {
        a = [
            "object" == (typeof globalThis === "undefined" ? "undefined" : (0, $5djcY._)(globalThis)) && globalThis,
            a,
            "object" == (typeof window === "undefined" ? "undefined" : (0, $5djcY._)(window)) && window,
            "object" == (typeof self === "undefined" ? "undefined" : (0, $5djcY._)(self)) && self,
            "object" == (typeof $1c8830389a9e4a77$var$commonjsGlobal === "undefined" ? "undefined" : (0, $5djcY._)($1c8830389a9e4a77$var$commonjsGlobal)) && $1c8830389a9e4a77$var$commonjsGlobal
        ];
        for(var b = 0; b < a.length; ++b){
            var c = a[b];
            if (c && c.Math == Math) return c;
        }
        throw Error("Cannot find global object");
    }
    var ca = ba(this);
    function da(a, b) {
        if (b) a: {
            var c = ca;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                if (!(e in c)) break a;
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && b != null && aa(c, a, {
                configurable: true,
                writable: true,
                value: b
            });
        }
    }
    da("Symbol.dispose", function(a) {
        return a ? a : Symbol("Symbol.dispose");
    });
    da("Array.prototype.values", function(a) {
        return a ? a : function() {
            return this[Symbol.iterator]();
        };
    });
    da("Object.entries", function(a) {
        return a ? a : function(b) {
            var c = [], d;
            for(d in b)Object.prototype.hasOwnProperty.call(b, d) && c.push([
                d,
                b[d]
            ]);
            return c;
        };
    }); /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    var ea = ea || {}, l = this || self;
    function n(a) {
        var b = typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a);
        return b == "object" && a != null || b == "function";
    }
    function fa(a, b, c) {
        return a.call.apply(a.bind, arguments);
    }
    function p(a, b, c) {
        p = fa;
        return p.apply(null, arguments);
    }
    function ha(a, b) {
        var c = Array.prototype.slice.call(arguments, 1);
        return function() {
            var d = c.slice();
            d.push.apply(d, arguments);
            return a.apply(this, d);
        };
    }
    function t(a, b) {
        function c() {}
        c.prototype = b.prototype;
        a.Z = b.prototype;
        a.prototype = new c;
        a.prototype.constructor = a;
        a.Ob = function(d, e, f) {
            for(var g = Array(arguments.length - 2), k = 2; k < arguments.length; k++)g[k - 2] = arguments[k];
            return b.prototype[e].apply(d, g);
        };
    }
    var ia = typeof AsyncContext !== "undefined" && typeof AsyncContext.Snapshot === "function" ? function(a) {
        return a && AsyncContext.Snapshot.wrap(a);
    } : function(a) {
        return a;
    };
    function ja(a) {
        var b = a.length;
        if (b > 0) {
            var c = Array(b);
            for(var d = 0; d < b; d++)c[d] = a[d];
            return c;
        }
        return [];
    }
    function ka(a, b) {
        for(var d = 1; d < arguments.length; d++){
            var e = arguments[d];
            var c = typeof e === "undefined" ? "undefined" : (0, $5djcY._)(e);
            c = c != "object" ? c : e ? Array.isArray(e) ? "array" : c : "null";
            if (c == "array" || c == "object" && typeof e.length == "number") {
                c = a.length || 0;
                var f = e.length || 0;
                a.length = c + f;
                for(var g = 0; g < f; g++)a[c + g] = e[g];
            } else a.push(e);
        }
    }
    var la = /*#__PURE__*/ function() {
        "use strict";
        function la(a, b) {
            (0, $4QweW._)(this, la);
            this.i = a;
            this.j = b;
            this.h = 0;
            this.g = null;
        }
        (0, $6hK4i._)(la, [
            {
                key: "get",
                value: function get() {
                    var a;
                    this.h > 0 ? (this.h--, a = this.g, this.g = a.next, a.next = null) : a = this.i();
                    return a;
                }
            }
        ]);
        return la;
    }();
    function ma(a) {
        l.setTimeout(function() {
            throw a;
        }, 0);
    }
    function na() {
        var a = oa;
        var b = null;
        a.g && (b = a.g, a.g = a.g.next, a.g || (a.h = null), b.next = null);
        return b;
    }
    var pa = /*#__PURE__*/ function() {
        "use strict";
        function pa() {
            (0, $4QweW._)(this, pa);
            this.h = this.g = null;
        }
        (0, $6hK4i._)(pa, [
            {
                key: "add",
                value: function add(a, b) {
                    var c = qa.get();
                    c.set(a, b);
                    this.h ? this.h.next = c : this.g = c;
                    this.h = c;
                }
            }
        ]);
        return pa;
    }();
    var qa = new la(function() {
        return new ra;
    }, function(a) {
        return a.reset();
    });
    var ra = /*#__PURE__*/ function() {
        "use strict";
        function ra() {
            (0, $4QweW._)(this, ra);
            this.next = this.g = this.h = null;
        }
        (0, $6hK4i._)(ra, [
            {
                key: "set",
                value: function set(a, b) {
                    this.h = a;
                    this.g = b;
                    this.next = null;
                }
            },
            {
                key: "reset",
                value: function reset() {
                    this.next = this.g = this.h = null;
                }
            }
        ]);
        return ra;
    }();
    var u, v = false, oa = new pa, ta = function() {
        var a = Promise.resolve(void 0);
        u = function() {
            a.then(sa);
        };
    };
    function sa() {
        for(var a; a = na();){
            try {
                a.h.call(a.g);
            } catch (c) {
                ma(c);
            }
            var b = qa;
            b.j(a);
            b.h < 100 && (b.h++, a.next = b.g, b.g = a);
        }
        v = false;
    }
    function w() {
        this.u = this.u;
        this.C = this.C;
    }
    w.prototype.u = false;
    w.prototype.dispose = function() {
        this.u || (this.u = true, this.N());
    };
    w.prototype[Symbol.dispose] = function() {
        this.dispose();
    };
    w.prototype.N = function() {
        if (this.C) for(; this.C.length;)this.C.shift()();
    };
    function x(a, b) {
        this.type = a;
        this.g = this.target = b;
        this.defaultPrevented = false;
    }
    x.prototype.h = function() {
        this.defaultPrevented = true;
    };
    var ua = function() {
        if (!l.addEventListener || !Object.defineProperty) return false;
        var a = false, b = Object.defineProperty({}, "passive", {
            get: function get() {
                a = true;
            }
        });
        try {
            var c = function() {};
            l.addEventListener("test", c, b);
            l.removeEventListener("test", c, b);
        } catch (c) {}
        return a;
    }();
    function y(a) {
        return /^[\s\xa0]*$/.test(a);
    }
    function z(a, b) {
        x.call(this, a ? a.type : "");
        this.relatedTarget = this.g = this.target = null;
        this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
        this.key = "";
        this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = false;
        this.state = null;
        this.pointerId = 0;
        this.pointerType = "";
        this.i = null;
        a && this.init(a, b);
    }
    t(z, x);
    z.prototype.init = function(a, b) {
        var c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
        this.target = a.target || a.srcElement;
        this.g = b;
        b = a.relatedTarget;
        b || (c == "mouseover" ? b = a.fromElement : c == "mouseout" && (b = a.toElement));
        this.relatedTarget = b;
        d ? (this.clientX = d.clientX !== void 0 ? d.clientX : d.pageX, this.clientY = d.clientY !== void 0 ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = a.clientX !== void 0 ? a.clientX : a.pageX, this.clientY = a.clientY !== void 0 ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
        this.button = a.button;
        this.key = a.key || "";
        this.ctrlKey = a.ctrlKey;
        this.altKey = a.altKey;
        this.shiftKey = a.shiftKey;
        this.metaKey = a.metaKey;
        this.pointerId = a.pointerId || 0;
        this.pointerType = a.pointerType;
        this.state = a.state;
        this.i = a;
        a.defaultPrevented && z.Z.h.call(this);
    };
    z.prototype.h = function() {
        z.Z.h.call(this);
        var a = this.i;
        a.preventDefault ? a.preventDefault() : a.returnValue = false;
    };
    var B = "closure_listenable_" + (Math.random() * 1E6 | 0);
    var va = 0;
    function wa(a, b, c, d, e) {
        this.listener = a;
        this.proxy = null;
        this.src = b;
        this.type = c;
        this.capture = !!d;
        this.ha = e;
        this.key = ++va;
        this.da = this.fa = false;
    }
    function xa(a) {
        a.da = true;
        a.listener = null;
        a.proxy = null;
        a.src = null;
        a.ha = null;
    }
    function ya(a, b, c) {
        for(var d in a)b.call(c, a[d], d, a);
    }
    function Aa(a, b) {
        for(var c in a)b.call(void 0, a[c], c, a);
    }
    function Ba(a) {
        var b = {};
        for(var c in a)b[c] = a[c];
        return b;
    }
    var Ca = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
    function Da(a, b) {
        var c, d;
        for(var e = 1; e < arguments.length; e++){
            d = arguments[e];
            for(c in d)a[c] = d[c];
            for(var f = 0; f < Ca.length; f++)c = Ca[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
        }
    }
    function Ea(a) {
        this.src = a;
        this.g = {};
        this.h = 0;
    }
    Ea.prototype.add = function(a, b, c, d, e) {
        var f = a.toString();
        a = this.g[f];
        a || (a = this.g[f] = [], this.h++);
        var g = Fa(a, b, d, e);
        g > -1 ? (b = a[g], c || (b.fa = false)) : (b = new wa(b, this.src, f, !!d, e), b.fa = c, a.push(b));
        return b;
    };
    function Ga(a, b) {
        var c = b.type;
        if (c in a.g) {
            var d = a.g[c], e = Array.prototype.indexOf.call(d, b, void 0), f;
            (f = e >= 0) && Array.prototype.splice.call(d, e, 1);
            f && (xa(b), a.g[c].length == 0 && (delete a.g[c], a.h--));
        }
    }
    function Fa(a, b, c, d) {
        for(var e = 0; e < a.length; ++e){
            var f = a[e];
            if (!f.da && f.listener == b && f.capture == !!c && f.ha == d) return e;
        }
        return -1;
    }
    var Ha = "closure_lm_" + (Math.random() * 1E6 | 0), Ia = {};
    function Ka(a, b, c, d, e) {
        if (Array.isArray(b)) {
            for(var f = 0; f < b.length; f++)Ka(a, b[f], c, d, e);
            return null;
        }
        c = Ma(c);
        return a && a[B] ? a.J(b, c, n(d) ? !!d.capture : false, e) : Na(a, b, c, false, d, e);
    }
    function Na(a, b, c, d, e, f) {
        if (!b) throw Error("Invalid event type");
        var g = n(e) ? !!e.capture : !!e;
        var k = Oa(a);
        k || (a[Ha] = k = new Ea(a));
        c = k.add(b, c, d, g, f);
        if (c.proxy) return c;
        d = Pa();
        c.proxy = d;
        d.src = a;
        d.listener = c;
        if (a.addEventListener) ua || (e = g), e === void 0 && (e = false), a.addEventListener(b.toString(), d, e);
        else if (a.attachEvent) a.attachEvent(Qa(b.toString()), d);
        else if (a.addListener && a.removeListener) a.addListener(d);
        else throw Error("addEventListener and attachEvent are unavailable.");
        return c;
    }
    function Pa() {
        function a(c) {
            return b.call(a.src, a.listener, c);
        }
        var b = Ra;
        return a;
    }
    function Sa(a, b, c, d, e) {
        if (Array.isArray(b)) for(var f = 0; f < b.length; f++)Sa(a, b[f], c, d, e);
        else (d = n(d) ? !!d.capture : !!d, c = Ma(c), a && a[B]) ? (a = a.i, f = String(b).toString(), f in a.g && (b = a.g[f], c = Fa(b, c, d, e), c > -1 && (xa(b[c]), Array.prototype.splice.call(b, c, 1), b.length == 0 && (delete a.g[f], a.h--)))) : a && (a = Oa(a)) && (b = a.g[b.toString()], a = -1, b && (a = Fa(b, c, d, e)), (c = a > -1 ? b[a] : null) && Ta(c));
    }
    function Ta(a) {
        if (typeof a !== "number" && a && !a.da) {
            var b = a.src;
            if (b && b[B]) Ga(b.i, a);
            else {
                var c = a.type, d = a.proxy;
                b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(Qa(c), d) : b.addListener && b.removeListener && b.removeListener(d);
                (c = Oa(b)) ? (Ga(c, a), c.h == 0 && (c.src = null, b[Ha] = null)) : xa(a);
            }
        }
    }
    function Qa(a) {
        return a in Ia ? Ia[a] : Ia[a] = "on" + a;
    }
    function Ra(a, b) {
        if (a.da) a = true;
        else {
            b = new z(b, this);
            var c = a.listener, d = a.ha || a.src;
            a.fa && Ta(a);
            a = c.call(d, b);
        }
        return a;
    }
    function Oa(a) {
        a = a[Ha];
        return a instanceof Ea ? a : null;
    }
    var Ua = "__closure_events_fn_" + (Math.random() * 1E9 >>> 0);
    function Ma(a) {
        if (typeof a === "function") return a;
        a[Ua] || (a[Ua] = function(b) {
            return a.handleEvent(b);
        });
        return a[Ua];
    }
    function C() {
        w.call(this);
        this.i = new Ea(this);
        this.M = this;
        this.G = null;
    }
    t(C, w);
    C.prototype[B] = true;
    C.prototype.removeEventListener = function(a, b, c, d) {
        Sa(this, a, b, c, d);
    };
    function D(a, b) {
        var c, d = a.G;
        if (d) for(c = []; d; d = d.G)c.push(d);
        a = a.M;
        d = b.type || b;
        if (typeof b === "string") b = new x(b, a);
        else if (b instanceof x) b.target = b.target || a;
        else {
            var e = b;
            b = new x(d, a);
            Da(b, e);
        }
        e = true;
        var f, g;
        if (c) for(g = c.length - 1; g >= 0; g--)f = b.g = c[g], e = Va(f, d, true, b) && e;
        f = b.g = a;
        e = Va(f, d, true, b) && e;
        e = Va(f, d, false, b) && e;
        if (c) for(g = 0; g < c.length; g++)f = b.g = c[g], e = Va(f, d, false, b) && e;
    }
    C.prototype.N = function() {
        C.Z.N.call(this);
        if (this.i) {
            var a = this.i;
            for(var c in a.g){
                var d = a.g[c];
                for(var e = 0; e < d.length; e++)xa(d[e]);
                delete a.g[c];
                a.h--;
            }
        }
        this.G = null;
    };
    C.prototype.J = function(a, b, c, d) {
        return this.i.add(String(a), b, false, c, d);
    };
    C.prototype.K = function(a, b, c, d) {
        return this.i.add(String(a), b, true, c, d);
    };
    function Va(a, b, c, d) {
        b = a.i.g[String(b)];
        if (!b) return true;
        b = b.concat();
        var e = true;
        for(var f = 0; f < b.length; ++f){
            var g = b[f];
            if (g && !g.da && g.capture == c) {
                var k = g.listener, q = g.ha || g.src;
                g.fa && Ga(a.i, g);
                e = k.call(q, d) !== false && e;
            }
        }
        return e && !d.defaultPrevented;
    }
    function Wa(a, b) {
        if (typeof a !== "function") {
            if (a && typeof a.handleEvent == "function") a = p(a.handleEvent, a);
            else throw Error("Invalid listener argument");
        }
        return Number(b) > 2147483647 ? -1 : l.setTimeout(a, b || 0);
    }
    function Xa(a) {
        a.g = Wa(function() {
            a.g = null;
            a.i && (a.i = false, Xa(a));
        }, a.l);
        var b = a.h;
        a.h = null;
        a.m.apply(null, b);
    }
    var Ya = /*#__PURE__*/ function(w) {
        "use strict";
        (0, $c2MhV._)(Ya, w);
        function Ya(a, b) {
            (0, $4QweW._)(this, Ya);
            var _this;
            _this = (0, $ehF45._)(this, Ya);
            _this.m = a;
            _this.l = b;
            _this.h = null;
            _this.i = false;
            _this.g = null;
            return _this;
        }
        (0, $6hK4i._)(Ya, [
            {
                key: "j",
                value: function j(a) {
                    this.h = arguments;
                    this.g ? this.i = true : Xa(this);
                }
            },
            {
                key: "N",
                value: function N() {
                    (0, $hC9N3._)((0, $9atk1._)(Ya.prototype), "N", this).call(this);
                    this.g && (l.clearTimeout(this.g), this.g = null, this.i = false, this.h = null);
                }
            }
        ]);
        return Ya;
    }(w);
    function E(a) {
        w.call(this);
        this.h = a;
        this.g = {};
    }
    t(E, w);
    var Za = [];
    function $a(a) {
        ya(a.g, function(b, c) {
            this.g.hasOwnProperty(c) && Ta(b);
        }, a);
        a.g = {};
    }
    E.prototype.N = function() {
        E.Z.N.call(this);
        $a(this);
    };
    E.prototype.handleEvent = function() {
        throw Error("EventHandler.handleEvent not implemented");
    };
    var ab = l.JSON.stringify;
    var cb = l.JSON.parse;
    var db = /*#__PURE__*/ function() {
        "use strict";
        function db() {
            (0, $4QweW._)(this, db);
        }
        (0, $6hK4i._)(db, [
            {
                key: "stringify",
                value: function stringify(a) {
                    return l.JSON.stringify(a, void 0);
                }
            },
            {
                key: "parse",
                value: function parse(a) {
                    return l.JSON.parse(a, void 0);
                }
            }
        ]);
        return db;
    }();
    function eb() {}
    function fb() {}
    var H = {
        OPEN: "a",
        hb: "b",
        ERROR: "c",
        tb: "d"
    };
    function gb() {
        x.call(this, "d");
    }
    t(gb, x);
    function hb() {
        x.call(this, "c");
    }
    t(hb, x);
    var I = {}, ib = null;
    function jb() {
        return ib = ib || new C;
    }
    I.Ia = "serverreachability";
    function kb(a) {
        x.call(this, I.Ia, a);
    }
    t(kb, x);
    function lb(a) {
        var b = jb();
        D(b, new kb(b));
    }
    I.STAT_EVENT = "statevent";
    function mb(a, b) {
        x.call(this, I.STAT_EVENT, a);
        this.stat = b;
    }
    t(mb, x);
    function J(a) {
        var b = jb();
        D(b, new mb(b, a));
    }
    I.Ja = "timingevent";
    function nb(a, b) {
        x.call(this, I.Ja, a);
        this.size = b;
    }
    t(nb, x);
    function ob(a, b) {
        if (typeof a !== "function") throw Error("Fn must not be null and must be a function");
        return l.setTimeout(function() {
            a();
        }, b);
    }
    function pb() {
        this.g = true;
    }
    pb.prototype.ua = function() {
        this.g = false;
    };
    function qb(a, b, c, d, e, f) {
        a.info(function() {
            if (a.g) {
                if (f) {
                    var g = "";
                    var k = f.split("&");
                    for(var m = 0; m < k.length; m++){
                        var q = k[m].split("=");
                        if (q.length > 1) {
                            var r = q[0];
                            q = q[1];
                            var A = r.split("_");
                            g = A.length >= 2 && A[1] == "type" ? g + (r + "=" + q + "&") : g + (r + "=redacted&");
                        }
                    }
                } else g = null;
            } else g = f;
            return "XMLHTTP REQ (" + d + ") [attempt " + e + "]: " + b + "\n" + c + "\n" + g;
        });
    }
    function rb(a, b, c, d, e, f, g) {
        a.info(function() {
            return "XMLHTTP RESP (" + d + ") [ attempt " + e + "]: " + b + "\n" + c + "\n" + f + " " + g;
        });
    }
    function K(a, b, c, d) {
        a.info(function() {
            return "XMLHTTP TEXT (" + b + "): " + sb(a, c) + (d ? " " + d : "");
        });
    }
    function tb(a, b) {
        a.info(function() {
            return "TIMEOUT: " + b;
        });
    }
    pb.prototype.info = function() {};
    function sb(a, b) {
        if (!a.g) return b;
        if (!b) return null;
        try {
            var f = JSON.parse(b);
            if (f) {
                for(a = 0; a < f.length; a++)if (Array.isArray(f[a])) {
                    var c = f[a];
                    if (!(c.length < 2)) {
                        var d = c[1];
                        if (Array.isArray(d) && !(d.length < 1)) {
                            var e = d[0];
                            if (e != "noop" && e != "stop" && e != "close") for(var g = 1; g < d.length; g++)d[g] = "";
                        }
                    }
                }
            }
            return ab(f);
        } catch (f) {
            return b;
        }
    }
    var ub = {
        NO_ERROR: 0,
        cb: 1,
        qb: 2,
        pb: 3,
        kb: 4,
        ob: 5,
        rb: 6,
        Ga: 7,
        TIMEOUT: 8,
        ub: 9
    };
    var vb = {
        ib: "complete",
        Fb: "success",
        ERROR: "error",
        Ga: "abort",
        xb: "ready",
        yb: "readystatechange",
        TIMEOUT: "timeout",
        sb: "incrementaldata",
        wb: "progress",
        lb: "downloadprogress",
        Nb: "uploadprogress"
    };
    var wb;
    function xb() {}
    t(xb, eb);
    xb.prototype.g = function() {
        return new XMLHttpRequest;
    };
    wb = new xb;
    function L(a) {
        return encodeURIComponent(String(a));
    }
    function yb(a) {
        var b = 1;
        a = a.split(":");
        var c = [];
        for(; b > 0 && a.length;)c.push(a.shift()), b--;
        a.length && c.push(a.join(":"));
        return c;
    }
    function N(a, b, c, d) {
        this.j = a;
        this.i = b;
        this.l = c;
        this.S = d || 1;
        this.V = new E(this);
        this.H = 45E3;
        this.J = null;
        this.o = false;
        this.u = this.B = this.A = this.M = this.F = this.T = this.D = null;
        this.G = [];
        this.g = null;
        this.C = 0;
        this.m = this.v = null;
        this.X = -1;
        this.K = false;
        this.P = 0;
        this.O = null;
        this.W = this.L = this.U = this.R = false;
        this.h = new zb;
    }
    function zb() {
        this.i = null;
        this.g = "";
        this.h = false;
    }
    var Ab = {}, Bb = {};
    function Cb(a, b, c) {
        a.M = 1;
        a.A = Db(O(b));
        a.u = c;
        a.R = true;
        Eb(a, null);
    }
    function Eb(a, b) {
        a.F = Date.now();
        Fb(a);
        a.B = O(a.A);
        var c = a.B, d = a.S;
        Array.isArray(d) || (d = [
            String(d)
        ]);
        Gb(c.i, "t", d);
        a.C = 0;
        c = a.j.L;
        a.h = new zb;
        a.g = Hb(a.j, c ? b : null, !a.u);
        a.P > 0 && (a.O = new Ya(p(a.Y, a, a.g), a.P));
        b = a.V;
        c = a.g;
        d = a.ba;
        var e = "readystatechange";
        Array.isArray(e) || (e && (Za[0] = e.toString()), e = Za);
        for(var f = 0; f < e.length; f++){
            var g = Ka(c, e[f], d || b.handleEvent, false, b.h || b);
            if (!g) break;
            b.g[g.key] = g;
        }
        b = a.J ? Ba(a.J) : {};
        a.u ? (a.v || (a.v = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.g.ea(a.B, a.v, a.u, b)) : (a.v = "GET", a.g.ea(a.B, a.v, null, b));
        lb();
        qb(a.i, a.v, a.B, a.l, a.S, a.u);
    }
    N.prototype.ba = function(a) {
        a = a.target;
        var b = this.O;
        b && P(a) == 3 ? b.j() : this.Y(a);
    };
    N.prototype.Y = function(a) {
        try {
            if (a == this.g) a: {
                var k = P(this.g), q = this.g.ya(), m = this.g.ca();
                if (!(k < 3) && (k != 3 || this.g && (this.h.h || this.g.la() || Ib(this.g)))) {
                    this.K || k != 4 || q == 7 || (q == 8 || m <= 0 ? lb(3) : lb(2));
                    Jb(this);
                    var b = this.g.ca();
                    this.X = b;
                    var c = Kb(this);
                    this.o = b == 200;
                    rb(this.i, this.v, this.B, this.l, this.S, k, b);
                    if (this.o) {
                        if (this.U && !this.L) {
                            b: {
                                if (this.g) {
                                    var d, e = this.g;
                                    if ((d = e.g ? e.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !y(d)) {
                                        var f = d;
                                        break b;
                                    }
                                }
                                f = null;
                            }
                            if (a = f) K(this.i, this.l, a, "Initial handshake response via X-HTTP-Initial-Response"), this.L = !0, Lb(this, a);
                            else {
                                this.o = !1;
                                this.m = 3;
                                J(12);
                                Q(this);
                                Mb(this);
                                break a;
                            }
                        }
                        if (this.R) {
                            a = !0;
                            var r;
                            for(; !this.K && this.C < c.length;)if (r = Nb(this, c), r == Bb) {
                                k == 4 && (this.m = 4, J(14), a = !1);
                                K(this.i, this.l, null, "[Incomplete Response]");
                                break;
                            } else if (r == Ab) {
                                this.m = 4;
                                J(15);
                                K(this.i, this.l, c, "[Invalid Chunk]");
                                a = !1;
                                break;
                            } else K(this.i, this.l, r, null), Lb(this, r);
                            Ob(this) && this.C != 0 && (this.h.g = this.h.g.slice(this.C), this.C = 0);
                            k != 4 || c.length != 0 || this.h.h || (this.m = 1, J(16), a = !1);
                            this.o = this.o && a;
                            if (!a) K(this.i, this.l, c, "[Invalid Chunked Response]"), Q(this), Mb(this);
                            else if (c.length > 0 && !this.W) {
                                this.W = !0;
                                var g = this.j;
                                g.g == this && g.aa && !g.P && (g.j.info("Great, no buffering proxy detected. Bytes received: " + c.length), Pb(g), g.P = !0, J(11));
                            }
                        } else K(this.i, this.l, c, null), Lb(this, c);
                        k == 4 && Q(this);
                        this.o && !this.K && (k == 4 ? Qb(this.j, this) : (this.o = !1, Fb(this)));
                    } else Rb(this.g), b == 400 && c.indexOf("Unknown SID") > 0 ? (this.m = 3, J(12)) : (this.m = 0, J(13)), Q(this), Mb(this);
                }
            }
        } catch (k) {} finally{}
    };
    function Kb(a) {
        if (!Ob(a)) return a.g.la();
        var b = Ib(a.g);
        if (b === "") return "";
        var c = "";
        var d = b.length, e = P(a.g) == 4;
        if (!a.h.i) {
            if (typeof TextDecoder === "undefined") return Q(a), Mb(a), "";
            a.h.i = new l.TextDecoder;
        }
        for(var f = 0; f < d; f++)a.h.h = true, c += a.h.i.decode(b[f], {
            stream: !(e && f == d - 1)
        });
        b.length = 0;
        a.h.g += c;
        a.C = 0;
        return a.h.g;
    }
    function Ob(a) {
        return a.g ? a.v == "GET" && a.M != 2 && a.j.Aa : false;
    }
    function Nb(a, b) {
        var c = a.C, d = b.indexOf("\n", c);
        if (d == -1) return Bb;
        c = Number(b.substring(c, d));
        if (isNaN(c)) return Ab;
        d += 1;
        if (d + c > b.length) return Bb;
        b = b.slice(d, d + c);
        a.C = d + c;
        return b;
    }
    N.prototype.cancel = function() {
        this.K = true;
        Q(this);
    };
    function Fb(a) {
        a.T = Date.now() + a.H;
        Sb(a, a.H);
    }
    function Sb(a, b) {
        if (a.D != null) throw Error("WatchDog timer not null");
        a.D = ob(p(a.aa, a), b);
    }
    function Jb(a) {
        a.D && (l.clearTimeout(a.D), a.D = null);
    }
    N.prototype.aa = function() {
        this.D = null;
        var a = Date.now();
        a - this.T >= 0 ? (tb(this.i, this.B), this.M != 2 && (lb(), J(17)), Q(this), this.m = 2, Mb(this)) : Sb(this, this.T - a);
    };
    function Mb(a) {
        a.j.I == 0 || a.K || Qb(a.j, a);
    }
    function Q(a) {
        Jb(a);
        var b = a.O;
        b && typeof b.dispose == "function" && b.dispose();
        a.O = null;
        $a(a.V);
        a.g && (b = a.g, a.g = null, b.abort(), b.dispose());
    }
    function Lb(a, b) {
        try {
            var c = a.j;
            if (c.I != 0 && (c.g == a || Tb(c.h, a))) {
                if (!a.L && Tb(c.h, a) && c.I == 3) {
                    try {
                        var d = c.Ba.g.parse(b);
                    } catch (m) {
                        d = null;
                    }
                    if (Array.isArray(d) && d.length == 3) {
                        var e = d;
                        if (e[0] == 0) {
                            a: if (!c.v) {
                                if (c.g) {
                                    if (c.g.F + 3E3 < a.F) Ub(c), Vb(c);
                                    else break a;
                                }
                                Wb(c);
                                J(18);
                            }
                        } else c.xa = e[1], 0 < c.xa - c.K && e[2] < 37500 && c.F && c.A == 0 && !c.C && (c.C = ob(p(c.Va, c), 6E3));
                        Xb(c.h) <= 1 && c.ta && (c.ta = void 0);
                    } else R(c, 11);
                } else if ((a.L || c.g == a) && Ub(c), !y(b)) for(e = c.Ba.g.parse(b), b = 0; b < e.length; b++){
                    var m = e[b];
                    var r = m[0];
                    if (!(r <= c.K)) {
                        if (c.K = r, m = m[1], c.I == 2) {
                            if (m[0] == "c") {
                                c.M = m[1];
                                c.ba = m[2];
                                var A = m[3];
                                A != null && (c.ka = A, c.j.info("VER=" + c.ka));
                                var M = m[4];
                                M != null && (c.za = M, c.j.info("SVER=" + c.za));
                                var F = m[5];
                                F != null && typeof F === "number" && F > 0 && (d = 1.5 * F, c.O = d, c.j.info("backChannelRequestTimeoutMs_=" + d));
                                d = c;
                                var G = a.g;
                                if (G) {
                                    var za = G.g ? G.g.getResponseHeader("X-Client-Wire-Protocol") : null;
                                    if (za) {
                                        var f = d.h;
                                        f.g || za.indexOf("spdy") == -1 && za.indexOf("quic") == -1 && za.indexOf("h2") == -1 || (f.j = f.l, f.g = new Set, f.h && (Yb(f, f.h), f.h = null));
                                    }
                                    if (d.G) {
                                        var bb = G.g ? G.g.getResponseHeader("X-HTTP-Session-Id") : null;
                                        bb && (d.wa = bb, S(d.J, d.G, bb));
                                    }
                                }
                                c.I = 3;
                                c.l && c.l.ra();
                                c.aa && (c.T = Date.now() - a.F, c.j.info("Handshake RTT: " + c.T + "ms"));
                                d = c;
                                var g = a;
                                d.na = Zb(d, d.L ? d.ba : null, d.W);
                                if (g.L) {
                                    $b(d.h, g);
                                    var k = g, q = d.O;
                                    q && (k.H = q);
                                    k.D && (Jb(k), Fb(k));
                                    d.g = g;
                                } else ac(d);
                                c.i.length > 0 && bc(c);
                            } else m[0] != "stop" && m[0] != "close" || R(c, 7);
                        } else c.I == 3 && (m[0] == "stop" || m[0] == "close" ? m[0] == "stop" ? R(c, 7) : cc(c) : m[0] != "noop" && c.l && c.l.qa(m), c.A = 0);
                    }
                }
            }
            lb(4);
        } catch (m) {}
    }
    var dc = function dc(a, b) {
        "use strict";
        (0, $4QweW._)(this, dc);
        this.g = a;
        this.map = b;
    };
    function ec(a) {
        this.l = a || 10;
        l.PerformanceNavigationTiming ? (a = l.performance.getEntriesByType("navigation"), a = a.length > 0 && (a[0].nextHopProtocol == "hq" || a[0].nextHopProtocol == "h2")) : a = !!(l.chrome && l.chrome.loadTimes && l.chrome.loadTimes() && l.chrome.loadTimes().wasFetchedViaSpdy);
        this.j = a ? this.l : 1;
        this.g = null;
        this.j > 1 && (this.g = new Set);
        this.h = null;
        this.i = [];
    }
    function fc(a) {
        return a.h ? true : a.g ? a.g.size >= a.j : false;
    }
    function Xb(a) {
        return a.h ? 1 : a.g ? a.g.size : 0;
    }
    function Tb(a, b) {
        return a.h ? a.h == b : a.g ? a.g.has(b) : false;
    }
    function Yb(a, b) {
        a.g ? a.g.add(b) : a.h = b;
    }
    function $b(a, b) {
        a.h && a.h == b ? a.h = null : a.g && a.g.has(b) && a.g.delete(b);
    }
    ec.prototype.cancel = function() {
        this.i = hc(this);
        if (this.h) this.h.cancel(), this.h = null;
        else if (this.g && this.g.size !== 0) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.g.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var a = _step.value;
                    a.cancel();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            this.g.clear();
        }
    };
    function hc(a) {
        if (a.h != null) return a.i.concat(a.h.G);
        if (a.g != null && a.g.size !== 0) {
            var b = a.i;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = a.g.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var c = _step.value;
                    b = b.concat(c.G);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return b;
        }
        return ja(a.i);
    }
    var ic = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$");
    function jc(a, b) {
        if (a) {
            a = a.split("&");
            for(var c = 0; c < a.length; c++){
                var d = a[c].indexOf("=");
                var e = void 0, f = null;
                d >= 0 ? (e = a[c].substring(0, d), f = a[c].substring(d + 1)) : e = a[c];
                b(e, f ? decodeURIComponent(f.replace(/\+/g, " ")) : "");
            }
        }
    }
    function T(a) {
        this.g = this.o = this.j = "";
        this.u = null;
        this.m = this.h = "";
        this.l = false;
        var b;
        a instanceof T ? (this.l = a.l, kc(this, a.j), this.o = a.o, this.g = a.g, lc(this, a.u), this.h = a.h, mc(this, nc(a.i)), this.m = a.m) : a && (b = String(a).match(ic)) ? (this.l = false, kc(this, b[1] || "", true), this.o = oc(b[2] || ""), this.g = oc(b[3] || "", true), lc(this, b[4]), this.h = oc(b[5] || "", true), mc(this, b[6] || "", true), this.m = oc(b[7] || "")) : (this.l = false, this.i = new pc(null, this.l));
    }
    T.prototype.toString = function() {
        var a = [];
        var b = this.j;
        b && a.push(qc(b, rc, true), ":");
        var c = this.g;
        if (c || b == "file") a.push("//"), (b = this.o) && a.push(qc(b, rc, true), "@"), a.push(L(c).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.u, c != null && a.push(":", String(c));
        if (c = this.h) this.g && c.charAt(0) != "/" && a.push("/"), a.push(qc(c, c.charAt(0) == "/" ? sc : tc, true));
        (c = this.i.toString()) && a.push("?", c);
        (c = this.m) && a.push("#", qc(c, uc));
        return a.join("");
    };
    T.prototype.resolve = function(a) {
        var b = O(this);
        var c = !!a.j;
        c ? kc(b, a.j) : c = !!a.o;
        c ? b.o = a.o : c = !!a.g;
        c ? b.g = a.g : c = a.u != null;
        var d = a.h;
        if (c) lc(b, a.u);
        else if (c = !!a.h) {
            if (d.charAt(0) != "/") {
                if (this.g && !this.h) d = "/" + d;
                else {
                    var e = b.h.lastIndexOf("/");
                    e != -1 && (d = b.h.slice(0, e + 1) + d);
                }
            }
            e = d;
            if (e == ".." || e == ".") d = "";
            else if (e.indexOf("./") != -1 || e.indexOf("/.") != -1) {
                d = e.lastIndexOf("/", 0) == 0;
                e = e.split("/");
                var f = [];
                for(var g = 0; g < e.length;){
                    var k = e[g++];
                    k == "." ? d && g == e.length && f.push("") : k == ".." ? ((f.length > 1 || f.length == 1 && f[0] != "") && f.pop(), d && g == e.length && f.push("")) : (f.push(k), d = true);
                }
                d = f.join("/");
            } else d = e;
        }
        c ? b.h = d : c = a.i.toString() !== "";
        c ? mc(b, nc(a.i)) : c = !!a.m;
        c && (b.m = a.m);
        return b;
    };
    function O(a) {
        return new T(a);
    }
    function kc(a, b, c) {
        a.j = c ? oc(b, true) : b;
        a.j && (a.j = a.j.replace(/:$/, ""));
    }
    function lc(a, b) {
        if (b) {
            b = Number(b);
            if (isNaN(b) || b < 0) throw Error("Bad port number " + b);
            a.u = b;
        } else a.u = null;
    }
    function mc(a, b, c) {
        b instanceof pc ? (a.i = b, vc(a.i, a.l)) : (c || (b = qc(b, wc)), a.i = new pc(b, a.l));
    }
    function S(a, b, c) {
        a.i.set(b, c);
    }
    function Db(a) {
        S(a, "zx", Math.floor(Math.random() * 2147483648).toString(36) + Math.abs(Math.floor(Math.random() * 2147483648) ^ Date.now()).toString(36));
        return a;
    }
    function oc(a, b) {
        return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
    }
    function qc(a, b, c) {
        return typeof a === "string" ? (a = encodeURI(a).replace(b, xc), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
    }
    function xc(a) {
        a = a.charCodeAt(0);
        return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
    }
    var rc = /[#\/\?@]/g, tc = /[#\?:]/g, sc = /[#\?]/g, wc = /[#\?@]/g, uc = /#/g;
    function pc(a, b) {
        this.h = this.g = null;
        this.i = a || null;
        this.j = !!b;
    }
    function U(a) {
        a.g || (a.g = new Map, a.h = 0, a.i && jc(a.i, function(b, c) {
            a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
        }));
    }
    h = pc.prototype;
    h.add = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        var c = this.g.get(a);
        c || this.g.set(a, c = []);
        c.push(b);
        this.h += 1;
        return this;
    };
    function yc(a, b) {
        U(a);
        b = V(a, b);
        a.g.has(b) && (a.i = null, a.h -= a.g.get(b).length, a.g.delete(b));
    }
    function zc(a, b) {
        U(a);
        b = V(a, b);
        return a.g.has(b);
    }
    h.forEach = function(a, b) {
        U(this);
        this.g.forEach(function(c, d) {
            c.forEach(function(e) {
                a.call(b, e, d, this);
            }, this);
        }, this);
    };
    function Ac(a, b) {
        U(a);
        var c = [];
        if (typeof b === "string") zc(a, b) && (c = c.concat(a.g.get(V(a, b))));
        else for(a = Array.from(a.g.values()), b = 0; b < a.length; b++)c = c.concat(a[b]);
        return c;
    }
    h.set = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        zc(this, a) && (this.h -= this.g.get(a).length);
        this.g.set(a, [
            b
        ]);
        this.h += 1;
        return this;
    };
    h.get = function(a, b) {
        if (!a) return b;
        a = Ac(this, a);
        return a.length > 0 ? String(a[0]) : b;
    };
    function Gb(a, b, c) {
        yc(a, b);
        c.length > 0 && (a.i = null, a.g.set(V(a, b), ja(c)), a.h += c.length);
    }
    h.toString = function() {
        if (this.i) return this.i;
        if (!this.g) return "";
        var a = [], b = Array.from(this.g.keys());
        for(var d = 0; d < b.length; d++){
            var c = b[d];
            var e = L(c);
            c = Ac(this, c);
            for(var f = 0; f < c.length; f++){
                var g = e;
                c[f] !== "" && (g += "=" + L(c[f]));
                a.push(g);
            }
        }
        return this.i = a.join("&");
    };
    function nc(a) {
        var b = new pc;
        b.i = a.i;
        a.g && (b.g = new Map(a.g), b.h = a.h);
        return b;
    }
    function V(a, b) {
        b = String(b);
        a.j && (b = b.toLowerCase());
        return b;
    }
    function vc(a, b) {
        b && !a.j && (U(a), a.i = null, a.g.forEach(function(c, d) {
            var e = d.toLowerCase();
            d != e && (yc(this, d), Gb(this, e, c));
        }, a));
        a.j = b;
    }
    function Bc(a, b) {
        var c = new pb;
        if (l.Image) {
            var d = new Image;
            d.onload = ha(W, c, "TestLoadImage: loaded", true, b, d);
            d.onerror = ha(W, c, "TestLoadImage: error", false, b, d);
            d.onabort = ha(W, c, "TestLoadImage: abort", false, b, d);
            d.ontimeout = ha(W, c, "TestLoadImage: timeout", false, b, d);
            l.setTimeout(function() {
                if (d.ontimeout) d.ontimeout();
            }, 1E4);
            d.src = a;
        } else b(false);
    }
    function Cc(a, b) {
        var c = new pb, d = new AbortController, e = setTimeout(function() {
            d.abort();
            W(c, "TestPingServer: timeout", false, b);
        }, 1E4);
        fetch(a, {
            signal: d.signal
        }).then(function(f) {
            clearTimeout(e);
            f.ok ? W(c, "TestPingServer: ok", true, b) : W(c, "TestPingServer: server error", false, b);
        }).catch(function() {
            clearTimeout(e);
            W(c, "TestPingServer: error", false, b);
        });
    }
    function W(a, b, c, d, e) {
        try {
            e && (e.onload = null, e.onerror = null, e.onabort = null, e.ontimeout = null), d(c);
        } catch (f) {}
    }
    function Dc() {
        this.g = new db;
    }
    function Ec(a) {
        this.i = a.Sb || null;
        this.h = a.ab || false;
    }
    t(Ec, eb);
    Ec.prototype.g = function() {
        return new Fc(this.i, this.h);
    };
    function Fc(a, b) {
        C.call(this);
        this.H = a;
        this.o = b;
        this.m = void 0;
        this.status = this.readyState = 0;
        this.responseType = this.responseText = this.response = this.statusText = "";
        this.onreadystatechange = null;
        this.A = new Headers;
        this.h = null;
        this.F = "GET";
        this.D = "";
        this.g = false;
        this.B = this.j = this.l = null;
        this.v = new AbortController;
    }
    t(Fc, C);
    h = Fc.prototype;
    h.open = function(a, b) {
        if (this.readyState != 0) throw this.abort(), Error("Error reopening a connection");
        this.F = a;
        this.D = b;
        this.readyState = 1;
        Gc(this);
    };
    h.send = function(a) {
        if (this.readyState != 1) throw this.abort(), Error("need to call open() first. ");
        if (this.v.signal.aborted) throw this.abort(), Error("Request was aborted.");
        this.g = true;
        var b = {
            headers: this.A,
            method: this.F,
            credentials: this.m,
            cache: void 0,
            signal: this.v.signal
        };
        a && (b.body = a);
        (this.H || l).fetch(new Request(this.D, b)).then(this.Pa.bind(this), this.ga.bind(this));
    };
    h.abort = function() {
        this.response = this.responseText = "";
        this.A = new Headers;
        this.status = 0;
        this.v.abort();
        this.j && this.j.cancel("Request was aborted.").catch(function() {});
        this.readyState >= 1 && this.g && this.readyState != 4 && (this.g = false, Hc(this));
        this.readyState = 0;
    };
    h.Pa = function(a) {
        if (this.g && (this.l = a, this.h || (this.status = this.l.status, this.statusText = this.l.statusText, this.h = a.headers, this.readyState = 2, Gc(this)), this.g && (this.readyState = 3, Gc(this), this.g))) {
            if (this.responseType === "arraybuffer") a.arrayBuffer().then(this.Na.bind(this), this.ga.bind(this));
            else if (typeof l.ReadableStream !== "undefined" && "body" in a) {
                this.j = a.body.getReader();
                if (this.o) {
                    if (this.responseType) throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');
                    this.response = [];
                } else this.response = this.responseText = "", this.B = new TextDecoder;
                Ic(this);
            } else a.text().then(this.Oa.bind(this), this.ga.bind(this));
        }
    };
    function Ic(a) {
        a.j.read().then(a.Ma.bind(a)).catch(a.ga.bind(a));
    }
    h.Ma = function(a) {
        if (this.g) {
            if (this.o && a.value) this.response.push(a.value);
            else if (!this.o) {
                var b = a.value ? a.value : new Uint8Array(0);
                if (b = this.B.decode(b, {
                    stream: !a.done
                })) this.response = this.responseText += b;
            }
            a.done ? Hc(this) : Gc(this);
            this.readyState == 3 && Ic(this);
        }
    };
    h.Oa = function(a) {
        this.g && (this.response = this.responseText = a, Hc(this));
    };
    h.Na = function(a) {
        this.g && (this.response = a, Hc(this));
    };
    h.ga = function() {
        this.g && Hc(this);
    };
    function Hc(a) {
        a.readyState = 4;
        a.l = null;
        a.j = null;
        a.B = null;
        Gc(a);
    }
    h.setRequestHeader = function(a, b) {
        this.A.append(a, b);
    };
    h.getResponseHeader = function(a) {
        return this.h ? this.h.get(a.toLowerCase()) || "" : "";
    };
    h.getAllResponseHeaders = function() {
        if (!this.h) return "";
        var a = [], b = this.h.entries();
        for(var c = b.next(); !c.done;)c = c.value, a.push(c[0] + ": " + c[1]), c = b.next();
        return a.join("\r\n");
    };
    function Gc(a) {
        a.onreadystatechange && a.onreadystatechange.call(a);
    }
    Object.defineProperty(Fc.prototype, "withCredentials", {
        get: function get() {
            return this.m === "include";
        },
        set: function set(a) {
            this.m = a ? "include" : "same-origin";
        }
    });
    function Jc(a) {
        var b = "";
        ya(a, function(c, d) {
            b += d;
            b += ":";
            b += c;
            b += "\r\n";
        });
        return b;
    }
    function Kc(a, b, c) {
        a: {
            for(d in c){
                var d = false;
                break a;
            }
            d = true;
        }
        d || (c = Jc(c), typeof a === "string" ? c != null && L(c) : S(a, b, c));
    }
    function X(a) {
        C.call(this);
        this.headers = new Map;
        this.L = a || null;
        this.h = false;
        this.g = null;
        this.D = "";
        this.o = 0;
        this.l = "";
        this.j = this.B = this.v = this.A = false;
        this.m = null;
        this.F = "";
        this.H = false;
    }
    t(X, C);
    var Lc = /^https?$/i, Mc = [
        "POST",
        "PUT"
    ];
    h = X.prototype;
    h.Fa = function(a) {
        this.H = a;
    };
    h.ea = function(a, b, c, d) {
        if (this.g) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.D + "; newUri=" + a);
        b = b ? b.toUpperCase() : "GET";
        this.D = a;
        this.l = "";
        this.o = 0;
        this.A = false;
        this.h = true;
        this.g = this.L ? this.L.g() : wb.g();
        this.g.onreadystatechange = ia(p(this.Ca, this));
        try {
            this.B = !0, this.g.open(b, String(a), !0), this.B = !1;
        } catch (f) {
            Nc(this, f);
            return;
        }
        a = c || "";
        c = new Map(this.headers);
        if (d) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (Object.getPrototypeOf(d) === Object.prototype) for(var e in d)c.set(e, d[e]);
            else if (typeof d.keys === "function" && typeof d.get === "function") try {
                for(var _iterator = d.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$f = _step.value;
                    c.set(_$f, d.get(_$f));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            else throw Error("Unknown input type for opt_headers: " + String(d));
        }
        d = Array.from(c.keys()).find(function(f) {
            return "content-type" == f.toLowerCase();
        });
        e = l.FormData && a instanceof l.FormData;
        !(Array.prototype.indexOf.call(Mc, b, void 0) >= 0) || d || e || c.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = c[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var _step_value = (0, $6ZpBv._)(_step1.value, 2), _$f1 = _step_value[0], g = _step_value[1];
                this.g.setRequestHeader(_$f1, g);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        this.F && (this.g.responseType = this.F);
        "withCredentials" in this.g && this.g.withCredentials !== this.H && (this.g.withCredentials = this.H);
        try {
            this.m && (clearTimeout(this.m), this.m = null), this.v = !0, this.g.send(a), this.v = !1;
        } catch (f) {
            Nc(this, f);
        }
    };
    function Nc(a, b) {
        a.h = false;
        a.g && (a.j = true, a.g.abort(), a.j = false);
        a.l = b;
        a.o = 5;
        Oc(a);
        Pc(a);
    }
    function Oc(a) {
        a.A || (a.A = true, D(a, "complete"), D(a, "error"));
    }
    h.abort = function(a) {
        this.g && this.h && (this.h = false, this.j = true, this.g.abort(), this.j = false, this.o = a || 7, D(this, "complete"), D(this, "abort"), Pc(this));
    };
    h.N = function() {
        this.g && (this.h && (this.h = false, this.j = true, this.g.abort(), this.j = false), Pc(this, true));
        X.Z.N.call(this);
    };
    h.Ca = function() {
        this.u || (this.B || this.v || this.j ? Qc(this) : this.Xa());
    };
    h.Xa = function() {
        Qc(this);
    };
    function Qc(a) {
        if (a.h && typeof ea != "undefined") {
            if (a.v && P(a) == 4) setTimeout(a.Ca.bind(a), 0);
            else if (D(a, "readystatechange"), P(a) == 4) {
                a.h = false;
                try {
                    var f = a.ca();
                    a: switch(f){
                        case 200:
                        case 201:
                        case 202:
                        case 204:
                        case 206:
                        case 304:
                        case 1223:
                            var b = !0;
                            break a;
                        default:
                            b = !1;
                    }
                    var c;
                    if (!(c = b)) {
                        var d;
                        if (d = f === 0) {
                            var g = String(a.D).match(ic)[1] || null;
                            !g && l.self && l.self.location && (g = l.self.location.protocol.slice(0, -1));
                            d = !Lc.test(g ? g.toLowerCase() : "");
                        }
                        c = d;
                    }
                    if (c) D(a, "complete"), D(a, "success");
                    else {
                        a.o = 6;
                        try {
                            var e = P(a) > 2 ? a.g.statusText : "";
                        } catch (g) {
                            e = "";
                        }
                        a.l = e + " [" + a.ca() + "]";
                        Oc(a);
                    }
                } finally{
                    Pc(a);
                }
            }
        }
    }
    function Pc(a, b) {
        if (a.g) {
            a.m && (clearTimeout(a.m), a.m = null);
            var c = a.g;
            a.g = null;
            b || D(a, "ready");
            try {
                c.onreadystatechange = null;
            } catch (d) {}
        }
    }
    h.isActive = function() {
        return !!this.g;
    };
    function P(a) {
        return a.g ? a.g.readyState : 0;
    }
    h.ca = function() {
        try {
            return P(this) > 2 ? this.g.status : -1;
        } catch (a) {
            return -1;
        }
    };
    h.la = function() {
        try {
            return this.g ? this.g.responseText : "";
        } catch (a) {
            return "";
        }
    };
    h.La = function(a) {
        if (this.g) {
            var b = this.g.responseText;
            a && b.indexOf(a) == 0 && (b = b.substring(a.length));
            return cb(b);
        }
    };
    function Ib(a) {
        try {
            if (!a.g) return null;
            if ("response" in a.g) return a.g.response;
            switch(a.F){
                case "":
                case "text":
                    return a.g.responseText;
                case "arraybuffer":
                    if ("mozResponseArrayBuffer" in a.g) return a.g.mozResponseArrayBuffer;
            }
            return null;
        } catch (b) {
            return null;
        }
    }
    function Rb(a) {
        var b = {};
        a = (a.g && P(a) >= 2 ? a.g.getAllResponseHeaders() || "" : "").split("\r\n");
        for(var d = 0; d < a.length; d++){
            if (y(a[d])) continue;
            var c = yb(a[d]);
            var e = c[0];
            c = c[1];
            if (typeof c !== "string") continue;
            c = c.trim();
            var f = b[e] || [];
            b[e] = f;
            f.push(c);
        }
        Aa(b, function(d) {
            return d.join(", ");
        });
    }
    h.ya = function() {
        return this.o;
    };
    h.Ha = function() {
        return typeof this.l === "string" ? this.l : String(this.l);
    };
    function Rc(a, b, c) {
        return c && c.internalChannelParams ? c.internalChannelParams[a] || b : b;
    }
    function Sc(a) {
        this.za = 0;
        this.i = [];
        this.j = new pb;
        this.ba = this.na = this.J = this.W = this.g = this.wa = this.G = this.H = this.u = this.U = this.o = null;
        this.Ya = this.V = 0;
        this.Sa = Rc("failFast", false, a);
        this.F = this.C = this.v = this.m = this.l = null;
        this.X = true;
        this.xa = this.K = -1;
        this.Y = this.A = this.D = 0;
        this.Qa = Rc("baseRetryDelayMs", 5E3, a);
        this.Za = Rc("retryDelaySeedMs", 1E4, a);
        this.Ta = Rc("forwardChannelMaxRetries", 2, a);
        this.va = Rc("forwardChannelRequestTimeoutMs", 2E4, a);
        this.ma = a && a.xmlHttpFactory || void 0;
        this.Ua = a && a.Rb || void 0;
        this.Aa = a && a.useFetchStreams || false;
        this.O = void 0;
        this.L = a && a.supportsCrossDomainXhr || false;
        this.M = "";
        this.h = new ec(a && a.concurrentRequestLimit);
        this.Ba = new Dc;
        this.S = a && a.fastHandshake || false;
        this.R = a && a.encodeInitMessageHeaders || false;
        this.S && this.R && (this.R = false);
        this.Ra = a && a.Pb || false;
        a && a.ua && this.j.ua();
        a && a.forceLongPolling && (this.X = false);
        this.aa = !this.S && this.X && a && a.detectBufferingProxy || false;
        this.ia = void 0;
        a && a.longPollingTimeout && a.longPollingTimeout > 0 && (this.ia = a.longPollingTimeout);
        this.ta = void 0;
        this.T = 0;
        this.P = false;
        this.ja = this.B = null;
    }
    h = Sc.prototype;
    h.ka = 8;
    h.I = 1;
    h.connect = function(a, b, c, d) {
        J(0);
        this.W = a;
        this.H = b || {};
        c && d !== void 0 && (this.H.OSID = c, this.H.OAID = d);
        this.F = this.X;
        this.J = Zb(this, null, this.W);
        bc(this);
    };
    function cc(a) {
        Tc(a);
        if (a.I == 3) {
            var b = a.V++, c = O(a.J);
            S(c, "SID", a.M);
            S(c, "RID", b);
            S(c, "TYPE", "terminate");
            Uc(a, c);
            b = new N(a, a.j, b);
            b.M = 2;
            b.A = Db(O(c));
            c = false;
            if (l.navigator && l.navigator.sendBeacon) try {
                c = l.navigator.sendBeacon(b.A.toString(), "");
            } catch (d) {}
            !c && l.Image && ((new Image).src = b.A, c = true);
            c || (b.g = Hb(b.j, null), b.g.ea(b.A));
            b.F = Date.now();
            Fb(b);
        }
        Vc(a);
    }
    function Vb(a) {
        a.g && (Pb(a), a.g.cancel(), a.g = null);
    }
    function Tc(a) {
        Vb(a);
        a.v && (l.clearTimeout(a.v), a.v = null);
        Ub(a);
        a.h.cancel();
        a.m && (typeof a.m === "number" && l.clearTimeout(a.m), a.m = null);
    }
    function bc(a) {
        if (!fc(a.h) && !a.m) {
            a.m = true;
            var b = a.Ea;
            u || ta();
            v || (u(), v = true);
            oa.add(b, a);
            a.D = 0;
        }
    }
    function Wc(a, b) {
        if (Xb(a.h) >= a.h.j - (a.m ? 1 : 0)) return false;
        if (a.m) return a.i = b.G.concat(a.i), true;
        if (a.I == 1 || a.I == 2 || a.D >= (a.Sa ? 0 : a.Ta)) return false;
        a.m = ob(p(a.Ea, a, b), Xc(a, a.D));
        a.D++;
        return true;
    }
    h.Ea = function(a) {
        if (this.m) {
            if (this.m = null, this.I == 1) {
                if (!a) {
                    this.V = Math.floor(Math.random() * 1E5);
                    a = this.V++;
                    var e = new N(this, this.j, a);
                    var f = this.o;
                    this.U && (f ? (f = Ba(f), Da(f, this.U)) : f = this.U);
                    this.u !== null || this.R || (e.J = f, f = null);
                    if (this.S) a: {
                        var b = 0;
                        for(var c = 0; c < this.i.length; c++){
                            b: {
                                var d = this.i[c];
                                if ("__data__" in d.map && (d = d.map.__data__, typeof d === "string")) {
                                    d = d.length;
                                    break b;
                                }
                                d = void 0;
                            }
                            if (d === void 0) break;
                            b += d;
                            if (b > 4096) {
                                b = c;
                                break a;
                            }
                            if (b === 4096 || c === this.i.length - 1) {
                                b = c + 1;
                                break a;
                            }
                        }
                        b = 1E3;
                    }
                    else b = 1E3;
                    b = Yc(this, e, b);
                    c = O(this.J);
                    S(c, "RID", a);
                    S(c, "CVER", 22);
                    this.G && S(c, "X-HTTP-Session-Id", this.G);
                    Uc(this, c);
                    f && (this.R ? b = "headers=" + L(Jc(f)) + "&" + b : this.u && Kc(c, this.u, f));
                    Yb(this.h, e);
                    this.Ra && S(c, "TYPE", "init");
                    this.S ? (S(c, "$req", b), S(c, "SID", "null"), e.U = true, Cb(e, c, null)) : Cb(e, c, b);
                    this.I = 2;
                }
            } else this.I == 3 && (a ? Zc(this, a) : this.i.length == 0 || fc(this.h) || Zc(this));
        }
    };
    function Zc(a, b) {
        var c;
        b ? c = b.l : c = a.V++;
        var d = O(a.J);
        S(d, "SID", a.M);
        S(d, "RID", c);
        S(d, "AID", a.K);
        Uc(a, d);
        a.u && a.o && Kc(d, a.u, a.o);
        c = new N(a, a.j, c, a.D + 1);
        a.u === null && (c.J = a.o);
        b && (a.i = b.G.concat(a.i));
        b = Yc(a, c, 1E3);
        c.H = Math.round(a.va * .5) + Math.round(a.va * .5 * Math.random());
        Yb(a.h, c);
        Cb(c, d, b);
    }
    function Uc(a, b) {
        a.H && ya(a.H, function(c, d) {
            S(b, d, c);
        });
        a.l && ya({}, function(c, d) {
            S(b, d, c);
        });
    }
    function Yc(a, b, c) {
        c = Math.min(a.i.length, c);
        var d = a.l ? p(a.l.Ka, a.l, a) : null;
        a: {
            var e = a.i;
            var k = -1;
            for(;;){
                var q = [
                    "count=" + c
                ];
                k == -1 ? c > 0 ? (k = e[0].g, q.push("ofs=" + k)) : k = 0 : q.push("ofs=" + k);
                var m = true;
                for(var r = 0; r < c; r++){
                    var f = e[r].g;
                    var A = e[r].map;
                    f -= k;
                    if (f < 0) k = Math.max(0, e[r].g - 100), m = false;
                    else try {
                        f = "req" + f + "_";
                        try {
                            var g = A instanceof Map ? A : Object.entries(A);
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = g[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _step_value = (0, $6ZpBv._)(_step.value, 2), _$M = _step_value[0], F = _step_value[1];
                                    var G = F;
                                    n(F) && (G = ab(F));
                                    q.push(f + _$M + "=" + encodeURIComponent(G));
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        } catch (M) {
                            throw q.push(f + "type=" + encodeURIComponent("_badmap")), M;
                        }
                    } catch (M) {
                        d && d(A);
                    }
                }
                if (m) {
                    g = q.join("&");
                    break a;
                }
            }
            g = void 0;
        }
        a = a.i.splice(0, c);
        b.G = a;
        return g;
    }
    function ac(a) {
        if (!a.g && !a.v) {
            a.Y = 1;
            var b = a.Da;
            u || ta();
            v || (u(), v = true);
            oa.add(b, a);
            a.A = 0;
        }
    }
    function Wb(a) {
        if (a.g || a.v || a.A >= 3) return false;
        a.Y++;
        a.v = ob(p(a.Da, a), Xc(a, a.A));
        a.A++;
        return true;
    }
    h.Da = function() {
        this.v = null;
        $c(this);
        if (this.aa && !(this.P || this.g == null || this.T <= 0)) {
            var a = 4 * this.T;
            this.j.info("BP detection timer enabled: " + a);
            this.B = ob(p(this.Wa, this), a);
        }
    };
    h.Wa = function() {
        this.B && (this.B = null, this.j.info("BP detection timeout reached."), this.j.info("Buffering proxy detected and switch to long-polling!"), this.F = false, this.P = true, J(10), Vb(this), $c(this));
    };
    function Pb(a) {
        a.B != null && (l.clearTimeout(a.B), a.B = null);
    }
    function $c(a) {
        a.g = new N(a, a.j, "rpc", a.Y);
        a.u === null && (a.g.J = a.o);
        a.g.P = 0;
        var b = O(a.na);
        S(b, "RID", "rpc");
        S(b, "SID", a.M);
        S(b, "AID", a.K);
        S(b, "CI", a.F ? "0" : "1");
        !a.F && a.ia && S(b, "TO", a.ia);
        S(b, "TYPE", "xmlhttp");
        Uc(a, b);
        a.u && a.o && Kc(b, a.u, a.o);
        a.O && (a.g.H = a.O);
        var c = a.g;
        a = a.ba;
        c.M = 1;
        c.A = Db(O(b));
        c.u = null;
        c.R = true;
        Eb(c, a);
    }
    h.Va = function() {
        this.C != null && (this.C = null, Vb(this), Wb(this), J(19));
    };
    function Ub(a) {
        a.C != null && (l.clearTimeout(a.C), a.C = null);
    }
    function Qb(a, b) {
        var c = null;
        if (a.g == b) {
            Ub(a);
            Pb(a);
            a.g = null;
            var d = 2;
        } else if (Tb(a.h, b)) c = b.G, $b(a.h, b), d = 1;
        else return;
        if (a.I != 0) {
            if (b.o) {
                if (d == 1) {
                    c = b.u ? b.u.length : 0;
                    b = Date.now() - b.F;
                    var e = a.D;
                    d = jb();
                    D(d, new nb(d, c));
                    bc(a);
                } else ac(a);
            } else if (e = b.m, e == 3 || e == 0 && b.X > 0 || !(d == 1 && Wc(a, b) || d == 2 && Wb(a))) switch(c && c.length > 0 && (b = a.h, b.i = b.i.concat(c)), e){
                case 1:
                    R(a, 5);
                    break;
                case 4:
                    R(a, 10);
                    break;
                case 3:
                    R(a, 6);
                    break;
                default:
                    R(a, 2);
            }
        }
    }
    function Xc(a, b) {
        var c = a.Qa + Math.floor(Math.random() * a.Za);
        a.isActive() || (c *= 2);
        return c * b;
    }
    function R(a, b) {
        a.j.info("Error code " + b);
        if (b == 2) {
            var c = p(a.bb, a), d = a.Ua;
            var e = !d;
            d = new T(d || "//www.google.com/images/cleardot.gif");
            l.location && l.location.protocol == "http" || kc(d, "https");
            Db(d);
            e ? Bc(d.toString(), c) : Cc(d.toString(), c);
        } else J(2);
        a.I = 0;
        a.l && a.l.pa(b);
        Vc(a);
        Tc(a);
    }
    h.bb = function(a) {
        a ? (this.j.info("Successfully pinged google.com"), J(2)) : (this.j.info("Failed to ping google.com"), J(1));
    };
    function Vc(a) {
        a.I = 0;
        a.ja = [];
        if (a.l) {
            var b = hc(a.h);
            if (b.length != 0 || a.i.length != 0) ka(a.ja, b), ka(a.ja, a.i), a.h.i.length = 0, ja(a.i), a.i.length = 0;
            a.l.oa();
        }
    }
    function Zb(a, b, c) {
        var d = c instanceof T ? O(c) : new T(c);
        if (d.g != "") b && (d.g = b + "." + d.g), lc(d, d.u);
        else {
            var e = l.location;
            d = e.protocol;
            b = b ? b + "." + e.hostname : e.hostname;
            e = +e.port;
            var f = new T(null);
            d && kc(f, d);
            b && (f.g = b);
            e && lc(f, e);
            c && (f.h = c);
            d = f;
        }
        c = a.G;
        b = a.wa;
        c && b && S(d, c, b);
        S(d, "VER", a.ka);
        Uc(a, d);
        return d;
    }
    function Hb(a, b, c) {
        if (b && !a.L) throw Error("Can't create secondary domain capable XhrIo object.");
        b = a.Aa && !a.ma ? new X(new Ec({
            ab: c
        })) : new X(a.ma);
        b.Fa(a.L);
        return b;
    }
    h.isActive = function() {
        return !!this.l && this.l.isActive(this);
    };
    function ad() {}
    h = ad.prototype;
    h.ra = function() {};
    h.qa = function() {};
    h.pa = function() {};
    h.oa = function() {};
    h.isActive = function() {
        return true;
    };
    h.Ka = function() {};
    function bd() {}
    bd.prototype.g = function(a, b) {
        return new Y(a, b);
    };
    function Y(a, b) {
        C.call(this);
        this.g = new Sc(b);
        this.l = a;
        this.h = b && b.messageUrlParams || null;
        a = b && b.messageHeaders || null;
        b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = {
            "X-Client-Protocol": "webchannel"
        });
        this.g.o = a;
        a = b && b.initMessageHeaders || null;
        b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = {
            "X-WebChannel-Content-Type": b.messageContentType
        });
        b && b.sa && (a ? a["X-WebChannel-Client-Profile"] = b.sa : a = {
            "X-WebChannel-Client-Profile": b.sa
        });
        this.g.U = a;
        (a = b && b.Qb) && !y(a) && (this.g.u = a);
        this.A = b && b.supportsCrossDomainXhr || false;
        this.v = b && b.sendRawJson || false;
        (b = b && b.httpSessionIdParam) && !y(b) && (this.g.G = b, a = this.h, a !== null && b in a && (a = this.h, b in a && delete a[b]));
        this.j = new Z(this);
    }
    t(Y, C);
    Y.prototype.m = function() {
        this.g.l = this.j;
        this.A && (this.g.L = true);
        this.g.connect(this.l, this.h || void 0);
    };
    Y.prototype.close = function() {
        cc(this.g);
    };
    Y.prototype.o = function(a) {
        var b = this.g;
        if (typeof a === "string") {
            var c = {};
            c.__data__ = a;
            a = c;
        } else this.v && (c = {}, c.__data__ = ab(a), a = c);
        b.i.push(new dc(b.Ya++, a));
        b.I == 3 && bc(b);
    };
    Y.prototype.N = function() {
        this.g.l = null;
        delete this.j;
        cc(this.g);
        delete this.g;
        Y.Z.N.call(this);
    };
    function cd(a) {
        gb.call(this);
        a.__headers__ && (this.headers = a.__headers__, this.statusCode = a.__status__, delete a.__headers__, delete a.__status__);
        var b = a.__sm__;
        if (b) {
            a: {
                for(var c in b){
                    a = c;
                    break a;
                }
                a = void 0;
            }
            if (this.i = a) a = this.i, b = b !== null && a in b ? b[a] : void 0;
            this.data = b;
        } else this.data = a;
    }
    t(cd, gb);
    function dd() {
        hb.call(this);
        this.status = 1;
    }
    t(dd, hb);
    function Z(a) {
        this.g = a;
    }
    t(Z, ad);
    Z.prototype.ra = function() {
        D(this.g, "a");
    };
    Z.prototype.qa = function(a) {
        D(this.g, new cd(a));
    };
    Z.prototype.pa = function(a) {
        D(this.g, new dd());
    };
    Z.prototype.oa = function() {
        D(this.g, "b");
    };
    bd.prototype.createWebChannel = bd.prototype.g;
    Y.prototype.send = Y.prototype.o;
    Y.prototype.open = Y.prototype.m;
    Y.prototype.close = Y.prototype.close;
    $1c8830389a9e4a77$export$66869136fc133c3a = $1c8830389a9e4a77$export$2e2bcd8739ae039.createWebChannelTransport = function createWebChannelTransport() {
        return new bd;
    };
    $1c8830389a9e4a77$export$888d0d9ab79d08fc = $1c8830389a9e4a77$export$2e2bcd8739ae039.getStatEventTarget = function getStatEventTarget() {
        return jb();
    };
    $1c8830389a9e4a77$export$d61e24a684f9e51 = $1c8830389a9e4a77$export$2e2bcd8739ae039.Event = I;
    $1c8830389a9e4a77$export$cbbc350c1dfc80cb = $1c8830389a9e4a77$export$2e2bcd8739ae039.Stat = {
        jb: 0,
        mb: 1,
        nb: 2,
        Hb: 3,
        Mb: 4,
        Jb: 5,
        Kb: 6,
        Ib: 7,
        Gb: 8,
        Lb: 9,
        PROXY: 10,
        NOPROXY: 11,
        Eb: 12,
        Ab: 13,
        Bb: 14,
        zb: 15,
        Cb: 16,
        Db: 17,
        fb: 18,
        eb: 19,
        gb: 20
    };
    ub.NO_ERROR = 0;
    ub.TIMEOUT = 8;
    ub.HTTP_ERROR = 6;
    $1c8830389a9e4a77$export$d4e71bc0b80dc0fb = $1c8830389a9e4a77$export$2e2bcd8739ae039.ErrorCode = ub;
    vb.COMPLETE = "complete";
    $1c8830389a9e4a77$export$3d7865934588d77e = $1c8830389a9e4a77$export$2e2bcd8739ae039.EventType = vb;
    fb.EventType = H;
    H.OPEN = "a";
    H.CLOSE = "b";
    H.ERROR = "c";
    H.MESSAGE = "d";
    C.prototype.listen = C.prototype.J;
    $1c8830389a9e4a77$export$aa726fb96ad3e039 = $1c8830389a9e4a77$export$2e2bcd8739ae039.WebChannel = fb;
    $1c8830389a9e4a77$export$ddb1030448106742 = $1c8830389a9e4a77$export$2e2bcd8739ae039.FetchXmlHttpFactory = Ec;
    X.prototype.listenOnce = X.prototype.K;
    X.prototype.getLastError = X.prototype.Ha;
    X.prototype.getLastErrorCode = X.prototype.ya;
    X.prototype.getStatus = X.prototype.ca;
    X.prototype.getResponseJson = X.prototype.La;
    X.prototype.getResponseText = X.prototype.la;
    X.prototype.send = X.prototype.ea;
    X.prototype.setWithCredentials = X.prototype.Fa;
    $1c8830389a9e4a77$export$26404658cda3ee02 = $1c8830389a9e4a77$export$2e2bcd8739ae039.XhrIo = X;
}).apply(typeof $1c8830389a9e4a77$var$commonjsGlobal !== 'undefined' ? $1c8830389a9e4a77$var$commonjsGlobal : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});

});

parcelRegister("lmcdu", function(module, exports) {

$parcel$export(module.exports, "RE2JS", function () { return $f8c5210791d45577$export$e46efc5f33420715; });
/*!
* re2js
* RE2JS is the JavaScript port of RE2, a regular expression engine that provides linear time matching
*
* @version v2.8.6
* @author Oleksii Vasyliev
* @homepage https://github.com/le0pard/re2js#readme
* @repository github:le0pard/re2js
* @license MIT
*/ //#region src/RE2Flags.js

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $6tY97 = parcelRequire("6tY97");

var $c2MhV = parcelRequire("c2MhV");

var $6ZpBv = parcelRequire("6ZpBv");

var $jlUaU = parcelRequire("jlUaU");

var $67kUy = parcelRequire("67kUy");

var $gh3Df = parcelRequire("gh3Df");
var $f8c5210791d45577$var$_RE2Flags, $f8c5210791d45577$var$_class, $f8c5210791d45577$var$_class1, $f8c5210791d45577$var$_Unicode, $f8c5210791d45577$var$_Utils, $f8c5210791d45577$var$_MatcherInputBase, $f8c5210791d45577$var$_Matcher, $f8c5210791d45577$var$_Inst, $f8c5210791d45577$var$_DFA, $f8c5210791d45577$var$_Regexp, $f8c5210791d45577$var$_Prefilter, $f8c5210791d45577$var$_Parser, $f8c5210791d45577$var$_RE2Set, $f8c5210791d45577$var$_RE2JS;
var $f8c5210791d45577$var$RE2Flags = ($f8c5210791d45577$var$_RE2Flags = function RE2Flags() {
    "use strict";
    (0, $4QweW._)(this, RE2Flags);
}, (0, $6tY97._)($f8c5210791d45577$var$_RE2Flags, "FOLD_CASE", 1), (0, $6tY97._)($f8c5210791d45577$var$_RE2Flags, "LITERAL", 2), (0, $6tY97._)($f8c5210791d45577$var$_RE2Flags, "CLASS_NL", 4), (0, $6tY97._)($f8c5210791d45577$var$_RE2Flags, "DOT_NL", 8), (0, $6tY97._)($f8c5210791d45577$var$_RE2Flags, "ONE_LINE", 16), (0, $6tY97._)($f8c5210791d45577$var$_RE2Flags, "NON_GREEDY", 32), (0, $6tY97._)($f8c5210791d45577$var$_RE2Flags, "PERL_X", 64), (0, $6tY97._)($f8c5210791d45577$var$_RE2Flags, "UNICODE_GROUPS", 128), (0, $6tY97._)($f8c5210791d45577$var$_RE2Flags, "WAS_DOLLAR", 256), (0, $6tY97._)($f8c5210791d45577$var$_RE2Flags, "LOOKBEHIND", 512), (0, $6tY97._)($f8c5210791d45577$var$_RE2Flags, "MATCH_NL", $f8c5210791d45577$var$_RE2Flags.CLASS_NL | $f8c5210791d45577$var$_RE2Flags.DOT_NL), (0, $6tY97._)($f8c5210791d45577$var$_RE2Flags, "PERL", $f8c5210791d45577$var$_RE2Flags.CLASS_NL | $f8c5210791d45577$var$_RE2Flags.ONE_LINE | $f8c5210791d45577$var$_RE2Flags.PERL_X | $f8c5210791d45577$var$_RE2Flags.UNICODE_GROUPS), (0, $6tY97._)($f8c5210791d45577$var$_RE2Flags, "POSIX", 0), (0, $6tY97._)($f8c5210791d45577$var$_RE2Flags, "UNANCHORED", 0), (0, $6tY97._)($f8c5210791d45577$var$_RE2Flags, "ANCHOR_START", 1), (0, $6tY97._)($f8c5210791d45577$var$_RE2Flags, "ANCHOR_BOTH", 2), $f8c5210791d45577$var$_RE2Flags);
//#endregion
//#region src/PublicFlags.js
/**
* Public flags for RE2JS and RE2Set compilation.
*/ var $f8c5210791d45577$var$PublicFlags = {
    CASE_INSENSITIVE: 1,
    DOTALL: 2,
    MULTILINE: 4,
    DISABLE_UNICODE_GROUPS: 8,
    LONGEST_MATCH: 16,
    LOOKBEHINDS: 512
};
//#endregion
//#region src/Codepoint.js
/**
* Various constants and helper for unicode codepoints.
*/ var $f8c5210791d45577$var$ASCII_SIZE = 128;
var $f8c5210791d45577$var$ASCII_TO_UPPER = new Int32Array($f8c5210791d45577$var$ASCII_SIZE);
var $f8c5210791d45577$var$ASCII_TO_LOWER = new Int32Array($f8c5210791d45577$var$ASCII_SIZE);
var $f8c5210791d45577$var$MAX_BMP = 65535;
for(var $f8c5210791d45577$var$i = 0; $f8c5210791d45577$var$i < $f8c5210791d45577$var$ASCII_SIZE; $f8c5210791d45577$var$i++){
    if ($f8c5210791d45577$var$i >= 97 && $f8c5210791d45577$var$i <= 122) $f8c5210791d45577$var$ASCII_TO_UPPER[$f8c5210791d45577$var$i] = $f8c5210791d45577$var$i - 32;
    else $f8c5210791d45577$var$ASCII_TO_UPPER[$f8c5210791d45577$var$i] = $f8c5210791d45577$var$i;
    if ($f8c5210791d45577$var$i >= 65 && $f8c5210791d45577$var$i <= 90) $f8c5210791d45577$var$ASCII_TO_LOWER[$f8c5210791d45577$var$i] = $f8c5210791d45577$var$i + 32;
    else $f8c5210791d45577$var$ASCII_TO_LOWER[$f8c5210791d45577$var$i] = $f8c5210791d45577$var$i;
}
var $f8c5210791d45577$var$Codepoint = ($f8c5210791d45577$var$_class = /*#__PURE__*/ function() {
    "use strict";
    function _class() {
        (0, $4QweW._)(this, _class);
    }
    (0, $6hK4i._)(_class, null, [
        {
            key: "toUpperCase",
            value: function toUpperCase(codepoint) {
                if (codepoint < $f8c5210791d45577$var$ASCII_SIZE) return $f8c5210791d45577$var$ASCII_TO_UPPER[codepoint];
                var s = String.fromCodePoint(codepoint).toUpperCase();
                var expectedLen = s.codePointAt(0) > $f8c5210791d45577$var$MAX_BMP ? 2 : 1;
                if (s.length > expectedLen) return codepoint;
                var sOrigin = String.fromCodePoint(s.codePointAt(0)).toLowerCase();
                var originExpectedLen = sOrigin.codePointAt(0) > $f8c5210791d45577$var$MAX_BMP ? 2 : 1;
                if (sOrigin.length > originExpectedLen || sOrigin.codePointAt(0) !== codepoint) return codepoint;
                return s.codePointAt(0);
            }
        },
        {
            key: "toLowerCase",
            value: function toLowerCase(codepoint) {
                if (codepoint < $f8c5210791d45577$var$ASCII_SIZE) return $f8c5210791d45577$var$ASCII_TO_LOWER[codepoint];
                var s = String.fromCodePoint(codepoint).toLowerCase();
                var expectedLen = s.codePointAt(0) > $f8c5210791d45577$var$MAX_BMP ? 2 : 1;
                if (s.length > expectedLen) return codepoint;
                var sOrigin = String.fromCodePoint(s.codePointAt(0)).toUpperCase();
                var originExpectedLen = sOrigin.codePointAt(0) > $f8c5210791d45577$var$MAX_BMP ? 2 : 1;
                if (sOrigin.length > originExpectedLen || sOrigin.codePointAt(0) !== codepoint) return codepoint;
                return s.codePointAt(0);
            }
        }
    ]);
    return _class;
}(), (0, $6tY97._)($f8c5210791d45577$var$_class, "CODES", /* @__PURE__ */ new Map([
    [
        "\x07",
        7
    ],
    [
        "\b",
        8
    ],
    [
        "	",
        9
    ],
    [
        "\n",
        10
    ],
    [
        "\v",
        11
    ],
    [
        "\f",
        12
    ],
    [
        "\r",
        13
    ],
    [
        " ",
        32
    ],
    [
        "\"",
        34
    ],
    [
        "$",
        36
    ],
    [
        "&",
        38
    ],
    [
        "'",
        39
    ],
    [
        "(",
        40
    ],
    [
        ")",
        41
    ],
    [
        "*",
        42
    ],
    [
        "+",
        43
    ],
    [
        "-",
        45
    ],
    [
        ".",
        46
    ],
    [
        "0",
        48
    ],
    [
        "1",
        49
    ],
    [
        "2",
        50
    ],
    [
        "3",
        51
    ],
    [
        "4",
        52
    ],
    [
        "5",
        53
    ],
    [
        "6",
        54
    ],
    [
        "7",
        55
    ],
    [
        "8",
        56
    ],
    [
        "9",
        57
    ],
    [
        ":",
        58
    ],
    [
        "<",
        60
    ],
    [
        ">",
        62
    ],
    [
        "?",
        63
    ],
    [
        "A",
        65
    ],
    [
        "B",
        66
    ],
    [
        "C",
        67
    ],
    [
        "F",
        70
    ],
    [
        "P",
        80
    ],
    [
        "Q",
        81
    ],
    [
        "U",
        85
    ],
    [
        "Z",
        90
    ],
    [
        "[",
        91
    ],
    [
        "\\",
        92
    ],
    [
        "]",
        93
    ],
    [
        "^",
        94
    ],
    [
        "_",
        95
    ],
    [
        "`",
        96
    ],
    [
        "a",
        97
    ],
    [
        "b",
        98
    ],
    [
        "f",
        102
    ],
    [
        "i",
        105
    ],
    [
        "m",
        109
    ],
    [
        "n",
        110
    ],
    [
        "r",
        114
    ],
    [
        "s",
        115
    ],
    [
        "t",
        116
    ],
    [
        "v",
        118
    ],
    [
        "x",
        120
    ],
    [
        "z",
        122
    ],
    [
        "{",
        123
    ],
    [
        "|",
        124
    ],
    [
        "}",
        125
    ]
])), $f8c5210791d45577$var$_class);
//#endregion
//#region src/UnicodeRangeTable.js
var $f8c5210791d45577$var$UnicodeRangeTable = /*#__PURE__*/ function() {
    "use strict";
    function UnicodeRangeTable(data) {
        var isStride1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        (0, $4QweW._)(this, UnicodeRangeTable);
        this.data = data;
        this.isStride1 = isStride1;
        this.SIZE = isStride1 ? 2 : 3;
    }
    (0, $6hK4i._)(UnicodeRangeTable, [
        {
            key: "getLo",
            value: function getLo(index) {
                return this.data[index * this.SIZE];
            }
        },
        {
            key: "getHi",
            value: function getHi(index) {
                return this.data[index * this.SIZE + 1];
            }
        },
        {
            key: "getStride",
            value: function getStride(index) {
                return this.isStride1 ? 1 : this.data[index * this.SIZE + 2];
            }
        },
        {
            key: "length",
            get: function get() {
                return this.data.length / this.SIZE;
            }
        }
    ]);
    return UnicodeRangeTable;
}();
//#endregion
//#region src/UnicodeTables.js
var $f8c5210791d45577$var$B64_MAP = /* @__PURE__ */ new Uint8Array(256);
for(var $f8c5210791d45577$var$i1 = 0, $f8c5210791d45577$var$b = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-"; $f8c5210791d45577$var$i1 < 64; $f8c5210791d45577$var$i1++)$f8c5210791d45577$var$B64_MAP[$f8c5210791d45577$var$b.charCodeAt($f8c5210791d45577$var$i1)] = $f8c5210791d45577$var$i1;
var $f8c5210791d45577$var$decodeVLQ = function(str) {
    var res = [];
    var value = 0, shift = 0;
    for(var i = 0; i < str.length; i++){
        var digit = $f8c5210791d45577$var$B64_MAP[str.charCodeAt(i)];
        value |= (digit & 31) << shift;
        if ((digit & 32) === 0) {
            res.push(value);
            value = 0;
            shift = 0;
        } else shift += 5;
    }
    return res;
};
var $f8c5210791d45577$var$decodeRanges = function(str, isStride1) {
    var res = $f8c5210791d45577$var$decodeVLQ(str);
    var numRanges = isStride1 ? res.length / 2 : res.length / 3;
    var out = new Uint32Array(numRanges * 3);
    var current = 0, resIdx = 0;
    for(var i = 0; i < numRanges; i++){
        current += res[resIdx++];
        out[i * 3] = current;
        current += res[resIdx++];
        out[i * 3 + 1] = current;
        out[i * 3 + 2] = isStride1 ? 1 : res[resIdx++];
    }
    return out;
};
var $f8c5210791d45577$var$decodeOrbit = function(str) {
    var res = $f8c5210791d45577$var$decodeVLQ(str);
    var map = /* @__PURE__ */ new Map();
    var currentKey = 0;
    for(var i = 0; i < res.length; i += 2){
        currentKey += res[i];
        var zz = res[i + 1];
        var delta = zz >>> 1 ^ -(zz & 1);
        map.set(currentKey, currentKey + delta);
    }
    return map;
};
var $f8c5210791d45577$var$LazyMap = /*#__PURE__*/ function() {
    "use strict";
    function LazyMap(initializer) {
        (0, $4QweW._)(this, LazyMap);
        this.initializer = initializer;
        this.cache = /* @__PURE__ */ new Map();
    }
    (0, $6hK4i._)(LazyMap, [
        {
            key: "has",
            value: function has(key) {
                return key in this.initializer;
            }
        },
        {
            key: "get",
            value: function get(key) {
                if (this.cache.has(key)) return this.cache.get(key);
                var fn = this.initializer[key];
                var val = fn ? fn() : null;
                this.cache.set(key, val);
                return val;
            }
        }
    ]);
    return LazyMap;
}();
var $f8c5210791d45577$var$UnicodeTables = ($f8c5210791d45577$var$_class1 = /*#__PURE__*/ function() {
    "use strict";
    function _class() {
        (0, $4QweW._)(this, _class);
    }
    (0, $6hK4i._)(_class, null, [
        {
            key: "CASE_ORBIT",
            get: function get() {
                if (!this._CASE_ORBIT) this._CASE_ORBIT = $f8c5210791d45577$var$decodeOrbit("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");
                return this._CASE_ORBIT;
            }
        },
        {
            key: "Print",
            get: function get() {
                if (!this._Print) this._Print = new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("hB9CBjBLBCpWBDFBFGBCCCBSBCsMBClBBDxBBDCBC2BBJaBFFBSVBC-FBCvBBD6BBDkDBP6BBDwBBDOBCbBDCCBJBGfBIqCBCgFBCHBDBBDVBCGBCEEBCBDIBDBBDDBJFFBCCBDBDYBDCBCFBFBBDVBCGBCBBCBBCBBDCCBDBFBBDCBEIIBCBCIIBPBLCBCIBCCBCVBCGBCBBCEBDJBCCBCCBDQQBCBDLBIGBCCBCHBDBBDVBCGBCBBCEBDIBDBBDCBICBFBBCEBDRBLBBCFBECBCDBEBBCCCBEEBEEBBBELBFEBECBCDBDHHPUBGMBCCBCWBCPBDIBCCBCDBIBBCCBCBBDDBDJBIVBCCBCWBCJBCEBDIBCCBCDBIBBGCBCDBDJBCCBNMBCCBCyBBCCBCFBFPBDZBCCBCRBEXBCIBCDDBFBEFFBEBCCCBGBHJBDCBN5BBFcBmBBBCCCBDBCXBCCCBVBDEBCCCBFBCJBDDBhBnCBCjBBFmBBCjBBCOBCMBmBlGBCGGD4LBCDBDGBCCCBCBDoBBCDBDgBBCDBDGBCCCBCBDOBC4BBCDBDiCBDfBEZBH1CBDFBD-TBCbBE4CBIVBKXBKTBNMBCCBCBBN9CBDJBHJBHNBCKBH4CBIqBBGlCBLeBCLBFLBFEEBoBBDEBMrBBFZBHKBE9BBDgCBCcBDKBHJBHNBDtBBDLBVsCBClFBJ7BBEOBE9BBGqBBDKBJqBBG1QBDFBDlBBDFBDHBCGCBdBD0BBCOBCNBDFBCSBDCBCIBSXBJuBBSBBDaBCMBEhBBPgBBQrEBF5UBXKBWz4BBD9LBGsBBCGGD3BBIBBPXBKGBCGBCGBCGBCGBCGBCGBCGBC9DBjBZBC4CBN1GBbPBC+BBC1CBDmDBGqBBC9CBC1CBKvBBCszcBE2BBK7KBV3FBJ8GBV7BBEJBH3BBJlCBJLBHzDBMdBEtCBCKBFgBBC2BBKNBDJBDmDBZbBLFBDFBDFBKGBCGBC7BBF9DBDJBHj9KBNWBFwBBloItLBDpDBnBGBNEBGZBCEBCCCBCCBCCBoUBhBpBBHyBBCSBCDBFEBCmEBF9FBEFBDFBDFBDCBEGBCGBOBBDLBCZBCSBCBBCOBDNBjB6DBGCBFsBBE3CBCMBEwBwBBsBBjEcBEwBBQbBFjBBKdBGqBBGdBCkBBFNBrB9EBDJBHjBBFjBBFnBBJzBBMLBCOBCGBCBBCKBCOBCGBCBBEzBBN2JBKVBLHBZFBCpBBCIBmCFBDCCBqBBCBBEDDBVBCnCBJIBxBSBCBBGgBBEaBGaBnB3BBFTBDxBBCBBGHBCCBCcBDCBFJBIIBI-BBhBmBBFLBK1BBEcBDaBGZBIDBNGBxCoCB4ByBBOyBBItBBJJBHlBBEcBJBBxGeBCpBBCCBDBBRFBJIBiBtBBJpBBXZBnBbBVWBKtCBFjBBK9BBCEBOYBIJBH0BBCRBJmBBK-CBCTBMRBCuBB-BGBCCCBCBCOBCKBH6BBGJBHDBCHBDBBDVBCGBCBBCEBCJBDBBDCBDHHGGBDGBEEBMJBCDDClBBCJBCDDCDBCJBCBBJBBe7CBCEBfnCBJJBnF1BBDlBBjBkCBMJBHMBU5BBHJBHTBdaBDOBFWB6F7BBlDyCBNHBDDDBGBCBBCdBCBBDLBKJBnCHBDtBBDKBcnCBJyCBOoCBIJB3CHB5ChBBPJBHIBCsBBCNBLcBEfBDVBCNBqCGBCBBCrBBECCBCCBHBJJBHFBCBBCkBBCBBCFBIJBHrBBFJB3HYBIQBCoBBEcB2CQQBwBBO6cBnDuDBCEBMjGBtyCiDBOvhBBRVBL68DBGmSB61G5BBn2B4RBIeBCJBFwCBCJBHdBDFBLlCBLJBCGBCUBGSBxN5BBnG6CBGYBDYBtBqCBF4BBIQBhCEBMGBK1mHBqBfBiDyDB+vIDBCGBCBBCiJBQeeBBBDPPBCBJrMBloCqDBGMBEIBIJBDDBh7D8HBEzNBHWBQQBQtBBDWBKzDB9B1HBLmBBDpCBJvDBWlCB7DTBNTBN2CBKYBoE0CBCmCBCBBDDDBDDBCBCLBCCCBFBCgCBCDBDHBCGBCbBCDBCEBCEEBFBCzKBDjJBD9VBQEBCOBxiBeBHFB2GGBCQBDGBCBBCEBG9BBiBxDxDBrBBENBDJBFBBhKeBS5BBGxOxOBoBB3GqBBFhGhGBdBCVBJBBhHGBCDBCBBCOBCkGBDPBqBrCBFJBFBByYjCBtC8BBjGDBCaBCBBCDDCJBCDBCCCHFFCECBBBCBBCDDCICBCCDDBCGBCDBCDBCCCBIBCQBGCBCEBCQB1BBBvIrBBFjDBNOBDOBCOBCkBBLtFB5BcBOrBBFIBIBBPFB7E4eBEQBEMBE5GBHLBFQQBKBF3BBJJBHnBBJdBDLBFBBPIBoB3KBJNBDMBEKBE4BBCFFBOBDLBFJBIyEBCmDBmgB-2pBBhB9oEBDt0FBDwpHBQtTBjtC9QBjvBq6EBGppIBnkzVvHB", false));
                return this._Print;
            }
        },
        {
            key: "Upper",
            get: function get() {
                return this.CATEGORIES.get("Lu");
            }
        }
    ]);
    return _class;
}(), (0, $6tY97._)($f8c5210791d45577$var$_class1, "_CASE_ORBIT", null), (0, $6tY97._)($f8c5210791d45577$var$_class1, "_Print", null), (0, $6tY97._)($f8c5210791d45577$var$_class1, "CATEGORIES", new $f8c5210791d45577$var$LazyMap({
    C: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("AfBgDgBBOrWrWBHHBCBICCVuMuMnBBBzBBBE4B4BBGBcDBHQBXhGhGxBBB8BBBmDNB8BBByBBBQddBCCMEBhBGBsCiFiFJBBDBBXIICCBFBBKBBDBBFHBCDBDGGBaaBEEHDBDBBXIIDGDBCCGDBDBBECBCGBFCCBFBSJBEKKEXXIDDGBBLIEBCCBNBFBBNGBIEEJBBDBBXIIDGGBKKBDDBEEBFBEDBDGGBTTBIBDHHBBBEFFBBBDCCDCBDCBECBNDBGCBEFFBCCBEBCNBWEBOEEYRRBKKEFFBFBDEEDBBFBBLGBXEEYLLGBBKEEFGBDEBEFFBLLELBOEE0BEEHDBRBBbEETCBZKKCBBICBCDBHCCJFBLBBELB7BDBekBBDCCGZZCYYBGGCIILBBFfBpClBlBBCBoBlBlBQOOBjBBnGCCBDBCBB6LFFBIICFFBqBqBFBBiBFFBIICFFBQQ6BFFBkCkCBhBhBBBBbFB3CBBHBB+UCB6CGBXIBZIBVLBOEEDLB-CBBLFBLFBPMMBEB6CGBsBEBnCJBgBNNBCBNDBCCBrBBBGKBtBDBbFBMCB-BBBiCeeBMMBEBLFBPBBvBBBNTBuCnFnFBGB9BCBQCB-BEBsBBBMHBsBEB3QBBHBBnBBBHBBJGCgBBB2BQQPBBHUUBEEKMMBDBbEByBPBDBBcOOBBBjBNBiBOBtEDB7UVBMUB14BBB-LEBuBCCBDBCBB5BGBDNBZIBI4BI-DhBBb6C6CBKB3GZBxC3C3CBoDoDBDBsB-C-C3CIBxBuzcuzcBBB4BIB9KTB5FHB+GTB9BCBLFB5BHBnCHBNFB1DKBfCBvCMMBCBiB4B4BBHBPBBLBBoDXBdJBHBBHBBHIBIII9BDB-DBBLFBl9KLBYDByBjoIBvLBBrDlBBILBGEBbGGCGDrUfBrBFB0BUUFDBGoEoEBCB-FCBHBBHBBHBBECBIIIBLBDBBNbbUDDQBBPhBB8DEBEDBuBCB5COOBBBCuBBvBhEBeCByBOBdDBlBIBfEBsBEBfmBmBBCBPpBB-EBBLFBlBDBlBDBpBHB1BKBNQQIDDMQQIDDBBB1BLB4JIBXJBJXBHrBrBKkCBHBBCtBtBDCBCBBYpCpCBGBKvBBUDDBDBiBCBcEBclBB5BDBVBBzBDDBDBJEEeBBEDBLGBKGBhCfBoBDBNIB3BCBeBBcEBbGBFLBIvCBqC2BB0BMB0BGBvBHBLFBnBCBeHBDvGBgBrBrBEBBDPBHHBKgBBvBHBrBVBblBBdTBYIBvCDBlBIB-BGGBLBaGBLFB2BTTBGBoBIBhDVVBJBTwBwBB8BBICCFQQMFB8BEBLFBFJJBDDBXXIDDGLLBDDBEEBCCBEBCEBIBBICBGKBLCCBCCnBLLCBBCFFLDDBGBDcB9CGGBcBpCHBLlFB3BBBnBhBBmCKBLFBOSB7BFBLFBVbBcBBQDBY4FB9BjDB0CLBJBBCBBJDDfDDBNNBHBLlCBJBBvBBBMaBpCHB0CMBqCGBL1CBJ3CBjBNBLFBKuBuBPJBeCBhBBBXPPBnCBIDDtBCBCDDKHBLFBHDDmBDDHGBLFBtBDBL1HBaGBSqBqBBBBe0CBCOBzBMB8clDBwDGGBJBlGryCBkDMBxhBPBXJB88DEBoS41GB7Bl2BB6RGBgBLLBCByCLLBEBfBBHJBnCJBLIIWEBUvNB7BlGB8CEBaBBarBBsCDB6BGBS-BBGKBIIB3mHoBBhBgDB0D8vIBFIIDkJkJBNBCcBEBBCNBFHBtMjoCBsDEBOCBKGBLBBF-6DB+HCB1NFBYOBSOBvBBBYIB1D7BB3HJBoBBBrCHBxDUBnC5DBVLBVLB4CIBamEB2CoCoCDBBCBBDBBFNNCIIiCFFBJJIddFGGCCBI1K1KBlJlJB-V-VBNBGQQBuiBBgBFBH0GBISSBIIDGGBDB-BgBBCvDBuBCBPBBLDBD-JBgBQB7BEBCvOBrB1GBsBDBC-FBgBXXBGBD-GBIFFDQQmGBBRoBBtCDBLDBDwYBlCrCB+BhGBFccDCCBCCLFFCCCBEBCDBCECEDDCBBCICDCCBFFIKFCLLSEBEGGSzBBDtIBtBDBlDLBQBBQQQmBJBvF3BBeMBtBDBKGBDNBH5EB6eCBSCBOCB7GFBNDBCOBNDB5BHBLFBpBHBfBBNDBDNBKmBB5KHBPBBOCBMCB6BCCBCBRBBNDBLGB0EoDoDBjgBBh3pBfB-oEBBv0FBBypHOBvThtCB-QhvBBs6EEBrpIlkzVBxHvw-FB", false));
    },
    Cc: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("AfgDgB", true));
    },
    Cf: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("tFzqBzqBBEBXhGhGyBhMhMBxCxCs5D9-B9-BBDBbEByBEBCJBw03B6H6HBBBimEQQj7IPBhjiBDBwmFHBn0rYffB+CB", false));
    },
    Cn: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("4bBBHDBICCVuMuMnBBBzBBBE4B4BBGBcDBHKBvI9B9BBmDmDBMB8BBByBBBQddBCCMEBjBEBuHJJBDDBXXICCBBBFBBKBBDBBFHBCDBDGGBaaBEEHDBDBBXIIDGDBCCGDBDBBECBCGBFCCBFBSJBEKKEXXIDDGBBLIEBCCBNBFBBNGBIEEJBBDBBXIIDGGBKKBDDBEEBFBEDBDGGBTTBIBDHHBBBEFFBBBDCCDCBDCBECBNDBGCBEFFBCCBEBCNBWEBOEEYRRBKKEFFBFBDEEDBBFBBLGBXEEYLLGBBKEEFGBDEBEFFBLLELBOEE0BEEHDBRBBbEETCBZKKCBBICBCDBHCCJFBLBBELB7BDBekBBDCCGZZCYYBGGCIILBBFfBpClBlBBCBoBlBlBQOOBjBBnGCCBDBCBB6LFFBIICFFBqBqBFBBiBFFBIICFFBQQ6BFFBkCkCBhBhBBBBbFB3CBBHBB+UCB6CGBXIBZIBVLBOEEDLB-CBBLFBLFBbFB6CGBsBEBnCJBgBNNBCBNDBCCBrBBBGKBtBDBbFBMCB-BBBiCeeBMMBEBLFBPBBvBBBNTBuCnFnFBGB9BCBQCB-BEBsBBBMHBsBEB3QBBHBBnBBBHBBJGCgBBB2BQQPBBHUUBEEKmDmDNBBcOOBBBjBNBiBOBtEDB7UVBMUB14BBB-LEBuBCCBDBCBB5BGBDNBZIBI4BI-DhBBb6C6CBKB3GZBxC3C3CBoDoDBDBsB-C-C3CIBxBuzcuzcBBB4BIB9KTB5FHB+GTB9BCBLFB5BHBnCHBNFB1DKBfCBvCMMBCBiB4B4BBHBPBBLBBoDXBdJBHBBHBBHIBIII9BDB-DBBLFBl9KLBYDByBDBvzIBBrDlBBILBGEBbGGCGDrUfBrBFB0BUUFDBGoEoEBCC-FCBHBBHBBHBBECBIIIBIBGBBNbbUDDQBBPhBB8DEBEDBuBCB5COOBBBCuBBvBhEBeCByBOBdDBlBIBfEBsBEBfmBmBBCBPpBB-EBBLFBlBDBlBDBpBHB1BKBNQQIDDMQQIDDBBB1BLB4JIBXJBJXBHrBrBKkCBHBBCtBtBDCBCBBYpCpCBGBKvBBUDDBDBiBCBcEBclBB5BDBVBBzBDDBDBJEEeBBEDBLGBKGBhCfBoBDBNIB3BCBeBBcEBbGBFLBIvCBqC2BB0BMB0BGBvBHBLFBnBCBeHBDvGBgBrBrBEBBDPBHHBKgBBvBHBrBVBblBBdTBYIBvCDBlBIBlCJBCBBaGBLFB2BTTBGBoBIBhDVVBJBTwBwBB8BBICCFQQMFB8BEBLFBFJJBDDBXXIDDGLLBDDBEEBCCBEBCEBIBBICBGKBLCCBCCnBLLCBBCFFLDDBGBDcB9CGGBcBpCHBLlFB3BBBnBhBBmCKBLFBOSB7BFBLFBVbBcBBQDBY4FB9BjDB0CLBJBBCBBJDDfDDBNNBHBLlCBJBBvBBBMaBpCHB0CMBqCGBL1CBJ3CBjBNBLFBKuBuBPJBeCBhBBBXPPBnCBIDDtBCBCDDKHBLFBHDDmBDDHGBLFBtBDBL1HBaGBSqBqBBBBe0CBCOBzBMB8clDBwDGGBJBlGryCBkDMB3iBJB88DEBoS41GB7Bl2BB6RGBgBLLBCByCLLBEBfBBHJBnCJBLIIWEBUvNB7BlGB8CEBaBBarBBsCDB6BGBS-BBGKBIIB3mHoBBhBgDB0D8vIBFIIDkJkJBNBCcBEBBCNBFHBtMjoCBsDEBOCBKGBLBBJ76DB+HCB1NFBYOBSOBvBBBYIB1D7BB3HJBoBBBjGUBnC5DBVLBVLB4CIBamEB2CoCoCDBBCBBDBBFNNCIIiCFFBJJIddFGGCCBI1K1KBlJlJB-V-VBNBGQQBuiBBgBFBH0GBISSBIIDGGBDB-BgBBCvDBuBCBPBBLDBD-JBgBQB7BEBCvOBrB1GBsBDBC-FBgBXXBGBD-GBIFFDQQmGBBRoBBtCDBLDBDwYBlCrCB+BhGBFccDCCBCCLFFCCCBEBCDBCECEDDCBBCICDCCBFFIKFCLLSEBEGGSzBBDtIBtBDBlDLBQBBQQQmBJBvF3BBeMBtBDBKGBDNBH5EB6eCBSCBOCB7GFBNDBCOBNDB5BHBLFBpBHBfBBNDBDNBKmBB5KHBPBBOCBMCB6BCCBCBRBBNDBLGB0EoDoDBjgBBh3pBfB-oEBBv0FBBypHOBvThtCB-QhvBBs6EEBrpIm8yVBCdBhD-DBxHvw-BB---BBB---BBB", false));
    },
    Co: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gg4B-nGh4hc9--BD9--B", true));
    },
    Cs: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gg2B--B", true));
    },
    L: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("hCZBHZBwBLLFGGBVBCeBCpOBFLBPEBICCiEEBCBBDDBCHHCCBCCCBSBCyCBCqEBJlFBClBBDHHBnBBoCaBFDBuBqBBkBBBCiDBCQQBIIBLLBBBDRRCdBe4CBMZZBfBKBBFGGBUBFKKEYYBXBIKBGXBCGBRpBB7B1BBETTIJBQPBFHBDBBDVBCGBCEEBCBERROBBCCBPBBLJJBEBFBBDVBCGBCBBCBBCBBgBDBCUUBBBRIBCCBCVBCGBCBBCEBETTQBBYMMBGBDBBDVBCGBCBBCEBEffBCCBBBQSSCFBECBCDBEBBCCCBEEBEEBBBELBX1B1BBGBCCBCWBCPBEbbBBBCBBDBBfFFBGBCCBCWBCJBCEBEffBBBCBBQBBSIBCCBCoBBDRRGCBJCBZFBGRBEXBCIBCDDBFB7BvBBCBBNGB7BBBCCCBDBCXBCCCBIBCBBKDDBDBCWWBCBhBgCgCBGBCjBBcEB0DqBBVRRBEBFDBEEEBIIBBBFMBNSSBkBBCGGDqBBCsKBCDBDGBCCCBCBDoBBCDBDgBBCDBDGBCCCBCBDOBC4BBCDBDiCBmBPBR1CBDFBErTBDQBCZBGqCBHHBIRBOSBPRBPMBCCBQzBBkBFFkC4CBIEBDhBBCGGBkCBLeByBdBDEBMrBBFZB3BWBK0BBzC+C+CBtBBSHB3BdBOBBLrBBbjBBqBCBLjBBDKBGqBBDCBqBDBCFBCBBEGGB+FBhC1IBDFBDlBBDFBDHBCGCBdBD0BBCGBCEEBBBCGBEDBDFBFMBGCBCGB1DOORMBmDFFDJBCEEBDBHGCBCBCKBDDBGEBF1B1BB8zC8zCBjHBHDBEBBNlBBCGGD3BBIRRBVBKGBCGBCGBCGBCGBCGBCGBCGBxC2O2OBrBrBBDBGBBF1CBHCBC5CBCDBGqBBC9CBSfBxBPBhQ-tGBhCs0VBkCtBBDsIBEPBLBBVuBBReBDlCByBIBDmDBDxCBVQBCCBCDBCWBezBBPxBB-BFBECCBMMBaBLWBacBIuBBdRRBDBCJBLEBCoBBYCBCHBVWBEEEBwBBCEEBDDBDBDCCZCBDKBICBNFBDFBDFBKGBCGBCqBBCNBHyDBej9KBNWBFwBBloItLBDpDBnBGBNEBGCCBIBCMBCEBCCCBCCBCCBqDBiBqLBT-BBD1BBpBLB1DEBCmEBlBZBHZBM4CBEFBDFBDFBDCBkBLBCZBCSBCBBCOBDNBjB6DBmMcBEwBBwBfBOTBCHBHlBBLdBDjBBFHBxB9EBTjBBFjBBFnBBJzBBNKBCOBCGBCBBCKBCOBCGBCBBEzBBN2JBKVBLHBZFBCpBBCIBmCFBDCCBqBBCBBEDDBVBLWBKeBiCSBCBBLVBLZBHZBnB3BBHBBhCQQBCBCCBCcBrBcBEcBkBHBCbBc1BBLVBLSBORBvDoCB4ByBBOyBBOjBBnBbBKWB7HpBBHBBRFB5BcBLJJBUBrBRBvBUBcWBN0BB6BBBDOOBrBBhBYBbjBBeDDJiBBENNBuBBPDBWCCkBRBCYBUBBgCGBCCCBCBCOBCJBIuBBnBHBDBBDVBCGBCBBCEBETTNEBfJBCDDClBBCaaCtBtBBzBBTDBVCBfvBBVBBC5F5FBtBBqBDBlBvBBV8B8BBpBBOoCoCBZBmBGB6FrBB1D-BBgBHBDDDBGBCBBCXBQCC-CHBDmBBRCCdLLBmBBIWWMtBBUTTBnCBoGgBBgBIBCkBBSyByBBcBxDGBCBBClBBWaaBEBCBBCfBPYYBqBBlISBQCCBLBChBB9DwCwCB4cBnHjGBtyCgDBQvhBBSFBa68DBGmSB61GdBj3B4RBIeBSuCBSdBTvBBRDBgBUBGSBxNsBB0G-BBhBYBDYBtBqCBGjCjCBLBhCBBCPPBNNB0mHBqBfBiDyDB+vIDBCGBCBBCiJBQeeBBBDPPBCBJrMBloCqDBGMBEIBIJBn7F0CBCmCBCBBDDDBDDBCBCLBCCCBFBCgCBCDBDHBCGBCbBCDBCEBCEEBFBCzKBDYBCYBCeBCYBCeBCYBCeBCYBCeBCYBCHB15BeBHFBmI9BBzEsBBLGBRiKiKBcBTrBBlPbBlHdBDwGwGBdBCCBCBBCGBDEBKBBhHGBCDBCBBCOBCkGB8BjCBI1lB1lBBCBCaBCBBCDDCJBCDBCCCHFFCECBBBCBBCDDCICBCCDDBCGBCDBCDBCCCBIBCQBGCBCEBCQBlqE-2pBBhB9oEBDt0FBDwpHBQtTBjtC9QBjvBq6EBGppIB", false));
    },
    LC: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("hCZBHZB7BLLBVBCeBCiGBCDBFvGBDZBhGDBDBBECBCHHCCBCCCBSBCyCBCqEBJlFBClBBKoBB44ClBBCGGDqBBDCBhV1CBDFBjkCKBGqBBDCBhCrBBgCMBChBBmD1IBDFBDlBBDFBDHBCGCBdBD0BBCGBCEEBBBCGBEDBDFBFMBGCBCGBmIFFDJBCEEBDBHGCBCBCFBFDDBCBGEBF1B1BB8zC8zCB6DBDmDBHDBEBBNlBBCGGzoetBBTbBnEtCBCWBEDBCsCBZBBE2Z2ZBpBBGIBIvCBh6TGBNEBqgBZBHZBmlBvCBhDjBBFjBB1DKBCOBCGBCBBCKBCOBCGBCBBk2ByBBOyBB+CVBLVB74C-BBhrV-BBhBYBDYBtpZ0CBCmCBCBBDDDBDDBCBCLBCCCBFBCgCBCDBDHBCGBCbBCDBCEBCEEBFBCzKBDYBCYBCeBCYBCeBCYBCeBCYBCeBCYBCHB15BJBCTBHFB2uCjCB", false));
    },
    Ll: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("hDZB7BqBqBBWBCHBC2BCBQCBuBCDECBBBDCCDEEBFFDEEBBBDDDCCCDCCBCCDEECDDBDDBBBHGDCOCBSCBDDCEEC4BCBFBDDDBCCFICBjCBDZBiGCCEEEBBBTccBhBBCBBECBCWCBDBCGDB0B0BBuBBCgBCK0BCDMCBgDCxBoBBo6CqBBDCB5XFBjkCIBC2D2DBqBBgCMBChBBnD0ECBHBCgDCBHBJFBLHBJHBJFBLHBJHBJNBDHBJHBJHBJEBCBBHEEBBBCBBJDBDBBJHBLCBCBBzIEEBEEcKFDBBJDBF2B2Bs1CvBBCEEBGCFCCBCCBEBGiDCBIICFFNlBBCGG0oesBCUaCoEMCBBBC+BCBGBCCCDICFCCDCCBBBCSCGGGCMCFCCDOCbEE2ZqBBGIBIvCBh6TGBNEBqhBZBumBnBBpEjBB8EKBCOBCGBCBBk4ByBB+DVB75CfBhsVfB8BYBnqZZBbGBCRBbZBbDBCCCBFBCKBbZBbZBbZBbZBbZBbZBbZBbZBbbBdYBCFBbYBCFBbYBCFBbYBCFBbYBCFBC15B15BBIBCTBHFB4vChBB", false));
    },
    Lm: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("wVRBFLBPEBICCmEGG-OnHnHlFBBuIBBFgBgBKEEhFoFoF1mBgEgE2R72B72BsDkTkTxOFBvF+BBOjBjBBjBByVOORMBg-CBByHgGgG2OsBsBBDBGiDiDB+C+CBBB34bjnBjnBBEBvIzDzDdBB6DIBxCYYpDDBEBB2OXXqEtDtDWBBoDDBKngVngVuBBBh-BFBCpBBCIB0sBhBhB2K04D04DnrTDB9PCBpBBBnRMBhCBBCPPB9-P9-PBCBCGBCBByhM9BBqGGBud0Q0QsSAB", false));
    },
    Lo: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("qFQQhIFFBCBxGBB7ZaBFDBuBfBCJBkBBBCiDBCZZBLLBBBDRRCdBe4CBMZZBfBWVBrBYBIKBGXBCGBRoBB8B1BBETTIJBROBFHBDBBDVBCGBCEEBCBERROBBCCBPBBLJJBEBFBBDVBCGBCBBCBBCBBgBDBCUUBBBRIBCCBCVBCGBCBBCEBETTQBBYMMBGBDBBDVBCGBCBBCEBEffBCCBBBQSSCFBECBCDBEBBCCCBEEBEEBBBELBX1B1BBGBCCBCWBCPBEbbBBBCBBDBBfFFBGBCCBCWBCJBCEBEffBBBCBBQBBSIBCCBCoBBDRRGCBJCBZFBGRBEXBCIBCDDBFB7BvBBCBBNFB8BBBCCCBDBCXBCCCBIBCBBKDDBDBYDBhBgCgCBGBCjBBcEB0DqBBVRRBEBFDBEEEBIIBBBFMBNyDyDBnKBCDBDGBCCCBCBDoBBCDBDgBBCDBDGBCCCBCBDOBC4BBCDBDiCBmBPByDrTBDQBCZBGqCBHHBIRBOSBPRBPMBCCBQzBBpBkCkCBhBBC0BBIEBDhBBCGGBkCBLeByBdBDEBMrBBFZB3BWBK0BBxFuBBSHB3BdBOBBLrBBbjBBqBCBLdByDDBCFBCBBE7hB7hBBCB4-C3BBZWBKGBCGBCGBCGBCGBCGBCGBCGBoR2B2BF1CBJCCB4CBFGGBpBBC9CBSfBxBPBhQ-tGBhC0wUBC2jBBkCnBBJrIBFPBLBBjCyByBBkCBqFoDoDEGBCCBCDBCWBezBBPxBB-BFBECCBMMBaBLWBacBIuBBuBEBDIBLEBCoBBYCBCHBVPBCFBEEEBwBBCEEBDDBDBDCCZBBEKBIPPBEBDFBDFBKGBCGByEiBBej9KBNWBFwBBloItLBDpDBkCCCBIBCMBCEBCCCBCCBCCBqDBiBqLBT-BBD1BBpBLB1DEBCmEBqDJBCsBBDeBEFBDFBDFBDCBkBLBCZBCSBCBBCOBDNBjB6DBmMcBEwBBwBfBOTBCHBHlBBLdBDjBBFHBhEtCBjDnBBJzBB9CzBBN2JBKVBLHB5EFBDCCBqBBCBBEDDBVBLWBKeBiCSBCBBLVBLZBHZBnB3BBHBBhCQQBCBCCBCcBrBcBEcBkBHBCbBc1BBLVBLSBORBvDoCB4FjBBnBDBCxJxJBoBBHBBRCBCBB5BcBLJJBUBrBRBvBUBcWBN0BB6BBBDOOBrBBhBYBbjBBeDDJiBBENNBuBBPDBWCCkBRBCYBUBBgCGBCCCBCBCOBCJBIuBBnBHBDBBDVBCGBCBBCEBETTNEBfJBCDDClBBCaaCtBtBBzBBTDBVCBfvBBVBBC5F5FBtBBqBDBlBvBBV8B8BBpBBOoCoCBZBmBGB6FrBB0GHBDDDBGBCBBCXBQCC-CHBDmBBRCCdLLBmBBIWWMtBBUTTBnCBoGgBBgBIBCkBBSyByBBcBxDGBCBBClBBWaaBEBCBBCfBPYYBnBBCBBlISBQCCBLBChBB9DwCwCB4cBnHjGBtyCgDBQvhBBSFBa68DBGmSB61GdBj3B4RBIeBSuCBSdBTvBB0BUBGSB0NnBB2MqCBGwFwFB0mHBqBfBiDyDBuwIiJBQeeBBBDPPBCBJrMBloCqDBGMBEIBIJBxzI2P2PBrBBiBiKiKBcBTrBBlPaBmHdBDwGwGBdBCCBCBBCGBDEBKiHiHBFBCDBCBBCOBCkGB8pBDBCaBCBBCDDCJBCDBCCCHFFCECBBBCBBCDDCICBCCDDBCGBCDBCDBCCCBIBCQBGCBCEBCQBlqE-2pBBhB9oEBDt0FBDwpHBQtTBjtC9QBjvBq6EBGppIB", false));
    },
    Lt: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("lOGDnB2sH2sHBGBJHBJHBNQQwBAB", false));
    },
    Lu: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("hCZBmDWBCGBiB2BCDOCDuBCBECEBBCCCBCCBBBDDBCBBCCBEBBCBBCECBCCDCCBCCBBBCCCBEEIJDCMCDQCDDDCCBC4BCIBBCBBDCCBCBCGCiJCCEJJHCCBBBCCCBCCBPBCIBkBDDBBBEWCGDDCBBDyBBxBgBCK2BCBMCD+CCDlBBq6ClBBCGGzW1CB0kCHHBpBBDCBhK0ECKgDCKHBJFBLHBJHBJFBMGCJHBpCDBNDBNDBNEBMDBnIFFECBDCBDEEBDBHGCBCBDDBLBBG+B+B9zCvBBxBCCBBBDGCBCBCDDJCBCgDCJCCFuqeuqeCqBCUaCoEMCE8BCLECBICFCCDCCEUCBDBCEBCOCBCBCCCBQCZs5Vs5VBYBmmBnBBpEjBB9EKBCOBCGBCBBr3ByBB+EVB75CfBhsVfBhCYBoqZZBbZBbZBbCCBGDBDDBCBCHBbZBbBBCDBDHBCGBcBBCDBCEBCEEBFBcZBbZBbZBbZBbZBbZBfYBiBYBiBYBiBYBiBYBiB2pE2pEBgBB", false));
    },
    M: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gYvDB0IGBoIsBBCCCBCCBCCpCKBxBUBRmDmDBFBDFBDBBCDBkBffBZB8CKB7BIBKZZBCBCIBCCBCEBsBCB8BIBrBXBCgBB3BCBCRBCGBLBBeCB5BCCBFBDBBDCBKLLBbbDCB5BCCBDBFBBDCBEffBEEMCB5BCCBGBCCBCCBVBBXFBCCB5BCCBFBDBBDCBICBLBBf8B8BBDBECBCDBKpBpBBDB4BCCBFBCCBCDBIBBMBBeCB5BCCBFBCCBCDBIBBMBBQNNBCB4BBBCGBCCBCDBKLLBeeBBBnCFFBEBCCCBGBTBB+BDDBFBNHBjDDDBHBMGBqCBBcECFBByBTBCBBGKBCjBBKlDlDBSBYDBFCBCCBDGBEDBOLBCLLBCBgWCBzdDBdCBeBBfBBhCfBKuBuBBBBC2D2DBjBjB3DLBFLB8GEB6BJBCcBDxBxBBsBBDLBVEBwBQBnBIBNCBfMB5BNBxBTB5ECBCUBFHHDCBnG-BBxWgBB--CCBuEhDhDBeBrRFBqDBB1udDBCJBhBBBxCBBxIEEFYYBDBF0C0CBzBzBBQBbRBOnBnBBGBaMBtBDBwBNBlBkCkCBMBNJJBuBuBBBBzBCCBBBDBBGBBCqBqBBDBGBBtHHBCBBx5TiXiXBOBRPBuejHjH2EEBn0BCBCBBGDBpBCBFmFmFB+R+RBCBiCEB+JBBuCFBnCKByBDB7DCB2BOBqBDDBLLBCBuBKBI+B+BBBBlBNBRBBtBNNBBBxBNBJDBCBB9CLBHDD+ELBWDB4BBBCGBDBBDCBKLLBDDBFBEEBkCIBCDDCDBCEBCPPBzCzCBQBYyCyCBSBsHGBDIBcBBzCQBrDMBmDOBhIOB2HFBCBBDDBCCCBuEuEBFBDGBEddBIBpBGBCDBJKKBJBvBPBnGHBoGHBCHBzCVBCNB7DFBECCBCCBFBCjCjCBDBCBBCEB8KDBKBBCxBxBBFBEEBYmnFmnFHOBpmLRBhuCEB8BGB5gBCCB1BBIDByCMMBslTslTBizEizEBsBBDWB-QEBEFBJHBDGBfDB1ECB89B2BBFxBBJPPXEBCOBxqBGBCQBDGBCBBCEBlDhFhFBFB4L+B+BBCB9PDB-HBB0HDDIBBG7O7OBFBuDGB29lYvHB", false));
    },
    Mc: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("joC4B4BDCBJDBCBBzBBB7BCBHBBDBBLsBsB7BCBjC7B7BBBBJCCB2B2BB7B7BCHHBDDBLLnDBBCBBECBCCBLqBqBBBB+BDB+BBB7BCCBDBDBBCBBKBBdPPB7B7BBBBGCBCCBLrBrBBsCsCBBBHHBTBBrKBBgCsFsFBFFHDDBaaBLLBBBDGBWBBDFBDLLBBB5zBffiEIIBGBCBB7KDBDCBFBBCFBhHBB7BCCKCCBJJBEByExBxBGCCBDBCBB+BffFBBD9B9BDCBCEEBxBxBBGBJBBsFWW35EBB0-dBBD5C5CBzBzBBOBvEBBwBxBxBBFFBDDBBBvDBBDBBZuBuBCuDuDDBBGuHuHBCCBCCBCC0gZCCgEuBuBBBBFBB0DZZB8B8BxBCBKBBO+C+CBBBEBBCrFrFBBBgBBB7BBBCDBDBBDCBKLLB1C1CBBBIDDCDBCBBCmDmDBBBJBBErDrDBBBHCCBCBDuHuHBBBHDBDyDyDBBBJBBCuDuDCBBHoDoDCBBFmImIBBBK4H4HBEBCBBFDDCvEvEBBBJDBF1C1CeBB-BqGqGECCoGPPrDIID2G2GBDBFBBC-K-KBNNxBBBJBBCpvQpvQBBBlxD2BBpDBB0rYBBHFB", false));
    },
    Me: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("okBBB1xF-wB-wBBCBCCBsshBCB", false));
    },
    Mn: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gYvDB0IEBqIsBBCCCBCCBCCpCKBxBUBRmDmDBFBDFBDBBCDBkBffBZB8CKB7BIBKZZBCBCIBCCBCEBsBCB8BIBrBXBCfB4BCCFHBFEEBFBLBBe7B7BFDBJVVBbbDBB6BFFBFFBDDBBBEffBEEMBB6BFFBDBCBBFVVBXXBEBC7B7BDCCBCBJIIBMMBff+BNNzBEE4BCCBBBGCBCDBIBBMBBe7B7BDHHGBBVBBdBB6BBBFDBJVVBeepCIIBBBC7C7CDGBNHBjDDDBHBMGBqCBBcEC4BNBCEBCBBGKBCjBBKnDnDBCBCFBCBBDBBaBBFCBRDBODDBHHQgWgWBBBzdCBeBBfBBfBBhCBBCGBJDDBJBKuBuBBBBC2D2DBjBjB3DCBFBBKHHBBB8GBBD7B7BCGBCCCDHBHJBDxBxBBMBCeBDLBVDBxBCCBDBCGGpBIBNBBhBDBDBBCCB5BCCBEECCB7BHBDBB5ECBCMBCGBFHHEBBnG-BBxWMBFEEBKB--CCBuEhDhDBeBrRDBsDBB1udFFBIBhBBBxCBBxIEEFaaBGG4EBBbRBOnBnBBGBaKBvBCBxBDDBCBDBBoBkCkCBEBDBBDBBNJJwB0B0BCCBDBBGBBCrBrBBJJvHDDFx5Tx5TiXPBRPBuejHjH2EEBn0BCBCBBGDBpBCBFmFmFB+R+RBCBiCEB+JBBuCFBnCKByBDB8D3B3BBNBqBDDBLLBBByBDBDBBI+B+BBBBlBEBCHB-BNNB1B1BBHBLDBDgDgDBBBDCCBHHD+E+EEHBWBB6BBBEmBmBBFBEEBnCFBOECPBB2CHBDCBCYY1CFBCFFBCCBvHvHBCBHBBCBBcBB2CHBDCCBrDrDCDDBEBCmDmDCDDBCBCEBkIIBCBBhIBBCFFxEDBDBBFhBhBBIBpBFBDDBJKKBEBDCBvBMBCBBnGCCBBBCqGqGBFBCFBCzCzCBUBDGBCBBCBB7DFBECCBCCBFBCpCpCBEEC8K8KBMMB1B1BBDBGCCYmnFmnFHOBpmLLBECBhuCEB8BGB5gBgCgCBCByC5lT5lTBizEizEBsBBDWBhRCBSHBDGBfDB1ECB89B2BBFxBBJPPXEBCOBxqBGBCQBDGBCBBCEBlDhFhFBFB4L+B+BBCB9PDB-HBB0HDDIBBG7O7OBFBuDGB29lYvHB", false));
    },
    N: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("wBJB5DBBGDDBBBitBJBnEJBnGJB9MJB3DJBFFBtDJB3DJB3DJBDFBvDMB0DJBJGBoDJBpDGBISBuDJBhDJB3DJBnCTBtIJBnCJBwWTBybCBwHJBHJBXJBtJJBhEKBmFJBHJB3FJB3CJBnEJBHJB3gBEEBEBHJBnGyBBDEB3W7BBvCVB3TdBqrBqYqYaIBPCB4KDBrEJBfHBCOBhBJBoBOBh7cJB9FJBhKFB7EJBnBJBnGJBXJB3CJB3MJB34UJBuPsBBN4BBSBB2KaBlBDBeJJnEEBrGJBvdHBaGBoBIBsCEBXFBhFBBDPBDtBBhCIB1BBBfCBsCEBpDHBZHBqBGBrKFBxBJBHJB3IeB-EJBrBDBxDGBnEdBhEJB9BJBxEJBITB8HJB3KJB3DJB3LJBnDJBHTBtCLBlNSB+CJB3UJB3CcBkHJBnCJB3BJBnLJBnDUBshBuDBimPJBnpCJB3CJBnEJBCGBvQJBnIWB+KCB6nXJBnuBTBNTBtDYB2iBxBBhqCJBnNJB3PJB4HJBtWIBhEJB4Y6BBCCBCDBtCsBBCOBjeMBk3CJB", false));
    },
    Nd: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("wBJnxBJnEJnGJ9MJ3DJ3DJ3DJ3DJ3DJ3DJ3DJ3DJ3DJhDJ3DJnCJ3IJnCJn6BJnBJtJJhEJnFJHJ3FJ3CJnEJHJnuiBJnVJnBJnGJXJ3CJ3MJ34UJnsBJnkCJHJ9YJhEJ9BJxEJ3IJ3KJ3DJ3LJnDJHTtCJnNJnDJ3UJ3CJ3HJnCJ3BJnLJ3uQJnpCJ3CJnEJ3QJ37XJ12CxBhqCJnNJ3PJ4HJ2aJ30EJ", true));
    },
    Nl: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("u3FCBwzCiBBDDB-zDaaBHBPCBs1dJBxyW0BBtOJJnEEBrhIuDBm8SCB", false));
    },
    No: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("yFBBGDDBBB2pCFB5LFB5DCBmEGB6GGBSIByNJB2hBTB0jBJBhP20B20BEFBHJBnGPBqB3W3WB6BBvCVB3TdBqrB1kB1kBBCBrEJBfHBCOBhBJBoBOBxrdFBymWsBBiCDBSBB2KaBlBDB1pBHBaGBoBIBsCEBXFBhFBBDPBDtBBhCIB1BBBfCBsCEBpDHBZHBqBGBrKFBhLeB-EJBrBDBxDGBnETB8LTBmqBBBvNIBobSB0aUBn8SGB-YWBqhZTBNTBtDYBvqFIBid6BBCCBCDBtCsBBCOBjeMB", false));
    },
    P: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("hBCBCFBCDBLBBEBBbCBCccCkBkBGEELBBEEE-VJJzOFBqBBB0BCCDDDtBBBVBBCBBOCCBBBrCDBnDsBsBBMBqHCB3BOBgBmImIBLLtE5D5D6DnMnMNwLwL7CLLBpFpFBNBCmBmBBCBoCrCrCBDBFBBwDFBsFlTlTBHB4EuTuTtBBBvCCBoCBB+ECBCCBmBKB6JBB5GBBhEGBCFBhFBBLGBdCB9DDB8BEB-BBBhCHBM9Z9ZBWBJTBCMBCLBfBBPBB6TDBeBB+hBNBwCBBgBJB0MVBgCDBhBBB8XDBCBBxDwEwEBtBBCfBDLBkNCBFJBDLBRNNjD7C7CjgdBBuICBkDLL0DFB9LDB3CBBpBCBCyByBBwBwBiDMBRBB9DDB-DBBRBB6HzqUzqUBxGxGBIBXiBBCNBCFFCBB2ECBCFBCDBLBBEBBbCBCccCCCBFB7MCB9UxBxB-MoXoXoGgBgBxIIBnBxDxDBFBjCGB6CDByO-J-JjBlElEBDBtBDB+FGBuDBBCDB-DDBxBBBwCDBFOOCCB5CFBsDrJrJBCCBzDzDBDBLBBCpDpD7HWBqDCBdMBtCjEjEBBB9HpIpIBBB8E9C9CBGB0CCBCEB+CJB4GgDgDBDBrBBBmUBBrCMBwFxjBxjBBDB97CBB8zOBBmEiCiCBDBJpRpRBBBoJDBoK9lT9lTovHEB07C-a-aBAB", false));
    },
    Pc: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("-Cg-Hg-HBUU-u3BBBZCBwHAB", false));
    },
    Pd: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("tB9qB9qB0BiyDiyDmgBqgCqgCBEBiwDDDgBBBFdd-NUUwDxszBxszBBmBmBLqFqFhzD-J-J", false));
    },
    Pe: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("pB0B0BgB+1D+1DC-6B-6BqtC4B4BQ7T7TCff-hBMCxChBhBCGC1MUChCCCiBmhBmhBCECtBGCtNICEGCDBB-ozB6G6GeOCESSCCCrF0B0BgBGD", false));
    },
    Pf: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("7F+6H+6HEddpuDCCFDDQEE", false));
    },
    Pi: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("rFt7Ht7HDBBDaapuDCCFDDQEE", false));
    },
    Po: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("hBCBCCBDECBLLBEEBcclCGGPBBI-V-VJzOzOBEBqB3B3BDDDtBBBVBBCBBOCCBBBrCDBnDsBsBBMBqHCB3BOBgBmImIBLLtE5D5D6DnMnMNwLwL7CLLBpFpFBNBCxDxDrCEBFBBwDFBsFlTlTBHBmY9D9DBBBoCBB+ECBCCBmBFBCDB6JBB5GBBhEGBCFBhFBBLGBdCB9DDB8BEB-BBBhCHBMjajaBJJBGBJIBDDBDCBEKBCCCBIB7kDDBCBBxDwEwEBFFBBBDDDBHBCBBCDDBLLBDBCJBDDBCCCBLBDCBtNCB6B+F+FjgdBBuICBkDLL0DFB9LDB3CBBpBCBCyByBBwBwBiDMBRBB9DDB-DBBRBB6HlxUlxUBFBDXXVBBDDBECBCDBICBHCCB2E2EBBBCCBDECBLLBEEBcclBDDB7M7MBBB9UxBxB-MoXoXoGgBgBxIIBnBxDxDBFBjCGB6CDB0ZlElEBDBtBDB+FGBuDBBCDB-DDBxBBBwCDBFOOCCB5CFBsDrJrJBCCBzDzDBDBLBBCpDpD7HWBqDCBdMBtCjEjEBBB9HpIpIBBB8E9C9CBGB0CCBCEB+CJB4GgDgDBDBrBBBmUBBrCMBwFxjBxjBBDB97CBB8zOBBmEiCiCBDBJpRpRBBBoJDBoK9lT9lTovHEB07C-a-aBAB", false));
    },
    Ps: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("oBzBzBgB-1D-1DC-6B-6B-rCEEnB4B4BQ7T7TCff-hBMCxChBhBCGC1MUChCCCiBmhBmhBCECaTTCECtNICEGCDipzBipzB4GeeCMCESSCCCrFzBzBgBEEDAB", false));
    },
    S: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("kBHHRCBgBCCcCCkBEBCBBDCCBCBDEEfgBgBrODBNNBGGBCCCBPB2DPPBxDxDsErIrIBBB3DCBDDDBvGvGLUUB4H4HIBBpEqLqLBHHB2H2H-DjEjEBGBlEwGwGqBmGmGiGCBQCCBBBDFBVECmEHBCFBCBBGDBmGBBxXJB0WuLuLlL+E+EBgBBiLJBKIBhiBCCBBBMCBOCBOCBOBBmCOOoBCBOCBUhBB-BBBCDBCBBLCCBBBGFBCECFMMBFFBDBGDBC7B7BBFFB2LBFcBD+HBXKByCtCBXnTBtBwBBDeBLyMBX+BBFfBD1LBDpEBmHFBmLBBvBZBC4CBN1GBbPBFOOBNNWBBHBB8CBB0HBBFJBhBlBBKRRBdBMdBJQQBeBLmBBQ-JBhuG-BBx0V2BB6RWBKBBoDBB+EDBLDB+RCBiHPPB+9T+9TpEgBBuLPBhCBB3BHBtBDBjDCCBBBD7E7EHRRBBBgBCCcCCiEGBCGBOBB6JIB6BQBDCBCMBEwBwBBrBB7zBBBwSmWmWBiKiKBGBnjC2kC2kCBbBr6SDBG3qU3qUk7DvHBLCBEzNBHWBQQBgDzDB9B1HBLmBBD7BBGCBXBBIdBF8BBWhCBE7F7FB1CBrbaagBaagBaagBaagBaa9B-PB4BDBzBHBCNBCBBp2BwNwNttCEE+DiOiOBvIvIBqBBFjDBNOBDOBCOBCkBBYgFB5BcBOrBBFIBIBBPFB7E4eBEQBEMBE5GBHLBFQQBKBF3BBJJBHnBBJdBDLBFBBPIBoB3KBJNBDMBEKBE4BBCFFBOBDLBFJBIyEBC7CBLAB", false));
    },
    Sc: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("kB+D+DBCBqnB8D8DzPBBzPBBI2H2HoImSmS8sClmClmCBgBB37hBkuVkuVtD7E7E8GBBEBB3-HDB-4wBxtCxtC", false));
    },
    Sk: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("+CCCoCHHFEEqQDBNNBGGBCCCBPB2DPPBjoBjoB15FCCBBBMCBOCBOCBOBB9kEBBkzdWBKBBoDBBxePPBniUniUBPB8bCCjF4g9B4g9BBDB", false));
    },
    Sm: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("rBRRBBB+BCCuBFFmBgBgB-XwQwQBBB8xGOOoBCBOCBsEoBoBBDBHlClCBDBGBBFGDIgBgBBDDCgBgBBqIBhBBB7CffBXBpBFB2OKK3BHBwDxKxKBDBDeBLPBhIiEBX+BBFfBDhIBxBUBDFB9+zB5Z5ZCCBlFRRBBB+BCCkEHHBCBitDBBhrwBx+Bx+BagBgBagBgBagBgBagBgBat5Ft5FB-uC-uCBHB", false));
    },
    So: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("mFDDFCCyerIrIBgEgEBvGvGLUUB4H4HkQ2L2LjEFBClElEwGqBqBoMCBQCCBBBDFBVECmEHBCFBCBBGDBmGBBxXJB0WzWzW+EhBBiLJBKIBksBBBCDBCBBLCCBHHBEBCECFMMBPPCBBC7B7BBKKBDBDDBCBBCBBCGBCeBDBBCCCBdBtIHBFTBDGBDwCBCdBanBBHnCBXKByCtCBX2FBCIBC1BBJuDBC3HBtBrBBhC-HBhQvBBWBBHmBBDpEBmHFBmLBBvBZBC4CBN1GBbPBFOOBNNWBBHBBxKBBFJBhBlBBKRRBdBMdBJQQBeBLmBBQ-JBhuG-BBx0V2BBibDBLBBC+R+RBBBqqUPBuLPBhCBB3BHBuBCBlPEEFBBOBB6JIB6BQBDCBCMBEwBwBBrBB7zBBBwSpgBpgBBGBnjC2kC2kCBGBFQBr6SDBG3qU3qUk7DvHBLCBEzNBHWBQPBhDzDB9B1HBLmBBD7BBGCBXBBIdBF8BBWhCBE7F7FB1CBqlB-PB4BDBzBHBCNBCBBp2B96C96CiEyWyWBqBBFjDBNOBDOBCOBCkBBYgFB5BcBOrBBFIBIBBPFB7E6HBG4WBEQBEMBE5GBHLBFQQBKBF3BBJJBHnBBJdBDLBFBB-B3KBJNBDMBEKBE4BBCFFBOBDLBFJBIyEBC7CBLAB", false));
    },
    Z: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gBgEgEgvFgsCgsCBJBeBBGwBwBh9DAB", false));
    },
    Zl: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("ohIA", true));
    },
    Zp: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("phIA", true));
    },
    Zs: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gBgEgEgvFgsCgsCBJBlBwBwBh9DAB", false));
    },
    ASCII_Hex_Digit: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("wBJIFbF", true));
    },
    Alphabetic: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("hCZBHZBwBLLFGGBVBCeBCpOBFLBPEBICC3CeeBQBCBBDDBCHHCCBCCCBSBCyCBCqEBJlFBClBBDHHBnBBoBNBCCCBCCBCCJaBFDBeKBG3BBCGBPlDBCHBFHBFCBLCBDRRBuBBOkDBZgBBKBBFGGBWBDSBUYBIKBGXBCGBIJJBoBBLLBEGBHrCBCPBCCBFOBOSBCHBDBBDVBCGBCEEBCBEHBDBBDBBCJJFBBCEBNBBLFFBBBCFBFBBDVBCGBCBBCBBCBBFEBFBBDBBFIIBCBCSSBEBMCBCIBCCBCVBCGBCBBCEBEIBCCBCBBEQQBCBWDBFCBCHBDBBDVBCGBCBBCEBEHBDBBDBBKBBFBBCEBORRBCCBEBECBCDBEBBCCCBEEBEEBBBELBFEBECBCCBEHHpBMBCCBCWBCPBEHBCCBCCBJBBCCBCBBDDBdDBCHBCCBCWBCJBCEBEHBCCBCCBJBBGCBCDBOCBNMBCCBCoBBDHBCCBCCBCGGBCBIEBXFBCCBCRBEXBCIBCDDBFBJFBCCCBGBTBBO5BBGGBH0B0BBECBDBCXBCCCBRBCCBDEBCHHPDBhBgCgCBGBCjBBFSBFPBCjBBkC2BBCDDBDBR-BBLDBDlBBCGGDqBBCsKBCDBDGBCCCBCBDoBBCDBDgBBCDBDGBCCCBCBDOBC4BBCDBDiCBmBPBR1CBDFBErTBDQBCZBGqCBEKBITBMUBNTBNMBCCBCBBNzBBDSBPFFkC4CBIqBBGlCBLeBCLBFIBYdBDEBMrBBFZB3BbBF+BBDTBzBYYBMMBBByBzBBCOBCHB0BpBBDDBLrBBCKBP2BBXCBLjBBDKBGqBBDCBqBDBCFBCBBEGGB+FBUhBBM1IBDFBDlBBDFBDHBCGCBdBD0BBCGBCEEBBBCGBEDBDFBFMBGCBCGB1DOORMBmDFFDJBCEEBDBHGCBCBCKBDDBGEBFSSBnBBuZzBB34BkHBHDBEBBNlBBCGGD3BBIRRBVBKGBCGBCGBCGBCGBCGBCGBCGBCfBwB2O2OBBBaIBIEBDEBF1CBHCBC5CBCDBGqBBC9CBSfBxBPBhQ-tGBhCs0VBkCtBBDsIBEPBLBBVuBBGHBEwDBoBIBDmDBDxCBVUBCgBBZzBBNjCBCtBtBBEBECCBBBLgBBGiBBOcBEyBBCLBQRRBOBLEBC2BBKNBTWBEkCBCCCZCBDPBDDBMFBDFBDFBKGBCGBCqBBCNBH6DBWj9KBNWBFwBBloItLBDpDBnBGBNEBGLBCMBCEBCCCBCCBCCBqDBiBqLBT-BBD1BBpBLB1DEBCmEBlBZBHZBM4CBEFBDFBDFBDCBkBLBCZBCSBCBBCOBDNBjB6DBmC0BBsIcBEwBBwBfBOdBGqBBGdBDjBBFHBCEBrB9EBTjBBFjBBFnBBJzBBNKBCOBCGBCBBCKBCOBCGBCBBEzBBN2JBKVBLHBZFBCpBBCIBmCFBDCCBqBBCBBEDDBVBLWBKeBiCSBCBBLVBLZBHZBnB3BBHBBhCDBCBBGHBCCBCcBrBcBEcBkBHBCbBc1BBLVBLSBORBvDoCB4ByBBOyBBOnBBjBbBEGGBVB7HpBBCBBEBBRFBzBCBEcBLJJBUBrBRBvBUBcWBKlCBsBEBL4BBKOOBXBYyBBSDBJiBBEKKB+BBCDBKBBLCCkBRBChBBDHHBCB-BGBCCCBCBCOBCJBI4BBYDBCHBDBBDVBCGBCBBCEBEHBDBBDBBEHHGGBdJBCDDClBBCJBCDDCDBCBBECCtBhCBCCBCDBVCBfhCBDBBC5F5FB0BBDGBaFBjB+BBCEE8B1BBDoCoCBZBDNBWGB6F4BBoD-BBgBHBDDDBGBCBBCdBCBBDBBDDB+CHBDtBBDFBCCCBccBxBBDJBSnCBGTTBnCBoDHB5CgBBgBIBCsBBCGBCyByBBcBDVBCNBqCGBCBBCrBBECCBCCBBBCDDBZZBEBCBBCkBBCBBCDBCYYBqBBlIWBKQBCoBBECBwDwCwCB4cBnDuDBSjGBtyCgDBQvhBBSFBa68DBGmSB61GuBBy2B4RBIeBSuCBSdBTvBBRDBgBUBGSBxNsBB0G-BBhBYBDYBtBqCBF4BBIQBhCBBCNNBFBK1mHBqBfBiDyDB+vIDBCGBCBBCiJBQeeBBBDPPBCBJrMBloCqDBGMBEIBIJBFi7Fi7FBzCBCmCBCBBDDDBDDBCBCLBCCCBFBCgCBCDBDHBCGBCbBCDBCEBCEEBFBCzKBDYBCYBCeBCYBCeBCYBCeBCYBCeBCYBCHB15BeBHFB2GGBCQBDGBCBBCEBG9BBiBxDxDBrBBLGBRiKiKBcBTrBBlPbBlHdBDwGwGBdBCVBJBBhHGBCDBCBBCOBCkGB8BjCBEEE1lBDBCaBCBBCDDCJBCDBCCCHFFCECBBBCBBCDDCICBCCDDBCGBCDBCDBCCCBIBCQBGCBCEBCQB1TZBHZBHZB3zD-2pBBhB9oEBDt0FBDwpHBQtTBjtC9QBjvBq6EBGppIB", false));
    },
    Dash: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("tB9qB9qB0BiyDiyDmgBqgCqgCBEB+BoBoBQnMnMlgDDDgBBBFdd-NUUwDxszBxszBBmBmBLqFqFhzD-J-J", false));
    },
    Emoji: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("jBHHGJBwDFFu8HNN5GXX7CFBQBBwLBBNnFnFaKBFCBoGoHoHBLLK7B7BBCBCEBKGDBDDFDDCBBDIEBJJBBBGCCGLBMBBDCCBCCTDDBTTBEBCCCBEEBGGDBBFBBMBBGBBDGGBECBVVBGGBEBCDBDFFDDDBEBCDDCCCHEEHLLBQQDFFCFFBBBCMMBxBxBBBBKeP1LBBwOCBUBB0BFF7mBNN6SCCrrvDrGrGhFBBNBBPDDBIBsCZBCBBYVVDIBWBBvFhBBDvDBDBBCCBDyCBDCBCmIBC+BBMFBCXBIBBDHBNDDBCBDFFBOOBDDJBBKGGBBBNCBJCBDCCFHHEHHB0CBxBlCBGHBDDBEJBECCBEEDJBkHLBF8I8IBtBBCJBC4FBxDMBEKBE4BBCFFBOBDLBFJB", false));
    },
    Emoji_Component: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("jBHHGJB0+H2G2Gsp3B3+8B3+8BBYB8PEBxtBDBtzhY-CB", false));
    },
    Emoji_Modifier: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("7-8DE", true));
    },
    Emoji_Modifier_Base: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("9wJ8G8GRDB4jzD9B9BBBBDDDBBB2DBBDKBWSBEFFBBBCCBICCZqGqGBFFWFFBvFvFBBBEEB0CRRBBBKMMgSDDJHBHKKBIBDCB5B+B+BBCCBCCSCBCMBmHCBrBIB", false));
    },
    Emoji_Presentation: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("64IBBuGDBEDDqQBBWBBzBLBsBUUOJJBSSBGGBJJGWWIBBCFFDIIFBBdkBkBCFFBBBC+B+BBBBZPP8aBB0BFFvlxDrGrG-FDDBIBsCZBCZZVDDBDBCCBWBBvFgBBNIBClCBCVBNqBBFEBNQBEEEBlCBCCCB5FBD+BBODBCXBTbbBOO3C0CBxBlCBHEEBBBDDBEDBMBBIIBkHLBF8I8IBtBBCJBC4FBxDMBEKBE4BBCFFBOBDLBFJB", false));
    },
    Extended_Pictographic: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("pFFFu8HNN5GXX7CFBQBBwLBBNnFnFaKBFCBoGoHoHBLLK7B7BBCBCEBKGDBDDFDDCBBDIEBJJBBBGCCGLBMBBDCCBCCTDDBTTBEBCCCBEEBGGDBBFBBMBBGBBDGGBECBVVBGGBEBCDBDFFDDDBEBCDDCCCHEEHLLBQQDFFCFFBBBCMMBxBxBBBBKeP1LBBwOCBUBB0BFF7mBNN6SCCrrvDoBoBBCBlDLBQBBQPPBmBmBBIBxDBBNBBPDDBIBU3BBcOBLVVDIBCDBKWBH7FBDvDBDBBCCBDyCBDCBCDBG9HBC+BBMFBCXBIBBDHBNDDBCBDFFBOOBDDJBBKGGBBBNCBJCBDCCFHHEHHB0CBxBlCBGHBDQBECCBEBDMB7GlBBNDB5BHBLFBpBHBfBBNDBDNBKmBBNuBBCJBC4FB5CHBPxEBhI9fB", false));
    },
    Hex_Digit: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("wBJIFbFq1-BJIFbF", true));
    },
    Lowercase: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("hDZBwBLLFlBlBBWBCHBC2BCBQCBuBCDECBBBDCCDEEBFFDEEBBBDDDCCCDCCBCCDEECDDBDDBBBHGDCOCBSCBDDCEEC4BCBFBDDDBCCFICBjCBDiBBIBBfEBhDsBsBCEEDDBTccBhBBCBBECBCWCBDBCGDB0B0BBuBBCgBCK0BCDMCBgDCxBoBBo6CqBBCDB5XFBjkCIBC2D2DB+FBiC0ECBHBCgDCBHBJFBLHBJHBJFBLHBJHBJNBDHBJHBJHBJEBCBBHEEBBBCBBJDBDBBJHBLCBCBB6DOORMBuDEEBEEcKFDBBJDBFiBiBBOBFsasaBYBn6BvBBCEEBGCFCCBCCBGBEiDCBIICFFNlBBCGG0oesBCUaCBBBmEMCBBBC8BCBIBCCCDICFCCDCCBBBCSCGGGCMCFCCDOCWDBCCCBBB2ZqBBCNBHvCBh6TGBNEBqhBZBumBnBBpEjBB8EKBCOBCGBCBBkODDBBBCpBBCIBmoByBB+DVB75CfBhsVfB8BYBnqZZBbGBCRBbZBbDBCCCBFBCKBbZBbZBbZBbZBbZBbZBbZBbZBbbBdYBCFBbYBCFBbYBCFBbYBCFBbYBCFBC15B15BBIBCTBHFBmI9BB1lChBB", false));
    },
    Math: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("rBRRBBBgBeeCuBuBFmBmBgB5W5WBBBDbbBDDBBBwQCBuwGccBBBMEEOPPBCBWEBMEBiCMBFEEBFFBDBTFFDJBCDDBEBHEEBDDBCCBBBCFBENBClClCBWBCFBCBBFBBFfBCHHBPPBqIBJDBVBB7CffBZBCZZMGB+NBBNJBFFBFBBDBBEEBPCCDFBMHBGBB6BCCeDBKCBxK-BBhI-PBxBUBDFB9+zB4Z4ZBEBCjFjFRCBeCCeCCkEHHBCBitDBBhrwBwoBwoBBzCBCmCBCBBDDDBDDBCBCLBCCCBFBCgCBCDBDHBCGBCbBCDBCEBCEEBFBCzKBDjJBDxBBhwFDBCaBCBBCDDCJBCDBCCCHFFCECBBBCBBCDDCICBCCDDBCGBCDBCDBCCCBIBCQBGCBCEBCQB1BBB-uCIB", false));
    },
    Quotation_Mark: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("iBFFkEQQ96HHBaBBowDqOqOBCBOCBixzBDB+FFF7CBB", false));
    },
    Terminal_Punctuation: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("hBLLCMMBEE-ZJJiQ6B6BpCPPCCB1FsBsBBJBCsHsHB3B3BBEBCHBgBmImIB1nB1nBBtFtFFFB4JBB2YHBmY9D9DBBBoCBB+ECBEoBoBBCBDBB7JBBjLDBjFBBLBBCCBeCB8FEB-BBBldYYBKKBBBwlDCBzJOOFLLCBBEBBtNBB8ndBBuICBkHEB-LBB3CBBgD4E4EBBB0ECBgERRB6H6HnxUDDB6B6BBBBCDBqFLLCMMBEEiCDD7hBxBxBnkBoGoG3JBB5EFBlCFB6CDB5dEBtBDB+FGBxDDBgECBiEBBHRRB5C5CBDBtDrJrJB2D2DBBBNBBnLDBEOBqDBB6HCBmQCC8HBB4CBBFBB-MCBuBmUmUBrCrCBspBspBBDB6vRBBmEiCiCBBBLqRqRBoJoJBnwTnwTovHDB", false));
    },
    Uppercase: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("hCZBmDWBCGBiB2BCDOCDuBCBECEBBCCCBCCBBBDDBCBBCCBEBBCBBCECBCCDCCBCCBBBCCCBEEIJDCMCDQCDDDCCBC4BCIBBCBBDCCBCBCGCiJCCEJJHCCBBBCCCBCCBPBCIBkBDDBBBEWCGDDCBBDyBBxBgBCK2BCBMCD+CCDlBBq6ClBBCGGzW1CB0kCHHBpBBDCBhK0ECKgDCKHBJFBLHBJHBJFBMGCJHBpCDBNDBNDBNEBMDBnIFFECBDCBDEEBDBHGCBCBDDBLBBGbbBOBUzZzZBYBx5BvBBxBCCBBBDGCBCBCDDJCBCgDCJCCFuqeuqeCqBCUaCoEMCE8BCLECBICFCCDCCEUCBDBCEBCOCBCBCCCBQCZs5Vs5VBYBmmBnBBpEjBB9EKBCOBCGBCBBr3ByBB+EVB75CfBhsVfBhCYBoqZZBbZBbZBbCCBGDBDDBCBCHBbZBbBBCDBDHBCGBcBBCDBCEBCEEBFBcZBbZBbZBbZBbZBbZBfYBiBYBiBYBiBYBiBYBiB2pE2pEBgBBvgCZBHZBHZB", false));
    },
    White_Space: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("JEBTlDlDbgvFgvFgsCKBeBBGwBwBh9DAB", false));
    }
})), (0, $6tY97._)($f8c5210791d45577$var$_class1, "SCRIPTS", new $f8c5210791d45577$var$LazyMap({
    Adlam: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("go6DrCFJFB", true));
    },
    Ahom: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g4lCaDOFW", true));
    },
    Anatolian_Hieroglyphs: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("ggxCmS", true));
    },
    Arabic: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gwBEBCFBCNBCCBCfBCJBMZBCrDBChBBxCvBBxHhBBGqCBCcBxy8BtPBDvEBhBPBxDEBCmEBk7DeBkCFBJIBiBFBh43BDBCaBCBBCDDCJBCDBCCCHFFCECBBBCBBCDDCICBCCDDBCGBCDBCDBCCCBIBCQBGCBCEBCQB1BBB", false));
    },
    Armenian: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("xpBlBDxBDCks9BE", true));
    },
    Avestan: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g4iC1BEG", true));
    },
    Balinese: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g4GsCCxB", true));
    },
    Bamum: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g1pB3CpowB4R", true));
    },
    Bassa_Vah: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("w26CdDF", true));
    },
    Batak: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g+GzBJD", true));
    },
    Bengali: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gsCDBCHBDBBDVBCGBCEEBCBDIBDBBDDBJFFBCCBDBDYB", false));
    },
    Beria_Erfe: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g17CYDY", true));
    },
    Bhaiksuki: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("ggnCICsBCNLc", true));
    },
    Bopomofo: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("qXB6wLqBxDf", true));
    },
    Brahmi: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("ggkCtCFjBKA", true));
    },
    Braille: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("ggK-H", true));
    },
    Buginese: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gwGbDB", true));
    },
    Buhid: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g6FT", true));
    },
    Canadian_Aboriginal: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("ggF-TxRlC7tgCP", true));
    },
    Carian: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g1gCwB", true));
    },
    Caucasian_Albanian: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("wphCzBMA", true));
    },
    Chakma: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gokC0BCR", true));
    },
    Cham: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gwqB2BKNDJDD", true));
    },
    Cherokee: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g9E1CDFz7lBvC", true));
    },
    Chorasmian: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("w9jCb", true));
    },
    Common: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("AgCBbFBbuBBCOBCEBYgBgBiOmBBGEBDTB1DKKHCC+THHPEEhB9E9ElQiEiEB6mB6mB2MDBjJwvBwvBBBBoCBBsGBBCumBumBOIIBCBCFBCCBDmYmYBKBD2CBCKBEKBCOBShBB-BlBBCCBDFBCaBCQBqBCBF5UBXKBW-cBhIzTBDpEBhQ9CBzMUBCCCBXBQHBFDB8CBBE7C7CB0E0EBOBhBlBBKxBxBB+BBgBwCBwB5C5CBmFBhuG-BBhoWhBBnDCBmFJB1HhFhFsMPPBzuUzuUBxGxGBIBXiBBCSBCDB0ECCBeBbFBbKBLuBuBBhChCBFBCGBLEBjICBFsBBEIBxCMB0BsBBlHaBltuBDB96D8HBEzNBHWBQQBgDzDB9B1HBLmBBD9BBEQBJBBIdBF8BB2GTBNTBN2CBKYBoE0CBCmCBCBBDDDBDDBCBCLBCCCBFBCgCBCDBDHBCGBCbBCDBCEBCEEBFBCzKBDjJBDxBByjFjCBtC8BBjWrBBFjDBNOBDOBCOBCkBBLtFB5BZBCBBOrBBFIBIBBPFB7E4eBEQBEMBE5GBHLBFQQBKBF3BBJJBHnBBJdBDLBFBBPIBoB3KBJNBDMBEKBE4BBCFFBOBDLBFJBIyEBCmDBnghYffB+CB", false));
    },
    Coptic: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("ifNxkKzDGG", true));
    },
    Cuneiform: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("ggoC5cnDuDCEMjG", true));
    },
    Cypriot: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("ggiCFBDCCBqBBCBBEDD", false));
    },
    Cypro_Minoan: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("w8rCiD", true));
    },
    Cyrillic: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("ggBkEBDoFBx6FKBhFtCtCojEfBhie-CBv8VBBhw4B9BBiBAB", false));
    },
    Deseret: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gghCvC", true));
    },
    Devanagari: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("goCwCFODZh7nBfhwcJ", true));
    },
    Dives_Akuru: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gomCGBDDDBGBCBBCdBCBBDLBKJB", false));
    },
    Dogra: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("ggmC7B", true));
    },
    Duployan: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("ggvDqDGMEIIJDD", true));
    },
    Egyptian_Hieroglyphs: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("ggsC1iBL68D", true));
    },
    Elbasan: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gohCnB", true));
    },
    Elymaic: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g-jCW", true));
    },
    Ethiopic: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gwEoCBCDBDGBCCCBCBDoBBCDBDgBBCDBDGBCCCBCBDOBC4BBCDBDiCBDfBEZBnvGWBKGBCGBCGBCGBCGBCGBCGBCGBjpfFBDFBDFBKGBCGBylvCGBCDBCBBCOB", false));
    },
    Garay: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gqjClBEcJB", true));
    },
    Georgian: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("glElBBCGGDqBBCDBx8CqBBDCBhiElBBCGG", false));
    },
    Glagolitic: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("ggL-Ch9sDGCQDGCBCE", true));
    },
    Gothic: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("w5gCa", true));
    },
    Grantha: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g4kCDBCHBDBBDVBCGBCBBCEBDIBDBBDCBDHHGGBDGBEEB", false));
    },
    Greek: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("wbDBCCBDDBCFFCCCBBBCCCBSBC+BBPPBnpGEBzBEBFEB1ChKhKBUBDFBDlBBDFBDHBCGCBdBD0BBCOBCNBDFBCSBDCBCIBoJ-xiB-xiB7uVuCBSgj0Bgj0BBkCB", false));
    },
    Gujarati: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("h0CCBCIBCCBCVBCGBCBBCEBDJBCCBCCBDQQBCBDLBIGB", false));
    },
    Gunjala_Gondi: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("grnCFCBCkBCBCFIJ", true));
    },
    Gurmukhi: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("hwCCBCFBFBBDVBCGBCBBCBBCBBDCCBDBFBBDCBEIIBCBCIIBPB", false));
    },
    Gurung_Khema: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("go4C5B", true));
    },
    Han: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g0LZBC4CBN1GBwBCCaIBPDBle-tGBhC-vUBhoWtLBDpDBpodBBNGBqgkB-2pBBhB9oEBDt0FBDwpHBQtTBjtC9QBjvBq6EBGppIB", false));
    },
    Hangul: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("goE-HvxHBiI9CyDeiCei3dckUj9KNWFwBl9JeEFDFDFDC", true));
    },
    Hanifi_Rohingya: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gojCnBJJ", true));
    },
    Hanunoo: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g5FU", true));
    },
    Hatran: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gniCSCBGE", true));
    },
    Hebrew: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("xsB2BBJaBFFBpp9BZBCEBCCCBCCBCCBIB", false));
    },
    Hiragana: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("hiM1CBHCBi7-C+IBTeeBBBulQAB", false));
    },
    Imperial_Aramaic: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("giiCVCI", true));
    },
    Inherited: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gYvDB2IBBlOKBbhXhXBCB8qEtBBDLBlPCBCMBCGBFHHEBBnG-BBtQBBjGgBB65DDBsDBBmrzBPBRNBwejHjH7iEl+uBl+uBBsBBDWBhRCBSHBDGBfDBz6rYvHB", false));
    },
    Inscriptional_Pahlavi: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g7iCSGH", true));
    },
    Inscriptional_Parthian: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g6iCVDH", true));
    },
    Javanese: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gsqBtCDJFB", true));
    },
    Kaithi: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gkkCiCLA", true));
    },
    Kannada: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gkDMCCCWCJCEDICCCDIBGCCDDJCC", true));
    },
    Katakana: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("hlM5CBDCBxHPBxGuBBC3CBvgzBJBCsBBzisBDBCGBCBBCgJgJBBBzBPPBCB", false));
    },
    Kawi: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g4nCQCoBEc", true));
    },
    Kayah_Li: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("goqBtBCA", true));
    },
    Kharoshthi: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gwiCDCBGHCCCcDCFJII", true));
    },
    Khitan_Small_Script: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("k-7C84G84GB0OBqBAB", false));
    },
    Khmer: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g8F9CDJHJnPf", true));
    },
    Khojki: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gwkCRCuB", true));
    },
    Khudawadi: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("w1kC6BGJ", true));
    },
    Kirat_Rai: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gq7C5B", true));
    },
    Lao: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("h0DBBCCCBDBCXBCCCBVBDEBCCCBFBCJBDDB", false));
    },
    Latin: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("hCZBHZBwBQQGWBCeBCgOBoBEB8wGlBBHwBBGDBGMBClCBiC-HByLOORMBuEBBHccSoBB42CfBj1elDBExCBVOBxZqBBCIBCDB38TGB7gBZBHZBmhCFBCpBBCIBm61BeBHFB", false));
    },
    Lepcha: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("ggH3BEOEC", true));
    },
    Limbu: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("goGeBCLBFLBFEEBKB", false));
    },
    Linear_A: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gwhC2JKVLH", true));
    },
    Linear_B: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gggCLCZCSCBCODNjB6D", true));
    },
    Lisu: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("wmpBvBx1eA", true));
    },
    Lycian: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g0gCc", true));
    },
    Lydian: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gpiCZGA", true));
    },
    Mahajani: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("wqkCmB", true));
    },
    Makasar: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g3nCY", true));
    },
    Malayalam: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("goDMCCCyBCCCFFPDZ", true));
    },
    Mandaic: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("giCbDA", true));
    },
    Manichaean: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g2iCmBFL", true));
    },
    Marchen: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("wjnCfDVCN", true));
    },
    Masaram_Gondi: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gonCGBCBBCrBBECCBCCBHBJJB", false));
    },
    Medefaidrin: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gy7C6C", true));
    },
    Meetei_Mayek: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g3qBWqGtBDJ", true));
    },
    Mende_Kikakui: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gg6DkGDP", true));
    },
    Meroitic_Cursive: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gtiCXFTDtB", true));
    },
    Meroitic_Hieroglyphs: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gsiCf", true));
    },
    Miao: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g47CqCF4BIQ", true));
    },
    Modi: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gwlCkCMJ", true));
    },
    Mongolian: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("ggGBBDCCBSBH4CBIqBB2t-BMB", false));
    },
    Mro: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gy6CeCJFB", true));
    },
    Multani: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g0kCGBCCCBCBCOBCKB", false));
    },
    Myanmar: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("ggE-EhqmBeiDfxibT", true));
    },
    Nabataean: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gkiCeJI", true));
    },
    Nag_Mundari: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("wm5DpB", true));
    },
    Nandinagari: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gtmCHDtBDK", true));
    },
    New_Tai_Lue: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gsGrBFZHKEB", true));
    },
    Newa: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gglC7CCE", true));
    },
    Nko: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g+B6BDC", true));
    },
    Nushu: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("h-7CvsQvsQBqMB", false));
    },
    Nyiakeng_Puachue_Hmong: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("go4DsBENDJFB", true));
    },
    Ogham: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g0Fc", true));
    },
    Ol_Chiki: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("wiHvB", true));
    },
    Ol_Onal: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("wu5DqBFA", true));
    },
    Old_Hungarian: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gkjCyBOyBIF", true));
    },
    Old_Italic: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g4gCjBKC", true));
    },
    Old_North_Arabian: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g0iCf", true));
    },
    Old_Permic: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("w6gCqB", true));
    },
    Old_Persian: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g9gCjBFN", true));
    },
    Old_Sogdian: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g4jCnB", true));
    },
    Old_South_Arabian: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gziCf", true));
    },
    Old_Turkic: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("ggjCoC", true));
    },
    Old_Uyghur: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("w7jCZ", true));
    },
    Oriya: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("h4CCCHDBDVCGCBCEDIDBDCICFBCEDR", true));
    },
    Osage: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("wlhCjBFjB", true));
    },
    Osmanya: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gkhCdDJ", true));
    },
    Pahawh_Hmong: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g46ClCLJCGCUGS", true));
    },
    Palmyrene: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gjiCf", true));
    },
    Pau_Cin_Hau: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g2mC4B", true));
    },
    Phags_Pa: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("giqB3B", true));
    },
    Phoenician: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("goiCbEA", true));
    },
    Psalter_Pahlavi: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g8iCRIDNG", true));
    },
    Rejang: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("wpqBjBMA", true));
    },
    Runic: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g1FqCEK", true));
    },
    Samaritan: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("ggCtBDO", true));
    },
    Saurashtra: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gkqBlCJL", true));
    },
    Sharada: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gskC-ChsCH", true));
    },
    Shavian: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("wihCvB", true));
    },
    Siddham: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gslC1BDlB", true));
    },
    Sidetic: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gqiCZ", true));
    },
    SignWriting: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gg2DrUQECO", true));
    },
    Sinhala: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("hsDCBCRBEXBCIBCDDBFBEFFBEBCCCBGBHJBDCBt-gCTB", false));
    },
    Sogdian: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("w5jCpB", true));
    },
    Sora_Sompeng: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("wmkCYIJ", true));
    },
    Soyombo: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("wymCyC", true));
    },
    Sundanese: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g8G-BhIH", true));
    },
    Sunuwar: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g+mChBPJ", true));
    },
    Syloti_Nagri: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("ggqBsB", true));
    },
    Syriac: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g4BNC7BDCxIK", true));
    },
    Tagalog: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g4FVKA", true));
    },
    Tagbanwa: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g7FMCCCB", true));
    },
    Tai_Le: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("wqGdDE", true));
    },
    Tai_Tham: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gxG+BCcDKHJHN", true));
    },
    Tai_Viet: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g0qBiCZE", true));
    },
    Tai_Yo: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g25DeCVJB", true));
    },
    Takri: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g0lC5BHJ", true));
    },
    Tamil: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("i8CBBCFBECBCDBEBBCCCBEEBEEBBBELBFEBECBCDBDHHPUBm+kCxBBOAB", false));
    },
    Tangsa: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("wz6CuCCJ", true));
    },
    Tangut: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g-7CgBgBB+3GBhQeBiDyDB", false));
    },
    Telugu: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("ggDMCCCWCPDICCCDIBCCCBDDDJII", true));
    },
    Thaana: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g8BxB", true));
    },
    Thai: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("hwD5BGb", true));
    },
    Tibetan: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g4DnCCjBFmBCjBCOCGFB", true));
    },
    Tifinagh: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("wpL3BIBPA", true));
    },
    Tirhuta: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gklCnCJJ", true));
    },
    Todhri: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("guhCzB", true));
    },
    Tolong_Siki: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("wtnCrBFJ", true));
    },
    Toto: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("w04De", true));
    },
    Tulu_Tigalari: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g8kCJBCDDClBBCJBCDDCDBCJBCBBJBB", false));
    },
    Ugaritic: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g8gCdCA", true));
    },
    Unknown: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("4bBBHDBICCVuMuMnBBBzBBBE4B4BBGBcDBHKBvI9B9BBmDmDBMB8BBByBBBQddBCCMEBjBEBuHJJBDDBXXICCBBBFBBKBBDBBFHBCDBDGGBaaBEEHDBDBBXIIDGDBCCGDBDBBECBCGBFCCBFBSJBEKKEXXIDDGBBLIEBCCBNBFBBNGBIEEJBBDBBXIIDGGBKKBDDBEEBFBEDBDGGBTTBIBDHHBBBEFFBBBDCCDCBDCBECBNDBGCBEFFBCCBEBCNBWEBOEEYRRBKKEFFBFBDEEDBBFBBLGBXEEYLLGBBKEEFGBDEBEFFBLLELBOEE0BEEHDBRBBbEETCBZKKCBBICBCDBHCCJFBLBBELB7BDBekBBDCCGZZCYYBGGCIILBBFfBpClBlBBCBoBlBlBQOOBjBBnGCCBDBCBB6LFFBIICFFBqBqBFBBiBFFBIICFFBQQ6BFFBkCkCBhBhBBBBbFB3CBBHBB+UCB6CGBXIBZIBVLBOEEDLB-CBBLFBLFBbFB6CGBsBEBnCJBgBNNBCBNDBCCBrBBBGKBtBDBbFBMCB-BBBiCeeBMMBEBLFBPBBvBBBNTBuCnFnFBGB9BCBQCB-BEBsBBBMHBsBEB3QBBHBBnBBBHBBJGCgBBB2BQQPBBHUUBEEKmDmDNBBcOOBBBjBNBiBOBtEDB7UVBMUB14BBB-LEBuBCCBDBCBB5BGBDNBZIBI4BI-DhBBb6C6CBKB3GZBxC3C3CBoDoDBDBsB-C-C3CIBxBuzcuzcBBB4BIB9KTB5FHB+GTB9BCBLFB5BHBnCHBNFB1DKBfCBvCMMBCBiB4B4BBHBPBBLBBoDXBdJBHBBHBBHIBIII9BDB-DBBLFBl9KLBYDByBjoIBvLBBrDlBBILBGEBbGGCGDrUfBrBFB0BUUFDBGoEoEBCC-FCBHBBHBBHBBECBIIIBIBGBBNbbUDDQBBPhBB8DEBEDBuBCB5COOBBBCuBBvBhEBeCByBOBdDBlBIBfEBsBEBfmBmBBCBPpBB-EBBLFBlBDBlBDBpBHB1BKBNQQIDDMQQIDDBBB1BLB4JIBXJBJXBHrBrBKkCBHBBCtBtBDCBCBBYpCpCBGBKvBBUDDBDBiBCBcEBclBB5BDBVBBzBDDBDBJEEeBBEDBLGBKGBhCfBoBDBNIB3BCBeBBcEBbGBFLBIvCBqC2BB0BMB0BGBvBHBLFBnBCBeHBDvGBgBrBrBEBBDPBHHBKgBBvBHBrBVBblBBdTBYIBvCDBlBIBlCJBCBBaGBLFB2BTTBGBoBIBhDVVBJBTwBwBB8BBICCFQQMFB8BEBLFBFJJBDDBXXIDDGLLBDDBEEBCCBEBCEBIBBICBGKBLCCBCCnBLLCBBCFFLDDBGBDcB9CGGBcBpCHBLlFB3BBBnBhBBmCKBLFBOSB7BFBLFBVbBcBBQDBY4FB9BjDB0CLBJBBCBBJDDfDDBNNBHBLlCBJBBvBBBMaBpCHB0CMBqCGBL1CBJ3CBjBNBLFBKuBuBPJBeCBhBBBXPPBnCBIDDtBCBCDDKHBLFBHDDmBDDHGBLFBtBDBL1HBaGBSqBqBBBBe0CBCOBzBMB8clDBwDGGBJBlGryCBkDMB3iBJB88DEBoS41GB7Bl2BB6RGBgBLLBCByCLLBEBfBBHJBnCJBLIIWEBUvNB7BlGB8CEBaBBarBBsCDB6BGBS-BBGKBIIB3mHoBBhBgDB0D8vIBFIIDkJkJBNBCcBEBBCNBFHBtMjoCBsDEBOCBKGBLBBJ76DB+HCB1NFBYOBSOBvBBBYIB1D7BB3HJBoBBBjGUBnC5DBVLBVLB4CIBamEB2CoCoCDBBCBBDBBFNNCIIiCFFBJJIddFGGCCBI1K1KBlJlJB-V-VBNBGQQBuiBBgBFBH0GBISSBIIDGGBDB-BgBBCvDBuBCBPBBLDBD-JBgBQB7BEBCvOBrB1GBsBDBC-FBgBXXBGBD-GBIFFDQQmGBBRoBBtCDBLDBDwYBlCrCB+BhGBFccDCCBCCLFFCCCBEBCDBCECEDDCBBCICDCCBFFIKFCLLSEBEGGSzBBDtIBtBDBlDLBQBBQQQmBJBvF3BBeMBtBDBKGBDNBH5EB6eCBSCBOCB7GFBNDBCOBNDB5BHBLFBpBHBfBBNDBDNBKmBB5KHBPBBOCBMCB6BCCBCBRBBNDBLGB0EoDoDBjgBBh3pBfB-oEBBv0FBBypHOBvThtCB-QhvBBs6EEBrpIm8yVBCdBhD-DBxHvw-FB", false));
    },
    Vai: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gopBrJ", true));
    },
    Vithkuqi: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("wrhCKCOCGCBCKCOCGCB", true));
    },
    Wancho: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g24D5BGA", true));
    },
    Warang_Citi: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("glmCyCNA", true));
    },
    Yezidi: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("g0jCpBCCDB", true));
    },
    Yi: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("ggoBskBE2B", true));
    },
    Zanabazar_Square: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("gwmCnC", true));
    }
})), (0, $6tY97._)($f8c5210791d45577$var$_class1, "FOLD_CATEGORIES", new $f8c5210791d45577$var$LazyMap({
    L: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("laA", true));
    },
    LC: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("laA", true));
    },
    Ll: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("hCZBmDWBCGBiBuBCEECDOCDuBCBECEBBCCCBCCBBBDDBCBBCCBEBBCBBCECBCCDCCBCCBBBCCCBEEIBBCBBCBBCOCDQCDBBCCCBBBC4BCIBBCBBDCCBCBCGC3HrBrBCEEJHHCCBCCCBCCBPBCIBkBJJCUCGDDCBBDyBBxBgBCK2BCBMCD+CCDlBBq6ClBBCGGzW1CB0kCHHBpBBDCBhK0ECKgDCKHBJFBLHBJHBJFBMGCJHBZHBJHBJHBJEBMEBMDBNEBMEBqJEEBHHxC9zC9zCBuBBxBCCBBBDGCBCBCDDJCBCgDCJCCFuqeuqeCqBCUaCoEMCE8BCLECBICFCCDCCEUCBDBCEBCOCBCBCCCBQCZs5Vs5VBYBmmBnBBpEjBB9EKBCOBCGBCBBr3ByBB+EVB75CfBhsVfBhCYBoyehBB", false));
    },
    Lt: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("kOCCBCCBCClBCCtsHHBJHBJHBMQQwBAB", false));
    },
    Lu: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("hDZB7BqBqBBWBCHBCuBCEECDOCDsBCDECBBBDCCDEEGDDECBDDDCCCDFFDEECDDECCGBBCBBCBBCOCBSCDBBCEECkBCEQCJDDBCCFICBEBCBBCCCBEEBCCBCBCEBDCCBDDIDDCBBEFBGLLBnFnFsBCCEEEBBBvBDBCdBCBBECBCWCBDBCGD1BvBBCgBCK0BCDMCBgDCyBlBBq6CqBBDCB5XFBjkCIBCvHvHERRzD0ECGGGC8CCBHBJFBLHBJHBJFBMGCJHBJNBzBBBNSSBPPBEEpL2B2Bs1CvBBCEEBGCHDDLiDCJCCFNNBkBBCGG0oesBCUaCoEMCE8BCLCCDICFFFCBBDSCMOCFCCDOCb9a9advCBi8UZBumBnBBpEjBB8EKBCOBCGBCBBk4ByBB+DVB75CfBhsVfB8BYBvyehBB", false));
    },
    M: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("5cgBgBlgHAB", false));
    },
    Mn: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("5cgBgBlgHAB", false));
    },
    Emoji: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("8mJA", true));
    },
    Extended_Pictographic: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("8mJA", true));
    },
    Lowercase: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("hCZBmDWBCGBiBuBCEECDOCDuBCBECEBBCCCBCCBBBDDBCBBCCBEBBCBBCECBCCDCCBCCBBBCCCBEEIBBCBBCBBCOCDQCDBBCCCBBBC4BCIBBCBBDCCBCBCGCiJCCEJJHCCBBBCCCBCCBPBCIBkBJJCUCGDDCBBDyBBxBgBCK2BCBMCD+CCDlBBq6ClBBCGGzW1CB0kCHHBpBBDCBhK0ECKgDCKHBJFBLHBJHBJFBMGCJHBZHBJHBJHBJEBMEBMDBNEBMEBqJEEBHHuBPBUzZzZBYBx5BvBBxBCCBBBDGCBCBCDDJCBCgDCJCCFuqeuqeCqBCUaCoEMCE8BCLECBICFCCDCCEUCBDBCEBCOCBCBCCCBQCZs5Vs5VBYBmmBnBBpEjBB9EKBCOBCGBCBBr3ByBB+EVB75CfBhsVfBhCYBoyehBB", false));
    },
    Math: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("ycGDCHHFMMDDDCHHFAB", false));
    },
    Uppercase: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("hDZB7BqBqBBWBCHBCuBCEECDOCDsBCDECBBBDCCDEEGDDECBDDDCCCDFFDEECDDECCGBBCBBCBBCOCBSCDBBCEECkBCEQCJDDBCCFICBEBCBBCCCBEEBCCBCBCEBDCCBDDIDDCBBEFBGLLBnFnFsBCCEEEBBBvBDBCdBCBBECBCWCBDBCGD1BvBBCgBCK0BCDMCBgDCyBlBBq6CqBBDCB5XFBjkCIBCvHvHERRzD0ECGGGC8CCBHBJFBLHBJHBJFBMGCJHBJNBzBBBNSSBPPBEEpLiBiBBOBFsasaBYBn6BvBBCEEBGCHDDLiDCJCCFNNBkBBCGG0oesBCUaCoEMCE8BCLCCDICFFFCBBDSCMOCFCCDOCb9a9advCBi8UZBumBnBBpEjBB8EKBCOBCGBCBBk4ByBB+DVB75CfBhsVfB8BYBvyehBB", false));
    }
})), (0, $6tY97._)($f8c5210791d45577$var$_class1, "FOLD_SCRIPT", new $f8c5210791d45577$var$LazyMap({
    Common: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("8cgBgB", false));
    },
    Greek: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("1FwUwU", false));
    },
    Inherited: function() {
        return new $f8c5210791d45577$var$UnicodeRangeTable($f8c5210791d45577$var$decodeRanges("5cgBgBlgHAB", false));
    }
})), $f8c5210791d45577$var$_class1);
//#endregion
//#region src/Unicode.js
/**
* Utilities for dealing with Unicode better than JS does.
*/ var $f8c5210791d45577$var$Unicode = ($f8c5210791d45577$var$_Unicode = /*#__PURE__*/ function() {
    "use strict";
    function Unicode() {
        (0, $4QweW._)(this, Unicode);
    }
    (0, $6hK4i._)(Unicode, null, [
        {
            key: "is32",
            value: function is32(ranges, r) {
                var lo = 0;
                var hi = ranges.length;
                while(lo < hi){
                    var m = lo + Math.floor((hi - lo) / 2);
                    var rlo = ranges.getLo(m);
                    var rhi = ranges.getHi(m);
                    if (rlo <= r && r <= rhi) {
                        var stride = ranges.getStride(m);
                        return (r - rlo) % stride === 0;
                    }
                    if (r < rlo) hi = m;
                    else lo = m + 1;
                }
                return false;
            }
        },
        {
            key: "is",
            value: function is(ranges, r) {
                if (r <= Unicode.MAX_LATIN1) {
                    for(var i = 0; i < ranges.length; i++){
                        if (r > ranges.getHi(i)) continue;
                        var rlo = ranges.getLo(i);
                        if (r < rlo) return false;
                        var stride = ranges.getStride(i);
                        return (r - rlo) % stride === 0;
                    }
                    return false;
                }
                return ranges.length > 0 && r >= ranges.getLo(0) && Unicode.is32(ranges, r);
            }
        },
        {
            key: "isUpper",
            value: function isUpper(r) {
                if (r <= Unicode.MAX_LATIN1) {
                    var s = String.fromCodePoint(r);
                    return s.toUpperCase() === s && s.toLowerCase() !== s;
                }
                return Unicode.is($f8c5210791d45577$var$UnicodeTables.Upper, r);
            }
        },
        {
            key: "isPrint",
            value: function isPrint(r) {
                if (r <= Unicode.MAX_LATIN1) return r >= 32 && r < Unicode.MAX_ASCII || r >= 161 && r !== 173;
                return Unicode.is($f8c5210791d45577$var$UnicodeTables.Print, r);
            }
        },
        {
            key: "simpleFold",
            value: function simpleFold(r) {
                if ($f8c5210791d45577$var$UnicodeTables.CASE_ORBIT.has(r)) return $f8c5210791d45577$var$UnicodeTables.CASE_ORBIT.get(r);
                var l = $f8c5210791d45577$var$Codepoint.toLowerCase(r);
                if (l !== r) return l;
                return $f8c5210791d45577$var$Codepoint.toUpperCase(r);
            }
        },
        {
            key: "equalsIgnoreCase",
            value: function equalsIgnoreCase(r1, r2) {
                if (r1 === r2) return true;
                if (r1 < 0 || r2 < 0) return false;
                if (r1 <= Unicode.MAX_ASCII && r2 <= Unicode.MAX_ASCII) {
                    if (65 <= r1 && r1 <= 90) r1 |= 32;
                    if (65 <= r2 && r2 <= 90) r2 |= 32;
                    return r1 === r2;
                }
                for(var r = Unicode.simpleFold(r1); r !== r1; r = Unicode.simpleFold(r))if (r === r2) return true;
                return false;
            }
        }
    ]);
    return Unicode;
}(), (0, $6tY97._)($f8c5210791d45577$var$_Unicode, "MAX_RUNE", 1114111), (0, $6tY97._)($f8c5210791d45577$var$_Unicode, "MAX_ASCII", 127), (0, $6tY97._)($f8c5210791d45577$var$_Unicode, "MAX_LATIN1", 255), (0, $6tY97._)($f8c5210791d45577$var$_Unicode, "MAX_BMP", 65535), (0, $6tY97._)($f8c5210791d45577$var$_Unicode, "MIN_FOLD", 65), (0, $6tY97._)($f8c5210791d45577$var$_Unicode, "MAX_FOLD", 125251), (0, $6tY97._)($f8c5210791d45577$var$_Unicode, "MIN_HIGH_SURROGATE", 55296), (0, $6tY97._)($f8c5210791d45577$var$_Unicode, "MAX_HIGH_SURROGATE", 56319), (0, $6tY97._)($f8c5210791d45577$var$_Unicode, "MIN_LOW_SURROGATE", 56320), (0, $6tY97._)($f8c5210791d45577$var$_Unicode, "MAX_LOW_SURROGATE", 57343), (0, $6tY97._)($f8c5210791d45577$var$_Unicode, "MIN_SUPPLEMENTARY_CODE_POINT", 65536), $f8c5210791d45577$var$_Unicode);
//#endregion
//#region src/Utils.js
/**
* Size of the precomputed single-byte lookup table.
* Covers standard ASCII and Latin-1 characters for fast-path execution.
*/ var $f8c5210791d45577$var$FAST_PATH_TABLE_SIZE = 256;
/**
* Precomputed lookup table for Word Boundary (\b, \B) assertions.
* * By precomputing the boolean results for standard ASCII word ranges
* ('a'-'z', 'A'-'Z', '0'-'9', '_'), we completely eliminate 4 logical
* branches from the NFA's hot execution loop. This prevents costly
* CPU branch mispredictions when scanning large strings.
*/ var $f8c5210791d45577$var$WORD_RUNE_TABLE = new Uint8Array($f8c5210791d45577$var$FAST_PATH_TABLE_SIZE);
for(var $f8c5210791d45577$var$i2 = 0; $f8c5210791d45577$var$i2 < $f8c5210791d45577$var$FAST_PATH_TABLE_SIZE; $f8c5210791d45577$var$i2++)$f8c5210791d45577$var$WORD_RUNE_TABLE[$f8c5210791d45577$var$i2] = 97 <= $f8c5210791d45577$var$i2 && $f8c5210791d45577$var$i2 <= 122 || 65 <= $f8c5210791d45577$var$i2 && $f8c5210791d45577$var$i2 <= 90 || 48 <= $f8c5210791d45577$var$i2 && $f8c5210791d45577$var$i2 <= 57 || $f8c5210791d45577$var$i2 === 95 ? 1 : 0;
var $f8c5210791d45577$var$cachedNativeEncoder = null;
var $f8c5210791d45577$var$cachedNativeDecoder = null;
/**
* Various constants and helper utilities.
*/ var $f8c5210791d45577$var$Utils = ($f8c5210791d45577$var$_Utils = /*#__PURE__*/ function() {
    "use strict";
    function Utils() {
        (0, $4QweW._)(this, Utils);
    }
    (0, $6hK4i._)(Utils, null, [
        {
            key: "emptyInts",
            value: function emptyInts() {
                return [];
            }
        },
        {
            key: "isByteArray",
            value: function isByteArray(input) {
                return Array.isArray(input) || input instanceof Uint8Array;
            }
        },
        {
            key: "isalnum",
            value: function isalnum(c) {
                return $f8c5210791d45577$var$Codepoint.CODES.get("0") <= c && c <= $f8c5210791d45577$var$Codepoint.CODES.get("9") || $f8c5210791d45577$var$Codepoint.CODES.get("a") <= c && c <= $f8c5210791d45577$var$Codepoint.CODES.get("z") || $f8c5210791d45577$var$Codepoint.CODES.get("A") <= c && c <= $f8c5210791d45577$var$Codepoint.CODES.get("Z");
            }
        },
        {
            key: "unhex",
            value: function unhex(c) {
                if ($f8c5210791d45577$var$Codepoint.CODES.get("0") <= c && c <= $f8c5210791d45577$var$Codepoint.CODES.get("9")) return c - $f8c5210791d45577$var$Codepoint.CODES.get("0");
                if ($f8c5210791d45577$var$Codepoint.CODES.get("a") <= c && c <= $f8c5210791d45577$var$Codepoint.CODES.get("f")) return c - $f8c5210791d45577$var$Codepoint.CODES.get("a") + 10;
                if ($f8c5210791d45577$var$Codepoint.CODES.get("A") <= c && c <= $f8c5210791d45577$var$Codepoint.CODES.get("F")) return c - $f8c5210791d45577$var$Codepoint.CODES.get("A") + 10;
                return -1;
            }
        },
        {
            key: "escapeRune",
            value: function escapeRune(rune) {
                var out = "";
                if ($f8c5210791d45577$var$Unicode.isPrint(rune)) {
                    if (Utils.METACHARACTERS.indexOf(String.fromCodePoint(rune)) >= 0) out += "\\";
                    out += String.fromCodePoint(rune);
                } else switch(rune){
                    case $f8c5210791d45577$var$Codepoint.CODES.get("\""):
                        out += "\\\"";
                        break;
                    case $f8c5210791d45577$var$Codepoint.CODES.get("\\"):
                        out += "\\\\";
                        break;
                    case $f8c5210791d45577$var$Codepoint.CODES.get("	"):
                        out += "\\t";
                        break;
                    case $f8c5210791d45577$var$Codepoint.CODES.get("\n"):
                        out += "\\n";
                        break;
                    case $f8c5210791d45577$var$Codepoint.CODES.get("\r"):
                        out += "\\r";
                        break;
                    case $f8c5210791d45577$var$Codepoint.CODES.get("\b"):
                        out += "\\b";
                        break;
                    case $f8c5210791d45577$var$Codepoint.CODES.get("\f"):
                        out += "\\f";
                        break;
                    default:
                        {
                            var s = rune.toString(16);
                            if (rune < 256) {
                                out += "\\x";
                                if (s.length === 1) out += "0";
                                out += s;
                            } else out += "\\x{".concat(s, "}");
                            break;
                        }
                }
                return out;
            }
        },
        {
            key: "stringToRunes",
            value: function stringToRunes(str) {
                var string = String(str);
                var runes = [];
                var i = 0;
                while(i < string.length){
                    var cp = string.codePointAt(i);
                    runes.push(cp);
                    i += cp > $f8c5210791d45577$var$Unicode.MAX_BMP ? 2 : 1;
                }
                return runes;
            }
        },
        {
            key: "runeToString",
            value: function runeToString(r) {
                return String.fromCodePoint(r);
            }
        },
        {
            key: "isWordRune",
            value: function isWordRune(r) {
                return r < $f8c5210791d45577$var$FAST_PATH_TABLE_SIZE ? $f8c5210791d45577$var$WORD_RUNE_TABLE[r] === 1 : false;
            }
        },
        {
            key: "emptyOpContext",
            value: function emptyOpContext(r1, r2) {
                var op = 0;
                if (r1 < 0) op |= Utils.EMPTY_BEGIN_TEXT | Utils.EMPTY_BEGIN_LINE;
                if (r1 === 10) op |= Utils.EMPTY_BEGIN_LINE;
                if (r2 < 0) op |= Utils.EMPTY_END_TEXT | Utils.EMPTY_END_LINE;
                if (r2 === 10) op |= Utils.EMPTY_END_LINE;
                if (Utils.isWordRune(r1) !== Utils.isWordRune(r2)) op |= Utils.EMPTY_WORD_BOUNDARY;
                else op |= Utils.EMPTY_NO_WORD_BOUNDARY;
                return op;
            }
        },
        {
            key: "quoteMeta",
            value: /**
	* Returns a string that quotes all regular expression metacharacters inside the argument text;
	* the returned string is a regular expression matching the literal text. For example,
	* {@code quoteMeta("[foo]").equals("\\[foo\\]")}.
	* @param {string} str
	* @returns {string}
	*/ function quoteMeta(str) {
                return str.split("").map(function(s) {
                    if (Utils.METACHARACTERS.indexOf(s) >= 0) return "\\".concat(s);
                    return s;
                }).join("");
            }
        },
        {
            key: "charCount",
            value: function charCount(codePoint) {
                return codePoint > $f8c5210791d45577$var$Unicode.MAX_BMP ? 2 : 1;
            }
        },
        {
            key: "toArray",
            value: /**
	* High-speed conversion from TypedArrays to standard JS Arrays.
	* Bypasses the expensive Symbol.iterator overhead of Array.from()
	*/ function toArray(typedArray) {
                var len = typedArray.length;
                var res = new Array(len);
                for(var i = 0; i < len; i++)res[i] = typedArray[i];
                return res;
            }
        },
        {
            key: "stringToUtf8ByteArray",
            value: function stringToUtf8ByteArray(str) {
                if (globalThis.TextEncoder) {
                    if (!$f8c5210791d45577$var$cachedNativeEncoder) $f8c5210791d45577$var$cachedNativeEncoder = new TextEncoder();
                    return $f8c5210791d45577$var$cachedNativeEncoder.encode(str);
                } else {
                    var out = [], p = 0;
                    for(var i = 0; i < str.length; i++){
                        var c = str.charCodeAt(i);
                        if (c < 128) out[p++] = c;
                        else if (c < 2048) {
                            out[p++] = c >> 6 | 192;
                            out[p++] = c & 63 | 128;
                        } else if ((c & 64512) === $f8c5210791d45577$var$Unicode.MIN_HIGH_SURROGATE && i + 1 < str.length && (str.charCodeAt(i + 1) & 64512) === $f8c5210791d45577$var$Unicode.MIN_LOW_SURROGATE) {
                            c = $f8c5210791d45577$var$Unicode.MIN_SUPPLEMENTARY_CODE_POINT + ((c & 1023) << 10) + (str.charCodeAt(++i) & 1023);
                            out[p++] = c >> 18 | 240;
                            out[p++] = c >> 12 & 63 | 128;
                            out[p++] = c >> 6 & 63 | 128;
                            out[p++] = c & 63 | 128;
                        } else {
                            out[p++] = c >> 12 | 224;
                            out[p++] = c >> 6 & 63 | 128;
                            out[p++] = c & 63 | 128;
                        }
                    }
                    return out;
                }
            }
        },
        {
            key: "utf8ByteArrayToString",
            value: function utf8ByteArrayToString(bytes) {
                if (globalThis.TextDecoder) {
                    if (!$f8c5210791d45577$var$cachedNativeDecoder) $f8c5210791d45577$var$cachedNativeDecoder = new TextDecoder("utf-8");
                    var view = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
                    return $f8c5210791d45577$var$cachedNativeDecoder.decode(view);
                } else {
                    var out = [], pos = 0, c = 0;
                    while(pos < bytes.length){
                        var c1 = bytes[pos++];
                        if (c1 < 128) out[c++] = String.fromCharCode(c1);
                        else if (c1 > 191 && c1 < 224) {
                            var c2 = bytes[pos++];
                            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
                        } else if (c1 > 239 && c1 < 365) {
                            var c21 = bytes[pos++];
                            var c3 = bytes[pos++];
                            var c4 = bytes[pos++];
                            var u = ((c1 & 7) << 18 | (c21 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - $f8c5210791d45577$var$Unicode.MIN_SUPPLEMENTARY_CODE_POINT;
                            out[c++] = String.fromCharCode($f8c5210791d45577$var$Unicode.MIN_HIGH_SURROGATE + (u >> 10));
                            out[c++] = String.fromCharCode($f8c5210791d45577$var$Unicode.MIN_LOW_SURROGATE + (u & 1023));
                        } else {
                            var c22 = bytes[pos++];
                            var c31 = bytes[pos++];
                            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c22 & 63) << 6 | c31 & 63);
                        }
                    }
                    return out.join("");
                }
            }
        }
    ]);
    return Utils;
}(), (0, $6tY97._)($f8c5210791d45577$var$_Utils, "METACHARACTERS", "\\.+*?()|[]{}^$"), (0, $6tY97._)($f8c5210791d45577$var$_Utils, "EMPTY_BEGIN_LINE", 1), (0, $6tY97._)($f8c5210791d45577$var$_Utils, "EMPTY_END_LINE", 2), (0, $6tY97._)($f8c5210791d45577$var$_Utils, "EMPTY_BEGIN_TEXT", 4), (0, $6tY97._)($f8c5210791d45577$var$_Utils, "EMPTY_END_TEXT", 8), (0, $6tY97._)($f8c5210791d45577$var$_Utils, "EMPTY_WORD_BOUNDARY", 16), (0, $6tY97._)($f8c5210791d45577$var$_Utils, "EMPTY_NO_WORD_BOUNDARY", 32), (0, $6tY97._)($f8c5210791d45577$var$_Utils, "EMPTY_ALL", -1), $f8c5210791d45577$var$_Utils);
//#endregion
//#region src/helpers.js
var $f8c5210791d45577$var$createEnum = function() {
    var values = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], initNum = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var enumObject = Object.create(null);
    for(var i = 0; i < values.length; i++){
        var val = values[i];
        var keyVal = initNum + i;
        enumObject[val] = keyVal;
        enumObject[keyVal] = val;
    }
    return Object.freeze(enumObject);
};
//#endregion
//#region src/MatcherInput.js
/**
* Abstract the representations of input text supplied to Matcher.
*/ var $f8c5210791d45577$export$cefe1fb40cb8a0f6 = ($f8c5210791d45577$var$_MatcherInputBase = /*#__PURE__*/ function() {
    "use strict";
    function MatcherInputBase() {
        (0, $4QweW._)(this, MatcherInputBase);
    }
    (0, $6hK4i._)(MatcherInputBase, [
        {
            key: "getEncoding",
            value: function getEncoding() {
                throw Error("not implemented");
            }
        },
        {
            /** @returns {string} */ key: "asCharSequence",
            value: function asCharSequence() {
                throw Error("not implemented");
            }
        },
        {
            /** @returns {Uint8Array|number[]} */ key: "asBytes",
            value: function asBytes() {
                throw Error("not implemented");
            }
        },
        {
            /** @returns {number} */ key: "length",
            value: function length() {
                throw Error("not implemented");
            }
        },
        {
            /**
	*
	* @returns {boolean}
	*/ key: "isUTF8Encoding",
            value: function isUTF8Encoding() {
                return this.getEncoding() === MatcherInputBase.Encoding.UTF_8;
            }
        },
        {
            /**
	*
	* @returns {boolean}
	*/ key: "isUTF16Encoding",
            value: function isUTF16Encoding() {
                return this.getEncoding() === MatcherInputBase.Encoding.UTF_16;
            }
        }
    ]);
    return MatcherInputBase;
}(), (0, $6tY97._)($f8c5210791d45577$var$_MatcherInputBase, "Encoding", $f8c5210791d45577$var$createEnum([
    "UTF_16",
    "UTF_8"
])), $f8c5210791d45577$var$_MatcherInputBase);
var $f8c5210791d45577$var$Utf8MatcherInput = /*#__PURE__*/ function(MatcherInputBase1) {
    "use strict";
    (0, $c2MhV._)(Utf8MatcherInput, MatcherInputBase1);
    function Utf8MatcherInput() {
        var bytes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        (0, $4QweW._)(this, Utf8MatcherInput);
        var _this;
        _this = (0, $ehF45._)(this, Utf8MatcherInput);
        _this.bytes = bytes;
        return _this;
    }
    (0, $6hK4i._)(Utf8MatcherInput, [
        {
            key: "getEncoding",
            value: function getEncoding() {
                return $f8c5210791d45577$export$cefe1fb40cb8a0f6.Encoding.UTF_8;
            }
        },
        {
            /**
	*
	* @returns {string}
	*/ key: "asCharSequence",
            value: function asCharSequence() {
                return $f8c5210791d45577$var$Utils.utf8ByteArrayToString(this.bytes);
            }
        },
        {
            /**
	*
	* @returns {Uint8Array|number[]|null}
	*/ key: "asBytes",
            value: function asBytes() {
                return this.bytes;
            }
        },
        {
            /**
	*
	* @returns {number}
	*/ key: "length",
            value: function length() {
                return this.bytes.length;
            }
        }
    ]);
    return Utf8MatcherInput;
}($f8c5210791d45577$export$cefe1fb40cb8a0f6);
var $f8c5210791d45577$var$Utf16MatcherInput = /*#__PURE__*/ function(MatcherInputBase1) {
    "use strict";
    (0, $c2MhV._)(Utf16MatcherInput, MatcherInputBase1);
    function Utf16MatcherInput() {
        var charSequence = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        (0, $4QweW._)(this, Utf16MatcherInput);
        var _this;
        _this = (0, $ehF45._)(this, Utf16MatcherInput);
        _this.charSequence = charSequence;
        return _this;
    }
    (0, $6hK4i._)(Utf16MatcherInput, [
        {
            key: "getEncoding",
            value: function getEncoding() {
                return $f8c5210791d45577$export$cefe1fb40cb8a0f6.Encoding.UTF_16;
            }
        },
        {
            /**
	*
	* @returns {string}
	*/ key: "asCharSequence",
            value: function asCharSequence() {
                return this.charSequence;
            }
        },
        {
            /**
	*
	* @returns {number[]}
	*/ key: "asBytes",
            value: function asBytes() {
                return $f8c5210791d45577$var$Utils.stringToUtf8ByteArray(this.charSequence.toString());
            }
        },
        {
            /**
	*
	* @returns {number}
	*/ key: "length",
            value: function length() {
                return this.charSequence.length;
            }
        }
    ]);
    return Utf16MatcherInput;
}($f8c5210791d45577$export$cefe1fb40cb8a0f6);
var $f8c5210791d45577$export$3430ac14b3833fca = /*#__PURE__*/ function() {
    "use strict";
    function MatcherInput() {
        (0, $4QweW._)(this, MatcherInput);
    }
    (0, $6hK4i._)(MatcherInput, null, [
        {
            key: "utf16",
            value: /**
	* Return the MatcherInput for UTF_16 encoding.
	* @returns {Utf16MatcherInput}
	*/ function utf16(charSequence) {
                return new $f8c5210791d45577$var$Utf16MatcherInput(charSequence);
            }
        },
        {
            key: "utf8",
            value: /**
	* Return the MatcherInput for UTF_8 encoding.
	* @returns {Utf8MatcherInput}
	*/ function utf8(input) {
                if ($f8c5210791d45577$var$Utils.isByteArray(input)) return new $f8c5210791d45577$var$Utf8MatcherInput(input);
                return new $f8c5210791d45577$var$Utf8MatcherInput($f8c5210791d45577$var$Utils.stringToUtf8ByteArray(input));
            }
        }
    ]);
    return MatcherInput;
}();
//#endregion
//#region src/MachineInput.js
/**
* MachineInput abstracts different representations of the input text supplied to the Machine. It
* provides one-character lookahead.
*/ var $f8c5210791d45577$var$MachineInputBase = /*#__PURE__*/ function() {
    "use strict";
    function MachineInputBase() {
        (0, $4QweW._)(this, MachineInputBase);
        this.end = 0;
    }
    (0, $6hK4i._)(MachineInputBase, [
        {
            key: "canCheckPrefix",
            value: function canCheckPrefix() {
                return true;
            }
        },
        {
            key: "endPos",
            value: function endPos() {
                return this.end;
            }
        },
        {
            key: "hasString",
            value: function hasString() {
                return false;
            }
        },
        {
            key: "hasAnyString",
            value: function hasAnyString() {
                return false;
            }
        },
        {
            key: "prefixLength",
            value: function prefixLength() {
                return 0;
            }
        }
    ], [
        {
            key: "EOF",
            value: function EOF() {
                return -8;
            }
        }
    ]);
    return MachineInputBase;
}();
var $f8c5210791d45577$var$MachineUTF8Input = /*#__PURE__*/ function(MachineInputBase1) {
    "use strict";
    (0, $c2MhV._)(MachineUTF8Input, MachineInputBase1);
    function MachineUTF8Input(bytes) {
        var start = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, end = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : bytes.length;
        (0, $4QweW._)(this, MachineUTF8Input);
        var _this;
        _this = (0, $ehF45._)(this, MachineUTF8Input);
        _this.bytes = bytes;
        _this.start = start;
        _this.end = end;
        return _this;
    }
    (0, $6hK4i._)(MachineUTF8Input, [
        {
            key: "hasString",
            value: function hasString(prefilter, pos) {
                var target = prefilter.bytes;
                if (target.length === 0) return true;
                var idx = this.indexOf(this.bytes, target, this.start + pos);
                return idx !== -1 && idx <= this.end - target.length;
            }
        },
        {
            key: "hasAnyString",
            value: function hasAnyString(prefilter, pos) {
                if (!prefilter.ac8) return false;
                return prefilter.ac8.searchUTF8(this.bytes, this.start + pos, this.end);
            }
        },
        {
            key: "step",
            value: function step(pos) {
                pos += this.start;
                if (pos >= this.end) return $f8c5210791d45577$var$MachineInputBase.EOF();
                var c = this.bytes[pos] & 255;
                if (c < 128) return c << 3 | 1;
                else if (c >= 194 && c <= 223 && pos + 1 < this.end) {
                    var c1 = this.bytes[pos + 1] & 255;
                    if ((c1 & 192) !== 128) return c << 3 | 1;
                    return ((c & 31) << 6 | c1 & 63) << 3 | 2;
                } else if (c >= 224 && c <= 239 && pos + 2 < this.end) {
                    var c11 = this.bytes[pos + 1] & 255;
                    if ((c11 & 192) !== 128) return c << 3 | 1;
                    var c2 = this.bytes[pos + 2] & 255;
                    if ((c2 & 192) !== 128) return c << 3 | 1;
                    return ((c & 15) << 12 | (c11 & 63) << 6 | c2 & 63) << 3 | 3;
                } else if (c >= 240 && c <= 244 && pos + 3 < this.end) {
                    var c12 = this.bytes[pos + 1] & 255;
                    if ((c12 & 192) !== 128) return c << 3 | 1;
                    var c21 = this.bytes[pos + 2] & 255;
                    if ((c21 & 192) !== 128) return c << 3 | 1;
                    var c3 = this.bytes[pos + 3] & 255;
                    if ((c3 & 192) !== 128) return c << 3 | 1;
                    return ((c & 7) << 18 | (c12 & 63) << 12 | (c21 & 63) << 6 | c3 & 63) << 3 | 4;
                } else return c << 3 | 1;
            }
        },
        {
            key: "index",
            value: function index(re2, pos) {
                pos += this.start;
                var i = this.indexOf(this.bytes, re2.prefixUTF8, pos);
                return i < 0 ? i : i - pos;
            }
        },
        {
            key: "context",
            value: function context(pos) {
                pos += this.start;
                var r1 = -1;
                if (pos > this.start && pos <= this.end) {
                    var start = pos - 1;
                    r1 = this.bytes[start--];
                    if (r1 >= 128) {
                        var lim = pos - 4;
                        if (lim < this.start) lim = this.start;
                        while(start >= lim && (this.bytes[start] & 192) === 128)start--;
                        if (start < this.start) start = this.start;
                        r1 = this.step(start - this.start) >> 3;
                    }
                }
                var r2 = pos < this.end ? this.step(pos - this.start) >> 3 : -1;
                return $f8c5210791d45577$var$Utils.emptyOpContext(r1, r2);
            }
        },
        {
            key: "indexOf",
            value: function indexOf(source, target) {
                var fromIndex = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var targetLength = target.length;
                if (targetLength === 0) return fromIndex <= this.end ? fromIndex : -1;
                var firstByte = target[0];
                var limit = this.end - targetLength;
                var hasNativeIndexOf = typeof source.indexOf === "function";
                var i = fromIndex;
                while(i <= limit){
                    if (hasNativeIndexOf) {
                        i = source.indexOf(firstByte, i);
                        if (i === -1 || i > limit) return -1;
                    } else {
                        while(i <= limit && source[i] !== firstByte)i++;
                        if (i > limit) return -1;
                    }
                    var match = true;
                    for(var j = 1; j < targetLength; j++)if (source[i + j] !== target[j]) {
                        match = false;
                        break;
                    }
                    if (match) return i;
                    i++;
                }
                return -1;
            }
        },
        {
            key: "prefixLength",
            value: function prefixLength(re2) {
                return re2.prefixUTF8.length;
            }
        }
    ]);
    return MachineUTF8Input;
}($f8c5210791d45577$var$MachineInputBase);
var $f8c5210791d45577$var$MachineUTF16Input = /*#__PURE__*/ function(MachineInputBase1) {
    "use strict";
    (0, $c2MhV._)(MachineUTF16Input, MachineInputBase1);
    function MachineUTF16Input(charSequence) {
        var start = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, end = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : charSequence.length;
        (0, $4QweW._)(this, MachineUTF16Input);
        var _this;
        _this = (0, $ehF45._)(this, MachineUTF16Input);
        _this.charSequence = charSequence;
        _this.start = start;
        _this.end = end;
        return _this;
    }
    (0, $6hK4i._)(MachineUTF16Input, [
        {
            key: "hasString",
            value: function hasString(prefilter, pos) {
                var idx = this.charSequence.indexOf(prefilter.str, this.start + pos);
                return idx !== -1 && idx <= this.end - prefilter.str.length;
            }
        },
        {
            key: "hasAnyString",
            value: function hasAnyString(prefilter, pos) {
                if (!prefilter.ac16) return false;
                return prefilter.ac16.searchUTF16(this.charSequence, this.start + pos, this.end);
            }
        },
        {
            key: "step",
            value: function step(pos) {
                pos += this.start;
                if (pos >= this.end) return $f8c5210791d45577$var$MachineInputBase.EOF();
                var c1 = this.charSequence.charCodeAt(pos);
                if (c1 < $f8c5210791d45577$var$Unicode.MIN_HIGH_SURROGATE || c1 > $f8c5210791d45577$var$Unicode.MAX_HIGH_SURROGATE || pos + 1 >= this.end) return c1 << 3 | 1;
                var c2 = this.charSequence.charCodeAt(pos + 1);
                if (c2 >= $f8c5210791d45577$var$Unicode.MIN_LOW_SURROGATE && c2 <= $f8c5210791d45577$var$Unicode.MAX_LOW_SURROGATE) return (c1 - $f8c5210791d45577$var$Unicode.MIN_HIGH_SURROGATE) * 1024 + (c2 - $f8c5210791d45577$var$Unicode.MIN_LOW_SURROGATE) + $f8c5210791d45577$var$Unicode.MIN_SUPPLEMENTARY_CODE_POINT << 3 | 2;
                return c1 << 3 | 1;
            }
        },
        {
            key: "index",
            value: function index(re2, pos) {
                pos += this.start;
                var i = this.charSequence.indexOf(re2.prefix, pos);
                if (i < 0 || i > this.end - re2.prefix.length) return -1;
                return i - pos;
            }
        },
        {
            key: "context",
            value: function context(pos) {
                pos += this.start;
                var r1 = pos > this.start && pos <= this.end ? this.charSequence.charCodeAt(pos - 1) : -1;
                var r2 = pos < this.end ? this.charSequence.charCodeAt(pos) : -1;
                return $f8c5210791d45577$var$Utils.emptyOpContext(r1, r2);
            }
        },
        {
            key: "prefixLength",
            value: function prefixLength(re2) {
                return re2.prefix.length;
            }
        }
    ]);
    return MachineUTF16Input;
}($f8c5210791d45577$var$MachineInputBase);
var $f8c5210791d45577$var$MachineInput = /*#__PURE__*/ function() {
    "use strict";
    function MachineInput() {
        (0, $4QweW._)(this, MachineInput);
    }
    (0, $6hK4i._)(MachineInput, null, [
        {
            key: "fromUTF8",
            value: function fromUTF8(bytes) {
                var start = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, end = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : bytes.length;
                return new $f8c5210791d45577$var$MachineUTF8Input(bytes, start, end);
            }
        },
        {
            key: "fromUTF16",
            value: function fromUTF16(charSequence) {
                var start = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, end = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : charSequence.length;
                return new $f8c5210791d45577$var$MachineUTF16Input(charSequence, start, end);
            }
        }
    ]);
    return MachineInput;
}();
//#endregion
//#region src/exceptions.js
var $f8c5210791d45577$export$54306bca8e0bffc2 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $c2MhV._)(RE2JSException, Error1);
    function RE2JSException(message) {
        (0, $4QweW._)(this, RE2JSException);
        var _this;
        _this = (0, $ehF45._)(this, RE2JSException, [
            message
        ]);
        _this.name = "RE2JSException";
        return _this;
    }
    return RE2JSException;
}((0, $67kUy._)(Error));
/**
* An exception thrown by the parser if the pattern was invalid.
*/ var $f8c5210791d45577$export$9c12d0c1e9bff151 = /*#__PURE__*/ function(RE2JSException) {
    "use strict";
    (0, $c2MhV._)(RE2JSSyntaxException, RE2JSException);
    function RE2JSSyntaxException(error) {
        var input = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        (0, $4QweW._)(this, RE2JSSyntaxException);
        var _this;
        var message = "error parsing regexp: ".concat(error);
        if (input) message += ": `".concat(input, "`");
        _this = (0, $ehF45._)(this, RE2JSSyntaxException, [
            message
        ]);
        _this.name = "RE2JSSyntaxException";
        _this.message = message;
        /** @type {string} */ _this.error = error;
        /** @type {string|null} */ _this.input = input;
        return _this;
    }
    (0, $6hK4i._)(RE2JSSyntaxException, [
        {
            /**
	* Retrieves the description of the error.
	* @returns {string}
	*/ key: "getDescription",
            value: function getDescription() {
                return this.error;
            }
        },
        {
            /**
	* Retrieves the erroneous regular-expression pattern.
	* @returns {string|null}
	*/ key: "getPattern",
            value: function getPattern() {
                return this.input;
            }
        }
    ]);
    return RE2JSSyntaxException;
}($f8c5210791d45577$export$54306bca8e0bffc2);
/**
* An exception thrown by the compiler
*/ var $f8c5210791d45577$export$457eacef9ada3821 = /*#__PURE__*/ function(RE2JSException) {
    "use strict";
    (0, $c2MhV._)(RE2JSCompileException, RE2JSException);
    function RE2JSCompileException(message) {
        (0, $4QweW._)(this, RE2JSCompileException);
        var _this;
        _this = (0, $ehF45._)(this, RE2JSCompileException, [
            message
        ]);
        _this.name = "RE2JSCompileException";
        return _this;
    }
    return RE2JSCompileException;
}($f8c5210791d45577$export$54306bca8e0bffc2);
/**
* An exception thrown by using groups
*/ var $f8c5210791d45577$export$eab8e70da4919c35 = /*#__PURE__*/ function(RE2JSException) {
    "use strict";
    (0, $c2MhV._)(RE2JSGroupException, RE2JSException);
    function RE2JSGroupException(message) {
        (0, $4QweW._)(this, RE2JSGroupException);
        var _this;
        _this = (0, $ehF45._)(this, RE2JSGroupException, [
            message
        ]);
        _this.name = "RE2JSGroupException";
        return _this;
    }
    return RE2JSGroupException;
}($f8c5210791d45577$export$54306bca8e0bffc2);
/**
* An exception thrown by flags
*/ var $f8c5210791d45577$export$fa1c64d63b2c22b1 = /*#__PURE__*/ function(RE2JSException) {
    "use strict";
    (0, $c2MhV._)(RE2JSFlagsException, RE2JSException);
    function RE2JSFlagsException(message) {
        (0, $4QweW._)(this, RE2JSFlagsException);
        var _this;
        _this = (0, $ehF45._)(this, RE2JSFlagsException, [
            message
        ]);
        _this.name = "RE2JSFlagsException";
        return _this;
    }
    return RE2JSFlagsException;
}($f8c5210791d45577$export$54306bca8e0bffc2);
/**
* An exception thrown for internal engine errors, such as corrupted bytecodes.
*/ var $f8c5210791d45577$export$3a148716bb6e0468 = /*#__PURE__*/ function(RE2JSException) {
    "use strict";
    (0, $c2MhV._)(RE2JSInternalException, RE2JSException);
    function RE2JSInternalException(message) {
        (0, $4QweW._)(this, RE2JSInternalException);
        var _this;
        _this = (0, $ehF45._)(this, RE2JSInternalException, [
            message
        ]);
        _this.name = "RE2JSInternalException";
        return _this;
    }
    return RE2JSInternalException;
}($f8c5210791d45577$export$54306bca8e0bffc2);
//#endregion
//#region src/Matcher.js
/**
* A stateful iterator that interprets a regex {@code RE2JS} on a specific input.
*
* Conceptually, a Matcher consists of four parts:
* <ol>
* <li>A compiled regular expression {@code RE2JS}, set at construction and fixed for the lifetime
* of the matcher.</li>
*
* <li>The remainder of the input string, set at construction or {@link #reset()} and advanced by
* each match operation such as {@link #find}, {@link #matches} or {@link #lookingAt}.</li>
*
* <li>The current match information, accessible via {@link #start}, {@link #end}, and
* {@link #group}, and updated by each match operation.</li>
*
* <li>The append position, used and advanced by {@link #appendReplacement} and {@link #appendTail}
* if performing a search and replace from the input to an external {@code StringBuffer}.
*
* </ol>
*
*
* @author rsc@google.com (Russ Cox)
*/ var $f8c5210791d45577$export$20214574ec94167d = ($f8c5210791d45577$var$_Matcher = /*#__PURE__*/ function() {
    "use strict";
    function Matcher(pattern, input) {
        (0, $4QweW._)(this, Matcher);
        if (pattern === null) throw new Error("pattern is null");
        /**
		* The pattern being matched.
		* @type {import('./index.js').RE2JS}
		*/ this.patternInput = pattern;
        var re2 = this.patternInput.re2();
        /** @type {number} */ this.patternGroupCount = re2.numberOfCapturingGroups();
        /** @type {number[]} */ this.groups = [];
        /** @type {Record<string, number>} */ this.namedGroups = re2.namedGroups;
        /** @type {number} */ this.numberOfInstructions = re2.numberOfInstructions();
        if (input instanceof $f8c5210791d45577$export$cefe1fb40cb8a0f6) this.resetMatcherInput(input);
        else if ($f8c5210791d45577$var$Utils.isByteArray(input)) this.resetMatcherInput($f8c5210791d45577$export$3430ac14b3833fca.utf8(input));
        else this.resetMatcherInput($f8c5210791d45577$export$3430ac14b3833fca.utf16(input));
    }
    (0, $6hK4i._)(Matcher, [
        {
            /**
	* Returns the {@code RE2JS} associated with this {@code Matcher}.
	* @returns {import('./index.js').RE2JS}
	*/ key: "pattern",
            value: function pattern() {
                return this.patternInput;
            }
        },
        {
            /**
	* Resets the {@code Matcher}, rewinding input and discarding any match information.
	*
	* @returns {Matcher} the {@code Matcher} itself, for chained method calls
	*/ key: "reset",
            value: function reset() {
                /** @type {number} */ this.matcherInputLength = this.matcherInput.length();
                /** @type {number} */ this.appendPos = 0;
                this.hasMatch = false;
                this.hasGroups = false;
                this.anchorFlag = 0;
                return this;
            }
        },
        {
            /**
	* Resets the {@code Matcher} and changes the input.
	* @param {string|number[]|Uint8Array|MatcherInputBase} input
	* @returns {Matcher} the {@code Matcher} itself, for chained method calls
	*/ key: "resetMatcherInput",
            value: function resetMatcherInput(input) {
                if (input === null) throw new Error("input is null");
                if (!(input instanceof $f8c5210791d45577$export$cefe1fb40cb8a0f6)) {
                    if ($f8c5210791d45577$var$Utils.isByteArray(input)) input = $f8c5210791d45577$export$3430ac14b3833fca.utf8(input);
                    else input = $f8c5210791d45577$export$3430ac14b3833fca.utf16(input);
                }
                this.matcherInput = input;
                this.reset();
                return this;
            }
        },
        {
            /**
	* Returns the start of the named group of the most recent match, or -1 if the group was not
	* matched.
	* @param {string|number} [group=0]
	* @returns {number}
	*/ key: "start",
            value: function start() {
                var group = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                if (typeof group === "string") {
                    var groupInt = this.namedGroups[group];
                    if (!Number.isFinite(groupInt)) throw new $f8c5210791d45577$export$eab8e70da4919c35("group '".concat(group, "' not found"));
                    group = groupInt;
                }
                this.loadGroup(group);
                return this.groups[2 * group];
            }
        },
        {
            /**
	* Returns the end of the named group of the most recent match, or -1 if the group was not
	* matched.
	* @param {string|number} [group=0]
	* @returns {number}
	*/ key: "end",
            value: function end() {
                var group = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                if (typeof group === "string") {
                    var groupInt = this.namedGroups[group];
                    if (!Number.isFinite(groupInt)) throw new $f8c5210791d45577$export$eab8e70da4919c35("group '".concat(group, "' not found"));
                    group = groupInt;
                }
                this.loadGroup(group);
                return this.groups[2 * group + 1];
            }
        },
        {
            /**
	* Returns the program size of this pattern.
	*
	* <p>
	* Similar to the C++ implementation, the program size is a very approximate measure of a regexp's
	* "cost". Larger numbers are more expensive than smaller numbers.
	* </p>
	*
	* @returns {number} the program size of this pattern
	*/ key: "programSize",
            value: function programSize() {
                return this.numberOfInstructions;
            }
        },
        {
            /**
	* Returns the named group of the most recent match, or {@code null} if the group was not matched.
	* @param {string|number} [group=0]
	* @returns {string|null}
	*/ key: "group",
            value: function group() {
                var group = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                if (typeof group === "string") {
                    var groupInt = this.namedGroups[group];
                    if (!Number.isFinite(groupInt)) throw new $f8c5210791d45577$export$eab8e70da4919c35("group '".concat(group, "' not found"));
                    group = groupInt;
                }
                var start = this.start(group);
                var end = this.end(group);
                if (start < 0 && end < 0) return null;
                return this.substring(start, end);
            }
        },
        {
            /**
	* Returns a dictionary map of all named capturing groups and their matched values.
	* If a group was not matched, its value will be `null`.
	* @returns {Record<string, string|null>}
	*/ key: "getNamedGroups",
            value: function getNamedGroups() {
                if (!this.hasMatch) throw new $f8c5210791d45577$export$eab8e70da4919c35("perhaps no match attempted");
                var result = Object.create(null);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(this.namedGroups)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var name = _step.value;
                        result[name] = this.group(name);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return result;
            }
        },
        {
            /**
	* Returns the number of subgroups in this pattern.
	*
	* @returns {number} the number of subgroups; the overall match (group 0) does not count
	*/ key: "groupCount",
            value: function groupCount() {
                return this.patternGroupCount;
            }
        },
        {
            /**
	* Helper: finds subgroup information if needed for group.
	* @param {number} group
	* @private
	*/ key: "loadGroup",
            value: function loadGroup(group) {
                if (group < 0 || group > this.patternGroupCount) throw new $f8c5210791d45577$export$eab8e70da4919c35("Group index out of bounds: ".concat(group));
                if (!this.hasMatch) throw new $f8c5210791d45577$export$eab8e70da4919c35("perhaps no match attempted");
                if (group === 0 || this.hasGroups) return;
                var end = this.matcherInputLength;
                var res = this.patternInput.re2().matchMachineInput(this.matcherInput, this.groups[0], end, this.anchorFlag, 1 + this.patternGroupCount);
                if (!res[0]) throw new $f8c5210791d45577$export$eab8e70da4919c35("inconsistency in matching group data");
                this.groups = res[1];
                this.hasGroups = true;
            }
        },
        {
            /**
	* Matches the entire input against the pattern (anchored start and end). If there is a match,
	* {@code matches} sets the match state to describe it.
	*
	* @returns {boolean} true if the entire input matches the pattern
	*/ key: "matches",
            value: function matches() {
                return this.genMatch(0, $f8c5210791d45577$var$RE2Flags.ANCHOR_BOTH);
            }
        },
        {
            /**
	* Matches the beginning of input against the pattern (anchored start). If there is a match,
	* {@code lookingAt} sets the match state to describe it.
	*
	* @returns {boolean} true if the beginning of the input matches the pattern
	*/ key: "lookingAt",
            value: function lookingAt() {
                return this.genMatch(0, $f8c5210791d45577$var$RE2Flags.ANCHOR_START);
            }
        },
        {
            /**
	* Matches the input against the pattern (unanchored), starting at a specified position. If there
	* is a match, {@code find} sets the match state to describe it.
	*
	* @param {number|null} [start=null] the input position where the search begins
	* @returns {boolean} if it finds a match
	* @throws IndexOutOfBoundsException if start is not a valid input position
	*/ key: "find",
            value: function find() {
                var start = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                if (start !== null) {
                    if (start < 0 || start > this.matcherInputLength) throw new $f8c5210791d45577$export$eab8e70da4919c35("start index out of bounds: ".concat(start));
                    this.reset();
                    return this.genMatch(start, 0);
                }
                start = 0;
                if (this.hasMatch) {
                    start = this.groups[1];
                    if (this.groups[0] === this.groups[1]) {
                        var r = (this.matcherInput.isUTF16Encoding() ? $f8c5210791d45577$var$MachineInput.fromUTF16(this.matcherInput.asCharSequence(), 0, this.matcherInputLength) : $f8c5210791d45577$var$MachineInput.fromUTF8(this.matcherInput.asBytes(), 0, this.matcherInputLength)).step(start);
                        if (r < 0) start++;
                        else start += r & 7;
                    }
                }
                return this.genMatch(start, $f8c5210791d45577$var$RE2Flags.UNANCHORED);
            }
        },
        {
            /**
	* Helper: does match starting at start, with RE2 anchor flag.
	* @param {number} startByte
	* @param {number} anchor
	* @returns {boolean}
	* @private
	*/ key: "genMatch",
            value: function genMatch(startByte, anchor) {
                var res = this.patternInput.re2().matchMachineInput(this.matcherInput, startByte, this.matcherInputLength, anchor, 1);
                if (!res[0]) {
                    this.hasMatch = false;
                    return false;
                }
                this.groups = res[1];
                this.hasMatch = true;
                this.hasGroups = this.patternGroupCount === 0;
                this.anchorFlag = anchor;
                return true;
            }
        },
        {
            /**
	* Helper: return substring for [start, end).
	* @param {number} start
	* @param {number} end
	* @returns {string}
	*/ key: "substring",
            value: function substring(start, end) {
                if (this.matcherInput.isUTF8Encoding()) return $f8c5210791d45577$var$Utils.utf8ByteArrayToString(this.matcherInput.asBytes().slice(start, end));
                return this.matcherInput.asCharSequence().substring(start, end).toString();
            }
        },
        {
            /**
	* Helper for Pattern: return input length.
	* @returns {number}
	*/ key: "inputLength",
            value: function inputLength() {
                return this.matcherInputLength;
            }
        },
        {
            /**
	* Appends to result two strings: the text from the append position up to the beginning of the
	* most recent match, and then the replacement with submatch groups substituted for references of
	* the form {@code $n}, where {@code n} is the group number in decimal. It advances the append
	* position to where the most recent match ended.
	*
	* To embed a literal {@code $}, use \$ (actually {@code "\\$"} with string escapes). The escape
	* is only necessary when {@code $} is followed by a digit, but it is always allowed. Only
	* {@code $} and {@code \} need escaping, but any character can be escaped.
	*
	* The group number {@code n} in {@code $n} is always at least one digit and expands to use more
	* digits as long as the resulting number is a valid group number for this pattern. To cut it off
	* earlier, escape the first digit that should not be used.
	*
	* @param {string} replacement the replacement string
	* @param {boolean} [javaMode=false] activate java mode (different behaviour for capture groups and special characters)
	* @returns {string}
	* @throws IllegalStateException if there was no most recent match
	* @throws IndexOutOfBoundsException if replacement refers to an invalid group
	* @private
	*/ key: "appendReplacement",
            value: function appendReplacement(replacement) {
                var javaMode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var res = "";
                var s = this.start();
                var e = this.end();
                if (this.appendPos < s) res += this.substring(this.appendPos, s);
                this.appendPos = e;
                res += javaMode ? this.appendReplacementInternalJava(replacement) : this.appendReplacementInternalJs(replacement);
                return res;
            }
        },
        {
            /**
	* @param {string} replacement - the replacement string
	* @returns {string}
	* @private
	*/ key: "appendReplacementInternalJava",
            value: function appendReplacementInternalJava(replacement) {
                var res = "";
                var last = 0;
                var m = replacement.length;
                var i = 0;
                while(i < m){
                    var cCode = replacement.codePointAt(i);
                    if (cCode === $f8c5210791d45577$var$Codepoint.CODES.get("\\")) {
                        if (last < i) res += replacement.substring(last, i);
                        i++;
                        if (i >= m) throw new $f8c5210791d45577$export$eab8e70da4919c35("character to be escaped is missing");
                        last = i;
                        i++;
                        continue;
                    }
                    if (cCode === $f8c5210791d45577$var$Codepoint.CODES.get("$")) {
                        if (last < i) res += replacement.substring(last, i);
                        if (i + 1 >= m) throw new $f8c5210791d45577$export$eab8e70da4919c35("Illegal group reference: group index is missing");
                        var nextCode = replacement.codePointAt(i + 1);
                        if ($f8c5210791d45577$var$Codepoint.CODES.get("0") <= nextCode && nextCode <= $f8c5210791d45577$var$Codepoint.CODES.get("9")) {
                            var n = nextCode - $f8c5210791d45577$var$Codepoint.CODES.get("0");
                            var j = i + 2;
                            for(; j < m; j++){
                                var digit = replacement.codePointAt(j);
                                if (digit < $f8c5210791d45577$var$Codepoint.CODES.get("0") || digit > $f8c5210791d45577$var$Codepoint.CODES.get("9") || n * 10 + digit - $f8c5210791d45577$var$Codepoint.CODES.get("0") > this.patternGroupCount) break;
                                n = n * 10 + digit - $f8c5210791d45577$var$Codepoint.CODES.get("0");
                            }
                            if (n > this.patternGroupCount) throw new $f8c5210791d45577$export$eab8e70da4919c35("n > number of groups: ".concat(n));
                            var group = this.group(n);
                            if (group !== null) res += group;
                            i = j;
                            last = i;
                        } else if (nextCode === $f8c5210791d45577$var$Codepoint.CODES.get("{")) {
                            var j1 = i + 2;
                            while(j1 < m && replacement.codePointAt(j1) !== $f8c5210791d45577$var$Codepoint.CODES.get("}"))j1++;
                            if (j1 >= m) throw new $f8c5210791d45577$export$eab8e70da4919c35("named capture group is missing trailing '}'");
                            var groupName = replacement.substring(i + 2, j1);
                            var groupVal = this.group(groupName);
                            if (groupVal !== null) res += groupVal;
                            i = j1 + 1;
                            last = i;
                        } else throw new $f8c5210791d45577$export$eab8e70da4919c35("Illegal group reference");
                        continue;
                    }
                    i++;
                }
                if (last < m) res += replacement.substring(last, m);
                return res;
            }
        },
        {
            /**
	* @param {string} replacement - the replacement string
	* @returns {string}
	* @private
	*/ key: "appendReplacementInternalJs",
            value: function appendReplacementInternalJs(replacement) {
                var res = "";
                var last = 0;
                var m = replacement.length;
                for(var i = 0; i < m - 1; i++)if (replacement.codePointAt(i) === $f8c5210791d45577$var$Codepoint.CODES.get("$")) {
                    var c = replacement.codePointAt(i + 1);
                    if ($f8c5210791d45577$var$Codepoint.CODES.get("$") === c) {
                        if (last < i) res += replacement.substring(last, i);
                        res += "$";
                        i++;
                        last = i + 1;
                        continue;
                    } else if ($f8c5210791d45577$var$Codepoint.CODES.get("&") === c) {
                        if (last < i) res += replacement.substring(last, i);
                        var group = this.group(0);
                        if (group !== null) res += group;
                        else res += "$&";
                        i++;
                        last = i + 1;
                        continue;
                    } else if ($f8c5210791d45577$var$Codepoint.CODES.get("`") === c) {
                        if (last < i) res += replacement.substring(last, i);
                        res += this.substring(0, this.start(0));
                        i++;
                        last = i + 1;
                        continue;
                    } else if ($f8c5210791d45577$var$Codepoint.CODES.get("'") === c) {
                        if (last < i) res += replacement.substring(last, i);
                        res += this.substring(this.end(0), this.matcherInputLength);
                        i++;
                        last = i + 1;
                        continue;
                    } else if ($f8c5210791d45577$var$Codepoint.CODES.get("1") <= c && c <= $f8c5210791d45577$var$Codepoint.CODES.get("9")) {
                        var n = c - $f8c5210791d45577$var$Codepoint.CODES.get("0");
                        if (last < i) res += replacement.substring(last, i);
                        for(i += 2; i < m; i++){
                            c = replacement.codePointAt(i);
                            if (c < $f8c5210791d45577$var$Codepoint.CODES.get("0") || c > $f8c5210791d45577$var$Codepoint.CODES.get("9") || n * 10 + c - $f8c5210791d45577$var$Codepoint.CODES.get("0") > this.patternGroupCount) break;
                            n = n * 10 + c - $f8c5210791d45577$var$Codepoint.CODES.get("0");
                        }
                        if (n > this.patternGroupCount) {
                            res += "$".concat(n);
                            last = i;
                            i--;
                            continue;
                        }
                        var group1 = this.group(n);
                        if (group1 !== null) res += group1;
                        last = i;
                        i--;
                        continue;
                    } else if (c === $f8c5210791d45577$var$Codepoint.CODES.get("<")) {
                        if (last < i) res += replacement.substring(last, i);
                        i++;
                        var j = i + 1;
                        while(j < replacement.length && replacement.codePointAt(j) !== $f8c5210791d45577$var$Codepoint.CODES.get(">") && replacement.codePointAt(j) !== $f8c5210791d45577$var$Codepoint.CODES.get(" "))j++;
                        if (j === replacement.length || replacement.codePointAt(j) !== $f8c5210791d45577$var$Codepoint.CODES.get(">")) {
                            res += replacement.substring(i - 1, j + 1);
                            last = j + 1;
                            i = j;
                            continue;
                        }
                        var groupName = replacement.substring(i + 1, j);
                        if (Object.prototype.hasOwnProperty.call(this.namedGroups, groupName)) {
                            var groupVal = this.group(groupName);
                            if (groupVal !== null) res += groupVal;
                        } else res += "$<".concat(groupName, ">");
                        last = j + 1;
                        i = j;
                        continue;
                    }
                }
                if (last < m) res += replacement.substring(last, m);
                return res;
            }
        },
        {
            /**
	* Return the substring of the input from the append position to the end of the
	* input.
	* @returns {string}
	*/ key: "appendTail",
            value: function appendTail() {
                return this.substring(this.appendPos, this.matcherInputLength);
            }
        },
        {
            /**
	* Returns the input with all matches replaced by {@code replacement}, interpreted as for
	* {@code appendReplacement}.
	*
	* @param {string|((...args: any[]) => string)} replacement - the replacement string or a replacer function
	* @param {boolean} [javaMode=false] - activate java mode (different behaviour for capture groups and special characters)
	* @returns {string} the input string with the matches replaced
	* @throws IndexOutOfBoundsException if replacement refers to an invalid group and javaMode is true
	*/ key: "replaceAll",
            value: function replaceAll(replacement) {
                var javaMode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                return this.replace(replacement, true, javaMode);
            }
        },
        {
            /**
	* Returns the input with the first match replaced by {@code replacement}, interpreted as for
	* {@code appendReplacement}.
	*
	* @param {string|((...args: any[]) => string)} replacement - the replacement string or a replacer function
	* @param {boolean} [javaMode=false] - activate java mode (different behaviour for capture groups and special characters)
	* @returns {string} the input string with the first match replaced
	* @throws IndexOutOfBoundsException if replacement refers to an invalid group and javaMode is true
	*/ key: "replaceFirst",
            value: function replaceFirst(replacement) {
                var javaMode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                return this.replace(replacement, false, javaMode);
            }
        },
        {
            /**
	* Helper: replaceAll/replaceFirst hybrid.
	* @param {string|((...args: any[]) => string)} replacement - the replacement string or a replacer function
	* @param {boolean} [all=true] - replace all matches
	* @param {boolean} [javaMode=false] - activate java mode (different behaviour for capture groups and special characters)
	* @returns {string}
	* @private
	*/ key: "replace",
            value: function replace(replacement) {
                var all = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, javaMode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                var res = "";
                this.reset();
                var isFunc = typeof replacement === "function";
                var hasNamedGroups = Object.keys(this.namedGroups).length > 0;
                var originalInput = null;
                if (isFunc) {
                    if (this.groupCount() >= Matcher.MAX_REPLACER_ARGS) throw new $f8c5210791d45577$export$eab8e70da4919c35("Too many capture groups to safely invoke replacer function");
                    originalInput = this.matcherInput.isUTF8Encoding() ? this.matcherInput.asBytes() : this.matcherInput.asCharSequence();
                }
                while(this.find()){
                    res += isFunc ? this.appendReplacementFunc(replacement, hasNamedGroups, originalInput) : this.appendReplacement(replacement, javaMode);
                    if (!all) break;
                }
                res += this.appendTail();
                return res;
            }
        },
        {
            /**
	* Evaluates a replacer function for the current match and appends the result,
	* along with any un-matched preceding text, advancing the append position.
	* @param {Function} replacer - the replacer function
	* @param {boolean} hasNamedGroups - cached flag if pattern has named groups
	* @param {string|Uint8Array|number[]} originalInput - the cached original input reference
	* @returns {string} the evaluated string to append
	* @private
	*/ key: "appendReplacementFunc",
            value: function appendReplacementFunc(replacer, hasNamedGroups, originalInput) {
                var res = "";
                var s = this.start();
                var e = this.end();
                if (this.appendPos < s) res += this.substring(this.appendPos, s);
                this.appendPos = e;
                var args = this.buildReplacerArgs(s, hasNamedGroups, originalInput);
                res += String(replacer.apply(void 0, (0, $jlUaU._)(args)));
                return res;
            }
        },
        {
            /**
	* Builds the argument array for the replacer function matching the standard
	* JS String.prototype.replace(regex, replacer) signature.
	* @param {number} matchStart - the start index of the match
	* @param {boolean} hasNamedGroups - cached flag if pattern has named groups
	* @param {string|Uint8Array|number[]} originalInput - the cached original input reference
	* @returns {Array} array of arguments
	* @private
	*/ key: "buildReplacerArgs",
            value: function buildReplacerArgs(matchStart, hasNamedGroups, originalInput) {
                var args = [
                    this.group(0)
                ];
                var numGroups = this.groupCount();
                for(var i = 1; i <= numGroups; i++){
                    var start = this.start(i);
                    if (start < 0) args.push(void 0);
                    else args.push(this.substring(start, this.end(i)));
                }
                args.push(matchStart);
                args.push(originalInput);
                if (hasNamedGroups) {
                    var parsedGroups = this.getNamedGroups();
                    for(var key in parsedGroups)if (parsedGroups[key] === null) parsedGroups[key] = void 0;
                    args.push(parsedGroups);
                }
                return args;
            }
        }
    ], [
        {
            key: "quoteReplacement",
            value: /**
	* Quotes '\' and '$' in {@code s}, so that the returned string could be used in
	* {@link #appendReplacement} as a literal replacement of {@code s}.
	*
	* @param {string} str the string to be quoted
	* @param {boolean} [javaMode=false] whether the replacement will be used in javaMode
	* @returns {string} the quoted string
	*/ function quoteReplacement(str) {
                var javaMode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (javaMode) {
                    if (str.indexOf("\\") < 0 && str.indexOf("$") < 0) return str;
                    return str.split("").map(function(s) {
                        var c = s.codePointAt(0);
                        if (c === $f8c5210791d45577$var$Codepoint.CODES.get("\\") || c === $f8c5210791d45577$var$Codepoint.CODES.get("$")) return "\\".concat(s);
                        return s;
                    }).join("");
                }
                if (str.indexOf("$") < 0) return str;
                return str.split("").map(function(s) {
                    if (s.codePointAt(0) === $f8c5210791d45577$var$Codepoint.CODES.get("$")) return "$$";
                    return s;
                }).join("");
            }
        }
    ]);
    return Matcher;
}(), /**
	* V8 and WebKit have historical hard limits on the number of arguments
	* that can be passed to a function. We cap replacer arguments to prevent
	* Call Stack Overflow (DoS) vulnerabilities on massive ASTs.
	*/ (0, $6tY97._)($f8c5210791d45577$var$_Matcher, "MAX_REPLACER_ARGS", 65535), $f8c5210791d45577$var$_Matcher);
//#endregion
//#region src/Inst.js
/**
* A single instruction in the regular expression virtual machine.
*
* @see http://swtch.com/~rsc/regexp/regexp2.html
*/ var $f8c5210791d45577$var$Inst = ($f8c5210791d45577$var$_Inst = /*#__PURE__*/ function() {
    "use strict";
    function Inst(op) {
        (0, $4QweW._)(this, Inst);
        this.op = op;
        this.out = 0;
        this.arg = 0;
        this.runes = [];
        /** @type {Uint32Array | number[] | null} */ this.next = null;
    }
    (0, $6hK4i._)(Inst, [
        {
            key: "matchRune",
            value: function matchRune(r) {
                if (this.runes.length === 1) {
                    var r0 = this.runes[0];
                    if ((this.arg & $f8c5210791d45577$var$RE2Flags.FOLD_CASE) !== 0) return $f8c5210791d45577$var$Unicode.equalsIgnoreCase(r0, r);
                    return r === r0;
                }
                var len = this.runes.length;
                if (len === 0) return false;
                if (len === 2 || len === 4 || len === 6 || len === 8) {
                    for(var j = 0; j < len; j += 2){
                        if (r < this.runes[j]) return false;
                        if (r <= this.runes[j + 1]) return true;
                    }
                    return false;
                }
                var base = 0;
                var n = len >> 1;
                while(n > 1){
                    var half = n >> 1;
                    base += this.runes[base + half << 1] <= r ? half : 0;
                    n -= half;
                }
                base += this.runes[base << 1] <= r ? 1 : 0;
                var m = base - 1;
                return m >= 0 && r <= this.runes[m << 1 | 1];
            }
        },
        {
            key: "matchRunePos",
            value: function matchRunePos(r) {
                if (this.runes.length === 1) {
                    var r0 = this.runes[0];
                    if ((this.arg & $f8c5210791d45577$var$RE2Flags.FOLD_CASE) !== 0) return $f8c5210791d45577$var$Unicode.equalsIgnoreCase(r0, r) ? 0 : -1;
                    return r === r0 ? 0 : -1;
                }
                var len = this.runes.length;
                if (len === 0) return -1;
                if (len === 2 || len === 4 || len === 6 || len === 8) {
                    for(var j = 0; j < len; j += 2){
                        if (r < this.runes[j]) return -1;
                        if (r <= this.runes[j + 1]) return Math.floor(j / 2);
                    }
                    return -1;
                }
                var base = 0;
                var n = len >> 1;
                while(n > 1){
                    var half = n >> 1;
                    base += this.runes[base + half << 1] <= r ? half : 0;
                    n -= half;
                }
                base += this.runes[base << 1] <= r ? 1 : 0;
                var m = base - 1;
                return m >= 0 && r <= this.runes[m << 1 | 1] ? m : -1;
            }
        },
        {
            /**
	*
	* @returns {string}
	*/ key: "toString",
            value: function toString() {
                switch(this.op){
                    case Inst.ALT:
                        return "alt -> ".concat(this.out, ", ").concat(this.arg);
                    case Inst.ALT_MATCH:
                        return "altmatch -> ".concat(this.out, ", ").concat(this.arg);
                    case Inst.CAPTURE:
                        return "cap ".concat(this.arg, " -> ").concat(this.out);
                    case Inst.EMPTY_WIDTH:
                        return "empty ".concat(this.arg, " -> ").concat(this.out);
                    case Inst.MATCH:
                        return "match".concat(this.arg !== 0 ? " ".concat(this.arg) : "");
                    case Inst.FAIL:
                        return "fail";
                    case Inst.NOP:
                        return "nop -> ".concat(this.out);
                    case Inst.LB_WRITE:
                        return "lbwrite ".concat(this.arg, " -> ").concat(this.out);
                    case Inst.LB_CHECK:
                        return "lbcheck ".concat(this.arg, " -> ").concat(this.out);
                    case Inst.RUNE:
                        if (this.runes === null) return "rune <null>";
                        return [
                            "rune ",
                            Inst.escapeRunes(this.runes),
                            (this.arg & $f8c5210791d45577$var$RE2Flags.FOLD_CASE) !== 0 ? "/i" : "",
                            " -> ",
                            this.out
                        ].join("");
                    case Inst.RUNE1:
                        return "rune1 ".concat(Inst.escapeRunes(this.runes), " -> ").concat(this.out);
                    case Inst.RUNE_ANY:
                        return "any -> ".concat(this.out);
                    case Inst.RUNE_ANY_NOT_NL:
                        return "anynotnl -> ".concat(this.out);
                    default:
                        throw new Error("unhandled case in Inst.toString");
                }
            }
        }
    ], [
        {
            key: "isRuneOp",
            value: function isRuneOp(op) {
                return Inst.RUNE <= op && op <= Inst.RUNE_ANY_NOT_NL;
            }
        },
        {
            key: "escapeRunes",
            value: function escapeRunes(runes) {
                var out = "\"";
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = runes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var rune = _step.value;
                        out += $f8c5210791d45577$var$Utils.escapeRune(rune);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                out += "\"";
                return out;
            }
        }
    ]);
    return Inst;
}(), (0, $6tY97._)($f8c5210791d45577$var$_Inst, "ALT", 1), (0, $6tY97._)($f8c5210791d45577$var$_Inst, "ALT_MATCH", 2), (0, $6tY97._)($f8c5210791d45577$var$_Inst, "CAPTURE", 3), (0, $6tY97._)($f8c5210791d45577$var$_Inst, "EMPTY_WIDTH", 4), (0, $6tY97._)($f8c5210791d45577$var$_Inst, "FAIL", 5), (0, $6tY97._)($f8c5210791d45577$var$_Inst, "MATCH", 6), (0, $6tY97._)($f8c5210791d45577$var$_Inst, "NOP", 7), (0, $6tY97._)($f8c5210791d45577$var$_Inst, "RUNE", 8), (0, $6tY97._)($f8c5210791d45577$var$_Inst, "RUNE1", 9), (0, $6tY97._)($f8c5210791d45577$var$_Inst, "RUNE_ANY", 10), (0, $6tY97._)($f8c5210791d45577$var$_Inst, "RUNE_ANY_NOT_NL", 11), (0, $6tY97._)($f8c5210791d45577$var$_Inst, "LB_WRITE", 12), (0, $6tY97._)($f8c5210791d45577$var$_Inst, "LB_CHECK", 13), $f8c5210791d45577$var$_Inst);
//#endregion
//#region src/Machine.js
var $f8c5210791d45577$var$Queue = /*#__PURE__*/ function() {
    "use strict";
    function Queue(numInst) {
        (0, $4QweW._)(this, Queue);
        this.sparse = new Int32Array(numInst);
        this.densePcs = new Int32Array(numInst);
        this.denseCaps = null;
        this.size = 0;
        this.ncap = 0;
    }
    (0, $6hK4i._)(Queue, [
        {
            key: "init",
            value: function init(ncap) {
                this.ncap = ncap;
                var needed = this.densePcs.length * ncap;
                if (!this.denseCaps || this.denseCaps.length < needed) this.denseCaps = new Int32Array(needed);
            }
        },
        {
            key: "contains",
            value: function contains(pc) {
                var j = this.sparse[pc];
                return j < this.size && this.densePcs[j] === pc;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.size === 0;
            }
        },
        {
            key: "add",
            value: function add(pc) {
                var j = this.size++;
                this.sparse[pc] = j;
                this.densePcs[j] = pc;
                return j;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.size = 0;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var out = "{";
                for(var i = 0; i < this.size; i++){
                    if (i !== 0) out += ", ";
                    out += this.densePcs[i];
                }
                out += "}";
                return out;
            }
        }
    ]);
    return Queue;
}();
var $f8c5210791d45577$var$Machine = /*#__PURE__*/ function() {
    "use strict";
    function Machine() {
        (0, $4QweW._)(this, Machine);
        this.prog = null;
        this.re2 = null;
        this.q0 = null;
        this.q1 = null;
        this.matched = false;
        this.matchcap = null;
        this.ncap = 0;
        this.lbTable = null;
    }
    (0, $6hK4i._)(Machine, [
        {
            key: "init",
            value: function init(ncap) {
                this.ncap = ncap;
                if (ncap > this.matchcap.length) this.matchcap = new Int32Array(ncap).fill(-1);
                else this.matchcap.fill(-1);
                this.q0.init(ncap);
                this.q1.init(ncap);
                if (this.prog.numLb > 0) {
                    if (!this.lbTable || this.lbTable.length < this.prog.numLb + 1) this.lbTable = new Int32Array(this.prog.numLb + 1);
                    this.lbTable.fill(-1);
                }
            }
        },
        {
            key: "submatches",
            value: function submatches() {
                if (this.ncap === 0) return $f8c5210791d45577$var$Utils.emptyInts();
                return $f8c5210791d45577$var$Utils.toArray(this.matchcap.subarray(0, this.ncap));
            }
        },
        {
            key: "match",
            value: function match(input, pos, anchor) {
                var startCond = this.re2.cond;
                if (startCond === $f8c5210791d45577$var$Utils.EMPTY_ALL) return false;
                if ((anchor === $f8c5210791d45577$var$RE2Flags.ANCHOR_START || anchor === $f8c5210791d45577$var$RE2Flags.ANCHOR_BOTH) && pos !== 0) return false;
                this.matched = false;
                this.matchcap.fill(-1);
                var currentPos = this.prog.numLb > 0 ? 0 : pos;
                var matchStartPos = pos;
                var runq = this.q0;
                var nextq = this.q1;
                var r = input.step(currentPos);
                var rune = r >> 3;
                var width = r & 7;
                var rune1 = -1;
                var width1 = 0;
                if (r !== $f8c5210791d45577$var$MachineInputBase.EOF()) {
                    r = input.step(currentPos + width);
                    rune1 = r >> 3;
                    width1 = r & 7;
                }
                var flag;
                if (currentPos === 0) flag = $f8c5210791d45577$var$Utils.emptyOpContext(-1, rune);
                else flag = input.context(currentPos);
                while(true){
                    if (runq.isEmpty()) {
                        if ((startCond & $f8c5210791d45577$var$Utils.EMPTY_BEGIN_TEXT) !== 0 && currentPos !== 0) break;
                        if ((anchor === $f8c5210791d45577$var$RE2Flags.ANCHOR_START || anchor === $f8c5210791d45577$var$RE2Flags.ANCHOR_BOTH) && currentPos !== 0) break;
                        if (this.matched) break;
                        if (this.prog.numLb === 0 && !(this.re2.prefix.length === 0) && rune1 !== this.re2.prefixRune && input.canCheckPrefix()) {
                            var advance = input.index(this.re2, currentPos);
                            if (advance < 0) break;
                            currentPos += advance;
                            r = input.step(currentPos);
                            rune = r >> 3;
                            width = r & 7;
                            r = input.step(currentPos + width);
                            rune1 = r >> 3;
                            width1 = r & 7;
                            flag = input.context(currentPos);
                        }
                    }
                    if (currentPos === 0 && this.prog.numLb > 0) for(var i = 0; i < this.prog.lbStarts.length; i++)this.add(runq, this.prog.lbStarts[i], currentPos, this.matchcap, 0, flag);
                    if (!this.matched && (currentPos === 0 || anchor === $f8c5210791d45577$var$RE2Flags.UNANCHORED)) {
                        if (currentPos >= matchStartPos) {
                            if (this.ncap > 0) this.matchcap[0] = currentPos;
                            this.add(runq, this.prog.start, currentPos, this.matchcap, 0, flag);
                        }
                    }
                    var nextPos = currentPos + width;
                    flag = input.context(nextPos);
                    this.step(runq, nextq, currentPos, nextPos, rune, flag, anchor, currentPos === input.endPos());
                    if (width === 0) break;
                    if (this.ncap === 0 && this.matched) break;
                    currentPos += width;
                    rune = rune1;
                    width = width1;
                    if (rune !== -1) {
                        r = input.step(currentPos + width);
                        rune1 = r >> 3;
                        width1 = r & 7;
                    }
                    var tmpq = runq;
                    runq = nextq;
                    nextq = tmpq;
                }
                nextq.clear();
                return this.matched;
            }
        },
        {
            key: "matchSet",
            value: function matchSet(input, pos, anchor) {
                var startCond = this.re2.cond;
                if (startCond === $f8c5210791d45577$var$Utils.EMPTY_ALL) return [];
                if ((anchor === $f8c5210791d45577$var$RE2Flags.ANCHOR_START || anchor === $f8c5210791d45577$var$RE2Flags.ANCHOR_BOTH) && pos !== 0) return [];
                var currentPos = this.prog.numLb > 0 ? 0 : pos;
                var matchStartPos = pos;
                var runq = this.q0;
                var nextq = this.q1;
                var r = input.step(currentPos);
                var rune = r >> 3;
                var width = r & 7;
                var rune1 = -1;
                var width1 = 0;
                if (r !== $f8c5210791d45577$var$MachineInputBase.EOF()) {
                    r = input.step(currentPos + width);
                    rune1 = r >> 3;
                    width1 = r & 7;
                }
                var flag = currentPos === 0 ? $f8c5210791d45577$var$Utils.emptyOpContext(-1, rune) : input.context(currentPos);
                var matches = /* @__PURE__ */ new Set();
                while(true){
                    if (runq.isEmpty()) {
                        if ((startCond & $f8c5210791d45577$var$Utils.EMPTY_BEGIN_TEXT) !== 0 && currentPos !== 0) break;
                        if ((anchor === $f8c5210791d45577$var$RE2Flags.ANCHOR_START || anchor === $f8c5210791d45577$var$RE2Flags.ANCHOR_BOTH) && currentPos !== 0) break;
                    }
                    if (currentPos === 0 && this.prog.numLb > 0) for(var i = 0; i < this.prog.lbStarts.length; i++)this.add(runq, this.prog.lbStarts[i], currentPos, this.matchcap, 0, flag);
                    if (currentPos === 0 || anchor === $f8c5210791d45577$var$RE2Flags.UNANCHORED) {
                        if (currentPos >= matchStartPos) this.add(runq, this.prog.start, currentPos, this.matchcap, 0, flag);
                    }
                    var nextPos = currentPos + width;
                    flag = input.context(nextPos);
                    for(var j = 0; j < runq.size; j++){
                        var pc = runq.densePcs[j];
                        var i1 = this.prog.inst[pc];
                        var capOffset = j * this.ncap;
                        var add = false;
                        switch(i1.op){
                            case $f8c5210791d45577$var$Inst.MATCH:
                                if (anchor === $f8c5210791d45577$var$RE2Flags.ANCHOR_BOTH && currentPos !== input.endPos()) break;
                                matches.add(i1.arg);
                                break;
                            case $f8c5210791d45577$var$Inst.RUNE:
                                add = i1.matchRune(rune);
                                break;
                            case $f8c5210791d45577$var$Inst.RUNE1:
                                add = rune === i1.runes[0];
                                break;
                            case $f8c5210791d45577$var$Inst.RUNE_ANY:
                                add = true;
                                break;
                            case $f8c5210791d45577$var$Inst.RUNE_ANY_NOT_NL:
                                add = rune !== 10;
                                break;
                            default:
                                continue;
                        }
                        if (add) this.add(nextq, i1.out, nextPos, runq.denseCaps, capOffset, flag);
                    }
                    runq.clear();
                    if (width === 0) break;
                    currentPos += width;
                    rune = rune1;
                    width = width1;
                    if (rune !== -1) {
                        r = input.step(currentPos + width);
                        rune1 = r >> 3;
                        width1 = r & 7;
                    }
                    var tmpq = runq;
                    runq = nextq;
                    nextq = tmpq;
                }
                nextq.clear();
                return Array.from(matches).sort(function(a, b) {
                    return a - b;
                });
            }
        },
        {
            key: "step",
            value: function step(runq, nextq, pos, nextPos, c, nextCond, anchor, atEnd) {
                var longest = this.re2.longest;
                for(var j = 0; j < runq.size; j++){
                    var pc = runq.densePcs[j];
                    var capOffset = j * this.ncap;
                    if (longest && this.matched && this.ncap > 0 && this.matchcap[0] < runq.denseCaps[capOffset]) continue;
                    var i = this.prog.inst[pc];
                    var add = false;
                    switch(i.op){
                        case $f8c5210791d45577$var$Inst.MATCH:
                            if (anchor === $f8c5210791d45577$var$RE2Flags.ANCHOR_BOTH && !atEnd) break;
                            if (this.ncap > 0 && (!longest || !this.matched || this.matchcap[1] < pos)) {
                                runq.denseCaps[capOffset + 1] = pos;
                                for(var k = 0; k < this.ncap; k++)this.matchcap[k] = runq.denseCaps[capOffset + k];
                            }
                            if (!longest) runq.size = 0;
                            this.matched = true;
                            break;
                        case $f8c5210791d45577$var$Inst.RUNE:
                            add = i.matchRune(c);
                            break;
                        case $f8c5210791d45577$var$Inst.RUNE1:
                            add = c === i.runes[0];
                            break;
                        case $f8c5210791d45577$var$Inst.RUNE_ANY:
                            add = true;
                            break;
                        case $f8c5210791d45577$var$Inst.RUNE_ANY_NOT_NL:
                            add = c !== 10;
                            break;
                        default:
                            continue;
                    }
                    if (add) this.add(nextq, i.out, nextPos, runq.denseCaps, capOffset, nextCond);
                }
                runq.clear();
            }
        },
        {
            key: "add",
            value: function add(q, pc, pos, capArray, capOffset, cond) {
                while(true){
                    if (pc === 0) return;
                    if (q.contains(pc)) return;
                    var d = q.add(pc);
                    var inst = this.prog.inst[pc];
                    switch(inst.op){
                        case $f8c5210791d45577$var$Inst.FAIL:
                            return;
                        case $f8c5210791d45577$var$Inst.ALT:
                        case $f8c5210791d45577$var$Inst.ALT_MATCH:
                            this.add(q, inst.out, pos, capArray, capOffset, cond);
                            pc = inst.arg;
                            continue;
                        case $f8c5210791d45577$var$Inst.EMPTY_WIDTH:
                            if ((inst.arg & ~cond) === 0) {
                                pc = inst.out;
                                continue;
                            }
                            return;
                        case $f8c5210791d45577$var$Inst.NOP:
                            pc = inst.out;
                            continue;
                        case $f8c5210791d45577$var$Inst.CAPTURE:
                            if (inst.arg < this.ncap) {
                                var opos = capArray[capOffset + inst.arg];
                                capArray[capOffset + inst.arg] = pos;
                                this.add(q, inst.out, pos, capArray, capOffset, cond);
                                capArray[capOffset + inst.arg] = opos;
                                return;
                            } else {
                                pc = inst.out;
                                continue;
                            }
                        case $f8c5210791d45577$var$Inst.LB_WRITE:
                            this.lbTable[Math.abs(inst.arg)] = pos;
                            pc = inst.out;
                            continue;
                        case $f8c5210791d45577$var$Inst.LB_CHECK:
                            if (inst.arg > 0) {
                                if (this.lbTable[inst.arg] === pos) {
                                    pc = inst.out;
                                    continue;
                                }
                            } else if (this.lbTable[-inst.arg] !== pos) {
                                pc = inst.out;
                                continue;
                            }
                            return;
                        case $f8c5210791d45577$var$Inst.MATCH:
                        case $f8c5210791d45577$var$Inst.RUNE:
                        case $f8c5210791d45577$var$Inst.RUNE1:
                        case $f8c5210791d45577$var$Inst.RUNE_ANY:
                        case $f8c5210791d45577$var$Inst.RUNE_ANY_NOT_NL:
                            if (this.ncap > 0) {
                                var destOffset = d * this.ncap;
                                for(var c = 0; c < this.ncap; c++)q.denseCaps[destOffset + c] = capArray[capOffset + c];
                            }
                            return;
                        default:
                            throw new $f8c5210791d45577$export$3a148716bb6e0468("unhandled");
                    }
                }
            }
        }
    ], [
        {
            key: "fromRE2",
            value: function fromRE2(re2) {
                var m = new Machine();
                m.prog = re2.prog;
                m.re2 = re2;
                m.q0 = new $f8c5210791d45577$var$Queue(m.prog.numInst());
                m.q1 = new $f8c5210791d45577$var$Queue(m.prog.numInst());
                m.matched = false;
                m.matchcap = new Int32Array(m.prog.numCap < 2 ? 2 : m.prog.numCap);
                m.ncap = 0;
                return m;
            }
        },
        {
            key: "fromMachine",
            value: function fromMachine(machine) {
                return Machine.fromRE2(machine.re2);
            }
        }
    ]);
    return Machine;
}();
//#endregion
//#region src/DFA.js
var $f8c5210791d45577$var$hashPCs = function(pcs) {
    var h = -2128831035;
    for(var i = 0; i < pcs.length; i++){
        h ^= pcs[i];
        h = Math.imul(h, 16777619);
    }
    return h;
};
var $f8c5210791d45577$var$arraysEqual = function(a, b) {
    if (a.length !== b.length) return false;
    for(var i = 0; i < a.length; i++)if (a[i] !== b[i]) return false;
    return true;
};
var $f8c5210791d45577$var$DFAState = function DFAState(nfaStates, isMatch) {
    "use strict";
    var matchIDs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    (0, $4QweW._)(this, DFAState);
    this.nfaStates = nfaStates;
    this.isMatch = isMatch;
    this.matchIDs = matchIDs;
    this.nextLatin1 = new Array($f8c5210791d45577$var$Unicode.MAX_LATIN1 + 1).fill(null);
    this.nextLatin1Anchored = new Array($f8c5210791d45577$var$Unicode.MAX_LATIN1 + 1).fill(null);
    this.transKeys = [];
    this.transVals = [];
    this.lastSeen = 0;
};
var $f8c5210791d45577$var$DFA = ($f8c5210791d45577$var$_DFA = /*#__PURE__*/ function() {
    "use strict";
    function DFA(prog) {
        var maxMem = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 8388608;
        (0, $4QweW._)(this, DFA);
        this.prog = prog;
        this.stateCache = /* @__PURE__ */ new Map();
        this.stateCount = 0;
        this.startState = null;
        this.stateLimit = Math.max(1, Math.floor(maxMem / DFA.STATE_MEMORY_ESTIMATE));
        this.cacheClears = 0;
        this.failed = false;
        this.clock = 0;
    }
    (0, $6hK4i._)(DFA, [
        {
            key: "computeClosure",
            value: function computeClosure(pcs) {
                var closure = /* @__PURE__ */ new Set();
                var stack = (0, $jlUaU._)(pcs);
                var isMatch = false;
                var matchIDs = [];
                while(stack.length > 0){
                    var pc = stack.pop();
                    if (closure.has(pc)) continue;
                    closure.add(pc);
                    var inst = this.prog.getInst(pc);
                    switch(inst.op){
                        case $f8c5210791d45577$var$Inst.MATCH:
                            isMatch = true;
                            if (!matchIDs.includes(inst.arg)) matchIDs.push(inst.arg);
                            break;
                        case $f8c5210791d45577$var$Inst.ALT:
                        case $f8c5210791d45577$var$Inst.ALT_MATCH:
                            stack.push(inst.out);
                            stack.push(inst.arg);
                            break;
                        case $f8c5210791d45577$var$Inst.NOP:
                        case $f8c5210791d45577$var$Inst.CAPTURE:
                            stack.push(inst.out);
                            break;
                        case $f8c5210791d45577$var$Inst.EMPTY_WIDTH:
                        case $f8c5210791d45577$var$Inst.LB_WRITE:
                        case $f8c5210791d45577$var$Inst.LB_CHECK:
                            return null;
                    }
                }
                var sortedPCs = Int32Array.from(closure).sort();
                matchIDs.sort(function(a, b) {
                    return a - b;
                });
                return {
                    pcs: sortedPCs,
                    isMatch: isMatch,
                    matchIDs: matchIDs
                };
            }
        },
        {
            key: "getState",
            value: function getState(pcs) {
                var closureResult = this.computeClosure(pcs);
                if (!closureResult) return null;
                var sortedPCs = closureResult.pcs;
                var hash = $f8c5210791d45577$var$hashPCs(sortedPCs);
                var bucket = this.stateCache.get(hash);
                if (bucket) for(var i = 0; i < bucket.length; i++){
                    var state = bucket[i];
                    if ($f8c5210791d45577$var$arraysEqual(state.nfaStates, sortedPCs)) {
                        state.lastSeen = ++this.clock;
                        return state;
                    }
                }
                else {
                    bucket = [];
                    this.stateCache.set(hash, bucket);
                }
                if (this.failed) return null;
                if (this.stateCount >= this.stateLimit) {
                    this.cacheClears++;
                    if (this.cacheClears >= DFA.MAX_CACHE_CLEARS) {
                        this.failed = true;
                        this.stateCache.clear();
                        this.stateCount = 0;
                        this.startState = null;
                        return null;
                    }
                    this.evictCache();
                    bucket = this.stateCache.get(hash);
                    if (!bucket) {
                        bucket = [];
                        this.stateCache.set(hash, bucket);
                    }
                }
                var state1 = new $f8c5210791d45577$var$DFAState(sortedPCs, closureResult.isMatch, closureResult.matchIDs);
                state1.lastSeen = ++this.clock;
                bucket.push(state1);
                this.stateCount++;
                return state1;
            }
        },
        {
            key: "evictCache",
            value: function evictCache() {
                var allStates = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.stateCache.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var bucket = _step.value;
                        for(var i = 0; i < bucket.length; i++)allStates.push(bucket[i]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                allStates.sort(function(a, b) {
                    return a.lastSeen - b.lastSeen;
                });
                var keepCount = Math.max(1, Math.floor(this.stateLimit / 2));
                var startIndex = allStates.length - keepCount;
                var survivorsArray = allStates.slice(startIndex);
                var survivors = new Set(survivorsArray);
                this.stateCache.clear();
                this.stateCount = 0;
                for(var i1 = 0; i1 < survivorsArray.length; i1++){
                    var state = survivorsArray[i1];
                    state.nextLatin1.fill(null);
                    state.nextLatin1Anchored.fill(null);
                    state.transKeys.length = 0;
                    state.transVals.length = 0;
                    var hash = $f8c5210791d45577$var$hashPCs(state.nfaStates);
                    var bucket1 = this.stateCache.get(hash);
                    if (!bucket1) {
                        bucket1 = [];
                        this.stateCache.set(hash, bucket1);
                    }
                    bucket1.push(state);
                    this.stateCount++;
                }
                if (this.startState && !survivors.has(this.startState)) this.startState = null;
            }
        },
        {
            key: "step",
            value: function step(state, charCode, anchor) {
                if (charCode <= $f8c5210791d45577$var$Unicode.MAX_LATIN1) {
                    if (anchor === $f8c5210791d45577$var$RE2Flags.UNANCHORED) {
                        var next = state.nextLatin1[charCode];
                        if (next !== null) return next;
                    } else {
                        var next1 = state.nextLatin1Anchored[charCode];
                        if (next1 !== null) return next1;
                    }
                } else {
                    var key = charCode + (anchor === $f8c5210791d45577$var$RE2Flags.UNANCHORED ? 0 : $f8c5210791d45577$var$Unicode.MAX_RUNE + 1);
                    var keys = state.transKeys;
                    var len = keys.length;
                    for(var i = 0; i < len; i++)if (keys[i] === key) return state.transVals[i];
                }
                var nextPCs = [];
                for(var i1 = 0; i1 < state.nfaStates.length; i1++){
                    var pc = state.nfaStates[i1];
                    var inst = this.prog.getInst(pc);
                    if ($f8c5210791d45577$var$Inst.isRuneOp(inst.op) && inst.matchRune(charCode)) nextPCs.push(inst.out);
                }
                if (anchor === $f8c5210791d45577$var$RE2Flags.UNANCHORED) nextPCs.push(this.prog.start);
                var nextState = this.getState(nextPCs);
                if (charCode <= $f8c5210791d45577$var$Unicode.MAX_LATIN1) {
                    if (anchor === $f8c5210791d45577$var$RE2Flags.UNANCHORED) state.nextLatin1[charCode] = nextState;
                    else state.nextLatin1Anchored[charCode] = nextState;
                } else {
                    var key1 = charCode + (anchor === $f8c5210791d45577$var$RE2Flags.UNANCHORED ? 0 : $f8c5210791d45577$var$Unicode.MAX_RUNE + 1);
                    state.transKeys.push(key1);
                    state.transVals.push(nextState);
                }
                return nextState;
            }
        },
        {
            key: "match",
            value: function match(input, pos, anchor) {
                if ((anchor === $f8c5210791d45577$var$RE2Flags.ANCHOR_START || anchor === $f8c5210791d45577$var$RE2Flags.ANCHOR_BOTH) && pos !== 0) return false;
                if (!this.startState) {
                    this.startState = this.getState([
                        this.prog.start
                    ]);
                    if (!this.startState) return null;
                }
                var endPos = input.endPos();
                var currentState = this.startState;
                if (currentState.isMatch) {
                    if (anchor === $f8c5210791d45577$var$RE2Flags.ANCHOR_BOTH) {
                        if (pos === endPos) return true;
                    } else return true;
                }
                var i = pos;
                while(i < endPos){
                    var r = input.step(i);
                    var rune = r >> 3;
                    var width = r & 7;
                    if (width === 0) break;
                    currentState = anchor === $f8c5210791d45577$var$RE2Flags.UNANCHORED && rune <= $f8c5210791d45577$var$Unicode.MAX_LATIN1 && currentState.nextLatin1[rune] || this.step(currentState, rune, anchor);
                    if (currentState === null) return null;
                    currentState.lastSeen = ++this.clock;
                    if (currentState.isMatch) {
                        if (anchor === $f8c5210791d45577$var$RE2Flags.ANCHOR_BOTH) {
                            if (i + width === endPos) return true;
                        } else return true;
                    }
                    if (currentState.nfaStates.length === 0) {
                        if (anchor !== $f8c5210791d45577$var$RE2Flags.UNANCHORED) return false;
                    }
                    i += width;
                }
                return false;
            }
        },
        {
            key: "matchSet",
            value: function matchSet(input, pos, anchor) {
                if ((anchor === $f8c5210791d45577$var$RE2Flags.ANCHOR_START || anchor === $f8c5210791d45577$var$RE2Flags.ANCHOR_BOTH) && pos !== 0) return [];
                if (!this.startState) {
                    this.startState = this.getState([
                        this.prog.start
                    ]);
                    if (!this.startState) return null;
                }
                var endPos = input.endPos();
                var currentState = this.startState;
                var matches = /* @__PURE__ */ new Set();
                var checkMatch = function(state, currentPos) {
                    if (state.isMatch) {
                        if (anchor === $f8c5210791d45577$var$RE2Flags.ANCHOR_BOTH) {
                            if (currentPos === endPos) state.matchIDs.forEach(function(id) {
                                return matches.add(id);
                            });
                        } else state.matchIDs.forEach(function(id) {
                            return matches.add(id);
                        });
                    }
                };
                checkMatch(currentState, pos);
                var i = pos;
                while(i < endPos){
                    var r = input.step(i);
                    var rune = r >> 3;
                    var width = r & 7;
                    if (width === 0) break;
                    currentState = anchor === $f8c5210791d45577$var$RE2Flags.UNANCHORED && rune <= $f8c5210791d45577$var$Unicode.MAX_LATIN1 && currentState.nextLatin1[rune] || this.step(currentState, rune, anchor);
                    if (currentState === null) return null;
                    currentState.lastSeen = ++this.clock;
                    i += width;
                    checkMatch(currentState, i);
                    if (currentState.nfaStates.length === 0) {
                        if (anchor !== $f8c5210791d45577$var$RE2Flags.UNANCHORED) break;
                    }
                }
                return Array.from(matches).sort(function(a, b) {
                    return a - b;
                });
            }
        }
    ]);
    return DFA;
}(), (0, $6tY97._)($f8c5210791d45577$var$_DFA, "MAX_CACHE_CLEARS", 5), (0, $6tY97._)($f8c5210791d45577$var$_DFA, "STATE_MEMORY_ESTIMATE", 838), $f8c5210791d45577$var$_DFA);
//#endregion
//#region src/Backtracker.js
var $f8c5210791d45577$var$VISITED_BITS = 32;
var $f8c5210791d45577$var$MAX_BACKTRACK_PROG = 500;
var $f8c5210791d45577$var$INITIAL_JOB_CAPACITY = 256;
var $f8c5210791d45577$var$MAX_BACKTRACK_VECTOR = 262144;
var $f8c5210791d45577$var$BitState = /*#__PURE__*/ function() {
    "use strict";
    function BitState() {
        (0, $4QweW._)(this, BitState);
        this.end = 0;
        this.cap = /* @__PURE__ */ new Int32Array(0);
        this.matchcap = /* @__PURE__ */ new Int32Array(0);
        this.ncap = 0;
        this.jobPc = new Int32Array($f8c5210791d45577$var$INITIAL_JOB_CAPACITY);
        this.jobArg = new Uint8Array($f8c5210791d45577$var$INITIAL_JOB_CAPACITY);
        this.jobPos = new Int32Array($f8c5210791d45577$var$INITIAL_JOB_CAPACITY);
        this.jobLen = 0;
        this.visited = /* @__PURE__ */ new Uint32Array(0);
    }
    (0, $6hK4i._)(BitState, [
        {
            key: "reset",
            value: function reset(prog, end, ncap) {
                this.end = end;
                this.jobLen = 0;
                this.ncap = ncap;
                var visitedSize = prog.numInst() * (end + 1) + $f8c5210791d45577$var$VISITED_BITS - 1 >>> 5;
                if (this.visited.length < visitedSize) this.visited = new Uint32Array(visitedSize);
                else this.visited.fill(0, 0, visitedSize);
                if (this.cap.length < ncap) this.cap = new Int32Array(ncap).fill(-1);
                else this.cap.fill(-1, 0, ncap);
                if (this.matchcap.length < ncap) this.matchcap = new Int32Array(ncap).fill(-1);
                else this.matchcap.fill(-1, 0, ncap);
            }
        },
        {
            key: "shouldVisit",
            value: function shouldVisit(pc, pos) {
                var n = pc * (this.end + 1) + pos;
                var idx = n >>> 5;
                var mask = 1 << (n & 31);
                if ((this.visited[idx] & mask) !== 0) return false;
                this.visited[idx] |= mask;
                return true;
            }
        },
        {
            key: "push",
            value: function push(re2, pc, pos, arg) {
                if (re2.prog.getInst(pc).op !== $f8c5210791d45577$var$Inst.FAIL && (arg || this.shouldVisit(pc, pos))) {
                    if (this.jobLen >= this.jobPc.length) {
                        var newSize = this.jobPc.length * 2;
                        var newPc = new Int32Array(newSize);
                        newPc.set(this.jobPc);
                        this.jobPc = newPc;
                        var newArg = new Uint8Array(newSize);
                        newArg.set(this.jobArg);
                        this.jobArg = newArg;
                        var newPos = new Int32Array(newSize);
                        newPos.set(this.jobPos);
                        this.jobPos = newPos;
                    }
                    this.jobPc[this.jobLen] = pc;
                    this.jobArg[this.jobLen] = arg ? 1 : 0;
                    this.jobPos[this.jobLen] = pos;
                    this.jobLen++;
                }
            }
        },
        {
            key: "tryBacktrack",
            value: function tryBacktrack(re2, input, pc, pos, anchor) {
                var longest = re2.longest;
                this.push(re2, pc, pos, false);
                while(this.jobLen > 0){
                    this.jobLen--;
                    var currentPc = this.jobPc[this.jobLen];
                    var arg = this.jobArg[this.jobLen] === 1;
                    var currentPos = this.jobPos[this.jobLen];
                    var skipShouldVisit = true;
                    while(true){
                        if (!skipShouldVisit) {
                            if (!this.shouldVisit(currentPc, currentPos)) break;
                        }
                        skipShouldVisit = false;
                        var inst = re2.prog.getInst(currentPc);
                        switch(inst.op){
                            case $f8c5210791d45577$var$Inst.FAIL:
                                throw new $f8c5210791d45577$export$3a148716bb6e0468("unexpected InstFail");
                            case $f8c5210791d45577$var$Inst.ALT:
                                if (arg) {
                                    arg = false;
                                    currentPc = inst.arg;
                                    continue;
                                } else {
                                    this.push(re2, currentPc, currentPos, true);
                                    currentPc = inst.out;
                                    continue;
                                }
                            case $f8c5210791d45577$var$Inst.ALT_MATCH:
                                {
                                    var outInst = re2.prog.getInst(inst.out);
                                    if ($f8c5210791d45577$var$Inst.isRuneOp(outInst.op)) {
                                        this.push(re2, inst.arg, currentPos, false);
                                        currentPc = inst.arg;
                                        currentPos = this.end;
                                        continue;
                                    }
                                    this.push(re2, inst.out, this.end, false);
                                    currentPc = inst.out;
                                    continue;
                                }
                            case $f8c5210791d45577$var$Inst.RUNE:
                                {
                                    var r = input.step(currentPos);
                                    if (r === $f8c5210791d45577$var$MachineInputBase.EOF()) break;
                                    if (!inst.matchRune(r >> 3)) break;
                                    currentPos += r & 7;
                                    currentPc = inst.out;
                                    continue;
                                }
                            case $f8c5210791d45577$var$Inst.RUNE1:
                                {
                                    var r1 = input.step(currentPos);
                                    if (r1 === $f8c5210791d45577$var$MachineInputBase.EOF()) break;
                                    if (r1 >> 3 !== inst.runes[0]) break;
                                    currentPos += r1 & 7;
                                    currentPc = inst.out;
                                    continue;
                                }
                            case $f8c5210791d45577$var$Inst.RUNE_ANY_NOT_NL:
                                {
                                    var r2 = input.step(currentPos);
                                    if (r2 === $f8c5210791d45577$var$MachineInputBase.EOF()) break;
                                    if (r2 >> 3 === 10) break;
                                    currentPos += r2 & 7;
                                    currentPc = inst.out;
                                    continue;
                                }
                            case $f8c5210791d45577$var$Inst.RUNE_ANY:
                                {
                                    var r3 = input.step(currentPos);
                                    if (r3 === $f8c5210791d45577$var$MachineInputBase.EOF()) break;
                                    currentPos += r3 & 7;
                                    currentPc = inst.out;
                                    continue;
                                }
                            case $f8c5210791d45577$var$Inst.CAPTURE:
                                if (arg) {
                                    this.cap[inst.arg] = currentPos;
                                    break;
                                } else {
                                    if (inst.arg < this.ncap) {
                                        this.push(re2, currentPc, this.cap[inst.arg], true);
                                        this.cap[inst.arg] = currentPos;
                                    }
                                    currentPc = inst.out;
                                    continue;
                                }
                            case $f8c5210791d45577$var$Inst.EMPTY_WIDTH:
                                {
                                    var flag = input.context(currentPos);
                                    if ((inst.arg & ~flag) !== 0) break;
                                    currentPc = inst.out;
                                    continue;
                                }
                            case $f8c5210791d45577$var$Inst.NOP:
                                currentPc = inst.out;
                                continue;
                            case $f8c5210791d45577$var$Inst.MATCH:
                                {
                                    if (anchor === $f8c5210791d45577$var$RE2Flags.ANCHOR_BOTH && currentPos !== this.end) break;
                                    if (this.ncap === 0) return true;
                                    if (this.ncap > 1) this.cap[1] = currentPos;
                                    var old = this.matchcap[1];
                                    if (old === -1 || longest && currentPos > 0 && currentPos > old) this.matchcap.set(this.cap);
                                    if (!longest) return true;
                                    if (currentPos === this.end) return true;
                                    break;
                                }
                            case $f8c5210791d45577$var$Inst.LB_WRITE:
                            case $f8c5210791d45577$var$Inst.LB_CHECK:
                                throw new $f8c5210791d45577$export$3a148716bb6e0468("Backtracker cannot evaluate Lookbehind instructions");
                            default:
                                throw new $f8c5210791d45577$export$3a148716bb6e0468("bad inst");
                        }
                        break;
                    }
                }
                return longest && this.matchcap.length > 1 && this.matchcap[1] >= 0;
            }
        }
    ]);
    return BitState;
}();
var $f8c5210791d45577$var$bitStatePool = [];
var $f8c5210791d45577$var$Backtracker = /*#__PURE__*/ function() {
    "use strict";
    function Backtracker() {
        (0, $4QweW._)(this, Backtracker);
    }
    (0, $6hK4i._)(Backtracker, null, [
        {
            key: "shouldBacktrack",
            value: function shouldBacktrack(prog) {
                return prog.numInst() <= $f8c5210791d45577$var$MAX_BACKTRACK_PROG;
            }
        },
        {
            key: "maxBitStateLen",
            value: function maxBitStateLen(prog) {
                if (!Backtracker.shouldBacktrack(prog)) return 0;
                return Math.floor($f8c5210791d45577$var$MAX_BACKTRACK_VECTOR / prog.numInst());
            }
        },
        {
            key: "execute",
            value: function execute(re2, input, pos, anchor, ncap) {
                var startCond = re2.cond;
                if (startCond === $f8c5210791d45577$var$Utils.EMPTY_ALL) return null;
                if ((anchor === $f8c5210791d45577$var$RE2Flags.ANCHOR_START || anchor === $f8c5210791d45577$var$RE2Flags.ANCHOR_BOTH) && pos !== 0) return null;
                if ((startCond & $f8c5210791d45577$var$Utils.EMPTY_BEGIN_TEXT) !== 0 && pos !== 0) return null;
                var b = $f8c5210791d45577$var$bitStatePool.length > 0 ? $f8c5210791d45577$var$bitStatePool.pop() : new $f8c5210791d45577$var$BitState();
                var end = input.endPos();
                b.reset(re2.prog, end, ncap);
                var matched = false;
                if ((startCond & $f8c5210791d45577$var$Utils.EMPTY_BEGIN_TEXT) !== 0 || anchor === $f8c5210791d45577$var$RE2Flags.ANCHOR_START || anchor === $f8c5210791d45577$var$RE2Flags.ANCHOR_BOTH) {
                    if (b.ncap > 0) b.cap[0] = pos;
                    if (b.tryBacktrack(re2, input, re2.prog.start, pos, anchor)) matched = true;
                } else {
                    var width = -1;
                    for(; pos <= end && width !== 0; pos += width){
                        if (re2.prefix.length > 0) {
                            var advance = input.index(re2, pos);
                            if (advance < 0) break;
                            pos += advance;
                        }
                        if (b.ncap > 0) b.cap[0] = pos;
                        if (b.tryBacktrack(re2, input, re2.prog.start, pos, anchor)) {
                            matched = true;
                            break;
                        }
                        var r = input.step(pos);
                        width = r === $f8c5210791d45577$var$MachineInputBase.EOF() ? 0 : r & 7;
                    }
                }
                if (!matched) {
                    $f8c5210791d45577$var$bitStatePool.push(b);
                    return null;
                }
                var result = ncap === 0 ? [] : $f8c5210791d45577$var$Utils.toArray(b.matchcap.subarray(0, ncap));
                $f8c5210791d45577$var$bitStatePool.push(b);
                return result;
            }
        }
    ]);
    return Backtracker;
}();
//#endregion
//#region src/OnePass.js
var $f8c5210791d45577$var$QueueOnePass = /*#__PURE__*/ function() {
    "use strict";
    function QueueOnePass(size) {
        (0, $4QweW._)(this, QueueOnePass);
        this.sparse = new Uint32Array(size);
        this.dense = new Uint32Array(size);
        this.size = 0;
        this.nextIndex = 0;
    }
    (0, $6hK4i._)(QueueOnePass, [
        {
            key: "empty",
            value: function empty() {
                return this.nextIndex >= this.size;
            }
        },
        {
            key: "next",
            value: function next() {
                return this.dense[this.nextIndex++];
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.size = 0;
                this.nextIndex = 0;
            }
        },
        {
            key: "contains",
            value: function contains(u) {
                return u < this.sparse.length && this.sparse[u] < this.size && this.dense[this.sparse[u]] === u;
            }
        },
        {
            key: "insert",
            value: function insert(u) {
                if (!this.contains(u)) this.insertNew(u);
            }
        },
        {
            key: "insertNew",
            value: function insertNew(u) {
                if (u >= this.sparse.length) return;
                this.sparse[u] = this.size;
                this.dense[this.size] = u;
                this.size++;
            }
        }
    ]);
    return QueueOnePass;
}();
var $f8c5210791d45577$var$mergeRuneSets = function(leftRunes, rightRunes, leftPC, rightPC) {
    var leftLen = leftRunes.length;
    var rightLen = rightRunes.length;
    var lx = 0, rx = 0;
    var merged = [];
    var next = [];
    var ok = true;
    var ix = -1;
    var extend = function(isLeft) {
        var newArray = isLeft ? leftRunes : rightRunes;
        var low = isLeft ? lx : rx;
        var pc = isLeft ? leftPC : rightPC;
        if (ix > 0 && newArray[low] <= merged[ix]) return false;
        merged.push(newArray[low], newArray[low + 1]);
        if (isLeft) lx += 2;
        else rx += 2;
        ix += 2;
        next.push(pc);
        return true;
    };
    while(lx < leftLen || rx < rightLen){
        if (rx >= rightLen) ok = extend(true);
        else if (lx >= leftLen) ok = extend(false);
        else if (rightRunes[rx] < leftRunes[lx]) ok = extend(false);
        else ok = extend(true);
        if (!ok) return null;
    }
    return {
        merged: merged,
        next: next
    };
};
var $f8c5210791d45577$var$OnePassProg = function OnePassProg(prog) {
    "use strict";
    (0, $4QweW._)(this, OnePassProg);
    this.start = prog.start;
    this.numCap = prog.numCap;
    this.inst = new Array(prog.inst.length);
    for(var i = 0; i < prog.inst.length; i++){
        var orig = prog.inst[i];
        var inst = new $f8c5210791d45577$var$Inst(orig.op);
        inst.out = orig.out;
        inst.arg = orig.arg;
        inst.runes = orig.runes ? orig.runes.slice() : [];
        inst.next = null;
        this.inst[i] = inst;
    }
};
var $f8c5210791d45577$var$onePassCopy = function(prog) {
    var p = new $f8c5210791d45577$var$OnePassProg(prog);
    for(var pc = 0; pc < p.inst.length; pc++){
        var inst = p.inst[pc];
        if (inst.op !== $f8c5210791d45577$var$Inst.ALT && inst.op !== $f8c5210791d45577$var$Inst.ALT_MATCH) continue;
        var pAOther = "out";
        var pAAlt = "arg";
        var instAlt = p.inst[inst[pAAlt]];
        if (instAlt.op !== $f8c5210791d45577$var$Inst.ALT && instAlt.op !== $f8c5210791d45577$var$Inst.ALT_MATCH) {
            pAOther = "arg";
            pAAlt = "out";
            instAlt = p.inst[inst[pAAlt]];
            if (instAlt.op !== $f8c5210791d45577$var$Inst.ALT && instAlt.op !== $f8c5210791d45577$var$Inst.ALT_MATCH) continue;
        }
        var instOther = p.inst[inst[pAOther]];
        if (instOther.op === $f8c5210791d45577$var$Inst.ALT || instOther.op === $f8c5210791d45577$var$Inst.ALT_MATCH) continue;
        var pBAlt = "out";
        var pBOther = "arg";
        var patch = false;
        if (instAlt.out === pc) patch = true;
        else if (instAlt.arg === pc) {
            patch = true;
            pBAlt = "arg";
            pBOther = "out";
        }
        if (patch) instAlt[pBAlt] = inst[pAOther];
        if (inst[pAOther] === instAlt[pBAlt]) inst[pAAlt] = instAlt[pBOther];
    }
    return p;
};
var $f8c5210791d45577$var$makeOnePass = function(p) {
    if (p.inst.length >= 1e3) return null;
    var instQueue = new $f8c5210791d45577$var$QueueOnePass(p.inst.length);
    var visitQueue = new $f8c5210791d45577$var$QueueOnePass(p.inst.length);
    var onePassRunes = new Array(p.inst.length);
    var m = new Array(p.inst.length).fill(false);
    var check = function(pc) {
        var ok = true;
        var inst = p.inst[pc];
        if (visitQueue.contains(pc)) return true;
        visitQueue.insert(pc);
        switch(inst.op){
            case $f8c5210791d45577$var$Inst.ALT:
            case $f8c5210791d45577$var$Inst.ALT_MATCH:
                {
                    ok = check(inst.out) && check(inst.arg);
                    var matchOut = m[inst.out];
                    var matchArg = m[inst.arg];
                    if (matchOut && matchArg) return false;
                    if (matchArg) {
                        var tempOut = inst.out;
                        inst.out = inst.arg;
                        inst.arg = tempOut;
                        var tempMatch = matchOut;
                        matchOut = matchArg;
                        matchArg = tempMatch;
                    }
                    if (matchOut) {
                        m[pc] = true;
                        inst.op = $f8c5210791d45577$var$Inst.ALT_MATCH;
                    }
                    var leftRunes = onePassRunes[inst.out] || [];
                    var rightRunes = onePassRunes[inst.arg] || [];
                    var mergeRes = $f8c5210791d45577$var$mergeRuneSets(leftRunes, rightRunes, inst.out, inst.arg);
                    if (!mergeRes) return false;
                    onePassRunes[pc] = mergeRes.merged;
                    inst.next = new Uint32Array(mergeRes.next);
                    break;
                }
            case $f8c5210791d45577$var$Inst.CAPTURE:
            case $f8c5210791d45577$var$Inst.EMPTY_WIDTH:
            case $f8c5210791d45577$var$Inst.NOP:
                ok = check(inst.out);
                m[pc] = m[inst.out];
                onePassRunes[pc] = onePassRunes[inst.out] ? onePassRunes[inst.out].slice() : [];
                inst.next = new Uint32Array(Math.floor(onePassRunes[pc].length / 2) + 1).fill(inst.out);
                break;
            case $f8c5210791d45577$var$Inst.MATCH:
            case $f8c5210791d45577$var$Inst.FAIL:
                m[pc] = inst.op === $f8c5210791d45577$var$Inst.MATCH;
                break;
            case $f8c5210791d45577$var$Inst.RUNE:
                {
                    m[pc] = false;
                    if (inst.next && inst.next.length > 0) break;
                    instQueue.insert(inst.out);
                    if (!inst.runes || inst.runes.length === 0) {
                        onePassRunes[pc] = [];
                        inst.next = new Uint32Array([
                            inst.out
                        ]);
                        break;
                    }
                    var runes = [];
                    if (inst.runes.length === 1 && (inst.arg & $f8c5210791d45577$var$RE2Flags.FOLD_CASE) !== 0) {
                        var r0 = inst.runes[0];
                        runes.push(r0, r0);
                        for(var r1 = $f8c5210791d45577$var$Unicode.simpleFold(r0); r1 !== r0; r1 = $f8c5210791d45577$var$Unicode.simpleFold(r1))runes.push(r1, r1);
                        runes.sort(function(a, b) {
                            return a - b;
                        });
                    } else for(var j = 0; j < inst.runes.length; j++)runes.push(inst.runes[j]);
                    onePassRunes[pc] = runes;
                    inst.next = new Uint32Array(Math.floor(runes.length / 2) + 1).fill(inst.out);
                    inst.op = $f8c5210791d45577$var$Inst.RUNE;
                    break;
                }
            case $f8c5210791d45577$var$Inst.RUNE1:
                {
                    m[pc] = false;
                    if (inst.next && inst.next.length > 0) break;
                    instQueue.insert(inst.out);
                    var runes1 = [];
                    if ((inst.arg & $f8c5210791d45577$var$RE2Flags.FOLD_CASE) !== 0) {
                        var r01 = inst.runes[0];
                        runes1.push(r01, r01);
                        for(var r11 = $f8c5210791d45577$var$Unicode.simpleFold(r01); r11 !== r01; r11 = $f8c5210791d45577$var$Unicode.simpleFold(r11))runes1.push(r11, r11);
                        runes1.sort(function(a, b) {
                            return a - b;
                        });
                    } else runes1.push(inst.runes[0], inst.runes[0]);
                    onePassRunes[pc] = runes1;
                    inst.next = new Uint32Array(Math.floor(runes1.length / 2) + 1).fill(inst.out);
                    inst.op = $f8c5210791d45577$var$Inst.RUNE;
                    break;
                }
            case $f8c5210791d45577$var$Inst.RUNE_ANY:
                m[pc] = false;
                if (inst.next && inst.next.length > 0) break;
                instQueue.insert(inst.out);
                onePassRunes[pc] = [
                    0,
                    $f8c5210791d45577$var$Unicode.MAX_RUNE
                ];
                inst.next = new Uint32Array([
                    inst.out
                ]);
                break;
            case $f8c5210791d45577$var$Inst.RUNE_ANY_NOT_NL:
                m[pc] = false;
                if (inst.next && inst.next.length > 0) break;
                instQueue.insert(inst.out);
                onePassRunes[pc] = [
                    0,
                    9,
                    11,
                    $f8c5210791d45577$var$Unicode.MAX_RUNE
                ];
                inst.next = new Uint32Array(Math.floor(onePassRunes[pc].length / 2) + 1).fill(inst.out);
                break;
        }
        return ok;
    };
    instQueue.clear();
    instQueue.insert(p.start);
    while(!instQueue.empty()){
        visitQueue.clear();
        if (!check(instQueue.next())) return null;
    }
    for(var i = 0; i < p.inst.length; i++)if (onePassRunes[i]) p.inst[i].runes = onePassRunes[i];
    return p;
};
var $f8c5210791d45577$var$cleanupOnePass = function(p, original) {
    for(var ix = 0; ix < original.inst.length; ix++){
        var instOriginal = original.inst[ix];
        switch(instOriginal.op){
            case $f8c5210791d45577$var$Inst.ALT:
            case $f8c5210791d45577$var$Inst.ALT_MATCH:
            case $f8c5210791d45577$var$Inst.RUNE:
                break;
            case $f8c5210791d45577$var$Inst.CAPTURE:
            case $f8c5210791d45577$var$Inst.EMPTY_WIDTH:
            case $f8c5210791d45577$var$Inst.NOP:
            case $f8c5210791d45577$var$Inst.MATCH:
            case $f8c5210791d45577$var$Inst.FAIL:
                p.inst[ix].next = null;
                break;
            case $f8c5210791d45577$var$Inst.RUNE1:
            case $f8c5210791d45577$var$Inst.RUNE_ANY:
            case $f8c5210791d45577$var$Inst.RUNE_ANY_NOT_NL:
                p.inst[ix].next = null;
                p.inst[ix].op = instOriginal.op;
                p.inst[ix].runes = instOriginal.runes ? instOriginal.runes.slice() : [];
                break;
        }
    }
};
var $f8c5210791d45577$var$OnePass = /*#__PURE__*/ function() {
    "use strict";
    function OnePass() {
        (0, $4QweW._)(this, OnePass);
    }
    (0, $6hK4i._)(OnePass, null, [
        {
            key: "compile",
            value: function compile(prog) {
                if (prog.start === 0) return null;
                if (prog.numLb > 0) return null;
                var startInst = prog.inst[prog.start];
                if (startInst.op !== $f8c5210791d45577$var$Inst.EMPTY_WIDTH || (startInst.arg & $f8c5210791d45577$var$Utils.EMPTY_BEGIN_TEXT) === 0) return null;
                var hasAlt = false;
                for(var i = 0; i < prog.inst.length; i++)if (prog.inst[i].op === $f8c5210791d45577$var$Inst.ALT || prog.inst[i].op === $f8c5210791d45577$var$Inst.ALT_MATCH) {
                    hasAlt = true;
                    break;
                }
                for(var i1 = 0; i1 < prog.inst.length; i1++){
                    var inst = prog.inst[i1];
                    var opOut = prog.inst[inst.out].op;
                    switch(inst.op){
                        case $f8c5210791d45577$var$Inst.ALT:
                        case $f8c5210791d45577$var$Inst.ALT_MATCH:
                            if (opOut === $f8c5210791d45577$var$Inst.MATCH || prog.inst[inst.arg].op === $f8c5210791d45577$var$Inst.MATCH) return null;
                            break;
                        case $f8c5210791d45577$var$Inst.EMPTY_WIDTH:
                            if (opOut === $f8c5210791d45577$var$Inst.MATCH) {
                                if ((inst.arg & $f8c5210791d45577$var$Utils.EMPTY_END_TEXT) === $f8c5210791d45577$var$Utils.EMPTY_END_TEXT) continue;
                                return null;
                            }
                            break;
                        default:
                            if (opOut === $f8c5210791d45577$var$Inst.MATCH && hasAlt) return null;
                            break;
                    }
                }
                var p = $f8c5210791d45577$var$onePassCopy(prog);
                p = $f8c5210791d45577$var$makeOnePass(p);
                if (p !== null) $f8c5210791d45577$var$cleanupOnePass(p, prog);
                return p;
            }
        },
        {
            key: "next",
            value: function next(inst, r) {
                var nextIdx = inst.matchRunePos(r);
                if (nextIdx >= 0) return inst.next[nextIdx];
                if (inst.op === $f8c5210791d45577$var$Inst.ALT_MATCH) return inst.out;
                return 0;
            }
        },
        {
            key: "execute",
            value: function execute(re2, input, pos, anchor, ncap) {
                var onepass = re2.onepass;
                if (!onepass) return null;
                var matchcap = new Int32Array(ncap).fill(-1);
                var matched = false;
                var r = input.step(pos);
                var rune = r >> 3;
                var width = r & 7;
                var r1 = $f8c5210791d45577$var$MachineInputBase.EOF();
                var rune1 = -1;
                var width1 = 0;
                if (r !== $f8c5210791d45577$var$MachineInputBase.EOF()) {
                    r1 = input.step(pos + width);
                    if (r1 !== $f8c5210791d45577$var$MachineInputBase.EOF()) {
                        rune1 = r1 >> 3;
                        width1 = r1 & 7;
                    }
                }
                var flag = pos === 0 ? $f8c5210791d45577$var$Utils.emptyOpContext(-1, rune) : input.context(pos);
                var pc = onepass.start;
                var inst;
                while(true){
                    inst = onepass.inst[pc];
                    pc = inst.out;
                    switch(inst.op){
                        case $f8c5210791d45577$var$Inst.MATCH:
                            if (anchor === $f8c5210791d45577$var$RE2Flags.ANCHOR_BOTH && pos !== input.endPos()) return null;
                            matched = true;
                            if (matchcap.length > 0) {
                                matchcap[0] = 0;
                                matchcap[1] = pos;
                            }
                            return ncap === 0 ? [] : $f8c5210791d45577$var$Utils.toArray(matchcap);
                        case $f8c5210791d45577$var$Inst.RUNE:
                            if (!inst.matchRune(rune)) return null;
                            break;
                        case $f8c5210791d45577$var$Inst.RUNE1:
                            if (rune !== inst.runes[0]) return null;
                            break;
                        case $f8c5210791d45577$var$Inst.RUNE_ANY:
                            break;
                        case $f8c5210791d45577$var$Inst.RUNE_ANY_NOT_NL:
                            if (rune === 10) return null;
                            break;
                        case $f8c5210791d45577$var$Inst.ALT:
                        case $f8c5210791d45577$var$Inst.ALT_MATCH:
                            pc = OnePass.next(inst, rune);
                            continue;
                        case $f8c5210791d45577$var$Inst.FAIL:
                            return null;
                        case $f8c5210791d45577$var$Inst.NOP:
                            continue;
                        case $f8c5210791d45577$var$Inst.EMPTY_WIDTH:
                            if ((inst.arg & ~flag) !== 0) return null;
                            continue;
                        case $f8c5210791d45577$var$Inst.CAPTURE:
                            if (inst.arg < matchcap.length) matchcap[inst.arg] = pos;
                            continue;
                        default:
                            throw new $f8c5210791d45577$export$3a148716bb6e0468("bad inst");
                    }
                    if (width === 0) break;
                    flag = $f8c5210791d45577$var$Utils.emptyOpContext(rune, rune1);
                    pos += width;
                    rune = rune1;
                    width = width1;
                    if (rune !== -1) {
                        r1 = input.step(pos + width);
                        if (r1 !== $f8c5210791d45577$var$MachineInputBase.EOF()) {
                            rune1 = r1 >> 3;
                            width1 = r1 & 7;
                        } else {
                            rune1 = -1;
                            width1 = 0;
                        }
                    }
                }
                if (!matched) return null;
                return ncap === 0 ? [] : $f8c5210791d45577$var$Utils.toArray(matchcap);
            }
        }
    ]);
    return OnePass;
}();
//#endregion
//#region src/Regexp.js
/**
* Regular expression abstract syntax tree. Produced by parser, used by compiler. NB, this
* corresponds to {@code syntax.regexp} in the Go implementation; Go's {@code regexp} is called
* {@code RE2} in Java.
*/ var $f8c5210791d45577$var$Regexp = ($f8c5210791d45577$var$_Regexp = /*#__PURE__*/ function() {
    "use strict";
    function Regexp(op) {
        (0, $4QweW._)(this, Regexp);
        this.op = op;
        this.flags = 0;
        this.subs = Regexp.emptySubs();
        this.runes = [];
        this.min = 0;
        this.max = 0;
        this.cap = 0;
        this.name = null;
        this.namedGroups = Object.create(null);
        this.lb = 0;
    }
    (0, $6hK4i._)(Regexp, [
        {
            key: "reinit",
            value: function reinit() {
                this.flags = 0;
                this.subs = Regexp.emptySubs();
                this.runes = [];
                this.cap = 0;
                this.min = 0;
                this.max = 0;
                this.name = null;
                this.namedGroups = Object.create(null);
                this.lb = 0;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.appendTo();
            }
        },
        {
            key: "appendTo",
            value: function appendTo() {
                var out = "";
                switch(this.op){
                    case Regexp.Op.NO_MATCH:
                        out += "[^\\x00-\\x{10FFFF}]";
                        break;
                    case Regexp.Op.EMPTY_MATCH:
                        out += "(?:)";
                        break;
                    case Regexp.Op.STAR:
                    case Regexp.Op.PLUS:
                    case Regexp.Op.QUEST:
                    case Regexp.Op.REPEAT:
                        {
                            var sub = this.subs[0];
                            if (sub.op > Regexp.Op.CAPTURE || sub.op === Regexp.Op.LITERAL && sub.runes.length > 1) out += "(?:".concat(sub.appendTo(), ")");
                            else out += sub.appendTo();
                            switch(this.op){
                                case Regexp.Op.STAR:
                                    out += "*";
                                    break;
                                case Regexp.Op.PLUS:
                                    out += "+";
                                    break;
                                case Regexp.Op.QUEST:
                                    out += "?";
                                    break;
                                case Regexp.Op.REPEAT:
                                    out += "{".concat(this.min);
                                    if (this.min !== this.max) {
                                        out += ",";
                                        if (this.max >= 0) out += this.max;
                                    }
                                    out += "}";
                                    break;
                            }
                            if ((this.flags & $f8c5210791d45577$var$RE2Flags.NON_GREEDY) !== 0) out += "?";
                            break;
                        }
                    case Regexp.Op.CONCAT:
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this.subs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var sub1 = _step.value;
                                if (sub1.op === Regexp.Op.ALTERNATE) out += "(?:".concat(sub1.appendTo(), ")");
                                else out += sub1.appendTo();
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        break;
                    case Regexp.Op.ALTERNATE:
                        {
                            var sep = "";
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(var _iterator1 = this.subs[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    var sub2 = _step1.value;
                                    out += sep;
                                    sep = "|";
                                    out += sub2.appendTo();
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                            break;
                        }
                    case Regexp.Op.LITERAL:
                        if ((this.flags & $f8c5210791d45577$var$RE2Flags.FOLD_CASE) !== 0) out += "(?i:";
                        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                        try {
                            for(var _iterator2 = this.runes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                var rune = _step2.value;
                                out += $f8c5210791d45577$var$Utils.escapeRune(rune);
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                    _iterator2.return();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                        if ((this.flags & $f8c5210791d45577$var$RE2Flags.FOLD_CASE) !== 0) out += ")";
                        break;
                    case Regexp.Op.ANY_CHAR_NOT_NL:
                        out += "(?-s:.)";
                        break;
                    case Regexp.Op.ANY_CHAR:
                        out += "(?s:.)";
                        break;
                    case Regexp.Op.PLB:
                        out += "(?<=".concat(this.subs[0].appendTo(), ")");
                        break;
                    case Regexp.Op.NLB:
                        out += "(?<!".concat(this.subs[0].appendTo(), ")");
                        break;
                    case Regexp.Op.CAPTURE:
                        if (this.name === null || this.name.length === 0) out += "(";
                        else out += "(?P<".concat(this.name, ">");
                        if (this.subs[0].op !== Regexp.Op.EMPTY_MATCH) out += this.subs[0].appendTo();
                        out += ")";
                        break;
                    case Regexp.Op.BEGIN_TEXT:
                        out += "\\A";
                        break;
                    case Regexp.Op.END_TEXT:
                        if ((this.flags & $f8c5210791d45577$var$RE2Flags.WAS_DOLLAR) !== 0) out += "(?-m:$)";
                        else out += "\\z";
                        break;
                    case Regexp.Op.BEGIN_LINE:
                        out += "^";
                        break;
                    case Regexp.Op.END_LINE:
                        out += "$";
                        break;
                    case Regexp.Op.WORD_BOUNDARY:
                        out += "\\b";
                        break;
                    case Regexp.Op.NO_WORD_BOUNDARY:
                        out += "\\B";
                        break;
                    case Regexp.Op.CHAR_CLASS:
                        if (this.runes.length % 2 !== 0) {
                            out += "[invalid char class]";
                            break;
                        }
                        out += "[";
                        if (this.runes.length === 0) out += "^\\x00-\\x{10FFFF}";
                        else if (this.runes[0] === 0 && this.runes[this.runes.length - 1] === $f8c5210791d45577$var$Unicode.MAX_RUNE) {
                            out += "^";
                            for(var i = 1; i < this.runes.length - 1; i += 2){
                                var lo = this.runes[i] + 1;
                                var hi = this.runes[i + 1] - 1;
                                out += Regexp.quoteIfHyphen(lo);
                                out += $f8c5210791d45577$var$Utils.escapeRune(lo);
                                if (lo !== hi) {
                                    out += "-";
                                    out += Regexp.quoteIfHyphen(hi);
                                    out += $f8c5210791d45577$var$Utils.escapeRune(hi);
                                }
                            }
                        } else for(var i1 = 0; i1 < this.runes.length; i1 += 2){
                            var lo1 = this.runes[i1];
                            var hi1 = this.runes[i1 + 1];
                            out += Regexp.quoteIfHyphen(lo1);
                            out += $f8c5210791d45577$var$Utils.escapeRune(lo1);
                            if (lo1 !== hi1) {
                                out += "-";
                                out += Regexp.quoteIfHyphen(hi1);
                                out += $f8c5210791d45577$var$Utils.escapeRune(hi1);
                            }
                        }
                        out += "]";
                        break;
                    default:
                        out += this.op;
                        break;
                }
                return out;
            }
        },
        {
            key: "maxCap",
            value: function maxCap() {
                var m = 0;
                if (this.op === Regexp.Op.CAPTURE) m = this.cap;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (this.subs !== null) try {
                    for(var _iterator = this.subs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sub = _step.value;
                        var n = sub.maxCap();
                        if (m < n) m = n;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return m;
            }
        },
        {
            key: "equals",
            value: function equals(that) {
                if (!(that !== null && that instanceof Regexp)) return false;
                if (this.op !== that.op) return false;
                switch(this.op){
                    case Regexp.Op.END_TEXT:
                        if ((this.flags & $f8c5210791d45577$var$RE2Flags.WAS_DOLLAR) !== (that.flags & $f8c5210791d45577$var$RE2Flags.WAS_DOLLAR)) return false;
                        break;
                    case Regexp.Op.LITERAL:
                    case Regexp.Op.CHAR_CLASS:
                        if (this.runes === null && that.runes === null) break;
                        if (this.runes === null || that.runes === null) return false;
                        if (this.runes.length !== that.runes.length) return false;
                        for(var i = 0; i < this.runes.length; i++)if (this.runes[i] !== that.runes[i]) return false;
                        break;
                    case Regexp.Op.ALTERNATE:
                    case Regexp.Op.CONCAT:
                        if (this.subs.length !== that.subs.length) return false;
                        for(var i1 = 0; i1 < this.subs.length; ++i1)if (!this.subs[i1].equals(that.subs[i1])) return false;
                        break;
                    case Regexp.Op.STAR:
                    case Regexp.Op.PLUS:
                    case Regexp.Op.QUEST:
                        if ((this.flags & $f8c5210791d45577$var$RE2Flags.NON_GREEDY) !== (that.flags & $f8c5210791d45577$var$RE2Flags.NON_GREEDY) || !this.subs[0].equals(that.subs[0])) return false;
                        break;
                    case Regexp.Op.REPEAT:
                        if ((this.flags & $f8c5210791d45577$var$RE2Flags.NON_GREEDY) !== (that.flags & $f8c5210791d45577$var$RE2Flags.NON_GREEDY) || this.min !== that.min || this.max !== that.max || !this.subs[0].equals(that.subs[0])) return false;
                        break;
                    case Regexp.Op.CAPTURE:
                        if (this.cap !== that.cap || (this.name === null ? that.name !== null : this.name !== that.name) || !this.subs[0].equals(that.subs[0])) return false;
                        break;
                    case Regexp.Op.PLB:
                    case Regexp.Op.NLB:
                        if (this.lb !== that.lb || !this.subs[0].equals(that.subs[0])) return false;
                        break;
                }
                return true;
            }
        }
    ], [
        {
            key: "isPseudoOp",
            value: function isPseudoOp(op) {
                return op >= Regexp.Op.LEFT_PAREN;
            }
        },
        {
            key: "emptySubs",
            value: function emptySubs() {
                return [];
            }
        },
        {
            key: "quoteIfHyphen",
            value: function quoteIfHyphen(rune) {
                if (rune === $f8c5210791d45577$var$Codepoint.CODES.get("-")) return "\\";
                return "";
            }
        },
        {
            key: "fromRegexp",
            value: function fromRegexp(re) {
                var regex = new Regexp(re.op);
                regex.flags = re.flags;
                regex.subs = re.subs;
                regex.runes = re.runes;
                regex.cap = re.cap;
                regex.min = re.min;
                regex.max = re.max;
                regex.name = re.name;
                regex.namedGroups = re.namedGroups;
                regex.lb = re.lb;
                return regex;
            }
        }
    ]);
    return Regexp;
}(), (0, $6tY97._)($f8c5210791d45577$var$_Regexp, "Op", $f8c5210791d45577$var$createEnum([
    "NO_MATCH",
    "EMPTY_MATCH",
    "LITERAL",
    "CHAR_CLASS",
    "ANY_CHAR_NOT_NL",
    "ANY_CHAR",
    "BEGIN_LINE",
    "END_LINE",
    "BEGIN_TEXT",
    "END_TEXT",
    "WORD_BOUNDARY",
    "NO_WORD_BOUNDARY",
    "CAPTURE",
    "STAR",
    "PLUS",
    "QUEST",
    "REPEAT",
    "CONCAT",
    "ALTERNATE",
    "PLB",
    "NLB",
    "LEFT_PAREN",
    "VERTICAL_BAR"
])), $f8c5210791d45577$var$_Regexp);
//#endregion
//#region src/Prefilter.js
var $f8c5210791d45577$var$AhoCorasick = /*#__PURE__*/ function() {
    "use strict";
    function AhoCorasick(wordArrays) {
        (0, $4QweW._)(this, AhoCorasick);
        this.next = [
            Object.create(null)
        ];
        this.fail = [
            0
        ];
        this.match = [
            false
        ];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = wordArrays[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var word = _step.value;
                var node = 0;
                for(var i = 0; i < word.length; i++){
                    var val = word[i];
                    if (!(val in this.next[node])) {
                        this.next.push(Object.create(null));
                        this.fail.push(0);
                        this.match.push(false);
                        this.next[node][val] = this.next.length - 1;
                    }
                    node = this.next[node][val];
                }
                this.match[node] = true;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var queue = [];
        for(var val1 in this.next[0])if (Object.prototype.hasOwnProperty.call(this.next[0], val1)) {
            var child = this.next[0][val1];
            this.fail[child] = 0;
            queue.push(child);
        }
        while(queue.length > 0){
            var curr = queue.shift();
            for(var val2 in this.next[curr])if (Object.prototype.hasOwnProperty.call(this.next[curr], val2)) {
                var child1 = this.next[curr][val2];
                var failNode = this.fail[curr];
                while(failNode !== 0 && !(val2 in this.next[failNode]))failNode = this.fail[failNode];
                if (val2 in this.next[failNode]) this.fail[child1] = this.next[failNode][val2];
                else this.fail[child1] = 0;
                this.match[child1] = this.match[child1] || this.match[this.fail[child1]];
                queue.push(child1);
            }
        }
    }
    (0, $6hK4i._)(AhoCorasick, [
        {
            key: "searchUTF16",
            value: function searchUTF16(charSeq, start, end) {
                var node = 0;
                for(var i = start; i < end; i++){
                    var val = charSeq.charCodeAt(i);
                    while(node !== 0 && !(val in this.next[node]))node = this.fail[node];
                    if (val in this.next[node]) node = this.next[node][val];
                    if (this.match[node]) return true;
                }
                return false;
            }
        },
        {
            key: "searchUTF8",
            value: function searchUTF8(bytes, start, end) {
                var node = 0;
                for(var i = start; i < end; i++){
                    var val = bytes[i];
                    while(node !== 0 && !(val in this.next[node]))node = this.fail[node];
                    if (val in this.next[node]) node = this.next[node][val];
                    if (this.match[node]) return true;
                }
                return false;
            }
        }
    ]);
    return AhoCorasick;
}();
var $f8c5210791d45577$var$Prefilter = ($f8c5210791d45577$var$_Prefilter = /*#__PURE__*/ function() {
    "use strict";
    function Prefilter(type) {
        (0, $4QweW._)(this, Prefilter);
        this.type = type;
        this.subs = [];
        this.str = "";
        this.bytes = null;
        this.ac16 = null;
        this.ac8 = null;
    }
    (0, $6hK4i._)(Prefilter, [
        {
            key: "eval",
            value: function _eval(input, pos) {
                switch(this.type){
                    case Prefilter.Type.NONE:
                        return true;
                    case Prefilter.Type.EXACT:
                        return input.hasString(this, pos);
                    case Prefilter.Type.AND:
                        for(var i = 0; i < this.subs.length; i++)if (!this.subs[i].eval(input, pos)) return false;
                        return true;
                    case Prefilter.Type.OR:
                        if (this.ac16 && this.ac8) return input.hasAnyString(this, pos);
                        for(var i1 = 0; i1 < this.subs.length; i1++)if (this.subs[i1].eval(input, pos)) return true;
                        return false;
                    default:
                        return true;
                }
            }
        }
    ]);
    return Prefilter;
}(), (0, $6tY97._)($f8c5210791d45577$var$_Prefilter, "Type", {
    NONE: 0,
    EXACT: 1,
    AND: 2,
    OR: 3
}), $f8c5210791d45577$var$_Prefilter);
var $f8c5210791d45577$var$PrefilterTree = /*#__PURE__*/ function() {
    "use strict";
    function PrefilterTree() {
        (0, $4QweW._)(this, PrefilterTree);
    }
    (0, $6hK4i._)(PrefilterTree, null, [
        {
            key: "build",
            value: function build(re) {
                var pf = PrefilterTree.fromRegexp(re);
                return PrefilterTree.simplify(pf);
            }
        },
        {
            key: "fromRegexp",
            value: function fromRegexp(re) {
                if (!re) return new $f8c5210791d45577$var$Prefilter($f8c5210791d45577$var$Prefilter.Type.NONE);
                switch(re.op){
                    case $f8c5210791d45577$var$Regexp.Op.PLB:
                    case $f8c5210791d45577$var$Regexp.Op.NLB:
                    case $f8c5210791d45577$var$Regexp.Op.NO_MATCH:
                    case $f8c5210791d45577$var$Regexp.Op.EMPTY_MATCH:
                    case $f8c5210791d45577$var$Regexp.Op.BEGIN_LINE:
                    case $f8c5210791d45577$var$Regexp.Op.END_LINE:
                    case $f8c5210791d45577$var$Regexp.Op.BEGIN_TEXT:
                    case $f8c5210791d45577$var$Regexp.Op.END_TEXT:
                    case $f8c5210791d45577$var$Regexp.Op.WORD_BOUNDARY:
                    case $f8c5210791d45577$var$Regexp.Op.NO_WORD_BOUNDARY:
                    case $f8c5210791d45577$var$Regexp.Op.CHAR_CLASS:
                    case $f8c5210791d45577$var$Regexp.Op.ANY_CHAR_NOT_NL:
                    case $f8c5210791d45577$var$Regexp.Op.ANY_CHAR:
                        return new $f8c5210791d45577$var$Prefilter($f8c5210791d45577$var$Prefilter.Type.NONE);
                    case $f8c5210791d45577$var$Regexp.Op.LITERAL:
                        {
                            if (re.runes.length === 0 || (re.flags & $f8c5210791d45577$var$RE2Flags.FOLD_CASE) !== 0) return new $f8c5210791d45577$var$Prefilter($f8c5210791d45577$var$Prefilter.Type.NONE);
                            var pf = new $f8c5210791d45577$var$Prefilter($f8c5210791d45577$var$Prefilter.Type.EXACT);
                            var str = "";
                            for(var i = 0; i < re.runes.length; i++)str += String.fromCodePoint(re.runes[i]);
                            pf.str = str;
                            pf.bytes = $f8c5210791d45577$var$Utils.stringToUtf8ByteArray(pf.str);
                            return pf;
                        }
                    case $f8c5210791d45577$var$Regexp.Op.CAPTURE:
                    case $f8c5210791d45577$var$Regexp.Op.PLUS:
                        return PrefilterTree.fromRegexp(re.subs[0]);
                    case $f8c5210791d45577$var$Regexp.Op.REPEAT:
                        if (re.min >= 1) return PrefilterTree.fromRegexp(re.subs[0]);
                        return new $f8c5210791d45577$var$Prefilter($f8c5210791d45577$var$Prefilter.Type.NONE);
                    case $f8c5210791d45577$var$Regexp.Op.CONCAT:
                        {
                            var pf1 = new $f8c5210791d45577$var$Prefilter($f8c5210791d45577$var$Prefilter.Type.AND);
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = re.subs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var sub = _step.value;
                                    pf1.subs.push(PrefilterTree.fromRegexp(sub));
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            return pf1;
                        }
                    case $f8c5210791d45577$var$Regexp.Op.ALTERNATE:
                        {
                            var pf2 = new $f8c5210791d45577$var$Prefilter($f8c5210791d45577$var$Prefilter.Type.OR);
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(var _iterator1 = re.subs[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    var sub1 = _step1.value;
                                    pf2.subs.push(PrefilterTree.fromRegexp(sub1));
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                            return pf2;
                        }
                    default:
                        return new $f8c5210791d45577$var$Prefilter($f8c5210791d45577$var$Prefilter.Type.NONE);
                }
            }
        },
        {
            key: "simplify",
            value: function simplify(pf) {
                if (pf.type === $f8c5210791d45577$var$Prefilter.Type.EXACT || pf.type === $f8c5210791d45577$var$Prefilter.Type.NONE) return pf;
                if (pf.type === $f8c5210791d45577$var$Prefilter.Type.AND) {
                    var newSubs = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = pf.subs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var sub = _step.value;
                            var s = PrefilterTree.simplify(sub);
                            if (s.type !== $f8c5210791d45577$var$Prefilter.Type.NONE) {
                                if (s.type === $f8c5210791d45577$var$Prefilter.Type.AND) for(var j = 0; j < s.subs.length; j++)newSubs.push(s.subs[j]);
                                else newSubs.push(s);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (newSubs.length === 0) return new $f8c5210791d45577$var$Prefilter($f8c5210791d45577$var$Prefilter.Type.NONE);
                    if (newSubs.length === 1) return newSubs[0];
                    pf.subs = newSubs;
                    return pf;
                }
                if (pf.type === $f8c5210791d45577$var$Prefilter.Type.OR) {
                    var newSubs1 = [];
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = pf.subs[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var sub1 = _step1.value;
                            var s1 = PrefilterTree.simplify(sub1);
                            if (s1.type === $f8c5210791d45577$var$Prefilter.Type.NONE) return new $f8c5210791d45577$var$Prefilter($f8c5210791d45577$var$Prefilter.Type.NONE);
                            if (s1.type === $f8c5210791d45577$var$Prefilter.Type.OR) for(var j1 = 0; j1 < s1.subs.length; j1++)newSubs1.push(s1.subs[j1]);
                            else newSubs1.push(s1);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    if (newSubs1.length === 0) return new $f8c5210791d45577$var$Prefilter($f8c5210791d45577$var$Prefilter.Type.NONE);
                    if (newSubs1.length === 1) return newSubs1[0];
                    var seen = /* @__PURE__ */ new Set();
                    var uniqueSubs = [];
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = newSubs1[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var sub2 = _step2.value;
                            if (sub2.type === $f8c5210791d45577$var$Prefilter.Type.EXACT) {
                                if (!seen.has(sub2.str)) {
                                    seen.add(sub2.str);
                                    uniqueSubs.push(sub2);
                                }
                            } else uniqueSubs.push(sub2);
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                    pf.subs = uniqueSubs;
                    var allExact = true;
                    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                    try {
                        for(var _iterator3 = uniqueSubs[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                            var sub3 = _step3.value;
                            if (sub3.type !== $f8c5210791d45577$var$Prefilter.Type.EXACT) {
                                allExact = false;
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                _iterator3.return();
                            }
                        } finally{
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                    if (allExact && uniqueSubs.length > 1) {
                        pf.ac16 = new $f8c5210791d45577$var$AhoCorasick(uniqueSubs.map(function(s) {
                            var arr = [];
                            for(var i = 0; i < s.str.length; i++)arr.push(s.str.charCodeAt(i));
                            return arr;
                        }));
                        pf.ac8 = new $f8c5210791d45577$var$AhoCorasick(uniqueSubs.map(function(s) {
                            return s.bytes;
                        }));
                    }
                    return pf;
                }
                return pf;
            }
        }
    ]);
    return PrefilterTree;
}();
//#endregion
//#region src/Prog.js
/**
* A list of instruction pointers waiting to be patched.
* Tracks both `head` and `tail` to allow O(1) appending during compilation.
* * Values are encoded integers, not standard memory pointers:
* - Program instruction index: `l >> 1`
* - Patch `.out` field if: `(l & 1) === 0`
* - Patch `.arg` field if: `(l & 1) === 1`
* - `0` denotes an empty list.
* * @see https://swtch.com/~rsc/regexp/regexp1.html
*/ var $f8c5210791d45577$var$PatchList = function PatchList() {
    "use strict";
    var head = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, tail = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    (0, $4QweW._)(this, PatchList);
    this.head = head;
    this.tail = tail;
};
/**
* A Prog is a compiled regular expression program.
*/ var $f8c5210791d45577$var$Prog = /*#__PURE__*/ function() {
    "use strict";
    function Prog() {
        (0, $4QweW._)(this, Prog);
        this.inst = [];
        this.start = 0;
        this.numCap = 2;
        this.lbStarts = [];
        this.numLb = 0;
    }
    (0, $6hK4i._)(Prog, [
        {
            key: "getInst",
            value: function getInst(pc) {
                return this.inst[pc];
            }
        },
        {
            key: "numInst",
            value: function numInst() {
                return this.inst.length;
            }
        },
        {
            key: "addInst",
            value: function addInst(op) {
                this.inst.push(new $f8c5210791d45577$var$Inst(op));
            }
        },
        {
            key: "skipNop",
            value: function skipNop(pc) {
                var i = this.inst[pc];
                while(i.op === $f8c5210791d45577$var$Inst.NOP || i.op === $f8c5210791d45577$var$Inst.CAPTURE){
                    i = this.inst[pc];
                    pc = i.out;
                }
                return i;
            }
        },
        {
            key: "prefix",
            value: function prefix() {
                var prefix = "";
                var i = this.skipNop(this.start);
                if (!$f8c5210791d45577$var$Inst.isRuneOp(i.op) || i.runes.length !== 1) return [
                    i.op === $f8c5210791d45577$var$Inst.MATCH,
                    prefix
                ];
                while($f8c5210791d45577$var$Inst.isRuneOp(i.op) && i.runes.length === 1 && (i.arg & $f8c5210791d45577$var$RE2Flags.FOLD_CASE) === 0){
                    prefix += String.fromCodePoint(i.runes[0]);
                    i = this.skipNop(i.out);
                }
                return [
                    i.op === $f8c5210791d45577$var$Inst.MATCH,
                    prefix
                ];
            }
        },
        {
            key: "startCond",
            value: function startCond() {
                var flag = 0;
                var pc = this.start;
                loop: for(;;){
                    var i = this.inst[pc];
                    switch(i.op){
                        case $f8c5210791d45577$var$Inst.EMPTY_WIDTH:
                            flag |= i.arg;
                            break;
                        case $f8c5210791d45577$var$Inst.FAIL:
                            return -1;
                        case $f8c5210791d45577$var$Inst.CAPTURE:
                        case $f8c5210791d45577$var$Inst.NOP:
                            break;
                        default:
                            break loop;
                    }
                    pc = i.out;
                }
                return flag;
            }
        },
        {
            key: "patch",
            value: function patch(l, val) {
                var head = l.head;
                while(head !== 0){
                    var i = this.inst[head >> 1];
                    if ((head & 1) === 0) {
                        head = i.out;
                        i.out = val;
                    } else {
                        head = i.arg;
                        i.arg = val;
                    }
                }
            }
        },
        {
            key: "append",
            value: function append(l1, l2) {
                if (l1.head === 0) return l2;
                if (l2.head === 0) return l1;
                var i = this.inst[l1.tail >> 1];
                if ((l1.tail & 1) === 0) i.out = l2.head;
                else i.arg = l2.head;
                return new $f8c5210791d45577$var$PatchList(l1.head, l2.tail);
            }
        },
        {
            /**
	*
	* @returns {string}
	*/ key: "toString",
            value: function toString() {
                var out = "";
                for(var pc = 0; pc < this.inst.length; pc++){
                    var len = out.length;
                    out += pc;
                    if (pc === this.start) out += "*";
                    out += "        ".substring(out.length - len);
                    out += this.inst[pc];
                    out += "\n";
                }
                return out;
            }
        }
    ]);
    return Prog;
}();
//#endregion
//#region src/Compiler.js
/**
* A fragment of a compiled regular expression program.
*
* @see http://swtch.com/~rsc/regexp/regexp1.html
* @class
*/ var $f8c5210791d45577$var$Frag = function Frag() {
    "use strict";
    var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, out = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $f8c5210791d45577$var$PatchList(), nullable = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    (0, $4QweW._)(this, Frag);
    this.i = i;
    this.out = out;
    this.nullable = nullable;
};
/**
* Compiler from {@code Regexp} (RE2 abstract syntax) to {@code RE2} (compiled regular expression).
*
* The only entry point is {@link #compileRegexp}.
*/ var $f8c5210791d45577$var$Compiler = /*#__PURE__*/ function() {
    "use strict";
    function Compiler() {
        (0, $4QweW._)(this, Compiler);
        this.prog = new $f8c5210791d45577$var$Prog();
        this.newInst($f8c5210791d45577$var$Inst.FAIL);
    }
    (0, $6hK4i._)(Compiler, [
        {
            key: "newInst",
            value: function newInst(op) {
                this.prog.addInst(op);
                return new $f8c5210791d45577$var$Frag(this.prog.numInst() - 1, new $f8c5210791d45577$var$PatchList(), true);
            }
        },
        {
            key: "nop",
            value: function nop() {
                var f = this.newInst($f8c5210791d45577$var$Inst.NOP);
                f.out = new $f8c5210791d45577$var$PatchList(f.i << 1, f.i << 1);
                return f;
            }
        },
        {
            key: "fail",
            value: function fail() {
                return new $f8c5210791d45577$var$Frag();
            }
        },
        {
            key: "cap",
            value: function cap(arg) {
                var f = this.newInst($f8c5210791d45577$var$Inst.CAPTURE);
                f.out = new $f8c5210791d45577$var$PatchList(f.i << 1, f.i << 1);
                this.prog.getInst(f.i).arg = arg;
                if (this.prog.numCap < arg + 1) this.prog.numCap = arg + 1;
                return f;
            }
        },
        {
            key: "cat",
            value: function cat(f1, f2) {
                if (f1.i === 0 || f2.i === 0) return this.fail();
                this.prog.patch(f1.out, f2.i);
                return new $f8c5210791d45577$var$Frag(f1.i, f2.out, f1.nullable && f2.nullable);
            }
        },
        {
            key: "alt",
            value: function alt(f1, f2) {
                if (f1.i === 0) return f2;
                if (f2.i === 0) return f1;
                var f = this.newInst($f8c5210791d45577$var$Inst.ALT);
                var i = this.prog.getInst(f.i);
                i.out = f1.i;
                i.arg = f2.i;
                f.out = this.prog.append(f1.out, f2.out);
                f.nullable = f1.nullable || f2.nullable;
                return f;
            }
        },
        {
            key: "loop",
            value: function loop(f1, nongreedy) {
                var f = this.newInst($f8c5210791d45577$var$Inst.ALT);
                var i = this.prog.getInst(f.i);
                if (nongreedy) {
                    i.arg = f1.i;
                    f.out = new $f8c5210791d45577$var$PatchList(f.i << 1, f.i << 1);
                } else {
                    i.out = f1.i;
                    f.out = new $f8c5210791d45577$var$PatchList(f.i << 1 | 1, f.i << 1 | 1);
                }
                this.prog.patch(f1.out, f.i);
                return f;
            }
        },
        {
            key: "quest",
            value: function quest(f1, nongreedy) {
                var f = this.newInst($f8c5210791d45577$var$Inst.ALT);
                var i = this.prog.getInst(f.i);
                if (nongreedy) {
                    i.arg = f1.i;
                    f.out = new $f8c5210791d45577$var$PatchList(f.i << 1, f.i << 1);
                } else {
                    i.out = f1.i;
                    f.out = new $f8c5210791d45577$var$PatchList(f.i << 1 | 1, f.i << 1 | 1);
                }
                f.out = this.prog.append(f.out, f1.out);
                return f;
            }
        },
        {
            key: "star",
            value: function star(f1, nongreedy) {
                if (f1.nullable) return this.quest(this.plus(f1, nongreedy), nongreedy);
                return this.loop(f1, nongreedy);
            }
        },
        {
            key: "plus",
            value: function plus(f1, nongreedy) {
                return new $f8c5210791d45577$var$Frag(f1.i, this.loop(f1, nongreedy).out, f1.nullable);
            }
        },
        {
            key: "empty",
            value: function empty(op) {
                var f = this.newInst($f8c5210791d45577$var$Inst.EMPTY_WIDTH);
                this.prog.getInst(f.i).arg = op;
                f.out = new $f8c5210791d45577$var$PatchList(f.i << 1, f.i << 1);
                return f;
            }
        },
        {
            key: "rune",
            value: function rune(runes, flags) {
                var f = this.newInst($f8c5210791d45577$var$Inst.RUNE);
                f.nullable = false;
                var i = this.prog.getInst(f.i);
                i.runes = runes;
                flags &= $f8c5210791d45577$var$RE2Flags.FOLD_CASE;
                if (runes.length !== 1 || $f8c5210791d45577$var$Unicode.simpleFold(runes[0]) === runes[0]) flags &= ~$f8c5210791d45577$var$RE2Flags.FOLD_CASE;
                i.arg = flags;
                f.out = new $f8c5210791d45577$var$PatchList(f.i << 1, f.i << 1);
                if ((flags & $f8c5210791d45577$var$RE2Flags.FOLD_CASE) === 0 && runes.length === 1 || runes.length === 2 && runes[0] === runes[1]) i.op = $f8c5210791d45577$var$Inst.RUNE1;
                else if (runes.length === 2 && runes[0] === 0 && runes[1] === $f8c5210791d45577$var$Unicode.MAX_RUNE) i.op = $f8c5210791d45577$var$Inst.RUNE_ANY;
                else if (runes.length === 4 && runes[0] === 0 && runes[1] === $f8c5210791d45577$var$Codepoint.CODES.get("\n") - 1 && runes[2] === $f8c5210791d45577$var$Codepoint.CODES.get("\n") + 1 && runes[3] === $f8c5210791d45577$var$Unicode.MAX_RUNE) i.op = $f8c5210791d45577$var$Inst.RUNE_ANY_NOT_NL;
                return f;
            }
        },
        {
            key: "lookBehind",
            value: function lookBehind(a, lb) {
                var id = this.newInst($f8c5210791d45577$var$Inst.LB_WRITE);
                this.prog.getInst(id.i).arg = lb;
                var any = this.rune(Compiler.ANY_RUNE(), 0);
                var dotStar = this.star(any, true);
                var lbAutomaton = this.cat(dotStar, a);
                this.prog.patch(lbAutomaton.out, id.i);
                var checkId = this.newInst($f8c5210791d45577$var$Inst.LB_CHECK);
                this.prog.getInst(checkId.i).arg = lb;
                this.prog.lbStarts.push(lbAutomaton.i);
                if (Math.abs(lb) > this.prog.numLb) this.prog.numLb = Math.abs(lb);
                checkId.out = new $f8c5210791d45577$var$PatchList(checkId.i << 1, checkId.i << 1);
                return checkId;
            }
        },
        {
            key: "compile",
            value: function compile(re) {
                switch(re.op){
                    case $f8c5210791d45577$var$Regexp.Op.NO_MATCH:
                        return this.fail();
                    case $f8c5210791d45577$var$Regexp.Op.EMPTY_MATCH:
                        return this.nop();
                    case $f8c5210791d45577$var$Regexp.Op.LITERAL:
                        if (re.runes.length === 0) return this.nop();
                        else {
                            var f = null;
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = re.runes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var r = _step.value;
                                    var f1 = this.rune([
                                        r
                                    ], re.flags);
                                    f = f === null ? f1 : this.cat(f, f1);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            return f;
                        }
                    case $f8c5210791d45577$var$Regexp.Op.CHAR_CLASS:
                        return this.rune(re.runes, re.flags);
                    case $f8c5210791d45577$var$Regexp.Op.ANY_CHAR_NOT_NL:
                        return this.rune(Compiler.ANY_RUNE_NOT_NL(), 0);
                    case $f8c5210791d45577$var$Regexp.Op.ANY_CHAR:
                        return this.rune(Compiler.ANY_RUNE(), 0);
                    case $f8c5210791d45577$var$Regexp.Op.BEGIN_LINE:
                        return this.empty($f8c5210791d45577$var$Utils.EMPTY_BEGIN_LINE);
                    case $f8c5210791d45577$var$Regexp.Op.END_LINE:
                        return this.empty($f8c5210791d45577$var$Utils.EMPTY_END_LINE);
                    case $f8c5210791d45577$var$Regexp.Op.BEGIN_TEXT:
                        return this.empty($f8c5210791d45577$var$Utils.EMPTY_BEGIN_TEXT);
                    case $f8c5210791d45577$var$Regexp.Op.END_TEXT:
                        return this.empty($f8c5210791d45577$var$Utils.EMPTY_END_TEXT);
                    case $f8c5210791d45577$var$Regexp.Op.WORD_BOUNDARY:
                        return this.empty($f8c5210791d45577$var$Utils.EMPTY_WORD_BOUNDARY);
                    case $f8c5210791d45577$var$Regexp.Op.NO_WORD_BOUNDARY:
                        return this.empty($f8c5210791d45577$var$Utils.EMPTY_NO_WORD_BOUNDARY);
                    case $f8c5210791d45577$var$Regexp.Op.PLB:
                    case $f8c5210791d45577$var$Regexp.Op.NLB:
                        return this.lookBehind(this.compile(re.subs[0]), re.lb);
                    case $f8c5210791d45577$var$Regexp.Op.CAPTURE:
                        {
                            var bra = this.cap(re.cap << 1);
                            var sub = this.compile(re.subs[0]);
                            var ket = this.cap(re.cap << 1 | 1);
                            return this.cat(this.cat(bra, sub), ket);
                        }
                    case $f8c5210791d45577$var$Regexp.Op.STAR:
                        return this.star(this.compile(re.subs[0]), (re.flags & $f8c5210791d45577$var$RE2Flags.NON_GREEDY) !== 0);
                    case $f8c5210791d45577$var$Regexp.Op.PLUS:
                        return this.plus(this.compile(re.subs[0]), (re.flags & $f8c5210791d45577$var$RE2Flags.NON_GREEDY) !== 0);
                    case $f8c5210791d45577$var$Regexp.Op.QUEST:
                        return this.quest(this.compile(re.subs[0]), (re.flags & $f8c5210791d45577$var$RE2Flags.NON_GREEDY) !== 0);
                    case $f8c5210791d45577$var$Regexp.Op.CONCAT:
                        if (re.subs.length === 0) return this.nop();
                        else {
                            var f2 = null;
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(var _iterator1 = re.subs[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    var sub1 = _step1.value;
                                    var f11 = this.compile(sub1);
                                    f2 = f2 === null ? f11 : this.cat(f2, f11);
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                            return f2;
                        }
                    case $f8c5210791d45577$var$Regexp.Op.ALTERNATE:
                        if (re.subs.length === 0) return this.nop();
                        else {
                            var f3 = null;
                            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            try {
                                for(var _iterator2 = re.subs[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                    var sub2 = _step2.value;
                                    var f12 = this.compile(sub2);
                                    f3 = f3 === null ? f12 : this.alt(f3, f12);
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                        _iterator2.return();
                                    }
                                } finally{
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                            return f3;
                        }
                    default:
                        throw new $f8c5210791d45577$export$457eacef9ada3821("regexp: unhandled case in compile");
                }
            }
        }
    ], [
        {
            key: "ANY_RUNE_NOT_NL",
            value: function ANY_RUNE_NOT_NL() {
                return [
                    0,
                    $f8c5210791d45577$var$Codepoint.CODES.get("\n") - 1,
                    $f8c5210791d45577$var$Codepoint.CODES.get("\n") + 1,
                    $f8c5210791d45577$var$Unicode.MAX_RUNE
                ];
            }
        },
        {
            key: "ANY_RUNE",
            value: function ANY_RUNE() {
                return [
                    0,
                    $f8c5210791d45577$var$Unicode.MAX_RUNE
                ];
            }
        },
        {
            key: "compileRegexp",
            value: function compileRegexp(re) {
                var c = new Compiler();
                var f = c.compile(re);
                c.prog.patch(f.out, c.newInst($f8c5210791d45577$var$Inst.MATCH).i);
                c.prog.start = f.i;
                return c.prog;
            }
        },
        {
            key: "compileSet",
            value: function compileSet(regexps) {
                var c = new Compiler();
                if (regexps.length === 0) {
                    c.prog.start = c.newInst($f8c5210791d45577$var$Inst.FAIL).i;
                    return c.prog;
                }
                var starts = [];
                for(var i = 0; i < regexps.length; i++){
                    var f = c.compile(regexps[i]);
                    var m = c.newInst($f8c5210791d45577$var$Inst.MATCH);
                    c.prog.getInst(m.i).arg = i;
                    c.prog.patch(f.out, m.i);
                    starts.push(f.i);
                }
                var start = starts[0];
                for(var i1 = 1; i1 < starts.length; i1++){
                    var f1 = c.newInst($f8c5210791d45577$var$Inst.ALT);
                    var inst = c.prog.getInst(f1.i);
                    inst.out = start;
                    inst.arg = starts[i1];
                    start = f1.i;
                }
                c.prog.start = start;
                return c.prog;
            }
        }
    ]);
    return Compiler;
}();
//#endregion
//#region src/Simplify.js
var $f8c5210791d45577$var$Simplify = /*#__PURE__*/ function() {
    "use strict";
    function Simplify() {
        (0, $4QweW._)(this, Simplify);
    }
    (0, $6hK4i._)(Simplify, null, [
        {
            key: "simplify",
            value: function simplify(re) {
                if (re === null) return null;
                switch(re.op){
                    case $f8c5210791d45577$var$Regexp.Op.PLB:
                    case $f8c5210791d45577$var$Regexp.Op.NLB:
                    case $f8c5210791d45577$var$Regexp.Op.CAPTURE:
                        {
                            var sub = Simplify.simplify(re.subs[0]);
                            if (sub !== re.subs[0]) {
                                var nre = $f8c5210791d45577$var$Regexp.fromRegexp(re);
                                nre.runes = [];
                                nre.subs = [
                                    sub
                                ];
                                return nre;
                            }
                            return re;
                        }
                    case $f8c5210791d45577$var$Regexp.Op.CONCAT:
                    case $f8c5210791d45577$var$Regexp.Op.ALTERNATE:
                        {
                            var newSubs = [];
                            var changed = false;
                            for(var i = 0; i < re.subs.length; i++){
                                var sub1 = re.subs[i];
                                var nsub = Simplify.simplify(sub1);
                                if (nsub !== sub1) changed = true;
                                if (re.op === $f8c5210791d45577$var$Regexp.Op.CONCAT) {
                                    if (nsub.op === $f8c5210791d45577$var$Regexp.Op.NO_MATCH) return new $f8c5210791d45577$var$Regexp($f8c5210791d45577$var$Regexp.Op.NO_MATCH);
                                    if (nsub.op === $f8c5210791d45577$var$Regexp.Op.EMPTY_MATCH) {
                                        changed = true;
                                        continue;
                                    }
                                    if (nsub.op === $f8c5210791d45577$var$Regexp.Op.CONCAT) {
                                        changed = true;
                                        for(var j = 0; j < nsub.subs.length; j++)newSubs.push(nsub.subs[j]);
                                        continue;
                                    }
                                } else if (re.op === $f8c5210791d45577$var$Regexp.Op.ALTERNATE) {
                                    if (nsub.op === $f8c5210791d45577$var$Regexp.Op.NO_MATCH) {
                                        changed = true;
                                        continue;
                                    }
                                    if (nsub.op === $f8c5210791d45577$var$Regexp.Op.ALTERNATE) {
                                        changed = true;
                                        for(var j1 = 0; j1 < nsub.subs.length; j1++)newSubs.push(nsub.subs[j1]);
                                        continue;
                                    }
                                }
                                newSubs.push(nsub);
                            }
                            if (changed) {
                                if (newSubs.length === 0) return new $f8c5210791d45577$var$Regexp(re.op === $f8c5210791d45577$var$Regexp.Op.CONCAT ? $f8c5210791d45577$var$Regexp.Op.EMPTY_MATCH : $f8c5210791d45577$var$Regexp.Op.NO_MATCH);
                                if (newSubs.length === 1) return newSubs[0];
                                var nre1 = $f8c5210791d45577$var$Regexp.fromRegexp(re);
                                nre1.runes = [];
                                nre1.subs = newSubs;
                                return nre1;
                            }
                            return re;
                        }
                    case $f8c5210791d45577$var$Regexp.Op.CHAR_CLASS:
                        if (re.runes === null) return re;
                        if (re.runes.length === 0) return new $f8c5210791d45577$var$Regexp($f8c5210791d45577$var$Regexp.Op.NO_MATCH);
                        if (re.runes.length === 2 && re.runes[0] === 0 && re.runes[1] === $f8c5210791d45577$var$Unicode.MAX_RUNE) return new $f8c5210791d45577$var$Regexp($f8c5210791d45577$var$Regexp.Op.ANY_CHAR);
                        if (re.runes.length === 4 && re.runes[0] === 0 && re.runes[1] === $f8c5210791d45577$var$Codepoint.CODES.get("\n") - 1 && re.runes[2] === $f8c5210791d45577$var$Codepoint.CODES.get("\n") + 1 && re.runes[3] === $f8c5210791d45577$var$Unicode.MAX_RUNE) return new $f8c5210791d45577$var$Regexp($f8c5210791d45577$var$Regexp.Op.ANY_CHAR_NOT_NL);
                        return re;
                    case $f8c5210791d45577$var$Regexp.Op.STAR:
                    case $f8c5210791d45577$var$Regexp.Op.PLUS:
                    case $f8c5210791d45577$var$Regexp.Op.QUEST:
                        {
                            var sub2 = Simplify.simplify(re.subs[0]);
                            return Simplify.simplify1(re.op, re.flags, sub2, re);
                        }
                    case $f8c5210791d45577$var$Regexp.Op.REPEAT:
                        {
                            if (re.min === 0 && re.max === 0) return new $f8c5210791d45577$var$Regexp($f8c5210791d45577$var$Regexp.Op.EMPTY_MATCH);
                            var sub3 = Simplify.simplify(re.subs[0]);
                            if (re.max === -1) {
                                if (re.min === 0) return Simplify.simplify1($f8c5210791d45577$var$Regexp.Op.STAR, re.flags, sub3, null);
                                if (re.min === 1) return Simplify.simplify1($f8c5210791d45577$var$Regexp.Op.PLUS, re.flags, sub3, null);
                                var nre2 = new $f8c5210791d45577$var$Regexp($f8c5210791d45577$var$Regexp.Op.CONCAT);
                                var subs = [];
                                for(var i1 = 0; i1 < re.min - 1; i1++)subs.push(sub3);
                                subs.push(Simplify.simplify1($f8c5210791d45577$var$Regexp.Op.PLUS, re.flags, sub3, null));
                                nre2.subs = subs.slice(0);
                                return Simplify.simplify(nre2);
                            }
                            if (re.min === 1 && re.max === 1) return sub3;
                            var prefixSubs = null;
                            if (re.min > 0) {
                                prefixSubs = [];
                                for(var i2 = 0; i2 < re.min; i2++)prefixSubs.push(sub3);
                            }
                            if (re.max > re.min) {
                                var suffix = Simplify.simplify1($f8c5210791d45577$var$Regexp.Op.QUEST, re.flags, sub3, null);
                                for(var i3 = re.min + 1; i3 < re.max; i3++){
                                    var nre21 = new $f8c5210791d45577$var$Regexp($f8c5210791d45577$var$Regexp.Op.CONCAT);
                                    nre21.subs = [
                                        sub3,
                                        suffix
                                    ];
                                    suffix = Simplify.simplify1($f8c5210791d45577$var$Regexp.Op.QUEST, re.flags, nre21, null);
                                }
                                if (prefixSubs === null) return suffix;
                                prefixSubs.push(suffix);
                            }
                            if (prefixSubs !== null) {
                                var prefix = new $f8c5210791d45577$var$Regexp($f8c5210791d45577$var$Regexp.Op.CONCAT);
                                prefix.subs = prefixSubs.slice(0);
                                return Simplify.simplify(prefix);
                            }
                            return new $f8c5210791d45577$var$Regexp($f8c5210791d45577$var$Regexp.Op.NO_MATCH);
                        }
                }
                return re;
            }
        },
        {
            key: "simplify1",
            value: function simplify1(op, flags, sub, re) {
                if (sub.op === $f8c5210791d45577$var$Regexp.Op.EMPTY_MATCH) return sub;
                if (sub.op === $f8c5210791d45577$var$Regexp.Op.NO_MATCH) {
                    if (op === $f8c5210791d45577$var$Regexp.Op.PLUS) return sub;
                    return new $f8c5210791d45577$var$Regexp($f8c5210791d45577$var$Regexp.Op.EMPTY_MATCH);
                }
                if (op === sub.op && (flags & $f8c5210791d45577$var$RE2Flags.NON_GREEDY) === (sub.flags & $f8c5210791d45577$var$RE2Flags.NON_GREEDY)) return sub;
                if (re !== null && re.op === op && (re.flags & $f8c5210791d45577$var$RE2Flags.NON_GREEDY) === (flags & $f8c5210791d45577$var$RE2Flags.NON_GREEDY) && sub === re.subs[0]) return re;
                var nre = new $f8c5210791d45577$var$Regexp(op);
                nre.flags = flags;
                nre.subs = [
                    sub
                ];
                return nre;
            }
        }
    ]);
    return Simplify;
}();
//#endregion
//#region src/CharGroup.js
var $f8c5210791d45577$var$CharGroup = function CharGroup(sign, cls) {
    "use strict";
    (0, $4QweW._)(this, CharGroup);
    this.sign = sign;
    this.cls = cls;
};
var $f8c5210791d45577$var$code1 = [
    48,
    57
];
var $f8c5210791d45577$var$code2 = [
    9,
    10,
    12,
    13,
    32,
    32
];
var $f8c5210791d45577$var$code3 = [
    48,
    57,
    65,
    90,
    95,
    95,
    97,
    122
];
var $f8c5210791d45577$var$PERL_GROUPS = /* @__PURE__ */ new Map([
    [
        "\\d",
        new $f8c5210791d45577$var$CharGroup(1, $f8c5210791d45577$var$code1)
    ],
    [
        "\\D",
        new $f8c5210791d45577$var$CharGroup(-1, $f8c5210791d45577$var$code1)
    ],
    [
        "\\s",
        new $f8c5210791d45577$var$CharGroup(1, $f8c5210791d45577$var$code2)
    ],
    [
        "\\S",
        new $f8c5210791d45577$var$CharGroup(-1, $f8c5210791d45577$var$code2)
    ],
    [
        "\\w",
        new $f8c5210791d45577$var$CharGroup(1, $f8c5210791d45577$var$code3)
    ],
    [
        "\\W",
        new $f8c5210791d45577$var$CharGroup(-1, $f8c5210791d45577$var$code3)
    ]
]);
var $f8c5210791d45577$var$code4 = [
    48,
    57,
    65,
    90,
    97,
    122
];
var $f8c5210791d45577$var$code5 = [
    65,
    90,
    97,
    122
];
var $f8c5210791d45577$var$code6 = [
    0,
    127
];
var $f8c5210791d45577$var$code7 = [
    9,
    9,
    32,
    32
];
var $f8c5210791d45577$var$code8 = [
    0,
    31,
    127,
    127
];
var $f8c5210791d45577$var$code9 = [
    48,
    57
];
var $f8c5210791d45577$var$code10 = [
    33,
    126
];
var $f8c5210791d45577$var$code11 = [
    97,
    122
];
var $f8c5210791d45577$var$code12 = [
    32,
    126
];
var $f8c5210791d45577$var$code13 = [
    33,
    47,
    58,
    64,
    91,
    96,
    123,
    126
];
var $f8c5210791d45577$var$code14 = [
    9,
    13,
    32,
    32
];
var $f8c5210791d45577$var$code15 = [
    65,
    90
];
var $f8c5210791d45577$var$code16 = [
    48,
    57,
    65,
    90,
    95,
    95,
    97,
    122
];
var $f8c5210791d45577$var$code17 = [
    48,
    57,
    65,
    70,
    97,
    102
];
var $f8c5210791d45577$var$POSIX_GROUPS = /* @__PURE__ */ new Map([
    [
        "[:alnum:]",
        new $f8c5210791d45577$var$CharGroup(1, $f8c5210791d45577$var$code4)
    ],
    [
        "[:^alnum:]",
        new $f8c5210791d45577$var$CharGroup(-1, $f8c5210791d45577$var$code4)
    ],
    [
        "[:alpha:]",
        new $f8c5210791d45577$var$CharGroup(1, $f8c5210791d45577$var$code5)
    ],
    [
        "[:^alpha:]",
        new $f8c5210791d45577$var$CharGroup(-1, $f8c5210791d45577$var$code5)
    ],
    [
        "[:ascii:]",
        new $f8c5210791d45577$var$CharGroup(1, $f8c5210791d45577$var$code6)
    ],
    [
        "[:^ascii:]",
        new $f8c5210791d45577$var$CharGroup(-1, $f8c5210791d45577$var$code6)
    ],
    [
        "[:blank:]",
        new $f8c5210791d45577$var$CharGroup(1, $f8c5210791d45577$var$code7)
    ],
    [
        "[:^blank:]",
        new $f8c5210791d45577$var$CharGroup(-1, $f8c5210791d45577$var$code7)
    ],
    [
        "[:cntrl:]",
        new $f8c5210791d45577$var$CharGroup(1, $f8c5210791d45577$var$code8)
    ],
    [
        "[:^cntrl:]",
        new $f8c5210791d45577$var$CharGroup(-1, $f8c5210791d45577$var$code8)
    ],
    [
        "[:digit:]",
        new $f8c5210791d45577$var$CharGroup(1, $f8c5210791d45577$var$code9)
    ],
    [
        "[:^digit:]",
        new $f8c5210791d45577$var$CharGroup(-1, $f8c5210791d45577$var$code9)
    ],
    [
        "[:graph:]",
        new $f8c5210791d45577$var$CharGroup(1, $f8c5210791d45577$var$code10)
    ],
    [
        "[:^graph:]",
        new $f8c5210791d45577$var$CharGroup(-1, $f8c5210791d45577$var$code10)
    ],
    [
        "[:lower:]",
        new $f8c5210791d45577$var$CharGroup(1, $f8c5210791d45577$var$code11)
    ],
    [
        "[:^lower:]",
        new $f8c5210791d45577$var$CharGroup(-1, $f8c5210791d45577$var$code11)
    ],
    [
        "[:print:]",
        new $f8c5210791d45577$var$CharGroup(1, $f8c5210791d45577$var$code12)
    ],
    [
        "[:^print:]",
        new $f8c5210791d45577$var$CharGroup(-1, $f8c5210791d45577$var$code12)
    ],
    [
        "[:punct:]",
        new $f8c5210791d45577$var$CharGroup(1, $f8c5210791d45577$var$code13)
    ],
    [
        "[:^punct:]",
        new $f8c5210791d45577$var$CharGroup(-1, $f8c5210791d45577$var$code13)
    ],
    [
        "[:space:]",
        new $f8c5210791d45577$var$CharGroup(1, $f8c5210791d45577$var$code14)
    ],
    [
        "[:^space:]",
        new $f8c5210791d45577$var$CharGroup(-1, $f8c5210791d45577$var$code14)
    ],
    [
        "[:upper:]",
        new $f8c5210791d45577$var$CharGroup(1, $f8c5210791d45577$var$code15)
    ],
    [
        "[:^upper:]",
        new $f8c5210791d45577$var$CharGroup(-1, $f8c5210791d45577$var$code15)
    ],
    [
        "[:word:]",
        new $f8c5210791d45577$var$CharGroup(1, $f8c5210791d45577$var$code16)
    ],
    [
        "[:^word:]",
        new $f8c5210791d45577$var$CharGroup(-1, $f8c5210791d45577$var$code16)
    ],
    [
        "[:xdigit:]",
        new $f8c5210791d45577$var$CharGroup(1, $f8c5210791d45577$var$code17)
    ],
    [
        "[:^xdigit:]",
        new $f8c5210791d45577$var$CharGroup(-1, $f8c5210791d45577$var$code17)
    ]
]);
//#endregion
//#region src/CharClass.js
/**
* A "builder"-style helper class for manipulating character classes represented as an array of
* pairs of runes [lo, hi], each denoting an inclusive interval.
*
* All methods mutate the internal state and return {@code this}, allowing operations to be chained.
*/ var $f8c5210791d45577$var$CharClass = /*#__PURE__*/ function() {
    "use strict";
    function CharClass() {
        var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $f8c5210791d45577$var$Utils.emptyInts();
        (0, $4QweW._)(this, CharClass);
        this.r = r;
        this.len = r.length;
    }
    (0, $6hK4i._)(CharClass, [
        {
            key: "toArray",
            value: function toArray() {
                if (this.len === this.r.length) return this.r;
                else return this.r.slice(0, this.len);
            }
        },
        {
            key: "cleanClass",
            value: function cleanClass() {
                if (this.len < 4) return this;
                CharClass.qsortIntPair(this.r, 0, this.len - 2);
                var w = 2;
                for(var i = 2; i < this.len; i += 2){
                    var lo = this.r[i];
                    var hi = this.r[i + 1];
                    if (lo <= this.r[w - 1] + 1) {
                        if (hi > this.r[w - 1]) this.r[w - 1] = hi;
                        continue;
                    }
                    this.r[w] = lo;
                    this.r[w + 1] = hi;
                    w += 2;
                }
                this.len = w;
                return this;
            }
        },
        {
            key: "appendLiteral",
            value: function appendLiteral(x, flags) {
                return (flags & $f8c5210791d45577$var$RE2Flags.FOLD_CASE) !== 0 ? this.appendFoldedRange(x, x) : this.appendRange(x, x);
            }
        },
        {
            key: "appendRange",
            value: function appendRange(lo, hi) {
                if (this.len > 0) {
                    for(var i = 2; i <= 4; i += 2)if (this.len >= i) {
                        var rlo = this.r[this.len - i];
                        var rhi = this.r[this.len - i + 1];
                        if (lo <= rhi + 1 && rlo <= hi + 1) {
                            if (lo < rlo) this.r[this.len - i] = lo;
                            if (hi > rhi) this.r[this.len - i + 1] = hi;
                            return this;
                        }
                    }
                }
                this.r[this.len++] = lo;
                this.r[this.len++] = hi;
                return this;
            }
        },
        {
            key: "appendFoldedRange",
            value: function appendFoldedRange(lo, hi) {
                if (lo <= $f8c5210791d45577$var$Unicode.MIN_FOLD && hi >= $f8c5210791d45577$var$Unicode.MAX_FOLD) return this.appendRange(lo, hi);
                if (hi < $f8c5210791d45577$var$Unicode.MIN_FOLD || lo > $f8c5210791d45577$var$Unicode.MAX_FOLD) return this.appendRange(lo, hi);
                if (lo < $f8c5210791d45577$var$Unicode.MIN_FOLD) {
                    this.appendRange(lo, $f8c5210791d45577$var$Unicode.MIN_FOLD - 1);
                    lo = $f8c5210791d45577$var$Unicode.MIN_FOLD;
                }
                if (hi > $f8c5210791d45577$var$Unicode.MAX_FOLD) {
                    this.appendRange($f8c5210791d45577$var$Unicode.MAX_FOLD + 1, hi);
                    hi = $f8c5210791d45577$var$Unicode.MAX_FOLD;
                }
                for(var c = lo; c <= hi; c++){
                    this.appendRange(c, c);
                    for(var f = $f8c5210791d45577$var$Unicode.simpleFold(c); f !== c; f = $f8c5210791d45577$var$Unicode.simpleFold(f))this.appendRange(f, f);
                }
                return this;
            }
        },
        {
            key: "appendClass",
            value: function appendClass(x) {
                for(var i = 0; i < x.length; i += 2)this.appendRange(x[i], x[i + 1]);
                return this;
            }
        },
        {
            key: "appendFoldedClass",
            value: function appendFoldedClass(x) {
                for(var i = 0; i < x.length; i += 2)this.appendFoldedRange(x[i], x[i + 1]);
                return this;
            }
        },
        {
            key: "appendNegatedClass",
            value: function appendNegatedClass(x) {
                var nextLo = 0;
                for(var i = 0; i < x.length; i += 2){
                    var lo = x[i];
                    var hi = x[i + 1];
                    if (nextLo <= lo - 1) this.appendRange(nextLo, lo - 1);
                    nextLo = hi + 1;
                }
                if (nextLo <= $f8c5210791d45577$var$Unicode.MAX_RUNE) this.appendRange(nextLo, $f8c5210791d45577$var$Unicode.MAX_RUNE);
                return this;
            }
        },
        {
            key: "appendTable",
            value: function appendTable(table) {
                for(var i = 0; i < table.length; ++i){
                    var lo = table.getLo(i);
                    var hi = table.getHi(i);
                    var stride = table.getStride(i);
                    if (stride === 1) {
                        this.appendRange(lo, hi);
                        continue;
                    }
                    for(var c = lo; c <= hi; c += stride)this.appendRange(c, c);
                }
                return this;
            }
        },
        {
            key: "appendNegatedTable",
            value: function appendNegatedTable(table) {
                var nextLo = 0;
                for(var i = 0; i < table.length; ++i){
                    var lo = table.getLo(i);
                    var hi = table.getHi(i);
                    var stride = table.getStride(i);
                    if (stride === 1) {
                        if (nextLo <= lo - 1) this.appendRange(nextLo, lo - 1);
                        nextLo = hi + 1;
                        continue;
                    }
                    for(var c = lo; c <= hi; c += stride){
                        if (nextLo <= c - 1) this.appendRange(nextLo, c - 1);
                        nextLo = c + 1;
                    }
                }
                if (nextLo <= $f8c5210791d45577$var$Unicode.MAX_RUNE) this.appendRange(nextLo, $f8c5210791d45577$var$Unicode.MAX_RUNE);
                return this;
            }
        },
        {
            key: "appendTableWithSign",
            value: function appendTableWithSign(table, sign) {
                return sign < 0 ? this.appendNegatedTable(table) : this.appendTable(table);
            }
        },
        {
            key: "negateClass",
            value: function negateClass() {
                var nextLo = 0;
                var w = 0;
                for(var i = 0; i < this.len; i += 2){
                    var lo = this.r[i];
                    var hi = this.r[i + 1];
                    if (nextLo <= lo - 1) {
                        this.r[w] = nextLo;
                        this.r[w + 1] = lo - 1;
                        w += 2;
                    }
                    nextLo = hi + 1;
                }
                this.len = w;
                if (nextLo <= $f8c5210791d45577$var$Unicode.MAX_RUNE) {
                    this.r[this.len++] = nextLo;
                    this.r[this.len++] = $f8c5210791d45577$var$Unicode.MAX_RUNE;
                }
                return this;
            }
        },
        {
            key: "appendClassWithSign",
            value: function appendClassWithSign(x, sign) {
                return sign < 0 ? this.appendNegatedClass(x) : this.appendClass(x);
            }
        },
        {
            key: "appendGroup",
            value: function appendGroup(g, foldCase) {
                var cls = g.cls;
                if (foldCase) cls = new CharClass().appendFoldedClass(cls).cleanClass().toArray();
                return this.appendClassWithSign(cls, g.sign);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return CharClass.charClassToString(this.r, this.len);
            }
        }
    ], [
        {
            key: "charClassToString",
            value: function charClassToString(r, len) {
                var result = "[";
                for(var i = 0; i < len; i += 2){
                    if (i > 0) result += " ";
                    var lo = r[i];
                    var hi = r[i + 1];
                    if (lo === hi) result += "0x".concat(lo.toString(16));
                    else result += "0x".concat(lo.toString(16), "-0x").concat(hi.toString(16));
                }
                result += "]";
                return result;
            }
        },
        {
            key: "cmp",
            value: function cmp(array, i, pivotFrom, pivotTo) {
                var cmp = array[i] - pivotFrom;
                return cmp !== 0 ? cmp : pivotTo - array[i + 1];
            }
        },
        {
            key: "qsortIntPair",
            value: function qsortIntPair(array, left, right) {
                var pivotIndex = ((left + right) / 2 | 0) & -2;
                var pivotFrom = array[pivotIndex];
                var pivotTo = array[pivotIndex + 1];
                var i = left;
                var j = right;
                while(i <= j){
                    while(i < right && CharClass.cmp(array, i, pivotFrom, pivotTo) < 0)i += 2;
                    while(j > left && CharClass.cmp(array, j, pivotFrom, pivotTo) > 0)j -= 2;
                    if (i <= j) {
                        if (i !== j) {
                            var temp = array[i];
                            array[i] = array[j];
                            array[j] = temp;
                            temp = array[i + 1];
                            array[i + 1] = array[j + 1];
                            array[j + 1] = temp;
                        }
                        i += 2;
                        j -= 2;
                    }
                }
                if (left < j) CharClass.qsortIntPair(array, left, j);
                if (i < right) CharClass.qsortIntPair(array, i, right);
            }
        }
    ]);
    return CharClass;
}();
//#endregion
//#region src/Parser.js
var $f8c5210791d45577$var$StringIterator = /*#__PURE__*/ function() {
    "use strict";
    function StringIterator(str) {
        (0, $4QweW._)(this, StringIterator);
        this.str = str;
        this.position = 0;
    }
    (0, $6hK4i._)(StringIterator, [
        {
            key: "pos",
            value: function pos() {
                return this.position;
            }
        },
        {
            key: "rewindTo",
            value: function rewindTo(pos) {
                this.position = pos;
            }
        },
        {
            key: "more",
            value: function more() {
                return this.position < this.str.length;
            }
        },
        {
            key: "peek",
            value: function peek() {
                return this.str.codePointAt(this.position);
            }
        },
        {
            key: "skip",
            value: function skip(n) {
                this.position += n;
            }
        },
        {
            key: "skipString",
            value: function skipString(s) {
                this.position += s.length;
            }
        },
        {
            key: "pop",
            value: function pop() {
                var r = this.str.codePointAt(this.position);
                this.position += $f8c5210791d45577$var$Utils.charCount(r);
                return r;
            }
        },
        {
            key: "lookingAt",
            value: function lookingAt(s) {
                return this.str.startsWith(s, this.position);
            }
        },
        {
            key: "rest",
            value: function rest() {
                return this.str.substring(this.position);
            }
        },
        {
            key: "from",
            value: function from(beforePos) {
                return this.str.substring(beforePos, this.position);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.rest();
            }
        }
    ]);
    return StringIterator;
}();
/**
* A parser of regular expression patterns.
*
* The only public entry point is {@link #parse(String pattern, int flags)}.
*/ var $f8c5210791d45577$var$Parser = ($f8c5210791d45577$var$_Parser = /*#__PURE__*/ function() {
    "use strict";
    function Parser(wholeRegexp) {
        var flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, $4QweW._)(this, Parser);
        this.wholeRegexp = wholeRegexp;
        this.flags = flags;
        this.numCap = 0;
        this.namedGroups = Object.create(null);
        this.stack = [];
        this.free = null;
        this.numRegexp = 0;
        this.numRunes = 0;
        this.repeats = 0;
        this.height = null;
        this.size = null;
        this.nlb = 0;
    }
    (0, $6hK4i._)(Parser, [
        {
            key: "newRegexp",
            value: function newRegexp(op) {
                var re = this.free;
                if (re !== null && re.subs !== null && re.subs.length > 0) {
                    this.free = re.subs[0];
                    re.reinit();
                    re.op = op;
                } else {
                    re = new $f8c5210791d45577$var$Regexp(op);
                    this.numRegexp += 1;
                }
                return re;
            }
        },
        {
            key: "reuse",
            value: function reuse(re) {
                if (this.height !== null && this.height.has(re)) this.height.delete(re);
                if (re.subs !== null && re.subs.length > 0) re.subs[0] = this.free;
                this.free = re;
            }
        },
        {
            key: "checkLimits",
            value: function checkLimits(re) {
                if (this.numRunes > Parser.MAX_RUNES) throw new $f8c5210791d45577$export$9c12d0c1e9bff151(Parser.ERR_LARGE);
                this.checkSize(re);
                this.checkHeight(re);
            }
        },
        {
            key: "checkSize",
            value: function checkSize(re) {
                if (this.size === null) {
                    if (this.repeats === 0) this.repeats = 1;
                    if (re.op === $f8c5210791d45577$var$Regexp.Op.REPEAT) {
                        var n = re.max;
                        if (n === -1) n = re.min;
                        if (n <= 0) n = 1;
                        if (n > Math.floor(Parser.MAX_SIZE / this.repeats)) this.repeats = Parser.MAX_SIZE;
                        else this.repeats *= n;
                    }
                    if (this.numRegexp < Math.floor(Parser.MAX_SIZE / this.repeats)) return;
                    this.size = /* @__PURE__ */ new Map();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this.stack[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var reEx = _step.value;
                            this.checkSize(reEx);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                if (this.calcSize(re, true) > Parser.MAX_SIZE) throw new $f8c5210791d45577$export$9c12d0c1e9bff151(Parser.ERR_LARGE);
            }
        },
        {
            key: "calcSize",
            value: function calcSize(re) {
                var force = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (!force && this.size !== null) {
                    if (this.size.has(re)) return this.size.get(re);
                }
                var size = 0;
                switch(re.op){
                    case $f8c5210791d45577$var$Regexp.Op.LITERAL:
                        size = re.runes.length;
                        break;
                    case $f8c5210791d45577$var$Regexp.Op.PLB:
                    case $f8c5210791d45577$var$Regexp.Op.NLB:
                    case $f8c5210791d45577$var$Regexp.Op.CAPTURE:
                    case $f8c5210791d45577$var$Regexp.Op.STAR:
                        size = 2 + this.calcSize(re.subs[0]);
                        break;
                    case $f8c5210791d45577$var$Regexp.Op.PLUS:
                    case $f8c5210791d45577$var$Regexp.Op.QUEST:
                        size = 1 + this.calcSize(re.subs[0]);
                        break;
                    case $f8c5210791d45577$var$Regexp.Op.CONCAT:
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = re.subs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var sub = _step.value;
                                size = size + this.calcSize(sub);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        break;
                    case $f8c5210791d45577$var$Regexp.Op.ALTERNATE:
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = re.subs[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var sub1 = _step1.value;
                                size = size + this.calcSize(sub1);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        if (re.subs.length > 1) size = size + re.subs.length - 1;
                        break;
                    case $f8c5210791d45577$var$Regexp.Op.REPEAT:
                        {
                            var sub2 = this.calcSize(re.subs[0]);
                            if (re.max === -1) {
                                if (re.min === 0) size = 2 + sub2;
                                else size = 1 + re.min * sub2;
                                break;
                            }
                            size = re.max * sub2 + (re.max - re.min);
                            break;
                        }
                }
                size = Math.max(1, size);
                if (this.size === null) this.size = /* @__PURE__ */ new Map();
                this.size.set(re, size);
                return size;
            }
        },
        {
            key: "checkHeight",
            value: function checkHeight(re) {
                if (this.numRegexp < Parser.MAX_HEIGHT) return;
                if (this.height === null) {
                    this.height = /* @__PURE__ */ new Map();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this.stack[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var reEx = _step.value;
                            this.checkHeight(reEx);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                if (this.calcHeight(re, true) > Parser.MAX_HEIGHT) throw new $f8c5210791d45577$export$9c12d0c1e9bff151(Parser.ERR_NESTING_DEPTH);
            }
        },
        {
            key: "calcHeight",
            value: function calcHeight(re) {
                var force = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (!force && this.height !== null) {
                    if (this.height.has(re)) return this.height.get(re);
                }
                var h = 1;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = re.subs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sub = _step.value;
                        var hsub = this.calcHeight(sub);
                        if (h < 1 + hsub) h = 1 + hsub;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (this.height === null) this.height = /* @__PURE__ */ new Map();
                this.height.set(re, h);
                return h;
            }
        },
        {
            key: "pop",
            value: function pop() {
                return this.stack.pop();
            }
        },
        {
            key: "popToPseudo",
            value: function popToPseudo() {
                var n = this.stack.length;
                var i = n;
                while(i > 0 && !$f8c5210791d45577$var$Regexp.isPseudoOp(this.stack[i - 1].op))i--;
                var r = this.stack.slice(i, n);
                this.stack = this.stack.slice(0, i);
                return r;
            }
        },
        {
            key: "push",
            value: function push(re) {
                this.numRunes += re.runes.length;
                if (re.op === $f8c5210791d45577$var$Regexp.Op.CHAR_CLASS && re.runes.length === 2 && re.runes[0] === re.runes[1]) {
                    if (this.maybeConcat(re.runes[0], this.flags & ~$f8c5210791d45577$var$RE2Flags.FOLD_CASE)) return null;
                    re.op = $f8c5210791d45577$var$Regexp.Op.LITERAL;
                    re.runes = [
                        re.runes[0]
                    ];
                    re.flags = this.flags & ~$f8c5210791d45577$var$RE2Flags.FOLD_CASE;
                } else if (re.op === $f8c5210791d45577$var$Regexp.Op.CHAR_CLASS && re.runes.length === 4 && re.runes[0] === re.runes[1] && re.runes[2] === re.runes[3] && $f8c5210791d45577$var$Unicode.simpleFold(re.runes[0]) === re.runes[2] && $f8c5210791d45577$var$Unicode.simpleFold(re.runes[2]) === re.runes[0] || re.op === $f8c5210791d45577$var$Regexp.Op.CHAR_CLASS && re.runes.length === 2 && re.runes[0] + 1 === re.runes[1] && $f8c5210791d45577$var$Unicode.simpleFold(re.runes[0]) === re.runes[1] && $f8c5210791d45577$var$Unicode.simpleFold(re.runes[1]) === re.runes[0]) {
                    if (this.maybeConcat(re.runes[0], this.flags | $f8c5210791d45577$var$RE2Flags.FOLD_CASE)) return null;
                    re.op = $f8c5210791d45577$var$Regexp.Op.LITERAL;
                    re.runes = [
                        re.runes[0]
                    ];
                    re.flags = this.flags | $f8c5210791d45577$var$RE2Flags.FOLD_CASE;
                } else this.maybeConcat(-1, 0);
                this.stack.push(re);
                this.checkLimits(re);
                return re;
            }
        },
        {
            key: "maybeConcat",
            value: function maybeConcat(r, flags) {
                var n = this.stack.length;
                if (n < 2) return false;
                var re1 = this.stack[n - 1];
                var re2 = this.stack[n - 2];
                if (re1.op !== $f8c5210791d45577$var$Regexp.Op.LITERAL || re2.op !== $f8c5210791d45577$var$Regexp.Op.LITERAL || (re1.flags & $f8c5210791d45577$var$RE2Flags.FOLD_CASE) !== (re2.flags & $f8c5210791d45577$var$RE2Flags.FOLD_CASE)) return false;
                re2.runes = Parser.concatRunes(re2.runes, re1.runes);
                if (r >= 0) {
                    re1.runes = [
                        r
                    ];
                    re1.flags = flags;
                    return true;
                }
                this.pop();
                this.reuse(re1);
                return false;
            }
        },
        {
            key: "newLiteral",
            value: function newLiteral(r, flags) {
                var re = this.newRegexp($f8c5210791d45577$var$Regexp.Op.LITERAL);
                re.flags = flags;
                if ((flags & $f8c5210791d45577$var$RE2Flags.FOLD_CASE) !== 0) r = Parser.minFoldRune(r);
                re.runes = [
                    r
                ];
                return re;
            }
        },
        {
            key: "literal",
            value: function literal(r) {
                this.push(this.newLiteral(r, this.flags));
            }
        },
        {
            key: "op",
            value: function op(_op) {
                var re = this.newRegexp(_op);
                re.flags = this.flags;
                return this.push(re);
            }
        },
        {
            key: "repeat",
            value: function repeat(op, min, max, beforePos, t, lastRepeatPos) {
                var flags = this.flags;
                if ((flags & $f8c5210791d45577$var$RE2Flags.PERL_X) !== 0) {
                    if (t.more() && t.lookingAt("?")) {
                        t.skip(1);
                        flags ^= $f8c5210791d45577$var$RE2Flags.NON_GREEDY;
                    }
                    if (lastRepeatPos !== -1) throw new $f8c5210791d45577$export$9c12d0c1e9bff151(Parser.ERR_INVALID_REPEAT_OP, t.from(lastRepeatPos));
                }
                var n = this.stack.length;
                if (n === 0) throw new $f8c5210791d45577$export$9c12d0c1e9bff151(Parser.ERR_MISSING_REPEAT_ARGUMENT, t.from(beforePos));
                var sub = this.stack[n - 1];
                if ($f8c5210791d45577$var$Regexp.isPseudoOp(sub.op)) throw new $f8c5210791d45577$export$9c12d0c1e9bff151(Parser.ERR_MISSING_REPEAT_ARGUMENT, t.from(beforePos));
                var re = this.newRegexp(op);
                re.min = min;
                re.max = max;
                re.flags = flags;
                re.subs = [
                    sub
                ];
                this.stack[n - 1] = re;
                this.checkLimits(re);
                if (op === $f8c5210791d45577$var$Regexp.Op.REPEAT && (min >= 2 || max >= 2) && !this.repeatIsValid(re, 1e3)) throw new $f8c5210791d45577$export$9c12d0c1e9bff151(Parser.ERR_INVALID_REPEAT_SIZE, t.from(beforePos));
            }
        },
        {
            key: "repeatIsValid",
            value: function repeatIsValid(re, n) {
                if (re.op === $f8c5210791d45577$var$Regexp.Op.REPEAT) {
                    var m = re.max;
                    if (m === 0) return true;
                    if (m < 0) m = re.min;
                    if (m > n) return false;
                    if (m > 0) n = Math.trunc(n / m);
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = re.subs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sub = _step.value;
                        if (!this.repeatIsValid(sub, n)) return false;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return true;
            }
        },
        {
            key: "concat",
            value: function concat() {
                this.maybeConcat(-1, 0);
                var subs = this.popToPseudo();
                if (subs.length === 0) return this.push(this.newRegexp($f8c5210791d45577$var$Regexp.Op.EMPTY_MATCH));
                return this.push(this.collapse(subs, $f8c5210791d45577$var$Regexp.Op.CONCAT));
            }
        },
        {
            key: "alternate",
            value: function alternate() {
                var subs = this.popToPseudo();
                if (subs.length > 0) this.cleanAlt(subs[subs.length - 1]);
                if (subs.length === 0) return this.push(this.newRegexp($f8c5210791d45577$var$Regexp.Op.NO_MATCH));
                return this.push(this.collapse(subs, $f8c5210791d45577$var$Regexp.Op.ALTERNATE));
            }
        },
        {
            key: "cleanAlt",
            value: function cleanAlt(re) {
                if (re.op === $f8c5210791d45577$var$Regexp.Op.CHAR_CLASS) {
                    re.runes = new $f8c5210791d45577$var$CharClass(re.runes).cleanClass().toArray();
                    if (re.runes.length === 2 && re.runes[0] === 0 && re.runes[1] === $f8c5210791d45577$var$Unicode.MAX_RUNE) {
                        re.runes = [];
                        re.op = $f8c5210791d45577$var$Regexp.Op.ANY_CHAR;
                    } else if (re.runes.length === 4 && re.runes[0] === 0 && re.runes[1] === $f8c5210791d45577$var$Codepoint.CODES.get("\n") - 1 && re.runes[2] === $f8c5210791d45577$var$Codepoint.CODES.get("\n") + 1 && re.runes[3] === $f8c5210791d45577$var$Unicode.MAX_RUNE) {
                        re.runes = [];
                        re.op = $f8c5210791d45577$var$Regexp.Op.ANY_CHAR_NOT_NL;
                    }
                }
            }
        },
        {
            key: "collapse",
            value: function collapse(subs, op) {
                if (subs.length === 1) return subs[0];
                var len = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = subs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sub = _step.value;
                        len += sub.op === op ? sub.subs.length : 1;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var newsubs = new Array(len).fill(null);
                var i = 0;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = subs[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var sub1 = _step1.value;
                        if (sub1.op === op) {
                            for(var j = 0; j < sub1.subs.length; j++)newsubs[i++] = sub1.subs[j];
                            this.reuse(sub1);
                        } else newsubs[i++] = sub1;
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                var re = this.newRegexp(op);
                re.subs = newsubs;
                if (op === $f8c5210791d45577$var$Regexp.Op.ALTERNATE) {
                    re.subs = this.factor(re.subs);
                    if (re.subs.length === 1) {
                        var old = re;
                        re = re.subs[0];
                        this.reuse(old);
                    }
                }
                return re;
            }
        },
        {
            key: "factor",
            value: function factor(array) {
                if (array.length < 2) return array;
                var s = 0;
                var lensub = array.length;
                var lenout = 0;
                var str = null;
                var strlen = 0;
                var strflags = 0;
                var start = 0;
                for(var i = 0; i <= lensub; i++){
                    var istr = null;
                    var istrlen = 0;
                    var iflags = 0;
                    if (i < lensub) {
                        var re = array[s + i];
                        if (re.op === $f8c5210791d45577$var$Regexp.Op.CONCAT && re.subs.length > 0) re = re.subs[0];
                        if (re.op === $f8c5210791d45577$var$Regexp.Op.LITERAL) {
                            istr = re.runes;
                            istrlen = re.runes.length;
                            iflags = re.flags & $f8c5210791d45577$var$RE2Flags.FOLD_CASE;
                        }
                        if (iflags === strflags) {
                            var same = 0;
                            while(same < strlen && same < istrlen && str[same] === istr[same])same++;
                            if (same > 0) {
                                strlen = same;
                                continue;
                            }
                        }
                    }
                    if (i === start) ;
                    else if (i === start + 1) array[lenout++] = array[s + start];
                    else {
                        var prefix = this.newRegexp($f8c5210791d45577$var$Regexp.Op.LITERAL);
                        prefix.flags = strflags;
                        prefix.runes = str.slice(0, strlen);
                        for(var j = start; j < i; j++){
                            array[s + j] = this.removeLeadingString(array[s + j], strlen);
                            this.checkLimits(array[s + j]);
                        }
                        var suffix = this.collapse(array.slice(s + start, s + i), $f8c5210791d45577$var$Regexp.Op.ALTERNATE);
                        var re1 = this.newRegexp($f8c5210791d45577$var$Regexp.Op.CONCAT);
                        re1.subs = [
                            prefix,
                            suffix
                        ];
                        array[lenout++] = re1;
                    }
                    start = i;
                    str = istr;
                    strlen = istrlen;
                    strflags = iflags;
                }
                lensub = lenout;
                s = 0;
                start = 0;
                lenout = 0;
                var first = null;
                for(var i1 = 0; i1 <= lensub; i1++){
                    var ifirst = null;
                    if (i1 < lensub) {
                        ifirst = Parser.leadingRegexp(array[s + i1]);
                        if (first !== null && first.equals(ifirst) && (Parser.isCharClass(first) || first.op === $f8c5210791d45577$var$Regexp.Op.REPEAT && first.min === first.max && Parser.isCharClass(first.subs[0]))) continue;
                    }
                    if (i1 === start) ;
                    else if (i1 === start + 1) array[lenout++] = array[s + start];
                    else {
                        var prefix1 = first;
                        for(var j1 = start; j1 < i1; j1++){
                            var reuse = j1 !== start;
                            array[s + j1] = this.removeLeadingRegexp(array[s + j1], reuse);
                            this.checkLimits(array[s + j1]);
                        }
                        var suffix1 = this.collapse(array.slice(s + start, s + i1), $f8c5210791d45577$var$Regexp.Op.ALTERNATE);
                        var re2 = this.newRegexp($f8c5210791d45577$var$Regexp.Op.CONCAT);
                        re2.subs = [
                            prefix1,
                            suffix1
                        ];
                        array[lenout++] = re2;
                    }
                    start = i1;
                    first = ifirst;
                }
                lensub = lenout;
                s = 0;
                start = 0;
                lenout = 0;
                for(var i2 = 0; i2 <= lensub; i2++){
                    if (i2 < lensub && Parser.isCharClass(array[s + i2])) continue;
                    if (i2 === start) ;
                    else if (i2 === start + 1) array[lenout++] = array[s + start];
                    else {
                        var max = start;
                        for(var j2 = start + 1; j2 < i2; j2++){
                            var subMax = array[s + max];
                            var subJ = array[s + j2];
                            if (subMax.op < subJ.op || subMax.op === subJ.op && (subMax.runes !== null ? subMax.runes.length : 0) < (subJ.runes !== null ? subJ.runes.length : 0)) max = j2;
                        }
                        var tmp = array[s + start];
                        array[s + start] = array[s + max];
                        array[s + max] = tmp;
                        for(var j3 = start + 1; j3 < i2; j3++){
                            Parser.mergeCharClass(array[s + start], array[s + j3]);
                            this.reuse(array[s + j3]);
                        }
                        this.cleanAlt(array[s + start]);
                        array[lenout++] = array[s + start];
                    }
                    if (i2 < lensub) array[lenout++] = array[s + i2];
                    start = i2 + 1;
                }
                lensub = lenout;
                s = 0;
                start = 0;
                lenout = 0;
                for(var i3 = 0; i3 < lensub; ++i3){
                    if (i3 + 1 < lensub && array[s + i3].op === $f8c5210791d45577$var$Regexp.Op.EMPTY_MATCH && array[s + i3 + 1].op === $f8c5210791d45577$var$Regexp.Op.EMPTY_MATCH) continue;
                    array[lenout++] = array[s + i3];
                }
                lensub = lenout;
                s = 0;
                return array.slice(s, lensub);
            }
        },
        {
            key: "removeLeadingString",
            value: function removeLeadingString(re, n) {
                if (re.op === $f8c5210791d45577$var$Regexp.Op.CONCAT && re.subs.length > 0) {
                    var sub = this.removeLeadingString(re.subs[0], n);
                    re.subs[0] = sub;
                    if (sub.op === $f8c5210791d45577$var$Regexp.Op.EMPTY_MATCH) {
                        this.reuse(sub);
                        switch(re.subs.length){
                            case 0:
                            case 1:
                                re.op = $f8c5210791d45577$var$Regexp.Op.EMPTY_MATCH;
                                re.subs = $f8c5210791d45577$var$Regexp.emptySubs();
                                break;
                            case 2:
                                {
                                    var old = re;
                                    re = re.subs[1];
                                    this.reuse(old);
                                    break;
                                }
                            default:
                                re.subs = re.subs.slice(1, re.subs.length);
                                break;
                        }
                    }
                    return re;
                }
                if (re.op === $f8c5210791d45577$var$Regexp.Op.LITERAL) {
                    re.runes = re.runes.slice(n, re.runes.length);
                    if (re.runes.length === 0) re.op = $f8c5210791d45577$var$Regexp.Op.EMPTY_MATCH;
                }
                return re;
            }
        },
        {
            key: "removeLeadingRegexp",
            value: function removeLeadingRegexp(re, reuse) {
                if (re.op === $f8c5210791d45577$var$Regexp.Op.CONCAT && re.subs.length > 0) {
                    if (reuse) this.reuse(re.subs[0]);
                    re.subs = re.subs.slice(1, re.subs.length);
                    switch(re.subs.length){
                        case 0:
                            re.op = $f8c5210791d45577$var$Regexp.Op.EMPTY_MATCH;
                            re.subs = $f8c5210791d45577$var$Regexp.emptySubs();
                            break;
                        case 1:
                            {
                                var old = re;
                                re = re.subs[0];
                                this.reuse(old);
                                break;
                            }
                    }
                    return re;
                }
                if (reuse) this.reuse(re);
                return this.newRegexp($f8c5210791d45577$var$Regexp.Op.EMPTY_MATCH);
            }
        },
        {
            key: "parseInternal",
            value: function parseInternal() {
                if ((this.flags & $f8c5210791d45577$var$RE2Flags.LITERAL) !== 0) return Parser.literalRegexp(this.wholeRegexp, this.flags);
                var lastRepeatPos = -1;
                var min = -1;
                var max = -1;
                var t = new $f8c5210791d45577$var$StringIterator(this.wholeRegexp);
                while(t.more()){
                    var repeatPos = -1;
                    bigswitch: switch(t.peek()){
                        case $f8c5210791d45577$var$Codepoint.CODES.get("("):
                            if ((this.flags & $f8c5210791d45577$var$RE2Flags.LOOKBEHIND) !== 0) {
                                if (t.lookingAt("(?<=")) {
                                    this.parsePosLookBehind();
                                    t.skip(4);
                                    break;
                                }
                                if (t.lookingAt("(?<!")) {
                                    this.parseNegLookBehind();
                                    t.skip(4);
                                    break;
                                }
                            }
                            if ((this.flags & $f8c5210791d45577$var$RE2Flags.PERL_X) !== 0 && t.lookingAt("(?")) {
                                this.parsePerlFlags(t);
                                break;
                            }
                            this.op($f8c5210791d45577$var$Regexp.Op.LEFT_PAREN).cap = ++this.numCap;
                            t.skip(1);
                            break;
                        case $f8c5210791d45577$var$Codepoint.CODES.get("|"):
                            this.parseVerticalBar();
                            t.skip(1);
                            break;
                        case $f8c5210791d45577$var$Codepoint.CODES.get(")"):
                            this.parseRightParen();
                            t.skip(1);
                            break;
                        case $f8c5210791d45577$var$Codepoint.CODES.get("^"):
                            if ((this.flags & $f8c5210791d45577$var$RE2Flags.ONE_LINE) !== 0) this.op($f8c5210791d45577$var$Regexp.Op.BEGIN_TEXT);
                            else this.op($f8c5210791d45577$var$Regexp.Op.BEGIN_LINE);
                            t.skip(1);
                            break;
                        case $f8c5210791d45577$var$Codepoint.CODES.get("$"):
                            if ((this.flags & $f8c5210791d45577$var$RE2Flags.ONE_LINE) !== 0) this.op($f8c5210791d45577$var$Regexp.Op.END_TEXT).flags |= $f8c5210791d45577$var$RE2Flags.WAS_DOLLAR;
                            else this.op($f8c5210791d45577$var$Regexp.Op.END_LINE);
                            t.skip(1);
                            break;
                        case $f8c5210791d45577$var$Codepoint.CODES.get("."):
                            if ((this.flags & $f8c5210791d45577$var$RE2Flags.DOT_NL) !== 0) this.op($f8c5210791d45577$var$Regexp.Op.ANY_CHAR);
                            else this.op($f8c5210791d45577$var$Regexp.Op.ANY_CHAR_NOT_NL);
                            t.skip(1);
                            break;
                        case $f8c5210791d45577$var$Codepoint.CODES.get("["):
                            this.parseClass(t);
                            break;
                        case $f8c5210791d45577$var$Codepoint.CODES.get("*"):
                        case $f8c5210791d45577$var$Codepoint.CODES.get("+"):
                        case $f8c5210791d45577$var$Codepoint.CODES.get("?"):
                            {
                                repeatPos = t.pos();
                                var op = null;
                                switch(t.pop()){
                                    case $f8c5210791d45577$var$Codepoint.CODES.get("*"):
                                        op = $f8c5210791d45577$var$Regexp.Op.STAR;
                                        break;
                                    case $f8c5210791d45577$var$Codepoint.CODES.get("+"):
                                        op = $f8c5210791d45577$var$Regexp.Op.PLUS;
                                        break;
                                    case $f8c5210791d45577$var$Codepoint.CODES.get("?"):
                                        op = $f8c5210791d45577$var$Regexp.Op.QUEST;
                                        break;
                                }
                                this.repeat(op, min, max, repeatPos, t, lastRepeatPos);
                                break;
                            }
                        case $f8c5210791d45577$var$Codepoint.CODES.get("{"):
                            {
                                repeatPos = t.pos();
                                var minMax = Parser.parseRepeat(t);
                                if (minMax < 0) {
                                    t.rewindTo(repeatPos);
                                    this.literal(t.pop());
                                    break;
                                }
                                min = minMax >> 16;
                                max = (minMax & $f8c5210791d45577$var$Unicode.MAX_BMP) << 16 >> 16;
                                this.repeat($f8c5210791d45577$var$Regexp.Op.REPEAT, min, max, repeatPos, t, lastRepeatPos);
                                break;
                            }
                        case $f8c5210791d45577$var$Codepoint.CODES.get("\\"):
                            {
                                var savedPos = t.pos();
                                t.skip(1);
                                if ((this.flags & $f8c5210791d45577$var$RE2Flags.PERL_X) !== 0 && t.more()) switch(t.pop()){
                                    case $f8c5210791d45577$var$Codepoint.CODES.get("A"):
                                        this.op($f8c5210791d45577$var$Regexp.Op.BEGIN_TEXT);
                                        break bigswitch;
                                    case $f8c5210791d45577$var$Codepoint.CODES.get("b"):
                                        this.op($f8c5210791d45577$var$Regexp.Op.WORD_BOUNDARY);
                                        break bigswitch;
                                    case $f8c5210791d45577$var$Codepoint.CODES.get("B"):
                                        this.op($f8c5210791d45577$var$Regexp.Op.NO_WORD_BOUNDARY);
                                        break bigswitch;
                                    case $f8c5210791d45577$var$Codepoint.CODES.get("C"):
                                        throw new $f8c5210791d45577$export$9c12d0c1e9bff151(Parser.ERR_INVALID_ESCAPE, "\\C");
                                    case $f8c5210791d45577$var$Codepoint.CODES.get("Q"):
                                        {
                                            var lit = t.rest();
                                            var i = lit.indexOf("\\E");
                                            if (i >= 0) {
                                                lit = lit.substring(0, i);
                                                t.skipString(lit);
                                                t.skipString("\\E");
                                            } else t.skipString(lit);
                                            var j = 0;
                                            while(j < lit.length){
                                                var codepoint = lit.codePointAt(j);
                                                this.literal(codepoint);
                                                j += $f8c5210791d45577$var$Utils.charCount(codepoint);
                                            }
                                            break bigswitch;
                                        }
                                    case $f8c5210791d45577$var$Codepoint.CODES.get("z"):
                                        this.op($f8c5210791d45577$var$Regexp.Op.END_TEXT);
                                        break bigswitch;
                                    default:
                                        t.rewindTo(savedPos);
                                        break;
                                }
                                else t.rewindTo(savedPos);
                                var re = this.newRegexp($f8c5210791d45577$var$Regexp.Op.CHAR_CLASS);
                                re.flags = this.flags;
                                if (t.lookingAt("\\p") || t.lookingAt("\\P")) {
                                    var cc = new $f8c5210791d45577$var$CharClass();
                                    if (this.parseUnicodeClass(t, cc)) {
                                        re.runes = cc.toArray();
                                        this.push(re);
                                        break bigswitch;
                                    }
                                }
                                var cc1 = new $f8c5210791d45577$var$CharClass();
                                if (this.parsePerlClassEscape(t, cc1)) {
                                    re.runes = cc1.toArray();
                                    this.push(re);
                                    break bigswitch;
                                }
                                t.rewindTo(savedPos);
                                this.reuse(re);
                                this.literal(Parser.parseEscape(t));
                                break;
                            }
                        default:
                            this.literal(t.pop());
                            break;
                    }
                    lastRepeatPos = repeatPos;
                }
                this.concat();
                if (this.swapVerticalBar()) this.pop();
                this.alternate();
                if (this.stack.length !== 1) throw new $f8c5210791d45577$export$9c12d0c1e9bff151(Parser.ERR_MISSING_PAREN, this.wholeRegexp);
                this.stack[0].namedGroups = this.namedGroups;
                return this.stack[0];
            }
        },
        {
            key: "parsePerlFlags",
            value: function parsePerlFlags(t) {
                var startPos = t.pos();
                var s = t.rest();
                if (s.startsWith("(?P<") || s.startsWith("(?<")) {
                    var begin = s.charAt(2) === "P" ? 4 : 3;
                    var end = s.indexOf(">");
                    if (end < 0) throw new $f8c5210791d45577$export$9c12d0c1e9bff151(Parser.ERR_INVALID_NAMED_CAPTURE, s);
                    var name = s.substring(begin, end);
                    t.skipString(name);
                    t.skip(begin + 1);
                    if (!Parser.isValidCaptureName(name)) throw new $f8c5210791d45577$export$9c12d0c1e9bff151(Parser.ERR_INVALID_NAMED_CAPTURE, s.substring(0, end + 1));
                    var re = this.op($f8c5210791d45577$var$Regexp.Op.LEFT_PAREN);
                    re.cap = ++this.numCap;
                    if (this.namedGroups[name]) throw new $f8c5210791d45577$export$9c12d0c1e9bff151(Parser.ERR_DUPLICATE_NAMED_CAPTURE, name);
                    this.namedGroups[name] = this.numCap;
                    re.name = name;
                    return;
                }
                t.skip(2);
                var flags = this.flags;
                var sign = 1;
                var sawFlag = false;
                loop: while(t.more()){
                    var c = t.pop();
                    switch(c){
                        case $f8c5210791d45577$var$Codepoint.CODES.get("i"):
                            flags |= $f8c5210791d45577$var$RE2Flags.FOLD_CASE;
                            sawFlag = true;
                            break;
                        case $f8c5210791d45577$var$Codepoint.CODES.get("m"):
                            flags &= ~$f8c5210791d45577$var$RE2Flags.ONE_LINE;
                            sawFlag = true;
                            break;
                        case $f8c5210791d45577$var$Codepoint.CODES.get("s"):
                            flags |= $f8c5210791d45577$var$RE2Flags.DOT_NL;
                            sawFlag = true;
                            break;
                        case $f8c5210791d45577$var$Codepoint.CODES.get("U"):
                            flags |= $f8c5210791d45577$var$RE2Flags.NON_GREEDY;
                            sawFlag = true;
                            break;
                        case $f8c5210791d45577$var$Codepoint.CODES.get("-"):
                            if (sign < 0) break loop;
                            sign = -1;
                            flags = ~flags;
                            sawFlag = false;
                            break;
                        case $f8c5210791d45577$var$Codepoint.CODES.get(":"):
                        case $f8c5210791d45577$var$Codepoint.CODES.get(")"):
                            if (sign < 0) {
                                if (!sawFlag) break loop;
                                flags = ~flags;
                            }
                            if (c === $f8c5210791d45577$var$Codepoint.CODES.get(":")) this.op($f8c5210791d45577$var$Regexp.Op.LEFT_PAREN);
                            this.flags = flags;
                            return;
                        default:
                            break loop;
                    }
                }
                throw new $f8c5210791d45577$export$9c12d0c1e9bff151(Parser.ERR_INVALID_PERL_OP, t.from(startPos));
            }
        },
        {
            key: "parsePosLookBehind",
            value: function parsePosLookBehind() {
                var re = this.newRegexp($f8c5210791d45577$var$Regexp.Op.LEFT_PAREN);
                re.flags = this.flags;
                re.lb = ++this.nlb;
                return this.push(re);
            }
        },
        {
            key: "parseNegLookBehind",
            value: function parseNegLookBehind() {
                var re = this.newRegexp($f8c5210791d45577$var$Regexp.Op.LEFT_PAREN);
                re.flags = this.flags;
                re.lb = -++this.nlb;
                return this.push(re);
            }
        },
        {
            key: "parseVerticalBar",
            value: function parseVerticalBar() {
                this.concat();
                if (!this.swapVerticalBar()) this.op($f8c5210791d45577$var$Regexp.Op.VERTICAL_BAR);
            }
        },
        {
            key: "swapVerticalBar",
            value: function swapVerticalBar() {
                var n = this.stack.length;
                if (n >= 3 && this.stack[n - 2].op === $f8c5210791d45577$var$Regexp.Op.VERTICAL_BAR && Parser.isCharClass(this.stack[n - 1]) && Parser.isCharClass(this.stack[n - 3])) {
                    var re1 = this.stack[n - 1];
                    var re3 = this.stack[n - 3];
                    if (re1.op > re3.op) {
                        var tmp = re3;
                        re3 = re1;
                        re1 = tmp;
                        this.stack[n - 3] = re3;
                    }
                    Parser.mergeCharClass(re3, re1);
                    this.reuse(re1);
                    this.pop();
                    return true;
                }
                if (n >= 2) {
                    var re11 = this.stack[n - 1];
                    var re2 = this.stack[n - 2];
                    if (re2.op === $f8c5210791d45577$var$Regexp.Op.VERTICAL_BAR) {
                        if (n >= 3) this.cleanAlt(this.stack[n - 3]);
                        this.stack[n - 2] = re11;
                        this.stack[n - 1] = re2;
                        return true;
                    }
                }
                return false;
            }
        },
        {
            key: "parseRightParen",
            value: function parseRightParen() {
                this.concat();
                if (this.swapVerticalBar()) this.pop();
                this.alternate();
                if (this.stack.length < 2) throw new $f8c5210791d45577$export$9c12d0c1e9bff151(Parser.ERR_UNEXPECTED_PAREN, this.wholeRegexp);
                var re1 = this.pop();
                var re2 = this.pop();
                if (re2.op !== $f8c5210791d45577$var$Regexp.Op.LEFT_PAREN) throw new $f8c5210791d45577$export$9c12d0c1e9bff151(Parser.ERR_UNEXPECTED_PAREN, this.wholeRegexp);
                this.flags = re2.flags;
                if (re2.lb !== 0) {
                    if (Parser.hasCapture(re1)) throw new $f8c5210791d45577$export$9c12d0c1e9bff151(Parser.ERR_INVALID_CAPTURE_IN_LOOKBEHIND, this.wholeRegexp);
                    if (re2.lb > 0) re2.op = $f8c5210791d45577$var$Regexp.Op.PLB;
                    else re2.op = $f8c5210791d45577$var$Regexp.Op.NLB;
                    re2.subs = [
                        re1
                    ];
                    this.push(re2);
                    return;
                }
                if (re2.cap === 0) this.push(re1);
                else {
                    re2.op = $f8c5210791d45577$var$Regexp.Op.CAPTURE;
                    re2.subs = [
                        re1
                    ];
                    this.push(re2);
                }
            }
        },
        {
            key: "parsePerlClassEscape",
            value: function parsePerlClassEscape(t, cc) {
                var beforePos = t.pos();
                if ((this.flags & $f8c5210791d45577$var$RE2Flags.PERL_X) === 0 || !t.more() || t.pop() !== $f8c5210791d45577$var$Codepoint.CODES.get("\\") || !t.more()) return false;
                t.pop();
                var p = t.from(beforePos);
                var g = $f8c5210791d45577$var$PERL_GROUPS.has(p) ? $f8c5210791d45577$var$PERL_GROUPS.get(p) : null;
                if (g === null) return false;
                cc.appendGroup(g, (this.flags & $f8c5210791d45577$var$RE2Flags.FOLD_CASE) !== 0);
                return true;
            }
        },
        {
            key: "parseNamedClass",
            value: function parseNamedClass(t, cc) {
                var cls = t.rest();
                var i = cls.indexOf(":]");
                if (i < 0) return false;
                var name = cls.substring(0, i + 2);
                t.skipString(name);
                var g = $f8c5210791d45577$var$POSIX_GROUPS.has(name) ? $f8c5210791d45577$var$POSIX_GROUPS.get(name) : null;
                if (g === null) throw new $f8c5210791d45577$export$9c12d0c1e9bff151(Parser.ERR_INVALID_CHAR_RANGE, name);
                cc.appendGroup(g, (this.flags & $f8c5210791d45577$var$RE2Flags.FOLD_CASE) !== 0);
                return true;
            }
        },
        {
            key: "parseUnicodeClass",
            value: function parseUnicodeClass(t, cc) {
                var startPos = t.pos();
                if ((this.flags & $f8c5210791d45577$var$RE2Flags.UNICODE_GROUPS) === 0 || !t.lookingAt("\\p") && !t.lookingAt("\\P")) return false;
                t.skip(1);
                var sign = 1;
                var c = t.pop();
                if (c === $f8c5210791d45577$var$Codepoint.CODES.get("P")) sign = -1;
                if (!t.more()) {
                    t.rewindTo(startPos);
                    throw new $f8c5210791d45577$export$9c12d0c1e9bff151(Parser.ERR_INVALID_CHAR_RANGE, t.rest());
                }
                c = t.pop();
                var name;
                if (c !== $f8c5210791d45577$var$Codepoint.CODES.get("{")) name = $f8c5210791d45577$var$Utils.runeToString(c);
                else {
                    var rest = t.rest();
                    var end = rest.indexOf("}");
                    if (end < 0) {
                        t.rewindTo(startPos);
                        throw new $f8c5210791d45577$export$9c12d0c1e9bff151(Parser.ERR_INVALID_CHAR_RANGE, t.rest());
                    }
                    name = rest.substring(0, end);
                    t.skipString(name);
                    t.skip(1);
                }
                if (!(name.length === 0) && name.codePointAt(0) === $f8c5210791d45577$var$Codepoint.CODES.get("^")) {
                    sign = 0 - sign;
                    name = name.substring(1);
                }
                var pair = Parser.unicodeTable(name);
                if (pair === null) throw new $f8c5210791d45577$export$9c12d0c1e9bff151(Parser.ERR_INVALID_CHAR_RANGE, t.from(startPos));
                if (pair.sign < 0) sign = 0 - sign;
                var tab = pair.tab;
                var fold = pair.fold;
                if ((this.flags & $f8c5210791d45577$var$RE2Flags.FOLD_CASE) === 0 || fold === null) cc.appendTableWithSign(tab, sign);
                else {
                    var tmp = new $f8c5210791d45577$var$CharClass().appendTable(tab).appendTable(fold).cleanClass().toArray();
                    cc.appendClassWithSign(tmp, sign);
                }
                return true;
            }
        },
        {
            key: "parseClass",
            value: function parseClass(t) {
                var startPos = t.pos();
                t.skip(1);
                var re = this.newRegexp($f8c5210791d45577$var$Regexp.Op.CHAR_CLASS);
                re.flags = this.flags;
                var cc = new $f8c5210791d45577$var$CharClass();
                var sign = 1;
                if (t.more() && t.lookingAt("^")) {
                    sign = -1;
                    t.skip(1);
                    if ((this.flags & $f8c5210791d45577$var$RE2Flags.CLASS_NL) === 0) cc.appendRange($f8c5210791d45577$var$Codepoint.CODES.get("\n"), $f8c5210791d45577$var$Codepoint.CODES.get("\n"));
                }
                var first = true;
                while(!t.more() || t.peek() !== $f8c5210791d45577$var$Codepoint.CODES.get("]") || first){
                    if (t.more() && t.lookingAt("-") && (this.flags & $f8c5210791d45577$var$RE2Flags.PERL_X) === 0 && !first) {
                        var s = t.rest();
                        if (s === "-" || !s.startsWith("-]")) {
                            t.rewindTo(startPos);
                            throw new $f8c5210791d45577$export$9c12d0c1e9bff151(Parser.ERR_INVALID_CHAR_RANGE, t.rest());
                        }
                    }
                    first = false;
                    var beforePos = t.pos();
                    if (t.lookingAt("[:")) {
                        if (this.parseNamedClass(t, cc)) continue;
                        t.rewindTo(beforePos);
                    }
                    if (this.parseUnicodeClass(t, cc)) continue;
                    if (this.parsePerlClassEscape(t, cc)) continue;
                    t.rewindTo(beforePos);
                    var lo = Parser.parseClassChar(t, startPos);
                    var hi = lo;
                    if (t.more() && t.lookingAt("-")) {
                        t.skip(1);
                        if (t.more() && t.lookingAt("]")) t.skip(-1);
                        else {
                            hi = Parser.parseClassChar(t, startPos);
                            if (hi < lo) throw new $f8c5210791d45577$export$9c12d0c1e9bff151(Parser.ERR_INVALID_CHAR_RANGE, t.from(beforePos));
                        }
                    }
                    if ((this.flags & $f8c5210791d45577$var$RE2Flags.FOLD_CASE) === 0) cc.appendRange(lo, hi);
                    else cc.appendFoldedRange(lo, hi);
                }
                t.skip(1);
                cc.cleanClass();
                if (sign < 0) cc.negateClass();
                re.runes = cc.toArray();
                this.push(re);
            }
        }
    ], [
        {
            key: "unicodeTable",
            value: function unicodeTable(name) {
                if (name === "Any") return {
                    tab: Parser.ANY_TABLE,
                    fold: Parser.ANY_TABLE,
                    sign: 1
                };
                if (name === "Ascii") return {
                    tab: Parser.ASCII_TABLE,
                    fold: Parser.ASCII_FOLD_TABLE,
                    sign: 1
                };
                if (name === "Assigned") return {
                    tab: $f8c5210791d45577$var$UnicodeTables.CATEGORIES.get("Cn"),
                    fold: $f8c5210791d45577$var$UnicodeTables.CATEGORIES.get("Cn"),
                    sign: -1
                };
                if (name === "Lc") return {
                    tab: $f8c5210791d45577$var$UnicodeTables.CATEGORIES.get("LC"),
                    fold: $f8c5210791d45577$var$UnicodeTables.FOLD_CATEGORIES.get("LC"),
                    sign: 1
                };
                if ($f8c5210791d45577$var$UnicodeTables.CATEGORIES.has(name)) return {
                    tab: $f8c5210791d45577$var$UnicodeTables.CATEGORIES.get(name),
                    fold: $f8c5210791d45577$var$UnicodeTables.FOLD_CATEGORIES.get(name),
                    sign: 1
                };
                if ($f8c5210791d45577$var$UnicodeTables.SCRIPTS.has(name)) return {
                    tab: $f8c5210791d45577$var$UnicodeTables.SCRIPTS.get(name),
                    fold: $f8c5210791d45577$var$UnicodeTables.FOLD_SCRIPT.get(name),
                    sign: 1
                };
                return null;
            }
        },
        {
            key: "minFoldRune",
            value: function minFoldRune(r) {
                if (r < $f8c5210791d45577$var$Unicode.MIN_FOLD || r > $f8c5210791d45577$var$Unicode.MAX_FOLD) return r;
                var min = r;
                var r0 = r;
                for(r = $f8c5210791d45577$var$Unicode.simpleFold(r); r !== r0; r = $f8c5210791d45577$var$Unicode.simpleFold(r))if (min > r) min = r;
                return min;
            }
        },
        {
            key: "leadingRegexp",
            value: function leadingRegexp(re) {
                if (re.op === $f8c5210791d45577$var$Regexp.Op.EMPTY_MATCH) return null;
                if (re.op === $f8c5210791d45577$var$Regexp.Op.CONCAT && re.subs.length > 0) {
                    var sub = re.subs[0];
                    if (sub.op === $f8c5210791d45577$var$Regexp.Op.EMPTY_MATCH) return null;
                    return sub;
                }
                return re;
            }
        },
        {
            key: "literalRegexp",
            value: function literalRegexp(s, flags) {
                var re = new $f8c5210791d45577$var$Regexp($f8c5210791d45577$var$Regexp.Op.LITERAL);
                re.flags = flags;
                re.runes = $f8c5210791d45577$var$Utils.stringToRunes(s);
                return re;
            }
        },
        {
            key: "parse",
            value: /**
	* Parse regular expression pattern {@code pattern} with mode flags {@code flags}.
	* @param {string} pattern
	* @param {number} flags
	*/ function parse(pattern, flags) {
                return new Parser(pattern, flags).parseInternal();
            }
        },
        {
            key: "parseRepeat",
            value: function parseRepeat(t) {
                var start = t.pos();
                if (!t.more() || !t.lookingAt("{")) return -1;
                t.skip(1);
                var min = Parser.parseInt(t);
                if (min === -1) return -1;
                if (!t.more()) return -1;
                var max;
                if (!t.lookingAt(",")) max = min;
                else {
                    t.skip(1);
                    if (!t.more()) return -1;
                    if (t.lookingAt("}")) max = -1;
                    else if ((max = Parser.parseInt(t)) === -1) return -1;
                }
                if (!t.more() || !t.lookingAt("}")) return -1;
                t.skip(1);
                if (min < 0 || min > 1e3 || max === -2 || max > 1e3 || max >= 0 && min > max) throw new $f8c5210791d45577$export$9c12d0c1e9bff151(Parser.ERR_INVALID_REPEAT_SIZE, t.from(start));
                return min << 16 | max & $f8c5210791d45577$var$Unicode.MAX_BMP;
            }
        },
        {
            key: "isValidCaptureName",
            value: function isValidCaptureName(name) {
                if (name.length === 0) return false;
                for(var i = 0; i < name.length; i++){
                    var c = name.codePointAt(i);
                    if (c !== $f8c5210791d45577$var$Codepoint.CODES.get("_") && !$f8c5210791d45577$var$Utils.isalnum(c)) return false;
                }
                return true;
            }
        },
        {
            key: "parseInt",
            value: function parseInt1(t) {
                var start = t.pos();
                while(t.more() && t.peek() >= $f8c5210791d45577$var$Codepoint.CODES.get("0") && t.peek() <= $f8c5210791d45577$var$Codepoint.CODES.get("9"))t.skip(1);
                var n = t.from(start);
                if (n.length === 0 || n.length > 1 && n.codePointAt(0) === $f8c5210791d45577$var$Codepoint.CODES.get("0")) return -1;
                if (n.length > 8) return -2;
                return parseInt(n, 10);
            }
        },
        {
            key: "isCharClass",
            value: function isCharClass(re) {
                return re.op === $f8c5210791d45577$var$Regexp.Op.LITERAL && re.runes.length === 1 || re.op === $f8c5210791d45577$var$Regexp.Op.CHAR_CLASS || re.op === $f8c5210791d45577$var$Regexp.Op.ANY_CHAR_NOT_NL || re.op === $f8c5210791d45577$var$Regexp.Op.ANY_CHAR;
            }
        },
        {
            key: "matchRune",
            value: function matchRune(re, r) {
                switch(re.op){
                    case $f8c5210791d45577$var$Regexp.Op.LITERAL:
                        return re.runes.length === 1 && re.runes[0] === r;
                    case $f8c5210791d45577$var$Regexp.Op.CHAR_CLASS:
                        for(var i = 0; i < re.runes.length; i += 2)if (re.runes[i] <= r && r <= re.runes[i + 1]) return true;
                        return false;
                    case $f8c5210791d45577$var$Regexp.Op.ANY_CHAR_NOT_NL:
                        return r !== $f8c5210791d45577$var$Codepoint.CODES.get("\n");
                    case $f8c5210791d45577$var$Regexp.Op.ANY_CHAR:
                        return true;
                }
                return false;
            }
        },
        {
            key: "mergeCharClass",
            value: function mergeCharClass(dst, src) {
                switch(dst.op){
                    case $f8c5210791d45577$var$Regexp.Op.ANY_CHAR:
                        break;
                    case $f8c5210791d45577$var$Regexp.Op.ANY_CHAR_NOT_NL:
                        if (Parser.matchRune(src, $f8c5210791d45577$var$Codepoint.CODES.get("\n"))) dst.op = $f8c5210791d45577$var$Regexp.Op.ANY_CHAR;
                        break;
                    case $f8c5210791d45577$var$Regexp.Op.CHAR_CLASS:
                        if (src.op === $f8c5210791d45577$var$Regexp.Op.LITERAL) dst.runes = new $f8c5210791d45577$var$CharClass(dst.runes).appendLiteral(src.runes[0], src.flags).toArray();
                        else dst.runes = new $f8c5210791d45577$var$CharClass(dst.runes).appendClass(src.runes).toArray();
                        break;
                    case $f8c5210791d45577$var$Regexp.Op.LITERAL:
                        if (src.runes[0] === dst.runes[0] && src.flags === dst.flags) break;
                        dst.op = $f8c5210791d45577$var$Regexp.Op.CHAR_CLASS;
                        dst.runes = new $f8c5210791d45577$var$CharClass().appendLiteral(dst.runes[0], dst.flags).appendLiteral(src.runes[0], src.flags).toArray();
                        break;
                }
            }
        },
        {
            key: "parseEscape",
            value: function parseEscape(t) {
                var startPos = t.pos();
                t.skip(1);
                if (!t.more()) throw new $f8c5210791d45577$export$9c12d0c1e9bff151(Parser.ERR_TRAILING_BACKSLASH);
                var c = t.pop();
                bigswitch: switch(c){
                    case $f8c5210791d45577$var$Codepoint.CODES.get("1"):
                    case $f8c5210791d45577$var$Codepoint.CODES.get("2"):
                    case $f8c5210791d45577$var$Codepoint.CODES.get("3"):
                    case $f8c5210791d45577$var$Codepoint.CODES.get("4"):
                    case $f8c5210791d45577$var$Codepoint.CODES.get("5"):
                    case $f8c5210791d45577$var$Codepoint.CODES.get("6"):
                    case $f8c5210791d45577$var$Codepoint.CODES.get("7"):
                        if (!t.more() || t.peek() < $f8c5210791d45577$var$Codepoint.CODES.get("0") || t.peek() > $f8c5210791d45577$var$Codepoint.CODES.get("7")) break;
                    case $f8c5210791d45577$var$Codepoint.CODES.get("0"):
                        {
                            var r = c - $f8c5210791d45577$var$Codepoint.CODES.get("0");
                            for(var i = 1; i < 3; i++){
                                if (!t.more() || t.peek() < $f8c5210791d45577$var$Codepoint.CODES.get("0") || t.peek() > $f8c5210791d45577$var$Codepoint.CODES.get("7")) break;
                                r = r * 8 + t.peek() - $f8c5210791d45577$var$Codepoint.CODES.get("0");
                                t.skip(1);
                            }
                            return r;
                        }
                    case $f8c5210791d45577$var$Codepoint.CODES.get("x"):
                        {
                            if (!t.more()) break;
                            c = t.pop();
                            if (c === $f8c5210791d45577$var$Codepoint.CODES.get("{")) {
                                var nhex = 0;
                                var r1 = 0;
                                while(true){
                                    if (!t.more()) break bigswitch;
                                    c = t.pop();
                                    if (c === $f8c5210791d45577$var$Codepoint.CODES.get("}")) break;
                                    var v = $f8c5210791d45577$var$Utils.unhex(c);
                                    if (v < 0) break bigswitch;
                                    r1 = r1 * 16 + v;
                                    if (r1 > $f8c5210791d45577$var$Unicode.MAX_RUNE) break bigswitch;
                                    nhex++;
                                }
                                if (nhex === 0) break bigswitch;
                                return r1;
                            }
                            var x = $f8c5210791d45577$var$Utils.unhex(c);
                            if (!t.more()) break;
                            c = t.pop();
                            var y = $f8c5210791d45577$var$Utils.unhex(c);
                            if (x < 0 || y < 0) break;
                            return x * 16 + y;
                        }
                    case $f8c5210791d45577$var$Codepoint.CODES.get("a"):
                        return $f8c5210791d45577$var$Codepoint.CODES.get("\x07");
                    case $f8c5210791d45577$var$Codepoint.CODES.get("f"):
                        return $f8c5210791d45577$var$Codepoint.CODES.get("\f");
                    case $f8c5210791d45577$var$Codepoint.CODES.get("n"):
                        return $f8c5210791d45577$var$Codepoint.CODES.get("\n");
                    case $f8c5210791d45577$var$Codepoint.CODES.get("r"):
                        return $f8c5210791d45577$var$Codepoint.CODES.get("\r");
                    case $f8c5210791d45577$var$Codepoint.CODES.get("t"):
                        return $f8c5210791d45577$var$Codepoint.CODES.get("	");
                    case $f8c5210791d45577$var$Codepoint.CODES.get("v"):
                        return $f8c5210791d45577$var$Codepoint.CODES.get("\v");
                    default:
                        if (c <= $f8c5210791d45577$var$Unicode.MAX_ASCII && !$f8c5210791d45577$var$Utils.isalnum(c)) return c;
                        break;
                }
                throw new $f8c5210791d45577$export$9c12d0c1e9bff151(Parser.ERR_INVALID_ESCAPE, t.from(startPos));
            }
        },
        {
            key: "parseClassChar",
            value: function parseClassChar(t, wholeClassPos) {
                if (!t.more()) throw new $f8c5210791d45577$export$9c12d0c1e9bff151(Parser.ERR_MISSING_BRACKET, t.from(wholeClassPos));
                if (t.lookingAt("\\")) return Parser.parseEscape(t);
                return t.pop();
            }
        },
        {
            key: "concatRunes",
            value: function concatRunes(x, y) {
                for(var i = 0; i < y.length; i++)x.push(y[i]);
                return x;
            }
        },
        {
            key: "hasCapture",
            value: function hasCapture(re) {
                if (re === null) return false;
                if (re.op === $f8c5210791d45577$var$Regexp.Op.CAPTURE) return true;
                if (re.subs) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = re.subs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var sub = _step.value;
                            if (Parser.hasCapture(sub)) return true;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                return false;
            }
        }
    ]);
    return Parser;
}(), (0, $6tY97._)($f8c5210791d45577$var$_Parser, "ERR_INTERNAL_ERROR", "regexp/syntax: internal error"), (0, $6tY97._)($f8c5210791d45577$var$_Parser, "ERR_INVALID_CHAR_RANGE", "invalid character class range"), (0, $6tY97._)($f8c5210791d45577$var$_Parser, "ERR_INVALID_ESCAPE", "invalid escape sequence"), (0, $6tY97._)($f8c5210791d45577$var$_Parser, "ERR_INVALID_NAMED_CAPTURE", "invalid named capture"), (0, $6tY97._)($f8c5210791d45577$var$_Parser, "ERR_INVALID_PERL_OP", "invalid or unsupported Perl syntax"), (0, $6tY97._)($f8c5210791d45577$var$_Parser, "ERR_INVALID_REPEAT_OP", "invalid nested repetition operator"), (0, $6tY97._)($f8c5210791d45577$var$_Parser, "ERR_INVALID_REPEAT_SIZE", "invalid repeat count"), (0, $6tY97._)($f8c5210791d45577$var$_Parser, "ERR_MISSING_BRACKET", "missing closing ]"), (0, $6tY97._)($f8c5210791d45577$var$_Parser, "ERR_MISSING_PAREN", "missing closing )"), (0, $6tY97._)($f8c5210791d45577$var$_Parser, "ERR_MISSING_REPEAT_ARGUMENT", "missing argument to repetition operator"), (0, $6tY97._)($f8c5210791d45577$var$_Parser, "ERR_TRAILING_BACKSLASH", "trailing backslash at end of expression"), (0, $6tY97._)($f8c5210791d45577$var$_Parser, "ERR_DUPLICATE_NAMED_CAPTURE", "duplicate capture group name"), (0, $6tY97._)($f8c5210791d45577$var$_Parser, "ERR_UNEXPECTED_PAREN", "unexpected )"), (0, $6tY97._)($f8c5210791d45577$var$_Parser, "ERR_NESTING_DEPTH", "expression nests too deeply"), (0, $6tY97._)($f8c5210791d45577$var$_Parser, "ERR_LARGE", "expression too large"), (0, $6tY97._)($f8c5210791d45577$var$_Parser, "ERR_INVALID_CAPTURE_IN_LOOKBEHIND", "invalid capture in lookbehind"), (0, $6tY97._)($f8c5210791d45577$var$_Parser, "MAX_HEIGHT", 1e3), (0, $6tY97._)($f8c5210791d45577$var$_Parser, "MAX_SIZE", 3355443), (0, $6tY97._)($f8c5210791d45577$var$_Parser, "MAX_RUNES", 33554432), (0, $6tY97._)($f8c5210791d45577$var$_Parser, "ANY_TABLE", new $f8c5210791d45577$var$UnicodeRangeTable(new Uint32Array([
    0,
    $f8c5210791d45577$var$Unicode.MAX_RUNE,
    1
]))), (0, $6tY97._)($f8c5210791d45577$var$_Parser, "ASCII_TABLE", new $f8c5210791d45577$var$UnicodeRangeTable(new Uint32Array([
    0,
    127,
    1
]))), (0, $6tY97._)($f8c5210791d45577$var$_Parser, "ASCII_FOLD_TABLE", new $f8c5210791d45577$var$UnicodeRangeTable(new Uint32Array([
    0,
    127,
    1,
    383,
    383,
    1,
    8490,
    8490,
    1
]))), $f8c5210791d45577$var$_Parser);
//#endregion
//#region src/RE2.js
/**
* An RE2 class instance is a compiled representation of an RE2 regular expression, independent of
* the public Java-like Pattern/Matcher API.
*
* This class also contains various implementation helpers for RE2 regular expressions.
*
* Use the {@link #quoteMeta(String)} utility function to quote all regular expression
* metacharacters in an arbitrary string.
*
*/ var $f8c5210791d45577$var$RE2 = /*#__PURE__*/ function() {
    "use strict";
    function RE2(expr, prog) {
        var numSubexp = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, longest = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
        (0, $4QweW._)(this, RE2);
        this.expr = expr;
        this.prog = prog;
        this.numSubexp = numSubexp;
        this.longest = longest;
        this.cond = prog.startCond();
        this.prefix = null;
        this.prefixUTF8 = null;
        this.prefixComplete = false;
        this.prefixRune = 0;
        this.machinePool = [];
        this.dfa = new $f8c5210791d45577$var$DFA(this.prog);
        this.onepass = $f8c5210791d45577$var$OnePass.compile(this.prog);
        this.prefilter = null;
    }
    (0, $6hK4i._)(RE2, [
        {
            key: "matchPrefixComplete",
            value: function matchPrefixComplete(input, pos, anchor, ncap) {
                if ((anchor === $f8c5210791d45577$var$RE2Flags.ANCHOR_START || anchor === $f8c5210791d45577$var$RE2Flags.ANCHOR_BOTH) && pos !== 0) return null;
                var matchStart = -1;
                var matchEnd = -1;
                var pLen = input.prefixLength(this);
                if (anchor === $f8c5210791d45577$var$RE2Flags.UNANCHORED) {
                    var idx = input.index(this, pos);
                    if (idx < 0) return null;
                    matchStart = pos + idx;
                    matchEnd = matchStart + pLen;
                } else if (anchor === $f8c5210791d45577$var$RE2Flags.ANCHOR_BOTH) {
                    if (input.endPos() !== pLen) return null;
                    if (input.index(this, 0) !== 0) return null;
                    matchStart = 0;
                    matchEnd = pLen;
                } else if (anchor === $f8c5210791d45577$var$RE2Flags.ANCHOR_START) {
                    if (input.index(this, 0) !== 0) return null;
                    matchStart = 0;
                    matchEnd = pLen;
                }
                if (matchStart < 0) return null;
                if (ncap > 0) {
                    var matchcap = new Int32Array(ncap).fill(-1);
                    matchcap[0] = matchStart;
                    matchcap[1] = matchEnd;
                    return Array.from(matchcap);
                }
                return [];
            }
        },
        {
            key: "executeEngine",
            value: function executeEngine(input, pos, anchor, ncap) {
                if (this.prefixComplete && (ncap === 0 || this.numSubexp === 0)) return this.matchPrefixComplete(input, pos, anchor, ncap);
                if (this.prefilter !== null && anchor === $f8c5210791d45577$var$RE2Flags.UNANCHORED) {
                    if (!this.prefilter.eval(input, pos)) return null;
                }
                if (this.onepass !== null) return $f8c5210791d45577$var$OnePass.execute(this, input, pos, anchor, ncap);
                if (ncap > 0) {
                    if (this.prog.numLb === 0 && input.endPos() <= $f8c5210791d45577$var$Backtracker.maxBitStateLen(this.prog)) return $f8c5210791d45577$var$Backtracker.execute(this, input, pos, anchor, ncap);
                    return this.doExecuteNFA(input, pos, anchor, ncap);
                }
                if (this.prog.numLb === 0) {
                    var dfaResult = this.dfa.match(input, pos, anchor);
                    if (dfaResult !== null) return dfaResult ? [] : null;
                    if (input.endPos() <= $f8c5210791d45577$var$Backtracker.maxBitStateLen(this.prog)) return $f8c5210791d45577$var$Backtracker.execute(this, input, pos, anchor, ncap);
                }
                return this.doExecuteNFA(input, pos, anchor, ncap);
            }
        },
        {
            /**
	* Returns the number of parenthesized subexpressions in this regular expression.
	*/ key: "numberOfCapturingGroups",
            value: function numberOfCapturingGroups() {
                return this.numSubexp;
            }
        },
        {
            /**
	* Returns the number of instructions in this compiled regular expression program.
	*/ key: "numberOfInstructions",
            value: function numberOfInstructions() {
                return this.prog.numInst();
            }
        },
        {
            key: "get",
            value: function get() {
                return this.machinePool.length > 0 ? this.machinePool.pop() : null;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.machinePool.length = 0;
            }
        },
        {
            key: "put",
            value: function put(m) {
                this.machinePool.push(m);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.expr;
            }
        },
        {
            key: "doExecuteNFA",
            value: function doExecuteNFA(input, pos, anchor, ncap) {
                var m = this.get();
                if (!m) m = $f8c5210791d45577$var$Machine.fromRE2(this);
                m.init(ncap);
                var cap = m.match(input, pos, anchor) ? m.submatches() : null;
                this.put(m);
                return cap;
            }
        },
        {
            key: "match",
            value: function match(s) {
                return this.executeEngine($f8c5210791d45577$var$MachineInput.fromUTF16(s), 0, $f8c5210791d45577$var$RE2Flags.UNANCHORED, 0) !== null;
            }
        },
        {
            /**
	* Matches the regular expression against input starting at position start and ending at position
	* end, with the given anchoring. Records the submatch boundaries in group, which is [start, end)
	* pairs of byte offsets. The number of boundaries needed is inferred from the size of the group
	* array. It is most efficient not to ask for submatch boundaries.
	*
	* @param input the input byte array
	* @param start the beginning position in the input
	* @param end the end position in the input
	* @param anchor the anchoring flag (UNANCHORED, ANCHOR_START, ANCHOR_BOTH)
	* @param group the array to fill with submatch positions
	* @param ngroup the number of array pairs to fill in
	* @returns true if a match was found
	*/ key: "matchWithGroup",
            value: function matchWithGroup(input, start, end, anchor, ngroup) {
                if (!(input instanceof $f8c5210791d45577$export$cefe1fb40cb8a0f6)) {
                    if ($f8c5210791d45577$var$Utils.isByteArray(input)) input = $f8c5210791d45577$export$3430ac14b3833fca.utf8(input);
                    else input = $f8c5210791d45577$export$3430ac14b3833fca.utf16(input);
                }
                return this.matchMachineInput(input, start, end, anchor, ngroup);
            }
        },
        {
            key: "matchMachineInput",
            value: function matchMachineInput(input, start, end, anchor, ngroup) {
                if (start > end) return [
                    false,
                    null
                ];
                var machineInput = input.isUTF16Encoding() ? $f8c5210791d45577$var$MachineInput.fromUTF16(input.asCharSequence(), 0, end) : $f8c5210791d45577$var$MachineInput.fromUTF8(input.asBytes(), 0, end);
                var groupMatch = this.executeEngine(machineInput, start, anchor, 2 * ngroup);
                if (groupMatch === null) return [
                    false,
                    null
                ];
                return [
                    true,
                    groupMatch
                ];
            }
        },
        {
            /**
	* Returns true iff this regexp matches the UTF-8 byte array {@code b}.
	*/ key: "matchUTF8",
            value: function matchUTF8(b) {
                return this.executeEngine($f8c5210791d45577$var$MachineInput.fromUTF8(b), 0, $f8c5210791d45577$var$RE2Flags.UNANCHORED, 0) !== null;
            }
        },
        {
            /**
	* Returns a copy of {@code src} in which all matches for this regexp have been replaced by
	* {@code repl}. No support is provided for expressions (e.g. {@code \1} or {@code $1}) in the
	* replacement string.
	*/ key: "replaceAll",
            value: function replaceAll(src, repl) {
                return this.replaceAllFunc(src, function() {
                    return repl;
                }, 2 * src.length + 1);
            }
        },
        {
            /**
	* Returns a copy of {@code src} in which only the first match for this regexp has been replaced
	* by {@code repl}. No support is provided for expressions (e.g. {@code \1} or {@code $1}) in the
	* replacement string.
	*/ key: "replaceFirst",
            value: function replaceFirst(src, repl) {
                return this.replaceAllFunc(src, function() {
                    return repl;
                }, 1);
            }
        },
        {
            /**
	* Returns a copy of {@code src} in which at most {@code maxReplaces} matches for this regexp have
	* been replaced by the return value of of function {@code repl} (whose first argument is the
	* matched string). No support is provided for expressions (e.g. {@code \1} or {@code $1}) in the
	* replacement string.
	*/ key: "replaceAllFunc",
            value: function replaceAllFunc(src, replFunc, maxReplaces) {
                var lastMatchEnd = 0;
                var searchPos = 0;
                var out = "";
                var input = $f8c5210791d45577$var$MachineInput.fromUTF16(src);
                var numReplaces = 0;
                while(searchPos <= src.length){
                    var a = this.executeEngine(input, searchPos, $f8c5210791d45577$var$RE2Flags.UNANCHORED, 2);
                    if (a === null || a.length === 0) break;
                    out += src.substring(lastMatchEnd, a[0]);
                    if (a[1] > lastMatchEnd || a[0] === 0) {
                        out += replFunc(src.substring(a[0], a[1]));
                        numReplaces++;
                    }
                    lastMatchEnd = a[1];
                    var width = input.step(searchPos) & 7;
                    if (searchPos + width > a[1]) searchPos += width;
                    else if (searchPos + 1 > a[1]) searchPos++;
                    else searchPos = a[1];
                    if (numReplaces >= maxReplaces) break;
                }
                out += src.substring(lastMatchEnd);
                return out;
            }
        },
        {
            key: "pad",
            value: function pad(a) {
                if (a === null) return null;
                var n = (1 + this.numSubexp) * 2;
                if (a.length < n) {
                    var a2 = new Array(n).fill(-1);
                    for(var i = 0; i < a.length; i++)a2[i] = a[i];
                    a = a2;
                }
                return a;
            }
        },
        {
            key: "allMatches",
            value: function allMatches(input, n) {
                var deliverFun = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(v) {
                    return v;
                };
                var result = [];
                var end = input.endPos();
                if (n < 0) n = end + 1;
                var pos = 0;
                var i = 0;
                var prevMatchEnd = -1;
                while(i < n && pos <= end){
                    var matches = this.executeEngine(input, pos, $f8c5210791d45577$var$RE2Flags.UNANCHORED, this.prog.numCap);
                    if (matches === null || matches.length === 0) break;
                    var accept = true;
                    if (matches[1] === pos) {
                        if (matches[0] === prevMatchEnd) accept = false;
                        var r = input.step(pos);
                        if (r < 0) pos = end + 1;
                        else pos += r & 7;
                    } else pos = matches[1];
                    prevMatchEnd = matches[1];
                    if (accept) {
                        result.push(deliverFun(this.pad(matches)));
                        i++;
                    }
                }
                return result;
            }
        },
        {
            /**
	* Returns an array holding the text of the leftmost match in {@code b} of this regular
	* expression.
	*
	* A return value of null indicates no match.
	*/ key: "findUTF8",
            value: function findUTF8(b) {
                var a = this.executeEngine($f8c5210791d45577$var$MachineInput.fromUTF8(b), 0, $f8c5210791d45577$var$RE2Flags.UNANCHORED, 2);
                if (a === null) return null;
                return b.slice(a[0], a[1]);
            }
        },
        {
            /**
	* Returns a two-element array of integers defining the location of the leftmost match in
	* {@code b} of this regular expression. The match itself is at {@code b[loc[0]...loc[1]]}.
	*
	* A return value of null indicates no match.
	*/ key: "findUTF8Index",
            value: function findUTF8Index(b) {
                var a = this.executeEngine($f8c5210791d45577$var$MachineInput.fromUTF8(b), 0, $f8c5210791d45577$var$RE2Flags.UNANCHORED, 2);
                if (a === null) return null;
                return a.slice(0, 2);
            }
        },
        {
            /**
	* Returns a string holding the text of the leftmost match in {@code s} of this regular
	* expression.
	*
	* If there is no match, the return value is an empty string, but it will also be empty if the
	* regular expression successfully matches an empty string. Use {@link #findIndex} or
	* {@link #findSubmatch} if it is necessary to distinguish these cases.
	*/ key: "find",
            value: function find(s) {
                var a = this.executeEngine($f8c5210791d45577$var$MachineInput.fromUTF16(s), 0, $f8c5210791d45577$var$RE2Flags.UNANCHORED, 2);
                if (a === null) return "";
                return s.substring(a[0], a[1]);
            }
        },
        {
            /**
	* Returns a two-element array of integers defining the location of the leftmost match in
	* {@code s} of this regular expression. The match itself is at
	* {@code s.substring(loc[0], loc[1])}.
	*
	* A return value of null indicates no match.
	*/ key: "findIndex",
            value: function findIndex(s) {
                return this.executeEngine($f8c5210791d45577$var$MachineInput.fromUTF16(s), 0, $f8c5210791d45577$var$RE2Flags.UNANCHORED, 2);
            }
        },
        {
            /**
	* Returns an array of arrays the text of the leftmost match of the regular expression in
	* {@code b} and the matches, if any, of its subexpressions, as defined by the <a
	* href='#submatch'>Submatch</a> description above.
	*
	* A return value of null indicates no match.
	*/ key: "findUTF8Submatch",
            value: function findUTF8Submatch(b) {
                var a = this.executeEngine($f8c5210791d45577$var$MachineInput.fromUTF8(b), 0, $f8c5210791d45577$var$RE2Flags.UNANCHORED, this.prog.numCap);
                if (a === null) return null;
                var ret = new Array(1 + this.numSubexp).fill(null);
                for(var i = 0; i < ret.length; i++)if (2 * i < a.length && a[2 * i] >= 0) ret[i] = b.slice(a[2 * i], a[2 * i + 1]);
                return ret;
            }
        },
        {
            /**
	* Returns an array holding the index pairs identifying the leftmost match of this regular
	* expression in {@code b} and the matches, if any, of its subexpressions, as defined by the the
	* <a href='#submatch'>Submatch</a> and <a href='#index'>Index</a> descriptions above.
	*
	* A return value of null indicates no match.
	*/ key: "findUTF8SubmatchIndex",
            value: function findUTF8SubmatchIndex(b) {
                return this.pad(this.executeEngine($f8c5210791d45577$var$MachineInput.fromUTF8(b), 0, $f8c5210791d45577$var$RE2Flags.UNANCHORED, this.prog.numCap));
            }
        },
        {
            /**
	* Returns an array of strings holding the text of the leftmost match of the regular expression in
	* {@code s} and the matches, if any, of its subexpressions, as defined by the <a
	* href='#submatch'>Submatch</a> description above.
	*
	* A return value of null indicates no match.
	*/ key: "findSubmatch",
            value: function findSubmatch(s) {
                var a = this.executeEngine($f8c5210791d45577$var$MachineInput.fromUTF16(s), 0, $f8c5210791d45577$var$RE2Flags.UNANCHORED, this.prog.numCap);
                if (a === null) return null;
                var ret = new Array(1 + this.numSubexp).fill(null);
                for(var i = 0; i < ret.length; i++)if (2 * i < a.length && a[2 * i] >= 0) ret[i] = s.substring(a[2 * i], a[2 * i + 1]);
                return ret;
            }
        },
        {
            /**
	* Returns an array holding the index pairs identifying the leftmost match of this regular
	* expression in {@code s} and the matches, if any, of its subexpressions, as defined by the <a
	* href='#submatch'>Submatch</a> description above.
	*
	* A return value of null indicates no match.
	*/ key: "findSubmatchIndex",
            value: function findSubmatchIndex(s) {
                return this.pad(this.executeEngine($f8c5210791d45577$var$MachineInput.fromUTF16(s), 0, $f8c5210791d45577$var$RE2Flags.UNANCHORED, this.prog.numCap));
            }
        },
        {
            /**
	* {@code findAllUTF8()} is the <a href='#all'>All</a> version of {@link #findUTF8}; it returns a
	* list of up to {@code n} successive matches of the expression, as defined by the <a
	* href='#all'>All</a> description above.
	*
	* A return value of null indicates no match.
	*
	* TODO(adonovan): think about defining a byte slice view class, like a read-only Go slice backed
	* by |b|.
	*/ key: "findAllUTF8",
            value: function findAllUTF8(b, n) {
                var result = this.allMatches($f8c5210791d45577$var$MachineInput.fromUTF8(b), n, function(match) {
                    return b.slice(match[0], match[1]);
                });
                if (result.length === 0) return null;
                return result;
            }
        },
        {
            /**
	* {@code findAllUTF8Index} is the <a href='#all'>All</a> version of {@link #findUTF8Index}; it
	* returns a list of up to {@code n} successive matches of the expression, as defined by the <a
	* href='#all'>All</a> description above.
	*
	* A return value of null indicates no match.
	*/ key: "findAllUTF8Index",
            value: function findAllUTF8Index(b, n) {
                var result = this.allMatches($f8c5210791d45577$var$MachineInput.fromUTF8(b), n, function(match) {
                    return match.slice(0, 2);
                });
                if (result.length === 0) return null;
                return result;
            }
        },
        {
            /**
	* {@code findAll} is the <a href='#all'>All</a> version of {@link #find}; it returns a list of up
	* to {@code n} successive matches of the expression, as defined by the <a href='#all'>All</a>
	* description above.
	*
	* A return value of null indicates no match.
	*/ key: "findAll",
            value: function findAll(s, n) {
                var result = this.allMatches($f8c5210791d45577$var$MachineInput.fromUTF16(s), n, function(match) {
                    return s.substring(match[0], match[1]);
                });
                if (result.length === 0) return null;
                return result;
            }
        },
        {
            /**
	* {@code findAllIndex} is the <a href='#all'>All</a> version of {@link #findIndex}; it returns a
	* list of up to {@code n} successive matches of the expression, as defined by the <a
	* href='#all'>All</a> description above.
	*
	* A return value of null indicates no match.
	*/ key: "findAllIndex",
            value: function findAllIndex(s, n) {
                var result = this.allMatches($f8c5210791d45577$var$MachineInput.fromUTF16(s), n, function(match) {
                    return match.slice(0, 2);
                });
                if (result.length === 0) return null;
                return result;
            }
        },
        {
            /**
	* {@code findAllUTF8Submatch} is the <a href='#all'>All</a> version of {@link #findUTF8Submatch};
	* it returns a list of up to {@code n} successive matches of the expression, as defined by the <a
	* href='#all'>All</a> description above.
	*
	* A return value of null indicates no match.
	*/ key: "findAllUTF8Submatch",
            value: function findAllUTF8Submatch(b, n) {
                var result = this.allMatches($f8c5210791d45577$var$MachineInput.fromUTF8(b), n, function(match) {
                    var slice = new Array(match.length / 2 | 0).fill(null);
                    for(var j = 0; j < slice.length; j++)if (match[2 * j] >= 0) slice[j] = b.slice(match[2 * j], match[2 * j + 1]);
                    return slice;
                });
                if (result.length === 0) return null;
                return result;
            }
        },
        {
            /**
	* {@code findAllUTF8SubmatchIndex} is the <a href='#all'>All</a> version of
	* {@link #findUTF8SubmatchIndex}; it returns a list of up to {@code n} successive matches of the
	* expression, as defined by the <a href='#all'>All</a> description above.
	*
	* A return value of null indicates no match.
	*/ key: "findAllUTF8SubmatchIndex",
            value: function findAllUTF8SubmatchIndex(b, n) {
                var result = this.allMatches($f8c5210791d45577$var$MachineInput.fromUTF8(b), n);
                if (result.length === 0) return null;
                return result;
            }
        },
        {
            /**
	* {@code findAllSubmatch} is the <a href='#all'>All</a> version of {@link #findSubmatch}; it
	* returns a list of up to {@code n} successive matches of the expression, as defined by the <a
	* href='#all'>All</a> description above.
	*
	* A return value of null indicates no match.
	*/ key: "findAllSubmatch",
            value: function findAllSubmatch(s, n) {
                var result = this.allMatches($f8c5210791d45577$var$MachineInput.fromUTF16(s), n, function(match) {
                    var slice = new Array(match.length / 2 | 0).fill(null);
                    for(var j = 0; j < slice.length; j++)if (match[2 * j] >= 0) slice[j] = s.substring(match[2 * j], match[2 * j + 1]);
                    return slice;
                });
                if (result.length === 0) return null;
                return result;
            }
        },
        {
            /**
	* {@code findAllSubmatchIndex} is the <a href='#all'>All</a> version of
	* {@link #findSubmatchIndex}; it returns a list of up to {@code n} successive matches of the
	* expression, as defined by the <a href='#all'>All</a> description above.
	*
	* A return value of null indicates no match.
	*/ key: "findAllSubmatchIndex",
            value: function findAllSubmatchIndex(s, n) {
                var result = this.allMatches($f8c5210791d45577$var$MachineInput.fromUTF16(s), n);
                if (result.length === 0) return null;
                return result;
            }
        }
    ], [
        {
            key: "initTest",
            value: function initTest(expr) {
                var re2 = RE2.compile(expr);
                var res = new RE2(re2.expr, re2.prog, re2.numSubexp, re2.longest);
                res.cond = re2.cond;
                res.prefix = re2.prefix;
                res.prefixUTF8 = re2.prefixUTF8;
                res.prefixComplete = re2.prefixComplete;
                res.prefixRune = re2.prefixRune;
                res.prefilter = re2.prefilter;
                return res;
            }
        },
        {
            key: "compile",
            value: /**
	* Parses a regular expression and returns, if successful, an {@code RE2} instance that can be
	* used to match against text.
	*
	* When matching against text, the regexp returns a match that begins as early as possible in the
	* input (leftmost), and among those it chooses the one that a backtracking search would have
	* found first. This so-called leftmost-first matching is the same semantics that Perl, Python,
	* and other implementations use, although this package implements it without the expense of
	* backtracking. For POSIX leftmost-longest matching, see {@link #compilePOSIX}.
	*/ function compile(expr) {
                return RE2.compileImpl(expr, $f8c5210791d45577$var$RE2Flags.PERL, false);
            }
        },
        {
            key: "compilePOSIX",
            value: /**
	* {@code compilePOSIX} is like {@link #compile} but restricts the regular expression to POSIX ERE
	* (egrep) syntax and changes the match semantics to leftmost-longest.
	*
	* That is, when matching against text, the regexp returns a match that begins as early as
	* possible in the input (leftmost), and among those it chooses a match that is as long as
	* possible. This so-called leftmost-longest matching is the same semantics that early regular
	* expression implementations used and that POSIX specifies.
	*
	* However, there can be multiple leftmost-longest matches, with different submatch choices, and
	* here this package diverges from POSIX. Among the possible leftmost-longest matches, this
	* package chooses the one that a backtracking search would have found first, while POSIX
	* specifies that the match be chosen to maximize the length of the first subexpression, then the
	* second, and so on from left to right. The POSIX rule is computationally prohibitive and not
	* even well-defined. See http://swtch.com/~rsc/regexp/regexp2.html#posix
	*/ function compilePOSIX(expr) {
                return RE2.compileImpl(expr, $f8c5210791d45577$var$RE2Flags.POSIX, true);
            }
        },
        {
            key: "compileImpl",
            value: function compileImpl(expr, mode, longest) {
                var re = $f8c5210791d45577$var$Parser.parse(expr, mode);
                var maxCap = re.maxCap();
                re = $f8c5210791d45577$var$Simplify.simplify(re);
                var prefilter = $f8c5210791d45577$var$PrefilterTree.build(re);
                var prog = $f8c5210791d45577$var$Compiler.compileRegexp(re);
                var re2 = new RE2(expr, prog, maxCap, longest);
                re2.prefilter = prefilter.type === $f8c5210791d45577$var$Prefilter.Type.NONE ? null : prefilter;
                var _prog_prefix = (0, $6ZpBv._)(prog.prefix(), 2), prefixCompl = _prog_prefix[0], prefixStr = _prog_prefix[1];
                re2.prefixComplete = prefixCompl;
                re2.prefix = prefixStr;
                re2.prefixUTF8 = $f8c5210791d45577$var$Utils.stringToUtf8ByteArray(re2.prefix);
                if (re2.prefix.length > 0) re2.prefixRune = re2.prefix.codePointAt(0);
                re2.namedGroups = re.namedGroups;
                return re2;
            }
        },
        {
            key: "match",
            value: /**
	* Returns true iff textual regular expression {@code pattern} matches string {@code s}.
	*
	* More complicated queries need to use {@link #compile} and the full {@code RE2} interface.
	*/ function match(pattern, s) {
                return RE2.compile(pattern).match(s);
            }
        }
    ]);
    return RE2;
}();
//#endregion
//#region src/Set.js
var $f8c5210791d45577$export$a6524876738a3b9d = ($f8c5210791d45577$var$_RE2Set = /*#__PURE__*/ function() {
    "use strict";
    function RE2Set() {
        var anchor = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : RE2Set.UNANCHORED, flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, maxMem = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 8388608;
        (0, $4QweW._)(this, RE2Set);
        this.anchor = anchor;
        this.jsFlags = flags;
        this.maxMem = maxMem;
        var re2Flags = $f8c5210791d45577$var$RE2Flags.PERL;
        if ((flags & $f8c5210791d45577$var$PublicFlags.DISABLE_UNICODE_GROUPS) !== 0) re2Flags &= ~$f8c5210791d45577$var$RE2Flags.UNICODE_GROUPS;
        if ((flags & $f8c5210791d45577$var$PublicFlags.LOOKBEHINDS) !== 0) re2Flags |= $f8c5210791d45577$var$RE2Flags.LOOKBEHIND;
        this.re2Flags = re2Flags;
        this.regexps = [];
        this.prog = null;
        this.dfa = null;
        this.dummyRe2 = null;
    }
    (0, $6hK4i._)(RE2Set, [
        {
            /**
	* Adds a new regular expression pattern to the set.
	* Patterns cannot be added after the set has been compiled.
	* @param {string} pattern - The regular expression pattern to add.
	* @returns {number} The integer index assigned to the added pattern.
	* @throws {RE2JSCompileException} If patterns are added after compilation.
	*/ key: "add",
            value: function add(pattern) {
                if (this.prog) throw new $f8c5210791d45577$export$457eacef9ada3821("Cannot add patterns after compile");
                var fregex = pattern;
                if ((this.jsFlags & $f8c5210791d45577$var$PublicFlags.CASE_INSENSITIVE) !== 0) fregex = "(?i)".concat(fregex);
                if ((this.jsFlags & $f8c5210791d45577$var$PublicFlags.DOTALL) !== 0) fregex = "(?s)".concat(fregex);
                if ((this.jsFlags & $f8c5210791d45577$var$PublicFlags.MULTILINE) !== 0) fregex = "(?m)".concat(fregex);
                var re = $f8c5210791d45577$var$Parser.parse(fregex, this.re2Flags);
                this.regexps.push($f8c5210791d45577$var$Simplify.simplify(re));
                return this.regexps.length - 1;
            }
        },
        {
            /**
	* Compiles the added patterns into a single state machine.
	* This is automatically called on the first match if not called explicitly.
	* @returns {void}
	*/ key: "compile",
            value: function compile() {
                if (this.prog) return;
                this.prog = $f8c5210791d45577$var$Compiler.compileSet(this.regexps);
                this.dfa = new $f8c5210791d45577$var$DFA(this.prog, this.maxMem);
                this.dummyRe2 = {
                    prog: this.prog,
                    cond: this.prog.startCond(),
                    prefix: "",
                    prefixRune: 0,
                    longest: false
                };
            }
        },
        {
            /**
	* Matches the input against the compiled set of regular expressions.
	* @param {string|number[]|Uint8Array} input - The input string or UTF-8 byte array to match against.
	* @returns {number[]} An array of indices representing the patterns that successfully matched the input.
	*/ key: "match",
            value: function match(input) {
                if (!this.prog) this.compile();
                var machineInput = $f8c5210791d45577$var$Utils.isByteArray(input) ? $f8c5210791d45577$var$MachineInput.fromUTF8(input) : $f8c5210791d45577$var$MachineInput.fromUTF16(input);
                var internalAnchor = $f8c5210791d45577$var$RE2Flags.UNANCHORED;
                if (this.anchor === RE2Set.ANCHOR_START) internalAnchor = $f8c5210791d45577$var$RE2Flags.ANCHOR_START;
                else if (this.anchor === RE2Set.ANCHOR_BOTH) internalAnchor = $f8c5210791d45577$var$RE2Flags.ANCHOR_BOTH;
                var dfaResult = this.dfa.matchSet(machineInput, 0, internalAnchor);
                if (dfaResult !== null) return dfaResult;
                var machine = $f8c5210791d45577$var$Machine.fromRE2(this.dummyRe2);
                machine.init(0);
                return machine.matchSet(machineInput, 0, internalAnchor);
            }
        }
    ]);
    return RE2Set;
}(), /** @type {number} */ (0, $6tY97._)($f8c5210791d45577$var$_RE2Set, "UNANCHORED", $f8c5210791d45577$var$RE2Flags.UNANCHORED), /** @type {number} */ (0, $6tY97._)($f8c5210791d45577$var$_RE2Set, "ANCHOR_START", $f8c5210791d45577$var$RE2Flags.ANCHOR_START), /** @type {number} */ (0, $6tY97._)($f8c5210791d45577$var$_RE2Set, "ANCHOR_BOTH", $f8c5210791d45577$var$RE2Flags.ANCHOR_BOTH), $f8c5210791d45577$var$_RE2Set);
//#endregion
//#region src/TranslateRegExpString.js
/**
* Transform JS regex string to RE2 regex string
*/ var $f8c5210791d45577$var$TranslateRegExpString = /*#__PURE__*/ function() {
    "use strict";
    function TranslateRegExpString() {
        (0, $4QweW._)(this, TranslateRegExpString);
    }
    (0, $6hK4i._)(TranslateRegExpString, null, [
        {
            key: "isHexadecimal",
            value: function isHexadecimal(ch) {
                return "0" <= ch && ch <= "9" || "A" <= ch && ch <= "F" || "a" <= ch && ch <= "f";
            }
        },
        {
            key: "translate",
            value: function translate(data) {
                var prefixFlags = "";
                if (data instanceof RegExp) {
                    if (data.ignoreCase) prefixFlags += "i";
                    if (data.multiline) prefixFlags += "m";
                    if (data.dotAll) prefixFlags += "s";
                    data = data.source;
                }
                if (typeof data !== "string") return data;
                var result = "";
                var changed = false;
                var size = data.length;
                if (size === 0) {
                    result = "(?:)";
                    changed = true;
                }
                var inCharClass = false;
                var i = 0;
                while(i < size){
                    var ch = data[i];
                    if (ch === "\\") {
                        if (i + 1 < size) {
                            ch = data[i + 1];
                            switch(ch){
                                case "\\":
                                    result += "\\\\";
                                    i += 2;
                                    continue;
                                case "c":
                                    if (i + 2 < size) {
                                        var code = data[i + 2].charCodeAt(0);
                                        if (code >= 65 && code <= 90 || code >= 97 && code <= 122) {
                                            var val = code % 32;
                                            result += "\\x";
                                            result += (val >> 4).toString(16).toUpperCase();
                                            result += (val & 15).toString(16).toUpperCase();
                                            i += 3;
                                            changed = true;
                                            continue;
                                        }
                                    }
                                    result += "c";
                                    i += 2;
                                    changed = true;
                                    continue;
                                case "u":
                                    if (i + 2 < size) {
                                        if (data[i + 2] === "{") {
                                            var j = i + 3;
                                            var hasHex = false;
                                            var closed = false;
                                            while(j < size){
                                                var hexChar = data[j];
                                                if (hexChar === "}") {
                                                    closed = true;
                                                    break;
                                                }
                                                if (!TranslateRegExpString.isHexadecimal(hexChar)) break;
                                                hasHex = true;
                                                j++;
                                            }
                                            if (closed && hasHex) {
                                                result += "\\x";
                                                i += 2;
                                                changed = true;
                                                continue;
                                            }
                                        } else if (i + 5 < size) {
                                            var isHex4 = true;
                                            for(var j1 = 0; j1 < 4; j1++)if (!TranslateRegExpString.isHexadecimal(data[i + 2 + j1])) {
                                                isHex4 = false;
                                                break;
                                            }
                                            if (isHex4) {
                                                result += "\\x{" + data.substring(i + 2, i + 6) + "}";
                                                i += 6;
                                                changed = true;
                                                continue;
                                            }
                                        }
                                    }
                                    result += "u";
                                    i += 2;
                                    changed = true;
                                    continue;
                                case "x":
                                    {
                                        var isValidHex = false;
                                        if (i + 2 < size && data[i + 2] === "{") {
                                            var j2 = i + 3;
                                            var hasHex1 = false;
                                            var closed1 = false;
                                            while(j2 < size){
                                                var hexChar1 = data[j2];
                                                if (hexChar1 === "}") {
                                                    closed1 = true;
                                                    break;
                                                }
                                                if (!TranslateRegExpString.isHexadecimal(hexChar1)) break;
                                                hasHex1 = true;
                                                j2++;
                                            }
                                            if (closed1 && hasHex1) isValidHex = true;
                                        } else if (i + 3 < size && TranslateRegExpString.isHexadecimal(data[i + 2]) && TranslateRegExpString.isHexadecimal(data[i + 3])) isValidHex = true;
                                        if (isValidHex) {
                                            result += "\\x";
                                            i += 2;
                                        } else {
                                            result += "x";
                                            i += 2;
                                            changed = true;
                                        }
                                        continue;
                                    }
                                case "n":
                                case "r":
                                case "t":
                                case "a":
                                case "f":
                                case "v":
                                case "d":
                                case "D":
                                case "s":
                                case "S":
                                case "w":
                                case "W":
                                case "b":
                                case "B":
                                case "p":
                                case "P":
                                case "A":
                                case "z":
                                case "Q":
                                case "E":
                                case "0":
                                case "1":
                                case "2":
                                case "3":
                                case "4":
                                case "5":
                                case "6":
                                case "7":
                                    result += "\\" + ch;
                                    i += 2;
                                    continue;
                                default:
                                    {
                                        var cp = data.codePointAt(i + 1);
                                        if (cp >= 48 && cp <= 57 || cp >= 65 && cp <= 90 || cp >= 97 && cp <= 122) {
                                            var symSize = $f8c5210791d45577$var$Utils.charCount(cp);
                                            result += data.substring(i + 1, i + 1 + symSize);
                                            i += symSize + 1;
                                            changed = true;
                                        } else {
                                            result += "\\";
                                            var symSize1 = $f8c5210791d45577$var$Utils.charCount(cp);
                                            result += data.substring(i + 1, i + 1 + symSize1);
                                            i += symSize1 + 1;
                                        }
                                        continue;
                                    }
                            }
                        }
                    } else if (ch === "/") {
                        result += "\\/";
                        i += 1;
                        changed = true;
                        continue;
                    } else if (ch === "[") inCharClass = true;
                    else if (ch === "]") inCharClass = false;
                    else if (!inCharClass && ch === "(" && i + 2 < size && data[i + 1] === "?" && data[i + 2] === "<") {
                        if (i + 3 < size && !"=!>)".includes(data[i + 3])) {
                            result += "(?P<";
                            i += 3;
                            changed = true;
                            continue;
                        }
                    }
                    var cp1 = data.codePointAt(i);
                    var symSize2 = $f8c5210791d45577$var$Utils.charCount(cp1);
                    result += data.substring(i, i + symSize2);
                    i += symSize2;
                }
                var finalResult = changed ? result : data;
                if (prefixFlags.length > 0) return "(?".concat(prefixFlags, ")").concat(finalResult);
                return finalResult;
            }
        }
    ]);
    return TranslateRegExpString;
}();
//#endregion
//#region src/index.js
/**
* A compiled representation of an RE2 regular expression
*
* The matching functions take {@code String} arguments instead of the more general Java
* {@code CharSequence} since the latter doesn't provide UTF-16 decoding.
*
*
* @author rsc@google.com (Russ Cox)
* @class
*/ var $f8c5210791d45577$export$e46efc5f33420715 = ($f8c5210791d45577$var$_RE2JS = /*#__PURE__*/ function() {
    "use strict";
    function RE2JS(pattern, flags) {
        (0, $4QweW._)(this, RE2JS);
        this.patternInput = pattern;
        this.flagsInput = flags;
        /** @type {import('./RE2.js').RE2} */ this.re2Input = null;
    }
    (0, $6hK4i._)(RE2JS, [
        {
            /**
	* Releases memory used by internal caches associated with this pattern. Does not change the
	* observable behaviour. Useful for tests that detect memory leaks via allocation tracking.
	*/ key: "reset",
            value: function reset() {
                this.re2Input.reset();
            }
        },
        {
            /**
	* Returns the flags used in the constructor.
	* @returns {number}
	*/ key: "flags",
            value: function flags() {
                return this.flagsInput;
            }
        },
        {
            /**
	* Returns the pattern used in the constructor.
	* @returns {string}
	*/ key: "pattern",
            value: function pattern() {
                return this.patternInput;
            }
        },
        {
            key: "re2",
            value: function re2() {
                return this.re2Input;
            }
        },
        {
            /**
	* Matches a string against a regular expression.
	*
	* @param {string|number[]|Uint8Array} input the input
	* @returns {boolean} true if the regular expression matches the entire input
	*/ key: "matches",
            value: function matches(input) {
                return this.testExact(input);
            }
        },
        {
            /**
	* Creates a new {@code Matcher} matching the pattern against the input.
	*
	* @param {string|number[]|Uint8Array|MatcherInputBase} input the input string
	* @returns {Matcher}
	*/ key: "matcher",
            value: function matcher(input) {
                if ($f8c5210791d45577$var$Utils.isByteArray(input)) input = $f8c5210791d45577$export$3430ac14b3833fca.utf8(input);
                return new $f8c5210791d45577$export$20214574ec94167d(this, input);
            }
        },
        {
            /**
	* Tests whether the regular expression matches any part of the input string.
	* Performance Note: This method is highly optimized. Because it only returns
	* a boolean and does not extract capture groups, it bypasses the `Matcher` overhead
	* and guarantees execution on the high-speed DFA engine whenever possible.
	*
	* @param {string|number[]|Uint8Array} input - The input string or UTF-8 byte array to test against.
	* @returns {boolean} `true` if the pattern is found anywhere in the input, `false` otherwise.
	*/ key: "test",
            value: function test(input) {
                if ($f8c5210791d45577$var$Utils.isByteArray(input)) return this.re2Input.matchUTF8(input);
                return this.re2Input.match(input);
            }
        },
        {
            /**
	* Tests whether the regular expression matches the ENTIRE input string.
	* * **Performance Note:** This operates identically to `.matches()`, but is significantly
	* faster because it does not request capture group data. By requesting 0 capture groups,
	* it securely routes execution through the DFA fast-path.
	*
	* @param {string|number[]|Uint8Array} input - The input string or UTF-8 byte array to test against.
	* @returns {boolean} `true` if the exact input string fully matches the pattern, `false` otherwise.
	*/ key: "testExact",
            value: function testExact(input) {
                var machineInput = $f8c5210791d45577$var$Utils.isByteArray(input) ? $f8c5210791d45577$var$MachineInput.fromUTF8(input) : $f8c5210791d45577$var$MachineInput.fromUTF16(input);
                return this.re2Input.executeEngine(machineInput, 0, $f8c5210791d45577$var$RE2Flags.ANCHOR_BOTH, 0) !== null;
            }
        },
        {
            /**
	* Executes a search for a match in a specified string.
	* Returns a result array, or null if no match is found.
	* The returned array perfectly mirrors standard JavaScript `RegExpExecArray`,
	* including `.index`, `.input`, and `.groups` properties.
	*
	* @param {string|number[]|Uint8Array} input the input string or byte array
	* @returns {Array|null} the match array with index, input, and groups properties, or null
	*/ key: "exec",
            value: function exec(input) {
                var m = this.matcher(input);
                if (!m.find()) return null;
                var result = [
                    m.group(0)
                ];
                for(var i = 1; i <= m.groupCount(); i++){
                    var val = m.group(i);
                    result.push(val === null ? void 0 : val);
                }
                result.index = m.start(0);
                result.input = input;
                var namedGroups = this.namedGroups();
                if (Object.keys(namedGroups).length > 0) {
                    var parsedGroups = m.getNamedGroups();
                    for(var key in parsedGroups)if (parsedGroups[key] === null) parsedGroups[key] = void 0;
                    result.groups = parsedGroups;
                } else result.groups = void 0;
                return result;
            }
        },
        {
            /**
	* Splits input around instances of the regular expression. It returns an array giving the strings
	* that occur before, between, and after instances of the regular expression.
	*
	* If {@code limit <= 0}, there is no limit on the size of the returned array. If
	* {@code limit == 0}, empty strings that would occur at the end of the array are omitted. If
	* {@code limit > 0}, at most limit strings are returned. The final string contains the remainder
	* of the input, possibly including additional matches of the pattern.
	*
	* @param {string} input the input string to be split
	* @param {number} [limit=0] the limit
	* @returns {string[]} the split strings
	*/ key: "split",
            value: function split(input) {
                var limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var m = this.matcher(input);
                var result = [];
                var emptiesSkipped = 0;
                var last = 0;
                while(m.find()){
                    if (last === 0 && m.end() === 0) {
                        last = m.end();
                        continue;
                    }
                    if (limit > 0 && result.length === limit - 1) break;
                    if (last === m.start()) {
                        if (limit === 0) {
                            emptiesSkipped += 1;
                            last = m.end();
                            continue;
                        }
                    } else while(emptiesSkipped > 0){
                        result.push("");
                        emptiesSkipped -= 1;
                    }
                    result.push(m.substring(last, m.start()));
                    last = m.end();
                }
                if (limit === 0 && last !== m.inputLength()) {
                    while(emptiesSkipped > 0){
                        result.push("");
                        emptiesSkipped -= 1;
                    }
                    result.push(m.substring(last, m.inputLength()));
                }
                if (limit !== 0 || result.length === 0 && !(last === m.inputLength() && last > 0)) result.push(m.substring(last, m.inputLength()));
                return result;
            }
        },
        {
            key: "matchAll",
            value: /**
	* Returns an iterator of all results matching a string against the regular expression,
	* including capturing groups.
	*
	* @param {string|number[]|Uint8Array} input the input string or byte array
	* @returns {IterableIterator<RegExpMatchArray>}
	*/ function matchAll(input) {
                var m, result, i, groupVal, namedGroups, parsedGroups, key;
                return (0, $gh3Df._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            m = this.matcher(input);
                            _state.label = 1;
                        case 1:
                            if (!m.find()) return [
                                3,
                                3
                            ];
                            result = [
                                m.group(0)
                            ];
                            for(i = 1; i <= m.groupCount(); i++){
                                groupVal = m.group(i);
                                result.push(groupVal === null ? void 0 : groupVal);
                            }
                            result.index = m.start(0);
                            result.input = input;
                            namedGroups = this.namedGroups();
                            if (Object.keys(namedGroups).length > 0) {
                                parsedGroups = m.getNamedGroups();
                                for(var key in parsedGroups)if (parsedGroups[key] === null) parsedGroups[key] = void 0;
                                result.groups = parsedGroups;
                            } else result.groups = void 0;
                            return [
                                4,
                                result
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                1
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            /**
	*
	* @returns {string}
	*/ key: "toString",
            value: function toString() {
                return this.patternInput;
            }
        },
        {
            /**
	* Returns the program size of this pattern.
	*
	* <p>
	* Similar to the C++ implementation, the program size is a very approximate measure of a regexp's
	* "cost". Larger numbers are more expensive than smaller numbers.
	* </p>
	*
	* @returns {number} the program size of this pattern
	*/ key: "programSize",
            value: function programSize() {
                return this.re2Input.numberOfInstructions();
            }
        },
        {
            /**
	* Returns the number of capturing groups in this matcher's pattern. Group zero denotes the entire
	* pattern and is excluded from this count.
	*
	* @returns {number} the number of capturing groups in this pattern
	*/ key: "groupCount",
            value: function groupCount() {
                return this.re2Input.numberOfCapturingGroups();
            }
        },
        {
            /**
	* Return a map of the capturing groups in this matcher's pattern, where key is the name and value
	* is the index of the group in the pattern.
	* @returns {Record<string, number>}
	*/ key: "namedGroups",
            value: function namedGroups() {
                return this.re2Input.namedGroups;
            }
        },
        {
            /**
	*
	* @param {*} other
	* @returns {boolean}
	*/ key: "equals",
            value: function equals(other) {
                if (this === other) return true;
                if (other === null || this.constructor !== other.constructor) return false;
                return this.flagsInput === other.flagsInput && this.patternInput === other.patternInput;
            }
        }
    ], [
        {
            key: "quote",
            value: /**
	* Returns a literal pattern string for the specified string.
	*
	* This method produces a string that can be used to create a <code>RE2JS</code> that would
	* match the string <code>s</code> as if it were a literal pattern.
	*
	* Metacharacters or escape sequences in the input sequence will be given no special meaning.
	*
	* @param {string} str The string to be literalized
	* @returns {string} A literal string replacement
	*/ function quote(str) {
                return $f8c5210791d45577$var$Utils.quoteMeta(str);
            }
        },
        {
            key: "quoteReplacement",
            value: /**
	* Quotes '\' and '$' in {@code str}, so that the returned string could be used in
	* replacement methods as a literal replacement of {@code str}.
	*
	* This is a convenience delegation to {@link Matcher.quoteReplacement}.
	*
	* @param {string} str the string to be quoted
	* @param {boolean} [javaMode=false] whether the replacement will be used in javaMode
	* @returns {string} the quoted string
	*/ function quoteReplacement(str) {
                var javaMode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                return $f8c5210791d45577$export$20214574ec94167d.quoteReplacement(str, javaMode);
            }
        },
        {
            key: "translateRegExp",
            value: /**
	* Translates a given regular expression string to ensure compatibility with RE2JS.
	*
	* This function preprocesses the input regex string by applying necessary transformations,
	* such as escaping special characters (e.g., `/`), converting named capture groups to
	* RE2JS-compatible syntax, and handling Unicode sequences properly. It ensures that the
	* resulting regex is safe and properly formatted before compilation.
	*
	* @param {string|RegExp} expr - The regular expression string to be translated.
	* @returns {string} - The transformed regular expression string, ready for compilation.
	*/ function translateRegExp(expr) {
                return $f8c5210791d45577$var$TranslateRegExpString.translate(expr);
            }
        },
        {
            key: "compile",
            value: /**
	* Helper: create new RE2JS with given regex and flags. Flregex is the regex with flags applied.
	* @param {string} regex
	* @param {number} [flags=0]
	* @returns {RE2JS}
	*/ function compile(regex) {
                var flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var fregex = regex;
                if ((flags & RE2JS.CASE_INSENSITIVE) !== 0) fregex = "(?i)".concat(fregex);
                if ((flags & RE2JS.DOTALL) !== 0) fregex = "(?s)".concat(fregex);
                if ((flags & RE2JS.MULTILINE) !== 0) fregex = "(?m)".concat(fregex);
                if ((flags & ~(RE2JS.MULTILINE | RE2JS.DOTALL | RE2JS.CASE_INSENSITIVE | RE2JS.DISABLE_UNICODE_GROUPS | RE2JS.LONGEST_MATCH | RE2JS.LOOKBEHINDS)) !== 0) throw new $f8c5210791d45577$export$fa1c64d63b2c22b1("Flags should only be a combination of MULTILINE, DOTALL, CASE_INSENSITIVE, DISABLE_UNICODE_GROUPS, LONGEST_MATCH, LOOKBEHINDS");
                var re2Flags = $f8c5210791d45577$var$RE2Flags.PERL;
                if ((flags & RE2JS.DISABLE_UNICODE_GROUPS) !== 0) re2Flags &= ~$f8c5210791d45577$var$RE2Flags.UNICODE_GROUPS;
                if ((flags & RE2JS.LOOKBEHINDS) !== 0) re2Flags |= $f8c5210791d45577$var$RE2Flags.LOOKBEHIND;
                var p = new RE2JS(regex, flags);
                p.re2Input = $f8c5210791d45577$var$RE2.compileImpl(fregex, re2Flags, (flags & RE2JS.LONGEST_MATCH) !== 0);
                return p;
            }
        },
        {
            key: "matches",
            value: /**
	* Matches a string against a regular expression.
	*
	* @param {string} regex the regular expression
	* @param {string|number[]|Uint8Array} input the input
	* @returns {boolean} true if the regular expression matches the entire input
	* @throws RE2JSSyntaxException if the regular expression is malformed
	*/ function matches(regex, input) {
                return RE2JS.compile(regex).testExact(input);
            }
        },
        {
            key: "initTest",
            value: /**
	* This is visible for testing.
	* @private
	*/ function initTest(pattern, flags, re2) {
                if (pattern == null) throw new Error("pattern is null");
                if (re2 == null) throw new Error("re2 is null");
                var p = new RE2JS(pattern, flags);
                p.re2Input = re2;
                return p;
            }
        }
    ]);
    return RE2JS;
}(), /**
	* Flag: case insensitive matching.
	*/ (0, $6tY97._)($f8c5210791d45577$var$_RE2JS, "CASE_INSENSITIVE", $f8c5210791d45577$var$PublicFlags.CASE_INSENSITIVE), /**
	* Flag: dot ({@code .}) matches all characters, including newline.
	*/ (0, $6tY97._)($f8c5210791d45577$var$_RE2JS, "DOTALL", $f8c5210791d45577$var$PublicFlags.DOTALL), /**
	* Flag: multiline matching: {@code ^} and {@code $} match at beginning and end of line, not just
	* beginning and end of input.
	*/ (0, $6tY97._)($f8c5210791d45577$var$_RE2JS, "MULTILINE", $f8c5210791d45577$var$PublicFlags.MULTILINE), /**
	* Flag: Unicode groups (e.g. {@code \p\ Greek\} ) will be syntax errors.
	*/ (0, $6tY97._)($f8c5210791d45577$var$_RE2JS, "DISABLE_UNICODE_GROUPS", $f8c5210791d45577$var$PublicFlags.DISABLE_UNICODE_GROUPS), /**
	* Flag: matches longest possible string.
	*/ (0, $6tY97._)($f8c5210791d45577$var$_RE2JS, "LONGEST_MATCH", $f8c5210791d45577$var$PublicFlags.LONGEST_MATCH), /**
	* Flag: enable linear-time captureless lookbehinds.
	*/ (0, $6tY97._)($f8c5210791d45577$var$_RE2JS, "LOOKBEHINDS", $f8c5210791d45577$var$PublicFlags.LOOKBEHINDS), $f8c5210791d45577$var$_RE2JS);
/**
* Creates an RE2JS regex directly from a template literal.
* @overload
* @param {TemplateStringsArray} stringsOrFlags - The raw string segments of the template literal.
* @param {...any} values - The interpolated values.
* @returns {RE2JS}
*/ /**
* Creates a template literal tag function with specific RE2JS flags.
* @overload
* @param {number} stringsOrFlags - The RE2JS flags to apply (e.g., RE2JS.CASE_INSENSITIVE).
* @returns {(strings: TemplateStringsArray, ...tagValues: any[]) => RE2JS}
*/ /**
* Implementation signature
* @param {TemplateStringsArray | number} stringsOrFlags
* @param {...any} values
* @returns {RE2JS | ((strings: TemplateStringsArray, ...tagValues: any[]) => RE2JS)}
*/ var $f8c5210791d45577$export$b1f1627d659a651 = function(stringsOrFlags) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        values[_key - 1] = arguments[_key];
    }
    if (Array.isArray(stringsOrFlags) && "raw" in stringsOrFlags) {
        var _String;
        var pattern = (_String = String).raw.apply(_String, [
            stringsOrFlags
        ].concat((0, $jlUaU._)(values)));
        return $f8c5210791d45577$export$e46efc5f33420715.compile(pattern);
    }
    var flags = typeof stringsOrFlags === "number" ? stringsOrFlags : 0;
    return function(strings) {
        for(var _len = arguments.length, tagValues = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            tagValues[_key - 1] = arguments[_key];
        }
        var _String;
        var pattern = (_String = String).raw.apply(_String, [
            strings
        ].concat((0, $jlUaU._)(tagValues)));
        return $f8c5210791d45577$export$e46efc5f33420715.compile(pattern, flags);
    };
};

});

parcelRegister("3QAQu", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $2cd2cf383169a3ab$export$a143d493d941bafc; }, function (v) { return $2cd2cf383169a3ab$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $2cd2cf383169a3ab$export$f99ded8fe4b79145; }, function (v) { return $2cd2cf383169a3ab$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $c2MhV = parcelRequire("c2MhV");

var $5djcY = parcelRequire("5djcY");
var $2cd2cf383169a3ab$export$a143d493d941bafc;
var $2cd2cf383169a3ab$export$e4cf37d7f6fb9e0a;
var $2cd2cf383169a3ab$export$f99ded8fe4b79145;
var $2cd2cf383169a3ab$export$599f31c3813fae4d;
'use strict';

var $5jr4l = parcelRequire("5jr4l");

var $dwsc2 = parcelRequire("dwsc2");
var $2cd2cf383169a3ab$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$2cd2cf383169a3ab$export$a143d493d941bafc = $2cd2cf383169a3ab$var$Buffer;
$2cd2cf383169a3ab$export$e4cf37d7f6fb9e0a = $2cd2cf383169a3ab$var$SlowBuffer;
$2cd2cf383169a3ab$export$f99ded8fe4b79145 = 50;
var $2cd2cf383169a3ab$var$K_MAX_LENGTH = 0x7fffffff;
$2cd2cf383169a3ab$export$599f31c3813fae4d = $2cd2cf383169a3ab$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $2cd2cf383169a3ab$var$Buffer.TYPED_ARRAY_SUPPORT = $2cd2cf383169a3ab$var$typedArraySupport();
if (!$2cd2cf383169a3ab$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $2cd2cf383169a3ab$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($2cd2cf383169a3ab$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$2cd2cf383169a3ab$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($2cd2cf383169a3ab$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$2cd2cf383169a3ab$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $2cd2cf383169a3ab$var$createBuffer(length) {
    if (length > $2cd2cf383169a3ab$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $2cd2cf383169a3ab$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $2cd2cf383169a3ab$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $2cd2cf383169a3ab$var$allocUnsafe(arg);
    }
    return $2cd2cf383169a3ab$var$from(arg, encodingOrOffset, length);
}
$2cd2cf383169a3ab$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $2cd2cf383169a3ab$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $2cd2cf383169a3ab$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $2cd2cf383169a3ab$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $5djcY._)(value)));
    if ($2cd2cf383169a3ab$var$isInstance(value, ArrayBuffer) || value && $2cd2cf383169a3ab$var$isInstance(value.buffer, ArrayBuffer)) return $2cd2cf383169a3ab$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($2cd2cf383169a3ab$var$isInstance(value, SharedArrayBuffer) || value && $2cd2cf383169a3ab$var$isInstance(value.buffer, SharedArrayBuffer))) return $2cd2cf383169a3ab$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $2cd2cf383169a3ab$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $2cd2cf383169a3ab$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $2cd2cf383169a3ab$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $5djcY._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $2cd2cf383169a3ab$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $2cd2cf383169a3ab$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($2cd2cf383169a3ab$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($2cd2cf383169a3ab$var$Buffer, Uint8Array);
function $2cd2cf383169a3ab$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $2cd2cf383169a3ab$var$alloc(size, fill, encoding) {
    $2cd2cf383169a3ab$var$assertSize(size);
    if (size <= 0) return $2cd2cf383169a3ab$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $2cd2cf383169a3ab$var$createBuffer(size).fill(fill, encoding) : $2cd2cf383169a3ab$var$createBuffer(size).fill(fill);
    return $2cd2cf383169a3ab$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $2cd2cf383169a3ab$var$Buffer.alloc = function(size, fill, encoding) {
    return $2cd2cf383169a3ab$var$alloc(size, fill, encoding);
};
function $2cd2cf383169a3ab$var$allocUnsafe(size) {
    $2cd2cf383169a3ab$var$assertSize(size);
    return $2cd2cf383169a3ab$var$createBuffer(size < 0 ? 0 : $2cd2cf383169a3ab$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $2cd2cf383169a3ab$var$Buffer.allocUnsafe = function(size) {
    return $2cd2cf383169a3ab$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $2cd2cf383169a3ab$var$Buffer.allocUnsafeSlow = function(size) {
    return $2cd2cf383169a3ab$var$allocUnsafe(size);
};
function $2cd2cf383169a3ab$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$2cd2cf383169a3ab$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $2cd2cf383169a3ab$var$byteLength(string, encoding) | 0;
    var buf = $2cd2cf383169a3ab$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $2cd2cf383169a3ab$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $2cd2cf383169a3ab$var$checked(array.length) | 0;
    var buf = $2cd2cf383169a3ab$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $2cd2cf383169a3ab$var$fromArrayView(arrayView) {
    if ($2cd2cf383169a3ab$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $2cd2cf383169a3ab$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $2cd2cf383169a3ab$var$fromArrayLike(arrayView);
}
function $2cd2cf383169a3ab$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $2cd2cf383169a3ab$var$Buffer.prototype);
    return buf;
}
function $2cd2cf383169a3ab$var$fromObject(obj) {
    if ($2cd2cf383169a3ab$var$Buffer.isBuffer(obj)) {
        var len = $2cd2cf383169a3ab$var$checked(obj.length) | 0;
        var buf = $2cd2cf383169a3ab$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $2cd2cf383169a3ab$var$numberIsNaN(obj.length)) return $2cd2cf383169a3ab$var$createBuffer(0);
        return $2cd2cf383169a3ab$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $2cd2cf383169a3ab$var$fromArrayLike(obj.data);
}
function $2cd2cf383169a3ab$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $2cd2cf383169a3ab$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $2cd2cf383169a3ab$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $2cd2cf383169a3ab$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $2cd2cf383169a3ab$var$Buffer.alloc(+length);
}
$2cd2cf383169a3ab$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $2cd2cf383169a3ab$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$2cd2cf383169a3ab$var$Buffer.compare = function compare(a, b) {
    if ($2cd2cf383169a3ab$var$isInstance(a, Uint8Array)) a = $2cd2cf383169a3ab$var$Buffer.from(a, a.offset, a.byteLength);
    if ($2cd2cf383169a3ab$var$isInstance(b, Uint8Array)) b = $2cd2cf383169a3ab$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$2cd2cf383169a3ab$var$Buffer.isBuffer(a) || !$2cd2cf383169a3ab$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$2cd2cf383169a3ab$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$2cd2cf383169a3ab$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $2cd2cf383169a3ab$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $2cd2cf383169a3ab$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($2cd2cf383169a3ab$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$2cd2cf383169a3ab$var$Buffer.isBuffer(buf)) buf = $2cd2cf383169a3ab$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$2cd2cf383169a3ab$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $2cd2cf383169a3ab$var$byteLength(string, encoding) {
    if ($2cd2cf383169a3ab$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $2cd2cf383169a3ab$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $5djcY._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $2cd2cf383169a3ab$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $2cd2cf383169a3ab$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $2cd2cf383169a3ab$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$2cd2cf383169a3ab$var$Buffer.byteLength = $2cd2cf383169a3ab$var$byteLength;
function $2cd2cf383169a3ab$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $2cd2cf383169a3ab$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $2cd2cf383169a3ab$var$utf8Slice(this, start, end);
        case 'ascii':
            return $2cd2cf383169a3ab$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $2cd2cf383169a3ab$var$latin1Slice(this, start, end);
        case 'base64':
            return $2cd2cf383169a3ab$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $2cd2cf383169a3ab$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$2cd2cf383169a3ab$var$Buffer.prototype._isBuffer = true;
function $2cd2cf383169a3ab$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$2cd2cf383169a3ab$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$2cd2cf383169a3ab$var$swap(this, i, i + 1);
    return this;
};
$2cd2cf383169a3ab$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $2cd2cf383169a3ab$var$swap(this, i, i + 3);
        $2cd2cf383169a3ab$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$2cd2cf383169a3ab$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $2cd2cf383169a3ab$var$swap(this, i, i + 7);
        $2cd2cf383169a3ab$var$swap(this, i + 1, i + 6);
        $2cd2cf383169a3ab$var$swap(this, i + 2, i + 5);
        $2cd2cf383169a3ab$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$2cd2cf383169a3ab$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $2cd2cf383169a3ab$var$utf8Slice(this, 0, length);
    return $2cd2cf383169a3ab$var$slowToString.apply(this, arguments);
};
$2cd2cf383169a3ab$var$Buffer.prototype.toLocaleString = $2cd2cf383169a3ab$var$Buffer.prototype.toString;
$2cd2cf383169a3ab$var$Buffer.prototype.equals = function equals(b) {
    if (!$2cd2cf383169a3ab$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $2cd2cf383169a3ab$var$Buffer.compare(this, b) === 0;
};
$2cd2cf383169a3ab$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $2cd2cf383169a3ab$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($2cd2cf383169a3ab$var$customInspectSymbol) $2cd2cf383169a3ab$var$Buffer.prototype[$2cd2cf383169a3ab$var$customInspectSymbol] = $2cd2cf383169a3ab$var$Buffer.prototype.inspect;
$2cd2cf383169a3ab$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($2cd2cf383169a3ab$var$isInstance(target, Uint8Array)) target = $2cd2cf383169a3ab$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$2cd2cf383169a3ab$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $5djcY._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $2cd2cf383169a3ab$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($2cd2cf383169a3ab$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $2cd2cf383169a3ab$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($2cd2cf383169a3ab$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $2cd2cf383169a3ab$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $2cd2cf383169a3ab$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $2cd2cf383169a3ab$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$2cd2cf383169a3ab$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$2cd2cf383169a3ab$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $2cd2cf383169a3ab$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$2cd2cf383169a3ab$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $2cd2cf383169a3ab$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $2cd2cf383169a3ab$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($2cd2cf383169a3ab$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $2cd2cf383169a3ab$var$utf8Write(buf, string, offset, length) {
    return $2cd2cf383169a3ab$var$blitBuffer($2cd2cf383169a3ab$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $2cd2cf383169a3ab$var$asciiWrite(buf, string, offset, length) {
    return $2cd2cf383169a3ab$var$blitBuffer($2cd2cf383169a3ab$var$asciiToBytes(string), buf, offset, length);
}
function $2cd2cf383169a3ab$var$base64Write(buf, string, offset, length) {
    return $2cd2cf383169a3ab$var$blitBuffer($2cd2cf383169a3ab$var$base64ToBytes(string), buf, offset, length);
}
function $2cd2cf383169a3ab$var$ucs2Write(buf, string, offset, length) {
    return $2cd2cf383169a3ab$var$blitBuffer($2cd2cf383169a3ab$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$2cd2cf383169a3ab$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $2cd2cf383169a3ab$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $2cd2cf383169a3ab$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $2cd2cf383169a3ab$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $2cd2cf383169a3ab$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $2cd2cf383169a3ab$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$2cd2cf383169a3ab$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $2cd2cf383169a3ab$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $5jr4l.fromByteArray(buf);
    else return $5jr4l.fromByteArray(buf.slice(start, end));
}
function $2cd2cf383169a3ab$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $2cd2cf383169a3ab$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $2cd2cf383169a3ab$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $2cd2cf383169a3ab$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $2cd2cf383169a3ab$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $2cd2cf383169a3ab$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $2cd2cf383169a3ab$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $2cd2cf383169a3ab$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $2cd2cf383169a3ab$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $2cd2cf383169a3ab$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $2cd2cf383169a3ab$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$2cd2cf383169a3ab$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $2cd2cf383169a3ab$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $2cd2cf383169a3ab$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$2cd2cf383169a3ab$var$Buffer.prototype.readUintLE = $2cd2cf383169a3ab$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$2cd2cf383169a3ab$var$Buffer.prototype.readUintBE = $2cd2cf383169a3ab$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$2cd2cf383169a3ab$var$Buffer.prototype.readUint8 = $2cd2cf383169a3ab$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$2cd2cf383169a3ab$var$Buffer.prototype.readUint16LE = $2cd2cf383169a3ab$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$2cd2cf383169a3ab$var$Buffer.prototype.readUint16BE = $2cd2cf383169a3ab$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$2cd2cf383169a3ab$var$Buffer.prototype.readUint32LE = $2cd2cf383169a3ab$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$2cd2cf383169a3ab$var$Buffer.prototype.readUint32BE = $2cd2cf383169a3ab$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$2cd2cf383169a3ab$var$Buffer.prototype.readBigUInt64LE = $2cd2cf383169a3ab$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $2cd2cf383169a3ab$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $2cd2cf383169a3ab$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$2cd2cf383169a3ab$var$Buffer.prototype.readBigUInt64BE = $2cd2cf383169a3ab$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $2cd2cf383169a3ab$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $2cd2cf383169a3ab$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$2cd2cf383169a3ab$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$2cd2cf383169a3ab$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$2cd2cf383169a3ab$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$2cd2cf383169a3ab$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$2cd2cf383169a3ab$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$2cd2cf383169a3ab$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$2cd2cf383169a3ab$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$2cd2cf383169a3ab$var$Buffer.prototype.readBigInt64LE = $2cd2cf383169a3ab$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $2cd2cf383169a3ab$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $2cd2cf383169a3ab$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$2cd2cf383169a3ab$var$Buffer.prototype.readBigInt64BE = $2cd2cf383169a3ab$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $2cd2cf383169a3ab$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $2cd2cf383169a3ab$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$2cd2cf383169a3ab$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkOffset(offset, 4, this.length);
    return $dwsc2.read(this, offset, true, 23, 4);
};
$2cd2cf383169a3ab$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkOffset(offset, 4, this.length);
    return $dwsc2.read(this, offset, false, 23, 4);
};
$2cd2cf383169a3ab$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkOffset(offset, 8, this.length);
    return $dwsc2.read(this, offset, true, 52, 8);
};
$2cd2cf383169a3ab$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkOffset(offset, 8, this.length);
    return $dwsc2.read(this, offset, false, 52, 8);
};
function $2cd2cf383169a3ab$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$2cd2cf383169a3ab$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$2cd2cf383169a3ab$var$Buffer.prototype.writeUintLE = $2cd2cf383169a3ab$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $2cd2cf383169a3ab$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$2cd2cf383169a3ab$var$Buffer.prototype.writeUintBE = $2cd2cf383169a3ab$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $2cd2cf383169a3ab$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$2cd2cf383169a3ab$var$Buffer.prototype.writeUint8 = $2cd2cf383169a3ab$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$2cd2cf383169a3ab$var$Buffer.prototype.writeUint16LE = $2cd2cf383169a3ab$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$2cd2cf383169a3ab$var$Buffer.prototype.writeUint16BE = $2cd2cf383169a3ab$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$2cd2cf383169a3ab$var$Buffer.prototype.writeUint32LE = $2cd2cf383169a3ab$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$2cd2cf383169a3ab$var$Buffer.prototype.writeUint32BE = $2cd2cf383169a3ab$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $2cd2cf383169a3ab$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $2cd2cf383169a3ab$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $2cd2cf383169a3ab$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $2cd2cf383169a3ab$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$2cd2cf383169a3ab$var$Buffer.prototype.writeBigUInt64LE = $2cd2cf383169a3ab$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $2cd2cf383169a3ab$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$2cd2cf383169a3ab$var$Buffer.prototype.writeBigUInt64BE = $2cd2cf383169a3ab$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $2cd2cf383169a3ab$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$2cd2cf383169a3ab$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $2cd2cf383169a3ab$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$2cd2cf383169a3ab$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $2cd2cf383169a3ab$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$2cd2cf383169a3ab$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$2cd2cf383169a3ab$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$2cd2cf383169a3ab$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$2cd2cf383169a3ab$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$2cd2cf383169a3ab$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$2cd2cf383169a3ab$var$Buffer.prototype.writeBigInt64LE = $2cd2cf383169a3ab$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $2cd2cf383169a3ab$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$2cd2cf383169a3ab$var$Buffer.prototype.writeBigInt64BE = $2cd2cf383169a3ab$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $2cd2cf383169a3ab$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $2cd2cf383169a3ab$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $2cd2cf383169a3ab$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $dwsc2.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$2cd2cf383169a3ab$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $2cd2cf383169a3ab$var$writeFloat(this, value, offset, true, noAssert);
};
$2cd2cf383169a3ab$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $2cd2cf383169a3ab$var$writeFloat(this, value, offset, false, noAssert);
};
function $2cd2cf383169a3ab$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2cd2cf383169a3ab$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $dwsc2.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$2cd2cf383169a3ab$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $2cd2cf383169a3ab$var$writeDouble(this, value, offset, true, noAssert);
};
$2cd2cf383169a3ab$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $2cd2cf383169a3ab$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$2cd2cf383169a3ab$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$2cd2cf383169a3ab$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$2cd2cf383169a3ab$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$2cd2cf383169a3ab$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $2cd2cf383169a3ab$var$Buffer.isBuffer(val) ? val : $2cd2cf383169a3ab$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $2cd2cf383169a3ab$var$errors = {};
function $2cd2cf383169a3ab$var$E(sym, getMessage, Base) {
    $2cd2cf383169a3ab$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $c2MhV._)(NodeError, Base);
        function NodeError() {
            (0, $4QweW._)(this, NodeError);
            var _this;
            _this = (0, $ehF45._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $6hK4i._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$2cd2cf383169a3ab$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$2cd2cf383169a3ab$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $5djcY._)(actual));
}, TypeError);
$2cd2cf383169a3ab$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $2cd2cf383169a3ab$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $5djcY._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $2cd2cf383169a3ab$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $2cd2cf383169a3ab$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $2cd2cf383169a3ab$var$checkBounds(buf, offset, byteLength) {
    $2cd2cf383169a3ab$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $2cd2cf383169a3ab$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $2cd2cf383169a3ab$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $5djcY._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $2cd2cf383169a3ab$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $2cd2cf383169a3ab$var$checkBounds(buf, offset, byteLength);
}
function $2cd2cf383169a3ab$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $2cd2cf383169a3ab$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $2cd2cf383169a3ab$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $2cd2cf383169a3ab$var$validateNumber(value, type);
        throw new $2cd2cf383169a3ab$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $2cd2cf383169a3ab$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $2cd2cf383169a3ab$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $2cd2cf383169a3ab$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $2cd2cf383169a3ab$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($2cd2cf383169a3ab$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $2cd2cf383169a3ab$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $2cd2cf383169a3ab$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $2cd2cf383169a3ab$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $2cd2cf383169a3ab$var$base64ToBytes(str) {
    return $5jr4l.toByteArray($2cd2cf383169a3ab$var$base64clean(str));
}
function $2cd2cf383169a3ab$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $2cd2cf383169a3ab$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $2cd2cf383169a3ab$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $2cd2cf383169a3ab$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $2cd2cf383169a3ab$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $2cd2cf383169a3ab$var$BufferBigIntNotDefined : fn;
}
function $2cd2cf383169a3ab$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("5jr4l", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $3de3b973f0b0967f$export$d622b2ad8d90c771; }, function (v) { return $3de3b973f0b0967f$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $3de3b973f0b0967f$export$6100ba28696e12de; }, function (v) { return $3de3b973f0b0967f$export$6100ba28696e12de = v; });
var $3de3b973f0b0967f$export$a48f0734ac7c2329;
var $3de3b973f0b0967f$export$d622b2ad8d90c771;
var $3de3b973f0b0967f$export$6100ba28696e12de;
'use strict';
$3de3b973f0b0967f$export$a48f0734ac7c2329 = $3de3b973f0b0967f$var$byteLength;
$3de3b973f0b0967f$export$d622b2ad8d90c771 = $3de3b973f0b0967f$var$toByteArray;
$3de3b973f0b0967f$export$6100ba28696e12de = $3de3b973f0b0967f$var$fromByteArray;
var $3de3b973f0b0967f$var$lookup = [];
var $3de3b973f0b0967f$var$revLookup = [];
var $3de3b973f0b0967f$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $3de3b973f0b0967f$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $3de3b973f0b0967f$var$i = 0, $3de3b973f0b0967f$var$len = $3de3b973f0b0967f$var$code.length; $3de3b973f0b0967f$var$i < $3de3b973f0b0967f$var$len; ++$3de3b973f0b0967f$var$i){
    $3de3b973f0b0967f$var$lookup[$3de3b973f0b0967f$var$i] = $3de3b973f0b0967f$var$code[$3de3b973f0b0967f$var$i];
    $3de3b973f0b0967f$var$revLookup[$3de3b973f0b0967f$var$code.charCodeAt($3de3b973f0b0967f$var$i)] = $3de3b973f0b0967f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$3de3b973f0b0967f$var$revLookup['-'.charCodeAt(0)] = 62;
$3de3b973f0b0967f$var$revLookup['_'.charCodeAt(0)] = 63;
function $3de3b973f0b0967f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $3de3b973f0b0967f$var$byteLength(b64) {
    var lens = $3de3b973f0b0967f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3de3b973f0b0967f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3de3b973f0b0967f$var$toByteArray(b64) {
    var tmp;
    var lens = $3de3b973f0b0967f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $3de3b973f0b0967f$var$Arr($3de3b973f0b0967f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $3de3b973f0b0967f$var$revLookup[b64.charCodeAt(i)] << 18 | $3de3b973f0b0967f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $3de3b973f0b0967f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $3de3b973f0b0967f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $3de3b973f0b0967f$var$revLookup[b64.charCodeAt(i)] << 2 | $3de3b973f0b0967f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $3de3b973f0b0967f$var$revLookup[b64.charCodeAt(i)] << 10 | $3de3b973f0b0967f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $3de3b973f0b0967f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $3de3b973f0b0967f$var$tripletToBase64(num) {
    return $3de3b973f0b0967f$var$lookup[num >> 18 & 0x3F] + $3de3b973f0b0967f$var$lookup[num >> 12 & 0x3F] + $3de3b973f0b0967f$var$lookup[num >> 6 & 0x3F] + $3de3b973f0b0967f$var$lookup[num & 0x3F];
}
function $3de3b973f0b0967f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($3de3b973f0b0967f$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $3de3b973f0b0967f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($3de3b973f0b0967f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($3de3b973f0b0967f$var$lookup[tmp >> 2] + $3de3b973f0b0967f$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($3de3b973f0b0967f$var$lookup[tmp >> 10] + $3de3b973f0b0967f$var$lookup[tmp >> 4 & 0x3F] + $3de3b973f0b0967f$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("dwsc2", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $9d84221cb9dec3f8$export$aafa59e2e03f2942; }, function (v) { return $9d84221cb9dec3f8$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $9d84221cb9dec3f8$export$68d8715fc104d294; }, function (v) { return $9d84221cb9dec3f8$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $9d84221cb9dec3f8$export$aafa59e2e03f2942;
var $9d84221cb9dec3f8$export$68d8715fc104d294;
$9d84221cb9dec3f8$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$9d84221cb9dec3f8$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});




parcelRegister("1Ov0T", function(module, exports) {

$parcel$export(module.exports, "nanoid", function () { return $1522848e5ebf4e86$export$ac4959f4f1338dfc; });

var $cGY4w = parcelRequire("cGY4w");
var $1522848e5ebf4e86$export$62e99e5c9f473d7f = function(alphabet) {
    var defaultSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 21;
    return function() {
        var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultSize;
        var id = '';
        var i = size | 0;
        while(i-- > 0)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
var $1522848e5ebf4e86$export$ac4959f4f1338dfc = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 21;
    var id = '';
    var i = size | 0;
    while(i-- > 0)id += (0, $cGY4w.urlAlphabet)[Math.random() * 64 | 0];
    return id;
};

});
parcelRegister("cGY4w", function(module, exports) {

$parcel$export(module.exports, "urlAlphabet", function () { return $93d80153b3147479$export$2b646eea95309f00; });
var $93d80153b3147479$export$2b646eea95309f00 = '57X6y3wQZNzYjJB2L_10pxbackgroundhimselfUTF-8DEMOGRAPHICSVqvt4KW9';

});


parcelRegister("34ZKH", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $23e1a58c0ce47d26$var$ReactIs, $23e1a58c0ce47d26$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("jcgNi"))();

});
parcelRegister("jcgNi", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $lz8re = parcelRequire("lz8re");
function $df9c2a438da7b9e6$var$emptyFunction() {}
function $df9c2a438da7b9e6$var$emptyFunctionWithReset() {}
$df9c2a438da7b9e6$var$emptyFunctionWithReset.resetWarningCache = $df9c2a438da7b9e6$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $lz8re) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $df9c2a438da7b9e6$var$emptyFunctionWithReset,
        resetWarningCache: $df9c2a438da7b9e6$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("lz8re", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $fb33698669fbe5d4$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $fb33698669fbe5d4$var$ReactPropTypesSecret;

});




var $9HB6H = parcelRequire("9HB6H");
parcelRequire("6VBea");
var $9uiPq = parcelRequire("9uiPq");

var $kwI20 = parcelRequire("kwI20");

var $dxEC4 = parcelRequire("dxEC4");

var $6tY97 = parcelRequire("6tY97");

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $6ZpBv = parcelRequire("6ZpBv");

var $gh3Df = parcelRequire("gh3Df");

var $9HB6H = parcelRequire("9HB6H");

var $a8poV = parcelRequire("a8poV");
parcelRequire("6tkaO");


var $hh2l2 = parcelRequire("hh2l2");
var $6tkaO = parcelRequire("6tkaO");

var $1Ov0T = parcelRequire("1Ov0T");

var $34ZKH = parcelRequire("34ZKH");

var $iD6kw = parcelRequire("iD6kw");

var $kqzqZ = parcelRequire("kqzqZ");
var $6287c7e8f36a7954$var$sendToGTM = function(eventData) {
    if ('event' in eventData) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(eventData);
    }
};
var $6287c7e8f36a7954$export$c4c51ed05207b3b5 = function(selection) {
    $6287c7e8f36a7954$var$sendToGTM({
        event: 'blogFeedbackVoted',
        blogFeedbackScore: selection
    });
};



var $wQDEL = parcelRequire("wQDEL");
var $81e3c3d9dd70c817$var$name = "firebase";
var $81e3c3d9dd70c817$var$version = "12.19.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $wQDEL.registerVersion)($81e3c3d9dd70c817$var$name, $81e3c3d9dd70c817$var$version, 'app');


var $wQDEL = parcelRequire("wQDEL");

var $hh2l2 = parcelRequire("hh2l2");
var $d51780e75c522f3d$var$firebaseConfig = {
    apiKey: 'AIzaSyC7AQz_6vc7EHVeW_JF4J4w5QHhgUkRSuM',
    authDomain: 'meisterplan-bf5a1.firebaseapp.com',
    projectId: 'meisterplan-bf5a1',
    storageBucket: 'meisterplan-bf5a1.appspot.com',
    messagingSenderId: '484496177701',
    appId: '1:484496177701:web:a82eab07a571af6e1fddcc'
};
var $d51780e75c522f3d$var$app = (0, $wQDEL.initializeApp)($d51780e75c522f3d$var$firebaseConfig);
var $d51780e75c522f3d$export$e0cb15fb3b8fc489 = (0, $hh2l2.aV)($d51780e75c522f3d$var$app);


var $617bb8856d25f7e6$export$6268306c4a1a8f2a = function() {
    return window.location.hostname;
};


var $87f1f0d1e1846c3d$var$getAvatarStorageKey = function() {
    return 'mpAvatar';
};
var $87f1f0d1e1846c3d$var$getVotedPostsStorageKey = function() {
    return 'blogFeedback';
};
var $87f1f0d1e1846c3d$export$6836fb99d2ec00dc = {
    QUESTION: 'question',
    EVALUATION: 'evaluation',
    FEEDBACK: 'feedback',
    SUBMISSION: 'submission',
    VOTED: 'voted'
};
var $87f1f0d1e1846c3d$export$f0a8fb8b2bc234f = function() {
    var votedPosts = localStorage.getItem($87f1f0d1e1846c3d$var$getVotedPostsStorageKey());
    return votedPosts ? JSON.parse(votedPosts) : [];
};
var $87f1f0d1e1846c3d$export$2b0b60287a97ec23 = function(postID) {
    var votedPosts = $87f1f0d1e1846c3d$export$f0a8fb8b2bc234f();
    if (!votedPosts.includes(postID)) votedPosts.push(postID);
    localStorage.setItem($87f1f0d1e1846c3d$var$getVotedPostsStorageKey(), JSON.stringify(votedPosts));
};
var $87f1f0d1e1846c3d$export$eb271d196d2d06a9 = function() {
    var storedAvatar = localStorage.getItem($87f1f0d1e1846c3d$var$getAvatarStorageKey());
    return storedAvatar ? storedAvatar : 'default';
};
var $87f1f0d1e1846c3d$export$a060e901195d1695 = function(avatarKey) {
    localStorage.setItem($87f1f0d1e1846c3d$var$getAvatarStorageKey(), avatarKey);
};



var $9HB6H = parcelRequire("9HB6H");

var $34ZKH = parcelRequire("34ZKH");
function $d233e99922b52b79$export$2e2bcd8739ae039(param) {
    var _param_openModal = param.openModal, openModal = _param_openModal === void 0 ? function() {} : _param_openModal, _param_img = param.img, img = _param_img === void 0 ? '' : _param_img, _param_canChangeAvatar = param.canChangeAvatar, canChangeAvatar = _param_canChangeAvatar === void 0 ? false : _param_canChangeAvatar;
    var classes = [
        'blog-feedback__avatar'
    ];
    if (canChangeAvatar) classes.push('blog-feedback__avatar--edit');
    return /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
        onClick: function() {
            return canChangeAvatar && openModal();
        },
        className: classes.join(' '),
        children: /*#__PURE__*/ (0, $9HB6H.jsx)("img", {
            src: img,
            alt: "",
            loading: "lazy"
        })
    });
}
$d233e99922b52b79$export$2e2bcd8739ae039.propTypes = {
    openModal: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).func,
    img: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).string,
    canChangeAvatar: (0, $34ZKH.bool)
};



var $9HB6H = parcelRequire("9HB6H");

var $34ZKH = parcelRequire("34ZKH");

var $iD6kw = parcelRequire("iD6kw");
function $7c1d9797434bd633$export$2e2bcd8739ae039(props) {
    var textareaRef = (0, $iD6kw.useRef)(null);
    return /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
        className: "blog-feedback__form",
        children: [
            /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
                className: "form-field",
                children: [
                    /*#__PURE__*/ (0, $9HB6H.jsx)("label", {
                        htmlFor: "message",
                        children: props.labels.form_textarea_label
                    }),
                    /*#__PURE__*/ (0, $9HB6H.jsx)("textarea", {
                        id: "message",
                        name: "message",
                        rows: "6",
                        ref: textareaRef
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9HB6H.jsx)("button", {
                onClick: function() {
                    return props.submitForm(textareaRef.current.value);
                },
                className: "btn btn--primary",
                children: props.labels.form_button
            })
        ]
    });
}
$7c1d9797434bd633$export$2e2bcd8739ae039.propTypes = {
    labels: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).object,
    submitForm: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).func
};



var $9HB6H = parcelRequire("9HB6H");

var $34ZKH = parcelRequire("34ZKH");
function $1a7a7ece422e3d7e$export$2e2bcd8739ae039(param) {
    var _param_alignment = param.alignment, alignment = _param_alignment === void 0 ? 'left' : _param_alignment, children = param.children;
    var classes = [
        'blog-feedback__participant',
        "blog-feedback__participant--".concat(alignment)
    ];
    return /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
        className: classes.join(' '),
        children: children
    });
}
$1a7a7ece422e3d7e$export$2e2bcd8739ae039.propTypes = {
    alignment: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).node
};



var $9HB6H = parcelRequire("9HB6H");

var $34ZKH = parcelRequire("34ZKH");


var $9HB6H = parcelRequire("9HB6H");

var $34ZKH = parcelRequire("34ZKH");
function $bd07b381dcaba1d1$export$2e2bcd8739ae039(props) {
    var classes = [
        'blog-feedback__rating-btn'
    ];
    if (props.value === props.selection) classes.push('blog-feedback__rating-btn--selected');
    return /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
        id: props.value,
        onClick: function() {
            return props.selection === '' ? props.submitVote(props.value) : '';
        },
        className: classes.join(' '),
        children: props.selection !== '' && /*#__PURE__*/ (0, $9HB6H.jsx)("span", {
            className: "h6",
            children: props.count
        })
    });
}
$bd07b381dcaba1d1$export$2e2bcd8739ae039.propTypes = {
    selection: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).string,
    count: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).number,
    submitVote: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).func,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).string
};


function $78619262003abb2b$export$2e2bcd8739ae039(param) {
    var score = param.score, userData = param.userData, submitVote = param.submitVote;
    var selection = userData.selection;
    var classes = [
        'blog-feedback__rating'
    ];
    if (userData.step === (0, $87f1f0d1e1846c3d$export$6836fb99d2ec00dc).QUESTION) classes.push('blog-feedback__rating--open');
    return /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
        className: classes.join(' '),
        children: Object.keys(score).reverse().map(function(key) {
            return /*#__PURE__*/ (0, $9HB6H.jsx)((0, $bd07b381dcaba1d1$export$2e2bcd8739ae039), {
                selection: selection,
                count: score[key],
                submitVote: submitVote,
                value: key
            }, key);
        })
    });
}
$78619262003abb2b$export$2e2bcd8739ae039.propTypes = {
    score: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).object,
    userData: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).object,
    submitVote: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).func
};



var $9HB6H = parcelRequire("9HB6H");

var $34ZKH = parcelRequire("34ZKH");

var $5djcY = parcelRequire("5djcY");

var $iD6kw = parcelRequire("iD6kw");
function $5d51d9a576368015$var$i(e, t, r, n) {
    return new (r || (r = Promise))(function(o, a) {
        function i(e) {
            try {
                c(n.next(e));
            } catch (e) {
                a(e);
            }
        }
        function u(e) {
            try {
                c(n.throw(e));
            } catch (e) {
                a(e);
            }
        }
        function c(e) {
            var _$t;
            e.done ? o(e.value) : (_$t = e.value, _$t instanceof r ? _$t : new r(function(e) {
                e(_$t);
            })).then(i, u);
        }
        c((n = n.apply(e, t || [])).next());
    });
}
function $5d51d9a576368015$var$u(e, t) {
    var r, n, _$o, _$a, i = {
        label: 0,
        sent: function sent() {
            if (1 & _$o[0]) throw _$o[1];
            return _$o[1];
        },
        trys: [],
        ops: []
    };
    return _$a = {
        next: u(0),
        throw: u(1),
        return: u(2)
    }, "function" == typeof Symbol && (_$a[Symbol.iterator] = function() {
        return this;
    }), _$a;
    function u(a) {
        return function(u) {
            return function(a) {
                if (r) throw new TypeError("Generator is already executing.");
                for(; i;)try {
                    if (r = 1, n && (_$o = 2 & a[0] ? n.return : a[0] ? n.throw || ((_$o = n.return) && _$o.call(n), 0) : n.next) && !(_$o = _$o.call(n, a[1])).done) return _$o;
                    switch(n = 0, _$o && (a = [
                        2 & a[0],
                        _$o.value
                    ]), a[0]){
                        case 0:
                        case 1:
                            _$o = a;
                            break;
                        case 4:
                            return i.label++, {
                                value: a[1],
                                done: !1
                            };
                        case 5:
                            i.label++, n = a[1], a = [
                                0
                            ];
                            continue;
                        case 7:
                            a = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(_$o = i.trys, (_$o = _$o.length > 0 && _$o[_$o.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === a[0] && (!_$o || a[1] > _$o[0] && a[1] < _$o[3])) {
                                i.label = a[1];
                                break;
                            }
                            if (6 === a[0] && i.label < _$o[1]) {
                                i.label = _$o[1], _$o = a;
                                break;
                            }
                            if (_$o && i.label < _$o[2]) {
                                i.label = _$o[2], i.ops.push(a);
                                break;
                            }
                            _$o[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    a = t.call(e, i);
                } catch (e) {
                    a = [
                        6,
                        e
                    ], n = 0;
                } finally{
                    r = _$o = 0;
                }
                if (5 & a[0]) throw a[1];
                return {
                    value: a[0] ? a[1] : void 0,
                    done: !0
                };
            }([
                a,
                u
            ]);
        };
    }
}
function $5d51d9a576368015$var$c(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, r = t && e[t], n = 0;
    if (r) return r.call(e);
    if (e && "number" == typeof e.length) return {
        next: function next() {
            return e && n >= e.length && (e = void 0), {
                value: e && e[n++],
                done: !e
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5d51d9a576368015$var$l(e, t) {
    var r = "function" == typeof Symbol && e[Symbol.iterator];
    if (!r) return e;
    var n, _$o, _$a = r.call(e), i = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(n = _$a.next()).done;)i.push(n.value);
    } catch (e) {
        _$o = {
            error: e
        };
    } finally{
        try {
            n && !n.done && (r = _$a.return) && r.call(_$a);
        } finally{
            if (_$o) throw _$o.error;
        }
    }
    return i;
}
function $5d51d9a576368015$var$s(e, t, r) {
    if (r || 2 === arguments.length) for(var n, _$o = 0, _$a = t.length; _$o < _$a; _$o++)!n && _$o in t || (n || (n = Array.prototype.slice.call(t, 0, _$o)), n[_$o] = t[_$o]);
    return e.concat(n || Array.prototype.slice.call(t));
}
function $5d51d9a576368015$var$f(e, t, r, n, o) {
    for(var _$a = [], f = 5; f < arguments.length; f++)_$a[f - 5] = arguments[f];
    return $5d51d9a576368015$var$i(this, void 0, void 0, function() {
        var _$i, f, h, y, v, b;
        return $5d51d9a576368015$var$u(this, function(u) {
            switch(u.label){
                case 0:
                    u.trys.push([
                        0,
                        12,
                        13,
                        14
                    ]), _$i = $5d51d9a576368015$var$c(_$a), f = _$i.next(), u.label = 1;
                case 1:
                    if (f.done) return [
                        3,
                        11
                    ];
                    switch(h = f.value, typeof h === "undefined" ? "undefined" : (0, $5djcY._)(h)){
                        case "string":
                            return [
                                3,
                                2
                            ];
                        case "number":
                            return [
                                3,
                                4
                            ];
                        case "function":
                            return [
                                3,
                                6
                            ];
                    }
                    return [
                        3,
                        8
                    ];
                case 2:
                    return [
                        4,
                        $5d51d9a576368015$var$d(e, t, h, r, n, o)
                    ];
                case 3:
                    return u.sent(), [
                        3,
                        10
                    ];
                case 4:
                    return [
                        4,
                        $5d51d9a576368015$var$p(h)
                    ];
                case 5:
                    return u.sent(), [
                        3,
                        10
                    ];
                case 6:
                    return [
                        4,
                        h.apply(void 0, $5d51d9a576368015$var$s([
                            e,
                            t,
                            r,
                            n,
                            o
                        ], $5d51d9a576368015$var$l(_$a), !1))
                    ];
                case 7:
                    return u.sent(), [
                        3,
                        10
                    ];
                case 8:
                    return [
                        4,
                        h
                    ];
                case 9:
                    u.sent(), u.label = 10;
                case 10:
                    return f = _$i.next(), [
                        3,
                        1
                    ];
                case 11:
                    return [
                        3,
                        14
                    ];
                case 12:
                    return y = u.sent(), v = {
                        error: y
                    }, [
                        3,
                        14
                    ];
                case 13:
                    try {
                        f && !f.done && (b = _$i.return) && b.call(_$i);
                    } finally{
                        if (v) throw v.error;
                    }
                    return [
                        7
                    ];
                case 14:
                    return [
                        2
                    ];
            }
        });
    });
}
function $5d51d9a576368015$var$d(e, t, r, n, o, a) {
    return $5d51d9a576368015$var$i(this, void 0, void 0, function() {
        var _$i, c;
        return $5d51d9a576368015$var$u(this, function(u) {
            switch(u.label){
                case 0:
                    return _$i = e.textContent || "", c = function(e, t) {
                        var _$r = $5d51d9a576368015$var$l(t).slice(0);
                        return $5d51d9a576368015$var$s($5d51d9a576368015$var$s([], $5d51d9a576368015$var$l(e), !1), [
                            NaN
                        ], !1).findIndex(function(e, t) {
                            return _$r[t] !== e;
                        });
                    }(_$i, r), [
                        4,
                        $5d51d9a576368015$var$h(e, $5d51d9a576368015$var$s($5d51d9a576368015$var$s([], $5d51d9a576368015$var$l($5d51d9a576368015$var$v(_$i, t, c)), !1), $5d51d9a576368015$var$l($5d51d9a576368015$var$y(r, t, c)), !1), n, o, a)
                    ];
                case 1:
                    return u.sent(), [
                        2
                    ];
            }
        });
    });
}
function $5d51d9a576368015$var$p(e) {
    return $5d51d9a576368015$var$i(this, void 0, void 0, function() {
        return $5d51d9a576368015$var$u(this, function(t) {
            switch(t.label){
                case 0:
                    return [
                        4,
                        new Promise(function(t) {
                            return setTimeout(t, e);
                        })
                    ];
                case 1:
                    return t.sent(), [
                        2
                    ];
            }
        });
    });
}
function $5d51d9a576368015$var$h(e, t, r, n, o) {
    return $5d51d9a576368015$var$i(this, void 0, void 0, function() {
        var _$a, _$i, s, f, d, h, y, v, b, m, w, g, x;
        return $5d51d9a576368015$var$u(this, function(S) {
            switch(S.label){
                case 0:
                    if (_$a = t, o) {
                        for(_$i = 0, s = 1; s < t.length; s++)if (f = $5d51d9a576368015$var$l([
                            t[s - 1],
                            t[s]
                        ], 2), d = f[0], (h = f[1]).length > d.length || "" === h) {
                            _$i = s;
                            break;
                        }
                        _$a = t.slice(_$i, t.length);
                    }
                    S.label = 1;
                case 1:
                    S.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]), y = $5d51d9a576368015$var$c(function(e) {
                        var _$t, _$r, _$n, _$o, _$a, _$i, _$l;
                        return $5d51d9a576368015$var$u(this, function(s) {
                            switch(s.label){
                                case 0:
                                    _$t = function t(e) {
                                        return $5d51d9a576368015$var$u(this, function(t) {
                                            switch(t.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        {
                                                            op: function op(t) {
                                                                return requestAnimationFrame(function() {
                                                                    return t.textContent = e;
                                                                });
                                                            },
                                                            opCode: function opCode(t) {
                                                                var _$r = t.textContent || "";
                                                                return "" === e || _$r.length > e.length ? "DELETE" : "WRITING";
                                                            }
                                                        }
                                                    ];
                                                case 1:
                                                    return t.sent(), [
                                                        2
                                                    ];
                                            }
                                        });
                                    }, s.label = 1;
                                case 1:
                                    s.trys.push([
                                        1,
                                        6,
                                        7,
                                        8
                                    ]), _$r = $5d51d9a576368015$var$c(e), _$n = _$r.next(), s.label = 2;
                                case 2:
                                    return _$n.done ? [
                                        3,
                                        5
                                    ] : (_$o = _$n.value, [
                                        5,
                                        _$t(_$o)
                                    ]);
                                case 3:
                                    s.sent(), s.label = 4;
                                case 4:
                                    return _$n = _$r.next(), [
                                        3,
                                        2
                                    ];
                                case 5:
                                    return [
                                        3,
                                        8
                                    ];
                                case 6:
                                    return _$a = s.sent(), _$i = {
                                        error: _$a
                                    }, [
                                        3,
                                        8
                                    ];
                                case 7:
                                    try {
                                        _$n && !_$n.done && (_$l = _$r.return) && _$l.call(_$r);
                                    } finally{
                                        if (_$i) throw _$i.error;
                                    }
                                    return [
                                        7
                                    ];
                                case 8:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }(_$a)), v = y.next(), S.label = 2;
                case 2:
                    return v.done ? [
                        3,
                        5
                    ] : (b = v.value, m = "WRITING" === b.opCode(e) ? r + r * (Math.random() - .5) : n + n * (Math.random() - .5), b.op(e), [
                        4,
                        $5d51d9a576368015$var$p(m)
                    ]);
                case 3:
                    S.sent(), S.label = 4;
                case 4:
                    return v = y.next(), [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    return w = S.sent(), g = {
                        error: w
                    }, [
                        3,
                        8
                    ];
                case 7:
                    try {
                        v && !v.done && (x = y.return) && x.call(y);
                    } finally{
                        if (g) throw g.error;
                    }
                    return [
                        7
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
}
function $5d51d9a576368015$var$y(e, t, r) {
    var n, _$o;
    return void 0 === r && (r = 0), $5d51d9a576368015$var$u(this, function(a) {
        switch(a.label){
            case 0:
                n = t(e), _$o = n.length, a.label = 1;
            case 1:
                return r < _$o ? [
                    4,
                    n.slice(0, ++r).join("")
                ] : [
                    3,
                    3
                ];
            case 2:
                return a.sent(), [
                    3,
                    1
                ];
            case 3:
                return [
                    2
                ];
        }
    });
}
function $5d51d9a576368015$var$v(e, t, r) {
    var n, _$o;
    return void 0 === r && (r = 0), $5d51d9a576368015$var$u(this, function(a) {
        switch(a.label){
            case 0:
                n = t(e), _$o = n.length, a.label = 1;
            case 1:
                return _$o > r ? [
                    4,
                    n.slice(0, --_$o).join("")
                ] : [
                    3,
                    3
                ];
            case 2:
                return a.sent(), [
                    3,
                    1
                ];
            case 3:
                return [
                    2
                ];
        }
    });
}
var $5d51d9a576368015$var$b = "index-module_type__E-SaG";
!function(e, t) {
    void 0 === t && (t = {});
    var r = t.insertAt;
    if (e && "undefined" != typeof document) {
        var n = document.head || document.getElementsByTagName("head")[0], _$o = document.createElement("style");
        _$o.type = "text/css", "top" === r && n.firstChild ? n.insertBefore(_$o, n.firstChild) : n.appendChild(_$o), _$o.styleSheet ? _$o.styleSheet.cssText = e : _$o.appendChild(document.createTextNode(e));
    }
}(".index-module_type__E-SaG::after {\n  content: '|';\n  animation: index-module_cursor__PQg0P 1.1s infinite step-start;\n}\n\n@keyframes index-module_cursor__PQg0P {\n  50% {\n    opacity: 0;\n  }\n}\n");
var $5d51d9a576368015$export$9ccb4d0b6557995c = (0, $iD6kw.memo)((0, $iD6kw.forwardRef)(function(o, a) {
    var i = o.sequence, u = o.repeat, c = o.className, d = o.speed, p = void 0 === d ? 40 : d, h = o.deletionSpeed, y = o.omitDeletionAnimation, v = void 0 !== y && y, m = o.preRenderFirstString, w = void 0 !== m && m, g = o.wrapper, x = void 0 === g ? "span" : g, S = o.splitter, E = void 0 === S ? function E(e) {
        return $5d51d9a576368015$var$s([], $5d51d9a576368015$var$l(e), !1);
    } : S, _ = o.cursor, k = void 0 === _ || _, O = o.style, T = function(e, t) {
        var _$r = {};
        for(var _$n in e)Object.prototype.hasOwnProperty.call(e, _$n) && t.indexOf(_$n) < 0 && (_$r[_$n] = e[_$n]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var _$o = 0;
            for(_$n = Object.getOwnPropertySymbols(e); _$o < _$n.length; _$o++)t.indexOf(_$n[_$o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, _$n[_$o]) && (_$r[_$n[_$o]] = e[_$n[_$o]]);
        }
        return _$r;
    }(o, [
        "sequence",
        "repeat",
        "className",
        "speed",
        "deletionSpeed",
        "omitDeletionAnimation",
        "preRenderFirstString",
        "wrapper",
        "splitter",
        "cursor",
        "style"
    ]), A = T["aria-label"], C = T["aria-hidden"], N = T.role;
    h || (h = p);
    var P = new Array(2).fill(40);
    [
        p,
        h
    ].forEach(function(e, t) {
        switch(typeof e === "undefined" ? "undefined" : (0, $5djcY._)(e)){
            case "number":
                P[t] = Math.abs(e - 100);
                break;
            case "object":
                var _$r = e.type, _$n = e.value;
                if ("number" != typeof _$n) break;
                if ("keyStrokeDelayInMs" === _$r) P[t] = _$n;
        }
    });
    var j, I, G, D, M, R, q = P[0], F = P[1], B = function(e, r) {
        void 0 === r && (r = null);
        var _$o = (0, $iD6kw.useRef)(r);
        return (0, $iD6kw.useEffect)(function() {
            e && ("function" == typeof e ? e(_$o.current) : e.current = _$o.current);
        }, [
            e
        ]), _$o;
    }(a), Q = $5d51d9a576368015$var$b;
    j = c ? "".concat(k ? Q + " " : "").concat(c) : k ? Q : "", I = (0, $iD6kw.useRef)(function() {
        var _$e, _$t = i;
        u === 1 / 0 ? _$e = $5d51d9a576368015$var$f : "number" == typeof u && (_$t = Array(1 + u).fill(i).flat());
        var _$r = _$e ? $5d51d9a576368015$var$s($5d51d9a576368015$var$s([], $5d51d9a576368015$var$l(_$t), !1), [
            _$e
        ], !1) : $5d51d9a576368015$var$s([], $5d51d9a576368015$var$l(_$t), !1);
        return $5d51d9a576368015$var$f.apply(void 0, $5d51d9a576368015$var$s([
            B.current,
            E,
            q,
            F,
            v
        ], $5d51d9a576368015$var$l(_$r), !1)), function() {
            B.current;
        };
    }), G = (0, $iD6kw.useRef)(), D = (0, $iD6kw.useRef)(!1), M = (0, $iD6kw.useRef)(!1), R = $5d51d9a576368015$var$l((0, $iD6kw.useState)(0), 2)[1], D.current && (M.current = !0), (0, $iD6kw.useEffect)(function() {
        return D.current || (G.current = I.current(), D.current = !0), R(function(e) {
            return e + 1;
        }), function() {
            M.current && G.current && G.current();
        };
    }, []);
    var W = x, L = w ? i.find(function(e) {
        return "string" == typeof e;
    }) || "" : null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).createElement(W, {
        "aria-hidden": C,
        "aria-label": A,
        role: N,
        style: O,
        className: j,
        children: A ? (0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).createElement("span", {
            "aria-hidden": "true",
            ref: B,
            children: L
        }) : L,
        ref: A ? void 0 : B
    });
}), function(e, t) {
    return !0;
});


function $87f6e38935a56ee1$export$2e2bcd8739ae039(param) {
    var who = param.who, text = param.text, children = param.children;
    var classes = [
        'blog-feedback__speech-bubble'
    ];
    return /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
        className: classes.join(' '),
        children: [
            who && /*#__PURE__*/ (0, $9HB6H.jsx)("p", {
                className: "blog-feedback__who",
                children: who
            }),
            text && /*#__PURE__*/ (0, $9HB6H.jsx)("p", {
                className: "blog-feedback__text h6",
                children: /*#__PURE__*/ (0, $9HB6H.jsx)((0, $5d51d9a576368015$export$9ccb4d0b6557995c), {
                    sequence: [
                        text
                    ],
                    speed: 40,
                    cursor: false
                }, text)
            }),
            children
        ]
    });
}
$87f6e38935a56ee1$export$2e2bcd8739ae039.propTypes = {
    who: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).string,
    text: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).node
};


function $3efa334d1fb6b6a5$export$2e2bcd8739ae039(props) {
    // Collections: Must have an odd number of segments in the path.
    var databaseRoot = "".concat($617bb8856d25f7e6$export$6268306c4a1a8f2a(), "/blog_feedback/data");
    var _useState = (0, $6ZpBv._)((0, $iD6kw.useState)({}), 2), appData = _useState[0], setAppData = _useState[1];
    var _useState1 = (0, $6ZpBv._)((0, $iD6kw.useState)({}), 2), scoreData = _useState1[0], setScoreData = _useState1[1];
    var dialogRef = (0, $iD6kw.useRef)(null);
    var _useState2 = (0, $6ZpBv._)((0, $iD6kw.useState)({
        uid: (0, (/*@__PURE__*/$parcel$interopDefault($a8poV)))("".concat(Date.now(), "-").concat((0, $1Ov0T.nanoid)())),
        step: $87f1f0d1e1846c3d$export$f0a8fb8b2bc234f().includes(props.postId) ? (0, $87f1f0d1e1846c3d$export$6836fb99d2ec00dc).VOTED : (0, $87f1f0d1e1846c3d$export$6836fb99d2ec00dc).QUESTION,
        selection: '',
        avatar: $87f1f0d1e1846c3d$export$eb271d196d2d06a9(),
        modalOpen: false
    }), 2), userData = _useState2[0], setUserData = _useState2[1];
    var getPostData = function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var collectionRef, q, doc_refs, res, emojis, score;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        collectionRef = (0, $hh2l2.aL)((0, $d51780e75c522f3d$export$e0cb15fb3b8fc489), databaseRoot);
                        q = (0, $6tkaO.query)(collectionRef, (0, $6tkaO.where)('userId', '==', userData.uid), (0, $6tkaO.where)('postId', '==', props.postId));
                        return [
                            4,
                            (0, $6tkaO.getDocs)(q)
                        ];
                    case 1:
                        doc_refs = _state.sent();
                        res = [];
                        doc_refs.forEach(function(post) {
                            res.push((0, $kWfK0._)({}, post.data()));
                        });
                        emojis = [
                            'very_satisfied',
                            'satisfied',
                            'neutral',
                            'dissatisfied',
                            'very_dissatisfied'
                        ];
                        score = {};
                        emojis.map(function(emote) {
                            score[emote] = res.length ? res.filter(function(entry) {
                                return entry.selectionId === emote;
                            }).length : 0;
                        });
                        setScoreData(score);
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var sendVoteToFirebase = function(selection) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var err;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0, $6tkaO.setDoc)((0, $hh2l2.v)((0, $d51780e75c522f3d$export$e0cb15fb3b8fc489), databaseRoot, userData.uid), {
                                contentHash: props.contentHash,
                                postId: props.postId,
                                postUrl: props.postUrl,
                                selectionId: selection,
                                timestamp: (0, $hh2l2.b0)(),
                                language: props.language
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        console.log(err);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var submitVote = function(selection) {
        $87f1f0d1e1846c3d$export$2b0b60287a97ec23(props.postId);
        (0, $6287c7e8f36a7954$export$c4c51ed05207b3b5)(selection);
        sendVoteToFirebase(selection);
        setScoreData(function(scoreData) {
            return (0, $hApvp._)((0, $kWfK0._)({}, scoreData), (0, $6tY97._)({}, selection, scoreData[selection] + 1));
        });
        setUserData(function(userData) {
            return (0, $hApvp._)((0, $kWfK0._)({}, userData), {
                step: (0, $87f1f0d1e1846c3d$export$6836fb99d2ec00dc).EVALUATION,
                selection: selection
            });
        });
    };
    var sendFormToFirebase = function(comment) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var err;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0, $6tkaO.updateDoc)((0, $hh2l2.v)((0, $d51780e75c522f3d$export$e0cb15fb3b8fc489), databaseRoot, userData.uid), {
                                comment: comment
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        console.log(err);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var submitForm = function(comment) {
        sendFormToFirebase(comment);
        setUserData(function(userData) {
            return (0, $hApvp._)((0, $kWfK0._)({}, userData), {
                step: (0, $87f1f0d1e1846c3d$export$6836fb99d2ec00dc).SUBMISSION
            });
        });
    };
    var selectAvatar = function(avatar) {
        $87f1f0d1e1846c3d$export$a060e901195d1695(avatar);
        setUserData(function(userData) {
            return (0, $hApvp._)((0, $kWfK0._)({}, userData), {
                avatar: avatar
            });
        });
    };
    var getAvatarsPortal = function() {
        return /*#__PURE__*/ (0, $kqzqZ.createPortal)(/*#__PURE__*/ (0, $9HB6H.jsxs)("dialog", {
            ref: dialogRef,
            children: [
                /*#__PURE__*/ (0, $9HB6H.jsxs)("form", {
                    method: "dialog",
                    children: [
                        appData.labels.modal_title,
                        /*#__PURE__*/ (0, $9HB6H.jsx)("button", {
                            onClick: function() {
                                return setUserData(function(userData) {
                                    return (0, $hApvp._)((0, $kWfK0._)({}, userData), {
                                        modalOpen: false
                                    });
                                });
                            },
                            className: "close"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9HB6H.jsx)("main", {
                    children: Object.keys(appData.images.avatars).map(function(key) {
                        return /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                            tabIndex: 0,
                            onClick: function() {
                                return selectAvatar(key);
                            },
                            className: "blog-feedback__avatar".concat(userData.avatar === key ? ' blog-feedback__avatar--active' : ''),
                            children: /*#__PURE__*/ (0, $9HB6H.jsx)("img", {
                                src: appData.images.avatars[key],
                                alt: ""
                            })
                        }, key);
                    })
                })
            ]
        }), document.getElementById('blog-feedback__dialog'));
    };
    (0, $iD6kw.useEffect)(function() {
        // Fetch App Data via provided REST URL.
        fetch(props.dataUrl).then(function(res) {
            return res.json();
        }).then(function(data) {
            setAppData((0, $kWfK0._)({}, appData, data));
        }).catch(function(error) {
            return console.error(error);
        });
        // Update the appDate when the user has made a selection.
        getPostData();
    }, []);
    (0, $iD6kw.useEffect)(function() {
        if (userData.selection !== '') setTimeout(function() {
            setUserData(function(userData) {
                return (0, $hApvp._)((0, $kWfK0._)({}, userData), {
                    step: (0, $87f1f0d1e1846c3d$export$6836fb99d2ec00dc).FEEDBACK
                });
            });
        }, 2500);
    }, [
        userData.selection
    ]);
    var canRender = function() {
        return appData.labels && appData.images && Object.keys(appData.images).length === 2 && Object.keys(scoreData).length;
    };
    return canRender() ? /*#__PURE__*/ (0, $9HB6H.jsxs)((0, $9HB6H.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9HB6H.jsxs)((0, $1a7a7ece422e3d7e$export$2e2bcd8739ae039), {
                alignment: "right",
                children: [
                    /*#__PURE__*/ (0, $9HB6H.jsx)((0, $d233e99922b52b79$export$2e2bcd8739ae039), {
                        img: appData.images.us
                    }),
                    /*#__PURE__*/ (0, $9HB6H.jsx)((0, $87f6e38935a56ee1$export$2e2bcd8739ae039), {
                        who: appData.labels.us || '',
                        text: [
                            (0, $87f1f0d1e1846c3d$export$6836fb99d2ec00dc).EVALUATION,
                            (0, $87f1f0d1e1846c3d$export$6836fb99d2ec00dc).FEEDBACK
                        ].includes(userData.step) ? appData.labels.steps[(0, $87f1f0d1e1846c3d$export$6836fb99d2ec00dc).EVALUATION] : appData.labels.steps[userData.step]
                    })
                ]
            }),
            ![
                (0, $87f1f0d1e1846c3d$export$6836fb99d2ec00dc).SUBMISSION,
                (0, $87f1f0d1e1846c3d$export$6836fb99d2ec00dc).VOTED
            ].includes(userData.step) && /*#__PURE__*/ (0, $9HB6H.jsxs)((0, $1a7a7ece422e3d7e$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $9HB6H.jsx)((0, $d233e99922b52b79$export$2e2bcd8739ae039), {
                        openModal: function() {
                            return dialogRef.current.showModal();
                        },
                        img: appData.images.avatars[userData.avatar],
                        canChangeAvatar: Object.keys(appData.images.avatars).length > 1
                    }),
                    /*#__PURE__*/ (0, $9HB6H.jsxs)((0, $87f6e38935a56ee1$export$2e2bcd8739ae039), {
                        who: appData.labels.you,
                        children: [
                            [
                                (0, $87f1f0d1e1846c3d$export$6836fb99d2ec00dc).QUESTION,
                                (0, $87f1f0d1e1846c3d$export$6836fb99d2ec00dc).EVALUATION,
                                (0, $87f1f0d1e1846c3d$export$6836fb99d2ec00dc).FEEDBACK
                            ].includes(userData.step) && /*#__PURE__*/ (0, $9HB6H.jsx)((0, $78619262003abb2b$export$2e2bcd8739ae039), {
                                score: scoreData,
                                userData: userData,
                                submitVote: submitVote
                            }),
                            userData.step === (0, $87f1f0d1e1846c3d$export$6836fb99d2ec00dc).FEEDBACK && /*#__PURE__*/ (0, $9HB6H.jsx)((0, $7c1d9797434bd633$export$2e2bcd8739ae039), {
                                submitForm: submitForm,
                                labels: appData.labels
                            })
                        ]
                    })
                ]
            }),
            getAvatarsPortal()
        ]
    }) : null;
}
$3efa334d1fb6b6a5$export$2e2bcd8739ae039.propTypes = {
    contentHash: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).string,
    dataUrl: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).string,
    postId: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).number,
    postUrl: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).string,
    language: (0, (/*@__PURE__*/$parcel$interopDefault($34ZKH))).string
};


var $27782c183ecb6649$var$el = document.querySelector('#blog-feedback');
if ($27782c183ecb6649$var$el) {
    var $27782c183ecb6649$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($kwI20))).createRoot($27782c183ecb6649$var$el);
    (0, $9uiPq.getReCAPTCHAResponse)('blogFeedbackVisibility').then(function(response) {
        if (response.success && response.score >= 0.5) $27782c183ecb6649$var$root.render(/*#__PURE__*/ (0, $9HB6H.jsx)((0, $3efa334d1fb6b6a5$export$2e2bcd8739ae039), {
            contentHash: $27782c183ecb6649$var$el.getAttribute('data-content-hash'),
            dataUrl: $27782c183ecb6649$var$el.getAttribute('data-rest-url'),
            postId: parseInt($27782c183ecb6649$var$el.getAttribute('data-post-id')),
            postUrl: $27782c183ecb6649$var$el.getAttribute('data-post-url'),
            language: $27782c183ecb6649$var$el.getAttribute('data-language')
        }));
    }).catch(function(error) {
        console.error(error);
    });
}

})();
//# sourceMappingURL=blog_feedback.min.js.map
